
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("36FLn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c2607b8aea5b89fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $5BRby = parcelRequire("5BRby");

var $8BZ1O = parcelRequire("8BZ1O");

var $jpVCp = parcelRequire("jpVCp");

var $egJIx = parcelRequire("egJIx");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $79xbN = parcelRequire("79xbN");

var $fD1Hq = parcelRequire("fD1Hq");

var $aeIT6 = parcelRequire("aeIT6");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $jK1pm = parcelRequire("jK1pm");
const $c2607b8aea5b89fd$var$JiraBusinessListApp = (props)=>{
    const { data: project } = (0, $aeIT6.useProject)();
    const isSubtasksEnabled = (0, $fD1Hq.useIsSubtasksEnabled)();
    const isSimplifiedProject = Boolean(project?.isSimplified);
    const canCreateIssues = Boolean(project?.permissions.createIssues);
    const canCreateSubtask = canCreateIssues && (isSimplifiedProject || isSubtasksEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-list-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "business"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BZ1O.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $egJIx.ListFeaturesProvider), {
        hasCreateSubtask: canCreateSubtask,
        canCreateIssues: canCreateIssues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7c3W1.ViewPreferencesProvider), {
        view: "list",
        preferences: (0, $ji3xf.LIST_VIEW_PREFERENCES)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jpVCp.default), {
        formattingRulesQuery: (0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? props.queries.formattingRulesQuery : null
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "core"
    }))));
};
var $c2607b8aea5b89fd$export$2e2bcd8739ae039 = $c2607b8aea5b89fd$var$JiraBusinessListApp;

});
parcelRegister("8BZ1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $80390eebeffb6a20$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bDUCT = parcelRequire("bDUCT");

var $fDLFb = parcelRequire("fDLFb");

var $eZbpk = parcelRequire("eZbpk");

var $ePgRW = parcelRequire("ePgRW");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $jWIW7 = parcelRequire("jWIW7");

var $7IBv4 = parcelRequire("7IBv4");

var $8WuJm = parcelRequire("8WuJm");

var $lB25E = parcelRequire("lB25E");

var $aeIT6 = parcelRequire("aeIT6");

var $dWLk9 = parcelRequire("dWLk9");

var $hCCuu = parcelRequire("hCCuu");

var $k4xGW = parcelRequire("k4xGW");
const $80390eebeffb6a20$var$ProjectContextProvider = ({ children: children })=>{
    const { data: project, loading: loading, error: error } = (0, $aeIT6.useProject)();
    const { replace: replace } = (0, $lB25E.useRouterActions)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectId = project?.id;
    const projectKey = project?.key;
    const projectType = project?.type;
    const isTeamManaged = Boolean(project?.isSimplified);
    const jqlContext = projectKey ? `project = '${projectKey}'` : '';
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            projectId: projectId,
            isTeamManaged: isTeamManaged,
            projectType: projectType
        }), [
        projectId,
        isTeamManaged,
        projectType
    ]);
    const entityData = (0, $eUqFw.useMemo)(()=>project?.permissions?.viewIssues ? {
            name: project.name,
            id: String(project.id)
        } : null, [
        project
    ]);
    const projects = (0, $eUqFw.useMemo)(()=>project ? [
            project
        ] : undefined, [
        project
    ]);
    const projectIdList = (0, $eUqFw.useMemo)(()=>projectId ? [
            projectId
        ] : undefined, [
        projectId
    ]);
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    if (project?.status === 'ARCHIVED') {
        replace('/jira/errors/project-archived');
        return null;
    }
    let content;
    if (loading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IBv4.ThemedLazySkeleton), null);
    else if (project == null || entityData == null || error) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4xGW.default), null), error && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE),
        error: error
    }));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQAZu.ProjectHookProvider), {
        project: project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDLFb.BusinessEntityProvider), {
        data: entityData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePgRW.RealtimeProvider), {
        ids: projectIdList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDUCT.AriProvider), {
        ari: projectAri
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZbpk.JqlProvider), {
        jqlContext: jqlContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWIW7.FiltersProvider), {
        projects: projects
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        containerId: String(project?.id),
        containerType: "project",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "businessProjectContext",
        attributes: analyticsAttributes,
        // we set a key on the first element to force React to re-render when the context changes
        // to avoid query race-conditions that would lead to promises from a previous context
        // resolving in the current context view, and thus seeing unrelated data
        key: String(project?.id)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceStart), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    }), content);
};
var $80390eebeffb6a20$export$2e2bcd8739ae039 = $80390eebeffb6a20$var$ProjectContextProvider;

});
parcelRegister("bDUCT", function(module, exports) {

$parcel$export(module.exports, "AriProvider", () => $76c0a50c757f3bcd$export$c806f8ac05dc61fa);
$parcel$export(module.exports, "useEntityAri", () => $76c0a50c757f3bcd$export$badcacdc306567b8);

var $eUqFw = parcelRequire("eUqFw");
const $76c0a50c757f3bcd$var$AriContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $76c0a50c757f3bcd$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76c0a50c757f3bcd$var$AriContext.Provider, {
        value: ari
    }, children);
const $76c0a50c757f3bcd$export$badcacdc306567b8 = ()=>(0, $eUqFw.useContext)($76c0a50c757f3bcd$var$AriContext);

});

parcelRegister("fDLFb", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $984e8248b41af828$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $984e8248b41af828$export$ff2574b00bc1c100);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $984e8248b41af828$var$BusinessEntityContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $984e8248b41af828$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($984e8248b41af828$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $984e8248b41af828$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $eUqFw.useContext)($984e8248b41af828$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});

parcelRegister("eZbpk", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $28ab7b3257a6571c$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $28ab7b3257a6571c$export$f32e2f688fc08561);

var $eUqFw = parcelRequire("eUqFw");
const $28ab7b3257a6571c$var$JqlContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $28ab7b3257a6571c$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($28ab7b3257a6571c$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $28ab7b3257a6571c$export$f32e2f688fc08561 = ()=>(0, $eUqFw.useContext)($28ab7b3257a6571c$var$JqlContext);

});

parcelRegister("ePgRW", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $d87d469a5640e4cf$export$64d242981d970821);
$parcel$export(module.exports, "useRealtimeContext", () => $d87d469a5640e4cf$export$f39c07717ad8c35b);

var $eUqFw = parcelRequire("eUqFw");
const $d87d469a5640e4cf$var$RealtimeContext = /*#__PURE__*/ (0, $eUqFw.createContext)([]);
const $d87d469a5640e4cf$export$64d242981d970821 = ({ ids: ids, children: children })=>{
    const projectsIds = (0, $eUqFw.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
        ids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87d469a5640e4cf$var$RealtimeContext.Provider, {
        value: projectsIds
    }, children);
};
const $d87d469a5640e4cf$export$f39c07717ad8c35b = ()=>(0, $eUqFw.useContext)($d87d469a5640e4cf$var$RealtimeContext);

});

parcelRegister("kQAZu", function(module, exports) {

$parcel$export(module.exports, "ProjectHookProvider", () => $5a070342b3707183$export$f1938a4916a14d9f);
$parcel$export(module.exports, "useProject", () => $5a070342b3707183$export$51b1383ef8844a7);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $5a070342b3707183$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $5a070342b3707183$export$f1938a4916a14d9f = ({ project: project, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a070342b3707183$var$Context.Provider, {
        value: project
    }, children);
const $5a070342b3707183$export$51b1383ef8844a7 = ()=>{
    const project = (0, $eUqFw.useContext)($5a070342b3707183$var$Context);
    if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
    return project;
};

});

parcelRegister("jWIW7", function(module, exports) {

$parcel$export(module.exports, "FiltersProvider", () => $85c94258ff14c8b6$export$905df3588d1d8c75);
$parcel$export(module.exports, "useAssigneesFilterQuery", () => $85c94258ff14c8b6$export$f39bce8705b01ff5);
$parcel$export(module.exports, "useProjectFilter", () => $85c94258ff14c8b6$export$b71768ffb8163578);
$parcel$export(module.exports, "useAllowedFieldTypes", () => $85c94258ff14c8b6$export$9dc8a291956c2fa9);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");
const $85c94258ff14c8b6$var$DEFAULT_VALUE = {
    assigneeQuery: '',
    projectFilter: {
        totalCount: 0,
        options: []
    }
};
const $85c94258ff14c8b6$var$FiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($85c94258ff14c8b6$var$DEFAULT_VALUE);
const $85c94258ff14c8b6$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
    const value = (0, $eUqFw.useMemo)(()=>{
        if (!projects) return $85c94258ff14c8b6$var$DEFAULT_VALUE;
        const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
        const projectFilter = {
            totalCount: projects.length,
            options: projects.map((project)=>({
                    label: project.name,
                    value: String(project.id),
                    avatar: project.avatarUrl,
                    square: true
                }))
        };
        return {
            assigneeQuery: assigneeQuery,
            projectFilter: projectFilter
        };
    }, [
        projects
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85c94258ff14c8b6$var$FiltersContext.Provider, {
        value: value
    }, children);
};
const $85c94258ff14c8b6$export$f39bce8705b01ff5 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).assigneeQuery;
const $85c94258ff14c8b6$export$b71768ffb8163578 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).projectFilter;
const $85c94258ff14c8b6$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
    const filtersContext = (0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext);
    return (0, $eUqFw.useMemo)(()=>{
        const result = new Set(inputAllowedFieldTypes ?? (0, $9TEHc.BUSINESS_FIELD_TYPES));
        if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, $lO4Or.PROJECT_TYPE));
        return result;
    }, [
        filtersContext,
        inputAllowedFieldTypes
    ]);
};

});
parcelRegister("9TEHc", function(module, exports) {

$parcel$export(module.exports, "POPUP_WIDTH", () => $199ced4cefdf295b$export$b6d617db656efcca);
$parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", () => $199ced4cefdf295b$export$dd535f74d98d8b3);
$parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", () => $199ced4cefdf295b$export$dba112976ea61483);
$parcel$export(module.exports, "GAP_BETWEEN_OPTION", () => $199ced4cefdf295b$export$fe1082abeeda69ed);
$parcel$export(module.exports, "OPTION_SPAN_PADDING", () => $199ced4cefdf295b$export$17ed91292eb6c163);
$parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", () => $199ced4cefdf295b$export$fb22dccd99438559);
$parcel$export(module.exports, "POPUP_OFFSET_TOP", () => $199ced4cefdf295b$export$15839778e99d81e7);
$parcel$export(module.exports, "OPTION_MAX_WIDTH", () => $199ced4cefdf295b$export$39aa3a14ebf850c7);
$parcel$export(module.exports, "DATE_RANGE_TYPE", () => $199ced4cefdf295b$export$1178808c606e043b);
$parcel$export(module.exports, "BUSINESS_FIELD_TYPES", () => $199ced4cefdf295b$export$c269ba5d631cb115);
$parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", () => $199ced4cefdf295b$export$232814e45256d5dc);
$parcel$export(module.exports, "IMPLEMENTED_TYPES", () => $199ced4cefdf295b$export$9615a3d79408a88a);
$parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", () => $199ced4cefdf295b$export$a21166a4b76932b5);
$parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", () => $199ced4cefdf295b$export$1989c7236a398e8a);

var $c9TLT = parcelRequire("c9TLT");

var $lO4Or = parcelRequire("lO4Or");
const $199ced4cefdf295b$export$b6d617db656efcca = 360;
const $199ced4cefdf295b$export$90bfd0dcc25478e1 = (0, $c9TLT.gridSize) * 2.5;
const $199ced4cefdf295b$export$dd535f74d98d8b3 = 32;
const $199ced4cefdf295b$export$dba112976ea61483 = $199ced4cefdf295b$export$b6d617db656efcca - $199ced4cefdf295b$export$90bfd0dcc25478e1 * 2;
const $199ced4cefdf295b$export$fe1082abeeda69ed = (0, $c9TLT.gridSize) / 2;
const $199ced4cefdf295b$export$17ed91292eb6c163 = (0, $c9TLT.gridSize) * 2;
const $199ced4cefdf295b$export$fb22dccd99438559 = 14;
const $199ced4cefdf295b$export$15839778e99d81e7 = 215;
const $199ced4cefdf295b$export$de3cbeaaf9d2669 = 28;
const $199ced4cefdf295b$export$39aa3a14ebf850c7 = 150;
const $199ced4cefdf295b$export$1178808c606e043b = 'dateRange';
const $199ced4cefdf295b$export$c269ba5d631cb115 = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.CREATED),
    $199ced4cefdf295b$export$1178808c606e043b,
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.PROJECT_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.UPDATED),
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE),
    (0, $lO4Or.GOALS_CF_TYPE),
    (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
    (0, $lO4Or.PARENT_FIELD_TYPE)
];
const $199ced4cefdf295b$export$232814e45256d5dc = [
    (0, $lO4Or.SPRINT_TYPE),
    (0, $lO4Or.FIX_VERSIONS_TYPE)
];
const $199ced4cefdf295b$export$9615a3d79408a88a = new Set([
    ...$199ced4cefdf295b$export$c269ba5d631cb115,
    ...$199ced4cefdf295b$export$232814e45256d5dc
]);
const $199ced4cefdf295b$export$a21166a4b76932b5 = new Set([
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE)
]);
const $199ced4cefdf295b$export$90ca377eb0b24ff1 = {
    assignee: (0, $lO4Or.ASSIGNEE_TYPE),
    component: (0, $lO4Or.COMPONENTS_TYPE),
    created: (0, $lO4Or.CREATED),
    issuetype: (0, $lO4Or.ISSUE_TYPE),
    labels: (0, $lO4Or.LABELS_TYPE),
    priority: (0, $lO4Or.PRIORITY_TYPE),
    project: (0, $lO4Or.PROJECT_TYPE),
    reporter: (0, $lO4Or.REPORTER_TYPE),
    status: (0, $lO4Or.STATUS_TYPE),
    type: (0, $lO4Or.ISSUE_TYPE),
    updated: (0, $lO4Or.UPDATED)
};
const $199ced4cefdf295b$export$6a2e733db5135f27 = (0, $c9TLT.gridSize) * 3.5;
const $199ced4cefdf295b$export$1989c7236a398e8a = 50;
const $199ced4cefdf295b$export$91fc9d65fca142a3 = 'users';
const $199ced4cefdf295b$export$d74c70f8fb216c6b = 'recentlyUsedUsers';

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("hCCuu", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", () => $be9e1adc5e199dda$export$cb40bbf7ea51db63);
const $be9e1adc5e199dda$export$cb40bbf7ea51db63 = {
    experience: 'fetch-project',
    packageName: 'jiraBusinessEntityProjectProvider',
    teamName: 'wanjel'
};

});

parcelRegister("k4xGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1de8d4690ad3f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $7e1de8d4690ad3f8$var$NotFoundComponent = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("8UKUA")), {
    moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
});
const $7e1de8d4690ad3f8$var$NotFoundAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "not-found-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e1de8d4690ad3f8$var$NotFoundComponent, null));
var $7e1de8d4690ad3f8$export$2e2bcd8739ae039 = $7e1de8d4690ad3f8$var$NotFoundAsync;

});
parcelRegister("8UKUA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("dX4bq")
]).then(()=>parcelRequire('gutLJ'));

});



parcelRegister("jpVCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $21c64313516c2064$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aml13 = parcelRequire("aml13");

var $7T0RP = parcelRequire("7T0RP");

var $yuXsW = parcelRequire("yuXsW");

var $7e8pf = parcelRequire("7e8pf");

var $fAoR8 = parcelRequire("fAoR8");

var $3555e = parcelRequire("3555e");

var $kQAZu = parcelRequire("kQAZu");

var $cWd72 = parcelRequire("cWd72");

var $6F6Wi = parcelRequire("6F6Wi");

var $4G5xU = parcelRequire("4G5xU");

var $d3C6e = parcelRequire("d3C6e");

var $k3EUD = parcelRequire("k3EUD");

var $c7wtc = parcelRequire("c7wtc");

var $fWkFY = parcelRequire("fWkFY");

var $jasPp = parcelRequire("jasPp");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $gbsaq = parcelRequire("gbsaq");

var $egJIx = parcelRequire("egJIx");

var $dSE3z = parcelRequire("dSE3z");

var $1kNYc = parcelRequire("1kNYc");

var $aPQfg = parcelRequire("aPQfg");
const $21c64313516c2064$var$analyticsSourceName = 'listView';
const $21c64313516c2064$export$4b527a365d42af03 = /*#__PURE__*/ (0, $eUqFw.memo)(({ header: header, formattingRulesQuery: formattingRulesQuery })=>{
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $egJIx.useJWMListFeatures)();
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const projectKey = projectData.key;
    const projectName = projectData.name;
    const isTeamManaged = projectData.isSimplified;
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const isGroupingByStatus = groupByFieldId === (0, $lO4Or.STATUS_TYPE);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const services = (0, $eI5EY.fg)('use-generated-types-for-create-issue') ? (0, $1kNYc.useCreateIssue)() : undefined;
    const ConditionalWorkflowProvider = (0, $eI5EY.fg)('jwm_conditional_workflow_data_loading') || isGroupingByStatus ? (0, $c7wtc.WorkflowsProvider) : (0, $eUqFw.Fragment);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        objectType: "list",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: $21c64313516c2064$var$analyticsSourceName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aPQfg.default), {
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isTeamManaged: isTeamManaged,
        formattingRulesQuery: formattingRulesQuery
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            projectKey: projectKey
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7e8pf.default), {
        header: header,
        sidebarTheme: isSoftwareFieldsEnabled ? 'software' : 'business',
        withSidebar: true,
        withOverflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWd72.IssueTypesAndFieldsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConditionalWorkflowProvider, {
        enabled: isGroupingByStatus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d3C6e.IssueCreateProvider), {
        mutation: (0, $k3EUD.CREATE_ISSUE_MUTATION),
        query: (0, $k3EUD.ISSUE_REFETCH_QUERY),
        onCreateIssue: services?.createIssue,
        onRefetchIssue: services?.refetchIssue
    }, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6F6Wi.RefetchFieldsController), null)));
});
const $21c64313516c2064$var$ListViewRootWithConfluenceProvider = ({ children: children })=>{
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    return hasConfluence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fAoR8.ConfluenceModalProvider), null, children) : children;
};
const $21c64313516c2064$export$d63bf888f7c02a67 = (props)=>{
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    // `hasConfluence` check only needed until we roll out `jsw_perf_format-links-in-custom-fields` experiment.
    // remove this condition after clean up but keep `SmartCardProvider` & `ListViewRootWithConfluenceProvider`
    if (hasConfluence || (0, $79xbN.expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21c64313516c2064$var$ListViewRootWithConfluenceProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
        client: (0, $7T0RP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21c64313516c2064$export$4b527a365d42af03, props))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
        client: (0, $7T0RP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21c64313516c2064$export$4b527a365d42af03, props));
};
const $21c64313516c2064$var$List = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $gbsaq.VIEW_EXPERIENCE),
        shouldStartExperience: true
    }, (0, $eI5EY.fg)('jira_list_add_401_error_handling') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jasPp.AuthenticationErrorBoundary), {
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWkFY.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21c64313516c2064$export$d63bf888f7c02a67, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21c64313516c2064$export$d63bf888f7c02a67, props));
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$21c64313516c2064$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($21c64313516c2064$var$List);

});
parcelRegister("aml13", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $ddfb038c93ff29bc$export$497ecb0280204df4);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $cGAGh = parcelRequire("cGAGh");

var $fQDHB = parcelRequire("fQDHB");

var $aatVr = parcelRequire("aatVr");

var $gqldc = parcelRequire("gqldc");

var $1Hojg = parcelRequire("1Hojg");
function $ddfb038c93ff29bc$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $eUqFw.useContext)((0, $gqldc.SmartCardContext));
    const defaultInitialState = (0, $eUqFw.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eUqFw.useMemo)(()=>{
        return (0, $huRi7.createStore)((0, $aatVr.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eUqFw.useMemo)(()=>{
        const client = customClient || new (0, $1Hojg.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cGAGh.getUrl)(store, url);
            return cardState.details ? (0, $fQDHB.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqldc.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $ddfb038c93ff29bc$export$2e2bcd8739ae039 = $ddfb038c93ff29bc$export$497ecb0280204df4;

});
parcelRegister("cGAGh", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $6b31d06902eb0186$export$94df0e59ebebf4a7);
const $6b31d06902eb0186$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("fQDHB", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $060df7d9b738514e$export$4b0d98b1b7f6d115);

var $5amkT = parcelRequire("5amkT");

var $9W7HP = parcelRequire("9W7HP");
const $060df7d9b738514e$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $5amkT.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("5amkT", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $8b80b7bf7b97ac24$export$3e8ad908070b68b2);
const $8b80b7bf7b97ac24$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("9W7HP", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65);
const $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("aatVr", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $f4cdd08462296438$export$3c7c3113a97b6492);

var $6EHO5 = parcelRequire("6EHO5");
var $4hPjC = parcelRequire("4hPjC");
const $f4cdd08462296438$var$isCardAction = (action)=>{
    return [
        (0, $6EHO5.ACTION_PENDING),
        (0, $6EHO5.ACTION_RESOLVING),
        (0, $6EHO5.ACTION_RESOLVED),
        (0, $6EHO5.ACTION_RELOADING),
        (0, $6EHO5.ACTION_ERROR),
        (0, $6EHO5.ACTION_ERROR_FALLBACK),
        (0, $6EHO5.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $f4cdd08462296438$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $4hPjC.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $f4cdd08462296438$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $6EHO5.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVED:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $6EHO5.ACTION_RELOADING:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $6EHO5.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $6EHO5.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $6EHO5.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $f4cdd08462296438$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$f4cdd08462296438$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $f4cdd08462296438$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("6EHO5", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $48f17d480117024d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $48f17d480117024d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $48f17d480117024d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $48f17d480117024d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $48f17d480117024d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $48f17d480117024d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $48f17d480117024d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $48f17d480117024d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $48f17d480117024d$export$6e470aad5ba8952e = 'pending';
const $48f17d480117024d$export$9a6a932a0a39498e = 'resolving';
const $48f17d480117024d$export$63ec8bc7a8a75482 = 'resolved';
const $48f17d480117024d$export$b8cfaa842c9ab487 = 'reloading';
const $48f17d480117024d$export$6d8ed3f9433dd372 = 'errored';
const $48f17d480117024d$export$cfbbb7126bc8a0c6 = 'fallback';
const $48f17d480117024d$export$76b5c1aca20759c6 = 'preload';
const $48f17d480117024d$export$2c5edb971b673330 = 'metadata';
const $48f17d480117024d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("4hPjC", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6a6a7fcdba3f3a7c$export$b70265791d2079d4);
const $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $6a6a7fcdba3f3a7c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("gqldc", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $ee9cd29169baa49b$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $ee9cd29169baa49b$export$e1d190b530cf0ee9);

var $eUqFw = parcelRequire("eUqFw");

const $ee9cd29169baa49b$export$156b523e63b4f63a = (0, $eUqFw.createContext)(undefined);
function $ee9cd29169baa49b$export$e1d190b530cf0ee9() {
    const context = (0, $eUqFw.useContext)($ee9cd29169baa49b$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $ee9cd29169baa49b$export$2e2bcd8739ae039 = $ee9cd29169baa49b$export$156b523e63b4f63a;

});

parcelRegister("1Hojg", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d12fbaea01fc74$export$2e2bcd8739ae039);

var $1l2Nv = parcelRequire("1l2Nv");

var $aTD8J = parcelRequire("aTD8J");

var $bsIpz = parcelRequire("bsIpz");

var $f9yXU = parcelRequire("f9yXU");
var $dUrSu = parcelRequire("dUrSu");
var $4hPjC = parcelRequire("4hPjC");
var $5LW2w = parcelRequire("5LW2w");

var $gbc85 = parcelRequire("gbc85");

var $6roQF = parcelRequire("6roQF");

var $XHGTv = parcelRequire("XHGTv");
const $22d12fbaea01fc74$var$MAX_BATCH_SIZE = 50;
const $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE = 100;
const $22d12fbaea01fc74$export$d6a66073b5d79eb3 = new (0, $6roQF.LRUMap)($22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE);
class $22d12fbaea01fc74$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ ...(0, $XHGTv.fg)('platform.linking-platform.datasource.add-timezone-header') ? {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
                } : {},
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $gbc85.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dUrSu.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($bsIpz)))({
            limit: 1,
            interval: $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1l2Nv)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $22d12fbaea01fc74$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $22d12fbaea01fc74$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $gbc85.isSuccessfulResponse)(response) || (0, $4hPjC.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $gbc85.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $gbc85.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $gbc85.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $gbc85.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $gbc85.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $5LW2w.NetworkError)) return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                    return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                    return new (0, $f9yXU.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                    return new (0, $f9yXU.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                    return new (0, $f9yXU.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
            if ((0, $XHGTv.fg)('map_new_ors_generic_error_types_in_link_provider')) switch(errorType){
                case 'BadRequestError':
                    return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                case 'AuthError':
                    return new (0, $f9yXU.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                case 'UnsupportedError':
                    return new (0, $f9yXU.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $f9yXU.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $f9yXU.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("1l2Nv", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $0f99ec2102c35890$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $0f99ec2102c35890$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $0f99ec2102c35890$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $0f99ec2102c35890$var$getValidCacheKeyFn(options);
        this._cacheMap = $0f99ec2102c35890$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $0f99ec2102c35890$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $0f99ec2102c35890$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$0f99ec2102c35890$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $0f99ec2102c35890$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$0f99ec2102c35890$var$resolvedPromise) $0f99ec2102c35890$var$resolvedPromise = Promise.resolve();
    $0f99ec2102c35890$var$resolvedPromise.then(function() {
        $2fFJv.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $0f99ec2102c35890$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $0f99ec2102c35890$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $0f99ec2102c35890$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $0f99ec2102c35890$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $0f99ec2102c35890$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$0f99ec2102c35890$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $0f99ec2102c35890$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $0f99ec2102c35890$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $0f99ec2102c35890$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $0f99ec2102c35890$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $0f99ec2102c35890$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $0f99ec2102c35890$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $0f99ec2102c35890$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $0f99ec2102c35890$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $0f99ec2102c35890$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $0f99ec2102c35890$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $0f99ec2102c35890$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $0f99ec2102c35890$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $0f99ec2102c35890$var$DataLoader;

});

parcelRegister("aTD8J", function(module, exports) {
// Packages

var $kiPA0 = parcelRequire("kiPA0");
function $7eed66c63d4af541$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        var op = $kiPA0.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $7eed66c63d4af541$var$retry;

});
parcelRegister("kiPA0", function(module, exports) {

module.exports = (parcelRequire("2aMUW"));

});
parcelRegister("2aMUW", function(module, exports) {

var $6ZiEJ = parcelRequire("6ZiEJ");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $6ZiEJ(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("6ZiEJ", function(module, exports) {
function $5166e949108ea881$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $5166e949108ea881$var$RetryOperation;
$5166e949108ea881$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$5166e949108ea881$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$5166e949108ea881$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$5166e949108ea881$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$5166e949108ea881$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = $5166e949108ea881$var$RetryOperation.prototype.try;
$5166e949108ea881$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$5166e949108ea881$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$5166e949108ea881$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("bsIpz", function(module, exports) {
'use strict';
class $8584c26edaaf8f93$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $8584c26edaaf8f93$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $8584c26edaaf8f93$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $8584c26edaaf8f93$var$pThrottle;
module.exports.AbortError = $8584c26edaaf8f93$var$AbortError;

});

parcelRegister("f9yXU", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $eab65a9e311d10e1$export$3e5b797e39668f84);
class $eab65a9e311d10e1$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`);
        this.kind = kind;
        this.hostname = hostname;
        this.message = message;
        this.type = type;
        this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("dUrSu", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $67d3f38f231759a2$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $67d3f38f231759a2$export$dc37652c1696f231);
const $67d3f38f231759a2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $67d3f38f231759a2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $67d3f38f231759a2$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $67d3f38f231759a2$export$e2b040f052407032 = {
    dev: $67d3f38f231759a2$var$devBaseUrl,
    development: $67d3f38f231759a2$var$devBaseUrl,
    stg: $67d3f38f231759a2$var$stgBaseUrl,
    staging: $67d3f38f231759a2$var$stgBaseUrl,
    prd: $67d3f38f231759a2$var$prodBaseUrl,
    prod: $67d3f38f231759a2$var$prodBaseUrl,
    production: $67d3f38f231759a2$var$prodBaseUrl
};
const $67d3f38f231759a2$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $67d3f38f231759a2$export$e2b040f052407032 ? $67d3f38f231759a2$export$e2b040f052407032[envKey] : $67d3f38f231759a2$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $67d3f38f231759a2$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $67d3f38f231759a2$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $67d3f38f231759a2$export$2e2bcd8739ae039 = $67d3f38f231759a2$export$e2b040f052407032;

});

parcelRegister("5LW2w", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $182a4c691eac998e$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $182a4c691eac998e$export$b5fe3f66a567bec0);
const $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $182a4c691eac998e$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $182a4c691eac998e$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $182a4c691eac998e$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("gbc85", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $fe0c9814ae7f11c7$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $fe0c9814ae7f11c7$export$bea7bee8a87e7c52);
const $fe0c9814ae7f11c7$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $fe0c9814ae7f11c7$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("7T0RP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42cc5e4608d3fe0$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $gUUjF = parcelRequire("gUUjF");

var $aXA7t = parcelRequire("aXA7t");

var $iV2Ac = parcelRequire("iV2Ac");

var $1ZkL6 = parcelRequire("1ZkL6");

var $9ypom = parcelRequire("9ypom");
const $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $e42cc5e4608d3fe0$var$CACHE_NAME = `apollo-cache/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}`;
const $e42cc5e4608d3fe0$var$LOG_NAMESPACE = `apollo.${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
const $e42cc5e4608d3fe0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $e42cc5e4608d3fe0$export$851a7159daf49c89 = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($iV2Ac))
});
const $e42cc5e4608d3fe0$var$errorLink = (0, $aqG9W.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $1ZkL6.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $1ZkL6.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(operation.getContext(), [
            $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $e42cc5e4608d3fe0$var$retryLinkWithFama = new (0, $kcwGc.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $1ZkL6.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $e42cc5e4608d3fe0$var$CancelableRequestLink extends (0, $bvQX6.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $bvQX6.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $e42cc5e4608d3fe0$var$cache = new (0, $2vRh6.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $e42cc5e4608d3fe0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
}).restore(!$e42cc5e4608d3fe0$var$isSsrSuccessful() && window.SPA_STATE[$e42cc5e4608d3fe0$var$CACHE_NAME] || {});
const $e42cc5e4608d3fe0$export$de66868aab9e79ea = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $e42cc5e4608d3fe0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $bvQX6.ApolloLink).from([
            $e42cc5e4608d3fe0$var$retryLinkWithFama,
            $e42cc5e4608d3fe0$var$errorLink,
            (0, $aXA7t.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($e42cc5e4608d3fe0$var$cache),
            ...!$e42cc5e4608d3fe0$var$isSsrSuccessful() ? [
                new $e42cc5e4608d3fe0$var$CancelableRequestLink()
            ] : [],
            new (0, $35Kb7.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$e42cc5e4608d3fe0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $e42cc5e4608d3fe0$var$cache,
        connectToDevTools: false
    });
var $e42cc5e4608d3fe0$export$2e2bcd8739ae039 = {
    clientId: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $e42cc5e4608d3fe0$export$de66868aab9e79ea
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});

parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $bvQX6.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $bvQX6.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $bvQX6.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("10n8H", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $0bb7bd86ef08f58c$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d);

var $42BH7 = parcelRequire("42BH7");

var $hiwGV = parcelRequire("hiwGV");

var $2vRh6 = parcelRequire("2vRh6");
function $0bb7bd86ef08f58c$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2vRh6.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $42BH7.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $hiwGV.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("hiwGV", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $c97d79f1a0a9adb8$export$a13f755900e15d9e);

var $bvQX6 = parcelRequire("bvQX6");

var $42BH7 = parcelRequire("42BH7");

var $77JSu = parcelRequire("77JSu");

var $fl4NX = parcelRequire("fl4NX");
var $c97d79f1a0a9adb8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c97d79f1a0a9adb8$var$graphql = $77JSu.graphql;
var $c97d79f1a0a9adb8$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $c97d79f1a0a9adb8$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $c97d79f1a0a9adb8$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $bvQX6.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fl4NX.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $42BH7.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fl4NX.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $c97d79f1a0a9adb8$var$capitalizeFirstLetter(((0, $42BH7.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $bvQX6.Observable).of({
                data: {}
            });
            return new (0, $bvQX6.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $c97d79f1a0a9adb8$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $bvQX6.ApolloLink)))();
};

});
parcelRegister("77JSu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");

var $1BuKE = parcelRequire("1BuKE");
function $52fcc63cc3cd9b23$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $52fcc63cc3cd9b23$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $52fcc63cc3cd9b23$var$graphql;
function $52fcc63cc3cd9b23$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $fKE23.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $fKE23.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$42BH7.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$42BH7.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $42BH7.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $1BuKE.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($42BH7.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $1BuKE.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeField(field, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $42BH7.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $42BH7.resultKeyNameFromField(field),
                        directives: $42BH7.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, item, execContext);
        return $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("1BuKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42BH7 = parcelRequire("42BH7");
function $12b119b85c2553d1$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $12b119b85c2553d1$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $12b119b85c2553d1$var$graphql;
function $12b119b85c2553d1$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$42BH7.shouldInclude(selection, variables)) return;
        if ($42BH7.isField(selection)) {
            var fieldResult = $12b119b85c2553d1$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $42BH7.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $12b119b85c2553d1$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($42BH7.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $12b119b85c2553d1$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $12b119b85c2553d1$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $12b119b85c2553d1$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $42BH7.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $42BH7.resultKeyNameFromField(field),
        directives: $42BH7.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext);
    return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, item, execContext);
        return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $12b119b85c2553d1$var$hasOwn = Object.prototype.hasOwnProperty;
function $12b119b85c2553d1$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$12b119b85c2553d1$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $12b119b85c2553d1$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $12b119b85c2553d1$var$merge;

});


parcelRegister("fl4NX", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b2ac8b51e1cafdcd$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b2ac8b51e1cafdcd$export$467f9c465e4ace4e);

var $aKlnM = parcelRequire("aKlnM");

var $42BH7 = parcelRequire("42BH7");
var $b2ac8b51e1cafdcd$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b2ac8b51e1cafdcd$var$removed = new Map();
function $b2ac8b51e1cafdcd$export$8eae69e876ee321e(query) {
    var cached = $b2ac8b51e1cafdcd$var$removed.get(query);
    if (cached) return cached;
    (0, $42BH7.checkDocument)(query);
    var docClone = (0, $42BH7.removeDirectivesFromDocument)([
        $b2ac8b51e1cafdcd$var$connectionRemoveConfig
    ], query);
    $b2ac8b51e1cafdcd$var$removed.set(query, docClone);
    return docClone;
}
function $b2ac8b51e1cafdcd$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $aKlnM.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("aXA7t", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $2f1700194c3d8ae8$export$fb326ed954631f3f);

var $bvQX6 = parcelRequire("bvQX6");

var $fYqUr = parcelRequire("fYqUr");
const $2f1700194c3d8ae8$export$fb326ed954631f3f = new (0, $bvQX6.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $fYqUr.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("iV2Ac", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskSubmissionFailed\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("1ZkL6", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a205b903a47dbc85$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a205b903a47dbc85$export$a78ebe1911f50d41);

var $illlw = parcelRequire("illlw");

var $jlBDe = parcelRequire("jlBDe");

var $guiFP = parcelRequire("guiFP");
const $a205b903a47dbc85$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a205b903a47dbc85$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a205b903a47dbc85$export$15d632fe38832073]: errorAnalytics
    });
const $a205b903a47dbc85$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(context, [
        $a205b903a47dbc85$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a205b903a47dbc85$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a205b903a47dbc85$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $jlBDe.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("yuXsW", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $343a391851b41a38$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $343a391851b41a38$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $343a391851b41a38$export$8e363dbef886ff17);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $4ErPU = parcelRequire("4ErPU");

var $gd0Sp = parcelRequire("gd0Sp");
const $343a391851b41a38$var$CLIENTS_CACHE = {};
const $343a391851b41a38$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $343a391851b41a38$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $343a391851b41a38$var$CLIENTS_CACHE[clientId];
};
const $343a391851b41a38$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($343a391851b41a38$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $343a391851b41a38$var$CLIENTS_CACHE[key].extract()
        }), {});
const $343a391851b41a38$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $343a391851b41a38$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $343a391851b41a38$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $343a391851b41a38$export$8e363dbef886ff17 extends (0, $eUqFw.Component) {
    getClient(baseUrl, xsrfToken) {
        return $343a391851b41a38$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("7e8pf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed5a3ae63b1b20d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kar7l = parcelRequire("kar7l");


var $hSCS8 = parcelRequire("hSCS8");

var $eUu4u = parcelRequire("eUu4u");

var $2ESAZ = parcelRequire("2ESAZ");
// This wrapper should be agnostic, please don't add any project or overview logic here.
const $3ed5a3ae63b1b20d$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
    const [{ content: sidebarContent }] = (0, $hSCS8.useSidebar)();
    const isSidebarOpen = withSidebar && sidebarContent != null;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, header, children);
    if (withSidebar) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUu4u.SidebarLayout), {
        theme: sidebarTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $3ed5a3ae63b1b20d$var$contentWrapperStyles,
            isSidebarOpen && $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles
        ]
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ESAZ.ThemedContainer), {
        shouldAddPadding: shouldAddPadding,
        isSidebarOpen: isSidebarOpen,
        withSidebar: withSidebar,
        withDynamicHeight: withDynamicHeight,
        withOverflow: withOverflow,
        id: (0, $d02be44255a1478f$export$e5e75ff4daca6597),
        // Used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, content);
};
const $3ed5a3ae63b1b20d$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error - we need to use Tokens to correctly set the color value using CSS variables
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    color: (0, $kar7l.Tokens).COLOR_TEXT,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: '0',
    width: 'auto'
});
const $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
var $3ed5a3ae63b1b20d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3ed5a3ae63b1b20d$var$BusinessAppWrapper);

});
const $d02be44255a1478f$export$e5e75ff4daca6597 = 'jwm-container';

parcelRegister("hSCS8", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $cda1eebb5d053035$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $cda1eebb5d053035$export$54c70f22f548bff8);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $jGcn0 = parcelRequire("jGcn0");

var $iclz4 = parcelRequire("iclz4");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $l0jym = parcelRequire("l0jym");
const $cda1eebb5d053035$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $cda1eebb5d053035$export$b16f75f2e0c3c029 = 360;
const $cda1eebb5d053035$export$ddc11e4d41e7cf62 = ()=>[
        (0, $jGcn0.SELECTED_ISSUE_PARAM),
        (0, $jGcn0.SELECTED_COMMENT_PARAM)
    ];
const $cda1eebb5d053035$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $cda1eebb5d053035$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newWidth = Math.max(width, $cda1eebb5d053035$export$b16f75f2e0c3c029);
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $l0jym.localStorage).set($cda1eebb5d053035$export$86880b4b2e1a2384, newWidth);
    };
const $cda1eebb5d053035$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $cda1eebb5d053035$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        });
    };
const $cda1eebb5d053035$var$actions = {
    setSidebarContent: $cda1eebb5d053035$var$setSidebarContent,
    setSidebarWidth: $cda1eebb5d053035$var$setSidebarWidth,
    setSidebarOnClose: $cda1eebb5d053035$var$setSidebarOnClose,
    closeSidebar: $cda1eebb5d053035$var$closeSidebar
};
const $cda1eebb5d053035$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        content: null,
        sidebarWidth: (0, $l0jym.localStorage).get($cda1eebb5d053035$export$86880b4b2e1a2384) || $cda1eebb5d053035$export$b16f75f2e0c3c029,
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    actions: $cda1eebb5d053035$var$actions,
    name: 'JWMSidebarStore'
});
const $cda1eebb5d053035$var$useHook = (0, $1yZQx.createHook)($cda1eebb5d053035$var$Store);
const $cda1eebb5d053035$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $cda1eebb5d053035$var$useHook();
    const sidebarQueryParams = $cda1eebb5d053035$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("jGcn0", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $15ed10c690a013f2$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $15ed10c690a013f2$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $15ed10c690a013f2$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $15ed10c690a013f2$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $15ed10c690a013f2$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $15ed10c690a013f2$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $15ed10c690a013f2$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $15ed10c690a013f2$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $15ed10c690a013f2$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $15ed10c690a013f2$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $15ed10c690a013f2$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $15ed10c690a013f2$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $15ed10c690a013f2$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $15ed10c690a013f2$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $15ed10c690a013f2$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$c72ea455b368cdd9);

const $15ed10c690a013f2$export$8386e51ba415e85d = (0, $44cab0426b6cf0d7$export$1dee026a19752d6b);
const $15ed10c690a013f2$export$159fe44438c210e9 = '48x48';
const $15ed10c690a013f2$export$d8301e0b33832d94 = 'filter';
const $15ed10c690a013f2$export$599c163c1570a353 = 'inlineCreate';
const $15ed10c690a013f2$export$3a74d1a195d2f007 = 'inviteOpen';
const $15ed10c690a013f2$export$e1e3f9fa6f04d6d = 'quickFilters';
const $15ed10c690a013f2$export$c070acdc9b0f1be5 = 'selectedIssue';
const $15ed10c690a013f2$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $15ed10c690a013f2$export$dba794af6c0f2afc = 'assignee';
const $15ed10c690a013f2$export$56ecb5d2dfb80edc = 'priority';
const $15ed10c690a013f2$export$22ef551f315f2786 = 'category';
const $15ed10c690a013f2$export$6d69efb296b78a = 'status';
const $15ed10c690a013f2$export$e23e1d1ea45171c2 = 'startdate';
const $15ed10c690a013f2$export$e35c6e217c75dc4b = 'rank';
const $15ed10c690a013f2$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $15ed10c690a013f2$export$a311e1b78816c048 = 'commentsummary';
const $15ed10c690a013f2$export$f5583ff4ab4d63e5 = 'cardCovers';
const $15ed10c690a013f2$export$5716e8bcb003888d = 25;
const $15ed10c690a013f2$export$1f9fb9f15184100f = 'storypoints';
const $15ed10c690a013f2$export$c72ea455b368cdd9 = 'storypointestimate';
const $15ed10c690a013f2$export$786b42b4618e6ee4 = 'sprint';

});
const $44cab0426b6cf0d7$export$1dee026a19752d6b = 'ASC';
const $44cab0426b6cf0d7$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("l0jym", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $9c968063af1d87e8$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $9c968063af1d87e8$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_business_common');

});


parcelRegister("eUu4u", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $b41642a7c0ef06fe$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $h585o = parcelRequire("h585o");

var $h5BJf = parcelRequire("h5BJf");

var $hSCS8 = parcelRequire("hSCS8");

var $lRBAz = parcelRequire("lRBAz");
const $b41642a7c0ef06fe$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            (0, $1ybV0.ff)('jwm-sidebar-resizer-limit_4m1km') ? $b41642a7c0ef06fe$var$sidebarStyles : $b41642a7c0ef06fe$var$oldSidebarStyles,
            theme === 'business' && $b41642a7c0ef06fe$var$businessSidebarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: sidebarWidth
        }
    }, children);
const $b41642a7c0ef06fe$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
    (0, $h585o.useSidebarQueryParams)();
    const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, $h5BJf.useResizer)();
    // reset sidebar content on view unmount
    (0, $eUqFw.useEffect)(()=>()=>{
            setSidebarContent(null);
        }, [
        setSidebarContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.Wrapper), {
        isResizing: isResizing,
        "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
    }, children, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b41642a7c0ef06fe$var$Sidebar, {
        sidebarWidth: sidebarWidth,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.ResizeHandle), {
        onMouseDown: onMouseDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.SidebarContent), null, content)));
};
const $b41642a7c0ef06fe$var$oldSidebarStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card'
});
const $b41642a7c0ef06fe$var$sidebarStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card',
    maxWidth: '75%'
});
const $b41642a7c0ef06fe$var$businessSidebarStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'border.radius.200',
    borderTopRightRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    marginRight: 'space.300',
    marginTop: 'space.300'
});

});
parcelRegister("h585o", function(module, exports) {

$parcel$export(module.exports, "useSidebarQueryParams", () => $357741b682c79613$export$34adbeffbeceba68);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $eI5EY = parcelRequire("eI5EY");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iclz4 = parcelRequire("iclz4");

var $hSCS8 = parcelRequire("hSCS8");
const $357741b682c79613$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
const $357741b682c79613$export$34adbeffbeceba68 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, $hSCS8.useSidebar)();
    const sidebarQueryParams = (0, $hSCS8.getSidebarQueryParams)();
    const [queryParams, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const prevQueryParams = (0, $hzcvF.usePreviousWithInitial)(queryParams);
    const closeSidebar = (0, $eUqFw.useCallback)(()=>{
        // reset sidebar query params (IssueApp, Comments)
        resetSidebarQueryParams();
        // reset sidebar content
        setSidebarContent(null);
    }, [
        resetSidebarQueryParams,
        setSidebarContent
    ]);
    // keep only one sidebar-related query param at the time
    (0, $eUqFw.useEffect)(()=>{
        sidebarQueryParams.forEach((queryParam)=>{
            if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                        [param]: undefined
                    }), {});
                setQueryParams(newQueryParams);
            }
        });
    }, [
        prevQueryParams,
        queryParams,
        setQueryParams,
        sidebarQueryParams
    ]);
    // handle closing sidebar on Escape
    (0, $eUqFw.useEffect)(()=>{
        const handleKeydown = (event)=>{
            if (!queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && (0, $eI5EY.fg)('jira_list_keyboard_nav')) // sidebar is not open, exit
            return;
            if (queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') // should not close the sidebar if the sidebar and modal is open
            return;
            if ($357741b682c79613$var$isEscapeEvent(event)) {
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                closeSidebar();
            }
        };
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        closeSidebar,
        content?.key,
        createAnalyticsEvent,
        queryParams
    ]);
};

});

parcelRegister("h5BJf", function(module, exports) {

$parcel$export(module.exports, "useResizer", () => $2c653e9e7bda86ce$export$faede3f1542958fc);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $hSCS8 = parcelRequire("hSCS8");
const $2c653e9e7bda86ce$var$THROTTLE_TIME = 16;
const $2c653e9e7bda86ce$export$faede3f1542958fc = ()=>{
    const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, $hSCS8.useSidebar)();
    const startRef = (0, $eUqFw.useRef)(0);
    // storing width in a ref to avoid re-creating onMouseMove handler during resize
    const width = (0, $eUqFw.useRef)(0);
    const [isResizing, setIsResizing] = (0, $eUqFw.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resize = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((clientX)=>{
        const proposedWidth = width.current + startRef.current - clientX;
        setSidebarWidth(proposedWidth);
    }, $2c653e9e7bda86ce$var$THROTTLE_TIME), [
        setSidebarWidth
    ]);
    const onMouseMove = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        resize(event.clientX);
    }, [
        resize
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)(()=>{
        startRef.current = 0;
        width.current = 0;
        setIsResizing(false);
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }, [
        onMouseMove,
        onMouseUp
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        startRef.current = event.clientX;
        width.current = sidebarWidth;
        setIsResizing(true);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp,
        sidebarWidth
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        isResizing: isResizing
    };
};

});

parcelRegister("lRBAz", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $8c2051301c5af547$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SidebarContent", () => $8c2051301c5af547$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "ResizeHandle", () => $8c2051301c5af547$export$33f2411a0ad35be7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8c2051301c5af547$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
            __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2ESAZ", function(module, exports) {

$parcel$export(module.exports, "ThemedContainer", () => $c8a88c0524c1629a$export$2a4209ec8a7db359);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c8a88c0524c1629a$export$2a4209ec8a7db359 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
            !__cmplp.withSidebar && "_syaz1c2q",
            __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
            __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
            __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
            __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fAoR8", function(module, exports) {

$parcel$export(module.exports, "ConfluenceModalProvider", () => $c504526f38fce139$export$465701d340b2a0fb);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $fQ8Gt = parcelRequire("fQ8Gt");

var $38C70 = parcelRequire("38C70");

var $Mkrqy = parcelRequire("Mkrqy");

var $5bEwi = parcelRequire("5bEwi");
const $c504526f38fce139$export$465701d340b2a0fb = ({ children: children })=>{
    const viewModalControlNew = (0, $Mkrqy.useConfluenceViewModalNew)();
    const { createModalProps: createModalProps, showCreatePage: showCreatePage, hideCreatePage: hideCreatePage } = (0, $Mkrqy.useConfluenceCreatePageModal)();
    const confluenceContext = (0, $eUqFw.useMemo)(()=>({
            showConfluencePage: viewModalControlNew.showConfluencePage,
            showCreatePage: showCreatePage
        }), [
        viewModalControlNew.showConfluencePage,
        showCreatePage
    ]);
    const { confluencePageUrl: confluencePageUrl, viewMode: viewMode, onCloseCompleteCallback: onCloseCompleteCallback } = viewModalControlNew.viewModalProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ8Gt.confluencePagesContext).Provider, {
        value: confluenceContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, confluencePageUrl != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bEwi.default), {
        onClose: viewModalControlNew.hideConfluencePage,
        confluenceUrl: confluencePageUrl || '',
        mode: viewMode,
        onCloseComplete: onCloseCompleteCallback,
        isOpen: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $38C70.default), {
        onClose: hideCreatePage,
        ...createModalProps
    }));
};

});
parcelRegister("fQ8Gt", function(module, exports) {

$parcel$export(module.exports, "confluencePagesContext", () => $37beefa91041e6e4$export$4cb8e522e2ecb030);
$parcel$export(module.exports, "useConfluencePagesModals", () => $37beefa91041e6e4$export$750ed67ce7764287);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $37beefa91041e6e4$export$4cb8e522e2ecb030 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    showConfluencePage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    showCreatePage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $37beefa91041e6e4$export$750ed67ce7764287 = ()=>{
    const context = (0, $eUqFw.useContext)($37beefa91041e6e4$export$4cb8e522e2ecb030);
    const { showConfluencePage: showConfluencePage, showCreatePage: showCreatePage } = context;
    return {
        showConfluencePage: showConfluencePage,
        showCreatePage: showCreatePage
    };
};

});

parcelRegister("38C70", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5a2043a17368e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ce5a2043a17368e7$var$LazyCreatePage = (0, $7rh0R.lazy)(()=>(parcelRequire("jsZKc")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/create-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ce5a2043a17368e7$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "create-page-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ce5a2043a17368e7$var$LazyCreatePage, props));

});
parcelRegister("jsZKc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("iWR0i")
]).then(()=>parcelRequire('4gJwS'));

});


parcelRegister("Mkrqy", function(module, exports) {

$parcel$export(module.exports, "useConfluenceCreatePageModal", () => $7c28d3b4703778fb$export$81799af04beb008f);
$parcel$export(module.exports, "useConfluenceViewModalNew", () => $7c28d3b4703778fb$export$3cac20211c8788d8);

var $eUqFw = parcelRequire("eUqFw");

var $eDn3S = parcelRequire("eDn3S");

var $bFzGY = parcelRequire("bFzGY");

var $jMP2a = parcelRequire("jMP2a");
const $7c28d3b4703778fb$export$81799af04beb008f = ()=>{
    const [createModalProps, setCreateModalProps] = (0, $eUqFw.useState)({
        showCreateModal: false,
        onCreate: undefined
    });
    const showCreatePage = (0, $eUqFw.useCallback)(({ onCreate: onCreate, onCloseComplete: onCloseComplete, onCancel: onCancel } = {})=>setCreateModalProps({
            showCreateModal: true,
            onCreate: onCreate,
            onCloseComplete: onCloseComplete,
            onCancel: onCancel
        }), []);
    const hideCreatePage = (0, $eUqFw.useCallback)(()=>setCreateModalProps({
            showCreateModal: false,
            onCreate: undefined
        }), []);
    return {
        createModalProps: createModalProps,
        showCreatePage: showCreatePage,
        hideCreatePage: hideCreatePage
    };
};
const $7c28d3b4703778fb$export$3cac20211c8788d8 = ()=>{
    const [viewModalProps, setViewModalProps] = (0, $eUqFw.useState)({
        confluencePageUrl: null,
        viewMode: (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        onCloseCompleteCallback: undefined
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const showConfluencePage = (0, $eUqFw.useCallback)(({ confluenceUrl: confluenceUrl, mode: mode, onCloseComplete: onCloseComplete })=>{
        setViewModalProps({
            confluencePageUrl: confluenceUrl,
            viewMode: mode || (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: onCloseComplete
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal viewed');
    }, [
        createAnalyticsEvent
    ]);
    /**
	 * Sets the modal props state back to a default state, which will cause the modal to close
	 *
	 * NOTE: There's a [StrictMode](https://react.dev/reference/react/StrictMode) bug using the
	 * `onCloseCompleteCallback` prop on `@atlaskit/modal-dialog`. This issue has been raised with the
	 * Design System team in the following [thread](https://atlassian.slack.com/archives/CFJ9DU39U/p1715670965075749).
	 * StrictMode is enabled by default in local development so this will not work in local dev
	 * until fixed but works in production.
	 */ const hideConfluencePage = (0, $eUqFw.useCallback)(()=>{
        setViewModalProps({
            confluencePageUrl: null,
            viewMode: (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: undefined
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal closed');
    }, [
        createAnalyticsEvent
    ]);
    return {
        viewModalProps: viewModalProps,
        showConfluencePage: showConfluencePage,
        hideConfluencePage: hideConfluencePage
    };
};

});

parcelRegister("5bEwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6c1b8e81f1ff3d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e6c1b8e81f1ff3d7$var$LazyConfluenceViewModal = (0, $7rh0R.lazy)(()=>(parcelRequire("jsbKl")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/view-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e6c1b8e81f1ff3d7$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "view-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e6c1b8e81f1ff3d7$var$LazyConfluenceViewModal, props));

});
parcelRegister("jsbKl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bfFl5")
]).then(()=>parcelRequire('eCTVv'));

});



parcelRegister("3555e", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $583c95185f8eb6cc$export$964fe2dd9242a588);

var $e91YZ = parcelRequire("e91YZ");

var $j3FUN = parcelRequire("j3FUN");
const $583c95185f8eb6cc$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).CONFLUENCE]);
};

});

parcelRegister("cWd72", function(module, exports) {

$parcel$export(module.exports, "IssueTypesAndFieldsContext", () => $c6421b4581e45226$export$31eaf35dc72d0fa0);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gEmpR = parcelRequire("gEmpR");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $c6421b4581e45226$var$noop = ()=>{};
// track Apollo cache watchers 1 sec after availableFields query finishes to make sure UI is fully rendered
const $c6421b4581e45226$var$TRACKING_TIMEOUT = 1000;
const $c6421b4581e45226$export$31eaf35dc72d0fa0 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const IssueTypesAndFieldsViewContextProps = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'VIEW'
    });
    const IssueTypesAndFieldsCreateContextProps = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'CREATE'
    });
    const loading = IssueTypesAndFieldsViewContextProps.loading || IssueTypesAndFieldsCreateContextProps.loading;
    (0, $eUqFw.useEffect)(()=>{
        if (loading) return $c6421b4581e45226$var$noop;
        const timeoutId = setTimeout(()=>{
            // tracking the number of Apollo cache watches
            // the lower the number, the faster UI
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'apolloCacheWatches created', {
                // @ts-expect-error - TS2551 - Property 'watches' does not exist on type 'ApolloCache<object>'. Did you mean 'watch'?
                watches: client?.cache?.watches?.size
            });
        }, $c6421b4581e45226$var$TRACKING_TIMEOUT);
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        loading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEmpR.IssueTypesAndFieldsContextView).Provider, {
        value: IssueTypesAndFieldsViewContextProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEmpR.IssueTypesAndFieldsContextCreate).Provider, {
        value: IssueTypesAndFieldsCreateContextProps
    }, children));
};

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("gEmpR", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesAndFieldsService", () => $0655e80332547c29$export$3ef3324b7f7d6a38);
$parcel$export(module.exports, "IssueTypesAndFieldsContextView", () => $0655e80332547c29$export$77937175321fab39);
$parcel$export(module.exports, "IssueTypesAndFieldsContextCreate", () => $0655e80332547c29$export$fbd286e14113bfc);
$parcel$export(module.exports, "useIssueTypesAndFields", () => $0655e80332547c29$export$d2121b02f0b65782);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");


var $ZvXTS = parcelRequire("ZvXTS");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $9zYls = parcelRequire("9zYls");

var $i2apV = parcelRequire("i2apV");

var $2RZxj = parcelRequire("2RZxj");

const $0655e80332547c29$export$d7241b17c19f0a9c = 'PROJECT_NOT_FOUND';
const $0655e80332547c29$export$4c72baf45fce4585 = 'VIEW_PROJECT_PERMISSION_ERROR';
const $0655e80332547c29$var$isProjectPermissionError = (error)=>error.message.indexOf($0655e80332547c29$export$d7241b17c19f0a9c) > -1 || error.message.indexOf($0655e80332547c29$export$4c72baf45fce4585) > -1 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 403 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 404;
const $0655e80332547c29$export$6b9bc8a33ade0736 = (input)=>{
    const [routerState] = (0, $lB25E.useRouter)();
    const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(routerState?.match, routerState?.query);
    const variables = (0, $eUqFw.useMemo)(()=>({
            projectKey: projectKey,
            issueOperation: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            input.issueOperation,
            first: 100
        }), [
        input.issueOperation,
        projectKey
    ]);
    const { query: query, view: view } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "classic-business-form": { readonly view: "Form"; readonly query: DocumentNode; }; readonly "classic-business-form-submit": { readonly view: "FormSubmit"; readonly query: DocumentNode; }; ... 8 more ...; readonly default: { ...; }; }'.
    (0, $2RZxj.JWMQueryByRouteMap)?.[routerState?.route?.name] ?? (0, $2RZxj.JWMQueryByRouteMap)[0, $i2apV.DEFAULT];
    return (0, $eUqFw.useMemo)(()=>({
            loading: false,
            query: query,
            view: view,
            variables: variables
        }), [
        query,
        view,
        variables
    ]);
};
const $0655e80332547c29$export$1768f0a0f85b4de9 = (input)=>{
    const client = (0, $iZuDo.useApolloClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { variables: queryVariables, query: query } = $0655e80332547c29$export$6b9bc8a33ade0736(input);
    const analyticsTaskName = 'useIssueTypesAndFieldsCacheApolloCacheActions';
    return (0, $eUqFw.useCallback)(({ findField: findField, updateItem: updateItem })=>{
        const getCacheData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: queryVariables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'useIssueTypesAndFieldsCache',
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const cacheData = getCacheData();
        const existingEdges = cacheData?.jiraBusinessAvailableFields?.edges;
        if (existingEdges == null) return;
        let shouldUpdate = false;
        const newEdges = existingEdges.map((edge)=>{
            const existingFields = edge?.node?.fields?.edges;
            if (existingFields == null) return edge;
            const itemToUpdateIndex = existingFields.findIndex((fieldEdge)=>findField ? findField(fieldEdge?.node) : false) ?? undefined;
            const existingField = existingFields[itemToUpdateIndex]?.node;
            if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingField == null) return edge;
            const itemOverride = updateItem(existingField);
            if (itemOverride === undefined) return edge;
            const newFields = [
                ...existingFields
            ];
            newFields[itemToUpdateIndex] = {
                node: itemOverride,
                __typename: 'JiraIssueFieldEdge'
            };
            shouldUpdate = true;
            return {
                ...edge,
                node: {
                    ...edge?.node || {},
                    fields: {
                        edges: newFields,
                        __typename: 'JiraIssueFieldConnection'
                    }
                }
            };
        });
        if (!shouldUpdate) return;
        const newData = {
            ...cacheData,
            jiraBusinessAvailableFields: {
                ...cacheData?.jiraBusinessAvailableFields || {},
                edges: newEdges
            }
        };
        try {
            client.writeQuery({
                query: query,
                variables: queryVariables,
                // @ts-expect-error - TS2345 - Argument of type '{ query: any; variables: { projectId: number | undefined; issueOperation: IssueOperation; first: number; } | undefined; notifyOnNetworkStatusChange: boolean; data: { jiraBusinessAvailableFields: { ...; }; }; }' is not assignable to parameter of type 'WriteQueryOptions<{ jiraBusinessAvailableFields: { edges: (JiraBusinessAvailableFieldsListView_jiraBusinessAvailableFields_edges | { ...; } | null)[]; __typename?: "JiraBusinessAvailableFieldsConnection" | undefined; }; }, { ...; }>'.
                notifyOnNetworkStatusChange: true,
                data: newData
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'useIssueTypesAndFieldsCache',
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(queryVariables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        query,
        queryVariables
    ]);
};
const $0655e80332547c29$export$3ef3324b7f7d6a38 = (input)=>{
    const [hasStartedFetchingFields, setHasStartedFetchingFields] = (0, $eUqFw.useState)(false);
    const fetchAttempts = (0, $eUqFw.useRef)(0);
    const { variables: queryVariables, loading: isQueryLoading, query: query, view: view } = $0655e80332547c29$export$6b9bc8a33ade0736(input);
    const [getAvailableFields, { data: data, called: called, loading: loading, error: error, refetch: refetchQuery }] = (0, $iZuDo.useLazyQuery)(query, {
        variables: queryVariables,
        errorPolicy: (0, $eI5EY.fg)('handle_partial_errors_for_availablefields_query') ? 'all' : undefined,
        fetchPolicy: 'cache-first',
        onError: (apolloError)=>{
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$ac953882305d6102));
            // do not fire error if user doesn't have project permissions
            if ($0655e80332547c29$var$isProjectPermissionError(apolloError)) return;
            (0, $guiFP.default)({
                meta: {
                    id: `availableFields${view}ViewQuery`,
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: `Failed to fetch available fields in ${view} view`
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (onCompletedData)=>{
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$ac953882305d6102));
            if (onCompletedData?.jiraBusinessAvailableFields == null && (0, $eI5EY.fg)('handle_partial_errors_for_availablefields_query')) throw error || new Error('No available fields data');
            onCompletedData?.jiraBusinessAvailableFields?.edges?.forEach((e)=>{
                const fieldEdges = e?.node?.fields?.edges;
                if (fieldEdges == null || fieldEdges?.length === 0) {
                    const emptyMessage = fieldEdges == null ? 'null fields' : '0 length fields';
                    const emptyFieldsError = new Error(`availableFieldsAPI is returning ${emptyMessage} for issueType ${e?.node?.issueType.name ?? 'UNKNOWN'}`);
                    // retrying due to intermittent error related to new projects: FUN-570
                    if (fetchAttempts.current < 1) {
                        fetchAttempts.current += 1;
                        refetch();
                    } else throw emptyFieldsError;
                }
            });
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        if (queryVariables && !hasStartedFetchingFields && !error) {
            setHasStartedFetchingFields(true);
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$7b887ee35f2b465e));
            getAvailableFields();
        }
    }, [
        error,
        getAvailableFields,
        hasStartedFetchingFields,
        queryVariables,
        view
    ]);
    const refetch = (0, $eUqFw.useCallback)(()=>{
        if (called && typeof refetchQuery === 'function') return refetchQuery(queryVariables);
        const err = new Error('availableFields refetch is undefined because the service has not been called yet');
        (0, $guiFP.default)({
            meta: {
                id: 'availableFieldsRefetchIsUndefined',
                packageName: 'jiraBusinessEntityProject',
                teamName: 'wanjel'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    }, [
        called,
        refetchQuery,
        queryVariables
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasStartedFetchingFields && error) setHasStartedFetchingFields(false);
    }, [
        hasStartedFetchingFields,
        error
    ]);
    const result = (0, $eUqFw.useMemo)(()=>(0, $2RZxj.transformResult)(data), [
        data
    ]);
    const typesWithFields = (0, $eUqFw.useMemo)(()=>(0, $2RZxj.transformResultToTypesWithFields)(data), [
        data
    ]);
    const hierarchyLevels = (0, $eUqFw.useMemo)(()=>result.issueTypes.map((issueType)=>({
                level: issueType.hierarchyLevel,
                name: issueType.name,
                id: issueType.id
            })).sort((a, b)=>a.level !== b.level ? b.level - a.level : a.name.localeCompare(b.name)), [
        result.issueTypes
    ]);
    // make sure "loading" flag starts from "true"
    const isFieldsLoading = hasStartedFetchingFields ? loading : true;
    return {
        error: error,
        loading: error ? false : isQueryLoading || isFieldsLoading,
        data: result,
        typesWithFields: typesWithFields,
        hierarchyLevels: hierarchyLevels,
        refetch: refetch
    };
};
const $0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue = {
    data: {
        fields: [],
        issueTypes: []
    },
    loading: false,
    error: undefined,
    typesWithFields: [],
    hierarchyLevels: []
};
const $0655e80332547c29$export$77937175321fab39 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    ...$0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue
});
const $0655e80332547c29$export$fbd286e14113bfc = /*#__PURE__*/ (0, $eUqFw.createContext)({
    ...$0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue
});
const $0655e80332547c29$export$d2121b02f0b65782 = (input)=>{
    const issueTypesAndFieldsViewData = (0, $eUqFw.useContext)($0655e80332547c29$export$77937175321fab39);
    const issueTypesAndFieldsCreateData = (0, $eUqFw.useContext)($0655e80332547c29$export$fbd286e14113bfc);
    if (!input || input.issueOperation === 'VIEW') return issueTypesAndFieldsViewData;
    return issueTypesAndFieldsCreateData;
};

});
const $78bb8734d7176028$export$747aad128920134d = 3000;
const $78bb8734d7176028$export$e4f8d353742c04ac = 4000;
const $78bb8734d7176028$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $78bb8734d7176028$export$23e322eb7c526958 = 'REQUEST_START';
const $78bb8734d7176028$export$83ca21a50372ea3b = 'REQUEST_END';
const $78bb8734d7176028$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $78bb8734d7176028$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $78bb8734d7176028$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $78bb8734d7176028$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $78bb8734d7176028$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $78bb8734d7176028$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("i2apV", function(module, exports) {

$parcel$export(module.exports, "DEFAULT", () => $3bfdf44128ce0634$export$e6952b12ade67489);
$parcel$export(module.exports, "HierarchyLevel", () => $3bfdf44128ce0634$export$7faaf3222dfd10db);
const $3bfdf44128ce0634$export$e6952b12ade67489 = 'default';
const $3bfdf44128ce0634$export$7faaf3222dfd10db = Object.freeze({
    EPIC: 1,
    BASE: 0,
    SUBTASK: -1
});

});

parcelRegister("2RZxj", function(module, exports) {

$parcel$export(module.exports, "transformResult", () => $36ea36a72d22859a$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "transformResultToTypesWithFields", () => $36ea36a72d22859a$export$55ab7865f91ba09b);
$parcel$export(module.exports, "JWMQueryByRouteMap", () => $36ea36a72d22859a$export$7188da46161cbb8f);

var $exb0h = parcelRequire("exb0h");

var $lO4Or = parcelRequire("lO4Or");

var $i2apV = parcelRequire("i2apV");

var $fEf9a = parcelRequire("fEf9a");
const $36ea36a72d22859a$export$b07b0d8dc0894ecf = {
    fields: [],
    issueTypes: []
};
const $36ea36a72d22859a$var$emptyArray = [];
const $36ea36a72d22859a$export$bffa388e20165996 = (node, issueType)=>{
    const fieldConfig = {
        isRequired: !!node.fieldConfig?.isRequired,
        isEditable: !!node.fieldConfig?.isEditable
    };
    if (node.type === 'priority') {
        fieldConfig.options = node.priorities.nodes;
        // Set middle priority as default if backend doesn't return any
        if (node.priority) fieldConfig.defaultPriorityId = node.priority.priorityId;
        else if (fieldConfig.options.length > 0) fieldConfig.defaultPriorityId = // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        node.priorities.nodes[Math.floor(fieldConfig.options.length / 2)].priorityId;
    }
    if (node.type === 'issuetype') {
        fieldConfig.options = node.issueTypes.nodes;
        fieldConfig.avatarId = issueType.avatarId;
        fieldConfig.avatarUrl = issueType.avatar?.medium;
    }
    if (node.type === 'issuelinks' && node.issueLinkTypeRelations) // 'is blocked by' / 'blocks' is used as the default issue link type
    fieldConfig.defaultIssueLinkTypeId = node.issueLinkTypeRelations.nodes.find(// @ts-expect-error - TS7006 - Parameter 'linkNode' implicitly has an 'any' type.
    (linkNode)=>linkNode.relationName === 'is blocked by')?.linkTypeId || // take the first awailable otherwise
    node.issueLinkTypeRelations.nodes[0]?.linkTypeId;
    if (node.type === (0, $lO4Or.MULTI_SELECT_CF_TYPE) || node.type === (0, $lO4Or.SELECT_CF_TYPE)) {
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) {
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $lO4Or.CATEGORY_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId, color: color })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId,
                color: color?.colorKey ?? null
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    return {
        id: node.fieldId,
        aliasFieldId: node.aliasFieldId,
        name: node.name,
        type: node.type,
        fieldConfig: fieldConfig,
        issueTypes: [],
        __typename: node.__typename
    };
};
const $36ea36a72d22859a$export$f13b29f9ed0c5a03 = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) {
        const issueFieldsById = {};
        const issueTypesById = {};
        data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).forEach(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => void' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => void'.
        ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>{
            issueTypesById[issueType.issueTypeId] = {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? null,
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            };
            fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).forEach((node)=>{
                if (node.fieldId) {
                    if (!issueFieldsById[node.fieldId]) issueFieldsById[node.fieldId] = $36ea36a72d22859a$export$bffa388e20165996(node, issueType);
                    issueFieldsById[node.fieldId].issueTypes = issueFieldsById[node.fieldId].issueTypes || [];
                    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                    issueFieldsById[node.fieldId].issueTypes.push(issueType.issueTypeId);
                }
            });
        });
        return {
            fields: Object.keys(issueFieldsById).map((id)=>issueFieldsById[id]),
            issueTypes: Object.keys(issueTypesById).map((id)=>issueTypesById[id])
        };
    }
    // @ts-expect-error - TS2322 - Type '{ readonly fields: readonly []; readonly issueTypes: readonly []; }' is not assignable to type '{ fields: BusinessIssueField[]; issueTypes: BusinessIssueType[]; }'.
    return $36ea36a72d22859a$export$b07b0d8dc0894ecf;
};
const $36ea36a72d22859a$export$55ab7865f91ba09b = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) return data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).map(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => { issueType: { id: string; isDefault: boolean;...' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => { issueType: { id: string; isDefault: boolean; name: string; subtask: boolean; avatarId: string; hierarchyLevel: number; }; fields: BusinessIssueField[]; }'.
    ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>({
            issueType: {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? '',
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            },
            fields: fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).map((node)=>$36ea36a72d22859a$export$bffa388e20165996(node, issueType))
        }));
    return $36ea36a72d22859a$var$emptyArray;
};
const $36ea36a72d22859a$export$7188da46161cbb8f = {
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM)]: {
        view: 'Form',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_FORM_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT)]: {
        view: 'FormSubmit',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR)]: {
        view: 'Calendar',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED)]: {
        view: 'CalendarEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST)]: {
        view: 'List',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED)]: {
        view: 'ListEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE)]: {
        view: 'Timeline',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED)]: {
        view: 'TimelineEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD)]: {
        view: 'Board',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED)]: {
        view: 'BoardEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $i2apV.DEFAULT)]: {
        view: 'Common',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    }
};

});
parcelRegister("fEf9a", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_LIST_QUERY", () => $546f0d2a9095de4c$export$ba5f98a8d6136727);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY", () => $546f0d2a9095de4c$export$cba408dff1091b60);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY", () => $546f0d2a9095de4c$export$363435cea078aa93);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_BOARD_QUERY", () => $546f0d2a9095de4c$export$1641a42cf2cdb09a);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_QUERY", () => $546f0d2a9095de4c$export$7903c43b0ec55315);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY", () => $546f0d2a9095de4c$export$79304c172f5555ae);

var $9ypom = parcelRequire("9ypom");
const $546f0d2a9095de4c$export$ec2562ca5badac3b = (0, $9ypom.default)`
  fragment GetIssueTypesAndFields on JiraBusinessAvailableFields {
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
    isDefaultIssueType
    fields {
      edges {
        node {
          fieldId
          type
          name
          aliasFieldId
          ... on GenericIssueField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueTypes {
              nodes {
                name
                id
              }
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
              isEditable
            }
            priority {
              priorityId
            }
            priorities {
              nodes {
                priorityId
                name
                iconUrl
              }
            }
          }
          ... on JiraLabelsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleLineTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDatePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAffectedServicesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAttachmentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCMDBField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCascadingSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraColorField {
            fieldConfig {
              isRequired
              isEditable
            }
            color {
              colorKey
            }
          }
          ... on JiraComponentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDateTimePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraEpicLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueLinkTypeRelations(first: 10) {
              nodes {
                linkTypeId
                relationName
              }
            }
          }
          ... on JiraIssueRestrictionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraMultipleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraNumberField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraPeopleField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraProjectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRadioSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraResolutionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRichTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSecurityLevelField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraSingleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSprintField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraUrlField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JsmRequestTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JWMCategoryField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
                color {
                    colorKey
                }
              }
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraAtlassianTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraGoalsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
        }
      }
    }
  }
`;
const $546f0d2a9095de4c$export$ba5f98a8d6136727 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsListView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$cba408dff1091b60 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsCalendarView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$363435cea078aa93 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsTimelineView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$1641a42cf2cdb09a = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsBoardView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$7903c43b0ec55315 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsFormView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$79304c172f5555ae = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsFormSubmitView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;

});




parcelRegister("6F6Wi", function(module, exports) {

$parcel$export(module.exports, "useRefetchFields", () => $3162568d5bd19ad8$export$715664166ba98964);
$parcel$export(module.exports, "RefetchFieldsController", () => $3162568d5bd19ad8$export$f1f4bd03b141f216);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $gEmpR = parcelRequire("gEmpR");
const $3162568d5bd19ad8$var$REFETCH_TIMEOUT = 500;
const $3162568d5bd19ad8$var$MAX_NUMBER_OF_RETRIES = 5;
const $3162568d5bd19ad8$var$actions = {
    setRefetchFields: (refetchFields)=>({ setState: setState })=>setState({
                refetchFields: refetchFields
            })
};
const $3162568d5bd19ad8$export$c87e497850d70653 = ()=>Promise.resolve(null);
const $3162568d5bd19ad8$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        refetchFields: $3162568d5bd19ad8$export$c87e497850d70653
    },
    actions: $3162568d5bd19ad8$var$actions,
    name: 'JWMRefetchFieldsStore'
});
const $3162568d5bd19ad8$var$useHook = (0, $1yZQx.createHook)($3162568d5bd19ad8$var$Store);
const $3162568d5bd19ad8$export$715664166ba98964 = ()=>{
    const [{ refetchFields: refetchFields }, { setRefetchFields: setRefetchFields }] = $3162568d5bd19ad8$var$useHook();
    return {
        refetchFields: refetchFields,
        setRefetchFields: setRefetchFields
    };
};
const $3162568d5bd19ad8$export$f1f4bd03b141f216 = ()=>{
    const pendingRefetch = (0, $eUqFw.useRef)();
    const retryCount = (0, $eUqFw.useRef)(0);
    const { setRefetchFields: setRefetchFields } = $3162568d5bd19ad8$export$715664166ba98964();
    const { refetch: refetchViewFields } = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'VIEW'
    });
    const { refetch: refetchCreateFields } = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'CREATE'
    });
    const setPendingRefetch = (refetch, resolve)=>{
        const toId = setTimeout(()=>{
            pendingRefetch.current = null;
            refetch();
        }, $3162568d5bd19ad8$var$REFETCH_TIMEOUT);
        pendingRefetch.current = {
            timeoutId: toId,
            resolve: resolve
        };
    };
    const clearPendingRefetch = ()=>{
        if (pendingRefetch.current) {
            const { timeoutId: toId, resolve: resolve } = pendingRefetch.current;
            clearTimeout(toId);
            resolve(null);
            pendingRefetch.current = null;
        }
    };
    (0, $eUqFw.useEffect)(()=>()=>{
            setRefetchFields($3162568d5bd19ad8$export$c87e497850d70653);
        }, [
        setRefetchFields
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            clearPendingRefetch();
        }, []);
    const refetchFields = (0, $eUqFw.useCallback)(({ shouldRetry: shouldRetry } = {})=>{
        clearPendingRefetch();
        return new Promise((resolve, reject)=>{
            const refetch = async ()=>{
                try {
                    const response = await Promise.all([
                        refetchViewFields(),
                        refetchCreateFields()
                    ]);
                    if (!shouldRetry || !shouldRetry(response)) {
                        resolve(response);
                        retryCount.current = 0;
                    } else if (retryCount.current < $3162568d5bd19ad8$var$MAX_NUMBER_OF_RETRIES) {
                        retryCount.current += 1;
                        // schedule another refetch
                        setPendingRefetch(refetch, resolve);
                    } else {
                        const error = new Error('refetching fields exceeded retries count');
                        (0, $guiFP.default)({
                            meta: {
                                id: 'JwmRefetchFields',
                                packageName: 'jiraBusinessEntityProject',
                                teamName: 'wanjel'
                            },
                            error: error,
                            attributes: {
                                message: `Failed to refetch fields after ${$3162568d5bd19ad8$var$MAX_NUMBER_OF_RETRIES} retries`
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            skipSentry: true
                        });
                        reject(error);
                    }
                } catch (error) {
                    reject(error);
                }
            };
            // A newly associated field doesn’t show up instantly because of the eventual consistency:
            // recomputation of the fields configuration executes as a background task.
            // That's why we need to wait for a bit here before refetching
            setPendingRefetch(refetch, resolve);
        });
    }, [
        refetchCreateFields,
        refetchViewFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setRefetchFields(refetchFields);
    }, [
        refetchFields,
        setRefetchFields
    ]);
    return null;
};

});

parcelRegister("d3C6e", function(module, exports) {

$parcel$export(module.exports, "IssueCreateProvider", () => $167db4325906604f$export$a975cd9627cdf4b6);
$parcel$export(module.exports, "useCreateIssue", () => $167db4325906604f$export$8af2d18142c8506c);
$parcel$export(module.exports, "isOptimisticIssue", () => $167db4325906604f$export$8512029c7fc94e58);
$parcel$export(module.exports, "useIsHighlighted", () => $167db4325906604f$export$2ecca9d8a7f031af);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");

var $lskA1 = parcelRequire("lskA1");

var $cWiVr = parcelRequire("cWiVr");

var $kjzom = parcelRequire("kjzom");

var $frfm9 = parcelRequire("frfm9");
class $167db4325906604f$var$IssueCreateJob {
    constructor(createParams){
        this.createParams = createParams;
        this.promise = new Promise((resolve, reject)=>{
            this.reject = reject;
            this.resolve = resolve;
        });
    }
}
const $167db4325906604f$var$IssueCreateContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $167db4325906604f$var$reducer = (state, action)=>{
    switch(action.type){
        case 'enqueue':
            return {
                ...state,
                jobQueue: [
                    ...state.jobQueue,
                    action.job
                ]
            };
        case 'start-job':
            return {
                ...state,
                runningJob: state.jobQueue[0],
                jobQueue: state.jobQueue.slice(1)
            };
        case 'end-job':
            return {
                ...state,
                runningJob: null
            };
        case 'highlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues,
                    action.issueId
                ])
            };
        case 'unhighlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues
                ].filter((id)=>id !== action.issueId))
            };
        case 'save-summary':
            return {
                ...state,
                summary: action.summary
            };
        default:
            return state;
    }
};
const $167db4325906604f$var$initialState = {
    jobQueue: [],
    runningJob: null,
    highlightedIssues: new Set(),
    summary: ''
};
const $167db4325906604f$export$a975cd9627cdf4b6 = ({ mutation: mutation, query: query, onCreateIssue: onCreateIssue, onRefetchIssue: onRefetchIssue, ignoreFiltersContext: ignoreFiltersContext = false, children: children })=>{
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const currentUser = user;
    // optimistic issue ids are negative numbers to distinguish them from real issue ids
    const nextIssueId = (0, $eUqFw.useRef)(-1);
    const [{ jobQueue: jobQueue, runningJob: runningJob, highlightedIssues: highlightedIssues, summary: summary }, dispatch] = (0, $eUqFw.useReducer)($167db4325906604f$var$reducer, $167db4325906604f$var$initialState);
    const createIssueController = onCreateIssue && onRefetchIssue ? (0, $kjzom.useCreateIssue)(onCreateIssue, onRefetchIssue) : (0, $kjzom.useCreateIssueOld)(mutation, query);
    const highlightIssue = (0, $eUqFw.useCallback)((issueId)=>dispatch({
            type: 'highlight',
            issueId: issueId
        }), []);
    const unhighlightIssue = (0, $eUqFw.useCallback)((issueId)=>setTimeout(()=>{
            dispatch({
                type: 'unhighlight',
                issueId: issueId
            });
        }, 2000), []);
    const createIssue = (0, $eUqFw.useCallback)((createParams)=>{
        const job = new $167db4325906604f$var$IssueCreateJob(createParams);
        dispatch({
            type: 'enqueue',
            job: job
        });
        let rank;
        if (createParams.input.rankAfter) rank = (0, $lskA1.getNextRank)(createParams.input.rankAfter.rank);
        else if (createParams.input.rankBefore) rank = (0, $lskA1.getPreviousRank)(createParams.input.rankBefore.rank);
        const reporter = {
            accountId: currentUser.accountId,
            avatarUrl: currentUser.avatarUrls['48x48'],
            displayName: currentUser.displayName
        };
        const optimisticIssuePayload = {
            issueId: nextIssueId.current--,
            rank: rank,
            reporter: reporter,
            ...createParams.input
        };
        return {
            optimisticIssuePayload: optimisticIssuePayload,
            promise: job.promise
        };
    }, [
        currentUser
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // dequeue and run the next job if there is one and there is no running job
        if (jobQueue.length > 0 && !runningJob) {
            const job = jobQueue[0];
            dispatch({
                type: 'start-job'
            });
            createIssueController({
                createParams: job.createParams,
                highlightIssue: highlightIssue,
                unhighlightIssue: unhighlightIssue,
                ignoreFiltersContext: ignoreFiltersContext
            }).then(job.resolve).catch(job.reject).finally(()=>dispatch({
                    type: 'end-job'
                }));
        }
    }, [
        createIssueController,
        highlightedIssues,
        jobQueue,
        runningJob,
        highlightIssue,
        unhighlightIssue,
        ignoreFiltersContext
    ]);
    (0, $frfm9.useCreateParamHandler)();
    const saveSummary = (0, $eUqFw.useCallback)((newSummary)=>{
        dispatch({
            type: 'save-summary',
            summary: newSummary
        });
    }, []);
    const value = (0, $eUqFw.useMemo)(()=>({
            createIssue: createIssue,
            highlightedIssues: highlightedIssues,
            summary: summary,
            saveSummary: saveSummary
        }), [
        createIssue,
        highlightedIssues,
        summary,
        saveSummary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($167db4325906604f$var$IssueCreateContext.Provider, {
        value: value
    }, children);
};
const $167db4325906604f$export$8af2d18142c8506c = (onSubmit, onBlur)=>{
    const context = (0, $eUqFw.useContext)($167db4325906604f$var$IssueCreateContext);
    if (!context) throw new Error('useCreateIssue must be used within an IssueCreateProvider');
    const { createIssue: createIssue, summary: summary, saveSummary: saveSummary } = context;
    const summaryRef = (0, $eUqFw.useRef)(summary);
    const hasExitedWithoutUserAction = (0, $eUqFw.useRef)(true);
    const submit = (0, $eUqFw.useCallback)((createParams)=>{
        const result = createIssue(createParams);
        onSubmit(result);
        hasExitedWithoutUserAction.current = false;
        setTimeout(()=>{
            // reset the value as the form can stay open after submitting
            hasExitedWithoutUserAction.current = true;
        }, 100);
        return result;
    }, [
        createIssue,
        onSubmit
    ]);
    const blur = (0, $eUqFw.useCallback)(()=>{
        onBlur?.();
        hasExitedWithoutUserAction.current = false;
    }, [
        onBlur
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // if the component has exited without the user blurring the form or submitting,
            // then save the summary value so it can be reapplied
            saveSummary(hasExitedWithoutUserAction.current ? summaryRef.current : '');
        }, [
        saveSummary
    ]);
    return {
        summaryRef: summaryRef,
        submit: submit,
        blur: blur
    };
};
const $167db4325906604f$export$8512029c7fc94e58 = (issueId)=>issueId < 0;
const $167db4325906604f$export$2ecca9d8a7f031af = ()=>{
    const context = (0, $eUqFw.useContext)($167db4325906604f$var$IssueCreateContext);
    if (!context) throw new Error('useIsHighlighted must be used within an IssueCreateProvider');
    const { highlightedIssues: highlightedIssues } = context;
    return (0, $eUqFw.useCallback)((issueId)=>$167db4325906604f$export$8512029c7fc94e58(issueId) || highlightedIssues.has(issueId), [
        highlightedIssues
    ]);
};

});
parcelRegister("lskA1", function(module, exports) {

$parcel$export(module.exports, "getNextRank", () => $7b4071d915fd0829$export$5c16a8b7eebff4b8);
$parcel$export(module.exports, "getPreviousRank", () => $7b4071d915fd0829$export$e2047b3433d9f565);
const $7b4071d915fd0829$export$5c16a8b7eebff4b8 = (s)=>`${s}0`;
const $7b4071d915fd0829$export$e2047b3433d9f565 = (s)=>{
    const lastCharCode = s.charCodeAt(s.length - 1);
    const previousLastChar = String.fromCharCode(lastCharCode - 1);
    if (lastCharCode === 0) return $7b4071d915fd0829$export$e2047b3433d9f565(s.substring(0, s.length - 1));
    return `${s.substring(0, s.length - 1)}${previousLastChar}99`;
};

});

parcelRegister("kjzom", function(module, exports) {

$parcel$export(module.exports, "useCreateIssueOld", () => $b3543cf4b0365df5$export$1245c77f7693955b);
$parcel$export(module.exports, "useCreateIssue", () => $b3543cf4b0365df5$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $c7wtc = parcelRequire("c7wtc");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iNULk = parcelRequire("iNULk");

var $fop6E = parcelRequire("fop6E");

var $5ujax = parcelRequire("5ujax");

var $auegK = parcelRequire("auegK");

var $fOAem = parcelRequire("fOAem");

var $9Y2JR = parcelRequire("9Y2JR");
const $b3543cf4b0365df5$export$8edbb6d449614942 = ()=>{
    const workflows = (0, $c7wtc.useWorkflows)();
    return (0, $eUqFw.useCallback)((createInput)=>{
        if (createInput.status && workflows != null) {
            // find the workflow for the input issue type
            const workflow = workflows.find((w)=>w.issueTypes.some((it)=>it.issueTypeId === createInput.issueType.id));
            // find the first transition to the input status that is initial, or global but not conditional
            const { statusId: statusId } = createInput.status;
            const transition = workflow?.transitions.find((t)=>t.to.statusId === statusId && (t.isInitial || t.isGlobal && !t.isConditional));
            return transition?.transitionId;
        }
    }, [
        workflows
    ]);
};
const $b3543cf4b0365df5$export$1245c77f7693955b = (mutation, query)=>{
    const createIssue = (0, $iNULk.useCreateIssue)(mutation);
    const refetchIssue = (0, $fop6E.useRefetchIssue)(query);
    const showCreateSuccessFlag = (0, $fOAem.useShowCreateSuccessFlag)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const getTransitionId = $b3543cf4b0365df5$export$8edbb6d449614942();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext })=>{
        const transitionId = getTransitionId(createParams.input);
        try {
            if (!(0, $5ujax.hasAllRequiredFields)({
                issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                createInput: createParams.input
            })) throw new (0, $7byHA.ValidationError)('Missing required fields');
            const response = await createIssue(createParams, {
                transitionId: transitionId
            });
            highlightIssue(response.itemIdentifiers.issueId);
            if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                location: createParams.location
            });
            unhighlightIssue(response.itemIdentifiers.issueId);
            return response.item;
        } catch (error) {
            let finalError = error;
            try {
                if (error instanceof (0, $7byHA.ValidationError)) {
                    const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, {
                        transitionId: transitionId
                    });
                    highlightIssue(issueId);
                    const issue = await refetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                    if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey);
                    unhighlightIssue(issueId);
                    return issue;
                }
            } catch (refetchError) {
                finalError = refetchError;
            }
            if (finalError instanceof (0, $auegK.CancelledError)) return null;
            showFlag({
                type: 'error',
                title: formatMessage((0, $9Y2JR.default).errorFlagTitle),
                description: formatMessage((0, $9Y2JR.default).errorFlagDescription)
            });
            throw finalError;
        }
    }, [
        getTransitionId,
        typesWithFields,
        createIssue,
        createAnalyticsEvent,
        showCreateSuccessFlag,
        showFlag,
        formatMessage,
        showCreateIssueDialog,
        refetchIssue
    ]);
};
const $b3543cf4b0365df5$export$8af2d18142c8506c = (onCreateIssue, onRefetchIssue)=>{
    const showCreateSuccessFlag = (0, $fOAem.useShowCreateSuccessFlag)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const getTransitionId = $b3543cf4b0365df5$export$8edbb6d449614942();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext })=>{
        const transitionId = getTransitionId(createParams.input);
        try {
            if (!(0, $5ujax.hasAllRequiredFields)({
                issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                createInput: createParams.input
            })) throw new (0, $7byHA.ValidationError)('Missing required fields');
            const response = await onCreateIssue(createParams, {
                transitionId: transitionId
            });
            highlightIssue(response.itemIdentifiers.issueId);
            if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                location: createParams.location
            });
            unhighlightIssue(response.itemIdentifiers.issueId);
            return response.item;
        } catch (error) {
            let finalError = error;
            try {
                if (error instanceof (0, $7byHA.ValidationError)) {
                    const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, {
                        transitionId: transitionId
                    });
                    highlightIssue(issueId);
                    const issue = await onRefetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                    if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey);
                    unhighlightIssue(issueId);
                    return issue;
                }
                if (error instanceof Error) (0, $guiFP.default)({
                    meta: {
                        id: 'JWMCreateIssueInline',
                        packageName: 'jiraBusinessIssueCreate',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } catch (refetchError) {
                finalError = refetchError;
            }
            if (finalError instanceof (0, $auegK.CancelledError)) return null;
            showFlag({
                type: 'error',
                title: formatMessage((0, $9Y2JR.default).errorFlagTitle),
                description: formatMessage((0, $9Y2JR.default).errorFlagDescription)
            });
            throw finalError;
        }
    }, [
        getTransitionId,
        typesWithFields,
        onCreateIssue,
        createAnalyticsEvent,
        showCreateSuccessFlag,
        showFlag,
        formatMessage,
        showCreateIssueDialog,
        onRefetchIssue
    ]);
};

});
parcelRegister("c7wtc", function(module, exports) {

$parcel$export(module.exports, "WorkflowsProvider", () => $0662fc67a6d31ad1$export$80a1d3130ff3ec75);
$parcel$export(module.exports, "useWorkflows", () => $0662fc67a6d31ad1$export$437f9bd807b88beb);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $6LdZl = parcelRequire("6LdZl");

var $8xqyO = parcelRequire("8xqyO");
const $0662fc67a6d31ad1$var$FETCH_WORKFLOW_FLAG_ID = (0, $eo17r.toFlagId)('fetch-board-error-flag');
const $0662fc67a6d31ad1$var$WorkflowsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $0662fc67a6d31ad1$export$80a1d3130ff3ec75 = ({ children: children, enabled: enabled = true, workflows: workflows })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { fetch: fetch, data: data, error: error } = (0, $6LdZl.useFetchWorkflows)();
    (0, $eUqFw.useEffect)(()=>{
        if ((!(0, $eI5EY.fg)('jwm_conditional_workflow_data_loading') || enabled) && workflows == null) fetch();
    }, [
        enabled,
        fetch,
        workflows
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) showFlag({
            id: $0662fc67a6d31ad1$var$FETCH_WORKFLOW_FLAG_ID,
            type: 'error',
            title: (0, $8xqyO.default).workflowsErrorTitle,
            description: (0, $8xqyO.default).workflowsErrorDescription
        });
    }, [
        error,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0662fc67a6d31ad1$var$WorkflowsContext.Provider, {
        value: workflows ?? data
    }, children);
};
const $0662fc67a6d31ad1$export$437f9bd807b88beb = ()=>(0, $eUqFw.useContext)($0662fc67a6d31ad1$var$WorkflowsContext);

});
parcelRegister("6LdZl", function(module, exports) {

$parcel$export(module.exports, "useFetchWorkflows", () => $999083320983ea8a$export$41ba56ef14d1b9b1);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $5Hc99 = parcelRequire("5Hc99");
const $999083320983ea8a$export$41ba56ef14d1b9b1 = ()=>{
    const project = (0, $kQAZu.useProject)();
    const [fetch, { data: data, loading: loading, error: error }] = (0, $iZuDo.useLazyQuery)((0, $5Hc99.WORKFLOWS_QUERY), {
        variables: {
            projectId: project.id,
            first: 100
        },
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'jwmFetchWorkflows',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch workflows'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const workflowsDetails = (0, $eUqFw.useMemo)(()=>data?.jwmWorkflowWithIssueTypes?.edges?.map((edge)=>{
            const { workflow: workflow, issueTypes: issueTypes } = edge?.node || {};
            return {
                workflowId: workflow.workflowId,
                name: workflow?.name ?? undefined,
                transitions: workflow.transitions.edges.map((transitionEdge)=>({
                        transitionId: transitionEdge.node.transitionId,
                        name: transitionEdge.node.name ?? undefined,
                        isInitial: transitionEdge.node.isInitial,
                        isGlobal: transitionEdge.node.isGlobal,
                        isConditional: transitionEdge.node.isConditional,
                        to: {
                            statusId: transitionEdge.node.to.statusId
                        }
                    })),
                issueTypes: issueTypes.edges.map((issueTypeEdge)=>({
                        issueTypeId: issueTypeEdge.node.issueTypeId,
                        name: issueTypeEdge.node.name,
                        avatarUrl: issueTypeEdge.node.avatar.medium,
                        hierarchyLevel: issueTypeEdge.node.hierarchy.level
                    }))
            };
        }), [
        data
    ]);
    return {
        fetch: fetch,
        data: workflowsDetails,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5Hc99", function(module, exports) {

$parcel$export(module.exports, "WORKFLOWS_QUERY", () => $d1ebb9e47bb48695$export$d54deb6c2b9695b7);

var $9ypom = parcelRequire("9ypom");
const $d1ebb9e47bb48695$export$d54deb6c2b9695b7 = (0, $9ypom.default)`
    query JWMWorkflowWithIssueTypes($projectId: Long!, $filter: JWMWorkflowWithIssueTypesFilter, $first: Int, $after: String, $last: Int, $before: String) {
        jwmWorkflowWithIssueTypes(projectId: $projectId, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
            edges {
                node {
                    workflow {
                        workflowId
                        name
                        transitions(first: $first) {
                            edges {
                                node {
                                    transitionId
                                    name
                                    isInitial
                                    isGlobal
                                    isConditional
                                    to {
                                        statusId
                                    }
                                }
                            }
                        }
                    }
                    issueTypes(first: $first) {
                        edges {
                            node {
                                issueTypeId
                                name
                                avatar {
                                  medium
                                }
                              	hierarchy {
                              	  level
                              	}
                            }
                        }
                    }
                }
            }
        }
    }
`;

});


parcelRegister("8xqyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2d03bd6919e7a8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f2d03bd6919e7a8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    workflowsErrorTitle: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-title",
        "defaultMessage": "Failed to load workflows details"
    },
    workflowsErrorDescription: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-description",
        "defaultMessage": "We couldn't load your workflow details, try refreshing the page or try again later."
    }
});

});


parcelRegister("iNULk", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $7f9682590ce5c99c$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jGcn0 = parcelRequire("jGcn0");

var $e4qlg = parcelRequire("e4qlg");

var $4S5hf = parcelRequire("4S5hf");

var $kkYfO = parcelRequire("kkYfO");

var $dlVOn = parcelRequire("dlVOn");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $7byHA = parcelRequire("7byHA");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $4xHig = parcelRequire("4xHig");


var $iWGMH = parcelRequire("iWGMH");
const $7f9682590ce5c99c$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $7f9682590ce5c99c$var$storyPointsFieldPredicate = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $7f9682590ce5c99c$var$sprintFieldPredicate = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $7f9682590ce5c99c$export$8af2d18142c8506c = (mutation)=>{
    const locale = (0, $4xHig.useLocale)();
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const { data: startDateField } = (0, $fD1Hq.useStartDateField)();
    const { data: storyPointEstimateField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$storyPointEstimateFieldPredicate);
    const { data: storyPointsField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$storyPointsFieldPredicate);
    const { data: sprintField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$sprintFieldPredicate);
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const [createIssue] = (0, $iZuDo.useMutation)(mutation);
    return (0, $eUqFw.useCallback)(async (createParams, extraPayload)=>{
        try {
            const input = (0, $iWGMH.buildInput)(createParams.input, locale, extraPayload, categoryField, startDateField, sprintField, storyPointEstimateField, storyPointsField);
            const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
            let isParentFieldVisible = false;
            let isDevSummaryFieldVisible = false;
            if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
                isDevSummaryFieldVisible = fieldIdsSet.has((0, $908924b2d198da78$export$20b3b4741b8cfb64));
                isParentFieldVisible = fieldIdsSet.has((0, $908924b2d198da78$export$bf9df74e065af482));
                fieldIdsSet.delete((0, $908924b2d198da78$export$20b3b4741b8cfb64));
                fieldIdsSet.delete((0, $908924b2d198da78$export$bf9df74e065af482));
            }
            const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled;
            fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
            const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
            fieldIdsSet.delete((0, $jGcn0.CARD_COVERS_TYPE));
            const fieldIds = Array.from(fieldIdsSet);
            const { data: data, errors: errors } = await createIssue({
                variables: {
                    input: input,
                    fieldIds: fieldIds,
                    withCoverMedia: withCoverMedia,
                    withChildrenCount: false,
                    isParentFieldVisible: isParentFieldVisible,
                    isDevSummaryFieldVisible: isDevSummaryFieldVisible,
                    withIssueLinks: withIssueLinks,
                    withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
                },
                // @ts-expect-error - errorPolicy is not in the types but does work
                errorPolicy: 'all'
            });
            const result = data?.createJiraBusinessIssue;
            if (result?.success !== true || !result?.item) {
                const firstMutationError = result?.errors?.[0];
                if (firstMutationError) {
                    const statusCode = firstMutationError.extensions?.statusCode;
                    if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, $7byHA.ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                    throw new (0, $kkYfO.MutationError)(firstMutationError);
                }
                throw new (0, $dlVOn.GraphQLErrors)(errors);
            }
            return {
                item: result.item,
                itemIdentifiers: {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    issueId: result.itemIdentifiers.issueId,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
                    issueKey: result.itemIdentifiers.issueKey[0].text
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (!(error instanceof (0, $7byHA.ValidationError))) (0, $guiFP.default)({
                meta: {
                    id: 'JWMCreateIssueInline',
                    packageName: 'jiraBusinessIssueCreate',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        categoryField,
        createIssue,
        locale,
        sprintField,
        startDateField,
        storyPointEstimateField,
        storyPointsField,
        isLinkingEnabled
    ]);
};

});
parcelRegister("e4qlg", function(module, exports) {

$parcel$export(module.exports, "useCategoryField", () => $ce9b32995a7706e8$export$f7ac7f1f12b4c794);

var $lO4Or = parcelRequire("lO4Or");

var $gEmpR = parcelRequire("gEmpR");
const $ce9b32995a7706e8$export$f7ac7f1f12b4c794 = ()=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const categoryField = fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE)) ?? null;
    return {
        data: categoryField,
        loading: loading,
        error: error
    };
};

});

parcelRegister("4S5hf", function(module, exports) {

$parcel$export(module.exports, "useFindField", () => $8ce2e5c1390595df$export$4b0b80fa50e6b4be);

var $gEmpR = parcelRequire("gEmpR");
const $8ce2e5c1390595df$export$4b0b80fa50e6b4be = (predicate)=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const field = fields.find(predicate) ?? null;
    return {
        data: field,
        loading: loading,
        error: error
    };
};

});

parcelRegister("kkYfO", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $f83939e5f3c23160$export$10c788363424e94e);
const $f83939e5f3c23160$export$bd0568a021288e41 = 'MutationError';
class $f83939e5f3c23160$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
    }
}

});

const $908924b2d198da78$export$41b6c9f5441c22c5 = 'rankBefore';
const $908924b2d198da78$export$d564e563c2ee8c4f = 'rankAfter';
const $908924b2d198da78$export$20b3b4741b8cfb64 = 'devSummaryField';
const $908924b2d198da78$export$bf9df74e065af482 = 'parentField';

parcelRegister("iWGMH", function(module, exports) {

$parcel$export(module.exports, "buildInput", () => $6cba527c033852df$export$f4db126e014728a3);

var $lO4Or = parcelRequire("lO4Or");

var $8K9kM = parcelRequire("8K9kM");

const $6cba527c033852df$export$f4db126e014728a3 = (input, locale, extraPayload, categoryField, startDateField, sprintField, storyPointEstimateField, storyPointsField)=>{
    const result = {
        projectId: input.projectId,
        issueType: input.issueType.id,
        fields: {
            singleLineTextFields: [
                {
                    fieldId: (0, $lO4Or.SUMMARY_TYPE),
                    text: input.summary
                }
            ],
            singleSelectUserPickerFields: [],
            datePickerFields: [],
            numberFields: []
        },
        rank: {}
    };
    if (input.category && categoryField?.id) result.fields.singleLineTextFields.push({
        fieldId: categoryField.id,
        text: input.category.optionId
    });
    if (input.assignee) result.fields.singleSelectUserPickerFields.push({
        fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
        user: {
            accountId: input.assignee.accountId
        }
    });
    if (input.startDate && startDateField?.id) result.fields.datePickerFields.push({
        fieldId: startDateField?.id,
        date: {
            formattedDate: (0, $8K9kM.formatTimezonedWithLocale)(input.startDate, 'dd/MMM/yy', locale, 'UTC')
        }
    });
    if (input.dueDate) result.fields.datePickerFields.push({
        fieldId: (0, $lO4Or.DUE_DATE_TYPE),
        date: {
            formattedDate: (0, $8K9kM.formatTimezonedWithLocale)(input.dueDate, 'dd/MMM/yy', locale, 'UTC')
        }
    });
    if (input.priority) result.fields.priority = {
        priorityId: input.priority.priorityId
    };
    if (input.parentIssueId) result.fields.parentField = {
        issueId: input.parentIssueId
    };
    if (input.rankBefore) result.rank.before = {
        id: (0, $908924b2d198da78$export$41b6c9f5441c22c5),
        issueId: input.rankBefore.issueId
    };
    if (input.rankAfter) result.rank.after = {
        id: (0, $908924b2d198da78$export$d564e563c2ee8c4f),
        issueId: input.rankAfter.issueId
    };
    if (extraPayload.transitionId) result.transitionId = extraPayload.transitionId;
    if (input.storyPointEstimate != null && storyPointEstimateField?.id) result.fields.numberFields.push({
        fieldId: storyPointEstimateField.id,
        value: input.storyPointEstimate
    });
    if (input.storyPoints != null && storyPointsField?.id) result.fields.numberFields.push({
        fieldId: storyPointsField.id,
        value: input.storyPoints
    });
    if (input.sprint && sprintField?.id) result.fields.sprintsField = {
        fieldId: sprintField.id,
        sprints: [
            {
                sprintId: input.sprint.id
            }
        ]
    };
    return result;
};

});


parcelRegister("fop6E", function(module, exports) {

$parcel$export(module.exports, "useRefetchIssue", () => $afeef06c89f9a563$export$8bf876d423f9293d);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $lGxgz = parcelRequire("lGxgz");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $dWLk9 = parcelRequire("dWLk9");
function $afeef06c89f9a563$export$fd83eea6ecd2d8fa(query) {
    const client = (0, $iZuDo.useApolloClient)();
    return (0, $eUqFw.useCallback)((variables)=>client.query({
            query: query,
            variables: variables,
            errorPolicy: 'all'
        }), [
        client,
        query
    ]);
}
const $afeef06c89f9a563$export$8bf876d423f9293d = (query)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const filtersJQL = (0, $lGxgz.useFilteredViewJQL)();
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const refetchIssue = $afeef06c89f9a563$export$fd83eea6ecd2d8fa(query);
    return (0, $eUqFw.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
        const jql = (0, $i3K0B.generateJql)({
            jqlContext: jqlContext,
            quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
            issueIds: [
                issueId
            ]
        });
        const fieldIdsSet = new Set(fieldIds);
        const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled;
        fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
        const fieldIdsToRequest = Array.from(fieldIdsSet);
        const { data: data } = await refetchIssue({
            jql: jql,
            fieldIds: fieldIdsToRequest,
            cloudId: cloudId,
            first: 1,
            withCoverMedia: withCoverMedia,
            withChildrenCount: false,
            isParentFieldVisible: false,
            isDevSummaryFieldVisible: false,
            withIssueLinks: withIssueLinks,
            withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
        });
        const viewItems = data?.jira?.jwmViewItems;
        if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issue = viewItems.edges?.[0]?.node;
        return issue ?? null;
    }, [
        cloudId,
        filtersJQL,
        jqlContext,
        refetchIssue,
        isLinkingEnabled
    ]);
};

});
parcelRegister("i3K0B", function(module, exports) {

$parcel$export(module.exports, "generateJql", () => $6bd61e247d9e0007$export$d43e55153d6948c0);
$parcel$export(module.exports, "getVariables", () => $6bd61e247d9e0007$export$a39eddd73bba62c1);

var $jGcn0 = parcelRequire("jGcn0");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");


var $lF3sI = parcelRequire("lF3sI");
const $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE = (0, $jGcn0.DEFAULT_PAGE_SIZE);
const $6bd61e247d9e0007$var$IS_EMPTY = 'IS EMPTY';
const $6bd61e247d9e0007$var$IS_NOT_EMPTY = 'IS NOT EMPTY';
const $6bd61e247d9e0007$export$d43e55153d6948c0 = (input, parentIssueForJql)=>{
    const { groupQuery: groupQuery, hierarchyLevel: hierarchyLevel, hierarchyParent: hierarchyParent, issueIds: issueIds, jqlContext: jqlContext, projectIdOrKey: projectIdOrKey, quickFiltersJql: quickFiltersJql, sorting: sorting } = input;
    const defaultSorting = `ORDER BY Rank ${(0, $jGcn0.DEFAULT_RANK_SORTING_DIRECTION)}`;
    const jql = [];
    // Check if sorting direction is valid, the direction possible passed from the URL params which can be invalid
    const isValidDirection = sorting?.direction?.toUpperCase() === 'ASC' || sorting?.direction?.toUpperCase() === 'DESC';
    const sortByClause = sorting != null && sorting.sortBy != null && sorting.direction != null && isValidDirection ? `ORDER By ${(0, $lF3sI.getJqlTerm)(sorting.sortBy)} ${sorting.direction}, Rank ${sorting.direction}` : defaultSorting;
    if (Array.isArray(issueIds) && issueIds.length > 0) jql.push(`(${issueIds.map((id)=>`id = ${id}`).join(' or ')})`);
    if (jqlContext) jql.push(jqlContext);
    else if (typeof projectIdOrKey !== 'undefined') jql.push(`project = '${projectIdOrKey}'`);
    if (typeof hierarchyLevel === 'number' && hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) {
        // fetch items by hierarchyLevel + any item that doesn't have a parent (e.g. tasks that don't belong to any Epic)
        if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') && typeof projectIdOrKey !== 'undefined') jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$6bd61e247d9e0007$var$IS_EMPTY} OR (parent ${$6bd61e247d9e0007$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
        else jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$6bd61e247d9e0007$var$IS_EMPTY})`);
    }
    if (hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) jql.push('type in standardIssueTypes()');
    // Controls the query to get all children for a single parent
    if (parentIssueForJql && parentIssueForJql.hierarchyType === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) jql.push(`parent = '${parentIssueForJql.issueId}'`);
    // Controls the query to get group items
    if (groupQuery) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { jqlTerm: jqlTerm, value: value } = groupQuery;
        if (!value) jql.push(`${jqlTerm} ${$6bd61e247d9e0007$var$IS_EMPTY}`);
        else jql.push(`${jqlTerm} = ${value}`);
        if (hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) {
            if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') && typeof projectIdOrKey !== 'undefined') jql.push(`(parent ${$6bd61e247d9e0007$var$IS_EMPTY} OR (parent ${$6bd61e247d9e0007$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
            else jql.push(`parent ${$6bd61e247d9e0007$var$IS_EMPTY}`);
        }
    }
    if (quickFiltersJql != null) jql.push(`(${quickFiltersJql})`);
    return `${jql.join(' AND ')} ${sortByClause}`;
};
const $6bd61e247d9e0007$export$a39eddd73bba62c1 = (input)=>{
    const { fieldIds: fieldIds, parentIssue: parentIssue } = input;
    const singleQueryJql = {
        jql: $6bd61e247d9e0007$export$d43e55153d6948c0(input, parentIssue)
    };
    // REMOTE_ISSUE_LINKS_TYPE should not be part of the fieldIds as it is only used to determine
    // whether legacyConfluenceLinks(JIS2) is fetched
    const newFieldIds = Array.isArray(fieldIds) ? [
        ...fieldIds
    ] : [];
    const remoteIssueLinksIndex = newFieldIds.indexOf((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
    const hasConfluenceLinks = remoteIssueLinksIndex > -1;
    if (hasConfluenceLinks) newFieldIds.splice(remoteIssueLinksIndex, 1);
    return {
        ...singleQueryJql,
        first: parentIssue ? $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE : (0, $jGcn0.DEFAULT_PAGE_SIZE),
        fieldIds: newFieldIds,
        withConfluenceLinks: hasConfluenceLinks,
        includeDoneItems: input.isHidingDoneItems === false,
        isParentFieldVisible: input.isParentFieldVisible ?? false,
        isDevSummaryFieldVisible: input.isDevSummaryFieldVisible ?? false,
        withParentRank: (0, $1ybV0.ff)('jwm-timeline-sort-parent-rank-first_waal4'),
        withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
    };
};

});
const $2a7b21c0842403e6$export$9355e489ad16f98e = 'TASK';
const $2a7b21c0842403e6$export$3cb4a99a332e4186 = 'EPIC';

parcelRegister("lF3sI", function(module, exports) {

$parcel$export(module.exports, "getJqlTerm", () => $74367c535f0c8550$export$43330b5a5235b231);

var $79xbN = parcelRequire("79xbN");

var $lO4Or = parcelRequire("lO4Or");
const $74367c535f0c8550$export$43330b5a5235b231 = (fieldId, fieldType)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldId.indexOf('customfield_') === 0) {
        const customFieldId = fieldId.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // We are hardcoding the components field jqlTerm because is not the same as field ID
    // We should get the jqlTerm from the BE
    // https://atlassian.slack.com/archives/CFGMKF5QC/p1724650674231049?thread_ts=1720579171.825049&cid=CFGMKF5QC
    if (fieldType === (0, $lO4Or.COMPONENTS_TYPE) && (0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation')) return 'component';
    return fieldId;
};

});


parcelRegister("lGxgz", function(module, exports) {

$parcel$export(module.exports, "useFilteredViewJQL", () => $6fc881cfc8a36877$export$a50cc7c1087f7d9b);
$parcel$export(module.exports, "useFilteredViewContextInput", () => $6fc881cfc8a36877$export$d566b5d8a729afa0);

var $eUqFw = parcelRequire("eUqFw");


var $eZbpk = parcelRequire("eZbpk");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $iaCjO = parcelRequire("iaCjO");

var $gZpkQ = parcelRequire("gZpkQ");

var $lEWmB = parcelRequire("lEWmB");

var $96etS = parcelRequire("96etS");

var $jQFcD = parcelRequire("jQFcD");
const $6fc881cfc8a36877$export$a50cc7c1087f7d9b = ()=>{
    const { addSimpleSearchToJQL: addSimpleSearchToJQL } = (0, $96etS.useSimpleSearchJQL)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const [isHidingDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    // ensure views recieve filters jql that will not cause a page crash
    const jqlSanitised = (0, $eUqFw.useMemo)(()=>(0, $jQFcD.sanitiseJql)(jql), [
        jql
    ]);
    const filtersJQL = (0, $eUqFw.useMemo)(()=>{
        if (isHidingDoneItems) {
            const filtersJql = [
                jqlSanitised,
                "StatusCategory != 'Complete'"
            ].filter(Boolean).join(' AND ');
            return addSimpleSearchToJQL(filtersJql);
        }
        return addSimpleSearchToJQL(jqlSanitised || null);
    }, [
        jqlSanitised,
        addSimpleSearchToJQL,
        isHidingDoneItems
    ]);
    return filtersJQL;
};
const $6fc881cfc8a36877$var$FIX_VERSION_SORTING_JQL = 'fixVersion';
const $6fc881cfc8a36877$export$d566b5d8a729afa0 = ({ view: view })=>{
    const filtersJQL = $6fc881cfc8a36877$export$a50cc7c1087f7d9b();
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    const [sortingBy] = (0, $iaCjO.useSorting)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const isFiltering = jql != null || isSearching;
    const [isHidingDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const hierarchyParent = (view === 'list' || view === 'timeline') && !isFiltering ? (0, $2a7b21c0842403e6$export$9355e489ad16f98e) : undefined;
    const jqlErrors = (0, $eUqFw.useMemo)(()=>{
        if ((0, $1ybV0.ff)('jwm.filters.handle-invalid-jql')) return (0, $jQFcD.getJqlErrors)(jql);
        return [];
    }, [
        jql
    ]);
    const sorting = (0, $eUqFw.useMemo)(()=>{
        /*
			When sorting by a specific field, we use the fieldId in the JQL query.
			For the fix version field, the fieldId doesn’t work in JQL must be “fixVersion”.
			Apparently, "fixVersion" is the clause name. It's a legacy choice that was made from the very beginning, and now we're unable to change it.
		*/ if (sortingBy.sortBy === (0, $lO4Or.FIX_VERSIONS_TYPE) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return {
            ...sortingBy,
            sortBy: $6fc881cfc8a36877$var$FIX_VERSION_SORTING_JQL
        };
        return sortingBy;
    }, [
        sortingBy
    ]);
    return {
        jqlContext: jqlContext,
        quickFiltersJql: filtersJQL,
        sorting: sorting,
        isFiltering: isFiltering,
        hierarchyParent: hierarchyParent,
        isHidingDoneItems: isHidingDoneItems,
        jqlErrors: jqlErrors
    };
};

});
parcelRegister("iaCjO", function(module, exports) {

$parcel$export(module.exports, "useSorting", () => $35b6a42c26975572$export$21ebc1ba2b2bee67);
$parcel$export(module.exports, "useSorter", () => $35b6a42c26975572$export$f161a6f9d84a6fea);

var $eUqFw = parcelRequire("eUqFw");

var $35jYz = parcelRequire("35jYz");

var $gEmpR = parcelRequire("gEmpR");

var $a75Ge = parcelRequire("a75Ge");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $a6BBe = parcelRequire("a6BBe");

var $iP9h2 = parcelRequire("iP9h2");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $35b6a42c26975572$var$EMPTY_SORTING_ATTRIBUTE = {};
const $35b6a42c26975572$export$21ebc1ba2b2bee67 = ()=>{
    const [sorting, setSorting] = (0, $7c3W1.useViewPreference)((0, $ji3xf.SORTING_PREFERENCE));
    return [
        sorting || $35b6a42c26975572$var$EMPTY_SORTING_ATTRIBUTE,
        setSorting
    ];
};
const $35b6a42c26975572$var$emptyArray = [];
const $35b6a42c26975572$export$f161a6f9d84a6fea = ()=>{
    const [sorting] = $35b6a42c26975572$export$21ebc1ba2b2bee67();
    const [sortingFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: sorting.sortBy
    });
    const [priorityFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: data } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const sortingFieldConfigFieldType = sortingFieldConfig?.fieldType ?? data?.fields?.find((field)=>field?.id === sorting.sortBy)?.type;
    const { statuses: statuses } = (0, $a75Ge.useProjectStatuses)();
    const priorities = priorityFieldConfig?.options || $35b6a42c26975572$var$emptyArray;
    const sortFunction = (0, $eUqFw.useCallback)((issues)=>{
        const getPrioritiesSortedList = ()=>[
                ...priorities
            ].reverse().reduce((acc, next, index)=>{
                acc[next.priorityId] = index;
                return acc;
            }, {});
        const getIssueTypesSortedList = ()=>[
                ...data.issueTypes
            ].sort((a, b)=>a.name.localeCompare(b.name)).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const getStatusSortOrder = (key)=>{
            if (key in (0, $a6BBe.STATUS_SORT_ORDER)) return (0, $a6BBe.STATUS_SORT_ORDER)[key];
            return -1;
        };
        const getStatusesSortedList = ()=>[
                ...statuses
            ].sort((a, b)=>{
                const orderComparison = getStatusSortOrder(a.statusCategory.key) - getStatusSortOrder(b.statusCategory.key);
                if (orderComparison !== 0) return orderComparison;
                // If the status category order is the same, then sort alphabetically by name.
                return a.name.localeCompare(b.name);
            }).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const sortedLists = {
            priorities: getPrioritiesSortedList(),
            issueTypes: getIssueTypesSortedList(),
            statuses: getStatusesSortedList()
        };
        const { getters: getters, orders: orders } = (0, $iP9h2.createSortingGettersAndOrders)(sorting, sortingFieldConfigFieldType, sortedLists);
        return (0, $iP9h2.sortListBy)(issues, getters, orders);
    }, [
        sorting,
        sortingFieldConfigFieldType,
        priorities,
        data.issueTypes,
        statuses
    ]);
    return {
        sort: sortFunction
    };
};

});
parcelRegister("35jYz", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeFieldConfig", () => $81e81ebd14cd3d82$export$42e875bfb69ded2);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $1yZQx = parcelRequire("1yZQx");
var $1jo4G = parcelRequire("1jo4G");
var $kEDjj = parcelRequire("kEDjj");

var $gEmpR = parcelRequire("gEmpR");
const $81e81ebd14cd3d82$var$merge = (screen, issueTypeId, configs)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            [screen]: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(getState(), [
                    screen
                ], {}),
                [issueTypeId]: configs
            }
        });
    };
const $81e81ebd14cd3d82$var$actions = {
    merge: $81e81ebd14cd3d82$var$merge
};
const $81e81ebd14cd3d82$export$cbf0f7fe9ca42a65 = (0, $kEDjj.createStore)({
    initialState: {},
    actions: $81e81ebd14cd3d82$var$actions,
    name: 'issueTypeFieldConfig'
});
const $81e81ebd14cd3d82$var$getIssueTypeFieldConfigSelector = (0, $1jo4G.createSelector)((state)=>state, (_, props)=>props?.screen ?? undefined, (_, props)=>props?.issueTypeId ?? undefined, (_, props)=>props?.fieldId ?? undefined, (state, screen, issueTypeId, fieldId)=>{
    if (screen === undefined || issueTypeId === undefined || fieldId === undefined) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(state, [
        screen,
        issueTypeId,
        fieldId
    ], null);
});
const $81e81ebd14cd3d82$export$47647eb426e85a25 = (0, $1yZQx.createHook)($81e81ebd14cd3d82$export$cbf0f7fe9ca42a65, {
    selector: $81e81ebd14cd3d82$var$getIssueTypeFieldConfigSelector
});
const $81e81ebd14cd3d82$export$42e875bfb69ded2 = (props)=>{
    const [state, fieldsConfigActions] = $81e81ebd14cd3d82$export$47647eb426e85a25(props);
    const screen = props?.screen || 'VIEW';
    const { data: data, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: screen
    });
    // store field config to be consumed at the cell level
    return (0, $eUqFw.useMemo)(()=>{
        if (state != null) return [
            state,
            fieldsConfigActions,
            {
                loading: false,
                error: undefined
            }
        ];
        if (loading === false && (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, [
            'issueTypes'
        ], []).length > 0) data.issueTypes.forEach((issueType)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const config = {};
            data.fields.forEach((field)=>{
                if ((field.issueTypes || []).includes(issueType.id) && field.id != null) config[field.id] = {
                    ...field.fieldConfig,
                    fieldType: field.type
                };
            });
            fieldsConfigActions.merge(screen, issueType.id, config);
            if (issueType.isDefault) fieldsConfigActions.merge(screen, 'default', config);
        });
        return [
            state,
            fieldsConfigActions,
            {
                loading: loading,
                error: error
            }
        ];
    }, [
        data,
        error,
        fieldsConfigActions,
        loading,
        screen,
        state
    ]);
};

});

parcelRegister("a75Ge", function(module, exports) {

$parcel$export(module.exports, "useProjectStatuses", () => $342d49f1f4fd71f7$export$11ff6a520db76faf);

var $eUqFw = parcelRequire("eUqFw");

var $3G3gn = parcelRequire("3G3gn");

var $lyOYo = parcelRequire("lyOYo");

var $kQAZu = parcelRequire("kQAZu");

var $gUUjF = parcelRequire("gUUjF");

var $1yZQx = parcelRequire("1yZQx");
var $1jo4G = parcelRequire("1jo4G");
var $kEDjj = parcelRequire("kEDjj");
const $342d49f1f4fd71f7$var$PACKAGE_LOCATION = 'jira-business.common.services.project-statuses';
const $342d49f1f4fd71f7$var$MAX_RETRIES = 3;
const $342d49f1f4fd71f7$var$set = (projectKey, statuses)=>({ setState: setState })=>setState({
            [projectKey]: statuses
        });
const $342d49f1f4fd71f7$var$actions = {
    set: $342d49f1f4fd71f7$var$set
};
const $342d49f1f4fd71f7$var$ProjectStatusesStore = (0, $kEDjj.createStore)({
    initialState: {},
    actions: $342d49f1f4fd71f7$var$actions,
    name: 'projectStatuses'
});
const $342d49f1f4fd71f7$var$getProjectStatusesSelector = (0, $1jo4G.createSelector)((state)=>state, (_, props)=>props?.projectKey ?? undefined, (state, projectKey)=>{
    if (projectKey === undefined || state[projectKey] == null) return [];
    return state[projectKey];
});
const $342d49f1f4fd71f7$export$482f388228eef22c = (0, $1yZQx.createHook)($342d49f1f4fd71f7$var$ProjectStatusesStore, {
    selector: $342d49f1f4fd71f7$var$getProjectStatusesSelector
});
const $342d49f1f4fd71f7$var$emptyArray = [];
const $342d49f1f4fd71f7$export$11ff6a520db76faf = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasLoaded, setHasLoaded] = (0, $eUqFw.useState)(false);
    const [retriesCount, setRetriesCount] = (0, $eUqFw.useState)(0);
    const projectData = (0, $kQAZu.useProject)();
    const projectKey = projectData.key;
    const [statuses, statusActions] = $342d49f1f4fd71f7$export$482f388228eef22c({
        projectKey: projectKey
    });
    const retry = ()=>{
        setRetriesCount(retriesCount + 1);
        setIsLoading(false);
        setHasLoaded(false);
    };
    if (projectKey != null && Array.isArray(statuses) && statuses.length > 0) return {
        statuses: statuses,
        loading: isLoading
    };
    if (!isLoading && !hasLoaded) {
        fetch(`/rest/api/3/project/${projectKey}/statuses`).then((response)=>response.json()).then((issueTypes)=>{
            const allStatuses = issueTypes.reduce(// @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'next' implicitly has an 'any' type.
            (acc, next)=>acc.concat(next.statuses), []);
            const dedupedResults = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(allStatuses, 'id');
            return (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(dedupedResults, [
                'name'
            ]);
        }).then((uniqueStatuses)=>{
            statusActions.set(projectKey, uniqueStatuses);
            setIsLoading(false);
            setHasLoaded(true);
        }).catch(()=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($342d49f1f4fd71f7$var$PACKAGE_LOCATION, `Failed to retrieve project statuses - Retry #${retriesCount}`);
            if (retriesCount < $342d49f1f4fd71f7$var$MAX_RETRIES) retry();
        });
        setIsLoading(true);
    }
    return {
        statuses: $342d49f1f4fd71f7$var$emptyArray,
        loading: isLoading
    };
};

});

parcelRegister("ji3xf", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_WORKFLOW_PREFERENCE", () => $3ed190d907cd42b1$export$5d3f940b56d7af28);
$parcel$export(module.exports, "COLLAPSED_COLUMNS_PREFERENCE", () => $3ed190d907cd42b1$export$8019dfa5a44f6d46);
$parcel$export(module.exports, "COLUMNS_ORDER_PREFERENCE", () => $3ed190d907cd42b1$export$3ef984a9f784490f);
$parcel$export(module.exports, "CREATE_TYPE_ID_PREFERENCE", () => $3ed190d907cd42b1$export$2df4c3d44dcb1e5b);
$parcel$export(module.exports, "EXPANDED_ISSUES_PREFERENCE", () => $3ed190d907cd42b1$export$638c3932e4cbdede);
$parcel$export(module.exports, "FIELDS_PREFERENCE", () => $3ed190d907cd42b1$export$e3ddfc509464e305);
$parcel$export(module.exports, "FIELDS_DETAIL_PREFERENCE", () => $3ed190d907cd42b1$export$ffcb5603c64e12d0);
$parcel$export(module.exports, "FILTER_PREFERENCE", () => $3ed190d907cd42b1$export$f50d5db589fb1475);
$parcel$export(module.exports, "GROUPING_PREFERENCE", () => $3ed190d907cd42b1$export$ac8a4771da7f03af);
$parcel$export(module.exports, "HIDE_DONE_ITEMS_PREFERENCE", () => $3ed190d907cd42b1$export$4aace169721c2927);
$parcel$export(module.exports, "HIDE_SOFTWARE_RELEASE_PREFERENCE", () => $3ed190d907cd42b1$export$983f0d3325e2938);
$parcel$export(module.exports, "RANGE_MODE_PREFERENCE", () => $3ed190d907cd42b1$export$f43988a3762bf711);
$parcel$export(module.exports, "SORTING_PREFERENCE", () => $3ed190d907cd42b1$export$373eea1341dcff74);
$parcel$export(module.exports, "BOARD_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$4ec60be96e9eadc0);
$parcel$export(module.exports, "LIST_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$43fc1ec27b2f1801);
$parcel$export(module.exports, "CALENDAR_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$14e2a519a8c2881a);
$parcel$export(module.exports, "TIMELINE_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$8443f3f4fd94276);
$parcel$export(module.exports, "ATTACHMENTS_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$2e2923d9c9daba20);

var $jGcn0 = parcelRequire("jGcn0");

var $khRV9 = parcelRequire("khRV9");
const $3ed190d907cd42b1$export$5d3f940b56d7af28 = (0, $khRV9.createSimplePreference)('activeWorkflow');
const $3ed190d907cd42b1$export$8019dfa5a44f6d46 = (0, $khRV9.createSimplePreference)('collapsedColumns');
const $3ed190d907cd42b1$export$3ef984a9f784490f = (0, $khRV9.createSimplePreference)('columnOrder');
const $3ed190d907cd42b1$export$2df4c3d44dcb1e5b = (0, $khRV9.createSimplePreference)('createType');
const $3ed190d907cd42b1$export$638c3932e4cbdede = (0, $khRV9.createSimplePreference)('expandedIssues');
const $3ed190d907cd42b1$export$e3ddfc509464e305 = (0, $khRV9.createSimplePreference)('fields');
const $3ed190d907cd42b1$export$ffcb5603c64e12d0 = (0, $khRV9.createSimplePreference)('fieldsDetail');
const $3ed190d907cd42b1$export$f50d5db589fb1475 = (0, $khRV9.createSimpleUrlPreference)((0, $jGcn0.FILTER_PARAM));
const $3ed190d907cd42b1$export$ac8a4771da7f03af = (0, $khRV9.createSimpleUrlPreference)('groupBy');
const $3ed190d907cd42b1$export$4aace169721c2927 = (0, $khRV9.createSimpleUrlPreference)('hideDone');
const $3ed190d907cd42b1$export$983f0d3325e2938 = (0, $khRV9.createSimpleUrlPreference)('hideSoftwareRelease');
const $3ed190d907cd42b1$export$f43988a3762bf711 = (0, $khRV9.createSimpleUrlPreference)('rangeMode');
const $3ed190d907cd42b1$export$373eea1341dcff74 = {
    ...(0, $khRV9.createSimplePreference)('sorting'),
    queryParameter: {
        serialize: (value)=>({
                sortBy: value?.sortBy,
                direction: value?.direction
            }),
        deserialize: (value)=>value.sortBy ? {
                sortBy: value.sortBy,
                direction: value.direction
            } : undefined
    }
};
const $3ed190d907cd42b1$export$4ec60be96e9eadc0 = [
    $3ed190d907cd42b1$export$5d3f940b56d7af28,
    $3ed190d907cd42b1$export$8019dfa5a44f6d46,
    $3ed190d907cd42b1$export$3ef984a9f784490f,
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$638c3932e4cbdede,
    $3ed190d907cd42b1$export$e3ddfc509464e305,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$ac8a4771da7f03af
];
const $3ed190d907cd42b1$export$43fc1ec27b2f1801 = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$e3ddfc509464e305,
    $3ed190d907cd42b1$export$ffcb5603c64e12d0,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$ac8a4771da7f03af,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$373eea1341dcff74
];
const $3ed190d907cd42b1$export$14e2a519a8c2881a = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$983f0d3325e2938
];
const $3ed190d907cd42b1$export$8443f3f4fd94276 = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$f43988a3762bf711
];
const $3ed190d907cd42b1$export$2e2923d9c9daba20 = [
    $3ed190d907cd42b1$export$f50d5db589fb1475
];

});
parcelRegister("khRV9", function(module, exports) {

$parcel$export(module.exports, "createSimplePreference", () => $462fa2c618ea906f$export$464a71be397e5f3d);
$parcel$export(module.exports, "createSimpleUrlPreference", () => $462fa2c618ea906f$export$78f3983105936d30);

var $3QMTK = parcelRequire("3QMTK");
const $462fa2c618ea906f$export$464a71be397e5f3d = (id)=>({
        id: id,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
    });
const $462fa2c618ea906f$export$78f3983105936d30 = (queryParameter)=>({
        id: queryParameter,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        queryParameter: {
            serialize: (value)=>({
                    [queryParameter]: value
                }),
            deserialize: (value)=>value[queryParameter]
        }
    });

});


parcelRegister("7c3W1", function(module, exports) {

$parcel$export(module.exports, "ViewPreferencesProvider", () => $6117ab20ad9a3ccd$export$1db44e21d818b27);
$parcel$export(module.exports, "useViewPreference", () => $6117ab20ad9a3ccd$export$ee494de6c0ff45d7);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $fDLFb = parcelRequire("fDLFb");

var $hzcvF = parcelRequire("hzcvF");

var $lB25E = parcelRequire("lB25E");

var $6YT9E = parcelRequire("6YT9E");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $6117ab20ad9a3ccd$var$ViewPreferencesContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $6117ab20ad9a3ccd$export$1db44e21d818b27 = ({ view: view, preferences: preferences, children: children, persistChanges: persistChanges = true })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const [{ query: query }, routerActions] = (0, $lB25E.useRouter)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { updateQueryParam: updateQueryParam } = routerActions;
    const prevQuery = (0, $hzcvF.usePreviousWithInitial)(query);
    const [store, setStore] = (0, $eUqFw.useState)(()=>preferences.reduce((acc, preference)=>{
            let value;
            const { id: id, queryParameter: queryParameter } = preference;
            // if the URL has a preference value set
            // we prioritize those values over the persisted ones
            const queryValue = queryParameter && queryParameter.deserialize(query);
            if (queryValue) value = queryValue;
            else if (persistChanges) // if the view is persisting changes, restore the preferences from local storage
            value = preference.deserialize((0, $6YT9E.getPreference)(entity.id, view, preference.id));
            acc[id] = value;
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {}));
    const setPreferenceValue = (0, $eUqFw.useCallback)((preference, value, action)=>{
        // set the new preference value in the store
        setStore((prevStore)=>{
            const newStore = {
                ...prevStore,
                [preference.id]: value
            };
            return newStore;
        });
        // if the preference serialises to the URL, update the URL
        if (preference.queryParameter && action !== 'none') updateQueryParam(preference.queryParameter.serialize(value), action);
        // if the view is persisting changes, update the preference in local storage
        if (persistChanges) {
            const serializedValue = preference.serialize(value);
            (0, $6YT9E.setPreference)(entity.id, view, preference.id, serializedValue);
        }
    }, [
        persistChanges,
        updateQueryParam,
        entity.id,
        view
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if the view is persisting changes, on initial mount
        // check all preferences that serialise to the URL, and set their values to the URL
        if (!persistChanges) return;
        let restoredQuery = {};
        for (const preference of preferences){
            const value = store[preference.id];
            if (value && preference.queryParameter) restoredQuery = {
                ...restoredQuery,
                ...preference.queryParameter.serialize(value)
            };
        }
        updateQueryParam({
            ...restoredQuery,
            ...query
        }, 'replace');
    // only run this effect on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // this effect updates the store value only when the query has changed
        // we shouldn't run it when the component is mounting the first time
        // or when the query hasn't changed
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevQuery, query)) {
            // update the store if the query is updated
            const newState = preferences.reduce((acc, preference)=>{
                const { id: id, queryParameter: queryParameter } = preference;
                if (queryParameter) {
                    const queryValue = queryParameter.deserialize(query);
                    acc[id] = queryValue;
                }
                return acc;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            }, {});
            setStore({
                ...store,
                ...newState
            });
        }
    }, [
        preferences,
        query,
        store,
        entity.id,
        view,
        prevQuery
    ]);
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            store: store,
            setPreferenceValue: setPreferenceValue
        }), [
        store,
        setPreferenceValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6117ab20ad9a3ccd$var$ViewPreferencesContext.Provider, {
        value: contextValue
    }, children);
};
const $6117ab20ad9a3ccd$export$ee494de6c0ff45d7 = (preference)=>{
    const { store: store, setPreferenceValue: setPreferenceValue } = (0, $eUqFw.useContext)($6117ab20ad9a3ccd$var$ViewPreferencesContext);
    const setValue = (0, $eUqFw.useCallback)((value, action = 'push')=>{
        setPreferenceValue(preference, value, action);
    }, [
        preference,
        setPreferenceValue
    ]);
    const value = store[preference.id];
    return [
        value,
        setValue
    ];
};

});
parcelRegister("6YT9E", function(module, exports) {

$parcel$export(module.exports, "setPreference", () => $e32968ac8498b8dc$export$c6483f3cdc3e51e1);
$parcel$export(module.exports, "getPreference", () => $e32968ac8498b8dc$export$5fa261395d19a143);

var $aZaPn = parcelRequire("aZaPn");
const $e32968ac8498b8dc$var$store = (0, $aZaPn.createLocalStorageProvider)('jwm-view-preferences');
const $e32968ac8498b8dc$var$buildPreferenceKey = (entityId, viewId, preferenceId)=>`${entityId}_${viewId}_${preferenceId}`;
const $e32968ac8498b8dc$export$c6483f3cdc3e51e1 = (entityId, viewId, preferenceId, value)=>{
    const key = $e32968ac8498b8dc$var$buildPreferenceKey(entityId, viewId, preferenceId);
    $e32968ac8498b8dc$var$store.set(key, value);
};
const $e32968ac8498b8dc$export$5fa261395d19a143 = (entityId, viewId, preferenceId)=>{
    const key = $e32968ac8498b8dc$var$buildPreferenceKey(entityId, viewId, preferenceId);
    return $e32968ac8498b8dc$var$store.get(key);
};

});


parcelRegister("a6BBe", function(module, exports) {

$parcel$export(module.exports, "STATUS_SORT_ORDER", () => $4f70cf7d8b2e6b0e$export$de9c103e53e690d1);
const $4f70cf7d8b2e6b0e$export$de9c103e53e690d1 = {
    new: 1,
    indeterminate: 2,
    done: 3
};

});

parcelRegister("iP9h2", function(module, exports) {

$parcel$export(module.exports, "sortListBy", () => $61a5cf2a87fc48eb$export$3793ed28be8699ad);
$parcel$export(module.exports, "createSortingGettersAndOrders", () => $61a5cf2a87fc48eb$export$b3fdfcb601c683c3);

var $bDIST = parcelRequire("bDIST");

var $jGcn0 = parcelRequire("jGcn0");

var $6imc4 = parcelRequire("6imc4");

var $iJbbQ = parcelRequire("iJbbQ");

var $3uSNh = parcelRequire("3uSNh");

var $8Qd0L = parcelRequire("8Qd0L");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $90Dtq = parcelRequire("90Dtq");
const $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE = 'Z';
const $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE = '~~';
const $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE = 0;
const $61a5cf2a87fc48eb$var$toAcceptedOrder = (order)=>order != null && order.toLowerCase() === 'asc' ? 'asc' : 'desc';
const $61a5cf2a87fc48eb$export$3793ed28be8699ad = (nodes, getters, orders)=>(0, (/*@__PURE__*/$parcel$interopDefault($bDIST)))(nodes, getters, orders.map($61a5cf2a87fc48eb$var$toAcceptedOrder));
const $61a5cf2a87fc48eb$var$getValueMapAndJoin = (fields, fieldKey, attributeName, defaultValue, // eslint-disable-next-line @typescript-eslint/no-explicit-any
getMapValueCb)=>{
    // join array with space so alphabetical order can be applied.
    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    const fieldValue = (0, $3uSNh.safeGetValue)(fields, fieldKey, attributeName, defaultValue) ?? defaultValue;
    return fieldValue.map(getMapValueCb).join(' ') || $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
};
const $61a5cf2a87fc48eb$var$resolvePriorityOrder = (fields, priorities)=>{
    const priorityId = (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') ? (0, $3uSNh.safeGetValue)(fields, 'priority', 'value.priorityId', '') : (0, $3uSNh.safeGetValue)(fields, 'priority', 'priorityId', '');
    const priorityOrder = priorities[priorityId];
    if (priorityOrder == null) return -1;
    return priorityOrder;
};
const $61a5cf2a87fc48eb$var$resolveStatusOrder = (fields, statuses)=>{
    const statusName = (0, $3uSNh.safeGetValue)(fields, 'status', 'name', '');
    const statusOrder = statuses[statusName];
    if (statusOrder == null) return -1;
    return statusOrder;
};
const $61a5cf2a87fc48eb$var$resolveTypeOrder = (fields, types)=>{
    const typeName = (0, $3uSNh.safeGetValue)(fields, 'issuetype', 'value', '');
    const typeOrder = types[typeName];
    if (typeOrder == null) return -1;
    return typeOrder;
};
const $61a5cf2a87fc48eb$var$resolveIssueKeyOrder = (fields)=>{
    const [, issueKeyNumber = 0] = (0, $3uSNh.safeGetValue)(fields, 'issuekey', 'value', '').split('-');
    return Number(issueKeyNumber);
};
const $61a5cf2a87fc48eb$var$resolveCustomTextFieldOrder = (fields, sortingField)=>{
    // wiki value will be null when empty
    const value = (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', null);
    return value != null ? value.toLowerCase() : $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE; // empty values should rank lower
};
/* eslint-disable complexity */ const $61a5cf2a87fc48eb$var$createSortableGetter = (fieldType, sortingField, sortedList)=>(node)=>{
        const { rank: rank, fields: fields = [] } = node;
        if (fieldType != null && (0, $6imc4.isSortingSupportedFieldTypePredicated)(fieldType) && (0, $6imc4.isSortingSupported)(fieldType) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            const field = (0, $3uSNh.getFieldValue)(fields, sortingField);
            if ((0, $iJbbQ.isNewTransformedFieldPredicated)(field)) return (0, $6imc4.getSorting)(fieldType, field) || $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
            return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
        }
        switch(fieldType){
            case 0, $lO4Or.LABELS_TYPE:
            case 0, $lO4Or.LABELS_CF_TYPE:
                // The backend will return [''] when it's empty so our default value might not be applied so we force return ~~ when it happens so empty items are ordered properly
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [
                    ''
                ], (label)=>label.toLowerCase());
            case 0, $lO4Or.PRIORITY_TYPE:
                return $61a5cf2a87fc48eb$var$resolvePriorityOrder(fields, sortedList != null && sortedList.priorities || {});
            case 0, $lO4Or.STATUS_TYPE:
                return $61a5cf2a87fc48eb$var$resolveStatusOrder(fields, sortedList != null && sortedList.statuses || {});
            case 0, $lO4Or.ISSUE_TYPE:
                return $61a5cf2a87fc48eb$var$resolveTypeOrder(fields, sortedList != null && sortedList.issueTypes || {});
            case 0, $lO4Or.ASSIGNEE_TYPE:
            case 0, $lO4Or.REPORTER_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 0, $lO4Or.USER_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 'issuekey':
                return $61a5cf2a87fc48eb$var$resolveIssueKeyOrder(fields);
            case 0, $lO4Or.CREATED:
            case 0, $lO4Or.UPDATED:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', '');
            case 0, $lO4Or.DATE_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $lO4Or.DUE_DATE_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', // empty dates are ranked higher than the ones with set date :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $lO4Or.DATETIME_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $jGcn0.RANK_ALIAS_FIELD_ID:
                if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
                    // We want to check for l-1 if the new jql parent is on
                    if ((0, $3uSNh.safeGetValue)(fields, 'issuetype', 'level', undefined) === -1) return (0, $90Dtq.resolveRank)((0, $3uSNh.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                } else return (0, $90Dtq.resolveRank)((0, $3uSNh.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                return rank ?? '';
            case 0, $lO4Or.SUMMARY_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', '').toLowerCase();
            case 0, $lO4Or.TEXT_CF_TYPE:
                return $61a5cf2a87fc48eb$var$resolveCustomTextFieldOrder(fields, sortingField);
            case 0, $lO4Or.SELECT_CF_TYPE:
            case 0, $lO4Or.CATEGORY_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [], (selectedValue)=>selectedValue?.value.toLowerCase());
            case 0, $lO4Or.TIME_ESTIMATE_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.timeInSeconds', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $lO4Or.URL_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $lO4Or.NUMBER_CF_TYPE:
            case 0, $lO4Or.STORY_POINTS_TYPE:
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $lO4Or.COMPONENTS_TYPE:
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [], (component)=>component?.name.toLowerCase());
            case 0, $lO4Or.SPRINT_TYPE:
                {
                    const sprintValue = (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
                    if (Array.isArray(sprintValue) && sprintValue.length) {
                        const { name: name, state: state } = sprintValue[0];
                        if (state === 'CLOSED') {
                            const statusId = (0, $3uSNh.safeGetValue)(fields, 'status', 'value', '');
                            // closed sprints should not be shown if the status is not done
                            // means that this ticket is on the backlog
                            if (statusId?.toString() !== (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE].toString()) return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
                        }
                        return name.toLowerCase();
                    }
                    return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
                }
            default:
                return (0, $3uSNh.safeGetValue)(fields, (0, $jGcn0.RANK_ALIAS_FIELD_ID), 'value', '');
        }
    };
const $61a5cf2a87fc48eb$export$b3fdfcb601c683c3 = (sorting, fieldType, sortedLists)=>{
    const getters = [];
    const orders = [];
    let sortFieldType = fieldType;
    // fieldType for key is not returned from useIssueTypeFieldConfig
    if (sorting?.sortBy === 'key') sortFieldType = 'issuekey';
    if (sorting != null && sorting.sortBy != null) {
        orders.push(sorting.direction, sorting.direction);
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter(sortFieldType, sorting.sortBy, sortedLists));
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter((0, $jGcn0.RANK_ALIAS_FIELD_ID), (0, $jGcn0.RANK_ALIAS_FIELD_ID)));
    } else {
        orders.push((0, $jGcn0.DEFAULT_RANK_SORTING_DIRECTION));
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter((0, $jGcn0.RANK_ALIAS_FIELD_ID), (0, $jGcn0.RANK_ALIAS_FIELD_ID)));
    }
    return {
        getters: getters,
        orders: orders
    };
};

});
parcelRegister("bDIST", function(module, exports) {

var $943C2 = parcelRequire("943C2");

var $1c8hB = parcelRequire("1c8hB");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $8796275107b9d4d1$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$1c8hB(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$1c8hB(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $943C2(collection, iteratees, orders);
}
module.exports = $8796275107b9d4d1$var$orderBy;

});

parcelRegister("6imc4", function(module, exports) {

$parcel$export(module.exports, "getSorting", () => $5172533d88399045$export$654dceec98f3061f);
$parcel$export(module.exports, "isSortingSupported", () => $5172533d88399045$export$c6c6084d02f37d7e);
$parcel$export(module.exports, "isSortingSupportedFieldTypePredicated", () => $5172533d88399045$export$190ed2ad153b150b);
$parcel$export(module.exports, "getSortingDisabledFields", () => $5172533d88399045$export$56c924491e5617ad);

var $5iWql = parcelRequire("5iWql");

var $hPNnE = parcelRequire("hPNnE");

var $6Kxnm = parcelRequire("6Kxnm");

var $4dn6Q = parcelRequire("4dn6Q");

var $fgDTb = parcelRequire("fgDTb");

var $4kOft = parcelRequire("4kOft");

var $dnGVZ = parcelRequire("dnGVZ");

var $5GKSf = parcelRequire("5GKSf");

var $4ACib = parcelRequire("4ACib");

var $8DMfR = parcelRequire("8DMfR");

var $77PMd = parcelRequire("77PMd");

var $fGEjz = parcelRequire("fGEjz");
const $5172533d88399045$var$createSortingHandlers = (0, $5iWql.default)(()=>({
        ...(0, $4kOft.parentSortingHandler),
        ...(0, $fGEjz.versionSortingHandler),
        ...(0, $4ACib.resolutionSortingHandler),
        ...(0, $fgDTb.groupSortingHandler),
        ...(0, $5GKSf.radioSelectSortingHandler),
        ...(0, $hPNnE.cascadingSelectSortingHandler),
        ...(0, $dnGVZ.projectSortingHandler)
    }));
const $5172533d88399045$export$654dceec98f3061f = (fieldType, ...args)=>{
    const handlers = $5172533d88399045$var$createSortingHandlers();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $5172533d88399045$export$c6c6084d02f37d7e = (fieldType)=>{
    const handlers = $5172533d88399045$var$createSortingHandlers();
    return handlers[fieldType] != null;
};
const $5172533d88399045$export$190ed2ad153b150b = (fieldType)=>true;
const $5172533d88399045$export$56c924491e5617ad = (0, $5iWql.default)(()=>({
        ...(0, $6Kxnm.devSummaryDisabledSorting),
        ...(0, $77PMd.teamDisabledSorting),
        ...(0, $8DMfR.statusCategoryDisabledSorting),
        ...(0, $4dn6Q.goalsDisabledSorting)
    }));

});
parcelRegister("hPNnE", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectSortingHandler", () => $9006c1312190fa14$export$7b0bfc6838ff3257);

var $lO4Or = parcelRequire("lO4Or");

var $yTRlI = parcelRequire("yTRlI");
const $9006c1312190fa14$var$getCascadingSelectSorting = (field)=>(0, $yTRlI.getCascadingSelectStringValue)(field.value);
const $9006c1312190fa14$export$7b0bfc6838ff3257 = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $9006c1312190fa14$var$getCascadingSelectSorting
};

});
parcelRegister("yTRlI", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectStringValue", () => $501644a5d0f27e91$export$f110a74eb752aa7e);
$parcel$export(module.exports, "cascadingSelectStringValueHandler", () => $501644a5d0f27e91$export$f39c163ada81742a);
$parcel$export(module.exports, "cascadingSelectRichValueHandler", () => $501644a5d0f27e91$export$af92c160980c340f);

var $lO4Or = parcelRequire("lO4Or");
const $501644a5d0f27e91$export$f110a74eb752aa7e = (fieldValue)=>{
    if (fieldValue && fieldValue.parentOptionValue) {
        if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
        return `${fieldValue.parentOptionValue.value}`;
    }
    return '';
};
const $501644a5d0f27e91$var$getCascadingSelectValue = (field)=>$501644a5d0f27e91$export$f110a74eb752aa7e(field.value);
const $501644a5d0f27e91$var$getCascadingSelectRichValue = (field)=>field.value ?? null;
const $501644a5d0f27e91$export$f39c163ada81742a = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $501644a5d0f27e91$var$getCascadingSelectValue
};
const $501644a5d0f27e91$export$af92c160980c340f = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $501644a5d0f27e91$var$getCascadingSelectRichValue
};

});


parcelRegister("6Kxnm", function(module, exports) {

$parcel$export(module.exports, "devSummaryDisabledSorting", () => $13cd49fb2f12cee8$export$8cf683615a3ccf77);

var $lO4Or = parcelRequire("lO4Or");
const $13cd49fb2f12cee8$export$8cf683615a3ccf77 = {
    [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: false
};

});

parcelRegister("4dn6Q", function(module, exports) {

$parcel$export(module.exports, "goalsDisabledSorting", () => $e609dcddc34139db$export$60ff70c996f5c362);

var $lO4Or = parcelRequire("lO4Or");
const $e609dcddc34139db$export$60ff70c996f5c362 = {
    [(0, $lO4Or.GOALS_CF_TYPE)]: false
};

});

parcelRegister("fgDTb", function(module, exports) {

$parcel$export(module.exports, "groupSortingHandler", () => $2965094b1aff09d1$export$a577fd60fa30451d);

var $lO4Or = parcelRequire("lO4Or");
const $2965094b1aff09d1$var$getSingleGroupSorting = (field)=>field.value?.name ?? '';
const $2965094b1aff09d1$var$getMultipleGroupSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $2965094b1aff09d1$export$a577fd60fa30451d = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: $2965094b1aff09d1$var$getSingleGroupSorting,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: $2965094b1aff09d1$var$getMultipleGroupSorting
};

});

parcelRegister("4kOft", function(module, exports) {

$parcel$export(module.exports, "parentSortingHandler", () => $b1645a5228930c15$export$20dbdacc158507c9);

var $lO4Or = parcelRequire("lO4Or");
const $b1645a5228930c15$var$getParentSorting = (field)=>field.value ? field.value.issueKey : '';
const $b1645a5228930c15$export$20dbdacc158507c9 = {
    [(0, $lO4Or.PARENT_TYPE)]: $b1645a5228930c15$var$getParentSorting
};

});

parcelRegister("dnGVZ", function(module, exports) {

$parcel$export(module.exports, "projectSortingHandler", () => $b535da34585ea13f$export$18c888fa7805bbf9);

var $lO4Or = parcelRequire("lO4Or");
const $b535da34585ea13f$var$getProjectSorting = (field)=>field.value?.name ?? '';
const $b535da34585ea13f$export$18c888fa7805bbf9 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $b535da34585ea13f$var$getProjectSorting
};

});

parcelRegister("5GKSf", function(module, exports) {

$parcel$export(module.exports, "radioSelectSortingHandler", () => $090676a3e9c576f9$export$d622730346571a2b);

var $lO4Or = parcelRequire("lO4Or");
const $090676a3e9c576f9$var$getRadioSelectSorting = (field)=>field.value ? field.value.value : '';
const $090676a3e9c576f9$export$d622730346571a2b = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $090676a3e9c576f9$var$getRadioSelectSorting
};

});

parcelRegister("4ACib", function(module, exports) {

$parcel$export(module.exports, "resolutionSortingHandler", () => $2a63ab07413670f0$export$596a643f093db9a7);

var $lO4Or = parcelRequire("lO4Or");
const $2a63ab07413670f0$var$getResolutionSorting = (field)=>field.value?.name ?? '';
const $2a63ab07413670f0$export$596a643f093db9a7 = {
    [(0, $lO4Or.RESOLUTION_TYPE)]: $2a63ab07413670f0$var$getResolutionSorting
};

});

parcelRegister("8DMfR", function(module, exports) {

$parcel$export(module.exports, "statusCategoryDisabledSorting", () => $14c4f6b294c727dd$export$117cb43589655b27);

var $lO4Or = parcelRequire("lO4Or");
const $14c4f6b294c727dd$export$117cb43589655b27 = {
    [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: false
};

});

parcelRegister("77PMd", function(module, exports) {

$parcel$export(module.exports, "teamDisabledSorting", () => $4318536e894fadd9$export$1626c947db580b0f);

var $lO4Or = parcelRequire("lO4Or");
const $4318536e894fadd9$export$1626c947db580b0f = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: false
};

});

parcelRegister("fGEjz", function(module, exports) {

$parcel$export(module.exports, "versionSortingHandler", () => $478431d0e41552b9$export$f2894a637a250eaa);

var $lO4Or = parcelRequire("lO4Or");
const $478431d0e41552b9$var$getSingleVersionSorting = (field)=>field.value?.name ?? '';
const $478431d0e41552b9$var$getMultipleVersionSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $478431d0e41552b9$export$f2894a637a250eaa = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $478431d0e41552b9$var$getSingleVersionSorting,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting
};

});


parcelRegister("iJbbQ", function(module, exports) {

$parcel$export(module.exports, "isNewTransformedFieldPredicated", () => $1f6d8e2cada4a475$export$b018c2b58ea7e0de);

const $1f6d8e2cada4a475$export$b018c2b58ea7e0de = (field)=>field != null;

});

parcelRegister("3uSNh", function(module, exports) {

$parcel$export(module.exports, "getFieldValue", () => $0a411223ee962893$export$2e85048acc9aea83);
$parcel$export(module.exports, "safeGetValue", () => $0a411223ee962893$export$f17a5eaf5fe57cff);
$parcel$export(module.exports, "safeGetTransformedFieldValue", () => $0a411223ee962893$export$16456470899ab77f);
$parcel$export(module.exports, "safeGetTransformedValue", () => $0a411223ee962893$export$c1cc7bc9b4953394);

var $illlw = parcelRequire("illlw");
const $0a411223ee962893$export$2e85048acc9aea83 = (fields, fieldKey)=>{
    if (fields && fieldKey != null) return fields.find((field)=>field?.fieldKey && field.fieldKey === fieldKey || field?.fieldId && field.fieldId === fieldKey || field?.aliasFieldId && field.aliasFieldId === fieldKey);
    return undefined;
};
const $0a411223ee962893$export$f17a5eaf5fe57cff = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $0a411223ee962893$export$2e85048acc9aea83(fields, fieldKey);
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, attributeName, defaultValue);
};
const $0a411223ee962893$export$16456470899ab77f = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $0a411223ee962893$export$2e85048acc9aea83(fields, fieldKey);
    return $0a411223ee962893$export$c1cc7bc9b4953394(field, defaultValue);
};
const $0a411223ee962893$export$c1cc7bc9b4953394 = (field, defaultValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, 'value', defaultValue);

});

parcelRegister("90Dtq", function(module, exports) {

$parcel$export(module.exports, "resolveRank", () => $668a01cc7ea88012$export$992090b26f7c7f11);
const $668a01cc7ea88012$export$992090b26f7c7f11 = (parentIssue, rank)=>{
    // for the Sub-task issue types, sorting based on rank considers the parent rank first, then sorts based on item rank
    // concatenating (parentRank + rank) would do that for us!
    const parentRank = parentIssue?.rank ?? '';
    return parentRank.concat(rank);
};

});



parcelRegister("gZpkQ", function(module, exports) {

$parcel$export(module.exports, "useHideDoneItems", () => $0e65969a09396197$export$c2cb7b17819b92d4);
$parcel$export(module.exports, "useInferHideDoneItemsWithFilters", () => $0e65969a09396197$export$a14bc8305f71e469);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $8Qd0L = parcelRequire("8Qd0L");

var $9GlEj = parcelRequire("9GlEj");
const $0e65969a09396197$export$c2cb7b17819b92d4 = ()=>{
    const [hideDoneItems, persistHideDoneItems] = (0, $7c3W1.useViewPreference)((0, $ji3xf.HIDE_DONE_ITEMS_PREFERENCE));
    const setHideDoneItems = (0, $eUqFw.useCallback)((hide, action = 'push')=>persistHideDoneItems(hide ? 'true' : undefined, action), [
        persistHideDoneItems
    ]);
    return [
        hideDoneItems === 'true',
        setHideDoneItems
    ];
};
const $0e65969a09396197$export$a14bc8305f71e469 = ({ filters: filters })=>{
    const [hideDoneItems, setHideDoneItems] = $0e65969a09396197$export$c2cb7b17819b92d4();
    const { quickFilters: quickFilters } = (0, $9GlEj.useQuickFilters)();
    (0, $eUqFw.useEffect)(()=>{
        if (hideDoneItems) {
            const isFilteringByDoneStatus = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (filters && filters.status)?.find((status)=>Number(status.categoryId) === (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE]);
            if (isFilteringByDoneStatus || quickFilters?.DONE) setHideDoneItems(false, 'replace');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters,
        quickFilters?.DONE
    ]);
};

});
parcelRegister("9GlEj", function(module, exports) {

$parcel$export(module.exports, "useQuickFilters", () => $20c7583d02c9250e$export$3dae1bb95b659fd4);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $lO4Or = parcelRequire("lO4Or");

var $kMmsu = parcelRequire("kMmsu");
const $20c7583d02c9250e$var$quickFilterToJQLMapOld = {
    ASSIGNED_TO_ME: 'assignee = currentUser()',
    DONE: "StatusCategory = 'Complete'",
    DUE_THIS_WEEK: 'duedate <= endOfWeek() and duedate > startOfWeek()'
};
const $20c7583d02c9250e$export$808f76242d61e1a5 = (sprintJQLTerm)=>{
    if (sprintJQLTerm == null) return $20c7583d02c9250e$var$quickFilterToJQLMapOld;
    return {
        ...$20c7583d02c9250e$var$quickFilterToJQLMapOld,
        ACTIVE_SPRINTS: `${sprintJQLTerm} in openSprints()`
    };
};
const $20c7583d02c9250e$var$buildJQLFromQuickFilters = (quickFilters, { quickFilterToJQLMap: quickFilterToJQLMap = $20c7583d02c9250e$var$quickFilterToJQLMapOld } = {})=>{
    const jqlClauses = Object.entries(quickFilters).map(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly ASSIGNED_TO_ME: "assignee = currentUser()"; readonly DONE: "StatusCategory = 'Complete'"; readonly DUE_THIS_WEEK: "duedate <= endOfWeek() and duedate > startOfWeek()"; }'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([key, isEnabled])=>isEnabled === true && quickFilterToJQLMap[key]);
    const enabledFilters = jqlClauses.filter((jql)=>jql);
    return enabledFilters.join(' AND ') || null;
};
const $20c7583d02c9250e$export$9294471da4d3c33f = {
    ASSIGNED_TO_ME: false,
    DONE: false,
    DUE_THIS_WEEK: false,
    ACTIVE_SPRINTS: false
};
const $20c7583d02c9250e$export$9692fc1a2fd983f5 = (jql, { quickFilterToJQLMap: quickFilterToJQLMap = $20c7583d02c9250e$var$quickFilterToJQLMapOld } = {})=>{
    const quickFilters = {
        ...$20c7583d02c9250e$export$9294471da4d3c33f
    };
    if (!jql) return quickFilters;
    if (jql.includes(quickFilterToJQLMap.ASSIGNED_TO_ME)) quickFilters.ASSIGNED_TO_ME = true;
    if (jql.includes(quickFilterToJQLMap.DONE)) quickFilters.DONE = true;
    if (jql.includes(quickFilterToJQLMap.DUE_THIS_WEEK)) quickFilters.DUE_THIS_WEEK = true;
    if (quickFilterToJQLMap.ACTIVE_SPRINTS && jql.includes(quickFilterToJQLMap.ACTIVE_SPRINTS)) quickFilters.ACTIVE_SPRINTS = true;
    return quickFilters;
};
const $20c7583d02c9250e$var$useSprintFieldJQLTerm = ()=>{
    const { data: fields } = (0, $kMmsu.useFieldsResource)();
    return (0, $eUqFw.useMemo)(()=>{
        if (fields == null) return undefined;
        const sprintField = fields.find((field)=>field.type === (0, $lO4Or.SPRINT_TYPE));
        return sprintField != null ? sprintField.jqlTerm : undefined;
    }, [
        fields
    ]);
};
const $20c7583d02c9250e$export$3dae1bb95b659fd4 = ()=>{
    const sprintFieldJQLTerm = $20c7583d02c9250e$var$useSprintFieldJQLTerm();
    const quickFilterToJQLMap = (0, $eUqFw.useMemo)(()=>$20c7583d02c9250e$export$808f76242d61e1a5(sprintFieldJQLTerm), [
        sprintFieldJQLTerm
    ]);
    const [filters, setFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const setQuickFilters = (0, $eUqFw.useCallback)((newQuickFilters)=>{
        if (newQuickFilters) {
            const jql = $20c7583d02c9250e$var$buildJQLFromQuickFilters(newQuickFilters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            });
            if (jql == null) setFilters(undefined);
            else setFilters(jql);
        } else setFilters(undefined);
    }, [
        quickFilterToJQLMap,
        setFilters
    ]);
    const quickFilters = (0, $eUqFw.useMemo)(()=>$20c7583d02c9250e$export$9692fc1a2fd983f5(filters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        }), [
        filters,
        quickFilterToJQLMap
    ]);
    return {
        quickFilters: quickFilters,
        persistQuickFilters: setQuickFilters,
        quickFiltersJql: $20c7583d02c9250e$var$buildJQLFromQuickFilters(quickFilters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        })
    };
};

});


parcelRegister("lEWmB", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $2972841342234906$export$973ca22476b0e05f);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $8aCHU = parcelRequire("8aCHU");
const $2972841342234906$export$973ca22476b0e05f = ()=>{
    const [jql, saveFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const setFilter = (0, $eUqFw.useCallback)((filters)=>{
        const serialisedJql = (0, $8aCHU.serialiseJql)(filters);
        saveFilters(serialisedJql !== '' ? serialisedJql : undefined);
    }, [
        saveFilters
    ]);
    return {
        setFilter: setFilter,
        jql: jql
    };
};

});
parcelRegister("8aCHU", function(module, exports) {

$parcel$export(module.exports, "serialiseJql", () => $0e700551905b00b3$export$e1718e1e441cb0f6);
$parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", () => $0e700551905b00b3$export$9ee6085825c9cbfa);

var $8blac = parcelRequire("8blac");

var $27QuD = parcelRequire("27QuD");

var $6wqPF = parcelRequire("6wqPF");

var $6x1NF = parcelRequire("6x1NF");

var $ehDeP = parcelRequire("ehDeP");
var $k85ht = parcelRequire("k85ht");
var $lmIUR = parcelRequire("lmIUR");

var $dG4cR = parcelRequire("dG4cR");
const $0e700551905b00b3$var$START_DATE_JQL = 'Start date[Date]';
const $0e700551905b00b3$var$EMPTY = 'EMPTY';
const $0e700551905b00b3$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
const $0e700551905b00b3$var$getFieldNameForJqlRaw = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
    // the "to" fieldName for the date range will be transformed to "due" in the "serialiseJql" function
    // where "const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;"
    if (fieldName === 'dateRange') return $0e700551905b00b3$var$START_DATE_JQL;
    return fieldName;
};
const $0e700551905b00b3$var$getFieldNameForJql = (fieldName)=>$0e700551905b00b3$var$getQuotedFieldName($0e700551905b00b3$var$getFieldNameForJqlRaw(fieldName));
const $0e700551905b00b3$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $0e700551905b00b3$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $0e700551905b00b3$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
const $0e700551905b00b3$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
const $0e700551905b00b3$export$e1718e1e441cb0f6 = (filters)=>{
    const jqlQuery = (0, $ehDeP.default).query();
    Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options.value)))).forEach(([fieldId, options])=>{
        const fieldName = $0e700551905b00b3$var$getFieldNameForJqlRaw(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
            if (options.value.to != null) {
                const toDate = (0, $6x1NF.default)((0, $6wqPF.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(toFieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_LT)), (0, $ehDeP.default).valueOperand(toDate)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            }
            if (options.value.from != null) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_GT_EQUALS)), (0, $ehDeP.default).valueOperand(options.value.from)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            return;
        }
        if (Array.isArray(options)) {
            const operands = options.map((option)=>{
                if (option.isEmptyOption) return (0, $ehDeP.default).valueOperand((0, $807962b43ef03b56$export$1c46dca02aac24dd));
                if (option.value) // Currently, the AST does not sanatize all values correctly (no \ or JQL keywords), so we need to manually wrap in quotes
                // We can remove this once https://jplat.jira.atlassian.cloud/browse/EM-6563 is implemented
                return (0, $ehDeP.default).byText.valueOperand(`"${$0e700551905b00b3$var$sanitizeWord(option.value)}"`);
                return null;
            }).filter((operand)=>operand != null);
            if (operands.length === 1) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_EQUALS)), operands[0]), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            else if (operands.length > 1) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_IN)), (0, $ehDeP.default).listOperand(operands)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
        }
    });
    const jast = (0, $ehDeP.default).jast(jqlQuery);
    return (0, $lmIUR.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $0e700551905b00b3$export$5bd6a523f48a18cd = (filters)=>{
    const pairs = Object.entries(filters).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options.value)))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([fieldId, options])=>{
        const fieldName = $0e700551905b00b3$var$getFieldNameForJql(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? $0e700551905b00b3$var$getQuotedFieldName('due') : fieldName;
            let toDate;
            if (options.value.to) toDate = (0, $6x1NF.default)((0, $6wqPF.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
            else toDate = options.value.to;
            if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
            if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
            return `${toFieldName} < ${toDate}`;
        }
        if (Array.isArray(options)) {
            const values = options.map((option)=>// make sure we don't wrap EMPTY with quotation marks
                option.value === (0, $dG4cR.EMPTY_FILTER_VALUE) ? $0e700551905b00b3$var$EMPTY : `'${$0e700551905b00b3$var$sanitizeWordOld(option.value)}'`).join(',');
            if (options.length > 1) return `${fieldName} in (${values})`;
            if (options.length === 1) return `${fieldName} = ${values}`;
        }
        return null;
    });
    return pairs.join(' AND ');
};
const $0e700551905b00b3$var$extractField = (statement)=>{
    let fieldId;
    const dateOperatorRegex = />=|</;
    if (dateOperatorRegex.test(statement)) {
        const operator = statement.includes('>=') ? ' >= ' : ' < ';
        [fieldId] = statement.split(operator);
    }
    if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
    if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
    if (fieldId) return $0e700551905b00b3$var$getFieldIdFromJql(fieldId);
};
const $0e700551905b00b3$export$9ee6085825c9cbfa = (jql)=>{
    if (!jql) return {};
    return jql.split(/ AND | OR /).map($0e700551905b00b3$var$extractField).reduce((acc, curr)=>{
        if (curr) acc[curr] = true;
        return acc;
    }, {});
};

});
parcelRegister("27QuD", function(module, exports) {

var $TLr3n = parcelRequire("TLr3n");

var $2cjNq = parcelRequire("2cjNq");

var $8SGvQ = parcelRequire("8SGvQ");

var $1qE1i = parcelRequire("1qE1i");

var $3Muqa = parcelRequire("3Muqa");

var $aSldm = parcelRequire("aSldm");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $18c4f43cd593e3cf$var$trim(string, chars, guard) {
    string = $1uqnh(string);
    if (string && (guard || chars === undefined)) return $2cjNq(string);
    if (!string || !(chars = $TLr3n(chars))) return string;
    var strSymbols = $aSldm(string), chrSymbols = $aSldm(chars), start = $3Muqa(strSymbols, chrSymbols), end = $1qE1i(strSymbols, chrSymbols) + 1;
    return $8SGvQ(strSymbols, start, end).join('');
}
module.exports = $18c4f43cd593e3cf$var$trim;

});
parcelRegister("1qE1i", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $10a7434ada2e55c3$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $10a7434ada2e55c3$var$charsEndIndex;

});

parcelRegister("3Muqa", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $2c0d73c17288fd42$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $2c0d73c17288fd42$var$charsStartIndex;

});


const $e5bc650799ce4838$export$6d6d48d210d3ca97 = 'and';
const $e5bc650799ce4838$export$7b8f0a728d79a753 = 'or';

parcelRegister("ehDeP", function(module, exports) {

$parcel$export(module.exports, "internalCreators", () => $b9828d20df20ab04$export$64d991963cfb5532);
$parcel$export(module.exports, "default", () => $b9828d20df20ab04$export$2e2bcd8739ae039);

var $bdxrq = parcelRequire("bdxrq");

var $6PZUx = parcelRequire("6PZUx");

var $1tKLQ = parcelRequire("1tKLQ");

var $1l80e = parcelRequire("1l80e");

var $2H3zB = parcelRequire("2H3zB");

var $kDZbK = parcelRequire("kDZbK");

var $dnbob = parcelRequire("dnbob");

var $bfn5R = parcelRequire("bfn5R");

var $eD0Hy = parcelRequire("eD0Hy");

var $1uxra = parcelRequire("1uxra");

var $5eoHT = parcelRequire("5eoHT");

var $3T5iU = parcelRequire("3T5iU");

var $8Tr0t = parcelRequire("8Tr0t");

var $1R1xk = parcelRequire("1R1xk");

var $eHzms = parcelRequire("eHzms");

var $i2yZF = parcelRequire("i2yZF");

var $3fSGD = parcelRequire("3fSGD");

var $jvsC0 = parcelRequire("jvsC0");

var $bdP2p = parcelRequire("bdP2p");

var $1Rz9E = parcelRequire("1Rz9E");

var $5o1cq = parcelRequire("5o1cq");

var $4VxAa = parcelRequire("4VxAa");
const $b9828d20df20ab04$export$64d991963cfb5532 = {
    query: (0, $1Rz9E.queryInternal),
    compoundClause: (0, $6PZUx.compoundClauseInternal),
    compoundOperator: (0, $1tKLQ.compoundOperatorInternal),
    terminalClause: (0, $5o1cq.terminalClauseInternal),
    notClause: (0, $1uxra.notClauseInternal),
    notClauseOperator: (0, $5eoHT.notClauseOperatorInternal),
    predicate: (0, $3fSGD.predicateInternal),
    predicateOperator: (0, $jvsC0.predicateOperatorInternal),
    field: (0, $1l80e.fieldInternal),
    property: (0, $bdP2p.propertyInternal),
    operator: (0, $3T5iU.operatorInternal),
    valueOperand: (0, $4VxAa.valueOperandInternal),
    keywordOperand: (0, $bfn5R.keywordOperandInternal),
    functionOperand: (0, $2H3zB.functionOperandInternal),
    functionString: (0, $kDZbK.functionStringInternal),
    argument: (0, $bdxrq.argumentInternal),
    listOperand: (0, $eD0Hy.listOperandInternal),
    orderBy: (0, $8Tr0t.orderByInternal),
    orderByOperator: (0, $i2yZF.orderByOperatorInternal),
    orderByField: (0, $eHzms.orderByFieldInternal),
    orderByDirection: (0, $1R1xk.orderByDirectionInternal)
};
var $b9828d20df20ab04$export$2e2bcd8739ae039 = {
    jast: $dnbob.jast,
    query: $1Rz9E.query,
    compoundClause: $6PZUx.compoundClause,
    compoundOperator: $1tKLQ.compoundOperator,
    terminalClause: $5o1cq.terminalClause,
    notClause: $1uxra.notClause,
    notClauseOperator: $5eoHT.notClauseOperator,
    predicate: $3fSGD.predicate,
    predicateOperator: $jvsC0.predicateOperator,
    field: $1l80e.field,
    property: $bdP2p.property,
    operator: $3T5iU.operator,
    valueOperand: $4VxAa.valueOperand,
    keywordOperand: $bfn5R.keywordOperand,
    functionOperand: $2H3zB.functionOperand,
    functionString: $kDZbK.functionString,
    argument: $bdxrq.argument,
    listOperand: $eD0Hy.listOperand,
    orderBy: $8Tr0t.orderBy,
    orderByOperator: $i2yZF.orderByOperator,
    orderByField: $eHzms.orderByField,
    orderByDirection: $1R1xk.orderByDirection,
    byText: {
        argument: (0, $bdxrq.argumentByText),
        valueOperand: (0, $4VxAa.valueOperandByText)
    }
};

});
parcelRegister("bdxrq", function(module, exports) {

$parcel$export(module.exports, "argument", () => $07ff9cf8710db9a9$export$6ea29ee575e3f5ff);
$parcel$export(module.exports, "argumentInternal", () => $07ff9cf8710db9a9$export$5b341d50fa5bcdd5);
$parcel$export(module.exports, "argumentByText", () => $07ff9cf8710db9a9$export$84c43d23f51170cb);

var $g2nfy = parcelRequire("g2nfy");
var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $07ff9cf8710db9a9$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $07ff9cf8710db9a9$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $07ff9cf8710db9a9$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $07ff9cf8710db9a9$export$6ea29ee575e3f5ff = (value)=>$07ff9cf8710db9a9$export$5b341d50fa5bcdd5(value, (0, $tI64Y.sanitiseJqlString)(value));
const $07ff9cf8710db9a9$export$84c43d23f51170cb = (text)=>$07ff9cf8710db9a9$export$5b341d50fa5bcdd5((0, $g2nfy.normaliseJqlString)(text), text);
const $07ff9cf8710db9a9$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $07ff9cf8710db9a9$var$acceptArgument,
        enterNode: $07ff9cf8710db9a9$var$enterNode,
        exitNode: $07ff9cf8710db9a9$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});
parcelRegister("g2nfy", function(module, exports) {

$parcel$export(module.exports, "normaliseJqlString", () => $33fc07f8fcdc6596$export$cecf78a779acc0ff);
const $33fc07f8fcdc6596$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $33fc07f8fcdc6596$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $33fc07f8fcdc6596$export$b86601123607fee5 = (maybeQuotedString)=>$33fc07f8fcdc6596$export$7a0b99b892e0dda8(maybeQuotedString) || $33fc07f8fcdc6596$export$d5efd6512db694fd(maybeQuotedString);
const $33fc07f8fcdc6596$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($33fc07f8fcdc6596$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};

});

parcelRegister("tI64Y", function(module, exports) {

$parcel$export(module.exports, "sanitiseJqlString", () => $67c602023b602b57$export$3eb9033c48208278);

var $e1vfz = parcelRequire("e1vfz");
// Derived from JQLLexer#VALID_UNQUOTED_CHARS
const $67c602023b602b57$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $67c602023b602b57$export$3eb9033c48208278 = (jqlString)=>{
    if ($67c602023b602b57$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    return jqlString;
};

});
parcelRegister("e1vfz", function(module, exports) {

var $1uqnh = parcelRequire("1uqnh");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $a359664a3c663e8b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $a359664a3c663e8b$var$reHasRegExpChar = RegExp($a359664a3c663e8b$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $a359664a3c663e8b$var$escapeRegExp(string) {
    string = $1uqnh(string);
    return string && $a359664a3c663e8b$var$reHasRegExpChar.test(string) ? string.replace($a359664a3c663e8b$var$reRegExpChar, '\\$&') : string;
}
module.exports = $a359664a3c663e8b$var$escapeRegExp;

});


parcelRegister("8vd0B", function(module, exports) {

$parcel$export(module.exports, "noChildren", () => $bdd25090ea4701e8$export$470bef71e654b804);
$parcel$export(module.exports, "assignParent", () => $bdd25090ea4701e8$export$a4685923af2913a);
const $bdd25090ea4701e8$export$470bef71e654b804 = ()=>[];
const $bdd25090ea4701e8$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};

});


parcelRegister("6PZUx", function(module, exports) {

$parcel$export(module.exports, "compoundClause", () => $21944f207531c2fe$export$ab714e56a32c25f2);
$parcel$export(module.exports, "compoundClauseInternal", () => $21944f207531c2fe$export$cd65eed8c10b0911);


var $6Ijjg = parcelRequire("6Ijjg");

var $8vd0B = parcelRequire("8vd0B");
function $21944f207531c2fe$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $21944f207531c2fe$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $21944f207531c2fe$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $21944f207531c2fe$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $21944f207531c2fe$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $21944f207531c2fe$export$cd65eed8c10b0911(operator, clauses);
};
const $21944f207531c2fe$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$2d205682cc545947),
        clauseType: (0, $35634e4e5a46f5ae$export$7a58b23488ea076b),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $21944f207531c2fe$var$acceptCompoundClause,
        enterNode: $21944f207531c2fe$var$enterNode,
        exitNode: $21944f207531c2fe$var$exitNode,
        getChildren: $21944f207531c2fe$var$getChildren,
        parent: null,
        appendClause: $6Ijjg.appendClause,
        remove: $6Ijjg.remove,
        removeClause: $6Ijjg.removeClause,
        replace: $6Ijjg.replace,
        replaceClause: $6Ijjg.replaceClause
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
const $35634e4e5a46f5ae$export$7a58b23488ea076b = 'compound';
const $35634e4e5a46f5ae$export$ae56b4ef248a2b6a = 'terminal';
const $35634e4e5a46f5ae$export$e356b89f8c8d2fcb = 'not';

const $4dac9dd1966bb7dd$export$98dda21ec825792 = 'query';
const $4dac9dd1966bb7dd$export$2d205682cc545947 = 'clause';
const $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d = 'operand';
const $4dac9dd1966bb7dd$export$da0f73edded4a63d = 'order_by';

parcelRegister("6Ijjg", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);


var $8vd0B = parcelRequire("8vd0B");
function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $8vd0B.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $8vd0B.assignParent)(this);
}

});


parcelRegister("1tKLQ", function(module, exports) {

$parcel$export(module.exports, "compoundOperator", () => $41689cae7add497a$export$84bb3ebbba491aee);
$parcel$export(module.exports, "compoundOperatorInternal", () => $41689cae7add497a$export$63c33bc3fe74fee6);

var $8vd0B = parcelRequire("8vd0B");
function $41689cae7add497a$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $41689cae7add497a$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $41689cae7add497a$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $41689cae7add497a$export$84bb3ebbba491aee = (value)=>$41689cae7add497a$export$63c33bc3fe74fee6(value, []);
const $41689cae7add497a$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $41689cae7add497a$var$acceptCompoundOperator,
        enterNode: $41689cae7add497a$var$enterNode,
        exitNode: $41689cae7add497a$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("1l80e", function(module, exports) {

$parcel$export(module.exports, "field", () => $ca7da08f64c6e9e4$export$e0f35d825088c098);
$parcel$export(module.exports, "fieldInternal", () => $ca7da08f64c6e9e4$export$2193f8c541622b6);

var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $ca7da08f64c6e9e4$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $ca7da08f64c6e9e4$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $ca7da08f64c6e9e4$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $ca7da08f64c6e9e4$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $ca7da08f64c6e9e4$export$e0f35d825088c098 = (value, properties)=>{
    return $ca7da08f64c6e9e4$export$2193f8c541622b6(value, (0, $tI64Y.sanitiseJqlString)(value), properties);
};
const $ca7da08f64c6e9e4$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $ca7da08f64c6e9e4$var$acceptField,
        enterNode: $ca7da08f64c6e9e4$var$enterNode,
        exitNode: $ca7da08f64c6e9e4$var$exitNode,
        getChildren: $ca7da08f64c6e9e4$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});

parcelRegister("2H3zB", function(module, exports) {

$parcel$export(module.exports, "functionOperand", () => $40b2ef8348f4cf32$export$4f981b0e83488ce);
$parcel$export(module.exports, "functionOperandInternal", () => $40b2ef8348f4cf32$export$c1f2ce91dc05872a);


var $8vd0B = parcelRequire("8vd0B");
function $40b2ef8348f4cf32$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $40b2ef8348f4cf32$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $40b2ef8348f4cf32$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $40b2ef8348f4cf32$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $40b2ef8348f4cf32$export$4f981b0e83488ce = (functionString, args = [])=>$40b2ef8348f4cf32$export$c1f2ce91dc05872a(functionString, args);
const $40b2ef8348f4cf32$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$19c7c729db381f9d),
        function: functionString,
        arguments: args,
        position: position,
        accept: $40b2ef8348f4cf32$var$acceptFunctionOperand,
        enterNode: $40b2ef8348f4cf32$var$enterNode,
        exitNode: $40b2ef8348f4cf32$var$exitNode,
        getChildren: $40b2ef8348f4cf32$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
const $807962b43ef03b56$export$38accfc5a5d1c113 = 'value';
const $807962b43ef03b56$export$f6049126fd97001f = 'keyword';
const $807962b43ef03b56$export$19c7c729db381f9d = 'function';
const $807962b43ef03b56$export$fabec4aebba3f4df = 'list';
const $807962b43ef03b56$export$1c46dca02aac24dd = 'empty';


parcelRegister("kDZbK", function(module, exports) {

$parcel$export(module.exports, "functionString", () => $4a79528e6e143f86$export$4e1bb9a7ff8d0ef9);
$parcel$export(module.exports, "functionStringInternal", () => $4a79528e6e143f86$export$7aa9944588b7a69f);

var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $4a79528e6e143f86$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $4a79528e6e143f86$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $4a79528e6e143f86$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $4a79528e6e143f86$export$4e1bb9a7ff8d0ef9 = (value)=>$4a79528e6e143f86$export$7aa9944588b7a69f(value, (0, $tI64Y.sanitiseJqlString)(value));
const $4a79528e6e143f86$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $4a79528e6e143f86$var$acceptFunctionString,
        enterNode: $4a79528e6e143f86$var$enterNode,
        exitNode: $4a79528e6e143f86$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("dnbob", function(module, exports) {

$parcel$export(module.exports, "jast", () => $b5aa2ed089d54434$export$b9e70a00f479ff43);
const $b5aa2ed089d54434$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });

});

parcelRegister("bfn5R", function(module, exports) {

$parcel$export(module.exports, "keywordOperand", () => $33ccff7643df2fc3$export$2edd4971ed69f2ce);
$parcel$export(module.exports, "keywordOperandInternal", () => $33ccff7643df2fc3$export$7cc55480b054047b);


var $8vd0B = parcelRequire("8vd0B");
function $33ccff7643df2fc3$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $33ccff7643df2fc3$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $33ccff7643df2fc3$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $33ccff7643df2fc3$export$2edd4971ed69f2ce = ()=>$33ccff7643df2fc3$export$7cc55480b054047b((0, $807962b43ef03b56$export$1c46dca02aac24dd));
const $33ccff7643df2fc3$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$f6049126fd97001f),
        value: value,
        position: position,
        accept: $33ccff7643df2fc3$var$acceptKeywordOperand,
        enterNode: $33ccff7643df2fc3$var$enterNode,
        exitNode: $33ccff7643df2fc3$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("eD0Hy", function(module, exports) {

$parcel$export(module.exports, "listOperand", () => $c8986a6d4d679671$export$769866c3e9d41d50);
$parcel$export(module.exports, "listOperandInternal", () => $c8986a6d4d679671$export$663c7831528c984b);


var $7IFnF = parcelRequire("7IFnF");

var $8vd0B = parcelRequire("8vd0B");
function $c8986a6d4d679671$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $c8986a6d4d679671$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $c8986a6d4d679671$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $c8986a6d4d679671$var$getChildren() {
    return [
        ...this.values
    ];
}
const $c8986a6d4d679671$export$769866c3e9d41d50 = (values)=>$c8986a6d4d679671$export$663c7831528c984b(values);
const $c8986a6d4d679671$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$fabec4aebba3f4df),
        values: values,
        position: position,
        accept: $c8986a6d4d679671$var$acceptListOperand,
        enterNode: $c8986a6d4d679671$var$enterNode,
        exitNode: $c8986a6d4d679671$var$exitNode,
        getChildren: $c8986a6d4d679671$var$getChildren,
        parent: null,
        appendOperand: $7IFnF.appendOperand
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("7IFnF", function(module, exports) {

$parcel$export(module.exports, "appendOperand", () => $f8f36eb1e6c645ee$export$d94c54f1aee177c4);


var $8vd0B = parcelRequire("8vd0B");
function $f8f36eb1e6c645ee$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df) ? operand.values : [
        operand
    ]);
    (0, $8vd0B.assignParent)(this);
}

});


parcelRegister("1uxra", function(module, exports) {

$parcel$export(module.exports, "notClause", () => $1553b96d0b936df5$export$b4734a9fedb4d44e);
$parcel$export(module.exports, "notClauseInternal", () => $1553b96d0b936df5$export$b25621824fea4548);


var $3nho4 = parcelRequire("3nho4");

var $8vd0B = parcelRequire("8vd0B");

var $5eoHT = parcelRequire("5eoHT");
function $1553b96d0b936df5$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $1553b96d0b936df5$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $1553b96d0b936df5$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $1553b96d0b936df5$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $1553b96d0b936df5$export$b4734a9fedb4d44e = (clause)=>{
    return $1553b96d0b936df5$export$b25621824fea4548(clause, (0, $5eoHT.notClauseOperator)());
};
const $1553b96d0b936df5$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$2d205682cc545947),
        clauseType: (0, $35634e4e5a46f5ae$export$e356b89f8c8d2fcb),
        clause: clause,
        operator: operator,
        position: position,
        accept: $1553b96d0b936df5$var$acceptNotClause,
        enterNode: $1553b96d0b936df5$var$enterNode,
        exitNode: $1553b96d0b936df5$var$exitNode,
        getChildren: $1553b96d0b936df5$var$getChildren,
        parent: null,
        remove: $3nho4.remove,
        removeClause: $3nho4.removeClause,
        replace: $3nho4.replace,
        replaceClause: $3nho4.replaceClause
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("3nho4", function(module, exports) {

$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $8vd0B = parcelRequire("8vd0B");
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $8vd0B.assignParent)(this);
    }
}

});

parcelRegister("5eoHT", function(module, exports) {

$parcel$export(module.exports, "notClauseOperator", () => $f538dc12d855c47e$export$d2cd8239f99c13d3);
$parcel$export(module.exports, "notClauseOperatorInternal", () => $f538dc12d855c47e$export$1b15a32bb57b9020);

var $k85ht = parcelRequire("k85ht");

var $8vd0B = parcelRequire("8vd0B");
function $f538dc12d855c47e$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $f538dc12d855c47e$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $f538dc12d855c47e$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $f538dc12d855c47e$export$d2cd8239f99c13d3 = ()=>$f538dc12d855c47e$export$1b15a32bb57b9020();
const $f538dc12d855c47e$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $k85ht.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $f538dc12d855c47e$var$acceptNotClauseOperator,
        enterNode: $f538dc12d855c47e$var$enterNode,
        exitNode: $f538dc12d855c47e$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});
parcelRegister("k85ht", function(module, exports) {

$parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", () => $e007b5b5543cc378$export$c6c71ceedb15cda9);
$parcel$export(module.exports, "OPERATOR_EQUALS", () => $e007b5b5543cc378$export$466517a888d00195);
$parcel$export(module.exports, "OPERATOR_NOT_EQUALS", () => $e007b5b5543cc378$export$6d0d8810623974a5);
$parcel$export(module.exports, "OPERATOR_GT", () => $e007b5b5543cc378$export$bcbb090ab3c498b3);
$parcel$export(module.exports, "OPERATOR_LT", () => $e007b5b5543cc378$export$4bf1a4aa659c6ea4);
$parcel$export(module.exports, "OPERATOR_GT_EQUALS", () => $e007b5b5543cc378$export$83ce674214a54b2a);
$parcel$export(module.exports, "OPERATOR_LT_EQUALS", () => $e007b5b5543cc378$export$9629fd1727ef62ee);
$parcel$export(module.exports, "OPERATOR_IN", () => $e007b5b5543cc378$export$c4e3fb55e320e979);
$parcel$export(module.exports, "OPERATOR_NOT_IN", () => $e007b5b5543cc378$export$f9857532eaa24ddc);
$parcel$export(module.exports, "OPERATOR_LIKE", () => $e007b5b5543cc378$export$221595834b8766ab);
$parcel$export(module.exports, "OPERATOR_NOT_LIKE", () => $e007b5b5543cc378$export$fcefabf94a9bffbf);
$parcel$export(module.exports, "OPERATOR_IS", () => $e007b5b5543cc378$export$4feeb3f4ff56bcef);
$parcel$export(module.exports, "OPERATOR_IS_NOT", () => $e007b5b5543cc378$export$d08d969a0da27188);
$parcel$export(module.exports, "OPERATOR_WAS", () => $e007b5b5543cc378$export$8f907e179985256d);
$parcel$export(module.exports, "OPERATOR_WAS_IN", () => $e007b5b5543cc378$export$cc7b9d0b3ee23193);
$parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", () => $e007b5b5543cc378$export$585d3c004af078bb);
$parcel$export(module.exports, "OPERATOR_WAS_NOT", () => $e007b5b5543cc378$export$123eaa9ccc2d9445);
$parcel$export(module.exports, "OPERATOR_CHANGED", () => $e007b5b5543cc378$export$15f5b446ba8c941e);
$parcel$export(module.exports, "EQUALS_OPERATORS", () => $e007b5b5543cc378$export$643c6101f3fc8547);
$parcel$export(module.exports, "LIKE_OPERATORS", () => $e007b5b5543cc378$export$329664c9cf18cca6);
$parcel$export(module.exports, "COMPARISON_OPERATORS", () => $e007b5b5543cc378$export$1b167a3705885a8b);
$parcel$export(module.exports, "IN_OPERATORS", () => $e007b5b5543cc378$export$f25cf16c2270312f);
$parcel$export(module.exports, "IS_OPERATORS", () => $e007b5b5543cc378$export$eb58cfffe4a6b805);
$parcel$export(module.exports, "WAS_OPERATORS", () => $e007b5b5543cc378$export$c22a981f581de218);
$parcel$export(module.exports, "WAS_IN_OPERATORS", () => $e007b5b5543cc378$export$6d08c4699bb75284);
$parcel$export(module.exports, "CHANGED_OPERATORS", () => $e007b5b5543cc378$export$b7dc214eef214c1c);
$parcel$export(module.exports, "OPERATORS", () => $e007b5b5543cc378$export$184799fc79ccac89);
$parcel$export(module.exports, "LIST_OPERATORS", () => $e007b5b5543cc378$export$77c793736847e030);
const $e007b5b5543cc378$export$c6c71ceedb15cda9 = 'not';
const $e007b5b5543cc378$export$466517a888d00195 = '=';
const $e007b5b5543cc378$export$6d0d8810623974a5 = '!=';
const $e007b5b5543cc378$export$bcbb090ab3c498b3 = '>';
const $e007b5b5543cc378$export$4bf1a4aa659c6ea4 = '<';
const $e007b5b5543cc378$export$83ce674214a54b2a = '>=';
const $e007b5b5543cc378$export$9629fd1727ef62ee = '<=';
const $e007b5b5543cc378$export$c4e3fb55e320e979 = 'in';
const $e007b5b5543cc378$export$f9857532eaa24ddc = 'not in';
const $e007b5b5543cc378$export$221595834b8766ab = '~';
const $e007b5b5543cc378$export$fcefabf94a9bffbf = '!~';
const $e007b5b5543cc378$export$4feeb3f4ff56bcef = 'is';
const $e007b5b5543cc378$export$d08d969a0da27188 = 'is not';
const $e007b5b5543cc378$export$8f907e179985256d = 'was';
const $e007b5b5543cc378$export$cc7b9d0b3ee23193 = 'was in';
const $e007b5b5543cc378$export$585d3c004af078bb = 'was not in';
const $e007b5b5543cc378$export$123eaa9ccc2d9445 = 'was not';
const $e007b5b5543cc378$export$15f5b446ba8c941e = 'changed';
const $e007b5b5543cc378$export$643c6101f3fc8547 = [
    $e007b5b5543cc378$export$466517a888d00195,
    $e007b5b5543cc378$export$6d0d8810623974a5
];
const $e007b5b5543cc378$export$329664c9cf18cca6 = [
    $e007b5b5543cc378$export$221595834b8766ab,
    $e007b5b5543cc378$export$fcefabf94a9bffbf
];
const $e007b5b5543cc378$export$1b167a3705885a8b = [
    $e007b5b5543cc378$export$4bf1a4aa659c6ea4,
    $e007b5b5543cc378$export$bcbb090ab3c498b3,
    $e007b5b5543cc378$export$9629fd1727ef62ee,
    $e007b5b5543cc378$export$83ce674214a54b2a
];
const $e007b5b5543cc378$export$f25cf16c2270312f = [
    $e007b5b5543cc378$export$c4e3fb55e320e979,
    $e007b5b5543cc378$export$f9857532eaa24ddc
];
const $e007b5b5543cc378$export$eb58cfffe4a6b805 = [
    $e007b5b5543cc378$export$4feeb3f4ff56bcef,
    $e007b5b5543cc378$export$d08d969a0da27188
];
const $e007b5b5543cc378$export$c22a981f581de218 = [
    $e007b5b5543cc378$export$8f907e179985256d,
    $e007b5b5543cc378$export$123eaa9ccc2d9445
];
const $e007b5b5543cc378$export$6d08c4699bb75284 = [
    $e007b5b5543cc378$export$cc7b9d0b3ee23193,
    $e007b5b5543cc378$export$585d3c004af078bb
];
const $e007b5b5543cc378$export$b7dc214eef214c1c = [
    $e007b5b5543cc378$export$15f5b446ba8c941e
];
const $e007b5b5543cc378$export$184799fc79ccac89 = [
    ...$e007b5b5543cc378$export$643c6101f3fc8547,
    ...$e007b5b5543cc378$export$329664c9cf18cca6,
    ...$e007b5b5543cc378$export$1b167a3705885a8b,
    ...$e007b5b5543cc378$export$f25cf16c2270312f,
    ...$e007b5b5543cc378$export$eb58cfffe4a6b805,
    ...$e007b5b5543cc378$export$c22a981f581de218,
    ...$e007b5b5543cc378$export$6d08c4699bb75284,
    ...$e007b5b5543cc378$export$b7dc214eef214c1c
];
const $e007b5b5543cc378$export$77c793736847e030 = [
    $e007b5b5543cc378$export$c4e3fb55e320e979,
    $e007b5b5543cc378$export$f9857532eaa24ddc,
    $e007b5b5543cc378$export$cc7b9d0b3ee23193,
    $e007b5b5543cc378$export$585d3c004af078bb
];

});



parcelRegister("3T5iU", function(module, exports) {

$parcel$export(module.exports, "operator", () => $7c07e8aa040a847b$export$dbd72860f701d4f3);
$parcel$export(module.exports, "operatorInternal", () => $7c07e8aa040a847b$export$649025bc60ab9c3b);

var $8vd0B = parcelRequire("8vd0B");
function $7c07e8aa040a847b$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $7c07e8aa040a847b$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $7c07e8aa040a847b$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $7c07e8aa040a847b$export$dbd72860f701d4f3 = (value)=>$7c07e8aa040a847b$export$649025bc60ab9c3b(value, value);
const $7c07e8aa040a847b$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $7c07e8aa040a847b$var$acceptOperator,
        enterNode: $7c07e8aa040a847b$var$enterNode,
        exitNode: $7c07e8aa040a847b$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("8Tr0t", function(module, exports) {

$parcel$export(module.exports, "orderBy", () => $c827a275c8f59b6f$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "orderByInternal", () => $c827a275c8f59b6f$export$e4eb1fa6bc8465c1);


var $1lC8l = parcelRequire("1lC8l");

var $8vd0B = parcelRequire("8vd0B");

var $i2yZF = parcelRequire("i2yZF");
function $c827a275c8f59b6f$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $c827a275c8f59b6f$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $c827a275c8f59b6f$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $c827a275c8f59b6f$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $c827a275c8f59b6f$export$f18af21d6f4dafd8 = (fields)=>{
    return $c827a275c8f59b6f$export$e4eb1fa6bc8465c1(fields, (0, $i2yZF.orderByOperator)());
};
const $c827a275c8f59b6f$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$da0f73edded4a63d),
        operator: operator,
        fields: fields,
        position: position,
        accept: $c827a275c8f59b6f$var$acceptOrderBy,
        enterNode: $c827a275c8f59b6f$var$enterNode,
        exitNode: $c827a275c8f59b6f$var$exitNode,
        getChildren: $c827a275c8f59b6f$var$getChildren,
        parent: null,
        prependOrderField: $1lC8l.prependOrderField,
        setOrderDirection: $1lC8l.setOrderDirection,
        replace: $1lC8l.replace,
        replaceOrderField: $1lC8l.replaceOrderField,
        remove: $1lC8l.remove,
        removeOrderField: $1lC8l.removeOrderField
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("1lC8l", function(module, exports) {

$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $8vd0B = parcelRequire("8vd0B");
function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $8vd0B.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $8vd0B.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("i2yZF", function(module, exports) {

$parcel$export(module.exports, "orderByOperator", () => $fa7d19490b4ecf54$export$c7307b67924c61ea);
$parcel$export(module.exports, "orderByOperatorInternal", () => $fa7d19490b4ecf54$export$739e30af23a08da0);


var $8vd0B = parcelRequire("8vd0B");
function $fa7d19490b4ecf54$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $fa7d19490b4ecf54$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $fa7d19490b4ecf54$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $fa7d19490b4ecf54$export$c7307b67924c61ea = ()=>$fa7d19490b4ecf54$export$739e30af23a08da0();
const $fa7d19490b4ecf54$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $e28fa7cc527af49f$export$ca51f5fd60a74517),
        position: position,
        accept: $fa7d19490b4ecf54$var$acceptOrderByOperator,
        enterNode: $fa7d19490b4ecf54$var$enterNode,
        exitNode: $fa7d19490b4ecf54$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});
const $e28fa7cc527af49f$export$ca51f5fd60a74517 = 'ORDER BY';
const $e28fa7cc527af49f$export$6d60017b9e092e73 = 'ASC';
const $e28fa7cc527af49f$export$2ea27ea5f2121899 = 'DESC';



parcelRegister("1R1xk", function(module, exports) {

$parcel$export(module.exports, "orderByDirection", () => $21aa5b2783962a5d$export$864d934efed3ccaa);
$parcel$export(module.exports, "orderByDirectionInternal", () => $21aa5b2783962a5d$export$8c65cac1a7852d1f);

var $8vd0B = parcelRequire("8vd0B");
function $21aa5b2783962a5d$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $21aa5b2783962a5d$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $21aa5b2783962a5d$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $21aa5b2783962a5d$export$864d934efed3ccaa = (value)=>$21aa5b2783962a5d$export$8c65cac1a7852d1f(value);
const $21aa5b2783962a5d$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $21aa5b2783962a5d$var$acceptOrderByDirection,
        enterNode: $21aa5b2783962a5d$var$enterNode,
        exitNode: $21aa5b2783962a5d$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("eHzms", function(module, exports) {

$parcel$export(module.exports, "orderByField", () => $d06d39ae8044bfe9$export$942df63e5e3d3899);
$parcel$export(module.exports, "orderByFieldInternal", () => $d06d39ae8044bfe9$export$661a7786e3d15926);

var $7dx7z = parcelRequire("7dx7z");

var $8vd0B = parcelRequire("8vd0B");
function $d06d39ae8044bfe9$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $d06d39ae8044bfe9$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $d06d39ae8044bfe9$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $d06d39ae8044bfe9$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $d06d39ae8044bfe9$export$942df63e5e3d3899 = (field, direction)=>$d06d39ae8044bfe9$export$661a7786e3d15926(field, direction);
const $d06d39ae8044bfe9$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $d06d39ae8044bfe9$var$acceptOrderByField,
        enterNode: $d06d39ae8044bfe9$var$enterNode,
        exitNode: $d06d39ae8044bfe9$var$exitNode,
        getChildren: $d06d39ae8044bfe9$var$getChildren,
        parent: null,
        setOrderDirection: $7dx7z.setOrderDirection,
        replace: $7dx7z.replace,
        remove: $7dx7z.remove
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("7dx7z", function(module, exports) {

$parcel$export(module.exports, "setOrderDirection", () => $6807a3abf64eb81e$export$b596730931a09703);
$parcel$export(module.exports, "replace", () => $6807a3abf64eb81e$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "remove", () => $6807a3abf64eb81e$export$cd7f480d6b8286c3);

var $8vd0B = parcelRequire("8vd0B");
function $6807a3abf64eb81e$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $8vd0B.assignParent)(this);
}
function $6807a3abf64eb81e$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $6807a3abf64eb81e$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}

});


parcelRegister("3fSGD", function(module, exports) {

$parcel$export(module.exports, "predicate", () => $462e396b7fd5655b$export$5fc51e445ce24faf);
$parcel$export(module.exports, "predicateInternal", () => $462e396b7fd5655b$export$a767a27ad05a38a2);

var $8vd0B = parcelRequire("8vd0B");
function $462e396b7fd5655b$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $462e396b7fd5655b$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $462e396b7fd5655b$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $462e396b7fd5655b$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $462e396b7fd5655b$export$5fc51e445ce24faf = (operator, operand)=>$462e396b7fd5655b$export$a767a27ad05a38a2(operator, operand);
const $462e396b7fd5655b$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $462e396b7fd5655b$var$acceptPredicate,
        enterNode: $462e396b7fd5655b$var$enterNode,
        exitNode: $462e396b7fd5655b$var$exitNode,
        getChildren: $462e396b7fd5655b$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});

parcelRegister("jvsC0", function(module, exports) {

$parcel$export(module.exports, "predicateOperator", () => $887e537fbec545f7$export$5419b7f16910ea62);
$parcel$export(module.exports, "predicateOperatorInternal", () => $887e537fbec545f7$export$c69d893689716768);

var $8vd0B = parcelRequire("8vd0B");
function $887e537fbec545f7$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $887e537fbec545f7$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $887e537fbec545f7$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $887e537fbec545f7$export$5419b7f16910ea62 = (value)=>$887e537fbec545f7$export$c69d893689716768(value, value);
const $887e537fbec545f7$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $887e537fbec545f7$var$acceptPredicateOperator,
        enterNode: $887e537fbec545f7$var$enterNode,
        exitNode: $887e537fbec545f7$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("bdP2p", function(module, exports) {

$parcel$export(module.exports, "property", () => $f08fc38c9f10e3ce$export$d541bacb2bda4494);
$parcel$export(module.exports, "propertyInternal", () => $f08fc38c9f10e3ce$export$1cbd90994fef1fad);

var $8vd0B = parcelRequire("8vd0B");
function $f08fc38c9f10e3ce$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $f08fc38c9f10e3ce$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $f08fc38c9f10e3ce$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $f08fc38c9f10e3ce$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $f08fc38c9f10e3ce$export$d541bacb2bda4494 = (key, path = [])=>$f08fc38c9f10e3ce$export$1cbd90994fef1fad(key, path);
const $f08fc38c9f10e3ce$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $f08fc38c9f10e3ce$var$acceptProperty,
        enterNode: $f08fc38c9f10e3ce$var$enterNode,
        exitNode: $f08fc38c9f10e3ce$var$exitNode,
        getChildren: $f08fc38c9f10e3ce$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});

parcelRegister("1Rz9E", function(module, exports) {

$parcel$export(module.exports, "query", () => $107f0c7ef22c6060$export$2fa187e846a241c4);
$parcel$export(module.exports, "queryInternal", () => $107f0c7ef22c6060$export$bc2d6e2e1fd9014);


var $kqYul = parcelRequire("kqYul");

var $8vd0B = parcelRequire("8vd0B");
/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $107f0c7ef22c6060$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $107f0c7ef22c6060$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $107f0c7ef22c6060$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $107f0c7ef22c6060$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $107f0c7ef22c6060$export$2fa187e846a241c4 = (where, orderBy)=>$107f0c7ef22c6060$export$bc2d6e2e1fd9014(where, orderBy);
const $107f0c7ef22c6060$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$98dda21ec825792),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $107f0c7ef22c6060$var$acceptQuery,
        enterNode: $107f0c7ef22c6060$var$enterNode,
        exitNode: $107f0c7ef22c6060$var$exitNode,
        getChildren: $107f0c7ef22c6060$var$getChildren,
        parent: null,
        appendClause: $kqYul.appendClause,
        prependOrderField: $kqYul.prependOrderField,
        setOrderDirection: $kqYul.setOrderDirection,
        removeClause: $kqYul.removeClause,
        replaceClause: $kqYul.replaceClause,
        replaceOrderBy: $kqYul.replaceOrderBy,
        removeOrderBy: $kqYul.removeOrderBy
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("kqYul", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $ehDeP = parcelRequire("ehDeP");

var $8vd0B = parcelRequire("8vd0B");
function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $ehDeP.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $ehDeP.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $8vd0B.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $ehDeP.default).orderBy([
            orderField
        ]);
        (0, $8vd0B.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $8vd0B.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $8vd0B.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});


parcelRegister("5o1cq", function(module, exports) {

$parcel$export(module.exports, "terminalClause", () => $ca791fbc90fc759d$export$2627cbe08dd86b00);
$parcel$export(module.exports, "terminalClauseInternal", () => $ca791fbc90fc759d$export$cc08e43598d091fc);


var $iKO2u = parcelRequire("iKO2u");

var $8vd0B = parcelRequire("8vd0B");
function $ca791fbc90fc759d$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $ca791fbc90fc759d$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $ca791fbc90fc759d$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $ca791fbc90fc759d$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $ca791fbc90fc759d$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $ca791fbc90fc759d$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $ca791fbc90fc759d$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$2d205682cc545947),
        clauseType: (0, $35634e4e5a46f5ae$export$ae56b4ef248a2b6a),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $ca791fbc90fc759d$var$acceptTerminalClause,
        enterNode: $ca791fbc90fc759d$var$enterNode,
        exitNode: $ca791fbc90fc759d$var$exitNode,
        getChildren: $ca791fbc90fc759d$var$getChildren,
        parent: null,
        setOperator: $iKO2u.setOperator,
        setOperand: $iKO2u.setOperand,
        appendOperand: $iKO2u.appendOperand,
        remove: $iKO2u.remove,
        replace: $iKO2u.replace
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("iKO2u", function(module, exports) {

$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);


var $ehDeP = parcelRequire("ehDeP");

var $8vd0B = parcelRequire("8vd0B");
function setOperator(operator) {
    this.operator = operator;
    (0, $8vd0B.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $8vd0B.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
        else this.setOperand((0, $ehDeP.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});


parcelRegister("4VxAa", function(module, exports) {

$parcel$export(module.exports, "valueOperand", () => $097471b9dc7f0edf$export$2b6e4d2ed8d53bf3);
$parcel$export(module.exports, "valueOperandInternal", () => $097471b9dc7f0edf$export$79c37d97caac8627);
$parcel$export(module.exports, "valueOperandByText", () => $097471b9dc7f0edf$export$3ac9155bde56a45f);


var $g2nfy = parcelRequire("g2nfy");
var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $097471b9dc7f0edf$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $097471b9dc7f0edf$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $097471b9dc7f0edf$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $097471b9dc7f0edf$export$2b6e4d2ed8d53bf3 = (value)=>$097471b9dc7f0edf$export$79c37d97caac8627(value, (0, $tI64Y.sanitiseJqlString)(value));
const $097471b9dc7f0edf$export$3ac9155bde56a45f = (text)=>$097471b9dc7f0edf$export$79c37d97caac8627((0, $g2nfy.normaliseJqlString)(text), text);
const $097471b9dc7f0edf$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$38accfc5a5d1c113),
        text: text,
        value: value,
        position: position,
        accept: $097471b9dc7f0edf$var$acceptValueOperand,
        enterNode: $097471b9dc7f0edf$var$enterNode,
        exitNode: $097471b9dc7f0edf$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});


parcelRegister("lmIUR", function(module, exports) {

$parcel$export(module.exports, "print", () => $a9625f5ea61b2ada$export$c2d084dc44961371);

var $8dloj = parcelRequire("8dloj");

var $8VPLp = parcelRequire("8VPLp");

var $gGtGU = parcelRequire("gGtGU");
const $a9625f5ea61b2ada$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $gGtGU.printDocToString)((0, $8VPLp.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("8VPLp", function(module, exports) {

$parcel$export(module.exports, "printAstToDoc", () => $d301c3605dc18477$export$f0ef38932978952);


var $6RWCB = parcelRequire("6RWCB");

var $6l51o = parcelRequire("6l51o");
const $d301c3605dc18477$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $d301c3605dc18477$export$27a275559a5c8102 extends (0, $6RWCB.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $6l51o.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $d301c3605dc18477$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $6l51o.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $6l51o.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $6l51o.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $d301c3605dc18477$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $6l51o.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $d301c3605dc18477$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $d301c3605dc18477$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $6l51o.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $6l51o.group)([
            query.where.accept(this),
            (0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $6l51o.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $6l51o.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $d301c3605dc18477$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $d301c3605dc18477$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
parcelRegister("6RWCB", function(module, exports) {

$parcel$export(module.exports, "AbstractJastVisitor", () => $17ed1e3c7a9e2333$export$51be62b46ee668fd);
class $17ed1e3c7a9e2333$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(node, currentResult) {
        return true;
    }
}

});

parcelRegister("6l51o", function(module, exports) {

$parcel$export(module.exports, "group", () => $505bf572d8c2f20e$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $505bf572d8c2f20e$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $505bf572d8c2f20e$export$dc84f6841f96b7da);
const $505bf572d8c2f20e$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $505bf572d8c2f20e$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $505bf572d8c2f20e$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("gGtGU", function(module, exports) {

$parcel$export(module.exports, "printDocToString", () => $1adbb8b7e9dc2aa6$export$316fc7e94b95b118);
const $1adbb8b7e9dc2aa6$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $1adbb8b7e9dc2aa6$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$printGroup(doc, context);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$printIfBreak(doc, context);
        case 'new-line':
            return $1adbb8b7e9dc2aa6$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $1adbb8b7e9dc2aa6$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $1adbb8b7e9dc2aa6$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $1adbb8b7e9dc2aa6$var$printDoc(doc.breakContents, context);
    return $1adbb8b7e9dc2aa6$var$printDoc(doc.flatContents, context);
};
const $1adbb8b7e9dc2aa6$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $1adbb8b7e9dc2aa6$var$defaultPrintWidth = 100;
const $1adbb8b7e9dc2aa6$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $1adbb8b7e9dc2aa6$var$defaultPrintWidth } = options;
    const output = $1adbb8b7e9dc2aa6$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});


parcelRegister("dG4cR", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID", () => $36a0671262b022c0$export$6e40821019289c70);
$parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$d6ceedee35ae2c19);
$parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$ca3691ea47eec823);
$parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$2a5fce320f18ac6c);
$parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$b0ec8deb6068dc3b);
$parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$6c99c87a0ac0052a);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $36a0671262b022c0$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", () => $36a0671262b022c0$export$9b72011e2eb8d7d0);
const $36a0671262b022c0$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
const $36a0671262b022c0$export$6e40821019289c70 = 'optimistic-filter-id';
const $36a0671262b022c0$export$d6ceedee35ae2c19 = {
    experience: 'filtersCreateSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$ca3691ea47eec823 = {
    experience: 'filtersUpdateSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$2a5fce320f18ac6c = {
    experience: 'filtersDeleteSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$b0ec8deb6068dc3b = {
    experience: 'filtersStarSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$6c99c87a0ac0052a = {
    experience: 'filtersLoadSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$9ebaf9fe814731d3 = null;
const $36a0671262b022c0$export$9b72011e2eb8d7d0 = 'text';

});



parcelRegister("96etS", function(module, exports) {

$parcel$export(module.exports, "useSimpleSearch", () => $70f3d6a365372dbd$export$b549f44e7ca96280);
$parcel$export(module.exports, "useSimpleSearchHighlight", () => $70f3d6a365372dbd$export$fd04dfca01137d2);
$parcel$export(module.exports, "useSearchText", () => $70f3d6a365372dbd$export$119186efd4186c93);
$parcel$export(module.exports, "useSimpleSearchJQL", () => $70f3d6a365372dbd$export$42b8d8a5ec5bc873);

var $eUqFw = parcelRequire("eUqFw");

var $6GXx9 = parcelRequire("6GXx9");

var $lB25E = parcelRequire("lB25E");

var $dG4cR = parcelRequire("dG4cR");
const $70f3d6a365372dbd$var$sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
const $70f3d6a365372dbd$var$issueKeyRegex = new RegExp(`^${(0, $6GXx9.ISSUEKEY_REGEX)}$`);
const $70f3d6a365372dbd$var$japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
const $70f3d6a365372dbd$export$b549f44e7ca96280 = ()=>{
    const [simpleSearch, persistSimpleSearch] = (0, $lB25E.useQueryParam)((0, $dG4cR.SIMPLE_SEARCH_PARAM));
    const setSimpleSearch = (0, $eUqFw.useCallback)((searchText)=>{
        searchText != null && searchText.trim() !== '' ? persistSimpleSearch(searchText) : persistSimpleSearch(undefined);
    }, [
        persistSimpleSearch
    ]);
    return [
        simpleSearch ?? '',
        setSimpleSearch
    ];
};
const $70f3d6a365372dbd$export$72839f749ccf76b2 = (text)=>{
    if (text == null) return [];
    return text.split(' ').filter((word)=>word !== '');
};
const $70f3d6a365372dbd$export$fd04dfca01137d2 = ()=>{
    const [simpleSearch] = $70f3d6a365372dbd$export$b549f44e7ca96280();
    return (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$72839f749ccf76b2(simpleSearch), [
        simpleSearch
    ]);
};
const $70f3d6a365372dbd$export$abb78553baf1cfac = (text)=>{
    if (text == null || text.trim() === '') return '';
    let search = $70f3d6a365372dbd$var$sanitize(text);
    if ($70f3d6a365372dbd$var$issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!$70f3d6a365372dbd$var$japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $70f3d6a365372dbd$export$119186efd4186c93 = (text)=>{
    const jql = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$abb78553baf1cfac(text), [
        text
    ]);
    const highlight = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$72839f749ccf76b2(text), [
        text
    ]);
    return {
        jql: jql,
        highlight: highlight
    };
};
const $70f3d6a365372dbd$export$42b8d8a5ec5bc873 = ()=>{
    const [simpleSearch] = $70f3d6a365372dbd$export$b549f44e7ca96280();
    const jql = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$abb78553baf1cfac(simpleSearch), [
        simpleSearch
    ]);
    const addSimpleSearchToJQL = (0, $eUqFw.useCallback)((currentJQL)=>{
        if (jql === '') return currentJQL;
        if (currentJQL == null) return jql;
        return `${currentJQL} AND ${jql}`;
    }, [
        jql
    ]);
    return {
        jql: jql,
        isSearching: jql !== '',
        addSimpleSearchToJQL: addSimpleSearchToJQL
    };
};
var $70f3d6a365372dbd$export$2e2bcd8739ae039 = $70f3d6a365372dbd$export$b549f44e7ca96280;

});
parcelRegister("6GXx9", function(module, exports) {

$parcel$export(module.exports, "ISSUEKEY_REGEX", () => $2bd12f0fe8e9dce1$export$b52c9cee589449a8);
$parcel$export(module.exports, "default", () => $2bd12f0fe8e9dce1$export$2e2bcd8739ae039);

var $k4nIh = parcelRequire("k4nIh");
const $2bd12f0fe8e9dce1$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
var /**
 * Returns the issue key if the URL is a valid full page Jira issue URL. It may also include a trailing
 * hash fragment. A matching URL must look like:
 * <host><baseurl>/browse/<issuekey><#hash?>
 * e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bd12f0fe8e9dce1$export$2e2bcd8739ae039 = (url, host)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {});
    const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    const isMatchingHost = parsedUrl.host === host;
    const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$2bd12f0fe8e9dce1$export$b52c9cee589449a8}\\/?$`));
    const issueKey = matches && matches.length > 1 ? matches[1] : null;
    return isMatchingProtocol && isMatchingHost && issueKey || null;
};

});


parcelRegister("jQFcD", function(module, exports) {

$parcel$export(module.exports, "sanitiseJql", () => $fea50252d29e77ce$export$78c9a06ab18996fc);
$parcel$export(module.exports, "getJqlErrors", () => $fea50252d29e77ce$export$cc387523b0acb16d);

var $bXcc5 = parcelRequire("bXcc5");
var $lmIUR = parcelRequire("lmIUR");
const $fea50252d29e77ce$export$78c9a06ab18996fc = (jql)=>{
    if (!jql) return jql;
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query && jast.query.orderBy) jast.query.orderBy = undefined;
    return (0, $lmIUR.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $fea50252d29e77ce$export$cc387523b0acb16d = (jql)=>{
    if (!jql) return [];
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    return jast.errors;
};

});
parcelRegister("bXcc5", function(module, exports) {

$parcel$export(module.exports, "JastBuilder", () => $eca1e117b7087a1d$export$99cae18a5a6ba8cf);

var $9pfFs = parcelRequire("9pfFs");

var $5iWql = parcelRequire("5iWql");

var $8YcxO = parcelRequire("8YcxO");
var $c35D3 = parcelRequire("c35D3");

var $ehDeP = parcelRequire("ehDeP");

var $9I5Iz = parcelRequire("9I5Iz");
var $16oBX = parcelRequire("16oBX");

var $icZEp = parcelRequire("icZEp");
class $eca1e117b7087a1d$export$99cae18a5a6ba8cf {
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new (0, $9I5Iz.JastBuilderErrorListener)();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
            this.errorHandler.reset(parser);
        }
        const visitor = new (0, $icZEp.QueryVisitor)(tokens);
        try {
            const parseTree = parser.jqlQuery();
            const query = parseTree.accept(visitor);
            return (0, $ehDeP.default).jast(query, value, astErrorListener.errors);
        } catch (error) {
            return (0, $ehDeP.default).jast(undefined, value, [
                new (0, $16oBX.JQLParseError)(error.message, error)
            ]);
        }
    }
    constructor(){
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = (0, $5iWql.default)((value)=>{
            const chars = (0, $9pfFs.CharStreams).fromString(value);
            const lexer = new (0, $8YcxO.JQLLexer)(chars);
            return new (0, $9pfFs.CommonTokenStream)(lexer);
        });
        this.getParser = (0, $5iWql.default)((tokens)=>new (0, $c35D3.JQLParser)(tokens));
    }
}

});
parcelRegister("9pfFs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6d929a23f22266a3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6d929a23f22266a3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6d929a23f22266a3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6d929a23f22266a3$var$__exportStar((parcelRequire("5oG2w")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("gO8Xw")), module.exports);

// export * from "./ANTLRFileStream";
$6d929a23f22266a3$var$__exportStar((parcelRequire("eZYsJ")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("csTA1")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("doEv1")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("aUhGF")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("8tY30")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("cNEtm")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("1EXcP")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("exlin")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("9hrXh")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("eCP5Y")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("eEgBk")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("3HZil")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("9xPUt")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("67k7F")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("2quiJ")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("5jZSY")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("jo2Zj")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("ldi9e")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("h7Q3L")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hVliW")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("l3IpB")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("c8NTK")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("iAlWg")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("c9Sjf")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("5n08Y")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("8rZl7")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("2pDMz")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("3Wiwr")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("jdbdJ")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("b7PPe")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("dwftT")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("1xO0Q")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("atcwe")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("3d5Fu")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hHHux")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("eKXi4")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("lL3Js")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("03lZa")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("b3QEj")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hwMU6")), module.exports);

// export * from "./UnbufferedCharStream";
// export * from "./UnbufferedTokenStream";
$6d929a23f22266a3$var$__exportStar((parcelRequire("2YAkU")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hBnE1")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("edl4x")), module.exports);

});
parcelRegister("5oG2w", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gO8Xw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eZYsJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ // ConvertTo-TS run at 2016-10-04T11:26:49.0828748-07:00
var $aeb5a9c9d3e1e2dc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANTLRInputStream = void 0;

var $fomfP = parcelRequire("fomfP");

var $aN41m = parcelRequire("aN41m");

var $ldi9e = parcelRequire("ldi9e");
const $aeb5a9c9d3e1e2dc$var$READ_BUFFER_SIZE = 1024;
const $aeb5a9c9d3e1e2dc$var$INITIAL_BUFFER_SIZE = 1024;
/**
 * Vacuum all input from a {@link Reader}/{@link InputStream} and then treat it
 * like a `char[]` buffer. Can also pass in a {@link String} or
 * `char[]` to use.
 *
 * If you need encoding, pass in stream/reader with correct encoding.
 *
 * @deprecated as of 4.7, please use `CharStreams` interface.
 */ class $aeb5a9c9d3e1e2dc$var$ANTLRInputStream {
    /** Copy data in string to a local char array */ constructor(input){
        /** 0..n-1 index into string of next char */ this.p = 0;
        this.data = input;
        this.n = input.length;
    }
    /** Reset the stream so that it's in the same state it was
     *  when the object was created *except* the data array is not
     *  touched.
     */ reset() {
        this.p = 0;
    }
    consume() {
        if (this.p >= this.n) {
            $fomfP(this.LA(1) === $ldi9e.IntStream.EOF);
            throw new Error("cannot consume EOF");
        }
        //System.out.println("prev p="+p+", c="+(char)data[p]);
        if (this.p < this.n) this.p++;
    }
    LA(i) {
        if (i === 0) return 0; // undefined
        if (i < 0) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
            if (this.p + i - 1 < 0) return $ldi9e.IntStream.EOF; // invalid; no char before first char
        }
        if (this.p + i - 1 >= this.n) //System.out.println("char LA("+i+")=EOF; p="+p);
        return $ldi9e.IntStream.EOF;
        //System.out.println("char LA("+i+")="+(char)data[p+i-1]+"; p="+p);
        //System.out.println("LA("+i+"); p="+p+" n="+n+" data.length="+data.length);
        return this.data.charCodeAt(this.p + i - 1);
    }
    LT(i) {
        return this.LA(i);
    }
    /** Return the current input symbol index 0..n where n indicates the
     *  last symbol has been read.  The index is the index of char to
     *  be returned from LA(1).
     */ get index() {
        return this.p;
    }
    get size() {
        return this.n;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    /** consume() ahead until p==index; can't just set p=index as we must
     *  update line and charPositionInLine. If we seek backwards, just set p
     */ seek(index) {
        if (index <= this.p) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index or n (whichever comes first)
        index = Math.min(index, this.n);
        while(this.p < index)this.consume();
    }
    getText(interval) {
        let start = interval.a;
        let stop = interval.b;
        if (stop >= this.n) stop = this.n - 1;
        let count = stop - start + 1;
        if (start >= this.n) return "";
        // System.err.println("data: "+Arrays.toString(data)+", n="+n+
        // 				   ", start="+start+
        // 				   ", stop="+stop);
        return this.data.substr(start, count);
    }
    get sourceName() {
        if (!this.name) return $ldi9e.IntStream.UNKNOWN_SOURCE_NAME;
        return this.name;
    }
    toString() {
        return this.data;
    }
}
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "consume", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "LA", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "index", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "size", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "mark", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "release", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "seek", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "getText", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "sourceName", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "toString", null);
module.exports.ANTLRInputStream = $aeb5a9c9d3e1e2dc$var$ANTLRInputStream;

});
parcelRegister("fomfP", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
function $b34a5c254ce73537$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b34a5c254ce73537$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b34a5c254ce73537$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b34a5c254ce73537$var$_typeof(obj);
}
function $b34a5c254ce73537$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $5xQQM = parcelRequire("5xQQM");
var $b34a5c254ce73537$var$_require$codes = $5xQQM.codes, $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT = $b34a5c254ce73537$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_ARG_TYPE, $b34a5c254ce73537$var$ERR_INVALID_ARG_VALUE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_ARG_VALUE, $b34a5c254ce73537$var$ERR_INVALID_RETURN_VALUE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_RETURN_VALUE, $b34a5c254ce73537$var$ERR_MISSING_ARGS = $b34a5c254ce73537$var$_require$codes.ERR_MISSING_ARGS;

var $4ZhvB = parcelRequire("4ZhvB");

var $ibOwR = parcelRequire("ibOwR");
var $b34a5c254ce73537$var$inspect = $ibOwR.inspect;

var $ibOwR = parcelRequire("ibOwR");
var $b34a5c254ce73537$require$_require$types = $ibOwR.types;
var $b34a5c254ce73537$var$isPromise = $b34a5c254ce73537$require$_require$types.isPromise, $b34a5c254ce73537$var$isRegExp = $b34a5c254ce73537$require$_require$types.isRegExp;

var $b34a5c254ce73537$var$objectAssign = Object.assign ? Object.assign : (parcelRequire("hQCs4")).assign;

var $b34a5c254ce73537$var$objectIs = Object.is ? Object.is : (parcelRequire("4BFNJ"));
var $b34a5c254ce73537$var$errorCache = new Map();
var $b34a5c254ce73537$var$isDeepEqual;
var $b34a5c254ce73537$var$isDeepStrictEqual;
var $b34a5c254ce73537$var$parseExpressionAt;
var $b34a5c254ce73537$var$findNodeAround;
var $b34a5c254ce73537$var$decoder;

function $b34a5c254ce73537$var$lazyLoadComparison() {
    var comparison = (parcelRequire("55ouo"));
    $b34a5c254ce73537$var$isDeepEqual = comparison.isDeepEqual;
    $b34a5c254ce73537$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $b34a5c254ce73537$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $b34a5c254ce73537$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $b34a5c254ce73537$var$escapeFn = function escapeFn(str) {
    return $b34a5c254ce73537$var$meta[str.charCodeAt(0)];
};
var $b34a5c254ce73537$var$warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $b34a5c254ce73537$var$assert = module.exports = $b34a5c254ce73537$var$ok;
var $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $b34a5c254ce73537$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $4ZhvB(obj);
}
function $b34a5c254ce73537$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($b34a5c254ce73537$var$warned === false) {
            $b34a5c254ce73537$var$warned = true;
            var warn = $2fFJv.emitWarning ? $2fFJv.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $b34a5c254ce73537$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $4ZhvB(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$b34a5c254ce73537$var$assert.fail = $b34a5c254ce73537$var$fail; // The AssertionError is defined in internal/error.
$b34a5c254ce73537$var$assert.AssertionError = $4ZhvB;
function $b34a5c254ce73537$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $4ZhvB({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $b34a5c254ce73537$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $b34a5c254ce73537$var$innerOk.apply(void 0, [
        $b34a5c254ce73537$var$ok,
        args.length
    ].concat(args));
}
$b34a5c254ce73537$var$assert.ok = $b34a5c254ce73537$var$ok; // The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $b34a5c254ce73537$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
     // eslint-disable-next-line eqeqeq
    if (actual != expected) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.
$b34a5c254ce73537$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
     // eslint-disable-next-line eqeqeq
    if (actual == expected) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
}; // The equivalence assertion tests a deep equality relation.
$b34a5c254ce73537$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if (!$b34a5c254ce73537$var$isDeepEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
}; // The non-equivalence assertion tests for any deep inequality.
$b34a5c254ce73537$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if ($b34a5c254ce73537$var$isDeepEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $b34a5c254ce73537$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if (!$b34a5c254ce73537$var$isDeepStrictEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$b34a5c254ce73537$var$assert.notDeepStrictEqual = $b34a5c254ce73537$var$notDeepStrictEqual;
function $b34a5c254ce73537$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if ($b34a5c254ce73537$var$isDeepStrictEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $b34a5c254ce73537$var$notDeepStrictEqual
    });
}
$b34a5c254ce73537$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$b34a5c254ce73537$var$objectIs(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$b34a5c254ce73537$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$objectIs(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $b34a5c254ce73537$var$Comparison = function Comparison(obj, keys, actual) {
    var _this = this;
    $b34a5c254ce73537$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $b34a5c254ce73537$var$isRegExp(obj[key]) && obj[key].test(actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
};
function $b34a5c254ce73537$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$b34a5c254ce73537$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $b34a5c254ce73537$var$Comparison(actual, keys);
            var b = new $b34a5c254ce73537$var$Comparison(expected, keys, actual);
            var err = new $4ZhvB({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $b34a5c254ce73537$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $b34a5c254ce73537$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($b34a5c254ce73537$var$isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
         // Handle primitives properly.
        if ($b34a5c254ce73537$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $4ZhvB({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $b34a5c254ce73537$var$isRegExp(expected[key]) && expected[key].test(actual[key])) return;
            $b34a5c254ce73537$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    } // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $b34a5c254ce73537$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL;
}
function $b34a5c254ce73537$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $b34a5c254ce73537$var$isPromise(obj) || obj !== null && $b34a5c254ce73537$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $b34a5c254ce73537$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn(); // Fail in case no promise is returned.
            if (!$b34a5c254ce73537$var$checkIsPromise(resultPromise)) throw new $b34a5c254ce73537$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($b34a5c254ce73537$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $b34a5c254ce73537$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($b34a5c254ce73537$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $b34a5c254ce73537$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $b34a5c254ce73537$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$b34a5c254ce73537$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $b34a5c254ce73537$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $b34a5c254ce73537$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $b34a5c254ce73537$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$b34a5c254ce73537$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $b34a5c254ce73537$var$expectsError.apply(void 0, [
        throws,
        $b34a5c254ce73537$var$getActual(promiseFn)
    ].concat(args));
};
$b34a5c254ce73537$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $b34a5c254ce73537$var$waitForActual(promiseFn).then(function(result) {
        return $b34a5c254ce73537$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$b34a5c254ce73537$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $b34a5c254ce73537$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $b34a5c254ce73537$var$getActual(fn)
    ].concat(args));
};
$b34a5c254ce73537$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $b34a5c254ce73537$var$waitForActual(fn).then(function(result) {
        return $b34a5c254ce73537$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$b34a5c254ce73537$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($b34a5c254ce73537$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $b34a5c254ce73537$var$inspect(err);
        var newErr = new $4ZhvB({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        }); // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift(); // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
}; // Expose a strict only variant of assert
function $b34a5c254ce73537$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $b34a5c254ce73537$var$innerOk.apply(void 0, [
        $b34a5c254ce73537$var$strict,
        args.length
    ].concat(args));
}
$b34a5c254ce73537$var$assert.strict = $b34a5c254ce73537$var$objectAssign($b34a5c254ce73537$var$strict, $b34a5c254ce73537$var$assert, {
    equal: $b34a5c254ce73537$var$assert.strictEqual,
    deepEqual: $b34a5c254ce73537$var$assert.deepStrictEqual,
    notEqual: $b34a5c254ce73537$var$assert.notStrictEqual,
    notDeepEqual: $b34a5c254ce73537$var$assert.notDeepStrictEqual
});
$b34a5c254ce73537$var$assert.strict.strict = $b34a5c254ce73537$var$assert.strict;

});
parcelRegister("5xQQM", function(module, exports) {

$parcel$export(module.exports, "codes", () => $409907ccfa1a83e8$export$e45cb6485273080e, (v) => $409907ccfa1a83e8$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $409907ccfa1a83e8$export$e45cb6485273080e;
'use strict'; // The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $409907ccfa1a83e8$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $409907ccfa1a83e8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $409907ccfa1a83e8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $409907ccfa1a83e8$var$_typeof(obj);
}
function $409907ccfa1a83e8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $409907ccfa1a83e8$var$_possibleConstructorReturn(self, call) {
    if (call && ($409907ccfa1a83e8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $409907ccfa1a83e8$var$_assertThisInitialized(self);
}
function $409907ccfa1a83e8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $409907ccfa1a83e8$var$_getPrototypeOf(o) {
    $409907ccfa1a83e8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $409907ccfa1a83e8$var$_getPrototypeOf(o);
}
function $409907ccfa1a83e8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $409907ccfa1a83e8$var$_setPrototypeOf(subClass, superClass);
}
function $409907ccfa1a83e8$var$_setPrototypeOf(o, p) {
    $409907ccfa1a83e8$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $409907ccfa1a83e8$var$_setPrototypeOf(o, p);
}
var $409907ccfa1a83e8$var$codes = {}; // Lazy loaded
var $409907ccfa1a83e8$var$assert;
var $409907ccfa1a83e8$var$util;
function $409907ccfa1a83e8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $409907ccfa1a83e8$var$_inherits(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $409907ccfa1a83e8$var$_classCallCheck(this, NodeError);
            _this = $409907ccfa1a83e8$var$_possibleConstructorReturn(this, $409907ccfa1a83e8$var$_getPrototypeOf(NodeError).call(this, getMessage(arg1, arg2, arg3)));
            _this.code = code;
            return _this;
        }
        return NodeError;
    }(Base);
    $409907ccfa1a83e8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $409907ccfa1a83e8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $409907ccfa1a83e8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $409907ccfa1a83e8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $409907ccfa1a83e8$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$409907ccfa1a83e8$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($409907ccfa1a83e8$var$assert === undefined) $409907ccfa1a83e8$var$assert = (parcelRequire("fomfP"));
    $409907ccfa1a83e8$var$assert(typeof name === 'string', "'name' must be a string"); // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $409907ccfa1a83e8$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($409907ccfa1a83e8$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($409907ccfa1a83e8$var$oneOf(expected, 'type'));
    else {
        var type = $409907ccfa1a83e8$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($409907ccfa1a83e8$var$oneOf(expected, 'type'));
    } // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($409907ccfa1a83e8$var$_typeof(actual));
    return msg;
}, TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($409907ccfa1a83e8$var$util === undefined) $409907ccfa1a83e8$var$util = (parcelRequire("ibOwR"));
    var inspected = $409907ccfa1a83e8$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($409907ccfa1a83e8$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($409907ccfa1a83e8$var$assert === undefined) $409907ccfa1a83e8$var$assert = (parcelRequire("fomfP"));
    $409907ccfa1a83e8$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$409907ccfa1a83e8$export$e45cb6485273080e = $409907ccfa1a83e8$var$codes;

});
parcelRegister("ibOwR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2fFJv = parcelRequire("2fFJv");
var $d3e0731ae145e11c$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $d3e0731ae145e11c$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$d3e0731ae145e11c$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($d3e0731ae145e11c$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($d3e0731ae145e11c$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($d3e0731ae145e11c$var$isNull(x) || !$d3e0731ae145e11c$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $d3e0731ae145e11c$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $2fFJv !== 'undefined' && $2fFJv.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $2fFJv === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($2fFJv.throwDeprecation) throw new Error(msg);
            else if ($2fFJv.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $d3e0731ae145e11c$var$debugs = {};
var $d3e0731ae145e11c$var$debugEnvRegex = /^$/;
var $d3e0731ae145e11c$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$d3e0731ae145e11c$var$debugs[set]) {
        if ($d3e0731ae145e11c$var$debugEnvRegex.test(set)) {
            var pid = $2fFJv.pid;
            $d3e0731ae145e11c$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $d3e0731ae145e11c$var$debugs[set] = function() {};
    }
    return $d3e0731ae145e11c$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $d3e0731ae145e11c$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $d3e0731ae145e11c$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($d3e0731ae145e11c$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($d3e0731ae145e11c$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $d3e0731ae145e11c$var$stylizeWithColor;
    return $d3e0731ae145e11c$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $d3e0731ae145e11c$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$d3e0731ae145e11c$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$d3e0731ae145e11c$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $d3e0731ae145e11c$var$stylizeWithColor(str, styleType) {
    var style = $d3e0731ae145e11c$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $d3e0731ae145e11c$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $d3e0731ae145e11c$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $d3e0731ae145e11c$var$stylizeNoColor(str, styleType) {
    return str;
}
function $d3e0731ae145e11c$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $d3e0731ae145e11c$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $d3e0731ae145e11c$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$d3e0731ae145e11c$var$isString(ret)) ret = $d3e0731ae145e11c$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $d3e0731ae145e11c$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $d3e0731ae145e11c$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($d3e0731ae145e11c$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $d3e0731ae145e11c$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($d3e0731ae145e11c$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($d3e0731ae145e11c$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($d3e0731ae145e11c$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($d3e0731ae145e11c$var$isError(value)) return $d3e0731ae145e11c$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($d3e0731ae145e11c$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($d3e0731ae145e11c$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($d3e0731ae145e11c$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($d3e0731ae145e11c$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($d3e0731ae145e11c$var$isError(value)) base = ' ' + $d3e0731ae145e11c$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($d3e0731ae145e11c$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $d3e0731ae145e11c$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $d3e0731ae145e11c$var$reduceToSingleString(output, base, braces);
}
function $d3e0731ae145e11c$var$formatPrimitive(ctx, value) {
    if ($d3e0731ae145e11c$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($d3e0731ae145e11c$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($d3e0731ae145e11c$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($d3e0731ae145e11c$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($d3e0731ae145e11c$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $d3e0731ae145e11c$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $d3e0731ae145e11c$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($d3e0731ae145e11c$var$hasOwnProperty(value, String(i))) output.push($d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$d3e0731ae145e11c$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($d3e0731ae145e11c$var$isNull(recurseTimes)) str = $d3e0731ae145e11c$var$formatValue(ctx, desc.value, null);
            else str = $d3e0731ae145e11c$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($d3e0731ae145e11c$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $d3e0731ae145e11c$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("jpjK2"));
function $d3e0731ae145e11c$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $d3e0731ae145e11c$var$isArray;
function $d3e0731ae145e11c$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $d3e0731ae145e11c$var$isBoolean;
function $d3e0731ae145e11c$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $d3e0731ae145e11c$var$isNull;
function $d3e0731ae145e11c$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $d3e0731ae145e11c$var$isNullOrUndefined;
function $d3e0731ae145e11c$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $d3e0731ae145e11c$var$isNumber;
function $d3e0731ae145e11c$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $d3e0731ae145e11c$var$isString;
function $d3e0731ae145e11c$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $d3e0731ae145e11c$var$isSymbol;
function $d3e0731ae145e11c$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $d3e0731ae145e11c$var$isUndefined;
function $d3e0731ae145e11c$var$isRegExp(re) {
    return $d3e0731ae145e11c$var$isObject(re) && $d3e0731ae145e11c$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $d3e0731ae145e11c$var$isRegExp;
module.exports.types.isRegExp = $d3e0731ae145e11c$var$isRegExp;
function $d3e0731ae145e11c$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $d3e0731ae145e11c$var$isObject;
function $d3e0731ae145e11c$var$isDate(d) {
    return $d3e0731ae145e11c$var$isObject(d) && $d3e0731ae145e11c$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $d3e0731ae145e11c$var$isDate;
module.exports.types.isDate = $d3e0731ae145e11c$var$isDate;
function $d3e0731ae145e11c$var$isError(e) {
    return $d3e0731ae145e11c$var$isObject(e) && ($d3e0731ae145e11c$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $d3e0731ae145e11c$var$isError;
module.exports.types.isNativeError = $d3e0731ae145e11c$var$isError;
function $d3e0731ae145e11c$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $d3e0731ae145e11c$var$isFunction;
function $d3e0731ae145e11c$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $d3e0731ae145e11c$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("fDPIL"));
function $d3e0731ae145e11c$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $d3e0731ae145e11c$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $d3e0731ae145e11c$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $d3e0731ae145e11c$var$timestamp() {
    var d = new Date();
    var time = [
        $d3e0731ae145e11c$var$pad(d.getHours()),
        $d3e0731ae145e11c$var$pad(d.getMinutes()),
        $d3e0731ae145e11c$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $d3e0731ae145e11c$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $d3e0731ae145e11c$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("lyUaN"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$d3e0731ae145e11c$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $d3e0731ae145e11c$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $d3e0731ae145e11c$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($d3e0731ae145e11c$var$kCustomPromisifiedSymbol && original[$d3e0731ae145e11c$var$kCustomPromisifiedSymbol]) {
        var fn = original[$d3e0731ae145e11c$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $d3e0731ae145e11c$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($d3e0731ae145e11c$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $d3e0731ae145e11c$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $d3e0731ae145e11c$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $d3e0731ae145e11c$var$kCustomPromisifiedSymbol;
function $d3e0731ae145e11c$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $d3e0731ae145e11c$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $2fFJv.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $2fFJv.nextTick($d3e0731ae145e11c$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $d3e0731ae145e11c$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $d3e0731ae145e11c$var$callbackify;

});
parcelRegister("jpjK2", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $9fDHT = parcelRequire("9fDHT");

var $e77t3 = parcelRequire("e77t3");

var $btMNR = parcelRequire("btMNR");

var $kQIcs = parcelRequire("kQIcs");
function $e20faa668af53337$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $e20faa668af53337$var$BigIntSupported = typeof BigInt !== 'undefined';
var $e20faa668af53337$var$SymbolSupported = typeof Symbol !== 'undefined';
var $e20faa668af53337$var$ObjectToString = $e20faa668af53337$var$uncurryThis(Object.prototype.toString);
var $e20faa668af53337$var$numberValue = $e20faa668af53337$var$uncurryThis(Number.prototype.valueOf);
var $e20faa668af53337$var$stringValue = $e20faa668af53337$var$uncurryThis(String.prototype.valueOf);
var $e20faa668af53337$var$booleanValue = $e20faa668af53337$var$uncurryThis(Boolean.prototype.valueOf);
if ($e20faa668af53337$var$BigIntSupported) var $e20faa668af53337$var$bigIntValue = $e20faa668af53337$var$uncurryThis(BigInt.prototype.valueOf);
if ($e20faa668af53337$var$SymbolSupported) var $e20faa668af53337$var$symbolValue = $e20faa668af53337$var$uncurryThis(Symbol.prototype.valueOf);
function $e20faa668af53337$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $9fDHT;
module.exports.isGeneratorFunction = $e77t3;
module.exports.isTypedArray = $kQIcs;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $e20faa668af53337$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $e20faa668af53337$var$isPromise;
function $e20faa668af53337$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $kQIcs(value) || $e20faa668af53337$var$isDataView(value);
}
module.exports.isArrayBufferView = $e20faa668af53337$var$isArrayBufferView;
function $e20faa668af53337$var$isUint8Array(value) {
    return $btMNR(value) === 'Uint8Array';
}
module.exports.isUint8Array = $e20faa668af53337$var$isUint8Array;
function $e20faa668af53337$var$isUint8ClampedArray(value) {
    return $btMNR(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $e20faa668af53337$var$isUint8ClampedArray;
function $e20faa668af53337$var$isUint16Array(value) {
    return $btMNR(value) === 'Uint16Array';
}
module.exports.isUint16Array = $e20faa668af53337$var$isUint16Array;
function $e20faa668af53337$var$isUint32Array(value) {
    return $btMNR(value) === 'Uint32Array';
}
module.exports.isUint32Array = $e20faa668af53337$var$isUint32Array;
function $e20faa668af53337$var$isInt8Array(value) {
    return $btMNR(value) === 'Int8Array';
}
module.exports.isInt8Array = $e20faa668af53337$var$isInt8Array;
function $e20faa668af53337$var$isInt16Array(value) {
    return $btMNR(value) === 'Int16Array';
}
module.exports.isInt16Array = $e20faa668af53337$var$isInt16Array;
function $e20faa668af53337$var$isInt32Array(value) {
    return $btMNR(value) === 'Int32Array';
}
module.exports.isInt32Array = $e20faa668af53337$var$isInt32Array;
function $e20faa668af53337$var$isFloat32Array(value) {
    return $btMNR(value) === 'Float32Array';
}
module.exports.isFloat32Array = $e20faa668af53337$var$isFloat32Array;
function $e20faa668af53337$var$isFloat64Array(value) {
    return $btMNR(value) === 'Float64Array';
}
module.exports.isFloat64Array = $e20faa668af53337$var$isFloat64Array;
function $e20faa668af53337$var$isBigInt64Array(value) {
    return $btMNR(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $e20faa668af53337$var$isBigInt64Array;
function $e20faa668af53337$var$isBigUint64Array(value) {
    return $btMNR(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $e20faa668af53337$var$isBigUint64Array;
function $e20faa668af53337$var$isMapToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Map]';
}
$e20faa668af53337$var$isMapToString.working = typeof Map !== 'undefined' && $e20faa668af53337$var$isMapToString(new Map());
function $e20faa668af53337$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $e20faa668af53337$var$isMapToString.working ? $e20faa668af53337$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $e20faa668af53337$var$isMap;
function $e20faa668af53337$var$isSetToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Set]';
}
$e20faa668af53337$var$isSetToString.working = typeof Set !== 'undefined' && $e20faa668af53337$var$isSetToString(new Set());
function $e20faa668af53337$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $e20faa668af53337$var$isSetToString.working ? $e20faa668af53337$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $e20faa668af53337$var$isSet;
function $e20faa668af53337$var$isWeakMapToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WeakMap]';
}
$e20faa668af53337$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $e20faa668af53337$var$isWeakMapToString(new WeakMap());
function $e20faa668af53337$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $e20faa668af53337$var$isWeakMapToString.working ? $e20faa668af53337$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $e20faa668af53337$var$isWeakMap;
function $e20faa668af53337$var$isWeakSetToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WeakSet]';
}
$e20faa668af53337$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $e20faa668af53337$var$isWeakSetToString(new WeakSet());
function $e20faa668af53337$var$isWeakSet(value) {
    return $e20faa668af53337$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $e20faa668af53337$var$isWeakSet;
function $e20faa668af53337$var$isArrayBufferToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$e20faa668af53337$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $e20faa668af53337$var$isArrayBufferToString(new ArrayBuffer());
function $e20faa668af53337$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $e20faa668af53337$var$isArrayBufferToString.working ? $e20faa668af53337$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $e20faa668af53337$var$isArrayBuffer;
function $e20faa668af53337$var$isDataViewToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object DataView]';
}
$e20faa668af53337$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $e20faa668af53337$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $e20faa668af53337$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $e20faa668af53337$var$isDataViewToString.working ? $e20faa668af53337$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $e20faa668af53337$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $e20faa668af53337$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $e20faa668af53337$var$isSharedArrayBufferToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $e20faa668af53337$var$isSharedArrayBuffer(value) {
    if (typeof $e20faa668af53337$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $e20faa668af53337$var$isSharedArrayBufferToString.working === 'undefined') $e20faa668af53337$var$isSharedArrayBufferToString.working = $e20faa668af53337$var$isSharedArrayBufferToString(new $e20faa668af53337$var$SharedArrayBufferCopy());
    return $e20faa668af53337$var$isSharedArrayBufferToString.working ? $e20faa668af53337$var$isSharedArrayBufferToString(value) : value instanceof $e20faa668af53337$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $e20faa668af53337$var$isSharedArrayBuffer;
function $e20faa668af53337$var$isAsyncFunction(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $e20faa668af53337$var$isAsyncFunction;
function $e20faa668af53337$var$isMapIterator(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $e20faa668af53337$var$isMapIterator;
function $e20faa668af53337$var$isSetIterator(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $e20faa668af53337$var$isSetIterator;
function $e20faa668af53337$var$isGeneratorObject(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $e20faa668af53337$var$isGeneratorObject;
function $e20faa668af53337$var$isWebAssemblyCompiledModule(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $e20faa668af53337$var$isWebAssemblyCompiledModule;
function $e20faa668af53337$var$isNumberObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$numberValue);
}
module.exports.isNumberObject = $e20faa668af53337$var$isNumberObject;
function $e20faa668af53337$var$isStringObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$stringValue);
}
module.exports.isStringObject = $e20faa668af53337$var$isStringObject;
function $e20faa668af53337$var$isBooleanObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$booleanValue);
}
module.exports.isBooleanObject = $e20faa668af53337$var$isBooleanObject;
function $e20faa668af53337$var$isBigIntObject(value) {
    return $e20faa668af53337$var$BigIntSupported && $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$bigIntValue);
}
module.exports.isBigIntObject = $e20faa668af53337$var$isBigIntObject;
function $e20faa668af53337$var$isSymbolObject(value) {
    return $e20faa668af53337$var$SymbolSupported && $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$symbolValue);
}
module.exports.isSymbolObject = $e20faa668af53337$var$isSymbolObject;
function $e20faa668af53337$var$isBoxedPrimitive(value) {
    return $e20faa668af53337$var$isNumberObject(value) || $e20faa668af53337$var$isStringObject(value) || $e20faa668af53337$var$isBooleanObject(value) || $e20faa668af53337$var$isBigIntObject(value) || $e20faa668af53337$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $e20faa668af53337$var$isBoxedPrimitive;
function $e20faa668af53337$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($e20faa668af53337$var$isArrayBuffer(value) || $e20faa668af53337$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $e20faa668af53337$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("9fDHT", function(module, exports) {
'use strict';

var $6bc450c4a7d545b1$var$hasToStringTag = (parcelRequire("6jtVY"))();

var $g94P8 = parcelRequire("g94P8");
var $6bc450c4a7d545b1$var$$toString = $g94P8('Object.prototype.toString');
var $6bc450c4a7d545b1$var$isStandardArguments = function isArguments(value) {
    if ($6bc450c4a7d545b1$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $6bc450c4a7d545b1$var$$toString(value) === '[object Arguments]';
};
var $6bc450c4a7d545b1$var$isLegacyArguments = function isArguments(value) {
    if ($6bc450c4a7d545b1$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6bc450c4a7d545b1$var$$toString(value) !== '[object Array]' && $6bc450c4a7d545b1$var$$toString(value.callee) === '[object Function]';
};
var $6bc450c4a7d545b1$var$supportsStandardArguments = function() {
    return $6bc450c4a7d545b1$var$isStandardArguments(arguments);
}();
$6bc450c4a7d545b1$var$isStandardArguments.isLegacyArguments = $6bc450c4a7d545b1$var$isLegacyArguments; // for tests
module.exports = $6bc450c4a7d545b1$var$supportsStandardArguments ? $6bc450c4a7d545b1$var$isStandardArguments : $6bc450c4a7d545b1$var$isLegacyArguments;

});
parcelRegister("6jtVY", function(module, exports) {
'use strict';

var $3e6zG = parcelRequire("3e6zG");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $3e6zG() && !!Symbol.toStringTag;
};

});


parcelRegister("e77t3", function(module, exports) {
'use strict';
var $a4678312b9f54a56$var$toStr = Object.prototype.toString;
var $a4678312b9f54a56$var$fnToStr = Function.prototype.toString;
var $a4678312b9f54a56$var$isFnRegex = /^\s*(?:function)?\*/;

var $a4678312b9f54a56$var$hasToStringTag = (parcelRequire("6jtVY"))();
var $a4678312b9f54a56$var$getProto = Object.getPrototypeOf;
var $a4678312b9f54a56$var$getGeneratorFunc = function() {
    if (!$a4678312b9f54a56$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $a4678312b9f54a56$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($a4678312b9f54a56$var$isFnRegex.test($a4678312b9f54a56$var$fnToStr.call(fn))) return true;
    if (!$a4678312b9f54a56$var$hasToStringTag) {
        var str = $a4678312b9f54a56$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$a4678312b9f54a56$var$getProto) return false;
    if (typeof $a4678312b9f54a56$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $a4678312b9f54a56$var$getGeneratorFunc();
        $a4678312b9f54a56$var$GeneratorFunction = generatorFunc ? $a4678312b9f54a56$var$getProto(generatorFunc) : false;
    }
    return $a4678312b9f54a56$var$getProto(fn) === $a4678312b9f54a56$var$GeneratorFunction;
};

});

parcelRegister("btMNR", function(module, exports) {
'use strict';

var $lUcp2 = parcelRequire("lUcp2");

var $isVN0 = parcelRequire("isVN0");

var $eitbu = parcelRequire("eitbu");

var $g94P8 = parcelRequire("g94P8");

var $aBzvk = parcelRequire("aBzvk");
/** @type {(O: object) => string} */ var $85b8426f3d620737$var$$toString = $g94P8('Object.prototype.toString');

var $85b8426f3d620737$var$hasToStringTag = (parcelRequire("6jtVY"))();
var $85b8426f3d620737$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $85b8426f3d620737$var$typedArrays = $isVN0();
var $85b8426f3d620737$var$$slice = $g94P8('String.prototype.slice');
var $85b8426f3d620737$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $85b8426f3d620737$var$$indexOf = $g94P8('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $85b8426f3d620737$var$cache = {
    __proto__: null
};
if ($85b8426f3d620737$var$hasToStringTag && $aBzvk && $85b8426f3d620737$var$getPrototypeOf) $lUcp2($85b8426f3d620737$var$typedArrays, function(typedArray) {
    var arr = new $85b8426f3d620737$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $85b8426f3d620737$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $aBzvk(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $85b8426f3d620737$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $aBzvk(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $85b8426f3d620737$var$cache['$' + typedArray] = $eitbu(descriptor.get);
    }
});
else $lUcp2($85b8426f3d620737$var$typedArrays, function(typedArray) {
    var arr = new $85b8426f3d620737$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $85b8426f3d620737$var$cache['$' + typedArray] = $eitbu(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $85b8426f3d620737$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $lUcp2(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $85b8426f3d620737$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ('$' + getter(value) === typedArray) found = $85b8426f3d620737$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $85b8426f3d620737$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $lUcp2(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $85b8426f3d620737$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $85b8426f3d620737$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$85b8426f3d620737$var$hasToStringTag) {
        /** @type {string} */ var tag = $85b8426f3d620737$var$$slice($85b8426f3d620737$var$$toString(value), 8, -1);
        if ($85b8426f3d620737$var$$indexOf($85b8426f3d620737$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $85b8426f3d620737$var$trySlices(value);
    }
    if (!$aBzvk) return null;
     // unknown engine
    return $85b8426f3d620737$var$tryTypedArrays(value);
};

});
parcelRegister("lUcp2", function(module, exports) {
'use strict';

var $2GDa0 = parcelRequire("2GDa0");
var $ff2872e50ec13c73$var$toStr = Object.prototype.toString;
var $ff2872e50ec13c73$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ff2872e50ec13c73$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($ff2872e50ec13c73$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $ff2872e50ec13c73$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $ff2872e50ec13c73$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($ff2872e50ec13c73$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $ff2872e50ec13c73$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$2GDa0(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($ff2872e50ec13c73$var$toStr.call(list) === '[object Array]') $ff2872e50ec13c73$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $ff2872e50ec13c73$var$forEachString(list, iterator, receiver);
    else $ff2872e50ec13c73$var$forEachObject(list, iterator, receiver);
};
module.exports = $ff2872e50ec13c73$var$forEach;

});
parcelRegister("2GDa0", function(module, exports) {
'use strict';
var $1f4de171721c0f5b$var$fnToStr = Function.prototype.toString;
var $1f4de171721c0f5b$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $1f4de171721c0f5b$var$badArrayLike;
var $1f4de171721c0f5b$var$isCallableMarker;
if (typeof $1f4de171721c0f5b$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $1f4de171721c0f5b$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $1f4de171721c0f5b$var$isCallableMarker;
        }
    });
    $1f4de171721c0f5b$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $1f4de171721c0f5b$var$reflectApply(function() {
        throw 42;
    }, null, $1f4de171721c0f5b$var$badArrayLike);
} catch (_) {
    if (_ !== $1f4de171721c0f5b$var$isCallableMarker) $1f4de171721c0f5b$var$reflectApply = null;
}
else $1f4de171721c0f5b$var$reflectApply = null;
var $1f4de171721c0f5b$var$constructorRegex = /^\s*class\b/;
var $1f4de171721c0f5b$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $1f4de171721c0f5b$var$fnToStr.call(value);
        return $1f4de171721c0f5b$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $1f4de171721c0f5b$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($1f4de171721c0f5b$var$isES6ClassFn(value)) return false;
        $1f4de171721c0f5b$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $1f4de171721c0f5b$var$toStr = Object.prototype.toString;
var $1f4de171721c0f5b$var$objectClass = '[object Object]';
var $1f4de171721c0f5b$var$fnClass = '[object Function]';
var $1f4de171721c0f5b$var$genClass = '[object GeneratorFunction]';
var $1f4de171721c0f5b$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $1f4de171721c0f5b$var$ddaClass2 = '[object HTML document.all class]';
var $1f4de171721c0f5b$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $1f4de171721c0f5b$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $1f4de171721c0f5b$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $1f4de171721c0f5b$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $1f4de171721c0f5b$var$all = document.all;
    if ($1f4de171721c0f5b$var$toStr.call($1f4de171721c0f5b$var$all) === $1f4de171721c0f5b$var$toStr.call(document.all)) $1f4de171721c0f5b$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($1f4de171721c0f5b$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $1f4de171721c0f5b$var$toStr.call(value);
            return (str === $1f4de171721c0f5b$var$ddaClass || str === $1f4de171721c0f5b$var$ddaClass2 || str === $1f4de171721c0f5b$var$ddaClass3 // opera 12.16
             || str === $1f4de171721c0f5b$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $1f4de171721c0f5b$var$reflectApply ? function isCallable(value) {
    if ($1f4de171721c0f5b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $1f4de171721c0f5b$var$reflectApply(value, null, $1f4de171721c0f5b$var$badArrayLike);
    } catch (e) {
        if (e !== $1f4de171721c0f5b$var$isCallableMarker) return false;
    }
    return !$1f4de171721c0f5b$var$isES6ClassFn(value) && $1f4de171721c0f5b$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($1f4de171721c0f5b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($1f4de171721c0f5b$var$hasToStringTag) return $1f4de171721c0f5b$var$tryFunctionObject(value);
    if ($1f4de171721c0f5b$var$isES6ClassFn(value)) return false;
    var strClass = $1f4de171721c0f5b$var$toStr.call(value);
    if (strClass !== $1f4de171721c0f5b$var$fnClass && strClass !== $1f4de171721c0f5b$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $1f4de171721c0f5b$var$tryFunctionObject(value);
};

});


parcelRegister("isVN0", function(module, exports) {
'use strict';

var $3LhLu = parcelRequire("3LhLu");
var $d717ab4641bd380c$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $3LhLu.length; i++)if (typeof $d717ab4641bd380c$var$g[$3LhLu[i]] === 'function') // @ts-expect-error
    out[out.length] = $3LhLu[i];
    return out;
};

});
parcelRegister("3LhLu", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("kQIcs", function(module, exports) {
'use strict';

var $btMNR = parcelRequire("btMNR");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$btMNR(value);
};

});


parcelRegister("fDPIL", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("lyUaN", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("4ZhvB", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $2fFJv = parcelRequire("2fFJv");
'use strict';
function $3a1a70c979998564$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $3a1a70c979998564$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $3a1a70c979998564$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3a1a70c979998564$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3a1a70c979998564$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3a1a70c979998564$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3a1a70c979998564$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3a1a70c979998564$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3a1a70c979998564$var$_possibleConstructorReturn(self, call) {
    if (call && ($3a1a70c979998564$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $3a1a70c979998564$var$_assertThisInitialized(self);
}
function $3a1a70c979998564$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3a1a70c979998564$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3a1a70c979998564$var$_setPrototypeOf(subClass, superClass);
}
function $3a1a70c979998564$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $3a1a70c979998564$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$3a1a70c979998564$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $3a1a70c979998564$var$_construct(Class, arguments, $3a1a70c979998564$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $3a1a70c979998564$var$_setPrototypeOf(Wrapper, Class);
    };
    return $3a1a70c979998564$var$_wrapNativeSuper(Class);
}
function $3a1a70c979998564$var$isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3a1a70c979998564$var$_construct(Parent, args, Class) {
    if ($3a1a70c979998564$var$isNativeReflectConstruct()) $3a1a70c979998564$var$_construct = Reflect.construct;
    else $3a1a70c979998564$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $3a1a70c979998564$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $3a1a70c979998564$var$_construct.apply(null, arguments);
}
function $3a1a70c979998564$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $3a1a70c979998564$var$_setPrototypeOf(o, p) {
    $3a1a70c979998564$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3a1a70c979998564$var$_setPrototypeOf(o, p);
}
function $3a1a70c979998564$var$_getPrototypeOf(o) {
    $3a1a70c979998564$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3a1a70c979998564$var$_getPrototypeOf(o);
}
function $3a1a70c979998564$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3a1a70c979998564$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3a1a70c979998564$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3a1a70c979998564$var$_typeof(obj);
}

var $ibOwR = parcelRequire("ibOwR");
var $3a1a70c979998564$var$inspect = $ibOwR.inspect;

var $5xQQM = parcelRequire("5xQQM");
var $3a1a70c979998564$var$ERR_INVALID_ARG_TYPE = $5xQQM.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $3a1a70c979998564$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $3a1a70c979998564$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $3a1a70c979998564$var$blue = '';
var $3a1a70c979998564$var$green = '';
var $3a1a70c979998564$var$red = '';
var $3a1a70c979998564$var$white = '';
var $3a1a70c979998564$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
}; // Comparing short primitives should just show === / !== instead of using the
// diff.
var $3a1a70c979998564$var$kMaxShortLength = 10;
function $3a1a70c979998564$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $3a1a70c979998564$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $3a1a70c979998564$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $3a1a70c979998564$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $3a1a70c979998564$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $3a1a70c979998564$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = ''; // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $3a1a70c979998564$var$_typeof(actual) === 'object' && $3a1a70c979998564$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
     // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $3a1a70c979998564$var$kMaxShortLength) {
            if (($3a1a70c979998564$var$_typeof(actual) !== 'object' || actual === null) && ($3a1a70c979998564$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($3a1a70c979998564$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $2fFJv.stderr && $2fFJv.stderr.isTTY ? $2fFJv.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                 // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($3a1a70c979998564$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    } // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n'); // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($3a1a70c979998564$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $3a1a70c979998564$var$kReadableOperator[operator] + "\n".concat($3a1a70c979998564$var$green, "+ actual").concat($3a1a70c979998564$var$white, " ").concat($3a1a70c979998564$var$red, "- expected").concat($3a1a70c979998564$var$white);
    var skippedMsg = " ".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the expected line to the cache.
            other += "\n".concat($3a1a70c979998564$var$red, "-").concat($3a1a70c979998564$var$white, " ").concat(expectedLines[i]);
            printedLines++; // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the actual line to the result.
            res += "\n".concat($3a1a70c979998564$var$green, "+").concat($3a1a70c979998564$var$white, " ").concat(actualLines[i]);
            printedLines++; // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$3a1a70c979998564$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $3a1a70c979998564$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                } // Mark the current line as the last diverging one.
                lastPos = i; // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($3a1a70c979998564$var$green, "+").concat($3a1a70c979998564$var$white, " ").concat(actualLine);
                other += "\n".concat($3a1a70c979998564$var$red, "-").concat($3a1a70c979998564$var$white, " ").concat(expectedLine);
                printedLines += 2; // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = ''; // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        } // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white).concat(other, "\n") + "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $3a1a70c979998564$var$AssertionError = /*#__PURE__*/ function(_Error) {
    $3a1a70c979998564$var$_inherits(AssertionError, _Error);
    function AssertionError(options) {
        var _this;
        $3a1a70c979998564$var$_classCallCheck(this, AssertionError);
        if ($3a1a70c979998564$var$_typeof(options) !== 'object' || options === null) throw new $3a1a70c979998564$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = $3a1a70c979998564$var$_possibleConstructorReturn(this, $3a1a70c979998564$var$_getPrototypeOf(AssertionError).call(this, String(message)));
        else {
            if ($2fFJv.stderr && $2fFJv.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($2fFJv.stderr && $2fFJv.stderr.getColorDepth && $2fFJv.stderr.getColorDepth() !== 1) {
                    $3a1a70c979998564$var$blue = "\x1B[34m";
                    $3a1a70c979998564$var$green = "\x1B[32m";
                    $3a1a70c979998564$var$white = "\x1B[39m";
                    $3a1a70c979998564$var$red = "\x1B[31m";
                } else {
                    $3a1a70c979998564$var$blue = '';
                    $3a1a70c979998564$var$green = '';
                    $3a1a70c979998564$var$white = '';
                    $3a1a70c979998564$var$red = '';
                }
            } // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($3a1a70c979998564$var$_typeof(actual) === 'object' && actual !== null && $3a1a70c979998564$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $3a1a70c979998564$var$copyError(actual);
                expected = $3a1a70c979998564$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = $3a1a70c979998564$var$_possibleConstructorReturn(this, $3a1a70c979998564$var$_getPrototypeOf(AssertionError).call(this, $3a1a70c979998564$var$createErrDiff(actual, expected, operator)));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $3a1a70c979998564$var$kReadableOperator[operator];
                var res = $3a1a70c979998564$var$inspectValue(actual).split('\n'); // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $3a1a70c979998564$var$_typeof(actual) === 'object' && actual !== null) base = $3a1a70c979998564$var$kReadableOperator.notStrictEqualObject;
                 // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    while(res.length > 27)res.pop();
                } // Only print a single input.
                if (res.length === 1) _this = $3a1a70c979998564$var$_possibleConstructorReturn(this, $3a1a70c979998564$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, " ").concat(res[0])));
                else _this = $3a1a70c979998564$var$_possibleConstructorReturn(this, $3a1a70c979998564$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n")));
            } else {
                var _res = $3a1a70c979998564$var$inspectValue(actual);
                var other = '';
                var knownOperators = $3a1a70c979998564$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($3a1a70c979998564$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($3a1a70c979998564$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = $3a1a70c979998564$var$_possibleConstructorReturn(this, $3a1a70c979998564$var$_getPrototypeOf(AssertionError).call(this, "".concat(_res).concat(other)));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($3a1a70c979998564$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($3a1a70c979998564$var$_assertThisInitialized(_this), stackStartFn);
         // Create error message including the error code in the name.
        _this.stack; // Reset the name.
        _this.name = 'AssertionError';
        return $3a1a70c979998564$var$_possibleConstructorReturn(_this);
    }
    $3a1a70c979998564$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: $3a1a70c979998564$var$inspect.custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $3a1a70c979998564$var$inspect(this, $3a1a70c979998564$var$_objectSpread({}, ctx, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}($3a1a70c979998564$var$_wrapNativeSuper(Error));
module.exports = $3a1a70c979998564$var$AssertionError;

});

parcelRegister("hQCs4", function(module, exports) {
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ 'use strict';
function $cfe51eb9750f915c$var$assign(target, firstSource) {
    if (target === undefined || target === null) throw new TypeError('Cannot convert first argument to object');
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}
function $cfe51eb9750f915c$var$polyfill() {
    if (!Object.assign) Object.defineProperty(Object, 'assign', {
        enumerable: false,
        configurable: true,
        writable: true,
        value: $cfe51eb9750f915c$var$assign
    });
}
module.exports = {
    assign: $cfe51eb9750f915c$var$assign,
    polyfill: $cfe51eb9750f915c$var$polyfill
};

});

parcelRegister("4BFNJ", function(module, exports) {
'use strict';

var $7DUGk = parcelRequire("7DUGk");

var $eitbu = parcelRequire("eitbu");

var $dAjEz = parcelRequire("dAjEz");

var $c4ycW = parcelRequire("c4ycW");

var $29zXl = parcelRequire("29zXl");
var $35ab0af6f8ad58df$var$polyfill = $eitbu($c4ycW(), Object);
$7DUGk($35ab0af6f8ad58df$var$polyfill, {
    getPolyfill: $c4ycW,
    implementation: $dAjEz,
    shim: $29zXl
});
module.exports = $35ab0af6f8ad58df$var$polyfill;

});
parcelRegister("7DUGk", function(module, exports) {
'use strict';

var $4jDQV = parcelRequire("4jDQV");
var $590824c046b6e009$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $590824c046b6e009$var$toStr = Object.prototype.toString;
var $590824c046b6e009$var$concat = Array.prototype.concat;

var $cCdl2 = parcelRequire("cCdl2");
var $590824c046b6e009$var$isFunction = function(fn) {
    return typeof fn === 'function' && $590824c046b6e009$var$toStr.call(fn) === '[object Function]';
};

var $590824c046b6e009$var$supportsDescriptors = (parcelRequire("kjsHT"))();
var $590824c046b6e009$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$590824c046b6e009$var$isFunction(predicate) || !predicate()) return;
    }
    if ($590824c046b6e009$var$supportsDescriptors) $cCdl2(object, name, value, true);
    else $cCdl2(object, name, value);
};
var $590824c046b6e009$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $4jDQV(map);
    if ($590824c046b6e009$var$hasSymbols) props = $590824c046b6e009$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$590824c046b6e009$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$590824c046b6e009$var$defineProperties.supportsDescriptors = !!$590824c046b6e009$var$supportsDescriptors;
module.exports = $590824c046b6e009$var$defineProperties;

});
parcelRegister("4jDQV", function(module, exports) {
'use strict';
var $3247d9b061104208$var$slice = Array.prototype.slice;

var $96nTn = parcelRequire("96nTn");
var $3247d9b061104208$var$origKeys = Object.keys;

var $3247d9b061104208$var$keysShim = $3247d9b061104208$var$origKeys ? function keys(o) {
    return $3247d9b061104208$var$origKeys(o);
} : (parcelRequire("a7WlO"));
var $3247d9b061104208$var$originalKeys = Object.keys;
$3247d9b061104208$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($96nTn(object)) return $3247d9b061104208$var$originalKeys($3247d9b061104208$var$slice.call(object));
            return $3247d9b061104208$var$originalKeys(object);
        };
    } else Object.keys = $3247d9b061104208$var$keysShim;
    return Object.keys || $3247d9b061104208$var$keysShim;
};
module.exports = $3247d9b061104208$var$keysShim;

});
parcelRegister("96nTn", function(module, exports) {
'use strict';
var $6a0735185fec05e3$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $6a0735185fec05e3$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6a0735185fec05e3$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("a7WlO", function(module, exports) {
'use strict';
var $75f7d21b7a735a78$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $75f7d21b7a735a78$var$has = Object.prototype.hasOwnProperty;
    var $75f7d21b7a735a78$var$toStr = Object.prototype.toString;
    var $75f7d21b7a735a78$var$isArgs = (parcelRequire("96nTn")); // eslint-disable-line global-require
    var $75f7d21b7a735a78$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $75f7d21b7a735a78$var$hasDontEnumBug = !$75f7d21b7a735a78$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $75f7d21b7a735a78$var$hasProtoEnumBug = $75f7d21b7a735a78$var$isEnumerable.call(function() {}, 'prototype');
    var $75f7d21b7a735a78$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $75f7d21b7a735a78$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $75f7d21b7a735a78$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $75f7d21b7a735a78$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$75f7d21b7a735a78$var$excludedKeys['$' + k] && $75f7d21b7a735a78$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $75f7d21b7a735a78$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$75f7d21b7a735a78$var$hasAutomationEqualityBug) return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        try {
            return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $75f7d21b7a735a78$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $75f7d21b7a735a78$var$toStr.call(object) === '[object Function]';
        var isArguments = $75f7d21b7a735a78$var$isArgs(object);
        var isString = isObject && $75f7d21b7a735a78$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $75f7d21b7a735a78$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$75f7d21b7a735a78$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $75f7d21b7a735a78$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($75f7d21b7a735a78$var$hasDontEnumBug) {
            var skipConstructor = $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $75f7d21b7a735a78$var$dontEnums.length; ++k)if (!(skipConstructor && $75f7d21b7a735a78$var$dontEnums[k] === 'constructor') && $75f7d21b7a735a78$var$has.call(object, $75f7d21b7a735a78$var$dontEnums[k])) theKeys.push($75f7d21b7a735a78$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $75f7d21b7a735a78$var$keysShim;

});



parcelRegister("dAjEz", function(module, exports) {
'use strict';
var $9e3de1e5d12e41fc$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($9e3de1e5d12e41fc$var$numberIsNaN(a) && $9e3de1e5d12e41fc$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("c4ycW", function(module, exports) {
'use strict';

var $dAjEz = parcelRequire("dAjEz");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $dAjEz;
};

});

parcelRegister("29zXl", function(module, exports) {
'use strict';

var $c4ycW = parcelRequire("c4ycW");

var $7DUGk = parcelRequire("7DUGk");
module.exports = function shimObjectIs() {
    var polyfill = $c4ycW();
    $7DUGk(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("55ouo", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $3b406a6c1a6d91fb$var$_slicedToArray(arr, i) {
    return $3b406a6c1a6d91fb$var$_arrayWithHoles(arr) || $3b406a6c1a6d91fb$var$_iterableToArrayLimit(arr, i) || $3b406a6c1a6d91fb$var$_nonIterableRest();
}
function $3b406a6c1a6d91fb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $3b406a6c1a6d91fb$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3b406a6c1a6d91fb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3b406a6c1a6d91fb$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3b406a6c1a6d91fb$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3b406a6c1a6d91fb$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3b406a6c1a6d91fb$var$_typeof(obj);
}
var $3b406a6c1a6d91fb$var$regexFlagsSupported = /a/g.flags !== undefined;
var $3b406a6c1a6d91fb$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $3b406a6c1a6d91fb$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $3b406a6c1a6d91fb$var$objectIs = Object.is ? Object.is : (parcelRequire("4BFNJ"));
var $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $3b406a6c1a6d91fb$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("djuuL"));
function $3b406a6c1a6d91fb$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $3b406a6c1a6d91fb$var$hasOwnProperty = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.hasOwnProperty);
var $3b406a6c1a6d91fb$var$propertyIsEnumerable = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $3b406a6c1a6d91fb$var$objectToString = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.toString);

var $ibOwR = parcelRequire("ibOwR");
var $3b406a6c1a6d91fb$require$_require$types = $ibOwR.types;
var $3b406a6c1a6d91fb$var$isAnyArrayBuffer = $3b406a6c1a6d91fb$require$_require$types.isAnyArrayBuffer, $3b406a6c1a6d91fb$var$isArrayBufferView = $3b406a6c1a6d91fb$require$_require$types.isArrayBufferView, $3b406a6c1a6d91fb$var$isDate = $3b406a6c1a6d91fb$require$_require$types.isDate, $3b406a6c1a6d91fb$var$isMap = $3b406a6c1a6d91fb$require$_require$types.isMap, $3b406a6c1a6d91fb$var$isRegExp = $3b406a6c1a6d91fb$require$_require$types.isRegExp, $3b406a6c1a6d91fb$var$isSet = $3b406a6c1a6d91fb$require$_require$types.isSet, $3b406a6c1a6d91fb$var$isNativeError = $3b406a6c1a6d91fb$require$_require$types.isNativeError, $3b406a6c1a6d91fb$var$isBoxedPrimitive = $3b406a6c1a6d91fb$require$_require$types.isBoxedPrimitive, $3b406a6c1a6d91fb$var$isNumberObject = $3b406a6c1a6d91fb$require$_require$types.isNumberObject, $3b406a6c1a6d91fb$var$isStringObject = $3b406a6c1a6d91fb$require$_require$types.isStringObject, $3b406a6c1a6d91fb$var$isBooleanObject = $3b406a6c1a6d91fb$require$_require$types.isBooleanObject, $3b406a6c1a6d91fb$var$isBigIntObject = $3b406a6c1a6d91fb$require$_require$types.isBigIntObject, $3b406a6c1a6d91fb$var$isSymbolObject = $3b406a6c1a6d91fb$require$_require$types.isSymbolObject, $3b406a6c1a6d91fb$var$isFloat32Array = $3b406a6c1a6d91fb$require$_require$types.isFloat32Array, $3b406a6c1a6d91fb$var$isFloat64Array = $3b406a6c1a6d91fb$require$_require$types.isFloat64Array;
function $3b406a6c1a6d91fb$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    } // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($3b406a6c1a6d91fb$var$isNonIndex).concat($3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
} // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $3b406a6c1a6d91fb$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE = undefined;
var $3b406a6c1a6d91fb$var$kStrict = true;
var $3b406a6c1a6d91fb$var$kLoose = false;
var $3b406a6c1a6d91fb$var$kNoIterator = 0;
var $3b406a6c1a6d91fb$var$kIsArray = 1;
var $3b406a6c1a6d91fb$var$kIsSet = 2;
var $3b406a6c1a6d91fb$var$kIsMap = 3; // Check if they have the same source and flags
function $3b406a6c1a6d91fb$var$areSimilarRegExps(a, b) {
    return $3b406a6c1a6d91fb$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $3b406a6c1a6d91fb$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $3b406a6c1a6d91fb$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $3b406a6c1a6d91fb$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $3b406a6c1a6d91fb$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $3b406a6c1a6d91fb$var$isEqualBoxedPrimitive(val1, val2) {
    if ($3b406a6c1a6d91fb$var$isNumberObject(val1)) return $3b406a6c1a6d91fb$var$isNumberObject(val2) && $3b406a6c1a6d91fb$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($3b406a6c1a6d91fb$var$isStringObject(val1)) return $3b406a6c1a6d91fb$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($3b406a6c1a6d91fb$var$isBooleanObject(val1)) return $3b406a6c1a6d91fb$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($3b406a6c1a6d91fb$var$isBigIntObject(val1)) return $3b406a6c1a6d91fb$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $3b406a6c1a6d91fb$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
} // Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $3b406a6c1a6d91fb$var$objectIs(val1, val2) : true;
    } // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($3b406a6c1a6d91fb$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $3b406a6c1a6d91fb$var$numberIsNaN(val1) && $3b406a6c1a6d91fb$var$numberIsNaN(val2);
        if ($3b406a6c1a6d91fb$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $3b406a6c1a6d91fb$var$_typeof(val1) !== 'object') {
            if (val2 === null || $3b406a6c1a6d91fb$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $3b406a6c1a6d91fb$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $3b406a6c1a6d91fb$var$objectToString(val1);
    var val2Tag = $3b406a6c1a6d91fb$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val1, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        var keys2 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val2, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsArray, keys1);
    } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$3b406a6c1a6d91fb$var$isMap(val1) && $3b406a6c1a6d91fb$var$isMap(val2) || !$3b406a6c1a6d91fb$var$isSet(val1) && $3b406a6c1a6d91fb$var$isSet(val2)) return false;
    }
    if ($3b406a6c1a6d91fb$var$isDate(val1)) {
        if (!$3b406a6c1a6d91fb$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isRegExp(val1)) {
        if (!$3b406a6c1a6d91fb$var$isRegExp(val2) || !$3b406a6c1a6d91fb$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($3b406a6c1a6d91fb$var$isArrayBufferView(val1)) {
        if (!strict && ($3b406a6c1a6d91fb$var$isFloat32Array(val1) || $3b406a6c1a6d91fb$var$isFloat64Array(val1))) {
            if (!$3b406a6c1a6d91fb$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$3b406a6c1a6d91fb$var$areSimilarTypedArrays(val1, val2)) return false;
         // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val1, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        var _keys2 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val2, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kNoIterator, _keys);
    } else if ($3b406a6c1a6d91fb$var$isSet(val1)) {
        if (!$3b406a6c1a6d91fb$var$isSet(val2) || val1.size !== val2.size) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsSet);
    } else if ($3b406a6c1a6d91fb$var$isMap(val1)) {
        if (!$3b406a6c1a6d91fb$var$isMap(val2) || val1.size !== val2.size) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsMap);
    } else if ($3b406a6c1a6d91fb$var$isAnyArrayBuffer(val1)) {
        if (!$3b406a6c1a6d91fb$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isBoxedPrimitive(val1) && !$3b406a6c1a6d91fb$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kNoIterator);
}
function $3b406a6c1a6d91fb$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $3b406a6c1a6d91fb$var$propertyIsEnumerable(val, k);
    });
}
function $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    } // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$3b406a6c1a6d91fb$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($3b406a6c1a6d91fb$var$propertyIsEnumerable(val1, key)) {
                    if (!$3b406a6c1a6d91fb$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($3b406a6c1a6d91fb$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $3b406a6c1a6d91fb$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $3b406a6c1a6d91fb$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $3b406a6c1a6d91fb$var$kNoIterator || iterationType === $3b406a6c1a6d91fb$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
     // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $3b406a6c1a6d91fb$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $3b406a6c1a6d91fb$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $3b406a6c1a6d91fb$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
} // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim) {
    switch($3b406a6c1a6d91fb$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($3b406a6c1a6d91fb$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $3b406a6c1a6d91fb$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$3b406a6c1a6d91fb$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $3b406a6c1a6d91fb$var$innerDeepEqual(item, curB, false, memo);
}
function $3b406a6c1a6d91fb$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $3b406a6c1a6d91fb$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($3b406a6c1a6d91fb$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
             // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.
            if (!$3b406a6c1a6d91fb$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $3b406a6c1a6d91fb$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i]; // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($3b406a6c1a6d91fb$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$3b406a6c1a6d91fb$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$3b406a6c1a6d91fb$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $3b406a6c1a6d91fb$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($3b406a6c1a6d91fb$var$innerDeepEqual(key1, key2, strict, memo) && $3b406a6c1a6d91fb$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $3b406a6c1a6d91fb$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $3b406a6c1a6d91fb$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $3b406a6c1a6d91fb$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($3b406a6c1a6d91fb$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$3b406a6c1a6d91fb$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $3b406a6c1a6d91fb$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $3b406a6c1a6d91fb$var$_slicedToArray(bEntries[_i2], 2), key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($3b406a6c1a6d91fb$var$_typeof(key) === 'object' && key !== null) {
                if (!$3b406a6c1a6d91fb$var$mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a.get(key), item, false, memo)) && !$3b406a6c1a6d91fb$var$mapHasEqualEntry(set, a, key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $3b406a6c1a6d91fb$var$kIsSet) {
        if (!$3b406a6c1a6d91fb$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $3b406a6c1a6d91fb$var$kIsMap) {
        if (!$3b406a6c1a6d91fb$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $3b406a6c1a6d91fb$var$kIsArray) for(; i < a.length; i++){
        if ($3b406a6c1a6d91fb$var$hasOwnProperty(a, i)) {
            if (!$3b406a6c1a6d91fb$var$hasOwnProperty(b, i) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($3b406a6c1a6d91fb$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$3b406a6c1a6d91fb$var$hasOwnProperty(b, key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
     // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key = keys[i];
        if (!$3b406a6c1a6d91fb$var$innerDeepEqual(a[_key], b[_key], strict, memos)) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$isDeepEqual(val1, val2) {
    return $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, $3b406a6c1a6d91fb$var$kLoose);
}
function $3b406a6c1a6d91fb$var$isDeepStrictEqual(val1, val2) {
    return $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, $3b406a6c1a6d91fb$var$kStrict);
}
module.exports = {
    isDeepEqual: $3b406a6c1a6d91fb$var$isDeepEqual,
    isDeepStrictEqual: $3b406a6c1a6d91fb$var$isDeepStrictEqual
};

});
parcelRegister("djuuL", function(module, exports) {
'use strict';

var $eitbu = parcelRequire("eitbu");

var $7DUGk = parcelRequire("7DUGk");

var $9NVyy = parcelRequire("9NVyy");

var $klO7B = parcelRequire("klO7B");

var $4dQLh = parcelRequire("4dQLh");
var $9b14b4694a770524$var$polyfill = $eitbu($klO7B(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $7DUGk($9b14b4694a770524$var$polyfill, {
    getPolyfill: $klO7B,
    implementation: $9NVyy,
    shim: $4dQLh
});
module.exports = $9b14b4694a770524$var$polyfill;

});
parcelRegister("9NVyy", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("klO7B", function(module, exports) {
'use strict';

var $9NVyy = parcelRequire("9NVyy");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $9NVyy;
};

});

parcelRegister("4dQLh", function(module, exports) {
'use strict';

var $7DUGk = parcelRequire("7DUGk");

var $klO7B = parcelRequire("klO7B");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $klO7B();
    $7DUGk(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("aN41m", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
function $7db19978462a2871$var$NotNull(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.NotNull = $7db19978462a2871$var$NotNull;
function $7db19978462a2871$var$Nullable(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.Nullable = $7db19978462a2871$var$Nullable;
function $7db19978462a2871$var$Override(target, propertyKey, propertyDescriptor) {
// do something with 'target' ...
}
module.exports.Override = $7db19978462a2871$var$Override;
function $7db19978462a2871$var$SuppressWarnings(options) {
    return (target, propertyKey, descriptor)=>{
    // intentionally empty
    };
}
module.exports.SuppressWarnings = $7db19978462a2871$var$SuppressWarnings;

});

parcelRegister("ldi9e", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntStream = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.6934376-07:00
var $f718e3b116f54f2a$var$IntStream;
(function(IntStream) {
    /**
     * The value returned by {@link #LA LA()} when the end of the stream is
     * reached.
     */ IntStream.EOF = -1;
    /**
     * The value returned by {@link #getSourceName} when the actual name of the
     * underlying source is not known.
     */ IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
})($f718e3b116f54f2a$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));

});


parcelRegister("csTA1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9133369c31e91133$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BailErrorStrategy = void 0;

var $3HZil = parcelRequire("3HZil");

var $5jZSY = parcelRequire("5jZSY");

var $aN41m = parcelRequire("aN41m");

var $hXb5J = parcelRequire("hXb5J");
/**
 * This implementation of {@link ANTLRErrorStrategy} responds to syntax errors
 * by immediately canceling the parse operation with a
 * {@link ParseCancellationException}. The implementation ensures that the
 * {@link ParserRuleContext#exception} field is set for all parse tree nodes
 * that were not completed prior to encountering the error.
 *
 * This error strategy is useful in the following scenarios.
 *
 * * **Two-stage parsing:** This error strategy allows the first
 *   stage of two-stage parsing to immediately terminate if an error is
 *   encountered, and immediately fall back to the second stage. In addition to
 *   avoiding wasted work by attempting to recover from errors here, the empty
 *   implementation of {@link BailErrorStrategy#sync} improves the performance of
 *   the first stage.
 * * **Silent validation:** When syntax errors are not being
 *   reported or logged, and the parse result is simply ignored if errors occur,
 *   the {@link BailErrorStrategy} avoids wasting work on recovering from errors
 *   when the result will be ignored either way.
 *
 * ```
 * myparser.errorHandler = new BailErrorStrategy();
 * ```
 *
 * @see Parser.errorHandler
 */ class $9133369c31e91133$var$BailErrorStrategy extends $3HZil.DefaultErrorStrategy {
    /** Instead of recovering from exception `e`, re-throw it wrapped
     *  in a {@link ParseCancellationException} so it is not caught by the
     *  rule function catches.  Use {@link Exception#getCause()} to get the
     *  original {@link RecognitionException}.
     */ recover(recognizer, e) {
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $hXb5J.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover inline; if the parser
     *  successfully recovers, it won't throw an exception.
     */ recoverInline(recognizer) {
        let e = new $5jZSY.InputMismatchException(recognizer);
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $hXb5J.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover from problems in subrules. */ sync(recognizer) {
    // intentionally empty
    }
}
$9133369c31e91133$var$__decorate([
    $aN41m.Override
], $9133369c31e91133$var$BailErrorStrategy.prototype, "recover", null);
$9133369c31e91133$var$__decorate([
    $aN41m.Override
], $9133369c31e91133$var$BailErrorStrategy.prototype, "recoverInline", null);
$9133369c31e91133$var$__decorate([
    $aN41m.Override
], $9133369c31e91133$var$BailErrorStrategy.prototype, "sync", null);
module.exports.BailErrorStrategy = $9133369c31e91133$var$BailErrorStrategy;

});
parcelRegister("3HZil", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2b34ef24d781854a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2b34ef24d781854a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorStrategy = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $2quiJ = parcelRequire("2quiJ");

var $5jZSY = parcelRequire("5jZSY");

var $6kdz0 = parcelRequire("6kdz0");

var $iAlWg = parcelRequire("iAlWg");

var $jaUCz = parcelRequire("jaUCz");

var $eKXi4 = parcelRequire("eKXi4");

var $aN41m = parcelRequire("aN41m");
/**
 * This is the default implementation of {@link ANTLRErrorStrategy} used for
 * error reporting and recovery in ANTLR parsers.
 */ class $2b34ef24d781854a$var$DefaultErrorStrategy {
    constructor(){
        /**
         * Indicates whether the error strategy is currently "recovering from an
         * error". This is used to suppress reporting multiple error messages while
         * attempting to recover from a detected syntax error.
         *
         * @see #inErrorRecoveryMode
         */ this.errorRecoveryMode = false;
        /** The index into the input stream where the last error occurred.
         * 	This is used to prevent infinite loops where an error is found
         *  but no token is consumed during recovery...another error is found,
         *  ad nauseum.  This is a failsafe mechanism to guarantee that at least
         *  one token/tree node is consumed for two errors.
         */ this.lastErrorIndex = -1;
        /**
         * @see #nextTokensContext
         */ this.nextTokensState = $dv9vN.ATNState.INVALID_STATE_NUMBER;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition} to
     * ensure that the handler is not in error recovery mode.
     */ reset(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * This method is called to enter error recovery mode when a recognition
     * exception is reported.
     *
     * @param recognizer the parser instance
     */ beginErrorCondition(recognizer) {
        this.errorRecoveryMode = true;
    }
    /**
     * {@inheritDoc}
     */ inErrorRecoveryMode(recognizer) {
        return this.errorRecoveryMode;
    }
    /**
     * This method is called to leave error recovery mode after recovering from
     * a recognition exception.
     *
     * @param recognizer
     */ endErrorCondition(recognizer) {
        this.errorRecoveryMode = false;
        this.lastErrorStates = undefined;
        this.lastErrorIndex = -1;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition}.
     */ reportMatch(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation returns immediately if the handler is already
     * in error recovery mode. Otherwise, it calls {@link #beginErrorCondition}
     * and dispatches the reporting task based on the runtime type of `e`
     * according to the following table.
     *
     * * {@link NoViableAltException}: Dispatches the call to
     *   {@link #reportNoViableAlternative}
     * * {@link InputMismatchException}: Dispatches the call to
     *   {@link #reportInputMismatch}
     * * {@link FailedPredicateException}: Dispatches the call to
     *   {@link #reportFailedPredicate}
     * * All other types: calls {@link Parser#notifyErrorListeners} to report
     *   the exception
     */ reportError(recognizer, e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if (this.inErrorRecoveryMode(recognizer)) //			System.err.print("[SPURIOUS] ");
        return; // don't report spurious errors
        this.beginErrorCondition(recognizer);
        if (e instanceof $iAlWg.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
        else if (e instanceof $5jZSY.InputMismatchException) this.reportInputMismatch(recognizer, e);
        else if (e instanceof $2quiJ.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
        else {
            console.error(`unknown recognition error type: ${e}`);
            this.notifyErrorListeners(recognizer, e.toString(), e);
        }
    }
    notifyErrorListeners(recognizer, message, e) {
        let offendingToken = e.getOffendingToken(recognizer);
        if (offendingToken === undefined) // Pass null to notifyErrorListeners so it in turn calls the error listeners with undefined as the offending
        // token. If we passed undefined, it would instead call the listeners with currentToken from the parser.
        offendingToken = null;
        recognizer.notifyErrorListeners(message, offendingToken, e);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation resynchronizes the parser by consuming tokens
     * until we find one in the resynchronization set--loosely the set of tokens
     * that can follow the current rule.
     */ recover(recognizer, e) {
        //		System.out.println("recover in "+recognizer.getRuleInvocationStack()+
        //						   " index="+recognizer.inputStream.index+
        //						   ", lastErrorIndex="+
        //						   lastErrorIndex+
        //						   ", states="+lastErrorStates);
        if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) // uh oh, another error at same token index and previously-visited
        // state in ATN; must be a case where LT(1) is in the recovery
        // token set so nothing got consumed. Consume a single token
        // at least to prevent an infinite loop; this is a failsafe.
        //			System.err.println("seen error condition before index="+
        //							   lastErrorIndex+", states="+lastErrorStates);
        //			System.err.println("FAILSAFE consumes "+recognizer.getTokenNames()[recognizer.inputStream.LA(1)]);
        recognizer.consume();
        this.lastErrorIndex = recognizer.inputStream.index;
        if (!this.lastErrorStates) this.lastErrorStates = new $6kdz0.IntervalSet();
        this.lastErrorStates.add(recognizer.state);
        let followSet = this.getErrorRecoverySet(recognizer);
        this.consumeUntil(recognizer, followSet);
    }
    /**
     * The default implementation of {@link ANTLRErrorStrategy#sync} makes sure
     * that the current lookahead symbol is consistent with what were expecting
     * at this point in the ATN. You can call this anytime but ANTLR only
     * generates code to check before subrules/loops and each iteration.
     *
     * Implements Jim Idle's magic sync mechanism in closures and optional
     * subrules. E.g.,
     *
     * ```antlr
     * a : sync ( stuff sync )* ;
     * sync : {consume to what can follow sync} ;
     * ```
     *
     * At the start of a sub rule upon error, {@link #sync} performs single
     * token deletion, if possible. If it can't do that, it bails on the current
     * rule and uses the default error recovery, which consumes until the
     * resynchronization set of the current rule.
     *
     * If the sub rule is optional (`(...)?`, `(...)*`, or block
     * with an empty alternative), then the expected set includes what follows
     * the subrule.
     *
     * During loop iteration, it consumes until it sees a token that can start a
     * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
     * stay in the loop as long as possible.
     *
     * **ORIGINS**
     *
     * Previous versions of ANTLR did a poor job of their recovery within loops.
     * A single mismatch token or missing token would force the parser to bail
     * out of the entire rules surrounding the loop. So, for rule
     *
     * ```antlr
     * classDef : 'class' ID '{' member* '}'
     * ```
     *
     * input with an extra token between members would force the parser to
     * consume until it found the next class definition rather than the next
     * member definition of the current class.
     *
     * This functionality cost a little bit of effort because the parser has to
     * compare token set at the start of the loop and at each iteration. If for
     * some reason speed is suffering for you, you can turn off this
     * functionality by simply overriding this method as a blank { }.
     */ sync(recognizer) {
        let s = recognizer.interpreter.atn.states[recognizer.state];
        //		System.err.println("sync @ "+s.stateNumber+"="+s.getClass().getSimpleName());
        // If already recovering, don't try to sync
        if (this.inErrorRecoveryMode(recognizer)) return;
        let tokens = recognizer.inputStream;
        let la = tokens.LA(1);
        // try cheaper subset first; might get lucky. seems to shave a wee bit off
        let nextTokens = recognizer.atn.nextTokens(s);
        if (nextTokens.contains(la)) {
            // We are sure the token matches
            this.nextTokensContext = undefined;
            this.nextTokensState = $dv9vN.ATNState.INVALID_STATE_NUMBER;
            return;
        }
        if (nextTokens.contains($eKXi4.Token.EPSILON)) {
            if (this.nextTokensContext === undefined) {
                // It's possible the next token won't match; information tracked
                // by sync is restricted for performance.
                this.nextTokensContext = recognizer.context;
                this.nextTokensState = recognizer.state;
            }
            return;
        }
        switch(s.stateType){
            case $fZESB.ATNStateType.BLOCK_START:
            case $fZESB.ATNStateType.STAR_BLOCK_START:
            case $fZESB.ATNStateType.PLUS_BLOCK_START:
            case $fZESB.ATNStateType.STAR_LOOP_ENTRY:
                // report error and recover if possible
                if (this.singleTokenDeletion(recognizer)) return;
                throw new $5jZSY.InputMismatchException(recognizer);
            case $fZESB.ATNStateType.PLUS_LOOP_BACK:
            case $fZESB.ATNStateType.STAR_LOOP_BACK:
                //			System.err.println("at loop back: "+s.getClass().getSimpleName());
                this.reportUnwantedToken(recognizer);
                let expecting = recognizer.getExpectedTokens();
                let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                break;
            default:
                break;
        }
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link NoViableAltException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportNoViableAlternative(recognizer, e) {
        let tokens = recognizer.inputStream;
        let input;
        if (tokens) {
            if (e.startToken.type === $eKXi4.Token.EOF) input = "<EOF>";
            else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
        } else input = "<unknown input>";
        let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is an
     * {@link InputMismatchException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportInputMismatch(recognizer, e) {
        let expected = e.expectedTokens;
        let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
        let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link FailedPredicateException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportFailedPredicate(recognizer, e) {
        let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
        let msg = "rule " + ruleName + " " + e.message;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This method is called to report a syntax error which requires the removal
     * of a token from the input stream. At the time this method is called, the
     * erroneous symbol is current `LT(1)` symbol and has not yet been
     * removed from the input stream. When this method returns,
     * `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenDeletion} identifies
     * single-token deletion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let tokenName = this.getTokenErrorDisplay(t);
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * This method is called to report a syntax error which requires the
     * insertion of a missing token into the input stream. At the time this
     * method is called, the missing token has not yet been inserted. When this
     * method returns, `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenInsertion} identifies
     * single-token insertion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation attempts to recover from the mismatched input
     * by using single token insertion and deletion as described below. If the
     * recovery attempt fails, this method
     * {@link InputMismatchException}.
     *
     * **EXTRA TOKEN** (single token deletion)
     *
     * `LA(1)` is not what we are looking for. If `LA(2)` has the
     * right token, however, then assume `LA(1)` is some extra spurious
     * token and delete it. Then consume and return the next token (which was
     * the `LA(2)` token) as the successful result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenDeletion}.
     *
     * **MISSING TOKEN** (single token insertion)
     *
     * If current token (at `LA(1)`) is consistent with what could come
     * after the expected `LA(1)` token, then assume the token is missing
     * and use the parser's {@link TokenFactory} to create it on the fly. The
     * "insertion" is performed by returning the created token as the successful
     * result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenInsertion}.
     *
     * **EXAMPLE**
     *
     * For example, Input `i=(3;` is clearly missing the `')'`. When
     * the parser returns from the nested call to `expr`, it will have
     * call chain:
     *
     * ```
     * stat → expr → atom
     * ```
     *
     * and it will be trying to match the `')'` at this point in the
     * derivation:
     *
     * ```
     * => ID '=' '(' INT ')' ('+' atom)* ';'
     *                    ^
     * ```
     *
     * The attempt to match `')'` will fail when it sees `';'` and
     * call {@link #recoverInline}. To recover, it sees that `LA(1)==';'`
     * is in the set of tokens that can follow the `')'` token reference
     * in rule `atom`. It can assume that you forgot the `')'`.
     */ recoverInline(recognizer) {
        // SINGLE TOKEN DELETION
        let matchedSymbol = this.singleTokenDeletion(recognizer);
        if (matchedSymbol) {
            // we have deleted the extra token.
            // now, move past ttype token as if all were ok
            recognizer.consume();
            return matchedSymbol;
        }
        // SINGLE TOKEN INSERTION
        if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
        // even that didn't work; must throw the exception
        if (this.nextTokensContext === undefined) throw new $5jZSY.InputMismatchException(recognizer);
        else throw new $5jZSY.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
    }
    /**
     * This method implements the single-token insertion inline error recovery
     * strategy. It is called by {@link #recoverInline} if the single-token
     * deletion strategy fails to recover from the mismatched input. If this
     * method returns `true`, `recognizer` will be in error recovery
     * mode.
     *
     * This method determines whether or not single-token insertion is viable by
     * checking if the `LA(1)` input symbol could be successfully matched
     * if it were instead the `LA(2)` symbol. If this method returns
     * `true`, the caller is responsible for creating and inserting a
     * token with the correct type to produce this behavior.
     *
     * @param recognizer the parser instance
     * @returns `true` if single-token insertion is a viable recovery
     * strategy for the current mismatched input, otherwise `false`
     */ singleTokenInsertion(recognizer) {
        let currentSymbolType = recognizer.inputStream.LA(1);
        // if current token is consistent with what could come after current
        // ATN state, then we know we're missing a token; error recovery
        // is free to conjure up and insert the missing token
        let currentState = recognizer.interpreter.atn.states[recognizer.state];
        let next = currentState.transition(0).target;
        let atn = recognizer.interpreter.atn;
        let expectingAtLL2 = atn.nextTokens(next, $jaUCz.PredictionContext.fromRuleContext(atn, recognizer.context));
        //		console.warn("LT(2) set="+expectingAtLL2.toString(recognizer.getTokenNames()));
        if (expectingAtLL2.contains(currentSymbolType)) {
            this.reportMissingToken(recognizer);
            return true;
        }
        return false;
    }
    /**
     * This method implements the single-token deletion inline error recovery
     * strategy. It is called by {@link #recoverInline} to attempt to recover
     * from mismatched input. If this method returns `undefined`, the parser and error
     * handler state will not have changed. If this method returns non-`undefined`,
     * `recognizer` will *not* be in error recovery mode since the
     * returned token was a successful match.
     *
     * If the single-token deletion is successful, this method calls
     * {@link #reportUnwantedToken} to report the error, followed by
     * {@link Parser#consume} to actually "delete" the extraneous token. Then,
     * before returning {@link #reportMatch} is called to signal a successful
     * match.
     *
     * @param recognizer the parser instance
     * @returns the successfully matched {@link Token} instance if single-token
     * deletion successfully recovers from the mismatched input, otherwise
     * `undefined`
     */ singleTokenDeletion(recognizer) {
        let nextTokenType = recognizer.inputStream.LA(2);
        let expecting = this.getExpectedTokens(recognizer);
        if (expecting.contains(nextTokenType)) {
            this.reportUnwantedToken(recognizer);
            /*
            System.err.println("recoverFromMismatchedToken deleting "+
                               ((TokenStream)recognizer.inputStream).LT(1)+
                               " since "+((TokenStream)recognizer.inputStream).LT(2)+
                               " is what we want");
            */ recognizer.consume(); // simply delete extra token
            // we want to return the token we're actually matching
            let matchedSymbol = recognizer.currentToken;
            this.reportMatch(recognizer); // we know current token is correct
            return matchedSymbol;
        }
        return undefined;
    }
    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */ getMissingSymbol(recognizer) {
        let currentSymbol = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let expectedTokenType = $eKXi4.Token.INVALID_TYPE;
        if (!expecting.isNil) // get any element
        expectedTokenType = expecting.minElement;
        let tokenText;
        if (expectedTokenType === $eKXi4.Token.EOF) tokenText = "<missing EOF>";
        else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
        let current = currentSymbol;
        let lookback = recognizer.inputStream.tryLT(-1);
        if (current.type === $eKXi4.Token.EOF && lookback != null) current = lookback;
        return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
    }
    constructToken(tokenSource, expectedTokenType, tokenText, current) {
        let factory = tokenSource.tokenFactory;
        let x = current.tokenSource;
        let stream = x ? x.inputStream : undefined;
        return factory.create({
            source: tokenSource,
            stream: stream
        }, expectedTokenType, tokenText, $eKXi4.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
    }
    getExpectedTokens(recognizer) {
        return recognizer.getExpectedTokens();
    }
    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */ getTokenErrorDisplay(t) {
        if (!t) return "<no token>";
        let s = this.getSymbolText(t);
        if (!s) {
            if (this.getSymbolType(t) === $eKXi4.Token.EOF) s = "<EOF>";
            else s = `<${this.getSymbolType(t)}>`;
        }
        return this.escapeWSAndQuote(s);
    }
    getSymbolText(symbol) {
        return symbol.text;
    }
    getSymbolType(symbol) {
        return symbol.type;
    }
    escapeWSAndQuote(s) {
        //		if ( s==null ) return s;
        s = s.replace("\n", "\\n");
        s = s.replace("\r", "\\r");
        s = s.replace("\t", "\\t");
        return "'" + s + "'";
    }
    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. See LinearApproximator.FIRST().
     *  This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various
     *  context-sensitive follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth     follow set       start of rule execution
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    2          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is ']' and in the set, so we would
     *  not consume anything. After printing an error, rule c would
     *  return normally.  Rule b would not find the required '^' though.
     *  At this point, it gets a mismatched token error and
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you can see that the parser walks up the call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implement context-sensitive FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */ getErrorRecoverySet(recognizer) {
        let atn = recognizer.interpreter.atn;
        let ctx = recognizer.context;
        let recoverSet = new $6kdz0.IntervalSet();
        while(ctx && ctx.invokingState >= 0){
            // compute what follows who invoked us
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            let follow = atn.nextTokens(rt.followState);
            recoverSet.addAll(follow);
            ctx = ctx._parent;
        }
        recoverSet.remove($eKXi4.Token.EPSILON);
        //		System.out.println("recover set "+recoverSet.toString(recognizer.getTokenNames()));
        return recoverSet;
    }
    /** Consume tokens until one matches the given token set. */ consumeUntil(recognizer, set) {
        //		System.err.println("consumeUntil("+set.toString(recognizer.getTokenNames())+")");
        let ttype = recognizer.inputStream.LA(1);
        while(ttype !== $eKXi4.Token.EOF && !set.contains(ttype)){
            //System.out.println("consume during recover LA(1)="+getTokenNames()[input.LA(1)]);
            //			recognizer.inputStream.consume();
            recognizer.consume();
            ttype = recognizer.inputStream.LA(1);
        }
    }
}
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reset", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportMatch", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportError", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "recover", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "sync", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "recoverInline", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
module.exports.DefaultErrorStrategy = $2b34ef24d781854a$var$DefaultErrorStrategy;

});
parcelRegister("dv9vN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9d458c7a5aa2e8f5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNState = void 0;

var $aN41m = parcelRequire("aN41m");
const $9d458c7a5aa2e8f5$var$INITIAL_NUM_TRANSITIONS = 4;
/**
 * The following images show the relation of states and
 * {@link ATNState#transitions} for various grammar constructs.
 *
 * * Solid edges marked with an &#0949; indicate a required
 *   {@link EpsilonTransition}.
 *
 * * Dashed edges indicate locations where any transition derived from
 *   {@link Transition} might appear.
 *
 * * Dashed nodes are place holders for either a sequence of linked
 *   {@link BasicState} states or the inclusion of a block representing a nested
 *   construct in one of the forms below.
 *
 * * Nodes showing multiple outgoing alternatives with a `...` support
 *   any number of alternatives (one or more). Nodes without the `...` only
 *   support the exact number of alternatives shown in the diagram.
 *
 * <h2>Basic Blocks</h2>
 *
 * <h3>Rule</h3>
 *
 * <embed src="images/Rule.svg" type="image/svg+xml"/>
 *
 * <h3>Block of 1 or more alternatives</h3>
 *
 * <embed src="images/Block.svg" type="image/svg+xml"/>
 *
 * <h2>Greedy Loops</h2>
 *
 * <h3>Greedy Closure: `(...)*`</h3>
 *
 * <embed src="images/ClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Positive Closure: `(...)+`</h3>
 *
 * <embed src="images/PositiveClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Optional: `(...)?`</h3>
 *
 * <embed src="images/OptionalGreedy.svg" type="image/svg+xml"/>
 *
 * <h2>Non-Greedy Loops</h2>
 *
 * <h3>Non-Greedy Closure: `(...)*?`</h3>
 *
 * <embed src="images/ClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Positive Closure: `(...)+?`</h3>
 *
 * <embed src="images/PositiveClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Optional: `(...)??`</h3>
 *
 * <embed src="images/OptionalNonGreedy.svg" type="image/svg+xml"/>
 */ class $9d458c7a5aa2e8f5$var$ATNState {
    constructor(){
        this.stateNumber = $9d458c7a5aa2e8f5$var$ATNState.INVALID_STATE_NUMBER;
        this.ruleIndex = 0; // at runtime, we don't have Rule objects
        this.epsilonOnlyTransitions = false;
        /** Track the transitions emanating from this ATN state. */ this.transitions = [];
        this.optimizedTransitions = this.transitions;
    }
    /**
     * Gets the state number.
     *
     * @returns the state number
     */ getStateNumber() {
        return this.stateNumber;
    }
    /**
     * For all states except {@link RuleStopState}, this returns the state
     * number. Returns -1 for stop states.
     *
     * @returns -1 for {@link RuleStopState}, otherwise the state number
     */ get nonStopStateNumber() {
        return this.getStateNumber();
    }
    hashCode() {
        return this.stateNumber;
    }
    equals(o) {
        // are these states same object?
        if (o instanceof $9d458c7a5aa2e8f5$var$ATNState) return this.stateNumber === o.stateNumber;
        return false;
    }
    get isNonGreedyExitState() {
        return false;
    }
    toString() {
        return String(this.stateNumber);
    }
    getTransitions() {
        return this.transitions.slice(0);
    }
    get numberOfTransitions() {
        return this.transitions.length;
    }
    addTransition(e, index) {
        if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
        else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
            this.epsilonOnlyTransitions = false;
            throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
        }
        this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
    }
    transition(i) {
        return this.transitions[i];
    }
    setTransition(i, e) {
        this.transitions[i] = e;
    }
    removeTransition(index) {
        return this.transitions.splice(index, 1)[0];
    }
    get onlyHasEpsilonTransitions() {
        return this.epsilonOnlyTransitions;
    }
    setRuleIndex(ruleIndex) {
        this.ruleIndex = ruleIndex;
    }
    get isOptimized() {
        return this.optimizedTransitions !== this.transitions;
    }
    get numberOfOptimizedTransitions() {
        return this.optimizedTransitions.length;
    }
    getOptimizedTransition(i) {
        return this.optimizedTransitions[i];
    }
    addOptimizedTransition(e) {
        if (!this.isOptimized) this.optimizedTransitions = new Array();
        this.optimizedTransitions.push(e);
    }
    setOptimizedTransition(i, e) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions[i] = e;
    }
    removeOptimizedTransition(i) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions.splice(i, 1);
    }
}
$9d458c7a5aa2e8f5$var$__decorate([
    $aN41m.Override
], $9d458c7a5aa2e8f5$var$ATNState.prototype, "hashCode", null);
$9d458c7a5aa2e8f5$var$__decorate([
    $aN41m.Override
], $9d458c7a5aa2e8f5$var$ATNState.prototype, "equals", null);
$9d458c7a5aa2e8f5$var$__decorate([
    $aN41m.Override
], $9d458c7a5aa2e8f5$var$ATNState.prototype, "toString", null);
module.exports.ATNState = $9d458c7a5aa2e8f5$var$ATNState;
(function(ATNState) {
    ATNState.INVALID_STATE_NUMBER = -1;
})($9d458c7a5aa2e8f5$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));

});

parcelRegister("fZESB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNStateType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.4734328-07:00
var $ba4c43613bc5a0e0$var$ATNStateType;
(function(ATNStateType) {
    ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
    ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
    ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
    ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
    ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
    ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
    ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
    ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
    ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
    ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
    ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
    ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
})($ba4c43613bc5a0e0$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));

});

parcelRegister("2quiJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1c4583a876daf8fc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1c4583a876daf8fc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedPredicateException = void 0;

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");

var $j3Sey = parcelRequire("j3Sey");
/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we test a predicate during
 *  prediction.
 */ let $1c4583a876daf8fc$var$FailedPredicateException = class FailedPredicateException extends $b7PPe.RecognitionException {
    constructor(recognizer, predicate, message){
        super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
        let s = recognizer.interpreter.atn.states[recognizer.state];
        let trans = s.transition(0);
        if (trans instanceof $j3Sey.PredicateTransition) {
            this._ruleIndex = trans.ruleIndex;
            this._predicateIndex = trans.predIndex;
        } else {
            this._ruleIndex = 0;
            this._predicateIndex = 0;
        }
        this._predicate = predicate;
        super.setOffendingToken(recognizer, recognizer.currentToken);
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
    get predicateIndex() {
        return this._predicateIndex;
    }
    get predicate() {
        return this._predicate;
    }
    static formatMessage(predicate, message) {
        if (message) return message;
        return `failed predicate: {${predicate}}?`;
    }
};
$1c4583a876daf8fc$var$__decorate([
    $aN41m.NotNull
], $1c4583a876daf8fc$var$FailedPredicateException, "formatMessage", null);
$1c4583a876daf8fc$var$FailedPredicateException = $1c4583a876daf8fc$var$__decorate([
    $1c4583a876daf8fc$var$__param(0, $aN41m.NotNull)
], $1c4583a876daf8fc$var$FailedPredicateException);
module.exports.FailedPredicateException = $1c4583a876daf8fc$var$FailedPredicateException;

});
parcelRegister("b7PPe", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionException = void 0;
/** The root of the ANTLR exception hierarchy. In general, ANTLR tracks just
 *  3 kinds of errors: prediction errors, failed predicate errors, and
 *  mismatched input errors. In each case, the parser knows where it is
 *  in the input, where it is in the ATN, the rule invocation stack,
 *  and what kind of problem occurred.
 */ class $81988c99cb6b26c7$var$RecognitionException extends Error {
    constructor(recognizer, input, ctx, message){
        super(message);
        this._offendingState = -1;
        this._recognizer = recognizer;
        this.input = input;
        this.ctx = ctx;
        if (recognizer) this._offendingState = recognizer.state;
    }
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     *
     * If the state number is not known, this method returns -1.
     */ get offendingState() {
        return this._offendingState;
    }
    setOffendingState(offendingState) {
        this._offendingState = offendingState;
    }
    /**
     * Gets the set of input symbols which could potentially follow the
     * previously matched symbol at the time this exception was thrown.
     *
     * If the set of expected tokens is not known and could not be computed,
     * this method returns `undefined`.
     *
     * @returns The set of token types that could potentially follow the current
     * state in the ATN, or `undefined` if the information is not available.
     */ get expectedTokens() {
        if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
        return undefined;
    }
    /**
     * Gets the {@link RuleContext} at the time this exception was thrown.
     *
     * If the context is not available, this method returns `undefined`.
     *
     * @returns The {@link RuleContext} at the time this exception was thrown.
     * If the context is not available, this method returns `undefined`.
     */ get context() {
        return this.ctx;
    }
    /**
     * Gets the input stream which is the symbol source for the recognizer where
     * this exception was thrown.
     *
     * If the input stream is not available, this method returns `undefined`.
     *
     * @returns The input stream which is the symbol source for the recognizer
     * where this exception was thrown, or `undefined` if the stream is not
     * available.
     */ get inputStream() {
        return this.input;
    }
    getOffendingToken(recognizer) {
        if (recognizer && recognizer !== this._recognizer) return undefined;
        return this.offendingToken;
    }
    setOffendingToken(recognizer, offendingToken) {
        if (recognizer === this._recognizer) this.offendingToken = offendingToken;
    }
    /**
     * Gets the {@link Recognizer} where this exception occurred.
     *
     * If the recognizer is not available, this method returns `undefined`.
     *
     * @returns The recognizer where this exception occurred, or `undefined` if
     * the recognizer is not available.
     */ get recognizer() {
        return this._recognizer;
    }
}
module.exports.RecognitionException = $81988c99cb6b26c7$var$RecognitionException;

});

parcelRegister("j3Sey", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $de085dd8bf5f9774$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $de085dd8bf5f9774$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateTransition = void 0;

var $kvmNv = parcelRequire("kvmNv");

var $aN41m = parcelRequire("aN41m");

var $3JS45 = parcelRequire("3JS45");
/** TODO: this is old comment:
 *  A tree of semantic predicates from the grammar AST if label==SEMPRED.
 *  In the ATN, labels will always be exactly one predicate, but the DFA
 *  may have to combine a bunch of them as it collects predicates from
 *  multiple ATN configurations into a single DFA state.
 */ let $de085dd8bf5f9774$var$PredicateTransition = class PredicateTransition extends $kvmNv.AbstractPredicateTransition {
    constructor(target, ruleIndex, predIndex, isCtxDependent){
        super(target);
        this.ruleIndex = ruleIndex;
        this.predIndex = predIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 4 /* PREDICATE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $3JS45.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
    }
    toString() {
        return "pred_" + this.ruleIndex + ":" + this.predIndex;
    }
};
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "serializationType", null);
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "isEpsilon", null);
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "matches", null);
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "toString", null);
$de085dd8bf5f9774$var$PredicateTransition = $de085dd8bf5f9774$var$__decorate([
    $de085dd8bf5f9774$var$__param(0, $aN41m.NotNull)
], $de085dd8bf5f9774$var$PredicateTransition);
module.exports.PredicateTransition = $de085dd8bf5f9774$var$PredicateTransition;

});
parcelRegister("kvmNv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractPredicateTransition = void 0;

var $5NWCj = parcelRequire("5NWCj");
/**
 *
 * @author Sam Harwell
 */ class $eed8630418e17dbe$var$AbstractPredicateTransition extends $5NWCj.Transition {
    constructor(target){
        super(target);
    }
}
module.exports.AbstractPredicateTransition = $eed8630418e17dbe$var$AbstractPredicateTransition;

});
parcelRegister("5NWCj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $439eff7922051987$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $439eff7922051987$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $aN41m = parcelRequire("aN41m");
/** An ATN transition between any two ATN states.  Subclasses define
 *  atom, set, epsilon, action, predicate, rule transitions.
 *
 *  This is a one way link.  It emanates from a state (usually via a list of
 *  transitions) and has a target state.
 *
 *  Since we never have to change the ATN transitions once we construct it,
 *  we can fix these transitions as specific classes. The DFA transitions
 *  on the other hand need to update the labels as it adds transitions to
 *  the states. We'll use the term Edge for the DFA to distinguish them from
 *  ATN transitions.
 */ let $439eff7922051987$var$Transition = class Transition {
    constructor(target){
        if (target == null) throw new Error("target cannot be null.");
        this.target = target;
    }
    /**
     * Determines if the transition is an "epsilon" transition.
     *
     * The default implementation returns `false`.
     *
     * @returns `true` if traversing this transition in the ATN does not
     * consume an input symbol; otherwise, `false` if traversing this
     * transition consumes (matches) an input symbol.
     */ get isEpsilon() {
        return false;
    }
    get label() {
        return undefined;
    }
};
$439eff7922051987$var$Transition.serializationNames = [
    "INVALID",
    "EPSILON",
    "RANGE",
    "RULE",
    "PREDICATE",
    "ATOM",
    "ACTION",
    "SET",
    "NOT_SET",
    "WILDCARD",
    "PRECEDENCE"
];
$439eff7922051987$var$__decorate([
    $aN41m.NotNull
], $439eff7922051987$var$Transition.prototype, "target", void 0);
$439eff7922051987$var$Transition = $439eff7922051987$var$__decorate([
    $439eff7922051987$var$__param(0, $aN41m.NotNull)
], $439eff7922051987$var$Transition);
module.exports.Transition = $439eff7922051987$var$Transition;

});


parcelRegister("3JS45", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2b8f833777da73eb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2b8f833777da73eb$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticContext = void 0;

var $fsqYw = parcelRequire("fsqYw");

var $6iIjF = parcelRequire("6iIjF");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $62Uvn = parcelRequire("62Uvn");
function $2b8f833777da73eb$var$max(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison < 0) result = current;
    }
    return result;
}
function $2b8f833777da73eb$var$min(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison > 0) result = current;
    }
    return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */ class $2b8f833777da73eb$var$SemanticContext {
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */ static get NONE() {
        if ($2b8f833777da73eb$var$SemanticContext._NONE === undefined) $2b8f833777da73eb$var$SemanticContext._NONE = new $2b8f833777da73eb$var$SemanticContext.Predicate();
        return $2b8f833777da73eb$var$SemanticContext._NONE;
    }
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */ evalPrecedence(parser, parserCallStack) {
        return this;
    }
    static and(a, b) {
        if (!a || a === $2b8f833777da73eb$var$SemanticContext.NONE) return b;
        if (b === $2b8f833777da73eb$var$SemanticContext.NONE) return a;
        let result = new $2b8f833777da73eb$var$SemanticContext.AND(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */ static or(a, b) {
        if (!a) return b;
        if (a === $2b8f833777da73eb$var$SemanticContext.NONE || b === $2b8f833777da73eb$var$SemanticContext.NONE) return $2b8f833777da73eb$var$SemanticContext.NONE;
        let result = new $2b8f833777da73eb$var$SemanticContext.OR(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
}
module.exports.SemanticContext = $2b8f833777da73eb$var$SemanticContext;
(function(SemanticContext) {
    /**
     * This random 30-bit prime represents the value of `AND.class.hashCode()`.
     */ const AND_HASHCODE = 40363613;
    /**
     * This random 30-bit prime represents the value of `OR.class.hashCode()`.
     */ const OR_HASHCODE = 486279973;
    function filterPrecedencePredicates(collection) {
        let result = [];
        for(let i = 0; i < collection.length; i++){
            let context = collection[i];
            if (context instanceof SemanticContext.PrecedencePredicate) {
                result.push(context);
                // Remove the item from 'collection' and move i back so we look at the same index again
                collection.splice(i, 1);
                i--;
            }
        }
        return result;
    }
    class Predicate extends SemanticContext {
        constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
            super();
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        eval(parser, parserCallStack) {
            let localctx = this.isCtxDependent ? parserCallStack : undefined;
            return parser.sempred(localctx, this.ruleIndex, this.predIndex);
        }
        hashCode() {
            let hashCode = $amQx9.MurmurHash.initialize();
            hashCode = $amQx9.MurmurHash.update(hashCode, this.ruleIndex);
            hashCode = $amQx9.MurmurHash.update(hashCode, this.predIndex);
            hashCode = $amQx9.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
            hashCode = $amQx9.MurmurHash.finish(hashCode, 3);
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof Predicate)) return false;
            if (this === obj) return true;
            return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
        }
        toString() {
            return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
        }
    }
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "toString", null);
    SemanticContext.Predicate = Predicate;
    class PrecedencePredicate extends SemanticContext {
        constructor(precedence){
            super();
            this.precedence = precedence;
        }
        eval(parser, parserCallStack) {
            return parser.precpred(parserCallStack, this.precedence);
        }
        evalPrecedence(parser, parserCallStack) {
            if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
            else return undefined;
        }
        compareTo(o) {
            return this.precedence - o.precedence;
        }
        hashCode() {
            let hashCode = 1;
            hashCode = 31 * hashCode + this.precedence;
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof PrecedencePredicate)) return false;
            if (this === obj) return true;
            return this.precedence === obj.precedence;
        }
        toString() {
            return "{" + this.precedence + ">=prec}?";
        }
    }
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "evalPrecedence", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "compareTo", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "toString", null);
    SemanticContext.PrecedencePredicate = PrecedencePredicate;
    /**
     * This is the base class for semantic context "operators", which operate on
     * a collection of semantic context "operands".
     *
     * @since 4.3
     */ class Operator extends SemanticContext {
    }
    SemanticContext.Operator = Operator;
    /**
     * A semantic context which is true whenever none of the contained contexts
     * is false.
     */ let AND = class AND extends Operator {
        constructor(a, b){
            super();
            let operands = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
            if (a instanceof AND) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof AND) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the lowest precedence
            let reduced = $2b8f833777da73eb$var$min(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof AND)) return false;
            return $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $amQx9.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (!opnd.eval(parser, parserCallStack)) return false;
            }
            return true;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated == null) // The AND context is false if any element is false
                return undefined;
                else if (evaluated !== SemanticContext.NONE) // Reduce the result by skipping true elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were true, so the AND context is true
            return SemanticContext.NONE;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
            return result;
        }
        toString() {
            return $62Uvn.join(this.opnds, "&&");
        }
    };
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "operands", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "evalPrecedence", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "toString", null);
    AND = $2b8f833777da73eb$var$__decorate([
        $2b8f833777da73eb$var$__param(0, $aN41m.NotNull),
        $2b8f833777da73eb$var$__param(1, $aN41m.NotNull)
    ], AND);
    SemanticContext.AND = AND;
    /**
     * A semantic context which is true whenever at least one of the contained
     * contexts is true.
     */ let OR = class OR extends Operator {
        constructor(a, b){
            super();
            let operands = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
            if (a instanceof OR) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof OR) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the highest precedence
            let reduced = $2b8f833777da73eb$var$max(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof OR)) return false;
            return $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $amQx9.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (opnd.eval(parser, parserCallStack)) return true;
            }
            return false;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated === SemanticContext.NONE) // The OR context is true if any element is true
                return SemanticContext.NONE;
                else if (evaluated) // Reduce the result by skipping false elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were false, so the OR context is false
            return undefined;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
            return result;
        }
        toString() {
            return $62Uvn.join(this.opnds, "||");
        }
    };
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "operands", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "evalPrecedence", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "toString", null);
    OR = $2b8f833777da73eb$var$__decorate([
        $2b8f833777da73eb$var$__param(0, $aN41m.NotNull),
        $2b8f833777da73eb$var$__param(1, $aN41m.NotNull)
    ], OR);
    SemanticContext.OR = OR;
})($2b8f833777da73eb$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));

});
parcelRegister("fsqYw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b40e65386248425a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b40e65386248425a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashSet = void 0;

var $fomfP = parcelRequire("fomfP");

var $aGZuj = parcelRequire("aGZuj");

var $aN41m = parcelRequire("aN41m");

var $amQx9 = parcelRequire("amQx9");
/** {@link Set} implementation with closed hashing (open addressing). */ // NOTE:  JavaScript's Set interface has on significant different diffrence from Java's:
// 		  e.g. the return type of add() differs!
//        For this reason I've commented tweaked the implements clause
const $b40e65386248425a$var$INITAL_CAPACITY = 16; // must be power of 2
const $b40e65386248425a$var$LOAD_FACTOR = 0.75;
class $b40e65386248425a$var$Array2DHashSet {
    constructor(comparatorOrSet, initialCapacity = $b40e65386248425a$var$INITAL_CAPACITY){
        /** How many elements in set */ this.n = 0;
        this.threshold = Math.floor($b40e65386248425a$var$INITAL_CAPACITY * $b40e65386248425a$var$LOAD_FACTOR); // when to expand
        if (comparatorOrSet instanceof $b40e65386248425a$var$Array2DHashSet) {
            this.comparator = comparatorOrSet.comparator;
            this.buckets = comparatorOrSet.buckets.slice(0);
            for(let i = 0; i < this.buckets.length; i++){
                let bucket = this.buckets[i];
                if (bucket) this.buckets[i] = bucket.slice(0);
            }
            this.n = comparatorOrSet.n;
            this.threshold = comparatorOrSet.threshold;
        } else {
            this.comparator = comparatorOrSet || $aGZuj.DefaultEqualityComparator.INSTANCE;
            this.buckets = this.createBuckets(initialCapacity);
        }
    }
    /**
     * Add `o` to set if not there; return existing value if already
     * there. This method performs the same operation as {@link #add} aside from
     * the return value.
     */ getOrAdd(o) {
        if (this.n > this.threshold) this.expand();
        return this.getOrAddImpl(o);
    }
    getOrAddImpl(o) {
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        // NEW BUCKET
        if (!bucket) {
            bucket = [
                o
            ];
            this.buckets[b] = bucket;
            this.n++;
            return o;
        }
        // LOOK FOR IT IN BUCKET
        for (let existing of bucket){
            if (this.comparator.equals(existing, o)) return existing; // found existing, quit
        }
        // FULL BUCKET, expand and add to end
        bucket.push(o);
        this.n++;
        return o;
    }
    get(o) {
        if (o == null) return o;
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        if (!bucket) // no bucket
        return undefined;
        for (let e of bucket){
            if (this.comparator.equals(e, o)) return e;
        }
        return undefined;
    }
    getBucket(o) {
        let hash = this.comparator.hashCode(o);
        let b = hash & this.buckets.length - 1; // assumes len is power of 2
        return b;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                hash = $amQx9.MurmurHash.update(hash, this.comparator.hashCode(o));
            }
        }
        hash = $amQx9.MurmurHash.finish(hash, this.size);
        return hash;
    }
    equals(o) {
        if (o === this) return true;
        if (!(o instanceof $b40e65386248425a$var$Array2DHashSet)) return false;
        if (o.size !== this.size) return false;
        let same = this.containsAll(o);
        return same;
    }
    expand() {
        let old = this.buckets;
        let newCapacity = this.buckets.length * 2;
        let newTable = this.createBuckets(newCapacity);
        this.buckets = newTable;
        this.threshold = Math.floor(newCapacity * $b40e65386248425a$var$LOAD_FACTOR);
        //		System.out.println("new size="+newCapacity+", thres="+threshold);
        // rehash all existing entries
        let oldSize = this.size;
        for (let bucket of old){
            if (!bucket) continue;
            for (let o of bucket){
                let b = this.getBucket(o);
                let newBucket = this.buckets[b];
                if (!newBucket) {
                    newBucket = [];
                    this.buckets[b] = newBucket;
                }
                newBucket.push(o);
            }
        }
        $fomfP(this.n === oldSize);
    }
    add(t) {
        let existing = this.getOrAdd(t);
        return existing === t;
    }
    get size() {
        return this.n;
    }
    get isEmpty() {
        return this.n === 0;
    }
    contains(o) {
        return this.containsFast(this.asElementType(o));
    }
    containsFast(obj) {
        if (obj == null) return false;
        return this.get(obj) != null;
    }
    *[Symbol.iterator]() {
        yield* this.toArray();
    }
    toArray() {
        const a = new Array(this.size);
        // Copy elements from the nested arrays into the destination array
        let i = 0; // Position within destination array
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                a[i++] = o;
            }
        }
        return a;
    }
    containsAll(collection) {
        if (collection instanceof $b40e65386248425a$var$Array2DHashSet) {
            let s = collection;
            for (let bucket of s.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (!this.containsFast(this.asElementType(o))) return false;
                }
            }
        } else for (let o of collection){
            if (!this.containsFast(this.asElementType(o))) return false;
        }
        return true;
    }
    addAll(c) {
        let changed = false;
        for (let o of c){
            let existing = this.getOrAdd(o);
            if (existing !== o) changed = true;
        }
        return changed;
    }
    clear() {
        this.buckets = this.createBuckets($b40e65386248425a$var$INITAL_CAPACITY);
        this.n = 0;
        this.threshold = Math.floor($b40e65386248425a$var$INITAL_CAPACITY * $b40e65386248425a$var$LOAD_FACTOR);
    }
    toString() {
        if (this.size === 0) return "{}";
        let buf = "{";
        let first = true;
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                if (first) first = false;
                else buf += ", ";
                buf += o.toString();
            }
        }
        buf += "}";
        return buf;
    }
    toTableString() {
        let buf = "";
        for (let bucket of this.buckets){
            if (bucket == null) {
                buf += "null\n";
                continue;
            }
            buf += "[";
            let first = true;
            for (let o of bucket){
                if (first) first = false;
                else buf += " ";
                if (o == null) buf += "_";
                else buf += o.toString();
            }
            buf += "]\n";
        }
        return buf;
    }
    /**
     * Return `o` as an instance of the element type `T`. If
     * `o` is non-undefined but known to not be an instance of `T`, this
     * method returns `undefined`. The base implementation does not perform any
     * type checks; override this method to provide strong type checks for the
     * {@link #contains} and {@link #remove} methods to ensure the arguments to
     * the {@link EqualityComparator} for the set always have the expected
     * types.
     *
     * @param o the object to try and cast to the element type of the set
     * @returns `o` if it could be an instance of `T`, otherwise
     * `undefined`.
     */ asElementType(o) {
        return o;
    }
    /**
     * Return an array of `T[]` with length `capacity`.
     *
     * @param capacity the length of the array to return
     * @returns the newly constructed array
     */ createBuckets(capacity) {
        return new Array(capacity);
    }
}
$b40e65386248425a$var$__decorate([
    $aN41m.NotNull
], $b40e65386248425a$var$Array2DHashSet.prototype, "comparator", void 0);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "hashCode", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "equals", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "add", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "size", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "isEmpty", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "contains", null);
$b40e65386248425a$var$__decorate([
    $b40e65386248425a$var$__param(0, $aN41m.Nullable)
], $b40e65386248425a$var$Array2DHashSet.prototype, "containsFast", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, Symbol.iterator, null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "toArray", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "containsAll", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "addAll", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "clear", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "toString", null);
$b40e65386248425a$var$__decorate([
    $aN41m.SuppressWarnings("unchecked")
], $b40e65386248425a$var$Array2DHashSet.prototype, "asElementType", null);
$b40e65386248425a$var$__decorate([
    $aN41m.SuppressWarnings("unchecked")
], $b40e65386248425a$var$Array2DHashSet.prototype, "createBuckets", null);
module.exports.Array2DHashSet = $b40e65386248425a$var$Array2DHashSet;

});
parcelRegister("aGZuj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7c8d85d29b04f35b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEqualityComparator = void 0;

var $aN41m = parcelRequire("aN41m");

var $amQx9 = parcelRequire("amQx9");

var $9eW9B = parcelRequire("9eW9B");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $7c8d85d29b04f35b$var$DefaultEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        else if (typeof obj === "string" || typeof obj === "number") return $amQx9.MurmurHash.hashCode([
            obj
        ]);
        else return $9eW9B.ObjectEqualityComparator.INSTANCE.hashCode(obj);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (typeof a === "string" || typeof a === "number") return a === b;
        else return $9eW9B.ObjectEqualityComparator.INSTANCE.equals(a, b);
    }
}
$7c8d85d29b04f35b$var$DefaultEqualityComparator.INSTANCE = new $7c8d85d29b04f35b$var$DefaultEqualityComparator();
$7c8d85d29b04f35b$var$__decorate([
    $aN41m.Override
], $7c8d85d29b04f35b$var$DefaultEqualityComparator.prototype, "hashCode", null);
$7c8d85d29b04f35b$var$__decorate([
    $aN41m.Override
], $7c8d85d29b04f35b$var$DefaultEqualityComparator.prototype, "equals", null);
module.exports.DefaultEqualityComparator = $7c8d85d29b04f35b$var$DefaultEqualityComparator;

});
parcelRegister("amQx9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MurmurHash = void 0;
/**
 *
 * @author Sam Harwell
 */ var $78c4b58c32e2212f$var$MurmurHash;
(function(MurmurHash) {
    const DEFAULT_SEED = 0;
    /**
     * Initialize the hash using the specified `seed`.
     *
     * @param seed the seed (optional)
     * @returns the intermediate hash value
     */ function initialize(seed = DEFAULT_SEED) {
        return seed;
    }
    MurmurHash.initialize = initialize;
    /**
     * Update the intermediate hash value for the next input `value`.
     *
     * @param hash the intermediate hash value
     * @param value the value to add to the current hash
     * @returns the updated intermediate hash value
     */ function update(hash, value) {
        const c1 = 0xCC9E2D51;
        const c2 = 0x1B873593;
        const r1 = 15;
        const r2 = 13;
        const m = 5;
        const n = 0xE6546B64;
        if (value == null) value = 0;
        else if (typeof value === "string") value = hashString(value);
        else if (typeof value === "object") value = value.hashCode();
        let k = value;
        k = Math.imul(k, c1);
        k = k << r1 | k >>> 32 - r1;
        k = Math.imul(k, c2);
        hash = hash ^ k;
        hash = hash << r2 | hash >>> 32 - r2;
        hash = Math.imul(hash, m) + n;
        return hash & 0xFFFFFFFF;
    }
    MurmurHash.update = update;
    /**
     * Apply the final computation steps to the intermediate value `hash`
     * to form the final result of the MurmurHash 3 hash function.
     *
     * @param hash the intermediate hash value
     * @param numberOfWords the number of integer values added to the hash
     * @returns the final hash result
     */ function finish(hash, numberOfWords) {
        hash = hash ^ numberOfWords * 4;
        hash = hash ^ hash >>> 16;
        hash = Math.imul(hash, 0x85EBCA6B);
        hash = hash ^ hash >>> 13;
        hash = Math.imul(hash, 0xC2B2AE35);
        hash = hash ^ hash >>> 16;
        return hash;
    }
    MurmurHash.finish = finish;
    /**
     * Utility function to compute the hash code of an array using the
     * MurmurHash algorithm.
     *
     * @param <T> the array element type
     * @param data the array data
     * @param seed the seed for the MurmurHash algorithm
     * @returns the hash code of the data
     */ function hashCode(data, seed = DEFAULT_SEED) {
        let hash = initialize(seed);
        let length = 0;
        for (let value of data){
            hash = update(hash, value);
            length++;
        }
        hash = finish(hash, length);
        return hash;
    }
    MurmurHash.hashCode = hashCode;
    /**
     * Function to hash a string. Based on the implementation found here:
     * http://stackoverflow.com/a/7616484
     */ function hashString(str) {
        let len = str.length;
        if (len === 0) return 0;
        let hash = 0;
        for(let i = 0; i < len; i++){
            let c = str.charCodeAt(i);
            hash = (hash << 5 >>> 0) - hash + c;
            hash |= 0;
        }
        return hash;
    }
})($78c4b58c32e2212f$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));

});

parcelRegister("9eW9B", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6ba288078a70e293$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectEqualityComparator = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $6ba288078a70e293$var$ObjectEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return obj.hashCode();
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        return a.equals(b);
    }
}
$6ba288078a70e293$var$ObjectEqualityComparator.INSTANCE = new $6ba288078a70e293$var$ObjectEqualityComparator();
$6ba288078a70e293$var$__decorate([
    $aN41m.Override
], $6ba288078a70e293$var$ObjectEqualityComparator.prototype, "hashCode", null);
$6ba288078a70e293$var$__decorate([
    $aN41m.Override
], $6ba288078a70e293$var$ObjectEqualityComparator.prototype, "equals", null);
module.exports.ObjectEqualityComparator = $6ba288078a70e293$var$ObjectEqualityComparator;

});



parcelRegister("6iIjF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4966cccca723aa26$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayEqualityComparator = void 0;

var $aN41m = parcelRequire("aN41m");

var $amQx9 = parcelRequire("amQx9");

var $9eW9B = parcelRequire("9eW9B");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $4966cccca723aa26$var$ArrayEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return $amQx9.MurmurHash.hashCode(obj, 0);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined`, this method returns `true`. Otherwise if only
     * `a` is `undefined`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (b == null) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$9eW9B.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
        }
        return true;
    }
}
$4966cccca723aa26$var$ArrayEqualityComparator.INSTANCE = new $4966cccca723aa26$var$ArrayEqualityComparator();
$4966cccca723aa26$var$__decorate([
    $aN41m.Override
], $4966cccca723aa26$var$ArrayEqualityComparator.prototype, "hashCode", null);
$4966cccca723aa26$var$__decorate([
    $aN41m.Override
], $4966cccca723aa26$var$ArrayEqualityComparator.prototype, "equals", null);
module.exports.ArrayEqualityComparator = $4966cccca723aa26$var$ArrayEqualityComparator;

});

parcelRegister("62Uvn", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
function $466ec2b4a094d7df$var$escapeWhitespace(s, escapeSpaces) {
    return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
}
module.exports.escapeWhitespace = $466ec2b4a094d7df$var$escapeWhitespace;
// Seriously: why isn't this built in to java? ugh!
function $466ec2b4a094d7df$var$join(collection, separator) {
    let buf = "";
    let first = true;
    for (let current of collection){
        if (first) first = false;
        else buf += separator;
        buf += current;
    }
    return buf;
}
module.exports.join = $466ec2b4a094d7df$var$join;
function $466ec2b4a094d7df$var$equals(x, y) {
    if (x === y) return true;
    if (x === undefined || y === undefined) return false;
    return x.equals(y);
}
module.exports.equals = $466ec2b4a094d7df$var$equals;
// export function numNonnull(data: any[]): number {
// 	let n: number =  0;
// 	if ( data == null ) return n;
// 	for (let o of data) {
// 		if ( o!=null ) n++;
// 	}
// 	return n;
// }
// export function removeAllElements<T>(data: Collection<T>, value: T): void {
// 	if ( data==null ) return;
// 	while ( data.contains(value) ) data.remove(value);
// }
// export function writeFile(@NotNull file: File, @NotNull content: Uint8Array): void {
// 	let fos: FileOutputStream = new FileOutputStream(file);
// 	try {
// 		fos.write(content);
// 	} finally {
// 		fos.close();
// 	}
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string): void {
// 	writeFile(fileName, content, null);
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string, @Nullable encoding: string): void {
// 	let f: File =  new File(fileName);
// 	let fos: FileOutputStream =  new FileOutputStream(f);
// 	let osw: OutputStreamWriter;
// 	if (encoding != null) {
// 		osw = new OutputStreamWriter(fos, encoding);
// 	}
// 	else {
// 		osw = new OutputStreamWriter(fos);
// 	}
// 	try {
// 		osw.write(content);
// 	}
// 	finally {
// 		osw.close();
// 	}
// }
// @NotNull
// export function readFile(@NotNull fileName: string): char[] {
// 	return readFile(fileName, null);
// }
// @NotNull
// export function readFile(@NotNull fileName: string, @Nullable encoding: string): char[] {
// 	let f: File =  new File(fileName);
// 	let size: number =  (int)f.length();
// 	let isr: InputStreamReader;
// 	let fis: FileInputStream =  new FileInputStream(fileName);
// 	if ( encoding!=null ) {
// 		isr = new InputStreamReader(fis, encoding);
// 	}
// 	else {
// 		isr = new InputStreamReader(fis);
// 	}
// 	let data: char[] =  null;
// 	try {
// 		data = new char[size];
// 		let n: number =  isr.read(data);
// 		if (n < data.length) {
// 			data = Arrays.copyOf(data, n);
// 		}
// 	}
// 	finally {
// 		isr.close();
// 	}
// 	return data;
// }
// export function removeAll<T>(@NotNull predicate: List<T> list,@NotNull Predicate<? super T>): void {
// 	let j: number =  0;
// 	for (let i = 0; i < list.size; i++) {
// 		let item: T =  list.get(i);
// 		if (!predicate.eval(item)) {
// 			if (j != i) {
// 				list.set(j, item);
// 			}
// 			j++;
// 		}
// 	}
// 	if (j < list.size) {
// 		list.subList(j, list.size).clear();
// 	}
// }
// export function removeAll<T>(@NotNull predicate: Iterable<T> iterable,@NotNull Predicate<? super T>): void {
// 	if (iterable instanceof List<?>) {
// 		removeAll((List<T>)iterable, predicate);
// 		return;
// 	}
// 	for (Iterator<T> iterator = iterable.iterator(); iterator.hasNext(); ) {
// 		let item: T =  iterator.next();
// 		if (predicate.eval(item)) {
// 			iterator.remove();
// 		}
// 	}
// }
/** Convert array of strings to string&rarr;index map. Useful for
 *  converting rulenames to name&rarr;ruleindex map.
 */ function $466ec2b4a094d7df$var$toMap(keys) {
    let m = new Map();
    for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
    return m;
}
module.exports.toMap = $466ec2b4a094d7df$var$toMap;
function $466ec2b4a094d7df$var$toCharArray(str) {
    if (typeof str === "string") {
        let result = new Uint16Array(str.length);
        for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
        return result;
    } else return str.toCharArray();
}
module.exports.toCharArray = $466ec2b4a094d7df$var$toCharArray; // /**
 // 	* @since 4.5
 // 	*/
 // @NotNull
 // export function toSet(@NotNull bits: BitSet): IntervalSet {
 // 	let s: IntervalSet =  new IntervalSet();
 // 	let i: number =  bits.nextSetBit(0);
 // 	while ( i >= 0 ) {
 // 		s.add(i);
 // 		i = bits.nextSetBit(i+1);
 // 	}
 // 	return s;
 // }

});




parcelRegister("5jZSY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3dfebb51130d9868$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3dfebb51130d9868$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputMismatchException = void 0;

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");
/** This signifies any kind of mismatched input exceptions such as
 *  when the current input does not match the expected token.
 */ let $3dfebb51130d9868$var$InputMismatchException = class InputMismatchException extends $b7PPe.RecognitionException {
    constructor(recognizer, state, context){
        if (context === undefined) context = recognizer.context;
        super(recognizer, recognizer.inputStream, context);
        if (state !== undefined) this.setOffendingState(state);
        this.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$3dfebb51130d9868$var$InputMismatchException = $3dfebb51130d9868$var$__decorate([
    $3dfebb51130d9868$var$__param(0, $aN41m.NotNull)
], $3dfebb51130d9868$var$InputMismatchException);
module.exports.InputMismatchException = $3dfebb51130d9868$var$InputMismatchException;

});

parcelRegister("6kdz0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $49af21c6dd39b813$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $49af21c6dd39b813$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntervalSet = void 0;

var $6iIjF = parcelRequire("6iIjF");

var $eRSlM = parcelRequire("eRSlM");

var $l8y5T = parcelRequire("l8y5T");

var $h7Q3L = parcelRequire("h7Q3L");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This class implements the {@link IntSet} backed by a sorted array of
 * non-overlapping intervals. It is particularly efficient for representing
 * large collections of numbers, where the majority of elements appear as part
 * of a sequential range of numbers that are all part of the set. For example,
 * the set { 1, 2, 3, 4, 7, 8 } may be represented as { [1, 4], [7, 8] }.
 *
 * This class is able to represent sets containing any combination of values in
 * the range {@link Integer#MIN_VALUE} to {@link Integer#MAX_VALUE}
 * (inclusive).
 */ class $49af21c6dd39b813$var$IntervalSet {
    constructor(intervals){
        this.readonly = false;
        if (intervals != null) this._intervals = intervals.slice(0);
        else this._intervals = [];
    }
    static get COMPLETE_CHAR_SET() {
        if ($49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
            $49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET = $49af21c6dd39b813$var$IntervalSet.of($h7Q3L.Lexer.MIN_CHAR_VALUE, $h7Q3L.Lexer.MAX_CHAR_VALUE);
            $49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
        }
        return $49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET;
    }
    static get EMPTY_SET() {
        if ($49af21c6dd39b813$var$IntervalSet._EMPTY_SET == null) {
            $49af21c6dd39b813$var$IntervalSet._EMPTY_SET = new $49af21c6dd39b813$var$IntervalSet();
            $49af21c6dd39b813$var$IntervalSet._EMPTY_SET.setReadonly(true);
        }
        return $49af21c6dd39b813$var$IntervalSet._EMPTY_SET;
    }
    /**
     * Create a set with all ints within range [a..b] (inclusive). If b is omitted, the set contains the single element
     * a.
     */ static of(a, b = a) {
        let s = new $49af21c6dd39b813$var$IntervalSet();
        s.add(a, b);
        return s;
    }
    clear() {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        this._intervals.length = 0;
    }
    /** Add interval; i.e., add all integers from a to b to set.
     *  If b&lt;a, do nothing.
     *  Keep list in sorted order (by left range value).
     *  If overlap, combine ranges.  For example,
     *  If this is {1..5, 10..20}, adding 6..7 yields
     *  {1..5, 6..7, 10..20}.  Adding 4..8 yields {1..8, 10..20}.
     */ add(a, b = a) {
        this.addRange($l8y5T.Interval.of(a, b));
    }
    // copy on write so we can cache a..a intervals and sets of that
    addRange(addition) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        //System.out.println("add "+addition+" to "+intervals.toString());
        if (addition.b < addition.a) return;
        // find position in list
        // Use iterators as we modify list in place
        for(let i = 0; i < this._intervals.length; i++){
            let r = this._intervals[i];
            if (addition.equals(r)) return;
            if (addition.adjacent(r) || !addition.disjoint(r)) {
                // next to each other, make a single larger interval
                let bigger = addition.union(r);
                this._intervals[i] = bigger;
                // make sure we didn't just create an interval that
                // should be merged with next interval in list
                while(i < this._intervals.length - 1){
                    i++;
                    let next = this._intervals[i];
                    if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                    // if we bump up against or overlap next, merge
                    // remove this one
                    this._intervals.splice(i, 1);
                    i--;
                    // move backwards to what we just set
                    this._intervals[i] = bigger.union(next);
                // set to 3 merged ones
                }
                // first call to next after previous duplicates the result
                return;
            }
            if (addition.startsBeforeDisjoint(r)) {
                // insert before r
                this._intervals.splice(i, 0, addition);
                return;
            }
        // if disjoint and after r, a future iteration will handle it
        }
        // ok, must be after last interval (and disjoint from last interval)
        // just add it
        this._intervals.push(addition);
    }
    /** combine all sets in the array returned the or'd value */ static or(sets) {
        let r = new $49af21c6dd39b813$var$IntervalSet();
        for (let s of sets)r.addAll(s);
        return r;
    }
    addAll(set) {
        if (set == null) return this;
        if (set instanceof $49af21c6dd39b813$var$IntervalSet) {
            let other = set;
            // walk set and add each interval
            let n = other._intervals.length;
            for(let i = 0; i < n; i++){
                let I = other._intervals[i];
                this.add(I.a, I.b);
            }
        } else for (let value of set.toArray())this.add(value);
        return this;
    }
    complementRange(minElement, maxElement) {
        return this.complement($49af21c6dd39b813$var$IntervalSet.of(minElement, maxElement));
    }
    /** {@inheritDoc} */ complement(vocabulary) {
        if (vocabulary.isNil) // nothing in common with null set
        return $49af21c6dd39b813$var$IntervalSet.EMPTY_SET;
        let vocabularyIS;
        if (vocabulary instanceof $49af21c6dd39b813$var$IntervalSet) vocabularyIS = vocabulary;
        else {
            vocabularyIS = new $49af21c6dd39b813$var$IntervalSet();
            vocabularyIS.addAll(vocabulary);
        }
        return vocabularyIS.subtract(this);
    }
    subtract(a) {
        if (a == null || a.isNil) return new $49af21c6dd39b813$var$IntervalSet(this._intervals);
        if (a instanceof $49af21c6dd39b813$var$IntervalSet) return $49af21c6dd39b813$var$IntervalSet.subtract(this, a);
        let other = new $49af21c6dd39b813$var$IntervalSet();
        other.addAll(a);
        return $49af21c6dd39b813$var$IntervalSet.subtract(this, other);
    }
    /**
     * Compute the set difference between two interval sets. The specific
     * operation is `left - right`.
     */ static subtract(left, right) {
        if (left.isNil) return new $49af21c6dd39b813$var$IntervalSet();
        let result = new $49af21c6dd39b813$var$IntervalSet(left._intervals);
        if (right.isNil) // right set has no elements; just return the copy of the current set
        return result;
        let resultI = 0;
        let rightI = 0;
        while(resultI < result._intervals.length && rightI < right._intervals.length){
            let resultInterval = result._intervals[resultI];
            let rightInterval = right._intervals[rightI];
            // operation: (resultInterval - rightInterval) and update indexes
            if (rightInterval.b < resultInterval.a) {
                rightI++;
                continue;
            }
            if (rightInterval.a > resultInterval.b) {
                resultI++;
                continue;
            }
            let beforeCurrent;
            let afterCurrent;
            if (rightInterval.a > resultInterval.a) beforeCurrent = new $l8y5T.Interval(resultInterval.a, rightInterval.a - 1);
            if (rightInterval.b < resultInterval.b) afterCurrent = new $l8y5T.Interval(rightInterval.b + 1, resultInterval.b);
            if (beforeCurrent) {
                if (afterCurrent) {
                    // split the current interval into two
                    result._intervals[resultI] = beforeCurrent;
                    result._intervals.splice(resultI + 1, 0, afterCurrent);
                    resultI++;
                    rightI++;
                    continue;
                } else {
                    // replace the current interval
                    result._intervals[resultI] = beforeCurrent;
                    resultI++;
                    continue;
                }
            } else if (afterCurrent) {
                // replace the current interval
                result._intervals[resultI] = afterCurrent;
                rightI++;
                continue;
            } else {
                // remove the current interval (thus no need to increment resultI)
                result._intervals.splice(resultI, 1);
                continue;
            }
        }
        // If rightI reached right.intervals.size, no more intervals to subtract from result.
        // If resultI reached result.intervals.size, we would be subtracting from an empty set.
        // Either way, we are done.
        return result;
    }
    or(a) {
        let o = new $49af21c6dd39b813$var$IntervalSet();
        o.addAll(this);
        o.addAll(a);
        return o;
    }
    /** {@inheritDoc} */ and(other) {
        if (other.isNil) // nothing in common with null set
        return new $49af21c6dd39b813$var$IntervalSet();
        let myIntervals = this._intervals;
        let theirIntervals = other._intervals;
        let intersection;
        let mySize = myIntervals.length;
        let theirSize = theirIntervals.length;
        let i = 0;
        let j = 0;
        // iterate down both interval lists looking for nondisjoint intervals
        while(i < mySize && j < theirSize){
            let mine = myIntervals[i];
            let theirs = theirIntervals[j];
            //System.out.println("mine="+mine+" and theirs="+theirs);
            if (mine.startsBeforeDisjoint(theirs)) // move this iterator looking for interval that might overlap
            i++;
            else if (theirs.startsBeforeDisjoint(mine)) // move other iterator looking for interval that might overlap
            j++;
            else if (mine.properlyContains(theirs)) {
                // overlap, add intersection, get next theirs
                if (!intersection) intersection = new $49af21c6dd39b813$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                j++;
            } else if (theirs.properlyContains(mine)) {
                // overlap, add intersection, get next mine
                if (!intersection) intersection = new $49af21c6dd39b813$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                i++;
            } else if (!mine.disjoint(theirs)) {
                // overlap, add intersection
                if (!intersection) intersection = new $49af21c6dd39b813$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                // Move the iterator of lower range [a..b], but not
                // the upper range as it may contain elements that will collide
                // with the next iterator. So, if mine=[0..115] and
                // theirs=[115..200], then intersection is 115 and move mine
                // but not theirs as theirs may collide with the next range
                // in thisIter.
                // move both iterators to next ranges
                if (mine.startsAfterNonDisjoint(theirs)) j++;
                else if (theirs.startsAfterNonDisjoint(mine)) i++;
            }
        }
        if (!intersection) return new $49af21c6dd39b813$var$IntervalSet();
        return intersection;
    }
    /** {@inheritDoc} */ contains(el) {
        let n = this._intervals.length;
        let l = 0;
        let r = n - 1;
        // Binary search for the element in the (sorted, disjoint) array of intervals.
        while(l <= r){
            let m = l + r >> 1;
            let I = this._intervals[m];
            let a = I.a;
            let b = I.b;
            if (b < el) l = m + 1;
            else if (a > el) r = m - 1;
            else // el >= a && el <= b
            return true;
        }
        return false;
    }
    /** {@inheritDoc} */ get isNil() {
        return this._intervals == null || this._intervals.length === 0;
    }
    /**
     * Returns the maximum value contained in the set if not isNil.
     *
     * @return the maximum value contained in the set.
     * @throws RangeError if set is empty
     */ get maxElement() {
        if (this.isNil) throw new RangeError("set is empty");
        let last = this._intervals[this._intervals.length - 1];
        return last.b;
    }
    /**
     * Returns the minimum value contained in the set if not isNil.
     *
     * @return the minimum value contained in the set.
     * @throws RangeError if set is empty
     */ get minElement() {
        if (this.isNil) throw new RangeError("set is empty");
        return this._intervals[0].a;
    }
    /** Return a list of Interval objects. */ get intervals() {
        return this._intervals;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        for (let I of this._intervals){
            hash = $amQx9.MurmurHash.update(hash, I.a);
            hash = $amQx9.MurmurHash.update(hash, I.b);
        }
        hash = $amQx9.MurmurHash.finish(hash, this._intervals.length * 2);
        return hash;
    }
    /** Are two IntervalSets equal?  Because all intervals are sorted
     *  and disjoint, equals is a simple linear walk over both lists
     *  to make sure they are the same.  Interval.equals() is used
     *  by the List.equals() method to check the ranges.
     */ equals(o) {
        if (o == null || !(o instanceof $49af21c6dd39b813$var$IntervalSet)) return false;
        return $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
    }
    toString(elemAreChar = false) {
        let buf = "";
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) {
                if (a === $eKXi4.Token.EOF) buf += "<EOF>";
                else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                else buf += a;
            } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
            else buf += a + ".." + b;
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    toStringVocabulary(vocabulary) {
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        let buf = "";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) buf += this.elementName(vocabulary, a);
            else for(let i = a; i <= b; i++){
                if (i > a) buf += ", ";
                buf += this.elementName(vocabulary, i);
            }
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    elementName(vocabulary, a) {
        if (a === $eKXi4.Token.EOF) return "<EOF>";
        else if (a === $eKXi4.Token.EPSILON) return "<EPSILON>";
        else return vocabulary.getDisplayName(a);
    }
    get size() {
        let n = 0;
        let numIntervals = this._intervals.length;
        if (numIntervals === 1) {
            let firstInterval = this._intervals[0];
            return firstInterval.b - firstInterval.a + 1;
        }
        for(let i = 0; i < numIntervals; i++){
            let I = this._intervals[i];
            n += I.b - I.a + 1;
        }
        return n;
    }
    toIntegerList() {
        let values = new $eRSlM.IntegerList(this.size);
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.add(v);
        }
        return values;
    }
    toSet() {
        let s = new Set();
        for (let I of this._intervals){
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)s.add(v);
        }
        return s;
    }
    toArray() {
        let values = new Array();
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.push(v);
        }
        return values;
    }
    remove(el) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            if (el < a) break; // list is sorted and el is before this interval; not here
            // if whole interval x..x, rm
            if (el === a && el === b) {
                this._intervals.splice(i, 1);
                break;
            }
            // if on left edge x..b, adjust left
            if (el === a) {
                this._intervals[i] = $l8y5T.Interval.of(I.a + 1, I.b);
                break;
            }
            // if on right edge a..x, adjust right
            if (el === b) {
                this._intervals[i] = $l8y5T.Interval.of(I.a, I.b - 1);
                break;
            }
            // if in middle a..x..b, split interval
            if (el > a && el < b) {
                let oldb = I.b;
                this._intervals[i] = $l8y5T.Interval.of(I.a, el - 1); // [a..x-1]
                this.add(el + 1, oldb); // add [x+1..b]
            }
        }
    }
    get isReadonly() {
        return this.readonly;
    }
    setReadonly(readonly) {
        if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
        this.readonly = readonly;
    }
}
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "addAll", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "complement", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "subtract", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "or", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "and", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "contains", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "isNil", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "hashCode", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "equals", null);
$49af21c6dd39b813$var$__decorate([
    $49af21c6dd39b813$var$__param(0, $aN41m.NotNull)
], $49af21c6dd39b813$var$IntervalSet.prototype, "toStringVocabulary", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.NotNull,
    $49af21c6dd39b813$var$__param(0, $aN41m.NotNull)
], $49af21c6dd39b813$var$IntervalSet.prototype, "elementName", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "size", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "remove", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.NotNull
], $49af21c6dd39b813$var$IntervalSet, "of", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.NotNull
], $49af21c6dd39b813$var$IntervalSet, "subtract", null);
module.exports.IntervalSet = $49af21c6dd39b813$var$IntervalSet;

});
parcelRegister("eRSlM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ad302cc069821a02$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerList = void 0;

var $4dKou = parcelRequire("4dKou");

var $aN41m = parcelRequire("aN41m");
const $ad302cc069821a02$var$EMPTY_DATA = new Int32Array(0);
const $ad302cc069821a02$var$INITIAL_SIZE = 4;
const $ad302cc069821a02$var$MAX_ARRAY_SIZE = 2147483639;
/**
 *
 * @author Sam Harwell
 */ class $ad302cc069821a02$var$IntegerList {
    constructor(arg){
        if (!arg) {
            this._data = $ad302cc069821a02$var$EMPTY_DATA;
            this._size = 0;
        } else if (arg instanceof $ad302cc069821a02$var$IntegerList) {
            this._data = arg._data.slice(0);
            this._size = arg._size;
        } else if (typeof arg === "number") {
            if (arg === 0) {
                this._data = $ad302cc069821a02$var$EMPTY_DATA;
                this._size = 0;
            } else {
                this._data = new Int32Array(arg);
                this._size = 0;
            }
        } else {
            // arg is Iterable<number>
            this._data = $ad302cc069821a02$var$EMPTY_DATA;
            this._size = 0;
            for (let value of arg)this.add(value);
        }
    }
    add(value) {
        if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
        this._data[this._size] = value;
        this._size++;
    }
    addAll(list) {
        if (Array.isArray(list)) {
            this.ensureCapacity(this._size + list.length);
            this._data.subarray(this._size, this._size + list.length).set(list);
            this._size += list.length;
        } else if (list instanceof $ad302cc069821a02$var$IntegerList) {
            this.ensureCapacity(this._size + list._size);
            this._data.subarray(this._size, this._size + list.size).set(list._data);
            this._size += list._size;
        } else {
            // list is JavaCollection<number>
            this.ensureCapacity(this._size + list.size);
            let current = 0;
            for (let xi of list){
                this._data[this._size + current] = xi;
                current++;
            }
            this._size += list.size;
        }
    }
    get(index) {
        if (index < 0 || index >= this._size) throw RangeError();
        return this._data[index];
    }
    contains(value) {
        for(let i = 0; i < this._size; i++){
            if (this._data[i] === value) return true;
        }
        return false;
    }
    set(index, value) {
        if (index < 0 || index >= this._size) throw RangeError();
        let previous = this._data[index];
        this._data[index] = value;
        return previous;
    }
    removeAt(index) {
        let value = this.get(index);
        this._data.copyWithin(index, index + 1, this._size);
        this._data[this._size - 1] = 0;
        this._size--;
        return value;
    }
    removeRange(fromIndex, toIndex) {
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
        if (fromIndex > toIndex) throw RangeError();
        this._data.copyWithin(toIndex, fromIndex, this._size);
        this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
        this._size -= toIndex - fromIndex;
    }
    get isEmpty() {
        return this._size === 0;
    }
    get size() {
        return this._size;
    }
    trimToSize() {
        if (this._data.length === this._size) return;
        this._data = this._data.slice(0, this._size);
    }
    clear() {
        this._data.fill(0, 0, this._size);
        this._size = 0;
    }
    toArray() {
        if (this._size === 0) return [];
        return Array.from(this._data.subarray(0, this._size));
    }
    sort() {
        this._data.subarray(0, this._size).sort();
    }
    /**
     * Compares the specified object with this list for equality.  Returns
     * `true` if and only if the specified object is also an {@link IntegerList},
     * both lists have the same size, and all corresponding pairs of elements in
     * the two lists are equal.  In other words, two lists are defined to be
     * equal if they contain the same elements in the same order.
     *
     * This implementation first checks if the specified object is this
     * list. If so, it returns `true`; if not, it checks if the
     * specified object is an {@link IntegerList}. If not, it returns `false`;
     * if so, it checks the size of both lists. If the lists are not the same size,
     * it returns `false`; otherwise it iterates over both lists, comparing
     * corresponding pairs of elements.  If any comparison returns `false`,
     * this method returns `false`.
     *
     * @param o the object to be compared for equality with this list
     * @returns `true` if the specified object is equal to this list
     */ equals(o) {
        if (o === this) return true;
        if (!(o instanceof $ad302cc069821a02$var$IntegerList)) return false;
        if (this._size !== o._size) return false;
        for(let i = 0; i < this._size; i++){
            if (this._data[i] !== o._data[i]) return false;
        }
        return true;
    }
    /**
     * Returns the hash code value for this list.
     *
     * This implementation uses exactly the code that is used to define the
     * list hash function in the documentation for the {@link List#hashCode}
     * method.
     *
     * @returns the hash code value for this list
     */ hashCode() {
        let hashCode = 1;
        for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
        return hashCode;
    }
    /**
     * Returns a string representation of this list.
     */ toString() {
        return this._data.toString();
    }
    binarySearch(key, fromIndex, toIndex) {
        if (fromIndex === undefined) fromIndex = 0;
        if (toIndex === undefined) toIndex = this._size;
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
        if (fromIndex > toIndex) throw new RangeError();
        return $4dKou.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
    }
    ensureCapacity(capacity) {
        if (capacity < 0 || capacity > $ad302cc069821a02$var$MAX_ARRAY_SIZE) throw new RangeError();
        let newLength;
        if (this._data.length === 0) newLength = $ad302cc069821a02$var$INITIAL_SIZE;
        else newLength = this._data.length;
        while(newLength < capacity){
            newLength = newLength * 2;
            if (newLength < 0 || newLength > $ad302cc069821a02$var$MAX_ARRAY_SIZE) newLength = $ad302cc069821a02$var$MAX_ARRAY_SIZE;
        }
        let tmp = new Int32Array(newLength);
        tmp.set(this._data);
        this._data = tmp;
    }
    /** Convert the list to a UTF-16 encoded char array. If all values are less
     *  than the 0xFFFF 16-bit code point limit then this is just a char array
     *  of 16-bit char as usual. For values in the supplementary range, encode
     * them as two UTF-16 code units.
     */ toCharArray() {
        // Optimize for the common case (all data values are < 0xFFFF) to avoid an extra scan
        let resultArray = new Uint16Array(this._size);
        let resultIdx = 0;
        let calculatedPreciseResultSize = false;
        for(let i = 0; i < this._size; i++){
            let codePoint = this._data[i];
            if (codePoint >= 0 && codePoint < 0x10000) {
                resultArray[resultIdx] = codePoint;
                resultIdx++;
                continue;
            }
            // Calculate the precise result size if we encounter a code point > 0xFFFF
            if (!calculatedPreciseResultSize) {
                let newResultArray = new Uint16Array(this.charArraySize());
                newResultArray.set(resultArray, 0);
                resultArray = newResultArray;
                calculatedPreciseResultSize = true;
            }
            // This will throw RangeError if the code point is not a valid Unicode code point
            let pair = String.fromCodePoint(codePoint);
            resultArray[resultIdx] = pair.charCodeAt(0);
            resultArray[resultIdx + 1] = pair.charCodeAt(1);
            resultIdx += 2;
        }
        return resultArray;
    }
    charArraySize() {
        let result = 0;
        for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
        return result;
    }
}
$ad302cc069821a02$var$__decorate([
    $aN41m.NotNull
], $ad302cc069821a02$var$IntegerList.prototype, "_data", void 0);
$ad302cc069821a02$var$__decorate([
    $aN41m.Override
], $ad302cc069821a02$var$IntegerList.prototype, "equals", null);
$ad302cc069821a02$var$__decorate([
    $aN41m.Override
], $ad302cc069821a02$var$IntegerList.prototype, "hashCode", null);
$ad302cc069821a02$var$__decorate([
    $aN41m.Override
], $ad302cc069821a02$var$IntegerList.prototype, "toString", null);
module.exports.IntegerList = $ad302cc069821a02$var$IntegerList;

});
parcelRegister("4dKou", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrays = void 0;
var $312c5d30775d92ef$var$Arrays;
(function(Arrays) {
    /**
     * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
     * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
     * multiple elements with the specified value, there is no guarantee which one will be found.
     *
     * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
     * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
     * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
     * that this guarantees that the return value will be >= 0 if and only if the key is found.
     */ function binarySearch(array, key, fromIndex, toIndex) {
        return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
    }
    Arrays.binarySearch = binarySearch;
    function binarySearch0(array, fromIndex, toIndex, key) {
        let low = fromIndex;
        let high = toIndex - 1;
        while(low <= high){
            let mid = low + high >>> 1;
            let midVal = array[mid];
            if (midVal < key) low = mid + 1;
            else if (midVal > key) high = mid - 1;
            else // key found
            return mid;
        }
        // key not found.
        return -(low + 1);
    }
    function toString(array) {
        let result = "[";
        let first = true;
        for (let element of array){
            if (first) first = false;
            else result += ", ";
            if (element === null) result += "null";
            else if (element === undefined) result += "undefined";
            else result += element;
        }
        result += "]";
        return result;
    }
    Arrays.toString = toString;
})($312c5d30775d92ef$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));

});


parcelRegister("l8y5T", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f634cab1d0696c5f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interval = void 0;

var $aN41m = parcelRequire("aN41m");
const $f634cab1d0696c5f$var$INTERVAL_POOL_MAX_VALUE = 1000;
/** An immutable inclusive interval a..b */ class $f634cab1d0696c5f$var$Interval {
    /**
     * @param a The start of the interval
     * @param b The end of the interval (inclusive)
     */ constructor(a, b){
        this.a = a;
        this.b = b;
    }
    static get INVALID() {
        return $f634cab1d0696c5f$var$Interval._INVALID;
    }
    /** Interval objects are used readonly so share all with the
     *  same single value a==b up to some max size.  Use an array as a perfect hash.
     *  Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
     *  Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
     *  have a..a (set with 1 element).
     */ static of(a, b) {
        // cache just a..a
        if (a !== b || a < 0 || a > $f634cab1d0696c5f$var$INTERVAL_POOL_MAX_VALUE) return new $f634cab1d0696c5f$var$Interval(a, b);
        if ($f634cab1d0696c5f$var$Interval.cache[a] == null) $f634cab1d0696c5f$var$Interval.cache[a] = new $f634cab1d0696c5f$var$Interval(a, a);
        return $f634cab1d0696c5f$var$Interval.cache[a];
    }
    /** return number of elements between a and b inclusively. x..x is length 1.
     *  if b &lt; a, then length is 0.  9..10 has length 2.
     */ get length() {
        if (this.b < this.a) return 0;
        return this.b - this.a + 1;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof $f634cab1d0696c5f$var$Interval)) return false;
        return this.a === o.a && this.b === o.b;
    }
    hashCode() {
        let hash = 23;
        hash = hash * 31 + this.a;
        hash = hash * 31 + this.b;
        return hash;
    }
    /** Does this start completely before other? Disjoint */ startsBeforeDisjoint(other) {
        return this.a < other.a && this.b < other.a;
    }
    /** Does this start at or before other? Nondisjoint */ startsBeforeNonDisjoint(other) {
        return this.a <= other.a && this.b >= other.a;
    }
    /** Does this.a start after other.b? May or may not be disjoint */ startsAfter(other) {
        return this.a > other.a;
    }
    /** Does this start completely after other? Disjoint */ startsAfterDisjoint(other) {
        return this.a > other.b;
    }
    /** Does this start after other? NonDisjoint */ startsAfterNonDisjoint(other) {
        return this.a > other.a && this.a <= other.b; // this.b>=other.b implied
    }
    /** Are both ranges disjoint? I.e., no overlap? */ disjoint(other) {
        return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
    }
    /** Are two intervals adjacent such as 0..41 and 42..42? */ adjacent(other) {
        return this.a === other.b + 1 || this.b === other.a - 1;
    }
    properlyContains(other) {
        return other.a >= this.a && other.b <= this.b;
    }
    /** Return the interval computed from combining this and other */ union(other) {
        return $f634cab1d0696c5f$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
    }
    /** Return the interval in common between this and o */ intersection(other) {
        return $f634cab1d0696c5f$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
    }
    /** Return the interval with elements from `this` not in `other`;
     *  `other` must not be totally enclosed (properly contained)
     *  within `this`, which would result in two disjoint intervals
     *  instead of the single one returned by this method.
     */ differenceNotProperlyContained(other) {
        let diff;
        if (other.startsBeforeNonDisjoint(this)) // other.a to left of this.a (or same)
        diff = $f634cab1d0696c5f$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
        else if (other.startsAfterNonDisjoint(this)) // other.a to right of this.a
        diff = $f634cab1d0696c5f$var$Interval.of(this.a, other.a - 1);
        return diff;
    }
    toString() {
        return this.a + ".." + this.b;
    }
}
$f634cab1d0696c5f$var$Interval._INVALID = new $f634cab1d0696c5f$var$Interval(-1, -2);
$f634cab1d0696c5f$var$Interval.cache = new Array($f634cab1d0696c5f$var$INTERVAL_POOL_MAX_VALUE + 1);
$f634cab1d0696c5f$var$__decorate([
    $aN41m.Override
], $f634cab1d0696c5f$var$Interval.prototype, "equals", null);
$f634cab1d0696c5f$var$__decorate([
    $aN41m.Override
], $f634cab1d0696c5f$var$Interval.prototype, "hashCode", null);
$f634cab1d0696c5f$var$__decorate([
    $aN41m.Override
], $f634cab1d0696c5f$var$Interval.prototype, "toString", null);
module.exports.Interval = $f634cab1d0696c5f$var$Interval;

});

parcelRegister("h7Q3L", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c77b7912a6658aa1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexer = void 0;

var $9hrXh = parcelRequire("9hrXh");

var $jB0DW = parcelRequire("jB0DW");

var $l8y5T = parcelRequire("l8y5T");

var $ldi9e = parcelRequire("ldi9e");

var $2160U = parcelRequire("2160U");

var $l3IpB = parcelRequire("l3IpB");

var $aN41m = parcelRequire("aN41m");

var $dwftT = parcelRequire("dwftT");

var $eKXi4 = parcelRequire("eKXi4");
/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */ class $c77b7912a6658aa1$var$Lexer extends $dwftT.Recognizer {
    constructor(input){
        super();
        /** How to create token objects */ this._factory = $9hrXh.CommonTokenFactory.DEFAULT;
        /** What character index in the stream did the current token start at?
         *  Needed, for example, to get the text for current token.  Set at
         *  the start of nextToken.
         */ this._tokenStartCharIndex = -1;
        /** The line on which the first character of the token resides */ this._tokenStartLine = 0;
        /** The character position of first character within the line */ this._tokenStartCharPositionInLine = 0;
        /** Once we see EOF on char stream, next token will be EOF.
         *  If you have DONE : EOF ; then you see DONE EOF.
         */ this._hitEOF = false;
        /** The channel number for the current token */ this._channel = 0;
        /** The token type for the current token */ this._type = 0;
        this._modeStack = new $jB0DW.IntegerStack();
        this._mode = $c77b7912a6658aa1$var$Lexer.DEFAULT_MODE;
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: input
        };
    }
    static get DEFAULT_TOKEN_CHANNEL() {
        return $eKXi4.Token.DEFAULT_CHANNEL;
    }
    static get HIDDEN() {
        return $eKXi4.Token.HIDDEN_CHANNEL;
    }
    reset(resetInput) {
        // wack Lexer state variables
        if (resetInput === undefined || resetInput) this._input.seek(0); // rewind the input
        this._token = undefined;
        this._type = $eKXi4.Token.INVALID_TYPE;
        this._channel = $eKXi4.Token.DEFAULT_CHANNEL;
        this._tokenStartCharIndex = -1;
        this._tokenStartCharPositionInLine = -1;
        this._tokenStartLine = -1;
        this._text = undefined;
        this._hitEOF = false;
        this._mode = $c77b7912a6658aa1$var$Lexer.DEFAULT_MODE;
        this._modeStack.clear();
        this.interpreter.reset();
    }
    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */ nextToken() {
        if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
        // Mark start location in char stream so unbuffered streams are
        // guaranteed at least have text of current token
        let tokenStartMarker = this._input.mark();
        try {
            outer: while(true){
                if (this._hitEOF) return this.emitEOF();
                this._token = undefined;
                this._channel = $eKXi4.Token.DEFAULT_CHANNEL;
                this._tokenStartCharIndex = this._input.index;
                this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                this._tokenStartLine = this.interpreter.line;
                this._text = undefined;
                do {
                    this._type = $eKXi4.Token.INVALID_TYPE;
                    //				System.out.println("nextToken line "+tokenStartLine+" at "+((char)input.LA(1))+
                    //								   " in mode "+mode+
                    //								   " at index "+input.index);
                    let ttype;
                    try {
                        ttype = this.interpreter.match(this._input, this._mode);
                    } catch (e) {
                        if (e instanceof $l3IpB.LexerNoViableAltException) {
                            this.notifyListeners(e); // report error
                            this.recover(e);
                            ttype = $c77b7912a6658aa1$var$Lexer.SKIP;
                        } else throw e;
                    }
                    if (this._input.LA(1) === $ldi9e.IntStream.EOF) this._hitEOF = true;
                    if (this._type === $eKXi4.Token.INVALID_TYPE) this._type = ttype;
                    if (this._type === $c77b7912a6658aa1$var$Lexer.SKIP) continue outer;
                }while (this._type === $c77b7912a6658aa1$var$Lexer.MORE);
                if (this._token == null) return this.emit();
                return this._token;
            }
        } finally{
            // make sure we release marker after match or
            // unbuffered char stream will keep buffering
            this._input.release(tokenStartMarker);
        }
    }
    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==undefined at end of any token rule, it creates one for you
     *  and emits it.
     */ skip() {
        this._type = $c77b7912a6658aa1$var$Lexer.SKIP;
    }
    more() {
        this._type = $c77b7912a6658aa1$var$Lexer.MORE;
    }
    mode(m) {
        this._mode = m;
    }
    pushMode(m) {
        if ($2160U.LexerATNSimulator.debug) console.log("pushMode " + m);
        this._modeStack.push(this._mode);
        this.mode(m);
    }
    popMode() {
        if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
        if ($2160U.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
        this.mode(this._modeStack.pop());
        return this._mode;
    }
    get tokenFactory() {
        return this._factory;
    }
    // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the char stream and reset the lexer */ set inputStream(input) {
        this.reset(false);
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: this._input
        };
    }
    get sourceName() {
        return this._input.sourceName;
    }
    emit(token) {
        if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
        this._token = token;
        return token;
    }
    emitEOF() {
        let cpos = this.charPositionInLine;
        let line = this.line;
        let eof = this._factory.create(this._tokenFactorySourcePair, $eKXi4.Token.EOF, undefined, $eKXi4.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
        this.emit(eof);
        return eof;
    }
    get line() {
        return this.interpreter.line;
    }
    set line(line) {
        this.interpreter.line = line;
    }
    get charPositionInLine() {
        return this.interpreter.charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this.interpreter.charPositionInLine = charPositionInLine;
    }
    /** What is the index of the current character of lookahead? */ get charIndex() {
        return this._input.index;
    }
    /** Return the text matched so far for the current token or any
     *  text override.
     */ get text() {
        if (this._text != null) return this._text;
        return this.interpreter.getText(this._input);
    }
    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */ set text(text) {
        this._text = text;
    }
    /** Override if emitting multiple tokens. */ get token() {
        return this._token;
    }
    set token(_token) {
        this._token = _token;
    }
    set type(ttype) {
        this._type = ttype;
    }
    get type() {
        return this._type;
    }
    set channel(channel) {
        this._channel = channel;
    }
    get channel() {
        return this._channel;
    }
    /** Return a list of all Token objects in input char stream.
     *  Forces load of all tokens. Does not include EOF token.
     */ getAllTokens() {
        let tokens = [];
        let t = this.nextToken();
        while(t.type !== $eKXi4.Token.EOF){
            tokens.push(t);
            t = this.nextToken();
        }
        return tokens;
    }
    notifyListeners(e) {
        let text = this._input.getText($l8y5T.Interval.of(this._tokenStartCharIndex, this._input.index));
        let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
    }
    getErrorDisplay(s) {
        if (typeof s === "number") {
            switch(s){
                case $eKXi4.Token.EOF:
                    return "<EOF>";
                case 0x0a:
                    return "\\n";
                case 0x09:
                    return "\\t";
                case 0x0d:
                    return "\\r";
            }
            return String.fromCharCode(s);
        }
        return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    getCharErrorDisplay(c) {
        let s = this.getErrorDisplay(c);
        return "'" + s + "'";
    }
    recover(re) {
        if (re instanceof $l3IpB.LexerNoViableAltException) {
            if (this._input.LA(1) !== $ldi9e.IntStream.EOF) // skip a char and try again
            this.interpreter.consume(this._input);
        } else //System.out.println("consuming char "+(char)input.LA(1)+" during recovery");
        //re.printStackTrace();
        // TODO: Do we lose character or line position information?
        this._input.consume();
    }
}
$c77b7912a6658aa1$var$Lexer.DEFAULT_MODE = 0;
$c77b7912a6658aa1$var$Lexer.MORE = -2;
$c77b7912a6658aa1$var$Lexer.SKIP = -3;
$c77b7912a6658aa1$var$Lexer.MIN_CHAR_VALUE = 0x0000;
$c77b7912a6658aa1$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "nextToken", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "tokenFactory", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "inputStream", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "sourceName", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "line", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "charPositionInLine", null);
module.exports.Lexer = $c77b7912a6658aa1$var$Lexer;

});
parcelRegister("9hrXh", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6c1b62e47790a82a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenFactory = void 0;

var $exlin = parcelRequire("exlin");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");
/**
 * This default implementation of {@link TokenFactory} creates
 * {@link CommonToken} objects.
 */ class $6c1b62e47790a82a$var$CommonTokenFactory {
    /**
     * Constructs a {@link CommonTokenFactory} with the specified value for
     * {@link #copyText}.
     *
     * When `copyText` is `false`, the {@link #DEFAULT} instance
     * should be used instead of constructing a new instance.
     *
     * @param copyText The value for {@link #copyText}.
     */ constructor(copyText = false){
        this.copyText = copyText;
    }
    create(source, type, text, channel, start, stop, line, charPositionInLine) {
        let t = new $exlin.CommonToken(type, text, source, channel, start, stop);
        t.line = line;
        t.charPositionInLine = charPositionInLine;
        if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($l8y5T.Interval.of(start, stop));
        return t;
    }
    createSimple(type, text) {
        return new $exlin.CommonToken(type, text);
    }
}
$6c1b62e47790a82a$var$__decorate([
    $aN41m.Override
], $6c1b62e47790a82a$var$CommonTokenFactory.prototype, "create", null);
$6c1b62e47790a82a$var$__decorate([
    $aN41m.Override
], $6c1b62e47790a82a$var$CommonTokenFactory.prototype, "createSimple", null);
module.exports.CommonTokenFactory = $6c1b62e47790a82a$var$CommonTokenFactory;
(function(CommonTokenFactory) {
    /**
     * The default {@link CommonTokenFactory} instance.
     *
     * This token factory does not explicitly copy token text when constructing
     * tokens.
     */ CommonTokenFactory.DEFAULT = new CommonTokenFactory();
})($6c1b62e47790a82a$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));

});
parcelRegister("exlin", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a954aa91d3b92162$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a954aa91d3b92162$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonToken = void 0;

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
let $a954aa91d3b92162$var$CommonToken = class CommonToken {
    constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $eKXi4.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
        /**
         * This is the backing field for {@link #getLine} and {@link #setLine}.
         */ this._line = 0;
        /**
         * This is the backing field for {@link #getCharPositionInLine} and
         * {@link #setCharPositionInLine}.
         */ this._charPositionInLine = -1; // set to invalid position
        /**
         * This is the backing field for {@link #getChannel} and
         * {@link #setChannel}.
         */ this._channel = $eKXi4.Token.DEFAULT_CHANNEL;
        /**
         * This is the backing field for `tokenIndex`.
         */ this.index = -1;
        this._text = text;
        this._type = type;
        this.source = source;
        this._channel = channel;
        this.start = start;
        this.stop = stop;
        if (source.source != null) {
            this._line = source.source.line;
            this._charPositionInLine = source.source.charPositionInLine;
        }
    }
    /**
     * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
     *
     * If `oldToken` is also a {@link CommonToken} instance, the newly
     * constructed token will share a reference to the {@link #text} field and
     * the {@link Tuple2} stored in {@link #source}. Otherwise, {@link #text} will
     * be assigned the result of calling {@link #getText}, and {@link #source}
     * will be constructed from the result of {@link Token#getTokenSource} and
     * {@link Token#getInputStream}.
     *
     * @param oldToken The token to copy.
     */ static fromToken(oldToken) {
        let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
        result._line = oldToken.line;
        result.index = oldToken.tokenIndex;
        result._charPositionInLine = oldToken.charPositionInLine;
        if (oldToken instanceof CommonToken) {
            result._text = oldToken._text;
            result.source = oldToken.source;
        } else {
            result._text = oldToken.text;
            result.source = {
                source: oldToken.tokenSource,
                stream: oldToken.inputStream
            };
        }
        return result;
    }
    get type() {
        return this._type;
    }
    // @Override
    set type(type) {
        this._type = type;
    }
    get line() {
        return this._line;
    }
    // @Override
    set line(line) {
        this._line = line;
    }
    get text() {
        if (this._text != null) return this._text;
        let input = this.inputStream;
        if (input == null) return undefined;
        let n = input.size;
        if (this.start < n && this.stop < n) return input.getText($l8y5T.Interval.of(this.start, this.stop));
        else return "<EOF>";
    }
    /**
     * Explicitly set the text for this token. If {code text} is not
     * `undefined`, then {@link #getText} will return this value rather than
     * extracting the text from the input.
     *
     * @param text The explicit text of the token, or `undefined` if the text
     * should be obtained from the input along with the start and stop indexes
     * of the token.
     */ // @Override
    set text(text) {
        this._text = text;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    // @Override
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    get channel() {
        return this._channel;
    }
    // @Override
    set channel(channel) {
        this._channel = channel;
    }
    get startIndex() {
        return this.start;
    }
    set startIndex(start) {
        this.start = start;
    }
    get stopIndex() {
        return this.stop;
    }
    set stopIndex(stop) {
        this.stop = stop;
    }
    get tokenIndex() {
        return this.index;
    }
    // @Override
    set tokenIndex(index) {
        this.index = index;
    }
    get tokenSource() {
        return this.source.source;
    }
    get inputStream() {
        return this.source.stream;
    }
    toString(recognizer) {
        let channelStr = "";
        if (this._channel > 0) channelStr = ",channel=" + this._channel;
        let txt = this.text;
        if (txt != null) {
            txt = txt.replace(/\n/g, "\\n");
            txt = txt.replace(/\r/g, "\\r");
            txt = txt.replace(/\t/g, "\\t");
        } else txt = "<no text>";
        let typeString = String(this._type);
        if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
        return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
    }
};
/**
 * An empty {@link Tuple2} which is used as the default value of
 * {@link #source} for tokens that do not have a source.
 */ $a954aa91d3b92162$var$CommonToken.EMPTY_SOURCE = {
    source: undefined,
    stream: undefined
};
$a954aa91d3b92162$var$__decorate([
    $aN41m.NotNull
], $a954aa91d3b92162$var$CommonToken.prototype, "source", void 0);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "type", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "line", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "text", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "charPositionInLine", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "channel", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "startIndex", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "stopIndex", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "tokenIndex", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "tokenSource", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "inputStream", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "toString", null);
$a954aa91d3b92162$var$__decorate([
    $a954aa91d3b92162$var$__param(0, $aN41m.NotNull)
], $a954aa91d3b92162$var$CommonToken, "fromToken", null);
$a954aa91d3b92162$var$CommonToken = $a954aa91d3b92162$var$__decorate([
    $a954aa91d3b92162$var$__param(2, $aN41m.NotNull)
], $a954aa91d3b92162$var$CommonToken);
module.exports.CommonToken = $a954aa91d3b92162$var$CommonToken;

});
parcelRegister("eKXi4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = void 0;

var $ldi9e = parcelRequire("ldi9e");
var $abe35a6f47a957ff$var$Token;
(function(Token) {
    Token.INVALID_TYPE = 0;
    /** During lookahead operations, this "token" signifies we hit rule end ATN state
     *  and did not follow it despite needing to.
     */ Token.EPSILON = -2;
    Token.MIN_USER_TOKEN_TYPE = 1;
    Token.EOF = $ldi9e.IntStream.EOF;
    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */ Token.DEFAULT_CHANNEL = 0;
    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */ Token.HIDDEN_CHANNEL = 1;
    /**
     * This is the minimum constant value which can be assigned to a
     * user-defined token channel.
     *
     * The non-negative numbers less than {@link #MIN_USER_CHANNEL_VALUE} are
     * assigned to the predefined channels {@link #DEFAULT_CHANNEL} and
     * {@link #HIDDEN_CHANNEL}.
     *
     * @see `Token.channel`
     */ Token.MIN_USER_CHANNEL_VALUE = 2;
})($abe35a6f47a957ff$var$Token = module.exports.Token || (module.exports.Token = {}));

});



parcelRegister("jB0DW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerStack = void 0;

var $eRSlM = parcelRequire("eRSlM");
/**
 *
 * @author Sam Harwell
 */ class $e441f8bbaf193f9f$var$IntegerStack extends $eRSlM.IntegerList {
    constructor(arg){
        super(arg);
    }
    push(value) {
        this.add(value);
    }
    pop() {
        return this.removeAt(this.size - 1);
    }
    peek() {
        return this.get(this.size - 1);
    }
}
module.exports.IntegerStack = $e441f8bbaf193f9f$var$IntegerStack;

});

parcelRegister("2160U", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $178056f04e0087b5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $178056f04e0087b5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerATNSimulator = void 0;

var $hu8W9 = parcelRequire("hu8W9");

var $eeOLb = parcelRequire("eeOLb");

var $hdFz0 = parcelRequire("hdFz0");

var $2SGHL = parcelRequire("2SGHL");

var $ceQRA = parcelRequire("ceQRA");

var $6P9ap = parcelRequire("6P9ap");

var $l8y5T = parcelRequire("l8y5T");

var $ldi9e = parcelRequire("ldi9e");

var $h7Q3L = parcelRequire("h7Q3L");

var $i6TH4 = parcelRequire("i6TH4");

var $l3IpB = parcelRequire("l3IpB");

var $aN41m = parcelRequire("aN41m");

var $9O0ze = parcelRequire("9O0ze");

var $jaUCz = parcelRequire("jaUCz");

var $jWsYN = parcelRequire("jWsYN");

var $eKXi4 = parcelRequire("eKXi4");

var $fomfP = parcelRequire("fomfP");
/** "dup" of ParserInterpreter */ let $178056f04e0087b5$var$LexerATNSimulator = class LexerATNSimulator extends $ceQRA.ATNSimulator {
    constructor(atn, recog){
        super(atn);
        this.optimize_tail_calls = true;
        /** The current token's starting index into the character stream.
         *  Shared across DFA to ATN simulation in case the ATN fails and the
         *  DFA did not have a previous accept state. In this case, we use the
         *  ATN-generated exception object.
         */ this.startIndex = -1;
        /** line number 1..n within the input */ this._line = 1;
        /** The index of the character relative to the beginning of the line 0..n-1 */ this._charPositionInLine = 0;
        this.mode = $h7Q3L.Lexer.DEFAULT_MODE;
        /** Used during DFA/ATN exec to record the most recent accept configuration info */ this.prevAccept = new LexerATNSimulator.SimState();
        this.recog = recog;
    }
    copyState(simulator) {
        this._charPositionInLine = simulator.charPositionInLine;
        this._line = simulator._line;
        this.mode = simulator.mode;
        this.startIndex = simulator.startIndex;
    }
    match(input, mode) {
        this.mode = mode;
        let mark = input.mark();
        try {
            this.startIndex = input.index;
            this.prevAccept.reset();
            let s0 = this.atn.modeToDFA[mode].s0;
            if (s0 == null) return this.matchATN(input);
            else return this.execATN(input, s0);
        } finally{
            input.release(mark);
        }
    }
    reset() {
        this.prevAccept.reset();
        this.startIndex = -1;
        this._line = 1;
        this._charPositionInLine = 0;
        this.mode = $h7Q3L.Lexer.DEFAULT_MODE;
    }
    matchATN(input) {
        let startState = this.atn.modeToStartState[this.mode];
        if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
        let old_mode = this.mode;
        let s0_closure = this.computeStartState(input, startState);
        let suppressEdge = s0_closure.hasSemanticContext;
        if (suppressEdge) s0_closure.hasSemanticContext = false;
        let next = this.addDFAState(s0_closure);
        if (!suppressEdge) {
            let dfa = this.atn.modeToDFA[this.mode];
            if (!dfa.s0) dfa.s0 = next;
            else next = dfa.s0;
        }
        let predict = this.execATN(input, next);
        if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
        return predict;
    }
    execATN(input, ds0) {
        // console.log("enter exec index "+input.index+" from "+ds0.configs);
        if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
        if (ds0.isAcceptState) // allow zero-length tokens
        this.captureSimState(this.prevAccept, input, ds0);
        let t = input.LA(1);
        // @NotNull
        let s = ds0; // s is current/from DFA state
        while(true){
            if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
            // As we move src->trg, src->trg, we keep track of the previous trg to
            // avoid looking up the DFA state again, which is expensive.
            // If the previous target was already part of the DFA, we might
            // be able to avoid doing a reach operation upon t. If s!=null,
            // it means that semantic predicates didn't prevent us from
            // creating a DFA state. Once we know s!=null, we check to see if
            // the DFA state has an edge already for t. If so, we can just reuse
            // it's configuration set; there's no point in re-computing it.
            // This is kind of like doing DFA simulation within the ATN
            // simulation because DFA simulation is really just a way to avoid
            // computing reach/closure sets. Technically, once we know that
            // we have a previously added DFA state, we could jump over to
            // the DFA simulator. But, that would mean popping back and forth
            // a lot and making things more complicated algorithmically.
            // This optimization makes a lot of sense for loops within DFA.
            // A character will take us back to an existing DFA state
            // that already has lots of edges out of it. e.g., .* in comments.
            let target = this.getExistingTargetState(s, t);
            if (target == null) target = this.computeTargetState(input, s, t);
            if (target === $ceQRA.ATNSimulator.ERROR) break;
            // If this is a consumable input element, make sure to consume before
            // capturing the accept state so the input index, line, and char
            // position accurately reflect the state of the interpreter at the
            // end of the token.
            if (t !== $ldi9e.IntStream.EOF) this.consume(input);
            if (target.isAcceptState) {
                this.captureSimState(this.prevAccept, input, target);
                if (t === $ldi9e.IntStream.EOF) break;
            }
            t = input.LA(1);
            s = target; // flip; current DFA target becomes new src/from state
        }
        return this.failOrAccept(this.prevAccept, input, s.configs, t);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        let target = s.getTarget(t);
        if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
        return target;
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param input The input stream
     * @param s The current DFA state
     * @param t The next input symbol
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(input, s, t) {
        let reach = new $9O0ze.OrderedATNConfigSet();
        // if we don't find an existing DFA state
        // Fill reach starting from closure, following t transitions
        this.getReachableConfigSet(input, s.configs, reach, t);
        if (reach.isEmpty) {
            if (!reach.hasSemanticContext) // we got nowhere on t, don't throw out this knowledge; it'd
            // cause a failover from DFA later.
            this.addDFAEdge(s, t, $ceQRA.ATNSimulator.ERROR);
            // stop when we can't match any more char
            return $ceQRA.ATNSimulator.ERROR;
        }
        // Add an edge from s to target DFA found/created for reach
        return this.addDFAEdge(s, t, reach);
    }
    failOrAccept(prevAccept, input, reach, t) {
        if (prevAccept.dfaState != null) {
            let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
            this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
            return prevAccept.dfaState.prediction;
        } else {
            // if no accept and EOF is first char, return EOF
            if (t === $ldi9e.IntStream.EOF && input.index === this.startIndex) return $eKXi4.Token.EOF;
            throw new $l3IpB.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
        }
    }
    /** Given a starting configuration set, figure out all ATN configurations
     *  we can reach upon input `t`. Parameter `reach` is a return
     *  parameter.
     */ getReachableConfigSet(input, closure, reach, t) {
        // this is used to skip processing for configs which have a lower priority
        // than a config that already reached an accept state for the same rule
        let skipAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        for (let c of closure){
            let currentAltReachedAcceptState = c.alt === skipAlt;
            if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
            if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
            let n = c.state.numberOfOptimizedTransitions;
            for(let ti = 0; ti < n; ti++){
                let trans = c.state.getOptimizedTransition(ti);
                let target = this.getReachableTarget(trans, t);
                if (target != null) {
                    let lexerActionExecutor = c.lexerActionExecutor;
                    let config;
                    if (lexerActionExecutor != null) {
                        lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                        config = c.transform(target, true, lexerActionExecutor);
                    } else {
                        $fomfP(c.lexerActionExecutor == null);
                        config = c.transform(target, true);
                    }
                    let treatEofAsEpsilon = t === $ldi9e.IntStream.EOF;
                    if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                        // any remaining configs for this alt have a lower priority than
                        // the one that just reached an accept state.
                        skipAlt = c.alt;
                        break;
                    }
                }
            }
        }
    }
    accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
        if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
        // seek to after last char in token
        input.seek(index);
        this._line = line;
        this._charPositionInLine = charPos;
        if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
    }
    getReachableTarget(trans, t) {
        if (trans.matches(t, $h7Q3L.Lexer.MIN_CHAR_VALUE, $h7Q3L.Lexer.MAX_CHAR_VALUE)) return trans.target;
        return undefined;
    }
    computeStartState(input, p) {
        let initialContext = $jaUCz.PredictionContext.EMPTY_FULL;
        let configs = new $9O0ze.OrderedATNConfigSet();
        for(let i = 0; i < p.numberOfTransitions; i++){
            let target = p.transition(i).target;
            let c = $hdFz0.ATNConfig.create(target, i + 1, initialContext);
            this.closure(input, c, configs, false, false, false);
        }
        return configs;
    }
    /**
     * Since the alternatives within any lexer decision are ordered by
     * preference, this method stops pursuing the closure as soon as an accept
     * state is reached. After the first accept state is reached by depth-first
     * search from `config`, all other (potentially reachable) states for
     * this rule would have a lower priority.
     *
     * @returns `true` if an accept state is reached, otherwise
     * `false`.
     */ closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
        if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
        if (config.state instanceof $jWsYN.RuleStopState) {
            if (LexerATNSimulator.debug) {
                if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                else console.log(`closure at rule stop ${config}`);
            }
            let context = config.context;
            if (context.isEmpty) {
                configs.add(config);
                return true;
            } else if (context.hasEmpty) {
                configs.add(config.transform(config.state, true, $jaUCz.PredictionContext.EMPTY_FULL));
                currentAltReachedAcceptState = true;
            }
            for(let i = 0; i < context.size; i++){
                let returnStateNumber = context.getReturnState(i);
                if (returnStateNumber === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                let newContext = context.getParent(i); // "pop" return state
                let returnState = this.atn.states[returnStateNumber];
                let c = config.transform(returnState, false, newContext);
                currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        // optimization
        if (!config.state.onlyHasEpsilonTransitions) {
            if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
        }
        let p = config.state;
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            let t = p.getOptimizedTransition(i);
            let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
            if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
        }
        return currentAltReachedAcceptState;
    }
    // side-effect: can alter configs.hasSemanticContext
    getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
        let c;
        switch(t.serializationType){
            case 3 /* RULE */ :
                let ruleTransition = t;
                if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                else {
                    let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                    c = config.transform(t.target, true, newContext);
                }
                break;
            case 10 /* PRECEDENCE */ :
                throw new Error("Precedence predicates are not supported in lexers.");
            case 4 /* PREDICATE */ :
                /*  Track traversing semantic predicates. If we traverse,
                    we cannot add a DFA state for this "reach" computation
                    because the DFA would not test the predicate again in the
                    future. Rather than creating collections of semantic predicates
                    like v3 and testing them on prediction, v4 will test them on the
                    fly all the time using the ATN not the DFA. This is slower but
                    semantically it's not used that often. One of the key elements to
                    this predicate mechanism is not adding DFA states that see
                    predicates immediately afterwards in the ATN. For example,
    
                    a : ID {p1}? | ID {p2}? ;
    
                    should create the start state for rule 'a' (to save start state
                    competition), but should not create target of ID state. The
                    collection of ATN states the following ID references includes
                    states reached by traversing predicates. Since this is when we
                    test them, we cannot cash the DFA state target of ID.
                */ let pt = t;
                if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                configs.hasSemanticContext = true;
                if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                else c = undefined;
                break;
            case 6 /* ACTION */ :
                if (config.context.hasEmpty) {
                    // execute actions anywhere in the start rule for a token.
                    //
                    // TODO: if the entry rule is invoked recursively, some
                    // actions may be executed during the recursive call. The
                    // problem can appear when hasEmpty is true but
                    // isEmpty is false. In this case, the config needs to be
                    // split into two contexts - one with just the empty path
                    // and another with everything but the empty path.
                    // Unfortunately, the current algorithm does not allow
                    // getEpsilonTarget to return two configurations, so
                    // additional modifications are needed before we can support
                    // the split operation.
                    let lexerActionExecutor = $i6TH4.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                    c = config.transform(t.target, true, lexerActionExecutor);
                    break;
                } else {
                    // ignore actions in referenced rules
                    c = config.transform(t.target, true);
                    break;
                }
            case 1 /* EPSILON */ :
                c = config.transform(t.target, true);
                break;
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                if (treatEofAsEpsilon) {
                    if (t.matches($ldi9e.IntStream.EOF, $h7Q3L.Lexer.MIN_CHAR_VALUE, $h7Q3L.Lexer.MAX_CHAR_VALUE)) {
                        c = config.transform(t.target, false);
                        break;
                    }
                }
                c = undefined;
                break;
            default:
                c = undefined;
                break;
        }
        return c;
    }
    /**
     * Evaluate a predicate specified in the lexer.
     *
     * If `speculative` is `true`, this method was called before
     * {@link #consume} for the matched character. This method should call
     * {@link #consume} before evaluating the predicate to ensure position
     * sensitive values, including {@link Lexer#getText}, {@link Lexer#getLine},
     * and {@link Lexer#getCharPositionInLine}, properly reflect the current
     * lexer state. This method should restore `input` and the simulator
     * to the original state before returning (i.e. undo the actions made by the
     * call to {@link #consume}.
     *
     * @param input The input stream.
     * @param ruleIndex The rule containing the predicate.
     * @param predIndex The index of the predicate within the rule.
     * @param speculative `true` if the current index in `input` is
     * one character before the predicate's location.
     *
     * @returns `true` if the specified predicate evaluates to
     * `true`.
     */ evaluatePredicate(input, ruleIndex, predIndex, speculative) {
        // assume true if no recognizer was provided
        if (this.recog == null) return true;
        if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
        let savedCharPositionInLine = this._charPositionInLine;
        let savedLine = this._line;
        let index = input.index;
        let marker = input.mark();
        try {
            this.consume(input);
            return this.recog.sempred(undefined, ruleIndex, predIndex);
        } finally{
            this._charPositionInLine = savedCharPositionInLine;
            this._line = savedLine;
            input.seek(index);
            input.release(marker);
        }
    }
    captureSimState(settings, input, dfaState) {
        settings.index = input.index;
        settings.line = this._line;
        settings.charPos = this._charPositionInLine;
        settings.dfaState = dfaState;
    }
    addDFAEdge(p, t, q) {
        if (q instanceof $2SGHL.ATNConfigSet) {
            /* leading to this call, ATNConfigSet.hasSemanticContext is used as a
            * marker indicating dynamic predicate evaluation makes this edge
            * dependent on the specific input sequence, so the static edge in the
            * DFA should be omitted. The target DFAState is still created since
            * execATN has the ability to resynchronize with the DFA state cache
            * following the predicate evaluation step.
            *
            * TJP notes: next time through the DFA, we see a pred again and eval.
            * If that gets us to a previously created (but dangling) DFA
            * state, we can continue in pure DFA mode from there.
            */ let suppressEdge = q.hasSemanticContext;
            if (suppressEdge) q.hasSemanticContext = false;
            // @NotNull
            let to = this.addDFAState(q);
            if (suppressEdge) return to;
            this.addDFAEdge(p, t, to);
            return to;
        } else {
            if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
            if (p != null) p.setTarget(t, q);
        }
    }
    /** Add a new DFA state if there isn't one with this set of
     * 	configurations already. This method also detects the first
     * 	configuration containing an ATN rule stop state. Later, when
     * 	traversing the DFA, we will know which rule to accept.
     */ addDFAState(configs) {
        /* the lexer evaluates predicates on-the-fly; by this point configs
         * should not contain any configurations with unevaluated predicates.
         */ $fomfP(!configs.hasSemanticContext);
        let proposed = new $6P9ap.DFAState(configs);
        let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
        if (existing != null) return existing;
        configs.optimizeConfigs(this);
        let newState = new $6P9ap.DFAState(configs.clone(true));
        let firstConfigWithRuleStopState;
        for (let c of configs)if (c.state instanceof $jWsYN.RuleStopState) {
            firstConfigWithRuleStopState = c;
            break;
        }
        if (firstConfigWithRuleStopState != null) {
            let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
            let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
            newState.acceptStateInfo = new $hu8W9.AcceptStateInfo(prediction, lexerActionExecutor);
        }
        return this.atn.modeToDFA[this.mode].addState(newState);
    }
    getDFA(mode) {
        return this.atn.modeToDFA[mode];
    }
    /** Get the text matched so far for the current token.
     */ getText(input) {
        // index is first lookahead char, don't include.
        return input.getText($l8y5T.Interval.of(this.startIndex, input.index - 1));
    }
    get line() {
        return this._line;
    }
    set line(line) {
        this._line = line;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    consume(input) {
        let curChar = input.LA(1);
        if (curChar === "\n".charCodeAt(0)) {
            this._line++;
            this._charPositionInLine = 0;
        } else this._charPositionInLine++;
        input.consume();
    }
    getTokenName(t) {
        if (t === -1) return "EOF";
        //if ( atn.g!=null ) return atn.g.getTokenDisplayName(t);
        return "'" + String.fromCharCode(t) + "'";
    }
};
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "prevAccept", void 0);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "copyState", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "match", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.Override
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "reset", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "matchATN", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "execATN", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "computeTargetState", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "accept", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "computeStartState", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "closure", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(3, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "captureSimState", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "addDFAState", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getDFA", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getText", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "consume", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getTokenName", null);
$178056f04e0087b5$var$LexerATNSimulator = $178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator);
module.exports.LexerATNSimulator = $178056f04e0087b5$var$LexerATNSimulator;
(function(LexerATNSimulator) {
    LexerATNSimulator.debug = false;
    LexerATNSimulator.dfa_debug = false;
    /** When we hit an accept state in either the DFA or the ATN, we
     *  have to notify the character stream to start buffering characters
     *  via {@link IntStream#mark} and record the current state. The current sim state
     *  includes the current index into the input, the current line,
     *  and current character position in that line. Note that the Lexer is
     *  tracking the starting line and characterization of the token. These
     *  variables track the "state" of the simulator when it hits an accept state.
     *
     *  We track these variables separately for the DFA and ATN simulation
     *  because the DFA simulation often has to fail over to the ATN
     *  simulation. If the ATN simulation fails, we need the DFA to fall
     *  back to its previously accepted state, if any. If the ATN succeeds,
     *  then the ATN does the accept and the DFA simulator that invoked it
     *  can simply return the predicted token type.
     */ class SimState {
        constructor(){
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
        }
        reset() {
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
            this.dfaState = undefined;
        }
    }
    LexerATNSimulator.SimState = SimState;
})($178056f04e0087b5$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
module.exports.LexerATNSimulator = $178056f04e0087b5$var$LexerATNSimulator;

});
parcelRegister("hu8W9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AcceptStateInfo = void 0;
/**
 * Stores information about a {@link DFAState} which is an accept state under
 * some condition. Certain settings, such as
 * {@link ParserATNSimulator#getPredictionMode()}, may be used in addition to
 * this information to determine whether or not a particular state is an accept
 * state.
 *
 * @author Sam Harwell
 */ class $cbac2bb2f6962aae$var$AcceptStateInfo {
    constructor(prediction, lexerActionExecutor){
        this._prediction = prediction;
        this._lexerActionExecutor = lexerActionExecutor;
    }
    /**
     * Gets the prediction made by this accept state. Note that this value
     * assumes the predicates, if any, in the {@link DFAState} evaluate to
     * `true`. If predicate evaluation is enabled, the final prediction of
     * the accept state will be determined by the result of predicate
     * evaluation.
     */ get prediction() {
        return this._prediction;
    }
    /**
     * Gets the {@link LexerActionExecutor} which can be used to execute actions
     * and/or commands after the lexer matches a token.
     */ get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
}
module.exports.AcceptStateInfo = $cbac2bb2f6962aae$var$AcceptStateInfo;

});

parcelRegister("eeOLb", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a5d9bf5b15739a51$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a5d9bf5b15739a51$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATN = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $1Cdmr = parcelRequire("1Cdmr");

var $6kdz0 = parcelRequire("6kdz0");

var $8ii30 = parcelRequire("8ii30");

var $kUmff = parcelRequire("kUmff");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $eKXi4 = parcelRequire("eKXi4");

var $fomfP = parcelRequire("fomfP");
/** */ let $a5d9bf5b15739a51$var$ATN = class ATN {
    /** Used for runtime deserialization of ATNs from strings */ constructor(grammarType, maxTokenType){
        this.states = [];
        /** Each subrule/rule is a decision point and we must track them so we
         *  can go back later and build DFA predictors for them.  This includes
         *  all the rules, subrules, optional blocks, ()+, ()* etc...
         */ this.decisionToState = [];
        this.modeNameToStartState = new Map();
        this.modeToStartState = [];
        this.contextCache = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.decisionToDFA = [];
        this.modeToDFA = [];
        this.LL1Table = new Map();
        this.grammarType = grammarType;
        this.maxTokenType = maxTokenType;
    }
    clearDFA() {
        this.decisionToDFA = new Array(this.decisionToState.length);
        for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $1Cdmr.DFA(this.decisionToState[i], i);
        this.modeToDFA = new Array(this.modeToStartState.length);
        for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $1Cdmr.DFA(this.modeToStartState[i]);
        this.contextCache.clear();
        this.LL1Table.clear();
    }
    get contextCacheSize() {
        return this.contextCache.size;
    }
    getCachedContext(context) {
        return $jaUCz.PredictionContext.getCachedContext(context, this.contextCache, new $jaUCz.PredictionContext.IdentityHashMap());
    }
    getDecisionToDFA() {
        $fomfP(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
        return this.decisionToDFA;
    }
    nextTokens(s, ctx) {
        if (ctx) {
            let anal = new $kUmff.LL1Analyzer(this);
            let next = anal.LOOK(s, ctx);
            return next;
        } else {
            if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
            s.nextTokenWithinRule = this.nextTokens(s, $jaUCz.PredictionContext.EMPTY_LOCAL);
            s.nextTokenWithinRule.setReadonly(true);
            return s.nextTokenWithinRule;
        }
    }
    addState(state) {
        state.atn = this;
        state.stateNumber = this.states.length;
        this.states.push(state);
    }
    removeState(state) {
        // just replace the state, don't shift states in list
        let invalidState = new $8ii30.InvalidState();
        invalidState.atn = this;
        invalidState.stateNumber = state.stateNumber;
        this.states[state.stateNumber] = invalidState;
    }
    defineMode(name, s) {
        this.modeNameToStartState.set(name, s);
        this.modeToStartState.push(s);
        this.modeToDFA.push(new $1Cdmr.DFA(s));
        this.defineDecisionState(s);
    }
    defineDecisionState(s) {
        this.decisionToState.push(s);
        s.decision = this.decisionToState.length - 1;
        this.decisionToDFA.push(new $1Cdmr.DFA(s, s.decision));
        return s.decision;
    }
    getDecisionState(decision) {
        if (this.decisionToState.length > 0) return this.decisionToState[decision];
        return undefined;
    }
    get numberOfDecisions() {
        return this.decisionToState.length;
    }
    /**
     * Computes the set of input symbols which could follow ATN state number
     * `stateNumber` in the specified full `context`. This method
     * considers the complete parser context, but does not evaluate semantic
     * predicates (i.e. all predicates encountered during the calculation are
     * assumed true). If a path in the ATN exists from the starting state to the
     * {@link RuleStopState} of the outermost context without matching any
     * symbols, {@link Token#EOF} is added to the returned set.
     *
     * If `context` is `undefined`, it is treated as
     * {@link ParserRuleContext#EMPTY}.
     *
     * Note that this does NOT give you the set of all tokens that could
     * appear at a given token position in the input phrase.  In other words, it
     * does not answer:
     *
     * > Given a specific partial input phrase, return the set of all
     * > tokens that can follow the last token in the input phrase.
     *
     * The big difference is that with just the input, the parser could land
     * right in the middle of a lookahead decision. Getting all
     * *possible* tokens given a partial input stream is a separate
     * computation. See https://github.com/antlr/antlr4/issues/1428
     *
     * For this function, we are specifying an ATN state and call stack to
     * compute what token(s) can come next and specifically: outside of a
     * lookahead decision. That is what you want for error reporting and
     * recovery upon parse error.
     *
     * @param stateNumber the ATN state number
     * @param context the full parse context
     * @returns The set of potentially valid input symbols which could follow the
     * specified state in the specified context.
     * @ if the ATN does not contain a state with
     * number `stateNumber`
     */ getExpectedTokens(stateNumber, context) {
        if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
        let ctx = context;
        let s = this.states[stateNumber];
        let following = this.nextTokens(s);
        if (!following.contains($eKXi4.Token.EPSILON)) return following;
        let expected = new $6kdz0.IntervalSet();
        expected.addAll(following);
        expected.remove($eKXi4.Token.EPSILON);
        while(ctx != null && ctx.invokingState >= 0 && following.contains($eKXi4.Token.EPSILON)){
            let invokingState = this.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = this.nextTokens(rt.followState);
            expected.addAll(following);
            expected.remove($eKXi4.Token.EPSILON);
            ctx = ctx._parent;
        }
        if (following.contains($eKXi4.Token.EPSILON)) expected.add($eKXi4.Token.EOF);
        return expected;
    }
};
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "states", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "decisionToState", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "modeNameToStartState", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "modeToStartState", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "decisionToDFA", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "modeToDFA", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "nextTokens", null);
$a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN.prototype, "removeState", null);
$a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull),
    $a5d9bf5b15739a51$var$__param(1, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN.prototype, "defineMode", null);
$a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN.prototype, "defineDecisionState", null);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "getExpectedTokens", null);
$a5d9bf5b15739a51$var$ATN = $a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN);
module.exports.ATN = $a5d9bf5b15739a51$var$ATN;
(function(ATN) {
    ATN.INVALID_ALT_NUMBER = 0;
})($a5d9bf5b15739a51$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
module.exports.ATN = $a5d9bf5b15739a51$var$ATN;

});
parcelRegister("jRlcM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashMap = void 0;

var $fsqYw = parcelRequire("fsqYw");
class $e7536a7825c78fd8$var$MapKeyEqualityComparator {
    constructor(keyComparator){
        this.keyComparator = keyComparator;
    }
    hashCode(obj) {
        return this.keyComparator.hashCode(obj.key);
    }
    equals(a, b) {
        return this.keyComparator.equals(a.key, b.key);
    }
}
class $e7536a7825c78fd8$var$Array2DHashMap {
    constructor(keyComparer){
        if (keyComparer instanceof $e7536a7825c78fd8$var$Array2DHashMap) this.backingStore = new $fsqYw.Array2DHashSet(keyComparer.backingStore);
        else this.backingStore = new $fsqYw.Array2DHashSet(new $e7536a7825c78fd8$var$MapKeyEqualityComparator(keyComparer));
    }
    clear() {
        this.backingStore.clear();
    }
    containsKey(key) {
        return this.backingStore.contains({
            key: key
        });
    }
    get(key) {
        let bucket = this.backingStore.get({
            key: key
        });
        if (!bucket) return undefined;
        return bucket.value;
    }
    get isEmpty() {
        return this.backingStore.isEmpty;
    }
    put(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else {
            result = element.value;
            element.value = value;
        }
        return result;
    }
    putIfAbsent(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else result = element.value;
        return result;
    }
    get size() {
        return this.backingStore.size;
    }
    hashCode() {
        return this.backingStore.hashCode();
    }
    equals(o) {
        if (!(o instanceof $e7536a7825c78fd8$var$Array2DHashMap)) return false;
        return this.backingStore.equals(o.backingStore);
    }
}
module.exports.Array2DHashMap = $e7536a7825c78fd8$var$Array2DHashMap;

});

parcelRegister("1Cdmr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $12d3b4406c1292f5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $12d3b4406c1292f5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFA = void 0;

var $fsqYw = parcelRequire("fsqYw");

var $2SGHL = parcelRequire("2SGHL");

var $aVeml = parcelRequire("aVeml");

var $6P9ap = parcelRequire("6P9ap");

var $gwhAV = parcelRequire("gwhAV");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $e0pjt = parcelRequire("e0pjt");

var $hBnE1 = parcelRequire("hBnE1");
let $12d3b4406c1292f5$var$DFA = class DFA {
    constructor(atnStartState, decision = 0){
        /**
         * A set of all states in the `DFA`.
         *
         * Note that this collection of states holds the DFA states for both SLL and LL prediction. Only the start state
         * needs to be differentiated for these cases, which is tracked by the `s0` and `s0full` fields.
         */ this.states = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.nextStateNumber = 0;
        if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
        this.atnStartState = atnStartState;
        this.atn = atnStartState.atn;
        this.decision = decision;
        // Precedence DFAs are associated with the special precedence decision created for left-recursive rules which
        // evaluate their alternatives using a precedence hierarchy. When such a decision is encountered, we mark this
        // DFA instance as a precedence DFA and initialize the initial states s0 and s0full to special DFAState
        // instances which use outgoing edges to link to the actual start state used for each precedence level.
        let isPrecedenceDfa = false;
        if (atnStartState instanceof $e0pjt.StarLoopEntryState) {
            if (atnStartState.precedenceRuleDecision) {
                isPrecedenceDfa = true;
                this.s0 = new $6P9ap.DFAState(new $2SGHL.ATNConfigSet());
                this.s0full = new $6P9ap.DFAState(new $2SGHL.ATNConfigSet());
            }
        }
        this.precedenceDfa = isPrecedenceDfa;
    }
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise,
     * `false`.
     * @see Parser.precedence
     */ get isPrecedenceDfa() {
        return this.precedenceDfa;
    }
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @returns The start state corresponding to the specified precedence, or
     * `undefined` if no start state exists for the specified precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ getPrecedenceStartState(precedence, fullContext) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        // s0 and s0full are never null for a precedence DFA
        if (fullContext) return this.s0full.getTarget(precedence);
        else return this.s0.getTarget(precedence);
    }
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified
     * precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ setPrecedenceStartState(precedence, fullContext, startState) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        if (precedence < 0) return;
        if (fullContext) // s0full is never null for a precedence DFA
        this.s0full.setTarget(precedence, startState);
        else // s0 is never null for a precedence DFA
        this.s0.setTarget(precedence, startState);
    }
    get isEmpty() {
        if (this.isPrecedenceDfa) // s0 and s0full are never null for a precedence DFA
        return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
        return this.s0 == null && this.s0full == null;
    }
    get isContextSensitive() {
        if (this.isPrecedenceDfa) // s0full is never null for a precedence DFA
        return this.s0full.getEdgeMap().size > 0;
        return this.s0full != null;
    }
    addState(state) {
        state.stateNumber = this.nextStateNumber++;
        return this.states.getOrAdd(state);
    }
    toString(vocabulary, ruleNames) {
        if (!vocabulary) vocabulary = $hBnE1.VocabularyImpl.EMPTY_VOCABULARY;
        if (!this.s0) return "";
        let serializer;
        if (ruleNames) serializer = new $aVeml.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
        else serializer = new $aVeml.DFASerializer(this, vocabulary);
        return serializer.toString();
    }
    toLexerString() {
        if (!this.s0) return "";
        let serializer = new $gwhAV.LexerDFASerializer(this);
        return serializer.toString();
    }
};
$12d3b4406c1292f5$var$__decorate([
    $aN41m.NotNull
], $12d3b4406c1292f5$var$DFA.prototype, "states", void 0);
$12d3b4406c1292f5$var$__decorate([
    $aN41m.NotNull
], $12d3b4406c1292f5$var$DFA.prototype, "atnStartState", void 0);
$12d3b4406c1292f5$var$__decorate([
    $aN41m.NotNull
], $12d3b4406c1292f5$var$DFA.prototype, "atn", void 0);
$12d3b4406c1292f5$var$DFA = $12d3b4406c1292f5$var$__decorate([
    $12d3b4406c1292f5$var$__param(0, $aN41m.NotNull)
], $12d3b4406c1292f5$var$DFA);
module.exports.DFA = $12d3b4406c1292f5$var$DFA;

});
parcelRegister("2SGHL", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2191c0313d388677$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfigSet = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $fsqYw = parcelRequire("fsqYw");

var $6iIjF = parcelRequire("6iIjF");

var $eeOLb = parcelRequire("eeOLb");

var $hdFz0 = parcelRequire("hdFz0");

var $8WIez = parcelRequire("8WIez");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $4BvNW = parcelRequire("4BvNW");

var $3JS45 = parcelRequire("3JS45");

var $fomfP = parcelRequire("fomfP");

var $62Uvn = parcelRequire("62Uvn");
class $2191c0313d388677$var$KeyTypeEqualityComparer {
    hashCode(key) {
        return key.state ^ key.alt;
    }
    equals(a, b) {
        return a.state === b.state && a.alt === b.alt;
    }
}
$2191c0313d388677$var$KeyTypeEqualityComparer.INSTANCE = new $2191c0313d388677$var$KeyTypeEqualityComparer();
function $2191c0313d388677$var$NewKeyedConfigMap(map) {
    if (map) return new $jRlcM.Array2DHashMap(map);
    else return new $jRlcM.Array2DHashMap($2191c0313d388677$var$KeyTypeEqualityComparer.INSTANCE);
}
/**
 * Represents a set of ATN configurations (see `ATNConfig`). As configurations are added to the set, they are merged
 * with other `ATNConfig` instances already in the set when possible using the graph-structured stack.
 *
 * An instance of this class represents the complete set of positions (with context) in an ATN which would be associated
 * with a single DFA state. Its internal representation is more complex than traditional state used for NFA to DFA
 * conversion due to performance requirements (both improving speed and reducing memory overhead) as well as supporting
 * features such as semantic predicates and non-greedy operators in a form to support ANTLR's prediction algorithm.
 *
 * @author Sam Harwell
 */ class $2191c0313d388677$var$ATNConfigSet {
    constructor(set, readonly){
        this._uniqueAlt = 0;
        // Used in parser and lexer. In lexer, it indicates we hit a pred
        // while computing a closure operation.  Don't make a DFA state from this.
        this._hasSemanticContext = false;
        this._dipsIntoOuterContext = false;
        /**
         * When `true`, this config set represents configurations where the entire
         * outer context has been consumed by the ATN interpreter. This prevents the
         * {@link ParserATNSimulator#closure} from pursuing the global FOLLOW when a
         * rule stop state is reached with an empty prediction context.
         *
         * Note: `outermostConfigSet` and {@link #dipsIntoOuterContext} should never
         * be true at the same time.
         */ this.outermostConfigSet = false;
        this.cachedHashCode = -1;
        if (!set) {
            this.mergedConfigs = $2191c0313d388677$var$NewKeyedConfigMap();
            this.unmerged = [];
            this.configs = [];
            this._uniqueAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        } else {
            if (readonly) {
                this.mergedConfigs = undefined;
                this.unmerged = undefined;
            } else if (!set.isReadOnly) {
                this.mergedConfigs = $2191c0313d388677$var$NewKeyedConfigMap(set.mergedConfigs);
                this.unmerged = set.unmerged.slice(0);
            } else {
                this.mergedConfigs = $2191c0313d388677$var$NewKeyedConfigMap();
                this.unmerged = [];
            }
            this.configs = set.configs.slice(0);
            this._dipsIntoOuterContext = set._dipsIntoOuterContext;
            this._hasSemanticContext = set._hasSemanticContext;
            this.outermostConfigSet = set.outermostConfigSet;
            if (readonly || !set.isReadOnly) {
                this._uniqueAlt = set._uniqueAlt;
                this._conflictInfo = set._conflictInfo;
            }
        // if (!readonly && set.isReadOnly) -> addAll is called from clone()
        }
    }
    /**
     * Get the set of all alternatives represented by configurations in this
     * set.
     */ getRepresentedAlternatives() {
        if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
        let alts = new $8WIez.BitSet();
        for (let config of this)alts.set(config.alt);
        return alts;
    }
    get isReadOnly() {
        return this.mergedConfigs == null;
    }
    get isOutermostConfigSet() {
        return this.outermostConfigSet;
    }
    set isOutermostConfigSet(outermostConfigSet) {
        if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
        $fomfP(!outermostConfigSet || !this._dipsIntoOuterContext);
        this.outermostConfigSet = outermostConfigSet;
    }
    getStates() {
        let states = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
        for (let c of this.configs)states.add(c.state);
        return states;
    }
    optimizeConfigs(interpreter) {
        if (this.configs.length === 0) return;
        for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
    }
    clone(readonly) {
        let copy = new $2191c0313d388677$var$ATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this.configs);
        return copy;
    }
    get size() {
        return this.configs.length;
    }
    get isEmpty() {
        return this.configs.length === 0;
    }
    contains(o) {
        if (!(o instanceof $hdFz0.ATNConfig)) return false;
        if (this.mergedConfigs && this.unmerged) {
            let config = o;
            let configKey = this.getKey(config);
            let mergedConfig = this.mergedConfigs.get(configKey);
            if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
            for (let c of this.unmerged){
                if (c.contains(o)) return true;
            }
        } else for (let c of this.configs){
            if (c.contains(o)) return true;
        }
        return false;
    }
    *[Symbol.iterator]() {
        yield* this.configs;
    }
    toArray() {
        return this.configs;
    }
    add(e, contextCache) {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        $fomfP(!this.outermostConfigSet || !e.reachesIntoOuterContext);
        if (contextCache == null) contextCache = $4BvNW.PredictionContextCache.UNCACHED;
        let addKey;
        let key = this.getKey(e);
        let mergedConfig = this.mergedConfigs.get(key);
        addKey = mergedConfig == null;
        if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
            mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
            if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
            let joined = $jaUCz.PredictionContext.join(mergedConfig.context, e.context, contextCache);
            this.updatePropertiesForMergedConfig(e);
            if (mergedConfig.context === joined) return false;
            mergedConfig.context = joined;
            return true;
        }
        for(let i = 0; i < this.unmerged.length; i++){
            let unmergedConfig = this.unmerged[i];
            if (this.canMerge(e, key, unmergedConfig)) {
                unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $jaUCz.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (unmergedConfig.context === joined) return false;
                unmergedConfig.context = joined;
                if (addKey) {
                    this.mergedConfigs.put(key, unmergedConfig);
                    this.unmerged.splice(i, 1);
                }
                return true;
            }
        }
        this.configs.push(e);
        if (addKey) this.mergedConfigs.put(key, e);
        else this.unmerged.push(e);
        this.updatePropertiesForAddedConfig(e);
        return true;
    }
    updatePropertiesForMergedConfig(config) {
        // merged configs can't change the alt or semantic context
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $fomfP(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    updatePropertiesForAddedConfig(config) {
        if (this.configs.length === 1) this._uniqueAlt = config.alt;
        else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        this._hasSemanticContext = this._hasSemanticContext || !$3JS45.SemanticContext.NONE.equals(config.semanticContext);
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $fomfP(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    canMerge(left, leftKey, right) {
        if (left.state.stateNumber !== right.state.stateNumber) return false;
        if (leftKey.alt !== right.alt) return false;
        return left.semanticContext.equals(right.semanticContext);
    }
    getKey(e) {
        return {
            state: e.state.stateNumber,
            alt: e.alt
        };
    }
    containsAll(c) {
        for (let o of c){
            if (!(o instanceof $hdFz0.ATNConfig)) return false;
            if (!this.contains(o)) return false;
        }
        return true;
    }
    addAll(c, contextCache) {
        this.ensureWritable();
        let changed = false;
        for (let group of c)if (this.add(group, contextCache)) changed = true;
        return changed;
    }
    clear() {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        this.mergedConfigs.clear();
        this.unmerged.length = 0;
        this.configs.length = 0;
        this._dipsIntoOuterContext = false;
        this._hasSemanticContext = false;
        this._uniqueAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        this._conflictInfo = undefined;
    }
    equals(obj) {
        if (this === obj) return true;
        if (!(obj instanceof $2191c0313d388677$var$ATNConfigSet)) return false;
        return this.outermostConfigSet === obj.outermostConfigSet && $62Uvn.equals(this._conflictInfo, obj._conflictInfo) && $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
    }
    hashCode() {
        if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
        let hashCode = 1;
        hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
        hashCode = 5 * hashCode ^ $6iIjF.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
        if (this.isReadOnly) this.cachedHashCode = hashCode;
        return hashCode;
    }
    toString(showContext) {
        if (showContext == null) showContext = false;
        let buf = "";
        let sortedConfigs = this.configs.slice(0);
        sortedConfigs.sort((o1, o2)=>{
            if (o1.alt !== o2.alt) return o1.alt - o2.alt;
            else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
            else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
        });
        buf += "[";
        for(let i = 0; i < sortedConfigs.length; i++){
            if (i > 0) buf += ", ";
            buf += sortedConfigs[i].toString(undefined, true, showContext);
        }
        buf += "]";
        if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
        if (this._uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
        if (this._conflictInfo != null) {
            buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
            if (!this._conflictInfo.isExact) buf += "*";
        }
        if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
        return buf.toString();
    }
    get uniqueAlt() {
        return this._uniqueAlt;
    }
    get hasSemanticContext() {
        return this._hasSemanticContext;
    }
    set hasSemanticContext(value) {
        this.ensureWritable();
        this._hasSemanticContext = value;
    }
    get conflictInfo() {
        return this._conflictInfo;
    }
    set conflictInfo(conflictInfo) {
        this.ensureWritable();
        this._conflictInfo = conflictInfo;
    }
    get conflictingAlts() {
        if (this._conflictInfo == null) return undefined;
        return this._conflictInfo.conflictedAlts;
    }
    get isExactConflict() {
        if (this._conflictInfo == null) return false;
        return this._conflictInfo.isExact;
    }
    get dipsIntoOuterContext() {
        return this._dipsIntoOuterContext;
    }
    get(index) {
        return this.configs[index];
    }
    ensureWritable() {
        if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
    }
}
$2191c0313d388677$var$__decorate([
    $aN41m.NotNull
], $2191c0313d388677$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "size", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "isEmpty", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "contains", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, Symbol.iterator, null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "toArray", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "containsAll", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "clear", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "equals", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "hashCode", null);
module.exports.ATNConfigSet = $2191c0313d388677$var$ATNConfigSet;

});
parcelRegister("hdFz0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c893e436b255fe4f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c893e436b255fe4f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfig = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $42ptv = parcelRequire("42ptv");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $3JS45 = parcelRequire("3JS45");

var $fomfP = parcelRequire("fomfP");
/**
 * This field stores the bit mask for implementing the
 * {@link #isPrecedenceFilterSuppressed} property as a bit within the
 * existing {@link #altAndOuterContextDepth} field.
 */ const $c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
/**
 * Represents a location with context in an ATN. The location is identified by the following values:
 *
 * * The current ATN state
 * * The predicted alternative
 * * The semantic context which must be true for this configuration to be enabled
 * * The syntactic context, which is represented as a graph-structured stack whose path(s) lead to the root of the rule
 *   invocations leading to this state
 *
 * In addition to these values, `ATNConfig` stores several properties about paths taken to get to the location which
 * were added over time to help with performance, correctness, and/or debugging.
 *
 * * `reachesIntoOuterContext`:: Used to ensure semantic predicates are not evaluated in the wrong context.
 * * `hasPassedThroughNonGreedyDecision`: Used for enabling first-match-wins instead of longest-match-wins after
 *   crossing a non-greedy decision.
 * * `lexerActionExecutor`: Used for tracking the lexer action(s) to execute should this instance be selected during
 *   lexing.
 * * `isPrecedenceFilterSuppressed`: A state variable for one of the dynamic disambiguation strategies employed by
 *   `ParserATNSimulator.applyPrecedenceFilter`.
 *
 * Due to the use of a graph-structured stack, a single `ATNConfig` is capable of representing many individual ATN
 * configurations which reached the same location in an ATN by following different paths.
 *
 * PERF: To conserve memory, `ATNConfig` is split into several different concrete types. `ATNConfig` itself stores the
 * minimum amount of information typically used to define an `ATNConfig` instance. Various derived types provide
 * additional storage space for cases where a non-default value is used for some of the object properties. The
 * `ATNConfig.create` and `ATNConfig.transform` methods automatically select the smallest concrete type capable of
 * representing the unique information for any given `ATNConfig`.
 */ let $c893e436b255fe4f$var$ATNConfig = class ATNConfig {
    constructor(state, altOrConfig, context){
        if (typeof altOrConfig === "number") {
            $fomfP((altOrConfig & 0xFFFFFF) === altOrConfig);
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig;
            this._context = context;
        } else {
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
            this._context = context;
        }
    }
    static create(state, alt, context, semanticContext = $3JS45.SemanticContext.NONE, lexerActionExecutor) {
        if (semanticContext !== $3JS45.SemanticContext.NONE) {
            if (lexerActionExecutor != null) return new $c893e436b255fe4f$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
            else return new $c893e436b255fe4f$var$SemanticContextATNConfig(semanticContext, state, alt, context);
        } else if (lexerActionExecutor != null) return new $c893e436b255fe4f$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
        else return new ATNConfig(state, alt, context);
    }
    /** Gets the ATN state associated with this configuration */ get state() {
        return this._state;
    }
    /** What alt (or lexer rule) is predicted by this configuration */ get alt() {
        return this.altAndOuterContextDepth & 0x00FFFFFF;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
    }
    get reachesIntoOuterContext() {
        return this.outerContextDepth !== 0;
    }
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth &gt; 0.  Note that it may not be totally accurate depth since I
     * don't ever decrement. TODO: make it a boolean then
     */ get outerContextDepth() {
        return this.altAndOuterContextDepth >>> 24 & 0x7F;
    }
    set outerContextDepth(outerContextDepth) {
        $fomfP(outerContextDepth >= 0);
        // saturate at 0x7F - everything but zero/positive is only used for debug information anyway
        outerContextDepth = Math.min(outerContextDepth, 0x7F);
        this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
    }
    get lexerActionExecutor() {
        return undefined;
    }
    get semanticContext() {
        return $3JS45.SemanticContext.NONE;
    }
    get hasPassedThroughNonGreedyDecision() {
        return false;
    }
    clone() {
        return this.transform(this.state, false);
    }
    transform(/*@NotNull*/ state, checkNonGreedy, arg2) {
        if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $jaUCz.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $3JS45.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
        else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
    }
    transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
        let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
        if (semanticContext !== $3JS45.SemanticContext.NONE) {
            if (lexerActionExecutor != null || passedThroughNonGreedy) return new $c893e436b255fe4f$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
            else return new $c893e436b255fe4f$var$SemanticContextATNConfig(semanticContext, state, this, context);
        } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $c893e436b255fe4f$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
        else return new ATNConfig(state, this, context);
    }
    static checkNonGreedyDecision(source, target) {
        return source.hasPassedThroughNonGreedyDecision || target instanceof $42ptv.DecisionState && target.nonGreedy;
    }
    appendContext(context, contextCache) {
        if (typeof context === "number") {
            let appendedContext = this.context.appendSingleContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        } else {
            let appendedContext = this.context.appendContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        }
    }
    /**
     * Determines if this `ATNConfig` fully contains another `ATNConfig`.
     *
     * An ATN configuration represents a position (including context) in an ATN during parsing. Since `ATNConfig` stores
     * the context as a graph, a single `ATNConfig` instance is capable of representing many ATN configurations which
     * are all in the same "location" but have different contexts. These `ATNConfig` instances are again merged when
     * they are added to an `ATNConfigSet`. This method supports `ATNConfigSet.contains` by evaluating whether a
     * particular `ATNConfig` contains all of the ATN configurations represented by another `ATNConfig`.
     *
     * An `ATNConfig` _a_ contains another `ATNConfig` _b_ if all of the following conditions are met:
     *
     * * The configurations are in the same state (`state`)
     * * The configurations predict the same alternative (`alt`)
     * * The semantic context of _a_ implies the semantic context of _b_ (this method performs a weaker equality check)
     * * Joining the prediction contexts of _a_ and _b_ results in the prediction context of _a_
     *
     * This method implements a conservative approximation of containment. As a result, when this method returns `true`
     * it is known that parsing from `subconfig` can only recognize a subset of the inputs which can be recognized
     * starting at the current `ATNConfig`. However, due to the imprecise evaluation of implication for the semantic
     * contexts, no assumptions can be made about the relationship between the configurations when this method returns
     * `false`.
     *
     * @param subconfig The sub configuration.
     * @returns `true` if this configuration contains `subconfig`; otherwise, `false`.
     */ contains(subconfig) {
        if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
        let leftWorkList = [];
        let rightWorkList = [];
        leftWorkList.push(this.context);
        rightWorkList.push(subconfig.context);
        while(true){
            let left = leftWorkList.pop();
            let right = rightWorkList.pop();
            if (!left || !right) break;
            if (left === right) return true;
            if (left.size < right.size) return false;
            if (right.isEmpty) return left.hasEmpty;
            else for(let i = 0; i < right.size; i++){
                let index = left.findReturnState(right.getReturnState(i));
                if (index < 0) // assumes invokingStates has no duplicate entries
                return false;
                leftWorkList.push(left.getParent(index));
                rightWorkList.push(right.getParent(i));
            }
        }
        return false;
    }
    get isPrecedenceFilterSuppressed() {
        return (this.altAndOuterContextDepth & $c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
    }
    set isPrecedenceFilterSuppressed(value) {
        if (value) this.altAndOuterContextDepth |= $c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER;
        else this.altAndOuterContextDepth &= ~$c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER;
    }
    /** An ATN configuration is equal to another if both have
     *  the same state, they predict the same alternative, and
     *  syntactic/semantic contexts are the same.
     */ equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ATNConfig)) return false;
        return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $9eW9B.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
    }
    hashCode() {
        let hashCode = $amQx9.MurmurHash.initialize(7);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.state.stateNumber);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.alt);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.context);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.semanticContext);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.lexerActionExecutor);
        hashCode = $amQx9.MurmurHash.finish(hashCode, 7);
        return hashCode;
    }
    /**
     * Returns a graphical representation of the current `ATNConfig` in Graphviz format. The graph can be stored to a
     * **.dot** file and then rendered to an image using Graphviz.
     *
     * @returns A Graphviz graph representing the current `ATNConfig`.
     *
     * @see http://www.graphviz.org/
     */ toDotString() {
        let builder = "";
        builder += "digraph G {\n";
        builder += "rankdir=LR;\n";
        let visited = new $jRlcM.Array2DHashMap($jaUCz.PredictionContext.IdentityEqualityComparator.INSTANCE);
        let workList = [];
        function getOrAddContext(context) {
            let newNumber = visited.size;
            let result = visited.putIfAbsent(context, newNumber);
            if (result != null) // Already saw this context
            return result;
            workList.push(context);
            return newNumber;
        }
        workList.push(this.context);
        visited.put(this.context, 0);
        while(true){
            let current = workList.pop();
            if (!current) break;
            for(let i = 0; i < current.size; i++){
                builder += "  s" + getOrAddContext(current);
                builder += "->";
                builder += "s" + getOrAddContext(current.getParent(i));
                builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
            }
        }
        builder += "}\n";
        return builder.toString();
    }
    toString(recog, showAlt, showContext) {
        // Must check showContext before showAlt to preserve original overload behavior
        if (showContext == null) showContext = showAlt != null;
        if (showAlt == null) showAlt = true;
        let buf = "";
        // if (this.state.ruleIndex >= 0) {
        // 	if (recog != null) {
        // 		buf += (recog.ruleNames[this.state.ruleIndex] + ":");
        // 	} else {
        // 		buf += (this.state.ruleIndex + ":");
        // 	}
        // }
        let contexts;
        if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
        else contexts = [
            "?"
        ];
        let first = true;
        for (let contextDesc of contexts){
            if (first) first = false;
            else buf += ", ";
            buf += "(";
            buf += this.state;
            if (showAlt) {
                buf += ",";
                buf += this.alt;
            }
            if (this.context) {
                buf += ",";
                buf += contextDesc;
            }
            if (this.semanticContext !== $3JS45.SemanticContext.NONE) {
                buf += ",";
                buf += this.semanticContext;
            }
            if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
            buf += ")";
        }
        return buf.toString();
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "_state", void 0);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "_context", void 0);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "state", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull,
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig.prototype, "context", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "semanticContext", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ATNConfig.prototype, "clone", null);
$c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig.prototype, "transformImpl", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ATNConfig.prototype, "equals", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ATNConfig.prototype, "hashCode", null);
$c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(3, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig, "create", null);
$c893e436b255fe4f$var$ATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig);
module.exports.ATNConfig = $c893e436b255fe4f$var$ATNConfig;
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $c893e436b255fe4f$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $c893e436b255fe4f$var$ATNConfig {
    constructor(semanticContext, state, altOrConfig, context){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else super(state, altOrConfig, context);
        this._semanticContext = semanticContext;
    }
    get semanticContext() {
        return this._semanticContext;
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$SemanticContextATNConfig.prototype, "semanticContext", null);
$c893e436b255fe4f$var$SemanticContextATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(1, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$SemanticContextATNConfig);
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a lexer action.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $c893e436b255fe4f$var$ActionATNConfig = class ActionATNConfig extends $c893e436b255fe4f$var$ATNConfig {
    constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else {
            super(state, altOrConfig, context);
            if (altOrConfig.semanticContext !== $3JS45.SemanticContext.NONE) throw new Error("Not supported");
        }
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$c893e436b255fe4f$var$ActionATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(1, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ActionATNConfig);
/**
 * This class was derived from `SemanticContextATNConfig` purely as a memory optimization. It allows for the creation of
 * an `ATNConfig` with both a lexer action and a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $c893e436b255fe4f$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $c893e436b255fe4f$var$SemanticContextATNConfig {
    constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
        else super(semanticContext, state, altOrConfig, context);
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$c893e436b255fe4f$var$ActionSemanticContextATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(1, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ActionSemanticContextATNConfig);

});
parcelRegister("42ptv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionState = void 0;

var $dv9vN = parcelRequire("dv9vN");
class $2f0b1c18dfdc93d3$var$DecisionState extends $dv9vN.ATNState {
    constructor(){
        super(...arguments);
        this.decision = -1;
        this.nonGreedy = false;
        this.sll = false;
    }
}
module.exports.DecisionState = $2f0b1c18dfdc93d3$var$DecisionState;

});

parcelRegister("jaUCz", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $df5adf3eeab6304c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $df5adf3eeab6304c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $fsqYw = parcelRequire("fsqYw");

var $4dKou = parcelRequire("4dKou");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $4BvNW = parcelRequire("4BvNW");

var $fomfP = parcelRequire("fomfP");
const $df5adf3eeab6304c$var$INITIAL_HASH = 1;
class $df5adf3eeab6304c$var$PredictionContext {
    constructor(cachedHashCode){
        this.cachedHashCode = cachedHashCode;
    }
    static calculateEmptyHashCode() {
        let hash = $amQx9.MurmurHash.initialize($df5adf3eeab6304c$var$INITIAL_HASH);
        hash = $amQx9.MurmurHash.finish(hash, 0);
        return hash;
    }
    static calculateSingleHashCode(parent, returnState) {
        let hash = $amQx9.MurmurHash.initialize($df5adf3eeab6304c$var$INITIAL_HASH);
        hash = $amQx9.MurmurHash.update(hash, parent);
        hash = $amQx9.MurmurHash.update(hash, returnState);
        hash = $amQx9.MurmurHash.finish(hash, 2);
        return hash;
    }
    static calculateHashCode(parents, returnStates) {
        let hash = $amQx9.MurmurHash.initialize($df5adf3eeab6304c$var$INITIAL_HASH);
        for (let parent of parents)hash = $amQx9.MurmurHash.update(hash, parent);
        for (let returnState of returnStates)hash = $amQx9.MurmurHash.update(hash, returnState);
        hash = $amQx9.MurmurHash.finish(hash, 2 * parents.length);
        return hash;
    }
    static fromRuleContext(atn, outerContext, fullContext = true) {
        if (outerContext.isEmpty) return fullContext ? $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL : $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
        let parent;
        if (outerContext._parent) parent = $df5adf3eeab6304c$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
        else parent = fullContext ? $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL : $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
        let state = atn.states[outerContext.invokingState];
        let transition = state.transition(0);
        return parent.getChild(transition.followState.stateNumber);
    }
    static addEmptyContext(context) {
        return context.addEmptyContext();
    }
    static removeEmptyContext(context) {
        return context.removeEmptyContext();
    }
    static join(context0, context1, contextCache = $4BvNW.PredictionContextCache.UNCACHED) {
        if (context0 === context1) return context0;
        if (context0.isEmpty) return $df5adf3eeab6304c$var$PredictionContext.isEmptyLocal(context0) ? context0 : $df5adf3eeab6304c$var$PredictionContext.addEmptyContext(context1);
        else if (context1.isEmpty) return $df5adf3eeab6304c$var$PredictionContext.isEmptyLocal(context1) ? context1 : $df5adf3eeab6304c$var$PredictionContext.addEmptyContext(context0);
        let context0size = context0.size;
        let context1size = context1.size;
        if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
            let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
            if (merged === context0.getParent(0)) return context0;
            else if (merged === context1.getParent(0)) return context1;
            else return merged.getChild(context0.getReturnState(0));
        }
        let count = 0;
        let parentsList = new Array(context0size + context1size);
        let returnStatesList = new Array(parentsList.length);
        let leftIndex = 0;
        let rightIndex = 0;
        let canReturnLeft = true;
        let canReturnRight = true;
        while(leftIndex < context0size && rightIndex < context1size){
            if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                leftIndex++;
                rightIndex++;
            } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnRight = false;
                leftIndex++;
            } else {
                $fomfP(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                canReturnLeft = false;
                rightIndex++;
            }
            count++;
        }
        while(leftIndex < context0size){
            parentsList[count] = context0.getParent(leftIndex);
            returnStatesList[count] = context0.getReturnState(leftIndex);
            leftIndex++;
            canReturnRight = false;
            count++;
        }
        while(rightIndex < context1size){
            parentsList[count] = context1.getParent(rightIndex);
            returnStatesList[count] = context1.getReturnState(rightIndex);
            rightIndex++;
            canReturnLeft = false;
            count++;
        }
        if (canReturnLeft) return context0;
        else if (canReturnRight) return context1;
        if (count < parentsList.length) {
            parentsList = parentsList.slice(0, count);
            returnStatesList = returnStatesList.slice(0, count);
        }
        if (parentsList.length === 0) // if one of them was EMPTY_LOCAL, it would be empty and handled at the beginning of the method
        return $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL;
        else if (parentsList.length === 1) return new $df5adf3eeab6304c$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
        else return new $df5adf3eeab6304c$var$ArrayPredictionContext(parentsList, returnStatesList);
    }
    static isEmptyLocal(context) {
        return context === $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
    }
    static getCachedContext(context, contextCache, visited) {
        if (context.isEmpty) return context;
        let existing = visited.get(context);
        if (existing) return existing;
        existing = contextCache.get(context);
        if (existing) {
            visited.put(context, existing);
            return existing;
        }
        let changed = false;
        let parents = new Array(context.size);
        for(let i = 0; i < parents.length; i++){
            let parent = $df5adf3eeab6304c$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
            if (changed || parent !== context.getParent(i)) {
                if (!changed) {
                    parents = new Array(context.size);
                    for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                    changed = true;
                }
                parents[i] = parent;
            }
        }
        if (!changed) {
            existing = contextCache.putIfAbsent(context, context);
            visited.put(context, existing != null ? existing : context);
            return context;
        }
        // We know parents.length>0 because context.isEmpty is checked at the beginning of the method.
        let updated;
        if (parents.length === 1) updated = new $df5adf3eeab6304c$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
        else {
            let returnStates = new Array(context.size);
            for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
            updated = new $df5adf3eeab6304c$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
        }
        existing = contextCache.putIfAbsent(updated, updated);
        visited.put(updated, existing || updated);
        visited.put(context, existing || updated);
        return updated;
    }
    appendSingleContext(returnContext, contextCache) {
        return this.appendContext($df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
    }
    getChild(returnState) {
        return new $df5adf3eeab6304c$var$SingletonPredictionContext(this, returnState);
    }
    hashCode() {
        return this.cachedHashCode;
    }
    toStrings(recognizer, currentState, stop = $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL) {
        let result = [];
        outer: for(let perm = 0;; perm++){
            let offset = 0;
            let last = true;
            let p = this;
            let stateNumber = currentState;
            let localBuffer = "";
            localBuffer += "[";
            while(!p.isEmpty && p !== stop){
                let index = 0;
                if (p.size > 0) {
                    let bits = 1;
                    while(1 << bits >>> 0 < p.size)bits++;
                    let mask = (1 << bits >>> 0) - 1;
                    index = perm >> offset & mask;
                    last = last && index >= p.size - 1;
                    if (index >= p.size) continue outer;
                    offset += bits;
                }
                if (recognizer) {
                    if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                    localBuffer += " ";
                    let atn = recognizer.atn;
                    let s = atn.states[stateNumber];
                    let ruleName = recognizer.ruleNames[s.ruleIndex];
                    localBuffer += ruleName;
                } else if (p.getReturnState(index) !== $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (!p.isEmpty) {
                        if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                        localBuffer += " ";
                        localBuffer += p.getReturnState(index);
                    }
                }
                stateNumber = p.getReturnState(index);
                p = p.getParent(index);
            }
            localBuffer += "]";
            result.push(localBuffer);
            if (last) break;
        }
        return result;
    }
}
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$PredictionContext.prototype, "hashCode", null);
$df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(1, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(2, $aN41m.NotNull)
], $df5adf3eeab6304c$var$PredictionContext, "join", null);
$df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(1, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(2, $aN41m.NotNull)
], $df5adf3eeab6304c$var$PredictionContext, "getCachedContext", null);
module.exports.PredictionContext = $df5adf3eeab6304c$var$PredictionContext;
class $df5adf3eeab6304c$var$EmptyPredictionContext extends $df5adf3eeab6304c$var$PredictionContext {
    constructor(fullContext){
        super($df5adf3eeab6304c$var$PredictionContext.calculateEmptyHashCode());
        this.fullContext = fullContext;
    }
    get isFullContext() {
        return this.fullContext;
    }
    addEmptyContext() {
        return this;
    }
    removeEmptyContext() {
        throw new Error("Cannot remove the empty context from itself.");
    }
    getParent(index) {
        throw new Error("index out of bounds");
    }
    getReturnState(index) {
        throw new Error("index out of bounds");
    }
    findReturnState(returnState) {
        return -1;
    }
    get size() {
        return 0;
    }
    appendSingleContext(returnContext, contextCache) {
        return contextCache.getChild(this, returnContext);
    }
    appendContext(suffix, contextCache) {
        return suffix;
    }
    get isEmpty() {
        return true;
    }
    get hasEmpty() {
        return true;
    }
    equals(o) {
        return this === o;
    }
    toStrings(recognizer, currentState, stop) {
        return [
            "[]"
        ];
    }
}
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "getParent", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "getReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "findReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "size", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "appendContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "isEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "hasEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "equals", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "toStrings", null);
let $df5adf3eeab6304c$var$ArrayPredictionContext = class ArrayPredictionContext extends $df5adf3eeab6304c$var$PredictionContext {
    constructor(parents, returnStates, hashCode){
        super(hashCode || $df5adf3eeab6304c$var$PredictionContext.calculateHashCode(parents, returnStates));
        $fomfP(parents.length === returnStates.length);
        $fomfP(returnStates.length > 1 || returnStates[0] !== $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
        this.parents = parents;
        this.returnStates = returnStates;
    }
    getParent(index) {
        return this.parents[index];
    }
    getReturnState(index) {
        return this.returnStates[index];
    }
    findReturnState(returnState) {
        return $4dKou.Arrays.binarySearch(this.returnStates, returnState);
    }
    get size() {
        return this.returnStates.length;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return this.returnStates[this.returnStates.length - 1] === $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY;
    }
    addEmptyContext() {
        if (this.hasEmpty) return this;
        let parents2 = this.parents.slice(0);
        let returnStates2 = this.returnStates.slice(0);
        parents2.push($df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL);
        returnStates2.push($df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY);
        return new ArrayPredictionContext(parents2, returnStates2);
    }
    removeEmptyContext() {
        if (!this.hasEmpty) return this;
        if (this.returnStates.length === 2) return new $df5adf3eeab6304c$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
        else {
            let parents2 = this.parents.slice(0, this.parents.length - 1);
            let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
    }
    appendContext(suffix, contextCache) {
        return ArrayPredictionContext.appendContextImpl(this, suffix, new $df5adf3eeab6304c$var$PredictionContext.IdentityHashMap());
    }
    static appendContextImpl(context, suffix, visited) {
        if (suffix.isEmpty) {
            if ($df5adf3eeab6304c$var$PredictionContext.isEmptyLocal(suffix)) {
                if (context.hasEmpty) return $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
                throw new Error("what to do here?");
            }
            return context;
        }
        if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
        let result = visited.get(context);
        if (!result) {
            if (context.isEmpty) result = suffix;
            else {
                let parentCount = context.size;
                if (context.hasEmpty) parentCount--;
                let updatedParents = new Array(parentCount);
                let updatedReturnStates = new Array(parentCount);
                for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                if (updatedParents.length === 1) result = new $df5adf3eeab6304c$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                else {
                    $fomfP(updatedParents.length > 1);
                    result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                }
                if (context.hasEmpty) result = $df5adf3eeab6304c$var$PredictionContext.join(result, suffix);
            }
            visited.put(context, result);
        }
        return result;
    }
    equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ArrayPredictionContext)) return false;
        if (this.hashCode() !== o.hashCode()) // can't be same if hash is different
        return false;
        let other = o;
        return this.equalsImpl(other, new $fsqYw.Array2DHashSet());
    }
    equalsImpl(other, visited) {
        let selfWorkList = [];
        let otherWorkList = [];
        selfWorkList.push(this);
        otherWorkList.push(other);
        while(true){
            let currentSelf = selfWorkList.pop();
            let currentOther = otherWorkList.pop();
            if (!currentSelf || !currentOther) break;
            let operands = new $4BvNW.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
            if (!visited.add(operands)) continue;
            let selfSize = operands.x.size;
            if (selfSize === 0) {
                if (!operands.x.equals(operands.y)) return false;
                continue;
            }
            let otherSize = operands.y.size;
            if (selfSize !== otherSize) return false;
            for(let i = 0; i < selfSize; i++){
                if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                let selfParent = operands.x.getParent(i);
                let otherParent = operands.y.getParent(i);
                if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                if (selfParent !== otherParent) {
                    selfWorkList.push(selfParent);
                    otherWorkList.push(otherParent);
                }
            }
        }
        return true;
    }
};
$df5adf3eeab6304c$var$__decorate([
    $aN41m.NotNull
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "parents", void 0);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.NotNull
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "returnStates", void 0);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "getParent", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "getReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "findReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "size", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "isEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "hasEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "appendContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "equals", null);
$df5adf3eeab6304c$var$ArrayPredictionContext = $df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull)
], $df5adf3eeab6304c$var$ArrayPredictionContext);
let $df5adf3eeab6304c$var$SingletonPredictionContext = class SingletonPredictionContext extends $df5adf3eeab6304c$var$PredictionContext {
    constructor(parent, returnState){
        super($df5adf3eeab6304c$var$PredictionContext.calculateSingleHashCode(parent, returnState));
        // assert(returnState != PredictionContext.EMPTY_FULL_STATE_KEY && returnState != PredictionContext.EMPTY_LOCAL_STATE_KEY);
        this.parent = parent;
        this.returnState = returnState;
    }
    getParent(index) {
        // assert(index == 0);
        return this.parent;
    }
    getReturnState(index) {
        // assert(index == 0);
        return this.returnState;
    }
    findReturnState(returnState) {
        return this.returnState === returnState ? 0 : -1;
    }
    get size() {
        return 1;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return false;
    }
    appendContext(suffix, contextCache) {
        return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
    }
    addEmptyContext() {
        let parents = [
            this.parent,
            $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL
        ];
        let returnStates = [
            this.returnState,
            $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY
        ];
        return new $df5adf3eeab6304c$var$ArrayPredictionContext(parents, returnStates);
    }
    removeEmptyContext() {
        return this;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof SingletonPredictionContext)) return false;
        let other = o;
        if (this.hashCode() !== other.hashCode()) return false;
        return this.returnState === other.returnState && this.parent.equals(other.parent);
    }
};
$df5adf3eeab6304c$var$__decorate([
    $aN41m.NotNull
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "parent", void 0);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "getParent", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "getReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "findReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "size", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "isEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "hasEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "appendContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "equals", null);
$df5adf3eeab6304c$var$SingletonPredictionContext = $df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull)
], $df5adf3eeab6304c$var$SingletonPredictionContext);
module.exports.SingletonPredictionContext = $df5adf3eeab6304c$var$SingletonPredictionContext;
(function(PredictionContext) {
    PredictionContext.EMPTY_LOCAL = new $df5adf3eeab6304c$var$EmptyPredictionContext(false);
    PredictionContext.EMPTY_FULL = new $df5adf3eeab6304c$var$EmptyPredictionContext(true);
    PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
    PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
    class IdentityHashMap extends $jRlcM.Array2DHashMap {
        constructor(){
            super(IdentityEqualityComparator.INSTANCE);
        }
    }
    PredictionContext.IdentityHashMap = IdentityHashMap;
    class IdentityEqualityComparator {
        IdentityEqualityComparator() {
        // intentionally empty
        }
        hashCode(obj) {
            return obj.hashCode();
        }
        equals(a, b) {
            return a === b;
        }
    }
    IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
    $df5adf3eeab6304c$var$__decorate([
        $aN41m.Override
    ], IdentityEqualityComparator.prototype, "hashCode", null);
    $df5adf3eeab6304c$var$__decorate([
        $aN41m.Override
    ], IdentityEqualityComparator.prototype, "equals", null);
    PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
})($df5adf3eeab6304c$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));

});
parcelRegister("4BvNW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $35a349d4d8246799$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionContextCache = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $fomfP = parcelRequire("fomfP");
/** Used to cache {@link PredictionContext} objects. Its used for the shared
 *  context cash associated with contexts in DFA states. This cache
 *  can be used for both lexers and parsers.
 *
 * @author Sam Harwell
 */ class $35a349d4d8246799$var$PredictionContextCache {
    constructor(enableCache = true){
        this.contexts = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.childContexts = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.joinContexts = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.enableCache = enableCache;
    }
    getAsCached(context) {
        if (!this.enableCache) return context;
        let result = this.contexts.get(context);
        if (!result) {
            result = context;
            this.contexts.put(context, context);
        }
        return result;
    }
    getChild(context, invokingState) {
        if (!this.enableCache) return context.getChild(invokingState);
        let operands = new $35a349d4d8246799$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
        let result = this.childContexts.get(operands);
        if (!result) {
            result = context.getChild(invokingState);
            result = this.getAsCached(result);
            this.childContexts.put(operands, result);
        }
        return result;
    }
    join(x, y) {
        if (!this.enableCache) return $jaUCz.PredictionContext.join(x, y, this);
        let operands = new $35a349d4d8246799$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
        let result = this.joinContexts.get(operands);
        if (result) return result;
        result = $jaUCz.PredictionContext.join(x, y, this);
        result = this.getAsCached(result);
        this.joinContexts.put(operands, result);
        return result;
    }
}
module.exports.PredictionContextCache = $35a349d4d8246799$var$PredictionContextCache;
$35a349d4d8246799$var$PredictionContextCache.UNCACHED = new $35a349d4d8246799$var$PredictionContextCache(false);
(function(PredictionContextCache) {
    class PredictionContextAndInt {
        constructor(obj, value){
            this.obj = obj;
            this.value = value;
        }
        equals(obj) {
            if (!(obj instanceof PredictionContextAndInt)) return false;
            else if (obj === this) return true;
            let other = obj;
            return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
        }
        hashCode() {
            let hashCode = 5;
            hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
            hashCode = 7 * hashCode + this.value;
            return hashCode;
        }
    }
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], PredictionContextAndInt.prototype, "equals", null);
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], PredictionContextAndInt.prototype, "hashCode", null);
    PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
    class IdentityCommutativePredictionContextOperands {
        constructor(x, y){
            $fomfP(x != null);
            $fomfP(y != null);
            this._x = x;
            this._y = y;
        }
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        equals(o) {
            if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
            else if (this === o) return true;
            let other = o;
            return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
        }
        hashCode() {
            return this._x.hashCode() ^ this._y.hashCode();
        }
    }
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
    PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
})($35a349d4d8246799$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));

});



parcelRegister("8WIez", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitSet = void 0;

var $ibOwR = parcelRequire("ibOwR");

var $amQx9 = parcelRequire("amQx9");
/**
 * Private empty array used to construct empty BitSets
 */ const $68360d7390f2502b$var$EMPTY_DATA = new Uint16Array(0);
/**
 * Gets the word index of the `UInt16` element in `BitSet.data` containing the bit with the specified index.
 */ function $68360d7390f2502b$var$getIndex(bitNumber) {
    return bitNumber >>> 4;
}
/**
 * Convert a word index into the bit index of the LSB of that word
 */ function $68360d7390f2502b$var$unIndex(n) {
    return n * 16;
}
/**
 * Get's the bit number of the least signficant bit set LSB which is set in a word non-zero word;
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $68360d7390f2502b$var$findLSBSet(word) {
    let bit = 1;
    for(let i = 0; i < 16; i++){
        if ((word & bit) !== 0) return i;
        bit = bit << 1 >>> 0;
    }
    throw new RangeError("No specified bit found");
}
function $68360d7390f2502b$var$findMSBSet(word) {
    let bit = 32768;
    for(let i = 15; i >= 0; i--){
        if ((word & bit) !== 0) return i;
        bit = bit >>> 1;
    }
    throw new RangeError("No specified bit found");
}
/**
 * Gets a 16-bit mask with bit numbers fromBit to toBit (inclusive) set.
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $68360d7390f2502b$var$bitsFor(fromBit, toBit) {
    fromBit &= 0xF;
    toBit &= 0xF;
    if (fromBit === toBit) return 1 << fromBit >>> 0;
    return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
}
/**
 * A lookup table for number of set bits in a 16-bit integer.   This is used to quickly count the cardinality (number of unique elements) of a BitSet.
 */ const $68360d7390f2502b$var$POP_CNT = new Uint8Array(65536);
for(let i = 0; i < 16; i++){
    const stride = 1 << i >>> 0;
    let index = 0;
    while(index < $68360d7390f2502b$var$POP_CNT.length){
        // skip the numbers where the bit isn't set
        index += stride;
        // increment the ones where the bit is set
        for(let j = 0; j < stride; j++){
            $68360d7390f2502b$var$POP_CNT[index]++;
            index++;
        }
    }
}
class $68360d7390f2502b$var$BitSet {
    /*
    ** constructor implementation
    */ constructor(arg){
        if (!arg) // covering the case of unspecified and nbits===0
        this.data = $68360d7390f2502b$var$EMPTY_DATA;
        else if (typeof arg === "number") {
            if (arg < 0) throw new RangeError("nbits cannot be negative");
            else this.data = new Uint16Array($68360d7390f2502b$var$getIndex(arg - 1) + 1);
        } else if (arg instanceof $68360d7390f2502b$var$BitSet) this.data = arg.data.slice(0); // Clone the data
        else {
            let max = -1;
            for (let v of arg)if (max < v) max = v;
            this.data = new Uint16Array($68360d7390f2502b$var$getIndex(max - 1) + 1);
            for (let v of arg)this.set(v);
        }
    }
    /**
     * Performs a logical **AND** of this target bit set with the argument bit set. This bit set is modified so that
     * each bit in it has the value `true` if and only if it both initially had the value `true` and the corresponding
     * bit in the bit set argument also had the value `true`.
     */ and(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Clears all of the bits in this `BitSet` whose corresponding bit is set in the specified `BitSet`.
     */ andNot(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i] ^ 0xFFFF;
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Returns the number of bits set to `true` in this `BitSet`.
     */ cardinality() {
        if (this.isEmpty) return 0;
        const data = this.data;
        const length = data.length;
        let result = 0;
        for(let i = 0; i < length; i++)result += $68360d7390f2502b$var$POP_CNT[data[i]];
        return result;
    }
    clear(fromIndex, toIndex) {
        if (fromIndex == null) this.data.fill(0);
        else if (toIndex == null) this.set(fromIndex, false);
        else this.set(fromIndex, toIndex, false);
    }
    flip(fromIndex, toIndex) {
        if (toIndex == null) toIndex = fromIndex;
        if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        const lastWord = $68360d7390f2502b$var$getIndex(toIndex);
        if (word === lastWord) this.data[word] ^= $68360d7390f2502b$var$bitsFor(fromIndex, toIndex);
        else {
            this.data[word++] ^= $68360d7390f2502b$var$bitsFor(fromIndex, 15);
            while(word < lastWord)this.data[word++] ^= 0xFFFF;
            this.data[word++] ^= $68360d7390f2502b$var$bitsFor(0, toIndex);
        }
    }
    get(fromIndex, toIndex) {
        if (toIndex === undefined) return !!(this.data[$68360d7390f2502b$var$getIndex(fromIndex)] & $68360d7390f2502b$var$bitsFor(fromIndex, fromIndex));
        else {
            // return a BitSet
            let result = new $68360d7390f2502b$var$BitSet(toIndex + 1);
            for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
            return result;
        }
    }
    /**
     * Returns true if the specified `BitSet` has any bits set to `true` that are also set to `true` in this `BitSet`.
     *
     * @param set `BitSet` to intersect with
     */ intersects(set) {
        let smallerLength = Math.min(this.length(), set.length());
        if (smallerLength === 0) return false;
        let bound = $68360d7390f2502b$var$getIndex(smallerLength - 1);
        for(let i = 0; i <= bound; i++){
            if ((this.data[i] & set.data[i]) !== 0) return true;
        }
        return false;
    }
    /**
     * Returns true if this `BitSet` contains no bits that are set to `true`.
     */ get isEmpty() {
        return this.length() === 0;
    }
    /**
     * Returns the "logical size" of this `BitSet`: the index of the highest set bit in the `BitSet` plus one. Returns
     * zero if the `BitSet` contains no set bits.
     */ length() {
        if (!this.data.length) return 0;
        return this.previousSetBit($68360d7390f2502b$var$unIndex(this.data.length) - 1) + 1;
    }
    /**
     * Returns the index of the first bit that is set to `false` that occurs on or after the specified starting index,
     * If no such bit exists then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word > length) return -1;
        let ignore = 0xFFFF ^ $68360d7390f2502b$var$bitsFor(fromIndex, 15);
        if ((data[word] | ignore) === 0xFFFF) {
            word++;
            ignore = 0;
            for(; word < length; word++){
                if (data[word] !== 0xFFFF) break;
            }
            if (word === length) // Hit the end
            return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
     * If no such bit exists then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.nextSetBit(0); i >= 0; i = bs.nextSetBit(i + 1)) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word > length) return -1;
        let mask = $68360d7390f2502b$var$bitsFor(fromIndex, 15);
        if ((data[word] & mask) === 0) {
            word++;
            mask = 0xFFFF;
            for(; word < length; word++){
                if (data[word] !== 0) break;
            }
            if (word >= length) return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findLSBSet(data[word] & mask);
    }
    /**
     * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
     * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
     * set argument has the value `true`.
     */ or(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Or those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] | other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord);
    }
    /**
     * Returns the index of the nearest bit that is set to `false` that occurs on or before the specified starting
     * index. If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let ignore = 0xFFFF ^ $68360d7390f2502b$var$bitsFor(0, fromIndex);
        if ((data[word] | ignore) === 0xFFFF) {
            ignore = 0;
            word--;
            for(; word >= 0; word--){
                if (data[word] !== 0xFFFF) break;
            }
            if (word < 0) // Hit the end
            return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the nearest bit that is set to `true` that occurs on or before the specified starting index.
     * If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.length(); (i = bs.previousSetBit(i-1)) >= 0; ) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let mask = $68360d7390f2502b$var$bitsFor(0, fromIndex);
        if ((data[word] & mask) === 0) {
            word--;
            mask = 0xFFFF;
            for(; word >= 0; word--){
                if (data[word] !== 0) break;
            }
            if (word < 0) return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findMSBSet(data[word] & mask);
    }
    set(fromIndex, toIndex, value) {
        if (toIndex === undefined) {
            toIndex = fromIndex;
            value = true;
        } else if (typeof toIndex === "boolean") {
            value = toIndex;
            toIndex = fromIndex;
        }
        if (value === undefined) value = true;
        if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        let lastWord = $68360d7390f2502b$var$getIndex(toIndex);
        if (value && lastWord >= this.data.length) {
            // Grow array "just enough" for bits we need to set
            let temp = new Uint16Array(lastWord + 1);
            this.data.forEach((value, index)=>temp[index] = value);
            this.data = temp;
        } else if (!value) {
            // But there is no need to grow array to clear bits.
            if (word >= this.data.length) // Early exit
            return;
            if (lastWord >= this.data.length) {
                // Adjust work to fit array
                lastWord = this.data.length - 1;
                toIndex = this.data.length * 16 - 1;
            }
        }
        if (word === lastWord) this._setBits(word, value, $68360d7390f2502b$var$bitsFor(fromIndex, toIndex));
        else {
            this._setBits(word++, value, $68360d7390f2502b$var$bitsFor(fromIndex, 15));
            while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
            this._setBits(word, value, $68360d7390f2502b$var$bitsFor(0, toIndex));
        }
    }
    _setBits(word, value, mask) {
        if (value) this.data[word] |= mask;
        else this.data[word] &= 0xFFFF ^ mask;
    }
    /**
     * Returns the number of bits of space actually in use by this `BitSet` to represent bit values. The maximum element
     * in the set is the size - 1st element.
     */ get size() {
        return this.data.byteLength * 8;
    }
    /**
     * Returns a new byte array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let bytes = s.toByteArray();`
     * then `bytes.length === (s.length()+7)/8` and `s.get(n) === ((bytes[n/8] & (1<<(n%8))) != 0)` for all
     * `n < 8 * bytes.length`.
     */ // toByteArray(): Int8Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Returns a new integer array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let integers = s.toIntegerArray();`
     * then `integers.length === (s.length()+31)/32` and `s.get(n) === ((integers[n/32] & (1<<(n%32))) != 0)` for all
     * `n < 32 * integers.length`.
     */ // toIntegerArray(): Int32Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    hashCode() {
        return $amQx9.MurmurHash.hashCode(this.data, 22);
    }
    /**
     * Compares this object against the specified object. The result is `true` if and only if the argument is not
     * `undefined` and is a `Bitset` object that has exactly the same set of bits set to `true` as this bit set. That
     * is, for every nonnegative index `k`,
     *
     * ```
     * ((BitSet)obj).get(k) == this.get(k)
     * ```
     *
     * must be true. The current sizes of the two bit sets are not compared.
     */ equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $68360d7390f2502b$var$BitSet)) return false;
        const len = this.length();
        if (len !== obj.length()) return false;
        if (len === 0) return true;
        let bound = $68360d7390f2502b$var$getIndex(len - 1);
        for(let i = 0; i <= bound; i++){
            if (this.data[i] !== obj.data[i]) return false;
        }
        return true;
    }
    /**
     * Returns a string representation of this bit set. For every index for which this `BitSet` contains a bit in the
     * set state, the decimal representation of that index is included in the result. Such indices are listed in order
     * from lowest to highest, separated by ", " (a comma and a space) and surrounded by braces, resulting in the usual
     * mathematical notation for a set of integers.
     *
     * Example:
     *
     *     BitSet drPepper = new BitSet();
     *
     * Now `drPepper.toString()` returns `"{}"`.
     *
     *     drPepper.set(2);
     *
     * Now `drPepper.toString()` returns `"{2}"`.
     *
     *     drPepper.set(4);
     *     drPepper.set(10);
     *
     * Now `drPepper.toString()` returns `"{2, 4, 10}"`.
     */ toString() {
        let result = "{";
        let first = true;
        for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
            if (first) first = false;
            else result += ", ";
            result += i;
        }
        result += "}";
        return result;
    }
    // static valueOf(bytes: Int8Array): BitSet;
    // static valueOf(buffer: ArrayBuffer): BitSet;
    // static valueOf(integers: Int32Array): BitSet;
    // static valueOf(data: Int8Array | Int32Array | ArrayBuffer): BitSet {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Performs a logical **XOR** of this bit set with the bit set argument. This bit set is modified so that a bit in
     * it has the value `true` if and only if one of the following statements holds:
     *
     * * The bit initially has the value `true`, and the corresponding bit in the argument has the value `false`.
     * * The bit initially has the value `false`, and the corresponding bit in the argument has the value `true`.
     */ xor(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Xor those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] ^ other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord + 1);
    }
    clone() {
        return new $68360d7390f2502b$var$BitSet(this);
    }
    [Symbol.iterator]() {
        return new $68360d7390f2502b$var$BitSetIterator(this.data);
    }
    // Overrides formatting for nodejs assert etc.
    [$ibOwR.inspect.custom]() {
        return "BitSet " + this.toString();
    }
}
module.exports.BitSet = $68360d7390f2502b$var$BitSet;
class $68360d7390f2502b$var$BitSetIterator {
    constructor(data){
        this.data = data;
        this.index = 0;
        this.mask = 0xFFFF;
    }
    next() {
        while(this.index < this.data.length){
            const bits = this.data[this.index] & this.mask;
            if (bits !== 0) {
                const bitNumber = $68360d7390f2502b$var$unIndex(this.index) + $68360d7390f2502b$var$findLSBSet(bits);
                this.mask = $68360d7390f2502b$var$bitsFor(bitNumber + 1, 15);
                return {
                    done: false,
                    value: bitNumber
                };
            }
            this.index++;
            this.mask = 0xFFFF;
        }
        return {
            done: true,
            value: -1
        };
    }
    [Symbol.iterator]() {
        return this;
    }
}

});


parcelRegister("aVeml", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7f3a5dbd36c0ece1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFASerializer = void 0;

var $ceQRA = parcelRequire("ceQRA");

var $aN41m = parcelRequire("aN41m");

var $jaUCz = parcelRequire("jaUCz");

var $dwftT = parcelRequire("dwftT");

var $hBnE1 = parcelRequire("hBnE1");
/** A DFA walker that knows how to dump them to serialized strings. */ class $7f3a5dbd36c0ece1$var$DFASerializer {
    constructor(dfa, vocabulary, ruleNames, atn){
        if (vocabulary instanceof $dwftT.Recognizer) {
            ruleNames = vocabulary.ruleNames;
            atn = vocabulary.atn;
            vocabulary = vocabulary.vocabulary;
        } else if (!vocabulary) vocabulary = $hBnE1.VocabularyImpl.EMPTY_VOCABULARY;
        this.dfa = dfa;
        this.vocabulary = vocabulary;
        this.ruleNames = ruleNames;
        this.atn = atn;
    }
    toString() {
        if (!this.dfa.s0) return "";
        let buf = "";
        if (this.dfa.states) {
            let states = new Array(...this.dfa.states.toArray());
            states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
            for (let s of states){
                let edges = s.getEdgeMap();
                let edgeKeys = [
                    ...edges.keys()
                ].sort((a, b)=>a - b);
                let contextEdges = s.getContextEdgeMap();
                let contextEdgeKeys = [
                    ...contextEdges.keys()
                ].sort((a, b)=>a - b);
                for (let entry of edgeKeys){
                    let value = edges.get(entry);
                    if ((value == null || value === $ceQRA.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                    let contextSymbol = false;
                    buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                    if (s.isContextSymbol(entry)) {
                        buf += "!";
                        contextSymbol = true;
                    }
                    let t = value;
                    if (t && t.stateNumber !== $ceQRA.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                    else if (contextSymbol) buf += "ctx\n";
                }
                if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
            }
        }
        let output = buf;
        if (output.length === 0) return "";
        //return Utils.sortLinesInString(output);
        return output;
    }
    getContextLabel(i) {
        if (i === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
        else if (i === $jaUCz.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
        if (this.atn && i > 0 && i <= this.atn.states.length) {
            let state = this.atn.states[i];
            let ruleIndex = state.ruleIndex;
            if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
        return "ctx:" + String(i);
    }
    getEdgeLabel(i) {
        return this.vocabulary.getDisplayName(i);
    }
    getStateString(s) {
        if (s === $ceQRA.ATNSimulator.ERROR) return "ERROR";
        let n = s.stateNumber;
        let stateStr = "s" + n;
        if (s.isAcceptState) {
            if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
            else stateStr = ":s" + n + "=>" + s.prediction;
        }
        if (s.isContextSensitive) {
            stateStr += "*";
            for (let config of s.configs)if (config.reachesIntoOuterContext) {
                stateStr += "*";
                break;
            }
        }
        return stateStr;
    }
}
$7f3a5dbd36c0ece1$var$__decorate([
    $aN41m.NotNull
], $7f3a5dbd36c0ece1$var$DFASerializer.prototype, "dfa", void 0);
$7f3a5dbd36c0ece1$var$__decorate([
    $aN41m.NotNull
], $7f3a5dbd36c0ece1$var$DFASerializer.prototype, "vocabulary", void 0);
$7f3a5dbd36c0ece1$var$__decorate([
    $aN41m.Override
], $7f3a5dbd36c0ece1$var$DFASerializer.prototype, "toString", null);
module.exports.DFASerializer = $7f3a5dbd36c0ece1$var$DFASerializer;

});
parcelRegister("ceQRA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8e8fcc5f6dae8ba8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8e8fcc5f6dae8ba8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNSimulator = void 0;

var $2SGHL = parcelRequire("2SGHL");

var $6P9ap = parcelRequire("6P9ap");

var $aN41m = parcelRequire("aN41m");

var $jaUCz = parcelRequire("jaUCz");
let $8e8fcc5f6dae8ba8$var$ATNSimulator = class ATNSimulator {
    constructor(atn){
        this.atn = atn;
    }
    static get ERROR() {
        if (!ATNSimulator._ERROR) {
            ATNSimulator._ERROR = new $6P9ap.DFAState(new $2SGHL.ATNConfigSet());
            ATNSimulator._ERROR.stateNumber = $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        return ATNSimulator._ERROR;
    }
    /**
     * Clear the DFA cache used by the current instance. Since the DFA cache may
     * be shared by multiple ATN simulators, this method may affect the
     * performance (but not accuracy) of other parsers which are being used
     * concurrently.
     *
     * @ if the current instance does not
     * support clearing the DFA.
     *
     * @since 4.3
     */ clearDFA() {
        this.atn.clearDFA();
    }
};
$8e8fcc5f6dae8ba8$var$__decorate([
    $aN41m.NotNull
], $8e8fcc5f6dae8ba8$var$ATNSimulator.prototype, "atn", void 0);
$8e8fcc5f6dae8ba8$var$__decorate([
    $aN41m.NotNull
], $8e8fcc5f6dae8ba8$var$ATNSimulator, "ERROR", null);
$8e8fcc5f6dae8ba8$var$ATNSimulator = $8e8fcc5f6dae8ba8$var$__decorate([
    $8e8fcc5f6dae8ba8$var$__param(0, $aN41m.NotNull)
], $8e8fcc5f6dae8ba8$var$ATNSimulator);
module.exports.ATNSimulator = $8e8fcc5f6dae8ba8$var$ATNSimulator;
(function(ATNSimulator) {
    const RULE_VARIANT_DELIMITER = "$";
    const RULE_LF_VARIANT_MARKER = "$lf$";
    const RULE_NOLF_VARIANT_MARKER = "$nolf$";
})($8e8fcc5f6dae8ba8$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
module.exports.ATNSimulator = $8e8fcc5f6dae8ba8$var$ATNSimulator;

});
parcelRegister("6P9ap", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4f7e9dd79d87c511$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4f7e9dd79d87c511$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFAState = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $8WIez = parcelRequire("8WIez");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $jaUCz = parcelRequire("jaUCz");

var $fomfP = parcelRequire("fomfP");
/** A DFA state represents a set of possible ATN configurations.
 *  As Aho, Sethi, Ullman p. 117 says "The DFA uses its state
 *  to keep track of all possible states the ATN can be in after
 *  reading each input symbol.  That is to say, after reading
 *  input a1a2..an, the DFA is in a state that represents the
 *  subset T of the states of the ATN that are reachable from the
 *  ATN's start state along some path labeled a1a2..an."
 *  In conventional NFA&rarr;DFA conversion, therefore, the subset T
 *  would be a bitset representing the set of states the
 *  ATN could be in.  We need to track the alt predicted by each
 *  state as well, however.  More importantly, we need to maintain
 *  a stack of states, tracking the closure operations as they
 *  jump from rule to rule, emulating rule invocations (method calls).
 *  I have to add a stack to simulate the proper lookahead sequences for
 *  the underlying LL grammar from which the ATN was derived.
 *
 *  I use a set of ATNConfig objects not simple states.  An ATNConfig
 *  is both a state (ala normal conversion) and a RuleContext describing
 *  the chain of rules (if any) followed to arrive at that state.
 *
 *  A DFA state may have multiple references to a particular state,
 *  but with different ATN contexts (with same or different alts)
 *  meaning that state was reached via a different set of rule invocations.
 */ class $4f7e9dd79d87c511$var$DFAState {
    /**
     * Constructs a new `DFAState`.
     *
     * @param configs The set of ATN configurations defining this state.
     */ constructor(configs){
        this.stateNumber = -1;
        this.configs = configs;
        this.edges = new Map();
        this.contextEdges = new Map();
    }
    get isContextSensitive() {
        return !!this.contextSymbols;
    }
    isContextSymbol(symbol) {
        if (!this.isContextSensitive) return false;
        return this.contextSymbols.get(symbol);
    }
    setContextSymbol(symbol) {
        $fomfP(this.isContextSensitive);
        this.contextSymbols.set(symbol);
    }
    setContextSensitive(atn) {
        $fomfP(!this.configs.isOutermostConfigSet);
        if (this.isContextSensitive) return;
        if (!this.contextSymbols) this.contextSymbols = new $8WIez.BitSet();
    }
    get acceptStateInfo() {
        return this._acceptStateInfo;
    }
    set acceptStateInfo(acceptStateInfo) {
        this._acceptStateInfo = acceptStateInfo;
    }
    get isAcceptState() {
        return !!this._acceptStateInfo;
    }
    get prediction() {
        if (!this._acceptStateInfo) return $eeOLb.ATN.INVALID_ALT_NUMBER;
        return this._acceptStateInfo.prediction;
    }
    get lexerActionExecutor() {
        if (!this._acceptStateInfo) return undefined;
        return this._acceptStateInfo.lexerActionExecutor;
    }
    getTarget(symbol) {
        return this.edges.get(symbol);
    }
    setTarget(symbol, target) {
        this.edges.set(symbol, target);
    }
    getEdgeMap() {
        return this.edges;
    }
    getContextTarget(invokingState) {
        if (invokingState === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        return this.contextEdges.get(invokingState);
    }
    setContextTarget(invokingState, target) {
        if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
        if (invokingState === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        this.contextEdges.set(invokingState, target);
    }
    getContextEdgeMap() {
        let map = new Map(this.contextEdges);
        let existing = map.get(-1);
        if (existing !== undefined) {
            if (map.size === 1) {
                let result = new Map();
                result.set($jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                return result;
            } else {
                map.delete(-1);
                map.set($jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
            }
        }
        return map;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize(7);
        hash = $amQx9.MurmurHash.update(hash, this.configs.hashCode());
        hash = $amQx9.MurmurHash.finish(hash, 1);
        return hash;
    }
    /**
     * Two {@link DFAState} instances are equal if their ATN configuration sets
     * are the same. This method is used to see if a state already exists.
     *
     * Because the number of alternatives and number of ATN configurations are
     * finite, there is a finite number of DFA states that can be processed.
     * This is necessary to show that the algorithm terminates.
     *
     * Cannot test the DFA state numbers here because in
     * {@link ParserATNSimulator#addDFAState} we need to know if any other state
     * exists that has this exact set of ATN configurations. The
     * {@link #stateNumber} is irrelevant.
     */ equals(o) {
        // compare set of ATN configurations in this set with other
        if (this === o) return true;
        if (!(o instanceof $4f7e9dd79d87c511$var$DFAState)) return false;
        let other = o;
        let sameSet = this.configs.equals(other.configs);
        //		System.out.println("DFAState.equals: "+configs+(sameSet?"==":"!=")+other.configs);
        return sameSet;
    }
    toString() {
        let buf = "";
        buf += this.stateNumber + ":" + this.configs;
        if (this.isAcceptState) {
            buf += "=>";
            if (this.predicates) buf += this.predicates;
            else buf += this.prediction;
        }
        return buf.toString();
    }
}
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.NotNull
], $4f7e9dd79d87c511$var$DFAState.prototype, "configs", void 0);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.NotNull
], $4f7e9dd79d87c511$var$DFAState.prototype, "edges", void 0);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.NotNull
], $4f7e9dd79d87c511$var$DFAState.prototype, "contextEdges", void 0);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.Override
], $4f7e9dd79d87c511$var$DFAState.prototype, "hashCode", null);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.Override
], $4f7e9dd79d87c511$var$DFAState.prototype, "equals", null);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.Override
], $4f7e9dd79d87c511$var$DFAState.prototype, "toString", null);
module.exports.DFAState = $4f7e9dd79d87c511$var$DFAState;
(function(DFAState) {
    /** Map a predicate to a predicted alternative. */ let PredPrediction = class PredPrediction {
        constructor(pred, alt){
            this.alt = alt;
            this.pred = pred;
        }
        toString() {
            return "(" + this.pred + ", " + this.alt + ")";
        }
    };
    $4f7e9dd79d87c511$var$__decorate([
        $aN41m.NotNull
    ], PredPrediction.prototype, "pred", void 0);
    $4f7e9dd79d87c511$var$__decorate([
        $aN41m.Override
    ], PredPrediction.prototype, "toString", null);
    PredPrediction = $4f7e9dd79d87c511$var$__decorate([
        $4f7e9dd79d87c511$var$__param(0, $aN41m.NotNull)
    ], PredPrediction);
    DFAState.PredPrediction = PredPrediction;
})($4f7e9dd79d87c511$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));

});


parcelRegister("dwftT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9d7a45bfa60542a5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9d7a45bfa60542a5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $eEgBk = parcelRequire("eEgBk");

var $3Wiwr = parcelRequire("3Wiwr");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");

var $62Uvn = parcelRequire("62Uvn");
class $9d7a45bfa60542a5$var$Recognizer {
    constructor(){
        this._listeners = [
            $eEgBk.ConsoleErrorListener.INSTANCE
        ];
        this._stateNumber = -1;
    }
    /**
     * Get a map from token names to token types.
     *
     * Used for XPath and tree pattern compilation.
     */ getTokenTypeMap() {
        let vocabulary = this.vocabulary;
        let result = $9d7a45bfa60542a5$var$Recognizer.tokenTypeMapCache.get(vocabulary);
        if (result == null) {
            let intermediateResult = new Map();
            for(let i = 0; i <= this.atn.maxTokenType; i++){
                let literalName = vocabulary.getLiteralName(i);
                if (literalName != null) intermediateResult.set(literalName, i);
                let symbolicName = vocabulary.getSymbolicName(i);
                if (symbolicName != null) intermediateResult.set(symbolicName, i);
            }
            intermediateResult.set("EOF", $eKXi4.Token.EOF);
            result = intermediateResult;
            $9d7a45bfa60542a5$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
        }
        return result;
    }
    /**
     * Get a map from rule names to rule indexes.
     *
     * Used for XPath and tree pattern compilation.
     */ getRuleIndexMap() {
        let ruleNames = this.ruleNames;
        if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
        let result = $9d7a45bfa60542a5$var$Recognizer.ruleIndexMapCache.get(ruleNames);
        if (result == null) {
            result = $62Uvn.toMap(ruleNames);
            $9d7a45bfa60542a5$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
        }
        return result;
    }
    getTokenType(tokenName) {
        let ttype = this.getTokenTypeMap().get(tokenName);
        if (ttype != null) return ttype;
        return $eKXi4.Token.INVALID_TYPE;
    }
    /**
     * If this recognizer was generated, it will have a serialized ATN
     * representation of the grammar.
     *
     * For interpreters, we don't know their serialized ATN despite having
     * created the interpreter from it.
     */ get serializedATN() {
        throw new Error("there is no serialized ATN");
    }
    /**
     * Get the {@link ATN} used by the recognizer for prediction.
     *
     * @returns The {@link ATN} used by the recognizer for prediction.
     */ get atn() {
        return this._interp.atn;
    }
    /**
     * Get the ATN interpreter used by the recognizer for prediction.
     *
     * @returns The ATN interpreter used by the recognizer for prediction.
     */ get interpreter() {
        return this._interp;
    }
    /**
     * Set the ATN interpreter used by the recognizer for prediction.
     *
     * @param interpreter The ATN interpreter used by the recognizer for
     * prediction.
     */ set interpreter(interpreter) {
        this._interp = interpreter;
    }
    /** If profiling during the parse/lex, this will return DecisionInfo records
     *  for each decision in recognizer in a ParseInfo object.
     *
     * @since 4.3
     */ get parseInfo() {
        return Promise.resolve(undefined);
    }
    /** What is the error header, normally line/character position information? */ getErrorHeader(e) {
        let token = e.getOffendingToken();
        if (!token) return "";
        let line = token.line;
        let charPositionInLine = token.charPositionInLine;
        return "line " + line + ":" + charPositionInLine;
    }
    /**
     * @exception NullPointerException if `listener` is `undefined`.
     */ addErrorListener(listener) {
        if (!listener) throw new TypeError("listener must not be null");
        this._listeners.push(listener);
    }
    removeErrorListener(listener) {
        let position = this._listeners.indexOf(listener);
        if (position !== -1) this._listeners.splice(position, 1);
    }
    removeErrorListeners() {
        this._listeners.length = 0;
    }
    getErrorListeners() {
        return this._listeners.slice(0);
    }
    getErrorListenerDispatch() {
        return new $3Wiwr.ProxyErrorListener(this.getErrorListeners());
    }
    // subclass needs to override these if there are sempreds or actions
    // that the ATN interp needs to execute
    sempred(_localctx, ruleIndex, actionIndex) {
        return true;
    }
    precpred(localctx, precedence) {
        return true;
    }
    action(_localctx, ruleIndex, actionIndex) {
    // intentionally empty
    }
    get state() {
        return this._stateNumber;
    }
    /** Indicate that the recognizer has changed internal state that is
     *  consistent with the ATN state passed in.  This way we always know
     *  where we are in the ATN as the parser goes along. The rule
     *  context objects form a stack that lets us see the stack of
     *  invoking rules. Combine this and we have complete ATN
     *  configuration information.
     */ set state(atnState) {
        //		System.err.println("setState "+atnState);
        this._stateNumber = atnState;
    //		if ( traceATNStates ) _ctx.trace(atnState);
    }
}
$9d7a45bfa60542a5$var$Recognizer.EOF = -1;
$9d7a45bfa60542a5$var$Recognizer.tokenTypeMapCache = new WeakMap();
$9d7a45bfa60542a5$var$Recognizer.ruleIndexMapCache = new WeakMap();
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.SuppressWarnings("serial"),
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "_listeners", void 0);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getTokenTypeMap", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getRuleIndexMap", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "serializedATN", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "atn", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull,
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "interpreter", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull,
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getErrorHeader", null);
$9d7a45bfa60542a5$var$__decorate([
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "addErrorListener", null);
$9d7a45bfa60542a5$var$__decorate([
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "removeErrorListener", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getErrorListeners", null);
module.exports.Recognizer = $9d7a45bfa60542a5$var$Recognizer;

});
parcelRegister("eEgBk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleErrorListener = void 0;
/**
 *
 * @author Sam Harwell
 */ class $aaa1adc002ecda3b$var$ConsoleErrorListener {
    /**
     * {@inheritDoc}
     *
     * This implementation prints messages to {@link System#err} containing the
     * values of `line`, `charPositionInLine`, and `msg` using
     * the following format.
     *
     * <pre>
     * line *line*:*charPositionInLine* *msg*
     * </pre>
     */ syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        console.error(`line ${line}:${charPositionInLine} ${msg}`);
    }
}
module.exports.ConsoleErrorListener = $aaa1adc002ecda3b$var$ConsoleErrorListener;
/**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */ $aaa1adc002ecda3b$var$ConsoleErrorListener.INSTANCE = new $aaa1adc002ecda3b$var$ConsoleErrorListener();

});

parcelRegister("3Wiwr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2de528078ef3db4e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2de528078ef3db4e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyErrorListener = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 * This implementation of {@link ANTLRErrorListener} dispatches all calls to a
 * collection of delegate listeners. This reduces the effort required to support multiple
 * listeners.
 *
 * @author Sam Harwell
 */ class $2de528078ef3db4e$var$ProxyErrorListener {
    constructor(delegates){
        this.delegates = delegates;
        if (!delegates) throw new Error("Invalid delegates");
    }
    getDelegates() {
        return this.delegates;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        this.delegates.forEach((listener)=>{
            if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
        });
    }
}
$2de528078ef3db4e$var$__decorate([
    $aN41m.Override,
    $2de528078ef3db4e$var$__param(0, $aN41m.NotNull),
    $2de528078ef3db4e$var$__param(4, $aN41m.NotNull)
], $2de528078ef3db4e$var$ProxyErrorListener.prototype, "syntaxError", null);
module.exports.ProxyErrorListener = $2de528078ef3db4e$var$ProxyErrorListener;

});


parcelRegister("hBnE1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cd083bb3193af652$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VocabularyImpl = void 0;

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This class provides a default implementation of the {@link Vocabulary}
 * interface.
 *
 * @author Sam Harwell
 */ class $cd083bb3193af652$var$VocabularyImpl {
    /**
     * Constructs a new instance of {@link VocabularyImpl} from the specified
     * literal, symbolic, and display token names.
     *
     * @param literalNames The literal names assigned to tokens, or an empty array
     * if no literal names are assigned.
     * @param symbolicNames The symbolic names assigned to tokens, or
     * an empty array if no symbolic names are assigned.
     * @param displayNames The display names assigned to tokens, or an empty array
     * to use the values in `literalNames` and `symbolicNames` as
     * the source of display names, as described in
     * {@link #getDisplayName(int)}.
     *
     * @see #getLiteralName(int)
     * @see #getSymbolicName(int)
     * @see #getDisplayName(int)
     */ constructor(literalNames, symbolicNames, displayNames){
        this.literalNames = literalNames;
        this.symbolicNames = symbolicNames;
        this.displayNames = displayNames;
        // See note here on -1 part: https://github.com/antlr/antlr4/pull/1146
        this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
    }
    get maxTokenType() {
        return this._maxTokenType;
    }
    getLiteralName(tokenType) {
        if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
        return undefined;
    }
    getSymbolicName(tokenType) {
        if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
        if (tokenType === $eKXi4.Token.EOF) return "EOF";
        return undefined;
    }
    getDisplayName(tokenType) {
        if (tokenType >= 0 && tokenType < this.displayNames.length) {
            let displayName = this.displayNames[tokenType];
            if (displayName) return displayName;
        }
        let literalName = this.getLiteralName(tokenType);
        if (literalName) return literalName;
        let symbolicName = this.getSymbolicName(tokenType);
        if (symbolicName) return symbolicName;
        return String(tokenType);
    }
}
/**
 * Gets an empty {@link Vocabulary} instance.
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */ $cd083bb3193af652$var$VocabularyImpl.EMPTY_VOCABULARY = new $cd083bb3193af652$var$VocabularyImpl([], [], []);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "literalNames", void 0);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "symbolicNames", void 0);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "displayNames", void 0);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override
], $cd083bb3193af652$var$VocabularyImpl.prototype, "maxTokenType", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override
], $cd083bb3193af652$var$VocabularyImpl.prototype, "getLiteralName", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override
], $cd083bb3193af652$var$VocabularyImpl.prototype, "getSymbolicName", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "getDisplayName", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
module.exports.VocabularyImpl = $cd083bb3193af652$var$VocabularyImpl;

});


parcelRegister("gwhAV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c06d486e830ea671$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c06d486e830ea671$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerDFASerializer = void 0;

var $aVeml = parcelRequire("aVeml");

var $aN41m = parcelRequire("aN41m");

var $hBnE1 = parcelRequire("hBnE1");
let $c06d486e830ea671$var$LexerDFASerializer = class LexerDFASerializer extends $aVeml.DFASerializer {
    constructor(dfa){
        super(dfa, $hBnE1.VocabularyImpl.EMPTY_VOCABULARY);
    }
    getEdgeLabel(i) {
        return "'" + String.fromCodePoint(i) + "'";
    }
};
$c06d486e830ea671$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $c06d486e830ea671$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
$c06d486e830ea671$var$LexerDFASerializer = $c06d486e830ea671$var$__decorate([
    $c06d486e830ea671$var$__param(0, $aN41m.NotNull)
], $c06d486e830ea671$var$LexerDFASerializer);
module.exports.LexerDFASerializer = $c06d486e830ea671$var$LexerDFASerializer;

});

parcelRegister("e0pjt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a324b36ed5e65ddb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopEntryState = void 0;

var $fZESB = parcelRequire("fZESB");

var $8WIez = parcelRequire("8WIez");

var $42ptv = parcelRequire("42ptv");

var $aN41m = parcelRequire("aN41m");
class $a324b36ed5e65ddb$var$StarLoopEntryState extends $42ptv.DecisionState {
    constructor(){
        super(...arguments);
        /**
         * Indicates whether this state can benefit from a precedence DFA during SLL
         * decision making.
         *
         * This is a computed property that is calculated during ATN deserialization
         * and stored for use in {@link ParserATNSimulator} and
         * {@link ParserInterpreter}.
         *
         * @see `DFA.isPrecedenceDfa`
         */ this.precedenceRuleDecision = false;
        /**
         * For precedence decisions, this set marks states *S* which have all
         * of the following characteristics:
         *
         * * One or more invocation sites of the current rule returns to
         *   *S*.
         * * The closure from *S* includes the current decision without
         *   passing through any rule invocations or stepping out of the current
         *   rule.
         *
         * This field is not used when {@link #precedenceRuleDecision} is
         * `false`.
         */ this.precedenceLoopbackStates = new $8WIez.BitSet();
    }
    get stateType() {
        return $fZESB.ATNStateType.STAR_LOOP_ENTRY;
    }
}
$a324b36ed5e65ddb$var$__decorate([
    $aN41m.Override
], $a324b36ed5e65ddb$var$StarLoopEntryState.prototype, "stateType", null);
module.exports.StarLoopEntryState = $a324b36ed5e65ddb$var$StarLoopEntryState;

});


parcelRegister("8ii30", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $609e010be7b51ab4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidState = void 0;

var $fZESB = parcelRequire("fZESB");

var $3XAPg = parcelRequire("3XAPg");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $609e010be7b51ab4$var$InvalidState extends $3XAPg.BasicState {
    get stateType() {
        return $fZESB.ATNStateType.INVALID_TYPE;
    }
}
$609e010be7b51ab4$var$__decorate([
    $aN41m.Override
], $609e010be7b51ab4$var$InvalidState.prototype, "stateType", null);
module.exports.InvalidState = $609e010be7b51ab4$var$InvalidState;

});
parcelRegister("3XAPg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2e2372a25da2f9ab$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $2e2372a25da2f9ab$var$BasicState extends $dv9vN.ATNState {
    get stateType() {
        return $fZESB.ATNStateType.BASIC;
    }
}
$2e2372a25da2f9ab$var$__decorate([
    $aN41m.Override
], $2e2372a25da2f9ab$var$BasicState.prototype, "stateType", null);
module.exports.BasicState = $2e2372a25da2f9ab$var$BasicState;

});


parcelRegister("kUmff", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f38a4b008fb55a2e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f38a4b008fb55a2e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LL1Analyzer = void 0;

var $kvmNv = parcelRequire("kvmNv");

var $fsqYw = parcelRequire("fsqYw");

var $hdFz0 = parcelRequire("hdFz0");

var $8WIez = parcelRequire("8WIez");

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $gFTdY = parcelRequire("gFTdY");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $jWsYN = parcelRequire("jWsYN");

var $lmhna = parcelRequire("lmhna");

var $eKXi4 = parcelRequire("eKXi4");

var $69uaV = parcelRequire("69uaV");
let $f38a4b008fb55a2e$var$LL1Analyzer = class LL1Analyzer {
    constructor(atn){
        this.atn = atn;
    }
    /**
     * Calculates the SLL(1) expected lookahead set for each outgoing transition
     * of an {@link ATNState}. The returned array has one element for each
     * outgoing transition in `s`. If the closure from transition
     * *i* leads to a semantic predicate before matching a symbol, the
     * element at index *i* of the result will be `undefined`.
     *
     * @param s the ATN state
     * @returns the expected symbols for each outgoing transition of `s`.
     */ getDecisionLookahead(s) {
        //		System.out.println("LOOK("+s.stateNumber+")");
        if (s == null) return undefined;
        let look = new Array(s.numberOfTransitions);
        for(let alt = 0; alt < s.numberOfTransitions; alt++){
            let current = new $6kdz0.IntervalSet();
            look[alt] = current;
            let lookBusy = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
            let seeThruPreds = false; // fail to get lookahead upon pred
            this._LOOK(s.transition(alt).target, undefined, $jaUCz.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $8WIez.BitSet(), seeThruPreds, false);
            // Wipe out lookahead for this alternative if we found nothing
            // or we had a predicate when we !seeThruPreds
            if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                current = undefined;
                look[alt] = current;
            }
        }
        return look;
    }
    LOOK(s, ctx, stopState) {
        if (stopState === undefined) {
            if (s.atn == null) throw new Error("Illegal state");
            stopState = s.atn.ruleToStopState[s.ruleIndex];
        } else if (stopState === null) // This is an explicit request to pass undefined as the stopState to _LOOK. Used to distinguish an overload
        // from the method which simply omits the stopState parameter.
        stopState = undefined;
        let r = new $6kdz0.IntervalSet();
        let seeThruPreds = true; // ignore preds; get all lookahead
        let addEOF = true;
        this._LOOK(s, stopState, ctx, r, new $fsqYw.Array2DHashSet(), new $8WIez.BitSet(), seeThruPreds, addEOF);
        return r;
    }
    /**
     * Compute set of tokens that can follow `s` in the ATN in the
     * specified `ctx`.
     * <p/>
     * If `ctx` is {@link PredictionContext#EMPTY_LOCAL} and
     * `stopState` or the end of the rule containing `s` is reached,
     * {@link Token#EPSILON} is added to the result set. If `ctx` is not
     * {@link PredictionContext#EMPTY_LOCAL} and `addEOF` is `true`
     * and `stopState` or the end of the outermost rule is reached,
     * {@link Token#EOF} is added to the result set.
     *
     * @param s the ATN state.
     * @param stopState the ATN state to stop at. This can be a
     * {@link BlockEndState} to detect epsilon paths through a closure.
     * @param ctx The outer context, or {@link PredictionContext#EMPTY_LOCAL} if
     * the outer context should not be used.
     * @param look The result lookahead set.
     * @param lookBusy A set used for preventing epsilon closures in the ATN
     * from causing a stack overflow. Outside code should pass
     * `new HashSet<ATNConfig>` for this argument.
     * @param calledRuleStack A set used for preventing left recursion in the
     * ATN from causing a stack overflow. Outside code should pass
     * `new BitSet()` for this argument.
     * @param seeThruPreds `true` to true semantic predicates as
     * implicitly `true` and "see through them", otherwise `false`
     * to treat semantic predicates as opaque and add {@link #HIT_PRED} to the
     * result if one is encountered.
     * @param addEOF Add {@link Token#EOF} to the result if the end of the
     * outermost context is reached. This parameter has no effect if `ctx`
     * is {@link PredictionContext#EMPTY_LOCAL}.
     */ _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
        //		System.out.println("_LOOK("+s.stateNumber+", ctx="+ctx);
        let c = $hdFz0.ATNConfig.create(s, 0, ctx);
        if (!lookBusy.add(c)) return;
        if (s === stopState) {
            if ($jaUCz.PredictionContext.isEmptyLocal(ctx)) {
                look.add($eKXi4.Token.EPSILON);
                return;
            } else if (ctx.isEmpty) {
                if (addEOF) look.add($eKXi4.Token.EOF);
                return;
            }
        }
        if (s instanceof $jWsYN.RuleStopState) {
            if (ctx.isEmpty && !$jaUCz.PredictionContext.isEmptyLocal(ctx)) {
                if (addEOF) look.add($eKXi4.Token.EOF);
                return;
            }
            let removed = calledRuleStack.get(s.ruleIndex);
            try {
                calledRuleStack.clear(s.ruleIndex);
                for(let i = 0; i < ctx.size; i++){
                    if (ctx.getReturnState(i) === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let returnState = this.atn.states[ctx.getReturnState(i)];
                    //					System.out.println("popping back to "+retState);
                    this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                }
            } finally{
                if (removed) calledRuleStack.set(s.ruleIndex);
            }
        }
        let n = s.numberOfTransitions;
        for(let i = 0; i < n; i++){
            let t = s.transition(i);
            if (t instanceof $lmhna.RuleTransition) {
                if (calledRuleStack.get(t.ruleIndex)) continue;
                let newContext = ctx.getChild(t.followState.stateNumber);
                try {
                    calledRuleStack.set(t.ruleIndex);
                    this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                } finally{
                    calledRuleStack.clear(t.ruleIndex);
                }
            } else if (t instanceof $kvmNv.AbstractPredicateTransition) {
                if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else look.add(LL1Analyzer.HIT_PRED);
            } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
            else if (t instanceof $69uaV.WildcardTransition) look.addAll($6kdz0.IntervalSet.of($eKXi4.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
            else {
                //				System.out.println("adding "+ t);
                let set = t.label;
                if (set != null) {
                    if (t instanceof $gFTdY.NotSetTransition) set = set.complement($6kdz0.IntervalSet.of($eKXi4.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    look.addAll(set);
                }
            }
        }
    }
};
/** Special value added to the lookahead sets to indicate that we hit
 *  a predicate during analysis if `seeThruPreds==false`.
 */ $f38a4b008fb55a2e$var$LL1Analyzer.HIT_PRED = $eKXi4.Token.INVALID_TYPE;
$f38a4b008fb55a2e$var$__decorate([
    $aN41m.NotNull
], $f38a4b008fb55a2e$var$LL1Analyzer.prototype, "atn", void 0);
$f38a4b008fb55a2e$var$__decorate([
    $aN41m.NotNull,
    $f38a4b008fb55a2e$var$__param(0, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(1, $aN41m.NotNull)
], $f38a4b008fb55a2e$var$LL1Analyzer.prototype, "LOOK", null);
$f38a4b008fb55a2e$var$__decorate([
    $f38a4b008fb55a2e$var$__param(0, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(2, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(3, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(4, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(5, $aN41m.NotNull)
], $f38a4b008fb55a2e$var$LL1Analyzer.prototype, "_LOOK", null);
$f38a4b008fb55a2e$var$LL1Analyzer = $f38a4b008fb55a2e$var$__decorate([
    $f38a4b008fb55a2e$var$__param(0, $aN41m.NotNull)
], $f38a4b008fb55a2e$var$LL1Analyzer);
module.exports.LL1Analyzer = $f38a4b008fb55a2e$var$LL1Analyzer;

});
parcelRegister("gFTdY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c23b501a5502a14e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c23b501a5502a14e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotSetTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5EcBU = parcelRequire("5EcBU");
let $c23b501a5502a14e$var$NotSetTransition = class NotSetTransition extends $5EcBU.SetTransition {
    constructor(target, set){
        super(target, set);
    }
    get serializationType() {
        return 8 /* NOT_SET */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
    }
    toString() {
        return "~" + super.toString();
    }
};
$c23b501a5502a14e$var$__decorate([
    $aN41m.Override
], $c23b501a5502a14e$var$NotSetTransition.prototype, "serializationType", null);
$c23b501a5502a14e$var$__decorate([
    $aN41m.Override
], $c23b501a5502a14e$var$NotSetTransition.prototype, "matches", null);
$c23b501a5502a14e$var$__decorate([
    $aN41m.Override
], $c23b501a5502a14e$var$NotSetTransition.prototype, "toString", null);
$c23b501a5502a14e$var$NotSetTransition = $c23b501a5502a14e$var$__decorate([
    $c23b501a5502a14e$var$__param(0, $aN41m.NotNull),
    $c23b501a5502a14e$var$__param(1, $aN41m.Nullable)
], $c23b501a5502a14e$var$NotSetTransition);
module.exports.NotSetTransition = $c23b501a5502a14e$var$NotSetTransition;

});
parcelRegister("5EcBU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $41ca785f4c67a19a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $41ca785f4c67a19a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTransition = void 0;

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");

var $5NWCj = parcelRequire("5NWCj");
/** A transition containing a set of values. */ let $41ca785f4c67a19a$var$SetTransition = class SetTransition extends $5NWCj.Transition {
    // TODO (sam): should we really allow undefined here?
    constructor(target, set){
        super(target);
        if (set == null) set = $6kdz0.IntervalSet.of($eKXi4.Token.INVALID_TYPE);
        this.set = set;
    }
    get serializationType() {
        return 7 /* SET */ ;
    }
    get label() {
        return this.set;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this.set.contains(symbol);
    }
    toString() {
        return this.set.toString();
    }
};
$41ca785f4c67a19a$var$__decorate([
    $aN41m.NotNull
], $41ca785f4c67a19a$var$SetTransition.prototype, "set", void 0);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override
], $41ca785f4c67a19a$var$SetTransition.prototype, "serializationType", null);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $41ca785f4c67a19a$var$SetTransition.prototype, "label", null);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override
], $41ca785f4c67a19a$var$SetTransition.prototype, "matches", null);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $41ca785f4c67a19a$var$SetTransition.prototype, "toString", null);
$41ca785f4c67a19a$var$SetTransition = $41ca785f4c67a19a$var$__decorate([
    $41ca785f4c67a19a$var$__param(0, $aN41m.NotNull),
    $41ca785f4c67a19a$var$__param(1, $aN41m.Nullable)
], $41ca785f4c67a19a$var$SetTransition);
module.exports.SetTransition = $41ca785f4c67a19a$var$SetTransition;

});


parcelRegister("jWsYN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e849e9dccd4b044f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStopState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/** The last node in the ATN for a rule, unless that rule is the start symbol.
 *  In that case, there is one transition to EOF. Later, we might encode
 *  references to all calls to this rule to compute FOLLOW sets for
 *  error handling.
 */ class $e849e9dccd4b044f$var$RuleStopState extends $dv9vN.ATNState {
    get nonStopStateNumber() {
        return -1;
    }
    get stateType() {
        return $fZESB.ATNStateType.RULE_STOP;
    }
}
$e849e9dccd4b044f$var$__decorate([
    $aN41m.Override
], $e849e9dccd4b044f$var$RuleStopState.prototype, "nonStopStateNumber", null);
$e849e9dccd4b044f$var$__decorate([
    $aN41m.Override
], $e849e9dccd4b044f$var$RuleStopState.prototype, "stateType", null);
module.exports.RuleStopState = $e849e9dccd4b044f$var$RuleStopState;

});

parcelRegister("lmhna", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f8c920e267cf5afe$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f8c920e267cf5afe$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
/** */ let $f8c920e267cf5afe$var$RuleTransition = class RuleTransition extends $5NWCj.Transition {
    constructor(ruleStart, ruleIndex, precedence, followState){
        super(ruleStart);
        this.tailCall = false;
        this.optimizedTailCall = false;
        this.ruleIndex = ruleIndex;
        this.precedence = precedence;
        this.followState = followState;
    }
    get serializationType() {
        return 3 /* RULE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
};
$f8c920e267cf5afe$var$__decorate([
    $aN41m.NotNull
], $f8c920e267cf5afe$var$RuleTransition.prototype, "followState", void 0);
$f8c920e267cf5afe$var$__decorate([
    $aN41m.Override
], $f8c920e267cf5afe$var$RuleTransition.prototype, "serializationType", null);
$f8c920e267cf5afe$var$__decorate([
    $aN41m.Override
], $f8c920e267cf5afe$var$RuleTransition.prototype, "isEpsilon", null);
$f8c920e267cf5afe$var$__decorate([
    $aN41m.Override
], $f8c920e267cf5afe$var$RuleTransition.prototype, "matches", null);
$f8c920e267cf5afe$var$RuleTransition = $f8c920e267cf5afe$var$__decorate([
    $f8c920e267cf5afe$var$__param(0, $aN41m.NotNull),
    $f8c920e267cf5afe$var$__param(3, $aN41m.NotNull)
], $f8c920e267cf5afe$var$RuleTransition);
module.exports.RuleTransition = $f8c920e267cf5afe$var$RuleTransition;

});

parcelRegister("69uaV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0127eb50794c99a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0127eb50794c99a9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $0127eb50794c99a9$var$WildcardTransition = class WildcardTransition extends $5NWCj.Transition {
    constructor(target){
        super(target);
    }
    get serializationType() {
        return 9 /* WILDCARD */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
    }
    toString() {
        return ".";
    }
};
$0127eb50794c99a9$var$__decorate([
    $aN41m.Override
], $0127eb50794c99a9$var$WildcardTransition.prototype, "serializationType", null);
$0127eb50794c99a9$var$__decorate([
    $aN41m.Override
], $0127eb50794c99a9$var$WildcardTransition.prototype, "matches", null);
$0127eb50794c99a9$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $0127eb50794c99a9$var$WildcardTransition.prototype, "toString", null);
$0127eb50794c99a9$var$WildcardTransition = $0127eb50794c99a9$var$__decorate([
    $0127eb50794c99a9$var$__param(0, $aN41m.NotNull)
], $0127eb50794c99a9$var$WildcardTransition);
module.exports.WildcardTransition = $0127eb50794c99a9$var$WildcardTransition;

});



parcelRegister("i6TH4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d2f3fd2991f6cfe3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d2f3fd2991f6cfe3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionExecutor = void 0;

var $6iIjF = parcelRequire("6iIjF");

var $jKxtl = parcelRequire("jKxtl");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Represents an executor for a sequence of lexer actions which traversed during
 * the matching operation of a lexer rule (token).
 *
 * The executor tracks position information for position-dependent lexer actions
 * efficiently, ensuring that actions appearing only at the end of the rule do
 * not cause bloating of the {@link DFA} created for the lexer.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $d2f3fd2991f6cfe3$var$LexerActionExecutor = class LexerActionExecutor {
    /**
     * Constructs an executor for a sequence of {@link LexerAction} actions.
     * @param lexerActions The lexer actions to execute.
     */ constructor(lexerActions){
        this._lexerActions = lexerActions;
        let hash = $amQx9.MurmurHash.initialize();
        for (let lexerAction of lexerActions)hash = $amQx9.MurmurHash.update(hash, lexerAction);
        this.cachedHashCode = $amQx9.MurmurHash.finish(hash, lexerActions.length);
    }
    /**
     * Creates a {@link LexerActionExecutor} which executes the actions for
     * the input `lexerActionExecutor` followed by a specified
     * `lexerAction`.
     *
     * @param lexerActionExecutor The executor for actions already traversed by
     * the lexer while matching a token within a particular
     * {@link ATNConfig}. If this is `undefined`, the method behaves as though
     * it were an empty executor.
     * @param lexerAction The lexer action to execute after the actions
     * specified in `lexerActionExecutor`.
     *
     * @returns A {@link LexerActionExecutor} for executing the combine actions
     * of `lexerActionExecutor` and `lexerAction`.
     */ static append(lexerActionExecutor, lexerAction) {
        if (!lexerActionExecutor) return new LexerActionExecutor([
            lexerAction
        ]);
        let lexerActions = lexerActionExecutor._lexerActions.slice(0);
        lexerActions.push(lexerAction);
        return new LexerActionExecutor(lexerActions);
    }
    /**
     * Creates a {@link LexerActionExecutor} which encodes the current offset
     * for position-dependent lexer actions.
     *
     * Normally, when the executor encounters lexer actions where
     * {@link LexerAction#isPositionDependent} returns `true`, it calls
     * {@link IntStream#seek} on the input {@link CharStream} to set the input
     * position to the *end* of the current token. This behavior provides
     * for efficient DFA representation of lexer actions which appear at the end
     * of a lexer rule, even when the lexer rule matches a variable number of
     * characters.
     *
     * Prior to traversing a match transition in the ATN, the current offset
     * from the token start index is assigned to all position-dependent lexer
     * actions which have not already been assigned a fixed offset. By storing
     * the offsets relative to the token start index, the DFA representation of
     * lexer actions which appear in the middle of tokens remains efficient due
     * to sharing among tokens of the same length, regardless of their absolute
     * position in the input stream.
     *
     * If the current executor already has offsets assigned to all
     * position-dependent lexer actions, the method returns `this`.
     *
     * @param offset The current offset to assign to all position-dependent
     * lexer actions which do not already have offsets assigned.
     *
     * @returns A {@link LexerActionExecutor} which stores input stream offsets
     * for all position-dependent lexer actions.
     */ fixOffsetBeforeMatch(offset) {
        let updatedLexerActions;
        for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $jKxtl.LexerIndexedCustomAction)) {
            if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
            updatedLexerActions[i] = new $jKxtl.LexerIndexedCustomAction(offset, this._lexerActions[i]);
        }
        if (!updatedLexerActions) return this;
        return new LexerActionExecutor(updatedLexerActions);
    }
    /**
     * Gets the lexer actions to be executed by this executor.
     * @returns The lexer actions to be executed by this executor.
     */ get lexerActions() {
        return this._lexerActions;
    }
    /**
     * Execute the actions encapsulated by this executor within the context of a
     * particular {@link Lexer}.
     *
     * This method calls {@link IntStream#seek} to set the position of the
     * `input` {@link CharStream} prior to calling
     * {@link LexerAction#execute} on a position-dependent action. Before the
     * method returns, the input position will be restored to the same position
     * it was in when the method was invoked.
     *
     * @param lexer The lexer instance.
     * @param input The input stream which is the source for the current token.
     * When this method is called, the current {@link IntStream#index} for
     * `input` should be the start of the following token, i.e. 1
     * character past the end of the current token.
     * @param startIndex The token start index. This value may be passed to
     * {@link IntStream#seek} to set the `input` position to the beginning
     * of the token.
     */ execute(lexer, input, startIndex) {
        let requiresSeek = false;
        let stopIndex = input.index;
        try {
            for (let lexerAction of this._lexerActions){
                if (lexerAction instanceof $jKxtl.LexerIndexedCustomAction) {
                    let offset = lexerAction.offset;
                    input.seek(startIndex + offset);
                    lexerAction = lexerAction.action;
                    requiresSeek = startIndex + offset !== stopIndex;
                } else if (lexerAction.isPositionDependent) {
                    input.seek(stopIndex);
                    requiresSeek = false;
                }
                lexerAction.execute(lexer);
            }
        } finally{
            if (requiresSeek) input.seek(stopIndex);
        }
    }
    hashCode() {
        return this.cachedHashCode;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerActionExecutor)) return false;
        return this.cachedHashCode === obj.cachedHashCode && $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
    }
};
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.NotNull
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.NotNull
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "lexerActions", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $d2f3fd2991f6cfe3$var$__param(0, $aN41m.NotNull)
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "execute", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.Override
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "hashCode", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.Override
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "equals", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.NotNull,
    $d2f3fd2991f6cfe3$var$__param(1, $aN41m.NotNull)
], $d2f3fd2991f6cfe3$var$LexerActionExecutor, "append", null);
$d2f3fd2991f6cfe3$var$LexerActionExecutor = $d2f3fd2991f6cfe3$var$__decorate([
    $d2f3fd2991f6cfe3$var$__param(0, $aN41m.NotNull)
], $d2f3fd2991f6cfe3$var$LexerActionExecutor);
module.exports.LexerActionExecutor = $d2f3fd2991f6cfe3$var$LexerActionExecutor;

});
parcelRegister("jKxtl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e60c471ba1c7e661$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e60c471ba1c7e661$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerIndexedCustomAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * This implementation of {@link LexerAction} is used for tracking input offsets
 * for position-dependent actions within a {@link LexerActionExecutor}.
 *
 * This action is not serialized as part of the ATN, and is only required for
 * position-dependent lexer actions which appear at a location other than the
 * end of a rule. For more information about DFA optimizations employed for
 * lexer actions, see {@link LexerActionExecutor#append} and
 * {@link LexerActionExecutor#fixOffsetBeforeMatch}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $e60c471ba1c7e661$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
    /**
     * Constructs a new indexed custom action by associating a character offset
     * with a {@link LexerAction}.
     *
     * Note: This class is only required for lexer actions for which
     * {@link LexerAction#isPositionDependent} returns `true`.
     *
     * @param offset The offset into the input {@link CharStream}, relative to
     * the token start index, at which the specified lexer action should be
     * executed.
     * @param action The lexer action to execute at a particular offset in the
     * input {@link CharStream}.
     */ constructor(offset, action){
        this._offset = offset;
        this._action = action;
    }
    /**
     * Gets the location in the input {@link CharStream} at which the lexer
     * action should be executed. The value is interpreted as an offset relative
     * to the token start index.
     *
     * @returns The location in the input {@link CharStream} at which the lexer
     * action should be executed.
     */ get offset() {
        return this._offset;
    }
    /**
     * Gets the lexer action to execute.
     *
     * @returns A {@link LexerAction} object which executes the lexer action.
     */ get action() {
        return this._action;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns the result of calling {@link #getActionType}
     * on the {@link LexerAction} returned by {@link #getAction}.
     */ get actionType() {
        return this._action.actionType;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * This method calls {@link #execute} on the result of {@link #getAction}
     * using the provided `lexer`.
     */ execute(lexer) {
        // assume the input stream position was properly set by the calling code
        this._action.execute(lexer);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this._offset);
        hash = $amQx9.MurmurHash.update(hash, this._action);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerIndexedCustomAction)) return false;
        return this._offset === obj._offset && this._action.equals(obj._action);
    }
};
$e60c471ba1c7e661$var$__decorate([
    $aN41m.NotNull
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "action", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "actionType", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "execute", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "hashCode", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "equals", null);
$e60c471ba1c7e661$var$LexerIndexedCustomAction = $e60c471ba1c7e661$var$__decorate([
    $e60c471ba1c7e661$var$__param(1, $aN41m.NotNull)
], $e60c471ba1c7e661$var$LexerIndexedCustomAction);
module.exports.LexerIndexedCustomAction = $e60c471ba1c7e661$var$LexerIndexedCustomAction;

});


parcelRegister("l3IpB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f54c54195bb1f77d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f54c54195bb1f77d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerNoViableAltException = void 0;

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");

var $l8y5T = parcelRequire("l8y5T");

var $62Uvn = parcelRequire("62Uvn");
let $f54c54195bb1f77d$var$LexerNoViableAltException = class LexerNoViableAltException extends $b7PPe.RecognitionException {
    constructor(lexer, input, startIndex, deadEndConfigs){
        super(lexer, input);
        this._startIndex = startIndex;
        this._deadEndConfigs = deadEndConfigs;
    }
    get startIndex() {
        return this._startIndex;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    get inputStream() {
        return super.inputStream;
    }
    toString() {
        let symbol = "";
        if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
            symbol = this.inputStream.getText($l8y5T.Interval.of(this._startIndex, this._startIndex));
            symbol = $62Uvn.escapeWhitespace(symbol, false);
        }
        // return String.format(Locale.getDefault(), "%s('%s')", LexerNoViableAltException.class.getSimpleName(), symbol);
        return `LexerNoViableAltException('${symbol}')`;
    }
};
$f54c54195bb1f77d$var$__decorate([
    $aN41m.Override
], $f54c54195bb1f77d$var$LexerNoViableAltException.prototype, "inputStream", null);
$f54c54195bb1f77d$var$__decorate([
    $aN41m.Override
], $f54c54195bb1f77d$var$LexerNoViableAltException.prototype, "toString", null);
$f54c54195bb1f77d$var$LexerNoViableAltException = $f54c54195bb1f77d$var$__decorate([
    $f54c54195bb1f77d$var$__param(1, $aN41m.NotNull)
], $f54c54195bb1f77d$var$LexerNoViableAltException);
module.exports.LexerNoViableAltException = $f54c54195bb1f77d$var$LexerNoViableAltException;

});

parcelRegister("9O0ze", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7239393757aed774$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedATNConfigSet = void 0;

var $2SGHL = parcelRequire("2SGHL");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $7239393757aed774$var$OrderedATNConfigSet extends $2SGHL.ATNConfigSet {
    constructor(set, readonly){
        if (set != null && readonly != null) super(set, readonly);
        else super();
    }
    clone(readonly) {
        let copy = new $7239393757aed774$var$OrderedATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this);
        return copy;
    }
    getKey(e) {
        // This is a specially crafted key to ensure configurations are only merged if they are equal
        return {
            state: 0,
            alt: e.hashCode()
        };
    }
    canMerge(left, leftKey, right) {
        return left.equals(right);
    }
}
$7239393757aed774$var$__decorate([
    $aN41m.Override
], $7239393757aed774$var$OrderedATNConfigSet.prototype, "clone", null);
$7239393757aed774$var$__decorate([
    $aN41m.Override
], $7239393757aed774$var$OrderedATNConfigSet.prototype, "getKey", null);
$7239393757aed774$var$__decorate([
    $aN41m.Override
], $7239393757aed774$var$OrderedATNConfigSet.prototype, "canMerge", null);
module.exports.OrderedATNConfigSet = $7239393757aed774$var$OrderedATNConfigSet;

});




parcelRegister("iAlWg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d87c9b6083957611$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoViableAltException = void 0;

var $c9Sjf = parcelRequire("c9Sjf");

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");
/** Indicates that the parser could not decide which of two or more paths
 *  to take based upon the remaining input. It tracks the starting token
 *  of the offending input and also knows where the parser was
 *  in the various paths when the error. Reported by reportNoViableAlternative()
 */ class $d87c9b6083957611$var$NoViableAltException extends $b7PPe.RecognitionException {
    constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
        if (recognizer instanceof $c9Sjf.Parser) {
            if (input === undefined) input = recognizer.inputStream;
            if (startToken === undefined) startToken = recognizer.currentToken;
            if (offendingToken === undefined) offendingToken = recognizer.currentToken;
            if (ctx === undefined) ctx = recognizer.context;
        }
        super(recognizer, input, ctx);
        this._deadEndConfigs = deadEndConfigs;
        this._startToken = startToken;
        this.setOffendingToken(recognizer, offendingToken);
    }
    get startToken() {
        return this._startToken;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
}
$d87c9b6083957611$var$__decorate([
    $aN41m.NotNull
], $d87c9b6083957611$var$NoViableAltException.prototype, "_startToken", void 0);
module.exports.NoViableAltException = $d87c9b6083957611$var$NoViableAltException;

});
parcelRegister("c9Sjf", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8da07405e42e2bc1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8da07405e42e2bc1$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var $8da07405e42e2bc1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $62Uvn = parcelRequire("62Uvn");

var $3VQ9j = parcelRequire("3VQ9j");

var $1ztRl = parcelRequire("1ztRl");

var $3HZil = parcelRequire("3HZil");

var $co9Xk = parcelRequire("co9Xk");

var $jB0DW = parcelRequire("jB0DW");

var $h7Q3L = parcelRequire("h7Q3L");

var $aN41m = parcelRequire("aN41m");

var $8EOCV = parcelRequire("8EOCV");

var $gzbPK = parcelRequire("gzbPK");

var $jdbdJ = parcelRequire("jdbdJ");

var $dwftT = parcelRequire("dwftT");

var $2IN61 = parcelRequire("2IN61");

var $eKXi4 = parcelRequire("eKXi4");
class $8da07405e42e2bc1$var$TraceListener {
    constructor(ruleNames, tokenStream){
        this.ruleNames = ruleNames;
        this.tokenStream = tokenStream;
    }
    enterEveryRule(ctx) {
        console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    exitEveryRule(ctx) {
        console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    visitErrorNode(node) {
    // intentionally empty
    }
    visitTerminal(node) {
        let parent = node.parent.ruleContext;
        let token = node.symbol;
        console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
    }
}
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "enterEveryRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "exitEveryRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "visitErrorNode", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "visitTerminal", null);



/** This is all the parsing support code essentially; most of it is error recovery stuff. */ class $8da07405e42e2bc1$var$Parser extends $dwftT.Recognizer {
    constructor(input){
        super();
        /**
         * The error handling strategy for the parser. The default value is a new
         * instance of {@link DefaultErrorStrategy}.
         *
         * @see #getErrorHandler
         * @see #setErrorHandler
         */ this._errHandler = new $3HZil.DefaultErrorStrategy();
        this._precedenceStack = new $jB0DW.IntegerStack();
        /**
         * Specifies whether or not the parser should construct a parse tree during
         * the parsing process. The default value is `true`.
         *
         * @see `buildParseTree`
         */ this._buildParseTrees = true;
        /**
         * The list of {@link ParseTreeListener} listeners registered to receive
         * events during the parse.
         *
         * @see #addParseListener
         */ this._parseListeners = [];
        /**
         * The number of syntax errors reported during parsing. This value is
         * incremented each time {@link #notifyErrorListeners} is called.
         */ this._syntaxErrors = 0;
        /** Indicates parser has match()ed EOF token. See {@link #exitRule()}. */ this.matchedEOF = false;
        this._precedenceStack.push(0);
        this.inputStream = input;
    }
    reset(resetInput) {
        // Note: this method executes when not parsing, so _ctx can be undefined
        if (resetInput === undefined || resetInput) this.inputStream.seek(0);
        this._errHandler.reset(this);
        this._ctx = undefined;
        this._syntaxErrors = 0;
        this.matchedEOF = false;
        this.isTrace = false;
        this._precedenceStack.clear();
        this._precedenceStack.push(0);
        let interpreter = this.interpreter;
        if (interpreter != null) interpreter.reset();
    }
    /**
     * Match current input symbol against `ttype`. If the symbol type
     * matches, {@link ANTLRErrorStrategy#reportMatch} and {@link #consume} are
     * called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @param ttype the token type to match
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * `ttype` and the error strategy could not recover from the
     * mismatched symbol
     */ match(ttype) {
        let t = this.currentToken;
        if (t.type === ttype) {
            if (ttype === $eKXi4.Token.EOF) this.matchedEOF = true;
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Match current input symbol as a wildcard. If the symbol type matches
     * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy#reportMatch}
     * and {@link #consume} are called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link Parser#createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * a wildcard and the error strategy could not recover from the mismatched
     * symbol
     */ matchWildcard() {
        let t = this.currentToken;
        if (t.type > 0) {
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Track the {@link ParserRuleContext} objects during the parse and hook
     * them up using the {@link ParserRuleContext#children} list so that it
     * forms a parse tree. The {@link ParserRuleContext} returned from the start
     * rule represents the root of the parse tree.
     *
     * Note that if we are not building parse trees, rule contexts only point
     * upwards. When a rule exits, it returns the context but that gets garbage
     * collected if nobody holds a reference. It points upwards but nobody
     * points at it.
     *
     * When we build parse trees, we are adding all of these contexts to
     * {@link ParserRuleContext#children} list. Contexts are then not candidates
     * for garbage collection.
     */ set buildParseTree(buildParseTrees) {
        this._buildParseTrees = buildParseTrees;
    }
    /**
     * Gets whether or not a complete parse tree will be constructed while
     * parsing. This property is `true` for a newly constructed parser.
     *
     * @returns `true` if a complete parse tree will be constructed while
     * parsing, otherwise `false`
     */ get buildParseTree() {
        return this._buildParseTrees;
    }
    getParseListeners() {
        return this._parseListeners;
    }
    /**
     * Registers `listener` to receive events during the parsing process.
     *
     * To support output-preserving grammar transformations (including but not
     * limited to left-recursion removal, automated left-factoring, and
     * optimized code generation), calls to listener methods during the parse
     * may differ substantially from calls made by
     * {@link ParseTreeWalker#DEFAULT} used after the parse is complete. In
     * particular, rule entry and exit events may occur in a different order
     * during the parse than after the parser. In addition, calls to certain
     * rule entry methods may be omitted.
     *
     * With the following specific exceptions, calls to listener events are
     * *deterministic*, i.e. for identical input the calls to listener
     * methods will be the same.
     *
     * * Alterations to the grammar used to generate code may change the
     *   behavior of the listener calls.
     * * Alterations to the command line options passed to ANTLR 4 when
     *   generating the parser may change the behavior of the listener calls.
     * * Changing the version of the ANTLR Tool used to generate the parser
     *   may change the behavior of the listener calls.
     *
     * @param listener the listener to add
     *
     * @throws {@link TypeError} if `listener` is `undefined`
     */ addParseListener(listener) {
        if (listener == null) throw new TypeError("listener cannot be null");
        this._parseListeners.push(listener);
    }
    /**
     * Remove `listener` from the list of parse listeners.
     *
     * If `listener` is `undefined` or has not been added as a parse
     * listener, this method does nothing.
     *
     * @see #addParseListener
     *
     * @param listener the listener to remove
     */ removeParseListener(listener) {
        let index = this._parseListeners.findIndex((l)=>l === listener);
        if (index !== -1) this._parseListeners.splice(index, 1);
    }
    /**
     * Remove all parse listeners.
     *
     * @see #addParseListener
     */ removeParseListeners() {
        this._parseListeners.length = 0;
    }
    /**
     * Notify any parse listeners of an enter rule event.
     *
     * @see #addParseListener
     */ triggerEnterRuleEvent() {
        for (let listener of this._parseListeners){
            if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
            this._ctx.enterRule(listener);
        }
    }
    /**
     * Notify any parse listeners of an exit rule event.
     *
     * @see #addParseListener
     */ triggerExitRuleEvent() {
        // reverse order walk of listeners
        for(let i = this._parseListeners.length - 1; i >= 0; i--){
            let listener = this._parseListeners[i];
            this._ctx.exitRule(listener);
            if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
        }
    }
    /**
     * Gets the number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     *
     * @see #notifyErrorListeners
     */ get numberOfSyntaxErrors() {
        return this._syntaxErrors;
    }
    get tokenFactory() {
        return this._input.tokenSource.tokenFactory;
    }
    /**
     * The ATN with bypass alternatives is expensive to create so we create it
     * lazily.
     *
     * @ if the current parser does not
     * implement the `serializedATN` property.
     */ getATNWithBypassAlts() {
        let serializedAtn = this.serializedATN;
        if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
        let result = $8da07405e42e2bc1$var$Parser.bypassAltsAtnCache.get(serializedAtn);
        if (result == null) {
            let deserializationOptions = new $3VQ9j.ATNDeserializationOptions();
            deserializationOptions.isGenerateRuleBypassTransitions = true;
            result = new $1ztRl.ATNDeserializer(deserializationOptions).deserialize($62Uvn.toCharArray(serializedAtn));
            $8da07405e42e2bc1$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
        }
        return result;
    }
    compileParseTreePattern(pattern, patternRuleIndex, lexer) {
        return $8da07405e42e2bc1$var$__awaiter(this, void 0, void 0, function*() {
            if (!lexer) {
                if (this.inputStream) {
                    let tokenSource = this.inputStream.tokenSource;
                    if (tokenSource instanceof $h7Q3L.Lexer) lexer = tokenSource;
                }
                if (!lexer) throw new Error("Parser can't discover a lexer to use");
            }
            let currentLexer = lexer;
            let m = yield Promise.resolve().then(()=>(parcelRequire("gQja9")));
            let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
            return matcher.compile(pattern, patternRuleIndex);
        });
    }
    get errorHandler() {
        return this._errHandler;
    }
    set errorHandler(handler) {
        this._errHandler = handler;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the token stream and reset the parser. */ set inputStream(input) {
        this.reset(false);
        this._input = input;
    }
    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.
     */ get currentToken() {
        return this._input.LT(1);
    }
    notifyErrorListeners(msg, offendingToken, e) {
        if (offendingToken === undefined) offendingToken = this.currentToken;
        else if (offendingToken === null) offendingToken = undefined;
        this._syntaxErrors++;
        let line = -1;
        let charPositionInLine = -1;
        if (offendingToken != null) {
            line = offendingToken.line;
            charPositionInLine = offendingToken.charPositionInLine;
        }
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
    }
    /**
     * Consume and return the [current symbol](`currentToken`).
     *
     * E.g., given the following input with `A` being the current
     * lookahead symbol, this function moves the cursor to `B` and returns
     * `A`.
     *
     * ```
     * A B
     * ^
     * ```
     *
     * If the parser is not in error recovery mode, the consumed symbol is added
     * to the parse tree using {@link ParserRuleContext#addChild(TerminalNode)}, and
     * {@link ParseTreeListener#visitTerminal} is called on any parse listeners.
     * If the parser *is* in error recovery mode, the consumed symbol is
     * added to the parse tree using {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)} and
     * {@link ParseTreeListener#visitErrorNode} is called on any parse
     * listeners.
     */ consume() {
        let o = this.currentToken;
        if (o.type !== $8da07405e42e2bc1$var$Parser.EOF) this.inputStream.consume();
        let hasListener = this._parseListeners.length !== 0;
        if (this._buildParseTrees || hasListener) {
            if (this._errHandler.inErrorRecoveryMode(this)) {
                let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                }
            } else {
                let node = this.createTerminalNode(this._ctx, o);
                this._ctx.addChild(node);
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                }
            }
        }
        return o;
    }
    /**
     * How to create a token leaf node associated with a parent.
     * Typically, the terminal node to create is not a function of the parent.
     *
     * @since 4.7
     */ createTerminalNode(parent, t) {
        return new $2IN61.TerminalNode(t);
    }
    /**
     * How to create an error node, given a token, associated with a parent.
     * Typically, the error node to create is not a function of the parent.
     *
     * @since 4.7
     */ createErrorNode(parent, t) {
        return new $co9Xk.ErrorNode(t);
    }
    addContextToParseTree() {
        let parent = this._ctx._parent;
        // add current context to parent if we have a parent
        if (parent != null) parent.addChild(this._ctx);
    }
    /**
     * Always called by generated parsers upon entry to a rule. Access field
     * {@link #_ctx} get the current context.
     */ enterRule(localctx, state, ruleIndex) {
        this.state = state;
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    enterLeftFactoredRule(localctx, state, ruleIndex) {
        this.state = state;
        if (this._buildParseTrees) {
            let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
            this._ctx.removeLastChild();
            factoredContext._parent = localctx;
            localctx.addChild(factoredContext);
        }
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    exitRule() {
        if (this.matchedEOF) // if we have matched EOF, it cannot consume past EOF so we use LT(1) here
        this._ctx._stop = this._input.LT(1); // LT(1) will be end of file
        else this._ctx._stop = this._input.tryLT(-1); // stop node is what we just matched
        // trigger event on _ctx, before it reverts to parent
        this.triggerExitRuleEvent();
        this.state = this._ctx.invokingState;
        this._ctx = this._ctx._parent;
    }
    enterOuterAlt(localctx, altNum) {
        localctx.altNumber = altNum;
        // if we have new localctx, make sure we replace existing ctx
        // that is previous child of parse tree
        if (this._buildParseTrees && this._ctx !== localctx) {
            let parent = this._ctx._parent;
            if (parent != null) {
                parent.removeLastChild();
                parent.addChild(localctx);
            }
        }
        this._ctx = localctx;
    }
    /**
     * Get the precedence level for the top-most precedence rule.
     *
     * @returns The precedence level for the top-most precedence rule, or -1 if
     * the parser context is not nested within a precedence rule.
     */ get precedence() {
        if (this._precedenceStack.isEmpty) return -1;
        return this._precedenceStack.peek();
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this.state = state;
        this._precedenceStack.push(precedence);
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    /** Like {@link #enterRule} but for recursive rules.
     *  Make the current context the child of the incoming localctx.
     */ pushNewRecursionContext(localctx, state, ruleIndex) {
        let previous = this._ctx;
        previous._parent = localctx;
        previous.invokingState = state;
        previous._stop = this._input.tryLT(-1);
        this._ctx = localctx;
        this._ctx._start = previous._start;
        if (this._buildParseTrees) this._ctx.addChild(previous);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    unrollRecursionContexts(_parentctx) {
        this._precedenceStack.pop();
        this._ctx._stop = this._input.tryLT(-1);
        let retctx = this._ctx; // save current ctx (return value)
        // unroll so _ctx is as it was before call to recursive method
        if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
            this.triggerExitRuleEvent();
            this._ctx = this._ctx._parent;
        }
        else this._ctx = _parentctx;
        // hook into tree
        retctx._parent = _parentctx;
        if (this._buildParseTrees && _parentctx != null) // add return ctx into invoking rule's tree
        _parentctx.addChild(retctx);
    }
    getInvokingContext(ruleIndex) {
        let p = this._ctx;
        while(p && p.ruleIndex !== ruleIndex)p = p._parent;
        return p;
    }
    get context() {
        return this._ctx;
    }
    set context(ctx) {
        this._ctx = ctx;
    }
    precpred(localctx, precedence) {
        return precedence >= this._precedenceStack.peek();
    }
    getErrorListenerDispatch() {
        return new $jdbdJ.ProxyParserErrorListener(this.getErrorListeners());
    }
    inContext(context) {
        // TODO: useful in parser?
        return false;
    }
    /**
     * Checks whether or not `symbol` can follow the current state in the
     * ATN. The behavior of this method is equivalent to the following, but is
     * implemented such that the complete context-sensitive follow set does not
     * need to be explicitly constructed.
     *
     * ```
     * return getExpectedTokens().contains(symbol);
     * ```
     *
     * @param symbol the symbol type to check
     * @returns `true` if `symbol` can follow the current state in
     * the ATN, otherwise `false`.
     */ isExpectedToken(symbol) {
        //   		return interpreter.atn.nextTokens(_ctx);
        let atn = this.interpreter.atn;
        let ctx = this._ctx;
        let s = atn.states[this.state];
        let following = atn.nextTokens(s);
        if (following.contains(symbol)) return true;
        //        System.out.println("following "+s+"="+following);
        if (!following.contains($eKXi4.Token.EPSILON)) return false;
        while(ctx != null && ctx.invokingState >= 0 && following.contains($eKXi4.Token.EPSILON)){
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = atn.nextTokens(rt.followState);
            if (following.contains(symbol)) return true;
            ctx = ctx._parent;
        }
        if (following.contains($eKXi4.Token.EPSILON) && symbol === $eKXi4.Token.EOF) return true;
        return false;
    }
    get isMatchedEOF() {
        return this.matchedEOF;
    }
    /**
     * Computes the set of input symbols which could follow the current parser
     * state and context, as given by {@link #getState} and {@link #getContext},
     * respectively.
     *
     * @see ATN#getExpectedTokens(int, RuleContext)
     */ getExpectedTokens() {
        return this.atn.getExpectedTokens(this.state, this.context);
    }
    getExpectedTokensWithinCurrentRule() {
        let atn = this.interpreter.atn;
        let s = atn.states[this.state];
        return atn.nextTokens(s);
    }
    /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */ getRuleIndex(ruleName) {
        let ruleIndex = this.getRuleIndexMap().get(ruleName);
        if (ruleIndex != null) return ruleIndex;
        return -1;
    }
    get ruleContext() {
        return this._ctx;
    }
    /** Return List&lt;String&gt; of the rule names in your parser instance
     *  leading up to a call to the current rule.  You could override if
     *  you want more details such as the file/line info of where
     *  in the ATN a rule is invoked.
     *
     *  This is very useful for error messages.
     */ getRuleInvocationStack(ctx = this._ctx) {
        let p = ctx; // Workaround for Microsoft/TypeScript#14487
        let ruleNames = this.ruleNames;
        let stack = [];
        while(p != null){
            // compute what follows who invoked us
            let ruleIndex = p.ruleIndex;
            if (ruleIndex < 0) stack.push("n/a");
            else stack.push(ruleNames[ruleIndex]);
            p = p._parent;
        }
        return stack;
    }
    /** For debugging and other purposes. */ getDFAStrings() {
        let s = [];
        for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
        return s;
    }
    /** For debugging and other purposes. */ dumpDFA() {
        let seenOne = false;
        for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
            if (seenOne) console.log();
            console.log("Decision " + dfa.decision + ":");
            $2fFJv.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
            seenOne = true;
        }
    }
    get sourceName() {
        return this._input.sourceName;
    }
    get parseInfo() {
        return Promise.resolve().then(()=>(parcelRequire("kTiidv"))).then((m)=>{
            let interp = this.interpreter;
            if (interp instanceof m.ProfilingATNSimulator) return new $8EOCV.ParseInfo(interp);
            return undefined;
        });
    }
    /**
     * @since 4.3
     */ setProfile(profile) {
        return $8da07405e42e2bc1$var$__awaiter(this, void 0, void 0, function*() {
            let m = yield Promise.resolve().then(()=>(parcelRequire("kTiidv")));
            let interp = this.interpreter;
            if (profile) {
                if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
            } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $gzbPK.ParserATNSimulator(this.atn, this);
            this.interpreter.setPredictionMode(interp.getPredictionMode());
        });
    }
    /** During a parse is sometimes useful to listen in on the rule entry and exit
     *  events as well as token matches. This is for quick and dirty debugging.
     */ set isTrace(trace) {
        if (!trace) {
            if (this._tracer) {
                this.removeParseListener(this._tracer);
                this._tracer = undefined;
            }
        } else {
            if (this._tracer) this.removeParseListener(this._tracer);
            else this._tracer = new $8da07405e42e2bc1$var$TraceListener(this.ruleNames, this._input);
            this.addParseListener(this._tracer);
        }
    }
    /**
     * Gets whether a {@link TraceListener} is registered as a parse listener
     * for the parser.
     */ get isTrace() {
        return this._tracer != null;
    }
}
/**
 * This field maps from the serialized ATN string to the deserialized {@link ATN} with
 * bypass alternatives.
 *
 * @see ATNDeserializationOptions.isGenerateRuleBypassTransitions
 */ $8da07405e42e2bc1$var$Parser.bypassAltsAtnCache = new Map();
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "_errHandler", void 0);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "match", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "matchWildcard", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getParseListeners", null);
$8da07405e42e2bc1$var$__decorate([
    $8da07405e42e2bc1$var$__param(0, $aN41m.NotNull)
], $8da07405e42e2bc1$var$Parser.prototype, "addParseListener", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getATNWithBypassAlts", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull,
    $8da07405e42e2bc1$var$__param(0, $aN41m.NotNull)
], $8da07405e42e2bc1$var$Parser.prototype, "errorHandler", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$Parser.prototype, "inputStream", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "currentToken", null);
$8da07405e42e2bc1$var$__decorate([
    $8da07405e42e2bc1$var$__param(0, $aN41m.NotNull)
], $8da07405e42e2bc1$var$Parser.prototype, "enterRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override,
    $8da07405e42e2bc1$var$__param(0, $aN41m.Nullable)
], $8da07405e42e2bc1$var$Parser.prototype, "precpred", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$Parser.prototype, "getErrorListenerDispatch", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getExpectedTokens", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$Parser.prototype, "parseInfo", null);
module.exports.Parser = $8da07405e42e2bc1$var$Parser;

});
parcelRegister("3VQ9j", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2dcf25b78652d5b7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializationOptions = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $2dcf25b78652d5b7$var$ATNDeserializationOptions {
    constructor(options){
        this.readOnly = false;
        if (options) {
            this.verifyATN = options.verifyATN;
            this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
            this.optimize = options.optimize;
        } else {
            this.verifyATN = true;
            this.generateRuleBypassTransitions = false;
            this.optimize = true;
        }
    }
    static get defaultOptions() {
        if ($2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions == null) {
            $2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions = new $2dcf25b78652d5b7$var$ATNDeserializationOptions();
            $2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
        }
        return $2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions;
    }
    get isReadOnly() {
        return this.readOnly;
    }
    makeReadOnly() {
        this.readOnly = true;
    }
    get isVerifyATN() {
        return this.verifyATN;
    }
    set isVerifyATN(verifyATN) {
        this.throwIfReadOnly();
        this.verifyATN = verifyATN;
    }
    get isGenerateRuleBypassTransitions() {
        return this.generateRuleBypassTransitions;
    }
    set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
        this.throwIfReadOnly();
        this.generateRuleBypassTransitions = generateRuleBypassTransitions;
    }
    get isOptimize() {
        return this.optimize;
    }
    set isOptimize(optimize) {
        this.throwIfReadOnly();
        this.optimize = optimize;
    }
    throwIfReadOnly() {
        if (this.isReadOnly) throw new Error("The object is read only.");
    }
}
$2dcf25b78652d5b7$var$__decorate([
    $aN41m.NotNull
], $2dcf25b78652d5b7$var$ATNDeserializationOptions, "defaultOptions", null);
module.exports.ATNDeserializationOptions = $2dcf25b78652d5b7$var$ATNDeserializationOptions;

});

parcelRegister("1ztRl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $125038c9196d1598$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $125038c9196d1598$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializer = void 0;

var $dNkDA = parcelRequire("dNkDA");

var $fsqYw = parcelRequire("fsqYw");

var $eeOLb = parcelRequire("eeOLb");

var $3VQ9j = parcelRequire("3VQ9j");

var $fZESB = parcelRequire("fZESB");

var $kXmw5 = parcelRequire("kXmw5");

var $exhhk = parcelRequire("exhhk");

var $3XAPg = parcelRequire("3XAPg");

var $8WIez = parcelRequire("8WIez");

var $jDuoI = parcelRequire("jDuoI");

var $jizfq = parcelRequire("jizfq");

var $42ptv = parcelRequire("42ptv");

var $1Cdmr = parcelRequire("1Cdmr");

var $7Ey8M = parcelRequire("7Ey8M");

var $6kdz0 = parcelRequire("6kdz0");

var $8ii30 = parcelRequire("8ii30");

var $96Can = parcelRequire("96Can");

var $8Nhul = parcelRequire("8Nhul");

var $Sqz9e = parcelRequire("Sqz9e");

var $a52hA = parcelRequire("a52hA");

var $etfit = parcelRequire("etfit");

var $en1aY = parcelRequire("en1aY");

var $jH58C = parcelRequire("jH58C");

var $345c1 = parcelRequire("345c1");

var $fFNPu = parcelRequire("fFNPu");

var $aN41m = parcelRequire("aN41m");

var $gFTdY = parcelRequire("gFTdY");

var $gzbPK = parcelRequire("gzbPK");

var $pC9Ki = parcelRequire("pC9Ki");

var $a84wo = parcelRequire("a84wo");

var $kIrC4 = parcelRequire("kIrC4");

var $j3Sey = parcelRequire("j3Sey");

var $6WqDl = parcelRequire("6WqDl");

var $UvARH = parcelRequire("UvARH");

var $jWsYN = parcelRequire("jWsYN");

var $lmhna = parcelRequire("lmhna");

var $5EcBU = parcelRequire("5EcBU");

var $ferBg = parcelRequire("ferBg");

var $9kZdU = parcelRequire("9kZdU");

var $e0pjt = parcelRequire("e0pjt");

var $eKXi4 = parcelRequire("eKXi4");

var $J9RdB = parcelRequire("J9RdB");

var $f0PQ3 = parcelRequire("f0PQ3");

var $69uaV = parcelRequire("69uaV");
var $125038c9196d1598$var$UnicodeDeserializingMode;
(function(UnicodeDeserializingMode) {
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
})($125038c9196d1598$var$UnicodeDeserializingMode || ($125038c9196d1598$var$UnicodeDeserializingMode = {}));
/**
 *
 * @author Sam Harwell
 */ class $125038c9196d1598$var$ATNDeserializer {
    constructor(deserializationOptions){
        if (deserializationOptions === undefined) deserializationOptions = $3VQ9j.ATNDeserializationOptions.defaultOptions;
        this.deserializationOptions = deserializationOptions;
    }
    static get SERIALIZED_VERSION() {
        /* This value should never change. Updates following this version are
         * reflected as change in the unique ID SERIALIZED_UUID.
         */ return 3;
    }
    /**
     * Determines if a particular serialized representation of an ATN supports
     * a particular feature, identified by the {@link UUID} used for serializing
     * the ATN at the time the feature was first introduced.
     *
     * @param feature The {@link UUID} marking the first time the feature was
     * supported in the serialized ATN.
     * @param actualUuid The {@link UUID} of the actual serialized ATN which is
     * currently being deserialized.
     * @returns `true` if the `actualUuid` value represents a
     * serialized ATN at or after the feature identified by `feature` was
     * introduced; otherwise, `false`.
     */ static isFeatureSupported(feature, actualUuid) {
        let featureIndex = $125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
        if (featureIndex < 0) return false;
        return $125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
    }
    static getUnicodeDeserializer(mode) {
        if (mode === 0 /* UNICODE_BMP */ ) return {
            readUnicode: (data, p)=>{
                return $125038c9196d1598$var$ATNDeserializer.toInt(data[p]);
            },
            size: 1
        };
        else return {
            readUnicode: (data, p)=>{
                return $125038c9196d1598$var$ATNDeserializer.toInt32(data, p);
            },
            size: 2
        };
    }
    deserialize(data) {
        data = data.slice(0);
        // Each Uint16 value in data is shifted by +2 at the entry to this method. This is an encoding optimization
        // targeting the serialized values 0 and -1 (serialized to 0xFFFF), each of which are very common in the
        // serialized form of the ATN. In the modified UTF-8 that Java uses for compiled string literals, these two
        // character values have multi-byte forms. By shifting each value by +2, they become characters 2 and 1 prior to
        // writing the string, each of which have single-byte representations. Since the shift occurs in the tool during
        // ATN serialization, each target is responsible for adjusting the values during deserialization.
        //
        // As a special case, note that the first element of data is not adjusted because it contains the major version
        // number of the serialized ATN, which was fixed at 3 at the time the value shifting was implemented.
        for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
        let p = 0;
        let version = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        if (version !== $125038c9196d1598$var$ATNDeserializer.SERIALIZED_VERSION) {
            let reason = `Could not deserialize ATN with version ${version} (expected ${$125038c9196d1598$var$ATNDeserializer.SERIALIZED_VERSION}).`;
            throw new Error(reason);
        }
        let uuid = $125038c9196d1598$var$ATNDeserializer.toUUID(data, p);
        p += 8;
        if ($125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
            let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$125038c9196d1598$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
            throw new Error(reason);
        }
        let supportsLexerActions = $125038c9196d1598$var$ATNDeserializer.isFeatureSupported($125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
        let grammarType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        let maxTokenType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        let atn = new $eeOLb.ATN(grammarType, maxTokenType);
        //
        // STATES
        //
        let loopBackStateNumbers = [];
        let endStateNumbers = [];
        let nstates = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nstates; i++){
            let stype = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            // ignore bad type of states
            if (stype === $fZESB.ATNStateType.INVALID_TYPE) {
                atn.addState(new $8ii30.InvalidState());
                continue;
            }
            let ruleIndex = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            if (ruleIndex === 0xFFFF) ruleIndex = -1;
            let s = this.stateFactory(stype, ruleIndex);
            if (stype === $fZESB.ATNStateType.LOOP_END) {
                let loopBackStateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                loopBackStateNumbers.push([
                    s,
                    loopBackStateNumber
                ]);
            } else if (s instanceof $jizfq.BlockStartState) {
                let endStateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                endStateNumbers.push([
                    s,
                    endStateNumber
                ]);
            }
            atn.addState(s);
        }
        // delay the assignment of loop back and end states until we know all the state instances have been initialized
        for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
        for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
        let numNonGreedyStates = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numNonGreedyStates; i++){
            let stateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].nonGreedy = true;
        }
        let numSllDecisions = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numSllDecisions; i++){
            let stateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].sll = true;
        }
        let numPrecedenceStates = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numPrecedenceStates; i++){
            let stateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].isPrecedenceRule = true;
        }
        //
        // RULES
        //
        let nrules = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        if (atn.grammarType === 0 /* LEXER */ ) atn.ruleToTokenType = new Int32Array(nrules);
        atn.ruleToStartState = new Array(nrules);
        for(let i = 0; i < nrules; i++){
            let s = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            let startState = atn.states[s];
            startState.leftFactored = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]) !== 0;
            atn.ruleToStartState[i] = startState;
            if (atn.grammarType === 0 /* LEXER */ ) {
                let tokenType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                if (tokenType === 0xFFFF) tokenType = $eKXi4.Token.EOF;
                atn.ruleToTokenType[i] = tokenType;
                if (!$125038c9196d1598$var$ATNDeserializer.isFeatureSupported($125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                    // this piece of unused metadata was serialized prior to the
                    // addition of LexerAction
                    let actionIndexIgnored = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                }
            }
        }
        atn.ruleToStopState = new Array(nrules);
        for (let state of atn.states){
            if (!(state instanceof $jWsYN.RuleStopState)) continue;
            atn.ruleToStopState[state.ruleIndex] = state;
            atn.ruleToStartState[state.ruleIndex].stopState = state;
        }
        //
        // MODES
        //
        let nmodes = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nmodes; i++){
            let s = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.modeToStartState.push(atn.states[s]);
        }
        atn.modeToDFA = new Array(nmodes);
        for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $1Cdmr.DFA(atn.modeToStartState[i]);
        //
        // SETS
        //
        let sets = [];
        // First, read all sets with 16-bit Unicode code points <= U+FFFF.
        p = this.deserializeSets(data, p, sets, $125038c9196d1598$var$ATNDeserializer.getUnicodeDeserializer(0 /* UNICODE_BMP */ ));
        // Next, if the ATN was serialized with the Unicode SMP feature,
        // deserialize sets with 32-bit arguments <= U+10FFFF.
        if ($125038c9196d1598$var$ATNDeserializer.isFeatureSupported($125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $125038c9196d1598$var$ATNDeserializer.getUnicodeDeserializer(1 /* UNICODE_SMP */ ));
        //
        // EDGES
        //
        let nedges = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nedges; i++){
            let src = $125038c9196d1598$var$ATNDeserializer.toInt(data[p]);
            let trg = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 1]);
            let ttype = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 2]);
            let arg1 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 3]);
            let arg2 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 4]);
            let arg3 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 5]);
            let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
            // console.log(`EDGE ${trans.constructor.name} ${src}->${trg} ${Transition.serializationNames[ttype]} ${arg1},${arg2},${arg3}`);
            let srcState = atn.states[src];
            srcState.addTransition(trans);
            p += 6;
        }
        let returnTransitionsSet = new $fsqYw.Array2DHashSet({
            hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
            equals: (a, b)=>{
                return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
            }
        });
        let returnTransitions = [];
        for (let state of atn.states){
            let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
            for(let i = 0; i < state.numberOfTransitions; i++){
                let t = state.transition(i);
                if (!(t instanceof $lmhna.RuleTransition)) continue;
                let ruleTransition = t;
                let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                if (!returningFromLeftFactored && returningToLeftFactored) continue;
                let outermostPrecedenceReturn = -1;
                if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                    if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                }
                let current = {
                    stopState: ruleTransition.target.ruleIndex,
                    returnState: ruleTransition.followState.stateNumber,
                    outermostPrecedenceReturn: outermostPrecedenceReturn
                };
                if (returnTransitionsSet.add(current)) returnTransitions.push(current);
            }
        }
        // Add all elements from returnTransitions to the ATN
        for (let returnTransition of returnTransitions){
            let transition = new $7Ey8M.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
            atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
        }
        for (let state of atn.states){
            if (state instanceof $jizfq.BlockStartState) {
                // we need to know the end state to set its start state
                if (state.endState === undefined) throw new Error("IllegalStateException");
                // block end states can only be associated to a single block start state
                if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                state.endState.startState = state;
            }
            if (state instanceof $a84wo.PlusLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $pC9Ki.PlusBlockStartState) target.loopBackState = loopbackState;
                }
            } else if (state instanceof $9kZdU.StarLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $e0pjt.StarLoopEntryState) target.loopBackState = loopbackState;
                }
            }
        }
        //
        // DECISIONS
        //
        let ndecisions = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 1; i <= ndecisions; i++){
            let s = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            let decState = atn.states[s];
            atn.decisionToState.push(decState);
            decState.decision = i - 1;
        }
        //
        // LEXER ACTIONS
        //
        if (atn.grammarType === 0 /* LEXER */ ) {
            if (supportsLexerActions) {
                atn.lexerActions = new Array($125038c9196d1598$var$ATNDeserializer.toInt(data[p++]));
                for(let i = 0; i < atn.lexerActions.length; i++){
                    let actionType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    let data1 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    if (data1 === 0xFFFF) data1 = -1;
                    let data2 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    if (data2 === 0xFFFF) data2 = -1;
                    let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                    atn.lexerActions[i] = lexerAction;
                }
            } else {
                // for compatibility with older serialized ATNs, convert the old
                // serialized action index for action transitions to the new
                // form, which is the index of a LexerCustomAction
                let legacyLexerActions = [];
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $dNkDA.ActionTransition)) continue;
                    let ruleIndex = transition.ruleIndex;
                    let actionIndex = transition.actionIndex;
                    let lexerAction = new $8Nhul.LexerCustomAction(ruleIndex, actionIndex);
                    state.setTransition(i, new $dNkDA.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                    legacyLexerActions.push(lexerAction);
                }
                atn.lexerActions = legacyLexerActions;
            }
        }
        this.markPrecedenceDecisions(atn);
        atn.decisionToDFA = new Array(ndecisions);
        for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $1Cdmr.DFA(atn.decisionToState[i], i);
        if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
        if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1 /* PARSER */ ) {
            atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let bypassStart = new $exhhk.BasicBlockStartState();
                bypassStart.ruleIndex = i;
                atn.addState(bypassStart);
                let bypassStop = new $jDuoI.BlockEndState();
                bypassStop.ruleIndex = i;
                atn.addState(bypassStop);
                bypassStart.endState = bypassStop;
                atn.defineDecisionState(bypassStart);
                bypassStop.startState = bypassStart;
                let endState;
                let excludeTransition;
                if (atn.ruleToStartState[i].isPrecedenceRule) {
                    // wrap from the beginning of the rule to the StarLoopEntryState
                    endState = undefined;
                    for (let state of atn.states){
                        if (state.ruleIndex !== i) continue;
                        if (!(state instanceof $e0pjt.StarLoopEntryState)) continue;
                        let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                        if (!(maybeLoopEndState instanceof $fFNPu.LoopEndState)) continue;
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $jWsYN.RuleStopState) {
                            endState = state;
                            break;
                        }
                    }
                    if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                    excludeTransition = endState.loopBackState.transition(0);
                } else endState = atn.ruleToStopState[i];
                // all non-excluded transitions that currently target end state need to target blockEnd instead
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (transition === excludeTransition) continue;
                    if (transition.target === endState) transition.target = bypassStop;
                }
                // all transitions leaving the rule start state need to leave blockStart instead
                while(atn.ruleToStartState[i].numberOfTransitions > 0){
                    let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                    bypassStart.addTransition(transition);
                }
                // link the new states
                atn.ruleToStartState[i].addTransition(new $7Ey8M.EpsilonTransition(bypassStart));
                bypassStop.addTransition(new $7Ey8M.EpsilonTransition(endState));
                let matchState = new $3XAPg.BasicState();
                atn.addState(matchState);
                matchState.addTransition(new $kXmw5.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                bypassStart.addTransition(new $7Ey8M.EpsilonTransition(matchState));
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        if (this.deserializationOptions.isOptimize) {
            while(true){
                let optimizationCount = 0;
                optimizationCount += $125038c9196d1598$var$ATNDeserializer.inlineSetRules(atn);
                optimizationCount += $125038c9196d1598$var$ATNDeserializer.combineChainedEpsilons(atn);
                let preserveOrder = atn.grammarType === 0 /* LEXER */ ;
                optimizationCount += $125038c9196d1598$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                if (optimizationCount === 0) break;
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        $125038c9196d1598$var$ATNDeserializer.identifyTailCalls(atn);
        return atn;
    }
    deserializeSets(data, p, sets, unicodeDeserializer) {
        let nsets = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nsets; i++){
            let nintervals = $125038c9196d1598$var$ATNDeserializer.toInt(data[p]);
            p++;
            let set = new $6kdz0.IntervalSet();
            sets.push(set);
            let containsEof = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]) !== 0;
            if (containsEof) set.add(-1);
            for(let j = 0; j < nintervals; j++){
                let a = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                let b = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                set.add(a, b);
            }
        }
        return p;
    }
    /**
     * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
     * the {@link StarLoopEntryState#precedenceRuleDecision} field to the
     * correct value.
     *
     * @param atn The ATN.
     */ markPrecedenceDecisions(atn) {
        // Map rule index -> precedence decision for that rule
        let rulePrecedenceDecisions = new Map();
        for (let state of atn.states){
            if (!(state instanceof $e0pjt.StarLoopEntryState)) continue;
            /* We analyze the ATN to determine if this ATN decision state is the
             * decision for the closure block that determines whether a
             * precedence rule should continue or complete.
             */ if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                if (maybeLoopEndState instanceof $fFNPu.LoopEndState) {
                    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $jWsYN.RuleStopState) {
                        rulePrecedenceDecisions.set(state.ruleIndex, state);
                        state.precedenceRuleDecision = true;
                        state.precedenceLoopbackStates = new $8WIez.BitSet(atn.states.length);
                    }
                }
            }
        }
        // After marking precedence decisions, we go back through and fill in
        // StarLoopEntryState.precedenceLoopbackStates.
        for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
            if (transition.serializationType !== 1 /* EPSILON */ ) continue;
            let epsilonTransition = transition;
            if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
            precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
        }
    }
    verifyATN(atn) {
        // verify assumptions
        for (let state of atn.states){
            this.checkCondition(state !== undefined, "ATN states should not be undefined.");
            if (state.stateType === $fZESB.ATNStateType.INVALID_TYPE) continue;
            this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
            if (state instanceof $pC9Ki.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $e0pjt.StarLoopEntryState) {
                let starLoopEntryState = state;
                this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                if (starLoopEntryState.transition(0).target instanceof $ferBg.StarBlockStartState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $fFNPu.LoopEndState);
                    this.checkCondition(!starLoopEntryState.nonGreedy);
                } else if (starLoopEntryState.transition(0).target instanceof $fFNPu.LoopEndState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $ferBg.StarBlockStartState);
                    this.checkCondition(starLoopEntryState.nonGreedy);
                } else throw new Error("IllegalStateException");
            }
            if (state instanceof $9kZdU.StarLoopbackState) {
                this.checkCondition(state.numberOfTransitions === 1);
                this.checkCondition(state.transition(0).target instanceof $e0pjt.StarLoopEntryState);
            }
            if (state instanceof $fFNPu.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $UvARH.RuleStartState) this.checkCondition(state.stopState !== undefined);
            if (state instanceof $jizfq.BlockStartState) this.checkCondition(state.endState !== undefined);
            if (state instanceof $jDuoI.BlockEndState) this.checkCondition(state.startState !== undefined);
            if (state instanceof $42ptv.DecisionState) {
                let decisionState = state;
                this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
            } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $jWsYN.RuleStopState);
        }
    }
    checkCondition(condition, message) {
        if (!condition) throw new Error("IllegalStateException: " + message);
    }
    static inlineSetRules(atn) {
        let inlinedCalls = 0;
        let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
        for(let i = 0; i < atn.ruleToStartState.length; i++){
            let startState = atn.ruleToStartState[i];
            let middleState = startState;
            while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1 /* EPSILON */ )middleState = middleState.getOptimizedTransition(0).target;
            if (middleState.numberOfOptimizedTransitions !== 1) continue;
            let matchTransition = middleState.getOptimizedTransition(0);
            let matchTarget = matchTransition.target;
            if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $jWsYN.RuleStopState)) continue;
            switch(matchTransition.serializationType){
                case 5 /* ATOM */ :
                case 2 /* RANGE */ :
                case 7 /* SET */ :
                    ruleToInlineTransition[i] = matchTransition;
                    break;
                case 8 /* NOT_SET */ :
                case 9 /* WILDCARD */ :
                    continue;
                default:
                    continue;
            }
        }
        for (let state of atn.states){
            if (state.ruleIndex < 0) continue;
            let optimizedTransitions;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $lmhna.RuleTransition)) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                let ruleTransition = transition;
                let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                if (effective === undefined) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                }
                inlinedCalls++;
                let target = ruleTransition.followState;
                let intermediateState = new $3XAPg.BasicState();
                intermediateState.setRuleIndex(target.ruleIndex);
                atn.addState(intermediateState);
                optimizedTransitions.push(new $7Ey8M.EpsilonTransition(intermediateState));
                switch(effective.serializationType){
                    case 5 /* ATOM */ :
                        intermediateState.addTransition(new $kXmw5.AtomTransition(target, effective._label));
                        break;
                    case 2 /* RANGE */ :
                        intermediateState.addTransition(new $6WqDl.RangeTransition(target, effective.from, effective.to));
                        break;
                    case 7 /* SET */ :
                        intermediateState.addTransition(new $5EcBU.SetTransition(target, effective.label));
                        break;
                    default:
                        throw new Error("UnsupportedOperationException");
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($gzbPK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
        return inlinedCalls;
    }
    static combineChainedEpsilons(atn) {
        let removedEdges = 0;
        for (let state of atn.states){
            if (!state.onlyHasEpsilonTransitions || state instanceof $jWsYN.RuleStopState) continue;
            let optimizedTransitions;
            nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                let intermediate = transition.target;
                if (transition.serializationType !== 1 /* EPSILON */  || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $fZESB.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 /* EPSILON */  || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                removedEdges++;
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                    let target = intermediate.getOptimizedTransition(j).target;
                    optimizedTransitions.push(new $7Ey8M.EpsilonTransition(target));
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($gzbPK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
        return removedEdges;
    }
    static optimizeSets(atn, preserveOrder) {
        if (preserveOrder) // this optimization currently doesn't preserve edge order.
        return 0;
        let removedPaths = 0;
        let decisions = atn.decisionToState;
        for (let decision of decisions){
            let setTransitions = new $6kdz0.IntervalSet();
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                let epsTransition = decision.getOptimizedTransition(i);
                if (!(epsTransition instanceof $7Ey8M.EpsilonTransition)) continue;
                if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                let transition = epsTransition.target.getOptimizedTransition(0);
                if (!(transition.target instanceof $jDuoI.BlockEndState)) continue;
                if (transition instanceof $gFTdY.NotSetTransition) continue;
                if (transition instanceof $kXmw5.AtomTransition || transition instanceof $6WqDl.RangeTransition || transition instanceof $5EcBU.SetTransition) setTransitions.add(i);
            }
            if (setTransitions.size <= 1) continue;
            let optimizedTransitions = [];
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
            let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
            let matchSet = new $6kdz0.IntervalSet();
            for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                if (matchTransition instanceof $gFTdY.NotSetTransition) throw new Error("Not yet implemented.");
                else matchSet.addAll(matchTransition.label);
            }
            let newTransition;
            if (matchSet.intervals.length === 1) {
                if (matchSet.size === 1) newTransition = new $kXmw5.AtomTransition(blockEndState, matchSet.minElement);
                else {
                    let matchInterval = matchSet.intervals[0];
                    newTransition = new $6WqDl.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                }
            } else newTransition = new $5EcBU.SetTransition(blockEndState, matchSet);
            let setOptimizedState = new $3XAPg.BasicState();
            setOptimizedState.setRuleIndex(decision.ruleIndex);
            atn.addState(setOptimizedState);
            setOptimizedState.addTransition(newTransition);
            optimizedTransitions.push(new $7Ey8M.EpsilonTransition(setOptimizedState));
            removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
            if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
            for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
        }
        if ($gzbPK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
        return removedPaths;
    }
    static identifyTailCalls(atn) {
        for (let state of atn.states){
            for(let i = 0; i < state.numberOfTransitions; i++){
                let transition = state.transition(i);
                if (!(transition instanceof $lmhna.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
            if (!state.isOptimized) continue;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $lmhna.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
        }
    }
    static testTailCall(atn, transition, optimizedPath) {
        if (!optimizedPath && transition.tailCall) return true;
        if (optimizedPath && transition.optimizedTailCall) return true;
        let reachable = new $8WIez.BitSet(atn.states.length);
        let worklist = [];
        worklist.push(transition.followState);
        while(true){
            let state = worklist.pop();
            if (!state) break;
            if (reachable.get(state.stateNumber)) continue;
            if (state instanceof $jWsYN.RuleStopState) continue;
            if (!state.onlyHasEpsilonTransitions) return false;
            let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
            for(let i = 0; i < transitionCount; i++){
                let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                if (t.serializationType !== 1 /* EPSILON */ ) return false;
                worklist.push(t.target);
            }
        }
        return true;
    }
    static toInt(c) {
        return c;
    }
    static toInt32(data, offset) {
        return (data[offset] | data[offset + 1] << 16) >>> 0;
    }
    static toUUID(data, offset) {
        let leastSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset);
        let lessSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset + 2);
        let moreSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset + 4);
        let mostSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset + 6);
        return new $f0PQ3.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
        let target = atn.states[trg];
        switch(type){
            case 1 /* EPSILON */ :
                return new $7Ey8M.EpsilonTransition(target);
            case 2 /* RANGE */ :
                if (arg3 !== 0) return new $6WqDl.RangeTransition(target, $eKXi4.Token.EOF, arg2);
                else return new $6WqDl.RangeTransition(target, arg1, arg2);
            case 3 /* RULE */ :
                let rt = new $lmhna.RuleTransition(atn.states[arg1], arg2, arg3, target);
                return rt;
            case 4 /* PREDICATE */ :
                let pt = new $j3Sey.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                return pt;
            case 10 /* PRECEDENCE */ :
                return new $kIrC4.PrecedencePredicateTransition(target, arg1);
            case 5 /* ATOM */ :
                if (arg3 !== 0) return new $kXmw5.AtomTransition(target, $eKXi4.Token.EOF);
                else return new $kXmw5.AtomTransition(target, arg1);
            case 6 /* ACTION */ :
                let a = new $dNkDA.ActionTransition(target, arg1, arg2, arg3 !== 0);
                return a;
            case 7 /* SET */ :
                return new $5EcBU.SetTransition(target, sets[arg1]);
            case 8 /* NOT_SET */ :
                return new $gFTdY.NotSetTransition(target, sets[arg1]);
            case 9 /* WILDCARD */ :
                return new $69uaV.WildcardTransition(target);
        }
        throw new Error("The specified transition type is not valid.");
    }
    stateFactory(type, ruleIndex) {
        let s;
        switch(type){
            case $fZESB.ATNStateType.INVALID_TYPE:
                return new $8ii30.InvalidState();
            case $fZESB.ATNStateType.BASIC:
                s = new $3XAPg.BasicState();
                break;
            case $fZESB.ATNStateType.RULE_START:
                s = new $UvARH.RuleStartState();
                break;
            case $fZESB.ATNStateType.BLOCK_START:
                s = new $exhhk.BasicBlockStartState();
                break;
            case $fZESB.ATNStateType.PLUS_BLOCK_START:
                s = new $pC9Ki.PlusBlockStartState();
                break;
            case $fZESB.ATNStateType.STAR_BLOCK_START:
                s = new $ferBg.StarBlockStartState();
                break;
            case $fZESB.ATNStateType.TOKEN_START:
                s = new $J9RdB.TokensStartState();
                break;
            case $fZESB.ATNStateType.RULE_STOP:
                s = new $jWsYN.RuleStopState();
                break;
            case $fZESB.ATNStateType.BLOCK_END:
                s = new $jDuoI.BlockEndState();
                break;
            case $fZESB.ATNStateType.STAR_LOOP_BACK:
                s = new $9kZdU.StarLoopbackState();
                break;
            case $fZESB.ATNStateType.STAR_LOOP_ENTRY:
                s = new $e0pjt.StarLoopEntryState();
                break;
            case $fZESB.ATNStateType.PLUS_LOOP_BACK:
                s = new $a84wo.PlusLoopbackState();
                break;
            case $fZESB.ATNStateType.LOOP_END:
                s = new $fFNPu.LoopEndState();
                break;
            default:
                let message = `The specified state type ${type} is not valid.`;
                throw new Error(message);
        }
        s.ruleIndex = ruleIndex;
        return s;
    }
    lexerActionFactory(type, data1, data2) {
        switch(type){
            case 0 /* CHANNEL */ :
                return new $96Can.LexerChannelAction(data1);
            case 1 /* CUSTOM */ :
                return new $8Nhul.LexerCustomAction(data1, data2);
            case 2 /* MODE */ :
                return new $Sqz9e.LexerModeAction(data1);
            case 3 /* MORE */ :
                return $a52hA.LexerMoreAction.INSTANCE;
            case 4 /* POP_MODE */ :
                return $etfit.LexerPopModeAction.INSTANCE;
            case 5 /* PUSH_MODE */ :
                return new $en1aY.LexerPushModeAction(data1);
            case 6 /* SKIP */ :
                return $jH58C.LexerSkipAction.INSTANCE;
            case 7 /* TYPE */ :
                return new $345c1.LexerTypeAction(data1);
            default:
                let message = `The specified lexer action type ${type} is not valid.`;
                throw new Error(message);
        }
    }
}
/* WARNING: DO NOT MERGE THESE LINES. If UUIDs differ during a merge,
 * resolve the conflict by generating a new ID!
 */ /**
 * This is the earliest supported serialized UUID.
 */ $125038c9196d1598$var$ATNDeserializer.BASE_SERIALIZED_UUID = $f0PQ3.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
/**
 * This UUID indicates an extension of {@link #ADDED_PRECEDENCE_TRANSITIONS}
 * for the addition of lexer actions encoded as a sequence of
 * {@link LexerAction} instances.
 */ $125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $f0PQ3.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
/**
 * This UUID indicates the serialized ATN contains two sets of
 * IntervalSets, where the second set's values are encoded as
 * 32-bit integers to support the full Unicode SMP range up to U+10FFFF.
 */ $125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP = $f0PQ3.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
/**
 * This list contains all of the currently supported UUIDs, ordered by when
 * the feature first appeared in this branch.
 */ $125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS = [
    $125038c9196d1598$var$ATNDeserializer.BASE_SERIALIZED_UUID,
    $125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
    $125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP
];
/**
 * This is the current serialized UUID.
 */ $125038c9196d1598$var$ATNDeserializer.SERIALIZED_UUID = $125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP;
$125038c9196d1598$var$__decorate([
    $aN41m.NotNull
], $125038c9196d1598$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
$125038c9196d1598$var$__decorate([
    $125038c9196d1598$var$__param(0, $aN41m.NotNull)
], $125038c9196d1598$var$ATNDeserializer.prototype, "deserialize", null);
$125038c9196d1598$var$__decorate([
    $125038c9196d1598$var$__param(0, $aN41m.NotNull)
], $125038c9196d1598$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
$125038c9196d1598$var$__decorate([
    $aN41m.NotNull,
    $125038c9196d1598$var$__param(0, $aN41m.NotNull)
], $125038c9196d1598$var$ATNDeserializer.prototype, "edgeFactory", null);
module.exports.ATNDeserializer = $125038c9196d1598$var$ATNDeserializer;

});
parcelRegister("dNkDA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a0afdc24220f1b76$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a0afdc24220f1b76$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $a0afdc24220f1b76$var$ActionTransition = class ActionTransition extends $5NWCj.Transition {
    constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
        super(target);
        this.ruleIndex = ruleIndex;
        this.actionIndex = actionIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 6 /* ACTION */ ;
    }
    get isEpsilon() {
        return true; // we are to be ignored by analysis 'cept for predicates
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "action_" + this.ruleIndex + ":" + this.actionIndex;
    }
};
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "serializationType", null);
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "isEpsilon", null);
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "matches", null);
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "toString", null);
$a0afdc24220f1b76$var$ActionTransition = $a0afdc24220f1b76$var$__decorate([
    $a0afdc24220f1b76$var$__param(0, $aN41m.NotNull)
], $a0afdc24220f1b76$var$ActionTransition);
module.exports.ActionTransition = $a0afdc24220f1b76$var$ActionTransition;

});

parcelRegister("kXmw5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f41ac8aa56432c28$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f41ac8aa56432c28$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtomTransition = void 0;

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
/** TODO: make all transitions sets? no, should remove set edges */ let $f41ac8aa56432c28$var$AtomTransition = class AtomTransition extends $5NWCj.Transition {
    constructor(target, label){
        super(target);
        this._label = label;
    }
    get serializationType() {
        return 5 /* ATOM */ ;
    }
    get label() {
        return $6kdz0.IntervalSet.of(this._label);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this._label === symbol;
    }
    toString() {
        return String(this.label);
    }
};
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override
], $f41ac8aa56432c28$var$AtomTransition.prototype, "serializationType", null);
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $f41ac8aa56432c28$var$AtomTransition.prototype, "label", null);
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override
], $f41ac8aa56432c28$var$AtomTransition.prototype, "matches", null);
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $f41ac8aa56432c28$var$AtomTransition.prototype, "toString", null);
$f41ac8aa56432c28$var$AtomTransition = $f41ac8aa56432c28$var$__decorate([
    $f41ac8aa56432c28$var$__param(0, $aN41m.NotNull)
], $f41ac8aa56432c28$var$AtomTransition);
module.exports.AtomTransition = $f41ac8aa56432c28$var$AtomTransition;

});

parcelRegister("exhhk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a9518ce3013a5e52$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicBlockStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $jizfq = parcelRequire("jizfq");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $a9518ce3013a5e52$var$BasicBlockStartState extends $jizfq.BlockStartState {
    get stateType() {
        return $fZESB.ATNStateType.BLOCK_START;
    }
}
$a9518ce3013a5e52$var$__decorate([
    $aN41m.Override
], $a9518ce3013a5e52$var$BasicBlockStartState.prototype, "stateType", null);
module.exports.BasicBlockStartState = $a9518ce3013a5e52$var$BasicBlockStartState;

});
parcelRegister("jizfq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStartState = void 0;

var $42ptv = parcelRequire("42ptv");
/**  The start of a regular `(...)` block. */ class $e0cb0a3899ef814e$var$BlockStartState extends $42ptv.DecisionState {
}
module.exports.BlockStartState = $e0cb0a3899ef814e$var$BlockStartState;

});


parcelRegister("jDuoI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e4b93d2d29e74e89$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockEndState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/** Terminal node of a simple `(a|b|c)` block. */ class $e4b93d2d29e74e89$var$BlockEndState extends $dv9vN.ATNState {
    get stateType() {
        return $fZESB.ATNStateType.BLOCK_END;
    }
}
$e4b93d2d29e74e89$var$__decorate([
    $aN41m.Override
], $e4b93d2d29e74e89$var$BlockEndState.prototype, "stateType", null);
module.exports.BlockEndState = $e4b93d2d29e74e89$var$BlockEndState;

});

parcelRegister("7Ey8M", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $5926c077d80a870b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5926c077d80a870b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpsilonTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $5926c077d80a870b$var$EpsilonTransition = class EpsilonTransition extends $5NWCj.Transition {
    constructor(target, outermostPrecedenceReturn = -1){
        super(target);
        this._outermostPrecedenceReturn = outermostPrecedenceReturn;
    }
    /**
     * @returns the rule index of a precedence rule for which this transition is
     * returning from, where the precedence value is 0; otherwise, -1.
     *
     * @see ATNConfig.isPrecedenceFilterSuppressed
     * @see ParserATNSimulator#applyPrecedenceFilter(ATNConfigSet, ParserRuleContext, PredictionContextCache)
     * @since 4.4.1
     */ get outermostPrecedenceReturn() {
        return this._outermostPrecedenceReturn;
    }
    get serializationType() {
        return 1 /* EPSILON */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "epsilon";
    }
};
$5926c077d80a870b$var$__decorate([
    $aN41m.Override
], $5926c077d80a870b$var$EpsilonTransition.prototype, "serializationType", null);
$5926c077d80a870b$var$__decorate([
    $aN41m.Override
], $5926c077d80a870b$var$EpsilonTransition.prototype, "isEpsilon", null);
$5926c077d80a870b$var$__decorate([
    $aN41m.Override
], $5926c077d80a870b$var$EpsilonTransition.prototype, "matches", null);
$5926c077d80a870b$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $5926c077d80a870b$var$EpsilonTransition.prototype, "toString", null);
$5926c077d80a870b$var$EpsilonTransition = $5926c077d80a870b$var$__decorate([
    $5926c077d80a870b$var$__param(0, $aN41m.NotNull)
], $5926c077d80a870b$var$EpsilonTransition);
module.exports.EpsilonTransition = $5926c077d80a870b$var$EpsilonTransition;

});

parcelRegister("96Can", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6a1247a4f2c7624c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6a1247a4f2c7624c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerChannelAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `channel` lexer action by calling
 * {@link Lexer#setChannel} with the assigned channel.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $6a1247a4f2c7624c$var$LexerChannelAction {
    /**
     * Constructs a new `channel` action with the specified channel value.
     * @param channel The channel value to pass to {@link Lexer#setChannel}.
     */ constructor(channel){
        this._channel = channel;
    }
    /**
     * Gets the channel to use for the {@link Token} created by the lexer.
     *
     * @returns The channel to use for the {@link Token} created by the lexer.
     */ get channel() {
        return this._channel;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#CHANNEL}.
     */ get actionType() {
        return 0 /* CHANNEL */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#setChannel} with the
     * value provided by {@link #getChannel}.
     */ execute(lexer) {
        lexer.channel = this._channel;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._channel);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $6a1247a4f2c7624c$var$LexerChannelAction)) return false;
        return this._channel === obj._channel;
    }
    toString() {
        return `channel(${this._channel})`;
    }
}
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "actionType", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "isPositionDependent", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override,
    $6a1247a4f2c7624c$var$__param(0, $aN41m.NotNull)
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "execute", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "hashCode", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "equals", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "toString", null);
module.exports.LexerChannelAction = $6a1247a4f2c7624c$var$LexerChannelAction;

});

parcelRegister("8Nhul", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $66707726ebb084aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $66707726ebb084aa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerCustomAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Executes a custom lexer action by calling {@link Recognizer#action} with the
 * rule and action indexes assigned to the custom action. The implementation of
 * a custom action is added to the generated code for the lexer in an override
 * of {@link Recognizer#action} when the grammar is compiled.
 *
 * This class may represent embedded actions created with the `{...}`
 * syntax in ANTLR 4, as well as actions created for lexer commands where the
 * command argument could not be evaluated when the grammar was compiled.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $66707726ebb084aa$var$LexerCustomAction {
    /**
     * Constructs a custom lexer action with the specified rule and action
     * indexes.
     *
     * @param ruleIndex The rule index to use for calls to
     * {@link Recognizer#action}.
     * @param actionIndex The action index to use for calls to
     * {@link Recognizer#action}.
     */ constructor(ruleIndex, actionIndex){
        this._ruleIndex = ruleIndex;
        this._actionIndex = actionIndex;
    }
    /**
     * Gets the rule index to use for calls to {@link Recognizer#action}.
     *
     * @returns The rule index for the custom action.
     */ get ruleIndex() {
        return this._ruleIndex;
    }
    /**
     * Gets the action index to use for calls to {@link Recognizer#action}.
     *
     * @returns The action index for the custom action.
     */ get actionIndex() {
        return this._actionIndex;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns {@link LexerActionType#CUSTOM}.
     */ get actionType() {
        return 1 /* CUSTOM */ ;
    }
    /**
     * Gets whether the lexer action is position-dependent. Position-dependent
     * actions may have different semantics depending on the {@link CharStream}
     * index at the time the action is executed.
     *
     * Custom actions are position-dependent since they may represent a
     * user-defined embedded action which makes calls to methods like
     * {@link Lexer#getText}.
     *
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * Custom actions are implemented by calling {@link Lexer#action} with the
     * appropriate rule and action indexes.
     */ execute(lexer) {
        lexer.action(undefined, this._ruleIndex, this._actionIndex);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._ruleIndex);
        hash = $amQx9.MurmurHash.update(hash, this._actionIndex);
        return $amQx9.MurmurHash.finish(hash, 3);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $66707726ebb084aa$var$LexerCustomAction)) return false;
        return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
    }
}
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "actionType", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "isPositionDependent", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override,
    $66707726ebb084aa$var$__param(0, $aN41m.NotNull)
], $66707726ebb084aa$var$LexerCustomAction.prototype, "execute", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "hashCode", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "equals", null);
module.exports.LexerCustomAction = $66707726ebb084aa$var$LexerCustomAction;

});

parcelRegister("Sqz9e", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0a39a6b1f9fd5776$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0a39a6b1f9fd5776$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerModeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `mode` lexer action by calling {@link Lexer#mode} with
 * the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $0a39a6b1f9fd5776$var$LexerModeAction {
    /**
     * Constructs a new `mode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#mode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `mode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MODE}.
     */ get actionType() {
        return 2 /* MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#mode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.mode(this._mode);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._mode);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $0a39a6b1f9fd5776$var$LexerModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `mode(${this._mode})`;
    }
}
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "actionType", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "isPositionDependent", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override,
    $0a39a6b1f9fd5776$var$__param(0, $aN41m.NotNull)
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "execute", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "hashCode", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "equals", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "toString", null);
module.exports.LexerModeAction = $0a39a6b1f9fd5776$var$LexerModeAction;

});

parcelRegister("a52hA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $756c244b6a2751b3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $756c244b6a2751b3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerMoreAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `more` lexer action by calling {@link Lexer#more}.
 *
 * The `more` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $756c244b6a2751b3$var$LexerMoreAction {
    /**
     * Constructs the singleton instance of the lexer `more` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MORE}.
     */ get actionType() {
        return 3 /* MORE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#more}.
     */ execute(lexer) {
        lexer.more();
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        return $amQx9.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "more";
    }
}
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "actionType", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "isPositionDependent", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override,
    $756c244b6a2751b3$var$__param(0, $aN41m.NotNull)
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "execute", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "hashCode", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "equals", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "toString", null);
module.exports.LexerMoreAction = $756c244b6a2751b3$var$LexerMoreAction;
(function(LexerMoreAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerMoreAction.INSTANCE = new LexerMoreAction();
})($756c244b6a2751b3$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));

});

parcelRegister("etfit", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a88fa3c89bb51f5a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a88fa3c89bb51f5a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPopModeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `popMode` lexer action by calling {@link Lexer#popMode}.
 *
 * The `popMode` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $a88fa3c89bb51f5a$var$LexerPopModeAction {
    /**
     * Constructs the singleton instance of the lexer `popMode` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#POP_MODE}.
     */ get actionType() {
        return 4 /* POP_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#popMode}.
     */ execute(lexer) {
        lexer.popMode();
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        return $amQx9.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "popMode";
    }
}
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "actionType", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "isPositionDependent", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override,
    $a88fa3c89bb51f5a$var$__param(0, $aN41m.NotNull)
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "execute", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "hashCode", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "equals", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "toString", null);
module.exports.LexerPopModeAction = $a88fa3c89bb51f5a$var$LexerPopModeAction;
(function(LexerPopModeAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerPopModeAction.INSTANCE = new LexerPopModeAction();
})($a88fa3c89bb51f5a$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));

});

parcelRegister("en1aY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a764202e107f6da8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a764202e107f6da8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPushModeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `pushMode` lexer action by calling
 * {@link Lexer#pushMode} with the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $a764202e107f6da8$var$LexerPushModeAction {
    /**
     * Constructs a new `pushMode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#pushMode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `pushMode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#PUSH_MODE}.
     */ get actionType() {
        return 5 /* PUSH_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#pushMode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.pushMode(this._mode);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._mode);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $a764202e107f6da8$var$LexerPushModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `pushMode(${this._mode})`;
    }
}
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "actionType", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "isPositionDependent", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override,
    $a764202e107f6da8$var$__param(0, $aN41m.NotNull)
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "execute", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "hashCode", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "equals", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "toString", null);
module.exports.LexerPushModeAction = $a764202e107f6da8$var$LexerPushModeAction;

});

parcelRegister("jH58C", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e56604c1d2a640c8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e56604c1d2a640c8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerSkipAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `skip` lexer action by calling {@link Lexer#skip}.
 *
 * The `skip` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $e56604c1d2a640c8$var$LexerSkipAction {
    /**
     * Constructs the singleton instance of the lexer `skip` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#SKIP}.
     */ get actionType() {
        return 6 /* SKIP */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#skip}.
     */ execute(lexer) {
        lexer.skip();
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        return $amQx9.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "skip";
    }
}
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "actionType", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "isPositionDependent", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override,
    $e56604c1d2a640c8$var$__param(0, $aN41m.NotNull)
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "execute", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "hashCode", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "equals", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "toString", null);
module.exports.LexerSkipAction = $e56604c1d2a640c8$var$LexerSkipAction;
(function(LexerSkipAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerSkipAction.INSTANCE = new LexerSkipAction();
})($e56604c1d2a640c8$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));

});

parcelRegister("345c1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $23b5c605e8108d72$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $23b5c605e8108d72$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerTypeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `type` lexer action by setting `Lexer.type`
 * with the assigned type.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $23b5c605e8108d72$var$LexerTypeAction {
    /**
     * Constructs a new `type` action with the specified token type value.
     * @param type The type to assign to the token using `Lexer.type`.
     */ constructor(type){
        this._type = type;
    }
    /**
     * Gets the type to assign to a token created by the lexer.
     * @returns The type to assign to a token created by the lexer.
     */ get type() {
        return this._type;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#TYPE}.
     */ get actionType() {
        return 7 /* TYPE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by setting `Lexer.type` with the
     * value provided by `type`.
     */ execute(lexer) {
        lexer.type = this._type;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._type);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $23b5c605e8108d72$var$LexerTypeAction)) return false;
        return this._type === obj._type;
    }
    toString() {
        return `type(${this._type})`;
    }
}
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "actionType", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "isPositionDependent", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override,
    $23b5c605e8108d72$var$__param(0, $aN41m.NotNull)
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "execute", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "hashCode", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "equals", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "toString", null);
module.exports.LexerTypeAction = $23b5c605e8108d72$var$LexerTypeAction;

});

parcelRegister("fFNPu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b6915673a04edde3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoopEndState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/** Mark the end of a * or + loop. */ class $b6915673a04edde3$var$LoopEndState extends $dv9vN.ATNState {
    get stateType() {
        return $fZESB.ATNStateType.LOOP_END;
    }
}
$b6915673a04edde3$var$__decorate([
    $aN41m.Override
], $b6915673a04edde3$var$LoopEndState.prototype, "stateType", null);
module.exports.LoopEndState = $b6915673a04edde3$var$LoopEndState;

});

parcelRegister("gzbPK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c0f91822940cc2ea$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c0f91822940cc2ea$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserATNSimulator = void 0;

var $hu8W9 = parcelRequire("hu8W9");

var $dNkDA = parcelRequire("dNkDA");

var $fsqYw = parcelRequire("fsqYw");

var $4dKou = parcelRequire("4dKou");

var $eeOLb = parcelRequire("eeOLb");

var $hdFz0 = parcelRequire("hdFz0");

var $2SGHL = parcelRequire("2SGHL");

var $ceQRA = parcelRequire("ceQRA");

var $fZESB = parcelRequire("fZESB");

var $kXmw5 = parcelRequire("kXmw5");

var $8WIez = parcelRequire("8WIez");

var $bPdk6 = parcelRequire("bPdk6");

var $42ptv = parcelRequire("42ptv");

var $6P9ap = parcelRequire("6P9ap");

var $eRSlM = parcelRequire("eRSlM");

var $l8y5T = parcelRequire("l8y5T");

var $ldi9e = parcelRequire("ldi9e");

var $aN41m = parcelRequire("aN41m");

var $gFTdY = parcelRequire("gFTdY");

var $iAlWg = parcelRequire("iAlWg");

var $9eW9B = parcelRequire("9eW9B");

var $2pDMz = parcelRequire("2pDMz");

var $jaUCz = parcelRequire("jaUCz");

var $4BvNW = parcelRequire("4BvNW");

var $hwoBE = parcelRequire("hwoBE");

var $jWsYN = parcelRequire("jWsYN");

var $lmhna = parcelRequire("lmhna");

var $3JS45 = parcelRequire("3JS45");

var $5EcBU = parcelRequire("5EcBU");

var $eDtKk = parcelRequire("eDtKk");

var $eKXi4 = parcelRequire("eKXi4");

var $hBnE1 = parcelRequire("hBnE1");

var $fomfP = parcelRequire("fomfP");
const $c0f91822940cc2ea$var$MAX_SHORT_VALUE = 0xFFFF;
const $c0f91822940cc2ea$var$MIN_INTEGER_VALUE = -2147483648;
/**
 * The embodiment of the adaptive LL(*), ALL(*), parsing strategy.
 *
 * The basic complexity of the adaptive strategy makes it harder to understand.
 * We begin with ATN simulation to build paths in a DFA. Subsequent prediction
 * requests go through the DFA first. If they reach a state without an edge for
 * the current symbol, the algorithm fails over to the ATN simulation to
 * complete the DFA path for the current input (until it finds a conflict state
 * or uniquely predicting state).
 *
 * All of that is done without using the outer context because we want to create
 * a DFA that is not dependent upon the rule invocation stack when we do a
 * prediction. One DFA works in all contexts. We avoid using context not
 * necessarily because it's slower, although it can be, but because of the DFA
 * caching problem. The closure routine only considers the rule invocation stack
 * created during prediction beginning in the decision rule. For example, if
 * prediction occurs without invoking another rule's ATN, there are no context
 * stacks in the configurations. When lack of context leads to a conflict, we
 * don't know if it's an ambiguity or a weakness in the strong LL(*) parsing
 * strategy (versus full LL(*)).
 *
 * When SLL yields a configuration set with conflict, we rewind the input and
 * retry the ATN simulation, this time using full outer context without adding
 * to the DFA. Configuration context stacks will be the full invocation stacks
 * from the start rule. If we get a conflict using full context, then we can
 * definitively say we have a true ambiguity for that input sequence. If we
 * don't get a conflict, it implies that the decision is sensitive to the outer
 * context. (It is not context-sensitive in the sense of context-sensitive
 * grammars.)
 *
 * The next time we reach this DFA state with an SLL conflict, through DFA
 * simulation, we will again retry the ATN simulation using full context mode.
 * This is slow because we can't save the results and have to "interpret" the
 * ATN each time we get that input.
 *
 * **CACHING FULL CONTEXT PREDICTIONS**
 *
 * We could cache results from full context to predicted alternative easily and
 * that saves a lot of time but doesn't work in presence of predicates. The set
 * of visible predicates from the ATN start state changes depending on the
 * context, because closure can fall off the end of a rule. I tried to cache
 * tuples (stack context, semantic context, predicted alt) but it was slower
 * than interpreting and much more complicated. Also required a huge amount of
 * memory. The goal is not to create the world's fastest parser anyway. I'd like
 * to keep this algorithm simple. By launching multiple threads, we can improve
 * the speed of parsing across a large number of files.
 *
 * There is no strict ordering between the amount of input used by SLL vs LL,
 * which makes it really hard to build a cache for full context. Let's say that
 * we have input A B C that leads to an SLL conflict with full context X. That
 * implies that using X we might only use A B but we could also use A B C D to
 * resolve conflict. Input A B C D could predict alternative 1 in one position
 * in the input and A B C E could predict alternative 2 in another position in
 * input. The conflicting SLL configurations could still be non-unique in the
 * full context prediction, which would lead us to requiring more input than the
 * original A B C.	To make a	prediction cache work, we have to track	the exact
 * input	used during the previous prediction. That amounts to a cache that maps
 * X to a specific DFA for that context.
 *
 * Something should be done for left-recursive expression predictions. They are
 * likely LL(1) + pred eval. Easier to do the whole SLL unless error and retry
 * with full LL thing Sam does.
 *
 * **AVOIDING FULL CONTEXT PREDICTION**
 *
 * We avoid doing full context retry when the outer context is empty, we did not
 * dip into the outer context by falling off the end of the decision state rule,
 * or when we force SLL mode.
 *
 * As an example of the not dip into outer context case, consider as super
 * constructor calls versus function calls. One grammar might look like
 * this:
 *
 * ```antlr
 * ctorBody
 *   : '{' superCall? stat* '}'
 *   ;
 * ```
 *
 * Or, you might see something like
 *
 * ```antlr
 * stat
 *   : superCall ';'
 *   | expression ';'
 *   | ...
 *   ;
 * ```
 *
 * In both cases I believe that no closure operations will dip into the outer
 * context. In the first case ctorBody in the worst case will stop at the '}'.
 * In the 2nd case it should stop at the ';'. Both cases should stay within the
 * entry rule and not dip into the outer context.
 *
 * **PREDICATES**
 *
 * Predicates are always evaluated if present in either SLL or LL both. SLL and
 * LL simulation deals with predicates differently. SLL collects predicates as
 * it performs closure operations like ANTLR v3 did. It delays predicate
 * evaluation until it reaches and accept state. This allows us to cache the SLL
 * ATN simulation whereas, if we had evaluated predicates on-the-fly during
 * closure, the DFA state configuration sets would be different and we couldn't
 * build up a suitable DFA.
 *
 * When building a DFA accept state during ATN simulation, we evaluate any
 * predicates and return the sole semantically valid alternative. If there is
 * more than 1 alternative, we report an ambiguity. If there are 0 alternatives,
 * we throw an exception. Alternatives without predicates act like they have
 * true predicates. The simple way to think about it is to strip away all
 * alternatives with false predicates and choose the minimum alternative that
 * remains.
 *
 * When we start in the DFA and reach an accept state that's predicated, we test
 * those and return the minimum semantically viable alternative. If no
 * alternatives are viable, we throw an exception.
 *
 * During full LL ATN simulation, closure always evaluates predicates and
 * on-the-fly. This is crucial to reducing the configuration set size during
 * closure. It hits a landmine when parsing with the Java grammar, for example,
 * without this on-the-fly evaluation.
 *
 * **SHARING DFA**
 *
 * All instances of the same parser share the same decision DFAs through a
 * static field. Each instance gets its own ATN simulator but they share the
 * same {@link ATN#decisionToDFA} field. They also share a
 * {@link PredictionContextCache} object that makes sure that all
 * {@link PredictionContext} objects are shared among the DFA states. This makes
 * a big size difference.
 *
 * **THREAD SAFETY**
 *
 * The {@link ParserATNSimulator} locks on the {@link ATN#decisionToDFA} field when
 * it adds a new DFA object to that array. {@link #addDFAEdge}
 * locks on the DFA for the current decision when setting the
 * {@link DFAState#edges} field. {@link #addDFAState} locks on
 * the DFA for the current decision when looking up a DFA state to see if it
 * already exists. We must make sure that all requests to add DFA states that
 * are equivalent result in the same shared DFA object. This is because lots of
 * threads will be trying to update the DFA at once. The
 * {@link #addDFAState} method also locks inside the DFA lock
 * but this time on the shared context cache when it rebuilds the
 * configurations' {@link PredictionContext} objects using cached
 * subgraphs/nodes. No other locking occurs, even during DFA simulation. This is
 * safe as long as we can guarantee that all threads referencing
 * `s.edge[t]` get the same physical target {@link DFAState}, or
 * `undefined`. Once into the DFA, the DFA simulation does not reference the
 * {@link DFA#states} map. It follows the {@link DFAState#edges} field to new
 * targets. The DFA simulator will either find {@link DFAState#edges} to be
 * `undefined`, to be non-`undefined` and `dfa.edges[t]` undefined, or
 * `dfa.edges[t]` to be non-undefined. The
 * {@link #addDFAEdge} method could be racing to set the field
 * but in either case the DFA simulator works; if `undefined`, and requests ATN
 * simulation. It could also race trying to get `dfa.edges[t]`, but either
 * way it will work because it's not doing a test and set operation.
 *
 * **Starting with SLL then failing to combined SLL/LL (Two-Stage
 * Parsing)**
 *
 * Sam pointed out that if SLL does not give a syntax error, then there is no
 * point in doing full LL, which is slower. We only have to try LL if we get a
 * syntax error. For maximum speed, Sam starts the parser set to pure SLL
 * mode with the {@link BailErrorStrategy}:
 *
 * ```
 * parser.interpreter.{@link #setPredictionMode setPredictionMode}`(`{@link PredictionMode#SLL}`)`;
 * parser.{@link Parser#setErrorHandler setErrorHandler}(new {@link BailErrorStrategy}());
 * ```
 *
 * If it does not get a syntax error, then we're done. If it does get a syntax
 * error, we need to retry with the combined SLL/LL strategy.
 *
 * The reason this works is as follows. If there are no SLL conflicts, then the
 * grammar is SLL (at least for that input set). If there is an SLL conflict,
 * the full LL analysis must yield a set of viable alternatives which is a
 * subset of the alternatives reported by SLL. If the LL set is a singleton,
 * then the grammar is LL but not SLL. If the LL set is the same size as the SLL
 * set, the decision is SLL. If the LL set has size &gt; 1, then that decision
 * is truly ambiguous on the current input. If the LL set is smaller, then the
 * SLL conflict resolution might choose an alternative that the full LL would
 * rule out as a possibility based upon better context information. If that's
 * the case, then the SLL parse will definitely get an error because the full LL
 * analysis says it's not viable. If SLL conflict resolution chooses an
 * alternative within the LL set, them both SLL and LL would choose the same
 * alternative because they both choose the minimum of multiple conflicting
 * alternatives.
 *
 * Let's say we have a set of SLL conflicting alternatives `{1, 2, 3}` and
 * a smaller LL set called *s*. If *s* is `{2, 3}`, then SLL
 * parsing will get an error because SLL will pursue alternative 1. If
 * *s* is `{1, 2}` or `{1, 3}` then both SLL and LL will
 * choose the same alternative because alternative one is the minimum of either
 * set. If *s* is `{2}` or `{3}` then SLL will get a syntax
 * error. If *s* is `{1}` then SLL will succeed.
 *
 * Of course, if the input is invalid, then we will get an error for sure in
 * both SLL and LL parsing. Erroneous input will therefore require 2 passes over
 * the input.
 */ let $c0f91822940cc2ea$var$ParserATNSimulator = class ParserATNSimulator extends $ceQRA.ATNSimulator {
    constructor(atn, parser){
        super(atn);
        this.predictionMode = $hwoBE.PredictionMode.LL;
        this.force_global_context = false;
        this.always_try_local_context = true;
        /**
         * Determines whether the DFA is used for full-context predictions. When
         * `true`, the DFA stores transition information for both full-context
         * and SLL parsing; otherwise, the DFA only stores SLL transition
         * information.
         *
         * For some grammars, enabling the full-context DFA can result in a
         * substantial performance improvement. However, this improvement typically
         * comes at the expense of memory used for storing the cached DFA states,
         * configuration sets, and prediction contexts.
         *
         * The default value is `false`.
         */ this.enable_global_context_dfa = false;
        this.optimize_unique_closure = true;
        this.optimize_ll1 = true;
        this.optimize_tail_calls = true;
        this.tail_call_preserves_sll = true;
        this.treat_sllk1_conflict_as_ambiguity = false;
        /**
         * When `true`, ambiguous alternatives are reported when they are
         * encountered within {@link #execATN}. When `false`, these messages
         * are suppressed. The default is `false`.
         *
         * When messages about ambiguous alternatives are not required, setting this
         * to `false` enables additional internal optimizations which may lose
         * this information.
         */ this.reportAmbiguities = false;
        /** By default we do full context-sensitive LL(*) parsing not
         *  Strong LL(*) parsing. If we fail with Strong LL(*) we
         *  try full LL(*). That means we rewind and use context information
         *  when closure operations fall off the end of the rule that
         *  holds the decision were evaluating.
         */ this.userWantsCtxSensitive = true;
        this._parser = parser;
    }
    getPredictionMode() {
        return this.predictionMode;
    }
    setPredictionMode(predictionMode) {
        this.predictionMode = predictionMode;
    }
    reset() {
    // intentionally empty
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext === undefined) useContext = false;
        let dfa = this.atn.decisionToDFA[decision];
        $fomfP(dfa != null);
        if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
            let ll_1 = input.LA(1);
            if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                let key = (decision << 16 >>> 0) + ll_1;
                let alt = this.atn.LL1Table.get(key);
                if (alt != null) return alt;
            }
        }
        this.dfa = dfa;
        if (this.force_global_context) useContext = true;
        else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
        this.userWantsCtxSensitive = useContext || this.predictionMode !== $hwoBE.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
        if (outerContext == null) outerContext = $2pDMz.ParserRuleContext.emptyContext();
        let state;
        if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
        if (state == null) {
            if (outerContext == null) outerContext = $2pDMz.ParserRuleContext.emptyContext();
            if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            state = this.computeStartState(dfa, outerContext, useContext);
        }
        let m = input.mark();
        let index = input.index;
        try {
            let alt = this.execDFA(dfa, input, index, state);
            if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            return alt;
        } finally{
            this.dfa = undefined;
            input.seek(index);
            input.release(m);
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        if (!useContext) {
            if (dfa.isPrecedenceDfa) {
                // the start state for a precedence DFA depends on the current
                // parser precedence, and is provided by a DFA method.
                let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                if (state == null) return undefined;
                return new $eDtKk.SimulatorState(outerContext, state, false, outerContext);
            } else {
                if (dfa.s0 == null) return undefined;
                return new $eDtKk.SimulatorState(outerContext, dfa.s0, false, outerContext);
            }
        }
        if (!this.enable_global_context_dfa) return undefined;
        let remainingContext = outerContext;
        $fomfP(outerContext != null);
        let s0;
        if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
        else s0 = dfa.s0full;
        while(remainingContext != null && s0 != null && s0.isContextSensitive){
            remainingContext = this.skipTailCalls(remainingContext);
            s0 = s0.getContextTarget(this.getReturnState(remainingContext));
            if (remainingContext.isEmpty) $fomfP(s0 == null || !s0.isContextSensitive);
            else remainingContext = remainingContext.parent;
        }
        if (s0 == null) return undefined;
        return new $eDtKk.SimulatorState(outerContext, s0, useContext, remainingContext);
    }
    execDFA(dfa, input, startIndex, state) {
        let outerContext = state.outerContext;
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
        if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
        let s = state.s0;
        let t = input.LA(1);
        let remainingOuterContext = state.remainingOuterContext;
        while(true){
            if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
            if (state.useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingOuterContext != null) {
                    remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                    next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                }
                if (next == null) {
                    // fail over to ATN
                    let initialState = new $eDtKk.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                    return this.execATN(dfa, input, startIndex, initialState);
                }
                $fomfP(remainingOuterContext != null);
                remainingOuterContext = remainingOuterContext.parent;
                s = next;
            }
            if (this.isAcceptState(s, state.useContext)) {
                if (s.predicates != null) {
                    if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                break;
            }
            // t is not updated if one of these states is reached
            $fomfP(!this.isAcceptState(s, state.useContext));
            // if no edge, pop over to ATN interpreter, update DFA and return
            let target = this.getExistingTargetState(s, t);
            if (target == null) {
                if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                let alt;
                if (ParserATNSimulator.dfa_debug) {
                    let interval = $l8y5T.Interval.of(startIndex, this._parser.inputStream.index);
                    console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                }
                let initialState = new $eDtKk.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                alt = this.execATN(dfa, input, startIndex, initialState);
                if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                // action already executed
                if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                return alt; // we've updated DFA, exec'd action, and have our deepest answer
            } else if (target === $ceQRA.ATNSimulator.ERROR) {
                let errorState = new $eDtKk.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                return this.handleNoViableAlt(input, startIndex, errorState);
            }
            s = target;
            if (!this.isAcceptState(s, state.useContext) && t !== $ldi9e.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
        //		if ( acceptState==null ) {
        //			if ( debug ) System.out.println("!!! no viable alt in dfa");
        //			return -1;
        //		}
        if (!state.useContext && s.configs.conflictInfo != null) {
            if (dfa.atnStartState instanceof $42ptv.DecisionState) {
                if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                else {
                    $fomfP(!state.useContext);
                    // Before attempting full context prediction, check to see if there are
                    // disambiguating or validating predicates to evaluate which allow an
                    // immediate decision
                    let conflictingAlts;
                    let predicates = s.predicates;
                    if (predicates != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                        if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                    if (this.reportAmbiguities) {
                        let conflictState = new $eDtKk.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                        this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                    }
                    input.seek(startIndex);
                    return this.adaptivePredict(input, dfa.decision, outerContext, true);
                }
            }
        }
        // Before jumping to prediction, check to see if there are
        // disambiguating or validating predicates to evaluate
        let predicates = s.predicates;
        if (predicates != null) {
            let stopIndex = input.index;
            if (startIndex !== stopIndex) input.seek(startIndex);
            let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $hwoBE.PredictionMode.LL_EXACT_AMBIG_DETECTION);
            switch(alts.cardinality()){
                case 0:
                    throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                case 1:
                    return alts.nextSetBit(0);
                default:
                    // report ambiguity after predicate evaluation to make sure the correct
                    // set of ambig alts is reported.
                    if (startIndex !== stopIndex) input.seek(stopIndex);
                    this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                    return alts.nextSetBit(0);
            }
        }
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
        return s.prediction;
    }
    /**
     * Determines if a particular DFA state should be treated as an accept state
     * for the current prediction mode. In addition to the `useContext`
     * parameter, the {@link #getPredictionMode()} method provides the
     * prediction mode controlling the prediction algorithm as a whole.
     *
     * The default implementation simply returns the value of
     * `DFAState.isAcceptState` except for conflict states when
     * `useContext` is `true` and {@link #getPredictionMode()} is
     * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}. In that case, only
     * conflict states where {@link ATNConfigSet#isExactConflict} is
     * `true` are considered accept states.
     *
     * @param state The DFA state to check.
     * @param useContext `true` if the prediction algorithm is currently
     * considering the full parser context; otherwise, `false` if the
     * algorithm is currently performing a local context prediction.
     *
     * @returns `true` if the specified `state` is an accept state;
     * otherwise, `false`.
     */ isAcceptState(state, useContext) {
        if (!state.isAcceptState) return false;
        if (state.configs.conflictingAlts == null) // unambiguous
        return true;
        // More picky when we need exact conflicts
        if (useContext && this.predictionMode === $hwoBE.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
        return true;
    }
    /** Performs ATN simulation to compute a predicted alternative based
     *  upon the remaining input, but also updates the DFA cache to avoid
     *  having to traverse the ATN again for the same input sequence.
     *
     * There are some key conditions we're looking for after computing a new
     * set of ATN configs (proposed DFA state):
     *
     * * if the set is empty, there is no viable alternative for current symbol
     * * does the state uniquely predict an alternative?
     * * does the state have a conflict that would prevent us from
     *   putting it on the work list?
     * * if in non-greedy decision is there a config at a rule stop state?
     *
     * We also have some key operations to do:
     *
     * * add an edge from previous DFA state to potentially new DFA state, D,
     *   upon current symbol but only if adding to work list, which means in all
     *   cases except no viable alternative (and possibly non-greedy decisions?)
     * * collecting predicates and adding semantic context to DFA accept states
     * * adding rule context to context-sensitive DFA accept states
     * * consuming an input symbol
     * * reporting a conflict
     * * reporting an ambiguity
     * * reporting a context sensitivity
     * * reporting insufficient predicates
     *
     * We should isolate those operations, which are side-effecting, to the
     * main work loop. We can isolate lots of code into other functions, but
     * they should be side effect free. They can return package that
     * indicates whether we should report something, whether we need to add a
     * DFA edge, whether we need to augment accept state with semantic
     * context or rule invocation context. Actually, it seems like we always
     * add predicates if they exist, so that can simply be done in the main
     * loop for any accept state creation or modification request.
     *
     * cover these cases:
     *   dead end
     *   single alt
     *   single alt + preds
     *   conflict
     *   conflict + preds
     *
     * TODO: greedy + those
     */ execATN(dfa, input, startIndex, initialState) {
        if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
        let outerContext = initialState.outerContext;
        let useContext = initialState.useContext;
        let t = input.LA(1);
        let previous = initialState;
        let contextCache = new $4BvNW.PredictionContextCache();
        while(true){
            let nextState = this.computeReachSet(dfa, previous, t, contextCache);
            if (nextState == null) {
                this.setDFAEdge(previous.s0, input.LA(1), $ceQRA.ATNSimulator.ERROR);
                return this.handleNoViableAlt(input, startIndex, previous);
            }
            let D = nextState.s0;
            // predicted alt => accept state
            $fomfP(D.isAcceptState || D.prediction === $eeOLb.ATN.INVALID_ALT_NUMBER);
            // conflicted => accept state
            $fomfP(D.isAcceptState || D.configs.conflictInfo == null);
            if (this.isAcceptState(D, useContext)) {
                let conflictingAlts = D.configs.conflictingAlts;
                let predictedAlt = conflictingAlts == null ? D.prediction : $eeOLb.ATN.INVALID_ALT_NUMBER;
                if (predictedAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) {
                    if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                        if (t >= 0 && t <= $c0f91822940cc2ea$var$MAX_SHORT_VALUE) {
                            let key = (dfa.decision << 16 >>> 0) + t;
                            this.atn.LL1Table.set(key, predictedAlt);
                        }
                    }
                    if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                }
                predictedAlt = D.prediction;
                //				int k = input.index - startIndex + 1; // how much input we used
                //				System.out.println("used k="+k);
                let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                if (attemptFullContext) // Only exact conflicts are known to be ambiguous when local
                // prediction does not step out of the decision rule.
                attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                if (D.configs.hasSemanticContext) {
                    let predPredictions = D.predicates;
                    if (predPredictions != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        // use complete evaluation here if we'll want to retry with full context if still ambiguous
                        conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                        switch(conflictingAlts.cardinality()){
                            case 0:
                                throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                            case 1:
                                return conflictingAlts.nextSetBit(0);
                            default:
                                break;
                        }
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                }
                if (!attemptFullContext) {
                    if (conflictingAlts != null) {
                        if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                        predictedAlt = conflictingAlts.nextSetBit(0);
                    }
                    return predictedAlt;
                } else {
                    $fomfP(!useContext);
                    $fomfP(this.isAcceptState(D, false));
                    if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                    let fullContextState = this.computeStartState(dfa, outerContext, true);
                    if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                    input.seek(startIndex);
                    return this.execATN(dfa, input, startIndex, fullContextState);
                }
            }
            previous = nextState;
            if (t !== $ldi9e.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
    }
    /**
     * This method is used to improve the localization of error messages by
     * choosing an alternative rather than throwing a
     * {@link NoViableAltException} in particular prediction scenarios where the
     * {@link #ERROR} state was reached during ATN simulation.
     *
     * The default implementation of this method uses the following
     * algorithm to identify an ATN configuration which successfully parsed the
     * decision entry rule. Choosing such an alternative ensures that the
     * {@link ParserRuleContext} returned by the calling rule will be complete
     * and valid, and the syntax error will be reported later at a more
     * localized location.
     *
     * * If no configuration in `configs` reached the end of the
     *   decision rule, return {@link ATN#INVALID_ALT_NUMBER}.
     * * If all configurations in `configs` which reached the end of the
     *   decision rule predict the same alternative, return that alternative.
     * * If the configurations in `configs` which reached the end of the
     *   decision rule predict multiple alternatives (call this *S*),
     *   choose an alternative in the following order.
     *
     *     1. Filter the configurations in `configs` to only those
     *        configurations which remain viable after evaluating semantic predicates.
     *        If the set of these filtered configurations which also reached the end of
     *        the decision rule is not empty, return the minimum alternative
     *        represented in this set.
     *     1. Otherwise, choose the minimum alternative in *S*.
     *
     * In some scenarios, the algorithm described above could predict an
     * alternative which will result in a {@link FailedPredicateException} in
     * parser. Specifically, this could occur if the *only* configuration
     * capable of successfully parsing to the end of the decision rule is
     * blocked by a semantic predicate. By choosing this alternative within
     * {@link #adaptivePredict} instead of throwing a
     * {@link NoViableAltException}, the resulting
     * {@link FailedPredicateException} in the parser will identify the specific
     * predicate which is preventing the parser from successfully parsing the
     * decision rule, which helps developers identify and correct logic errors
     * in semantic predicates.
     *
     * @param input The input {@link TokenStream}
     * @param startIndex The start index for the current prediction, which is
     * the input index where any semantic context in `configs` should be
     * evaluated
     * @param previous The ATN simulation state immediately before the
     * {@link #ERROR} state was reached
     *
     * @returns The value to return from {@link #adaptivePredict}, or
     * {@link ATN#INVALID_ALT_NUMBER} if a suitable alternative was not
     * identified and {@link #adaptivePredict} should report an error instead.
     */ handleNoViableAlt(input, startIndex, previous) {
        if (previous.s0 != null) {
            let alts = new $8WIez.BitSet();
            let maxAlt = 0;
            for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $jWsYN.RuleStopState) {
                alts.set(config.alt);
                maxAlt = Math.max(maxAlt, config.alt);
            }
            switch(alts.cardinality()){
                case 0:
                    break;
                case 1:
                    return alts.nextSetBit(0);
                default:
                    if (!previous.s0.configs.hasSemanticContext) // configs doesn't contain any predicates, so the predicate
                    // filtering code below would be pointless
                    return alts.nextSetBit(0);
                    /*
                     * Try to find a configuration set that not only dipped into the outer
                     * context, but also isn't eliminated by a predicate.
                     */ let filteredConfigs = new $2SGHL.ATNConfigSet();
                    for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $jWsYN.RuleStopState) filteredConfigs.add(config);
                    /* The following code blocks are adapted from predicateDFAState with
                     * the following key changes.
                     *
                     *  1. The code operates on an ATNConfigSet rather than a DFAState.
                     *  2. Predicates are collected for all alternatives represented in
                     *     filteredConfigs, rather than restricting the evaluation to
                     *     conflicting and/or unique configurations.
                     */ let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                    if (altToPred != null) {
                        let predicates = this.getPredicatePredictions(alts, altToPred);
                        if (predicates != null) {
                            let stopIndex = input.index;
                            try {
                                input.seek(startIndex);
                                let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                            } finally{
                                input.seek(stopIndex);
                            }
                        }
                    }
                    return alts.nextSetBit(0);
            }
        }
        throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
    }
    computeReachSet(dfa, previous, t, contextCache) {
        let useContext = previous.useContext;
        let remainingGlobalContext = previous.remainingOuterContext;
        let s = previous.s0;
        if (useContext) while(s.isContextSymbol(t)){
            let next;
            if (remainingGlobalContext != null) {
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
            }
            if (next == null) break;
            $fomfP(remainingGlobalContext != null);
            remainingGlobalContext = remainingGlobalContext.parent;
            s = next;
        }
        $fomfP(!this.isAcceptState(s, useContext));
        if (this.isAcceptState(s, useContext)) return new $eDtKk.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
        let s0 = s;
        let target = this.getExistingTargetState(s0, t);
        if (target == null) {
            let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
            target = result[0];
            remainingGlobalContext = result[1];
        }
        if (target === $ceQRA.ATNSimulator.ERROR) return undefined;
        $fomfP(!useContext || !target.configs.dipsIntoOuterContext);
        return new $eDtKk.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        return s.getTarget(t);
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param dfa
     * @param s The current DFA state
     * @param remainingGlobalContext
     * @param t The next input symbol
     * @param useContext
     * @param contextCache
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let closureConfigs = s.configs.toArray();
        let contextElements;
        let reach = new $2SGHL.ATNConfigSet();
        let stepIntoGlobal;
        do {
            let hasMoreContext = !useContext || remainingGlobalContext != null;
            if (!hasMoreContext) reach.isOutermostConfigSet = true;
            let reachIntermediate = new $2SGHL.ATNConfigSet();
            /* Configurations already in a rule stop state indicate reaching the end
             * of the decision rule (local context) or end of the start rule (full
             * context). Once reached, these configurations are never updated by a
             * closure operation, so they are handled separately for the performance
             * advantage of having a smaller intermediate set when calling closure.
             *
             * For full-context reach operations, separate handling is required to
             * ensure that the alternative matching the longest overall sequence is
             * chosen when multiple such configurations can match the input.
             */ let skippedStopStates;
            for (let c of closureConfigs){
                if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                if (c.state instanceof $jWsYN.RuleStopState) {
                    $fomfP(c.context.isEmpty);
                    if (useContext && !c.reachesIntoOuterContext || t === $ldi9e.IntStream.EOF) {
                        if (skippedStopStates == null) skippedStopStates = [];
                        skippedStopStates.push(c);
                    }
                    continue;
                }
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(c, trans, t);
                    if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                }
            }
            /* This block optimizes the reach operation for intermediate sets which
             * trivially indicate a termination state for the overall
             * adaptivePredict operation.
             *
             * The conditions assume that intermediate
             * contains all configurations relevant to the reach set, but this
             * condition is not true when one or more configurations have been
             * withheld in skippedStopStates, or when the current symbol is EOF.
             */ if (this.optimize_unique_closure && skippedStopStates == null && t !== $eKXi4.Token.EOF && reachIntermediate.uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) {
                reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                reach = reachIntermediate;
                break;
            }
            /* If the reach set could not be trivially determined, perform a closure
             * operation on the intermediate set to compute its initial value.
             */ let collectPredicates = false;
            let treatEofAsEpsilon = t === $eKXi4.Token.EOF;
            this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
            stepIntoGlobal = reach.dipsIntoOuterContext;
            if (t === $ldi9e.IntStream.EOF) /* After consuming EOF no additional input is possible, so we are
                 * only interested in configurations which reached the end of the
                 * decision rule (local context) or end of the start rule (full
                 * context). Update reach to contain only these configurations. This
                 * handles both explicit EOF transitions in the grammar and implicit
                 * EOF transitions following the end of the decision or start rule.
                 *
                 * This is handled before the configurations in skippedStopStates,
                 * because any configurations potentially added from that list are
                 * already guaranteed to meet this condition whether or not it's
                 * required.
                 */ reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
            /* If skippedStopStates is not undefined, then it contains at least one
             * configuration. For full-context reach operations, these
             * configurations reached the end of the start rule, in which case we
             * only add them back to reach if no configuration during the current
             * closure operation reached such a state. This ensures adaptivePredict
             * chooses an alternative matching the longest overall sequence when
             * multiple alternatives are viable.
             */ if (skippedStopStates != null && (!useContext || !$hwoBE.PredictionMode.hasConfigInRuleStopState(reach))) {
                $fomfP(skippedStopStates.length > 0);
                for (let c of skippedStopStates)reach.add(c, contextCache);
            }
            if (useContext && stepIntoGlobal) {
                reach.clear();
                // We know remainingGlobalContext is not undefined at this point (why?)
                remainingGlobalContext;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (contextElements == null) contextElements = new $eRSlM.IntegerList();
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                contextElements.add(nextContextElement);
                if (nextContextElement !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
            }
        }while (useContext && stepIntoGlobal);
        if (reach.isEmpty) {
            this.setDFAEdge(s, t, $ceQRA.ATNSimulator.ERROR);
            return [
                $ceQRA.ATNSimulator.ERROR,
                remainingGlobalContext
            ];
        }
        let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
        return [
            result,
            remainingGlobalContext
        ];
    }
    /**
     * Return a configuration set containing only the configurations from
     * `configs` which are in a {@link RuleStopState}. If all
     * configurations in `configs` are already in a rule stop state, this
     * method simply returns `configs`.
     *
     * @param configs the configuration set to update
     * @param contextCache the {@link PredictionContext} cache
     *
     * @returns `configs` if all configurations in `configs` are in a
     * rule stop state, otherwise return a new configuration set containing only
     * the configurations from `configs` which are in a rule stop state
     */ removeAllConfigsNotInRuleStopState(configs, contextCache) {
        if ($hwoBE.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
        let result = new $2SGHL.ATNConfigSet();
        for (let config of configs){
            if (!(config.state instanceof $jWsYN.RuleStopState)) continue;
            result.add(config, contextCache);
        }
        return result;
    }
    computeStartState(dfa, globalContext, useContext) {
        let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
        if (s0 != null) {
            if (!useContext) return new $eDtKk.SimulatorState(globalContext, s0, useContext, globalContext);
            s0.setContextSensitive(this.atn);
        }
        let decision = dfa.decision;
        // @NotNull
        let p = dfa.atnStartState;
        let previousContext = 0;
        let remainingGlobalContext = globalContext;
        let initialContext = useContext ? $jaUCz.PredictionContext.EMPTY_FULL : $jaUCz.PredictionContext.EMPTY_LOCAL; // always at least the implicit call to start rule
        let contextCache = new $4BvNW.PredictionContextCache();
        if (useContext) {
            if (!this.enable_global_context_dfa) {
                while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                    previousContext = $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
            }
            while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                let next;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) {
                    next = s0.getContextTarget($jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY);
                    previousContext = $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    next = s0.getContextTarget(previousContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
                if (next == null) break;
                s0 = next;
            }
        }
        if (s0 != null && !s0.isContextSensitive) return new $eDtKk.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        let configs = new $2SGHL.ATNConfigSet();
        while(true){
            let reachIntermediate = new $2SGHL.ATNConfigSet();
            let n = p.numberOfTransitions;
            for(let ti = 0; ti < n; ti++){
                // for each transition
                let target = p.transition(ti).target;
                reachIntermediate.add($hdFz0.ATNConfig.create(target, ti + 1, initialContext));
            }
            let hasMoreContext = remainingGlobalContext != null;
            if (!hasMoreContext) configs.isOutermostConfigSet = true;
            let collectPredicates = true;
            this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
            let stepIntoGlobal = configs.dipsIntoOuterContext;
            let next;
            if (useContext && !this.enable_global_context_dfa) {
                s0 = this.addDFAState(dfa, configs, contextCache);
                break;
            } else if (s0 == null) {
                if (!dfa.isPrecedenceDfa) {
                    next = this.addDFAState(dfa, configs, contextCache);
                    if (useContext) {
                        if (!dfa.s0full) dfa.s0full = next;
                        else next = dfa.s0full;
                    } else if (!dfa.s0) dfa.s0 = next;
                    else next = dfa.s0;
                } else {
                    /* If this is a precedence DFA, we use applyPrecedenceFilter
                     * to convert the computed start state to a precedence start
                     * state. We then use DFA.setPrecedenceStartState to set the
                     * appropriate start state for the precedence level rather
                     * than simply setting DFA.s0.
                     */ configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                }
            } else {
                if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                next = this.addDFAState(dfa, configs, contextCache);
                s0.setContextTarget(previousContext, next);
            }
            s0 = next;
            if (!useContext || !stepIntoGlobal) break;
            // TODO: make sure it distinguishes empty stack states
            next.setContextSensitive(this.atn);
            // We know remainingGlobalContext is not undefined at this point (why?)
            remainingGlobalContext;
            configs.clear();
            remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
            let nextContextElement = this.getReturnState(remainingGlobalContext);
            if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
            else remainingGlobalContext = remainingGlobalContext.parent;
            if (nextContextElement !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
            previousContext = nextContextElement;
        }
        return new $eDtKk.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
    }
    /**
     * This method transforms the start state computed by
     * {@link #computeStartState} to the special start state used by a
     * precedence DFA for a particular precedence value. The transformation
     * process applies the following changes to the start state's configuration
     * set.
     *
     * 1. Evaluate the precedence predicates for each configuration using
     *    {@link SemanticContext#evalPrecedence}.
     * 1. When {@link ATNConfig#isPrecedenceFilterSuppressed} is `false`,
     *    remove all configurations which predict an alternative greater than 1,
     *    for which another configuration that predicts alternative 1 is in the
     *    same ATN state with the same prediction context. This transformation is
     *    valid for the following reasons:
     *
     *     * The closure block cannot contain any epsilon transitions which bypass
     *       the body of the closure, so all states reachable via alternative 1 are
     *       part of the precedence alternatives of the transformed left-recursive
     *       rule.
     *     * The "primary" portion of a left recursive rule cannot contain an
     *       epsilon transition, so the only way an alternative other than 1 can exist
     *       in a state that is also reachable via alternative 1 is by nesting calls
     *       to the left-recursive rule, with the outer calls not being at the
     *       preferred precedence level. The
     *       {@link ATNConfig#isPrecedenceFilterSuppressed} property marks ATN
     *       configurations which do not meet this condition, and therefore are not
     *       eligible for elimination during the filtering process.
     *
     * The prediction context must be considered by this filter to address
     * situations like the following.
     *
     * ```antlr
     * grammar TA;
     * prog: statement* EOF;
     * statement: letterA | statement letterA 'b' ;
     * letterA: 'a';
     * ```
     *
     * If the above grammar, the ATN state immediately before the token
     * reference `'a'` in `letterA` is reachable from the left edge
     * of both the primary and closure blocks of the left-recursive rule
     * `statement`. The prediction context associated with each of these
     * configurations distinguishes between them, and prevents the alternative
     * which stepped out to `prog` (and then back in to `statement`
     * from being eliminated by the filter.
     *
     * @param configs The configuration set computed by
     * {@link #computeStartState} as the start state for the DFA.
     * @returns The transformed configuration set representing the start state
     * for a precedence DFA at a particular precedence level (determined by
     * calling {@link Parser#getPrecedence}).
     */ applyPrecedenceFilter(configs, globalContext, contextCache) {
        let statesFromAlt1 = new Map();
        let configSet = new $2SGHL.ATNConfigSet();
        for (let config of configs){
            // handle alt 1 first
            if (config.alt !== 1) continue;
            let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
            if (updatedContext == null) continue;
            statesFromAlt1.set(config.state.stateNumber, config.context);
            if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
            else configSet.add(config, contextCache);
        }
        for (let config of configs){
            if (config.alt === 1) continue;
            if (!config.isPrecedenceFilterSuppressed) {
                /* In the future, this elimination step could be updated to also
                 * filter the prediction context for alternatives predicting alt>1
                 * (basically a graph subtraction algorithm).
                 */ let context = statesFromAlt1.get(config.state.stateNumber);
                if (context != null && context.equals(config.context)) continue;
            }
            configSet.add(config, contextCache);
        }
        return configSet;
    }
    getReachableTarget(source, trans, ttype) {
        if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
        return undefined;
    }
    /** collect and set D's semantic context */ predicateDFAState(D, configs, nalts) {
        let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
        if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
        if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
        let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
        // altToPred[uniqueAlt] is now our validating predicate (if any)
        let predPredictions;
        if (altToPred != null) {
            // we have a validating predicate; test it
            // Update DFA so reach becomes accept state with predicate
            predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
            D.predicates = predPredictions;
        }
        return predPredictions;
    }
    getPredsForAmbigAlts(ambigAlts, configs, nalts) {
        // REACH=[1|1|[]|0:0, 1|2|[]|0:1]
        /* altToPred starts as an array of all undefined contexts. The entry at index i
         * corresponds to alternative i. altToPred[i] may have one of three values:
         *   1. undefined: no ATNConfig c is found such that c.alt===i
         *   2. SemanticContext.NONE: At least one ATNConfig c exists such that
         *      c.alt===i and c.semanticContext===SemanticContext.NONE. In other words,
         *      alt i has at least one unpredicated config.
         *   3. Non-NONE Semantic Context: There exists at least one, and for all
         *      ATNConfig c such that c.alt===i, c.semanticContext!==SemanticContext.NONE.
         *
         * From this, it is clear that NONE||anything==NONE.
         */ let altToPred = new Array(nalts + 1);
        let n = altToPred.length;
        for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $3JS45.SemanticContext.or(altToPred[c.alt], c.semanticContext);
        let nPredAlts = 0;
        for(let i = 0; i < n; i++){
            if (altToPred[i] == null) altToPred[i] = $3JS45.SemanticContext.NONE;
            else if (altToPred[i] !== $3JS45.SemanticContext.NONE) nPredAlts++;
        }
        // At this point we know `altToPred` doesn't contain any undefined entries
        let result = altToPred;
        // nonambig alts are undefined in result
        if (nPredAlts === 0) result = undefined;
        if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $4dKou.Arrays.toString(result) : "undefined"));
        return result;
    }
    getPredicatePredictions(ambigAlts, altToPred) {
        let pairs = [];
        let containsPredicate = false;
        for(let i = 1; i < altToPred.length; i++){
            let pred = altToPred[i];
            // unpredicated is indicated by SemanticContext.NONE
            $fomfP(pred != null);
            // find first unpredicated but ambig alternative, if any.
            // Only ambiguous alternatives will have SemanticContext.NONE.
            // Any unambig alts or ambig naked alts after first ambig naked are ignored
            // (undefined, i) means alt i is the default prediction
            // if no (undefined, i), then no default prediction.
            if (ambigAlts != null && ambigAlts.get(i) && pred === $3JS45.SemanticContext.NONE) pairs.push(new $6P9ap.DFAState.PredPrediction(pred, i));
            else if (pred !== $3JS45.SemanticContext.NONE) {
                containsPredicate = true;
                pairs.push(new $6P9ap.DFAState.PredPrediction(pred, i));
            }
        }
        if (!containsPredicate) return undefined;
        //		System.out.println(Arrays.toString(altToPred)+"->"+pairs);
        return pairs;
    }
    /** Look through a list of predicate/alt pairs, returning alts for the
     *  pairs that win. An `undefined` predicate indicates an alt containing an
     *  unpredicated config which behaves as "always true."
     */ evalSemanticContext(predPredictions, outerContext, complete) {
        let predictions = new $8WIez.BitSet();
        for (let pair of predPredictions){
            if (pair.pred === $3JS45.SemanticContext.NONE) {
                predictions.set(pair.alt);
                if (!complete) break;
                continue;
            }
            let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
            if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
            if (evaluatedResult) {
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                predictions.set(pair.alt);
                if (!complete) break;
            }
        }
        return predictions;
    }
    /**
     * Evaluate a semantic context within a specific parser context.
     *
     * This method might not be called for every semantic context evaluated
     * during the prediction process. In particular, we currently do not
     * evaluate the following but it may change in the future:
     *
     * * Precedence predicates (represented by
     *   {@link SemanticContext.PrecedencePredicate}) are not currently evaluated
     *   through this method.
     * * Operator predicates (represented by {@link SemanticContext.AND} and
     *   {@link SemanticContext.OR}) are evaluated as a single semantic
     *   context, rather than evaluating the operands individually.
     *   Implementations which require evaluation results from individual
     *   predicates should override this method to explicitly handle evaluation of
     *   the operands within operator predicates.
     *
     * @param pred The semantic context to evaluate
     * @param parserCallStack The parser context in which to evaluate the
     * semantic context
     * @param alt The alternative which is guarded by `pred`
     *
     * @since 4.3
     */ evalSemanticContextImpl(pred, parserCallStack, alt) {
        return pred.eval(this._parser, parserCallStack);
    }
    /* TODO: If we are doing predicates, there is no point in pursuing
         closure operations if we reach a DFA state that uniquely predicts
         alternative. We will not be caching that DFA state and it is a
         waste to pursue the closure. Might have to advance when we do
         ambig detection thought :(
          */ closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
        if (contextCache == null) contextCache = $4BvNW.PredictionContextCache.UNCACHED;
        let currentConfigs = sourceConfigs;
        let closureBusy = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
        while(currentConfigs.size > 0){
            let intermediate = new $2SGHL.ATNConfigSet();
            for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
            currentConfigs = intermediate;
        }
    }
    closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
        if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
        if (config.state instanceof $jWsYN.RuleStopState) {
            // We hit rule end. If we have context info, use it
            if (!config.context.isEmpty) {
                let hasEmpty = config.context.hasEmpty;
                let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                for(let i = 0; i < nonEmptySize; i++){
                    let newContext = config.context.getParent(i); // "pop" return state
                    let returnState = this.atn.states[config.context.getReturnState(i)];
                    let c = $hdFz0.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                    // While we have context to pop back from, we may have
                    // gotten that context AFTER having fallen off a rule.
                    // Make sure we track that we are now out of context.
                    c.outerContextDepth = config.outerContextDepth;
                    c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                    $fomfP(depth > $c0f91822940cc2ea$var$MIN_INTEGER_VALUE);
                    this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                }
                if (!hasEmpty || !hasMoreContexts) return;
                config = config.transform(config.state, false, $jaUCz.PredictionContext.EMPTY_LOCAL);
            } else if (!hasMoreContexts) {
                configs.add(config, contextCache);
                return;
            } else {
                // else if we have no context info, just chase follow links (if greedy)
                if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                if (config.context === $jaUCz.PredictionContext.EMPTY_FULL) // no need to keep full context overhead when we step out
                config = config.transform(config.state, false, $jaUCz.PredictionContext.EMPTY_LOCAL);
                else if (!config.reachesIntoOuterContext && $jaUCz.PredictionContext.isEmptyLocal(config.context)) // add stop state when leaving decision rule for the first time
                configs.add(config, contextCache);
            }
        }
        let p = config.state;
        // optimization
        if (!p.onlyHasEpsilonTransitions) {
            configs.add(config, contextCache);
            // make sure to not return here, because EOF transitions can act as
            // both epsilon transitions and non-epsilon transitions.
            if (ParserATNSimulator.debug) console.log("added config " + configs);
        }
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            // This block implements first-edge elimination of ambiguous LR
            // alternatives as part of dynamic disambiguation during prediction.
            // See antlr/antlr4#1398.
            if (i === 0 && p.stateType === $fZESB.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                let precedenceDecision = p;
                // When suppress is true, it means the outgoing edge i==0 is
                // ambiguous with the outgoing edge i==1, and thus the closure
                // operation can dynamically disambiguate by suppressing this
                // edge during the closure operation.
                let suppress = true;
                for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                    suppress = false;
                    break;
                }
                if (suppress) continue;
            }
            let t = p.getOptimizedTransition(i);
            let continueCollecting = !(t instanceof $dNkDA.ActionTransition) && collectPredicates;
            let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
            if (c != null) {
                if (t instanceof $lmhna.RuleTransition) {
                    if (intermediate != null && !collectPredicates) {
                        intermediate.add(c, contextCache);
                        continue;
                    }
                }
                let newDepth = depth;
                if (config.state instanceof $jWsYN.RuleStopState) {
                    // target fell off end of rule; mark resulting c as having dipped into outer context
                    // We can't get here if incoming config was rule stop and we had context
                    // track how far we dip into outer context.  Might
                    // come in handy and we avoid evaluating context dependent
                    // preds if this is > 0.
                    if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                        let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                        if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                    }
                    c.outerContextDepth = c.outerContextDepth + 1;
                    if (!closureBusy.add(c)) continue;
                    $fomfP(newDepth > $c0f91822940cc2ea$var$MIN_INTEGER_VALUE);
                    newDepth--;
                    if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                } else if (t instanceof $lmhna.RuleTransition) {
                    if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$jaUCz.PredictionContext.isEmptyLocal(config.context))) {
                        $fomfP(c.context === config.context);
                        if (newDepth === 0) {
                            // the pop/push of a tail call would keep the depth
                            // constant, except we latch if it goes negative
                            newDepth--;
                            if (!this.tail_call_preserves_sll && $jaUCz.PredictionContext.isEmptyLocal(config.context)) // make sure the SLL config "dips into the outer context" or prediction may not fall back to LL on conflict
                            c.outerContextDepth = c.outerContextDepth + 1;
                        }
                    } else // latch when newDepth goes negative - once we step out of the entry context we can't return
                    if (newDepth >= 0) newDepth++;
                } else {
                    if (!t.isEpsilon && !closureBusy.add(c)) continue;
                }
                this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
            }
        }
    }
    getRuleName(index) {
        if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
        return "<rule " + index + ">";
    }
    getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
        switch(t.serializationType){
            case 3 /* RULE */ :
                return this.ruleTransition(config, t, contextCache);
            case 10 /* PRECEDENCE */ :
                return this.precedenceTransition(config, t, collectPredicates, inContext);
            case 4 /* PREDICATE */ :
                return this.predTransition(config, t, collectPredicates, inContext);
            case 6 /* ACTION */ :
                return this.actionTransition(config, t);
            case 1 /* EPSILON */ :
                return config.transform(t.target, false);
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                // EOF transitions act like epsilon transitions after the first EOF
                // transition is traversed
                if (treatEofAsEpsilon) {
                    if (t.matches($eKXi4.Token.EOF, 0, 1)) return config.transform(t.target, false);
                }
                return undefined;
            default:
                return undefined;
        }
    }
    actionTransition(config, t) {
        if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
        return config.transform(t.target, false);
    }
    precedenceTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && inContext) {
            let newSemCtx = $3JS45.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    predTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
            let newSemCtx = $3JS45.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    ruleTransition(config, t, contextCache) {
        if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
        let returnState = t.followState;
        let newContext;
        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$jaUCz.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
        else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
        else newContext = config.context.getChild(returnState.stateNumber);
        return config.transform(t.target, false, newContext);
    }
    isConflicted(configset, contextCache) {
        if (configset.uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
        let configs = configset.toArray();
        configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
        let exact = !configset.dipsIntoOuterContext;
        let alts = new $8WIez.BitSet();
        let minAlt = configs[0].alt;
        alts.set(minAlt);
        /* Quick checks come first (single pass, no context joining):
         *  1. Make sure first config in the sorted list predicts the minimum
         *     represented alternative.
         *  2. Make sure every represented state has at least one configuration
         *     which predicts the minimum represented alternative.
         *  3. (exact only) make sure every represented state has at least one
         *     configuration which predicts each represented alternative.
         */ // quick check 1 & 2 => if we assume #1 holds and check #2 against the
        // minAlt from the first state, #2 will fail if the assumption was
        // incorrect
        let currentState = configs[0].state.nonStopStateNumber;
        for (let config of configs){
            let stateNumber = config.state.nonStopStateNumber;
            if (stateNumber !== currentState) {
                if (config.alt !== minAlt) return undefined;
                currentState = stateNumber;
            }
        }
        let representedAlts;
        if (exact) {
            currentState = configs[0].state.nonStopStateNumber;
            // get the represented alternatives of the first state
            representedAlts = new $8WIez.BitSet();
            let maxAlt = minAlt;
            for (let config of configs){
                if (config.state.nonStopStateNumber !== currentState) break;
                let alt = config.alt;
                representedAlts.set(alt);
                maxAlt = alt;
            }
            // quick check #3:
            currentState = configs[0].state.nonStopStateNumber;
            let currentAlt = minAlt;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                let alt = config.alt;
                if (stateNumber !== currentState) {
                    if (currentAlt !== maxAlt) {
                        exact = false;
                        break;
                    }
                    currentState = stateNumber;
                    currentAlt = minAlt;
                } else if (alt !== currentAlt) {
                    if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                        exact = false;
                        break;
                    }
                    currentAlt = alt;
                }
            }
        }
        currentState = configs[0].state.nonStopStateNumber;
        let firstIndexCurrentState = 0;
        let lastIndexCurrentStateMinAlt = 0;
        let joinedCheckContext = configs[0].context;
        for(let i = 1; i < configs.length; i++){
            let config = configs[i];
            if (config.alt !== minAlt) break;
            if (config.state.nonStopStateNumber !== currentState) break;
            lastIndexCurrentStateMinAlt = i;
            joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
        }
        for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
            let config = configs[i];
            let state = config.state;
            alts.set(config.alt);
            if (state.nonStopStateNumber !== currentState) {
                currentState = state.nonStopStateNumber;
                firstIndexCurrentState = i;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = config.context;
                for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== minAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateMinAlt = j;
                    joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                }
                i = lastIndexCurrentStateMinAlt;
                continue;
            }
            let joinedCheckContext2 = config.context;
            let currentAlt = config.alt;
            let lastIndexCurrentStateCurrentAlt = i;
            for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                let config2 = configs[j];
                if (config2.alt !== currentAlt) break;
                if (config2.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateCurrentAlt = j;
                joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
            }
            i = lastIndexCurrentStateCurrentAlt;
            let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
            if (!joinedCheckContext.equals(check)) return undefined;
            // update exact if necessary
            exact = exact && joinedCheckContext.equals(joinedCheckContext2);
        }
        return new $bPdk6.ConflictInfo(alts, exact);
    }
    getConflictingAltsFromConfigSet(configs) {
        let conflictingAlts = configs.conflictingAlts;
        if (conflictingAlts == null && configs.uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) {
            conflictingAlts = new $8WIez.BitSet();
            conflictingAlts.set(configs.uniqueAlt);
        }
        return conflictingAlts;
    }
    getTokenName(t) {
        if (t === $eKXi4.Token.EOF) return "EOF";
        let vocabulary = this._parser != null ? this._parser.vocabulary : $hBnE1.VocabularyImpl.EMPTY_VOCABULARY;
        let displayName = vocabulary.getDisplayName(t);
        if (displayName === String(t)) return displayName;
        return displayName + "<" + t + ">";
    }
    getLookaheadName(input) {
        return this.getTokenName(input.LA(1));
    }
    dumpDeadEndConfigs(nvae) {
        console.log("dead end configs: ");
        let deadEndConfigs = nvae.deadEndConfigs;
        if (!deadEndConfigs) return;
        for (let c of deadEndConfigs){
            let trans = "no edges";
            if (c.state.numberOfOptimizedTransitions > 0) {
                let t = c.state.getOptimizedTransition(0);
                if (t instanceof $kXmw5.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                else if (t instanceof $5EcBU.SetTransition) {
                    let not = t instanceof $gFTdY.NotSetTransition;
                    trans = (not ? "~" : "") + "Set " + t.set.toString();
                }
            }
            console.log(c.toString(this._parser, true) + ":" + trans);
        }
    }
    noViableAlt(input, outerContext, configs, startIndex) {
        return new $iAlWg.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
    }
    getUniqueAlt(configs) {
        let alt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        for (let c of configs){
            if (alt === $eeOLb.ATN.INVALID_ALT_NUMBER) alt = c.alt; // found first alt
            else if (c.alt !== alt) return $eeOLb.ATN.INVALID_ALT_NUMBER;
        }
        return alt;
    }
    configWithAltAtStopState(configs, alt) {
        for (let c of configs)if (c.alt === alt) {
            if (c.state instanceof $jWsYN.RuleStopState) return true;
        }
        return false;
    }
    addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
        $fomfP(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
        let from = fromState;
        let to = this.addDFAState(dfa, toConfigs, contextCache);
        if (contextTransitions != null) for (let context of contextTransitions.toArray()){
            if (context === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) {
                if (from.configs.isOutermostConfigSet) continue;
            }
            from.setContextSensitive(this.atn);
            from.setContextSymbol(t);
            let next = from.getContextTarget(context);
            if (next != null) {
                from = next;
                continue;
            }
            next = this.addDFAContextState(dfa, from.configs, context, contextCache);
            $fomfP(context !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
            from.setContextTarget(context, next);
            from = next;
        }
        if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
        this.setDFAEdge(from, t, to);
        if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $hBnE1.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
        return to;
    }
    setDFAEdge(p, t, q) {
        if (p != null) p.setTarget(t, q);
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAContextState(dfa, configs, returnContext, contextCache) {
        if (returnContext !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) {
            let contextConfigs = new $2SGHL.ATNConfigSet();
            for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
            return this.addDFAState(dfa, contextConfigs, contextCache);
        } else {
            $fomfP(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
            configs = configs.clone(true);
            configs.isOutermostConfigSet = true;
            return this.addDFAState(dfa, configs, contextCache);
        }
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAState(dfa, configs, contextCache) {
        let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
        if (enableDfa) {
            if (!configs.isReadOnly) configs.optimizeConfigs(this);
            let proposed = this.createDFAState(dfa, configs);
            let existing = dfa.states.get(proposed);
            if (existing != null) return existing;
        }
        if (!configs.isReadOnly) {
            if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
        }
        let newState = this.createDFAState(dfa, configs.clone(true));
        // getDecisionState won't return undefined when we request a known valid decision
        let decisionState = this.atn.getDecisionState(dfa.decision);
        let predictedAlt = this.getUniqueAlt(configs);
        if (predictedAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $hu8W9.AcceptStateInfo(predictedAlt);
        else if (configs.conflictingAlts != null) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts) newState.acceptStateInfo = new $hu8W9.AcceptStateInfo(conflictingAlts.nextSetBit(0));
        }
        if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
        if (!enableDfa) return newState;
        let added = dfa.addState(newState);
        if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
        return added;
    }
    createDFAState(dfa, configs) {
        return new $6P9ap.DFAState(configs);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $l8y5T.Interval.of(startIndex, stopIndex);
            console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        }
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $l8y5T.Interval.of(startIndex, stopIndex);
            console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
        }
    }
    /** If context sensitive parsing, we know it's ambiguity not conflict */ reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $l8y5T.Interval.of(startIndex, stopIndex);
            console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        }
    }
    getReturnState(context) {
        if (context.isEmpty) return $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
        let state = this.atn.states[context.invokingState];
        let transition = state.transition(0);
        return transition.followState.stateNumber;
    }
    skipTailCalls(context) {
        if (!this.optimize_tail_calls) return context;
        while(!context.isEmpty){
            let state = this.atn.states[context.invokingState];
            $fomfP(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3 /* RULE */ );
            let transition = state.transition(0);
            if (!transition.tailCall) break;
            // This method requires that the root ancestor of the ParserRuleContext be empty. If we make it to this
            // line, we know the current node is not empty, which means it does have a parent.
            context = context.parent;
        }
        return context;
    }
    /**
     * @since 4.3
     */ get parser() {
        return this._parser;
    }
};
$c0f91822940cc2ea$var$ParserATNSimulator.debug = false;
$c0f91822940cc2ea$var$ParserATNSimulator.dfa_debug = false;
$c0f91822940cc2ea$var$ParserATNSimulator.retry_debug = false;
$c0f91822940cc2ea$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
    let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
    if (diff !== 0) return diff;
    diff = o1.alt - o2.alt;
    if (diff !== 0) return diff;
    return 0;
};
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "predictionMode", void 0);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getPredictionMode", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "setPredictionMode", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.Override
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reset", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "adaptivePredict", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getStartState", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(3, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "execDFA", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(3, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "execATN", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "computeTargetState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "computeStartState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getReachableTarget", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(4, $aN41m.Nullable)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "closure", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.Nullable),
    $c0f91822940cc2ea$var$__param(3, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(6, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "closureImpl", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getRuleName", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "actionTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.Nullable,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "precedenceTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.Nullable,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "predTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.Nullable)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "ruleTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "isConflicted", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getTokenName", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "noViableAlt", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(4, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "addDFAEdge", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.Nullable),
    $c0f91822940cc2ea$var$__param(2, $aN41m.Nullable)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "setDFAEdge", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "addDFAContextState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "addDFAState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "createDFAState", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(5, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(6, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
$c0f91822940cc2ea$var$ParserATNSimulator = $c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator);
module.exports.ParserATNSimulator = $c0f91822940cc2ea$var$ParserATNSimulator;

});
parcelRegister("bPdk6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $89becade1f0ea245$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictInfo = void 0;

var $aN41m = parcelRequire("aN41m");

var $62Uvn = parcelRequire("62Uvn");
/**
 * This class stores information about a configuration conflict.
 *
 * @author Sam Harwell
 */ class $89becade1f0ea245$var$ConflictInfo {
    constructor(conflictedAlts, exact){
        this._conflictedAlts = conflictedAlts;
        this.exact = exact;
    }
    /**
     * Gets the set of conflicting alternatives for the configuration set.
     */ get conflictedAlts() {
        return this._conflictedAlts;
    }
    /**
     * Gets whether or not the configuration conflict is an exact conflict.
     * An exact conflict occurs when the prediction algorithm determines that
     * the represented alternatives for a particular configuration set cannot be
     * further reduced by consuming additional input. After reaching an exact
     * conflict during an SLL prediction, only switch to full-context prediction
     * could reduce the set of viable alternatives. In LL prediction, an exact
     * conflict indicates a true ambiguity in the input.
     *
     * For the {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} prediction mode,
     * accept states are conflicting but not exact are treated as non-accept
     * states.
     */ get isExact() {
        return this.exact;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $89becade1f0ea245$var$ConflictInfo)) return false;
        return this.isExact === obj.isExact && $62Uvn.equals(this.conflictedAlts, obj.conflictedAlts);
    }
    hashCode() {
        return this.conflictedAlts.hashCode();
    }
}
$89becade1f0ea245$var$__decorate([
    $aN41m.Override
], $89becade1f0ea245$var$ConflictInfo.prototype, "equals", null);
$89becade1f0ea245$var$__decorate([
    $aN41m.Override
], $89becade1f0ea245$var$ConflictInfo.prototype, "hashCode", null);
module.exports.ConflictInfo = $89becade1f0ea245$var$ConflictInfo;

});

parcelRegister("2pDMz", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1c1cc68451022b8b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserRuleContext = void 0;

var $co9Xk = parcelRequire("co9Xk");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $1xO0Q = parcelRequire("1xO0Q");

var $2IN61 = parcelRequire("2IN61");
/** A rule invocation record for parsing.
 *
 *  Contains all of the information about the current rule not stored in the
 *  RuleContext. It handles parse tree children list, Any ATN state
 *  tracing, and the default values available for rule invocations:
 *  start, stop, rule index, current alt number.
 *
 *  Subclasses made for each rule and grammar track the parameters,
 *  return values, locals, and labels specific to that rule. These
 *  are the objects that are returned from rules.
 *
 *  Note text is not an actual field of a rule return value; it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */ class $1c1cc68451022b8b$var$ParserRuleContext extends $1xO0Q.RuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber == null) super();
        else super(parent, invokingStateNumber);
    }
    static emptyContext() {
        return $1c1cc68451022b8b$var$ParserRuleContext.EMPTY;
    }
    /**
     * COPY a ctx (I'm deliberately not using copy constructor) to avoid
     * confusion with creating node with parent. Does not copy children
     * (except error leaves).
     *
     * This is used in the generated parser code to flip a generic XContext
     * node for rule X to a YContext for alt label Y. In that sense, it is not
     * really a generic copy function.
     *
     * If we do an error sync() at start of a rule, we might add error nodes
     * to the generic XContext so this function must copy those nodes to the
     * YContext as well else they are lost!
     */ copyFrom(ctx) {
        this._parent = ctx._parent;
        this.invokingState = ctx.invokingState;
        this._start = ctx._start;
        this._stop = ctx._stop;
        // copy any error nodes to alt label node
        if (ctx.children) {
            this.children = [];
            // reset parent pointer for any error nodes
            for (let child of ctx.children)if (child instanceof $co9Xk.ErrorNode) this.addChild(child);
        }
    }
    // Double dispatch methods for listeners
    enterRule(listener) {
    // intentionally empty
    }
    exitRule(listener) {
    // intentionally empty
    }
    /** Add a parse tree node to this as a child.  Works for
     *  internal and leaf nodes. Does not set parent link;
     *  other add methods must do that. Other addChild methods
     *  call this.
     *
     *  We cannot set the parent pointer of the incoming node
     *  because the existing interfaces do not have a setParent()
     *  method and I don't want to break backward compatibility for this.
     *
     *  @since 4.7
     */ addAnyChild(t) {
        if (!this.children) this.children = [
            t
        ];
        else this.children.push(t);
        return t;
    }
    addChild(t) {
        let result;
        if (t instanceof $2IN61.TerminalNode) {
            t.setParent(this);
            this.addAnyChild(t);
            return;
        } else if (t instanceof $1xO0Q.RuleContext) {
            // Does not set parent link
            this.addAnyChild(t);
            return;
        } else {
            // Deprecated code path
            t = new $2IN61.TerminalNode(t);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    addErrorNode(node) {
        if (node instanceof $co9Xk.ErrorNode) {
            const errorNode = node;
            errorNode.setParent(this);
            return this.addAnyChild(errorNode);
        } else {
            // deprecated path
            const badToken = node;
            let t = new $co9Xk.ErrorNode(badToken);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    //	public void trace(int s) {
    //		if ( states==null ) states = new ArrayList<Integer>();
    //		states.add(s);
    //	}
    /** Used by enterOuterAlt to toss out a RuleContext previously added as
     *  we entered a rule. If we have # label, we will need to remove
     *  generic ruleContext object.
     */ removeLastChild() {
        if (this.children) this.children.pop();
    }
    get parent() {
        let parent = super.parent;
        if (parent === undefined || parent instanceof $1c1cc68451022b8b$var$ParserRuleContext) return parent;
        throw new TypeError("Invalid parent type for ParserRuleContext");
    }
    // Note: in TypeScript, order or arguments reversed
    getChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
        if (ctxType == null) return this.children[i];
        let result = this.tryGetChild(i, ctxType);
        if (result === undefined) throw new Error("The specified node does not exist");
        return result;
    }
    tryGetChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what node with ctxType have we found?
        for (let o of this.children)if (o instanceof ctxType) {
            j++;
            if (j === i) return o;
        }
        return undefined;
    }
    getToken(ttype, i) {
        let result = this.tryGetToken(ttype, i);
        if (result === undefined) throw new Error("The specified token does not exist");
        return result;
    }
    tryGetToken(ttype, i) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what token with ttype have we found?
        for (let o of this.children)if (o instanceof $2IN61.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) {
                j++;
                if (j === i) return o;
            }
        }
        return undefined;
    }
    getTokens(ttype) {
        let tokens = [];
        if (!this.children) return tokens;
        for (let o of this.children)if (o instanceof $2IN61.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) tokens.push(o);
        }
        return tokens;
    }
    get ruleContext() {
        return this;
    }
    // NOTE: argument order change from Java version
    getRuleContext(i, ctxType) {
        return this.getChild(i, ctxType);
    }
    tryGetRuleContext(i, ctxType) {
        return this.tryGetChild(i, ctxType);
    }
    getRuleContexts(ctxType) {
        let contexts = [];
        if (!this.children) return contexts;
        for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
        return contexts;
    }
    get childCount() {
        return this.children ? this.children.length : 0;
    }
    get sourceInterval() {
        if (!this._start) return $l8y5T.Interval.INVALID;
        if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $l8y5T.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1); // empty
        return $l8y5T.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
    }
    /**
     * Get the initial token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may exceed stop.
     */ get start() {
        return this._start;
    }
    /**
     * Get the final token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may precede start.
     */ get stop() {
        return this._stop;
    }
    /** Used for rule context info debugging during parse-time, not so much for ATN debugging */ toInfoString(recognizer) {
        let rules = recognizer.getRuleInvocationStack(this).reverse();
        return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
    }
}
$1c1cc68451022b8b$var$ParserRuleContext.EMPTY = new $1c1cc68451022b8b$var$ParserRuleContext();
$1c1cc68451022b8b$var$__decorate([
    $aN41m.Override
], $1c1cc68451022b8b$var$ParserRuleContext.prototype, "parent", null);
$1c1cc68451022b8b$var$__decorate([
    $aN41m.Override
], $1c1cc68451022b8b$var$ParserRuleContext.prototype, "childCount", null);
$1c1cc68451022b8b$var$__decorate([
    $aN41m.Override
], $1c1cc68451022b8b$var$ParserRuleContext.prototype, "sourceInterval", null);
module.exports.ParserRuleContext = $1c1cc68451022b8b$var$ParserRuleContext;

});
parcelRegister("co9Xk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $904f72f292ced1ea$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorNode = void 0;

var $aN41m = parcelRequire("aN41m");

var $2IN61 = parcelRequire("2IN61");
/** Represents a token that was consumed during resynchronization
 *  rather than during a valid match operation. For example,
 *  we will create this kind of a node during single token insertion
 *  and deletion as well as during "consume until error recovery set"
 *  upon no viable alternative exceptions.
 */ class $904f72f292ced1ea$var$ErrorNode extends $2IN61.TerminalNode {
    constructor(token){
        super(token);
    }
    accept(visitor) {
        return visitor.visitErrorNode(this);
    }
}
$904f72f292ced1ea$var$__decorate([
    $aN41m.Override
], $904f72f292ced1ea$var$ErrorNode.prototype, "accept", null);
module.exports.ErrorNode = $904f72f292ced1ea$var$ErrorNode;

});
parcelRegister("2IN61", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1fb5c64751fbd583$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerminalNode = void 0;

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
class $1fb5c64751fbd583$var$TerminalNode {
    constructor(symbol){
        this._symbol = symbol;
    }
    getChild(i) {
        throw new RangeError("Terminal Node has no children.");
    }
    get symbol() {
        return this._symbol;
    }
    get parent() {
        return this._parent;
    }
    setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this._symbol;
    }
    get sourceInterval() {
        let tokenIndex = this._symbol.tokenIndex;
        return new $l8y5T.Interval(tokenIndex, tokenIndex);
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitTerminal(this);
    }
    get text() {
        return this._symbol.text || "";
    }
    toStringTree(parser) {
        return this.toString();
    }
    toString() {
        if (this._symbol.type === $eKXi4.Token.EOF) return "<EOF>";
        return this._symbol.text || "";
    }
}
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "getChild", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "parent", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "setParent", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "payload", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "sourceInterval", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "childCount", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "accept", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "text", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "toStringTree", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "toString", null);
module.exports.TerminalNode = $1fb5c64751fbd583$var$TerminalNode;

});


parcelRegister("1xO0Q", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $11ffaafc1554cb2d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContext = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $dwftT = parcelRequire("dwftT");

var $UzGvw = parcelRequire("UzGvw");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $iEJpM = parcelRequire("iEJpM");

var $2pDMz = parcelRequire("2pDMz");
/** A rule context is a record of a single rule invocation.
 *
 *  We form a stack of these context objects using the parent
 *  pointer. A parent pointer of `undefined` indicates that the current
 *  context is the bottom of the stack. The ParserRuleContext subclass
 *  as a children list so that we can turn this data structure into a
 *  tree.
 *
 *  The root node always has a `undefined` pointer and invokingState of -1.
 *
 *  Upon entry to parsing, the first invoked rule function creates a
 *  context object (a subclass specialized for that rule such as
 *  SContext) and makes it the root of a parse tree, recorded by field
 *  Parser._ctx.
 *
 *  public final SContext s() throws RecognitionException {
 *      SContext _localctx = new SContext(_ctx, state); <-- create new node
 *      enterRule(_localctx, 0, RULE_s);                     <-- push it
 *      ...
 *      exitRule();                                          <-- pop back to _localctx
 *      return _localctx;
 *  }
 *
 *  A subsequent rule invocation of r from the start rule s pushes a
 *  new context object for r whose parent points at s and use invoking
 *  state is the state with r emanating as edge label.
 *
 *  The invokingState fields from a context object to the root
 *  together form a stack of rule indication states where the root
 *  (bottom of the stack) has a -1 sentinel value. If we invoke start
 *  symbol s then call r1, which calls r2, the  would look like
 *  this:
 *
 *     SContext[-1]   <- root node (bottom of the stack)
 *     R1Context[p]   <- p in rule s called r1
 *     R2Context[q]   <- q in rule r1 called r2
 *
 *  So the top of the stack, _ctx, represents a call to the current
 *  rule and it holds the return address from another rule that invoke
 *  to this rule. To invoke a rule, we must always have a current context.
 *
 *  The parent contexts are useful for computing lookahead sets and
 *  getting error information.
 *
 *  These objects are used during parsing and prediction.
 *  For the special case of parsers, we use the subclass
 *  ParserRuleContext.
 *
 *  @see ParserRuleContext
 */ class $11ffaafc1554cb2d$var$RuleContext extends $UzGvw.RuleNode {
    constructor(parent, invokingState){
        super();
        this._parent = parent;
        this.invokingState = invokingState != null ? invokingState : -1;
    }
    static getChildContext(parent, invokingState) {
        return new $11ffaafc1554cb2d$var$RuleContext(parent, invokingState);
    }
    depth() {
        let n = 0;
        let p = this;
        while(p){
            p = p._parent;
            n++;
        }
        return n;
    }
    /** A context is empty if there is no invoking state; meaning nobody called
     *  current context.
     */ get isEmpty() {
        return this.invokingState === -1;
    }
    // satisfy the ParseTree / SyntaxTree interface
    get sourceInterval() {
        return $l8y5T.Interval.INVALID;
    }
    get ruleContext() {
        return this;
    }
    get parent() {
        return this._parent;
    }
    /** @since 4.7. {@see ParseTree#setParent} comment */ setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this;
    }
    /** Return the combined text of all child nodes. This method only considers
     *  tokens which have been added to the parse tree.
     *
     *  Since tokens on hidden channels (e.g. whitespace or comments) are not
     *  added to the parse trees, they will not appear in the output of this
     *  method.
     */ get text() {
        if (this.childCount === 0) return "";
        let builder = "";
        for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
        return builder.toString();
    }
    get ruleIndex() {
        return -1;
    }
    /** For rule associated with this parse tree internal node, return
     *  the outer alternative number used to match the input. Default
     *  implementation does not compute nor store this alt num. Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *  to set it.
     *
     *  @since 4.5.3
     */ get altNumber() {
        return $eeOLb.ATN.INVALID_ALT_NUMBER;
    }
    /** Set the outer alternative number for this context node. Default
     *  implementation does nothing to avoid backing field overhead for
     *  trees that don't need it.  Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *
     *  @since 4.5.3
     */ set altNumber(altNumber) {
    // intentionally ignored by the base implementation
    }
    getChild(i) {
        throw new RangeError("i must be greater than or equal to 0 and less than childCount");
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitChildren(this);
    }
    toStringTree(recog) {
        return $iEJpM.Trees.toStringTree(this, recog);
    }
    toString(arg1, stop) {
        const ruleNames = arg1 instanceof $dwftT.Recognizer ? arg1.ruleNames : arg1;
        stop = stop || $2pDMz.ParserRuleContext.emptyContext();
        let buf = "";
        let p = this;
        buf += "[";
        while(p && p !== stop){
            if (!ruleNames) {
                if (!p.isEmpty) buf += p.invokingState;
            } else {
                let ruleIndex = p.ruleIndex;
                let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                buf += ruleName;
            }
            if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
            p = p._parent;
        }
        buf += "]";
        return buf.toString();
    }
}
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "sourceInterval", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "ruleContext", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "parent", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "setParent", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "payload", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "text", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "getChild", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "childCount", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "accept", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "toStringTree", null);
module.exports.RuleContext = $11ffaafc1554cb2d$var$RuleContext;

});
parcelRegister("UzGvw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleNode = void 0;
class $0aa0e94bd9481018$var$RuleNode {
}
module.exports.RuleNode = $0aa0e94bd9481018$var$RuleNode;

});

parcelRegister("iEJpM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d94f30dcc5121681$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d94f30dcc5121681$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trees = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $exlin = parcelRequire("exlin");

var $co9Xk = parcelRequire("co9Xk");

var $aN41m = parcelRequire("aN41m");

var $c9Sjf = parcelRequire("c9Sjf");

var $2pDMz = parcelRequire("2pDMz");

var $UzGvw = parcelRequire("UzGvw");

var $2IN61 = parcelRequire("2IN61");

var $eKXi4 = parcelRequire("eKXi4");

var $62Uvn = parcelRequire("62Uvn");
/** A set of utility routines useful for all kinds of ANTLR trees. */ class $d94f30dcc5121681$var$Trees {
    static toStringTree(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $c9Sjf.Parser) ruleNames = arg2.ruleNames;
        else ruleNames = arg2;
        let s = $62Uvn.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        if (t.childCount === 0) return s;
        let buf = "";
        buf += "(";
        s = $62Uvn.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        buf += s;
        buf += " ";
        for(let i = 0; i < t.childCount; i++){
            if (i > 0) buf += " ";
            buf += this.toStringTree(t.getChild(i), ruleNames);
        }
        buf += ")";
        return buf;
    }
    static getNodeText(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $c9Sjf.Parser) ruleNames = arg2.ruleNames;
        else if (arg2) ruleNames = arg2;
        else {
            // no recog or rule names
            let payload = t.payload;
            if (typeof payload.text === "string") return payload.text;
            return t.payload.toString();
        }
        if (t instanceof $UzGvw.RuleNode) {
            let ruleContext = t.ruleContext;
            let ruleIndex = ruleContext.ruleIndex;
            let ruleName = ruleNames[ruleIndex];
            let altNumber = ruleContext.altNumber;
            if (altNumber !== $eeOLb.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
            return ruleName;
        } else if (t instanceof $co9Xk.ErrorNode) return t.toString();
        else if (t instanceof $2IN61.TerminalNode) {
            let symbol = t.symbol;
            return symbol.text || "";
        }
        throw new TypeError("Unexpected node type");
    }
    static getChildren(t) {
        let kids = [];
        for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
        return kids;
    }
    static getAncestors(t) {
        let ancestors = [];
        let p = t.parent;
        while(p){
            ancestors.unshift(p); // insert at start
            p = p.parent;
        }
        return ancestors;
    }
    /** Return true if t is u's parent or a node on path to root from u.
     *  Use === not equals().
     *
     *  @since 4.5.1
     */ static isAncestorOf(t, u) {
        if (!t || !u || !t.parent) return false;
        let p = u.parent;
        while(p){
            if (t === p) return true;
            p = p.parent;
        }
        return false;
    }
    static findAllTokenNodes(t, ttype) {
        return $d94f30dcc5121681$var$Trees.findAllNodes(t, ttype, true);
    }
    static findAllRuleNodes(t, ruleIndex) {
        return $d94f30dcc5121681$var$Trees.findAllNodes(t, ruleIndex, false);
    }
    static findAllNodes(t, index, findTokens) {
        let nodes = [];
        $d94f30dcc5121681$var$Trees._findAllNodes(t, index, findTokens, nodes);
        return nodes;
    }
    static _findAllNodes(t, index, findTokens, nodes) {
        // check this node (the root) first
        if (findTokens && t instanceof $2IN61.TerminalNode) {
            if (t.symbol.type === index) nodes.push(t);
        } else if (!findTokens && t instanceof $2pDMz.ParserRuleContext) {
            if (t.ruleIndex === index) nodes.push(t);
        }
        // check children
        for(let i = 0; i < t.childCount; i++)$d94f30dcc5121681$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
    }
    /** Get all descendents; includes t itself.
     *
     * @since 4.5.1
     */ static getDescendants(t) {
        let nodes = [];
        function recurse(e) {
            nodes.push(e);
            const n = e.childCount;
            for(let i = 0; i < n; i++)recurse(e.getChild(i));
        }
        recurse(t);
        return nodes;
    }
    /** Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
     *  inclusively using postorder traversal.  Recursive depth-first-search.
     *
     *  @since 4.5
     */ static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let child = t.getChild(i);
            let r = $d94f30dcc5121681$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
            if (r) return r;
        }
        if (t instanceof $2pDMz.ParserRuleContext) {
            let stopToken = t.stop;
            if (startTokenIndex >= t.start.tokenIndex && // is range fully contained in t?
            (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) // note: r.stop==null likely implies that we bailed out of parser and there's nothing to the right
            return t;
        }
        return undefined;
    }
    /** Replace any subtree siblings of root that are completely to left
     *  or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
     *  node. The source interval for t is not altered to suit smaller range!
     *
     *  WARNING: destructive to t.
     *
     *  @since 4.5.1
     */ static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
        if (!t) return;
        let count = t.childCount;
        for(let i = 0; i < count; i++){
            let child = t.getChild(i);
            let range = child.sourceInterval;
            if (child instanceof $2pDMz.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                if ($d94f30dcc5121681$var$Trees.isAncestorOf(child, root)) {
                    let abbrev = new $exlin.CommonToken($eKXi4.Token.INVALID_TYPE, "...");
                    t.children[i] = new $2IN61.TerminalNode(abbrev); // HACK access to private
                }
            }
        }
    }
    static findNodeSuchThat(t, pred) {
        // No type check needed as long as users only use one of the available overloads
        if (pred(t)) return t;
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let u = $d94f30dcc5121681$var$Trees.findNodeSuchThat(t.getChild(i), pred);
            if (u !== undefined) return u;
        }
        return undefined;
    }
}
$d94f30dcc5121681$var$__decorate([
    $d94f30dcc5121681$var$__param(0, $aN41m.NotNull)
], $d94f30dcc5121681$var$Trees, "toStringTree", null);
$d94f30dcc5121681$var$__decorate([
    $aN41m.NotNull,
    $d94f30dcc5121681$var$__param(0, $aN41m.NotNull)
], $d94f30dcc5121681$var$Trees, "getAncestors", null);
$d94f30dcc5121681$var$__decorate([
    $d94f30dcc5121681$var$__param(0, $aN41m.NotNull)
], $d94f30dcc5121681$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
module.exports.Trees = $d94f30dcc5121681$var$Trees;

});



parcelRegister("hwoBE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cc18831aaf00aa66$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionMode = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $jWsYN = parcelRequire("jWsYN");
/**
 * This enumeration defines the prediction modes available in ANTLR 4 along with
 * utility methods for analyzing configuration sets for conflicts and/or
 * ambiguities.
 */ var $cc18831aaf00aa66$var$PredictionMode;
(function(PredictionMode) {
    /**
     * The SLL(*) prediction mode. This prediction mode ignores the current
     * parser context when making predictions. This is the fastest prediction
     * mode, and provides correct results for many grammars. This prediction
     * mode is more powerful than the prediction mode provided by ANTLR 3, but
     * may result in syntax errors for grammar and input combinations which are
     * not SLL.
     *
     * When using this prediction mode, the parser will either return a correct
     * parse tree (i.e. the same parse tree that would be returned with the
     * {@link #LL} prediction mode), or it will report a syntax error. If a
     * syntax error is encountered when using the {@link #SLL} prediction mode,
     * it may be due to either an actual syntax error in the input or indicate
     * that the particular combination of grammar and input requires the more
     * powerful {@link #LL} prediction abilities to complete successfully.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
    /**
     * The LL(*) prediction mode. This prediction mode allows the current parser
     * context to be used for resolving SLL conflicts that occur during
     * prediction. This is the fastest prediction mode that guarantees correct
     * parse results for all combinations of grammars with syntactically correct
     * inputs.
     *
     * When using this prediction mode, the parser will make correct decisions
     * for all syntactically-correct grammar and input combinations. However, in
     * cases where the grammar is truly ambiguous this prediction mode might not
     * report a precise answer for *exactly which* alternatives are
     * ambiguous.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL"] = 1] = "LL";
    /**
     * The LL(*) prediction mode with exact ambiguity detection. In addition to
     * the correctness guarantees provided by the {@link #LL} prediction mode,
     * this prediction mode instructs the prediction algorithm to determine the
     * complete and exact set of ambiguous alternatives for every ambiguous
     * decision encountered while parsing.
     *
     * This prediction mode may be used for diagnosing ambiguities during
     * grammar development. Due to the performance overhead of calculating sets
     * of ambiguous alternatives, this prediction mode should be avoided when
     * the exact results are not necessary.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
})($cc18831aaf00aa66$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
(function(PredictionMode) {
    /** A Map that uses just the state and the stack context as the key. */ // NOTE: Base type used to be FlexibleHashMap<ATNConfig, BitSet>
    class AltAndContextMap extends $jRlcM.Array2DHashMap {
        constructor(){
            super(AltAndContextConfigEqualityComparator.INSTANCE);
        }
    }
    class AltAndContextConfigEqualityComparator {
        AltAndContextConfigEqualityComparator() {
        // intentionally empty
        }
        /**
         * The hash code is only a function of the {@link ATNState#stateNumber}
         * and {@link ATNConfig#context}.
         */ hashCode(o) {
            let hashCode = $amQx9.MurmurHash.initialize(7);
            hashCode = $amQx9.MurmurHash.update(hashCode, o.state.stateNumber);
            hashCode = $amQx9.MurmurHash.update(hashCode, o.context);
            hashCode = $amQx9.MurmurHash.finish(hashCode, 2);
            return hashCode;
        }
        equals(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
        }
    }
    AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
    $cc18831aaf00aa66$var$__decorate([
        $aN41m.Override
    ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
    $cc18831aaf00aa66$var$__decorate([
        $aN41m.Override
    ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
    /**
     * Checks if any configuration in `configs` is in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if any configuration in `configs` is in a
     * {@link RuleStopState}, otherwise `false`
     */ function hasConfigInRuleStopState(configs) {
        for (let c of configs){
            if (c.state instanceof $jWsYN.RuleStopState) return true;
        }
        return false;
    }
    PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
    /**
     * Checks if all configurations in `configs` are in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if all configurations in `configs` are in a
     * {@link RuleStopState}, otherwise `false`
     */ function allConfigsInRuleStopStates(/*@NotNull*/ configs) {
        for (let config of configs){
            if (!(config.state instanceof $jWsYN.RuleStopState)) return false;
        }
        return true;
    }
    PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
})($cc18831aaf00aa66$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));

});

parcelRegister("eDtKk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $aa7bc8301b4366a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $aa7bc8301b4366a9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulatorState = void 0;

var $aN41m = parcelRequire("aN41m");

var $2pDMz = parcelRequire("2pDMz");
/**
 *
 * @author Sam Harwell
 */ let $aa7bc8301b4366a9$var$SimulatorState = class SimulatorState {
    constructor(outerContext, s0, useContext, remainingOuterContext){
        this.outerContext = outerContext != null ? outerContext : $2pDMz.ParserRuleContext.emptyContext();
        this.s0 = s0;
        this.useContext = useContext;
        this.remainingOuterContext = remainingOuterContext;
    }
};
$aa7bc8301b4366a9$var$SimulatorState = $aa7bc8301b4366a9$var$__decorate([
    $aa7bc8301b4366a9$var$__param(1, $aN41m.NotNull)
], $aa7bc8301b4366a9$var$SimulatorState);
module.exports.SimulatorState = $aa7bc8301b4366a9$var$SimulatorState;

});


parcelRegister("pC9Ki", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $04cfeef02e935189$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusBlockStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $jizfq = parcelRequire("jizfq");

var $aN41m = parcelRequire("aN41m");
/** Start of `(A|B|...)+` loop. Technically a decision state, but
 *  we don't use for code generation; somebody might need it, so I'm defining
 *  it for completeness. In reality, the {@link PlusLoopbackState} node is the
 *  real decision-making note for `A+`.
 */ class $04cfeef02e935189$var$PlusBlockStartState extends $jizfq.BlockStartState {
    get stateType() {
        return $fZESB.ATNStateType.PLUS_BLOCK_START;
    }
}
$04cfeef02e935189$var$__decorate([
    $aN41m.Override
], $04cfeef02e935189$var$PlusBlockStartState.prototype, "stateType", null);
module.exports.PlusBlockStartState = $04cfeef02e935189$var$PlusBlockStartState;

});

parcelRegister("a84wo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $75fe289bbbae0de7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusLoopbackState = void 0;

var $fZESB = parcelRequire("fZESB");

var $42ptv = parcelRequire("42ptv");

var $aN41m = parcelRequire("aN41m");
/** Decision state for `A+` and `(A|B)+`.  It has two transitions:
 *  one to the loop back to start of the block and one to exit.
 */ class $75fe289bbbae0de7$var$PlusLoopbackState extends $42ptv.DecisionState {
    get stateType() {
        return $fZESB.ATNStateType.PLUS_LOOP_BACK;
    }
}
$75fe289bbbae0de7$var$__decorate([
    $aN41m.Override
], $75fe289bbbae0de7$var$PlusLoopbackState.prototype, "stateType", null);
module.exports.PlusLoopbackState = $75fe289bbbae0de7$var$PlusLoopbackState;

});

parcelRegister("kIrC4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f14d5618acbd1a12$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f14d5618acbd1a12$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecedencePredicateTransition = void 0;

var $kvmNv = parcelRequire("kvmNv");

var $aN41m = parcelRequire("aN41m");

var $3JS45 = parcelRequire("3JS45");
/**
 *
 * @author Sam Harwell
 */ let $f14d5618acbd1a12$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $kvmNv.AbstractPredicateTransition {
    constructor(target, precedence){
        super(target);
        this.precedence = precedence;
    }
    get serializationType() {
        return 10 /* PRECEDENCE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $3JS45.SemanticContext.PrecedencePredicate(this.precedence);
    }
    toString() {
        return this.precedence + " >= _p";
    }
};
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "serializationType", null);
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "matches", null);
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "toString", null);
$f14d5618acbd1a12$var$PrecedencePredicateTransition = $f14d5618acbd1a12$var$__decorate([
    $f14d5618acbd1a12$var$__param(0, $aN41m.NotNull)
], $f14d5618acbd1a12$var$PrecedencePredicateTransition);
module.exports.PrecedencePredicateTransition = $f14d5618acbd1a12$var$PrecedencePredicateTransition;

});

parcelRegister("6WqDl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $50dcd1b7595942de$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $50dcd1b7595942de$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangeTransition = void 0;

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $50dcd1b7595942de$var$RangeTransition = class RangeTransition extends $5NWCj.Transition {
    constructor(target, from, to){
        super(target);
        this.from = from;
        this.to = to;
    }
    get serializationType() {
        return 2 /* RANGE */ ;
    }
    get label() {
        return $6kdz0.IntervalSet.of(this.from, this.to);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= this.from && symbol <= this.to;
    }
    toString() {
        return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
    }
};
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override
], $50dcd1b7595942de$var$RangeTransition.prototype, "serializationType", null);
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $50dcd1b7595942de$var$RangeTransition.prototype, "label", null);
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override
], $50dcd1b7595942de$var$RangeTransition.prototype, "matches", null);
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $50dcd1b7595942de$var$RangeTransition.prototype, "toString", null);
$50dcd1b7595942de$var$RangeTransition = $50dcd1b7595942de$var$__decorate([
    $50dcd1b7595942de$var$__param(0, $aN41m.NotNull)
], $50dcd1b7595942de$var$RangeTransition);
module.exports.RangeTransition = $50dcd1b7595942de$var$RangeTransition;

});

parcelRegister("UvARH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0a9dbce885ceff1c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStartState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
class $0a9dbce885ceff1c$var$RuleStartState extends $dv9vN.ATNState {
    constructor(){
        super(...arguments);
        this.isPrecedenceRule = false;
        this.leftFactored = false;
    }
    get stateType() {
        return $fZESB.ATNStateType.RULE_START;
    }
}
$0a9dbce885ceff1c$var$__decorate([
    $aN41m.Override
], $0a9dbce885ceff1c$var$RuleStartState.prototype, "stateType", null);
module.exports.RuleStartState = $0a9dbce885ceff1c$var$RuleStartState;

});

parcelRegister("ferBg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b16d929992a0672d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarBlockStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $jizfq = parcelRequire("jizfq");

var $aN41m = parcelRequire("aN41m");
/** The block that begins a closure loop. */ class $b16d929992a0672d$var$StarBlockStartState extends $jizfq.BlockStartState {
    get stateType() {
        return $fZESB.ATNStateType.STAR_BLOCK_START;
    }
}
$b16d929992a0672d$var$__decorate([
    $aN41m.Override
], $b16d929992a0672d$var$StarBlockStartState.prototype, "stateType", null);
module.exports.StarBlockStartState = $b16d929992a0672d$var$StarBlockStartState;

});

parcelRegister("9kZdU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6cc579002aad9995$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopbackState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
class $6cc579002aad9995$var$StarLoopbackState extends $dv9vN.ATNState {
    get loopEntryState() {
        return this.transition(0).target;
    }
    get stateType() {
        return $fZESB.ATNStateType.STAR_LOOP_BACK;
    }
}
$6cc579002aad9995$var$__decorate([
    $aN41m.Override
], $6cc579002aad9995$var$StarLoopbackState.prototype, "stateType", null);
module.exports.StarLoopbackState = $6cc579002aad9995$var$StarLoopbackState;

});

parcelRegister("J9RdB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $087bd98cf80f5dfc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokensStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $42ptv = parcelRequire("42ptv");

var $aN41m = parcelRequire("aN41m");
/** The Tokens rule start state linking to each lexer rule start state */ class $087bd98cf80f5dfc$var$TokensStartState extends $42ptv.DecisionState {
    get stateType() {
        return $fZESB.ATNStateType.TOKEN_START;
    }
}
$087bd98cf80f5dfc$var$__decorate([
    $aN41m.Override
], $087bd98cf80f5dfc$var$TokensStartState.prototype, "stateType", null);
module.exports.TokensStartState = $087bd98cf80f5dfc$var$TokensStartState;

});

parcelRegister("f0PQ3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = void 0;

var $amQx9 = parcelRequire("amQx9");
class $02d20ca9e1d240ed$var$UUID {
    constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
        this.data = new Uint32Array(4);
        this.data[0] = mostSigBits;
        this.data[1] = moreSigBits;
        this.data[2] = lessSigBits;
        this.data[3] = leastSigBits;
    }
    static fromString(data) {
        if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
        let segments = data.split("-");
        let mostSigBits = parseInt(segments[0], 16);
        let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
        let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
        let leastSigBits = parseInt(segments[4].substr(-8), 16);
        return new $02d20ca9e1d240ed$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    hashCode() {
        return $amQx9.MurmurHash.hashCode([
            this.data[0],
            this.data[1],
            this.data[2],
            this.data[3]
        ]);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $02d20ca9e1d240ed$var$UUID)) return false;
        return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
    }
    toString() {
        return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
    }
}
module.exports.UUID = $02d20ca9e1d240ed$var$UUID;

});


parcelRegister("8EOCV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $64d95490c532b14b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $64d95490c532b14b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseInfo = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */ let $64d95490c532b14b$var$ParseInfo = class ParseInfo {
    constructor(atnSimulator){
        this.atnSimulator = atnSimulator;
    }
    /**
     * Gets an array of {@link DecisionInfo} instances containing the profiling
     * information gathered for each decision in the ATN.
     *
     * @returns An array of {@link DecisionInfo} instances, indexed by decision
     * number.
     */ getDecisionInfo() {
        return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */ getLLDecisions() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let LL = [];
        for(let i = 0; i < decisions.length; i++){
            let fallBack = decisions[i].LL_Fallback;
            if (fallBack > 0) LL.push(i);
        }
        return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */ getTotalTimeInPrediction() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let t = 0;
        for (let decision of decisions)t += decision.timeInPrediction;
        return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */ getTotalSLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */ getTotalLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */ getTotalSLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */ getTotalLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */ getTotalATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions){
            k += decision.SLL_ATNTransitions;
            k += decision.LL_ATNTransitions;
        }
        return k;
    }
    getDFASize(decision) {
        if (decision) {
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
            return decisionToDFA.states.size;
        } else {
            let n = 0;
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
            for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
            return n;
        }
    }
};
$64d95490c532b14b$var$__decorate([
    $aN41m.NotNull
], $64d95490c532b14b$var$ParseInfo.prototype, "getDecisionInfo", null);
$64d95490c532b14b$var$__decorate([
    $aN41m.NotNull
], $64d95490c532b14b$var$ParseInfo.prototype, "getLLDecisions", null);
$64d95490c532b14b$var$ParseInfo = $64d95490c532b14b$var$__decorate([
    $64d95490c532b14b$var$__param(0, $aN41m.NotNull)
], $64d95490c532b14b$var$ParseInfo);
module.exports.ParseInfo = $64d95490c532b14b$var$ParseInfo;

});

parcelRegister("jdbdJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $dfc7ef60d4f1d1dc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyParserErrorListener = void 0;

var $3Wiwr = parcelRequire("3Wiwr");

var $aN41m = parcelRequire("aN41m");
/**
 * @author Sam Harwell
 */ class $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener extends $3Wiwr.ProxyErrorListener {
    constructor(delegates){
        super(delegates);
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        });
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        });
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
        });
    }
}
$dfc7ef60d4f1d1dc$var$__decorate([
    $aN41m.Override
], $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
$dfc7ef60d4f1d1dc$var$__decorate([
    $aN41m.Override
], $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
$dfc7ef60d4f1d1dc$var$__decorate([
    $aN41m.Override
], $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
module.exports.ProxyParserErrorListener = $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener;

});

parcelRegister("gQja9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iWnPX").then(()=>parcelRequire('kU89k'));

});

parcelRegister("kTiidv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6JQOE").then(()=>parcelRequire('aVl0f'));

});




parcelRegister("hXb5J", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseCancellationException = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:42.5447085-07:00
/**
 * This exception is thrown to cancel a parsing operation. This exception does
 * not extend {@link RecognitionException}, allowing it to bypass the standard
 * error recovery mechanisms. {@link BailErrorStrategy} throws this exception in
 * response to a parse error.
 *
 * @author Sam Harwell
 */ class $d1208ce2fa370cab$var$ParseCancellationException extends Error {
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.stack = cause.stack;
    }
    getCause() {
        return this.cause;
    }
}
module.exports.ParseCancellationException = $d1208ce2fa370cab$var$ParseCancellationException;

});


parcelRegister("doEv1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9c0cee8efd4f75ec$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9c0cee8efd4f75ec$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferedTokenStream = void 0;

var $fomfP = parcelRequire("fomfP");

var $exlin = parcelRequire("exlin");

var $l8y5T = parcelRequire("l8y5T");

var $h7Q3L = parcelRequire("h7Q3L");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This implementation of {@link TokenStream} loads tokens from a
 * {@link TokenSource} on-demand, and places the tokens in a buffer to provide
 * access to any previous token by index.
 *
 * This token stream ignores the value of {@link Token#getChannel}. If your
 * parser requires the token stream filter tokens to only those on a particular
 * channel, such as {@link Token#DEFAULT_CHANNEL} or
 * {@link Token#HIDDEN_CHANNEL}, use a filtering token stream such a
 * {@link CommonTokenStream}.
 */ let $9c0cee8efd4f75ec$var$BufferedTokenStream = class BufferedTokenStream {
    constructor(tokenSource){
        /**
         * A collection of all tokens fetched from the token source. The list is
         * considered a complete view of the input once {@link #fetchedEOF} is set
         * to `true`.
         */ this.tokens = [];
        /**
         * The index into {@link #tokens} of the current token (next token to
         * {@link #consume}). {@link #tokens}`[`{@link #p}`]` should be
         * {@link #LT LT(1)}.
         *
         * This field is set to -1 when the stream is first constructed or when
         * {@link #setTokenSource} is called, indicating that the first token has
         * not yet been fetched from the token source. For additional information,
         * see the documentation of {@link IntStream} for a description of
         * Initializing Methods.
         */ this.p = -1;
        /**
         * Indicates whether the {@link Token#EOF} token has been fetched from
         * {@link #tokenSource} and added to {@link #tokens}. This field improves
         * performance for the following cases:
         *
         * * {@link #consume}: The lookahead check in {@link #consume} to prevent
         *   consuming the EOF symbol is optimized by checking the values of
         *   {@link #fetchedEOF} and {@link #p} instead of calling {@link #LA}.
         * * {@link #fetch}: The check to prevent adding multiple EOF symbols into
         *   {@link #tokens} is trivial with this field.
         */ this.fetchedEOF = false;
        if (tokenSource == null) throw new Error("tokenSource cannot be null");
        this._tokenSource = tokenSource;
    }
    get tokenSource() {
        return this._tokenSource;
    }
    /** Reset this token stream by setting its token source. */ set tokenSource(tokenSource) {
        this._tokenSource = tokenSource;
        this.tokens.length = 0;
        this.p = -1;
        this.fetchedEOF = false;
    }
    get index() {
        return this.p;
    }
    mark() {
        return 0;
    }
    release(marker) {
    // no resources to release
    }
    seek(index) {
        this.lazyInit();
        this.p = this.adjustSeekIndex(index);
    }
    get size() {
        return this.tokens.length;
    }
    consume() {
        let skipEofCheck;
        if (this.p >= 0) {
            if (this.fetchedEOF) // the last token in tokens is EOF. skip check if p indexes any
            // fetched token except the last.
            skipEofCheck = this.p < this.tokens.length - 1;
            else // no EOF token in tokens. skip check if p indexes a fetched token.
            skipEofCheck = this.p < this.tokens.length;
        } else // not yet initialized
        skipEofCheck = false;
        if (!skipEofCheck && this.LA(1) === $eKXi4.Token.EOF) throw new Error("cannot consume EOF");
        if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
    }
    /** Make sure index `i` in tokens has a token.
     *
     * @returns `true` if a token is located at index `i`, otherwise
     *    `false`.
     * @see #get(int i)
     */ sync(i) {
        $fomfP(i >= 0);
        let n = i - this.tokens.length + 1; // how many more elements we need?
        //System.out.println("sync("+i+") needs "+n);
        if (n > 0) {
            let fetched = this.fetch(n);
            return fetched >= n;
        }
        return true;
    }
    /** Add `n` elements to buffer.
     *
     * @returns The actual number of elements added to the buffer.
     */ fetch(n) {
        if (this.fetchedEOF) return 0;
        for(let i = 0; i < n; i++){
            let t = this.tokenSource.nextToken();
            if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
            this.tokens.push(t);
            if (t.type === $eKXi4.Token.EOF) {
                this.fetchedEOF = true;
                return i + 1;
            }
        }
        return n;
    }
    get(i) {
        if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
        return this.tokens[i];
    }
    /** Get all tokens from start..stop inclusively. */ getRange(start, stop) {
        if (start < 0 || stop < 0) return [];
        this.lazyInit();
        let subset = new Array();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $eKXi4.Token.EOF) break;
            subset.push(t);
        }
        return subset;
    }
    LA(i) {
        let token = this.LT(i);
        if (!token) return $eKXi4.Token.INVALID_TYPE;
        return token.type;
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        return this.tokens[this.p - k];
    }
    LT(k) {
        let result = this.tryLT(k);
        if (result === undefined) throw new RangeError("requested lookback index out of range");
        return result;
    }
    tryLT(k) {
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p + k - 1;
        this.sync(i);
        if (i >= this.tokens.length) // return EOF token
        // EOF must be last token
        return this.tokens[this.tokens.length - 1];
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /**
     * Allowed derived classes to modify the behavior of operations which change
     * the current stream position by adjusting the target token index of a seek
     * operation. The default implementation simply returns `i`. If an
     * exception is thrown in this method, the current stream index should not be
     * changed.
     *
     * For example, {@link CommonTokenStream} overrides this method to ensure that
     * the seek target is always an on-channel token.
     *
     * @param i The target token index.
     * @returns The adjusted target token index.
     */ adjustSeekIndex(i) {
        return i;
    }
    lazyInit() {
        if (this.p === -1) this.setup();
    }
    setup() {
        this.sync(0);
        this.p = this.adjustSeekIndex(0);
    }
    /** Given a start and stop index, return a `List` of all tokens in
     *  the token type `BitSet`.  Return an empty array if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */ getTokens(start, stop, types) {
        this.lazyInit();
        if (start === undefined) {
            $fomfP(stop === undefined && types === undefined);
            return this.tokens;
        } else if (stop === undefined) stop = this.tokens.length - 1;
        if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
        if (start > stop) return [];
        if (types === undefined) return this.tokens.slice(start, stop + 1);
        else if (typeof types === "number") types = new Set().add(types);
        let typesSet = types;
        // list = tokens[start:stop]:{T t, t.type in types}
        let filteredTokens = this.tokens.slice(start, stop + 1);
        filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
        return filteredTokens;
    }
    /**
     * Given a starting index, return the index of the next token on channel.
     * Return `i` if `tokens[i]` is on channel. Return the index of
     * the EOF token if there are no tokens on channel between `i` and
     * EOF.
     */ nextTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) return this.size - 1;
        let token = this.tokens[i];
        while(token.channel !== channel){
            if (token.type === $eKXi4.Token.EOF) return i;
            i++;
            this.sync(i);
            token = this.tokens[i];
        }
        return i;
    }
    /**
     * Given a starting index, return the index of the previous token on
     * channel. Return `i` if `tokens[i]` is on channel. Return -1
     * if there are no tokens on channel between `i` and 0.
     *
     * If `i` specifies an index at or after the EOF token, the EOF token
     * index is returned. This is due to the fact that the EOF token is treated
     * as though it were on every channel.
     */ previousTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) // the EOF token is on every channel
        return this.size - 1;
        while(i >= 0){
            let token = this.tokens[i];
            if (token.type === $eKXi4.Token.EOF || token.channel === channel) return i;
            i--;
        }
        return i;
    }
    /** Collect all tokens on specified channel to the right of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL} or
     *  EOF. If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToRight(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $h7Q3L.Lexer.DEFAULT_TOKEN_CHANNEL);
        let to;
        let from = tokenIndex + 1;
        // if none onchannel to right, nextOnChannel=-1 so set to = last token
        if (nextOnChannel === -1) to = this.size - 1;
        else to = nextOnChannel;
        return this.filterForChannel(from, to, channel);
    }
    /** Collect all tokens on specified channel to the left of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL}.
     *  If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToLeft(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        if (tokenIndex === 0) // obviously no tokens can appear before the first token
        return [];
        let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $h7Q3L.Lexer.DEFAULT_TOKEN_CHANNEL);
        if (prevOnChannel === tokenIndex - 1) return [];
        // if none onchannel to left, prevOnChannel=-1 then from=0
        let from = prevOnChannel + 1;
        let to = tokenIndex - 1;
        return this.filterForChannel(from, to, channel);
    }
    filterForChannel(from, to, channel) {
        let hidden = new Array();
        for(let i = from; i <= to; i++){
            let t = this.tokens[i];
            if (channel === -1) {
                if (t.channel !== $h7Q3L.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
            } else if (t.channel === channel) hidden.push(t);
        }
        return hidden;
    }
    get sourceName() {
        return this.tokenSource.sourceName;
    }
    getText(interval) {
        if (interval === undefined) interval = $l8y5T.Interval.of(0, this.size - 1);
        else if (!(interval instanceof $l8y5T.Interval)) // Note: the more obvious check for 'instanceof RuleContext' results in a circular dependency problem
        interval = interval.sourceInterval;
        let start = interval.a;
        let stop = interval.b;
        if (start < 0 || stop < 0) return "";
        this.fill();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        let buf = "";
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $eKXi4.Token.EOF) break;
            buf += t.text;
        }
        return buf.toString();
    }
    getTextFromRange(start, stop) {
        if (this.isToken(start) && this.isToken(stop)) return this.getText($l8y5T.Interval.of(start.tokenIndex, stop.tokenIndex));
        return "";
    }
    /** Get all tokens from lexer until EOF. */ fill() {
        this.lazyInit();
        const blockSize = 1000;
        while(true){
            let fetched = this.fetch(blockSize);
            if (fetched < blockSize) return;
        }
    }
    // TODO: Figure out a way to make this more flexible?
    isWritableToken(t) {
        return t instanceof $exlin.CommonToken;
    }
    // TODO: Figure out a way to make this more flexible?
    isToken(t) {
        return t instanceof $exlin.CommonToken;
    }
};
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "tokenSource", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "index", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "mark", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "release", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "seek", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "size", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "consume", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "get", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "LA", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull,
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "LT", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "sourceName", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull,
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "getText", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull,
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "getTextFromRange", null);
$9c0cee8efd4f75ec$var$BufferedTokenStream = $9c0cee8efd4f75ec$var$__decorate([
    $9c0cee8efd4f75ec$var$__param(0, $aN41m.NotNull)
], $9c0cee8efd4f75ec$var$BufferedTokenStream);
module.exports.BufferedTokenStream = $9c0cee8efd4f75ec$var$BufferedTokenStream;

});

parcelRegister("aUhGF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8tY30", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharStreams = void 0;

var $cNEtm = parcelRequire("cNEtm");

var $1EXcP = parcelRequire("1EXcP");

var $ldi9e = parcelRequire("ldi9e");
// const DEFAULT_BUFFER_SIZE: number = 4096;
/** This class represents the primary interface for creating {@link CharStream}s
 *  from a variety of sources as of 4.7.  The motivation was to support
 *  Unicode code points > U+FFFF.  {@link ANTLRInputStream} and
 *  {@link ANTLRFileStream} are now deprecated in favor of the streams created
 *  by this interface.
 *
 *  DEPRECATED: {@code new ANTLRFileStream("myinputfile")}
 *  NEW:        {@code CharStreams.fromFileName("myinputfile")}
 *
 *  WARNING: If you use both the deprecated and the new streams, you will see
 *  a nontrivial performance degradation. This speed hit is because the
 *  {@link Lexer}'s internal code goes from a monomorphic to megamorphic
 *  dynamic dispatch to get characters from the input stream. Java's
 *  on-the-fly compiler (JIT) is unable to perform the same optimizations
 *  so stick with either the old or the new streams, if performance is
 *  a primary concern. See the extreme debugging and spelunking
 *  needed to identify this issue in our timing rig:
 *
 *      https://github.com/antlr/antlr4/pull/1781
 *
 *  The ANTLR character streams still buffer all the input when you create
 *  the stream, as they have done for ~20 years. If you need unbuffered
 *  access, please note that it becomes challenging to create
 *  parse trees. The parse tree has to point to tokens which will either
 *  point into a stale location in an unbuffered stream or you have to copy
 *  the characters out of the buffer into the token. That defeats the purpose
 *  of unbuffered input. Per the ANTLR book, unbuffered streams are primarily
 *  useful for processing infinite streams *during the parse.*
 *
 *  The new streams also use 8-bit buffers when possible so this new
 *  interface supports character streams that use half as much memory
 *  as the old {@link ANTLRFileStream}, which assumed 16-bit characters.
 *
 *  A big shout out to Ben Hamilton (github bhamiltoncx) for his superhuman
 *  efforts across all targets to get true Unicode 3.1 support for U+10FFFF.
 *
 *  @since 4.7
 */ var $62cf9c5e285e940f$var$CharStreams;
(function(CharStreams) {
    // /**
    //  * Creates a {@link CharStream} given a path to a UTF-8
    //  * encoded file on disk.
    //  *
    //  * Reads the entire contents of the file into the result before returning.
    //  */
    // export function fromFile(file: File): CharStream;
    // export function fromFile(file: File, charset: Charset): CharStream;
    // export function fromFile(file: File, charset?: Charset): CharStream {
    // 	if (charset === undefined) {
    // 		charset = Charset.forName("UTF-8");
    // 	}
    function fromString(s, sourceName) {
        if (sourceName === undefined || sourceName.length === 0) sourceName = $ldi9e.IntStream.UNKNOWN_SOURCE_NAME;
        // Initial guess assumes no code points > U+FFFF: one code
        // point for each code unit in the string
        let codePointBufferBuilder = $cNEtm.CodePointBuffer.builder(s.length);
        // TODO: CharBuffer.wrap(String) rightfully returns a read-only buffer
        // which doesn't expose its array, so we make a copy.
        let cb = new Uint16Array(s.length);
        for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
        codePointBufferBuilder.append(cb);
        return $1EXcP.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
    }
    CharStreams.fromString = fromString;
// export function bufferFromChannel(
// 	channel: ReadableByteChannel,
// 	charset: Charset,
// 	bufferSize: number,
// 	decodingErrorAction: CodingErrorAction,
// 	inputSize: number): CodePointBuffer {
// 	try {
// 		let utf8BytesIn: Uint8Array = new Uint8Array(bufferSize);
// 		let utf16CodeUnitsOut: Uint16Array = new Uint16Array(bufferSize);
// 		if (inputSize === -1) {
// 			inputSize = bufferSize;
// 		} else if (inputSize > Integer.MAX_VALUE) {
// 			// ByteBuffer et al don't support long sizes
// 			throw new RangeError(`inputSize ${inputSize} larger than max ${Integer.MAX_VALUE}`);
// 		}
// 		let codePointBufferBuilder: CodePointBuffer.Builder = CodePointBuffer.builder(inputSize);
// 		let decoder: CharsetDecoder = charset
// 				.newDecoder()
// 				.onMalformedInput(decodingErrorAction)
// 				.onUnmappableCharacter(decodingErrorAction);
// 		let endOfInput: boolean = false;
// 		while (!endOfInput) {
// 			let bytesRead: number = channel.read(utf8BytesIn);
// 			endOfInput = (bytesRead === -1);
// 			utf8BytesIn.flip();
// 			let result: CoderResult = decoder.decode(
// 				utf8BytesIn,
// 				utf16CodeUnitsOut,
// 				endOfInput);
// 			if (result.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 				result.throwException();
// 			}
// 			utf16CodeUnitsOut.flip();
// 			codePointBufferBuilder.append(utf16CodeUnitsOut);
// 			utf8BytesIn.compact();
// 			utf16CodeUnitsOut.compact();
// 		}
// 		// Handle any bytes at the end of the file which need to
// 		// be represented as errors or substitution characters.
// 		let flushResult: CoderResult = decoder.flush(utf16CodeUnitsOut);
// 		if (flushResult.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 			flushResult.throwException();
// 		}
// 		utf16CodeUnitsOut.flip();
// 		codePointBufferBuilder.append(utf16CodeUnitsOut);
// 		return codePointBufferBuilder.build();
// 	}
// 	finally {
// 		channel.close();
// 	}
// }
})($62cf9c5e285e940f$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));

});
parcelRegister("cNEtm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointBuffer = void 0;

var $fomfP = parcelRequire("fomfP");

var $2ImFx = parcelRequire("2ImFx");
/**
 * Wrapper for `Uint8Array` / `Uint16Array` / `Int32Array`.
 */ class $951974a04eabf1bc$var$CodePointBuffer {
    constructor(buffer, size){
        this.buffer = buffer;
        this._position = 0;
        this._size = size;
    }
    static withArray(buffer) {
        return new $951974a04eabf1bc$var$CodePointBuffer(buffer, buffer.length);
    }
    get position() {
        return this._position;
    }
    set position(newPosition) {
        if (newPosition < 0 || newPosition > this._size) throw new RangeError();
        this._position = newPosition;
    }
    get remaining() {
        return this._size - this.position;
    }
    get(offset) {
        return this.buffer[offset];
    }
    array() {
        return this.buffer.slice(0, this._size);
    }
    static builder(initialBufferSize) {
        return new $951974a04eabf1bc$var$CodePointBuffer.Builder(initialBufferSize);
    }
}
module.exports.CodePointBuffer = $951974a04eabf1bc$var$CodePointBuffer;
(function(CodePointBuffer) {
    let Type;
    (function(Type) {
        Type[Type["BYTE"] = 0] = "BYTE";
        Type[Type["CHAR"] = 1] = "CHAR";
        Type[Type["INT"] = 2] = "INT";
    })(Type || (Type = {}));
    class Builder {
        constructor(initialBufferSize){
            this.type = 0 /* BYTE */ ;
            this.buffer = new Uint8Array(initialBufferSize);
            this.prevHighSurrogate = -1;
            this.position = 0;
        }
        build() {
            return new CodePointBuffer(this.buffer, this.position);
        }
        static roundUpToNextPowerOfTwo(i) {
            let nextPowerOfTwo = 32 - Math.clz32(i - 1);
            return Math.pow(2, nextPowerOfTwo);
        }
        ensureRemaining(remainingNeeded) {
            switch(this.type){
                case 0 /* BYTE */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint8Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 1 /* CHAR */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint16Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 2 /* INT */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Int32Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
            }
        }
        append(utf16In) {
            this.ensureRemaining(utf16In.length);
            this.appendArray(utf16In);
        }
        appendArray(utf16In) {
            switch(this.type){
                case 0 /* BYTE */ :
                    this.appendArrayByte(utf16In);
                    break;
                case 1 /* CHAR */ :
                    this.appendArrayChar(utf16In);
                    break;
                case 2 /* INT */ :
                    this.appendArrayInt(utf16In);
                    break;
            }
        }
        appendArrayByte(utf16In) {
            $fomfP(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outByte = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (c <= 0xFF) outByte[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    if (!$2ImFx.isHighSurrogate(c)) {
                        this.byteToCharBuffer(utf16In.length);
                        this.appendArrayChar(utf16In);
                        return;
                    } else {
                        this.byteToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayChar(utf16In) {
            $fomfP(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outChar = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (!$2ImFx.isHighSurrogate(c)) outChar[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    this.charToIntBuffer(utf16In.length);
                    this.appendArrayInt(utf16In);
                    return;
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayInt(utf16In) {
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outInt = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                inOffset++;
                if (this.prevHighSurrogate !== -1) {
                    if ($2ImFx.isLowSurrogate(c)) {
                        outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                        outOffset++;
                        this.prevHighSurrogate = -1;
                    } else {
                        // Dangling high surrogate
                        outInt[outOffset] = this.prevHighSurrogate;
                        outOffset++;
                        if ($2ImFx.isHighSurrogate(c)) this.prevHighSurrogate = c;
                        else {
                            outInt[outOffset] = c;
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        }
                    }
                } else if ($2ImFx.isHighSurrogate(c)) this.prevHighSurrogate = c;
                else {
                    outInt[outOffset] = c;
                    outOffset++;
                }
            }
            if (this.prevHighSurrogate !== -1) {
                // Dangling high surrogate
                outInt[outOffset] = this.prevHighSurrogate;
                outOffset++;
            }
            this.position = outOffset;
        }
        byteToCharBuffer(toAppend) {
            // CharBuffers hold twice as much per unit as ByteBuffers, so start with half the capacity.
            let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 1 /* CHAR */ ;
            this.buffer = newBuffer;
        }
        byteToIntBuffer(toAppend) {
            // IntBuffers hold four times as much per unit as ByteBuffers, so start with one quarter the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        charToIntBuffer(toAppend) {
            // IntBuffers hold two times as much per unit as ByteBuffers, so start with one half the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
    }
    CodePointBuffer.Builder = Builder;
})($951974a04eabf1bc$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));

});
parcelRegister("2ImFx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
function $1fa1466b3c6105b0$var$isHighSurrogate(ch) {
    return ch >= 0xD800 && ch <= 0xDBFF;
}
module.exports.isHighSurrogate = $1fa1466b3c6105b0$var$isHighSurrogate;
function $1fa1466b3c6105b0$var$isLowSurrogate(ch) {
    return ch >= 0xDC00 && ch <= 0xDFFF;
}
module.exports.isLowSurrogate = $1fa1466b3c6105b0$var$isLowSurrogate;
function $1fa1466b3c6105b0$var$isSupplementaryCodePoint(ch) {
    return ch >= 0x10000;
}
module.exports.isSupplementaryCodePoint = $1fa1466b3c6105b0$var$isSupplementaryCodePoint;

});


parcelRegister("1EXcP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $135773ef6fd5bbbc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointCharStream = void 0;

var $fomfP = parcelRequire("fomfP");

var $ldi9e = parcelRequire("ldi9e");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");
/**
 * Alternative to {@link ANTLRInputStream} which treats the input
 * as a series of Unicode code points, instead of a series of UTF-16
 * code units.
 *
 * Use this if you need to parse input which potentially contains
 * Unicode values > U+FFFF.
 */ class $135773ef6fd5bbbc$var$CodePointCharStream {
    // Use the factory method {@link #fromBuffer(CodePointBuffer)} to
    // construct instances of this type.
    constructor(array, position, remaining, name){
        // TODO
        $fomfP(position === 0);
        this._array = array;
        this._size = remaining;
        this._name = name;
        this._position = 0;
    }
    get internalStorage() {
        return this._array;
    }
    static fromBuffer(codePointBuffer, name) {
        if (name === undefined || name.length === 0) name = $ldi9e.IntStream.UNKNOWN_SOURCE_NAME;
        // Java lacks generics on primitive types.
        //
        // To avoid lots of calls to virtual methods in the
        // very hot codepath of LA() below, we construct one
        // of three concrete subclasses.
        //
        // The concrete subclasses directly access the code
        // points stored in the underlying array (byte[],
        // char[], or int[]), so we can avoid lots of virtual
        // method calls to ByteBuffer.get(offset).
        return new $135773ef6fd5bbbc$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
    }
    consume() {
        if (this._size - this._position === 0) {
            $fomfP(this.LA(1) === $ldi9e.IntStream.EOF);
            throw new RangeError("cannot consume EOF");
        }
        this._position++;
    }
    get index() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    seek(index) {
        this._position = index;
    }
    get sourceName() {
        return this._name;
    }
    toString() {
        return this.getText($l8y5T.Interval.of(0, this.size - 1));
    }
    LA(i) {
        let offset;
        switch(Math.sign(i)){
            case -1:
                offset = this.index + i;
                if (offset < 0) return $ldi9e.IntStream.EOF;
                return this._array[offset];
            case 0:
                // Undefined
                return 0;
            case 1:
                offset = this.index + i - 1;
                if (offset >= this.size) return $ldi9e.IntStream.EOF;
                return this._array[offset];
        }
        throw new RangeError("Not reached");
    }
    /** Return the UTF-16 encoded string for the given interval */ getText(interval) {
        const startIdx = Math.min(interval.a, this.size);
        const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
        if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
    }
}
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "consume", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "index", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "size", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "mark", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "release", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "seek", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "sourceName", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "toString", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "LA", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "getText", null);
module.exports.CodePointCharStream = $135773ef6fd5bbbc$var$CodePointCharStream;

});


parcelRegister("eCP5Y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $aa5c3fc2017da3f2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $aa5c3fc2017da3f2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenStream = void 0;

var $doEv1 = parcelRequire("doEv1");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This class extends {@link BufferedTokenStream} with functionality to filter
 * token streams to tokens on a particular channel (tokens where
 * {@link Token#getChannel} returns a particular value).
 *
 * This token stream provides access to all tokens by index or when calling
 * methods like {@link #getText}. The channel filtering is only used for code
 * accessing tokens via the lookahead methods {@link #LA}, {@link #LT}, and
 * {@link #LB}.
 *
 * By default, tokens are placed on the default channel
 * ({@link Token#DEFAULT_CHANNEL}), but may be reassigned by using the
 * `->channel(HIDDEN)` lexer command, or by using an embedded action to
 * call {@link Lexer#setChannel}.
 *
 * Note: lexer rules which use the `->skip` lexer command or call
 * {@link Lexer#skip} do not produce tokens at all, so input text matched by
 * such a rule will not be available as part of the token stream, regardless of
 * channel.
 */ let $aa5c3fc2017da3f2$var$CommonTokenStream = class CommonTokenStream extends $doEv1.BufferedTokenStream {
    /**
     * Constructs a new {@link CommonTokenStream} using the specified token
     * source and filtering tokens to the specified channel. Only tokens whose
     * {@link Token#getChannel} matches `channel` or have the
     * `Token.type` equal to {@link Token#EOF} will be returned by the
     * token stream lookahead methods.
     *
     * @param tokenSource The token source.
     * @param channel The channel to use for filtering tokens.
     */ constructor(tokenSource, channel = $eKXi4.Token.DEFAULT_CHANNEL){
        super(tokenSource);
        this.channel = channel;
    }
    adjustSeekIndex(i) {
        return this.nextTokenOnChannel(i, this.channel);
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        let i = this.p;
        let n = 1;
        // find k good tokens looking backwards
        while(n <= k && i > 0){
            // skip off-channel tokens
            i = this.previousTokenOnChannel(i - 1, this.channel);
            n++;
        }
        if (i < 0) return undefined;
        return this.tokens[i];
    }
    tryLT(k) {
        //System.out.println("enter LT("+k+")");
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p;
        let n = 1; // we know tokens[p] is a good one
        // find k good tokens
        while(n < k){
            // skip off-channel tokens, but make sure to not look past EOF
            if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
            n++;
        }
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /** Count EOF just once. */ getNumberOfOnChannelTokens() {
        let n = 0;
        this.fill();
        for (let t of this.tokens){
            if (t.channel === this.channel) n++;
            if (t.type === $eKXi4.Token.EOF) break;
        }
        return n;
    }
};
$aa5c3fc2017da3f2$var$__decorate([
    $aN41m.Override
], $aa5c3fc2017da3f2$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
$aa5c3fc2017da3f2$var$__decorate([
    $aN41m.Override
], $aa5c3fc2017da3f2$var$CommonTokenStream.prototype, "tryLB", null);
$aa5c3fc2017da3f2$var$__decorate([
    $aN41m.Override
], $aa5c3fc2017da3f2$var$CommonTokenStream.prototype, "tryLT", null);
$aa5c3fc2017da3f2$var$CommonTokenStream = $aa5c3fc2017da3f2$var$__decorate([
    $aa5c3fc2017da3f2$var$__param(0, $aN41m.NotNull)
], $aa5c3fc2017da3f2$var$CommonTokenStream);
module.exports.CommonTokenStream = $aa5c3fc2017da3f2$var$CommonTokenStream;

});

parcelRegister("9xPUt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dependents = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.1349829-07:00
/**
 *
 * @author Sam Harwell
 */ var $6f2f765ae75dbe26$var$Dependents;
(function(Dependents) {
    /**
     * The element is dependent upon the specified rule.
     */ Dependents[Dependents["SELF"] = 0] = "SELF";
    /**
     * The element is dependent upon the set of the specified rule's parents
     * (rules which directly reference it).
     */ Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
    /**
     * The element is dependent upon the set of the specified rule's children
     * (rules which it directly references).
     */ Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
    /**
     * The element is dependent upon the set of the specified rule's ancestors
     * (the transitive closure of `PARENTS` rules).
     */ Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
    /**
     * The element is dependent upon the set of the specified rule's descendants
     * (the transitive closure of `CHILDREN` rules).
     */ Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
    /**
     * The element is dependent upon the set of the specified rule's siblings
     * (the union of `CHILDREN` of its `PARENTS`).
     */ Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear before a reference to the rule).
     */ Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's following
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear after a reference to the rule).
     */ Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * elements (rules which might end before the start of the specified rule
     * while parsing). This is calculated by taking the
     * `PRECEEDING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
    /**
     * The element is dependent upon the set of the specified rule's following
     * elements (rules which might start after the end of the specified rule
     * while parsing). This is calculated by taking the
     * `FOLLOWING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
})($6f2f765ae75dbe26$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));

});

parcelRegister("67k7F", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4743017423787884$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4743017423787884$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticErrorListener = void 0;

var $8WIez = parcelRequire("8WIez");

var $aN41m = parcelRequire("aN41m");

var $l8y5T = parcelRequire("l8y5T");
/**
 * This implementation of {@link ANTLRErrorListener} can be used to identify
 * certain potential correctness and performance problems in grammars. "Reports"
 * are made by calling {@link Parser#notifyErrorListeners} with the appropriate
 * message.
 *
 * * **Ambiguities**: These are cases where more than one path through the
 *   grammar can match the input.
 * * **Weak context sensitivity**: These are cases where full-context
 *   prediction resolved an SLL conflict to a unique alternative which equaled the
 *   minimum alternative of the SLL conflict.
 * * **Strong (forced) context sensitivity**: These are cases where the
 *   full-context prediction resolved an SLL conflict to a unique alternative,
 *   *and* the minimum alternative of the SLL conflict was found to not be
 *   a truly viable alternative. Two-stage parsing cannot be used for inputs where
 *   this situation occurs.
 *
 * @author Sam Harwell
 */ class $4743017423787884$var$DiagnosticErrorListener {
    /**
     * Initializes a new instance of {@link DiagnosticErrorListener}, specifying
     * whether all ambiguities or only exact ambiguities are reported.
     *
     * @param exactOnly `true` to report only exact ambiguities, otherwise
     * `false` to report all ambiguities.  Defaults to true.
     */ constructor(exactOnly = true){
        this.exactOnly = exactOnly;
        this.exactOnly = exactOnly;
    }
    syntaxError(/*@NotNull*/ recognizer, offendingSymbol, line, charPositionInLine, /*@NotNull*/ msg, e) {
    // intentionally empty
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.exactOnly && !exact) return;
        let decision = this.getDecisionDescription(recognizer, dfa);
        let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
        let text = recognizer.inputStream.getText($l8y5T.Interval.of(startIndex, stopIndex));
        let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        let format = "reportAttemptingFullContext d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($l8y5T.Interval.of(startIndex, stopIndex));
        let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        let format = "reportContextSensitivity d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($l8y5T.Interval.of(startIndex, stopIndex));
        let message = `reportContextSensitivity d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    getDecisionDescription(recognizer, dfa) {
        let decision = dfa.decision;
        let ruleIndex = dfa.atnStartState.ruleIndex;
        let ruleNames = recognizer.ruleNames;
        if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
        let ruleName = ruleNames[ruleIndex];
        if (!ruleName) return decision.toString();
        return `${decision} (${ruleName})`;
    }
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `undefined`, otherwise
     * returns the set of alternatives represented in `configs`.
     */ getConflictingAlts(reportedAlts, configs) {
        if (reportedAlts != null) return reportedAlts;
        let result = new $8WIez.BitSet();
        for (let config of configs)result.set(config.alt);
        return result;
    }
}
$4743017423787884$var$__decorate([
    $aN41m.Override
], $4743017423787884$var$DiagnosticErrorListener.prototype, "syntaxError", null);
$4743017423787884$var$__decorate([
    $aN41m.Override,
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull),
    $4743017423787884$var$__param(6, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
$4743017423787884$var$__decorate([
    $aN41m.Override,
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull),
    $4743017423787884$var$__param(5, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
$4743017423787884$var$__decorate([
    $aN41m.Override,
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull),
    $4743017423787884$var$__param(5, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
$4743017423787884$var$__decorate([
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
$4743017423787884$var$__decorate([
    $aN41m.NotNull,
    $4743017423787884$var$__param(1, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
module.exports.DiagnosticErrorListener = $4743017423787884$var$DiagnosticErrorListener;

});

parcelRegister("jo2Zj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e1d2938a086e1390$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterpreterRuleContext = void 0;

var $aN41m = parcelRequire("aN41m");

var $2pDMz = parcelRequire("2pDMz");
/**
 * This class extends {@link ParserRuleContext} by allowing the value of
 * {@link #getRuleIndex} to be explicitly set for the context.
 *
 * {@link ParserRuleContext} does not include field storage for the rule index
 * since the context classes created by the code generator override the
 * {@link #getRuleIndex} method to return the correct value for that context.
 * Since the parser interpreter does not use the context classes generated for a
 * parser, this class (with slightly more memory overhead per node) is used to
 * provide equivalent functionality.
 */ class $e1d2938a086e1390$var$InterpreterRuleContext extends $2pDMz.ParserRuleContext {
    constructor(ruleIndex, parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._ruleIndex = ruleIndex;
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
}
$e1d2938a086e1390$var$__decorate([
    $aN41m.Override
], $e1d2938a086e1390$var$InterpreterRuleContext.prototype, "ruleIndex", null);
module.exports.InterpreterRuleContext = $e1d2938a086e1390$var$InterpreterRuleContext;

});

parcelRegister("hVliW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d0c8492ceb048178$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d0c8492ceb048178$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerInterpreter = void 0;

var $h7Q3L = parcelRequire("h7Q3L");

var $2160U = parcelRequire("2160U");

var $aN41m = parcelRequire("aN41m");

var $aN41m = parcelRequire("aN41m");
let $d0c8492ceb048178$var$LexerInterpreter = class LexerInterpreter extends $h7Q3L.Lexer {
    constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
        super(input);
        if (atn.grammarType !== 0 /* LEXER */ ) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
        this._grammarFileName = grammarFileName;
        this._atn = atn;
        this._ruleNames = ruleNames.slice(0);
        this._channelNames = channelNames.slice(0);
        this._modeNames = modeNames.slice(0);
        this._vocabulary = vocabulary;
        this._interp = new $2160U.LexerATNSimulator(atn, this);
    }
    get atn() {
        return this._atn;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get channelNames() {
        return this._channelNames;
    }
    get modeNames() {
        return this._modeNames;
    }
    get vocabulary() {
        return this._vocabulary;
    }
};
$d0c8492ceb048178$var$__decorate([
    $aN41m.NotNull
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "_vocabulary", void 0);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "atn", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "grammarFileName", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "ruleNames", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "channelNames", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "modeNames", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "vocabulary", null);
$d0c8492ceb048178$var$LexerInterpreter = $d0c8492ceb048178$var$__decorate([
    $d0c8492ceb048178$var$__param(1, $aN41m.NotNull)
], $d0c8492ceb048178$var$LexerInterpreter);
module.exports.LexerInterpreter = $d0c8492ceb048178$var$LexerInterpreter;

});

parcelRegister("c8NTK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8d6cf020aadeeb48$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8d6cf020aadeeb48$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListTokenSource = void 0;

var $9hrXh = parcelRequire("9hrXh");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * Provides an implementation of {@link TokenSource} as a wrapper around a list
 * of {@link Token} objects.
 *
 * If the final token in the list is an {@link Token#EOF} token, it will be used
 * as the EOF token for every call to {@link #nextToken} after the end of the
 * list is reached. Otherwise, an EOF token will be created.
 */ let $8d6cf020aadeeb48$var$ListTokenSource = class ListTokenSource {
    /**
     * Constructs a new {@link ListTokenSource} instance from the specified
     * collection of {@link Token} objects and source name.
     *
     * @param tokens The collection of {@link Token} objects to provide as a
     * {@link TokenSource}.
     * @param sourceName The name of the {@link TokenSource}. If this value is
     * `undefined`, {@link #getSourceName} will attempt to infer the name from
     * the next {@link Token} (or the previous token if the end of the input has
     * been reached).
     *
     * @exception NullPointerException if `tokens` is `undefined`
     */ constructor(tokens, sourceName){
        /**
         * The index into {@link #tokens} of token to return by the next call to
         * {@link #nextToken}. The end of the input is indicated by this value
         * being greater than or equal to the number of items in {@link #tokens}.
         */ this.i = 0;
        /**
         * This is the backing field for {@link #getTokenFactory} and
         * {@link setTokenFactory}.
         */ this._factory = $9hrXh.CommonTokenFactory.DEFAULT;
        if (tokens == null) throw new Error("tokens cannot be null");
        this.tokens = tokens;
        this._sourceName = sourceName;
    }
    /**
     * {@inheritDoc}
     */ get charPositionInLine() {
        if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
        else if (this.eofToken != null) return this.eofToken.charPositionInLine;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let tokenText = lastToken.text;
            if (tokenText != null) {
                let lastNewLine = tokenText.lastIndexOf("\n");
                if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
            }
            return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 0;
    }
    /**
     * {@inheritDoc}
     */ nextToken() {
        if (this.i >= this.tokens.length) {
            if (this.eofToken == null) {
                let start = -1;
                if (this.tokens.length > 0) {
                    let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                    if (previousStop !== -1) start = previousStop + 1;
                }
                let stop = Math.max(-1, start - 1);
                this.eofToken = this._factory.create({
                    source: this,
                    stream: this.inputStream
                }, $eKXi4.Token.EOF, "EOF", $eKXi4.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
            }
            return this.eofToken;
        }
        let t = this.tokens[this.i];
        if (this.i === this.tokens.length - 1 && t.type === $eKXi4.Token.EOF) this.eofToken = t;
        this.i++;
        return t;
    }
    /**
     * {@inheritDoc}
     */ get line() {
        if (this.i < this.tokens.length) return this.tokens[this.i].line;
        else if (this.eofToken != null) return this.eofToken.line;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let line = lastToken.line;
            let tokenText = lastToken.text;
            if (tokenText != null) {
                for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
            }
            // if no text is available, assume the token did not contain any newline characters.
            return line;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 1;
    }
    /**
     * {@inheritDoc}
     */ get inputStream() {
        if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
        else if (this.eofToken != null) return this.eofToken.inputStream;
        else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
        // no input stream information is available
        return undefined;
    }
    /**
     * {@inheritDoc}
     */ get sourceName() {
        if (this._sourceName) return this._sourceName;
        let inputStream = this.inputStream;
        if (inputStream != null) return inputStream.sourceName;
        return "List";
    }
    /**
     * {@inheritDoc}
     */ // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    /**
     * {@inheritDoc}
     */ get tokenFactory() {
        return this._factory;
    }
};
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "charPositionInLine", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "nextToken", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "line", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "inputStream", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "sourceName", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull,
    $8d6cf020aadeeb48$var$__param(0, $aN41m.NotNull)
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "tokenFactory", null);
$8d6cf020aadeeb48$var$ListTokenSource = $8d6cf020aadeeb48$var$__decorate([
    $8d6cf020aadeeb48$var$__param(0, $aN41m.NotNull)
], $8d6cf020aadeeb48$var$ListTokenSource);
module.exports.ListTokenSource = $8d6cf020aadeeb48$var$ListTokenSource;

});

parcelRegister("5n08Y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8rZl7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $62706d1c6fe2cac4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $62706d1c6fe2cac4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserInterpreter = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $8WIez = parcelRequire("8WIez");

var $2quiJ = parcelRequire("2quiJ");

var $5jZSY = parcelRequire("5jZSY");

var $jo2Zj = parcelRequire("jo2Zj");

var $fFNPu = parcelRequire("fFNPu");

var $aN41m = parcelRequire("aN41m");

var $aN41m = parcelRequire("aN41m");

var $c9Sjf = parcelRequire("c9Sjf");

var $gzbPK = parcelRequire("gzbPK");

var $b7PPe = parcelRequire("b7PPe");

var $e0pjt = parcelRequire("e0pjt");

var $eKXi4 = parcelRequire("eKXi4");
/** A parser simulator that mimics what ANTLR's generated
 *  parser code does. A ParserATNSimulator is used to make
 *  predictions via adaptivePredict but this class moves a pointer through the
 *  ATN to simulate parsing. ParserATNSimulator just
 *  makes us efficient rather than having to backtrack, for example.
 *
 *  This properly creates parse trees even for left recursive rules.
 *
 *  We rely on the left recursive rule invocation and special predicate
 *  transitions to make left recursive rules work.
 *
 *  See TestParserInterpreter for examples.
 */ let $62706d1c6fe2cac4$var$ParserInterpreter = class ParserInterpreter extends $c9Sjf.Parser {
    constructor(grammarFileName, vocabulary, ruleNames, atn, input){
        super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
        /** This stack corresponds to the _parentctx, _parentState pair of locals
         *  that would exist on call stack frames with a recursive descent parser;
         *  in the generated function for a left-recursive rule you'd see:
         *
         *  private EContext e(int _p) {
         *      ParserRuleContext _parentctx = _ctx;    // Pair.a
         *      int _parentState = state;          // Pair.b
         *      ...
         *  }
         *
         *  Those values are used to create new recursive rule invocation contexts
         *  associated with left operand of an alt like "expr '*' expr".
         */ this._parentContextStack = [];
        /** We need a map from (decision,inputIndex)->forced alt for computing ambiguous
         *  parse trees. For now, we allow exactly one override.
         */ this.overrideDecision = -1;
        this.overrideDecisionInputIndex = -1;
        this.overrideDecisionAlt = -1;
        this.overrideDecisionReached = false; // latch and only override once; error might trigger infinite loop
        /** What is the current context when we override a decisions?  This tells
         *  us what the root of the parse tree is when using override
         *  for an ambiguity/lookahead check.
         */ this._overrideDecisionRoot = undefined;
        if (grammarFileName instanceof ParserInterpreter) {
            let old = grammarFileName;
            this._grammarFileName = old._grammarFileName;
            this._atn = old._atn;
            this.pushRecursionContextStates = old.pushRecursionContextStates;
            this._ruleNames = old._ruleNames;
            this._vocabulary = old._vocabulary;
            this.interpreter = new $gzbPK.ParserATNSimulator(this._atn, this);
        } else {
            // The second constructor requires non-null arguments
            vocabulary;
            ruleNames;
            atn;
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._vocabulary = vocabulary;
            // identify the ATN states where pushNewRecursionContext() must be called
            this.pushRecursionContextStates = new $8WIez.BitSet(atn.states.length);
            for (let state of atn.states){
                if (!(state instanceof $e0pjt.StarLoopEntryState)) continue;
                if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
            }
            // get atn simulator that knows how to do predictions
            this.interpreter = new $gzbPK.ParserATNSimulator(atn, this);
        }
    }
    reset(resetInput) {
        if (resetInput === undefined) super.reset();
        else super.reset(resetInput);
        this.overrideDecisionReached = false;
        this._overrideDecisionRoot = undefined;
    }
    get atn() {
        return this._atn;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    /** Begin parsing at startRuleIndex */ parse(startRuleIndex) {
        let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
        this._rootContext = this.createInterpreterRuleContext(undefined, $dv9vN.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
        if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
        else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
        while(true){
            let p = this.atnState;
            switch(p.stateType){
                case $fZESB.ATNStateType.RULE_STOP:
                    // pop; return from rule
                    if (this._ctx.isEmpty) {
                        if (startRuleStartState.isPrecedenceRule) {
                            let result = this._ctx;
                            let parentContext = this._parentContextStack.pop();
                            this.unrollRecursionContexts(parentContext[0]);
                            return result;
                        } else {
                            this.exitRule();
                            return this._rootContext;
                        }
                    }
                    this.visitRuleStopState(p);
                    break;
                default:
                    try {
                        this.visitState(p);
                    } catch (e) {
                        if (e instanceof $b7PPe.RecognitionException) {
                            this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                            this.context.exception = e;
                            this.errorHandler.reportError(this, e);
                            this.recover(e);
                        } else throw e;
                    }
                    break;
            }
        }
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this._parentContextStack.push([
            this._ctx,
            localctx.invokingState
        ]);
        super.enterRecursionRule(localctx, state, ruleIndex, precedence);
    }
    get atnState() {
        return this._atn.states[this.state];
    }
    visitState(p) {
        let predictedAlt = 1;
        if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
        let transition = p.transition(predictedAlt - 1);
        switch(transition.serializationType){
            case 1 /* EPSILON */ :
                if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $fFNPu.LoopEndState)) {
                    // We are at the start of a left recursive rule's (...)* loop
                    // and we're not taking the exit branch of loop.
                    let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                    let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                    this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                }
                break;
            case 5 /* ATOM */ :
                this.match(transition._label);
                break;
            case 2 /* RANGE */ :
            case 7 /* SET */ :
            case 8 /* NOT_SET */ :
                if (!transition.matches(this._input.LA(1), $eKXi4.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                this.matchWildcard();
                break;
            case 9 /* WILDCARD */ :
                this.matchWildcard();
                break;
            case 3 /* RULE */ :
                let ruleStartState = transition.target;
                let ruleIndex = ruleStartState.ruleIndex;
                let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                break;
            case 4 /* PREDICATE */ :
                let predicateTransition = transition;
                if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $2quiJ.FailedPredicateException(this);
                break;
            case 6 /* ACTION */ :
                let actionTransition = transition;
                this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                break;
            case 10 /* PRECEDENCE */ :
                if (!this.precpred(this._ctx, transition.precedence)) {
                    let precedence = transition.precedence;
                    throw new $2quiJ.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                }
                break;
            default:
                throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
        }
        this.state = transition.target.stateNumber;
    }
    /** Method visitDecisionState() is called when the interpreter reaches
     *  a decision state (instance of DecisionState). It gives an opportunity
     *  for subclasses to track interesting things.
     */ visitDecisionState(p) {
        let predictedAlt;
        this.errorHandler.sync(this);
        let decision = p.decision;
        if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
            predictedAlt = this.overrideDecisionAlt;
            this.overrideDecisionReached = true;
        } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
        return predictedAlt;
    }
    /** Provide simple "factory" for InterpreterRuleContext's.
     *  @since 4.5.1
     */ createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
        return new $jo2Zj.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
    }
    visitRuleStopState(p) {
        let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
        if (ruleStartState.isPrecedenceRule) {
            let parentContext = this._parentContextStack.pop();
            this.unrollRecursionContexts(parentContext[0]);
            this.state = parentContext[1];
        } else this.exitRule();
        let ruleTransition = this._atn.states[this.state].transition(0);
        this.state = ruleTransition.followState.stateNumber;
    }
    /** Override this parser interpreters normal decision-making process
     *  at a particular decision and input token index. Instead of
     *  allowing the adaptive prediction mechanism to choose the
     *  first alternative within a block that leads to a successful parse,
     *  force it to take the alternative, 1..n for n alternatives.
     *
     *  As an implementation limitation right now, you can only specify one
     *  override. This is sufficient to allow construction of different
     *  parse trees for ambiguous input. It means re-parsing the entire input
     *  in general because you're never sure where an ambiguous sequence would
     *  live in the various parse trees. For example, in one interpretation,
     *  an ambiguous input sequence would be matched completely in expression
     *  but in another it could match all the way back to the root.
     *
     *  s : e '!'? ;
     *  e : ID
     *    | ID '!'
     *    ;
     *
     *  Here, x! can be matched as (s (e ID) !) or (s (e ID !)). In the first
     *  case, the ambiguous sequence is fully contained only by the root.
     *  In the second case, the ambiguous sequences fully contained within just
     *  e, as in: (e ID !).
     *
     *  Rather than trying to optimize this and make
     *  some intelligent decisions for optimization purposes, I settled on
     *  just re-parsing the whole input and then using
     *  {link Trees#getRootOfSubtreeEnclosingRegion} to find the minimal
     *  subtree that contains the ambiguous sequence. I originally tried to
     *  record the call stack at the point the parser detected and ambiguity but
     *  left recursive rules create a parse tree stack that does not reflect
     *  the actual call stack. That impedance mismatch was enough to make
     *  it it challenging to restart the parser at a deeply nested rule
     *  invocation.
     *
     *  Only parser interpreters can override decisions so as to avoid inserting
     *  override checking code in the critical ALL(*) prediction execution path.
     *
     *  @since 4.5
     */ addDecisionOverride(decision, tokenIndex, forcedAlt) {
        this.overrideDecision = decision;
        this.overrideDecisionInputIndex = tokenIndex;
        this.overrideDecisionAlt = forcedAlt;
    }
    get overrideDecisionRoot() {
        return this._overrideDecisionRoot;
    }
    /** Rely on the error handler for this parser but, if no tokens are consumed
     *  to recover, add an error node. Otherwise, nothing is seen in the parse
     *  tree.
     */ recover(e) {
        let i = this._input.index;
        this.errorHandler.recover(this, e);
        if (this._input.index === i) {
            // no input consumed, better add an error node
            let tok = e.getOffendingToken();
            if (!tok) throw new Error("Expected exception to have an offending token");
            let source = tok.tokenSource;
            let stream = source !== undefined ? source.inputStream : undefined;
            let sourcePair = {
                source: source,
                stream: stream
            };
            if (e instanceof $5jZSY.InputMismatchException) {
                let expectedTokens = e.expectedTokens;
                if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                let expectedTokenType = $eKXi4.Token.INVALID_TYPE;
                if (!expectedTokens.isNil) // get any element
                expectedTokenType = expectedTokens.minElement;
                let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $eKXi4.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            } else {
                let source = tok.tokenSource;
                let errToken = this.tokenFactory.create(sourcePair, $eKXi4.Token.INVALID_TYPE, tok.text, $eKXi4.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            }
        }
    }
    recoverInline() {
        return this._errHandler.recoverInline(this);
    }
    /** Return the root of the parse, which can be useful if the parser
     *  bails out. You still can access the top node. Note that,
     *  because of the way left recursive rules add children, it's possible
     *  that the root will not have any children if the start rule immediately
     *  called and left recursive rule that fails.
     *
     * @since 4.5.1
     */ get rootContext() {
        return this._rootContext;
    }
};
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.NotNull
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "_vocabulary", void 0);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "reset", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "atn", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "vocabulary", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "ruleNames", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "grammarFileName", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "enterRecursionRule", null);
$62706d1c6fe2cac4$var$ParserInterpreter = $62706d1c6fe2cac4$var$__decorate([
    $62706d1c6fe2cac4$var$__param(1, $aN41m.NotNull)
], $62706d1c6fe2cac4$var$ParserInterpreter);
module.exports.ParserInterpreter = $62706d1c6fe2cac4$var$ParserInterpreter;

});

parcelRegister("atcwe", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $79f652cad683467f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContextWithAltNum = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $aN41m = parcelRequire("aN41m");

var $2pDMz = parcelRequire("2pDMz");
/** A handy class for use with
 *
 *  options {contextSuperClass=org.antlr.v4.runtime.RuleContextWithAltNum;}
 *
 *  that provides a backing field / impl for the outer alternative number
 *  matched for an internal parse tree node.
 *
 *  I'm only putting into Java runtime as I'm certain I'm the only one that
 *  will really every use this.
 */ class $79f652cad683467f$var$RuleContextWithAltNum extends $2pDMz.ParserRuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._altNumber = $eeOLb.ATN.INVALID_ALT_NUMBER;
    }
    get altNumber() {
        return this._altNumber;
    }
    // @Override
    set altNumber(altNum) {
        this._altNumber = altNum;
    }
}
$79f652cad683467f$var$__decorate([
    $aN41m.Override
], $79f652cad683467f$var$RuleContextWithAltNum.prototype, "altNumber", null);
module.exports.RuleContextWithAltNum = $79f652cad683467f$var$RuleContextWithAltNum;

});

parcelRegister("3d5Fu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleDependency = void 0;
/**
 * Declares a dependency upon a grammar rule, along with a set of zero or more dependent rules.
 *
 * Version numbers within a grammar should be assigned on a monotonically increasing basis to allow for accurate
 * tracking of dependent rules.
 *
 * @author Sam Harwell
 */ function $2566fb8eb3eb638e$var$RuleDependency(dependency) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleDependency = $2566fb8eb3eb638e$var$RuleDependency;

});

parcelRegister("hHHux", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleVersion = void 0;
/**
 *
 * @author Sam Harwell
 */ function $ce3830527f1ccb0d$var$RuleVersion(version) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleVersion = $ce3830527f1ccb0d$var$RuleVersion;

});

parcelRegister("lL3Js", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("03lZa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("b3QEj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hwMU6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cc2b5c1f9eca6d60$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * Useful for rewriting out a buffered input token stream after doing some
 * augmentation or other manipulations on it.
 *
 * You can insert stuff, replace, and delete chunks. Note that the operations
 * are done lazily--only if you convert the buffer to a {@link String} with
 * {@link TokenStream#getText()}. This is very efficient because you are not
 * moving data around all the time. As the buffer of tokens is converted to
 * strings, the {@link #getText()} method(s) scan the input token stream and
 * check to see if there is an operation at the current index. If so, the
 * operation is done and then normal {@link String} rendering continues on the
 * buffer. This is like having multiple Turing machine instruction streams
 * (programs) operating on a single input tape. :)
 *
 * This rewriter makes no modifications to the token stream. It does not ask the
 * stream to fill itself up nor does it advance the input cursor. The token
 * stream `TokenStream.index` will return the same value before and
 * after any {@link #getText()} call.
 *
 * The rewriter only works on tokens that you have in the buffer and ignores the
 * current input cursor. If you are buffering tokens on-demand, calling
 * {@link #getText()} halfway through the input will only do rewrites for those
 * tokens in the first half of the file.
 *
 * Since the operations are done lazily at {@link #getText}-time, operations do
 * not screw up the token index values. That is, an insert operation at token
 * index `i` does not change the index values for tokens
 * `i`+1..n-1.
 *
 * Because operations never actually alter the buffer, you may always get the
 * original token stream back without undoing anything. Since the instructions
 * are queued up, you can easily simulate transactions and roll back any changes
 * if there is an error just by removing instructions. For example,
 *
 * ```
 * CharStream input = new ANTLRFileStream("input");
 * TLexer lex = new TLexer(input);
 * CommonTokenStream tokens = new CommonTokenStream(lex);
 * T parser = new T(tokens);
 * TokenStreamRewriter rewriter = new TokenStreamRewriter(tokens);
 * parser.startRule();
 * ```
 *
 * Then in the rules, you can execute (assuming rewriter is visible):
 *
 * ```
 * Token t,u;
 * ...
 * rewriter.insertAfter(t, "text to put after t");}
 * rewriter.insertAfter(u, "text after u");}
 * System.out.println(rewriter.getText());
 * ```
 *
 * You can also have multiple "instruction streams" and get multiple rewrites
 * from a single pass over the input. Just name the instruction streams and use
 * that name again when printing the buffer. This could be useful for generating
 * a C file and also its header file--all from the same buffer:
 *
 * ```
 * rewriter.insertAfter("pass1", t, "text to put after t");}
 * rewriter.insertAfter("pass2", u, "text after u");}
 * System.out.println(rewriter.getText("pass1"));
 * System.out.println(rewriter.getText("pass2"));
 * ```
 *
 * If you don't use named rewrite streams, a "default" stream is used as the
 * first example shows.
 */ class $cc2b5c1f9eca6d60$var$TokenStreamRewriter {
    constructor(tokens){
        this.tokens = tokens;
        this.programs = new Map();
        this.programs.set($cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
        this.lastRewriteTokenIndexes = new Map();
    }
    getTokenStream() {
        return this.tokens;
    }
    rollback(instructionIndex, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let is = this.programs.get(programName);
        if (is != null) this.programs.set(programName, is.slice($cc2b5c1f9eca6d60$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
    }
    deleteProgram(programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        this.rollback($cc2b5c1f9eca6d60$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
    }
    insertAfter(tokenOrIndex, text, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        // to insert after, just insert before next index (even if past end)
        let rewrites = this.getProgram(programName);
        let op = new $cc2b5c1f9eca6d60$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    insertBefore(tokenOrIndex, text, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        let rewrites = this.getProgram(programName);
        let op = new $cc2b5c1f9eca6d60$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    replaceSingle(index, text) {
        if (typeof index === "number") this.replace(index, index, text);
        else this.replace(index, index, text);
    }
    replace(from, to, text, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (typeof from !== "number") from = from.tokenIndex;
        if (typeof to !== "number") to = to.tokenIndex;
        if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
        let rewrites = this.getProgram(programName);
        let op = new $cc2b5c1f9eca6d60$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
        rewrites.push(op);
    }
    delete(from, to, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (to === undefined) to = from;
        if (typeof from === "number") this.replace(from, to, "", programName);
        else this.replace(from, to, "", programName);
    }
    getLastRewriteTokenIndex(programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let I = this.lastRewriteTokenIndexes.get(programName);
        if (I == null) return -1;
        return I;
    }
    setLastRewriteTokenIndex(programName, i) {
        this.lastRewriteTokenIndexes.set(programName, i);
    }
    getProgram(name) {
        let is = this.programs.get(name);
        if (is == null) is = this.initializeProgram(name);
        return is;
    }
    initializeProgram(name) {
        let is = [];
        this.programs.set(name, is);
        return is;
    }
    getText(intervalOrProgram, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let interval;
        if (intervalOrProgram instanceof $l8y5T.Interval) interval = intervalOrProgram;
        else interval = $l8y5T.Interval.of(0, this.tokens.size - 1);
        if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
        let rewrites = this.programs.get(programName);
        let start = interval.a;
        let stop = interval.b;
        // ensure start/end are in range
        if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
        if (start < 0) start = 0;
        if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval); // no instructions to execute
        let buf = [];
        // First, optimize instruction stream
        let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
        // Walk buffer, executing instructions and emitting tokens
        let i = start;
        while(i <= stop && i < this.tokens.size){
            let op = indexToOp.get(i);
            indexToOp.delete(i); // remove so any left have index size-1
            let t = this.tokens.get(i);
            if (op == null) {
                // no operation at that index, just dump token
                if (t.type !== $eKXi4.Token.EOF) buf.push(String(t.text));
                i++; // move to next token
            } else i = op.execute(buf); // execute operation and skip
        }
        // include stuff after end if it's last index in buffer
        // So, if they did an insertAfter(lastValidIndex, "foo"), include
        // foo if end==lastValidIndex.
        if (stop === this.tokens.size - 1) {
            // Scan any remaining operations after last token
            // should be included (they will be inserts).
            for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
        }
        return buf.join("");
    }
    /** We need to combine operations and report invalid operations (like
     *  overlapping replaces that are not completed nested). Inserts to
     *  same index need to be combined etc...  Here are the cases:
     *
     *  I.i.u I.j.v								leave alone, nonoverlapping
     *  I.i.u I.i.v								combine: Iivu
     *
     *  R.i-j.u R.x-y.v	| i-j in x-y			delete first R
     *  R.i-j.u R.i-j.v							delete first R
     *  R.i-j.u R.x-y.v	| x-y in i-j			ERROR
     *  R.i-j.u R.x-y.v	| boundaries overlap	ERROR
     *
     *  Delete special case of replace (text==undefined):
     *  D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
     *
     *  I.i.u R.x-y.v | i in (x+1)-y			delete I (since insert before
     * 											we're not deleting i)
     *  I.i.u R.x-y.v | i not in (x+1)-y		leave alone, nonoverlapping
     *  R.x-y.v I.i.u | i in x-y				ERROR
     *  R.x-y.v I.x.u 							R.x-y.uv (combine, delete I)
     *  R.x-y.v I.i.u | i not in x-y			leave alone, nonoverlapping
     *
     *  I.i.u = insert u before op @ index i
     *  R.x-y.u = replace x-y indexed tokens with u
     *
     *  First we need to examine replaces. For any replace op:
     *
     * 		1. wipe out any insertions before op within that range.
     * 		2. Drop any replace op before that is contained completely within
     * 	 that range.
     * 		3. Throw exception upon boundary overlap with any previous replace.
     *
     *  Then we can deal with inserts:
     *
     * 		1. for any inserts to same index, combine even if not adjacent.
     * 		2. for any prior replace with same left boundary, combine this
     * 	 insert with replace and delete this replace.
     * 		3. throw exception if index in same range as previous replace
     *
     *  Don't actually delete; make op undefined in list. Easier to walk list.
     *  Later we can throw as we add to index &rarr; op map.
     *
     *  Note that I.2 R.2-2 will wipe out I.2 even though, technically, the
     *  inserted stuff would be before the replace range. But, if you
     *  add tokens in front of a method body '{' and then delete the method
     *  body, I think the stuff before the '{' you added should disappear too.
     *
     *  Return a map from token index to operation.
     */ reduceToSingleOperationPerIndex(rewrites) {
        // console.log(`rewrites=[${Utils.join(rewrites, ", ")}]`);
        // WALK REPLACES
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $cc2b5c1f9eca6d60$var$ReplaceOp)) continue;
            let rop = op;
            // Wipe prior inserts within range
            let inserts = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$InsertBeforeOp, i);
            for (let iop of inserts){
                if (iop.index === rop.index) {
                    // E.g., insert before 2, delete 2..2; update replace
                    // text to include insert before, kill insert
                    rewrites[iop.instructionIndex] = undefined;
                    rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                } else if (iop.index > rop.index && iop.index <= rop.lastIndex) // delete insert as it's a no-op.
                rewrites[iop.instructionIndex] = undefined;
            }
            // Drop any prior replaces contained within
            let prevReplaces = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$ReplaceOp, i);
            for (let prevRop of prevReplaces){
                if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                    // delete replace as it's a no-op.
                    rewrites[prevRop.instructionIndex] = undefined;
                    continue;
                }
                // throw exception unless disjoint or identical
                let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                // Delete special case of replace (text==null):
                // D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
                if (prevRop.text == null && rop.text == null && !disjoint) {
                    // console.log(`overlapping deletes: ${prevRop}, ${rop}`);
                    rewrites[prevRop.instructionIndex] = undefined; // kill first delete
                    rop.index = Math.min(prevRop.index, rop.index);
                    rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                // console.log(`new rop ${rop}`);
                } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
            }
        }
        // WALK INSERTS
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $cc2b5c1f9eca6d60$var$InsertBeforeOp)) continue;
            let iop = op;
            // combine current insert with prior if any at same index
            let prevInserts = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$InsertBeforeOp, i);
            for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                if (prevIop instanceof $cc2b5c1f9eca6d60$var$InsertAfterOp) {
                    iop.text = this.catOpText(prevIop.text, iop.text);
                    rewrites[prevIop.instructionIndex] = undefined;
                } else if (prevIop instanceof $cc2b5c1f9eca6d60$var$InsertBeforeOp) {
                    // convert to strings...we're in process of toString'ing
                    // whole token buffer so no lazy eval issue with any templates
                    iop.text = this.catOpText(iop.text, prevIop.text);
                    // delete redundant prior insert
                    rewrites[prevIop.instructionIndex] = undefined;
                }
            }
            // look for replaces where iop.index is in range; error
            let prevReplaces = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$ReplaceOp, i);
            for (let rop of prevReplaces){
                if (iop.index === rop.index) {
                    rop.text = this.catOpText(iop.text, rop.text);
                    rewrites[i] = undefined; // delete current insert
                    continue;
                }
                if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
            }
        }
        // console.log(`rewrites after=[${Utils.join(rewrites, ", ")}]`);
        let m = new Map();
        for (let op of rewrites){
            if (op == null) continue;
            if (m.get(op.index) != null) throw new Error("should only be one op per index");
            m.set(op.index, op);
        }
        // console.log(`index to op: ${m}`);
        return m;
    }
    catOpText(a, b) {
        let x = "";
        let y = "";
        if (a != null) x = a.toString();
        if (b != null) y = b.toString();
        return x + y;
    }
    /** Get all operations before an index of a particular kind */ getKindOfOps(rewrites, kind, before) {
        let ops = [];
        for(let i = 0; i < before && i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (op instanceof kind) ops.push(op);
        }
        return ops;
    }
}
module.exports.TokenStreamRewriter = $cc2b5c1f9eca6d60$var$TokenStreamRewriter;
$cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
$cc2b5c1f9eca6d60$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
$cc2b5c1f9eca6d60$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
// Define the rewrite operation hierarchy
class $cc2b5c1f9eca6d60$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        this.tokens = tokens;
        this.instructionIndex = instructionIndex;
        this.index = index;
        this.text = text === undefined ? "" : text;
    }
    /** Execute the rewrite operation by possibly adding to the buffer.
     *  Return the index of the next token to operate on.
     */ execute(buf) {
        return this.index;
    }
    toString() {
        let opName = this.constructor.name;
        let $index = opName.indexOf("$");
        opName = opName.substring($index + 1, opName.length);
        return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
    }
}
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$RewriteOperation.prototype, "toString", null);
module.exports.RewriteOperation = $cc2b5c1f9eca6d60$var$RewriteOperation;
class $cc2b5c1f9eca6d60$var$InsertBeforeOp extends $cc2b5c1f9eca6d60$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index, instructionIndex, text);
    }
    execute(buf) {
        buf.push(this.text.toString());
        if (this.tokens.get(this.index).type !== $eKXi4.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
        return this.index + 1;
    }
}
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$InsertBeforeOp.prototype, "execute", null);
/** Distinguish between insert after/before to do the "insert afters"
 *  first and then the "insert befores" at same index. Implementation
 *  of "insert after" is "insert before index+1".
 */ class $cc2b5c1f9eca6d60$var$InsertAfterOp extends $cc2b5c1f9eca6d60$var$InsertBeforeOp {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index + 1, instructionIndex, text); // insert after is insert before index+1
    }
}
/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */ class $cc2b5c1f9eca6d60$var$ReplaceOp extends $cc2b5c1f9eca6d60$var$RewriteOperation {
    constructor(tokens, from, to, instructionIndex, text){
        super(tokens, from, instructionIndex, text);
        this.lastIndex = to;
    }
    execute(buf) {
        if (this.text != null) buf.push(this.text.toString());
        return this.lastIndex + 1;
    }
    toString() {
        if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
        return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
    }
}
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$ReplaceOp.prototype, "execute", null);
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$ReplaceOp.prototype, "toString", null);

});

parcelRegister("2YAkU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("edl4x", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("8YcxO", function(module, exports) {

$parcel$export(module.exports, "JQLLexer", () => $80306ddcd52cd923$export$375c79404cc64c7f);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLLexer.g4 by ANTLR 4.7.3-SNAPSHOT

var $1ztRl = parcelRequire("1ztRl");

var $h7Q3L = parcelRequire("h7Q3L");

var $2160U = parcelRequire("2160U");

var $hBnE1 = parcelRequire("hBnE1");

var $62Uvn = parcelRequire("62Uvn");
class $80306ddcd52cd923$export$375c79404cc64c7f extends (0, $h7Q3L.Lexer) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.QUOTED_STR = 1;
    }
    static{
        this.SQUOTED_STR = 2;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.channelNames = [
            'DEFAULT_TOKEN_CHANNEL',
            'HIDDEN'
        ];
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.modeNames = [
            'DEFAULT_MODE',
            'QUOTED_STR',
            'SQUOTED_STR'
        ];
    }
    static{
        this.ruleNames = [
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'LQUOTE',
            'LSQUOTE',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'QUOTED_CONTENT',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'SQUOTED_CONTENT',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING',
            'VALID_UNQUOTED_CHARS',
            'VALID_QUOTED_CHARS',
            'VALID_SQUOTED_CHARS',
            'RESERVED_CHARS',
            'QUOTE',
            'SQUOTE',
            'BSLASH',
            'NL',
            'CR',
            'SPACE',
            'AMPER',
            'AMPER_AMPER',
            'PIPE',
            'PIPE_PIPE',
            'ESCAPE',
            'NEWLINE',
            'HEXDIGIT',
            'WS',
            'MINUS',
            'DIGIT',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $hBnE1.VocabularyImpl)($80306ddcd52cd923$export$375c79404cc64c7f._LITERAL_NAMES, $80306ddcd52cd923$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $80306ddcd52cd923$export$375c79404cc64c7f.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input){
        super(input);
        this._interp = new (0, $2160U.LexerATNSimulator)($80306ddcd52cd923$export$375c79404cc64c7f._ATN, this);
    }
    // @Override
    get grammarFileName() {
        return 'JQLLexer.g4';
    }
    // @Override
    get ruleNames() {
        return $80306ddcd52cd923$export$375c79404cc64c7f.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $80306ddcd52cd923$export$375c79404cc64c7f._serializedATN;
    }
    // @Override
    get channelNames() {
        return $80306ddcd52cd923$export$375c79404cc64c7f.channelNames;
    }
    // @Override
    get modeNames() {
        return $80306ddcd52cd923$export$375c79404cc64c7f.modeNames;
    }
    static{
        this._serializedATNSegments = 3;
    }
    static{
        this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
    }
    static{
        this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
    }
    static{
        this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
    }
    static{
        this._serializedATN = $62Uvn.join([
            $80306ddcd52cd923$export$375c79404cc64c7f._serializedATNSegment0,
            $80306ddcd52cd923$export$375c79404cc64c7f._serializedATNSegment1,
            $80306ddcd52cd923$export$375c79404cc64c7f._serializedATNSegment2
        ], '');
    }
    static get _ATN() {
        if (!$80306ddcd52cd923$export$375c79404cc64c7f.__ATN) $80306ddcd52cd923$export$375c79404cc64c7f.__ATN = new (0, $1ztRl.ATNDeserializer)().deserialize($62Uvn.toCharArray($80306ddcd52cd923$export$375c79404cc64c7f._serializedATN));
        return $80306ddcd52cd923$export$375c79404cc64c7f.__ATN;
    }
}

});

parcelRegister("c35D3", function(module, exports) {

$parcel$export(module.exports, "JQLParser", () => $2ede3a572bfd1706$export$9c4772e191bdb810);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLParser.g4 by ANTLR 4.7.3-SNAPSHOT

var $1ztRl = parcelRequire("1ztRl");

var $iAlWg = parcelRequire("iAlWg");

var $c9Sjf = parcelRequire("c9Sjf");

var $2pDMz = parcelRequire("2pDMz");

var $gzbPK = parcelRequire("gzbPK");

var $b7PPe = parcelRequire("b7PPe");

var $eKXi4 = parcelRequire("eKXi4");

var $hBnE1 = parcelRequire("hBnE1");

var $62Uvn = parcelRequire("62Uvn");
class $2ede3a572bfd1706$export$9c4772e191bdb810 extends (0, $c9Sjf.Parser) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.RULE_jqlQuery = 0;
    }
    static{
        this.RULE_jqlWhere = 1;
    }
    static{
        this.RULE_jqlOrClause = 2;
    }
    static{
        this.RULE_jqlAndClause = 3;
    }
    static{
        this.RULE_jqlNotClause = 4;
    }
    static{
        this.RULE_jqlSubClause = 5;
    }
    static{
        this.RULE_jqlTerminalClause = 6;
    }
    static{
        this.RULE_jqlTerminalClauseRhs = 7;
    }
    static{
        this.RULE_jqlEqualsOperator = 8;
    }
    static{
        this.RULE_jqlLikeOperator = 9;
    }
    static{
        this.RULE_jqlComparisonOperator = 10;
    }
    static{
        this.RULE_jqlInOperator = 11;
    }
    static{
        this.RULE_jqlIsOperator = 12;
    }
    static{
        this.RULE_jqlWasOperator = 13;
    }
    static{
        this.RULE_jqlWasInOperator = 14;
    }
    static{
        this.RULE_jqlChangedOperator = 15;
    }
    static{
        this.RULE_jqlField = 16;
    }
    static{
        this.RULE_jqlFieldProperty = 17;
    }
    static{
        this.RULE_jqlCustomField = 18;
    }
    static{
        this.RULE_jqlString = 19;
    }
    static{
        this.RULE_jqlNumber = 20;
    }
    static{
        this.RULE_jqlOperand = 21;
    }
    static{
        this.RULE_jqlEmpty = 22;
    }
    static{
        this.RULE_jqlValue = 23;
    }
    static{
        this.RULE_jqlFunction = 24;
    }
    static{
        this.RULE_jqlFunctionName = 25;
    }
    static{
        this.RULE_jqlArgumentList = 26;
    }
    static{
        this.RULE_jqlList = 27;
    }
    static{
        this.RULE_jqlListStart = 28;
    }
    static{
        this.RULE_jqlListEnd = 29;
    }
    static{
        this.RULE_jqlPropertyArgument = 30;
    }
    static{
        this.RULE_jqlArgument = 31;
    }
    static{
        this.RULE_jqlWasPredicate = 32;
    }
    static{
        this.RULE_jqlChangedPredicate = 33;
    }
    static{
        this.RULE_jqlDatePredicateOperator = 34;
    }
    static{
        this.RULE_jqlDateRangePredicateOperator = 35;
    }
    static{
        this.RULE_jqlUserPredicateOperator = 36;
    }
    static{
        this.RULE_jqlValuePredicateOperator = 37;
    }
    static{
        this.RULE_jqlPredicateOperand = 38;
    }
    static{
        this.RULE_jqlOrderBy = 39;
    }
    static{
        this.RULE_jqlSearchSort = 40;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.ruleNames = [
            'jqlQuery',
            'jqlWhere',
            'jqlOrClause',
            'jqlAndClause',
            'jqlNotClause',
            'jqlSubClause',
            'jqlTerminalClause',
            'jqlTerminalClauseRhs',
            'jqlEqualsOperator',
            'jqlLikeOperator',
            'jqlComparisonOperator',
            'jqlInOperator',
            'jqlIsOperator',
            'jqlWasOperator',
            'jqlWasInOperator',
            'jqlChangedOperator',
            'jqlField',
            'jqlFieldProperty',
            'jqlCustomField',
            'jqlString',
            'jqlNumber',
            'jqlOperand',
            'jqlEmpty',
            'jqlValue',
            'jqlFunction',
            'jqlFunctionName',
            'jqlArgumentList',
            'jqlList',
            'jqlListStart',
            'jqlListEnd',
            'jqlPropertyArgument',
            'jqlArgument',
            'jqlWasPredicate',
            'jqlChangedPredicate',
            'jqlDatePredicateOperator',
            'jqlDateRangePredicateOperator',
            'jqlUserPredicateOperator',
            'jqlValuePredicateOperator',
            'jqlPredicateOperand',
            'jqlOrderBy',
            'jqlSearchSort'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $hBnE1.VocabularyImpl)($2ede3a572bfd1706$export$9c4772e191bdb810._LITERAL_NAMES, $2ede3a572bfd1706$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'JQLParser.g4';
    }
    // @Override
    get ruleNames() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810._serializedATN;
    }
    constructor(input){
        super(input);
        this._interp = new (0, $gzbPK.ParserATNSimulator)($2ede3a572bfd1706$export$9c4772e191bdb810._ATN, this);
    }
    // @RuleVersion(0)
    jqlQuery() {
        let _localctx = new $2ede3a572bfd1706$export$ff413535b9575c8(this._ctx, this.state);
        this.enterRule(_localctx, 0, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlQuery);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 83;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BANG | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 82;
                this.jqlWhere();
            }
            this.state = 86;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $2ede3a572bfd1706$export$9c4772e191bdb810.ORDER) {
                this.state = 85;
                this.jqlOrderBy();
            }
            this.state = 88;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.EOF);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWhere() {
        let _localctx = new $2ede3a572bfd1706$export$4148a879cab28017(this._ctx, this.state);
        this.enterRule(_localctx, 2, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWhere);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 90;
            this.jqlOrClause();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrClause() {
        let _localctx = new $2ede3a572bfd1706$export$d69831d387793480(this._ctx, this.state);
        this.enterRule(_localctx, 4, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOrClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 92;
            this.jqlAndClause();
            this.state = 97;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.OR){
                this.state = 93;
                this.match($2ede3a572bfd1706$export$9c4772e191bdb810.OR);
                this.state = 94;
                this.jqlAndClause();
                this.state = 99;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlAndClause() {
        let _localctx = new $2ede3a572bfd1706$export$f16819001158b9e(this._ctx, this.state);
        this.enterRule(_localctx, 6, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlAndClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 100;
            this.jqlNotClause();
            this.state = 105;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.AND){
                this.state = 101;
                this.match($2ede3a572bfd1706$export$9c4772e191bdb810.AND);
                this.state = 102;
                this.jqlNotClause();
                this.state = 107;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNotClause() {
        let _localctx = new $2ede3a572bfd1706$export$5e9146f8d5cf1330(this._ctx, this.state);
        this.enterRule(_localctx, 8, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlNotClause);
        let _la;
        try {
            this.state = 112;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.BANG:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 108;
                    _la = this._input.LA(1);
                    if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.BANG || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 109;
                    this.jqlNotClause();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 110;
                    this.jqlSubClause();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 111;
                    this.jqlTerminalClause();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSubClause() {
        let _localctx = new $2ede3a572bfd1706$export$a136a0e9655bfb04(this._ctx, this.state);
        this.enterRule(_localctx, 10, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlSubClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 114;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN);
            this.state = 115;
            this.jqlOrClause();
            this.state = 116;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClause() {
        let _localctx = new $2ede3a572bfd1706$export$23486a2f2ddd5bcd(this._ctx, this.state);
        this.enterRule(_localctx, 12, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlTerminalClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 118;
            this.jqlField();
            this.state = 119;
            this.jqlTerminalClauseRhs();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClauseRhs() {
        let _localctx = new $2ede3a572bfd1706$export$93924a205c12d32c(this._ctx, this.state);
        this.enterRule(_localctx, 14, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
        let _la;
        try {
            this.state = 176;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                case 1:
                    _localctx = new $2ede3a572bfd1706$export$c428f709a58396e5(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 121;
                    this.jqlEqualsOperator();
                    this.state = 125;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                        case 1:
                            this.state = 122;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 123;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 124;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 2:
                    _localctx = new $2ede3a572bfd1706$export$1b131204ef9fa33d(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 127;
                    this.jqlLikeOperator();
                    this.state = 131;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                        case 1:
                            this.state = 128;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 129;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 130;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 3:
                    _localctx = new $2ede3a572bfd1706$export$d83706ee80a9852a(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 133;
                    this.jqlComparisonOperator();
                    this.state = 136;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                        case 1:
                            this.state = 134;
                            this.jqlValue();
                            break;
                        case 2:
                            this.state = 135;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 4:
                    _localctx = new $2ede3a572bfd1706$export$2934b8ff22fddd2d(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 138;
                    this.jqlInOperator();
                    this.state = 141;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN:
                            this.state = 139;
                            this.jqlList();
                            break;
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 140;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $iAlWg.NoViableAltException)(this);
                    }
                    break;
                case 5:
                    _localctx = new $2ede3a572bfd1706$export$8b84310182afcf93(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    this.state = 143;
                    this.jqlIsOperator();
                    this.state = 144;
                    this.jqlEmpty();
                    break;
                case 6:
                    _localctx = new $2ede3a572bfd1706$export$5df295dc7a2cac7c(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    this.state = 146;
                    this.jqlWasOperator();
                    this.state = 150;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                        case 1:
                            this.state = 147;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 148;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 149;
                            this.jqlFunction();
                            break;
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.ON | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.DURING | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 152;
                        this.jqlWasPredicate();
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 7:
                    _localctx = new $2ede3a572bfd1706$export$9ac3367aee261b32(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    this.state = 158;
                    this.jqlWasInOperator();
                    this.state = 161;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN:
                            this.state = 159;
                            this.jqlList();
                            break;
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 160;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $iAlWg.NoViableAltException)(this);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.ON | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.DURING | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 163;
                        this.jqlWasPredicate();
                        this.state = 168;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 8:
                    _localctx = new $2ede3a572bfd1706$export$7a7defca8628a13c(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    this.state = 169;
                    this.jqlChangedOperator();
                    this.state = 173;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.FROM | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.TO | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.ON | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.DURING | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 170;
                        this.jqlChangedPredicate();
                        this.state = 175;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEqualsOperator() {
        let _localctx = new $2ede3a572bfd1706$export$41e475fc1988e413(this._ctx, this.state);
        this.enterRule(_localctx, 16, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 178;
            _la = this._input.LA(1);
            if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.EQUALS || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlLikeOperator() {
        let _localctx = new $2ede3a572bfd1706$export$b76fe5387fdd7efd(this._ctx, this.state);
        this.enterRule(_localctx, 18, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlLikeOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 180;
            _la = this._input.LA(1);
            if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.LIKE || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlComparisonOperator() {
        let _localctx = new $2ede3a572bfd1706$export$d821da0716b3ec95(this._ctx, this.state);
        this.enterRule(_localctx, 20, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 182;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.LT | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.GT | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.GTEQ | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlInOperator() {
        let _localctx = new $2ede3a572bfd1706$export$178478bfa8292f72(this._ctx, this.state);
        this.enterRule(_localctx, 22, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlInOperator);
        try {
            this.state = 187;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.IN:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 184;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IN);
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 185;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.NOT);
                    this.state = 186;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IN);
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlIsOperator() {
        let _localctx = new $2ede3a572bfd1706$export$e64c31d2830b66e4(this._ctx, this.state);
        this.enterRule(_localctx, 24, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlIsOperator);
        try {
            this.state = 192;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 189;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 190;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IS);
                    this.state = 191;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasOperator() {
        let _localctx = new $2ede3a572bfd1706$export$7e283636700e4a6c(this._ctx, this.state);
        this.enterRule(_localctx, 26, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasOperator);
        try {
            this.state = 197;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 194;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.WAS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 195;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.WAS);
                    this.state = 196;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasInOperator() {
        let _localctx = new $2ede3a572bfd1706$export$b9118b1ed9a78d66(this._ctx, this.state);
        this.enterRule(_localctx, 28, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasInOperator);
        try {
            this.state = 204;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 199;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.WAS);
                    this.state = 200;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IN);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 201;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.WAS);
                    this.state = 202;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.NOT);
                    this.state = 203;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IN);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedOperator() {
        let _localctx = new $2ede3a572bfd1706$export$493d626ed78ca66(this._ctx, this.state);
        this.enterRule(_localctx, 30, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlChangedOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 206;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.CHANGED);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlField() {
        let _localctx = new $2ede3a572bfd1706$export$b33300c3d916229a(this._ctx, this.state);
        this.enterRule(_localctx, 32, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlField);
        let _la;
        try {
            this.state = 219;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                    _localctx = new $2ede3a572bfd1706$export$11fec15307d2e17b(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 208;
                    this.jqlNumber();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                    _localctx = new $2ede3a572bfd1706$export$b8b24f99f985ebb3(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 211;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 209;
                            this.jqlString();
                            break;
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD:
                            this.state = 210;
                            this.jqlCustomField();
                            break;
                        default:
                            throw new (0, $iAlWg.NoViableAltException)(this);
                    }
                    this.state = 216;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.LBRACKET){
                        this.state = 213;
                        this.jqlFieldProperty();
                        this.state = 218;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFieldProperty() {
        let _localctx = new $2ede3a572bfd1706$export$b02d0b6637ce0593(this._ctx, this.state);
        this.enterRule(_localctx, 34, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFieldProperty);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 221;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.LBRACKET);
            this.state = 222;
            this.jqlArgument();
            this.state = 223;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.RBRACKET);
            this.state = 228;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                this.state = 225;
                this.jqlPropertyArgument();
                this.state = 230;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlCustomField() {
        let _localctx = new $2ede3a572bfd1706$export$401a038855cc5b15(this._ctx, this.state);
        this.enterRule(_localctx, 36, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlCustomField);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 231;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD);
            this.state = 232;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.LBRACKET);
            this.state = 233;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER);
            this.state = 234;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.RBRACKET);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlString() {
        let _localctx = new $2ede3a572bfd1706$export$bde73d8ad7c8b71e(this._ctx, this.state);
        this.enterRule(_localctx, 38, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlString);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 236;
            _la = this._input.LA(1);
            if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.STRING - 37 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNumber() {
        let _localctx = new $2ede3a572bfd1706$export$8737d94a1880e8b3(this._ctx, this.state);
        this.enterRule(_localctx, 40, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlNumber);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 238;
            _localctx._jqlNum = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOperand() {
        let _localctx = new $2ede3a572bfd1706$export$2eaac5a9828bf647(this._ctx, this.state);
        this.enterRule(_localctx, 42, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOperand);
        try {
            this.state = 244;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 240;
                    this.jqlEmpty();
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 241;
                    this.jqlValue();
                    break;
                case 3:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 242;
                    this.jqlFunction();
                    break;
                case 4:
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 243;
                    this.jqlList();
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEmpty() {
        let _localctx = new $2ede3a572bfd1706$export$d85a062f90025e5c(this._ctx, this.state);
        this.enterRule(_localctx, 44, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlEmpty);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 246;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.EMPTY);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValue() {
        let _localctx = new $2ede3a572bfd1706$export$2e17d457b0933bec(this._ctx, this.state);
        this.enterRule(_localctx, 46, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlValue);
        try {
            this.state = 250;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 248;
                    this.jqlString();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 249;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunction() {
        let _localctx = new $2ede3a572bfd1706$export$ebf0cc785e9ee41a(this._ctx, this.state);
        this.enterRule(_localctx, 48, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFunction);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 252;
            this.jqlFunctionName();
            this.state = 253;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN);
            this.state = 255;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 254;
                this.jqlArgumentList();
            }
            this.state = 257;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunctionName() {
        let _localctx = new $2ede3a572bfd1706$export$1f5f7ac816788f44(this._ctx, this.state);
        this.enterRule(_localctx, 50, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFunctionName);
        try {
            this.state = 261;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 259;
                    this.jqlString();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 260;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgumentList() {
        let _localctx = new $2ede3a572bfd1706$export$83d7c13849b931c3(this._ctx, this.state);
        this.enterRule(_localctx, 52, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlArgumentList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 263;
            this.jqlArgument();
            this.state = 268;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.COMMA){
                this.state = 264;
                this.match($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
                this.state = 265;
                this.jqlArgument();
                this.state = 270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlList() {
        let _localctx = new $2ede3a572bfd1706$export$9cb97a63f2be4864(this._ctx, this.state);
        this.enterRule(_localctx, 54, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 271;
            this.jqlListStart();
            this.state = 272;
            this.jqlOperand();
            this.state = 277;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.COMMA){
                this.state = 273;
                this.match($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
                this.state = 274;
                this.jqlOperand();
                this.state = 279;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 280;
            this.jqlListEnd();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListStart() {
        let _localctx = new $2ede3a572bfd1706$export$c419f717bfc46a5d(this._ctx, this.state);
        this.enterRule(_localctx, 56, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlListStart);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 282;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListEnd() {
        let _localctx = new $2ede3a572bfd1706$export$f6cd3e372f5ab120(this._ctx, this.state);
        this.enterRule(_localctx, 58, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlListEnd);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 284;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPropertyArgument() {
        let _localctx = new $2ede3a572bfd1706$export$e20ce4a2ed16372c(this._ctx, this.state);
        this.enterRule(_localctx, 60, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 286;
            this.jqlArgument();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgument() {
        let _localctx = new $2ede3a572bfd1706$export$a95583953c237f88(this._ctx, this.state);
        this.enterRule(_localctx, 62, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlArgument);
        try {
            this.state = 290;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 288;
                    this.jqlString();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 289;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasPredicate() {
        let _localctx = new $2ede3a572bfd1706$export$9fa1e4d63f31b911(this._ctx, this.state);
        this.enterRule(_localctx, 64, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 295;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.ON:
                    this.state = 292;
                    this.jqlDatePredicateOperator();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.DURING:
                    this.state = 293;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.BY:
                    this.state = 294;
                    this.jqlUserPredicateOperator();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
            this.state = 297;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedPredicate() {
        let _localctx = new $2ede3a572bfd1706$export$e77e479a48133015(this._ctx, this.state);
        this.enterRule(_localctx, 66, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 303;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.ON:
                    this.state = 299;
                    this.jqlDatePredicateOperator();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.DURING:
                    this.state = 300;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.BY:
                    this.state = 301;
                    this.jqlUserPredicateOperator();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.FROM:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.TO:
                    this.state = 302;
                    this.jqlValuePredicateOperator();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
            this.state = 305;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDatePredicateOperator() {
        let _localctx = new $2ede3a572bfd1706$export$dc01290aee731418(this._ctx, this.state);
        this.enterRule(_localctx, 68, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 307;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDateRangePredicateOperator() {
        let _localctx = new $2ede3a572bfd1706$export$75412b8b6a6442e1(this._ctx, this.state);
        this.enterRule(_localctx, 70, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 309;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.DURING);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlUserPredicateOperator() {
        let _localctx = new $2ede3a572bfd1706$export$ad402332075c8656(this._ctx, this.state);
        this.enterRule(_localctx, 72, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 311;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.BY);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValuePredicateOperator() {
        let _localctx = new $2ede3a572bfd1706$export$4239d7c0fbafd3f1(this._ctx, this.state);
        this.enterRule(_localctx, 74, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 313;
            _la = this._input.LA(1);
            if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.FROM || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPredicateOperand() {
        let _localctx = new $2ede3a572bfd1706$export$6b796c5a4b8c18e(this._ctx, this.state);
        this.enterRule(_localctx, 76, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 315;
            this.jqlOperand();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrderBy() {
        let _localctx = new $2ede3a572bfd1706$export$534469b9c8f44139(this._ctx, this.state);
        this.enterRule(_localctx, 78, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOrderBy);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 317;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.ORDER);
            this.state = 318;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.BY);
            this.state = 319;
            this.jqlSearchSort();
            this.state = 324;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.COMMA){
                this.state = 320;
                this.match($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
                this.state = 321;
                this.jqlSearchSort();
                this.state = 326;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSearchSort() {
        let _localctx = new $2ede3a572bfd1706$export$c7d8f03f36952a46(this._ctx, this.state);
        this.enterRule(_localctx, 80, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlSearchSort);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 327;
            this.jqlField();
            this.state = 329;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $2ede3a572bfd1706$export$9c4772e191bdb810.ASC || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.DESC) {
                this.state = 328;
                _la = this._input.LA(1);
                if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.ASC || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    static{
        this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
    }
    static get _ATN() {
        if (!$2ede3a572bfd1706$export$9c4772e191bdb810.__ATN) $2ede3a572bfd1706$export$9c4772e191bdb810.__ATN = new (0, $1ztRl.ATNDeserializer)().deserialize($62Uvn.toCharArray($2ede3a572bfd1706$export$9c4772e191bdb810._serializedATN));
        return $2ede3a572bfd1706$export$9c4772e191bdb810.__ATN;
    }
}
class $2ede3a572bfd1706$export$ff413535b9575c8 extends (0, $2pDMz.ParserRuleContext) {
    EOF() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.EOF, 0);
    }
    jqlWhere() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$4148a879cab28017);
    }
    jqlOrderBy() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$534469b9c8f44139);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlQuery;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlQuery) listener.enterJqlQuery(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlQuery) listener.exitJqlQuery(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$4148a879cab28017 extends (0, $2pDMz.ParserRuleContext) {
    jqlOrClause() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$d69831d387793480);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWhere;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWhere) listener.enterJqlWhere(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWhere) listener.exitJqlWhere(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$d69831d387793480 extends (0, $2pDMz.ParserRuleContext) {
    jqlAndClause(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$f16819001158b9e);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$f16819001158b9e);
    }
    OR(i) {
        if (i === undefined) return this.getTokens($2ede3a572bfd1706$export$9c4772e191bdb810.OR);
        else return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.OR, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOrClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$f16819001158b9e extends (0, $2pDMz.ParserRuleContext) {
    jqlNotClause(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$5e9146f8d5cf1330);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$5e9146f8d5cf1330);
    }
    AND(i) {
        if (i === undefined) return this.getTokens($2ede3a572bfd1706$export$9c4772e191bdb810.AND);
        else return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.AND, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlAndClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$5e9146f8d5cf1330 extends (0, $2pDMz.ParserRuleContext) {
    jqlNotClause() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$5e9146f8d5cf1330);
    }
    NOT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT, 0);
    }
    BANG() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.BANG, 0);
    }
    jqlSubClause() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$a136a0e9655bfb04);
    }
    jqlTerminalClause() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$23486a2f2ddd5bcd);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlNotClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$a136a0e9655bfb04 extends (0, $2pDMz.ParserRuleContext) {
    LPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN, 0);
    }
    jqlOrClause() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$d69831d387793480);
    }
    RPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlSubClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$23486a2f2ddd5bcd extends (0, $2pDMz.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$b33300c3d916229a);
    }
    jqlTerminalClauseRhs() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$93924a205c12d32c);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlTerminalClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$93924a205c12d32c extends (0, $2pDMz.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $2ede3a572bfd1706$export$c428f709a58396e5 extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlEqualsOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$41e475fc1988e413);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$1b131204ef9fa33d extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlLikeOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$b76fe5387fdd7efd);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$d83706ee80a9852a extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlComparisonOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$d821da0716b3ec95);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$2934b8ff22fddd2d extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlInOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$178478bfa8292f72);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInClause) listener.enterJqlInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInClause) listener.exitJqlInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$8b84310182afcf93 extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlIsOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$e64c31d2830b66e4);
    }
    jqlEmpty() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$d85a062f90025e5c);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$5df295dc7a2cac7c extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlWasOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$7e283636700e4a6c);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$9ac3367aee261b32 extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlWasInOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$b9118b1ed9a78d66);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$7a7defca8628a13c extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlChangedOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$493d626ed78ca66);
    }
    jqlChangedPredicate(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$e77e479a48133015);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$e77e479a48133015);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$41e475fc1988e413 extends (0, $2pDMz.ParserRuleContext) {
    EQUALS() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT_EQUALS, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$b76fe5387fdd7efd extends (0, $2pDMz.ParserRuleContext) {
    LIKE() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.LIKE, 0);
    }
    NOT_LIKE() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT_LIKE, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlLikeOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$d821da0716b3ec95 extends (0, $2pDMz.ParserRuleContext) {
    LT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.LT, 0);
    }
    GT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.GT, 0);
    }
    LTEQ() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.LTEQ, 0);
    }
    GTEQ() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.GTEQ, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$178478bfa8292f72 extends (0, $2pDMz.ParserRuleContext) {
    IN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$e64c31d2830b66e4 extends (0, $2pDMz.ParserRuleContext) {
    IS() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.IS, 0);
    }
    NOT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlIsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$7e283636700e4a6c extends (0, $2pDMz.ParserRuleContext) {
    WAS() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.WAS, 0);
    }
    NOT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$b9118b1ed9a78d66 extends (0, $2pDMz.ParserRuleContext) {
    WAS() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.WAS, 0);
    }
    IN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$493d626ed78ca66 extends (0, $2pDMz.ParserRuleContext) {
    CHANGED() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.CHANGED, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlChangedOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$b33300c3d916229a extends (0, $2pDMz.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlField;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $2ede3a572bfd1706$export$11fec15307d2e17b extends $2ede3a572bfd1706$export$b33300c3d916229a {
    jqlNumber() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$8737d94a1880e8b3);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$b8b24f99f985ebb3 extends $2ede3a572bfd1706$export$b33300c3d916229a {
    jqlString() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$bde73d8ad7c8b71e);
    }
    jqlCustomField() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$401a038855cc5b15);
    }
    jqlFieldProperty(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$b02d0b6637ce0593);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$b02d0b6637ce0593);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$b02d0b6637ce0593 extends (0, $2pDMz.ParserRuleContext) {
    LBRACKET() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.LBRACKET, 0);
    }
    RBRACKET() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.RBRACKET, 0);
    }
    jqlPropertyArgument(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$e20ce4a2ed16372c);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$e20ce4a2ed16372c);
    }
    jqlArgument() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFieldProperty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$401a038855cc5b15 extends (0, $2pDMz.ParserRuleContext) {
    CUSTOMFIELD() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD, 0);
    }
    LBRACKET() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.LBRACKET, 0);
    }
    POSNUMBER() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    RBRACKET() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.RBRACKET, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlCustomField;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$bde73d8ad7c8b71e extends (0, $2pDMz.ParserRuleContext) {
    STRING() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.STRING, 0);
    }
    QUOTE_STRING() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING, 0);
    }
    SQUOTE_STRING() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlString;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlString) listener.enterJqlString(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlString) listener.exitJqlString(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlString) return visitor.visitJqlString(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$8737d94a1880e8b3 extends (0, $2pDMz.ParserRuleContext) {
    POSNUMBER() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    NEGNUMBER() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlNumber;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumber) listener.enterJqlNumber(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumber) listener.exitJqlNumber(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$2eaac5a9828bf647 extends (0, $2pDMz.ParserRuleContext) {
    jqlEmpty() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$9cb97a63f2be4864);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOperand) listener.enterJqlOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOperand) listener.exitJqlOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$d85a062f90025e5c extends (0, $2pDMz.ParserRuleContext) {
    EMPTY() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.EMPTY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlEmpty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$2e17d457b0933bec extends (0, $2pDMz.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlValue;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValue) listener.enterJqlValue(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValue) listener.exitJqlValue(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$ebf0cc785e9ee41a extends (0, $2pDMz.ParserRuleContext) {
    jqlFunctionName() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$1f5f7ac816788f44);
    }
    LPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN, 0);
    }
    jqlArgumentList() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$83d7c13849b931c3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFunction;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunction) listener.enterJqlFunction(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunction) listener.exitJqlFunction(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$1f5f7ac816788f44 extends (0, $2pDMz.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFunctionName;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$83d7c13849b931c3 extends (0, $2pDMz.ParserRuleContext) {
    jqlArgument(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$a95583953c237f88);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$a95583953c237f88);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
        else return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlArgumentList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$9cb97a63f2be4864 extends (0, $2pDMz.ParserRuleContext) {
    jqlListStart() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$c419f717bfc46a5d);
    }
    jqlOperand(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$2eaac5a9828bf647);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$2eaac5a9828bf647);
    }
    jqlListEnd() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$f6cd3e372f5ab120);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
        else return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlList) listener.enterJqlList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlList) listener.exitJqlList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlList) return visitor.visitJqlList(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$c419f717bfc46a5d extends (0, $2pDMz.ParserRuleContext) {
    LPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlListStart;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListStart) listener.enterJqlListStart(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListStart) listener.exitJqlListStart(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$f6cd3e372f5ab120 extends (0, $2pDMz.ParserRuleContext) {
    RPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlListEnd;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$e20ce4a2ed16372c extends (0, $2pDMz.ParserRuleContext) {
    jqlArgument() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$a95583953c237f88 extends (0, $2pDMz.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgument) listener.enterJqlArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgument) listener.exitJqlArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$9fa1e4d63f31b911 extends (0, $2pDMz.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ad402332075c8656);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$e77e479a48133015 extends (0, $2pDMz.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ad402332075c8656);
    }
    jqlValuePredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$4239d7c0fbafd3f1);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$dc01290aee731418 extends (0, $2pDMz.ParserRuleContext) {
    AFTER() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.AFTER, 0);
    }
    BEFORE() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE, 0);
    }
    ON() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.ON, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$75412b8b6a6442e1 extends (0, $2pDMz.ParserRuleContext) {
    DURING() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.DURING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$ad402332075c8656 extends (0, $2pDMz.ParserRuleContext) {
    BY() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.BY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$4239d7c0fbafd3f1 extends (0, $2pDMz.ParserRuleContext) {
    FROM() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.FROM, 0);
    }
    TO() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.TO, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$6b796c5a4b8c18e extends (0, $2pDMz.ParserRuleContext) {
    jqlOperand() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$2eaac5a9828bf647);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$534469b9c8f44139 extends (0, $2pDMz.ParserRuleContext) {
    ORDER() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.ORDER, 0);
    }
    BY() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.BY, 0);
    }
    jqlSearchSort(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$c7d8f03f36952a46);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$c7d8f03f36952a46);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
        else return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOrderBy;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$c7d8f03f36952a46 extends (0, $2pDMz.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$b33300c3d916229a);
    }
    DESC() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.DESC, 0);
    }
    ASC() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.ASC, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlSearchSort;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
        else return visitor.visitChildren(this);
    }
}

});

parcelRegister("9I5Iz", function(module, exports) {

$parcel$export(module.exports, "JastBuilderErrorListener", () => $147ceb631043e3b3$export$d0857f60ff1f385);

var $16oBX = parcelRequire("16oBX");

var $8Y1dw = parcelRequire("8Y1dw");
class $147ceb631043e3b3$export$d0857f60ff1f385 {
    constructor(){
        this.errors = [];
        this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
            if (offendingSymbol === undefined) this.errors.push(new (0, $16oBX.JQLParseError)(msg));
            else this.errors.push(new (0, $8Y1dw.JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
        };
    }
}

});
parcelRegister("16oBX", function(module, exports) {

$parcel$export(module.exports, "JQLParseError", () => $7628b77a425707f8$export$e8cfe2b2c93fbd4b);
/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */ class $7628b77a425707f8$export$e8cfe2b2c93fbd4b extends Error {
    constructor(message, cause){
        super(message);
        this.name = 'JQLParseError';
        this.cause = cause;
        this.description = message;
    }
}

});

parcelRegister("8Y1dw", function(module, exports) {

$parcel$export(module.exports, "JQLSyntaxError", () => $df64d3ec2083227e$export$3276184116160c41);

var $16oBX = parcelRequire("16oBX");
class $df64d3ec2083227e$export$3276184116160c41 extends (0, $16oBX.JQLParseError) {
    constructor(message, start, stop, line, charPositionInLine){
        super(message);
        this.name = 'JQLSyntaxError';
        this.start = start;
        this.stop = stop;
        this.line = line;
        this.charPositionInLine = charPositionInLine;
    }
}

});


parcelRegister("icZEp", function(module, exports) {

$parcel$export(module.exports, "QueryVisitor", () => $27df4a640b532afb$export$418003b930734805);

var $ehDeP = parcelRequire("ehDeP");

var $3VUhG = parcelRequire("3VUhG");

var $7kD9l = parcelRequire("7kD9l");

var $9W3D9 = parcelRequire("9W3D9");
class $27df4a640b532afb$export$418003b930734805 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.whereVisitor = new (0, $9W3D9.WhereVisitor)(this.tokens);
        this.orderByVisitor = new (0, $7kD9l.OrderByVisitor)(this.tokens);
        this.visitJqlQuery = (ctx)=>{
            const whereContext = ctx.jqlWhere();
            const orderByContext = ctx.jqlOrderBy();
            return (0, $ehDeP.internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("3VUhG", function(module, exports) {

$parcel$export(module.exports, "JastBuildingVisitor", () => $50292ad2e95b079d$export$d3c14d7188b09387);
$parcel$export(module.exports, "getPositionFromToken", () => $50292ad2e95b079d$export$85a4e6d858dbc6fb);
$parcel$export(module.exports, "getPositionFromContext", () => $50292ad2e95b079d$export$264629d4cd3cad3f);
$parcel$export(module.exports, "getPositionsFromTerminalNodes", () => $50292ad2e95b079d$export$30d51184879cbaa8);
$parcel$export(module.exports, "normalizeText", () => $50292ad2e95b079d$export$7c2714a5250b9239);
class $50292ad2e95b079d$export$d3c14d7188b09387 {
    constructor(tokens){
        this.tokens = tokens;
    }
    visit(tree) {
        throw new Error('Unsupported operation visit(ParseTree)');
    }
    visitChildren(node) {
        throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
    visitErrorNode(node) {
        throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
    visitTerminal(node) {
        throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
}
const $50292ad2e95b079d$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
        startToken.startIndex,
        (stopToken || startToken).stopIndex + 1
    ];
const $50292ad2e95b079d$export$264629d4cd3cad3f = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
    ];
const $50292ad2e95b079d$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$50292ad2e95b079d$export$85a4e6d858dbc6fb(node.payload));
const $50292ad2e95b079d$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');

});

parcelRegister("7kD9l", function(module, exports) {

$parcel$export(module.exports, "OrderByVisitor", () => $e74a275e878565f8$export$2774b71b99734811);


var $ehDeP = parcelRequire("ehDeP");

var $kBQaV = parcelRequire("kBQaV");

var $3VUhG = parcelRequire("3VUhG");

var $cH74S = parcelRequire("cH74S");
class $e74a275e878565f8$export$2774b71b99734811 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.searchSortVisitor = new $e74a275e878565f8$var$SearchSortVisitor(this.tokens);
        this.visitJqlOrderBy = (ctx)=>{
            // If this rule returned due to an exception then the order by operator is incomplete so we should exit early,
            // e.g. 'order '.
            if (ctx.exception) return undefined;
            const operator = (0, $ehDeP.internalCreators).orderByOperator((0, $3VUhG.getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
            const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, $kBQaV.notUndefined));
            return (0, $ehDeP.internalCreators).orderBy(fields, operator, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}
class $e74a275e878565f8$var$SearchSortVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.fieldVisitor = new (0, $cH74S.FieldVisitor)(this.tokens);
        this.visitJqlSearchSort = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            // If the field rule is returned due to an exception then we should ignore this search search rule. This happens
            // when there are no fields following and order by clause, e.g. 'order by '
            if (fieldCtx.exception) return undefined;
            let direction;
            const desc = ctx.DESC();
            const asc = ctx.ASC();
            if (desc !== undefined) direction = (0, $ehDeP.internalCreators).orderByDirection((0, $e28fa7cc527af49f$export$2ea27ea5f2121899), (0, $3VUhG.getPositionFromToken)(desc.payload));
            else if (asc !== undefined) direction = (0, $ehDeP.internalCreators).orderByDirection((0, $e28fa7cc527af49f$export$6d60017b9e092e73), (0, $3VUhG.getPositionFromToken)(asc.payload));
            return (0, $ehDeP.internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("kBQaV", function(module, exports) {

$parcel$export(module.exports, "notUndefined", () => $e16d232ad106654d$export$9a1adf421b69c6a);
/**
 * Type predicate to assert an argument is not undefined.
 */ function $e16d232ad106654d$export$9a1adf421b69c6a(x) {
    return x !== undefined;
}

});

parcelRegister("cH74S", function(module, exports) {

$parcel$export(module.exports, "FieldVisitor", () => $53018f1de7e676aa$export$c6a85c4c3bf2317d);

var $ehDeP = parcelRequire("ehDeP");

var $9ACk0 = parcelRequire("9ACk0");

var $3VUhG = parcelRequire("3VUhG");

var $hnBFP = parcelRequire("hnBFP");
class $53018f1de7e676aa$export$c6a85c4c3bf2317d extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $hnBFP.StringVisitor)(this.tokens);
        this.fieldPropertyVisitor = new $53018f1de7e676aa$var$FieldPropertyVisitor(this.tokens);
        this.visitJqlNumberField = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $ehDeP.internalCreators).field(text, text, undefined, (0, $3VUhG.getPositionFromContext)(ctx));
        };
        this.visitJqlNonNumberField = (ctx)=>{
            const stringContext = ctx.jqlString();
            const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $ehDeP.internalCreators).field(stringValue.value, stringValue.text, properties, (0, $3VUhG.getPositionFromContext)(ctx));
            }
            const text = this.tokens.getText(ctx);
            return (0, $ehDeP.internalCreators).field(text, text, properties, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}
class $53018f1de7e676aa$var$FieldPropertyVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $9ACk0.ArgumentVisitor)(this.tokens);
        this.propertyArgumentVisitor = new $53018f1de7e676aa$var$PropertyArgumentVisitor(this.tokens);
        this.visitJqlFieldProperty = (ctx)=>{
            const argumentContext = ctx.jqlArgument();
            const propertyArgumentContext = ctx.jqlPropertyArgument();
            const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
            return (0, $ehDeP.internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}
class $53018f1de7e676aa$var$PropertyArgumentVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $9ACk0.ArgumentVisitor)(this.tokens);
        this.visitJqlPropertyArgument = (ctx)=>{
            return ctx.jqlArgument().accept(this.argumentVisitor);
        };
    }
}

});
parcelRegister("9ACk0", function(module, exports) {

$parcel$export(module.exports, "ArgumentVisitor", () => $0fa34e4f753b0d1e$export$46b5a1f6d962d533);

var $ehDeP = parcelRequire("ehDeP");

var $3VUhG = parcelRequire("3VUhG");

var $hnBFP = parcelRequire("hnBFP");
class $0fa34e4f753b0d1e$export$46b5a1f6d962d533 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $hnBFP.StringVisitor)(this.tokens);
        this.visitJqlArgument = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $ehDeP.internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $ehDeP.internalCreators).argument(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
            }
        };
    }
}

});
parcelRegister("hnBFP", function(module, exports) {

$parcel$export(module.exports, "StringVisitor", () => $4c8c01f6757ee5f1$export$617850cb96304515);

var $3VUhG = parcelRequire("3VUhG");
class $4c8c01f6757ee5f1$export$617850cb96304515 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.visitJqlString = (ctx)=>{
            const text = this.tokens.getText(ctx);
            const position = (0, $3VUhG.getPositionFromContext)(ctx);
            let value;
            if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
            else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
            else // unquoted string
            value = text;
            return {
                text: text,
                value: value,
                position: position
            };
        };
    }
}

});




parcelRegister("9W3D9", function(module, exports) {

$parcel$export(module.exports, "WhereVisitor", () => $722507e47fe53ea9$export$c573472f1d20e15d);


var $ehDeP = parcelRequire("ehDeP");

var $kBQaV = parcelRequire("kBQaV");

var $3VUhG = parcelRequire("3VUhG");

var $4wtao = parcelRequire("4wtao");
class $722507e47fe53ea9$export$c573472f1d20e15d extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.terminalClauseVisitor = new (0, $4wtao.TerminalClauseVisitor)(this.tokens);
        this.visitJqlWhere = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
        this.visitJqlOrClause = (ctx)=>{
            const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, $kBQaV.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $ehDeP.internalCreators).compoundOperator((0, $e5bc650799ce4838$export$7b8f0a728d79a753), (0, $3VUhG.getPositionsFromTerminalNodes)(ctx.OR()));
                return (0, $ehDeP.internalCreators).compoundClause(operator, clauses, (0, $3VUhG.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        };
        this.visitJqlAndClause = (ctx)=>{
            const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, $kBQaV.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $ehDeP.internalCreators).compoundOperator((0, $e5bc650799ce4838$export$6d6d48d210d3ca97), (0, $3VUhG.getPositionsFromTerminalNodes)(ctx.AND()));
                return (0, $ehDeP.internalCreators).compoundClause(operator, clauses, (0, $3VUhG.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        };
        this.visitJqlNotClause = (ctx)=>{
            const notClauseContext = ctx.jqlNotClause();
            const subClauseContext = ctx.jqlSubClause();
            const terminalClauseContext = ctx.jqlTerminalClause();
            let clause;
            if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
            else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
            else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
            // Our token can be either NOT or !
            let notToken = ctx.NOT();
            notToken = notToken === undefined ? ctx.BANG() : notToken;
            if (notToken && clause) return (0, $ehDeP.internalCreators).notClause(clause, (0, $ehDeP.internalCreators).notClauseOperator((0, $3VUhG.getPositionFromToken)(notToken.payload)), (0, $3VUhG.getPositionFromContext)(ctx));
            return clause;
        };
        this.visitJqlSubClause = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
    }
}

});
parcelRegister("4wtao", function(module, exports) {

$parcel$export(module.exports, "TerminalClauseVisitor", () => $6b978e460b5b79f7$export$14576ae5bd1874a9);

var $ehDeP = parcelRequire("ehDeP");

var $kBQaV = parcelRequire("kBQaV");

var $3VUhG = parcelRequire("3VUhG");

var $cH74S = parcelRequire("cH74S");

var $6z1Wi = parcelRequire("6z1Wi");

var $lLwbI = parcelRequire("lLwbI");

var $kBz8X = parcelRequire("kBz8X");
class $6b978e460b5b79f7$export$14576ae5bd1874a9 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.fieldVisitor = new (0, $cH74S.FieldVisitor)(this.tokens);
        this.terminalClauseRhsVisitor = new $6b978e460b5b79f7$var$TerminalClauseRhsVisitor(this.tokens);
        this.visitJqlTerminalClause = (ctx)=>{
            const field = ctx.jqlField().accept(this.fieldVisitor);
            const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
            const position = (0, $3VUhG.getPositionFromContext)(ctx);
            return (0, $ehDeP.internalCreators).terminalClause(field, operator, operand, predicates, position);
        };
    }
}
class $6b978e460b5b79f7$var$TerminalClauseRhsVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.operatorVisitor = new (0, $lLwbI.OperatorVisitor)(this.tokens);
        this.terminalClauseOperandVisitor = new $6b978e460b5b79f7$var$TerminalClauseOperandVisitor(this.tokens);
        this.predicateVisitor = new (0, $kBz8X.PredicateVisitor)(this.tokens);
        this.visitJqlEqualsClause = (ctx)=>{
            const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlLikeClause = (ctx)=>{
            const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlComparisonClause = (ctx)=>{
            const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlInClause = (ctx)=>{
            const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlIsClause = (ctx)=>{
            const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlWasClause = (ctx)=>{
            const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $kBQaV.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        };
        this.visitJqlWasInClause = (ctx)=>{
            const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $kBQaV.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        };
        this.visitJqlChangedClause = (ctx)=>{
            const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
            const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $kBQaV.notUndefined));
            return {
                operator: operator,
                operand: undefined,
                predicates: predicates
            };
        };
        // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const operator = node.accept(this.operatorVisitor);
            return {
                operator: operator,
                operand: undefined,
                predicates: []
            };
        };
    }
}
class $6b978e460b5b79f7$var$TerminalClauseOperandVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.operandVisitor = new (0, $6z1Wi.OperandVisitor)(this.tokens);
        this.visitJqlEqualsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlLikeClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlComparisonClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlIsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty()
            ]);
        };
        this.visitJqlWasClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlWasInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        };
        this.getOperandForContexts = (contexts)=>{
            const operandContext = contexts.find((0, $kBQaV.notUndefined));
            return operandContext?.accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("6z1Wi", function(module, exports) {

$parcel$export(module.exports, "OperandVisitor", () => $81f4193fbe0decad$export$ef8ae1aa15d9c9af);


var $ehDeP = parcelRequire("ehDeP");

var $kBQaV = parcelRequire("kBQaV");

var $9ACk0 = parcelRequire("9ACk0");

var $3VUhG = parcelRequire("3VUhG");

var $g32gk = parcelRequire("g32gk");

var $hnBFP = parcelRequire("hnBFP");
class $81f4193fbe0decad$export$ef8ae1aa15d9c9af extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $hnBFP.StringVisitor)(this.tokens);
        this.numberVisitor = new (0, $g32gk.NumberVisitor)(this.tokens);
        this.functionNameVisitor = new $81f4193fbe0decad$var$FunctionNameVisitor(this.tokens);
        this.argumentListVisitor = new $81f4193fbe0decad$var$ArgumentListVisitor(this.tokens);
        this.visitJqlOperand = (ctx)=>{
            const operandContext = [
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlList(),
                ctx.jqlFunction()
            ].find((0, $kBQaV.notUndefined));
            return operandContext?.accept(this);
        };
        this.visitJqlEmpty = (ctx)=>{
            // ANTLR will optimistically create a jqlEmpty node in some situations where user input doesn't match the EMPTY
            // token, e.g. when using value operands in IS clauses ("field is value"), where EMPTY is the only valid operand.
            if (ctx.exception) return undefined;
            return (0, $ehDeP.internalCreators).keywordOperand((0, $807962b43ef03b56$export$1c46dca02aac24dd), (0, $3VUhG.getPositionFromToken)(ctx.EMPTY().payload));
        };
        this.visitJqlValue = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $ehDeP.internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
            }
            const numberContext = ctx.jqlNumber();
            if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
        };
        this.visitJqlList = (ctx)=>{
            const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, $kBQaV.notUndefined));
            return (0, $ehDeP.internalCreators).listOperand(values, (0, $3VUhG.getPositionFromContext)(ctx));
        };
        this.visitJqlFunction = (ctx)=>{
            const argumentListContext = ctx.jqlArgumentList();
            return (0, $ehDeP.internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}
class $81f4193fbe0decad$var$FunctionNameVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $hnBFP.StringVisitor)(this.tokens);
        this.visitJqlFunctionName = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $ehDeP.internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $ehDeP.internalCreators).functionString(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
            }
        };
    }
}
class $81f4193fbe0decad$var$ArgumentListVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $9ACk0.ArgumentVisitor)(this.tokens);
        this.visitJqlArgumentList = (ctx)=>{
            return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
        };
    }
}

});
parcelRegister("g32gk", function(module, exports) {

$parcel$export(module.exports, "NumberVisitor", () => $8c2072821d46bf7b$export$a55432f0884633e4);

var $ehDeP = parcelRequire("ehDeP");

var $3VUhG = parcelRequire("3VUhG");
class $8c2072821d46bf7b$export$a55432f0884633e4 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.visitJqlNumber = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $ehDeP.internalCreators).valueOperand(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}

});


parcelRegister("lLwbI", function(module, exports) {

$parcel$export(module.exports, "OperatorVisitor", () => $56193d3bee1d14fd$export$e56f89ba95b51d2a);

var $ehDeP = parcelRequire("ehDeP");

var $ktjOC = parcelRequire("ktjOC");

var $3VUhG = parcelRequire("3VUhG");
class $56193d3bee1d14fd$export$e56f89ba95b51d2a extends (0, $3VUhG.JastBuildingVisitor) {
    visitJqlEqualsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $ktjOC.isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
        return (0, $ehDeP.internalCreators).operator(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlLikeOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $ktjOC.isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
        return (0, $ehDeP.internalCreators).operator(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlComparisonOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $ktjOC.isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
        return (0, $ehDeP.internalCreators).operator(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $3VUhG.normalizeText)(text);
        if (!(0, $ktjOC.isInOperator)(value)) // This can happen if an incomplete operator is used, e.g. `status not open`.
        return undefined;
        return (0, $ehDeP.internalCreators).operator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlIsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $3VUhG.normalizeText)(text);
        if (!(0, $ktjOC.isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
        return (0, $ehDeP.internalCreators).operator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlWasOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $3VUhG.normalizeText)(text);
        if (!(0, $ktjOC.isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
        return (0, $ehDeP.internalCreators).operator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlWasInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $3VUhG.normalizeText)(text);
        if (!(0, $ktjOC.isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
        return (0, $ehDeP.internalCreators).operator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlChangedOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $3VUhG.normalizeText)(text);
        if (!(0, $ktjOC.isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
        return (0, $ehDeP.internalCreators).operator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    constructor(...args){
        super(...args);
        // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const { sourceInterval: sourceInterval } = node;
            const text = this.tokens.getText(sourceInterval);
            if (text) {
                const value = (0, $3VUhG.normalizeText)(text);
                const { a: startIndex, b: stopIndex } = sourceInterval;
                const startToken = this.tokens.get(startIndex);
                const stopToken = this.tokens.get(stopIndex);
                const position = (0, $3VUhG.getPositionFromToken)(startToken, stopToken);
                if ((0, $ktjOC.isOperator)(value)) return (0, $ehDeP.internalCreators).operator(value, text, position);
            }
        };
    }
}

});
parcelRegister("ktjOC", function(module, exports) {

$parcel$export(module.exports, "isOperator", () => $198d8c737341c34e$export$4e40859592ee7ac2);
$parcel$export(module.exports, "isEqualsOperator", () => $198d8c737341c34e$export$6d0fc196fa8a1673);
$parcel$export(module.exports, "isLikeOperator", () => $198d8c737341c34e$export$ad91b6d6a89cb64e);
$parcel$export(module.exports, "isComparisonOperator", () => $198d8c737341c34e$export$4477c442bd5c2a6d);
$parcel$export(module.exports, "isInOperator", () => $198d8c737341c34e$export$c5e1cdef30e30bff);
$parcel$export(module.exports, "isIsOperator", () => $198d8c737341c34e$export$ccc3334744e395c7);
$parcel$export(module.exports, "isWasOperator", () => $198d8c737341c34e$export$2b1c5d7e7856f91d);
$parcel$export(module.exports, "isWasInOperator", () => $198d8c737341c34e$export$55d8c9b20d99509f);
$parcel$export(module.exports, "isChangedOperator", () => $198d8c737341c34e$export$b65d23d23ade534b);
$parcel$export(module.exports, "isListOperator", () => $198d8c737341c34e$export$b09522e4061bbdd6);

var $k85ht = parcelRequire("k85ht");
const $198d8c737341c34e$export$4e40859592ee7ac2 = (operator)=>(0, $k85ht.OPERATORS).includes(operator);
const $198d8c737341c34e$export$6d0fc196fa8a1673 = (operator)=>(0, $k85ht.EQUALS_OPERATORS).includes(operator);
const $198d8c737341c34e$export$ad91b6d6a89cb64e = (operator)=>(0, $k85ht.LIKE_OPERATORS).includes(operator);
const $198d8c737341c34e$export$4477c442bd5c2a6d = (operator)=>(0, $k85ht.COMPARISON_OPERATORS).includes(operator);
const $198d8c737341c34e$export$c5e1cdef30e30bff = (operator)=>(0, $k85ht.IN_OPERATORS).includes(operator);
const $198d8c737341c34e$export$ccc3334744e395c7 = (operator)=>(0, $k85ht.IS_OPERATORS).includes(operator);
const $198d8c737341c34e$export$2b1c5d7e7856f91d = (operator)=>(0, $k85ht.WAS_OPERATORS).includes(operator);
const $198d8c737341c34e$export$55d8c9b20d99509f = (operator)=>(0, $k85ht.WAS_IN_OPERATORS).includes(operator);
const $198d8c737341c34e$export$b65d23d23ade534b = (operator)=>(0, $k85ht.CHANGED_OPERATORS).includes(operator);
const $198d8c737341c34e$export$b09522e4061bbdd6 = (operator)=>(0, $k85ht.LIST_OPERATORS).includes(operator);

});


parcelRegister("kBz8X", function(module, exports) {

$parcel$export(module.exports, "PredicateVisitor", () => $12650a35f2520092$export$33bb52a35c693109);

var $ehDeP = parcelRequire("ehDeP");

var $4Mvgs = parcelRequire("4Mvgs");

var $kBQaV = parcelRequire("kBQaV");

var $3VUhG = parcelRequire("3VUhG");

var $6z1Wi = parcelRequire("6z1Wi");
class $12650a35f2520092$export$33bb52a35c693109 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.predicateOperatorVisitor = new $12650a35f2520092$var$PredicateOperatorVisitor(this.tokens);
        this.predicateOperandVisitor = new $12650a35f2520092$var$PredicateOperandVisitor(this.tokens);
        this.visitJqlWasPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $3VUhG.getPositionFromContext)(ctx);
            return (0, $ehDeP.internalCreators).predicate(operator, operand, position);
        };
        this.visitJqlChangedPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator(),
                ctx.jqlValuePredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $3VUhG.getPositionFromContext)(ctx);
            return (0, $ehDeP.internalCreators).predicate(operator, operand, position);
        };
        this.getOperatorForContexts = (contexts)=>{
            const operatorContext = contexts.find((0, $kBQaV.notUndefined));
            if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
            else throw new Error('Undefined predicate operator context');
        };
    }
}
class $12650a35f2520092$var$PredicateOperatorVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.visitJqlDatePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlDateRangePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlUserPredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlValuePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.getPredicateOperator = (ctx)=>{
            const text = this.tokens.getText(ctx);
            // Replace consecutive whitespace chars with single space
            const value = text.toLowerCase().replace(/\s+/g, ' ');
            if (!(0, $4Mvgs.isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
            return (0, $ehDeP.internalCreators).predicateOperator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}
class $12650a35f2520092$var$PredicateOperandVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.operandVisitor = new (0, $6z1Wi.OperandVisitor)(this.tokens);
        this.visitJqlPredicateOperand = (ctx)=>{
            return ctx.jqlOperand().accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("4Mvgs", function(module, exports) {

$parcel$export(module.exports, "isPredicateOperator", () => $8d2d30ba6207a521$export$188978ad94919403);

var $gjMYw = parcelRequire("gjMYw");
const $8d2d30ba6207a521$export$188978ad94919403 = (operator)=>(0, $gjMYw.PREDICATE_OPERATORS).includes(operator);

});
parcelRegister("gjMYw", function(module, exports) {

$parcel$export(module.exports, "PREDICATE_OPERATORS", () => $07443215caf672cb$export$e200440af9f1d9f);
const $07443215caf672cb$export$3d56e2ae1b4bbbf9 = 'after';
const $07443215caf672cb$export$f0a816341603bb63 = 'before';
const $07443215caf672cb$export$cdc81c84f768d513 = 'by';
const $07443215caf672cb$export$8a5280c65e704c3d = 'during';
const $07443215caf672cb$export$71f882dcac65f97a = 'from';
const $07443215caf672cb$export$5685a35c6b0a7ee8 = 'on';
const $07443215caf672cb$export$5a83c4789e531a = 'to';
const $07443215caf672cb$export$e200440af9f1d9f = [
    $07443215caf672cb$export$3d56e2ae1b4bbbf9,
    $07443215caf672cb$export$f0a816341603bb63,
    $07443215caf672cb$export$cdc81c84f768d513,
    $07443215caf672cb$export$8a5280c65e704c3d,
    $07443215caf672cb$export$71f882dcac65f97a,
    $07443215caf672cb$export$5685a35c6b0a7ee8,
    $07443215caf672cb$export$5a83c4789e531a
];

});










parcelRegister("5ujax", function(module, exports) {

$parcel$export(module.exports, "hasAllRequiredFields", () => $52d6130341d650ac$export$146976a1cbd99cd0);

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $52d6130341d650ac$export$146976a1cbd99cd0 = ({ issueType: issueType, createInput: createInput })=>{
    if (!issueType) return false;
    return issueType.fields.every((field)=>{
        if (!field.fieldConfig?.isRequired) return true;
        if (!field.type && !field.aliasFieldId) return false;
        if (field.aliasFieldId && field.aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID)) return Boolean(createInput.startDate);
        if (field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return createInput.storyPoints != null;
        if (field.type) switch(field.type){
            case 0, $lO4Or.ISSUE_TYPE:
            case 0, $lO4Or.REPORTER_TYPE:
                return true;
            case 0, $lO4Or.SUMMARY_TYPE:
                return Boolean(createInput.summary);
            case 0, $lO4Or.PRIORITY_TYPE:
                return Boolean(createInput.priority);
            case 0, $lO4Or.ASSIGNEE_TYPE:
                return Boolean(createInput.assignee);
            case 0, $lO4Or.DUE_DATE_TYPE:
                return Boolean(createInput.dueDate);
            case 0, $lO4Or.CATEGORY_TYPE:
                return Boolean(createInput.category);
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return createInput.storyPointEstimate != null;
            case 0, $lO4Or.SPRINT_TYPE:
                return Boolean(createInput.sprint);
            default:
                break;
        }
        return false;
    });
};

});

parcelRegister("auegK", function(module, exports) {

$parcel$export(module.exports, "CancelledError", () => $3e371496a660187a$export$a8430ed4188f35a9);
$parcel$export(module.exports, "useCreateIssueDialog", () => $3e371496a660187a$export$8254d39962ec7361);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $dNWQB = parcelRequire("dNWQB");

var $2gOs4 = parcelRequire("2gOs4");

var $1MRnf = parcelRequire("1MRnf");

var $ctR9z = parcelRequire("ctR9z");

var $fD1Hq = parcelRequire("fD1Hq");

var $l1Cux = parcelRequire("l1Cux");
class $3e371496a660187a$export$a8430ed4188f35a9 extends Error {
}
const $3e371496a660187a$export$8d1d8a0d2a7917ac = ()=>{
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    return (0, $eUqFw.useCallback)((issueType, predicate)=>{
        if (!issueType) return undefined;
        const issueTypeWithFields = typesWithFields.find((typeWithFields)=>typeWithFields.issueType.id === issueType.id);
        return issueTypeWithFields?.fields.find(predicate);
    }, [
        typesWithFields
    ]);
};
const $3e371496a660187a$export$8254d39962ec7361 = ()=>{
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const getField = $3e371496a660187a$export$8d1d8a0d2a7917ac();
    // rank field is handled separately as it's not returned by the available fields API
    const { data: rankField } = (0, $fD1Hq.useRankField)();
    return (0, $eUqFw.useCallback)((createInput, extraPayload)=>new Promise((resolve, reject)=>{
            const unsubscribe = subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                // the user cancelled editing
                onClose(null);
            });
            // resolve the promise once the GIC has been closed or reject it if cancelled
            const onClose = (data)=>{
                const result = data?.[0];
                if (result) resolve(result);
                else // adding a delay upon user cancelling because of a bug in the GIC's state management logic ICO-303
                setTimeout(()=>{
                    reject(new $3e371496a660187a$export$a8430ed4188f35a9('User cancelled'));
                }, 100);
                unsubscribe();
            };
            const { payload: payload, submitApiData: submitApiData } = (0, $l1Cux.buildGICPayload)({
                createInput: createInput,
                extraPayload: extraPayload,
                rankField: rankField,
                getField: getField
            });
            const isSubTaskCreationOpen = createInput.issueType?.hierarchyLevel === -1;
            openIssueCreateModal({
                id: 'jwm-create-issue-dialog',
                onClose: onClose,
                payload: payload,
                context: {
                    projectId: createInput.projectId,
                    submitApiData: submitApiData
                },
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                triggerPointKey: (0, $1MRnf.JWM_INLINE_CREATE),
                disableProjectDropdown: true,
                disableIssueTypeDropdown: Boolean(payload.issueType?.issueTypeId),
                disableCreationSuccessFlag: true,
                displayCreateAnotherIssueToggle: false,
                minimizableModalView: 'mini'
            });
        }), [
        getField,
        openIssueCreateModal,
        rankField,
        subscribe
    ]);
};

});
parcelRegister("dNWQB", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $21eb2e23e0bf69c0$export$876003a5b887f37e);
const $21eb2e23e0bf69c0$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("2gOs4", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $c9d12900db50c35b$export$e3ff72f196296fcc);

var $jcERi = parcelRequire("jcERi");
const $c9d12900db50c35b$var$GICLifeCycleEventsService = new (0, $jcERi.PubSubHub)();
const $c9d12900db50c35b$export$e3ff72f196296fcc = ()=>({
        ...$c9d12900db50c35b$var$GICLifeCycleEventsService
    });

});
parcelRegister("jcERi", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $a1db2e8ca1046c74$export$e3607828f8f2c01e);
class $a1db2e8ca1046c74$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("1MRnf", function(module, exports) {

$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $33ffe55cb7bcdadc$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $33ffe55cb7bcdadc$export$c78d329777576aa0);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $33ffe55cb7bcdadc$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $33ffe55cb7bcdadc$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $33ffe55cb7bcdadc$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $33ffe55cb7bcdadc$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $33ffe55cb7bcdadc$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $33ffe55cb7bcdadc$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $33ffe55cb7bcdadc$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $33ffe55cb7bcdadc$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $33ffe55cb7bcdadc$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $33ffe55cb7bcdadc$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $33ffe55cb7bcdadc$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $33ffe55cb7bcdadc$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $33ffe55cb7bcdadc$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $33ffe55cb7bcdadc$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $33ffe55cb7bcdadc$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $33ffe55cb7bcdadc$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $33ffe55cb7bcdadc$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $33ffe55cb7bcdadc$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $33ffe55cb7bcdadc$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $33ffe55cb7bcdadc$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $33ffe55cb7bcdadc$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $33ffe55cb7bcdadc$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $33ffe55cb7bcdadc$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $33ffe55cb7bcdadc$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $33ffe55cb7bcdadc$export$32648b574a536c8b);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $33ffe55cb7bcdadc$export$c0e2ab74dfaa67cc);
const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $33ffe55cb7bcdadc$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $33ffe55cb7bcdadc$export$f352408886aa304b = 'connect-app-ecosystem';
const $33ffe55cb7bcdadc$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};

});

parcelRegister("ctR9z", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $bd445758cecbab8c$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $bd445758cecbab8c$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $bd445758cecbab8c$export$558a195c5bfe3787);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $dfh7z = parcelRequire("dfh7z");

var $dEMIg = parcelRequire("dEMIg");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $h5RgW = parcelRequire("h5RgW");

var $ellXt = parcelRequire("ellXt");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
var $2HpOy = parcelRequire("2HpOy");

var $1MRnf = parcelRequire("1MRnf");

var $dgsxZ = parcelRequire("dgsxZ");
const $bd445758cecbab8c$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $1MRnf.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {}
};
const $bd445758cecbab8c$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $dgsxZ.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $dgsxZ.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $bd445758cecbab8c$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $dgsxZ.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $dfh7z.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $bd445758cecbab8c$var$store = (0, $kEDjj.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $bd445758cecbab8c$export$d4c72bab9d6cc13a,
    actions: $bd445758cecbab8c$export$e324594224ef24da
});
const $bd445758cecbab8c$var$useTriggerIssueCreateModalState = (0, $1yZQx.createStateHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$var$useTriggerIssueCreateModalActions = (0, $1yZQx.createActionsHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$export$71e0eb7b8a91a156 = ()=>{
    const createState = $bd445758cecbab8c$var$useTriggerIssueCreateModalState();
    const createActions = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $bd445758cecbab8c$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
};
const $bd445758cecbab8c$export$4c674fe824b8f278 = (0, $2HpOy.createSubscriber)($bd445758cecbab8c$var$store);
function $bd445758cecbab8c$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $bd445758cecbab8c$export$71e0eb7b8a91a156();
        const { data: data } = (0, $h5RgW.useResource)((0, $ellXt.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("dfh7z", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $5fd686e53a19cbe0$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $5fd686e53a19cbe0$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $5fd686e53a19cbe0$export$70208657c8d471a7);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $5fd686e53a19cbe0$export$cd75c112ac11a83b = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $5fd686e53a19cbe0$export$e890e797a25e655c = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5fd686e53a19cbe0$export$70208657c8d471a7 = new (0, $kDfSL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});

});

parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("dgsxZ", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $b8d8e5356c7976a6$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $b8d8e5356c7976a6$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $b8d8e5356c7976a6$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $b8d8e5356c7976a6$export$720579602bb055a2);

var $dfh7z = parcelRequire("dfh7z");

var $fqKjL = parcelRequire("fqKjL");

var $hBkQt = parcelRequire("hBkQt");

var $75e8i = parcelRequire("75e8i");
const $b8d8e5356c7976a6$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $dfh7z.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $75e8i.default)('global-issue.create-modal-subsequent');
    else (0, $75e8i.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $hBkQt.startGlobalIssueCreateTTIWithAdjustments)();
};
const $b8d8e5356c7976a6$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $b8d8e5356c7976a6$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $b8d8e5356c7976a6$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("fqKjL", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $de2993c8c3fea479$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $de2993c8c3fea479$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $de2993c8c3fea479$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $de2993c8c3fea479$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $de2993c8c3fea479$export$c1592e4d8d98963e);

var $lNfG4 = parcelRequire("lNfG4");
const $de2993c8c3fea479$export$5a01a7fa84b239c8 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $de2993c8c3fea479$export$c50ad3c31b6fcfc6 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $de2993c8c3fea479$export$4b2382574525bb0f = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $de2993c8c3fea479$export$7839bdaa2f6a2385 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $de2993c8c3fea479$export$c1592e4d8d98963e = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("hBkQt", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $362542d6dd943f24$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $362542d6dd943f24$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $362542d6dd943f24$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $362542d6dd943f24$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $362542d6dd943f24$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $362542d6dd943f24$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $362542d6dd943f24$export$9f3d6f17e1da7874 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $362542d6dd943f24$export$457c9fb71ad5b3a9 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.start();
};
const $362542d6dd943f24$export$ef664dac649a716c = ()=>$362542d6dd943f24$export$9f3d6f17e1da7874.mark('gic-tti');
const $362542d6dd943f24$export$30ca4c461fab486c = (customData)=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $362542d6dd943f24$export$27f2445288b528c = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.cancel();
};
const $362542d6dd943f24$export$7a2709fc1e33401a = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $362542d6dd943f24$export$cf3893335c93e33b = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $362542d6dd943f24$export$d86f4868694f2aa7 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [];

});




parcelRegister("l1Cux", function(module, exports) {

$parcel$export(module.exports, "buildGICPayload", () => $3b44adbb66991c12$export$eb18ffe6388f217a);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable complexity */ 
var $6x1NF = parcelRequire("6x1NF");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $3b44adbb66991c12$var$assigneeFieldPredicate = (field)=>field.type === (0, $lO4Or.ASSIGNEE_TYPE);
const $3b44adbb66991c12$var$categoryFieldPredicate = (field)=>field.type === (0, $lO4Or.CATEGORY_TYPE);
const $3b44adbb66991c12$var$dueDateFieldPredicate = (field)=>field.type === (0, $lO4Or.DUE_DATE_TYPE);
const $3b44adbb66991c12$var$priorityFieldPredicate = (field)=>field.type === (0, $lO4Or.PRIORITY_TYPE);
const $3b44adbb66991c12$var$startDateFieldPredicate = (field)=>field.aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID);
const $3b44adbb66991c12$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $3b44adbb66991c12$var$storyPointsFieldPredicate = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $3b44adbb66991c12$var$sprintFieldPredicate = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $3b44adbb66991c12$export$eb18ffe6388f217a = ({ createInput: createInput, extraPayload: extraPayload, rankField: rankField, getField: getField })=>{
    const payload = {
        defaultValues: {
            singleLineTextFields: [],
            singleSelectUserPickerFields: [],
            numberFields: [],
            datePickerFields: []
        },
        project: {
            projectId: createInput.projectId
        }
    };
    const additionalFields = {};
    let transition;
    if (createInput.summary) payload.defaultValues.singleLineTextFields.push({
        fieldId: (0, $lO4Or.SUMMARY_TYPE),
        text: createInput.summary
    });
    if (createInput.issueType) payload.issueType = {
        issueTypeId: createInput.issueType.id
    };
    if (createInput.dueDate && getField(createInput.issueType, $3b44adbb66991c12$var$dueDateFieldPredicate)) {
        const formattedDueDate = (0, $6x1NF.default)(createInput.dueDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: (0, $lO4Or.DUE_DATE_TYPE),
            date: {
                formattedDate: formattedDueDate
            }
        });
        additionalFields.duedate = formattedDueDate;
    }
    const startDateField = getField(createInput.issueType, $3b44adbb66991c12$var$startDateFieldPredicate);
    if (createInput.startDate && startDateField) {
        const formattedStartDate = (0, $6x1NF.default)(createInput.startDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: startDateField.id,
            date: {
                formattedDate: formattedStartDate
            }
        });
        additionalFields[startDateField.id] = formattedStartDate;
    }
    if (createInput.assignee && getField(createInput.issueType, $3b44adbb66991c12$var$assigneeFieldPredicate)) {
        payload.defaultValues.singleSelectUserPickerFields.push({
            fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
            user: {
                accountId: createInput.assignee.accountId
            }
        });
        additionalFields[0, $lO4Or.ASSIGNEE_TYPE] = {
            id: createInput.assignee.accountId
        };
    }
    if (createInput.priority && getField(createInput.issueType, $3b44adbb66991c12$var$priorityFieldPredicate)) {
        payload.defaultValues.priority = {
            priorityId: createInput.priority.priorityId
        };
        additionalFields[0, $lO4Or.PRIORITY_TYPE] = {
            id: createInput.priority.priorityId
        };
    }
    const categoryField = getField(createInput.issueType, $3b44adbb66991c12$var$categoryFieldPredicate);
    if (createInput.category && categoryField) {
        payload.defaultValues.singleSelectFields = [
            {
                fieldId: categoryField.id,
                option: {
                    id: createInput.category.optionId,
                    optionId: createInput.category.optionId
                }
            }
        ];
        additionalFields[categoryField.id] = {
            id: createInput.category.optionId,
            value: createInput.category.value
        };
    }
    const storyPointEstimateField = getField(createInput.issueType, $3b44adbb66991c12$var$storyPointEstimateFieldPredicate);
    if (createInput.storyPointEstimate && storyPointEstimateField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        });
        additionalFields[storyPointEstimateField.id] = {
            id: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        };
    }
    const storyPointsField = getField(createInput.issueType, $3b44adbb66991c12$var$storyPointsFieldPredicate);
    if (createInput.storyPoints && storyPointsField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointsField.id,
            value: createInput.storyPoints
        });
        additionalFields[storyPointsField.id] = {
            id: storyPointsField.id,
            value: createInput.storyPoints
        };
    }
    const sprintField = getField(createInput.issueType, $3b44adbb66991c12$var$sprintFieldPredicate);
    if (createInput.sprint && sprintField) {
        payload.defaultValues.sprintsField = {
            fieldId: sprintField.id,
            sprints: [
                {
                    sprintId: createInput.sprint.id
                }
            ]
        };
        additionalFields[sprintField.id] = {
            id: sprintField.id,
            value: createInput.sprint.id
        };
    }
    if (createInput.parentIssueId) {
        payload.parentId = {
            parentId: createInput.parentIssueId
        };
        payload.defaultValues.parentField = {
            issueId: createInput.parentIssueId
        };
    }
    if (createInput.status && extraPayload?.transitionId) {
        payload.status = {
            statusId: createInput.status.statusId
        };
        transition = {
            id: extraPayload.transitionId
        };
    }
    if (rankField && (createInput.rankAfter || createInput.rankBefore)) // rank is always passed as additional field
    additionalFields[rankField.id] = {
        ...createInput.rankAfter ? {
            rankAfterIssue: createInput.rankAfter.issueId
        } : {},
        ...createInput.rankBefore ? {
            rankBeforeIssue: createInput.rankBefore.issueId
        } : {}
    };
    return {
        payload: payload,
        submitApiData: {
            additionalFields: additionalFields,
            transition: transition
        }
    };
};

});


parcelRegister("fOAem", function(module, exports) {

$parcel$export(module.exports, "useShowCreateSuccessFlag", () => $96a3689a6bc73ef9$export$dfe953d11a91d407);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hIxFu = parcelRequire("hIxFu");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $jb0p7 = parcelRequire("jb0p7");
const $96a3689a6bc73ef9$export$dfe953d11a91d407 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [, setSelectedIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    return (0, $eUqFw.useCallback)((issueKey)=>{
        const flagId = `jwm-create-success-flag-${issueKey}`;
        showFlag({
            id: flagId,
            isAutoDismiss: true,
            type: 'success',
            title: formatMessage((0, $jb0p7.default).createSuccessFlagTitle, {
                issueKey: issueKey
            }),
            actions: [
                {
                    content: (0, $jb0p7.default).viewIssueLinkText,
                    href: `/browse/${issueKey}`,
                    onClick: (event)=>{
                        if (event && !(0, $hIxFu.isModifiedEvent)(event)) {
                            setSelectedIssueKey(issueKey);
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        dismissFlag(flagId);
                    }
                }
            ]
        });
    }, [
        dismissFlag,
        formatMessage,
        setSelectedIssueKey,
        showFlag
    ]);
};

});
parcelRegister("hIxFu", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $b3eda05a90faeae0$export$642c6f14f6d4bbd5);
const $b3eda05a90faeae0$export$642c6f14f6d4bbd5 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("jb0p7", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d4475055050609$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $82d4475055050609$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSuccessFlagTitle: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    viewIssueLinkText: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text",
        "defaultMessage": "View issue"
    }
});

});


parcelRegister("9Y2JR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd43750acdd7824c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bd43750acdd7824c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title",
        "defaultMessage": "We weren't able to create an issue"
    },
    errorFlagDescription: {
        "id": "business-issue-create.controllers.create-issue.error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});


parcelRegister("frfm9", function(module, exports) {

$parcel$export(module.exports, "useCreateParamHandler", () => $6b54e991d48bd90a$export$294bf5b0ba86140);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $lB25E = parcelRequire("lB25E");

var $auegK = parcelRequire("auegK");
const $6b54e991d48bd90a$export$294bf5b0ba86140 = ()=>{
    const [inlineCreateParam, setInlineCreateParam] = (0, $lB25E.useQueryParam)((0, $jGcn0.INLINE_CREATE_PARAM));
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const project = (0, $kQAZu.useProject)();
    (0, $eUqFw.useEffect)(()=>{
        if (inlineCreateParam != null) {
            showCreateIssueDialog({
                projectId: String(project.id)
            }).catch(()=>{
            // we don't care about the error in this scenario
            });
            setInlineCreateParam(undefined);
        }
    }, [
        inlineCreateParam,
        project,
        setInlineCreateParam,
        showCreateIssueDialog
    ]);
};

});


parcelRegister("k3EUD", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_MUTATION", () => $9c369d6aa3fa7766$export$f5c1cac020b22be4);
$parcel$export(module.exports, "ISSUE_REFETCH_QUERY", () => $9c369d6aa3fa7766$export$834c81726d4c51eb);

var $9ypom = parcelRequire("9ypom");

var $k9sa9 = parcelRequire("k9sa9");

var $jsfvR = parcelRequire("jsfvR");

var $7Pw84 = parcelRequire("7Pw84");

var $7XECd = parcelRequire("7XECd");
const $9c369d6aa3fa7766$var$CREATED_ITEM_FRAGMENT = (0, $9ypom.default)`
fragment CreatedListItemFragment on JiraWorkManagementViewItem {
    id
    issueId
    childSummary {
        hasChildren
        totalCount
    }
    commentSummary {
        totalCount
    }
    legacyConfluenceLinks(getFirstOnly: true) {
        ...ConfluenceLinksFragment
    }
    devSummaryCache @include(if: $isDevSummaryFieldVisible)  {
        ...DevSummaryFieldFragment
    }
    ...ListViewIssueFieldsFragment
}
${(0, $7XECd.LIST_VIEW_FIELDS_FRAGMENT)}
${(0, $k9sa9.CONFLUENCE_LINKS_FRAGMENT)}
${(0, $jsfvR.JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT)}
`;
const $9c369d6aa3fa7766$export$f5c1cac020b22be4 = (0, $9ypom.default)`

mutation JWMListInlineCreateIssue ($input: JiraCreateIssueInput!, $fieldIds: [String]!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentIssueId: Boolean!) {
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CreatedListItemFragment
        }
        ...CreateIssueFragment
    }
}
${(0, $7Pw84.CREATE_ISSUE_FRAGMENT)}
${$9c369d6aa3fa7766$var$CREATED_ITEM_FRAGMENT}
`;
const $9c369d6aa3fa7766$export$834c81726d4c51eb = (0, $9ypom.default)`
query JWMListInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentIssueId: Boolean!) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {
                        ...CreatedListItemFragment
                    }
                }
            }
        }
    }
}
${$9c369d6aa3fa7766$var$CREATED_ITEM_FRAGMENT}
`;

});
parcelRegister("k9sa9", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_LINKS_FRAGMENT", () => $560fee80a719f902$export$757a6323be066698);

var $9ypom = parcelRequire("9ypom");
const $560fee80a719f902$export$757a6323be066698 = (0, $9ypom.default)`
    fragment ConfluenceLinksFragment on ConfluenceLinks {    
            linkedConfluencePages {
                pageCount
                pages {
                    ... on ConfluencePage {
                        id
                        globalId
                        href
                        title
                        type
                        lastUpdatedContext {
                            user {
                                key
                                accountId
                                emailAddress
                                avatarUrl
                                displayName
                                active
                            }
                        }
                    }
                    ... on FailedRemoteLink {
                        id
                        error
                        link {
                            id
                            globalId
                            href
                        }
                        repairLink {
                            href
                        }
                    }
                }
            }
    }
`;

});

parcelRegister("jsfvR", function(module, exports) {

$parcel$export(module.exports, "JIRA_BUSINESS_FIELDS_FRAGMENT", () => $c67038b8aa4bb6f6$export$16a4e56fe7b29670);
$parcel$export(module.exports, "JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT", () => $c67038b8aa4bb6f6$export$8a6df2ce60bca6f1);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $knKYk = parcelRequire("knKYk");

var $7FAgb = parcelRequire("7FAgb");

var $eO5bL = parcelRequire("eO5bL");

var $6abst = parcelRequire("6abst");

var $7iWRP = parcelRequire("7iWRP");

var $8taGk = parcelRequire("8taGk");

var $jE8oD = parcelRequire("jE8oD");

var $dwTBA = parcelRequire("dwTBA");

var $dOZkn = parcelRequire("dOZkn");

var $cDFYl = parcelRequire("cDFYl");

var $edYOM = parcelRequire("edYOM");

var $l6gH4 = parcelRequire("l6gH4");

var $7Agtp = parcelRequire("7Agtp");

var $kpAWV = parcelRequire("kpAWV");

var $hNOMn = parcelRequire("hNOMn");

var $6YPjW = parcelRequire("6YPjW");

var $7V4Du = parcelRequire("7V4Du");

var $dfvNy = parcelRequire("dfvNy");

var $jy6Ks = parcelRequire("jy6Ks");

var $12K5u = parcelRequire("12K5u");

var $619OD = parcelRequire("619OD");
const $c67038b8aa4bb6f6$export$16a4e56fe7b29670 = (0, $9ypom.default)`
	${(0, $dwTBA.PARENT_FRAGMENT)}
	${(0, $jy6Ks.VERSION_FRAGMENT)}
	${(0, $hNOMn.TEAM_FRAGMENT)}
	${(0, $eO5bL.GOALS_FRAGMENT)}
	${(0, $l6gH4.RESOLUTION_FRAGMENT)}
	${(0, $6abst.GROUP_FRAGMENT)}
	${(0, $7iWRP.LABELS_FRAGMENT)}
	${(0, $12K5u.DATE_FRAGMENT)}
	${(0, $619OD.DATE_TIME_FRAGMENT)}
	${(0, $dfvNy.ATLASSIAN_ACCOUNT_FRAGMENT)}
	${(0, $dfvNy.USER_FRAGMENT)}
	${(0, $dfvNy.PEOPLE_FRAGMENT)}
	${(0, $dfvNy.MULTIPLE_USER_FRAGMENT)}
	${(0, $dOZkn.PRIORITY_FRAGMENT)}
	${(0, $8taGk.MULTIPLE_SELECT_FRAGMENT)}
	${(0, $jE8oD.NUMBER_FRAGMENT)}
	${(0, $edYOM.RADIO_SELECT_FRAGMENT)}
	${(0, $7Agtp.SINGLE_SELECT_FRAGMENT)}
	${(0, $7V4Du.URL_FRAGMENT)}
	${(0, $6YPjW.SINGLE_LINE_TEXT_FRAGMENT)}
	${(0, $kpAWV.STATUS_CATEGORY_FRAGMENT)}
	${(0, $knKYk.CASCADING_SELECT_FRAGMENT)}
	${(0, $cDFYl.PROJECT_FRAGMENT)}
`;
const $c67038b8aa4bb6f6$export$8a6df2ce60bca6f1 = (0, $9ypom.default)`
	${(0, $7FAgb.DEV_SUMMARY_FRAGMENT)}
`;

});
parcelRegister("knKYk", function(module, exports) {

$parcel$export(module.exports, "CASCADING_SELECT_FRAGMENT", () => $1dee1f780cc92072$export$88d11aac85f3a5f2);

var $9ypom = parcelRequire("9ypom");
const $1dee1f780cc92072$export$88d11aac85f3a5f2 = (0, $9ypom.default)`
    fragment jiraCascadingSelectFieldFragment on JiraCascadingSelectField {
        id
        fieldId
        fieldConfig {
            isEditable
        }
        cascadingOption {
            parentValue {
                id
                isDisabled
                value
            }
            childOptionValue {
                id
                optionId
                isDisabled
                value
            }
        }
    } 
`;

});

parcelRegister("7FAgb", function(module, exports) {

$parcel$export(module.exports, "DEV_SUMMARY_FRAGMENT", () => $1822f106238a6d70$export$a5751f0d2763fac3);

var $9ypom = parcelRequire("9ypom");
const $1822f106238a6d70$export$a5751f0d2763fac3 = (0, $9ypom.default)`
    fragment DevSummaryFieldFragment on JiraIssueDevSummaryResult {
        devSummary {
            commit {
                overall {
                    count
                }
            }
            pullrequest {
                overall {
                    state
                    count
                }
            }
        }
    } 
`;

});

parcelRegister("eO5bL", function(module, exports) {

$parcel$export(module.exports, "GOALS_FRAGMENT", () => $7c48f16fc92b4b75$export$14859f852d0eecb4);

var $9ypom = parcelRequire("9ypom");
const $7c48f16fc92b4b75$export$14859f852d0eecb4 = (0, $9ypom.default)`
    fragment JiraGoalsFieldFragment on JiraGoalsField {
        __typename
        fieldId
        name
        fieldConfig {
            isEditable
        }
        selectedGoals(first: 1) {
            totalCount,
            edges {
                node {
                    id
                    name
                    status
                }
            }
        }
    }
`;

});

parcelRegister("6abst", function(module, exports) {

$parcel$export(module.exports, "GROUP_FRAGMENT", () => $dc896979b0c4b14e$export$91c2ad2e63414b50);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $9ypom = parcelRequire("9ypom");
const $dc896979b0c4b14e$export$99b0877e6d0a4712 = (0, $9ypom.default)`
    fragment jiraBusinessSingleGroupFieldFragment on JiraSingleGroupPickerField {
      __typename
      id
      fieldId
      name
      selectedGroup {
        id
        groupId
        name
      }
    }
`;
const $dc896979b0c4b14e$export$27846949a41c873f = (0, $9ypom.default)`
    fragment jiraBusinessMultipleGroupFieldFragment on JiraMultipleGroupPickerField {
      __typename
      id
      fieldId
      name
      selectedGroupsConnection {
        edges {
          node {
            id
            groupId
            name
          }
        }
      }
    }
`;
const $dc896979b0c4b14e$export$91c2ad2e63414b50 = (0, $9ypom.default)`
	${$dc896979b0c4b14e$export$27846949a41c873f}
	${$dc896979b0c4b14e$export$99b0877e6d0a4712}
`;

});

parcelRegister("7iWRP", function(module, exports) {

$parcel$export(module.exports, "LABELS_FRAGMENT", () => $da845276456d17d3$export$30f9416168d64de4);

var $9ypom = parcelRequire("9ypom");
const $da845276456d17d3$export$30f9416168d64de4 = (0, $9ypom.default)`
    fragment jiraLabelsFieldFragment on JiraLabelsField {
        selectedLabelsConnection {
            edges {
                node {
                    name
                }
            }
        }
    } 
`;

});

parcelRegister("8taGk", function(module, exports) {

$parcel$export(module.exports, "MULTIPLE_SELECT_FRAGMENT", () => $dbe24feb054829bd$export$ed658c6a0e11bdf9);

var $9ypom = parcelRequire("9ypom");
const $dbe24feb054829bd$export$ed658c6a0e11bdf9 = (0, $9ypom.default)`
    fragment jiraMultipleSelectFieldFragment on JiraMultipleSelectField {
        fieldConfig {
            isEditable
          }
        selectedOptions {
            edges {
                node {
                    optionId
                    value
                }
            }
        }
    }
`;

});

parcelRegister("jE8oD", function(module, exports) {

$parcel$export(module.exports, "NUMBER_FRAGMENT", () => $618c56cda47ac49c$export$c1b90ff48aa1e878);

var $9ypom = parcelRequire("9ypom");
const $618c56cda47ac49c$export$c1b90ff48aa1e878 = (0, $9ypom.default)`
    fragment jiraNumberFieldFragment on JiraNumberField {
        number
        fieldConfig {
          isEditable
        }
    }
`;

});

parcelRegister("dwTBA", function(module, exports) {

$parcel$export(module.exports, "PARENT_FRAGMENT", () => $72420efef97913c5$export$1efcd2a93f28f76e);

var $9ypom = parcelRequire("9ypom");
const $72420efef97913c5$export$1efcd2a93f28f76e = (0, $9ypom.default)`
    fragment jiraBusinessParentFieldFragment on JiraParentIssueField {
        fieldId
        parentIssue {
            id @include(if: $withParentIssueId)
            issueId
            key
            rankField: fieldsByIdOrAlias(idsOrAliases: ["rank"], ignoreMissingFields: true) @connection (key: "parentRankField") {
                aliasFieldId
                ... on JiraSingleLineTextField {
                    text
                }
            }
            fields: fieldsByIdOrAlias(idsOrAliases: ["summary", "issuetype", "issuecolor", "status"], ignoreMissingFields: true) @connection (key: "parentFields") @include(if: $isParentFieldVisible) {
                fieldId
                name
                aliasFieldId
                type
                ... on JiraColorField {
                    color {
                        colorKey
                    }
                }
                ... on JiraSingleLineTextField {
                    text
                }
                ... on JiraStatusField {
                    status {
                        name
                        statusCategory {
                            statusCategoryId
                        }
                    }
                }
                ... on JiraIssueTypeField {
                    issueType {
                        name
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
`;

});

parcelRegister("dOZkn", function(module, exports) {

$parcel$export(module.exports, "PRIORITY_FRAGMENT", () => $b70122d1523a6883$export$6d5f71aa3bbf9a14);

var $9ypom = parcelRequire("9ypom");
const $b70122d1523a6883$export$6d5f71aa3bbf9a14 = (0, $9ypom.default)`
    fragment jiraPriorityFieldFragment on JiraPriorityField {
        priority {
            id
            name
            priorityId
            iconUrl
        }
    }
`;

});

parcelRegister("cDFYl", function(module, exports) {

$parcel$export(module.exports, "PROJECT_FRAGMENT", () => $a4a2cba79cefd910$export$e365122194197244);

var $9ypom = parcelRequire("9ypom");
const $a4a2cba79cefd910$export$e365122194197244 = (0, $9ypom.default)`
    fragment jiraProjectFieldFragment on JiraProjectField {
        fieldId
        name
        project {
            id
            projectId
            name
            key
            avatar {
                large
            }
        }
    }
`;

});

parcelRegister("edYOM", function(module, exports) {

$parcel$export(module.exports, "RADIO_SELECT_FRAGMENT", () => $9011f1a76bb1c7c7$export$55296ac87efdd2c2);

var $9ypom = parcelRequire("9ypom");
const $9011f1a76bb1c7c7$export$55296ac87efdd2c2 = (0, $9ypom.default)`
    fragment jiraRadioSelectFieldFragment on JiraRadioSelectField {
        fieldId
        name
        fieldConfig {
            isEditable
        }
        selectedOption {
            optionId
            value
        }
    }
`;

});

parcelRegister("l6gH4", function(module, exports) {

$parcel$export(module.exports, "RESOLUTION_FRAGMENT", () => $95c5771aabe2f2bb$export$e8f52599fbfc8f74);

var $9ypom = parcelRequire("9ypom");
const $95c5771aabe2f2bb$export$e8f52599fbfc8f74 = (0, $9ypom.default)`
    fragment jiraBusinessResolutionFieldFragment on JiraResolutionField {
        fieldId
        name
        resolution {
            id
            name
        }
    } 
`;

});

parcelRegister("7Agtp", function(module, exports) {

$parcel$export(module.exports, "SINGLE_SELECT_FRAGMENT", () => $60efd2c7e32ed4cb$export$f1c5cfc4b5de6700);

var $9ypom = parcelRequire("9ypom");
const $60efd2c7e32ed4cb$export$f1c5cfc4b5de6700 = (0, $9ypom.default)`
    fragment jiraSingleSelectFragment on JiraSingleSelectField {
        fieldConfig {
            isEditable
        }
        fieldOption {
            optionId
            value
            color {
                colorKey
            }
        }
    }
`;

});

parcelRegister("kpAWV", function(module, exports) {

$parcel$export(module.exports, "STATUS_CATEGORY_FRAGMENT", () => $3d33e6ad79841c36$export$a125a2d730e3d413);

var $9ypom = parcelRequire("9ypom");
const $3d33e6ad79841c36$export$a125a2d730e3d413 = (0, $9ypom.default)`
    fragment jiraStatusCategoryFragment on JiraStatusCategoryField {
        fieldId
        fieldConfig {
          isEditable
        }
        statusCategory {
          id
          statusCategoryId
          name
        }
    }
`;

});

parcelRegister("hNOMn", function(module, exports) {

$parcel$export(module.exports, "TEAM_FRAGMENT", () => $b3ffb5d31d5f4342$export$b8a1e15b67d0c801);

var $9ypom = parcelRequire("9ypom");
const $b3ffb5d31d5f4342$export$b8a1e15b67d0c801 = (0, $9ypom.default)`
    fragment jiraBusinessTeamFieldFragment on JiraTeamViewField {
        fieldId
        selectedTeam {
            jiraSuppliedName
            jiraSuppliedTeamId
        }
    } 
`;

});

parcelRegister("6YPjW", function(module, exports) {

$parcel$export(module.exports, "SINGLE_LINE_TEXT_FRAGMENT", () => $fe7b71abea61f99e$export$23113309bffe00ca);

var $9ypom = parcelRequire("9ypom");
const $fe7b71abea61f99e$export$23113309bffe00ca = (0, $9ypom.default)`
    fragment jiraSingleLineTextFragment on JiraSingleLineTextField {
        text
    }
`;

});

parcelRegister("7V4Du", function(module, exports) {

$parcel$export(module.exports, "URL_FRAGMENT", () => $f3ec340ded916e2c$export$7044ea8d89b6f59d);

var $9ypom = parcelRequire("9ypom");
const $f3ec340ded916e2c$export$7044ea8d89b6f59d = (0, $9ypom.default)`
    fragment jiraUrlFieldFragment on JiraUrlField {
        uri
        fieldConfig {
          isEditable
        }
    }
`;

});

parcelRegister("dfvNy", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT_FRAGMENT", () => $42c19ca4b42d5a18$export$7620e2c63d440c49);
$parcel$export(module.exports, "USER_FRAGMENT", () => $42c19ca4b42d5a18$export$6496fa362c67d06e);
$parcel$export(module.exports, "PEOPLE_FRAGMENT", () => $42c19ca4b42d5a18$export$49438f3cf8087021);
$parcel$export(module.exports, "MULTIPLE_USER_FRAGMENT", () => $42c19ca4b42d5a18$export$5267cb871f0541c9);

var $9ypom = parcelRequire("9ypom");
const $42c19ca4b42d5a18$export$7620e2c63d440c49 = (0, $9ypom.default)`
  fragment AtlassianAccountFragment on AtlassianAccountUser {
    accountId
    accountStatus
    picture
    name
  }
`;
const $42c19ca4b42d5a18$export$6496fa362c67d06e = (0, $9ypom.default)`
    fragment jiraSingleUserFieldFragment on JiraSingleSelectUserPickerField {
        user {
            ...AtlassianAccountFragment
        }
        fieldConfig {
            isEditable
        }
    }
`;
const $42c19ca4b42d5a18$export$49438f3cf8087021 = (0, $9ypom.default)`
    fragment jiraPeopleFieldFragment on JiraPeopleField {
        fieldConfig {
          isEditable
        }
        selectedUsersConnection {
          edges {
            node {
              ...AtlassianAccountFragment
            }
          }
        }
    }
`;
const $42c19ca4b42d5a18$export$5267cb871f0541c9 = (0, $9ypom.default)`
    fragment jiraMultipleUserFieldFragment on JiraMultipleSelectUserPickerField {
        selectedUsersConnection {
          edges {
            node {
              ...AtlassianAccountFragment
            }
          }
        }
        fieldConfig {
          isEditable
        }
    }
`;

});

parcelRegister("jy6Ks", function(module, exports) {

$parcel$export(module.exports, "VERSION_FRAGMENT", () => $1edd726b01aafa2b$export$6f6bf5d27acb96a6);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $9ypom = parcelRequire("9ypom");
const $1edd726b01aafa2b$export$4320515340a845c0 = (0, $9ypom.default)`
    fragment jiraBusinessSingleVersionFieldFragment on JiraSingleVersionPickerField {
      __typename
      id
      fieldId
      name
      version {
        versionId
        name
      }
    }
`;
const $1edd726b01aafa2b$export$b336fe1ccb7b1f67 = (0, $9ypom.default)`
    fragment jiraBusinessMultipleVersionFieldFragment on JiraMultipleVersionPickerField {
      __typename
      id
      fieldId
      name
      selectedVersionsConnection {
        edges {
          node {
            versionId
            name
          }
        }
      }
    }
`;
const $1edd726b01aafa2b$export$6f6bf5d27acb96a6 = (0, $9ypom.default)`
	${$1edd726b01aafa2b$export$b336fe1ccb7b1f67}
	${$1edd726b01aafa2b$export$4320515340a845c0}
`;

});

parcelRegister("12K5u", function(module, exports) {

$parcel$export(module.exports, "DATE_FRAGMENT", () => $e27c61cf85fc05d7$export$f8e1b8104aa9273f);

var $9ypom = parcelRequire("9ypom");
const $e27c61cf85fc05d7$export$f8e1b8104aa9273f = (0, $9ypom.default)`
    fragment jiraDateFieldFragment on JiraDatePickerField {
        date
    } 
`;

});

parcelRegister("619OD", function(module, exports) {

$parcel$export(module.exports, "DATE_TIME_FRAGMENT", () => $5bbad55334412b6a$export$f5c7c2e5cce27d00);

var $9ypom = parcelRequire("9ypom");
const $5bbad55334412b6a$export$f5c7c2e5cce27d00 = (0, $9ypom.default)`
    fragment jiraDateTimeFieldFragment on JiraDateTimePickerField {
        dateTime
    } 
`;

});


parcelRegister("7Pw84", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_FRAGMENT", () => $33f8e9ac12479c3a$export$47232071d0e9dfb);

var $9ypom = parcelRequire("9ypom");
const $33f8e9ac12479c3a$export$47232071d0e9dfb = (0, $9ypom.default)`
fragment CreateIssueFragment on JiraBusinessCreateIssuePayload {
  itemIdentifiers: item @connection (key: "issue-create-ids") {
    issueId
    issueKey: fieldsByIdOrAlias(idsOrAliases: ["issuekey"]) {
      ... on JiraSingleLineTextField {
          text
      }
    }
  }
  success
  errors {
    message
    extensions {
      ...on MutationErrorExtension {
        statusCode
        errorType
      }
    }
  }
}`;

});

parcelRegister("7XECd", function(module, exports) {

$parcel$export(module.exports, "LIST_VIEW_FIELDS_FRAGMENT", () => $fbac42598b9ed86c$export$878eea3ba159096b);
$parcel$export(module.exports, "LIST_VIEW_QUERY", () => $fbac42598b9ed86c$export$bf9c5668f03a036d);
$parcel$export(module.exports, "BACKGROUND_LIST_VIEW_QUERY", () => $fbac42598b9ed86c$export$b0ac16e8fe90de24);
$parcel$export(module.exports, "LIST_VIEW_ITEM_DETAILS_QUERY", () => $fbac42598b9ed86c$export$3f338783432a1617);

var $9ypom = parcelRequire("9ypom");

var $k9sa9 = parcelRequire("k9sa9");

var $jsfvR = parcelRequire("jsfvR");
const $fbac42598b9ed86c$export$878eea3ba159096b = (0, $9ypom.default)`
  fragment ListViewIssueFieldsFragment on JiraWorkManagementViewItem {
    fields: fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) @connection (key: "fields") {
      fieldId
      name
      aliasFieldId
      type
      ... on JiraIssueTypeField {
        issueType {
          issueTypeId
          name
          avatar {
            medium
          }
          hierarchy {
            level
          }
        }
      }
      ... on JiraStatusField {
        status {
          name
          statusId
          statusCategory {
            statusCategoryId
          }
        }
      }
      ... on JiraRichTextField {
        richText {
          adfValue {
            json
            convertedPlainText {
              plainText
              isTruncated
            }
          }
        }
        renderer
      }
      ... on JiraOriginalTimeEstimateField {
        originalEstimate {
          timeInSeconds
        }
        fieldConfig {
          isEditable
        }
      }
      ... on JiraTimeTrackingField {
        originalEstimate {
          timeInSeconds
        }
        timeTrackingSettings {
          defaultUnit
          defaultFormat
          workingHoursPerDay
          workingDaysPerWeek
        }
      }
      ... on JiraComponentsField {
        fieldConfig {
          isEditable
        }
        selectedComponentsConnection {
          edges {
            node {
              name
              componentId
            }
          }
        }
      }
      ... on JiraParentIssueField {
        parentIssue {
          issueId
          key
        }
      }
     ... on JiraCheckboxesField {
        selectedOptions {
          edges {
            node {
              optionId
              value
            }
          }
        }
      }
      ... on JiraSprintField {
        fieldId
        aliasFieldId
        fieldConfig {
          isEditable
        }
        selectedSprintsConnection(first: 1) {
          edges {
            node {
              sprintId
              name
              state
            }
          }
        }
      }
      ...jiraBusinessSingleVersionFieldFragment
      ...jiraBusinessMultipleVersionFieldFragment
      ...jiraBusinessParentFieldFragment
      ...jiraBusinessTeamFieldFragment
      ...JiraGoalsFieldFragment
      ...jiraBusinessResolutionFieldFragment
      ...jiraBusinessSingleGroupFieldFragment
      ...jiraBusinessMultipleGroupFieldFragment
      ...jiraLabelsFieldFragment
      ...jiraDateFieldFragment
      ...jiraDateTimeFieldFragment
      ...jiraSingleUserFieldFragment
      ...jiraMultipleUserFieldFragment
      ...jiraPeopleFieldFragment
      ...jiraPriorityFieldFragment
      ...jiraMultipleSelectFieldFragment
      ...jiraNumberFieldFragment
      ...jiraRadioSelectFieldFragment
      ...jiraSingleSelectFragment
      ...jiraUrlFieldFragment
      ...jiraSingleLineTextFragment
      ...jiraStatusCategoryFragment
      ...jiraCascadingSelectFieldFragment
      ...jiraProjectFieldFragment
    }
  }

  ${(0, $jsfvR.JIRA_BUSINESS_FIELDS_FRAGMENT)}
`;
const $fbac42598b9ed86c$export$5f151982dc1bb93c = (0, $9ypom.default)`
  fragment ListViewItemEdges on JiraWorkManagementViewItemConnection {
    edges {
      node {
        id
        issueId
        childSummary(includeDone: $includeDoneItems) {
            hasChildren
            totalCount
        }
        commentSummary {
            totalCount
        }
        legacyConfluenceLinks(getFirstOnly: true) @include(if: $withConfluenceLinks) @connection(key: "legacyConfluenceLinks") {
            ...ConfluenceLinksFragment
        }
        devSummaryCache @include(if: $isDevSummaryFieldVisible)  {
          ...DevSummaryFieldFragment
        }
        ...ListViewIssueFieldsFragment
      }
    }
  }
  ${$fbac42598b9ed86c$export$878eea3ba159096b}
  ${(0, $k9sa9.CONFLUENCE_LINKS_FRAGMENT)}
  ${(0, $jsfvR.JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT)}
`;
const $fbac42598b9ed86c$export$bf9c5668f03a036d = (0, $9ypom.default)`
  query JWMListViewItems($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentIssueId: Boolean!) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) @connection (key: "list", filter:["jql"]) {
        ...on QueryError {
          message
          extensions {
            statusCode
            errorType
          }
        }
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }

  ${$fbac42598b9ed86c$export$5f151982dc1bb93c}
`;
const $fbac42598b9ed86c$export$b0ac16e8fe90de24 = (0, $9ypom.default)`
  query JWMListViewItemsBackground($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentIssueId: Boolean!) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) @connection (key: "backgroundList", filter:["jql"]) {
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }

  ${$fbac42598b9ed86c$export$5f151982dc1bb93c}
`;
const $fbac42598b9ed86c$export$3f338783432a1617 = (0, $9ypom.default)`
  query JWMListViewItemDetails($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentIssueId: Boolean!) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) {
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
        }
      }
    }
  }

  ${$fbac42598b9ed86c$export$5f151982dc1bb93c}
`;

});


parcelRegister("fWkFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42223e83f1ce9c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3da0c = parcelRequire("3da0c");

var $lPArN = parcelRequire("lPArN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b42223e83f1ce9c0$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $3da0c.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPArN.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("3da0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $156a3428b96ddf9e$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $156a3428b96ddf9e$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("lPArN", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dddb8b24cbf4df$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84dddb8b24cbf4df$export$2e2bcd8739ae039 = ({ url: url })=>{
    window.location.assign(url);
    return null;
};

});


parcelRegister("jasPp", function(module, exports) {

$parcel$export(module.exports, "AuthenticationErrorBoundary", () => $f166a39fad510ca7$export$124b2dc1d1aab5e6);

var $eUqFw = parcelRequire("eUqFw");

var $4X5wI = parcelRequire("4X5wI");
class $f166a39fad510ca7$export$124b2dc1d1aab5e6 extends (0, $eUqFw.Component) {
    componentDidCatch(error, info) {
        if (error instanceof (0, $4X5wI.AuthenticationError)) {
            this.setState({
                caughtError: {
                    error: error,
                    info: info
                }
            });
            return;
        }
        throw error;
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback } = this.props;
        if (!caughtError) return children;
        return renderFallback();
    }
    constructor(...args){
        super(...args);
        this.state = {
            caughtError: null
        };
    }
}

});
parcelRegister("4X5wI", function(module, exports) {

$parcel$export(module.exports, "AuthenticationError", () => $9c4d4fc947b6f0a7$export$cf0c46b07324e9c5);
class $9c4d4fc947b6f0a7$export$cf0c46b07324e9c5 extends Error {
    constructor(message){
        super(message);
        this.name = 'AuthenticationError';
        this.skipSentry = true;
        this.statusCode = 401;
    }
}

});


parcelRegister("gbsaq", function(module, exports) {

$parcel$export(module.exports, "LIST_PADDING_LEFT", () => $c42804ad4b83a228$export$a473358fe9122073);
$parcel$export(module.exports, "LIST_ROW", () => $c42804ad4b83a228$export$beca668e8640bfff);
$parcel$export(module.exports, "DEFAULT_ROW_HEIGHT", () => $c42804ad4b83a228$export$258441c8a79bb589);
$parcel$export(module.exports, "ROW_KEY", () => $c42804ad4b83a228$export$1c6db1a0937ef0bd);
$parcel$export(module.exports, "SELECT_ROW_COLUMN_WIDTH", () => $c42804ad4b83a228$export$c9c106422318b1d6);
$parcel$export(module.exports, "EXPAND_ICON_INDENT_WIDTH", () => $c42804ad4b83a228$export$68438aed9d51940e);
$parcel$export(module.exports, "LIST_FIELD_POPUP_OFFSET", () => $c42804ad4b83a228$export$3e36baaa5cb0cfb5);
$parcel$export(module.exports, "DATE_LOZENGE_ID", () => $c42804ad4b83a228$export$9fcfab1f93d2a27a);
$parcel$export(module.exports, "CHILD_CREATE_BTN_WRAPPER", () => $c42804ad4b83a228$export$16bb76a118fce7b4);
$parcel$export(module.exports, "UP", () => $c42804ad4b83a228$export$b29f845fa4b57508);
$parcel$export(module.exports, "DOWN", () => $c42804ad4b83a228$export$c7c029a231f98d34);
$parcel$export(module.exports, "LEFT", () => $c42804ad4b83a228$export$f981f70d61d1405a);
$parcel$export(module.exports, "RIGHT", () => $c42804ad4b83a228$export$1cac5500365a4eb4);
$parcel$export(module.exports, "BULK_SELECT_CHECKBOX_ID", () => $c42804ad4b83a228$export$61ba93f63403a728);
$parcel$export(module.exports, "DRAG_AND_DROP_BUTTON_FOCUS_EVENT", () => $c42804ad4b83a228$export$2e64c33508f031cb);
$parcel$export(module.exports, "ACTION_DRAG_STARTED", () => $c42804ad4b83a228$export$5886ae675e1cc401);
$parcel$export(module.exports, "ACTION_DRAG_ENDED", () => $c42804ad4b83a228$export$736f74130173aad9);
$parcel$export(module.exports, "NO_ISSUE_TYPE", () => $c42804ad4b83a228$export$6a707112f448ba18);
$parcel$export(module.exports, "NO_PARENT_ISSUE_TYPE", () => $c42804ad4b83a228$export$aa7400fdf583255b);
$parcel$export(module.exports, "TOP_LEVEL_COLLECTION", () => $c42804ad4b83a228$export$e9f49e7d94ba81a7);
$parcel$export(module.exports, "BULK_DELETE_IN_PROGRESS_FLAG_ID", () => $c42804ad4b83a228$export$2537d1b6d47b8b99);
$parcel$export(module.exports, "BULK_DELETE_SUCCESS_FLAG_ID", () => $c42804ad4b83a228$export$50d12af09489a2d7);
$parcel$export(module.exports, "BULK_DELETE_FAILED_FLAG_ID", () => $c42804ad4b83a228$export$b4268ee17ddbdd7f);
$parcel$export(module.exports, "BULK_DELETE_FAILED_CLIENT_FLAG_ID", () => $c42804ad4b83a228$export$ebf578347a3066f4);
$parcel$export(module.exports, "VIEW_EXPERIENCE", () => $c42804ad4b83a228$export$4a2289be55388ee6);
$parcel$export(module.exports, "LOAD_CHILDREN_EXPERIENCE", () => $c42804ad4b83a228$export$16b872ae5b961241);
$parcel$export(module.exports, "LOAD_GROUP_ITEMS_EXPERIENCE", () => $c42804ad4b83a228$export$47da82a3abffaada);
$parcel$export(module.exports, "LOAD_GROUP_ITEMS_CHILDREN_EXPERIENCE", () => $c42804ad4b83a228$export$6c7be7d66ea2537f);
$parcel$export(module.exports, "BULK_DELETE_EXPERIENCE", () => $c42804ad4b83a228$export$435db386ec1c226);
$parcel$export(module.exports, "BULK_COPY_EXPERIENCE", () => $c42804ad4b83a228$export$dbecc95ea17b546e);
$parcel$export(module.exports, "CREATE_CATEGORY_EXPERIENCE", () => $c42804ad4b83a228$export$af494ffa4befd621);
$parcel$export(module.exports, "UPDATE_CATEGORY_EXPERIENCE", () => $c42804ad4b83a228$export$15d259507553cf76);
$parcel$export(module.exports, "DELETE_CATEGORY_EXPERIENCE", () => $c42804ad4b83a228$export$a433ff40336ab4a7);
$parcel$export(module.exports, "SUPPORTED_GROUPS_TYPES", () => $c42804ad4b83a228$export$220fd19c26dc2508);
$parcel$export(module.exports, "BULK_EDIT_CHANGEBOARDING_MESSAGE_ID", () => $c42804ad4b83a228$export$5b958d8fec7c426a);

var $lO4Or = parcelRequire("lO4Or");
const $c42804ad4b83a228$export$a473358fe9122073 = 20;
const $c42804ad4b83a228$export$beca668e8640bfff = 'listRow';
const $c42804ad4b83a228$export$258441c8a79bb589 = 40;
const $c42804ad4b83a228$export$727f6efd406ed55d = 50;
const $c42804ad4b83a228$export$1c6db1a0937ef0bd = 'rowKey';
const $c42804ad4b83a228$export$c9c106422318b1d6 = 65;
const $c42804ad4b83a228$export$1911356e2f572e = 35;
const $c42804ad4b83a228$export$68438aed9d51940e = 20;
const $c42804ad4b83a228$export$a2dd5f25b5a4e5d2 = 45;
const $c42804ad4b83a228$export$56446adcecbeec34 = {
    tableFooter: 1,
    tableShadow: 2,
    inlineFieldCreateControls: 3
};
const $c42804ad4b83a228$export$3e36baaa5cb0cfb5 = [
    0,
    -$c42804ad4b83a228$export$258441c8a79bb589
];
const $c42804ad4b83a228$export$eda9e94a9409652f = 'tag-wrapper-highlight-on-hover';
const $c42804ad4b83a228$export$9fcfab1f93d2a27a = 'list-date-lozenge';
const $c42804ad4b83a228$export$16bb76a118fce7b4 = 'child-create-btn-wrapper';
const $c42804ad4b83a228$export$b29f845fa4b57508 = 'up';
const $c42804ad4b83a228$export$c7c029a231f98d34 = 'down';
const $c42804ad4b83a228$export$f981f70d61d1405a = 'left';
const $c42804ad4b83a228$export$1cac5500365a4eb4 = 'right';
const $c42804ad4b83a228$export$61ba93f63403a728 = 'bulk-select-checkbox';
const $c42804ad4b83a228$export$2e64c33508f031cb = 'drag-and-drop-button-focus';
const $c42804ad4b83a228$export$ce523a2c42983704 = 45;
const $c42804ad4b83a228$export$5886ae675e1cc401 = 'dragStarted';
const $c42804ad4b83a228$export$736f74130173aad9 = 'dragEnded';
const $c42804ad4b83a228$export$6a707112f448ba18 = 'noIssueType';
const $c42804ad4b83a228$export$aa7400fdf583255b = 'noParentIssueType';
const $c42804ad4b83a228$export$e9f49e7d94ba81a7 = 'topLevelCollection';
const $c42804ad4b83a228$export$2537d1b6d47b8b99 = 'bulk-delete-in-progress-flag';
const $c42804ad4b83a228$export$50d12af09489a2d7 = 'bulk-delete-success-flag';
const $c42804ad4b83a228$export$b4268ee17ddbdd7f = 'bulk-delete-failed-flag';
const $c42804ad4b83a228$export$ebf578347a3066f4 = 'bulk-delete-failed-client-flag';
const $c42804ad4b83a228$export$4a2289be55388ee6 = {
    experience: 'listView',
    experienceId: 'main',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$16b872ae5b961241 = {
    experience: 'loadChildren',
    experienceId: 'children',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$47da82a3abffaada = {
    experience: 'loadGroup',
    experienceId: 'groupItems',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$6c7be7d66ea2537f = {
    experience: 'loadGroupChildren',
    experienceId: 'groupItemsChildren',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$435db386ec1c226 = {
    experience: 'bulkDelete',
    experienceId: 'bulkDelete',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$dbecc95ea17b546e = {
    experience: 'bulkCopy',
    experienceId: 'bulkCopy',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$af494ffa4befd621 = {
    experience: 'createCategory',
    experienceId: 'createCategory',
    packageName: 'jiraBusinessList',
    teamName: 'jira-warepil'
};
const $c42804ad4b83a228$export$15d259507553cf76 = {
    experience: 'updateCategory',
    experienceId: 'updateCategory',
    packageName: 'jiraBusinessList',
    teamName: 'jira-warepil'
};
const $c42804ad4b83a228$export$a433ff40336ab4a7 = {
    experience: 'deleteCategory',
    experienceId: 'deleteCategory',
    packageName: 'jiraBusinessList',
    teamName: 'jira-warepil'
};
const $c42804ad4b83a228$export$220fd19c26dc2508 = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
    (0, $lO4Or.NUMBER_CF_TYPE),
    (0, $lO4Or.SPRINT_TYPE)
];
const $c42804ad4b83a228$export$5b958d8fec7c426a = 'bulk_edit_changeboarding';

});

parcelRegister("egJIx", function(module, exports) {

$parcel$export(module.exports, "useJWMListFeatures", () => $dd73846feb791cdd$export$1253737febad5ca9);
$parcel$export(module.exports, "ListFeaturesProvider", () => $dd73846feb791cdd$export$9b33d4a1cd64aa2c);

var $eUqFw = parcelRequire("eUqFw");
const $dd73846feb791cdd$var$defaultFeaturesContext = {
    isShareButtonEnabled: true,
    isPresenceEnabled: true,
    issueViewInteraction: 'default',
    isOnboardingEnabled: true,
    featureView: 'list',
    inviteButtonInteraction: 'default',
    typeSelectInteraction: 'default',
    hasFilterCustomFields: true,
    hasCreateSubtask: true,
    canCreateIssues: true,
    isSoftwareFieldsEnabled: false,
    isBusinessFieldsEnabled: true,
    isScrumProject: false
};
const $dd73846feb791cdd$var$ListFeaturesContext = /*#__PURE__*/ (0, $eUqFw.createContext)($dd73846feb791cdd$var$defaultFeaturesContext);
const $dd73846feb791cdd$export$1253737febad5ca9 = ()=>(0, $eUqFw.useContext)($dd73846feb791cdd$var$ListFeaturesContext);
const $dd73846feb791cdd$export$9b33d4a1cd64aa2c = ({ children: children, ...props })=>{
    const value = (0, $eUqFw.useMemo)(()=>({
            ...$dd73846feb791cdd$var$defaultFeaturesContext,
            ...props
        }), [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd73846feb791cdd$var$ListFeaturesContext.Provider, {
        value: value
    }, children);
};

});

parcelRegister("dSE3z", function(module, exports) {

$parcel$export(module.exports, "useGroupBy", () => $2f464576ca82e79c$export$c4ec754551fa3ff4);

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");
const $2f464576ca82e79c$export$c4ec754551fa3ff4 = ()=>{
    const [groupByFieldId, setGroupBy] = (0, $7c3W1.useViewPreference)((0, $ji3xf.GROUPING_PREFERENCE));
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [
        groupByFieldId,
        setGroupBy
    ];
};

});

parcelRegister("1kNYc", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $26c5ccbb20325860$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $e4qlg = parcelRequire("e4qlg");

var $4S5hf = parcelRequire("4S5hf");

var $kkYfO = parcelRequire("kkYfO");

var $lGxgz = parcelRequire("lGxgz");

var $dlVOn = parcelRequire("dlVOn");

var $eI5EY = parcelRequire("eI5EY");

var $7byHA = parcelRequire("7byHA");

var $lO4Or = parcelRequire("lO4Or");

var $dWLk9 = parcelRequire("dWLk9");

var $k3EUD = parcelRequire("k3EUD");

var $3ZQNK = parcelRequire("3ZQNK");
const $26c5ccbb20325860$var$DEV_SUMMARY_FIELD = 'devSummaryField';
const $26c5ccbb20325860$var$PARENT_FIELD = 'parentField';
const $26c5ccbb20325860$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $26c5ccbb20325860$var$storyPointsFieldPredicate = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $26c5ccbb20325860$var$sprintFieldPredicate = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
function $26c5ccbb20325860$export$fd83eea6ecd2d8fa(query) {
    const client = (0, $iZuDo.useApolloClient)();
    return (0, $eUqFw.useCallback)((variables)=>client.query({
            query: query,
            variables: variables,
            errorPolicy: 'all'
        }), [
        client,
        query
    ]);
}
const $26c5ccbb20325860$export$8af2d18142c8506c = ()=>{
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const { data: storyPointEstimateField } = (0, $4S5hf.useFindField)($26c5ccbb20325860$var$storyPointEstimateFieldPredicate);
    const { data: storyPointsField } = (0, $4S5hf.useFindField)($26c5ccbb20325860$var$storyPointsFieldPredicate);
    const { data: sprintField } = (0, $4S5hf.useFindField)($26c5ccbb20325860$var$sprintFieldPredicate);
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const filtersJQL = (0, $lGxgz.useFilteredViewJQL)();
    const refetchIssue = $26c5ccbb20325860$export$fd83eea6ecd2d8fa((0, $k3EUD.ISSUE_REFETCH_QUERY));
    const [createIssue] = (0, $iZuDo.useMutation)((0, $k3EUD.CREATE_ISSUE_MUTATION));
    const createIssueService = (0, $eUqFw.useCallback)(async (createParams, extraPayload = {})=>{
        const input = (0, $3ZQNK.buildInput)(createParams.input, extraPayload, categoryField, sprintField, storyPointEstimateField, storyPointsField);
        const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
        let isParentFieldVisible = false;
        let isDevSummaryFieldVisible = false;
        if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            isDevSummaryFieldVisible = fieldIdsSet.has($26c5ccbb20325860$var$DEV_SUMMARY_FIELD);
            isParentFieldVisible = fieldIdsSet.has($26c5ccbb20325860$var$PARENT_FIELD);
            fieldIdsSet.delete($26c5ccbb20325860$var$DEV_SUMMARY_FIELD);
            fieldIdsSet.delete($26c5ccbb20325860$var$PARENT_FIELD);
        }
        fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
        fieldIdsSet.delete((0, $jGcn0.CARD_COVERS_TYPE));
        const fieldIds = Array.from(fieldIdsSet);
        const { data: data, errors: errors } = await createIssue({
            variables: {
                input: input,
                fieldIds: fieldIds,
                isParentFieldVisible: isParentFieldVisible,
                isDevSummaryFieldVisible: isDevSummaryFieldVisible,
                withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
            },
            // @ts-expect-error - errorPolicy is not in the types but does work
            errorPolicy: 'all'
        });
        const result = data?.createJiraBusinessIssue;
        if (result?.success !== true || !result?.item) {
            const firstMutationError = result?.errors?.[0];
            if (firstMutationError) {
                const statusCode = firstMutationError.extensions?.statusCode;
                if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, $7byHA.ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                throw new (0, $kkYfO.MutationError)(firstMutationError);
            }
            throw new (0, $dlVOn.GraphQLErrors)(errors);
        }
        return {
            item: result.item,
            itemIdentifiers: {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                issueId: result.itemIdentifiers.issueId,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
                issueKey: result.itemIdentifiers.issueKey[0].text
            }
        };
    }, [
        categoryField,
        createIssue,
        sprintField,
        storyPointEstimateField,
        storyPointsField
    ]);
    const refetchIssueService = (0, $eUqFw.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
        const jql = (0, $i3K0B.generateJql)({
            jqlContext: jqlContext,
            quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
            issueIds: [
                issueId
            ]
        });
        const fieldIdsSet = new Set(fieldIds);
        fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
        fieldIdsSet.delete((0, $jGcn0.CARD_COVERS_TYPE));
        const fieldIdsToRequest = Array.from(fieldIdsSet);
        const { data: data } = await refetchIssue({
            jql: jql,
            fieldIds: fieldIdsToRequest,
            cloudId: cloudId,
            first: 1,
            isParentFieldVisible: false,
            isDevSummaryFieldVisible: false,
            withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
        });
        const viewItems = data?.jira?.jwmViewItems;
        if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
        const issue = viewItems.edges?.[0]?.node;
        return issue ?? null;
    }, [
        cloudId,
        filtersJQL,
        jqlContext,
        refetchIssue
    ]);
    return {
        createIssue: createIssueService,
        refetchIssue: refetchIssueService
    };
};

});
parcelRegister("3ZQNK", function(module, exports) {

$parcel$export(module.exports, "buildInput", () => $5a091c9fc71ac2ca$export$f4db126e014728a3);

var $lO4Or = parcelRequire("lO4Or");
const $5a091c9fc71ac2ca$var$RANK_BEFORE_ID = 'rankBefore';
const $5a091c9fc71ac2ca$var$RANK_AFTER_ID = 'rankAfter';
const $5a091c9fc71ac2ca$export$f4db126e014728a3 = (input, extraPayload, categoryField, sprintField, storyPointEstimateField, storyPointsField)=>{
    const singleLineTextFields = [
        {
            fieldId: (0, $lO4Or.SUMMARY_TYPE),
            text: input.summary
        }
    ];
    const singleSelectUserPickerFields = [];
    const numberFields = [];
    if (input.category && categoryField?.id) singleLineTextFields.push({
        // @ts-expect-error - Type 'string' is not assignable to type '"summary"'.
        fieldId: categoryField.id,
        text: input.category.optionId
    });
    if (input.assignee) singleSelectUserPickerFields.push({
        fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
        user: {
            accountId: input.assignee.accountId
        }
    });
    if (input.storyPointEstimate != null && storyPointEstimateField?.id) numberFields.push({
        fieldId: storyPointEstimateField.id,
        value: input.storyPointEstimate
    });
    if (input.storyPoints != null && storyPointsField?.id) numberFields.push({
        fieldId: storyPointsField.id,
        value: input.storyPoints
    });
    const fields = {
        singleLineTextFields: singleLineTextFields,
        singleSelectUserPickerFields: singleSelectUserPickerFields,
        numberFields: numberFields,
        ...input.sprint && sprintField?.id && {
            sprintsField: {
                fieldId: sprintField.id,
                sprints: [
                    {
                        sprintId: input.sprint.id
                    }
                ]
            }
        },
        ...input.priority && {
            priority: {
                priorityId: input.priority.priorityId
            }
        },
        ...input.parentIssueId && {
            parentField: {
                issueId: input.parentIssueId
            }
        }
    };
    const rank = {
        ...input.rankBefore && {
            before: {
                id: $5a091c9fc71ac2ca$var$RANK_BEFORE_ID,
                issueId: input.rankBefore.issueId
            }
        },
        ...input.rankAfter && {
            after: {
                id: $5a091c9fc71ac2ca$var$RANK_AFTER_ID,
                issueId: input.rankAfter.issueId
            }
        }
    };
    const result = {
        projectId: input.projectId,
        issueType: input.issueType.id,
        fields: fields,
        rank: rank,
        ...extraPayload?.transitionId && {
            transitionId: extraPayload.transitionId
        }
    };
    return result;
};

});


parcelRegister("aPQfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f397652852d3db1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aOINP = parcelRequire("aOINP");

var $8pBAw = parcelRequire("8pBAw");

var $jGcn0 = parcelRequire("jGcn0");

var $hJYsP = parcelRequire("hJYsP");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $96etS = parcelRequire("96etS");

var $iaCjO = parcelRequire("iaCjO");

var $d3C6e = parcelRequire("d3C6e");

var $5I9Im = parcelRequire("5I9Im");

var $e3dJ4 = parcelRequire("e3dJ4");

var $kHnEs = parcelRequire("kHnEs");

var $9u6Jh = parcelRequire("9u6Jh");

var $aDWue = parcelRequire("aDWue");

var $5r9Wo = parcelRequire("5r9Wo");

var $h8g5T = parcelRequire("h8g5T");

var $bxcZe = parcelRequire("bxcZe");

var $hIxFu = parcelRequire("hIxFu");

var $6HWvN = parcelRequire("6HWvN");


var $gVPP8 = parcelRequire("gVPP8");

var $5ge6s = parcelRequire("5ge6s");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $jD3pk = parcelRequire("jD3pk");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $jK1pm = parcelRequire("jK1pm");

var $apShl = parcelRequire("apShl");

var $5s6G4 = parcelRequire("5s6G4");

var $gbsaq = parcelRequire("gbsaq");

var $jwBHm = parcelRequire("jwBHm");

var $hotly = parcelRequire("hotly");

var $cGmOd = parcelRequire("cGmOd");

var $egJIx = parcelRequire("egJIx");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");

var $6IRtV = parcelRequire("6IRtV");

var $lCzHy = parcelRequire("lCzHy");

var $5jA3I = parcelRequire("5jA3I");

var $eicDW = parcelRequire("eicDW");

var $e3maP = parcelRequire("e3maP");

var $8axyj = parcelRequire("8axyj");

var $aUash = parcelRequire("aUash");

var $bR4Tm = parcelRequire("bR4Tm");

var $56s5R = parcelRequire("56s5R");

var $5NSnR = parcelRequire("5NSnR");

var $1lhPF = parcelRequire("1lhPF");

var $fuaUK = parcelRequire("fuaUK");

var $aiXUL = parcelRequire("aiXUL");

var $4PNxf = parcelRequire("4PNxf");

var $6lgzJ = parcelRequire("6lgzJ");

var $1ukK3 = parcelRequire("1ukK3");

var $dSlaZ = parcelRequire("dSlaZ");

var $dcGUq = parcelRequire("dcGUq");
const $4f397652852d3db1$var$FOOTER_HEIGHT = 45;
const $4f397652852d3db1$var$ROW_HEIGHT = 40;
const $4f397652852d3db1$var$ON_END_REACHED_THRESHOLD = 300;
const $4f397652852d3db1$var$STARGATE_URL = '/gateway/api';
// passing in empty componentName so that we can define action name from analytics events
const $4f397652852d3db1$var$BaseTableWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('', {
    onResize: 'resized'
})((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56s5R.default), props));
const $4f397652852d3db1$var$ListContent = ({ projectId: projectId, projectKey: projectKey, projectName: projectName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const interactionMetrics = (0, $jwBHm.useInteractionMetrics)();
    const [columnWidths, { setColumnWidth: setColumnWidth }] = (0, $cGmOd.useColumnWidths)();
    const [{ issuesMap: issuesMap, hierarchyData: { data: issues, loading: loading, error: error } }] = (0, $5r9Wo.useHierarchyStore)();
    const viewMode = (0, $hJ992.useViewMode)();
    const isViewModeSideBar = viewMode === 'SIDEBAR';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { isFiltering: isFiltering } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    // Remove after clean up of jsw_list_view_-_all_the_fields
    const [selectedIssueKey, setSelectedIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const showReparentModal = (0, $e3maP.useShouldShowReparentModal)();
    (0, $4G5xU.useQueryBasedViewAutomaticTracking)((0, $gbsaq.VIEW_EXPERIENCE), {
        loading: loading,
        error: error
    });
    const [{ sortBy: sortBy }] = (0, $iaCjO.useSorting)();
    const isSorting = sortBy != null;
    const { featureView: featureView, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $egJIx.useJWMListFeatures)();
    const numIssues = (0, $eUqFw.useMemo)(()=>issues.filter((i)=>!i.id.match('^SKELETON-ITEM-[0-9]+-id$')).length, [
        issues
    ]);
    const [showBulkEditOnboarding, setShowBulkEditOnboarding] = (0, $eUqFw.useState)(false);
    const [coordinationClient, setCoordinationClient] = (0, $eUqFw.useState)(null);
    if ((0, $eI5EY.fg)('jira_list_view_bulk_edit_changeboarding')) {
        if (numIssues >= 2 && cloudId && orgId && !coordinationClient) {
            const coordClient = new (0, $5ge6s.CoordinationClient)(cloudId, $4f397652852d3db1$var$STARGATE_URL, false, orgId);
            setCoordinationClient(coordClient);
            coordClient.start((0, $gbsaq.BULK_EDIT_CHANGEBOARDING_MESSAGE_ID)).then(setShowBulkEditOnboarding);
        }
    }
    (0, $8axyj.useTableAnalytics)();
    const ufoPressTracing = (0, $5s6G4.default)('jwm.list.issue-view-opened');
    // Remove after clean up of jsw_list_view_-_all_the_fields
    let openIssueModal = (0, $eUqFw.useCallback)((issue)=>(event)=>{
            if (issue.id && !(0, $d3C6e.isOptimisticIssue)(Number(issue.id)) && issue.key) {
                if (!(0, $hIxFu.isModifiedEvent)(event)) {
                    ufoPressTracing(event.timeStamp);
                    setSelectedIssueKey(issue.key);
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        }, [
        setSelectedIssueKey,
        ufoPressTracing
    ]);
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const onBeforeOpened = (0, $eUqFw.useCallback)((event)=>{
            ufoPressTracing(event.timeStamp);
        }, [
            ufoPressTracing
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const filterIssue = (0, $eUqFw.useCallback)((issue)=>Boolean(issue.id && !(0, $d3C6e.isOptimisticIssue)(Number(issue.id)) && issue.key), []);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ createOpenIssueModalHandler: openIssueModal } = (0, $e3dJ4.useIssueModalActions)({
            onBeforeOpened: onBeforeOpened,
            filterIssue: filterIssue
        }));
    }
    const { toggleHighlightRow: toggleHighlightRow, getRowClassName: getRowClassName } = (0, $bxcZe.useHighlightDoneItems)();
    const highlightRow = (0, $eUqFw.useCallback)((issueKey)=>toggleHighlightRow(issueKey, true), [
        toggleHighlightRow
    ]);
    const { onIssueUpdated: onIssueUpdated } = (0, $bR4Tm.useIssueUpdated)();
    const columns = (0, $dcGUq.useGetColumns)({
        columnWidths: columnWidths,
        rowHeight: $4f397652852d3db1$var$ROW_HEIGHT,
        openIssueModal: openIssueModal,
        highlightRow: highlightRow,
        loading: loading,
        projectId: projectId,
        onIssueUpdated: onIssueUpdated,
        showBulkEditOnboarding: showBulkEditOnboarding
    });
    const onResize = (columnKey, width, analyticsEvent)=>{
        interactionMetrics[0, $jwBHm.COLUMN_RESIZED].start();
        setColumnWidth(columnKey, width);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'column resized', {
            columnKey: columnKey
        });
    };
    const onModalIssueClose = (0, $eUqFw.useCallback)(()=>{
        setSelectedIssueKey(undefined);
    }, [
        setSelectedIssueKey
    ]);
    const { onIssueChange: onIssueChange } = (0, $lCzHy.useIssueChangeUpdater)();
    // this needs to be memoised otherwise it rerenders when the table changes causing some elements to blink
    // a common reason for the table to change while this is open is the realtime implementation
    const bentoView = (0, $eUqFw.useMemo)(()=>selectedIssueKey != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kHnEs.default), {
            issueKey: (0, $6vrw7.toIssueKey)(selectedIssueKey),
            onClose: onModalIssueClose,
            analyticsSource: (0, $0100842672acae20$export$7ca28938a07e0c33),
            onChange: onIssueChange,
            isSoftwareProject: (0, $eI5EY.fg)('jsw_list_view_-_change_issue_view_analytics_event') && isSoftwareFieldsEnabled
        }), [
        selectedIssueKey,
        onModalIssueClose,
        onIssueChange,
        isSoftwareFieldsEnabled
    ]);
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const isGrouping = groupByFieldId != null;
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'list viewed', {
            isGrouping: isGrouping,
            isSorting: isSorting,
            isFiltering: isFiltering,
            isSearching: isSearching
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "list-view",
        hold: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.RenderStartMark), {
        view: featureView,
        loading: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h8g5T.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f397652852d3db1$var$BaseTableWithAnalytics, {
        columns: columns,
        onResize: onResize,
        onEndReachedThreshold: $4f397652852d3db1$var$ON_END_REACHED_THRESHOLD,
        footerHeight: $4f397652852d3db1$var$FOOTER_HEIGHT,
        rowHeight: $4f397652852d3db1$var$ROW_HEIGHT,
        getRowClassName: getRowClassName,
        loadingMessage: formatMessage((0, $6lgzJ.default).loadingMoreItems),
        isSorting: isSorting,
        EmptyState: (0, $fuaUK.EmptyState),
        GroupItem: (0, $aiXUL.GroupItem),
        projectId: projectId,
        projectKey: projectKey,
        projectName: projectName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eicDW.default), (0, $1ybV0.ff)('jwm.list.background-refetch-for-groups-and-children') ? {} : {
        issuesMap: issuesMap,
        isBackgroundQueryDisabled: isGrouping
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6IRtV.default), {
        isBackgroundQueryDisabled: !isGrouping
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hHiDc.UpdateFieldsDetail), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "jira-list-issue-app"
    }, isViewModeSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9u6Jh.SidebarIssueView), {
        issueKey: selectedIssueKey,
        onClose: onModalIssueClose,
        analyticsSource: (0, $0100842672acae20$export$7ca28938a07e0c33),
        onChange: onIssueChange,
        isSoftwareProject: (0, $eI5EY.fg)('jsw_list_view_-_change_issue_view_analytics_event') && isSoftwareFieldsEnabled
    }) : bentoView), (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gVPP8.DevDetailsDialogLoaderAsync), {
        scopeId: "software-list.list"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jA3I.default), {
        showBulkEditOnboarding: showBulkEditOnboarding,
        coordinationClient: coordinationClient
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5NSnR.default), null), showReparentModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSlaZ.AsyncReparentModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1lhPF.default), null));
};
const $4f397652852d3db1$export$84d0dd190d551cd1 = ({ projectId: projectId, projectKey: projectKey, projectName: projectName, isTeamManaged: isTeamManaged, formattingRulesQuery: formattingRulesQuery })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ childrenItems: _childrenQueryData }] = (0, $5r9Wo.useHierarchyStore)();
    const pageHeading = formatMessage((0, $6lgzJ.default).listHeading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClear = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'groupBy cleared', {
            reason: 'stale'
        });
    }, [
        createAnalyticsEvent
    ]);
    (0, $aUash.useClearStaleGroupBy)({
        onClear: onClear
    });
    (0, $aDWue.useWatchBulkSelection)();
    const listViewContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJYsP.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "jira-list-header-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4PNxf.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f397652852d3db1$var$ListContent, {
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isTeamManaged: isTeamManaged
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ukK3.InteractionMetrics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5I9Im.PrefetchIssueDataController), null), formattingRulesQuery && (0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pBAw.FormatRules), {
        query: formattingRulesQuery
    }));
    return (0, $1ybV0.ff)('bulk-edit-in-jwm-list-view_bny2w') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hotly.BulkSelectionContainer), {
        scope: "JWMListBulkSelection"
    }, listViewContent) : listViewContent;
};
var $4f397652852d3db1$export$2e2bcd8739ae039 = $4f397652852d3db1$export$84d0dd190d551cd1;

});
parcelRegister("8pBAw", function(module, exports) {

$parcel$export(module.exports, "FormatRules", () => $5eb31da1cb9cd613$export$85cc1c447494ea9e);

var $6Dz23 = parcelRequire("6Dz23");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $9vQCV = parcelRequire("9vQCV");

var $6yEM4 = parcelRequire("6yEM4");
const $5eb31da1cb9cd613$export$85cc1c447494ea9e = ({ query: query })=>{
    const [, { setFormatRules: setFormatRules, setRulesForJqlInput: setRulesForJqlInput }] = (0, $6yEM4.useFormatRulesStore)();
    const { jira: jira } = (0, $iWLL0.usePreloadedQuery)((0, $6Dz23.default), query);
    (0, $eUqFw.useEffect)(()=>{
        const formattingRulesByProject = jira.jiraProjectByKey.conditionalFormattingRules;
        if (!formattingRulesByProject) return;
        /* rowRules and cellRulesByFieldId - data to be able to format per rows and per field cell */ let rowRules = [];
        const cellRulesByFieldId = {};
        const rulesJqlInput = {};
        const ruleCallback = (mappedRule)=>{
            if (mappedRule) {
                if (mappedRule && mappedRule.fieldId) {
                    if (mappedRule.formattingArea === 'ROW') rowRules = [
                        ...rowRules,
                        mappedRule
                    ];
                    else cellRulesByFieldId[mappedRule.fieldId] = [
                        ...cellRulesByFieldId[mappedRule.fieldId] || [],
                        mappedRule
                    ];
                    // input to serialise jql input
                    const DUMMY_VALUE = '-';
                    const values = Array.isArray(mappedRule.value) ? mappedRule.value : [
                        mappedRule.value
                    ];
                    if (!rulesJqlInput[mappedRule.fieldId]) rulesJqlInput[mappedRule.fieldId] = [];
                    values.forEach((value)=>{
                        if (mappedRule.fieldId) rulesJqlInput[mappedRule.fieldId]?.push({
                            value: value ?? DUMMY_VALUE,
                            label: value ?? DUMMY_VALUE
                        });
                    });
                }
            }
        };
        (0, $9vQCV.mapFormatRuleConnection)(formattingRulesByProject, ruleCallback);
        setFormatRules({
            rowRules: rowRules,
            cellRulesByFieldId: cellRulesByFieldId
        });
        setRulesForJqlInput(rulesJqlInput);
    }, [
        jira.jiraProjectByKey.conditionalFormattingRules,
        setFormatRules,
        setRulesForJqlInput
    ]);
    return null;
};

});
parcelRegister("6Dz23", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca75e7f2a9529e9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<179e2ef722011360d57ec628a72f4a41>>
 * @relayHash 1a1fa6193f4c1b504180b39801d236b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46a4ccbc5551eab017f7cc101b63a1401cc0ac15f18b6f069f3a7dfcc6ce9af4

var $cNy9K = parcelRequire("cNy9K");
const $8ca75e7f2a9529e9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "formattingArea"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "LinkedField",
        "name": "expression",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "singleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ],
                "type": "JiraFormattingSingleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "multipleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "values"
                    }
                ],
                "type": "JiraFormattingMultipleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "noValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    }
                ],
                "type": "JiraFormattingNoValueOperand"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "formatRulesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraFormattingRuleConnection",
                                            "kind": "LinkedField",
                                            "name": "conditionalFormattingRules",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineDataFragmentSpread",
                                                    "name": "formatRuleConnection",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRuleEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFormattingRule",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "formattingColor",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v7 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "argumentDefinitions": []
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "formatRulesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "46a4ccbc5551eab017f7cc101b63a1401cc0ac15f18b6f069f3a7dfcc6ce9af4",
            "metadata": {},
            "name": "formatRulesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8ca75e7f2a9529e9$var$node.hash = "74ea1fa8f6a5533fcb3f20473d740504";
(0, $cNy9K.PreloadableQueryRegistry).set($8ca75e7f2a9529e9$var$node.params.id, $8ca75e7f2a9529e9$var$node);
var $8ca75e7f2a9529e9$export$2e2bcd8739ae039 = $8ca75e7f2a9529e9$var$node;

});

parcelRegister("9vQCV", function(module, exports) {

$parcel$export(module.exports, "mapFormatRuleConnection", () => $20458e195feac4cd$export$165da765704da243);

var $hyw1B = parcelRequire("hyw1B");

var $iWLL0 = parcelRequire("iWLL0");

var $29RWc = parcelRequire("29RWc");
const $20458e195feac4cd$export$165da765704da243 = (queryRef, ruleCallback)=>{
    if (!queryRef) return null;
    const rules = (0, $iWLL0.readInlineData)((0, $hyw1B.default), queryRef);
    const mappedRules = rules.edges?.map((edge, index)=>{
        const rule = edge?.node;
        if (rule) {
            const { formattingArea: formattingArea, formattingColor: formattingColor } = rule;
            let fieldId = null;
            let operator = 'IS';
            let value;
            switch(rule.expression.__typename){
                case 'JiraFormattingSingleValueOperand':
                    operator = rule.expression.singleValueOperator;
                    ({ value: value, fieldId: fieldId } = rule.expression);
                    break;
                case 'JiraFormattingMultipleValueOperand':
                    operator = rule.expression.multipleValueOperator;
                    value = rule.expression.values;
                    fieldId = rule.expression.fieldId;
                    break;
                case 'JiraFormattingNoValueOperand':
                    operator = rule.expression.noValueOperator;
                    fieldId = rule.expression.fieldId;
                    break;
                default:
                    break;
            }
            const mappedRule = {
                id: rule.id,
                fieldId: fieldId,
                operator: operator,
                value: value,
                color: (0, $29RWc.formattingColors)[formattingColor.colorKey || '']?.value,
                formattingArea: formattingArea,
                index: index
            };
            ruleCallback && ruleCallback(mappedRule);
            return mappedRule;
        }
        return null;
    }).filter(Boolean);
    return mappedRules ?? null;
};

});
parcelRegister("hyw1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $db967dd719f25902$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca1c7a6cef9da8e8bbcb87cb178dfbd0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $db967dd719f25902$var$node = {
    "kind": "InlineDataFragment",
    "name": "formatRuleConnection"
};
$db967dd719f25902$var$node.hash = "5359e5106c613cccc6e8a2b7c3819ced";
var $db967dd719f25902$export$2e2bcd8739ae039 = $db967dd719f25902$var$node;

});

parcelRegister("29RWc", function(module, exports) {

$parcel$export(module.exports, "formattingColors", () => $5eec940fd9094470$export$2fedf4ac4eb04087);
$parcel$export(module.exports, "getColorKeyFromValue", () => $5eec940fd9094470$export$ae7e938b8bdf2df5);

var $5iWql = parcelRequire("5iWql");

var $eVduU = parcelRequire("eVduU");
const $5eec940fd9094470$export$2fedf4ac4eb04087 = {
    lightPurple: {
        label: (0, $eVduU.default).lightPurple,
        value: "var(--ds-background-accent-purple-subtlest, #f3f0ff)"
    },
    lightBlue: {
        label: (0, $eVduU.default).lightBlue,
        value: "var(--ds-background-accent-blue-subtlest, #e9f2ff)"
    },
    lightGreen: {
        label: (0, $eVduU.default).lightGreen,
        value: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    lightTeal: {
        label: (0, $eVduU.default).lightTeal,
        value: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    lightYellow: {
        label: (0, $eVduU.default).lightYellow,
        value: "var(--ds-background-accent-yellow-subtlest, ##FFF7D6)"
    },
    lightRed: {
        label: (0, $eVduU.default).lightRed,
        value: "var(--ds-background-accent-red-subtlest, ##FFF7D6)"
    },
    lightGray: {
        label: (0, $eVduU.default).lightGray,
        value: "var(--ds-background-accent-gray-subtlest, ##FFF7D6)"
    },
    purple: {
        label: (0, $eVduU.default).purple,
        value: "var(--ds-background-accent-purple-subtler, #f3f0ff)"
    },
    blue: {
        label: (0, $eVduU.default).blue,
        value: "var(--ds-background-accent-blue-subtler, #DFD8FD)"
    },
    green: {
        label: (0, $eVduU.default).green,
        value: "var(--ds-background-accent-green-subtler, #C6EDFB)"
    },
    teal: {
        label: (0, $eVduU.default).teal,
        value: "var(--ds-background-accent-teal-subtler, #F8E6A0)"
    },
    yellow: {
        label: (0, $eVduU.default).yellow,
        value: "var(--ds-background-accent-yellow-subtler, #FFF7D6)"
    },
    red: {
        label: (0, $eVduU.default).red,
        value: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    gray: {
        label: (0, $eVduU.default).gray,
        value: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }
};
const $5eec940fd9094470$export$ae7e938b8bdf2df5 = (0, $5iWql.default)((value)=>{
    const selectedColor = Object.entries($5eec940fd9094470$export$2fedf4ac4eb04087).find(([_, color])=>color.value === value);
    return selectedColor?.[0];
});

});
parcelRegister("eVduU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b88a4c9d30f6a7e5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b88a4c9d30f6a7e5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    lightPurple: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-purple",
        "defaultMessage": "Subtle purple"
    },
    lightBlue: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-blue",
        "defaultMessage": "Subtle blue"
    },
    lightGreen: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-green",
        "defaultMessage": "Subtle green"
    },
    lightTeal: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-teal",
        "defaultMessage": "Subtle teal"
    },
    lightYellow: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-yellow",
        "defaultMessage": "Subtle yellow"
    },
    lightRed: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-red",
        "defaultMessage": "Subtle red"
    },
    lightGray: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-gray",
        "defaultMessage": "Subtle gray"
    },
    purple: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.purple",
        "defaultMessage": "Bold purple"
    },
    blue: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.blue",
        "defaultMessage": "Bold blue"
    },
    green: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.green",
        "defaultMessage": "Bold green"
    },
    teal: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.teal",
        "defaultMessage": "Bold teal"
    },
    yellow: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.yellow",
        "defaultMessage": "Bold yellow"
    },
    red: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.red",
        "defaultMessage": "Bold red"
    },
    gray: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.gray",
        "defaultMessage": "Bold gray"
    }
});

});



parcelRegister("6yEM4", function(module, exports) {

$parcel$export(module.exports, "useFormatRulesStore", () => $83177fea0cdffe5d$export$2fe3fe2e87aa2741);
$parcel$export(module.exports, "useFormatRulesSerialisedJql", () => $83177fea0cdffe5d$export$3b2286d9a476f9a1);

var $8aCHU = parcelRequire("8aCHU");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $83177fea0cdffe5d$var$initialState = {
    rowRules: [],
    cellRulesByFieldId: {},
    issueIdRowRuleMatched: {},
    rulesJqlInput: {}
};
const $83177fea0cdffe5d$var$actions = {
    setFormatRules: (rules)=>({ setState: setState })=>{
            const newState = {
                ...rules
            };
            setState(newState);
        },
    setRulesForJqlInput: (input)=>({ setState: setState })=>{
            const newState = {
                rulesJqlInput: input
            };
            setState(newState);
        },
    setMatchedRowRule: ({ rule: rule, issueId: issueId })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newState = {
                issueIdRowRuleMatched: {
                    ...currentState.issueIdRowRuleMatched,
                    [issueId]: rule
                }
            };
            setState(newState);
        },
    removeMatchedRowRule: ({ ruleId: ruleId })=>({ setState: setState, getState: getState })=>{
            const { issueIdRowRuleMatched: issueIdRowRuleMatched } = getState();
            const rowRuleMatched = Object.entries(issueIdRowRuleMatched).filter(([, value])=>value.id !== ruleId);
            const newIssueIdRowRuleMatched = Object.fromEntries(rowRuleMatched);
            setState({
                issueIdRowRuleMatched: newIssueIdRowRuleMatched
            });
        }
};
const $83177fea0cdffe5d$var$Store = (0, $kEDjj.createStore)({
    initialState: $83177fea0cdffe5d$var$initialState,
    actions: $83177fea0cdffe5d$var$actions,
    name: 'JWMFormatRules'
});
const $83177fea0cdffe5d$export$2fe3fe2e87aa2741 = (0, $1yZQx.createHook)($83177fea0cdffe5d$var$Store);
const $83177fea0cdffe5d$var$getSerialisedJql = (state)=>(0, $8aCHU.serialiseJql)(state.rulesJqlInput);
const $83177fea0cdffe5d$export$3b2286d9a476f9a1 = (0, $1yZQx.createHook)($83177fea0cdffe5d$var$Store, {
    selector: $83177fea0cdffe5d$var$getSerialisedJql
});

});


parcelRegister("hJYsP", function(module, exports) {

$parcel$export(module.exports, "BusinessDocumentTitle", () => $08e74678968dfe67$export$416064ba09d98e69);

var $eUqFw = parcelRequire("eUqFw");

var $heNSb = parcelRequire("heNSb");

var $fDLFb = parcelRequire("fDLFb");
const $08e74678968dfe67$export$416064ba09d98e69 = /*#__PURE__*/ (0, $eUqFw.memo)(({ pageHeading: pageHeading })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: documentTitle
    });
});

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});


parcelRegister("5I9Im", function(module, exports) {

$parcel$export(module.exports, "PrefetchIssueDataController", () => $1fd41398a8791bc6$export$1e95fb877713bf5e);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hzcvF = parcelRequire("hzcvF");

var $lB25E = parcelRequire("lB25E");

var $hYeSy = parcelRequire("hYeSy");

var $1SYbt = parcelRequire("1SYbt");
const $1fd41398a8791bc6$var$IssueDataLoader = /*#__PURE__*/ (0, $eUqFw.memo)(({ issues: issues })=>issues.map((issueKey)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SYbt.AsyncIssueViewCriticalDataLoader), {
            key: issueKey,
            issueKey: issueKey
        })));
const $1fd41398a8791bc6$export$1e95fb877713bf5e = ()=>{
    const { prefetchedIssues: prefetchedIssues } = (0, $hYeSy.usePrefetchIssueViewData)();
    const { clearCache: clearCache } = (0, $hYeSy.usePrefetchIssueViewDataActions)();
    const [selectedIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const prevSelectedIssueKey = (0, $hzcvF.usePreviousWithInitial)(selectedIssueKey);
    (0, $eUqFw.useEffect)(()=>{
        const isIssueAppClosed = prevSelectedIssueKey && !selectedIssueKey;
        const isIssueKeyUpdated = selectedIssueKey && prevSelectedIssueKey && selectedIssueKey !== prevSelectedIssueKey;
        // clear cache when user closes Issue modal or opens another issue without closing it (ie via breadcrumbs)
        if (isIssueAppClosed || isIssueKeyUpdated) clearCache();
    }, [
        clearCache,
        prevSelectedIssueKey,
        selectedIssueKey
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // clear cache on unmount
            clearCache();
        }, [
        clearCache
    ]);
    const issues = (0, $eUqFw.useMemo)(()=>Object.keys(prefetchedIssues), [
        prefetchedIssues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1fd41398a8791bc6$var$IssueDataLoader, {
        issues: issues
    });
};

});
parcelRegister("hYeSy", function(module, exports) {

$parcel$export(module.exports, "usePrefetchIssueViewData", () => $1367707b89dd09e1$export$519e056a921d9691);
$parcel$export(module.exports, "usePrefetchIssueViewDataActions", () => $1367707b89dd09e1$export$fee97ccc4dadacbb);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
/**
 * The minimum allowed time between two consecutive issue data prefetches.
 */ const $1367707b89dd09e1$var$ALLOWED_TIME_BETWEEN_PREFETCHES = 500;
const $1367707b89dd09e1$var$MAX_DELAY = 300;
const $1367707b89dd09e1$var$MIN_DELAY = 0;
const $1367707b89dd09e1$export$a87749ac92873cf7 = ()=>100;
const $1367707b89dd09e1$var$actions = {
    // prefetches issue view data on hover
    prefetchIssue: (issueKey)=>({ getState: getState, setState: setState })=>{
            const { timestampOfTheLastPrefetch: timestampOfTheLastPrefetch, prefetchedIssues: prefetchedIssues } = getState();
            const currentTimestamp = Date.now();
            const delay = timestampOfTheLastPrefetch !== null && currentTimestamp - timestampOfTheLastPrefetch < $1367707b89dd09e1$var$ALLOWED_TIME_BETWEEN_PREFETCHES ? $1367707b89dd09e1$var$MAX_DELAY : $1367707b89dd09e1$var$MIN_DELAY;
            // clear cache if it exceeds the limit so that it doesn't grow indefinitely
            const nextPrefetchedIssues = Object.keys(prefetchedIssues).length === $1367707b89dd09e1$export$a87749ac92873cf7() ? {} : prefetchedIssues;
            setState({
                // prefetch the issue only if the time from the last prefetch is greater than ALLOWED_TIME_BETWEEN_PREFETCHES
                prefetchedIssues: delay === $1367707b89dd09e1$var$MIN_DELAY && !prefetchedIssues[issueKey] ? {
                    ...nextPrefetchedIssues,
                    [issueKey]: true
                } : prefetchedIssues,
                timestampOfTheLastPrefetch: currentTimestamp
            });
        },
    // clears cached issues (ie on view unmount)
    clearCache: ()=>({ setState: setState })=>{
            setState({
                timestampOfTheLastPrefetch: null,
                prefetchedIssues: {}
            });
        }
};
const $1367707b89dd09e1$var$PrefetchIssueViewStore = (0, $kEDjj.createStore)({
    initialState: {
        timestampOfTheLastPrefetch: null,
        prefetchedIssues: {}
    },
    actions: $1367707b89dd09e1$var$actions,
    name: 'JWMPrefetchIssueViewStore'
});
const $1367707b89dd09e1$export$519e056a921d9691 = (0, $1yZQx.createStateHook)($1367707b89dd09e1$var$PrefetchIssueViewStore);
const $1367707b89dd09e1$export$fee97ccc4dadacbb = (0, $1yZQx.createActionsHook)($1367707b89dd09e1$var$PrefetchIssueViewStore);

});

parcelRegister("1SYbt", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueViewCriticalDataLoader", () => $b758d168c0275aa2$export$15a49d6c068f7356);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $72NCz = parcelRequire("72NCz");
const $b758d168c0275aa2$var$entryPointParams = {};
const $b758d168c0275aa2$export$15a49d6c068f7356 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $72NCz.asyncIssueViewCriticalDataLoaderEntrypoint), $b758d168c0275aa2$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm-issue-view-critical-data-loader",
        packageName: "jiraBusinessIssueViewCriticalDataLoader",
        runtimeProps: props
    });
});

});
parcelRegister("72NCz", function(module, exports) {

$parcel$export(module.exports, "asyncIssueViewCriticalDataLoaderEntrypoint", () => $80aa607d47f3d3ce$export$6254258f84be452a);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $80aa607d47f3d3ce$export$6254258f84be452a = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("jGDE5")), {
        moduleId: "1f53773a"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jGDE5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("apZDm").then(()=>parcelRequire('2rxqz'));

});




parcelRegister("e3dJ4", function(module, exports) {

$parcel$export(module.exports, "useIssueModalActions", () => $58c0bec98635e94c$export$6f3a65eba75c0ec1);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hIxFu = parcelRequire("hIxFu");

var $lB25E = parcelRequire("lB25E");
const $58c0bec98635e94c$var$alwaysTrue = ()=>true;
const $58c0bec98635e94c$export$6f3a65eba75c0ec1 = ({ onBeforeOpened: onBeforeOpened, filterIssue: filterIssue = $58c0bec98635e94c$var$alwaysTrue } = {})=>{
    const [_, setSelectedIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const createOpenIssueModalHandler = (0, $eUqFw.useCallback)((issue)=>(event)=>{
            if (filterIssue(issue)) {
                if (!(0, $hIxFu.isModifiedEvent)(event)) {
                    onBeforeOpened && onBeforeOpened(event);
                    setSelectedIssueKey(issue.key);
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        }, [
        filterIssue,
        onBeforeOpened,
        setSelectedIssueKey
    ]);
    return {
        createOpenIssueModalHandler: createOpenIssueModalHandler
    };
};

});

parcelRegister("kHnEs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3cc12293a50ce22$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $hSCS8 = parcelRequire("hSCS8");

var $jGcn0 = parcelRequire("jGcn0");


var $hJ992 = parcelRequire("hJ992");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $jK1pm = parcelRequire("jK1pm");

const $f3cc12293a50ce22$export$843a6e93936e3b60 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("81FSu")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $f3cc12293a50ce22$var$ModalIssueAppWrapper = ({ issueKey: issueKey, onClose: onClose, onChange: onChange, onDeleteSuccess: onDeleteSuccess, analyticsSource: analyticsSource = (0, $0100842672acae20$export$82540942fb014b0a), viewModeSwitchDisabled: viewModeSwitchDisabled, isSoftwareProject: isSoftwareProject })=>{
    const [, setSelectedIssue] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: toIssueKey })=>setSelectedIssue(toIssueKey), [
        setSelectedIssue
    ]);
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $hJ992.useIssueContextActions)();
    const onSwitchToModal = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $eUqFw.useCallback)(()=>{
        setSidebarContent(null);
        setDetailViewAsSidebar();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const viewModeOptions = (0, $eUqFw.useMemo)(()=>!viewModeSwitchDisabled ? {
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        } : undefined, [
        onSwitchToModal,
        onSwitchToSidebar,
        viewModeSwitchDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-modal-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: isSoftwareProject ? 'jswModalIssueApp' : 'jwmModalIssueApp'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        packageName: isSoftwareProject ? 'software' : 'business',
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3cc12293a50ce22$export$843a6e93936e3b60, {
        analyticsSource: analyticsSource,
        issueKey: issueKey,
        onClose: onClose,
        onChange: onChange,
        onIssueDeleteSuccess: onDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        viewModeOptions: viewModeOptions
    })))));
};
var $f3cc12293a50ce22$export$2e2bcd8739ae039 = $f3cc12293a50ce22$var$ModalIssueAppWrapper;

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$5e91e17726e54450 = 'jiraCalendar';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $fee69 = parcelRequire("fee69");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("81FSu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aTMMU")
]).then(()=>parcelRequire('kjWxV'));

});


parcelRegister("9u6Jh", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueView", () => $134113658c67db96$export$ccdf533f42a8d6f8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hSCS8 = parcelRequire("hSCS8");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $bw53Y = parcelRequire("bw53Y");

var $4LhhW = parcelRequire("4LhhW");
const $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY = 'issueViewSidebar';
const $134113658c67db96$var$callWhenIdle = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(callback);
    else setTimeout(callback, 3000);
};
const $134113658c67db96$export$ccdf533f42a8d6f8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, isSoftwareProject: isSoftwareProject })=>{
    const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const prevIssueKey = (0, $hzcvF.usePreviousWithInitial)(issueKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $4LhhW.useSetSidebarStyleVar)();
    const onCloseSidebar = (0, $eUqFw.useCallback)(()=>{
        onClose();
    }, [
        onClose
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // avoid re-rendering in case props aren't memoised
        if (issueKey === prevIssueKey && !!content) return;
        if (issueKey) {
            const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($134113658c67db96$var$CSSAntiCorruptionLayer, {
                key: $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bw53Y.SidebarIssueApp), {
                issueKey: (0, $6vrw7.toIssueKey)(issueKey),
                onClose: onCloseSidebar,
                analyticsSource: analyticsSource,
                onChange: onChange,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                isSoftwareProject: isSoftwareProject
            }));
            setSidebarContent(newContent);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp opened');
        } else {
            if (content?.key === $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY) setSidebarContent(null);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp closed');
        }
    }, [
        analyticsSource,
        content,
        createAnalyticsEvent,
        isSoftwareProject,
        issueKey,
        onChange,
        onCloseSidebar,
        onIssueDeleteSuccess,
        prevIssueKey,
        setSidebarContent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Preload IssueApp here, otherwise it'd be loaded when Sidebar opens up for the first time, which is a bit slow
        $134113658c67db96$var$callWhenIdle(()=>{
            (0, $bw53Y.IssueApp).preload();
        });
    }, []);
    return null;
});
// put an extra div around issue view to "adopt" styles from `SidebarContent` (`> div`)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $134113658c67db96$var$CSSAntiCorruptionLayer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bw53Y", function(module, exports) {

$parcel$export(module.exports, "IssueApp", () => $1d0bd87d82d1f36e$export$35dd9ab573b87c3f);
$parcel$export(module.exports, "SidebarIssueApp", () => $1d0bd87d82d1f36e$export$e402f7c18d4d7f37);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $hSCS8 = parcelRequire("hSCS8");

var $hJ992 = parcelRequire("hJ992");

var $gJYxu = parcelRequire("gJYxu");

var $gGtKh = parcelRequire("gGtKh");

var $hzcvF = parcelRequire("hzcvF");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c4qEZ = parcelRequire("c4qEZ");

var $jK1pm = parcelRequire("jK1pm");

const $1d0bd87d82d1f36e$export$35dd9ab573b87c3f = (0, $7rh0R.lazy)(()=>(parcelRequire("geiGJ")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $1d0bd87d82d1f36e$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange, isSoftwareProject: isSoftwareProject })=>{
    const [currentIssueKey, setCurrentIssueKey] = (0, $eUqFw.useState)(issueKey);
    const prevIssueKey = (0, $hzcvF.usePreviousWithInitial)(issueKey);
    // @ts-expect-error - TS7031 - Binding element 'nextIssueKey' implicitly has an 'any' type.
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: nextIssueKey })=>{
        setCurrentIssueKey(nextIssueKey);
    }, []);
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $hJ992.useIssueContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    (0, $eUqFw.useEffect)(()=>{
        if (prevIssueKey !== issueKey) setCurrentIssueKey(issueKey);
    }, [
        currentIssueKey,
        issueKey,
        prevIssueKey
    ]);
    const onSwitchToModal = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsSidebar();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const PACKAGE_NAME = (0, $eUqFw.useMemo)(()=>isSoftwareProject ? 'jswSidebarIssueApp' : 'jwmSidebarIssueApp', [
        isSoftwareProject
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-sidebar-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d0bd87d82d1f36e$export$35dd9ab573b87c3f, {
        viewModeOptions: {
            viewMode: 'SIDEBAR',
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        },
        issueKey: currentIssueKey,
        analyticsSource: analyticsSource,
        shouldShowCloseButton: true,
        onClose: onClose,
        onIssueKeyChange: onIssueKeyChange,
        shouldSetInitialFocus: true,
        shouldShowRootProjectsBreadcrumb: true,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        isSpaEnabled: false,
        isLoadedWithPage: false,
        onChange: onChange
    })))));
};

});
parcelRegister("gJYxu", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $47dde6f657625382$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $47dde6f657625382$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $c4qEZ = parcelRequire("c4qEZ");
const $47dde6f657625382$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $47dde6f657625382$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});

parcelRegister("geiGJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kMAKK")
]).then(()=>parcelRequire('9zAkH'));

});


parcelRegister("4LhhW", function(module, exports) {

$parcel$export(module.exports, "useSetSidebarStyleVar", () => $94858a1aa5f6a192$export$70b20cd72362e39d);

var $eUqFw = parcelRequire("eUqFw");

var $hSCS8 = parcelRequire("hSCS8");


var $53ucm = parcelRequire("53ucm");
const $94858a1aa5f6a192$var$MARGIN = 24;
const $94858a1aa5f6a192$export$70b20cd72362e39d = ()=>{
    const [{ content: content, sidebarWidth: sidebarWidth }] = (0, $hSCS8.useSidebar)();
    const { setWidth: setWidth } = (0, $53ucm.useDetailPanelActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (content !== null) {
            document.documentElement?.style.setProperty((0, $29bf8722faf6f5bf$export$c83c5cba188418d8), `${sidebarWidth}px`);
            setWidth(sidebarWidth + $94858a1aa5f6a192$var$MARGIN);
        } else document.documentElement?.style.removeProperty((0, $29bf8722faf6f5bf$export$c83c5cba188418d8));
        return ()=>{
            setWidth(0);
        };
    }, [
        content,
        setWidth,
        sidebarWidth
    ]);
};

});
const $29bf8722faf6f5bf$export$c83c5cba188418d8 = '--detailPanelWidth';



parcelRegister("aDWue", function(module, exports) {

$parcel$export(module.exports, "useWatchBulkSelection", () => $1dfbdfbec97ae97b$export$5cafb03426b5addb);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $kQAZu = parcelRequire("kQAZu");

var $lEWmB = parcelRequire("lEWmB");

var $9GlEj = parcelRequire("9GlEj");

var $5r9Wo = parcelRequire("5r9Wo");

var $hzcvF = parcelRequire("hzcvF");

var $dSE3z = parcelRequire("dSE3z");

var $hotly = parcelRequire("hotly");

var $8COV0 = parcelRequire("8COV0");
const $1dfbdfbec97ae97b$export$5cafb03426b5addb = ()=>{
    const [{ selectedIssues: selectedIssues }, { clearSelection: clearSelection, unselectIssues: unselectIssues }] = (0, $hotly.useBulkSelectionStore)();
    const projectData = (0, $kQAZu.useProject)();
    const projectId = projectData.id;
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const { quickFiltersJql: quickFiltersJql } = (0, $9GlEj.useQuickFilters)();
    const [{ hierarchyData: { data: issues }, childrenItems: childrenItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const isGrouping = groupByFieldId != null;
    /*
        Use state to check once the filters has been updated
        After this we should wait for the new issues to be fetched
        and unselect the issues that are no longer visible for this new query
    */ const [hasFiltersBeenUpdated, setHasFiltersBeenUpdated] = (0, $eUqFw.useState)(false);
    const prevIssues = (0, $hzcvF.usePreviousWithInitial)(issues);
    // clear all items when grouping & filters change as the groups reset and collapse
    (0, $eUqFw.useEffect)(()=>{
        if (selectedIssues.size && (jql || quickFiltersJql)) {
            if (isGrouping) clearSelection();
            else setHasFiltersBeenUpdated(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        jql,
        quickFiltersJql
    ]);
    // clear items which are no longer visible after filtering etc.
    (0, $eUqFw.useEffect)(()=>{
        if (hasFiltersBeenUpdated && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevIssues, issues) && !isGrouping) {
            const allIssueIds = (0, $8COV0.getAllIssuesIds)({
                data: issues,
                childrenItems: childrenItems
            });
            const issuesToUnselect = [
                ...selectedIssues
            ].filter((issueId)=>allIssueIds.indexOf(issueId) === -1);
            if (issuesToUnselect.length > 0) unselectIssues({
                issues: issuesToUnselect
            });
            setHasFiltersBeenUpdated(false);
        }
    }, [
        childrenItems,
        hasFiltersBeenUpdated,
        isGrouping,
        issues,
        prevIssues,
        selectedIssues,
        unselectIssues
    ]);
    // clear all items when changing project
    (0, $eUqFw.useEffect)(()=>{
        clearSelection();
    }, [
        projectId,
        clearSelection
    ]);
};

});
parcelRegister("5r9Wo", function(module, exports) {

$parcel$export(module.exports, "useHierarchyStore", () => $6f7d17a2863fe3d7$export$2fc259d06066fab6);

var $jG2Eu = parcelRequire("jG2Eu");

var $jGcn0 = parcelRequire("jGcn0");

var $3uSNh = parcelRequire("3uSNh");

var $4oWxH = parcelRequire("4oWxH");

var $lO4Or = parcelRequire("lO4Or");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $aXbY8 = parcelRequire("aXbY8");
const $6f7d17a2863fe3d7$export$21726efd4013edfd = 1;
const $6f7d17a2863fe3d7$var$createLoadingItems = ()=>Array.from(Array((0, $jGcn0.DEFAULT_PAGE_SIZE)).keys()).map((i)=>(0, $aXbY8.createItemSkeleton)({
            issueId: String(i)
        }));
const $6f7d17a2863fe3d7$var$getInitialState = ()=>({
        hierarchyData: {
            data: $6f7d17a2863fe3d7$var$createLoadingItems(),
            loading: true,
            totalCount: 0,
            isLoadingNextPage: false,
            loadNextPage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        },
        expandedItems: {},
        childrenItems: {},
        issuesMap: new Map(),
        issueParentMap: new Map()
    });
const $6f7d17a2863fe3d7$export$d4c72bab9d6cc13a = $6f7d17a2863fe3d7$var$getInitialState();
const $6f7d17a2863fe3d7$var$findAnchorIndex = (issues, anchorId)=>{
    if (anchorId == null) return undefined;
    const index = issues.findIndex((issue)=>String(issue.issueId) === anchorId);
    if (index === -1) return undefined;
    return index;
};
// Recursively creates hierarchy tree by iterating over the items and their children
const $6f7d17a2863fe3d7$var$createHierarchy = ({ item: item, childrenItems: childrenItems, issuesMap: issuesMap, extendItemsWithChildCreate: extendItemsWithChildCreate, hierarchyLevels: hierarchyLevels, showFlatList: showFlatList, issueParentMap: issueParentMap })=>{
    const childQueryData = childrenItems[item.issueId] || {};
    const childrenData = Array.isArray(childQueryData.data) ? childQueryData.data : [];
    const childrenCount = item.childSummary?.totalCount ?? 0;
    const epicLevelIssueTypeIds = hierarchyLevels.filter((hierarchyLevel)=>hierarchyLevel.level === $6f7d17a2863fe3d7$export$21726efd4013edfd).map((hierarchyLevel)=>hierarchyLevel.id);
    const hasChildren = item.issuetype?.id && epicLevelIssueTypeIds.includes(item.issuetype.id) ? true : childrenCount > 0;
    let children = [];
    if (((0, $4oWxH.isGroupItem)(item.issueId) || showFlatList !== true) && hasChildren) {
        const depth = (item.depth || 0) + 1;
        const skeletonItem = childQueryData.loading ? [
            (0, $aXbY8.createItemSkeleton)({
                issueId: item.issueId
            })
        ] : [];
        children = childrenData.length ? childrenData.map((childItem, index)=>{
            issueParentMap.set(`${childItem.issueId}`, `${item.issueId}`);
            return $6f7d17a2863fe3d7$var$createHierarchy({
                item: {
                    ...childItem,
                    rankIndex: index,
                    depth: depth,
                    rowKey: `${childItem.id}-${depth}`
                },
                childrenItems: childrenItems,
                issuesMap: issuesMap,
                hierarchyLevels: hierarchyLevels,
                extendItemsWithChildCreate: extendItemsWithChildCreate,
                issueParentMap: issueParentMap
            });
        }) : skeletonItem;
        if (childQueryData.hasNextPage === true) children.push((0, $aXbY8.createRowForShowMore)(item.issueId));
    }
    const newItem = extendItemsWithChildCreate(item, children);
    issuesMap.set(`${item.issueId}`, newItem);
    return newItem;
};
const $6f7d17a2863fe3d7$var$extendItemsWithChildCreate = (rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels)=>(item, children)=>{
        const expandItem = (issueId)=>{
            const state = getState();
            if (!state.expandedItems[issueId]) setState({
                ...state,
                expandedItems: {
                    ...state.expandedItems,
                    [issueId]: true
                }
            });
        };
        const insertInlineCreate = (anchorIndex, type, issueId)=>{
            if (anchorIndex != null) children.splice(anchorIndex, 0, (0, $aXbY8.createRowForInlineCreate)(type, String(issueId)));
            else children.unshift((0, $aXbY8.createRowForInlineCreate)(type, String(issueId)));
        };
        const hierarchyLevel = hierarchyLevels.find((x)=>x.id === item.issuetype?.id)?.level;
        const anchorIndex = $6f7d17a2863fe3d7$var$findAnchorIndex(children, rowCreateState.anchorId);
        const { parentId: parentId } = rowCreateState;
        if (String(parentId) === String(item.issueId)) {
            if ((0, $4oWxH.isGroupItem)(item.issueId)) insertInlineCreate(anchorIndex, 'group', item.issueId);
            else if (hierarchyLevel === 0) insertInlineCreate(anchorIndex, 'subtask', item.issueId);
            else if (hierarchyLevel && hierarchyLevel >= 1) insertInlineCreate(anchorIndex, 'task', item.issueId);
        }
        return {
            ...item,
            children: children,
            onChildCreateButtonClicked: hierarchyLevel !== -1 ? ()=>{
                setRowCreatePosition({
                    parentId: item.issueId
                });
                expandItem(item.issueId);
            } : undefined
        };
    };
const $6f7d17a2863fe3d7$var$transformTopLevelIssues = (data, rowCreateState)=>{
    const { parentId: parentId, anchorId: anchorId } = rowCreateState;
    /**
	 * Due to race conditions, we cannot trust query data to be the source of truth for top level issues,
	 * so we need to make sure any inline create row has been removed before proceeding
	 */ const topLevelIssues = data.filter((item)=>!(0, $aXbY8.isItemAnInlineCreate)(String(item.issueId)));
    if (anchorId && !parentId) {
        const anchorIndex = $6f7d17a2863fe3d7$var$findAnchorIndex(topLevelIssues, rowCreateState.anchorId);
        if (anchorIndex != null) // Insert the sibling issue create row
        topLevelIssues.splice(anchorIndex, 0, (0, $aXbY8.createRowForInlineCreate)('sibling'));
    }
    return topLevelIssues;
};
// Takes top level items (or Groups) GraphQL response and stores it in here
const $6f7d17a2863fe3d7$var$setHierarchyData = (queryData, rowCreateState, setRowCreatePosition, hierarchyLevels, showFlatList)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const { childrenItems: childrenItems, issuesMap: issuesMap, issueParentMap: issueParentMap } = state;
        const childCreateCallback = $6f7d17a2863fe3d7$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
        if (queryData.loading) return;
        /**
		 * transformTopLevelIssues is used to transform both ListViewIssue[] and HierarchyItem[] array types, depending on what is passed as the 'data' argument,
		 *  hence the need to type cast it as ListViewIssue[] to avoid type errors
		 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const topLevelIssues = $6f7d17a2863fe3d7$var$transformTopLevelIssues(queryData.data, rowCreateState);
        const data = queryData.loading ? $6f7d17a2863fe3d7$var$createLoadingItems() : topLevelIssues.map((item, index)=>$6f7d17a2863fe3d7$var$createHierarchy({
                item: {
                    ...item,
                    rankIndex: index,
                    depth: 0,
                    rowKey: `${item.id}-0`
                },
                childrenItems: childrenItems,
                issuesMap: issuesMap,
                extendItemsWithChildCreate: childCreateCallback,
                showFlatList: showFlatList,
                hierarchyLevels: hierarchyLevels,
                issueParentMap: issueParentMap
            }));
        setState({
            ...state,
            hierarchyData: {
                ...queryData,
                data: data
            }
        });
    };
// Updates expanded items
const $6f7d17a2863fe3d7$var$setExpandedItems = (issueId, isExpanded)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            expandedItems: {
                ...state.expandedItems,
                [issueId]: isExpanded
            }
        });
    };
// Stores GraphQL response of expanded child items
const $6f7d17a2863fe3d7$var$setChildrenItems = (parentIssueId, queryData, rowCreateState, setRowCreatePosition, hierarchyLevels)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const childrenItems = {
            ...state.childrenItems,
            [parentIssueId]: {
                ...queryData,
                ...queryData.data ? {
                    data: queryData.data.map((issue)=>({
                            ...issue,
                            parentIssueId: parentIssueId
                        }))
                } : {}
            }
        };
        const { issuesMap: issuesMap, issueParentMap: issueParentMap } = state;
        let targetFound = false;
        const updateHierarchy = ({ rootIssueId: rootIssueId })=>{
            const item = issuesMap.get(`${rootIssueId}`);
            // We can stop traversal once the parent node has been updated
            if (targetFound || !item) return null;
            const childCreateCallback = $6f7d17a2863fe3d7$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
            if (String(item.issueId) === String(parentIssueId)) {
                // If we find the node we're appending children to, we need to create the new hierarchy below it and return to notify parents to update
                targetFound = true;
                return $6f7d17a2863fe3d7$var$createHierarchy({
                    item: item,
                    childrenItems: childrenItems,
                    issuesMap: issuesMap,
                    extendItemsWithChildCreate: childCreateCallback,
                    hierarchyLevels: hierarchyLevels,
                    issueParentMap: issueParentMap
                });
            }
            const { children: children } = item;
            const updatedChild = children?.reduce((acc, curr, index)=>{
                const newChild = updateHierarchy({
                    rootIssueId: curr.issueId
                });
                if (newChild) children[index] = newChild;
                return newChild ?? acc;
            }, undefined);
            if (updatedChild) {
                // if one of the children updated, then we need to update this node as well
                const newItem = {
                    ...item,
                    children: children
                };
                issuesMap.set(`${item.issueId}`, newItem);
                return newItem;
            }
            return null;
        };
        const topLevelItems = state.hierarchyData.data;
        for(let index = 0, count = topLevelItems.length; index < count; index += 1){
            const item = topLevelItems[index];
            const newItem = updateHierarchy({
                rootIssueId: item.issueId
            });
            if (newItem) topLevelItems[index] = newItem;
            if (targetFound) break;
        }
        setState({
            ...state,
            childrenItems: childrenItems,
            hierarchyData: {
                ...state.hierarchyData,
                data: [
                    ...topLevelItems
                ]
            }
        });
    };
// rebuilds the hierarchy, factoring in changes to row create position
const $6f7d17a2863fe3d7$var$refreshHierarchy = (rowCreateState, setRowCreatePosition, hierarchyLevels)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const { issuesMap: issuesMap, childrenItems: childrenItems, issueParentMap: issueParentMap } = state;
        /**
		 * getTopLevelIssues is used to transform both ListViewIssue[] and HierarchyItem[], depending on what is passed as the 'data' argument,
		 *  hence the need to type cast it as HierarchyItem[] to avoid type errors
		 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const topLevelIssues = $6f7d17a2863fe3d7$var$transformTopLevelIssues(state.hierarchyData.data, rowCreateState);
        for(let index = 0, count = topLevelIssues.length; index < count; index += 1){
            const item = topLevelIssues[index];
            const childCreateCallback = $6f7d17a2863fe3d7$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
            const newItem = $6f7d17a2863fe3d7$var$createHierarchy({
                item: item,
                childrenItems: childrenItems,
                issuesMap: issuesMap,
                extendItemsWithChildCreate: childCreateCallback,
                hierarchyLevels: hierarchyLevels,
                issueParentMap: issueParentMap
            });
            if (newItem) topLevelIssues[index] = newItem;
        }
        setState({
            ...state,
            childrenItems: childrenItems,
            hierarchyData: {
                ...state.hierarchyData,
                data: [
                    ...topLevelIssues
                ]
            }
        });
    };
const $6f7d17a2863fe3d7$var$resetCache = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            childrenItems: {},
            expandedItems: {}
        });
    };
const $6f7d17a2863fe3d7$var$expandFirstItems = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const firstIssueId = state.hierarchyData.data[0]?.issueId;
        setState({
            ...state,
            expandedItems: firstIssueId != null ? {
                [firstIssueId]: true
            } : {}
        });
    };
const $6f7d17a2863fe3d7$var$clearExpandedItems = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            expandedItems: Object.fromEntries(Object.keys(state.expandedItems).map((key)=>[
                    key,
                    false
                ]))
        });
    };
const $6f7d17a2863fe3d7$var$getParentIssueKeysByChildId = (issueId)=>({ getState: getState })=>{
        const { issuesMap: issuesMap } = getState();
        let parents = [];
        let node = issuesMap.get(`${issueId}`);
        do {
            const parentIssue = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            node?.fields, (0, $lO4Or.PARENT_TYPE), 'issue', null);
            const cachedParentIssueId = !(0, $4oWxH.isGroupItem)(`${node?.parentIssueId}`) ? node?.parentIssueId : null;
            const parentIssueId = parentIssue?.issueId ? parentIssue?.issueId : cachedParentIssueId;
            if (parentIssueId) {
                node = issuesMap.get(`${parentIssueId}`);
                // When parent issue is cached in hierarchy store
                if (node) parents = [
                    {
                        id: `${parentIssueId}`,
                        key: `${node.key}`
                    },
                    ...parents
                ];
                else if (parentIssue?.issueKey) {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const key = `${parentIssue?.issueKey || ''}`;
                    parents = [
                        {
                            id: `${parentIssueId}`,
                            key: key
                        },
                        ...parents
                    ];
                }
            } else node = undefined;
        }while (node);
        if (parents.length) return parents;
        return null;
    };
const $6f7d17a2863fe3d7$var$clearHierarchyData = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            hierarchyData: $6f7d17a2863fe3d7$var$getInitialState().hierarchyData
        });
    };
const $6f7d17a2863fe3d7$var$initState = ({ projectKey: projectKey })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            projectKey: projectKey
        });
    };
const $6f7d17a2863fe3d7$var$actions = {
    setHierarchyData: $6f7d17a2863fe3d7$var$setHierarchyData,
    setExpandedItems: $6f7d17a2863fe3d7$var$setExpandedItems,
    setChildrenItems: $6f7d17a2863fe3d7$var$setChildrenItems,
    refreshHierarchy: $6f7d17a2863fe3d7$var$refreshHierarchy,
    expandFirstItems: $6f7d17a2863fe3d7$var$expandFirstItems,
    clearExpandedItems: $6f7d17a2863fe3d7$var$clearExpandedItems,
    clearHierarchyData: $6f7d17a2863fe3d7$var$clearHierarchyData,
    resetCache: $6f7d17a2863fe3d7$var$resetCache,
    getParentIssueKeysByChildId: $6f7d17a2863fe3d7$var$getParentIssueKeysByChildId,
    initState: $6f7d17a2863fe3d7$var$initState
};
const $6f7d17a2863fe3d7$var$Store = (0, $kEDjj.createStore)({
    initialState: $6f7d17a2863fe3d7$export$d4c72bab9d6cc13a,
    actions: $6f7d17a2863fe3d7$var$actions,
    name: 'JWMHierarchyStore'
});
const $6f7d17a2863fe3d7$export$2fc259d06066fab6 = (0, $1yZQx.createHook)($6f7d17a2863fe3d7$var$Store);

});
parcelRegister("4oWxH", function(module, exports) {

$parcel$export(module.exports, "getParentIssueId", () => $f8cd47f415fc2d3e$export$846a0afb93794223);
$parcel$export(module.exports, "isGroupItem", () => $f8cd47f415fc2d3e$export$dcc23ed179776a3b);
$parcel$export(module.exports, "getGroupItemId", () => $f8cd47f415fc2d3e$export$4f6368343f5d1a95);
$parcel$export(module.exports, "isRootLevel", () => $f8cd47f415fc2d3e$export$7044e84e19490c29);

var $3uSNh = parcelRequire("3uSNh");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $7Sz8O = parcelRequire("7Sz8O");
const $f8cd47f415fc2d3e$export$3ba5d152e044664d = (parentIssue, subtaskFieldIssue)=>{
    const parentIssueFields = parentIssue.fields || [];
    const subtasksFieldIndex = parentIssueFields.findIndex((field)=>field?.fieldKey === 'subtasks');
    const subtasksField = typeof subtasksFieldIndex === 'number' && subtasksFieldIndex !== -1 ? parentIssueFields[subtasksFieldIndex] : undefined;
    if (subtasksFieldIndex === -1 || subtasksField == null) // there should be a subtask field always in the code
    // since it's declared in the gql
    return parentIssue;
    const updatedFields = [
        ...parentIssueFields
    ];
    updatedFields[subtasksFieldIndex] = {
        ...updatedFields[subtasksFieldIndex],
        issues: [
            subtaskFieldIssue,
            ...subtasksField?.issues || []
        ].filter((issue, index, issueArray)=>issueArray.findIndex((current)=>current.issueId === issue.issueId) === index)
    };
    return {
        ...parentIssue,
        // we're updating just the subtasks field, but flow doesn't understand that because the union type of fields
        fields: updatedFields
    };
};
const $f8cd47f415fc2d3e$export$30019f8058090ccb = (isFiltering, id)=>{
    if (id === (0, $7Sz8O.OPTIMISTIC_ISSUE_ID)) return false;
    return !isFiltering;
};
const $f8cd47f415fc2d3e$export$d9893aac42f29b60 = (node)=>{
    const issueKey = (0, $3uSNh.safeGetValue)(node.fields, 'issuekey', 'text', undefined);
    const parentIssue = (0, $3uSNh.safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
    const projectKey1 = (issueKey ?? '').split('-')[0];
    const projectKey2 = (parentIssue?.key ?? '').split('-')[0];
    const sameProject = projectKey1 && projectKey2 ? projectKey1 === projectKey2 : false;
    return sameProject ? parentIssue?.issueId : undefined;
};
const $f8cd47f415fc2d3e$export$846a0afb93794223 = (node)=>{
    if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
        if ((0, $eI5EY.fg)('list_-_get_parent_id_should_support_group')) {
            const parentIssue = (0, $3uSNh.safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
            // We need to return parent issue if is a group parent
            if ($f8cd47f415fc2d3e$export$dcc23ed179776a3b(parentIssue?.issueId)) return parentIssue?.issueId;
        }
        return $f8cd47f415fc2d3e$export$d9893aac42f29b60(node);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parentIssue = (0, $3uSNh.safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
    if (parentIssue?.issueId) return parentIssue?.issueId;
    return undefined;
};
const $f8cd47f415fc2d3e$export$dcc23ed179776a3b = (issueId = '')=>typeof issueId === 'string' && issueId.startsWith((0, $7Sz8O.GROUP_ITEM_PREFIX));
const $f8cd47f415fc2d3e$export$4f6368343f5d1a95 = (issueId)=>{
    const [_, groupItemId] = issueId.split(`${(0, $7Sz8O.GROUP_ITEM_PREFIX)}_`);
    return groupItemId ?? issueId;
};
const $f8cd47f415fc2d3e$export$7044e84e19490c29 = (issueId)=>issueId === (0, $7Sz8O.ROOT_LEVEL);

});
parcelRegister("7Sz8O", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID_PREFIX", () => $f5561e29bb49c6a7$export$a76c6afcd77fffd8);
$parcel$export(module.exports, "OPTIMISTIC_ISSUE_ID", () => $f5561e29bb49c6a7$export$2bc461aaabcabfc9);
$parcel$export(module.exports, "ROOT_LEVEL", () => $f5561e29bb49c6a7$export$d24bbd23c8a5d65e);
$parcel$export(module.exports, "GROUP_ITEM_PREFIX", () => $f5561e29bb49c6a7$export$b29b9e70f9850100);
const $f5561e29bb49c6a7$export$a76c6afcd77fffd8 = '-optimistic';
const $f5561e29bb49c6a7$export$2bc461aaabcabfc9 = -1;
const $f5561e29bb49c6a7$export$d24bbd23c8a5d65e = 'rootLevel';
const $f5561e29bb49c6a7$export$b29b9e70f9850100 = 'GROUP_BY';

});


parcelRegister("aXbY8", function(module, exports) {

$parcel$export(module.exports, "isItemAnIssue", () => $dc3d38a485b6d99f$export$975d97cb9b482d9f);
$parcel$export(module.exports, "createItemSkeleton", () => $dc3d38a485b6d99f$export$ac4443ed642486ab);
$parcel$export(module.exports, "isItemSkeleton", () => $dc3d38a485b6d99f$export$121c11fd7ecbe3e1);
$parcel$export(module.exports, "INLINE_CREATE_ITEM_PREFIX", () => $dc3d38a485b6d99f$export$cdc74f7556cd3fa2);
$parcel$export(module.exports, "createRowForInlineCreate", () => $dc3d38a485b6d99f$export$eb550cfe09336f0d);
$parcel$export(module.exports, "isItemAnInlineCreate", () => $dc3d38a485b6d99f$export$f785dc554f71ae43);
$parcel$export(module.exports, "isItemAnInlineCreateTask", () => $dc3d38a485b6d99f$export$76703e048af589f9);
$parcel$export(module.exports, "isItemAnInlineCreateSubTask", () => $dc3d38a485b6d99f$export$7bcd44296e4ddac3);
$parcel$export(module.exports, "isItemAnInlineCreateGroup", () => $dc3d38a485b6d99f$export$a18c1da7342b1b86);
$parcel$export(module.exports, "isItemASiblingTopLevelHierarchyInlineCreate", () => $dc3d38a485b6d99f$export$6341a221cf48c3e1);
$parcel$export(module.exports, "isItemShowMore", () => $dc3d38a485b6d99f$export$20c8aeca27cd0961);
$parcel$export(module.exports, "createRowForShowMore", () => $dc3d38a485b6d99f$export$4a6167a75be5ff06);

var $8Qd0L = parcelRequire("8Qd0L");

var $lqO9q = parcelRequire("lqO9q");
const $dc3d38a485b6d99f$export$975d97cb9b482d9f = (issueId)=>Number(issueId) > 0;
const $dc3d38a485b6d99f$export$8764542593218704 = 'SKELETON-ITEM-';
const $dc3d38a485b6d99f$export$ac4443ed642486ab = ({ issueId: issueId })=>({
        id: `${$dc3d38a485b6d99f$export$8764542593218704}${issueId}-id`,
        issueId: `${$dc3d38a485b6d99f$export$8764542593218704}${issueId}`,
        typeId: 'loading',
        issuetype: {},
        key: 'loading',
        rank: '',
        status: {
            name: 'To do',
            categoryId: (0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.TODO)).toString()
        },
        totalSubtasks: 0,
        rankIndex: 0,
        cacheVariables: (0, $lqO9q.DEFAULT_CACHE_VARIABLES)
    });
const $dc3d38a485b6d99f$export$121c11fd7ecbe3e1 = (issueId = '')=>String(issueId).startsWith($dc3d38a485b6d99f$export$8764542593218704);
const $dc3d38a485b6d99f$export$cdc74f7556cd3fa2 = 'INLINE-CREATE-';
const $dc3d38a485b6d99f$export$eb550cfe09336f0d = (type = 'subtask', issueId = 'InlineCreate')=>({
        id: `${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}${type}-id`,
        issueId: `${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}${type}-issueId`,
        parentIssueId: issueId,
        typeId: `${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}-typeId--${issueId}`,
        issuetype: {},
        key: `${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}-key-${issueId}`,
        rank: '',
        rankIndex: -1,
        status: {
            name: 'To do',
            categoryId: (0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.TODO)).toString()
        },
        totalSubtasks: 0,
        rowKey: `${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}-${issueId}`,
        cacheVariables: (0, $lqO9q.DEFAULT_CACHE_VARIABLES)
    });
const $dc3d38a485b6d99f$export$f785dc554f71ae43 = (issueId = '')=>issueId.startsWith($dc3d38a485b6d99f$export$cdc74f7556cd3fa2);
const $dc3d38a485b6d99f$export$76703e048af589f9 = (issueId = '')=>issueId.startsWith(`${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}task`);
const $dc3d38a485b6d99f$export$7bcd44296e4ddac3 = (issueId = '')=>issueId.startsWith(`${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}subtask`);
const $dc3d38a485b6d99f$export$a18c1da7342b1b86 = (issueId = '')=>issueId.startsWith(`${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}group`);
const $dc3d38a485b6d99f$export$6341a221cf48c3e1 = (issueId = '')=>issueId.startsWith(`${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}sibling`);
const $dc3d38a485b6d99f$export$8fca45ac4bf48d8a = 'SHOW_MORE-';
const $dc3d38a485b6d99f$export$20c8aeca27cd0961 = (issueId = '')=>issueId.startsWith($dc3d38a485b6d99f$export$8fca45ac4bf48d8a);
const $dc3d38a485b6d99f$export$4a6167a75be5ff06 = (issueId)=>({
        id: `${$dc3d38a485b6d99f$export$8fca45ac4bf48d8a}-id`,
        issueId: `${$dc3d38a485b6d99f$export$8fca45ac4bf48d8a}-issueId`,
        parentIssueId: issueId,
        typeId: `${$dc3d38a485b6d99f$export$8fca45ac4bf48d8a}-typeId--${issueId}`,
        issuetype: {},
        key: `${$dc3d38a485b6d99f$export$8fca45ac4bf48d8a}-key-${issueId}`,
        rank: '',
        rankIndex: -1,
        status: {
            name: 'To do',
            categoryId: (0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.TODO)).toString()
        },
        totalSubtasks: 0,
        rowKey: `${$dc3d38a485b6d99f$export$8fca45ac4bf48d8a}-${issueId}`,
        cacheVariables: (0, $lqO9q.DEFAULT_CACHE_VARIABLES)
    });

});
parcelRegister("lqO9q", function(module, exports) {

$parcel$export(module.exports, "SELECT_ROW_COLUMN_ID", () => $f82872dc389830b4$export$2862da21a9b5c4c7);
$parcel$export(module.exports, "COLUMNS_WITH_DISABLED_REORDERING", () => $f82872dc389830b4$export$d4e2ef02d58b3b19);
$parcel$export(module.exports, "DEFAULT_CACHE_VARIABLES", () => $f82872dc389830b4$export$fc14c7f3b5089b5d);
$parcel$export(module.exports, "PLACEHOLDER_COLUMN", () => $f82872dc389830b4$export$b74e0ecca7ce25fe);

var $lO4Or = parcelRequire("lO4Or");
const $f82872dc389830b4$export$2862da21a9b5c4c7 = 'selectRow';
const $f82872dc389830b4$export$394fb015dc5fe3a6 = 'summary';
const $f82872dc389830b4$export$b76d46aaf0fea4b4 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $f82872dc389830b4$export$e7d0f09e45be184e = 'column-draggable-helper-class';
const $f82872dc389830b4$export$d4e2ef02d58b3b19 = [
    $f82872dc389830b4$export$2862da21a9b5c4c7,
    (0, $lO4Or.ISSUE_TYPE),
    'key'
];
const $f82872dc389830b4$export$7b293683c3b210c9 = 'JWMCategoryCustomField';
const $f82872dc389830b4$export$fc14c7f3b5089b5d = {
    jql: ''
};
const $f82872dc389830b4$export$b74e0ecca7ce25fe = 'PLACEHOLDER';

});



parcelRegister("hotly", function(module, exports) {

$parcel$export(module.exports, "BulkSelectionContainer", () => $6c9f50fcdf5be0d5$export$ba7d4447e46b479e);
$parcel$export(module.exports, "useBulkSelectionStore", () => $6c9f50fcdf5be0d5$export$2addfe65a8c51586);
$parcel$export(module.exports, "useIsIssueSelected", () => $6c9f50fcdf5be0d5$export$cfefd69fc8a5ac52);
$parcel$export(module.exports, "useIsGroupSelected", () => $6c9f50fcdf5be0d5$export$5810b0d7bc5c531d);
$parcel$export(module.exports, "useDiffIssuesSelected", () => $6c9f50fcdf5be0d5$export$84ca3a6195e96ba);

var $96gVp = parcelRequire("96gVp");
var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $gB6aI = parcelRequire("gB6aI");
const $6c9f50fcdf5be0d5$var$actions = {
    selectIssues: ({ issues: issues, issuesData: issuesData, selectGroup: selectGroup, rowIndex: rowIndex })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const selectedIssuesDataMap = new Map(state.selectedIssuesData);
            issuesData?.forEach((issue)=>{
                selectedIssuesDataMap.set(issue.issueId, issue);
            });
            const newState = {
                ...state,
                selectedIssues: new Set([
                    ...state.selectedIssues,
                    ...issues
                ]),
                ...issuesData && {
                    selectedIssuesData: selectedIssuesDataMap
                },
                ...selectGroup ? {
                    selectedGroups: new Set([
                        ...state.selectedGroups,
                        selectGroup
                    ])
                } : {},
                ...rowIndex !== undefined ? {
                    lastSelectedRowIndex: rowIndex
                } : {}
            };
            setState(newState);
        },
    selectAllIssues: ({ issues: issues, issuesData: // TODO: make issuesData required when removing use of issues https://jbusiness.atlassian.net/browse/HRZ-589
    issuesData = [] })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const selectedIssuesDataMap = new Map();
            issuesData?.forEach((issue)=>{
                selectedIssuesDataMap.set(issue.issueId, issue);
            });
            const newState = {
                ...state,
                areAllIssuesSelected: true,
                selectedIssues: new Set(issues),
                selectedIssuesData: selectedIssuesDataMap,
                lastSelectedRowIndex: undefined
            };
            setState(newState);
        },
    selectGroup: (groupId)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                selectedGroups: new Set([
                    ...state.selectedGroups,
                    groupId
                ])
            });
        },
    selectAll: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                areAllIssuesSelected: true
            });
        },
    unselectAll: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                areAllIssuesSelected: false,
                lastSelectedRowIndex: undefined
            });
        },
    unselectGroup: (groupId)=>({ setState: setState, getState: getState })=>{
            const { selectedGroups: selectedGroups, ...state } = getState();
            selectedGroups.delete(groupId);
            setState({
                ...state,
                areAllIssuesSelected: false,
                selectedGroups: new Set(selectedGroups)
            });
        },
    unselectIssues: ({ issues: issues, unselectGroup: unselectGroup, rowIndex: rowIndex })=>({ setState: setState, getState: getState })=>{
            const { selectedIssues: selectedIssues, selectedIssuesData: selectedIssuesData, ...state } = getState();
            if (unselectGroup) state.selectedGroups.delete(unselectGroup);
            issues.forEach((issueId)=>{
                selectedIssues.delete(issueId);
                selectedIssuesData.delete(issueId);
            });
            const newState = {
                ...state,
                areAllIssuesSelected: false,
                selectedIssues: new Set(selectedIssues),
                selectedIssuesData: selectedIssuesData,
                ...unselectGroup ? {
                    selectedGroups: new Set(state.selectedGroups)
                } : {},
                ...rowIndex !== undefined ? {
                    lastSelectedRowIndex: rowIndex
                } : {}
            };
            setState(newState);
        },
    clearSelection: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                areAllIssuesSelected: false,
                selectedGroups: new Set(),
                selectedIssues: new Set(),
                selectedIssuesData: new Map()
            });
        },
    toggleShowDeleteModal: ({ showDeleteModal: showDeleteModal })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                showDeleteModal: showDeleteModal
            });
        },
    toggleBulkEditSidebar: ({ showBulkEditSidebar: showBulkEditSidebar })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const { selectedIssues: selectedIssues } = state;
            if (showBulkEditSidebar) setState({
                ...state,
                showBulkEditSidebar: showBulkEditSidebar,
                bulkEditableIssues: new Set(selectedIssues)
            });
            else setState({
                ...state,
                showBulkEditSidebar: showBulkEditSidebar,
                bulkEditableIssues: new Set()
            });
        },
    setBulkChangePermission: ({ bulkChangePermission: bulkChangePermission })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                bulkChangePermission: bulkChangePermission
            });
        },
    setFetchingGroups: (groups)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                fetchingGroups: groups
            });
        },
    setLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                lastSelectedRowIndex: lastSelectedRowIndex
            });
        }
};
const $6c9f50fcdf5be0d5$var$initialState = {
    areAllIssuesSelected: false,
    selectedIssues: new Set(),
    selectedIssuesData: new Map(),
    selectedGroups: new Set(),
    showDeleteModal: false,
    showBulkEditSidebar: false,
    // groups that were collapsed and we are fetching the children to select them
    fetchingGroups: [],
    bulkEditableIssues: new Set()
};
const $6c9f50fcdf5be0d5$var$Store = (0, $kEDjj.createStore)({
    initialState: $6c9f50fcdf5be0d5$var$initialState,
    actions: $6c9f50fcdf5be0d5$var$actions,
    name: 'JWMListBulkSelection'
});
const $6c9f50fcdf5be0d5$export$ba7d4447e46b479e = (0, $96gVp.createContainer)($6c9f50fcdf5be0d5$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                ...$6c9f50fcdf5be0d5$var$initialState
            });
        }
});
const $6c9f50fcdf5be0d5$export$2addfe65a8c51586 = (0, $1yZQx.createHook)($6c9f50fcdf5be0d5$var$Store);
const $6c9f50fcdf5be0d5$export$cfefd69fc8a5ac52 = (0, $1yZQx.createHook)($6c9f50fcdf5be0d5$var$Store, {
    selector: (0, $gB6aI.isIssueSelected)
});
const $6c9f50fcdf5be0d5$export$5810b0d7bc5c531d = (0, $1yZQx.createHook)($6c9f50fcdf5be0d5$var$Store, {
    selector: (0, $gB6aI.isGroupSelected)
});
const $6c9f50fcdf5be0d5$export$84ca3a6195e96ba = (0, $1yZQx.createHook)($6c9f50fcdf5be0d5$var$Store, {
    selector: (0, $gB6aI.diffIssuesSelected)
});

});
parcelRegister("gB6aI", function(module, exports) {

$parcel$export(module.exports, "isIssueSelected", () => $27092b3cbe1590f2$export$32568110248dd20a);
$parcel$export(module.exports, "isGroupSelected", () => $27092b3cbe1590f2$export$9a23656adbf96f8a);
$parcel$export(module.exports, "diffIssuesSelected", () => $27092b3cbe1590f2$export$bb31aa8fa8f2c5e0);

var $1jo4G = parcelRequire("1jo4G");
const $27092b3cbe1590f2$export$32568110248dd20a = (0, $1jo4G.createSelector)((state)=>({
        selectedIssues: state.selectedIssues,
        fetchingGroups: state.fetchingGroups
    }), (__, { issueId: issueId, parentIssueId: parentIssueId })=>({
        issueId: issueId,
        parentIssueId: parentIssueId
    }), ({ selectedIssues: selectedIssues, fetchingGroups: fetchingGroups }, issue)=>{
    if (selectedIssues.has(String(issue.issueId))) return true;
    if (issue.parentIssueId) // Optimistic selection
    return fetchingGroups.includes(String(issue.parentIssueId));
    return false;
});
const $27092b3cbe1590f2$export$9a23656adbf96f8a = (0, $1jo4G.createSelector)((state)=>state.selectedGroups, (__, groupId)=>groupId, (selectedGroups, groupId)=>{
    if (!groupId) return false;
    return selectedGroups.has(groupId);
});
const $27092b3cbe1590f2$export$bb31aa8fa8f2c5e0 = (0, $1jo4G.createSelector)((state)=>state.selectedIssues, (__, issues)=>issues, (selectedIssues, issues)=>{
    if (!issues) return undefined;
    const diff = [];
    issues.forEach((issueId)=>{
        if (!selectedIssues.has(issueId)) diff.push(issueId);
    });
    return diff;
});

});


parcelRegister("8COV0", function(module, exports) {

$parcel$export(module.exports, "getFlattenIssuesList", () => $7ba7c1f031f18026$export$f47d7c5b44a813c0);
$parcel$export(module.exports, "getAllIssueChildren", () => $7ba7c1f031f18026$export$1945e9d463a28215);
$parcel$export(module.exports, "getAllIssuesIds", () => $7ba7c1f031f18026$export$1b9aa9aa607a46fc);

var $hTLlD = parcelRequire("hTLlD");

var $5iWql = parcelRequire("5iWql");

var $7Sz8O = parcelRequire("7Sz8O");

var $4oWxH = parcelRequire("4oWxH");

var $6vrw7 = parcelRequire("6vrw7");

var $aXbY8 = parcelRequire("aXbY8");
const $7ba7c1f031f18026$export$f47d7c5b44a813c0 = ({ issues: issues, expandedItems: expandedItems })=>{
    if (!issues || issues.length === 0) return [];
    const flattenedIssues = issues.flatMap((issue)=>{
        const isExpanded = expandedItems[(0, $6vrw7.toIssueId)(issue.issueId)];
        const children = isExpanded ? $7ba7c1f031f18026$export$f47d7c5b44a813c0({
            issues: issue.children,
            expandedItems: expandedItems
        }) : [];
        return [
            issue,
            ...children
        ];
    });
    return flattenedIssues;
};
const $7ba7c1f031f18026$export$1945e9d463a28215 = (0, $5iWql.default)(({ issue: issue, childrenItems: childrenItems })=>{
    if (!issue) return [];
    const issueChildren = childrenItems[issue.issueId];
    if (!issueChildren) return [];
    let issuesIds = [];
    issueChildren.data?.forEach((child)=>{
        issuesIds = [
            ...issuesIds,
            String(child.issueId),
            ...$7ba7c1f031f18026$export$1945e9d463a28215({
                issue: child,
                childrenItems: childrenItems
            })
        ];
    });
    return issuesIds;
}, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
const $7ba7c1f031f18026$export$1b9aa9aa607a46fc = ({ data: data, childrenItems: childrenItems })=>{
    let issuesIds = [];
    data.forEach((issue)=>{
        const { issueId: issueId, id: id } = issue;
        if (!(0, $4oWxH.isGroupItem)(issueId) && !(0, $aXbY8.isItemSkeleton)(issueId) && !id.startsWith((0, $7Sz8O.OPTIMISTIC_ID_PREFIX))) issuesIds.push(String(issueId));
        if (childrenItems[issueId]) issuesIds = [
            ...issuesIds,
            ...$7ba7c1f031f18026$export$1945e9d463a28215({
                issue: issue,
                childrenItems: childrenItems
            })
        ];
    });
    return issuesIds;
};

});


parcelRegister("h8g5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $0388c01def4135b6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dSE3z = parcelRequire("dSE3z");

var $2fYxG = parcelRequire("2fYxG");

var $xqSqx = parcelRequire("xqSqx");

var $kBwul = parcelRequire("kBwul");
const $0388c01def4135b6$var$Hierarchy = ()=>{
    const { childrenLoader: childrenLoader } = (0, $2fYxG.useChildrenLoader)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    // avoid re-fetching children when Hierarchy component re-renders
    const childItemsLoader = (0, $eUqFw.useMemo)(()=>childrenLoader, [
        childrenLoader
    ]);
    const shouldGroupItems = groupByFieldId != null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldGroupItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xqSqx.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kBwul.default), null), childItemsLoader);
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$0388c01def4135b6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($0388c01def4135b6$var$Hierarchy);

});
parcelRegister("2fYxG", function(module, exports) {

$parcel$export(module.exports, "useChildrenLoader", () => $fe41b4f14de4bba7$export$10e8857fe2182cb4);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $7Sz8O = parcelRequire("7Sz8O");

var $4oWxH = parcelRequire("4oWxH");

var $nxBOY = parcelRequire("nxBOY");

var $dYkSU = parcelRequire("dYkSU");

var $5r9Wo = parcelRequire("5r9Wo");

var $iGWrT = parcelRequire("iGWrT");
const $fe41b4f14de4bba7$export$10e8857fe2182cb4 = ()=>{
    const [{ expandedItems: expandedItems, childrenItems: childrenItems, issuesMap: issuesMap }] = (0, $5r9Wo.useHierarchyStore)();
    const { data: data } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const { setChildrenItems: setChildrenItems } = (0, $iGWrT.useSetChildrenItems)();
    const getHierarchyLevel = (0, $eUqFw.useCallback)((issueId)=>{
        const maybeIssue = issuesMap.get(issueId);
        if (!maybeIssue) return undefined;
        const maybeIssueTypeData = data.issueTypes.find((issueType)=>issueType.id === maybeIssue.issuetype.id);
        if (!maybeIssueTypeData) return undefined;
        return maybeIssueTypeData.hierarchyLevel;
    }, [
        data.issueTypes,
        issuesMap
    ]);
    const childrenLoader = (0, $eUqFw.useMemo)(()=>{
        const expandedItemIssueIds = Object.keys(expandedItems).filter((issueId)=>!(0, $4oWxH.isGroupItem)(issueId) && // exclude optimistically created items that'd immediately be expanded when "Expand All" is on
            String(issueId) !== String((0, $7Sz8O.OPTIMISTIC_ISSUE_ID)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $nxBOY.ChildrenController), {
            expandedItemIssueIds: expandedItemIssueIds,
            loadingIssueIds: expandedItemIssueIds.filter((expandedItemId)=>!childrenItems[expandedItemId] || childrenItems[expandedItemId].loading),
            setChildrenQueryData: setChildrenItems,
            ChildQueryController: (0, $dYkSU.ListViewChildQueryController),
            getHierarchyLevel: getHierarchyLevel
        });
    }, [
        expandedItems,
        setChildrenItems,
        getHierarchyLevel,
        childrenItems
    ]);
    return {
        childrenLoader: childrenLoader
    };
};

});
parcelRegister("nxBOY", function(module, exports) {

$parcel$export(module.exports, "ChildrenController", () => $f44a906179e22f72$export$8c3512dd18e9e8f);

var $eUqFw = parcelRequire("eUqFw");

const $f44a906179e22f72$export$8c3512dd18e9e8f = /*#__PURE__*/ (0, $eUqFw.memo)(({ expandedItemIssueIds: expandedItemIssueIds, setChildrenQueryData: setChildrenQueryData, ChildQueryController: ChildQueryController, getHierarchyLevel: getHierarchyLevel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, expandedItemIssueIds.map((expandedItemIssueId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChildQueryController, {
            parentIssueId: expandedItemIssueId,
            parentHierarchyType: (0, $2a7b21c0842403e6$export$9355e489ad16f98e),
            parentHierarchyLevel: getHierarchyLevel ? getHierarchyLevel(expandedItemIssueId) : undefined,
            onDataChange: setChildrenQueryData,
            key: expandedItemIssueId
        }))), (prevProps, nextProps)=>{
    const prevIssueIds = prevProps.expandedItemIssueIds.sort();
    const nextIssueIds = nextProps.expandedItemIssueIds.sort();
    const prevLoadingIssueIds = prevProps.loadingIssueIds?.sort();
    const nextLoadingIssueIds = nextProps.loadingIssueIds?.sort();
    let loadingIssuesMatch = true;
    if (prevLoadingIssueIds === undefined || nextLoadingIssueIds === undefined) loadingIssuesMatch = prevLoadingIssueIds === nextLoadingIssueIds;
    else loadingIssuesMatch = prevLoadingIssueIds?.length === nextLoadingIssueIds?.length && prevLoadingIssueIds.every((_, id)=>prevLoadingIssueIds[id] === nextLoadingIssueIds[id]);
    return prevProps.setChildrenQueryData === nextProps.setChildrenQueryData && prevIssueIds.length === nextIssueIds.length && prevIssueIds.every((_, id)=>prevIssueIds[id] === nextIssueIds[id]) && loadingIssuesMatch;
});

});

parcelRegister("dYkSU", function(module, exports) {

$parcel$export(module.exports, "ListViewChildQueryController", () => $a375fdd86ab2d782$export$fffae14cb4664bb4);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $aVwtE = parcelRequire("aVwtE");

var $dWGNJ = parcelRequire("dWGNJ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gbsaq = parcelRequire("gbsaq");

var $f8ADw = parcelRequire("f8ADw");

var $hHiDc = parcelRequire("hHiDc");

var $fXrll = parcelRequire("fXrll");
const $a375fdd86ab2d782$export$fffae14cb4664bb4 = /*#__PURE__*/ (0, $eUqFw.memo)(({ parentHierarchyType: parentHierarchyType, parentIssueId: parentIssueId, onDataChange: onDataChange, parentHierarchyLevel: parentHierarchyLevel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { getQueryFieldIds: getQueryFieldIds, loading: isLoadingFields, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $hHiDc.useIssueFields)();
    const onComplete = (0, $eUqFw.useCallback)((responseData)=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'listChildrenData fetched', {
            totalChildren: (0, $aVwtE.getAGGCompliantData)(responseData, 'list')?.edges?.length,
            parentIssueId: parentIssueId,
            hierarchyLevel: parentHierarchyLevel
        });
    }, [
        createAnalyticsEvent,
        parentHierarchyLevel,
        parentIssueId
    ]);
    const { data: data, error: error, hasNextPage: hasNextPage, isLoadingNextPage: isLoadingNextPage, loading: loading, loadNextPage: loadNextPage } = (0, $f8ADw.useListViewIssues)({
        input: {
            jqlContext: jqlContext,
            fieldIds: getQueryFieldIds(),
            quickFiltersJql: quickFiltersJql,
            parentIssue: {
                hierarchyType: parentHierarchyType,
                hierarchyLevel: parentHierarchyLevel,
                issueId: parentIssueId
            },
            sorting: sorting,
            isHidingDoneItems: isHidingDoneItems,
            isParentFieldVisible: isParentFieldVisible(),
            isDevSummaryFieldVisible: isDevSummaryFieldVisible()
        },
        condition: !isLoadingFields,
        onComplete: onComplete
    });
    (0, $4G5xU.useQueryBasedViewAutomaticTracking)((0, $gbsaq.LOAD_CHILDREN_EXPERIENCE), {
        loading: loading,
        error: error,
        shouldStartExperience: true
    });
    (0, $eUqFw.useEffect)(()=>{
        onDataChange(parentIssueId, {
            data: data,
            error: error,
            hasNextPage: hasNextPage,
            isLoadingNextPage: isLoadingNextPage,
            loading: loading,
            loadNextPage: loadNextPage
        });
    }, [
        data,
        error,
        hasNextPage,
        isLoadingNextPage,
        loading,
        loadNextPage,
        onDataChange,
        parentIssueId
    ]);
    return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $fXrll.default).errorTitle,
        description: (0, $fXrll.default).errorMessage
    }) : null;
});

});
parcelRegister("aVwtE", function(module, exports) {

$parcel$export(module.exports, "useFetchMore", () => $4a89f8875e643360$export$d84f34af2f3f5d9f);
$parcel$export(module.exports, "getAGGCompliantData", () => $4a89f8875e643360$export$5a178cf599565b50);

var $iZuDo = parcelRequire("iZuDo");

var $jlBDe = parcelRequire("jlBDe");

var $90pMD = parcelRequire("90pMD");

var $6gPph = parcelRequire("6gPph");

var $eI5EY = parcelRequire("eI5EY");

var $4X5wI = parcelRequire("4X5wI");
function $4a89f8875e643360$export$2b602b4ab6fde7b6({ after: after, onError: onError, errorPolicy: errorPolicy = 'none', updateQuery: updateQuery, query: query, variables: variables, client: client }) {
    const variablesWithAfter = {
        ...variables,
        after: after
    };
    return client.query({
        query: query,
        variables: variablesWithAfter,
        fetchPolicy: 'no-cache',
        errorPolicy: errorPolicy
    }).then((response)=>{
        if (!response) return;
        if (response.errors) {
            onError && onError(new (0, $jlBDe.ApolloError)({
                graphQLErrors: response.errors
            }));
            if (errorPolicy === 'none') return;
        }
        if (response.data == null) return;
        // Update cache based on updateQuery method
        const prevData = client.readQuery({
            query: query,
            variables: variables
        });
        if (prevData == null) // It should not happened, adding the check just to make flow happpy
        return;
        const newData = updateQuery(prevData, {
            fetchMoreResult: response.data,
            variables: variablesWithAfter
        });
        client.writeQuery({
            query: query,
            variables: variables,
            // @ts-expect-error - TS2345 - Argument of type '{ query: DocumentNode; variables: TVariables; notifyOnNetworkStatusChange: boolean; data: TData; }' is not assignable to parameter of type 'WriteQueryOptions<TData, TVariables>'.
            notifyOnNetworkStatusChange: true,
            data: newData
        });
    }).catch((err)=>{
        onError && onError(err);
    });
}
function $4a89f8875e643360$export$d84f34af2f3f5d9f({ variables: variables, query: query }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const client = (0, $iZuDo.useApolloClient)();
    // We're using `useDeepMemo` instead of `useCallback`/`useMemo` as it's very
    // likely that the `variables` dependency will change with each render even
    // though its contents will remain the same. Doing this stops us from
    // unnecessarily returning a new callback, as this could trigger unnecessary
    // rerenders or side-effects.
    return (0, $90pMD.useDeepMemo)(()=>(options)=>$4a89f8875e643360$export$2b602b4ab6fde7b6({
                ...options,
                variables: variables,
                query: query,
                client: client
            }), [
        client,
        variables,
        query
    ]);
}
function $4a89f8875e643360$export$5a178cf599565b50(data, listName, onError) {
    if (listName && data?.jira?.[listName]) {
        const _data = data.jira[listName];
        if (_data?.__typename === 'QueryError') {
            const queryError = new (0, $6gPph.QueryError)(_data);
            if (queryError.extensions?.find((ex)=>ex.statusCode === 401) && (0, $eI5EY.fg)('jira_list_add_401_error_handling')) throw new (0, $4X5wI.AuthenticationError)(_data.message);
            if (onError) {
                onError(_data);
                return undefined;
            }
            throw new (0, $6gPph.QueryError)(_data);
        }
        return _data;
    }
    return undefined;
}

});
parcelRegister("90pMD", function(module, exports) {

$parcel$export(module.exports, "useDeepMemo", () => $aa834e9231a22e71$export$722debc0e56fea39);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
const $aa834e9231a22e71$export$722debc0e56fea39 = (memoFn, deps)=>{
    const ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(ref.current.deps, deps)) ref.current = {
        value: memoFn(),
        deps: deps
    };
    return ref.current.value;
};

});

parcelRegister("6gPph", function(module, exports) {

$parcel$export(module.exports, "QueryError", () => $cba33ea5171f294f$export$83dcbdfe8cbc1e17);
const $cba33ea5171f294f$export$f215947b3d76a6b7 = 'QueryError';
class $cba33ea5171f294f$export$83dcbdfe8cbc1e17 extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.extensions = payload.extensions;
        this.message = payload.message ?? '';
        this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
    }
}

});


parcelRegister("dWGNJ", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $1e474dd65cc72606$export$518ba8e0e60f145f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $izafr = parcelRequire("izafr");
const $1e474dd65cc72606$export$518ba8e0e60f145f = ({ error: error, title: title, description: description })=>{
    if (!error) return null;
    if (error instanceof (0, $7byHA.ValidationError)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessage = error.message || error.errors && error.errors[0] && error.errors[0].error || description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
            flag: {
                type: 'warning',
                title: title,
                description: errorMessage,
                testId: (0, $1ybV0.ff)('relay-migration-issue-fields-number_q0em4') ? 'issue-error-flag.error-flag.warning' : undefined
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
        flag: {
            type: 'error',
            title: title,
            description: description,
            testId: (0, $1ybV0.ff)('relay-migration-issue-fields-number_q0em4') ? 'issue-error-flag.error-flag.error' : undefined
        }
    });
};

});
parcelRegister("izafr", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a);

var $gf6nQ = parcelRequire("gf6nQ");

var $5oIBC = parcelRequire("5oIBC");
const $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a = (0, $5oIBC.default)((0, $gf6nQ.default));

});
parcelRegister("gf6nQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eec4e9461c786a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
class $7eec4e9461c786a4$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $8vPhU.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});



parcelRegister("f8ADw", function(module, exports) {

$parcel$export(module.exports, "useListViewRecovery", () => $21ae3ba4f3dc3632$export$cedf3319fef1d036);
$parcel$export(module.exports, "useListViewIssues", () => $21ae3ba4f3dc3632$export$3c9c5774f09af6c0);

var $eUqFw = parcelRequire("eUqFw");

var $i3K0B = parcelRequire("i3K0B");

var $053h2 = parcelRequire("053h2");

var $iaCjO = parcelRequire("iaCjO");

var $4ZWyd = parcelRequire("4ZWyd");

var $12sJv = parcelRequire("12sJv");

var $aVwtE = parcelRequire("aVwtE");


var $ZvXTS = parcelRequire("ZvXTS");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");

var $pcT1W = parcelRequire("pcT1W");

var $7XECd = parcelRequire("7XECd");

var $fjqly = parcelRequire("fjqly");
const $21ae3ba4f3dc3632$export$cedf3319fef1d036 = (input, settings)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const variables = {
        ...(0, $i3K0B.getVariables)(input),
        cloudId: cloudId
    };
    return (0, $4ZWyd.useListRecovery)({
        settings: settings,
        queryList: (0, $7XECd.LIST_VIEW_QUERY),
        queryBackgroundList: (0, $7XECd.BACKGROUND_LIST_VIEW_QUERY),
        variables: variables,
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listRecoveryQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in background in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onBackgroundListError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listRecoveryBackgroundQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch more issues in background in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};
const $21ae3ba4f3dc3632$var$emptyArray = [];
const $21ae3ba4f3dc3632$export$3c9c5774f09af6c0 = ({ input: input, condition: condition = true, onComplete: onComplete })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [hasLoadingStarted, setHasLoadingStarted] = (0, $eUqFw.useState)(false);
    const cloudId = (0, $dWLk9.useCloudId)();
    const onNextPageLoaded = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'table endReached');
    }, [
        createAnalyticsEvent
    ]);
    const queryVariables = (0, $i3K0B.getVariables)(input);
    const { data: data, loadFirstPage: loadFirstPage, hasNextPage: hasNextPage, loading: loading, error: error, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage } = (0, $12sJv.useJqlPagination)({
        variables: {
            cloudId: cloudId,
            ...queryVariables
        },
        errorPolicy: (0, $eI5EY.fg)('jira_list_-_support_partial_failures') ? 'all' : 'none',
        query: (0, $7XECd.LIST_VIEW_QUERY),
        onCompleted: (responseData)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'listViewItemsQuery succeeded', {
                issuesCount: (0, $aVwtE.getAGGCompliantData)(responseData, 'list')?.edges?.length
            });
            (0, $ZvXTS.markViewMetric)('list', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
            if (onComplete) onComplete(responseData);
        },
        onError: (apolloError)=>{
            if (!(0, $pcT1W.shouldHandleTheError)(apolloError) && (0, $eI5EY.fg)('jira_list_-_support_partial_failures')) return;
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewItemsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in list view',
                    ...(0, $eI5EY.fg)('jira_list_partial_failures_instrumentation') ? (0, $053h2.getGraphqlErrorAttributes)(apolloError) : {}
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $ZvXTS.markViewMetric)('list', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
        },
        onPaginationError: (apolloError)=>{
            if (!(0, $pcT1W.shouldHandleTheError)(apolloError) && (0, $eI5EY.fg)('jira_list_-_support_partial_failures')) return;
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewPaginationQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch more issues in list view',
                    ...(0, $eI5EY.fg)('jira_list_partial_failures_instrumentation') ? (0, $053h2.getGraphqlErrorAttributes)(apolloError) : {}
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onNextPageLoaded: onNextPageLoaded
    });
    (0, $eUqFw.useEffect)(()=>{
        // only call once when condition === true
        if (!data && condition) {
            (0, $ZvXTS.markViewMetric)('list', (0, $78bb8734d7176028$export$23e322eb7c526958));
            loadFirstPage();
            setHasLoadingStarted(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        condition,
        data
    ]);
    const { sort: sort } = (0, $iaCjO.useSorter)();
    const _data = (0, $aVwtE.getAGGCompliantData)(data, 'list');
    const edges = _data?.edges || $21ae3ba4f3dc3632$var$emptyArray;
    const intl = (0, $5JgJ2.default)();
    const result = (0, $eUqFw.useMemo)(()=>{
        if (Array.isArray(edges) && edges.length === 0) return edges;
        const cacheVariables = {
            jql: queryVariables.jql,
            withConfluenceLinks: queryVariables.withConfluenceLinks,
            includeDoneItems: queryVariables.includeDoneItems,
            isParentFieldVisible: queryVariables.isParentFieldVisible,
            isDevSummaryFieldVisible: queryVariables.isDevSummaryFieldVisible
        };
        return sort(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $fjqly.transformResult)(edges, {
            cacheVariables: cacheVariables,
            intl: intl
        }));
    }, [
        edges,
        sort,
        queryVariables.jql,
        queryVariables.withConfluenceLinks,
        queryVariables.includeDoneItems,
        queryVariables.isParentFieldVisible,
        queryVariables.isDevSummaryFieldVisible,
        intl
    ]);
    return {
        data: result,
        // Make sure to return loading=true until items are loaded.
        loading: hasLoadingStarted ? loading : true,
        // return undefined to avoid showing the error flag in UI
        error: !(0, $pcT1W.shouldHandleTheError)(error) && (0, $eI5EY.fg)('jira_list_-_support_partial_failures') ? undefined : error,
        loadNextPage: loadNextPage,
        hasNextPage: hasNextPage,
        isLoadingNextPage: isLoadingNextPage
    };
};

});
parcelRegister("4ZWyd", function(module, exports) {

$parcel$export(module.exports, "useListRecovery", () => $e3f0f57f06398edd$export$c23bdcd09893983b);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $c4MRZ = parcelRequire("c4MRZ");

var $12sJv = parcelRequire("12sJv");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $aVwtE = parcelRequire("aVwtE");
const $e3f0f57f06398edd$var$getOperationName = (query)=>{
    const operation = (0, $c4MRZ.getOperationAST)(query, undefined);
    return operation && operation.name && operation.name.value || '';
};
const $e3f0f57f06398edd$export$c23bdcd09893983b = ({ settings: settings, queryList: queryList, queryBackgroundList: queryBackgroundList, variables: variables, onComplete: onComplete, onError: onError, onBackgroundListError: onBackgroundListError })=>{
    const analyticsTaskId = $e3f0f57f06398edd$var$getOperationName(queryBackgroundList);
    const analyticsTaskName = 'backgroundRefetch';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const [fetchListInBackground, { loading: loading, data: data }] = (0, $iZuDo.useLazyQuery)(queryBackgroundList, {
        fetchPolicy: 'network-only',
        onError: onError
    });
    const [hasStarted, setHasStarted] = (0, $eUqFw.useState)(false);
    const [hasFinished, setHasFinished] = (0, $eUqFw.useState)(false);
    const [refreshCount, setRefreshCount] = (0, $eUqFw.useState)(0);
    const [currentQuery, setCurrentQuery] = (0, $eUqFw.useState)();
    const listEndCursor = (0, $eUqFw.useRef)(undefined);
    const { next: next, hasNextPage: hasNextPage, endCursor: endCursor } = (0, $12sJv.useIssuePagination)({
        data: data,
        variables: variables,
        listName: 'list',
        onError: onBackgroundListError,
        query: queryBackgroundList
    });
    const prevEndCursor = (0, $hzcvF.usePreviousWithInitial)(endCursor);
    // abort background operations if a new query is provided
    (0, $eUqFw.useEffect)(()=>{
        if (!hasStarted || variables.jql === currentQuery) return;
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskAbort', {
            task: analyticsTaskName,
            taskId: analyticsTaskId,
            reason: 'query has changed'
        });
        setHasFinished(true);
        setHasStarted(false);
        setCurrentQuery(undefined);
    }, [
        analyticsTaskId,
        createAnalyticsEvent,
        currentQuery,
        hasStarted,
        variables.jql
    ]);
    // refetch all pages until the current endCursor: if we have 5 pages in total, list endCursor is on page 2,
    // then background refresh will pull first 2 pages only
    (0, $eUqFw.useEffect)(()=>{
        if (hasStarted && hasNextPage && // query pages one-by-one until we reach the current page
        endCursor !== listEndCursor.current && // query pages only when endCursor changes,
        // otherwise it might query the same page multiple times due to re-renders of useListRecovery
        endCursor !== prevEndCursor) next(endCursor);
    }, [
        hasStarted,
        hasNextPage,
        endCursor,
        next,
        prevEndCursor
    ]);
    // replace list items with backgroundList items so the main view will update
    (0, $eUqFw.useEffect)(()=>{
        if (hasStarted && !hasFinished && !loading && listEndCursor.current === endCursor) try {
            const getCachedData = (query, metaId)=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, $guiFP.default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: metaId,
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const backgroundListData = getCachedData(queryBackgroundList, 'getCachedBackgroundListData');
            const listData = getCachedData(queryList, 'getCachedListData');
            const backgroundList = (0, $aVwtE.getAGGCompliantData)(backgroundListData, 'list');
            const list = (0, $aVwtE.getAGGCompliantData)(listData, 'list');
            setRefreshCount(refreshCount + 1);
            setHasFinished(true);
            setHasStarted(false);
            setCurrentQuery(undefined);
            if (!backgroundList || !list || !listData || !Array.isArray(backgroundList.edges) || !Array.isArray(list.edges)) throw new Error('Conditions not met');
            client.writeQuery({
                query: queryList,
                variables: variables,
                data: {
                    ...listData,
                    jira: {
                        ...listData.jira,
                        list: {
                            ...backgroundList,
                            edges: backgroundList.edges
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskSuccess', {
                task: analyticsTaskName,
                taskId: analyticsTaskId,
                details: `${backgroundList.edges.length} items updated`
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            if ((0, $1ybV0.ff)('jwm.list.background-refetch-for-groups-and-children')) onComplete?.();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
                task: analyticsTaskName,
                taskId: analyticsTaskId,
                error: `Failed to refresh data in the background (${e.name || 'error'})`
            });
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'useIssueTypesAndFieldsCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(queryList),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        hasStarted,
        hasNextPage,
        endCursor,
        next,
        client,
        loading,
        hasFinished,
        refreshCount,
        queryList,
        queryBackgroundList,
        variables,
        createAnalyticsEvent,
        analyticsTaskId,
        listEndCursor,
        onComplete
    ]);
    const refreshList = (0, $eUqFw.useCallback)(()=>{
        if (hasStarted && !hasFinished || settings.isDisabled) return;
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: queryList,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'refreshList',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(queryList),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const listData = getCachedListData();
        const list = (0, $aVwtE.getAGGCompliantData)(listData ?? undefined, 'list');
        // store current list endCursor so that we know at what page to stop backgroundList fetching
        listEndCursor.current = list?.pageInfo?.endCursor;
        fetchListInBackground({
            variables: variables
        });
        setCurrentQuery(variables.jql);
        setHasStarted(true);
        setHasFinished(false);
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskStart', {
            task: analyticsTaskName,
            taskId: analyticsTaskId
        });
    }, [
        analyticsTaskId,
        client,
        createAnalyticsEvent,
        fetchListInBackground,
        hasFinished,
        hasStarted,
        queryList,
        settings.isDisabled,
        variables
    ]);
    const isRefreshing = hasStarted && !hasFinished;
    if (!(0, $1ybV0.ff)('jwm.list.background-refetch-for-groups-and-children')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $12sJv.useRefreshInterval)(refreshList, // it won't trigger a refresh if another has been triggered
    // it won't trigger refresh if the tab is invisible
    settings.isVisible && !isRefreshing, settings.updateInterval);
    return {
        isRefreshing: isRefreshing,
        refreshCount: refreshCount,
        refreshList: refreshList
    };
};

});
parcelRegister("c4MRZ", function(module, exports) {

$parcel$export(module.exports, "getOperationAST", () => $11510882f4ca1049$export$1f718485f6b6643f);

var $1c4hI = parcelRequire("1c4hI");
function $11510882f4ca1049$export$1f718485f6b6643f(documentAST, operationName) {
    var operation = null;
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var definition = _documentAST$definiti2[_i2];
        if (definition.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION) {
            var _definition$name;
            if (operationName == null) {
                // If no operation name was provided, only return an Operation if there
                // is one defined in the document. Upon encountering the second, return
                // null.
                if (operation) return null;
                operation = definition;
            } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) return definition;
        }
    }
    return operation;
}

});

parcelRegister("12sJv", function(module, exports) {

$parcel$export(module.exports, "useIssuePagination", () => $f9609ccfe0ed4e32$export$b49565a42289e6b);
$parcel$export(module.exports, "useJqlPagination", () => $f9609ccfe0ed4e32$export$9408824d9baedabc);
$parcel$export(module.exports, "useRefreshInterval", () => $f9609ccfe0ed4e32$export$7cfdc4e3bbeb1790);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $iZuDo = parcelRequire("iZuDo");

var $aVwtE = parcelRequire("aVwtE");
const $f9609ccfe0ed4e32$var$paginationOptionsForIssuesByJql = {
    uniqueId: 'issueId',
    filter: 'jql'
};
function $f9609ccfe0ed4e32$export$f80c710216eae131({ data: data, variables: variables, listName: listName, query: query, onError: onError, errorPolicy: errorPolicy = 'none', uniqueId: uniqueId, filter: filter }) {
    const [isLoadingNextPage, setIsLoadingNextPage] = (0, $eUqFw.useState)(false);
    const _data = data && (0, $aVwtE.getAGGCompliantData)(data, listName, onError);
    const hasNextPage = _data?.pageInfo?.hasNextPage || false;
    const endCursor = _data?.pageInfo?.endCursor || '';
    const fetchMore = (0, $aVwtE.useFetchMore)({
        query: query,
        variables: variables
    });
    /**
	 * creating a useRef for onError so that we don't regenerate the `next` function every time `onError` changes.
	 * - This will make the `next` reference to be more resistant to reference changes in case consumer inline the `onError` function
	 * - Moreover, `onError` is not affecting the data that we fetch, since it will be only called in in-need basis
	 * - Additionally in apollo repository, `onError` is also excluded from memoization list  (check the useQuery)
	 */ const onErrorRef = (0, $eUqFw.useRef)();
    onErrorRef.current = onError;
    const resetWhenChanged = filter ? variables[filter] : variables;
    (0, $eUqFw.useEffect)(()=>{
        // reset next page state
        setIsLoadingNextPage(false);
    }, [
        resetWhenChanged
    ]);
    const updateQueryAGGCompliant = (0, $eUqFw.useCallback)(// @ts-expect-error TS2345 - Argument of type '(prev: TData, { fetchMoreResult }: { fetchMoreResult?: TData | undefined; variables: TVariables; }) => TData | { jira: { [x: string]: any; }; }' is not assignable to parameter of type '(prev: TData, options: { fetchMoreResult?: TData | undefined; variables: TVariables; }) => TData'.
    (prev, { fetchMoreResult: fetchMoreResult })=>{
        setIsLoadingNextPage(false);
        if (!fetchMoreResult) return prev;
        const edges = [
            ...(0, $aVwtE.getAGGCompliantData)(prev, listName)?.edges || [],
            ...(0, $aVwtE.getAGGCompliantData)(fetchMoreResult, listName)?.edges || []
        ];
        return {
            jira: {
                ...fetchMoreResult.jira,
                [listName]: {
                    ...(0, $aVwtE.getAGGCompliantData)(fetchMoreResult, listName),
                    edges: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(edges, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    (edge)=>edge?.node && edge.node[uniqueId])
                }
            }
        };
    }, [
        setIsLoadingNextPage,
        listName,
        uniqueId
    ]);
    const next = (0, $eUqFw.useCallback)((after)=>{
        setIsLoadingNextPage(true);
        fetchMore({
            after: after,
            onError: onErrorRef.current,
            errorPolicy: errorPolicy,
            updateQuery: updateQueryAGGCompliant
        });
    }, [
        fetchMore,
        updateQueryAGGCompliant,
        errorPolicy
    ]);
    return {
        hasNextPage: hasNextPage,
        endCursor: endCursor,
        isLoadingNextPage: isLoadingNextPage,
        next: next
    };
}
const $f9609ccfe0ed4e32$export$b49565a42289e6b = (options)=>$f9609ccfe0ed4e32$export$f80c710216eae131({
        ...options,
        ...$f9609ccfe0ed4e32$var$paginationOptionsForIssuesByJql
    });
const $f9609ccfe0ed4e32$export$ea10f704343077db = ({ variables: variables, query: query, onCompleted: onCompleted, onError: onError, onPaginationError: onPaginationError, onNextPageLoaded: onNextPageLoaded, uniqueId: uniqueId, filter: filter, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none' })=>{
    const [inFlightPage, setInFlightPage] = (0, $eUqFw.useState)();
    const resetWhenChanged = filter ? variables[filter] : variables;
    (0, $eUqFw.useEffect)(()=>{
        // reset inflight track
        setInFlightPage(null);
    }, [
        resetWhenChanged
    ]);
    const [loadFirstPage, { data: data, loading: loading, error: error, refetch: refetch }] = (0, $iZuDo.useLazyQuery)(query, {
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy || 'network-only',
        onCompleted: onCompleted,
        onError: onError
    });
    if (data?.jira?.list?.__typename === 'QueryError') onError && onError(data?.jira?.list);
    const { next: next, hasNextPage: hasNextPage, endCursor: endCursor, isLoadingNextPage: isLoadingNextPage } = $f9609ccfe0ed4e32$export$f80c710216eae131({
        data: data,
        variables: variables,
        listName: 'list',
        onError: onPaginationError,
        errorPolicy: errorPolicy,
        query: query,
        uniqueId: uniqueId,
        filter: filter
    });
    const loadNextPage = (0, $eUqFw.useCallback)(()=>{
        /*
		 * Do not load the same page twice and do not load the next page if
		 * a request is already in progress.
		 */ if (!hasNextPage || endCursor === inFlightPage || loading) return;
        setInFlightPage(endCursor);
        next(endCursor);
        onNextPageLoaded && onNextPageLoaded();
    }, [
        endCursor,
        hasNextPage,
        inFlightPage,
        next,
        onNextPageLoaded,
        loading
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        loadFirstPage: loadFirstPage,
        hasNextPage: hasNextPage,
        isLoadingNextPage: isLoadingNextPage,
        loadNextPage: loadNextPage,
        refetch: refetch
    };
};
const $f9609ccfe0ed4e32$export$9408824d9baedabc = (options)=>$f9609ccfe0ed4e32$export$ea10f704343077db({
        ...options,
        ...$f9609ccfe0ed4e32$var$paginationOptionsForIssuesByJql
    });
const $f9609ccfe0ed4e32$export$7cfdc4e3bbeb1790 = (callback, condition, interval)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (interval == null) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const timer = setTimeout(()=>{
            if (condition) callback();
        }, interval * 1000);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        interval,
        callback,
        condition
    ]);
};

});


parcelRegister("pcT1W", function(module, exports) {

$parcel$export(module.exports, "shouldHandleTheError", () => $657d4c0c42a72428$export$47770c8b6d645cdb);
const $657d4c0c42a72428$var$IGNORED_ERRORS = [
    {
        errorType: 'ISSUE_UNAVAILABLE',
        statusCode: 404
    },
    {
        errorType: 'FIELD_VALUE_UNAVAILABLE',
        statusCode: 500
    },
    {
        errorType: 'DATA_FETCHER_THREW',
        statusCode: 500
    }
];
const $657d4c0c42a72428$export$47770c8b6d645cdb = (error)=>{
    if (error?.networkError) return true;
    const filterIssueUnavailableErrors = (graphQLError)=>!$657d4c0c42a72428$var$IGNORED_ERRORS.find((ignoredError)=>ignoredError.errorType === graphQLError?.extensions?.errorType && ignoredError.statusCode === graphQLError?.extensions?.statusCode);
    const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueUnavailableErrors);
    return errorsToShow.length > 0;
};

});

parcelRegister("fjqly", function(module, exports) {

$parcel$export(module.exports, "addChildToParentListView", () => $65b6ea7ab198376d$export$a79dcdc594f4a8c4);
$parcel$export(module.exports, "removeChildFromParentListView", () => $65b6ea7ab198376d$export$1ea2ddc4aab7921f);
$parcel$export(module.exports, "transformResult", () => $65b6ea7ab198376d$export$f13b29f9ed0c5a03);

var $jGcn0 = parcelRequire("jGcn0");

var $dHtvo = parcelRequire("dHtvo");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $6BYzZ = parcelRequire("6BYzZ");

var $f5yXM = parcelRequire("f5yXM");
const $65b6ea7ab198376d$export$a79dcdc594f4a8c4 = (parentIssue)=>({
        ...parentIssue,
        childSummary: {
            __typename: 'JiraWorkManagementChildSummary',
            hasChildren: true,
            totalCount: parentIssue.childSummary?.totalCount ? parentIssue.childSummary?.totalCount + 1 : 1
        }
    });
const $65b6ea7ab198376d$export$1ea2ddc4aab7921f = (parentIssue, childrenToRemove = 1)=>{
    const newCount = parentIssue.childSummary?.totalCount ? parentIssue.childSummary?.totalCount - childrenToRemove : 0;
    return {
        ...parentIssue,
        childSummary: {
            __typename: 'JiraWorkManagementChildSummary',
            hasChildren: newCount > 0,
            totalCount: newCount
        }
    };
};
const $65b6ea7ab198376d$var$createDateTimeFieldTransformer = ()=>(field)=>({
            [field.aliasFieldId || field.fieldId]: (field.dateTime && (0, $6BYzZ.DateOnly).fromDateAccordingToLocalTime(new Date(field.dateTime))) ?? null
        });
const $65b6ea7ab198376d$var$createDateFieldTransformer = ()=>(field)=>({
            [field.aliasFieldId || field.fieldId]: (field.date && (0, $6BYzZ.toDateOnly)(field.date)) ?? null
        });
const $65b6ea7ab198376d$var$atlassianAccountUserTransformer = (user)=>({
        accountId: user.accountId,
        avatarUrl: user.picture,
        displayName: user.name
    });
const $65b6ea7ab198376d$var$createJiraSingleSelectUserPickeTransformer = ()=>(field)=>field.user && {
            [field.aliasFieldId || field.fieldId]: $65b6ea7ab198376d$var$atlassianAccountUserTransformer(field.user)
        } || null;
const $65b6ea7ab198376d$var$createJiraSingleLineTextTransformer = (fieldId)=>(field)=>({
            [fieldId || field.aliasFieldId || field.fieldId]: field.text
        });
const $65b6ea7ab198376d$var$createJiraLabelsTransformer = ()=>(field)=>({
            [field.aliasFieldId || field.fieldId]: field.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name) || []
        });
const $65b6ea7ab198376d$var$topLevelFieldTransformers = {
    [(0, $lO4Or.ISSUE_KEY_TYPE)]: $65b6ea7ab198376d$var$createJiraSingleLineTextTransformer('key'),
    [(0, $lO4Or.ISSUE_TYPE)]: (field)=>({
            issuetype: {
                iconUrl: field.issueType?.avatar?.medium,
                id: field.issueType?.issueTypeId,
                name: field.issueType?.name,
                level: field.issueType?.hierarchy?.level
            }
        }),
    [(0, $lO4Or.SUMMARY_TYPE)]: $65b6ea7ab198376d$var$createJiraSingleLineTextTransformer(),
    [(0, $lO4Or.STATUS_TYPE)]: (field)=>({
            status: {
                id: field.status.statusId,
                name: field.status.name,
                categoryId: field.status.statusCategory?.statusCategoryId
            }
        }),
    [(0, $jGcn0.START_DATE_ALIAS_FIELD_ID)]: $65b6ea7ab198376d$var$createDateFieldTransformer(),
    [(0, $lO4Or.DUE_DATE_TYPE)]: $65b6ea7ab198376d$var$createDateFieldTransformer(),
    [(0, $lO4Or.UPDATED)]: $65b6ea7ab198376d$var$createDateTimeFieldTransformer(),
    [(0, $lO4Or.CREATED)]: $65b6ea7ab198376d$var$createDateTimeFieldTransformer(),
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $65b6ea7ab198376d$var$createJiraSingleSelectUserPickeTransformer(),
    [(0, $lO4Or.PRIORITY_TYPE)]: (field)=>({
            priority: (field.priority && {
                id: field.priority.id,
                name: field.priority.name,
                iconUrl: field.priority.iconUrl
            }) ?? null
        }),
    [(0, $lO4Or.LABELS_TYPE)]: $65b6ea7ab198376d$var$createJiraLabelsTransformer(),
    [(0, $lO4Or.RANK_CF_TYPE)]: $65b6ea7ab198376d$var$createJiraSingleLineTextTransformer(),
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: (field)=>({
            timeoriginalestimate: field.originalEstimate?.timeInSeconds ?? null
        })
};
const $65b6ea7ab198376d$var$getTopLevelField = (field)=>{
    const transformer = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $65b6ea7ab198376d$var$topLevelFieldTransformers[field.type];
    if (transformer) // @ts-expect-error - TS2345 - Type &#39;JWMListViewItems_jira_list_JiraWorkManagementViewItemConnection_edges_node_fields_JiraColorField&#39; is not assignable to type &#39;never&#39;
    return transformer(field);
    return null;
};
const $65b6ea7ab198376d$export$f13b29f9ed0c5a03 = (edges, options)=>{
    if (edges) return edges.filter((edge)=>{
        if ((0, $eI5EY.fg)('jira_list_-_support_partial_failures')) return Array.isArray(edge?.node?.fields);
        return edge?.node;
    }).map((edge)=>{
        const { id: id, fields: fields, issueId: issueId, childSummary: childSummary, legacyConfluenceLinks: legacyConfluenceLinks, commentSummary: commentSummary } = edge.node;
        const listViewIssue = {
            id: id,
            issueId: issueId,
            childSummary: {
                totalCount: childSummary?.totalCount,
                hasChildren: childSummary?.hasChildren ?? false
            },
            cacheVariables: options.cacheVariables,
            fields: (0, $f5yXM.listViewTransformFields)(fields, options.intl),
            confluenceLinks: legacyConfluenceLinks ?? undefined,
            commentSummary: {
                totalCount: commentSummary?.totalCount
            },
            ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? (0, $dHtvo.transformTopLevelFields)(edge?.node) : {}
        };
        fields?.forEach((field)=>{
            if (field != null) {
                const fieldValues = $65b6ea7ab198376d$var$getTopLevelField(field);
                Object.assign(listViewIssue, fieldValues);
            }
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return listViewIssue;
    });
    return [];
};

});
parcelRegister("dHtvo", function(module, exports) {

$parcel$export(module.exports, "transformField", () => $437837b35cd3faec$export$fbce423ada1f57a0);
$parcel$export(module.exports, "isTransformFieldSupported", () => $437837b35cd3faec$export$d3f2873cf2713a58);
$parcel$export(module.exports, "transformTopLevelFields", () => $437837b35cd3faec$export$82a9f94774eb7857);

var $5iWql = parcelRequire("5iWql");


var $kDvxN = parcelRequire("kDvxN");

var $1MCx2 = parcelRequire("1MCx2");

var $edHli = parcelRequire("edHli");

var $6Vgvs = parcelRequire("6Vgvs");

var $60igd = parcelRequire("60igd");

var $jH0qI = parcelRequire("jH0qI");

var $aCOZQ = parcelRequire("aCOZQ");

var $l7QbV = parcelRequire("l7QbV");

var $965Lk = parcelRequire("965Lk");

var $7BmGU = parcelRequire("7BmGU");

var $ehKZQ = parcelRequire("ehKZQ");

var $1eTr0 = parcelRequire("1eTr0");
// Used for list view controller when transforming Gira response
const $437837b35cd3faec$var$createSupportedTransformations = (0, $5iWql.default)(()=>({
        ...(0, $1eTr0.transformVersionField)(),
        ...(0, $jH0qI.transformParentField)(),
        ...(0, $ehKZQ.transformTeamField)(),
        ...(0, $1MCx2.transformGoalsField)(),
        ...(0, $965Lk.transformResolutionField)(),
        ...(0, $60igd.transformGroupField)(),
        ...(0, $l7QbV.transformRadioSelectField)(),
        ...(0, $7BmGU.transformStatusCategoryField)(),
        ...(0, $aCOZQ.transformProjectField)(),
        ...(0, $6Vgvs.transformCascadingSelectField)()
    }));
const $437837b35cd3faec$var$isValidTypename = (typename)=>true;
const $437837b35cd3faec$export$66480ae6e701514d = (field)=>true;
const $437837b35cd3faec$export$fbce423ada1f57a0 = (field, intl)=>{
    const supportedTransformations = $437837b35cd3faec$var$createSupportedTransformations();
    if (field == null) return null;
    const typename = field.__typename;
    if (!$437837b35cd3faec$var$isValidTypename(typename)) return null;
    const transform = supportedTransformations[typename];
    if (transform == null) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return transform(field, intl);
};
const $437837b35cd3faec$export$d3f2873cf2713a58 = (field)=>{
    const supportedTransformations = $437837b35cd3faec$var$createSupportedTransformations();
    if (!(0, $edHli.isJiraBusinessFields)(field)) return false;
    if (!$437837b35cd3faec$var$isValidTypename(field.__typename)) return false;
    return supportedTransformations[field.__typename] != null;
};
const $437837b35cd3faec$export$82a9f94774eb7857 = (issueNode)=>issueNode ? {
        [(0, $c12b99091b418650$export$72b5bd2391f1e7c0)]: (0, $kDvxN.transformDevSummaryField)(issueNode.devSummaryCache)
    } : {};

});
const $c12b99091b418650$export$72b5bd2391f1e7c0 = 'devSummary';

parcelRegister("kDvxN", function(module, exports) {

$parcel$export(module.exports, "transformDevSummaryField", () => $92fef3395c7adfcf$export$2093d68e8a6114b5);
const $92fef3395c7adfcf$var$hasPullRequest = (field)=>Number(field?.devSummary?.pullrequest?.overall?.count) > 0;
const $92fef3395c7adfcf$var$isUnderReview = (field)=>$92fef3395c7adfcf$var$hasPullRequest(field) && field?.devSummary?.pullrequest?.overall?.state === 'OPEN';
const $92fef3395c7adfcf$var$isMerged = (field)=>$92fef3395c7adfcf$var$hasPullRequest(field) && field?.devSummary?.pullrequest?.overall?.state === 'MERGED';
const $92fef3395c7adfcf$export$2093d68e8a6114b5 = (field)=>field ? {
        pullRequestsCount: Number(field?.devSummary?.pullrequest?.overall?.count),
        isUnderReview: $92fef3395c7adfcf$var$isUnderReview(field),
        isMerged: $92fef3395c7adfcf$var$isMerged(field),
        commitCount: Number(field?.devSummary?.commit?.overall?.count)
    } : null;

});

parcelRegister("1MCx2", function(module, exports) {

$parcel$export(module.exports, "transformGoalsField", () => $53a4fecceff51526$export$c34241865478278);

var $lO4Or = parcelRequire("lO4Or");

const $53a4fecceff51526$export$c34241865478278 = ()=>({
        [(0, $72b28c0dfc5355e0$export$aac6761ddd37ded5)]: (field)=>{
            if (field.__typename !== (0, $72b28c0dfc5355e0$export$aac6761ddd37ded5)) return null;
            return {
                type: (0, $lO4Or.GOALS_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                isEditable: !!field.fieldConfig?.isEditable,
                value: {
                    goals: field.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                            id: edge?.node?.id || '',
                            name: edge?.node?.name || '',
                            status: edge?.node?.status || null
                        })) || [],
                    totalCount: field.selectedGoals?.totalCount || 0
                }
            };
        }
    });

});
const $72b28c0dfc5355e0$export$aac6761ddd37ded5 = 'JiraGoalsField';


parcelRegister("edHli", function(module, exports) {

$parcel$export(module.exports, "isJiraBusinessFields", () => $58b3a50c72d1bd9f$export$257745f9c8865601);
const $58b3a50c72d1bd9f$export$257745f9c8865601 = (_)=>true;

});

parcelRegister("6Vgvs", function(module, exports) {

$parcel$export(module.exports, "transformCascadingSelectField", () => $37f6a251e511afcf$export$b5257861e8de13fa);

var $2rn3r = parcelRequire("2rn3r");

var $lO4Or = parcelRequire("lO4Or");

const $37f6a251e511afcf$export$b5257861e8de13fa = ()=>({
        [(0, $125a7921ac42bc2d$export$c5c9bcd04d3610df)]: (field)=>{
            if (field.__typename !== (0, $125a7921ac42bc2d$export$c5c9bcd04d3610df)) return null;
            return {
                type: (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
                id: field.id,
                fieldId: field.fieldId,
                value: field.cascadingOption && field.cascadingOption.parentValue ? {
                    parentOptionValue: {
                        id: field.cascadingOption.parentValue.id,
                        optionId: (0, $2rn3r.JiraIssueFieldOptionAri).parse(field.cascadingOption.parentValue.id).optionId,
                        value: field.cascadingOption.parentValue.value,
                        isDisabled: field.cascadingOption.parentValue.isDisabled
                    },
                    ...field.cascadingOption.childOptionValue ? {
                        childOptionValue: {
                            id: field.cascadingOption.childOptionValue.id,
                            optionId: field.cascadingOption.childOptionValue.optionId,
                            value: field.cascadingOption.childOptionValue.value,
                            isDisabled: field.cascadingOption.childOptionValue.isDisabled
                        }
                    } : {}
                } : null
            };
        }
    });

});
parcelRegister("2rn3r", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $396674cae5287926$export$e3bc1ec22f941fbe);

var $7HlAi = parcelRequire("7HlAi");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issue-field-option/manifest.ts
var $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $7HlAi.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $7HlAi.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $396674cae5287926$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("7HlAi", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $5632bebec8ddd527$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $5632bebec8ddd527$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $5632bebec8ddd527$export$eb4f4cf0880fe5a8 = "jira", $5632bebec8ddd527$export$4bec333360908e78 = "issue-field-option";

});


const $125a7921ac42bc2d$export$c5c9bcd04d3610df = 'JiraCascadingSelectField';


parcelRegister("60igd", function(module, exports) {

$parcel$export(module.exports, "transformGroupField", () => $5e6be5474ec79100$export$5090c8e3ce3e3e36);

var $lO4Or = parcelRequire("lO4Or");

const $5e6be5474ec79100$export$5090c8e3ce3e3e36 = ()=>({
        [(0, $2aba7ed23bc6b18c$export$e67f77aeba6db6c8)]: (field)=>{
            if (field.__typename !== (0, $2aba7ed23bc6b18c$export$e67f77aeba6db6c8)) return null;
            return {
                type: (0, $lO4Or.GROUP_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.selectedGroup ? {
                    id: field.selectedGroup.id,
                    groupId: field.selectedGroup.groupId,
                    name: field.selectedGroup.name ?? ''
                } : null
            };
        },
        [(0, $2aba7ed23bc6b18c$export$bf73c80438672453)]: (field)=>{
            if (field.__typename !== (0, $2aba7ed23bc6b18c$export$bf73c80438672453)) return null;
            return {
                type: (0, $lO4Or.MULTI_GROUP_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.selectedGroupsConnection?.edges?.map?.((edge)=>edge?.node != null ? {
                        id: edge.node.id,
                        groupId: edge.node.groupId,
                        name: edge.node.name ?? ''
                    } : null).filter(Boolean) ?? null
            };
        }
    });

});
const $2aba7ed23bc6b18c$export$e67f77aeba6db6c8 = 'JiraSingleGroupPickerField';
const $2aba7ed23bc6b18c$export$bf73c80438672453 = 'JiraMultipleGroupPickerField';


parcelRegister("jH0qI", function(module, exports) {

$parcel$export(module.exports, "transformParentField", () => $b9a24253f43185e7$export$9154eb05be84db49);

var $lO4Or = parcelRequire("lO4Or");

var $3uSNh = parcelRequire("3uSNh");

const $b9a24253f43185e7$export$9154eb05be84db49 = ()=>({
        [(0, $715a232380f49eb2$export$89cbdbc2fa7a3b27)]: (field)=>{
            if (field.__typename !== (0, $715a232380f49eb2$export$89cbdbc2fa7a3b27)) return null;
            let fields = {};
            if (Array.isArray(field.parentIssue?.fields)) {
                const issueType = (0, $3uSNh.safeGetValue)(field.parentIssue.fields, 'issuetype', 'issueType', null);
                const color = (0, $3uSNh.safeGetValue)(field.parentIssue.fields, 'issuecolor', 'color.colorKey', null);
                fields = {
                    summary: (0, $3uSNh.safeGetValue)(field.parentIssue.fields, 'summary', 'text', null),
                    statusCategoryId: (0, $3uSNh.safeGetValue)(field.parentIssue?.fields, 'status', 'status.statusCategory.statusCategoryId', null),
                    issueType: issueType ? {
                        name: issueType.name,
                        iconUrl: issueType.avatar?.medium
                    } : null,
                    color: color != null ? color.toUpperCase() : null
                };
            }
            if (Array.isArray(field.parentIssue?.rankField)) {
                const rank = (0, $3uSNh.safeGetValue)(field.parentIssue?.rankField, 'rank', 'text', null);
                fields = {
                    ...fields,
                    rank: rank ?? null
                };
            }
            return {
                type: (0, $lO4Or.PARENT_TYPE),
                fieldId: field.fieldId,
                value: field.parentIssue ? {
                    id: field.parentIssue?.id,
                    issueId: field.parentIssue?.issueId,
                    issueKey: field.parentIssue?.key,
                    ...fields
                } : null
            };
        }
    });

});
const $715a232380f49eb2$export$89cbdbc2fa7a3b27 = 'JiraParentIssueField';


parcelRegister("aCOZQ", function(module, exports) {

$parcel$export(module.exports, "transformProjectField", () => $5dbde54d59224ed6$export$1fd74e5690ffdae3);

var $79xbN = parcelRequire("79xbN");

var $lO4Or = parcelRequire("lO4Or");

const $5dbde54d59224ed6$export$1fd74e5690ffdae3 = ()=>({
        [(0, $286c7e8b25ae1c0d$export$32cecd77017de859)]: (field)=>{
            if (field.__typename !== (0, $286c7e8b25ae1c0d$export$32cecd77017de859)) return null;
            return {
                type: (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.project ? {
                    id: field.project.id,
                    name: field.project.name ?? '',
                    key: field.project.key ?? '',
                    avatarUrls: {
                        '48x48': field.project.avatar?.large ?? ''
                    },
                    projectId: (0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? field.project.projectId : undefined
                } : null
            };
        }
    });

});
const $286c7e8b25ae1c0d$export$32cecd77017de859 = 'JiraProjectField';


parcelRegister("l7QbV", function(module, exports) {

$parcel$export(module.exports, "transformRadioSelectField", () => $83f5b0b9b02fe828$export$ee3d5244f5f85b47);

var $lO4Or = parcelRequire("lO4Or");

const $83f5b0b9b02fe828$export$ee3d5244f5f85b47 = ()=>({
        [(0, $f96a5fe14aa86356$export$561e8c47e4fa1c1b)]: (field)=>{
            if (field.__typename !== (0, $f96a5fe14aa86356$export$561e8c47e4fa1c1b)) return null;
            return {
                type: (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                isEditable: !!field.fieldConfig?.isEditable,
                value: field.selectedOption ? {
                    id: field.selectedOption.optionId,
                    value: field.selectedOption.value ?? ''
                } : null
            };
        }
    });

});
const $f96a5fe14aa86356$export$561e8c47e4fa1c1b = 'JiraRadioSelectField';


parcelRegister("965Lk", function(module, exports) {

$parcel$export(module.exports, "transformResolutionField", () => $39b8d4431c014535$export$3441c85b045ddb32);

var $lO4Or = parcelRequire("lO4Or");

const $39b8d4431c014535$export$3441c85b045ddb32 = ()=>({
        [(0, $1db008f6a8fd416a$export$a7bcc074cfedc376)]: (field)=>{
            if (field.__typename !== (0, $1db008f6a8fd416a$export$a7bcc074cfedc376)) return null;
            return {
                type: (0, $lO4Or.RESOLUTION_TYPE),
                fieldId: field.fieldId,
                value: field.resolution ? {
                    id: field.resolution.id,
                    name: field.resolution.name ?? ''
                } : null
            };
        }
    });

});
const $1db008f6a8fd416a$export$a7bcc074cfedc376 = 'JiraResolutionField';


parcelRegister("7BmGU", function(module, exports) {

$parcel$export(module.exports, "transformStatusCategoryField", () => $517adf1afdcfab8e$export$daffdd43f256def6);

var $lO4Or = parcelRequire("lO4Or");

const $517adf1afdcfab8e$export$daffdd43f256def6 = ()=>({
        [(0, $00385361dcdfb8da$export$aa464b56f1076111)]: (field)=>{
            if (field.__typename !== (0, $00385361dcdfb8da$export$aa464b56f1076111)) return null;
            return {
                type: (0, $lO4Or.STATUS_CATEGORY_TYPE),
                fieldId: field.fieldId,
                value: field.statusCategory ? {
                    statusCategoryId: field.statusCategory.statusCategoryId,
                    name: field.statusCategory.name ?? ''
                } : null
            };
        }
    });

});
const $00385361dcdfb8da$export$aa464b56f1076111 = 'JiraStatusCategoryField';


parcelRegister("ehKZQ", function(module, exports) {

$parcel$export(module.exports, "transformTeamField", () => $7a263e99d93ab108$export$c924eaa42d1ef062);

var $lO4Or = parcelRequire("lO4Or");

const $7a263e99d93ab108$export$c924eaa42d1ef062 = ()=>({
        [(0, $51d4762401af983e$export$4b2dddaf094af935)]: (field)=>{
            if (field.__typename !== (0, $51d4762401af983e$export$4b2dddaf094af935)) return null;
            return {
                type: (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
                fieldId: field.fieldId,
                value: field.selectedTeam ? {
                    id: field.selectedTeam.jiraSuppliedTeamId,
                    name: field.selectedTeam.jiraSuppliedName ?? ''
                } : null
            };
        }
    });

});
const $51d4762401af983e$export$4b2dddaf094af935 = 'JiraTeamViewField';


parcelRegister("1eTr0", function(module, exports) {

$parcel$export(module.exports, "transformVersionField", () => $8a6c7a131969f81d$export$7beb4bd99d0c30b);

var $lO4Or = parcelRequire("lO4Or");

const $8a6c7a131969f81d$export$7beb4bd99d0c30b = ()=>({
        [(0, $fba37de157c6d93d$export$7d00c90aa4f1f657)]: (field)=>{
            if (field.__typename !== (0, $fba37de157c6d93d$export$7d00c90aa4f1f657)) return null;
            return {
                type: (0, $lO4Or.VERSION_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.version ? {
                    id: field.version.versionId,
                    name: field.version.name ?? ''
                } : null
            };
        },
        [(0, $fba37de157c6d93d$export$f240ecd334700f48)]: (field)=>{
            if (field.__typename !== (0, $fba37de157c6d93d$export$f240ecd334700f48)) return null;
            return {
                type: (0, $lO4Or.MULTI_VERSION_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.selectedVersionsConnection?.edges?.map?.((edge)=>edge?.node != null ? {
                        id: edge?.node.versionId,
                        name: edge?.node.name ?? ''
                    } : null).filter((version)=>version != null) ?? null
            };
        }
    });

});
const $fba37de157c6d93d$export$7d00c90aa4f1f657 = 'JiraSingleVersionPickerField';
const $fba37de157c6d93d$export$f240ecd334700f48 = 'JiraMultipleVersionPickerField';



parcelRegister("6BYzZ", function(module, exports) {

$parcel$export(module.exports, "DateOnly", () => $5d1ef987232e205a$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $5d1ef987232e205a$export$b0961ad8aee63b8b);
const $5d1ef987232e205a$export$9cda9b56d134780f = 'Invalid date or date format';
const $5d1ef987232e205a$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $5d1ef987232e205a$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $5d1ef987232e205a$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $5d1ef987232e205a$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $5d1ef987232e205a$var$isLeapYear(year) ? 29 : $5d1ef987232e205a$var$daysInMonth[month - 1])) return false;
    return true;
};
const $5d1ef987232e205a$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $5d1ef987232e205a$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $5d1ef987232e205a$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $5d1ef987232e205a$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $5d1ef987232e205a$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($5d1ef987232e205a$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $5d1ef987232e205a$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $5d1ef987232e205a$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $5d1ef987232e205a$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$5d1ef987232e205a$var$isDateValid(year, month, day)) throw new Error($5d1ef987232e205a$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $5d1ef987232e205a$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $5d1ef987232e205a$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $5d1ef987232e205a$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $5d1ef987232e205a$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});

parcelRegister("f5yXM", function(module, exports) {

$parcel$export(module.exports, "listViewTransformFields", () => $2e7db4abed8c4eed$export$34af57b660300007);

var $dHtvo = parcelRequire("dHtvo");

var $h9cCP = parcelRequire("h9cCP");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $7v0hO = parcelRequire("7v0hO");

var $gDg11 = parcelRequire("gDg11");
const $2e7db4abed8c4eed$var$transformTimeTracking = (originalEstimate, timeTrackingOptions, intl)=>{
    if (originalEstimate) return {
        timeInSeconds: Number(originalEstimate.timeInSeconds) || undefined,
        timeAsString: (0, $7v0hO.timeTrackingFormatter)(Number(originalEstimate.timeInSeconds), {
            ...timeTrackingOptions,
            timeFormat: (0, $gDg11.timeFormatMap).get(timeTrackingOptions.timeFormat) || (0, $h9cCP.PRETTY)
        }, intl)
    };
    return null;
};
const $2e7db4abed8c4eed$var$transformUser = (user)=>{
    if (user) return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        accountId: user.accountId,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        name: user.name,
        picture: user.picture ?? ''
    };
    return null;
};
const $2e7db4abed8c4eed$var$transformUsers = (users)=>{
    if (users) return users.map((user)=>$2e7db4abed8c4eed$var$transformUser(user?.node));
    return null;
};
const $2e7db4abed8c4eed$var$transformSelectField = (selectedOption)=>{
    if (selectedOption) return {
        optionId: String(selectedOption.optionId),
        value: selectedOption.value,
        ...selectedOption.color ? {
            color: selectedOption.color?.colorKey
        } : {}
    };
    return null;
};
const $2e7db4abed8c4eed$export$d4a0295c1cbaac03 = (selectedOptions)=>{
    if (selectedOptions) return selectedOptions.map((option)=>option?.node?.optionId && option?.node?.value ? $2e7db4abed8c4eed$var$transformSelectField(option.node) : null).filter((option)=>option !== null);
    return null;
};
const $2e7db4abed8c4eed$export$c072126708d93f04 = (labels)=>{
    if (labels) return labels.map((label)=>label?.node?.name ?? null).filter((label)=>label !== null);
    return null;
};
const $2e7db4abed8c4eed$var$transformSprint = (sprints)=>{
    if (sprints) return sprints.map((sprint)=>sprint?.node ?? null).filter((sprint)=>sprint !== null);
    return null;
};
const $2e7db4abed8c4eed$export$b5df62b8f5dea4f9 = (componentValues)=>{
    if (componentValues?.length) return componentValues.map((componentValue)=>componentValue?.node?.componentId ? {
            componentId: componentValue.node?.componentId ?? '',
            name: componentValue.node?.name ?? null
        } : null).filter((componentValue)=>componentValue !== null);
    return null;
};
const $2e7db4abed8c4eed$var$transformParent = (parentIssue)=>{
    if (parentIssue) return {
        issueId: parentIssue.issueId,
        issueKey: parentIssue.key
    };
    return null;
};
const $2e7db4abed8c4eed$var$listFieldTransformers = {
    JiraIssueTypeField: (field)=>{
        if (field.__typename !== 'JiraIssueTypeField') return null;
        return {
            type: (0, $lO4Or.ISSUE_TYPE),
            fieldId: field.fieldId,
            value: field.issueType?.name ?? null,
            level: field.issueType?.hierarchy?.level,
            issueTypeId: (0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? field.issueType?.issueTypeId : undefined
        };
    },
    JiraSingleLineTextField: (field)=>{
        if (field.__typename !== 'JiraSingleLineTextField') return null;
        return {
            type: field.type === 'issuekey' ? 'key' : field.type,
            fieldId: field.fieldId,
            value: field.text
        };
    },
    JiraUrlField: (field)=>{
        if (field.__typename !== 'JiraUrlField') return null;
        return {
            type: (0, $lO4Or.URL_CF_TYPE),
            fieldId: field.fieldId,
            value: field.uri
        };
    },
    JiraRichTextField: (field)=>{
        if (field.__typename !== 'JiraRichTextField') return null;
        const value = field.richText?.adfValue?.json;
        return {
            type: (0, $lO4Or.TEXT_AREA_CF_TYPE),
            fieldId: field.fieldId,
            value: value ? JSON.stringify(value) : ''
        };
    },
    JiraStatusField: (field)=>{
        if (field.__typename !== 'JiraStatusField') return null;
        return {
            type: (0, $lO4Or.STATUS_TYPE),
            fieldId: field.fieldId,
            name: field.status?.name,
            value: Number(field.status?.statusCategory?.statusCategoryId) ? Number(field.status?.statusCategory?.statusCategoryId) : null
        };
    },
    JiraSingleSelectUserPickerField: (field)=>{
        if (field.__typename !== 'JiraSingleSelectUserPickerField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformUser(field.user)
        };
    },
    JiraLabelsField: (field)=>{
        if (field.__typename !== 'JiraLabelsField') return null;
        return {
            type: field.fieldId === 'labels' ? (0, $lO4Or.LABELS_TYPE) : (0, $lO4Or.LABELS_CF_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$export$c072126708d93f04(field.selectedLabelsConnection?.edges ?? null)
        };
    },
    JiraPriorityField: (field)=>{
        if (field.__typename !== 'JiraPriorityField') return null;
        if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) return {
            type: (0, $lO4Or.PRIORITY_TYPE),
            fieldId: field.fieldId,
            value: field.priority ? {
                name: field.priority.name,
                priorityId: field.priority.priorityId,
                iconUrl: field.priority.iconUrl
            } : null
        };
        return {
            type: (0, $lO4Or.PRIORITY_TYPE),
            fieldId: field.fieldId,
            value: field.priority?.name ?? null,
            priorityId: field.priority?.priorityId ?? null
        };
    },
    JiraDateTimePickerField: (field)=>{
        if (field.__typename !== 'JiraDateTimePickerField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: field.dateTime
        };
    },
    JiraMultipleSelectField: (field)=>{
        if (field.__typename !== 'JiraMultipleSelectField') return null;
        return {
            type: (0, $lO4Or.MULTI_SELECT_CF_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$export$d4a0295c1cbaac03(field.selectedOptions?.edges ?? null)
        };
    },
    JiraSingleSelectField: (field)=>{
        if (field.__typename !== 'JiraSingleSelectField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformSelectField(field.fieldOption) ?? null
        };
    },
    // Use the timetracking field to map to the timeoriginalestimate field rather than directly using
    // timeoriginalestimate because timetracking returns data needed to determine the timeAsString.
    // Logic to request for the timetracking field data if timeoriginalestimate is in list view is in
    // `getQueryFieldIds` in src/packages/business/list/src/controllers/get-issue-fields/index.tsx
    JiraTimeTrackingField: (field, intl)=>{
        if (field.__typename !== 'JiraTimeTrackingField' || field.originalEstimate?.timeInSeconds == null || field.timeTrackingSettings?.workingHoursPerDay == null || field.timeTrackingSettings?.workingDaysPerWeek == null || field.timeTrackingSettings?.defaultUnit == null || intl == null) {
            if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) return {
                type: (0, $lO4Or.TIME_ESTIMATE_TYPE),
                fieldId: 'timeoriginalestimate',
                value: null
            };
            return null;
        }
        const { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: timeFormat, defaultUnit: defaultUnit } = field.timeTrackingSettings;
        return {
            type: (0, $lO4Or.TIME_ESTIMATE_TYPE),
            fieldId: 'timeoriginalestimate',
            value: $2e7db4abed8c4eed$var$transformTimeTracking(field.originalEstimate, {
                workingHoursPerDay: workingHoursPerDay,
                workingDaysPerWeek: workingDaysPerWeek,
                timeFormat: timeFormat || (0, $h9cCP.PRETTY),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                defaultUnit: defaultUnit
            }, intl)
        };
    },
    JiraDatePickerField: (field)=>{
        if (field.__typename !== 'JiraDatePickerField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: field.date
        };
    },
    JiraNumberField: (field)=>{
        if (field.__typename !== 'JiraNumberField') return null;
        return {
            type: field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE) || field.type === (0, $lO4Or.STORY_POINTS_TYPE) ? field.type : (0, $lO4Or.NUMBER_CF_TYPE),
            fieldId: field.fieldId,
            value: field.number
        };
    },
    JiraMultipleSelectUserPickerField: (field)=>{
        if (field.__typename !== 'JiraMultipleSelectUserPickerField') return null;
        return {
            type: (0, $lO4Or.MULTI_USER_CF_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformUsers(field.selectedUsersConnection?.edges ?? null)
        };
    },
    JiraPeopleField: (field)=>{
        if (field.__typename !== 'JiraPeopleField') return null;
        return {
            type: (0, $lO4Or.PEOPLE_CF_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformUsers(field.selectedUsersConnection?.edges ?? null)
        };
    },
    JiraComponentsField: (field)=>{
        if (field.__typename !== 'JiraComponentsField') return null;
        return {
            type: (0, $lO4Or.COMPONENTS_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$export$b5df62b8f5dea4f9(field.selectedComponentsConnection?.edges ?? null)
        };
    },
    JiraParentIssueField: (field)=>{
        if (field.__typename !== 'JiraParentIssueField') return null;
        return {
            type: (0, $lO4Or.PARENT_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformParent(field.parentIssue)
        };
    },
    JiraCheckboxesField: (field)=>{
        if (field.__typename !== 'JiraCheckboxesField') return null;
        return {
            type: (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$export$d4a0295c1cbaac03(field.selectedOptions?.edges ?? null)
        };
    },
    JiraSprintField: (field)=>{
        if (field.__typename !== 'JiraSprintField') return null;
        return {
            type: (0, $lO4Or.SPRINT_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformSprint(field.selectedSprintsConnection?.edges ?? null)
        };
    }
};
const $2e7db4abed8c4eed$var$listViewTransformField = (field, intl)=>{
    if (field == null) return null;
    if ((0, $dHtvo.isTransformFieldSupported)(field) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return (0, $dHtvo.transformField)(field, intl);
    if (field.__typename in $2e7db4abed8c4eed$var$listFieldTransformers) return $2e7db4abed8c4eed$var$listFieldTransformers[field.__typename](field, intl);
    return null;
};
const $2e7db4abed8c4eed$export$34af57b660300007 = (fields, intl)=>{
    const toReturn = [];
    fields?.forEach((field)=>{
        const transformedField = $2e7db4abed8c4eed$var$listViewTransformField(field, intl);
        if (transformedField != null) toReturn.push(transformedField);
    });
    return toReturn;
};

});
parcelRegister("h9cCP", function(module, exports) {

$parcel$export(module.exports, "MINUTE", () => $335f9886067ef898$export$f4aba04677f37907);
$parcel$export(module.exports, "HOUR", () => $335f9886067ef898$export$1bf939ebcf31ef0e);
$parcel$export(module.exports, "DAY", () => $335f9886067ef898$export$1a58b8d7f494dd72);
$parcel$export(module.exports, "WEEK", () => $335f9886067ef898$export$3241045aa1844a20);
$parcel$export(module.exports, "DAYS", () => $335f9886067ef898$export$b387b66963374517);
$parcel$export(module.exports, "HOURS", () => $335f9886067ef898$export$f25ebc73c10ad2c);
$parcel$export(module.exports, "PRETTY", () => $335f9886067ef898$export$d39e6ebabedff673);
$parcel$export(module.exports, "defaultTimeTrackingConfiguration", () => $335f9886067ef898$export$e17ebf14f4144ede);
$parcel$export(module.exports, "DEFAULT_TO_NEW_ISSUE_VIEW", () => $335f9886067ef898$export$83f9ac2d887bd06a);
const $335f9886067ef898$export$f4aba04677f37907 = 'minute';
const $335f9886067ef898$export$1bf939ebcf31ef0e = 'hour';
const $335f9886067ef898$export$1a58b8d7f494dd72 = 'day';
const $335f9886067ef898$export$3241045aa1844a20 = 'week';
const $335f9886067ef898$export$b387b66963374517 = 'days';
const $335f9886067ef898$export$f25ebc73c10ad2c = 'hours';
const $335f9886067ef898$export$d39e6ebabedff673 = 'pretty';
const $335f9886067ef898$export$e17ebf14f4144ede = {
    isTimeTrackingEnabled: false,
    daysPerWeek: 5,
    hoursPerDay: 8,
    defaultUnit: $335f9886067ef898$export$f4aba04677f37907,
    format: $335f9886067ef898$export$d39e6ebabedff673
};
const $335f9886067ef898$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';

});

parcelRegister("7v0hO", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $84936c9163886c98$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $84936c9163886c98$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $84936c9163886c98$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $84936c9163886c98$export$8516173ab945b52f);

var $eI5EY = parcelRequire("eI5EY");

var $4m36T = parcelRequire("4m36T");

var $eyAhE = parcelRequire("eyAhE");

var $3W1DB = parcelRequire("3W1DB");
const $84936c9163886c98$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $84936c9163886c98$var$timeFormatterNew = (time, unit, unitDisplay, { formatNumber: formatNumber })=>{
    if (time > 0) {
        const fixedTime = time.toFixed(2);
        return formatNumber(parseFloat(fixedTime), {
            style: 'unit',
            unit: unit,
            unitDisplay: unitDisplay
        }).replace(/\.?0+$/, '');
    }
    return formatNumber(0, {
        style: 'unit',
        unit: unit,
        unitDisplay: unitDisplay
    });
};
const $84936c9163886c98$var$timeFormatterOld = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $84936c9163886c98$var$timePrettyFormatterNew = (timeInSeconds, units, formatNumber)=>{
    const timeForZero = formatNumber(0, {
        style: 'unit',
        unit: (0, $4m36T.TimeUnits).MINUTE,
        unitDisplay: 'narrow'
    });
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? timeObj.time.concat(' ', formatNumber(currentTimeValue, {
            style: 'unit',
            unit: unit.type,
            unitDisplay: 'narrow'
        })) : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterOld = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterLongFormNew = (timeInSeconds, units, formatNumber)=>{
    const timeForZero = formatNumber(0, {
        style: 'unit',
        unit: (0, $4m36T.TimeUnits).MINUTE,
        unitDisplay: 'long'
    });
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: timeObj.time.concat(' ', formatNumber(currentTimeValue, {
                style: 'unit',
                unit: unit.type,
                unitDisplay: 'long'
            }))
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? timeObj.time.concat(' ', formatNumber(currentTimeValue, {
            style: 'unit',
            unit: unit.type,
            unitDisplay: 'long'
        })) : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterLongFormOld = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatNumber: formatNumber, formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $3W1DB.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $eyAhE.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $eyAhE.default).timeUnitDay,
            transform: $84936c9163886c98$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $eyAhE.default).timeUnitHour,
            transform: $84936c9163886c98$var$validate(isTimeValid),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $eyAhE.default).timeUnitMinute,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timeFormatterNew(units[1].time, units[1].type, 'narrow', {
                formatNumber: formatNumber
            });
            return $84936c9163886c98$var$timeFormatterOld(units[1].time, formatMessage(units[1].suffix));
        case (0, $4m36T.TimeFormats).HOURS:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timeFormatterNew(units[2].time, units[2].type, 'narrow', {
                formatNumber: formatNumber
            });
            return $84936c9163886c98$var$timeFormatterOld(units[2].time, formatMessage(units[2].suffix));
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timePrettyFormatterNew(timeInSeconds, units, formatNumber);
            return $84936c9163886c98$var$timePrettyFormatterOld(timeInSeconds, units, formatMessage);
    }
};
const $84936c9163886c98$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $4m36T.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $4m36T.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $4m36T.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $4m36T.defaultTimeTrackingOptions).defaultUnit
    };
    return $84936c9163886c98$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $84936c9163886c98$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage, formatNumber: formatNumber })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $3W1DB.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $eyAhE.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $eyAhE.default).timeUnitLongDay,
            transform: $84936c9163886c98$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $eyAhE.default).timeUnitLongHour,
            transform: $84936c9163886c98$var$validate(isTimeValid),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $eyAhE.default).timeUnitLongMinute,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timeFormatterNew(units[1].time, units[1].type, 'long', {
                formatNumber: formatNumber
            });
            return $84936c9163886c98$var$timeFormatterOld(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $4m36T.TimeFormats).HOURS:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timeFormatterNew(units[2].time, units[2].type, 'long', {
                formatNumber: formatNumber
            });
            return $84936c9163886c98$var$timeFormatterOld(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timePrettyFormatterLongFormNew(timeInSeconds, units, formatNumber);
            return $84936c9163886c98$var$timePrettyFormatterLongFormOld(timeInSeconds, units, formatMessage);
    }
};
const $84936c9163886c98$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $4m36T.TimeFormats).DAYS:
            return (0, $4m36T.TimeFormats).DAYS;
        case (0, $4m36T.TimeFormats).HOURS:
            return (0, $4m36T.TimeFormats).HOURS;
        case (0, $4m36T.TimeFormats).PRETTY:
            return (0, $4m36T.TimeFormats).PRETTY;
        default:
            return (0, $4m36T.TimeFormats).DAYS;
    }
};
const $84936c9163886c98$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $4m36T.TimeUnits).DAY:
            return (0, $4m36T.TimeUnits).DAY;
        case (0, $4m36T.TimeUnits).HOUR:
            return (0, $4m36T.TimeUnits).HOUR;
        case (0, $4m36T.TimeUnits).MINUTE:
            return (0, $4m36T.TimeUnits).MINUTE;
        case (0, $4m36T.TimeUnits).WEEK:
            return (0, $4m36T.TimeUnits).WEEK;
        default:
            return (0, $4m36T.TimeUnits).DAY;
    }
};

});
parcelRegister("4m36T", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $8d43f29047a2cbec$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $8d43f29047a2cbec$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $8d43f29047a2cbec$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $8d43f29047a2cbec$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $8d43f29047a2cbec$export$f8d48c1fed813e90);
const $8d43f29047a2cbec$export$544c576050746347 = 60;
const $8d43f29047a2cbec$export$a4982fdb1458274 = 60;
const $8d43f29047a2cbec$export$3cc7ae4b390f50a = $8d43f29047a2cbec$export$a4982fdb1458274 * $8d43f29047a2cbec$export$544c576050746347;
const $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY = 'pretty';
const $8d43f29047a2cbec$var$TIME_FORMAT_DAYS = 'days';
const $8d43f29047a2cbec$var$TIME_FORMAT_HOURS = 'hours';
const $8d43f29047a2cbec$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY,
    DAYS: $8d43f29047a2cbec$var$TIME_FORMAT_DAYS,
    HOURS: $8d43f29047a2cbec$var$TIME_FORMAT_HOURS
});
const $8d43f29047a2cbec$var$TIME_UNIT_WEEK = 'week';
const $8d43f29047a2cbec$var$TIME_UNIT_DAY = 'day';
const $8d43f29047a2cbec$var$TIME_UNIT_HOUR = 'hour';
const $8d43f29047a2cbec$var$TIME_UNIT_MINUTE = 'minute';
const $8d43f29047a2cbec$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $8d43f29047a2cbec$var$TIME_UNIT_WEEK,
    DAY: $8d43f29047a2cbec$var$TIME_UNIT_DAY,
    HOUR: $8d43f29047a2cbec$var$TIME_UNIT_HOUR,
    MINUTE: $8d43f29047a2cbec$var$TIME_UNIT_MINUTE
});
const $8d43f29047a2cbec$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $8d43f29047a2cbec$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $8d43f29047a2cbec$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("eyAhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93ae5507f3c0ae3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a93ae5507f3c0ae3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("3W1DB", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $1595a85c80e57d00$export$aab44654646f3ccc);
const $1595a85c80e57d00$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});


parcelRegister("gDg11", function(module, exports) {

$parcel$export(module.exports, "timeFormatMap", () => $b8cb5c2f048086dd$export$17f3cee8c0df1);

var $h9cCP = parcelRequire("h9cCP");
const $b8cb5c2f048086dd$export$17f3cee8c0df1 = new Map([
    [
        'HOURS',
        (0, $h9cCP.HOURS)
    ],
    [
        'hours',
        (0, $h9cCP.HOURS)
    ],
    [
        'DAYS',
        (0, $h9cCP.DAYS)
    ],
    [
        'days',
        (0, $h9cCP.DAYS)
    ],
    [
        'PRETTY',
        (0, $h9cCP.PRETTY)
    ],
    [
        'pretty',
        (0, $h9cCP.PRETTY)
    ]
]);

});




parcelRegister("hHiDc", function(module, exports) {

$parcel$export(module.exports, "useIssueFields", () => $2c6f147c9fec0ebf$export$3dd4dc75e8b8fc8a);
$parcel$export(module.exports, "UpdateFieldsDetail", () => $2c6f147c9fec0ebf$export$fc1188611b218081);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $jG2Eu = parcelRequire("jG2Eu");

var $MdoH4 = parcelRequire("MdoH4");

var $5iWql = parcelRequire("5iWql");

var $gEmpR = parcelRequire("gEmpR");

var $hPXdk = parcelRequire("hPXdk");

var $6HSAr = parcelRequire("6HSAr");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $1Te3F = parcelRequire("1Te3F");

var $6hN2s = parcelRequire("6hN2s");
const $2c6f147c9fec0ebf$var$fieldIdsToQuery = [
    'rank',
    'parent'
];
const $2c6f147c9fec0ebf$var$buildListOfAvailableFields = (0, $5iWql.default)((fields, constants)=>fields// add fields missing in the service response
    .concat(constants.MISSING_FIELDS)// filter out fields that we can't render yet
    .filter((field)=>constants.SUPPORTED_FIELD_TYPES.includes(field.type ?? ''))// sort in order of SUPPORTED_FIELDS
    .sort((a, b)=>constants.SUPPORTED_FIELD_TYPES.indexOf(a.type ?? '') - constants.SUPPORTED_FIELD_TYPES.indexOf(b.type ?? '')), (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
const $2c6f147c9fec0ebf$var$getSortedAvailableFields = (0, $5iWql.default)((availableFields, fieldsOrder, constants)=>availableFields.sort((a, b)=>{
        // fieldsOrder are initially set to SUPPORTED_FIELD_TYPES which are typed base
        // Category field is a custom field and it's id (e.g, customfield_X) is not equal to the type
        // so finding by id will return -1
        const aFieldsOrderIdx = a?.type && (0, $1Te3F.DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(a?.type) ? fieldsOrder.indexOf(a.type) : fieldsOrder.indexOf(a.id);
        const bFieldsOrderIdx = b?.type && (0, $1Te3F.DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(b?.type) ? fieldsOrder.indexOf(b.type) : fieldsOrder.indexOf(b.id);
        // if field is missing from fieldsOrder add to the end sorted based on field type
        if (aFieldsOrderIdx === -1 || bFieldsOrderIdx === -1) {
            if (aFieldsOrderIdx !== -1) return -1;
            if (bFieldsOrderIdx !== -1) return 1;
            return constants.SUPPORTED_FIELD_TYPES.indexOf(a.type ?? '') - constants.SUPPORTED_FIELD_TYPES.indexOf(b.type ?? '');
        }
        return aFieldsOrderIdx - bFieldsOrderIdx;
    }));
const $2c6f147c9fec0ebf$export$3dd4dc75e8b8fc8a = ()=>{
    const constants = (0, $1Te3F.useConstants)();
    const { data: data, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const availableFields = $2c6f147c9fec0ebf$var$buildListOfAvailableFields(data.fields, constants);
    let order;
    let details;
    let toggleField;
    let reorderFields;
    let resetCache = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    if ((0, $eI5EY.fg)('jsw_list_view_-_cache_extra_fields_data')) ({ fields: { order: order, details: details }, toggleField: toggleField, reorderFields: reorderFields, resetCache: resetCache } = (0, $6hN2s.useFieldsActions)(!loading && error == null ? availableFields : null));
    else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ fields: order, toggleField: toggleField, reorderFields: reorderFields } = (0, $6hN2s.useFieldsActionsOld)());
        details = null;
    }
    const getAvailableFields = (0, $eUqFw.useCallback)(()=>{
        try {
            return $2c6f147c9fec0ebf$var$getSortedAvailableFields(availableFields, order, constants);
        } catch (err) {
            if ((0, $eI5EY.fg)('jsw_list_view_-_cache_extra_fields_data')) {
                resetCache && resetCache();
                (0, $guiFP.default)({
                    meta: {
                        id: 'getAvailableFields',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Error trying to get available fields from cache'
                    },
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                return $2c6f147c9fec0ebf$var$getSortedAvailableFields(availableFields, [], constants);
            }
            throw err;
        }
    }, [
        availableFields,
        constants,
        order,
        resetCache
    ]);
    const shouldGetVisibleFieldsFromCache = (0, $eUqFw.useMemo)(()=>(loading || error != null) && details != null, [
        details,
        error,
        loading
    ]);
    const getVisibleFields = (0, $eUqFw.useCallback)(()=>{
        if (shouldGetVisibleFieldsFromCache) try {
            return order// Remove the ? once jsw_list_view_-_cache_extra_fields_data gets clean up
            .map((id)=>details?.[id]).filter((field)=>constants.SUPPORTED_FIELD_TYPES.includes(field?.type ?? ''));
        } catch (err) {
            resetCache && resetCache();
            (0, $guiFP.default)({
                meta: {
                    id: 'getVisibleFields',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error trying to get visible fields from cache'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            return [];
        }
        return getAvailableFields().filter((field)=>constants.ALWAYS_VISIBLE_FIELDS.includes(field.id) || field.id != null && order.includes(field.id) || field.type !== undefined && order.includes(field.type));
    }, [
        shouldGetVisibleFieldsFromCache,
        getAvailableFields,
        order,
        details,
        constants.SUPPORTED_FIELD_TYPES,
        constants.ALWAYS_VISIBLE_FIELDS,
        resetCache
    ]);
    const getQueryFieldIds = (0, $eUqFw.useCallback)(()=>{
        if (loading) return [];
        let visibleFieldIds;
        if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) // return queryFieldIds based on columns visibility
        // note that changing columns visibility triggers another items query
        visibleFieldIds = getVisibleFields()// the top level dev summary is the only thing that we should be using
        // we need to remove it from fieldIds because could fetch the field twice and is a complex field
        .filter((field)=>field.type !== (0, $lO4Or.DEV_SUMMARY_CF_TYPE)).map((field)=>field.id === 'key' ? 'issuekey' : field.id)// avoid querying items on columns re-ordering
        .sort((a, b)=>constants.SUPPORTED_FIELD_TYPES.indexOf(a) - constants.SUPPORTED_FIELD_TYPES.indexOf(b)).concat($2c6f147c9fec0ebf$var$fieldIdsToQuery);
        else // return queryFieldIds based on columns visibility
        // note that changing columns visibility triggers another items query
        visibleFieldIds = getVisibleFields().map((field)=>field.id === 'key' ? 'issuekey' : field.id)// avoid querying items on columns re-ordering
        .sort((a, b)=>constants.SUPPORTED_FIELD_TYPES.indexOf(a) - constants.SUPPORTED_FIELD_TYPES.indexOf(b)).concat($2c6f147c9fec0ebf$var$fieldIdsToQuery);
        if (visibleFieldIds.includes('timeoriginalestimate') && !visibleFieldIds.includes('timetracking')) // In JIS2, replace timeoriginalestimate with timetracking, which will have the information we
        // need to determine timeAsString in the JIS2 transformer in
        // src/packages/business/list/src/services/get-list-view-issues/field-transformer-jis2/index.tsx
        visibleFieldIds.splice(visibleFieldIds.indexOf('timeoriginalestimate'), 1, 'timetracking');
        const queryFieldIds = visibleFieldIds.filter((field)=>field !== 'commentsummary');
        return (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(queryFieldIds);
    }, [
        constants.SUPPORTED_FIELD_TYPES,
        getVisibleFields,
        loading
    ]);
    const { getQueryFieldIdsWithCache: getQueryFieldIdsWithCache } = (0, $6HSAr.useFieldsCache)({
        loading: loading,
        error: error,
        getQueryFieldIds: getQueryFieldIds
    });
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, $hPXdk.useHierarchyCache)({
        view: 'list'
    });
    const isParentFieldVisible = (0, $eUqFw.useCallback)(()=>(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? getVisibleFields().some((field)=>field.id === 'parent') : false, [
        getVisibleFields
    ]);
    const isDevSummaryFieldVisible = (0, $eUqFw.useCallback)(()=>(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? getVisibleFields().some((field)=>field.type === (0, $lO4Or.DEV_SUMMARY_CF_TYPE)) : false, [
        getVisibleFields
    ]);
    return {
        constants: constants,
        toggleField: toggleField,
        getVisibleFields: getVisibleFields,
        getAvailableFields: getAvailableFields,
        getQueryFieldIds: getQueryFieldIdsWithCache,
        isParentFieldVisible: isParentFieldVisible,
        isDevSummaryFieldVisible: isDevSummaryFieldVisible,
        hierarchyLevelsWithCache: hierarchyLevelsWithCache,
        reorderFields: reorderFields,
        fieldsOrder: order,
        isVisibleFieldsCached: shouldGetVisibleFieldsFromCache,
        loading: loading,
        error: error
    };
};
const $2c6f147c9fec0ebf$export$fc1188611b218081 = ()=>{
    /* eslint-disable react-hooks/rules-of-hooks */ if (!(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && !(0, $eI5EY.fg)('jsw_list_view_-_cache_extra_fields_data')) return null;
    const constants = (0, $1Te3F.useConstants)();
    const { data: data, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const availableFields = $2c6f147c9fec0ebf$var$buildListOfAvailableFields(data.fields, constants);
    (0, $6hN2s.useUpdateFieldsDetail)(!loading && error == null ? availableFields : null);
    return null;
/* eslint-enable react-hooks/rules-of-hooks */ };

});
parcelRegister("hPXdk", function(module, exports) {

$parcel$export(module.exports, "useHierarchyCache", () => $3299fbc32eb7c5ca$export$c2cd1510e81d00ce);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $fDLFb = parcelRequire("fDLFb");

var $gEmpR = parcelRequire("gEmpR");


var $9kyGZ = parcelRequire("9kyGZ");
const $3299fbc32eb7c5ca$export$c2cd1510e81d00ce = ({ view: view })=>{
    const { loading: loading, error: error, hierarchyLevels: newHierarchyLevels } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const localStorage = (0, $9kyGZ.getLocalStorage)(view);
    const hierarchyStorageKey = `${entity.id}_${(0, $ed82405237805b60$export$2cab30374aa79c41)}`;
    const [hierarchyLevels, setHierarchyLevels] = (0, $eUqFw.useState)(localStorage.get(hierarchyStorageKey));
    // save hierarchyLevels in localStorage
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && !error) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(hierarchyLevels, newHierarchyLevels)) {
                setHierarchyLevels(newHierarchyLevels);
                localStorage.set(hierarchyStorageKey, newHierarchyLevels);
            }
        }
    }, [
        loading,
        error,
        hierarchyLevels,
        hierarchyStorageKey,
        setHierarchyLevels,
        localStorage,
        newHierarchyLevels
    ]);
    const hierarchyLevelsWithCache = (0, $eUqFw.useMemo)(()=>{
        // return from cache (localStorage)
        if (hierarchyLevels && Array.isArray(hierarchyLevels)) return hierarchyLevels;
        // returns nothing if available fields query is in progress. But if cache is empty, it returns newHierarchyLevels
        if (loading) return [];
        return newHierarchyLevels;
    }, [
        hierarchyLevels,
        loading,
        newHierarchyLevels
    ]);
    return {
        hierarchyLevelsWithCache: hierarchyLevelsWithCache
    };
};

});
const $ed82405237805b60$export$2cab30374aa79c41 = 'hierarchy_levels';

parcelRegister("9kyGZ", function(module, exports) {

$parcel$export(module.exports, "getLocalStorage", () => $f21eb66b21e85710$export$d3720feff416e85b);

var $aZaPn = parcelRequire("aZaPn");
const $f21eb66b21e85710$export$d3720feff416e85b = (view)=>(0, $aZaPn.createLocalStorageProvider)(`jira_business_${view}-view`);

});


parcelRegister("6HSAr", function(module, exports) {

$parcel$export(module.exports, "useFieldsCache", () => $1a91a98110c84b08$export$2fa1686d7312ac20);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $fDLFb = parcelRequire("fDLFb");

var $iGdkQ = parcelRequire("iGdkQ");
const $1a91a98110c84b08$var$QUERY_FIELDS_ID_LOCAL_STORAGE_KEY = 'query_fields_id';
const $1a91a98110c84b08$export$2fa1686d7312ac20 = ({ loading: loading, error: error, getQueryFieldIds: getQueryFieldIds })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const queryFieldsStorageKey = `${entity.id}_${$1a91a98110c84b08$var$QUERY_FIELDS_ID_LOCAL_STORAGE_KEY}`;
    const [queryFieldIds, setQueryFieldsIds] = (0, $eUqFw.useState)((0, $iGdkQ.localStorage).get(queryFieldsStorageKey));
    // save queryFieldIds in localStorage on initial page load when queryFieldIds are empty in localStorage
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && !error) {
            const newQueryFieldIds = getQueryFieldIds();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(queryFieldIds, newQueryFieldIds)) {
                setQueryFieldsIds(newQueryFieldIds);
                (0, $iGdkQ.localStorage).set(queryFieldsStorageKey, newQueryFieldIds);
            }
        }
    }, [
        loading,
        error,
        getQueryFieldIds,
        queryFieldsStorageKey,
        queryFieldIds,
        setQueryFieldsIds
    ]);
    const getQueryFieldIdsWithCache = (0, $eUqFw.useCallback)(()=>{
        // return from cache (localStorage)
        if (queryFieldIds && Array.isArray(queryFieldIds)) return queryFieldIds;
        // returns nothing if available fields query is in progress. But if cache is empty, it calls getQueryFieldIds
        if (loading) return [];
        return getQueryFieldIds();
    }, [
        getQueryFieldIds,
        loading,
        queryFieldIds
    ]);
    return {
        getQueryFieldIdsWithCache: getQueryFieldIdsWithCache
    };
};

});
parcelRegister("iGdkQ", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $14f1b0b4f914bbd7$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $14f1b0b4f914bbd7$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_business_list-view');

});


parcelRegister("1Te3F", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CUSTOM_FIELDS_BY_TYPE", () => $16df7b8e3a965f2e$export$5150e2d13825462d);
$parcel$export(module.exports, "getInitVisibleFields", () => $16df7b8e3a965f2e$export$86172108eb1873dd);
$parcel$export(module.exports, "getAlwaysVisibleFields", () => $16df7b8e3a965f2e$export$de476ed52b559d9);
$parcel$export(module.exports, "useConstants", () => $16df7b8e3a965f2e$export$eedf91b09a0fe0d1);

var $eUqFw = parcelRequire("eUqFw");

var $3555e = parcelRequire("3555e");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $8lNor = parcelRequire("8lNor");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $egJIx = parcelRequire("egJIx");

var $kT5zt = parcelRequire("kT5zt");
const $16df7b8e3a965f2e$export$5150e2d13825462d = [
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.SPRINT_TYPE)
];
const $16df7b8e3a965f2e$export$86172108eb1873dd = ({ isCategoryEnabled: isCategoryEnabled = true, isScrumProject: isScrumProject = false })=>[
        (0, $lO4Or.ISSUE_TYPE),
        'key',
        (0, $lO4Or.SUMMARY_TYPE),
        (0, $lO4Or.STATUS_TYPE),
        isCategoryEnabled ? (0, $lO4Or.CATEGORY_TYPE) : undefined,
        isScrumProject ? (0, $lO4Or.SPRINT_TYPE) : undefined,
        (0, $lO4Or.ASSIGNEE_TYPE),
        (0, $lO4Or.DUE_DATE_TYPE),
        (0, $lO4Or.PRIORITY_TYPE),
        (0, $lO4Or.LABELS_TYPE),
        (0, $lO4Or.CREATED),
        (0, $lO4Or.UPDATED),
        (0, $lO4Or.REPORTER_TYPE)
    ].filter(Boolean);
const $16df7b8e3a965f2e$export$db265ae985088fd7 = ({ isCategoryEnabled: isCategoryEnabled = true, isScrumProject: isScrumProject = false })=>({
        [(0, $lO4Or.ISSUE_TYPE)]: true,
        key: true,
        [(0, $lO4Or.SUMMARY_TYPE)]: true,
        [(0, $lO4Or.STATUS_TYPE)]: true,
        ...isCategoryEnabled ? {
            [(0, $lO4Or.CATEGORY_TYPE)]: true
        } : {},
        ...isScrumProject ? {
            [(0, $lO4Or.SPRINT_TYPE)]: true
        } : {},
        [(0, $lO4Or.ASSIGNEE_TYPE)]: true,
        [(0, $lO4Or.DUE_DATE_TYPE)]: true,
        [(0, $lO4Or.PRIORITY_TYPE)]: true,
        [(0, $lO4Or.LABELS_TYPE)]: true,
        [(0, $lO4Or.CREATED)]: true,
        [(0, $lO4Or.UPDATED)]: true,
        [(0, $lO4Or.REPORTER_TYPE)]: true
    });
const $16df7b8e3a965f2e$export$de476ed52b559d9 = ()=>[
        (0, $lO4Or.ISSUE_TYPE),
        'key',
        (0, $lO4Or.SUMMARY_TYPE)
    ];
const $16df7b8e3a965f2e$export$e4330d77fd93d1de = ({ defaultVisibleFields: defaultVisibleFields, hasConfluence: hasConfluence = false, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled = false, isBusinessFieldsEnabled: isBusinessFieldsEnabled = true, isTeamManaged: isTeamManaged = true, isScrumProject: isScrumProject = false } = {})=>Object.keys(defaultVisibleFields ?? $16df7b8e3a965f2e$export$db265ae985088fd7({
        isCategoryEnabled: isBusinessFieldsEnabled,
        isScrumProject: isScrumProject
    })).concat([
        (0, $lO4Or.TEXT_CF_TYPE),
        (0, $lO4Or.USER_CF_TYPE),
        (0, $lO4Or.NUMBER_CF_TYPE),
        (0, $lO4Or.TIME_ESTIMATE_TYPE),
        (0, $lO4Or.TEXT_AREA_CF_TYPE),
        (0, $lO4Or.DATE_CF_TYPE),
        (0, $lO4Or.DATETIME_CF_TYPE),
        (0, $lO4Or.SELECT_CF_TYPE),
        (0, $lO4Or.MULTI_SELECT_CF_TYPE),
        (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
        (0, $lO4Or.URL_CF_TYPE),
        (0, $lO4Or.MULTI_USER_CF_TYPE),
        (0, $lO4Or.COMPONENTS_TYPE),
        (0, $lO4Or.LABELS_CF_TYPE),
        (0, $lO4Or.PEOPLE_CF_TYPE),
        (0, $jGcn0.COMMENT_SUMMARY_TYPE)
    ]).concat(isSoftwareFieldsEnabled && isTeamManaged ? [
        (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)
    ] : []).concat(isSoftwareFieldsEnabled && !isTeamManaged ? [
        (0, $lO4Or.STORY_POINTS_TYPE)
    ] : []).concat(isSoftwareFieldsEnabled && !isScrumProject ? [
        (0, $lO4Or.SPRINT_TYPE)
    ] : []).concat(hasConfluence ? [
        (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)
    ] : []).concat((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? (0, $8lNor.getSupportedFieldTypes)(isSoftwareFieldsEnabled) : []);
const $16df7b8e3a965f2e$export$c7b8f0505fa10763 = (hasConfluence)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $eUqFw.useMemo)(()=>[
            {
                id: 'key',
                type: 'key',
                name: formatMessage((0, $kT5zt.default).key),
                issueTypes: [],
                fieldConfig: {
                    isRequired: true,
                    isEditable: false
                }
            },
            {
                id: (0, $jGcn0.COMMENT_SUMMARY_TYPE),
                type: (0, $jGcn0.COMMENT_SUMMARY_TYPE),
                name: formatMessage((0, $kT5zt.default).comments),
                issueTypes: [],
                fieldConfig: {
                    isRequired: true,
                    isEditable: false
                }
            },
            ...hasConfluence ? [
                {
                    id: (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE),
                    type: (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE),
                    name: formatMessage((0, $kT5zt.default).confluencePages),
                    issueTypes: [],
                    fieldConfig: (0, $eI5EY.fg)('jira_list_keyboard_nav') ? {
                        isRequired: false,
                        isEditable: true
                    } : {
                        isRequired: true,
                        isEditable: false
                    }
                }
            ] : []
        ], [
        formatMessage,
        hasConfluence
    ]);
};
const $16df7b8e3a965f2e$export$eedf91b09a0fe0d1 = ()=>{
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    const projectData = (0, $kQAZu.useProject)();
    const isTeamManaged = projectData.isSimplified;
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled, isBusinessFieldsEnabled: isBusinessFieldsEnabled, isScrumProject: isScrumProject } = (0, $egJIx.useJWMListFeatures)();
    const missingFields = $16df7b8e3a965f2e$export$c7b8f0505fa10763(hasConfluence);
    return (0, $eUqFw.useMemo)(()=>{
        const defaultVisibleFields = $16df7b8e3a965f2e$export$db265ae985088fd7({
            isCategoryEnabled: isBusinessFieldsEnabled,
            isScrumProject: isScrumProject
        });
        const alwaysVisibleFields = $16df7b8e3a965f2e$export$de476ed52b559d9();
        const supportedFieldTypes = $16df7b8e3a965f2e$export$e4330d77fd93d1de({
            defaultVisibleFields: defaultVisibleFields,
            hasConfluence: hasConfluence,
            isSoftwareFieldsEnabled: isSoftwareFieldsEnabled,
            isBusinessFieldsEnabled: isBusinessFieldsEnabled,
            isTeamManaged: isTeamManaged,
            isScrumProject: isScrumProject
        });
        return {
            DEFAULT_VISIBLE_FIELDS: defaultVisibleFields,
            ALWAYS_VISIBLE_FIELDS: alwaysVisibleFields,
            SUPPORTED_FIELD_TYPES: supportedFieldTypes,
            MISSING_FIELDS: missingFields
        };
    }, [
        isBusinessFieldsEnabled,
        hasConfluence,
        isSoftwareFieldsEnabled,
        isTeamManaged,
        isScrumProject,
        missingFields
    ]);
};

});
parcelRegister("8lNor", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldTypes", () => $e1580c6b5fbd09d7$export$e4330d77fd93d1de);
$parcel$export(module.exports, "newInitVisibleFields", () => $e1580c6b5fbd09d7$export$e8fa0cca823ce465);
$parcel$export(module.exports, "isSupportedTypePredicated", () => $e1580c6b5fbd09d7$export$6868d04e3954dca5);
$parcel$export(module.exports, "getTopLevelFieldKey", () => $e1580c6b5fbd09d7$export$5a7b6a57d325d92);
$parcel$export(module.exports, "isTopLevelField", () => $e1580c6b5fbd09d7$export$9ce71a7c226d8918);

var $5iWql = parcelRequire("5iWql");


var $ajiYT = parcelRequire("ajiYT");

var $cQ6i7 = parcelRequire("cQ6i7");

var $8q0ZE = parcelRequire("8q0ZE");

var $csNv4 = parcelRequire("csNv4");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $aqWRZ = parcelRequire("aqWRZ");

var $9wDFL = parcelRequire("9wDFL");

var $fVV9q = parcelRequire("fVV9q");

var $6FuLp = parcelRequire("6FuLp");

var $843w3 = parcelRequire("843w3");

var $2yqHU = parcelRequire("2yqHU");

var $iAXnP = parcelRequire("iAXnP");
const $e1580c6b5fbd09d7$export$e4330d77fd93d1de = (0, $5iWql.default)((isSoftwareFieldsEnabled)=>[
        ...(0, $8q0ZE.parentSupportedTypes),
        ...(0, $csNv4.teamSupportedTypes),
        ...(0, $1ybV0.ff)('jira.list.field-support-part1') ? [
            ...(0, $843w3.resolutionSupportedTypes),
            ...(0, $9wDFL.groupSupportedTypes),
            ...(0, $2yqHU.statusCategorySupportedTypes),
            ...(0, $fVV9q.projectSupportedTypes),
            ...(0, $aqWRZ.cascadingSelectSupportedTypes),
            ...(0, $6FuLp.radioSelectSupportedTypes)
        ] : [],
        ...(0, $eI5EY.fg)('native_goals_integration_on_list_view') ? (0, $cQ6i7.goalsSupportedTypes) : [],
        ...isSoftwareFieldsEnabled ? [
            ...(0, $ajiYT.devSummarySupportedTypes),
            ...(0, $iAXnP.versionSupportedTypes)
        ] : []
    ]);
const $e1580c6b5fbd09d7$export$e8fa0cca823ce465 = (0, $5iWql.default)((isSoftwareFieldsEnabled)=>[
        ...(0, $8q0ZE.parentSupportedTypes),
        ...(0, $csNv4.teamSupportedTypes),
        ...isSoftwareFieldsEnabled ? [
            (0, $lO4Or.FIX_VERSIONS_TYPE),
            ...(0, $ajiYT.devSummarySupportedTypes)
        ] : []
    ]);
const $e1580c6b5fbd09d7$export$6868d04e3954dca5 = (fieldType, isSoftwareFieldsEnabled = true)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e1580c6b5fbd09d7$export$e4330d77fd93d1de(isSoftwareFieldsEnabled).includes(fieldType);
// top level field
const $e1580c6b5fbd09d7$var$TOP_LEVEL_FIELD = [
    ...(0, $ajiYT.devSummarySupportedTypes)
];
const $e1580c6b5fbd09d7$var$isValidTopFieldType = (typename)=>true;
const $e1580c6b5fbd09d7$export$5a7b6a57d325d92 = (fieldType)=>{
    if (!fieldType || !$e1580c6b5fbd09d7$var$isValidTopFieldType(fieldType)) return null;
    if ((0, $ajiYT.devSummarySupportedTypes).includes(fieldType)) return 0, $c12b99091b418650$export$72b5bd2391f1e7c0;
    return null;
};
const $e1580c6b5fbd09d7$export$9ce71a7c226d8918 = (fieldType)=>{
    if (!fieldType || !$e1580c6b5fbd09d7$var$isValidTopFieldType(fieldType)) return false;
    return $e1580c6b5fbd09d7$var$TOP_LEVEL_FIELD.includes(fieldType);
};

});
parcelRegister("ajiYT", function(module, exports) {

$parcel$export(module.exports, "devSummarySupportedTypes", () => $4a9102c9a6a79121$export$22d58d85f8d7faea);

var $lO4Or = parcelRequire("lO4Or");
const $4a9102c9a6a79121$export$22d58d85f8d7faea = [
    (0, $lO4Or.DEV_SUMMARY_CF_TYPE)
];

});

parcelRegister("cQ6i7", function(module, exports) {

$parcel$export(module.exports, "goalsSupportedTypes", () => $1c027395f8e7b4db$export$bc170bcdefb8333f);

var $lO4Or = parcelRequire("lO4Or");
const $1c027395f8e7b4db$export$bc170bcdefb8333f = [
    (0, $lO4Or.GOALS_CF_TYPE)
];

});

parcelRegister("8q0ZE", function(module, exports) {

$parcel$export(module.exports, "parentSupportedTypes", () => $52aa9997ad392f5e$export$cc8590a96c2280c);

var $lO4Or = parcelRequire("lO4Or");
const $52aa9997ad392f5e$export$cc8590a96c2280c = [
    (0, $lO4Or.PARENT_TYPE)
];

});

parcelRegister("csNv4", function(module, exports) {

$parcel$export(module.exports, "teamSupportedTypes", () => $ae82114964792b44$export$7fe9ceb0183f4a3e);

var $lO4Or = parcelRequire("lO4Or");
const $ae82114964792b44$export$7fe9ceb0183f4a3e = [
    (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)
];

});

parcelRegister("aqWRZ", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectSupportedTypes", () => $e102388129376b5f$export$caf76d0a4f04f1d);

var $lO4Or = parcelRequire("lO4Or");
const $e102388129376b5f$export$caf76d0a4f04f1d = [
    (0, $lO4Or.CASCADING_SELECT_CF_TYPE)
];

});

parcelRegister("9wDFL", function(module, exports) {

$parcel$export(module.exports, "groupSupportedTypes", () => $fe1c565660b1662c$export$f3ef0b84bd022156);

var $lO4Or = parcelRequire("lO4Or");
const $fe1c565660b1662c$export$f3ef0b84bd022156 = [
    (0, $lO4Or.GROUP_CF_TYPE),
    (0, $lO4Or.MULTI_GROUP_CF_TYPE)
];

});

parcelRegister("fVV9q", function(module, exports) {

$parcel$export(module.exports, "projectSupportedTypes", () => $26131322fb8e449c$export$ecab9c2d3c8390e9);

var $lO4Or = parcelRequire("lO4Or");
const $26131322fb8e449c$export$ecab9c2d3c8390e9 = [
    (0, $lO4Or.PROJECT_PICKER_CF_TYPE)
];

});

parcelRegister("6FuLp", function(module, exports) {

$parcel$export(module.exports, "radioSelectSupportedTypes", () => $aa04aa8aa7506338$export$a92ad538b45df386);

var $lO4Or = parcelRequire("lO4Or");
const $aa04aa8aa7506338$export$a92ad538b45df386 = [
    (0, $lO4Or.RADIO_BUTTONS_CF_TYPE)
];

});

parcelRegister("843w3", function(module, exports) {

$parcel$export(module.exports, "resolutionSupportedTypes", () => $2fdff68ebbb5c1de$export$89876769ad40213e);

var $lO4Or = parcelRequire("lO4Or");
const $2fdff68ebbb5c1de$export$89876769ad40213e = [
    (0, $lO4Or.RESOLUTION_TYPE)
];

});

parcelRegister("2yqHU", function(module, exports) {

$parcel$export(module.exports, "statusCategorySupportedTypes", () => $04bd63d71e65897e$export$ce1a6f07ee0c2fd4);

var $lO4Or = parcelRequire("lO4Or");
const $04bd63d71e65897e$export$ce1a6f07ee0c2fd4 = [
    (0, $lO4Or.STATUS_CATEGORY_TYPE)
];

});

parcelRegister("iAXnP", function(module, exports) {

$parcel$export(module.exports, "versionSupportedTypes", () => $c8c09a423c8a5fac$export$c35776c44a9e8a18);

var $lO4Or = parcelRequire("lO4Or");
const $c8c09a423c8a5fac$export$c35776c44a9e8a18 = [
    (0, $lO4Or.VERSION_CF_TYPE),
    (0, $lO4Or.MULTI_VERSION_CF_TYPE),
    (0, $lO4Or.FIX_VERSIONS_TYPE),
    (0, $lO4Or.AFFECTS_VERSIONS_TYPE)
];

});


parcelRegister("kT5zt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a59112d86e42fafe$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a59112d86e42fafe$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    key: {
        "id": "business-list.controllers.get-issue-fields.constants.key",
        "defaultMessage": "Key"
    },
    comments: {
        "id": "business-list.controllers.get-issue-fields.constants.comments",
        "defaultMessage": "Comments"
    },
    confluencePages: {
        "id": "business-list.controllers.get-issue-fields.constants.confluence-pages",
        "defaultMessage": "Confluence pages"
    }
});

});


parcelRegister("6hN2s", function(module, exports) {

$parcel$export(module.exports, "useUpdateFieldsDetail", () => $bbcd9cbd736a28e7$export$33428c970fa4bad3);
$parcel$export(module.exports, "useFieldsActions", () => $bbcd9cbd736a28e7$export$4027818e87c46ba5);
$parcel$export(module.exports, "useFieldsActionsOld", () => $bbcd9cbd736a28e7$export$b2e53e8897fe7ef8);

var $eUqFw = parcelRequire("eUqFw");

var $fDLFb = parcelRequire("fDLFb");

var $8lNor = parcelRequire("8lNor");

var $iGdkQ = parcelRequire("iGdkQ");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $egJIx = parcelRequire("egJIx");

var $lAcL9 = parcelRequire("lAcL9");

var $1Te3F = parcelRequire("1Te3F");

var $9aDlc = parcelRequire("9aDlc");
const $bbcd9cbd736a28e7$var$getFieldsCache = ({ availableFields: availableFields, fields: fields, order: order })=>{
    if (availableFields == null) return fields.details;
    const newDetails = {};
    availableFields.forEach(({ id: id, name: name, type: type })=>{
        if (order.includes(id)) newDetails[id] = {
            id: id,
            name: name,
            type: type
        };
        else if (type != null && order.includes(type)) newDetails[type] = {
            id: id,
            name: name,
            type: type
        };
    });
    return newDetails;
};
const $bbcd9cbd736a28e7$var$NEW_FIELDS_ONBOARDING_LOCAL_STORAGE_KEY = 'list_new_fields_onboarding';
const $bbcd9cbd736a28e7$export$33428c970fa4bad3 = (availableFields)=>{
    const [fields, setFields] = (0, $9aDlc.useFieldsPreference)();
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const { isScrumProject: isScrumProject } = (0, $egJIx.useJWMListFeatures)();
    const newFieldsOnboardingStorageKey = `${entity.id}_${$bbcd9cbd736a28e7$var$NEW_FIELDS_ONBOARDING_LOCAL_STORAGE_KEY}`;
    (0, $eUqFw.useEffect)(()=>{
        if (availableFields != null) {
            /*
                ---- START ----
                This part of the code is just for the onboarding of the new fields
                should be removed when we do the clean up of: jsw_list_view_-_all_the_fields
            */ const isOnboardingDone = (0, $iGdkQ.localStorage).get(newFieldsOnboardingStorageKey);
            if (!isOnboardingDone && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
                const newFields = availableFields.filter((field)=>field.type && (0, $8lNor.isSupportedTypePredicated)(field.type, isScrumProject) ? (0, $8lNor.newInitVisibleFields)(isScrumProject).includes(field.type) : false).map((field)=>field.id);
                const newFieldsOrder = [
                    ...fields.order,
                    ...newFields
                ];
                setFields({
                    order: newFieldsOrder,
                    details: $bbcd9cbd736a28e7$var$getFieldsCache({
                        availableFields: availableFields,
                        fields: fields,
                        order: newFieldsOrder
                    })
                });
                (0, $iGdkQ.localStorage).set(newFieldsOnboardingStorageKey, true);
            /* ---- END ---- */ } else setFields({
                order: fields.order,
                details: $bbcd9cbd736a28e7$var$getFieldsCache({
                    order: fields.order,
                    fields: fields,
                    availableFields: availableFields
                })
            });
        }
    // We only want to update cache when available fields change the first time
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        availableFields,
        newFieldsOnboardingStorageKey
    ]);
};
const $bbcd9cbd736a28e7$export$4027818e87c46ba5 = (availableFields)=>{
    const [fields, setFields, setFieldsOld] = (0, $9aDlc.useFieldsPreference)();
    const [{ createIndex: createIndex, createFields: createFields }] = (0, $lAcL9.useInlineFieldCreateControls)();
    const resetCache = (0, $eUqFw.useCallback)(()=>{
        setFields(undefined);
        setFieldsOld(undefined);
    }, [
        setFields,
        setFieldsOld
    ]);
    const reorderFields = (0, $eUqFw.useCallback)(({ visibleFields: visibleFields, oldIndex: oldIndex, newIndex: newIndex })=>{
        try {
            if (oldIndex === newIndex) return;
            let oldFieldIndex = oldIndex;
            let newFieldIndex = newIndex;
            if (newFieldIndex < 3) /*
                    moving column to:
                    - the first position it's not possible due to the bulk selection
                    - the second position it's not possible because the type issue should not be repositioned
                    - the third position it's not possible because the key issue should not be repositioned
                */ return;
            // We have an extra column at the beginning for bulk selection
            // that should be considered to reorder fields
            oldFieldIndex -= 1;
            newFieldIndex -= 1;
            const reorderedFields = [
                ...visibleFields
            ];
            const [reorderedField] = reorderedFields.splice(oldFieldIndex, 1);
            reorderedFields.splice(newFieldIndex, 0, reorderedField);
            // visibleFields is initially set by DEFAULT_VISIBLE_FIELDS which are type based
            // we need to keep it consistent for those fields as getAvailableFields finds this field by type
            const fieldsOrder = reorderedFields.map((field)=>field?.type && (0, $1Te3F.DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(field.type) ? field.type : field.id);
            setFields({
                ...fields,
                order: fieldsOrder
            });
        } catch (error) {
            resetCache();
            (0, $guiFP.default)({
                meta: {
                    id: 'reorderFields',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error trying to reorder the fields'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        fields,
        resetCache,
        setFields
    ]);
    const toggleField = (0, $eUqFw.useCallback)((fieldId)=>{
        try {
            const isVisible = fields.order.includes(fieldId);
            const newFieldsOrder = [
                ...fields.order
            ];
            let createColumnIndex = createIndex;
            if (createFields) {
                const createField = createFields.find((f)=>f.fieldId === fieldId);
                createColumnIndex = createField?.createIndex ?? createColumnIndex;
            }
            if (!isVisible) {
                if (typeof createColumnIndex !== 'undefined') newFieldsOrder.splice(createColumnIndex, 0, fieldId);
                else newFieldsOrder.push(fieldId);
            } else {
                const fieldIndex = newFieldsOrder.findIndex((fId)=>fId === fieldId);
                if (fieldIndex >= 0) newFieldsOrder.splice(fieldIndex, 1);
            }
            setFields({
                order: newFieldsOrder,
                details: $bbcd9cbd736a28e7$var$getFieldsCache({
                    availableFields: availableFields,
                    fields: fields,
                    order: newFieldsOrder
                })
            });
        } catch (error) {
            resetCache();
            (0, $guiFP.default)({
                meta: {
                    id: 'toggleFields',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error trying to toogle a field'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        fields,
        createIndex,
        createFields,
        setFields,
        availableFields,
        resetCache
    ]);
    return {
        fields: fields,
        toggleField: toggleField,
        reorderFields: reorderFields,
        resetCache: resetCache
    };
};
const $bbcd9cbd736a28e7$export$b2e53e8897fe7ef8 = ()=>{
    const [fields, setFields] = (0, $9aDlc.useFieldsPreferenceOld)();
    const [{ createIndex: createIndex, createFields: createFields }] = (0, $lAcL9.useInlineFieldCreateControls)();
    const reorderFields = (0, $eUqFw.useCallback)(({ visibleFields: visibleFields, oldIndex: oldIndex, newIndex: newIndex })=>{
        if (oldIndex === newIndex) return;
        let oldFieldIndex = oldIndex;
        let newFieldIndex = newIndex;
        if (newFieldIndex < 3) /*
                moving column to:
                - the first position it's not possible due to the bulk selection
                - the second position it's not possible because the type issue should not be repositioned
                - the third position it's not possible because the key issue should not be repositioned
            */ return;
        // We have an extra column at the beginning for bulk selection
        // that should be considered to reorder fields
        oldFieldIndex -= 1;
        newFieldIndex -= 1;
        const reorderedFields = [
            ...visibleFields
        ];
        const [reorderedField] = reorderedFields.splice(oldFieldIndex, 1);
        reorderedFields.splice(newFieldIndex, 0, reorderedField);
        // visibleFields is initially set by DEFAULT_VISIBLE_FIELDS which are type based
        // we need to keep it consistent for those fields as getAvailableFields finds this field by type
        const fieldsOrder = reorderedFields.map((field)=>field?.type && (0, $1Te3F.DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(field.type) ? field.type : field.id);
        setFields(fieldsOrder);
    }, [
        setFields
    ]);
    const toggleField = (0, $eUqFw.useCallback)((fieldId)=>{
        const isVisible = fields.includes(fieldId);
        const newFields = [
            ...fields
        ];
        let createColumnIndex = createIndex;
        if (createFields) {
            const createField = createFields.find((field)=>field.fieldId === fieldId);
            createColumnIndex = createField?.createIndex ?? createColumnIndex;
        }
        if (!isVisible) {
            if (typeof createColumnIndex !== 'undefined') newFields.splice(createColumnIndex, 0, fieldId);
            else newFields.push(fieldId);
        } else {
            const fieldIndex = newFields.findIndex((field)=>field === fieldId);
            if (fieldIndex >= 0) newFields.splice(fieldIndex, 1);
        }
        setFields(newFields);
    }, [
        fields,
        createFields,
        createIndex,
        setFields
    ]);
    return {
        fields: fields,
        toggleField: toggleField,
        reorderFields: reorderFields
    };
};

});
parcelRegister("lAcL9", function(module, exports) {

$parcel$export(module.exports, "useInlineFieldCreateControls", () => $3647fb1ffdff85af$export$d98d27d7d9c6b61f);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $3647fb1ffdff85af$var$actions = {
    setIsSelected: (isSelected)=>({ setState: setState })=>{
            setState({
                isSelected: isSelected
            });
        },
    setCreateIndex: (columnIndex)=>({ setState: setState })=>{
            setState({
                createIndex: columnIndex !== undefined ? columnIndex + 1 : undefined
            });
        },
    clearCreateIndex: ()=>({ setState: setState })=>{
            setState({
                createIndex: undefined
            });
        },
    addCreateField: ({ fieldId: fieldId, name: name, type: type })=>({ setState: setState, getState: getState })=>{
            setState({
                createFields: [
                    ...getState().createFields,
                    {
                        fieldId: fieldId,
                        name: name,
                        type: type,
                        createIndex: getState().createIndex
                    }
                ]
            });
        },
    removeCreateField: (fieldId)=>({ setState: setState, getState: getState })=>{
            setState({
                createFields: [
                    ...getState().createFields.filter((field)=>field.fieldId !== fieldId)
                ]
            });
        }
};
const $3647fb1ffdff85af$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        isSelected: false,
        createIndex: undefined,
        createFields: []
    },
    actions: $3647fb1ffdff85af$var$actions,
    name: 'JwmListInlineFieldCreate'
});
const $3647fb1ffdff85af$export$d98d27d7d9c6b61f = (0, $1yZQx.createHook)($3647fb1ffdff85af$var$Store);

});

parcelRegister("9aDlc", function(module, exports) {

$parcel$export(module.exports, "useFieldsPreference", () => $5966853789054e24$export$46ce869a6df40a8b);
$parcel$export(module.exports, "useFieldsPreferenceOld", () => $5966853789054e24$export$4a17407108f98215);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $egJIx = parcelRequire("egJIx");

var $1Te3F = parcelRequire("1Te3F");
const $5966853789054e24$export$46ce869a6df40a8b = ()=>{
    const [fields, setFieldsOld] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FIELDS_PREFERENCE));
    const [fieldsDetail, setFields] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FIELDS_DETAIL_PREFERENCE));
    const { isBusinessFieldsEnabled: isBusinessFieldsEnabled, isScrumProject: isScrumProject } = (0, $egJIx.useJWMListFeatures)();
    const fieldsPreferences = (0, $eUqFw.useMemo)(()=>{
        if (fieldsDetail == null && fields != null) return {
            order: fields,
            details: null
        };
        if (fieldsDetail == null || !Array.isArray(fieldsDetail.order)) return {
            order: (0, $1Te3F.getInitVisibleFields)({
                isCategoryEnabled: isBusinessFieldsEnabled,
                isScrumProject: isScrumProject
            }),
            details: null
        };
        return fieldsDetail;
    }, [
        fieldsDetail,
        fields,
        isBusinessFieldsEnabled,
        isScrumProject
    ]);
    return [
        fieldsPreferences,
        setFields,
        setFieldsOld
    ];
};
const $5966853789054e24$export$4a17407108f98215 = ()=>{
    const [fields, setFields] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FIELDS_PREFERENCE));
    const { isBusinessFieldsEnabled: isBusinessFieldsEnabled, isScrumProject: isScrumProject } = (0, $egJIx.useJWMListFeatures)();
    const fieldsPreferences = (0, $eUqFw.useMemo)(()=>{
        if (fields == null || !Array.isArray(fields)) return (0, $1Te3F.getInitVisibleFields)({
            isCategoryEnabled: isBusinessFieldsEnabled,
            isScrumProject: isScrumProject
        });
        return fields;
    }, [
        fields,
        isBusinessFieldsEnabled,
        isScrumProject
    ]);
    return [
        fieldsPreferences,
        setFields
    ];
};

});



parcelRegister("fXrll", function(module, exports) {

$parcel$export(module.exports, "default", () => $abcdf474eb5d3060$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $abcdf474eb5d3060$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.children-query.error-title",
        "defaultMessage": "We couldn't load items."
    },
    errorMessage: {
        "id": "business-list.controllers.children-query.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("iGWrT", function(module, exports) {

$parcel$export(module.exports, "useSetChildrenItems", () => $45e960eb5c7066b0$export$1d27e69d8e0f02db);

var $eUqFw = parcelRequire("eUqFw");

var $hHiDc = parcelRequire("hHiDc");

var $8gkkx = parcelRequire("8gkkx");

var $5r9Wo = parcelRequire("5r9Wo");
const $45e960eb5c7066b0$export$1d27e69d8e0f02db = ()=>{
    const [, { setChildrenItems: setChildrenItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [rowCreateState, { setRowCreatePosition: setRowCreatePosition }] = (0, $8gkkx.useRowCreateStore)();
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, $hHiDc.useIssueFields)();
    const setChildrenItemsWithDependencies = (0, $eUqFw.useCallback)((parentIssueId, queryData)=>setChildrenItems(parentIssueId, queryData, rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache), [
        setChildrenItems,
        rowCreateState,
        setRowCreatePosition,
        hierarchyLevelsWithCache
    ]);
    return {
        setChildrenItems: setChildrenItemsWithDependencies
    };
};

});
parcelRegister("8gkkx", function(module, exports) {

$parcel$export(module.exports, "useRowCreateStore", () => $ab7138b15ee48bfe$export$b9c0fc956229dde8);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $ab7138b15ee48bfe$var$initialState = {
    parentId: undefined,
    anchorId: undefined
};
const $ab7138b15ee48bfe$var$actions = {
    setRowCreatePosition: (rowCreatePosition)=>({ setState: setState })=>{
            if (rowCreatePosition) setState(rowCreatePosition);
        },
    resetRowCreatePosition: ()=>({ setState: setState })=>setState($ab7138b15ee48bfe$var$initialState)
};
const $ab7138b15ee48bfe$var$ListViewRowCreateStore = (0, $kEDjj.createStore)({
    initialState: $ab7138b15ee48bfe$var$initialState,
    actions: $ab7138b15ee48bfe$var$actions,
    name: 'JWMListViewRowInlineCreate'
});
const $ab7138b15ee48bfe$export$b9c0fc956229dde8 = (0, $1yZQx.createHook)($ab7138b15ee48bfe$var$ListViewRowCreateStore);

});



parcelRegister("xqSqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfae6c6d38ca00fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $dWGNJ = parcelRequire("dWGNJ");

var $hzcvF = parcelRequire("hzcvF");

var $gbsaq = parcelRequire("gbsaq");

var $dSE3z = parcelRequire("dSE3z");

var $6xvBl = parcelRequire("6xvBl");

var $94mYl = parcelRequire("94mYl");

var $iaqLb = parcelRequire("iaqLb");

var $5r9Wo = parcelRequire("5r9Wo");

var $2zwYz = parcelRequire("2zwYz");

var $fTRcw = parcelRequire("fTRcw");
const $bfae6c6d38ca00fc$var$GroupsLoader = ()=>{
    const items = (0, $6xvBl.useListItemGroups)();
    const { childrenLoader: childrenLoader } = (0, $iaqLb.useGroupChildrenLoader)({
        groups: items.data
    });
    const prevItems = (0, $hzcvF.usePreviousWithInitial)(items);
    const [, { expandFirstItems: expandFirstItems }] = (0, $5r9Wo.useHierarchyStore)();
    const { setHierarchyData: setHierarchyData } = (0, $fTRcw.useSetHierarchyData)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    (0, $4G5xU.useQueryBasedViewAutomaticTracking)((0, $gbsaq.LOAD_GROUP_ITEMS_EXPERIENCE), {
        loading: items.loading,
        error: items.error,
        shouldStartExperience: true
    });
    // resets expanded items and queryData cache when filtering/sorting/groupBy is updated
    (0, $2zwYz.useResetItems)();
    // initialize items when switching between grouping -> hierarchy
    (0, $eUqFw.useEffect)(()=>{
        if (items.loading) return;
        setHierarchyData(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items.loading
    ]);
    // updates groups only when "data", "loading", "isLoadingNextPage" or "totalCount" changes
    (0, $eUqFw.useEffect)(()=>{
        if (prevItems.totalCount !== items.totalCount || prevItems.loading !== items.loading || prevItems.data !== items.data || prevItems.isLoadingNextPage !== items.isLoadingNextPage) setHierarchyData(items);
    }, [
        items,
        prevItems,
        setHierarchyData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!items.loading && groupByFieldId != null) expandFirstItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items.loading,
        groupByFieldId
    ]);
    // avoid re-fetching children when GroupsLoader re-renders
    const groupChildrenLoader = (0, $eUqFw.useMemo)(()=>childrenLoader, [
        childrenLoader
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, groupChildrenLoader, items.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: items.error,
        title: (0, $94mYl.default).errorTitle,
        description: (0, $94mYl.default).errorMessage
    }));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$bfae6c6d38ca00fc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($bfae6c6d38ca00fc$var$GroupsLoader);

});
parcelRegister("6xvBl", function(module, exports) {

$parcel$export(module.exports, "useListItemGroups", () => $445faaf6b4924d57$export$cc19d2aa74250242);

var $eZbpk = parcelRequire("eZbpk");

var $7O3Xq = parcelRequire("7O3Xq");

var $dSE3z = parcelRequire("dSE3z");
const $445faaf6b4924d57$export$cc19d2aa74250242 = ()=>{
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    return (0, $7O3Xq.useListItemGroups)({
        input: {
            jqlContext: jqlContext,
            groupByFieldId: groupByFieldId
        }
    });
};

});
parcelRegister("7O3Xq", function(module, exports) {

$parcel$export(module.exports, "getGroupVariables", () => $d09cc729aa650ea5$export$5c591b26f9c07c51);
$parcel$export(module.exports, "useListViewGroupRecovery", () => $d09cc729aa650ea5$export$30e59d989a124a32);
$parcel$export(module.exports, "useListItemGroups", () => $d09cc729aa650ea5$export$cc19d2aa74250242);
/* eslint-disable camelcase */ 
var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $iZuDo = parcelRequire("iZuDo");

var $jGcn0 = parcelRequire("jGcn0");

var $hYxMC = parcelRequire("hYxMC");

var $guiFP = parcelRequire("guiFP");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hzwAr = parcelRequire("hzwAr");

var $26iUh = parcelRequire("26iUh");
const $d09cc729aa650ea5$var$DEFAULT_ITEMS_PER_PAGE = 50;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d09cc729aa650ea5$var$emptyArray = [];
const $d09cc729aa650ea5$var$fieldIds = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID),
    (0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
];
const $d09cc729aa650ea5$export$5c591b26f9c07c51 = ({ groupByFieldId: groupByFieldId, jqlContext: jqlContext })=>{
    const jql = jqlContext || '';
    return {
        jql: jql,
        first: $d09cc729aa650ea5$var$DEFAULT_ITEMS_PER_PAGE,
        groupByFieldId: groupByFieldId != null ? groupByFieldId : '',
        fieldIds: $d09cc729aa650ea5$var$fieldIds
    };
};
const $d09cc729aa650ea5$export$30e59d989a124a32 = (input, settings)=>{
    const variables = $d09cc729aa650ea5$export$5c591b26f9c07c51(input);
    return (0, $hYxMC.useGroupRecovery)({
        settings: settings,
        queryList: (0, $hzwAr.LIST_VIEW_ITEM_GROUPS_QUERY),
        queryBackgroundList: (0, $hzwAr.BACKGROUND_LIST_VIEW_ITEMS_GROUPS_QUERY),
        variables: variables,
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listRecoveryGroupQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in background in list view while grouping'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};
const $d09cc729aa650ea5$export$cc19d2aa74250242 = ({ input: input })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isLoadingNextPage, setIsLoadingNextPage] = (0, $eUqFw.useState)(false);
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $iZuDo.useQuery)((0, $hzwAr.LIST_VIEW_ITEM_GROUPS_QUERY), {
        variables: $d09cc729aa650ea5$export$5c591b26f9c07c51(input),
        onCompleted: (responseData)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'listViewItemGroupsQuery succeeded', {
                groupsCount: responseData.groups?.nodes?.length
            });
        },
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewItemGroupsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch item groups in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const totalCount = data?.groups?.totalCount || 0;
    const nodes = data?.groups?.nodes || $d09cc729aa650ea5$var$emptyArray;
    const hasNextPage = data?.groups?.pageInfo?.hasNextPage || false;
    const endCursor = data?.groups?.pageInfo?.endCursor || '';
    const result = (0, $eUqFw.useMemo)(()=>{
        if (!Array.isArray(nodes) || nodes.length === 0) return [];
        return (0, $26iUh.transformResult)(nodes);
    }, [
        nodes
    ]);
    const loadNextPage = (0, $eUqFw.useCallback)(()=>{
        /*
		 * Do not load the same page twice and do not load the next page if
		 * a request is already in progress.
		 */ if (!hasNextPage || loading) return;
        setIsLoadingNextPage(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'table endReached');
        fetchMore({
            variables: {
                ...$d09cc729aa650ea5$export$5c591b26f9c07c51(input),
                after: endCursor
            },
            // @ts-expect-error - The expected type comes from property 'updateQuery' which is declared here on type 'FetchMoreQueryOptions<JWMListViewItemGroupsWithPaginationVariables, keyof
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                setIsLoadingNextPage(false);
                if (!fetchMoreResult) return prev;
                const updatedNodes = [
                    ...prev?.groups?.nodes || [],
                    ...fetchMoreResult?.groups?.nodes || []
                ];
                return {
                    groups: {
                        ...fetchMoreResult.groups,
                        nodes: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(updatedNodes, 'id')
                    }
                };
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onError: (apolloError)=>{
                (0, $guiFP.default)({
                    meta: {
                        id: 'listViewItemGroupsQuery',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to fetch more item groups in list view'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    }, [
        createAnalyticsEvent,
        endCursor,
        fetchMore,
        hasNextPage,
        input,
        loading
    ]);
    return {
        data: result,
        loading: loading,
        error: error,
        totalCount: totalCount,
        hasNextPage: hasNextPage,
        isLoadingNextPage: isLoadingNextPage,
        loadNextPage: loadNextPage
    };
};

});
parcelRegister("hYxMC", function(module, exports) {

$parcel$export(module.exports, "useGroupRecovery", () => $945eecde7a3a52d2$export$b5990c6f00139390);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $c4MRZ = parcelRequire("c4MRZ");

var $12sJv = parcelRequire("12sJv");

var $guiFP = parcelRequire("guiFP");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $945eecde7a3a52d2$var$MAX_ITEMS_PER_PAGE = 50;
const $945eecde7a3a52d2$var$getOperationName = (query)=>{
    const operation = (0, $c4MRZ.getOperationAST)(query, undefined);
    return operation && operation.name && operation.name.value || '';
};
const $945eecde7a3a52d2$export$b5990c6f00139390 = ({ settings: settings, queryList: queryList, queryBackgroundList: queryBackgroundList, variables: variables, onError: onError })=>{
    const analyticsTaskId = $945eecde7a3a52d2$var$getOperationName(queryBackgroundList);
    const analyticsTaskName = 'groupsBackgroundRefetch';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const backgroundQueryVariables = (0, $eUqFw.useMemo)(()=>({
            ...variables,
            first: $945eecde7a3a52d2$var$MAX_ITEMS_PER_PAGE
        }), [
        variables
    ]);
    const client = (0, $iZuDo.useApolloClient)();
    const [fetchListInBackground, { loading: loading, data: data, fetchMore: fetchMore }] = (0, $iZuDo.useLazyQuery)(queryBackgroundList, {
        fetchPolicy: 'network-only',
        onError: onError
    });
    const [hasStarted, setHasStarted] = (0, $eUqFw.useState)(false);
    const [hasFinished, setHasFinished] = (0, $eUqFw.useState)(false);
    const [refreshCount, setRefreshCount] = (0, $eUqFw.useState)(0);
    const [currentQuery, setCurrentQuery] = (0, $eUqFw.useState)();
    const [currentGroup, setCurrentGroup] = (0, $eUqFw.useState)();
    const listEndCursor = (0, $eUqFw.useRef)(undefined);
    const { hasNextPage: hasNextPage, endCursor: endCursor } = data?.backgroundGroups?.pageInfo || {};
    const prevEndCursor = (0, $hzcvF.usePreviousWithInitial)(endCursor);
    // refetch all pages until the current endCursor: if we have 5 pages in total, list endCursor is on page 2,
    // then background refresh will pull first 2 pages only
    (0, $eUqFw.useEffect)(()=>{
        if (hasStarted && hasNextPage && // query pages one-by-one until we reach the current page
        endCursor !== listEndCursor.current && // query pages only when endCursor changes,
        // otherwise it might query the same page multiple times due to re-renders of useListRecovery
        endCursor !== prevEndCursor) fetchMore({
            variables: {
                ...backgroundQueryVariables,
                after: endCursor
            },
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult) return prev;
                const updatedNodes = [
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ...prev?.backgroundGroups?.nodes || [],
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ...fetchMoreResult?.backgroundGroups?.nodes || []
                ];
                return {
                    backgroundGroups: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ...fetchMoreResult.backgroundGroups,
                        nodes: updatedNodes
                    }
                };
            }
        });
    }, [
        hasStarted,
        hasNextPage,
        endCursor,
        prevEndCursor,
        fetchListInBackground,
        backgroundQueryVariables,
        fetchMore
    ]);
    // abort background operations if a new query is provided
    (0, $eUqFw.useEffect)(()=>{
        if (!hasStarted || variables.jql === currentQuery && variables.groupByFieldId === currentGroup) return;
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskAbort', {
            task: analyticsTaskName,
            taskId: analyticsTaskId,
            reason: 'query has changed'
        });
        setHasFinished(true);
        setHasStarted(false);
        setCurrentQuery(undefined);
        setCurrentGroup(undefined);
    }, [
        analyticsTaskId,
        createAnalyticsEvent,
        currentGroup,
        currentQuery,
        hasStarted,
        variables,
        variables.groupByFieldId,
        variables.jql
    ]);
    // replace list items with backgroundList items so the main view will update
    (0, $eUqFw.useEffect)(()=>{
        if (hasStarted && !hasFinished && !loading && listEndCursor.current === endCursor) try {
            const backgroundListData = client.readQuery({
                query: queryBackgroundList,
                variables: backgroundQueryVariables
            });
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: queryList,
                        variables: variables
                    });
                    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName,
                        taskId: analyticsTaskId
                    });
                    return read;
                } catch (e) {
                    (0, $guiFP.default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'useGroupRecovery',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            taskId: analyticsTaskId,
                            query: JSON.stringify(queryList),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const listData = getCachedListData();
            setRefreshCount(refreshCount + 1);
            setHasFinished(true);
            setHasStarted(false);
            setCurrentQuery(undefined);
            setCurrentGroup(undefined);
            if (!backgroundListData || backgroundListData.backgroundGroups == null || !listData || listData.groups == null || !Array.isArray(backgroundListData.backgroundGroups.nodes) || !Array.isArray(listData.groups.nodes)) throw new Error('Conditions not met');
            const { backgroundGroups: backgroundGroups } = backgroundListData;
            if (backgroundGroups.nodes == null) return;
            client.writeQuery({
                query: queryList,
                variables: variables,
                data: {
                    groups: {
                        ...backgroundGroups,
                        nodes: backgroundGroups.nodes
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskSuccess', {
                task: analyticsTaskName,
                taskId: analyticsTaskId,
                details: `${backgroundGroups.nodes.length} items updated`
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
                task: analyticsTaskName,
                taskId: analyticsTaskId,
                error: `Failed to refresh data in the background (${e.name || 'error'})`
            });
        }
    }, [
        hasStarted,
        client,
        loading,
        hasFinished,
        refreshCount,
        backgroundQueryVariables,
        queryList,
        queryBackgroundList,
        variables,
        createAnalyticsEvent,
        analyticsTaskId,
        endCursor
    ]);
    const refreshList = (0, $eUqFw.useCallback)(()=>{
        if (hasStarted && !hasFinished || settings.isDisabled) return;
        const listData = client.readQuery({
            query: queryList,
            variables: variables
        });
        // store current list endCursor so that we know at what page to stop backgroundList fetching
        listEndCursor.current = listData?.groups?.pageInfo?.endCursor;
        fetchListInBackground({
            variables: backgroundQueryVariables
        });
        setCurrentQuery(variables.jql);
        setCurrentGroup(variables.groupByFieldId);
        setHasStarted(true);
        setHasFinished(false);
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskStart', {
            task: analyticsTaskName,
            taskId: analyticsTaskId
        });
    }, [
        analyticsTaskId,
        backgroundQueryVariables,
        client,
        createAnalyticsEvent,
        fetchListInBackground,
        hasFinished,
        hasStarted,
        queryList,
        settings.isDisabled,
        variables
    ]);
    const isRefreshing = hasStarted && !hasFinished;
    (0, $12sJv.useRefreshInterval)(refreshList, // it won't trigger a refresh if another has been triggered
    // it won't trigger refresh if the tab is invisible
    settings.isVisible && !isRefreshing, settings.updateInterval);
    return {
        isRefreshing: isRefreshing,
        refreshCount: refreshCount,
        refreshList: refreshList
    };
};

});

parcelRegister("hzwAr", function(module, exports) {

$parcel$export(module.exports, "LIST_VIEW_ITEM_GROUPS_QUERY", () => $b9b4939e9b1787b5$export$ee6c63a9d588e5da);
$parcel$export(module.exports, "BACKGROUND_LIST_VIEW_ITEMS_GROUPS_QUERY", () => $b9b4939e9b1787b5$export$1531880e8d0ec6bc);

var $9ypom = parcelRequire("9ypom");

var $k2u2Z = parcelRequire("k2u2Z");
const $b9b4939e9b1787b5$export$ee6c63a9d588e5da = (0, $9ypom.default)`
    query JWMListViewItemGroupsWithPagination ($jql: String!, $groupByFieldId: ID!, $fieldIds: [String]!, $first: Int, $last: Int, $before: String, $after: String) {
        groups: jwmItemGroups(jql: $jql, groupByFieldId: $groupByFieldId, fieldIds: $fieldIds, first: $first, last: $last, before: $before, after: $after) @connection (key: "groups", filter:["jql", "groupByFieldId"]) {
            totalCount
            nodes {
                id
                field {
                    __typename
                    ...on StatusField {
                        fieldKey
                        name
                        statusId
                        statusCategoryId
                    }
                    ... on PriorityField {
                        fieldKey
                        name
                        id
                        iconUrl
                    }
                    ... on UserField {
                        fieldKey
                        userValue {
                            displayName
                            avatarUrl
                            accountId
                        }
                    }
                    ... on JWMCategoryCustomField {
                        fieldKey
                        selectedValue {
                            optionId
                            value
                        }
                        category {
                            ...JwmCategoryOptionsFragment
                        }
                    }
                    ... on SelectCustomField {
                        fieldKey
                        selectedValue {
                          optionId
                          value
                        }
                    }
                    ... on FloatCustomField {
                        fieldKey
                        floatValue
                    }
                    ... on SprintCustomField {
                        fieldKey
                        title
                        values {
                            id
                            name
                            state
                        }
                    }
                }
                totalCount
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
    ${(0, $k2u2Z.JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;
const $b9b4939e9b1787b5$export$1531880e8d0ec6bc = (0, $9ypom.default)`
    query JiraBusinessBackgroundListViewItemGroupsWithPagination ($jql: String!, $groupByFieldId: ID!, $fieldIds: [String]!, $first: Int, $last: Int, $before: String, $after: String) {
        backgroundGroups: jwmItemGroups(jql: $jql, groupByFieldId: $groupByFieldId, fieldIds: $fieldIds, first: $first, last: $last, before: $before, after: $after) @connection (key: "backgroundGroups", filter:["jql", "groupByFieldId"]) {
            totalCount
            nodes {
                id
                field {
                    __typename
                    ...on StatusField {
                        fieldKey
                        name
                        statusId
                        statusCategoryId
                    }
                    ... on PriorityField {
                        fieldKey
                        name
                        id
                        iconUrl
                    }
                    ... on UserField {
                        fieldKey
                        userValue {
                            displayName
                            avatarUrl
                            accountId
                        }
                    }
                    ... on JWMCategoryCustomField {
                        fieldKey
                        selectedValue {
                            optionId
                            value
                        }
                        category {
                            ...JwmCategoryOptionsFragment
                        }
                    }
                    ... on SelectCustomField {
                        fieldKey
                        selectedValue {
                          optionId
                          value
                        }
                    }
                    ... on FloatCustomField {
                        fieldKey
                        floatValue
                    }
                    ... on SprintCustomField {
                        fieldKey
                        title
                        values {
                            id
                            name
                            state
                        }
                    }
                }
                totalCount
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
    ${(0, $k2u2Z.JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;

});
parcelRegister("k2u2Z", function(module, exports) {

$parcel$export(module.exports, "JWM_CATEGORY_OPTIONS_FRAGMENT", () => $c539c000b5100098$export$61519670a3514192);

var $9ypom = parcelRequire("9ypom");
const $c539c000b5100098$export$61519670a3514192 = (0, $9ypom.default)`
    fragment JwmCategoryOptionsFragment on JiraWorkManagementCategoryOption {
        id
        color
        option {
            id
            optionId
            value
            isDisabled
        }
    }
`;

});


parcelRegister("26iUh", function(module, exports) {

$parcel$export(module.exports, "createGroupIssueId", () => $119f79f94d421d34$export$4ac2cce4af64b535);
$parcel$export(module.exports, "transformResult", () => $119f79f94d421d34$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "getGroupQuery", () => $119f79f94d421d34$export$399b257fbf191156);
$parcel$export(module.exports, "findItemGroup", () => $119f79f94d421d34$export$326ed4587250ed11);
$parcel$export(module.exports, "createItemGroup", () => $119f79f94d421d34$export$c8d5f559d504cbde);
/* eslint-disable camelcase */ 
var $hompL = parcelRequire("hompL");

var $lF3sI = parcelRequire("lF3sI");

var $jGcn0 = parcelRequire("jGcn0");

var $3uSNh = parcelRequire("3uSNh");

var $7Sz8O = parcelRequire("7Sz8O");

var $4oWxH = parcelRequire("4oWxH");

var $eI5EY = parcelRequire("eI5EY");

var $huI7r = parcelRequire("huI7r");

var $lO4Or = parcelRequire("lO4Or");
const $119f79f94d421d34$export$4ac2cce4af64b535 = (nodeId)=>`${0, $7Sz8O.GROUP_ITEM_PREFIX}_${nodeId}`;
const $119f79f94d421d34$export$eb0e89edd4882353 = (statusIdPath = '')=>{
    if (statusIdPath == null) return '';
    const splitStatusIdPath = statusIdPath.split('/');
    return splitStatusIdPath[splitStatusIdPath.length - 1];
};
const $119f79f94d421d34$var$getCategory = (field)=>{
    if (field && 'category' in field && field.category != null && field.category.option != null) return {
        fieldKey: field.fieldKey,
        name: field.category.option.value,
        optionId: field.category.option.optionId,
        color: field.category.color ?? null
    };
    return {};
};
const $119f79f94d421d34$var$getStoryPoints = (field)=>field?.__typename === 'FloatCustomField' && 'floatValue' in field ? field.floatValue : null;
const $119f79f94d421d34$var$getSprint = (field)=>{
    if (field && field.__typename === 'SprintCustomField' && field.values && field.values[0]) return {
        fieldKey: field.fieldKey,
        title: field.title,
        id: field.values[0].id,
        name: field.values[0].name,
        state: field.values[0].state
    };
    return null;
};
const $119f79f94d421d34$export$f13b29f9ed0c5a03 = (nodes)=>{
    if (!nodes) return [];
    return nodes.map((node)=>{
        const { id: id, field: field } = node || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const values = {};
        if (field && 'fieldKey' in field && field.fieldKey != null) values[field.fieldKey] = field;
        const totalCount = node?.totalCount;
        const groupItem = {
            id: id,
            issueId: $119f79f94d421d34$export$4ac2cce4af64b535(id || ''),
            key: '',
            typeId: '',
            issuetype: {},
            rank: '',
            status: values.status ? {
                id: values.status.statusId,
                name: values.status.name,
                categoryId: values.status.statusCategoryId
            } : {},
            ...values.assignee ? values.assignee.userValue && {
                assignee: {
                    accountId: values.assignee.userValue.accountId,
                    displayName: values.assignee.userValue.displayName,
                    avatarUrl: values.assignee.userValue.avatarUrl
                }
            } : {},
            labels: values.labels && values.labels.labels || [],
            priority: values.priority ? {
                id: values.priority.id,
                name: values.priority.name,
                iconUrl: values.priority.iconUrl
            } : {},
            category: $119f79f94d421d34$var$getCategory(field),
            childSummary: {
                totalCount: totalCount,
                hasChildren: (totalCount ?? 0) > 0
            },
            storypoints: $119f79f94d421d34$var$getStoryPoints(field),
            storypointestimate: $119f79f94d421d34$var$getStoryPoints(field),
            sprint: $119f79f94d421d34$var$getSprint(field)
        };
        return groupItem;
    });
};
const $119f79f94d421d34$export$399b257fbf191156 = ({ groupIssueId: groupIssueId, groupByFieldId: groupByFieldId, groups: groups })=>{
    if (!groups || !groupByFieldId) return undefined;
    const groupItem = groups.find((group)=>group.issueId === groupIssueId);
    if (!groupItem) return undefined;
    if (groupByFieldId === (0, $lO4Or.ASSIGNEE_TYPE)) return {
        jqlTerm: (0, $lO4Or.ASSIGNEE_TYPE),
        value: groupItem.assignee?.accountId
    };
    if (groupByFieldId === (0, $lO4Or.PRIORITY_TYPE)) {
        const priorityId = groupItem?.priority?.id;
        return {
            jqlTerm: (0, $lO4Or.PRIORITY_TYPE),
            value: priorityId ? (0, $huI7r.getAriConfig)(priorityId).resourceId : undefined
        };
    }
    if (groupByFieldId === (0, $lO4Or.STATUS_TYPE)) {
        if ((0, $eI5EY.fg)('jwm_conditional_workflow_data_loading')) {
            const statusId = groupItem?.status?.id;
            return {
                jqlTerm: (0, $lO4Or.STATUS_TYPE),
                value: statusId ? (0, $huI7r.getAriConfig)(statusId).resourceId : undefined
            };
        }
        const statusAri = (0, $huI7r.getAriConfig)(groupItem?.status?.id ?? '');
        return {
            jqlTerm: (0, $lO4Or.STATUS_TYPE),
            value: statusAri?.resourceId
        };
    }
    if (groupByFieldId.startsWith('customfield_')) {
        const getValue = ()=>{
            if (groupItem.category) {
                const categoryName = groupItem.category?.name ?? undefined;
                if (categoryName) // wrap with quotes and escape quotes
                return `"${categoryName.replace(/"/g, '\\"')}"`;
            }
            if (typeof groupItem.storypoints === 'number') return groupItem.storypoints;
            if (typeof groupItem.storypointestimate === 'number') return groupItem.storypointestimate;
            if (groupItem.sprint) return groupItem.sprint && String(groupItem.sprint?.id) || undefined;
            return undefined;
        };
        return {
            jqlTerm: (0, $lF3sI.getJqlTerm)(groupByFieldId),
            value: getValue()
        };
    }
    return undefined;
};
const $119f79f94d421d34$export$326ed4587250ed11 = ({ item: item, groups: groups, groupByFieldId: groupByFieldId, isGroupingByCategory: isGroupingByCategory = false })=>{
    if (!groups || !groupByFieldId) return undefined;
    const field = (0, $3uSNh.getFieldValue)(item.fields, groupByFieldId);
    // if item doesn't support category field but list is grouped by category, return the uncategorized group
    if (!field && isGroupingByCategory) return groups.find((group)=>!group.category?.name);
    return groups.find((group)=>{
        switch(field?.type){
            case 0, $lO4Or.CATEGORY_TYPE:
                return String(group?.category?.optionId) === String((0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'fieldOption', undefined)?.optionId);
            case 0, $lO4Or.ASSIGNEE_TYPE:
                return groupByFieldId && group.assignee?.accountId === (0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'user', undefined)?.accountId;
            case 0, $lO4Or.STATUS_TYPE:
                return groupByFieldId && $119f79f94d421d34$export$eb0e89edd4882353(group.status?.id) === (0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'status.statusId', undefined);
            case 0, $lO4Or.PRIORITY_TYPE:
                return groupByFieldId && group.priority?.name === (0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'priority.name', undefined);
            case 0, $lO4Or.SPRINT_TYPE:
                return $119f79f94d421d34$var$getSprintGroup(item, group);
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return groupByFieldId && group.storypointestimate === (0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'number', undefined);
            case 0, $lO4Or.NUMBER_CF_TYPE:
                if (field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return groupByFieldId && group.storypoints === (0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'number', undefined);
                return false;
            default:
                return false;
        }
    });
};
const $119f79f94d421d34$var$getSprintGroup = (item, group)=>{
    const sprintId = (0, $3uSNh.safeGetValue)(item.fields, 'sprint', 'selectedSprintsConnection.edges[0].node.sprintId', undefined);
    if (!sprintId) return group.sprint === null;
    return group.sprint?.id === Number(sprintId);
};
const $119f79f94d421d34$export$c86575e2d4de1020 = ({ item: item, groupItemsQueryData: groupItemsQueryData })=>{
    if (!groupItemsQueryData) return undefined;
    const keys = Object.keys(groupItemsQueryData);
    // an issue can be in multiple groups due to hierarchy items appearing at all levels
    const matchingGroups = keys.filter((groupIssueId)=>// data could be undefined if is loading
        groupItemsQueryData[groupIssueId].data?.find((node)=>node.issueId === item.issueId));
    return matchingGroups.find((groupName)=>(0, $4oWxH.isGroupItem)(groupName)) ?? matchingGroups[0];
};
const $119f79f94d421d34$var$convertFieldToGroupItemField = (groupByFieldId, field)=>{
    if (groupByFieldId === (0, $lO4Or.ASSIGNEE_TYPE) && field) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const userField = field;
        const convertedField = {
            fieldKey: groupByFieldId,
            userValue: {
                accountId: userField.user?.accountId ?? null,
                displayName: userField.user?.name ?? null,
                avatarUrl: userField.user?.picture,
                __typename: 'UserValue'
            },
            __typename: 'UserField'
        };
        return convertedField;
    }
    if (groupByFieldId === (0, $lO4Or.PRIORITY_TYPE) && field) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const priorityField = field;
        const convertedField = {
            fieldKey: groupByFieldId,
            name: priorityField.priority?.name ?? null,
            id: priorityField.priority?.id ?? null,
            iconUrl: priorityField.priority?.iconUrl,
            __typename: 'PriorityField'
        };
        return convertedField;
    }
    if (groupByFieldId?.startsWith('customfield_') && field) {
        if (field.__typename === 'JiraSingleSelectField' && field.type === (0, $lO4Or.CATEGORY_TYPE)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const categoryField = field;
            if (categoryField.fieldOption) {
                const convertedField = {
                    category: {
                        color: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        categoryField.fieldOption?.color?.colorKey ?? null,
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                        option: {
                            id: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                            isDisabled: false,
                            optionId: categoryField.fieldOption.optionId,
                            value: categoryField.fieldOption.value,
                            __typename: 'JiraOption'
                        },
                        __typename: 'JiraWorkManagementCategoryOption'
                    },
                    selectedValue: {
                        optionId: categoryField.fieldOption.optionId,
                        value: categoryField.fieldOption.value ?? '',
                        __typename: 'Option'
                    },
                    fieldKey: field.fieldId,
                    __typename: 'JWMCategoryCustomField'
                };
                return convertedField;
            }
        }
        if (field.__typename === 'JiraNumberField') {
            const convertedField = {
                fieldKey: field.fieldId,
                floatValue: field.number,
                __typename: 'FloatCustomField'
            };
            return convertedField;
        }
    }
    return field;
};
const $119f79f94d421d34$export$c8d5f559d504cbde = ({ item: item, groupByFieldId: groupByFieldId })=>{
    if (!item || !groupByFieldId) return undefined;
    let field = (0, $3uSNh.getFieldValue)(item.fields, groupByFieldId);
    if (!field) return;
    if (field && groupByFieldId) // TODO: Remove this part once JER-321 is done.
    field = $119f79f94d421d34$var$convertFieldToGroupItemField(groupByFieldId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    field);
    return {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
        field: field,
        totalCount: 1,
        __typename: 'JWMItemGroup'
    };
};

});



parcelRegister("94mYl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f283e4cd7d178c16$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f283e4cd7d178c16$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.with-grouping.error-title",
        "defaultMessage": "We couldn't load item groups."
    },
    errorMessage: {
        "id": "business-list.controllers.with-grouping.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});

parcelRegister("iaqLb", function(module, exports) {

$parcel$export(module.exports, "useGroupChildrenLoader", () => $99df389ad462343b$export$2f8ce4dc0f882a8a);

var $eUqFw = parcelRequire("eUqFw");

var $4oWxH = parcelRequire("4oWxH");

var $dSE3z = parcelRequire("dSE3z");

var $fLPR5 = parcelRequire("fLPR5");

var $5r9Wo = parcelRequire("5r9Wo");

var $iGWrT = parcelRequire("iGWrT");
const $99df389ad462343b$export$2f8ce4dc0f882a8a = ({ groups: groups })=>{
    const [{ expandedItems: expandedItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const { setChildrenItems: setChildrenItems } = (0, $iGWrT.useSetChildrenItems)();
    const childrenLoader = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fLPR5.GroupItemsController), {
            expandedGroupItemIssueIds: Object.keys(expandedItems).filter((0, $4oWxH.isGroupItem)),
            groupByFieldId: groupByFieldId,
            onDataChange: setChildrenItems,
            groups: groups
        }), [
        expandedItems,
        groupByFieldId,
        groups,
        setChildrenItems
    ]);
    return {
        childrenLoader: childrenLoader
    };
};

});
parcelRegister("fLPR5", function(module, exports) {

$parcel$export(module.exports, "GroupItemsController", () => $c6476a52a7960413$export$bf0c6c1ff455a90f);

var $eUqFw = parcelRequire("eUqFw");

var $26iUh = parcelRequire("26iUh");

var $bDdX6 = parcelRequire("bDdX6");
const $c6476a52a7960413$export$bf0c6c1ff455a90f = /*#__PURE__*/ (0, $eUqFw.memo)(({ expandedGroupItemIssueIds: expandedGroupItemIssueIds, groupByFieldId: groupByFieldId, groups: groups, onDataChange: onDataChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, expandedGroupItemIssueIds.map((expandedGroupItemIssueId)=>{
        const groupQuery = (0, $26iUh.getGroupQuery)({
            groups: groups,
            groupIssueId: expandedGroupItemIssueId,
            groupByFieldId: groupByFieldId
        });
        if (!groupQuery) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDdX6.GroupItemsQueryController), {
            groupIssueId: expandedGroupItemIssueId,
            onDataChange: onDataChange,
            key: expandedGroupItemIssueId,
            groupQuery: groupQuery
        });
    })), // Only re-render when expandedGroupItemIssueIds or onDataChange changes
(prevProps, nextProps)=>{
    const prevIssueIds = prevProps.expandedGroupItemIssueIds.sort();
    const nextIssueIds = nextProps.expandedGroupItemIssueIds.sort();
    return prevProps.onDataChange === nextProps.onDataChange && prevIssueIds.length === nextIssueIds.length && prevIssueIds.every((_, id)=>prevIssueIds[id] === nextIssueIds[id]);
});

});
parcelRegister("bDdX6", function(module, exports) {

$parcel$export(module.exports, "GroupItemsQueryController", () => $c3396a80970f7e98$export$e689a28b990fb20b);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $dWGNJ = parcelRequire("dWGNJ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gbsaq = parcelRequire("gbsaq");

var $f8ADw = parcelRequire("f8ADw");

var $hHiDc = parcelRequire("hHiDc");

var $aqGaJ = parcelRequire("aqGaJ");

var $kntjE = parcelRequire("kntjE");
const $c3396a80970f7e98$export$e689a28b990fb20b = /*#__PURE__*/ (0, $eUqFw.memo)(({ groupIssueId: groupIssueId, groupQuery: groupQuery, onDataChange: onDataChange })=>{
    const { hierarchyParent: hierarchyParent } = (0, $aqGaJ.useHierarchyConfig)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems, jqlErrors: jqlErrors } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const isValidFiltersJql = !jqlErrors.length;
    let projectKey;
    if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const projectData = (0, $kQAZu.useProject)();
        projectKey = projectData.key;
    }
    const { getQueryFieldIds: getQueryFieldIds, loading: isLoadingFields, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $hHiDc.useIssueFields)();
    const { data: data, loading: isLoadingItems, error: error, loadNextPage: loadNextPage, hasNextPage: hasNextPage, isLoadingNextPage: isLoadingNextPage } = (0, $f8ADw.useListViewIssues)({
        input: {
            jqlContext: jqlContext,
            fieldIds: getQueryFieldIds(),
            quickFiltersJql: quickFiltersJql,
            sorting: sorting,
            groupQuery: groupQuery,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            projectIdOrKey: projectKey,
            isParentFieldVisible: isParentFieldVisible(),
            isDevSummaryFieldVisible: isDevSummaryFieldVisible()
        },
        condition: isLoadingFields === false && isValidFiltersJql
    });
    const loading = !isValidFiltersJql ? false : isLoadingFields || isLoadingItems;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const totalIssues = data?.length;
    (0, $4G5xU.useQueryBasedViewAutomaticTracking)((0, $gbsaq.LOAD_GROUP_ITEMS_CHILDREN_EXPERIENCE), {
        loading: loading,
        error: error,
        shouldStartExperience: true
    });
    (0, $eUqFw.useEffect)(()=>{
        if (loading || typeof totalIssues !== 'number') return;
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'listGroupItemsQuery succeeded', {
            totalIssues: totalIssues
        });
    }, [
        loading,
        createAnalyticsEvent,
        totalIssues
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'listGroupItemsQuery',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: 'Failed to query group items in list view'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (jqlErrors.length) (0, $guiFP.default)({
            meta: {
                id: 'listGroupItemsQuery',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: 'Error in the JQL query'
            },
            error: jqlErrors[0],
            skipSentry: true
        });
    }, [
        jqlErrors
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onDataChange(groupIssueId, {
            data: data,
            loading: loading,
            error: error,
            loadNextPage: loadNextPage,
            isLoadingNextPage: isLoadingNextPage,
            hasNextPage: hasNextPage
        });
    }, [
        data,
        error,
        loading,
        loadNextPage,
        isLoadingNextPage,
        onDataChange,
        groupIssueId,
        hasNextPage
    ]);
    return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $kntjE.default).errorTitle,
        description: (0, $kntjE.default).errorMessage
    }) : null;
});

});
parcelRegister("aqGaJ", function(module, exports) {

$parcel$export(module.exports, "useHierarchyConfig", () => $d73448afed1a6ac7$export$4691cc2dea373ff0);


var $lGxgz = parcelRequire("lGxgz");

var $eI5EY = parcelRequire("eI5EY");

var $dSE3z = parcelRequire("dSE3z");
const $d73448afed1a6ac7$export$4691cc2dea373ff0 = ()=>{
    const { isFiltering: isFiltering } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const hierarchyParent = !isFiltering ? (0, $2a7b21c0842403e6$export$9355e489ad16f98e) : undefined;
    if ((0, $eI5EY.fg)('flat_lists_in_groups')) {
        const showFlatList = isFiltering || groupByFieldId != null;
        return {
            showFlatList: showFlatList,
            hierarchyParent: showFlatList ? undefined : hierarchyParent
        };
    }
    return {
        showFlatList: isFiltering,
        hierarchyParent: hierarchyParent
    };
};

});

parcelRegister("kntjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c9581159a48b09b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5c9581159a48b09b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.group-items-query.error-title",
        "defaultMessage": "We couldn't load group items."
    },
    errorMessage: {
        "id": "business-list.controllers.group-items-query.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});




parcelRegister("2zwYz", function(module, exports) {

$parcel$export(module.exports, "useResetItems", () => $2e5307c4489ed688$export$266465ecb6779ef7);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $lGxgz = parcelRequire("lGxgz");

var $lEWmB = parcelRequire("lEWmB");

var $9GlEj = parcelRequire("9GlEj");

var $dSE3z = parcelRequire("dSE3z");

var $5r9Wo = parcelRequire("5r9Wo");
const $2e5307c4489ed688$export$266465ecb6779ef7 = ()=>{
    const { sorting: sorting } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const { quickFiltersJql: quickFiltersJql } = (0, $9GlEj.useQuickFilters)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const [{ hierarchyData: { loading: loading } }, { resetCache: resetCache, clearHierarchyData: clearHierarchyData }] = (0, $5r9Wo.useHierarchyStore)();
    const projectData = (0, $kQAZu.useProject)();
    const projectKey = projectData.key;
    const lastSorting = (0, $eUqFw.useRef)({
        ...sorting
    });
    const lastJqlFiltering = (0, $eUqFw.useRef)(jql);
    const lastQuickFilterJql = (0, $eUqFw.useRef)(quickFiltersJql);
    const lastGroupByFieldId = (0, $eUqFw.useRef)(groupByFieldId);
    (0, $eUqFw.useEffect)(()=>{
        if (loading) return;
        const hasSortingChanged = lastSorting.current.sortBy !== sorting.sortBy || lastSorting.current.direction !== sorting.direction;
        const hasFilteringChanged = lastJqlFiltering.current !== jql || lastQuickFilterJql.current !== quickFiltersJql;
        const hasGroupByFieldIdChanged = lastGroupByFieldId.current !== groupByFieldId;
        if (hasGroupByFieldIdChanged || hasSortingChanged || hasFilteringChanged) {
            resetCache();
            // update last reference
            lastSorting.current = sorting;
            lastJqlFiltering.current = jql;
            lastQuickFilterJql.current = quickFiltersJql;
            lastGroupByFieldId.current = groupByFieldId;
        }
    }, [
        groupByFieldId,
        loading,
        sorting,
        resetCache,
        jql,
        quickFiltersJql
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Reset hierarchy data when navigate across projects
        clearHierarchyData();
    }, [
        projectKey,
        clearHierarchyData
    ]);
};

});

parcelRegister("fTRcw", function(module, exports) {

$parcel$export(module.exports, "useSetHierarchyData", () => $3c05167fde49e43c$export$b96814cd86fd4960);

var $eUqFw = parcelRequire("eUqFw");

var $hHiDc = parcelRequire("hHiDc");

var $8gkkx = parcelRequire("8gkkx");

var $aqGaJ = parcelRequire("aqGaJ");

var $5r9Wo = parcelRequire("5r9Wo");
const $3c05167fde49e43c$export$b96814cd86fd4960 = ()=>{
    const [, { setHierarchyData: setHierarchyData, refreshHierarchy: refreshHierarchy }] = (0, $5r9Wo.useHierarchyStore)();
    const [rowCreateState, { setRowCreatePosition: setRowCreatePosition }] = (0, $8gkkx.useRowCreateStore)();
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, $hHiDc.useIssueFields)();
    const { showFlatList: showFlatList } = (0, $aqGaJ.useHierarchyConfig)();
    (0, $eUqFw.useEffect)(()=>{
        refreshHierarchy(rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache);
    }, [
        rowCreateState,
        setRowCreatePosition,
        hierarchyLevelsWithCache,
        refreshHierarchy
    ]);
    const setHierarchyDataWithDependencies = (0, $eUqFw.useCallback)((queryData)=>setHierarchyData(queryData, rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache, showFlatList), [
        setHierarchyData,
        rowCreateState,
        setRowCreatePosition,
        hierarchyLevelsWithCache,
        showFlatList
    ]);
    return {
        setHierarchyData: setHierarchyDataWithDependencies
    };
};

});


parcelRegister("kBwul", function(module, exports) {

$parcel$export(module.exports, "default", () => $96ede29ffd923480$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $guiFP = parcelRequire("guiFP");

var $bKxX9 = parcelRequire("bKxX9");

var $dWGNJ = parcelRequire("dWGNJ");

var $hzcvF = parcelRequire("hzcvF");

var $gbsaq = parcelRequire("gbsaq");

var $f8ADw = parcelRequire("f8ADw");

var $gfhub = parcelRequire("gfhub");

var $hHiDc = parcelRequire("hHiDc");

var $aqGaJ = parcelRequire("aqGaJ");

var $5r9Wo = parcelRequire("5r9Wo");

var $2zwYz = parcelRequire("2zwYz");

var $fTRcw = parcelRequire("fTRcw");

var $afRND = parcelRequire("afRND");
const $96ede29ffd923480$export$9e1fb4c88b271603 = ()=>{
    const [{ hierarchyLevel: hierarchyLevel }, { resetHierarchyLevel: resetHierarchyLevel, setHierarchyLevel: setHierarchyLevel }] = (0, $gfhub.useHierarchyLevel)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems, jqlErrors: jqlErrors } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { showFlatList: showFlatList, hierarchyParent: hierarchyParent } = (0, $aqGaJ.useHierarchyConfig)();
    const prevShowFlatList = (0, $hzcvF.usePreviousWithInitial)(showFlatList);
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache, getQueryFieldIds: getQueryFieldIds, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $hHiDc.useIssueFields)();
    const queryFieldIds = getQueryFieldIds();
    const isValidFiltersJql = !jqlErrors.length;
    let projectKey;
    if ((0, $bKxX9.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const projectData = (0, $kQAZu.useProject)();
        projectKey = projectData.key;
    }
    // fetch issues based on `hierarchyLevel` - regardless of issue types
    const items = (0, $f8ADw.useListViewIssues)({
        input: {
            jqlContext: jqlContext,
            quickFiltersJql: quickFiltersJql,
            fieldIds: queryFieldIds,
            sorting: sorting,
            hierarchyLevel: hierarchyLevel,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            projectIdOrKey: projectKey,
            isParentFieldVisible: isParentFieldVisible(),
            isDevSummaryFieldVisible: isDevSummaryFieldVisible()
        },
        condition: typeof hierarchyLevel === 'number' && queryFieldIds.length > 0 && isValidFiltersJql
    });
    (0, $eUqFw.useEffect)(()=>{
        if (hierarchyLevel == null && hierarchyLevelsWithCache.length) setHierarchyLevel(hierarchyLevelsWithCache[0].level);
    }, [
        hierarchyLevel,
        hierarchyLevelsWithCache,
        setHierarchyLevel
    ]);
    // reset hierarchyLevel to the top level when filtering change
    (0, $eUqFw.useEffect)(()=>{
        if (hierarchyLevelsWithCache.length && prevShowFlatList && !showFlatList) setHierarchyLevel(hierarchyLevelsWithCache[0].level);
    }, [
        showFlatList,
        prevShowFlatList,
        setHierarchyLevel,
        hierarchyLevelsWithCache
    ]);
    // reset hierarchyLevel on unmount
    (0, $eUqFw.useEffect)(()=>()=>resetHierarchyLevel(), []); // eslint-disable-line react-hooks/exhaustive-deps
    const levels = (0, $eUqFw.useMemo)(()=>[
            ...new Set(hierarchyLevelsWithCache.map((x)=>x.level))
        ], [
        hierarchyLevelsWithCache
    ]);
    // When BE service returns empty response from top level items query
    // We take next hierarchy level and re-fetch items... until BE returs some data, or we reach the bottom hierarchy level
    (0, $eUqFw.useEffect)(()=>{
        if (!items.loading && !items.data.length && hierarchyLevel != null) {
            const nextIndex = levels.indexOf(hierarchyLevel) + 1;
            if (typeof levels[nextIndex] === 'number') setHierarchyLevel(levels[nextIndex]);
        }
    }, [
        hierarchyLevel,
        levels,
        items.data.length,
        items.loading,
        setHierarchyLevel
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (jqlErrors.length) (0, $guiFP.default)({
            meta: {
                id: 'listHierarchyLoader',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: 'Error in the JQL query'
            },
            error: jqlErrors[0],
            skipSentry: true
        });
    }, [
        jqlErrors
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            ...items,
            loading: isValidFiltersJql ? items.loading : false
        }), [
        items,
        isValidFiltersJql
    ]);
};
const $96ede29ffd923480$var$HierarchyLoader = ()=>{
    const items = $96ede29ffd923480$export$9e1fb4c88b271603();
    const prevItems = (0, $hzcvF.usePreviousWithInitial)(items);
    const [, { resetCache: resetCache }] = (0, $5r9Wo.useHierarchyStore)();
    const { setHierarchyData: setHierarchyData } = (0, $fTRcw.useSetHierarchyData)();
    (0, $4G5xU.useQueryBasedViewAutomaticTracking)((0, $gbsaq.VIEW_EXPERIENCE), {
        loading: items.loading,
        error: items.error
    });
    // resets expanded items and queryData cache when filtering/sorting/groupBy is updated
    (0, $2zwYz.useResetItems)();
    // initialize items when switching between grouping -> hierarchy
    (0, $eUqFw.useEffect)(()=>{
        setHierarchyData(items);
        resetCache();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // updates hierarchy items in store only when "data", "isLoadingNextPage" or "totalCount" changes
    (0, $eUqFw.useEffect)(()=>{
        if (prevItems.data !== items.data || prevItems.isLoadingNextPage !== items.isLoadingNextPage) setHierarchyData(items);
    }, [
        items,
        prevItems,
        setHierarchyData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, items.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: items.error,
        title: (0, $afRND.default).errorTitle,
        description: (0, $afRND.default).errorMessage
    }));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$96ede29ffd923480$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($96ede29ffd923480$var$HierarchyLoader);

});
parcelRegister("gfhub", function(module, exports) {

$parcel$export(module.exports, "useHierarchyLevel", () => $7e94e6d9ca58ea66$export$62fdc6b7b35d2861);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $7e94e6d9ca58ea66$var$initialState = {
    hierarchyLevel: undefined
};
const $7e94e6d9ca58ea66$var$resetHierarchyLevel = ()=>({ setState: setState })=>setState({
            ...$7e94e6d9ca58ea66$var$initialState
        });
const $7e94e6d9ca58ea66$var$setHierarchyLevel = (hierarchyLevel)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            hierarchyLevel: hierarchyLevel
        });
    };
const $7e94e6d9ca58ea66$var$actions = {
    resetHierarchyLevel: $7e94e6d9ca58ea66$var$resetHierarchyLevel,
    setHierarchyLevel: $7e94e6d9ca58ea66$var$setHierarchyLevel
};
const $7e94e6d9ca58ea66$var$Store = (0, $kEDjj.createStore)({
    initialState: $7e94e6d9ca58ea66$var$initialState,
    actions: $7e94e6d9ca58ea66$var$actions,
    name: 'JWMHierarchyLevelStore'
});
const $7e94e6d9ca58ea66$export$62fdc6b7b35d2861 = (0, $1yZQx.createHook)($7e94e6d9ca58ea66$var$Store);

});

parcelRegister("afRND", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb2eddeffee33e10$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $eb2eddeffee33e10$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.hierarchy.hierarchy-loader.error-title",
        "defaultMessage": "We couldn't load items."
    },
    errorMessage: {
        "id": "business-list.controllers.hierarchy.hierarchy-loader.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});



parcelRegister("bxcZe", function(module, exports) {

$parcel$export(module.exports, "getColumnVisibilityIndexes", () => $a6ed118b467cb247$export$2b4b1825d849585e);
$parcel$export(module.exports, "useHighlightDoneItems", () => $a6ed118b467cb247$export$10dde765bae17fce);
$parcel$export(module.exports, "calculateIssuesHeight", () => $a6ed118b467cb247$export$e12173811eb87ac);
$parcel$export(module.exports, "getIssueCreateRankBefore", () => $a6ed118b467cb247$export$963872cb9359ad45);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $d3C6e = parcelRequire("d3C6e");

var $6vrw7 = parcelRequire("6vrw7");

var $aXbY8 = parcelRequire("aXbY8");

var $fP6gY = parcelRequire("fP6gY");
const $a6ed118b467cb247$export$2b4b1825d849585e = (0, $5iWql.default)((scrollLeft, tableWidth, columns)=>{
    const leftEdge = scrollLeft;
    const rightEdge = scrollLeft + tableWidth;
    const visibleColumnsIdx = [];
    const invisibleColumnsIdx = [];
    let totalOffset = 0;
    const columnsOffset = columns.reduce((acc, column)=>{
        acc.push(totalOffset);
        totalOffset += column.width;
        return acc;
    }, []);
    columnsOffset.forEach((columnOffset, colIdx)=>{
        const isNotVisible = columnOffset + columns[colIdx].width < leftEdge || columnOffset > rightEdge;
        isNotVisible ? invisibleColumnsIdx.push(colIdx) : visibleColumnsIdx.push(colIdx);
    });
    return {
        visibleColumns: visibleColumnsIdx,
        invisibleColumns: invisibleColumnsIdx
    };
});
const $a6ed118b467cb247$export$10dde765bae17fce = ()=>{
    const [highlightedIssues, setHightlightedIssues] = (0, $eUqFw.useState)({});
    const toggleHighlightRow = (0, $eUqFw.useCallback)((issueKey, value, timeout = 5000)=>{
        setHightlightedIssues((prev)=>({
                ...prev,
                [issueKey]: value
            }));
        if (value) // using a timer here to clean up the object instead of tiying it to the unmount of the row because base-table unmounts rows due to virtualisation.
        setTimeout(()=>{
            setHightlightedIssues((prevState)=>{
                const newState = {
                    ...prevState
                };
                delete newState[issueKey];
                return newState;
            });
        }, timeout);
    }, []);
    const getRowClassName = (0, $eUqFw.useCallback)(({ rowData: rowData })=>highlightedIssues[rowData.key] && 'highlight', [
        highlightedIssues
    ]);
    return {
        toggleHighlightRow: toggleHighlightRow,
        getRowClassName: getRowClassName
    };
};
const $a6ed118b467cb247$export$e12173811eb87ac = (issues, rowHeight, expandedItems, expandedGroups)=>issues.reduce((totalHeight, issue)=>{
        let accumulatedHeight = totalHeight;
        accumulatedHeight += rowHeight;
        // add the total heights of all expanded children
        if (issue.children && issue.children.length > 0 && (expandedItems && expandedItems[(0, $6vrw7.toIssueId)(issue.issueId)] === true || expandedGroups && expandedGroups[(0, $6vrw7.toIssueId)(issue.issueId)] === true)) accumulatedHeight += $a6ed118b467cb247$export$e12173811eb87ac(issue.children, rowHeight, expandedItems, expandedGroups);
        return accumulatedHeight;
    }, 0);
const $a6ed118b467cb247$export$963872cb9359ad45 = ({ items: items, startIndex: startIndex })=>{
    let rankBefore;
    const itemsCount = items?.length ?? 0;
    if (itemsCount > 0) for(let i = startIndex; i < itemsCount; i++){
        const { issueId: issueId, rank: rank } = items[i];
        const isItemAnIssue = !(0, $d3C6e.isOptimisticIssue)(issueId) && !(0, $fP6gY.isEmptyRow)(String(issueId)) && !(0, $aXbY8.isItemAnInlineCreate)(String(issueId)) && !(0, $aXbY8.isItemShowMore)(String(issueId));
        if (isItemAnIssue) {
            rankBefore = {
                issueId: String(issueId),
                rank: rank
            };
            break;
        }
    }
    return rankBefore;
};

});
parcelRegister("fP6gY", function(module, exports) {

$parcel$export(module.exports, "isEmptyRow", () => $b4b94bbd67441d39$export$ee1d59c3151f153d);

var $4oWxH = parcelRequire("4oWxH");

var $6vrw7 = parcelRequire("6vrw7");

var $aXbY8 = parcelRequire("aXbY8");

var $lqO9q = parcelRequire("lqO9q");
const $b4b94bbd67441d39$export$36f6900d705f61ab = ({ data: data, childrenQueryData: childrenQueryData, rowCreateState: rowCreateState, setRowCreatePosition: setRowCreatePosition, setIssueExpanded: setIssueExpanded, groups: groups, groupItemsQueryData: groupItemsQueryData })=>{
    const issuesMap = new Map();
    const addAndReturnIssue = (issue)=>{
        issuesMap.set(String(issue.issueId), issue);
        return issue;
    };
    const convertListViewIssueToListViewControllerData = ({ issue: issue, children: children, issueHasChildCreateOpen: issueHasChildCreateOpen, canCreateChild: canCreateChild, rankIndex: rankIndex, parentIssueId: parentIssueId })=>{
        if ((0, $4oWxH.isGroupItem)(issue.issueId) && groupItemsQueryData) return addAndReturnIssue({
            ...issue,
            rankIndex: rankIndex,
            children: issueHasChildCreateOpen ? [
                (0, $aXbY8.createRowForInlineCreate)('group'),
                ...children || []
            ] : children
        });
        if (childrenQueryData) return addAndReturnIssue({
            ...issue,
            rankIndex: rankIndex,
            parentIssueId: parentIssueId,
            children: issueHasChildCreateOpen ? [
                ...children || [],
                (0, $aXbY8.createRowForInlineCreate)('subtask')
            ] : children,
            onChildCreateButtonClicked: canCreateChild ? ()=>{
                setRowCreatePosition({
                    parentId: issue.issueId
                });
                if (setIssueExpanded) setIssueExpanded((0, $6vrw7.toIssueId)(issue.issueId), true);
            } : undefined
        });
        return addAndReturnIssue({
            ...issue,
            rankIndex: rankIndex
        });
    };
    const isGrouping = typeof groups !== 'undefined' ? groups.length > 0 : false;
    if (isGrouping && !groupItemsQueryData || !childrenQueryData) return {
        convertedData: data.map((issue, index)=>convertListViewIssueToListViewControllerData({
                issue: issue,
                children: undefined,
                issueHasChildCreateOpen: false,
                canCreateChild: false,
                rankIndex: index,
                parentIssueId: undefined
            })),
        issuesMap: issuesMap
    };
    const items = isGrouping ? groups : data;
    const convertedData = (items || []).map((issue, index)=>{
        // TODO https://jbusiness.atlassian.net/browse/JET-1723 need to convert to string
        const { issueId: issueIdNumber, childSummary: childSummary } = issue;
        const issueId = String(issueIdNumber);
        const { parentId: parentId } = rowCreateState;
        const issueHasChildCreateOpen = parentId === issue.issueId;
        const hasNoChildren = !childSummary?.hasChildren;
        if (hasNoChildren) return convertListViewIssueToListViewControllerData({
            issue: issue,
            children: undefined,
            issueHasChildCreateOpen: issueHasChildCreateOpen,
            canCreateChild: true,
            parentIssueId: undefined,
            rankIndex: index
        });
        // Getting children from either GroupQueryData or ChildrenQueryData and merging them with items
        let children;
        const childIssuesData = childrenQueryData ? childrenQueryData[issue.issueId] : undefined;
        const groupItemsData = groupItemsQueryData ? groupItemsQueryData[issue.issueId] : undefined;
        const childItemsData = isGrouping ? groupItemsData : childIssuesData;
        const loading = isGrouping ? !groupItemsData || groupItemsData?.loading : !childIssuesData || childIssuesData?.loading;
        if (loading === true) children = [
            (0, $aXbY8.createItemSkeleton)({
                issueId: issueId
            })
        ];
        else children = childItemsData ? childItemsData.data.map((childIssue, childIndex)=>{
            const convertedChildIssue = convertListViewIssueToListViewControllerData({
                issue: childIssue,
                // TODO remove undefined children for recursive call once we introduce multiple hierarchy levels
                children: undefined,
                issueHasChildCreateOpen: false,
                // children items cannot create child anymore, TODO when multiple hierarchy introduced, this logic will need to change
                canCreateChild: false,
                parentIssueId: issueId,
                rankIndex: childIndex
            });
            return convertedChildIssue;
        }) : [];
        const convertedIssue = convertListViewIssueToListViewControllerData({
            issue: issue,
            children: children,
            issueHasChildCreateOpen: issueHasChildCreateOpen,
            canCreateChild: true,
            parentIssueId: undefined,
            rankIndex: index
        });
        return convertedIssue;
    });
    return {
        convertedData: convertedData,
        issuesMap: issuesMap
    };
};
const $b4b94bbd67441d39$var$EMTPY_ROW_PREFIX = 'EMPTY_ROW';
const $b4b94bbd67441d39$export$ee1d59c3151f153d = (issueId = '')=>issueId.toString().startsWith($b4b94bbd67441d39$var$EMTPY_ROW_PREFIX);
const $b4b94bbd67441d39$export$4293a35894588c6e = [
    {
        id: '',
        issueId: $b4b94bbd67441d39$var$EMTPY_ROW_PREFIX,
        typeId: '',
        issuetype: {},
        key: '',
        rank: '',
        rankIndex: -1,
        status: {
            categoryId: '',
            name: ''
        },
        totalSubtasks: 0,
        cacheVariables: (0, $lqO9q.DEFAULT_CACHE_VARIABLES)
    }
];

});


parcelRegister("6HWvN", function(module, exports) {

$parcel$export(module.exports, "RenderStartMark", () => $ebb8060987b09135$export$2128f295d6adb861);
$parcel$export(module.exports, "PageLoadMetrics", () => $ebb8060987b09135$export$66b33c055cbb625e);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");


var $ZvXTS = parcelRequire("ZvXTS");
const $ebb8060987b09135$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
    if (loading === true) return null;
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$b78f0bbf209e5f4));
    return null;
};
const $ebb8060987b09135$export$66b33c055cbb625e = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
    // set UI_RENDER_END mark to indicate the end of UI render
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$88ea1e280513690f));
    const metric = (0, $ZvXTS.pageLoadMetrics)[view];
    return metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: `${product}.${view}`,
        metric: metric,
        extra: attributes
    });
});

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("gVPP8", function(module, exports) {

$parcel$export(module.exports, "DevDetailsDialogLoaderAsync", () => $d943de865dd0122f$export$f5ffc0f323543e16);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d943de865dd0122f$var$DevDetailDialogLoaderWithContainer = (0, $7rh0R.lazy)(()=>(parcelRequire("3DVnO")), {
    ssr: false,
    moduleId: "./src/packages/development/details-loader/src/ui/index.tsx"
});
const $d943de865dd0122f$export$f5ffc0f323543e16 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dev-detail-dialog-loader-with-container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d943de865dd0122f$var$DevDetailDialogLoaderWithContainer, props));
$d943de865dd0122f$export$f5ffc0f323543e16.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};

});
parcelRegister("3DVnO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("90cOZ")
]).then(()=>parcelRequire('g5FQE'));

});


parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1C9jQ = parcelRequire("1C9jQ");

var $xMKqn = parcelRequire("xMKqn");
var $DEVKo = parcelRequire("DEVKo");

var $67SDP = parcelRequire("67SDP");

var $6uNFR = parcelRequire("6uNFR");
var $jGBLd = parcelRequire("jGBLd");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");

var $38OPi = parcelRequire("38OPi");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $DEVKo.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $1C9jQ.envType).PROD;
            if (env === 'staging') return (0, $1C9jQ.envType).STAGING;
            return (0, $1C9jQ.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $jGBLd.shouldBeChoreographed)({
            messageType: messageType
        }) && (0, $1ybV0.ff)('post-office_enable_jira_choreographer') && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $67SDP.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6uNFR.useChoreographedStatusContext)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    const isCoordinationClientChoreographed = client.enableChoreographer;
    // We need to wrap this context value with useMemo otherwise it always triggers
    // re-render of all children when parent of CoordinationClient re-render
    const choreographedStatusContextValue = (0, $eUqFw.useMemo)(()=>({
            isAlreadyChoreographedAtAncestor: isCoordinationClientChoreographed
        }), [
        isCoordinationClientChoreographed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uNFR.ChoreographedStatusContext).Provider, {
        value: choreographedStatusContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xMKqn.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});
parcelRegister("6uNFR", function(module, exports) {

$parcel$export(module.exports, "useChoreographer", () => $dbff780bfca374d0$export$9f0e2488ffd90f11);
$parcel$export(module.exports, "ChoreographedStatusContext", () => $dbff780bfca374d0$export$3ff96dbefca6b00d);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $dbff780bfca374d0$export$2eb1efa814fe4a);
$parcel$export(module.exports, "useChoreographedRender", () => $dbff780bfca374d0$export$2cfd68294be82811);

var $eUqFw = parcelRequire("eUqFw");

var $5xY1g = parcelRequire("5xY1g");
var $67SDP = parcelRequire("67SDP");

var $6rW04 = parcelRequire("6rW04");

var $38OPi = parcelRequire("38OPi");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $dbff780bfca374d0$var$environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment')) ?? 'prod';
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const { plugin: $dbff780bfca374d0$export$27fff9a48cfe124b, useChoreographer: $dbff780bfca374d0$export$9f0e2488ffd90f11 } = (0, $5xY1g.choreographerFactory)((0, $67SDP.ProductIds).JIRA, $dbff780bfca374d0$var$environment);
const $dbff780bfca374d0$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $dbff780bfca374d0$export$2eb1efa814fe4a = ()=>(0, $eUqFw.useContext)($dbff780bfca374d0$export$3ff96dbefca6b00d);
const $dbff780bfca374d0$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $dbff780bfca374d0$export$2eb1efa814fe4a();
    const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $dbff780bfca374d0$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};

});

parcelRegister("jGBLd", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $38eaf8660dcaa871$export$a8ba9111c7eec9ac);

var $EbGpR = parcelRequire("EbGpR");
function $38eaf8660dcaa871$export$a8ba9111c7eec9ac(props) {
    return !!props?.messageType && (0, $EbGpR.IntegratedChoreographerMessageTypesEnum).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.messageType);
}

});
parcelRegister("EbGpR", function(module, exports) {

$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0);
const $e5c6b031155cf9c2$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0 = [
    $e5c6b031155cf9c2$export$94e85cf3348f045a.ENGAGEMENT,
    $e5c6b031155cf9c2$export$94e85cf3348f045a.MARKETING
];

});



parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("jwBHm", function(module, exports) {

$parcel$export(module.exports, "COLUMN_RESIZED", () => $ad32839562116fec$export$8b3afcfe2043df19);
$parcel$export(module.exports, "COLUMN_VISIBILITY_CHANGED", () => $ad32839562116fec$export$8d5ff5bc3618f0bf);
$parcel$export(module.exports, "DND_ROW_DROPPED", () => $ad32839562116fec$export$fcf01bd231fb8f52);
$parcel$export(module.exports, "DND_ROW_LIFTED", () => $ad32839562116fec$export$96db5145b3b810a2);
$parcel$export(module.exports, "useInteractionMetrics", () => $ad32839562116fec$export$6f239bf5d81555c8);

var $lNfG4 = parcelRequire("lNfG4");
const $ad32839562116fec$export$8b3afcfe2043df19 = 'column-resized';
const $ad32839562116fec$export$8d5ff5bc3618f0bf = 'column-visibility-changed';
const $ad32839562116fec$export$fcf01bd231fb8f52 = 'dnd-row-droppped';
const $ad32839562116fec$export$96db5145b3b810a2 = 'dnd-row-lifted';
const $ad32839562116fec$export$eee8b97030e3c397 = 'more-fields-button-clicked';
const $ad32839562116fec$var$interactionMetrics = {
    [$ad32839562116fec$export$8b3afcfe2043df19]: (0, $lNfG4.metrics).interaction({
        key: `jwm.list.${$ad32839562116fec$export$8b3afcfe2043df19}`
    }),
    [$ad32839562116fec$export$8d5ff5bc3618f0bf]: (0, $lNfG4.metrics).interaction({
        key: `jwm.list.${$ad32839562116fec$export$8d5ff5bc3618f0bf}`
    }),
    [$ad32839562116fec$export$eee8b97030e3c397]: (0, $lNfG4.metrics).interaction({
        key: `jwm.list.${$ad32839562116fec$export$eee8b97030e3c397}`
    }),
    [$ad32839562116fec$export$96db5145b3b810a2]: (0, $lNfG4.metrics).interaction({
        key: `jwm.list.${$ad32839562116fec$export$96db5145b3b810a2}`
    }),
    [$ad32839562116fec$export$fcf01bd231fb8f52]: (0, $lNfG4.metrics).interaction({
        key: `jwm.list.${$ad32839562116fec$export$fcf01bd231fb8f52}`
    })
};
const $ad32839562116fec$export$6f239bf5d81555c8 = ()=>$ad32839562116fec$var$interactionMetrics;

});

parcelRegister("cGmOd", function(module, exports) {

$parcel$export(module.exports, "useColumnWidths", () => $d7c1e1f9391c5df0$export$d598237875812773);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $iGdkQ = parcelRequire("iGdkQ");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $d7c1e1f9391c5df0$export$86880b4b2e1a2384 = 'column.widths';
const $d7c1e1f9391c5df0$var$actions = {
    setColumnWidth: (columnKey, width)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const { columnsWidths: columnsWidths, storageKey: storageKey } = state;
            if (storageKey == null) return;
            const newState = {
                ...state,
                columnsWidths: {
                    ...columnsWidths,
                    [columnKey]: width
                }
            };
            (0, $iGdkQ.localStorage).set(storageKey, newState.columnsWidths);
            setState(newState);
        },
    initState: (projectKey)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.storageKey != null) return;
            const storageKey = `${projectKey}-${$d7c1e1f9391c5df0$export$86880b4b2e1a2384}`;
            setState({
                ...state,
                storageKey: storageKey,
                columnsWidths: (0, $iGdkQ.localStorage).get(storageKey) || {}
            });
        }
};
const $d7c1e1f9391c5df0$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        storageKey: null,
        columnsWidths: {}
    },
    actions: $d7c1e1f9391c5df0$var$actions,
    name: 'JBusListViewColumnWidthStore'
});
const $d7c1e1f9391c5df0$var$useHook = (0, $1yZQx.createHook)($d7c1e1f9391c5df0$var$Store);
const $d7c1e1f9391c5df0$export$d598237875812773 = ()=>{
    const [{ columnsWidths: columnsWidths }, { setColumnWidth: setColumnWidth, initState: initState }] = $d7c1e1f9391c5df0$var$useHook();
    const projectData = (0, $kQAZu.useProject)();
    const projectKey = projectData.key;
    (0, $eUqFw.useEffect)(()=>{
        if (projectKey != null) initState(projectKey);
    }, [
        initState,
        projectKey
    ]);
    return [
        columnsWidths,
        {
            setColumnWidth: setColumnWidth
        }
    ];
};

});

parcelRegister("6IRtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d52b6cf42a4f59$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e3d52b6cf42a4f59$var$GroupUpdater = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("bOrTl")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/controllers/group-updater/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e3d52b6cf42a4f59$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-group-updater",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e3d52b6cf42a4f59$var$GroupUpdater, props));

});
parcelRegister("bOrTl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("Dnl01").then(()=>parcelRequire('c4reD'));

});


parcelRegister("lCzHy", function(module, exports) {

$parcel$export(module.exports, "useIssueChangeUpdater", () => $479bbe2446616aac$export$55b903604085ad27);

var $eUqFw = parcelRequire("eUqFw");

var $fE3Ua = parcelRequire("fE3Ua");

var $99RVt = parcelRequire("99RVt");
const $479bbe2446616aac$export$55b903604085ad27 = ()=>{
    const { onIssueRemoved: onIssueRemoved } = (0, $99RVt.useListViewUpdaterService)();
    const onIssueChange = (0, $eUqFw.useCallback)((event)=>{
        if (event.type === (0, $fE3Ua.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) {
            const { issueId: issueId, meta: { oldParentIssueId: oldParentIssueId } } = event;
            onIssueRemoved({
                issueId: Number(issueId),
                parentId: oldParentIssueId || undefined
            });
        }
    }, [
        onIssueRemoved
    ]);
    return {
        onIssueChange: onIssueChange
    };
};

});
parcelRegister("fE3Ua", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $407ab16d43881e85$export$8db21fc94823e1cc);
const $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $407ab16d43881e85$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $407ab16d43881e85$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $407ab16d43881e85$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $407ab16d43881e85$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $407ab16d43881e85$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $407ab16d43881e85$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $407ab16d43881e85$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$export$8db21fc94823e1cc = {
    [$407ab16d43881e85$var$FIELD_CHANGE_REQUESTED]: $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED,
    [$407ab16d43881e85$var$FIELD_CHANGE_FAILED]: $407ab16d43881e85$var$FIELD_CHANGE_FAILED,
    [$407ab16d43881e85$var$FIELD_CHANGED]: $407ab16d43881e85$var$FIELD_CHANGED,
    [$407ab16d43881e85$var$ISSUE_TYPE_CHANGED]: $407ab16d43881e85$var$ISSUE_TYPE_CHANGED,
    [$407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED]: $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED,
    [$407ab16d43881e85$var$ISSUE_LINKS_CREATED]: $407ab16d43881e85$var$ISSUE_LINKS_CREATED,
    [$407ab16d43881e85$var$ISSUE_LINK_DELETED]: $407ab16d43881e85$var$ISSUE_LINK_DELETED,
    [$407ab16d43881e85$var$CHILD_ISSUE_ADDED]: $407ab16d43881e85$var$CHILD_ISSUE_ADDED,
    [$407ab16d43881e85$var$SUBTASK_ADDED]: $407ab16d43881e85$var$SUBTASK_ADDED,
    [$407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED]: $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED]: $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED,
    [$407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("99RVt", function(module, exports) {

$parcel$export(module.exports, "useListViewUpdaterService", () => $31de61f84209b9b7$export$8fe666044644d3c0);

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $kQAZu = parcelRequire("kQAZu");

var $lGxgz = parcelRequire("lGxgz");

var $4oWxH = parcelRequire("4oWxH");

var $hTnQu = parcelRequire("hTnQu");

var $aVwtE = parcelRequire("aVwtE");

var $2rYp2 = parcelRequire("2rYp2");

var $9j3OJ = parcelRequire("9j3OJ");

var $hotly = parcelRequire("hotly");

var $5r9Wo = parcelRequire("5r9Wo");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $26iUh = parcelRequire("26iUh");

var $7XECd = parcelRequire("7XECd");

var $fjqly = parcelRequire("fjqly");

var $gfhub = parcelRequire("gfhub");

var $dSE3z = parcelRequire("dSE3z");

var $fGcrx = parcelRequire("fGcrx");

var $aqGaJ = parcelRequire("aqGaJ");

var $9DopW = parcelRequire("9DopW");
const $31de61f84209b9b7$export$8fe666044644d3c0 = ()=>{
    const [{ selectedIssues: selectedIssues, showDeleteModal: showDeleteModal }, { toggleShowDeleteModal: toggleShowDeleteModal, unselectIssues: unselectIssues }] = (0, $hotly.useBulkSelectionStore)();
    const [{ hierarchyLevel: hierarchyLevel }] = (0, $gfhub.useHierarchyLevel)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const fieldIds = (0, $9DopW.useSupportedFieldIds)();
    const { hierarchyParent: hierarchyParent } = (0, $aqGaJ.useHierarchyConfig)();
    const { addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, $hTnQu.useCacheActions)();
    const [{ issueParentMap: issueParentMap, issuesMap: issuesMap, childrenItems: childrenQueryData, hierarchyData: hierarchyData }] = (0, $5r9Wo.useHierarchyStore)();
    let projectKey;
    if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const projectData = (0, $kQAZu.useProject)();
        projectKey = projectData.key;
    }
    const groups = hierarchyData.data;
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const isGroupingByStatus = groupByFieldId === (0, $lO4Or.STATUS_TYPE);
    const cloudId = (0, $dWLk9.useCloudId)();
    const topLevelVariables = {
        ...(0, $i3K0B.getVariables)({
            jqlContext: jqlContext,
            fieldIds: fieldIds,
            quickFiltersJql: quickFiltersJql,
            sorting: sorting,
            hierarchyLevel: hierarchyLevel,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            projectIdOrKey: projectKey
        }),
        cloudId: cloudId
    };
    const { addToCacheCallback: addToCacheCallback, removeFromCacheCallback: removeFromCacheCallback } = (0, $9j3OJ.createViewUpdaterCallbacksWithCacheActions)({
        query: (0, $7XECd.LIST_VIEW_QUERY),
        addToCache: addToCache,
        updateItemsInCache: updateItemsInCache,
        removeFromCache: removeFromCache,
        isHierarchyEnabled: ()=>typeof hierarchyParent !== 'undefined',
        isInfiniteHierarchyEnabled: ()=>typeof hierarchyParent !== 'undefined',
        createVariablesForItemWithoutParent: ()=>topLevelVariables,
        createVariablesForGroupItem: (groupIssueId)=>({
                cloudId: cloudId,
                ...(0, $i3K0B.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    groupQuery: (0, $26iUh.getGroupQuery)({
                        groups: groups,
                        groupIssueId: groupIssueId,
                        groupByFieldId: groupByFieldId
                    }),
                    hierarchyParent: hierarchyParent,
                    isHidingDoneItems: isHidingDoneItems
                })
            }),
        createVariablesForItemWithParent: (parentIssueId)=>{
            if (!hierarchyParent) // this scenario should be impossible because there is isHierarchyEnabled parameter above
            return topLevelVariables;
            return {
                ...(0, $i3K0B.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    isHidingDoneItems: isHidingDoneItems,
                    hierarchyParent: undefined,
                    projectIdOrKey: projectKey,
                    parentIssue: {
                        hierarchyType: hierarchyParent,
                        issueId: parentIssueId
                    }
                }),
                cloudId: cloudId
            };
        },
        // We only want to add or remove item if the existing query for children-of-this-parent exists
        // this is to prevent apollo error where the cache key is missing
        shouldChildItemBeAddedToOrRemovedFromCache: (parentIssueId)=>Boolean(childrenQueryData && childrenQueryData[(0, $6vrw7.toIssueId)(parentIssueId)] !== undefined),
        getParentOfIssueIfExist: (issueId)=>{
            const maybeIssue = issuesMap.get(issueId);
            if (!maybeIssue) return undefined;
            return maybeIssue.parentIssueId ?? (0, $4oWxH.getParentIssueId)(maybeIssue);
        },
        getPrevParentOfIssueIfExists: (issueId)=>issueParentMap.get(String(issueId)),
        onUpdateParentWithNewChild: (0, $fjqly.addChildToParentListView),
        // note that prevParent will be undefined if the prevParent is not expanded or does not exist
        updateIssueParentMap: (issueId, newParentId)=>{
            if (newParentId) issueParentMap.set(String(issueId), String(newParentId));
            else issueParentMap.delete(String(issueId));
        },
        removeChildFromParent: (0, $fjqly.removeChildFromParentListView),
        isGroupingByStatus: isGroupingByStatus,
        isGrouping: !!groupByFieldId
    });
    const isGrouping = groupByFieldId != null;
    const { addToGroupCache: addToGroupCache, removeFromGroupCache: removeFromGroupCache } = (0, $fGcrx.useGroupCacheActions)({
        fieldIds: fieldIds
    });
    // When we detect an item has been updated that is currently filtered out of view, we still want to update group totals
    // so we do another request with no filters and update group cache's total count only
    const [getUpdatedIssue] = (0, $iZuDo.useLazyQuery)((0, $7XECd.LIST_VIEW_ITEM_DETAILS_QUERY), {
        fetchPolicy: 'network-only',
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewUpdaterQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch updated issue by id in list view updater'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (result)=>{
            const items = (0, $aVwtE.getAGGCompliantData)(result, 'list');
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (validNodes && validNodes.length > 0) addToGroupCache(validNodes, {
                updateCountOnly: true
            });
        }
    });
    const handleFilteredUpdate = (issueIds)=>{
        getUpdatedIssue({
            variables: {
                ...(0, $i3K0B.getVariables)({
                    issueIds: issueIds,
                    fieldIds: fieldIds
                }),
                cloudId: cloudId
            }
        });
    };
    const getGroupChildItems = (items)=>{
        const groupChildItems = [];
        const nestedItems = [];
        items.forEach((item)=>{
            const parentIssueId = (0, $4oWxH.getParentIssueId)(item);
            // we only want to move items between groups via realtime update if the item is a direct child of a group item
            // that is when it doesn't have a parent field, or its parent is a group item,
            if (parentIssueId != null && !(0, $4oWxH.isGroupItem)(parentIssueId) && childrenQueryData && childrenQueryData[parentIssueId]) nestedItems.push(item);
            else groupChildItems.push(item);
        });
        return {
            groupChildItems: groupChildItems,
            nestedItems: nestedItems
        };
    };
    return (0, $2rYp2.useViewUpdater)({
        input: {
            projectKey: projectKey,
            fieldIds: fieldIds,
            quickFiltersJql: quickFiltersJql,
            isHidingDoneItems: isHidingDoneItems
        },
        query: (0, $7XECd.LIST_VIEW_ITEM_DETAILS_QUERY),
        actions: [
            {
                addToCache: (items)=>{
                    if (isGrouping) {
                        const { groupChildItems: groupChildItems, nestedItems: nestedItems } = getGroupChildItems(items);
                        if (groupChildItems.length) return addToGroupCache(groupChildItems);
                        if (nestedItems.length) return addToCacheCallback(items);
                    }
                    return addToCacheCallback(items);
                },
                removeFromCache: (items)=>{
                    if (selectedIssues?.size) {
                        let issuesToUnselect = [];
                        items.forEach(({ issueId: issueId })=>{
                            if (selectedIssues.has(String(issueId))) issuesToUnselect = [
                                ...issuesToUnselect,
                                String(issueId)
                            ];
                        });
                        if (issuesToUnselect.length) {
                            unselectIssues({
                                issues: issuesToUnselect
                            });
                            if (issuesToUnselect.length === selectedIssues.size && showDeleteModal) toggleShowDeleteModal({
                                showDeleteModal: false
                            });
                        }
                    }
                    if (isGrouping) {
                        const { groupChildItems: groupChildItems, nestedItems: nestedItems } = getGroupChildItems(items);
                        if (groupChildItems.length) return removeFromGroupCache(groupChildItems);
                        if (nestedItems.length) return removeFromCacheCallback(items);
                    }
                    return removeFromCacheCallback(items);
                },
                handleFilteredUpdate: (issueIds)=>isGrouping ? handleFilteredUpdate(issueIds) : undefined
            }
        ],
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewUpdaterQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in list view updater'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onAppendItemsError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewAppendItemsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to append issues by id in list view updater'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};

});
parcelRegister("hTnQu", function(module, exports) {

$parcel$export(module.exports, "useCacheActions", () => $018dc286559ccf2c$export$f79bd85e41a6298f);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $iZuDo = parcelRequire("iZuDo");

var $jGcn0 = parcelRequire("jGcn0");

var $3uSNh = parcelRequire("3uSNh");

var $guiFP = parcelRequire("guiFP");

var $kmr29 = parcelRequire("kmr29");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $6vrw7 = parcelRequire("6vrw7");

var $7Sz8O = parcelRequire("7Sz8O");

var $4oWxH = parcelRequire("4oWxH");

var $aVwtE = parcelRequire("aVwtE");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $018dc286559ccf2c$var$getIssueKey = (fields)=>(0, $3uSNh.safeGetValue)(fields, 'issuekey', 'text', '');
const $018dc286559ccf2c$var$getIndexById = (listData, issueId)=>{
    if (listData == null || listData.edges == null) return -1;
    const { edges: edges } = listData;
    return edges.findIndex((edge)=>edge != null && edge.node != null && edge.node.issueId != null && edge.node.issueId === issueId);
};
const $018dc286559ccf2c$export$f79bd85e41a6298f = ()=>{
    const analyticsTaskName = 'useCacheActionsApolloCacheActions';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const [, extractedFieldValueActions] = (0, $kmr29.useFieldsValuesActions)();
    const [currentIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const removeIssueFromExtractedFieldsCache = (0, $eUqFw.useCallback)(({ currentIssueId: currentIssueId, issueKey: issueKey, parentIssueId: parentIssueId })=>{
        issueKey != null && // do not clean the cache if the issue is currently visible in bento (that would show blank fields)
        issueKey !== currentIssueKey && `${parentIssueId}` !== `${currentIssueId}` && extractedFieldValueActions.setIssue((0, $6vrw7.toIssueKey)(issueKey), {});
    }, [
        currentIssueKey,
        extractedFieldValueActions
    ]);
    const addToCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, newNodes: newNodes })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'addToCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        if (listData == null || listData.edges == null || !Array.isArray(newNodes) || newNodes.length === 0) return;
        try {
            const newIssueIds = new Set(newNodes.map((item)=>{
                if (item != null && item.issueId != null) return item.issueId;
                return undefined;
            }).filter(Boolean));
            newNodes.forEach((item)=>{
                if (item == null || item.fields == null) return;
                const issueKey = $018dc286559ccf2c$var$getIssueKey(item.fields);
                if (issueKey != null && issueKey !== '') {
                    const parentIssueId = (0, $4oWxH.getParentIssueId)(item);
                    const currentIssueId = item.issueId;
                    removeIssueFromExtractedFieldsCache({
                        currentIssueId: currentIssueId,
                        issueKey: issueKey,
                        parentIssueId: parentIssueId
                    });
                }
            });
            const isOptimisticIssueWithRealIssueInNewNodes = (issue)=>{
                // check whether an issue is an optimisticIssue that has the real data coming in
                // summary should give us a second check to replace the right optimistic issue with the new one
                // we are using summary instead of issueKey or issueId
                // since it's the only field that will contain the same value to identify
                // the correlation between real issue and optimistic issue
                const issueSummary = issue.fields?.find((field)=>field.fieldId === 'summary');
                const newNodeWithSameSummary = newNodes.find((newNode)=>newNode.fields?.find((field)=>field.fieldId === 'summary' && issueSummary != null && field.text === issueSummary.text));
                return issue.id.toString().startsWith((0, $7Sz8O.OPTIMISTIC_ID_PREFIX)) && newNodeWithSameSummary != null;
            };
            const newIssues = listData.edges.filter((edge)=>edge != null && edge.node != null && edge.node.issueId != null && !newIssueIds.has(edge.node.issueId) && !isOptimisticIssueWithRealIssueInNewNodes(edge.node)).concat(newNodes.map((node)=>({
                    node: node,
                    __typename: 'JiraWorkManagementViewItemEdge'
                }))) ?? [];
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: newIssues,
                            totalCount: newIssues.length
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloAddToCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'addToCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        removeIssueFromExtractedFieldsCache
    ]);
    const removeFromCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
        const issueIds = Array.isArray(issueId) ? issueId : [
            issueId
        ];
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'removeFromCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        if (!listData?.edges || !Array.isArray(listData.edges)) return;
        try {
            const updatedEdges = listData.edges?.filter((edge)=>edge?.node && !issueIds.includes(edge.node.issueId));
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: updatedEdges,
                            totalCount: updatedEdges.length
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            issueIds.forEach((issue)=>{
                const index = $018dc286559ccf2c$var$getIndexById(listData ?? undefined, issue);
                const item = updatedEdges[index];
                const issueKey = $018dc286559ccf2c$var$getIssueKey(item?.node?.fields ?? []);
                const currentIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(item, 'issueId', 0);
                if (issueKey !== '') removeIssueFromExtractedFieldsCache({
                    currentIssueId: currentIssueId,
                    issueKey: issueKey
                });
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloRemoveFromCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache Write error'),
                meta: {
                    id: 'removeFromCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        removeIssueFromExtractedFieldsCache
    ]);
    const getCachedIssueById = (0, $eUqFw.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'getCachedIssueById',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloGetCachedIssueById taskSuccess', {
            task: analyticsTaskName
        });
        return listData?.edges?.find((issue)=>issue?.node?.issueId === Number(issueId))?.node ?? null;
    }, [
        client,
        createAnalyticsEvent
    ]);
    const updateItemsInCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, issueIds: issueIds, updateItem: updateItem })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'updateItemsInCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        const existingEdges = listData?.edges;
        if (existingEdges == null) return;
        try {
            const newEdges = [
                ...existingEdges
            ];
            let hasItemOverride = false;
            issueIds.forEach((issueId)=>{
                const issueToUpdateIndex = existingEdges.findIndex((issue)=>issue?.node?.issueId === Number(issueId)) ?? undefined;
                const existingIssue = existingEdges[issueToUpdateIndex];
                if (existingIssue?.node == null || issueToUpdateIndex === undefined || issueToUpdateIndex === -1 || existingIssue == null) return;
                const itemOverride = updateItem(existingIssue.node);
                if (itemOverride === undefined) return;
                hasItemOverride = true;
                newEdges[issueToUpdateIndex] = {
                    node: itemOverride,
                    __typename: 'JiraWorkManagementViewItemEdge'
                };
            });
            if (!hasItemOverride) return;
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: newEdges,
                            totalCount: newEdges.length
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloUpdateItemsInCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'updateItemsInCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent
    ]);
    return {
        addToCache: addToCache,
        removeFromCache: removeFromCache,
        getCachedIssueById: getCachedIssueById,
        updateItemsInCache: updateItemsInCache
    };
};

});
parcelRegister("kmr29", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $da19d1ee706d4a81$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $da19d1ee706d4a81$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $da19d1ee706d4a81$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $da19d1ee706d4a81$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $da19d1ee706d4a81$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $da19d1ee706d4a81$export$612d9bcb0c9d8976);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
var $2HpOy = parcelRequire("2HpOy");
const $da19d1ee706d4a81$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $da19d1ee706d4a81$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $da19d1ee706d4a81$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $da19d1ee706d4a81$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $da19d1ee706d4a81$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], fields)
        });
    };
const $da19d1ee706d4a81$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $da19d1ee706d4a81$var$actions = {
    setFieldValue: $da19d1ee706d4a81$var$setFieldValue,
    getFieldValue: $da19d1ee706d4a81$var$getFieldValue,
    setIssue: $da19d1ee706d4a81$var$setIssue,
    mergeIssue: $da19d1ee706d4a81$var$mergeIssue,
    setIssues: $da19d1ee706d4a81$var$setIssues,
    mergeIssues: $da19d1ee706d4a81$export$11aa02e14fdf7753
};
// this is a global store
const $da19d1ee706d4a81$var$store = (0, $kEDjj.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $da19d1ee706d4a81$var$actions
});
const $da19d1ee706d4a81$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$da19d1ee706d4a81$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $da19d1ee706d4a81$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $da19d1ee706d4a81$var$getAllFields = (state, issueKey)=>state[issueKey];
const $da19d1ee706d4a81$export$b79fae7fbe3ac392 = (0, $1yZQx.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$export$25b73e671fe7a8fa = (0, $1yZQx.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getAllFields
});
const $da19d1ee706d4a81$export$ac289b84121829df = (0, $1yZQx.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$915cdeec521b54f7 = (0, $1yZQx.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$4e5f1f4ed08d155e = (0, $2HpOy.createSubscriber)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$var$useFieldValueStoreActions = (0, $1yZQx.createHook)($da19d1ee706d4a81$var$store, {
    selector: null
});
const $da19d1ee706d4a81$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $da19d1ee706d4a81$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eUqFw.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});


parcelRegister("2rYp2", function(module, exports) {

$parcel$export(module.exports, "useViewUpdater", () => $7b05e60be9d51978$export$a7d7c9fa51f6f9e6);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $eZbpk = parcelRequire("eZbpk");

var $lT4mK = parcelRequire("lT4mK");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $dWLk9 = parcelRequire("dWLk9");

var $aVwtE = parcelRequire("aVwtE");

var $2hnDK = parcelRequire("2hnDK");

var $6HSzd = parcelRequire("6HSzd");
const $7b05e60be9d51978$export$a7d7c9fa51f6f9e6 = ({ input: input, query: query, actions: actions, onError: onError, onAppendItemsError: onAppendItemsError })=>{
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const cloudId = (0, $dWLk9.useCloudId)();
    // Keep track of updates in flight so we can validate them against the current list of issues.
    // Useful when filters are enabled and items are changed in a way that do not match the filter anymore.
    const [updateInFlightList, setUpdateInFlightList] = (0, $eUqFw.useState)([]);
    const [cacheActionIssues, dispatch] = (0, $6HSzd.useCacheActionsReducer)();
    // getIssuesByIdVariablesRef is for using the variables in the useCallback for onComplete,
    // otherwise it errors because it is referenced before it's declared and is undefined
    const getIssuesByIdVariablesRef = (0, $eUqFw.useRef)();
    const getIssuesByIdOnCompletedRef = (0, $eUqFw.useRef)(null);
    // Separate query to handle issue removal
    const [fetchIssueToRemove, { loading: fetchIssueToRemoveLoading }] = (0, $iZuDo.useLazyQuery)(query, {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
        onCompleted: (0, $eUqFw.useCallback)((result)=>{
            const items = (0, $aVwtE.getAGGCompliantData)(result, 'list');
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (validNodes && validNodes.length > 0) dispatch({
                type: 'REMOVE_FROM_CACHE',
                issues: validNodes
            });
        }, [
            dispatch
        ]),
        onError: onAppendItemsError
    });
    // Separated query to update individual items so the other query can deal with pagination in the right sequence
    const [getIssuesById, { variables: getIssuesByIdVariables, loading: getIssuesByIdLoading }] = (0, $iZuDo.useLazyQuery)(query, {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
        onError: (0, $eUqFw.useCallback)((error)=>{
            if ((0, $lT4mK.isAbortError)(error.networkError)) return;
            onError(error);
        }, [
            onError
        ]),
        onCompleted: (0, $eUqFw.useCallback)((result)=>getIssuesByIdOnCompletedRef.current?.(result), [])
    });
    if (getIssuesByIdVariablesRef.current !== getIssuesByIdVariables) getIssuesByIdVariablesRef.current = getIssuesByIdVariables;
    // Separated query to append newly created items so we know it needs to be added to the top of the list.
    // Adding to the top to mimic backend behaviour but this might need to change when we introduce sorting.
    const [appendIssuesById, { loading: appendIssuesByIdLoading }] = (0, $iZuDo.useLazyQuery)(query, {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
        onCompleted: (0, $eUqFw.useCallback)((result)=>{
            const items = (0, $aVwtE.getAGGCompliantData)(result, 'list', onError);
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (validNodes && validNodes.length > 0) dispatch({
                type: 'ADD_TO_CACHE',
                issues: validNodes
            });
        }, [
            dispatch,
            onError
        ]),
        onError: onAppendItemsError
    });
    const { addRequestToQueue: addRequestToQueue, addRequestToAbortableQueue: addRequestToAbortableQueue } = (0, $2hnDK.useRequestQueue)({
        isRequestLoading: fetchIssueToRemoveLoading || getIssuesByIdLoading || appendIssuesByIdLoading
    });
    const removeIssueById = (0, $eUqFw.useCallback)((issueIdsToRemove)=>{
        addRequestToQueue(()=>fetchIssueToRemove({
                variables: {
                    ...(0, $i3K0B.getVariables)({
                        jqlContext: jqlContext,
                        issueIds: issueIdsToRemove,
                        fieldIds: input.fieldIds,
                        isHidingDoneItems: input.isHidingDoneItems,
                        isParentFieldVisible: input.isParentFieldVisible,
                        isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                        projectIdOrKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? input.projectKey ?? undefined : undefined,
                        // we don't want to include any quickFiltersJql on purpose
                        // because we actually want to get the data of the issue that is not suppose to match the current quickFiltersJql
                        // e.g. consider this scenario
                        // - if the current quickFiltersJql is filtering DONE item
                        // - and the issueId that we need to remove is because user moving it to DONE
                        // - if we include the quickFiltersJql in here, the BE will NOT return the issue data because it's already DONE -> so we can't filter it in FE
                        // - so in this case we just want the data of the issue
                        quickFiltersJql: null
                    }),
                    cloudId: cloudId
                }
            }));
    }, [
        addRequestToQueue,
        fetchIssueToRemove,
        jqlContext,
        input.fieldIds,
        input.isHidingDoneItems,
        input.isParentFieldVisible,
        input.isDevSummaryFieldVisible,
        input.projectKey,
        cloudId
    ]);
    const removeIssue = (0, $eUqFw.useCallback)(({ issueId: issueId, parentId: parentId })=>{
        // @ts-expect-error ts(2322) - we can't instantiate an issue of the generic type, as we can't know the whole issue
        // However, the removeFromCache function called with this issue only needs this part of the interface
        const issueNode = {
            issueId: issueId,
            fields: parentId != null ? [
                {
                    fieldId: 'parent',
                    type: (0, $lO4Or.PARENT_TYPE),
                    parentIssue: {
                        issueId: parentId
                    }
                }
            ] : []
        };
        dispatch({
            type: 'REMOVE_FROM_CACHE',
            issues: [
                issueNode
            ]
        });
    }, [
        dispatch
    ]);
    // Filters are handled by JQL (not client side). The update function respects the filters so a BLANK update
    // means the item findIssueById didn't match the JQL filter and SHOULD be removed.
    const handleFilterMismatch = (0, $eUqFw.useCallback)((variables, result)=>{
        if (!variables.jql) return;
        if (!result || !result.jira) // this is a case where the request failed, we don't want to remove the issue from the list in this case
        return;
        const updateIndex = updateInFlightList.findIndex((updateInput)=>(0, $i3K0B.getVariables)(updateInput).jql === variables.jql);
        if (updateIndex === -1) return;
        const currentUpdate = updateInFlightList[updateIndex];
        // In slow connections, users might change filters after an update was requested but before it can be applied.
        // We should not process those!
        const isUsingSameFilter = currentUpdate.quickFiltersJql === input.quickFiltersJql;
        const issueIds = [
            ...currentUpdate.issueIds || []
        ];
        const items = (0, $aVwtE.getAGGCompliantData)(result, 'list');
        const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
        if (isUsingSameFilter) {
            const issueIdsToRemove = [];
            issueIds.forEach((issueId, idIndex)=>{
                // item exists in the list but not in the filtered results - remove it!
                const item = validNodes?.find((node)=>node?.issueId === issueId);
                if (item == null) issueIdsToRemove.push(issueId);
                issueIds.splice(idIndex, 0);
                updateInFlightList[updateIndex] = {
                    ...currentUpdate,
                    issueIds: issueIds
                };
            });
            if (issueIdsToRemove.length > 0) removeIssueById(issueIdsToRemove);
        }
        setUpdateInFlightList((prevUpdateInFlightList)=>{
            prevUpdateInFlightList.splice(updateIndex, 1);
            return prevUpdateInFlightList;
        });
        // if item returns in filtered results it should be added to the cache. The method will dedup and sort by rank.
        if (validNodes && validNodes.length > 0) dispatch({
            type: 'ADD_TO_CACHE',
            issues: validNodes
        });
        // if item has been filtered out we may still want to do something with it
        const filteredIssueIds = issueIds.filter((issueId)=>!(validNodes ?? []).find((node)=>node?.issueId === issueId));
        if (filteredIssueIds.length > 0) dispatch({
            type: 'HANDLE_FILTERED_UPDATE',
            issues: filteredIssueIds
        });
    }, [
        updateInFlightList,
        input,
        removeIssueById,
        dispatch
    ]);
    getIssuesByIdOnCompletedRef.current = (result)=>handleFilterMismatch(getIssuesByIdVariables, result);
    // Interact with the cache in a useEffect to avoid doing it faster than the group items query data is updated
    (0, $eUqFw.useEffect)(()=>{
        if (cacheActionIssues.addToCache.length === 0 && cacheActionIssues.removeFromCache.length === 0 && cacheActionIssues.handleFilteredUpdate.length === 0) return;
        /* eslint-disable @typescript-eslint/consistent-type-assertions */ Object.entries(cacheActionIssues)/* eslint-enable @typescript-eslint/consistent-type-assertions */ .forEach(([actionName, issues])=>{
            if (Array.isArray(issues) && issues.length > 0) actions.forEach((actionEntry)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                actionEntry?.[actionName]?.(issues);
            });
        });
        dispatch({
            type: 'CLEAR'
        });
    }, [
        cacheActionIssues,
        actions,
        dispatch
    ]);
    return {
        onIssueUpdated: (issueIds)=>{
            // we want to fetch this issueIds
            // but at the same time we pass the `quickFiltersJql`
            // so if in the end result, we don't get back the `issueIds`, we know that the updated issue is not valid anymore in the current `quickFiltersJql`
            // e.g.
            // - current quickFiltersJql is NOT showing DONE item
            // - then there is an update to an ISSUE-X that changes the status
            // - we then fetch updated data of ISSUE_X based on current quickFiltersJql
            // - if the ISSUE-X is returned in the result -> it means ISSUE-X still matches current quickFiltersJql
            // - otherwise it is not, so it will be handled in handleFilterMismatch to be removed from view
            const updateInput = {
                jqlContext: jqlContext,
                issueIds: issueIds,
                fieldIds: input.fieldIds,
                quickFiltersJql: input.quickFiltersJql,
                isHidingDoneItems: input.isHidingDoneItems,
                isParentFieldVisible: input.isParentFieldVisible,
                isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                projectIdOrKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? input.projectKey ?? undefined : undefined
            };
            setUpdateInFlightList((prevUpdateInFlightList)=>[
                    ...prevUpdateInFlightList,
                    updateInput
                ]);
            addRequestToAbortableQueue(issueIds, getIssuesById, {
                variables: {
                    ...(0, $i3K0B.getVariables)(updateInput),
                    cloudId: cloudId
                }
            });
        },
        onIssueCreated: (issueIds)=>{
            addRequestToQueue(()=>appendIssuesById({
                    variables: {
                        ...(0, $i3K0B.getVariables)({
                            jqlContext: jqlContext,
                            issueIds: issueIds,
                            fieldIds: input.fieldIds,
                            quickFiltersJql: input.quickFiltersJql,
                            isHidingDoneItems: input.isHidingDoneItems,
                            isParentFieldVisible: input.isParentFieldVisible,
                            isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                            projectIdOrKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? input.projectKey ?? undefined : undefined
                        }),
                        cloudId: cloudId
                    }
                }));
        },
        onIssueRemoved: (params)=>removeIssue(params)
    };
};

});
parcelRegister("lT4mK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ABORT_ERROR_MESSAGE", () => $804e6ae63bab13aa$export$6131a8d209a21250);
$parcel$export(module.exports, "AbortError", () => $804e6ae63bab13aa$export$18b052ffd8c84d7);
$parcel$export(module.exports, "isAbortError", () => $804e6ae63bab13aa$export$d2c30ea522b3259e);
const $804e6ae63bab13aa$export$6131a8d209a21250 = 'The operation was aborted.';
class $804e6ae63bab13aa$export$18b052ffd8c84d7 extends Error {
    constructor(message, statusCode = 499){
        super(message);
        this.name = 'AbortError';
        this.statusCode = statusCode;
    }
}
const $804e6ae63bab13aa$export$d2c30ea522b3259e = (error)=>error instanceof $804e6ae63bab13aa$export$18b052ffd8c84d7;

});

parcelRegister("2hnDK", function(module, exports) {

$parcel$export(module.exports, "useRequestQueue", () => $dfad9e82c2bb88f7$export$a90df70eeafb262f);

var $eUqFw = parcelRequire("eUqFw");

var $lT4mK = parcelRequire("lT4mK");
const $dfad9e82c2bb88f7$export$a90df70eeafb262f = ({ isRequestLoading: isRequestLoading })=>{
    const [abortableQueueMap, setAbortableQueueMap] = (0, $eUqFw.useState)(new Map());
    const abortControllerMap = (0, $eUqFw.useRef)(new Map());
    const inProgressRequestId = (0, $eUqFw.useRef)(null);
    const addRequestToAbortableQueue = (0, $eUqFw.useCallback)((issueIds, queryFunction, queryOptions)=>{
        const id = issueIds.join('-');
        const existingAbortController = abortControllerMap.current.get(id);
        existingAbortController?.abort(new (0, $lT4mK.AbortError)((0, $lT4mK.DEFAULT_ABORT_ERROR_MESSAGE)));
        const abortController = new AbortController();
        abortControllerMap.current.set(id, abortController);
        const request = ()=>{
            queryFunction({
                ...queryOptions,
                context: {
                    ...queryOptions.context,
                    fetchOptions: {
                        ...queryOptions.context?.fetchOptions,
                        signal: abortController.signal
                    }
                }
            });
        };
        setAbortableQueueMap((prevQueueMap)=>new Map([
                ...prevQueueMap,
                [
                    id,
                    request
                ]
            ]));
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (!isRequestLoading && abortableQueueMap.size) {
            const iterator = abortableQueueMap.entries();
            const nextResult = iterator.next();
            if (!nextResult.done) {
                const [id, request] = nextResult.value;
                inProgressRequestId.current = id;
                request();
            }
            setAbortableQueueMap(new Map(iterator));
        }
    }, [
        abortableQueueMap,
        isRequestLoading
    ]);
    const [queue, setQueue] = (0, $eUqFw.useState)([]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isRequestLoading && queue.length > 0) setQueue((prevQueue)=>{
            const [nextItem, ...restOfQueue] = prevQueue;
            nextItem();
            return restOfQueue;
        });
    }, [
        queue,
        isRequestLoading
    ]);
    const addRequestToQueue = (request)=>setQueue((prevQueue)=>[
                ...prevQueue,
                request
            ]);
    return {
        addRequestToQueue: addRequestToQueue,
        addRequestToAbortableQueue: addRequestToAbortableQueue
    };
};

});

parcelRegister("6HSzd", function(module, exports) {

$parcel$export(module.exports, "useCacheActionsReducer", () => $fe64e59249b7515f$export$83303d410e8412eb);

var $eUqFw = parcelRequire("eUqFw");
const $fe64e59249b7515f$var$cacheActionsReducer = (state, action)=>{
    switch(action.type){
        case 'ADD_TO_CACHE':
            return {
                ...state,
                addToCache: [
                    ...state.addToCache,
                    ...action.issues
                ]
            };
        case 'REMOVE_FROM_CACHE':
            return {
                ...state,
                removeFromCache: [
                    ...state.removeFromCache,
                    ...action.issues
                ]
            };
        case 'HANDLE_FILTERED_UPDATE':
            return {
                ...state,
                handleFilteredUpdate: [
                    ...state.handleFilteredUpdate,
                    ...action.issues
                ]
            };
        case 'CLEAR':
            return {
                addToCache: [],
                removeFromCache: [],
                handleFilteredUpdate: []
            };
        default:
            return state;
    }
};
const $fe64e59249b7515f$export$83303d410e8412eb = ()=>// @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
    (0, $eUqFw.useReducer)($fe64e59249b7515f$var$cacheActionsReducer, {
        addToCache: [],
        removeFromCache: [],
        handleFilteredUpdate: []
    });

});


parcelRegister("9j3OJ", function(module, exports) {

$parcel$export(module.exports, "createViewUpdaterCallbacksWithCacheActions", () => $8ac2f00f49bb3cf6$export$cc1c02509eec9edb);
$parcel$export(module.exports, "createGroupingViewUpdaterCacheActions", () => $8ac2f00f49bb3cf6$export$c410d2a23de7830a);

var $eI5EY = parcelRequire("eI5EY");

var $4oWxH = parcelRequire("4oWxH");
const $8ac2f00f49bb3cf6$export$cc1c02509eec9edb = ({ isHierarchyEnabled: isHierarchyEnabled, isInfiniteHierarchyEnabled: isInfiniteHierarchyEnabled, query: query, addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache, createVariablesForItemWithParent: createVariablesForItemWithParent, createVariablesForItemWithoutParent: createVariablesForItemWithoutParent, shouldChildItemBeAddedToOrRemovedFromCache: shouldChildItemBeAddedToOrRemovedFromCache, onUpdateParentWithNewChild: onUpdateParentWithNewChild, getParentOfIssueIfExist: getParentOfIssueIfExist, isItemHierarchySupported: isItemHierarchySupported, removeChildFromParent: removeChildFromParent, updateIssueParentMap: updateIssueParentMap, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, createVariablesForGroupItem: createVariablesForGroupItem, isGroupingByStatus: isGroupingByStatus = false, isGrouping: isGrouping = false })=>{
    const getParentVariables = (parentId)=>{
        const variables = createVariablesForItemWithoutParent();
        if (!parentId) return variables;
        if (createVariablesForGroupItem && (0, $4oWxH.isGroupItem)(parentId)) return createVariablesForGroupItem(parentId);
        return createVariablesForItemWithParent(parentId);
    };
    const updateIssueParent = ({ prevParentIssueId: prevParentIssueId, parentIssueId: parentIssueId, item: item })=>{
        updateIssueParentMap && updateIssueParentMap(item.issueId, parentIssueId);
        if (!prevParentIssueId && !isGrouping || isGrouping && prevParentIssueId || prevParentIssueId && shouldChildItemBeAddedToOrRemovedFromCache(prevParentIssueId)) removeFromCache({
            query: query,
            variables: getParentVariables(prevParentIssueId),
            issueId: Number(item.issueId)
        });
        if (isGroupingByStatus) return;
        const hasParentToRemove = getParentOfIssueIfExist && !!getParentOfIssueIfExist(item.issueId);
        if (removeChildFromParent && prevParentIssueId && hasParentToRemove) {
            const grandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(String(prevParentIssueId)) : undefined;
            if ((0, $4oWxH.isGroupItem)(grandParentId) || (0, $4oWxH.isGroupItem)(prevParentIssueId)) return;
            updateItemsInCache({
                query: query,
                variables: getParentVariables(grandParentId),
                issueIds: [
                    String(prevParentIssueId)
                ],
                updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
            });
        }
        if (!parentIssueId) return;
        // updateChildCount of new parent
        // so user will have an indicator that shows the parent has subtask now
        const newGrandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(parentIssueId.toString()) : undefined;
        if ((0, $4oWxH.isGroupItem)(newGrandParentId) || (0, $4oWxH.isGroupItem)(parentIssueId)) return;
        updateItemsInCache({
            query: query,
            variables: getParentVariables(newGrandParentId),
            issueIds: [
                parentIssueId
            ],
            updateItem: (existingIssue)=>{
                const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                return updatedIssueWithNewChild;
            }
        });
    };
    const addToCacheCallback = (items)=>{
        if (isHierarchyEnabled()) {
            const itemsWithoutParent = items.filter((i)=>(0, $4oWxH.getParentIssueId)(i) === undefined);
            const itemsWithParent = items.filter((i)=>(0, $4oWxH.getParentIssueId)(i) !== undefined);
            // add items WITHOUT parent first
            if (itemsWithoutParent.length > 0) {
                addToCache({
                    newNodes: itemsWithoutParent,
                    query: query,
                    variables: createVariablesForItemWithoutParent()
                });
                items.forEach((item)=>{
                    // when parent is unlinked from issue
                    const parentIssueId = undefined;
                    const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                    if (isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId) updateIssueParent({
                        prevParentIssueId: prevParentIssueId,
                        parentIssueId: parentIssueId,
                        item: item
                    });
                });
            }
            // then add items WITH parent
            itemsWithParent.forEach((item)=>{
                const parentIssueId = (0, $4oWxH.getParentIssueId)(item);
                if (parentIssueId === undefined) // this scenario should be impossible because we already filtered the item
                // but doing this just to remove the Flow error
                return;
                // CLEAN UP THE FOLLOWING CONDITION WITH as it's only used by timeline view - followed by https://jbusiness.atlassian.net/browse/HRZ-1391
                if (isItemHierarchySupported && !isItemHierarchySupported(item)) {
                    // this is a specific scenario for the TIMELINE
                    // in that view we don't support epic hierarchy (we don't show the epic children, those are displayed on the same level)
                    // in that case we should not use the parent variables because that query doesn't exist
                    addToCache({
                        newNodes: [
                            item
                        ],
                        query: query,
                        variables: createVariablesForItemWithoutParent()
                    });
                    return;
                }
                const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                const shouldUpdateIssueParent = isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId;
                const shouldChildItemBeAddedOrRemovedFromCache = shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId);
                if (shouldUpdateIssueParent) updateIssueParent({
                    prevParentIssueId: prevParentIssueId,
                    parentIssueId: parentIssueId,
                    item: item
                });
                // We only want to add item if the existing query for children-of-this-parent exists
                // this is to prevent apollo error where the cache key is missing
                if (shouldChildItemBeAddedOrRemovedFromCache) addToCache({
                    newNodes: [
                        item
                    ],
                    query: query,
                    variables: createVariablesForItemWithParent(parentIssueId)
                });
                else if (!shouldChildItemBeAddedOrRemovedFromCache && !shouldUpdateIssueParent) {
                    let variables = createVariablesForItemWithoutParent();
                    if (isInfiniteHierarchyEnabled() && // Grandparent only exists in infinite hierarchy
                    getParentOfIssueIfExist) {
                        const grandParentId = getParentOfIssueIfExist(parentIssueId.toString());
                        if (grandParentId != null) variables = createVariablesForItemWithParent(grandParentId);
                    }
                    // if the parent is not listed to have child yet
                    // we will update the parent to show children
                    // so user will have an indicator that shows the parent has subtask now
                    updateItemsInCache({
                        query: query,
                        variables: variables,
                        issueIds: [
                            parentIssueId
                        ],
                        updateItem: (existingIssue)=>{
                            const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                            return updatedIssueWithNewChild;
                        }
                    });
                }
            });
            return;
        }
        addToCache({
            newNodes: items,
            query: query,
            variables: createVariablesForItemWithoutParent()
        });
    };
    const removeFromCacheCallback = (items)=>{
        items.forEach((item)=>{
            if (isHierarchyEnabled()) {
                const parentIssueId = (0, $4oWxH.getParentIssueId)(item);
                if (parentIssueId !== undefined) {
                    if (shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId)) removeFromCache({
                        issueId: item.issueId,
                        query: query,
                        variables: createVariablesForItemWithParent(parentIssueId)
                    });
                    // TODO remove the subtask from parent 'Subtask' field https://jbusiness.atlassian.net/browse/JET-1883
                    return;
                }
            }
            removeFromCache({
                issueId: item.issueId,
                query: query,
                variables: createVariablesForItemWithoutParent()
            });
        });
    };
    return {
        addToCacheCallback: addToCacheCallback,
        removeFromCacheCallback: removeFromCacheCallback
    };
};
const $8ac2f00f49bb3cf6$export$c410d2a23de7830a = ({ query: query, groupsQuery: groupsQuery, addToCache: addToCache, removeFromCache: removeFromCache, addGroupItemToCache: addGroupItemToCache, updateGroupItemInCache: updateGroupItemInCache, updateItemsInCache: updateItemsInCache, createVariablesForGroups: createVariablesForGroups, createVariablesForGroupItem: createVariablesForGroupItem, createItemGroup: createItemGroup, findItemGroup: findItemGroup, findGroupById: findGroupById, canUpdateGroupCache: canUpdateGroupCache, getParentOfIssueIfExist: getParentOfIssueIfExist, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, onUpdateParentWithNewChild: onUpdateParentWithNewChild, removeChildFromParent: removeChildFromParent, createVariablesForItemWithParent: createVariablesForItemWithParent, updateIssueParentMap: updateIssueParentMap })=>{
    const getReparentingInfo = (item)=>{
        const currentParent = (0, $4oWxH.getParentIssueId)(item);
        const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
        // note that currentParent can be undefined or a groupitem if parent is unlinked
        const isUnlinkParent = (!currentParent || (0, $4oWxH.isGroupItem)(currentParent)) && prevParent && currentParent !== prevParent;
        const isReparenting = currentParent && currentParent !== prevParent;
        return {
            isReparenting: isReparenting,
            isUnlinkParent: isUnlinkParent,
            currentParent: currentParent,
            prevParent: prevParent
        };
    };
    const removeItemFromCache = (item, currentGroupIssueId)=>{
        const { isReparenting: isReparenting, prevParent: prevParent, isUnlinkParent: isUnlinkParent } = getReparentingInfo(item);
        // check if items data exists in apollo cache, so that updating it won't blow up apollo
        if (canUpdateGroupCache(currentGroupIssueId) && (!isReparenting && !isUnlinkParent || prevParent && (0, $4oWxH.isGroupItem)(prevParent))) removeFromCache({
            issueId: item.issueId,
            query: query,
            variables: createVariablesForGroupItem(currentGroupIssueId)
        });
        else if (prevParent && (isReparenting || isUnlinkParent) && !(0, $4oWxH.isGroupItem)(prevParent)) removeFromCache({
            issueId: item.issueId,
            query: query,
            variables: createVariablesForItemWithParent(prevParent)
        });
        const groupItem = findGroupById(currentGroupIssueId);
        const prevGrandParent = prevParent ? getParentOfIssueIfExist(prevParent) : undefined;
        if (groupItem) {
            if (prevParent && (isReparenting || isUnlinkParent) && prevGrandParent && removeChildFromParent) // update count of prevParent
            updateItemsInCache({
                query: query,
                variables: (0, $4oWxH.isGroupItem)(prevGrandParent) ? createVariablesForGroupItem(prevGrandParent) : createVariablesForItemWithParent(prevGrandParent),
                issueIds: [
                    prevParent
                ],
                updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
            });
            else if (isChildIssueInGroup(groupItem, item.issueId)) // update totalGroupItems in itemGroups cache.
            updateGroupItemInCache({
                query: groupsQuery,
                variables: createVariablesForGroups(),
                id: groupItem.id,
                updateItem: (group)=>({
                        ...group,
                        totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount - 1) : undefined
                    })
            });
        }
    };
    const getGroupIssueId = (issueId)=>{
        if ((0, $4oWxH.isGroupItem)(issueId)) return issueId;
        const parentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(issueId) : undefined;
        if (!parentId) return null;
        if ((0, $4oWxH.isGroupItem)(parentId)) return parentId;
        return getGroupIssueId(parentId);
    };
    const isChildIssueInGroup = (group, childIssueId)=>group.children?.some((issue)=>issue.issueId === childIssueId);
    const addToGroupCache = (items, { updateCountOnly: updateCountOnly = false } = {
        updateCountOnly: false
    })=>{
        items.forEach((item)=>{
            const { isReparenting: isReparenting, currentParent: currentParent, prevParent: prevParent } = getReparentingInfo(item);
            const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
            const nextGroup = findItemGroup(item);
            if (currentGroupIssueId != null && !updateCountOnly) removeItemFromCache(item, currentGroupIssueId);
            if (nextGroup != null) {
                // check if items data exists in apollo cache, so that updating it won't blow up apollo
                const shouldAddToCache = canUpdateGroupCache(nextGroup.issueId) && !updateCountOnly && ((0, $eI5EY.fg)('list-view-issue-disappear-upon-editing-fix') || !isReparenting);
                if (shouldAddToCache) {
                    // add the item to the next group
                    addToCache({
                        newNodes: [
                            item
                        ],
                        query: query,
                        variables: createVariablesForGroupItem(nextGroup.issueId)
                    });
                    // this should not be necessary once background refetch when grouping is working correctly
                    updateIssueParentMap(item.issueId);
                }
                const newGrandParentId = currentParent ? getParentOfIssueIfExist(currentParent) : undefined;
                if (currentParent && isReparenting && newGrandParentId) updateItemsInCache({
                    query: query,
                    variables: (0, $4oWxH.isGroupItem)(newGrandParentId) ? createVariablesForGroupItem(newGrandParentId) : createVariablesForItemWithParent(newGrandParentId),
                    issueIds: [
                        currentParent
                    ],
                    updateItem: (existingIssue)=>{
                        const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                        return updatedIssueWithNewChild;
                    }
                });
                else // update totalGroupItems in itemGroups cache.
                updateGroupItemInCache({
                    query: groupsQuery,
                    variables: createVariablesForGroups(),
                    id: nextGroup.id,
                    updateItem: (group)=>({
                            ...group,
                            totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount + 1) : undefined
                        })
                });
            } else {
                const newGroup = createItemGroup(item);
                if (newGroup != null) addGroupItemToCache({
                    query: groupsQuery,
                    variables: createVariablesForGroups(),
                    newNodes: [
                        newGroup
                    ]
                });
            }
        });
    };
    const removeFromGroupCache = (items)=>{
        items.forEach((item)=>{
            const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
            const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
            // happens when updating parent but new parent is not expanded
            if (currentGroupIssueId != null) removeItemFromCache(item, currentGroupIssueId);
        });
    };
    return {
        addToCache: addToGroupCache,
        removeFromCache: removeFromGroupCache
    };
};

});

parcelRegister("fGcrx", function(module, exports) {

$parcel$export(module.exports, "useGroupCacheActions", () => $d008973264df6542$export$3083f2cce6510ba2);

var $i3K0B = parcelRequire("i3K0B");

var $kQAZu = parcelRequire("kQAZu");

var $lGxgz = parcelRequire("lGxgz");

var $4oWxH = parcelRequire("4oWxH");

var $gtnVv = parcelRequire("gtnVv");

var $hTnQu = parcelRequire("hTnQu");

var $9j3OJ = parcelRequire("9j3OJ");

var $5r9Wo = parcelRequire("5r9Wo");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $7O3Xq = parcelRequire("7O3Xq");

var $hzwAr = parcelRequire("hzwAr");

var $26iUh = parcelRequire("26iUh");

var $7XECd = parcelRequire("7XECd");

var $fjqly = parcelRequire("fjqly");

var $gfhub = parcelRequire("gfhub");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");

var $aqGaJ = parcelRequire("aqGaJ");

var $g74gP = parcelRequire("g74gP");

var $k37U2 = parcelRequire("k37U2");
const $d008973264df6542$export$3083f2cce6510ba2 = ({ fieldIds: fieldIds } = {})=>{
    const { addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, $hTnQu.useCacheActions)();
    const { addGroupItemToCache: addGroupItemToCache, updateGroupItemInCache: updateGroupItemInCache } = (0, $gtnVv.useItemGroupsCacheActions)();
    const { hierarchyParent: hierarchyParent } = (0, $aqGaJ.useHierarchyConfig)();
    const [{ rankParentIssueId: rankParentIssueId }] = (0, $g74gP.useRankParent)();
    const input = (0, $k37U2.useIssuesInput)({
        groupIssueId: (0, $4oWxH.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
        parentIssueId: !(0, $4oWxH.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
    });
    let projectKey;
    if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const projectData = (0, $kQAZu.useProject)();
        projectKey = projectData.key;
    }
    const [{ issueParentMap: issueParentMap, issuesMap: issuesMap, childrenItems: childrenItems, hierarchyData: hierarchyData }] = (0, $5r9Wo.useHierarchyStore)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const groupItemsQueryData = childrenItems;
    const groups = hierarchyData.data;
    const cloudId = (0, $dWLk9.useCloudId)();
    const { getAvailableFields: getAvailableFields } = (0, $hHiDc.useIssueFields)();
    const availableFields = getAvailableFields();
    const categoryField = availableFields.find((field)=>field?.type === (0, $lO4Or.CATEGORY_TYPE));
    const isGroupingByCategory = groupByFieldId === categoryField?.id;
    const [{ hierarchyLevel: hierarchyLevel }] = (0, $gfhub.useHierarchyLevel)();
    const { addToCache: addToGroupCache, removeFromCache: removeFromGroupCache } = (0, $9j3OJ.createGroupingViewUpdaterCacheActions)({
        query: (0, $7XECd.LIST_VIEW_QUERY),
        groupsQuery: (0, $hzwAr.LIST_VIEW_ITEM_GROUPS_QUERY),
        addToCache: addToCache,
        removeFromCache: removeFromCache,
        updateItemsInCache: updateItemsInCache,
        addGroupItemToCache: addGroupItemToCache,
        updateGroupItemInCache: updateGroupItemInCache,
        // make sure group items data exists in apollo cache
        canUpdateGroupCache: (groupIssueId)=>groupItemsQueryData ? !!groupItemsQueryData[(0, $6vrw7.toIssueId)(groupIssueId)] : false,
        findItemGroup: (item)=>(0, $26iUh.findItemGroup)({
                groups: groups,
                groupByFieldId: groupByFieldId,
                item: item,
                isGroupingByCategory: isGroupingByCategory
            }),
        createItemGroup: (item)=>(0, $26iUh.createItemGroup)({
                groupByFieldId: groupByFieldId,
                item: item
            }),
        findGroupById: (groupIssueId)=>groups?.find((group)=>groupIssueId === (0, $26iUh.createGroupIssueId)(group.id)),
        createVariablesForGroupItem: (groupIssueId)=>({
                cloudId: cloudId,
                ...(0, $i3K0B.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds || input.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    groupQuery: (0, $26iUh.getGroupQuery)({
                        groups: groups,
                        groupIssueId: groupIssueId,
                        groupByFieldId: groupByFieldId
                    }),
                    hierarchyParent: input.hierarchyParent,
                    isHidingDoneItems: isHidingDoneItems,
                    projectIdOrKey: projectKey
                })
            }),
        createVariablesForGroups: ()=>(0, $7O3Xq.getGroupVariables)({
                groupByFieldId: groupByFieldId,
                jqlContext: jqlContext
            }),
        getParentOfIssueIfExist: (issueId)=>{
            const maybeIssue = issuesMap.get(String(issueId));
            if (!maybeIssue) return undefined;
            return maybeIssue.parentIssueId ?? (0, $4oWxH.getParentIssueId)(maybeIssue);
        },
        getPrevParentOfIssueIfExists: (issueId)=>issueParentMap.get(String(issueId)),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onUpdateParentWithNewChild: (0, $fjqly.addChildToParentListView),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        removeChildFromParent: (0, $fjqly.removeChildFromParentListView),
        createVariablesForItemWithParent: (parentIssueId)=>{
            if (!hierarchyParent) return {
                ...(0, $i3K0B.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds || input.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    hierarchyLevel: hierarchyLevel,
                    hierarchyParent: hierarchyParent,
                    isHidingDoneItems: isHidingDoneItems
                }),
                cloudId: cloudId
            };
            return {
                ...(0, $i3K0B.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds || input.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    isHidingDoneItems: isHidingDoneItems,
                    hierarchyParent: undefined,
                    parentIssue: {
                        hierarchyType: hierarchyParent,
                        issueId: parentIssueId
                    }
                }),
                cloudId: cloudId
            };
        },
        // note that prevParent will be undefined if the prevParent is not expanded or does not exist
        updateIssueParentMap: (issueId, newParentId)=>{
            if (newParentId) issueParentMap.set(String(issueId), String(newParentId));
            else issueParentMap.delete(String(issueId));
        }
    });
    return {
        addToGroupCache: addToGroupCache,
        removeFromGroupCache: removeFromGroupCache
    };
};

});
parcelRegister("gtnVv", function(module, exports) {

$parcel$export(module.exports, "useItemGroupsCacheActions", () => $b62511f8ae570da7$export$a49f2fc3773a6a0f);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $b62511f8ae570da7$export$a49f2fc3773a6a0f = ()=>{
    const analyticsTaskName = 'useItemGroupsCacheActionsApolloCacheActions';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const updateGroupItemInCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, id: id, updateItem: updateItem })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'updateGroupItemInCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const existingNodes = data?.groups.nodes;
        if (existingNodes == null) return;
        const itemToUpdateIndex = existingNodes.findIndex((issue)=>issue?.id === id) ?? undefined;
        const existingItem = existingNodes[itemToUpdateIndex];
        if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingItem == null) return;
        const itemOverride = updateItem(existingItem);
        if (itemOverride === undefined) return;
        const newNodes = [
            ...existingNodes
        ];
        newNodes[itemToUpdateIndex] = itemOverride;
        try {
            client.writeQuery({
                query: query,
                variables: variables,
                // @ts-expect-error - TS2345 - Argument of type '{ query: DocumentNode; variables: GenericGroupVariables; notifyOnNetworkStatusChange: boolean; data: { groups: { nodes: (TIssueNode | null | undefined)[]; }; }; }' is not assignable to parameter of type 'WriteQueryOptions<{ groups: { nodes: (TIssueNode | null | undefined)[]; }; }, GenericGroupVariables>'.
                notifyOnNetworkStatusChange: true,
                data: {
                    ...data,
                    groups: {
                        ...data?.groups || {},
                        nodes: newNodes
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'updateGroupItemInCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent
    ]);
    const addGroupItemToCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, newNodes: newNodes })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'addGroupItemToCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        if (data == null || data.groups == null || !Array.isArray(newNodes) || newNodes.length === 0 || !Array.isArray(newNodes)) return;
        const newGroupsIds = new Set(newNodes.map((item)=>item != null && item.id != null ? item.id : undefined).filter(Boolean));
        if (data == null || data.groups == null || !Array.isArray(data.groups.nodes)) return;
        try {
            const newGroups = data.groups.nodes.filter((node)=>node != null && node.id != null && !newGroupsIds.has(node.id)).concat(newNodes) ?? [];
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    groups: {
                        ...data.groups,
                        nodes: newGroups
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'addGroupItemToCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent
    ]);
    return {
        updateGroupItemInCache: updateGroupItemInCache,
        addGroupItemToCache: addGroupItemToCache
    };
};

});

parcelRegister("g74gP", function(module, exports) {

$parcel$export(module.exports, "useRankParent", () => $c13b72b900996970$export$70ab091cfa570abd);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $c13b72b900996970$var$actions = {
    setRankParentIssueId: (rankParentIssueId)=>({ setState: setState })=>setState({
                rankParentIssueId: rankParentIssueId
            })
};
const $c13b72b900996970$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        rankParentIssueId: null
    },
    actions: $c13b72b900996970$var$actions,
    name: 'JBusListViewRankParentIssueIdStore'
});
const $c13b72b900996970$export$70ab091cfa570abd = (0, $1yZQx.createHook)($c13b72b900996970$var$Store);

});

parcelRegister("k37U2", function(module, exports) {

$parcel$export(module.exports, "useIssuesInput", () => $f493ab16cd54b286$export$242d22b97c239de6);

var $kQAZu = parcelRequire("kQAZu");

var $lGxgz = parcelRequire("lGxgz");

var $5r9Wo = parcelRequire("5r9Wo");

var $1ybV0 = parcelRequire("1ybV0");

var $26iUh = parcelRequire("26iUh");

var $gfhub = parcelRequire("gfhub");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");

var $aqGaJ = parcelRequire("aqGaJ");
const $f493ab16cd54b286$export$242d22b97c239de6 = (options)=>{
    const { groupIssueId: groupIssueId, parentIssueId: parentIssueId } = options || {};
    const [{ hierarchyLevel: hierarchyLevel }] = (0, $gfhub.useHierarchyLevel)();
    const [{ hierarchyData: hierarchyData }] = (0, $5r9Wo.useHierarchyStore)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { hierarchyParent: hierarchyParent } = (0, $aqGaJ.useHierarchyConfig)();
    const { getQueryFieldIds: getQueryFieldIds, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $hHiDc.useIssueFields)();
    const groups = hierarchyData.data;
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    let projectKey;
    if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const projectData = (0, $kQAZu.useProject)();
        projectKey = projectData.key;
    }
    let input = {
        jqlContext: jqlContext,
        quickFiltersJql: quickFiltersJql,
        projectIdOrKey: projectKey,
        fieldIds: getQueryFieldIds(),
        isHidingDoneItems: isHidingDoneItems,
        isParentFieldVisible: isParentFieldVisible(),
        isDevSummaryFieldVisible: isDevSummaryFieldVisible()
    };
    if (groupIssueId != null) input = {
        ...input,
        hierarchyParent: hierarchyParent,
        groupQuery: (0, $26iUh.getGroupQuery)({
            groupIssueId: groupIssueId,
            groupByFieldId: groupByFieldId,
            groups: groups
        })
    };
    else if (parentIssueId != null && hierarchyParent != null) input = {
        ...input,
        hierarchyParent: undefined,
        parentIssue: {
            hierarchyType: hierarchyParent,
            issueId: parentIssueId
        }
    };
    else {
        input.hierarchyLevel = hierarchyLevel;
        input.hierarchyParent = hierarchyParent;
    }
    return input;
};

});


parcelRegister("9DopW", function(module, exports) {

$parcel$export(module.exports, "useSupportedFieldIds", () => $a95fc05aeef016aa$export$ec520f6de95e7778);

var $eUqFw = parcelRequire("eUqFw");

var $gbsaq = parcelRequire("gbsaq");

var $hHiDc = parcelRequire("hHiDc");
const $a95fc05aeef016aa$export$ec520f6de95e7778 = ()=>{
    const { getQueryFieldIds: getQueryFieldIds, getAvailableFields: getAvailableFields } = (0, $hHiDc.useIssueFields)();
    const queryFieldIds = getQueryFieldIds();
    return (0, $eUqFw.useMemo)(()=>[
            ...queryFieldIds,
            ...getAvailableFields().filter((field)=>field.type ? !queryFieldIds.includes(field.id) && (0, $gbsaq.SUPPORTED_GROUPS_TYPES).includes(field.type) : false).map((field)=>field.id)
        ], [
        getAvailableFields,
        queryFieldIds
    ]);
};

});



parcelRegister("5jA3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cec6992b21fffdf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9cec6992b21fffdf$var$ListActionsBanner = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("6NmJR")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/controllers/list-actions-banner/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9cec6992b21fffdf$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "list-actions-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9cec6992b21fffdf$var$ListActionsBanner, props));

});
parcelRegister("6NmJR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hSQOc").then(()=>parcelRequire('5MvXJ'));

});


parcelRegister("eicDW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5640d89dae7af19f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5640d89dae7af19f$var$ListViewUpdater = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("9Bf9K")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/controllers/list-updater/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5640d89dae7af19f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "list-view-updater",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5640d89dae7af19f$var$ListViewUpdater, props));

});
parcelRegister("9Bf9K", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("caoaB").then(()=>parcelRequire('e60XG'));

});


parcelRegister("e3maP", function(module, exports) {

$parcel$export(module.exports, "useReparentModalStore", () => $9c67d8ad9d47df4a$export$2e755c9651c94d7f);
$parcel$export(module.exports, "useShouldShowReparentModal", () => $9c67d8ad9d47df4a$export$bb435bd62aedac9f);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $9c67d8ad9d47df4a$var$actions = {
    openReparentModal: (issueIdToReparent)=>({ setState: setState })=>{
            setState({
                issueIdToReparent: issueIdToReparent
            });
        },
    closeReparentModal: ()=>({ setState: setState })=>{
            setState({
                issueIdToReparent: null
            });
        }
};
const $9c67d8ad9d47df4a$var$ReparentModalStore = (0, $kEDjj.createStore)({
    initialState: {
        issueIdToReparent: null
    },
    actions: $9c67d8ad9d47df4a$var$actions,
    name: 'JWMReparentModal'
});
const $9c67d8ad9d47df4a$export$2e755c9651c94d7f = (0, $1yZQx.createHook)($9c67d8ad9d47df4a$var$ReparentModalStore);
const $9c67d8ad9d47df4a$export$e88c9698e4ec8c24 = (state)=>state.issueIdToReparent != null;
const $9c67d8ad9d47df4a$export$bb435bd62aedac9f = (0, $1yZQx.createHook)($9c67d8ad9d47df4a$var$ReparentModalStore, {
    selector: $9c67d8ad9d47df4a$export$e88c9698e4ec8c24
});

});

parcelRegister("8axyj", function(module, exports) {

$parcel$export(module.exports, "useTableAnalytics", () => $d11291d162364e4c$export$d0703a75f31864f4);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $1eMsI = parcelRequire("1eMsI");
const $d11291d162364e4c$export$d0703a75f31864f4 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ tableRef: tableRef }] = (0, $1eMsI.useTableRefStore)();
    const tableInitialised = (0, $eUqFw.useRef)(false);
    const _columns = tableRef.current?.getColumnManager()?._columns;
    const columns = (0, $eUqFw.useMemo)(()=>_columns ?? [], [
        _columns
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!tableInitialised.current && columns.length > 0) {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'table init', {
                numberOfColumns: columns.length
            });
            tableInitialised.current = true;
        }
    }, [
        columns.length,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("1eMsI", function(module, exports) {

$parcel$export(module.exports, "useTableRefStore", () => $1f6827eabc323acd$export$18c478ca7c21c86a);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $1f6827eabc323acd$var$actions = {
    setTableRef: (tableRef)=>({ setState: setState })=>{
            setState({
                tableRef: tableRef
            });
        }
};
const $1f6827eabc323acd$var$TableRefStore = (0, $kEDjj.createStore)({
    initialState: {
        tableRef: {
            current: null
        }
    },
    actions: $1f6827eabc323acd$var$actions,
    name: 'JWMTableRef'
});
const $1f6827eabc323acd$export$18c478ca7c21c86a = (0, $1yZQx.createHook)($1f6827eabc323acd$var$TableRefStore);

});


parcelRegister("aUash", function(module, exports) {

$parcel$export(module.exports, "useClearStaleGroupBy", () => $b0512a5241132dc8$export$33497e7241a3f128);

var $eUqFw = parcelRequire("eUqFw");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");
const $b0512a5241132dc8$export$33497e7241a3f128 = ({ onClear: onClear })=>{
    const [groupByFieldId, setGroupBy] = (0, $dSE3z.useGroupBy)();
    const { getAvailableFields: getAvailableFields, loading: loading } = (0, $hHiDc.useIssueFields)();
    const availableFields = getAvailableFields();
    (0, $eUqFw.useEffect)(()=>{
        if (!groupByFieldId || loading) return;
        const isGroupedFieldAvailable = availableFields.some((field)=>field.id === groupByFieldId);
        if (!isGroupedFieldAvailable) {
            setGroupBy(undefined);
            onClear();
        }
    }, [
        groupByFieldId,
        setGroupBy,
        availableFields,
        loading,
        onClear
    ]);
    return null;
};

});

parcelRegister("bR4Tm", function(module, exports) {

$parcel$export(module.exports, "useIssueUpdated", () => $6499fbcc568e0c51$export$5ed6d188c4dd5d1d);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $99RVt = parcelRequire("99RVt");
const $6499fbcc568e0c51$var$canRemoveIssue = ({ fieldType: fieldType, issueKey: issueKey, newValue: newValue, oldValue: oldValue })=>{
    switch(fieldType){
        case 0, $lO4Or.PARENT_TYPE:
            if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
                const currentProject = (issueKey ?? '').split('-')[0];
                const oldValueProjectKey = (oldValue?.key ?? '').split('-')[0];
                const newValueProjectKey = (newValue?.key ?? '').split('-')[0];
                if (// parent from foreign project is assigned
                !oldValue?.value && newValueProjectKey !== currentProject || // parent from foreign project is unlinked
                !newValue?.value && oldValueProjectKey !== currentProject) return false;
            }
            return newValue?.value !== oldValue?.value;
        default:
            return false;
    }
};
const $6499fbcc568e0c51$export$5ed6d188c4dd5d1d = ()=>{
    const { onIssueRemoved: onIssueRemoved } = (0, $99RVt.useListViewUpdaterService)();
    const onIssueUpdated = (0, $eUqFw.useCallback)(({ issueKey: issueKey, issueId: issueId, fieldType: fieldType, newValue: newValue, oldValue: oldValue })=>{
        if ($6499fbcc568e0c51$var$canRemoveIssue({
            issueKey: issueKey,
            fieldType: fieldType,
            newValue: newValue,
            oldValue: oldValue
        })) onIssueRemoved({
            issueId: Number(issueId),
            parentId: oldValue?.value ?? undefined
        });
    }, [
        onIssueRemoved
    ]);
    return {
        onIssueUpdated: onIssueUpdated
    };
};

});

parcelRegister("56s5R", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a1ae6fe29740d0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $iEjRn = parcelRequire("iEjRn");



var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0a1ae6fe29740d0a$export$2e2bcd8739ae039 = (props)=>{
    (0, $eUqFw.useEffect)(()=>{
        // preload components required for initial render
        (0, $iEjRn.Table).preload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iEjRn.default), props);
};

});
parcelRegister("iEjRn", function(module, exports) {

$parcel$export(module.exports, "Table", () => $52e903affc483eca$export$54ec01a60f47d33d);
$parcel$export(module.exports, "default", () => $52e903affc483eca$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $al6r8 = parcelRequire("al6r8");

const $52e903affc483eca$export$54ec01a60f47d33d = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("f2Kts")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/base-table/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$52e903affc483eca$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "base-table",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $al6r8.LoadingTable), props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52e903affc483eca$export$54ec01a60f47d33d, props));

});
parcelRegister("al6r8", function(module, exports) {

$parcel$export(module.exports, "LoadingTable", () => $611d347caa94c445$export$b353ee8dbb8fb09e);

var $eUqFw = parcelRequire("eUqFw");

var $90G8g = parcelRequire("90G8g");

var $7P3DW = parcelRequire("7P3DW");
const $611d347caa94c445$var$getRowSkeleton = (columns, rowHeight, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonRow, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonField, key = 0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonRow, {
        key: key
    }, columns.map((column)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonField, {
            key: column.key,
            height: rowHeight,
            width: column.width
        })));
const $611d347caa94c445$var$getLoadingSkeleton = (columns, rowHeight, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonRow, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonField)=>Array.from({
        length: 20
    }, (_, i)=>$611d347caa94c445$var$getRowSkeleton(columns, rowHeight, SkeletonRow, SkeletonField, i));
const $611d347caa94c445$export$b353ee8dbb8fb09e = /*#__PURE__*/ (0, $eUqFw.memo)(({ columns: columns, rowHeight: rowHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.Wrapper), null, columns.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.TableWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.LoadingRow), {
        key: "loading-header-row"
    }, columns.map((column)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.LoadingWrapper), {
            key: column.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.LoadingIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.LoadingField), {
            // @ts-expect-error - Type 'number | undefined' is not assignable to type 'number'.
            height: rowHeight,
            width: column.width - (0, $7P3DW.ICON_OFFSET)
        })))), $611d347caa94c445$var$getLoadingSkeleton(columns, rowHeight, (0, $7P3DW.LoadingRow), (0, $7P3DW.LoadingField))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.SpinnerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90G8g.ThemedSpinner), null))), (prevProps, nextProps)=>prevProps.columns.length === nextProps.columns.length);

});
parcelRegister("7P3DW", function(module, exports) {

$parcel$export(module.exports, "LoadingRow", () => $20a0eba714969846$export$d1e723d3001badba);
$parcel$export(module.exports, "LoadingField", () => $20a0eba714969846$export$2304bbb03949f4f1);
$parcel$export(module.exports, "ICON_OFFSET", () => $20a0eba714969846$export$382610e783aa2ae8);
$parcel$export(module.exports, "LoadingWrapper", () => $20a0eba714969846$export$43a792a870d28db2);
$parcel$export(module.exports, "LoadingIcon", () => $20a0eba714969846$export$b936c55164dcf1db);
$parcel$export(module.exports, "Wrapper", () => $20a0eba714969846$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SpinnerWrapper", () => $20a0eba714969846$export$52b4dfd89a6b3a1b);
$parcel$export(module.exports, "TableWrapper", () => $20a0eba714969846$export$4267411171632d35);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $20a0eba714969846$var$LOADING_VIEW_HEIGHT = '76vh';
const $20a0eba714969846$export$d1e723d3001badba = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$export$2304bbb03949f4f1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1rjw0ur": (0, $9t7rW.default)(`${__cmplp.width - (0, $c9TLT.gridSize) * 2}px`),
            "--_mkz9at": (0, $9t7rW.default)(`${__cmplp.height - (0, $c9TLT.gridSize) * 2}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbra4q _4t3i2wna _bfhk15j7 _18s8u2gc _19bvv77o _2rko1sit",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$var$ICON_SIZE = 24;
const $20a0eba714969846$export$382610e783aa2ae8 = $20a0eba714969846$var$ICON_SIZE + (0, $c9TLT.gridSize) * 2;
const $20a0eba714969846$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$export$b936c55164dcf1db = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1tcg _4t3i1tcg _bfhk1aqf _18s8u2gc _2rko1sit",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoftgi _1e0c1txw _2lx21bp4 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1h6o _4cvr1h6o _1tkeo1og",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$export$4267411171632d35 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _1e0c1ule _4t3io1og _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("f2Kts", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("50qxY")
]).then(()=>parcelRequire('iaq7Q'));

});



parcelRegister("5NSnR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b4548836f1135cd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b4548836f1135cd$var$LazyBulkDeleteModal = (0, $7rh0R.lazy)(()=>(parcelRequire("2ZzhB")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/bulk-delete-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1b4548836f1135cd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "bulk-delete-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4548836f1135cd$var$LazyBulkDeleteModal, null));

});
parcelRegister("2ZzhB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("9pDXu")
]).then(()=>parcelRequire('2DsrU'));

});


parcelRegister("1lhPF", function(module, exports) {

$parcel$export(module.exports, "default", () => $12b3d960aa428cb2$export$2e2bcd8739ae039);
/* eslint-disable react-hooks/rules-of-hooks */ 
var $eUqFw = parcelRequire("eUqFw");

var $4E9Xv = parcelRequire("4E9Xv");

var $5SC3o = parcelRequire("5SC3o");

var $hotly = parcelRequire("hotly");

var $1ybV0 = parcelRequire("1ybV0");

var $9UXmP = parcelRequire("9UXmP");

var $blMI4 = parcelRequire("blMI4");

var $7x2p7 = parcelRequire("7x2p7");
const $12b3d960aa428cb2$var$BulkEdit = ()=>{
    const isBulkEditEnabled = (0, $1ybV0.ff)('bulk-edit-in-jwm-list-view_bny2w');
    if (!isBulkEditEnabled) return null;
    const bulkChangePermission = (0, $9UXmP.useBulkChangePermission)();
    const bulkOperationsForm = (0, $5SC3o.useReferenceLoader)();
    const [, { toggleBulkEditSidebar: toggleBulkEditSidebar }] = (0, $hotly.useBulkSelectionStore)();
    const onOpenSidebar = (0, $eUqFw.useCallback)(()=>{
        toggleBulkEditSidebar({
            showBulkEditSidebar: true
        });
    }, [
        toggleBulkEditSidebar
    ]);
    const onCloseSidebar = (0, $eUqFw.useCallback)(()=>{
        toggleBulkEditSidebar({
            showBulkEditSidebar: false
        });
    }, [
        toggleBulkEditSidebar
    ]);
    if (!isBulkEditEnabled || !bulkChangePermission) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4E9Xv.BulkOpsAnalyticsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7x2p7.BulkEditSidebar), {
        bulkOperationsForm: bulkOperationsForm
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $blMI4.BulkOperationsLoader), {
        bulkOperationsForm: bulkOperationsForm,
        onCloseSidebar: onCloseSidebar,
        onOpenSidebar: onOpenSidebar
    }));
};
var $12b3d960aa428cb2$export$2e2bcd8739ae039 = $12b3d960aa428cb2$var$BulkEdit;

});
parcelRegister("4E9Xv", function(module, exports) {

$parcel$export(module.exports, "BulkOpsAnalyticsProvider", () => $3d2709472df65d95$export$8ab440f197429d1e);
$parcel$export(module.exports, "useBulkOpsSessionContext", () => $3d2709472df65d95$export$95271787b6ae4d3c);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $jeI7w = parcelRequire("jeI7w");
const $3d2709472df65d95$var$BulkOpsAnalyticsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3d2709472df65d95$export$8ab440f197429d1e = (props)=>{
    const [bulkOpsFlow] = (0, $eUqFw.useState)(new (0, $jeI7w.DefaultBulkOpsFlow)());
    const [bulkOpsSessionID, setBulkOpsSessionID] = (0, $eUqFw.useState)(bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID || undefined);
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = bulkOpsFlow?.registerAnalyticsEventPublisher((sessionId)=>{
            setBulkOpsSessionID(sessionId);
        });
        return ()=>{
            unsubscribe?.();
        };
    }, [
        bulkOpsFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d2709472df65d95$var$BulkOpsAnalyticsContext.Provider, {
        value: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            bulkOpsSessionID: bulkOpsSessionID
        }
    }, props.children));
};
const $3d2709472df65d95$export$95271787b6ae4d3c = ()=>(0, $eUqFw.useContext)($3d2709472df65d95$var$BulkOpsAnalyticsContext);

});
parcelRegister("jeI7w", function(module, exports) {

$parcel$export(module.exports, "DefaultBulkOpsFlow", () => $d9ae6884fa818966$export$74bf75c57acfbb74);

var $hompL = parcelRequire("hompL");
class $d9ae6884fa818966$export$74bf75c57acfbb74 {
    isInFlow() {
        return this.bulkOpsSessionID !== undefined;
    }
    get sessionID() {
        return this.bulkOpsSessionID;
    }
    get bulkActionsCompleted() {
        return this.numBulkActionsCompleted;
    }
    get bulkOperationType() {
        return this.bulkOperationTypeValue;
    }
    notifyAnalyticsEventPublishers(sessionID) {
        let index = 0;
        this.analyticsEventPublishers.forEach((listener)=>{
            listener(sessionID, index);
            index += 1;
        });
        this.analyticsEventPublishers.clear();
    }
    start(_attributes) {
        if (this.isInFlow()) return;
        this.bulkOpsSessionID = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        this.notifyAnalyticsEventPublishers(this.bulkOpsSessionID);
    }
    end(_attributes) {
        this.bulkOpsSessionID = undefined;
        this.numBulkActionsCompleted = 0;
    }
    executeAction() {
        if (!this.isInFlow()) this.start();
        this.numBulkActionsCompleted += 1;
    }
    setBulkOperationType(bulkOperationType) {
        this.bulkOperationTypeValue = bulkOperationType;
    }
    getFlowAttributes() {
        if (this.bulkOpsSessionID && this.numBulkActionsCompleted !== 0) return {
            bulkOpsSessionID: this.bulkOpsSessionID,
            numBulkActionsCompleted: this.numBulkActionsCompleted
        };
        return this.bulkOpsSessionID ? {
            bulkOpsSessionID: this.bulkOpsSessionID
        } : {};
    }
    registerAnalyticsEventPublisher(analyticsEventPublisher) {
        this.analyticsEventPublishers.add(analyticsEventPublisher);
        return ()=>{
            this.analyticsEventPublishers.delete(analyticsEventPublisher);
        };
    }
    constructor(){
        this.numBulkActionsCompleted = 0;
        this.analyticsEventPublishers = new Set();
    }
}

});


parcelRegister("5SC3o", function(module, exports) {

$parcel$export(module.exports, "useReferenceLoader", () => $1500fcd781a55507$export$727d936bc4a88f4e);

var $eUqFw = parcelRequire("eUqFw");
const $1500fcd781a55507$export$727d936bc4a88f4e = ()=>{
    const [ref, setRef] = (0, $eUqFw.useState)(null);
    return (0, $eUqFw.useMemo)(()=>({
            setRef: setRef,
            ref: ref
        }), [
        setRef,
        ref
    ]);
};

});

parcelRegister("9UXmP", function(module, exports) {

$parcel$export(module.exports, "useBulkChangePermission", () => $8991899306b94587$export$9a67849ec94d7b59);

var $eUqFw = parcelRequire("eUqFw");

var $hotly = parcelRequire("hotly");

var $1ybV0 = parcelRequire("1ybV0");

var $fTkNj = parcelRequire("fTkNj");
const $8991899306b94587$export$9a67849ec94d7b59 = ()=>{
    if (!(0, $1ybV0.ff)('bulk-edit-in-jwm-list-view_bny2w')) return false;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [, { setBulkChangePermission: setBulkChangePermission }] = (0, $hotly.useBulkSelectionStore)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const bulkChangePermission = (0, $fTkNj.useBulkChangePermissionService)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useEffect)(()=>{
        bulkChangePermission !== null && bulkChangePermission !== undefined && setBulkChangePermission({
            bulkChangePermission: bulkChangePermission
        });
    }, [
        bulkChangePermission,
        setBulkChangePermission
    ]);
    return bulkChangePermission;
};

});
parcelRegister("fTkNj", function(module, exports) {

$parcel$export(module.exports, "useBulkChangePermissionService", () => $8131c5fbbb51b610$export$cd2838b9aad6b912);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gd0Sp = parcelRequire("gd0Sp");

const $8131c5fbbb51b610$export$cd2838b9aad6b912 = ()=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const [bulkChangePermission, setPermission] = (0, $eUqFw.useState)();
    const getBulkChangePermission = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const gqlResponse = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $366c055cc947f138$export$f9d7f5d9663f3e0c),
                    variables: {
                        cloudId: cloudId
                    }
                })
            });
            setPermission(gqlResponse?.data?.jira?.permission?.hasPermission ?? false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchBulkChangePermission',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to get bulk change permission.'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setPermission(false);
        }
    }, [
        cloudId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!cloudId) return;
        getBulkChangePermission();
    }, [
        getBulkChangePermission,
        cloudId
    ]);
    return bulkChangePermission;
};

});
const $366c055cc947f138$export$f9d7f5d9663f3e0c = `
query GetBulkEditPermission ($cloudId: ID!) {
    jira {
      permission(cloudId: $cloudId, type: BULK_CHANGE)
        @optIn(to: "JiraPermission")
        {
            hasPermission
        }
    }
  }
`;



parcelRegister("blMI4", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsLoader", () => $f0823ea538c98d65$export$3af81192d3c2a190);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $eZoe4 = parcelRequire("eZoe4");

var $hotly = parcelRequire("hotly");

var $epZpb = parcelRequire("epZpb");

var $dSE3z = parcelRequire("dSE3z");

var $1ji6g = parcelRequire("1ji6g");
const $f0823ea538c98d65$export$3af81192d3c2a190 = ({ bulkOperationsForm: bulkOperationsForm, onOpenSidebar: onOpenSidebar, onCloseSidebar: onCloseSidebar })=>{
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const { bulkOptimisticUpdate: bulkOptimisticUpdate } = (0, $1ji6g.useUpdateGroupIssue)();
    const { updateSelectedItemsInCache: updateSelectedItemsInCache } = (0, $epZpb.useBulkEditCacheActions)();
    const [{ bulkEditableIssues: selectedIssues }] = (0, $hotly.useBulkSelectionStore)();
    const onUpdateStart = (0, $eUqFw.useCallback)((res)=>{
        const { data: data, issueIds: issueIds } = res[0];
        if (data) {
            if (groupByFieldId) // TODO: Transform data to ListItemField type for bulkOptimisticUpdate
            bulkOptimisticUpdate(issueIds, []);
            else updateSelectedItemsInCache({
                data: data,
                issueIds: issueIds
            });
        }
    }, [
        groupByFieldId,
        bulkOptimisticUpdate,
        updateSelectedItemsInCache
    ]);
    // TODO remove this action on bulk-transition-multiple-workflows_wtnvv cleanup
    const onUpdateStartOld = (0, $eUqFw.useCallback)(({ data: data, issueIds: issueIds })=>{
        if (data) {
            if (groupByFieldId) // TODO: Transform data to ListItemField type for bulkOptimisticUpdate
            bulkOptimisticUpdate(issueIds, []);
            else updateSelectedItemsInCache({
                data: data,
                issueIds: issueIds
            });
        }
    }, [
        groupByFieldId,
        bulkOptimisticUpdate,
        updateSelectedItemsInCache
    ]);
    const onUpdateError = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), []);
    const onUpdateSuccess = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), []);
    const onOpenForm = (0, $eUqFw.useCallback)(()=>{
        onOpenSidebar();
    }, [
        onOpenSidebar
    ]);
    const onCloseForm = (0, $eUqFw.useCallback)(()=>{
        onCloseSidebar();
    }, [
        onCloseSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZoe4.AsyncBulkOpsCore), {
        bulkOperationsForm: bulkOperationsForm,
        onOpenForm: onOpenForm,
        onCloseForm: onCloseForm,
        onUpdateStart: onUpdateStart,
        onUpdateStartOld: onUpdateStartOld,
        onUpdateError: onUpdateError,
        onUpdateSuccess: onUpdateSuccess,
        onLegacyBulkEditRequest: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onSelectAll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        selectableIssueIds: [],
        selectedIssueIds: Array.from(selectedIssues).map(Number) ?? [],
        extraAnalyticsAttributes: {},
        onClearAll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onClearAllVisible: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        // configure when resolving the ticket https://jplat.jira.atlassian.cloud/browse/THOR-3771. leaving this switched on by default for now.
        hasBulkEditPermission: true
    });
};

});
parcelRegister("eZoe4", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkOpsCore", () => $d719578b48c9f60c$export$ac7b39f8b8a9f5cd);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $jt2jz = parcelRequire("jt2jz");
const $d719578b48c9f60c$var$entryPointParams = {};
const $d719578b48c9f60c$export$ac7b39f8b8a9f5cd = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $jt2jz.asyncBulkopsCoreEntryPoint), $d719578b48c9f60c$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira.backlog.bulk.operations.core",
        packageName: "jiraBulkOperationsCore",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: props
    });
};

});
parcelRegister("jt2jz", function(module, exports) {

$parcel$export(module.exports, "asyncBulkopsCoreEntryPoint", () => $a24e50e796ac10e7$export$3e78ba4b165ed95e);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $a24e50e796ac10e7$export$3e78ba4b165ed95e = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("fz112")), {
        moduleId: "f81933b6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fz112", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("ZR3gR")
]).then(()=>parcelRequire('hAaG7'));

});



parcelRegister("epZpb", function(module, exports) {

$parcel$export(module.exports, "useBulkEditCacheActions", () => $3e05e02cb955498f$export$cbb9dab75d903148);

var $eUqFw = parcelRequire("eUqFw");

var $fcWBJ = parcelRequire("fcWBJ");

var $jG2Eu = parcelRequire("jG2Eu");

var $kQAZu = parcelRequire("kQAZu");

var $7Sz8O = parcelRequire("7Sz8O");

var $hTnQu = parcelRequire("hTnQu");

var $3OkRL = parcelRequire("3OkRL");

var $5r9Wo = parcelRequire("5r9Wo");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $7XECd = parcelRequire("7XECd");

var $fjqly = parcelRequire("fjqly");

var $hHiDc = parcelRequire("hHiDc");

var $hotly = parcelRequire("hotly");

var $1cjzL = parcelRequire("1cjzL");
const $3e05e02cb955498f$export$cbb9dab75d903148 = ()=>{
    const { updateItemsInCache: updateItemsInCache } = (0, $hTnQu.useCacheActions)();
    const [{ selectedIssues: selectedIssues }] = (0, $hotly.useBulkSelectionStore)();
    const [{ issuesMap: issuesMap, issueParentMap: issueParentMap, childrenItems: childrenItems }] = (0, $5r9Wo.useHierarchyStore)();
    const { getQueryFieldIds: getQueryFieldIds } = (0, $1ybV0.ff)('thor-3996-optimistic-update-fixes-for-parent-field_6zcxj') ? (0, $hHiDc.useIssueFields)() : {
        getQueryFieldIds: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
    const queryFieldIds = (0, $1ybV0.ff)('thor-3996-optimistic-update-fixes-for-parent-field_6zcxj') ? getQueryFieldIds() : undefined;
    const { key: projectKey } = (0, $1ybV0.ff)('thor-3996-optimistic-update-fixes-for-parent-field_6zcxj') ? (0, $kQAZu.useProject)() : {
        key: undefined
    };
    const { updateIssueParent: updateIssueParent, unlinkParentIssue: unlinkParentIssue } = (0, $1ybV0.ff)('thor-3996-optimistic-update-fixes-for-parent-field_6zcxj') ? (0, $3OkRL.useUpdateIssueParent)({
        childrenQueryData: childrenItems,
        // @ts-expect-error - TS2322 - Type 'void | string[]' is not assignable to type 'string[]'.
        fieldIds: queryFieldIds,
        issuesMap: issuesMap,
        issueParentMap: issueParentMap,
        cacheQuery: (0, $7XECd.LIST_VIEW_QUERY),
        removeChildFromParent: (0, $fjqly.removeChildFromParentListView),
        addChildToParent: (0, $fjqly.addChildToParentListView),
        view: 'list',
        packageName: 'jiraBusinessList',
        shouldOnlyUpdateCache: true,
        projectKey: projectKey
    }) : {
        updateIssueParent: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        unlinkParentIssue: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
    const updateSelectedItemsInCache = (0, $eUqFw.useCallback)(({ data: data, issueIds: issueIds })=>{
        const selectedIssuesByParent = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))((0, $1ybV0.ff)('thor-3996-optimistic-update-fixes-for-parent-field_6zcxj') ? [
            ...issueIds.map((issueId)=>issueId.toString())
        ] : [
            ...selectedIssues
        ], (issueId)=>issuesMap.get(issueId)?.parentIssueId || (0, $7Sz8O.ROOT_LEVEL));
        const parents = Object.entries(selectedIssuesByParent);
        const optimisticUpdateIssue = (existingIssue)=>{
            const updatedIssue = {
                ...existingIssue,
                fields: [
                    ...existingIssue.fields?.filter((field)=>!Object.keys(data).includes(field?.fieldId)) ?? [],
                    ...(0, $1cjzL.transformData)(existingIssue, data)
                ]
            };
            return updatedIssue;
        };
        parents.forEach(([, issues])=>{
            const variables = issuesMap.get(issues[0])?.cacheVariables;
            if (variables !== undefined) {
                updateItemsInCache({
                    query: (0, $7XECd.LIST_VIEW_QUERY),
                    variables: {
                        ...variables,
                        withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
                    },
                    issueIds: issues,
                    updateItem: optimisticUpdateIssue
                });
                if ((0, $1ybV0.ff)('thor-3996-optimistic-update-fixes-for-parent-field_6zcxj') && data?.[0, $lO4Or.PARENT_TYPE] !== undefined) issues.forEach((issueId)=>{
                    if (data?.[0, $lO4Or.PARENT_TYPE]?.id) {
                        const parentIssue = issuesMap.get(data?.[0, $lO4Or.PARENT_TYPE].id.toString());
                        if (parentIssue) updateIssueParent({
                            issueKey: issueId,
                            parentIssue: parentIssue
                        });
                    } else unlinkParentIssue({
                        issueKey: issueId
                    });
                });
            }
        });
    }, [
        selectedIssues,
        issuesMap,
        updateItemsInCache,
        updateIssueParent,
        unlinkParentIssue
    ]);
    return {
        updateSelectedItemsInCache: updateSelectedItemsInCache
    };
};

});
parcelRegister("3OkRL", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueParent", () => $cd775cf1529c48eb$export$346cb12ae0ad6251);

var $eUqFw = parcelRequire("eUqFw");

var $i3K0B = parcelRequire("i3K0B");

var $gEmpR = parcelRequire("gEmpR");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $hTnQu = parcelRequire("hTnQu");

var $lskA1 = parcelRequire("lskA1");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $lO4Or = parcelRequire("lO4Or");

var $85tnI = parcelRequire("85tnI");

var $jucRl = parcelRequire("jucRl");

var $9quC1 = parcelRequire("9quC1");

var $75h8j = parcelRequire("75h8j");
const $cd775cf1529c48eb$export$346cb12ae0ad6251 = ({ childrenQueryData: childrenQueryData = {}, fieldIds: fieldIds, issueParentMap: issueParentMap, issuesMap: issuesMap, cacheQuery: cacheQuery, addChildToParent: addChildToParent, removeChildFromParent: removeChildFromParent, view: view, packageName: packageName, shouldOnlyUpdateCache: shouldOnlyUpdateCache = false, projectKey: projectKey })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { hierarchyLevels: hierarchyLevels } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, jqlContext: jqlContext, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: view
    });
    const { addToCache: addToCache, getCachedIssueById: getCachedIssueById, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, $hTnQu.useCacheActions)();
    const [newParentIssue, setNewParentIssue] = (0, $eUqFw.useState)();
    const [reparentIssue, setReparentIssue] = (0, $eUqFw.useState)();
    const [optimisticRank, setOptimisticRank] = (0, $eUqFw.useState)('');
    const [revertData, setRevertData] = (0, $eUqFw.useState)(null);
    const updateParentIssueExperience = (0, $9quC1.getUpdateParentIssueExperience)(packageName);
    const startExperience = (0, $4G5xU.useExperienceStart)(updateParentIssueExperience);
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)(updateParentIssueExperience);
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)(updateParentIssueExperience);
    const updateIssueField = (0, $jucRl.useUpdateIssueField)({
        onSuccess: ()=>{
            markExperienceSuccess();
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onError: (error)=>{
            if (error.statusCode === 400) showFlag((0, $9quC1.UPDATE_ITEM_PARENT_FAIL_400_FLAG));
            else if (error.statusCode === 404) showFlag((0, $9quC1.UPDATE_ITEM_PARENT_FAIL_404_FLAG));
            else {
                showFlag((0, $9quC1.UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
                markExperienceFailed('update issue parent failed', error);
            }
            throw error;
        }
    });
    const getRankPosition = (0, $eUqFw.useCallback)((rankRequest)=>{
        if (!rankRequest) return;
        const relativeIssueId = rankRequest.rankAfterId || rankRequest.rankBeforeId;
        if (relativeIssueId) {
            const relativeIssue = issuesMap.get(relativeIssueId);
            const relativeIssueRank = rankRequest.rankPosition || relativeIssue?.rank;
            if (relativeIssueRank) {
                const { rankBeforeId: rankBeforeId } = rankRequest;
                return rankBeforeId ? (0, $lskA1.getPreviousRank)(relativeIssueRank) : (0, $lskA1.getNextRank)(relativeIssueRank);
            }
        }
    }, [
        issuesMap
    ]);
    const getVariablesInput = (0, $eUqFw.useCallback)((parentId)=>{
        const defaultVariableInput = {
            jqlContext: jqlContext,
            fieldIds: fieldIds,
            quickFiltersJql: quickFiltersJql,
            isHidingDoneItems: isHidingDoneItems,
            ...hierarchyLevels !== undefined && {
                hierarchyLevel: hierarchyLevels[0]?.level
            },
            // project clause is only used in List view to render issues with parents from foreign projects
            projectIdOrKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? projectKey : undefined
        };
        if (hierarchyParent && parentId) return {
            ...defaultVariableInput,
            hierarchyParent: undefined,
            parentIssue: {
                hierarchyType: hierarchyParent,
                issueId: parentId
            }
        };
        return {
            ...defaultVariableInput,
            hierarchyParent: hierarchyParent
        };
    }, [
        jqlContext,
        fieldIds,
        quickFiltersJql,
        isHidingDoneItems,
        hierarchyLevels,
        projectKey,
        hierarchyParent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hierarchyParent && newParentIssue && reparentIssue) {
            const { issueId: newParentId, hasChildren: hasChildren, childSummary: childSummary } = newParentIssue;
            if (childrenQueryData[newParentId] && childrenQueryData[newParentId].loading === false) {
                const grandParentId = issueParentMap?.get(newParentId) ?? newParentIssue?.parentIssueId;
                if (!hasChildren || typeof childSummary?.totalCount === 'number') // Update parent issue hasChildren to true
                updateItemsInCache({
                    query: cacheQuery,
                    // We need to get the details of the current parent from the grandparent
                    variables: (0, $i3K0B.getVariables)(getVariablesInput(grandParentId)),
                    issueIds: [
                        newParentIssue.issueId
                    ],
                    updateItem: (existingIssue)=>addChildToParent(existingIssue)
                });
                const variables = (0, $i3K0B.getVariables)(getVariablesInput(newParentId));
                const newNode = (0, $75h8j.generateIssueWithUpdatedParent)(reparentIssue, newParentIssue, view);
                addToCache({
                    query: cacheQuery,
                    variables: variables,
                    newNodes: [
                        optimisticRank ? (0, $85tnI.getOptimisticRanked)(newNode, optimisticRank) : newNode
                    ]
                });
                setReparentIssue(undefined);
                setNewParentIssue(undefined);
                setOptimisticRank('');
            }
        }
    }, [
        addToCache,
        childrenQueryData,
        getVariablesInput,
        hierarchyParent,
        isHidingDoneItems,
        jqlContext,
        quickFiltersJql,
        newParentIssue,
        reparentIssue,
        updateItemsInCache,
        getCachedIssueById,
        issueParentMap,
        optimisticRank,
        cacheQuery,
        addChildToParent,
        issuesMap,
        view
    ]);
    const updateIssueParentCache = (0, $eUqFw.useCallback)(({ oldParentId: oldParentId, issueKey: issueKey, parentIssue: parentIssue })=>{
        const variables = (0, $i3K0B.getVariables)(getVariablesInput(oldParentId));
        const issue = getCachedIssueById({
            issueId: issueKey,
            query: cacheQuery,
            variables: variables
        });
        setNewParentIssue(parentIssue);
        if (issue) setReparentIssue(issue);
        // Remove the issue from the old parent
        removeFromCache({
            query: cacheQuery,
            variables: variables,
            issueId: Number(issueKey)
        });
        // update child count of prev parent
        if (oldParentId && removeChildFromParent) {
            const grandParentId = issuesMap.get(oldParentId)?.parentIssueId;
            const queryVariables = (0, $i3K0B.getVariables)(getVariablesInput(grandParentId));
            updateItemsInCache({
                query: cacheQuery,
                variables: queryVariables,
                issueIds: [
                    String(oldParentId)
                ],
                updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
            });
        }
    }, [
        getVariablesInput,
        getCachedIssueById,
        cacheQuery,
        removeFromCache,
        removeChildFromParent,
        updateItemsInCache,
        issuesMap
    ]);
    const unlinkParentIssueCache = (0, $eUqFw.useCallback)(({ issueKey: issueKey, oldParentId: oldParentId, updateRank: updateRank })=>{
        const variables = (0, $i3K0B.getVariables)(getVariablesInput(oldParentId));
        const issue = getCachedIssueById({
            issueId: issueKey,
            query: cacheQuery,
            variables: variables
        });
        // Remove the issue from the old parent
        removeFromCache({
            query: cacheQuery,
            variables: variables,
            issueId: Number(issueKey)
        });
        // update child count of prev parent
        if (oldParentId && removeChildFromParent) {
            const grandParentId = issuesMap.get(oldParentId)?.parentIssueId;
            const queryVariables = (0, $i3K0B.getVariables)(getVariablesInput(grandParentId));
            updateItemsInCache({
                query: cacheQuery,
                variables: queryVariables,
                issueIds: [
                    String(oldParentId)
                ],
                updateItem: (parentIssue)=>removeChildFromParent(parentIssue, 1)
            });
        }
        const reparentIssueVariable = (0, $i3K0B.getVariables)(getVariablesInput());
        if (issue) {
            const newNode = (0, $75h8j.generateIssueWithUpdatedParent)(issue, undefined, view);
            // Add issue to the top level
            addToCache({
                query: cacheQuery,
                variables: reparentIssueVariable,
                newNodes: [
                    updateRank ? (0, $85tnI.getOptimisticRanked)(newNode, updateRank) : newNode
                ]
            });
        }
    }, [
        getVariablesInput,
        getCachedIssueById,
        cacheQuery,
        removeFromCache,
        removeChildFromParent,
        issuesMap,
        updateItemsInCache,
        view,
        addToCache
    ]);
    const revertOptimisticCacheUpdate = (0, $eUqFw.useCallback)(({ originalParentId: originalParentId, parentIssue: parentIssue, issueKey: issueKey, originalRank: originalRank })=>{
        const originalParent = originalParentId && issuesMap.get(originalParentId);
        if (originalParent) updateIssueParentCache({
            oldParentId: parentIssue?.issueId,
            issueKey: issueKey,
            parentIssue: originalParent
        });
        else if (originalRank && parentIssue) unlinkParentIssueCache({
            oldParentId: parentIssue.issueId,
            issueKey: issueKey,
            updateRank: originalRank
        });
    }, [
        issuesMap,
        unlinkParentIssueCache,
        updateIssueParentCache
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (revertData && revertData.parentIssue?.issueId && childrenQueryData[revertData.parentIssue.issueId] && childrenQueryData[revertData.parentIssue.issueId].loading === false) {
            const { originalParentId: originalParentId, parentIssue: parentIssue, issueKey: issueKey, originalRank: originalRank } = revertData;
            originalRank && setOptimisticRank(originalRank);
            revertOptimisticCacheUpdate({
                originalParentId: originalParentId,
                parentIssue: parentIssue,
                issueKey: issueKey,
                originalRank: originalRank
            });
            setRevertData(null);
        }
    }, [
        childrenQueryData,
        revertData,
        revertOptimisticCacheUpdate
    ]);
    const updateIssueParent = (0, $eUqFw.useCallback)(async ({ issueKey: issueKey, parentIssue: parentIssue, rankRequest: rankRequest, oldParentIssueId: oldParentIssueId })=>{
        !shouldOnlyUpdateCache && startExperience();
        const updateRank = getRankPosition(rankRequest);
        if (updateRank) setOptimisticRank(updateRank);
        const issue = issuesMap.get(String(issueKey));
        const originalRank = issue?.rank;
        const oldParentId = oldParentIssueId ?? issueParentMap?.get(issueKey);
        updateIssueParentCache({
            oldParentId: oldParentId,
            issueKey: issueKey,
            parentIssue: parentIssue
        });
        if (shouldOnlyUpdateCache) {
            await Promise.resolve();
            return {
                updateStatus: (0, $9quC1.SUCCEEDED)
            };
        }
        try {
            await updateIssueField({
                issueKey: issueKey,
                fieldKey: (0, $lO4Or.PARENT_TYPE),
                newValue: {
                    id: String(parentIssue.issueId)
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: (0, $9quC1.ERROR_ID),
                    packageName: (0, $9quC1.PACKAGE_NAME),
                    teamName: (0, $9quC1.TEAM_NAME)
                },
                attributes: {
                    message: 'update issue parent failed',
                    parentLevel: parentIssue?.issueType?.hierarchyLevel,
                    issueLevel: issue?.issueType?.hierarchyLevel,
                    view: view
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setRevertData({
                originalParentId: oldParentId,
                parentIssue: parentIssue,
                issueKey: issueKey,
                originalRank: originalRank
            });
            return {
                updateStatus: (0, $9quC1.FAILED)
            };
        }
        return {
            updateStatus: (0, $9quC1.SUCCEEDED)
        };
    }, [
        shouldOnlyUpdateCache,
        startExperience,
        getRankPosition,
        issuesMap,
        issueParentMap,
        updateIssueParentCache,
        updateIssueField,
        view
    ]);
    const unlinkParentIssue = (0, $eUqFw.useCallback)(async ({ issueKey: issueKey, rankRequest: rankRequest, oldParentIssueId: oldParentIssueId })=>{
        !shouldOnlyUpdateCache && startExperience();
        const oldParentId = oldParentIssueId || issueParentMap?.get(issueKey);
        const updateRank = getRankPosition(rankRequest);
        const originalRank = issuesMap.get(String(issueKey))?.rank;
        unlinkParentIssueCache({
            issueKey: issueKey,
            oldParentId: oldParentId,
            updateRank: updateRank
        });
        if (shouldOnlyUpdateCache) {
            await Promise.resolve();
            return {
                updateStatus: (0, $9quC1.SUCCEEDED)
            };
        }
        try {
            await updateIssueField({
                issueKey: issueKey,
                fieldKey: (0, $lO4Or.PARENT_TYPE),
                newValue: {
                    id: null
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const issue = issuesMap.get(String(issueKey));
            (0, $guiFP.default)({
                meta: {
                    id: (0, $9quC1.ERROR_ID),
                    packageName: (0, $9quC1.PACKAGE_NAME),
                    teamName: (0, $9quC1.TEAM_NAME)
                },
                attributes: {
                    message: 'unlink issue parent failed',
                    issueLevel: issue?.issueType?.hierarchyLevel,
                    view: view
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            if (originalRank) {
                setOptimisticRank(originalRank);
                revertOptimisticCacheUpdate({
                    originalParentId: oldParentId,
                    issueKey: issueKey
                });
            }
            return {
                updateStatus: (0, $9quC1.FAILED)
            };
        }
        return {
            updateStatus: (0, $9quC1.SUCCEEDED)
        };
    }, [
        shouldOnlyUpdateCache,
        startExperience,
        issueParentMap,
        getRankPosition,
        issuesMap,
        unlinkParentIssueCache,
        updateIssueField,
        view,
        revertOptimisticCacheUpdate
    ]);
    return {
        updateIssueParent: updateIssueParent,
        unlinkParentIssue: unlinkParentIssue
    };
};

});
parcelRegister("85tnI", function(module, exports) {

$parcel$export(module.exports, "getOptimisticRanked", () => $fc25204f4b93389f$export$44963c8ed1f74aef);
$parcel$export(module.exports, "getListViewRelativeIssueInfo", () => $fc25204f4b93389f$export$caf645882630a6c1);

var $lO4Or = parcelRequire("lO4Or");
const $fc25204f4b93389f$export$44963c8ed1f74aef = (issue, rank)=>{
    const newRank = {
        ...issue?.fields?.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (field)=>field.type === (0, $lO4Or.RANK_CF_TYPE) || field.aliasFieldId === 'rank')
    };
    newRank.text = rank;
    return {
        ...issue,
        fields: [
            ...issue?.fields?.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (field)=>field.type !== (0, $lO4Or.RANK_CF_TYPE) && field.aliasFieldId !== 'rank') || [],
            newRank
        ]
    };
};
const $fc25204f4b93389f$export$caf645882630a6c1 = ({ newIndex: newIndex, oldIndex: oldIndex, issues: issues, instruction: instruction, relativeIssueOverride: relativeIssueOverride })=>{
    let rankCall = newIndex === 0 ? 'rankBefore' : 'rankAfter';
    // instruction will only be available ranking via dnd
    if (instruction) rankCall = instruction === 'reorder-below' ? 'rankAfter' : 'rankBefore';
    // if newIndex is 0 we want to optimistically rank it above the task that is
    // currently at index 0 of the collection
    let afterIndex = newIndex > oldIndex ? newIndex : Math.max(0, newIndex - 1);
    // newIndex will equal oldIndex in cases where we dnd to reparent and rank
    if (newIndex === oldIndex) afterIndex = rankCall === 'rankAfter' ? Math.max(0, newIndex - 1) : newIndex;
    let relativeIssue = relativeIssueOverride ?? issues[afterIndex];
    // if issue to rank after doesn't have a rank eg. group item then let's try and
    // rank before instead
    if (!relativeIssue?.rank) {
        const beforeIndex = newIndex > oldIndex ? Math.min(issues.length - 1, newIndex + 1) : newIndex;
        relativeIssue = issues[beforeIndex];
        rankCall = 'rankBefore';
    }
    return {
        rankCall: rankCall,
        relativeIssue: relativeIssue
    };
};

});

parcelRegister("jucRl", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueField", () => $d5ea7f4a6ca981df$export$cc74d3329dbba44d);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $fecbI = parcelRequire("fecbI");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $d5ea7f4a6ca981df$var$JWM_ISSUE_FIELD_UPDATE = 'jwmIssueFieldUpdate';
const $d5ea7f4a6ca981df$export$cc74d3329dbba44d = ({ onError: onError, onSuccess: onSuccess })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const updateIssueField = (0, $eUqFw.useCallback)(async ({ issueKey: issueKey, fieldKey: fieldKey, newValue: newValue })=>(0, $fecbI.defaultSaveField)(issueKey, fieldKey, newValue, '').then((response)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$d5ea7f4a6ca981df$var$JWM_ISSUE_FIELD_UPDATE} succeeded`, {
                field: newValue
            });
            onSuccess && onSuccess();
            return response;
        }).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: $d5ea7f4a6ca981df$var$JWM_ISSUE_FIELD_UPDATE,
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                attributes: {
                    message: `${$d5ea7f4a6ca981df$var$JWM_ISSUE_FIELD_UPDATE} failed`,
                    field: fieldKey.startsWith('customfield_') ? 'category' : fieldKey
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            onError && onError(error);
        }), [
        createAnalyticsEvent,
        onError,
        onSuccess
    ]);
    return updateIssueField;
};

});
parcelRegister("fecbI", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $4eca3d717c3df3ee$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $4eca3d717c3df3ee$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $4eca3d717c3df3ee$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $4eca3d717c3df3ee$export$33b78476f5d734b3);

var $lRmyA = parcelRequire("lRmyA");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eca3d717c3df3ee$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $4eca3d717c3df3ee$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $4eca3d717c3df3ee$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("9quC1", function(module, exports) {

$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG", () => $7c7324ba52c0b878$export$e80b28191e1d3602);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG", () => $7c7324ba52c0b878$export$29d372313e7a3d7b);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG", () => $7c7324ba52c0b878$export$6a4ca5120f2baf63);
$parcel$export(module.exports, "getUpdateParentIssueExperience", () => $7c7324ba52c0b878$export$8f39ff4e40cb6a05);
$parcel$export(module.exports, "SUCCEEDED", () => $7c7324ba52c0b878$export$11823571c61d4d02);
$parcel$export(module.exports, "FAILED", () => $7c7324ba52c0b878$export$d71930f7f5807a72);
$parcel$export(module.exports, "PACKAGE_NAME", () => $7c7324ba52c0b878$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "ERROR_ID", () => $7c7324ba52c0b878$export$f3390a0e172fee41);
$parcel$export(module.exports, "TEAM_NAME", () => $7c7324ba52c0b878$export$d57b6b390e78d90f);

var $1vfhg = parcelRequire("1vfhg");
const $7c7324ba52c0b878$export$e80b28191e1d3602 = {
    type: 'error',
    title: (0, $1vfhg.default).updateIssueParentErrorTitleNonFinal,
    description: (0, $1vfhg.default).updateIssueParentGenericErrorDescriptionNonFinal
};
const $7c7324ba52c0b878$export$29d372313e7a3d7b = {
    type: 'error',
    title: (0, $1vfhg.default).updateIssueParentErrorTitleNonFinal,
    description: (0, $1vfhg.default).updateIssueParent400ErrorDescriptionNonFinal
};
const $7c7324ba52c0b878$export$6a4ca5120f2baf63 = {
    type: 'error',
    title: (0, $1vfhg.default).updateIssueParentErrorTitleNonFinal,
    description: (0, $1vfhg.default).updateIssueParent404ErrorDescriptionNonFinal
};
const $7c7324ba52c0b878$export$8f39ff4e40cb6a05 = (packageName)=>({
        experience: 'updateParentIssue',
        packageName: packageName,
        teamName: 'keystone'
    });
const $7c7324ba52c0b878$export$11823571c61d4d02 = 'SUCCEEDED';
const $7c7324ba52c0b878$export$d71930f7f5807a72 = 'FAILED';
const $7c7324ba52c0b878$export$b8b9d90f9e5bd72b = 'jiraBusinessListHandlers';
const $7c7324ba52c0b878$export$f3390a0e172fee41 = 'useUpdateIssueParent';
const $7c7324ba52c0b878$export$d57b6b390e78d90f = 'keystone';

});
parcelRegister("1vfhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3855af390f6eddc6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // TODO: Finalize the following messages
$3855af390f6eddc6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    updateIssueParentErrorTitleNonFinal: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-error-title-non-final",
        "defaultMessage": "Something's gone wrong"
    },
    updateIssueParentGenericErrorDescriptionNonFinal: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-generic-error-description-non-final",
        "defaultMessage": "Refresh the page and try again."
    },
    updateIssueParent400ErrorDescriptionNonFinal: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-400-error-description-non-final",
        "defaultMessage": "You don\u2019t have permission to update this issue. Contact a project admin."
    },
    updateIssueParent404ErrorDescriptionNonFinal: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-404-error-description-non-final",
        "defaultMessage": "We\u2019re having trouble updating this issue. To continue, refresh the page."
    }
});

});


parcelRegister("75h8j", function(module, exports) {

$parcel$export(module.exports, "generateIssueWithUpdatedParent", () => $6662a1b5dd306f5c$export$2b799a607e235a03);

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");
const $6662a1b5dd306f5c$export$32c176d5dc779b09 = (rank)=>rank ? [
        {
            aliasFieldId: 'rank',
            text: rank,
            __typename: 'JiraSingleLineTextField'
        }
    ] : null;
const $6662a1b5dd306f5c$var$generateParentField = (issueId, key, id, rank, view)=>{
    const shouldHaveIdAttribute = (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && view === 'list';
    return {
        aliasFieldId: null,
        fieldId: (0, $lO4Or.PARENT_TYPE),
        type: (0, $lO4Or.PARENT_TYPE),
        name: 'Parent',
        parentIssue: issueId && key ? {
            __typename: 'JiraIssue',
            issueId: issueId,
            key: key,
            ...shouldHaveIdAttribute ? {
                id: id
            } : {},
            rankField: $6662a1b5dd306f5c$export$32c176d5dc779b09(rank)
        } : null,
        __typename: 'JiraParentIssueField'
    };
};
const $6662a1b5dd306f5c$export$2b799a607e235a03 = (issue, newParentIssue, view)=>{
    const { issueId: newParentIssueId, key: newParentKey, id: newParentId, rank: newParentRank } = newParentIssue || {};
    const parentFieldIndex = issue?.fields?.findIndex((field)=>field.type === (0, $lO4Or.PARENT_TYPE) || field.fieldId === (0, $lO4Or.PARENT_TYPE));
    const shouldHaveIdAttribute = (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && view === 'list';
    const parentField = parentFieldIndex !== -1 && parentFieldIndex !== undefined ? {
        ...issue?.fields?.[parentFieldIndex],
        parentIssue: !newParentIssueId || !newParentKey ? null : {
            ...shouldHaveIdAttribute ? {
                id: newParentId
            } : {},
            issueId: newParentIssueId,
            rankField: $6662a1b5dd306f5c$export$32c176d5dc779b09(newParentRank),
            key: newParentKey,
            __typename: 'JiraIssue'
        }
    } : $6662a1b5dd306f5c$var$generateParentField(newParentIssueId, newParentKey, newParentId, newParentRank, view);
    return {
        ...issue,
        fields: [
            ...issue?.fields?.filter((field)=>field.type !== (0, $lO4Or.PARENT_TYPE) && field.fieldId !== (0, $lO4Or.PARENT_TYPE)) || [],
            parentField
        ]
    };
};

});


parcelRegister("1cjzL", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $614a70d4040c7750$export$3ceb62baab058c6b);

var $dXOIB = parcelRequire("dXOIB");

var $1ybV0 = parcelRequire("1ybV0");
const $614a70d4040c7750$export$3ceb62baab058c6b = (existingIssue, data)=>{
    const optimisticUpdateFields = [];
    return Object.keys(data).reduce((acc, fieldId)=>{
        const accumulator = acc;
        const existingField = existingIssue.fields?.find((field)=>field.fieldId === fieldId);
        if (existingField) {
            if ((0, $dXOIB.isOptimisticUpdateSupported)(existingField.type)) {
                const fieldFormValue = data[existingField.fieldId];
                if (fieldFormValue === undefined) return accumulator;
                const transformedField = (0, $dXOIB.transformFieldForOptimisticUpdates)(existingField.type, existingField, fieldFormValue);
                if (transformedField !== undefined) accumulator.push(transformedField);
            } else if ((0, $1ybV0.ff)('thor-3996-optimistic-update-fixes-for-parent-field_6zcxj')) accumulator.push(existingField);
        }
        return accumulator;
    }, optimisticUpdateFields);
};

});
parcelRegister("dXOIB", function(module, exports) {

$parcel$export(module.exports, "transformFieldForOptimisticUpdates", () => $8b00d316a1e5e75e$export$efcd89b84c6a3e91);
$parcel$export(module.exports, "isOptimisticUpdateSupported", () => $8b00d316a1e5e75e$export$d96ec240de147154);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $gEWNG = parcelRequire("gEWNG");

var $2OcmD = parcelRequire("2OcmD");

var $gfc8V = parcelRequire("gfc8V");

var $6SSdp = parcelRequire("6SSdp");

var $dduzv = parcelRequire("dduzv");

var $KUkV1 = parcelRequire("KUkV1");

var $2eBI0 = parcelRequire("2eBI0");

var $5DlXh = parcelRequire("5DlXh");

var $cINNs = parcelRequire("cINNs");

var $lOzLM = parcelRequire("lOzLM");

var $cTnEj = parcelRequire("cTnEj");

var $1Oh2J = parcelRequire("1Oh2J");
const $8b00d316a1e5e75e$var$createSupportedBulkEditTransformations = (0, $5iWql.default)(()=>({
        ...(0, $2eBI0.priorityOptimisticUpdatesHandler),
        ...(0, $cTnEj.userOptimisticUpdatesHandler),
        ...(0, $gfc8V.labelsOptimisticUpdatesHandler),
        ...(0, $gEWNG.dateOptimisticUpdatesHandler),
        ...(0, $2OcmD.dateTimeOptimisticUpdatesHandler),
        ...(0, $6SSdp.multiSelectOptimisticUpdatesHandler),
        ...(0, $dduzv.numberOptimisticUpdatesHandler),
        ...(0, $1ybV0.ff)('thor-3996-optimistic-update-fixes-for-parent-field_6zcxj') && {
            ...(0, $KUkV1.parentOptimisticUpdatesHandler)
        },
        ...(0, $1Oh2J.versionOptimisticUpdatesHandler),
        ...(0, $5DlXh.singleSelectOptimisticUpdatesHandler),
        ...(0, $lOzLM.urlOptimisticUpdatesHandler),
        ...(0, $cINNs.textOptimisticUpdatesHandler)
    }));
const $8b00d316a1e5e75e$export$efcd89b84c6a3e91 = (fieldType, ...args)=>{
    const handlers = $8b00d316a1e5e75e$var$createSupportedBulkEditTransformations();
    if (!handlers[fieldType]) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType](...args);
};
const $8b00d316a1e5e75e$export$d96ec240de147154 = (fieldType)=>{
    const handlers = $8b00d316a1e5e75e$var$createSupportedBulkEditTransformations();
    return handlers[fieldType] !== null;
};

});
parcelRegister("gEWNG", function(module, exports) {

$parcel$export(module.exports, "dateOptimisticUpdatesHandler", () => $56c7d5c89815bc37$export$f6ab9c7ce755192);

var $lO4Or = parcelRequire("lO4Or");
const $56c7d5c89815bc37$export$fb826df18639e2fa = (existingField, fieldData)=>({
        ...existingField,
        date: fieldData ?? null
    });
const $56c7d5c89815bc37$export$f6ab9c7ce755192 = {
    [(0, $lO4Or.DATE_CF_TYPE)]: $56c7d5c89815bc37$export$fb826df18639e2fa,
    [(0, $lO4Or.DUE_DATE_TYPE)]: $56c7d5c89815bc37$export$fb826df18639e2fa,
    [(0, $lO4Or.START_DATE_TYPE)]: $56c7d5c89815bc37$export$fb826df18639e2fa
};

});

parcelRegister("2OcmD", function(module, exports) {

$parcel$export(module.exports, "dateTimeOptimisticUpdatesHandler", () => $fec393f1144feeae$export$a24474a096daecea);

var $lO4Or = parcelRequire("lO4Or");
const $fec393f1144feeae$export$3863479bf706ee55 = (existingField, fieldData)=>({
        ...existingField,
        dateTime: fieldData ?? null
    });
const $fec393f1144feeae$export$a24474a096daecea = {
    [(0, $lO4Or.DATETIME_CF_TYPE)]: $fec393f1144feeae$export$3863479bf706ee55
};

});

parcelRegister("gfc8V", function(module, exports) {

$parcel$export(module.exports, "labelsOptimisticUpdatesHandler", () => $866cd623680d6186$export$ae3a6c05d0376219);

var $lO4Or = parcelRequire("lO4Or");

var $bdPbp = parcelRequire("bdPbp");
const $866cd623680d6186$export$24889be11660a2f9 = (existingField, fieldData)=>{
    const action = fieldData.action;
    const existingLabels = existingField.selectedLabelsConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
    const labelNodes = (0, $bdPbp.transformOptionsUsingMultiAction)({
        existingOptions: existingLabels,
        options: fieldData.value.map((value)=>({
                __typename: 'JiraLabel',
                labelId: null,
                name: value.value
            })),
        action: action,
        isEqual: (option, existingOption)=>option.name === existingOption.name
    });
    return {
        ...existingField,
        selectedLabelsConnection: {
            __typename: 'JiraLabelConnection',
            edges: labelNodes?.map((node)=>({
                    __typename: 'JiraLabelEdge',
                    node: node
                })) ?? null
        }
    };
};
const $866cd623680d6186$export$ae3a6c05d0376219 = {
    [(0, $lO4Or.LABELS_TYPE)]: $866cd623680d6186$export$24889be11660a2f9
};

});
parcelRegister("bdPbp", function(module, exports) {

$parcel$export(module.exports, "transformOptionsUsingMultiAction", () => $e9be823968055534$export$de5a9a8aa203227b);
const $e9be823968055534$export$de5a9a8aa203227b = ({ existingOptions: existingOptions, options: options, action: action, isEqual: isEqual })=>{
    if (action === 'set') return options;
    if (action === 'add') return [
        ...existingOptions.filter((existingOption)=>options.some((option)=>!isEqual(option, existingOption))),
        ...options
    ];
    if (action === 'remove') return existingOptions.filter((existingOption)=>options.some((option)=>!isEqual(option, existingOption)));
    return null;
};

});


parcelRegister("6SSdp", function(module, exports) {

$parcel$export(module.exports, "multiSelectOptimisticUpdatesHandler", () => $0290c012aba98b26$export$451576b5e993a4c6);

var $lO4Or = parcelRequire("lO4Or");
const $0290c012aba98b26$export$6308785fb410c4b7 = (existingField, fieldData)=>({
        ...existingField,
        selectedOptions: {
            __typename: 'JiraOptionConnection',
            edges: fieldData.map((field)=>({
                    __typename: 'JiraOptionEdge',
                    node: {
                        __typename: 'JiraOption',
                        optionId: '',
                        value: field.value
                    }
                }))
        }
    });
const $0290c012aba98b26$export$451576b5e993a4c6 = {
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: $0290c012aba98b26$export$6308785fb410c4b7
};

});

parcelRegister("dduzv", function(module, exports) {

$parcel$export(module.exports, "numberOptimisticUpdatesHandler", () => $79bb4b501f624220$export$b507b41c3a04d8b2);

var $lO4Or = parcelRequire("lO4Or");
const $79bb4b501f624220$export$db1d3572e95020a7 = (existingField, fieldData)=>({
        ...existingField,
        number: fieldData
    });
const $79bb4b501f624220$export$b507b41c3a04d8b2 = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: $79bb4b501f624220$export$db1d3572e95020a7,
    [(0, $lO4Or.STORY_POINTS_TYPE)]: $79bb4b501f624220$export$db1d3572e95020a7,
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: $79bb4b501f624220$export$db1d3572e95020a7
};

});

parcelRegister("KUkV1", function(module, exports) {

$parcel$export(module.exports, "parentOptimisticUpdatesHandler", () => $e570ee2a2827b1e2$export$beaef88a0d44b30c);

var $lO4Or = parcelRequire("lO4Or");
const $e570ee2a2827b1e2$export$b807f08dd17c9fef = (existingField, fieldData)=>({
        ...existingField,
        parentIssue: {
            __typename: 'JiraIssue',
            id: fieldData.id?.toString() || '',
            issueId: fieldData.value.toString(),
            key: fieldData.key,
            rankField: [],
            fields: [
                {
                    fieldId: 'summary',
                    aliasFieldId: null,
                    name: 'Summary',
                    type: 'summary',
                    text: fieldData.fields.summary,
                    __typename: 'JiraSingleLineTextField'
                },
                {
                    fieldId: 'issuetype',
                    aliasFieldId: null,
                    name: 'Issue Type',
                    type: 'issuetype',
                    __typename: 'JiraIssueTypeField',
                    issueType: {
                        __typename: 'JiraIssueType',
                        name: fieldData?.fields?.issuetype?.name || '',
                        avatar: {
                            medium: fieldData?.fields?.issuetype?.iconUrl?.replace('xsmall', 'medium'),
                            __typename: 'JiraAvatar'
                        }
                    }
                }
            ]
        }
    });
const $e570ee2a2827b1e2$export$beaef88a0d44b30c = {
    [(0, $lO4Or.PARENT_TYPE)]: $e570ee2a2827b1e2$export$b807f08dd17c9fef
};

});

parcelRegister("2eBI0", function(module, exports) {

$parcel$export(module.exports, "priorityOptimisticUpdatesHandler", () => $eada8a0041e1baae$export$1722f398d0e70c01);

var $XGPnQ = parcelRequire("XGPnQ");

var $lO4Or = parcelRequire("lO4Or");
const $eada8a0041e1baae$export$5096de161ee14da = (existingField, fieldData)=>{
    const priorityId = fieldData.value && (0, $XGPnQ.JiraPriorityAri).check(fieldData.value) ? (0, $XGPnQ.JiraPriorityAri).parse(fieldData.value).resourceId : fieldData?.value ?? '';
    return {
        ...existingField,
        priority: {
            id: fieldData.value ?? '',
            name: fieldData.label,
            priorityId: priorityId,
            iconUrl: fieldData.iconUrl,
            __typename: 'JiraPriority'
        }
    };
};
const $eada8a0041e1baae$export$1722f398d0e70c01 = {
    [(0, $lO4Or.PRIORITY_TYPE)]: $eada8a0041e1baae$export$5096de161ee14da
};

});
parcelRegister("XGPnQ", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAri", () => $2eb998dfbb67cb97$export$5f41709ebd395cb1);

var $kVIiT = parcelRequire("kVIiT");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/priority/manifest.ts
var $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $kVIiT.JiraPriorityAriResourceOwner),
    resourceType: (0, $kVIiT.JiraPriorityAriResourceType),
    resourceIdSlug: "activation/{activationId}/{priorityId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        priorityId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/priority/index.ts
var $2eb998dfbb67cb97$export$5f41709ebd395cb1 = class _JiraPriorityAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._priorityId = opts.resourceIdSegmentValues.priorityId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get priorityId() {
        return this._priorityId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.qualifier,
            platformQualifier: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.resourceOwner,
            resourceType: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.priorityId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                priorityId: opts.priorityId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            priorityId: this.priorityId
        };
    }
};

});
parcelRegister("kVIiT", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAriResourceOwner", () => $87edd756771a8842$export$a154bdc743e3d7f4);
$parcel$export(module.exports, "JiraPriorityAriResourceType", () => $87edd756771a8842$export$f5f5f4d1fc71ee3e);
// src/jira/priority/types.ts
var $87edd756771a8842$export$a154bdc743e3d7f4 = "jira", $87edd756771a8842$export$f5f5f4d1fc71ee3e = "priority";

});



parcelRegister("5DlXh", function(module, exports) {

$parcel$export(module.exports, "singleSelectOptimisticUpdatesHandler", () => $9403be3430c48d89$export$3bfe96bec4aaa3d1);

var $lO4Or = parcelRequire("lO4Or");
const $9403be3430c48d89$export$1c2a2f3ef1a9bb3 = (existingField, fieldData)=>{
    if (fieldData === null) return {
        ...existingField,
        fieldOption: null
    };
    return {
        ...existingField,
        fieldOption: {
            __typename: 'JiraOption',
            optionId: fieldData.value,
            value: fieldData.label,
            color: null
        }
    };
};
const $9403be3430c48d89$export$3bfe96bec4aaa3d1 = {
    [(0, $lO4Or.SELECT_CF_TYPE)]: $9403be3430c48d89$export$1c2a2f3ef1a9bb3
};

});

parcelRegister("cINNs", function(module, exports) {

$parcel$export(module.exports, "textOptimisticUpdatesHandler", () => $99d0ef486f298ff5$export$6d32d6f2341892ca);

var $lO4Or = parcelRequire("lO4Or");
const $99d0ef486f298ff5$export$dff85ea10550e176 = (existingField, fieldData)=>({
        ...existingField,
        text: !fieldData ? ' ' : fieldData
    });
const $99d0ef486f298ff5$export$6d32d6f2341892ca = {
    [(0, $lO4Or.TEXT_CF_TYPE)]: $99d0ef486f298ff5$export$dff85ea10550e176
};

});

parcelRegister("lOzLM", function(module, exports) {

$parcel$export(module.exports, "urlOptimisticUpdatesHandler", () => $dada0ccdd3c33047$export$5275c3199d66bb55);

var $lO4Or = parcelRequire("lO4Or");
const $dada0ccdd3c33047$export$2fdc0fb9ea4e0c38 = (existingField, fieldData)=>({
        ...existingField,
        uri: !fieldData ? null : fieldData
    });
const $dada0ccdd3c33047$export$5275c3199d66bb55 = {
    [(0, $lO4Or.URL_CF_TYPE)]: $dada0ccdd3c33047$export$2fdc0fb9ea4e0c38
};

});

parcelRegister("cTnEj", function(module, exports) {

$parcel$export(module.exports, "userOptimisticUpdatesHandler", () => $af3752e2e37a93a1$export$2205d16240a6327f);

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $af3752e2e37a93a1$var$activeAccountStatus = 'active';
const $af3752e2e37a93a1$export$ae35491859a54223 = (existingField, fieldData)=>({
        ...existingField,
        user: fieldData != null ? {
            accountId: fieldData.accountId ?? '',
            accountStatus: $af3752e2e37a93a1$var$activeAccountStatus,
            picture: fieldData.avatarUrls[0, $jGcn0.DEFAULT_AVATAR_RES],
            name: fieldData.displayName,
            __typename: 'AtlassianAccountUser'
        } : null
    });
const $af3752e2e37a93a1$export$741c2fd1d5e759e7 = (existingField, fieldData)=>({
        ...existingField,
        user: fieldData != null ? {
            accountId: fieldData.id ?? '',
            accountStatus: $af3752e2e37a93a1$var$activeAccountStatus,
            picture: fieldData.avatarUrl,
            name: fieldData.name,
            __typename: 'AtlassianAccountUser'
        } : null
    });
const $af3752e2e37a93a1$export$2205d16240a6327f = {
    [(0, $lO4Or.REPORTER_TYPE)]: $af3752e2e37a93a1$export$741c2fd1d5e759e7,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $af3752e2e37a93a1$export$ae35491859a54223
};

});

parcelRegister("1Oh2J", function(module, exports) {

$parcel$export(module.exports, "versionOptimisticUpdatesHandler", () => $a43f30c32845e2f3$export$ded24c5df4d4a072);

var $lO4Or = parcelRequire("lO4Or");

var $bdPbp = parcelRequire("bdPbp");
const $a43f30c32845e2f3$export$23dfa4890df81d45 = (existingField, fieldData)=>({
        ...existingField,
        version: fieldData ? {
            __typename: 'JiraVersion',
            versionId: fieldData.value,
            name: fieldData.label
        } : null
    });
const $a43f30c32845e2f3$export$ab0e3c9aa41c8369 = (existingField, fieldData)=>{
    const action = fieldData.action;
    const existingVersions = existingField.selectedVersionsConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
    const versionNodes = (0, $bdPbp.transformOptionsUsingMultiAction)({
        existingOptions: existingVersions,
        options: fieldData.value.map((value)=>({
                __typename: 'JiraVersion',
                versionId: value.value,
                name: value.label
            })),
        action: action,
        isEqual: (option, existingOption)=>option.versionId === existingOption.versionId
    });
    return {
        ...existingField,
        selectedVersionsConnection: {
            __typename: 'JiraVersionConnection',
            edges: versionNodes?.map((node)=>({
                    __typename: 'JiraVersionEdge',
                    node: node
                })) ?? null
        }
    };
};
const $a43f30c32845e2f3$export$ded24c5df4d4a072 = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $a43f30c32845e2f3$export$23dfa4890df81d45,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $a43f30c32845e2f3$export$ab0e3c9aa41c8369,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $a43f30c32845e2f3$export$ab0e3c9aa41c8369,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $a43f30c32845e2f3$export$ab0e3c9aa41c8369
};

});




parcelRegister("1ji6g", function(module, exports) {

$parcel$export(module.exports, "useUpdateGroupIssue", () => $6b83525a7e08b896$export$43b9ca95cc220db0);

var $eUqFw = parcelRequire("eUqFw");

var $i3K0B = parcelRequire("i3K0B");

var $4oWxH = parcelRequire("4oWxH");

var $hTnQu = parcelRequire("hTnQu");

var $5r9Wo = parcelRequire("5r9Wo");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $fecbI = parcelRequire("fecbI");

var $huI7r = parcelRequire("huI7r");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $csTm8 = parcelRequire("csTm8");

var $7XECd = parcelRequire("7XECd");

var $9QCRO = parcelRequire("9QCRO");

var $fGcrx = parcelRequire("fGcrx");

var $g74gP = parcelRequire("g74gP");

var $k37U2 = parcelRequire("k37U2");


var $jcy5X = parcelRequire("jcy5X");
const $6b83525a7e08b896$export$43b9ca95cc220db0 = ()=>{
    const { getCachedIssueById: getCachedIssueById } = (0, $hTnQu.useCacheActions)();
    const { addToGroupCache: addToGroupCache } = (0, $fGcrx.useGroupCacheActions)();
    const [{ rankParentIssueId: rankParentIssueId }] = (0, $g74gP.useRankParent)();
    const input = (0, $k37U2.useIssuesInput)({
        groupIssueId: (0, $4oWxH.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
        parentIssueId: !(0, $4oWxH.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
    });
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [originalIssue, setOriginalIssue] = (0, $eUqFw.useState)();
    const [{ issuesMap: issuesMap }] = (0, $5r9Wo.useHierarchyStore)();
    const [updateError, setUpdateError] = (0, $eUqFw.useState)(null);
    const cloudId = (0, $dWLk9.useCloudId)();
    (0, $eUqFw.useEffect)(()=>{
        if (updateError) {
            setUpdateError(null);
            // revert optimistic update
            if (originalIssue) {
                addToGroupCache([
                    originalIssue
                ]);
                setOriginalIssue(null);
            }
            showFlag({
                type: 'error',
                title: [
                    (0, $jcy5X.default).errorTitle,
                    {
                        field: updateError.field
                    }
                ],
                description: [
                    (0, $jcy5X.default).errorMessage,
                    {
                        field: updateError.field
                    }
                ]
            });
            (0, $guiFP.default)({
                meta: {
                    id: updateError.query,
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                error: updateError.error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        originalIssue,
        updateError,
        addToGroupCache,
        showFlag
    ]);
    const optimisticUpdate = (0, $eUqFw.useCallback)((issue, fieldType, field)=>{
        const cachedIssue = getCachedIssueById({
            issueId: issue.issueId,
            query: (0, $7XECd.LIST_VIEW_QUERY),
            variables: {
                ...(0, $i3K0B.getVariables)(input),
                cloudId: cloudId
            }
        });
        setOriginalIssue(cachedIssue);
        if (cachedIssue) {
            const updatedIssue = {
                ...cachedIssue,
                fields: [
                    ...cachedIssue.fields?.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (cachedField)=>cachedField.fieldId !== fieldType) ?? [],
                    field
                ]
            };
            addToGroupCache([
                updatedIssue
            ]);
        }
    }, [
        getCachedIssueById,
        input,
        cloudId,
        addToGroupCache
    ]);
    const bulkOptimisticUpdate = (0, $eUqFw.useCallback)((issueIds, fields)=>{
        const cachedIssues = issueIds.map((issueId)=>getCachedIssueById({
                issueId: issueId.toString(),
                query: (0, $7XECd.LIST_VIEW_QUERY),
                variables: {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ...issuesMap.get(issueId.toString())?.cacheVariables,
                    cloudId: cloudId
                }
            })).filter(Boolean);
        const fieldIds = fields.map((field)=>field.fieldId);
        if (cachedIssues.length) {
            const updatedIssues = cachedIssues.map((cachedIssue)=>({
                    ...cachedIssue,
                    fields: [
                        ...cachedIssue.fields?.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (cachedField)=>!fieldIds.includes(cachedField.fieldId)) ?? [],
                        ...fields
                    ]
                }));
            addToGroupCache(updatedIssues);
        }
    }, [
        getCachedIssueById,
        issuesMap,
        cloudId,
        addToGroupCache
    ]);
    const updateField = (0, $eUqFw.useCallback)((issue, fieldType, fieldValue, analyticsAlias)=>{
        (0, $fecbI.defaultSaveField)((0, $6vrw7.toIssueKey)(issue.key), fieldType, fieldValue, '').then(()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $4243c9d89786171f$export$406cbd2164fd0d71)} succeeded`, {
                field: (0, $csTm8.getFieldForAnalytics)(fieldType, analyticsAlias)
            });
        }).catch((error)=>{
            setUpdateError({
                error: error,
                field: (0, $csTm8.getFieldForAnalytics)(fieldType, analyticsAlias),
                query: (0, $4243c9d89786171f$export$406cbd2164fd0d71)
            });
        });
    }, [
        setUpdateError,
        createAnalyticsEvent
    ]);
    const updateAssignee = (0, $eUqFw.useCallback)((issue, fieldValue)=>{
        const newField = {
            aliasFieldId: null,
            fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
            name: 'assignee',
            type: 'assignee',
            fieldConfig: {
                isEditable: true,
                __typename: 'JiraFieldConfig'
            },
            __typename: 'JiraSingleSelectUserPickerField',
            user: fieldValue != null ? {
                accountId: fieldValue.accountId,
                accountStatus: (0, $9QCRO.AccountStatus).active,
                picture: fieldValue.avatarUrl,
                name: fieldValue.displayName,
                __typename: 'AtlassianAccountUser'
            } : null
        };
        optimisticUpdate(issue, (0, $lO4Or.ASSIGNEE_TYPE), newField);
        if (fieldValue === null || fieldValue === undefined) // unassigned user
        updateField(issue, (0, $lO4Or.ASSIGNEE_TYPE), null);
        else (0, $lRmyA.performGetRequest)(`/rest/api/2/user/assignable/search?issueKey=${issue.key}&accountId=${fieldValue.accountId}`).then((response)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $4243c9d89786171f$export$3e3161555559eda3)} succeeded`);
            if (Array.isArray(response) && response[0]) updateField(issue, (0, $lO4Or.ASSIGNEE_TYPE), response[0]);
            else setUpdateError({
                error: new Error('User does not exist or is not allowed to be assigned to the issue'),
                field: (0, $lO4Or.ASSIGNEE_TYPE),
                query: (0, $4243c9d89786171f$export$3e3161555559eda3)
            });
        }).catch((error)=>{
            setUpdateError({
                error: error,
                field: (0, $lO4Or.ASSIGNEE_TYPE),
                query: (0, $4243c9d89786171f$export$3e3161555559eda3)
            });
        });
    }, [
        optimisticUpdate,
        updateField,
        setUpdateError,
        createAnalyticsEvent
    ]);
    const updatePriority = (0, $eUqFw.useCallback)((issue, fieldValue)=>{
        if (fieldValue) {
            const priorityId = fieldValue.id && (0, $huI7r.isAri)(fieldValue.id) ? (0, $huI7r.getAriConfig)(fieldValue.id).resourceId : fieldValue?.id ?? null;
            const newField = {
                aliasFieldId: null,
                fieldId: (0, $lO4Or.PRIORITY_TYPE),
                type: (0, $lO4Or.PRIORITY_TYPE),
                name: 'Priority',
                priority: {
                    id: fieldValue.id ?? '',
                    name: fieldValue.name,
                    priorityId: priorityId ?? '',
                    iconUrl: fieldValue.iconUrl,
                    __typename: 'JiraPriority'
                },
                __typename: 'JiraPriorityField'
            };
            optimisticUpdate(issue, (0, $lO4Or.PRIORITY_TYPE), newField);
            updateField(issue, (0, $lO4Or.PRIORITY_TYPE), {
                ...fieldValue,
                id: priorityId
            });
        }
    }, [
        optimisticUpdate,
        updateField
    ]);
    const updateCategory = (0, $eUqFw.useCallback)((issue, fieldKey, fieldValue)=>{
        const category = fieldValue ? {
            value: fieldValue.name,
            label: fieldValue.name
        } : null;
        const newField = {
            aliasFieldId: null,
            fieldId: fieldKey,
            fieldConfig: {
                isEditable: true,
                __typename: 'JiraFieldConfig'
            },
            __typename: 'JiraSingleSelectField',
            name: 'Category',
            type: (0, $lO4Or.CATEGORY_TYPE),
            fieldOption: fieldValue ? {
                optionId: fieldValue.optionId,
                value: fieldValue.name,
                color: fieldValue.color ? {
                    colorKey: fieldValue.color,
                    __typename: 'JiraColor'
                } : null,
                __typename: 'JiraOption'
            } : null
        };
        optimisticUpdate(issue, fieldKey, newField);
        updateField(issue, fieldKey, category, 'category');
    }, [
        optimisticUpdate,
        updateField
    ]);
    const updateJiraNumber = (0, $eUqFw.useCallback)((issue, field, number)=>{
        if (typeof number !== 'undefined') {
            const newField = {
                fieldId: field.id,
                aliasFieldId: field.aliasFieldId || null,
                name: field.name,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                type: field.type,
                number: number,
                fieldConfig: {
                    isEditable: true,
                    __typename: 'JiraFieldConfig'
                },
                __typename: 'JiraNumberField'
            };
            optimisticUpdate(issue, field.id, newField);
            updateField(issue, field.id, number, newField.aliasFieldId || newField.type);
        }
    }, [
        optimisticUpdate,
        updateField
    ]);
    const updateSprint = (0, $eUqFw.useCallback)((issue, field, sprint)=>{
        if (typeof sprint !== 'undefined') {
            const newField = {
                fieldId: field.id,
                name: field.name,
                aliasFieldId: 'sprint',
                type: (0, $lO4Or.SPRINT_TYPE),
                fieldConfig: {
                    isEditable: true,
                    __typename: 'JiraFieldConfig'
                },
                selectedSprintsConnection: {
                    edges: sprint === null ? [] : [
                        {
                            node: {
                                sprintId: String(sprint.id),
                                name: sprint.name,
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                state: sprint.state,
                                __typename: 'JiraSprint'
                            },
                            __typename: 'JiraSprintEdge'
                        }
                    ],
                    __typename: 'JiraSprintConnection'
                },
                __typename: 'JiraSprintField'
            };
            optimisticUpdate(issue, field.id, newField);
            updateField(issue, field.id, sprint === null ? null : Number(sprint.id), 'sprint');
        }
    }, [
        optimisticUpdate,
        updateField
    ]);
    return {
        updateAssignee: updateAssignee,
        updatePriority: updatePriority,
        updateCategory: updateCategory,
        updateJiraNumber: updateJiraNumber,
        updateSprint: updateSprint,
        bulkOptimisticUpdate: bulkOptimisticUpdate
    };
};

});
parcelRegister("csTm8", function(module, exports) {

$parcel$export(module.exports, "getFieldForAnalytics", () => $53d1fcbf7bde8af4$export$af1963dc1f827ac2);

var $lO4Or = parcelRequire("lO4Or");
const $53d1fcbf7bde8af4$export$af1963dc1f827ac2 = (fieldType, analyticsAlias)=>{
    if (analyticsAlias) {
        // keep backwards compatibility
        if (analyticsAlias === (0, $lO4Or.CATEGORY_TYPE)) return 'category';
        return analyticsAlias;
    }
    return fieldType;
};

});

parcelRegister("9QCRO", function(module, exports) {

$parcel$export(module.exports, "AccountStatus", () => $a8333aabe82fb202$export$3693f74db10d5f88);
var $a8333aabe82fb202$export$3693f74db10d5f88;
(function(AccountStatus) {
    AccountStatus["active"] = "active";
    AccountStatus["closed"] = "closed";
    AccountStatus["inactive"] = "inactive";
})($a8333aabe82fb202$export$3693f74db10d5f88 || ($a8333aabe82fb202$export$3693f74db10d5f88 = {}));

});

const $4243c9d89786171f$export$3e3161555559eda3 = 'updateGroupIssueAssigneeSearch';
const $4243c9d89786171f$export$406cbd2164fd0d71 = 'updateGroupIssueUpdateField';

parcelRegister("jcy5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d8b34908106b6b2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8d8b34908106b6b2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.update-group-issue.error-title",
        "defaultMessage": "Failed to update {field}"
    },
    errorMessage: {
        "id": "business-list.controllers.update-group-issue.error-message",
        "defaultMessage": "Something went wrong updating the issue's {field} field. Please try again or contact your administrator if the problem persists."
    }
});

});



parcelRegister("7x2p7", function(module, exports) {

$parcel$export(module.exports, "BulkEditSidebar", () => $fad5dc21f02178b6$export$43008afc76943d65);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hSCS8 = parcelRequire("hSCS8");

var $hotly = parcelRequire("hotly");
const $fad5dc21f02178b6$var$useOnUnmount = (fn)=>{
    const currentFn = (0, $eUqFw.useRef)(fn);
    currentFn.current = fn;
    (0, $eUqFw.useEffect)(()=>()=>currentFn.current(), []);
};
const $fad5dc21f02178b6$export$43008afc76943d65 = ({ bulkOperationsForm: bulkOperationsForm })=>{
    const [{ content: content }, { resetSidebarQueryParams: resetSidebarQueryParams, setSidebarContent: _setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const [{ showBulkEditSidebar: showBulkEditSidebar }] = (0, $hotly.useBulkSelectionStore)();
    const lastSetSidebarContent = (0, $eUqFw.useRef)(null);
    const setSidebarContent = (0, $eUqFw.useCallback)((newContent)=>{
        _setSidebarContent(newContent);
        lastSetSidebarContent.current = newContent;
    }, [
        _setSidebarContent
    ]);
    const resetSidebarContent = (0, $eUqFw.useCallback)(()=>{
        if (lastSetSidebarContent.current) setSidebarContent(null);
    }, [
        setSidebarContent
    ]);
    $fad5dc21f02178b6$var$useOnUnmount(resetSidebarContent);
    const sidebarContent = (0, $eUqFw.useMemo)(()=>showBulkEditSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            "data-testId": "business-list.ui.list-view.bulk-edit-sidebar.wrapper",
            xcss: $fad5dc21f02178b6$var$wrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            "data-testId": "business-list.ui.list-view.bulk-edit-sidebar.bulkops-sidebar",
            ref: bulkOperationsForm.setRef,
            xcss: $fad5dc21f02178b6$var$containerStyles
        })) : null, [
        bulkOperationsForm.setRef,
        showBulkEditSidebar
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!sidebarContent) return;
        if (!lastSetSidebarContent.current) resetSidebarQueryParams();
        if (content !== sidebarContent) setSidebarContent(sidebarContent);
    }, [
        content,
        resetSidebarQueryParams,
        setSidebarContent,
        sidebarContent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (sidebarContent) return;
        if (content && content === lastSetSidebarContent.current) resetSidebarContent();
    }, [
        content,
        resetSidebarContent,
        sidebarContent
    ]);
    return null;
};
const $fad5dc21f02178b6$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    inset: 'space.0',
    justifyContent: 'stretch'
});
const $fad5dc21f02178b6$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    flexGrow: 1,
    // Adjust for the unwanted vertical padding from 'SidebarLayout'
    marginBottom: 'space.negative.100',
    marginTop: 'space.negative.100'
});

});


parcelRegister("fuaUK", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $0302372f09956a0e$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $jGcn0 = parcelRequire("jGcn0");

var $lGxgz = parcelRequire("lGxgz");

var $96etS = parcelRequire("96etS");

var $kiBzn = parcelRequire("kiBzn");

var $lGiWG = parcelRequire("lGiWG");

var $kar7l = parcelRequire("kar7l");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $egJIx = parcelRequire("egJIx");

var $kny42 = parcelRequire("kny42");

var $j1jCa = parcelRequire("j1jCa");
const $0302372f09956a0e$export$ea3803e2a45d21c4 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, setInlineCreateParam] = (0, $lB25E.useQueryParam)((0, $jGcn0.INLINE_CREATE_PARAM));
    const handleClick = (0, $eUqFw.useCallback)(()=>setInlineCreateParam('true'), [
        setInlineCreateParam
    ]);
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $egJIx.useJWMListFeatures)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0302372f09956a0e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kny42.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0302372f09956a0e$var$HeadingWrapper, null, formatMessage((0, $j1jCa.default).emptyStateHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0302372f09956a0e$var$contentWrapperStyles
    }, formatMessage((0, $j1jCa.default).emptyStateDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        appearance: "primary",
        onClick: handleClick
    }, formatMessage(isSoftwareFieldsEnabled ? (0, $j1jCa.default).createIssueButton : (0, $j1jCa.default).createItemButton)));
};
const $0302372f09956a0e$export$fddf379e22a74b00 = ()=>{
    const { isFiltering: isFiltering, jqlErrors: jqlErrors } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    const emptyStateMessage = isSearching || isFiltering ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kiBzn.ThemedFilterEmptyState), {
        reason: jqlErrors.length ? 'INVALID_JQL' : 'NO_RESULTS'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0302372f09956a0e$export$ea3803e2a45d21c4, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $0302372f09956a0e$var$wrapperStyles
    }, emptyStateMessage);
};
const $0302372f09956a0e$var$Wrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0302372f09956a0e$var$emptyWrapperStyles
    }, children);
const $0302372f09956a0e$var$emptyWrapperStyles = (0, $1ZAYh.xcss)({
    textAlign: 'center',
    margin: 'auto',
    width: '400px',
    padding: 'space.300',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $kar7l.Tokens).ELEVATION_SURFACE_CONTRAST_BOLDER,
    borderRadius: 'border.radius.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0302372f09956a0e$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q _19pku2gc",
            __cmplp.className
        ])
    });
});
const $0302372f09956a0e$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.300'
});
const $0302372f09956a0e$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.1000',
    paddingTop: 'space.800',
    width: '100%'
});

});
parcelRegister("kiBzn", function(module, exports) {

$parcel$export(module.exports, "ThemedFilterEmptyState", () => $a505eae840e121fb$export$e911425bb76dd69e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $lGiWG = parcelRequire("lGiWG");

var $kar7l = parcelRequire("kar7l");
parcelRequire("hgbp4");
var $1lasE = parcelRequire("1lasE");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $dG4cR = parcelRequire("dG4cR");

var $9rrf5 = parcelRequire("9rrf5");
const $a505eae840e121fb$export$e911425bb76dd69e = ({ reason: reason })=>{
    // @ts-expect-error - TS2339 - Property 'updateQueryParam' does not exist on type 'BoundActions<EntireRouterState, PublicRouterActions>'.
    const { updateQueryParam: updateQueryParam } = (0, $lB25E.useRouterActions)();
    const [, setFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        // persist that the user has cleared filters in view preferences
        // but do not push the change to the URL as we're already pushing a history state
        // to clear both filters and simple search below
        setFilters(undefined, 'none');
        updateQueryParam({
            filter: undefined,
            quickFilters: undefined,
            [(0, $dG4cR.SIMPLE_SEARCH_PARAM)]: undefined
        }, 'push');
    }, [
        updateQueryParam,
        setFilters
    ]);
    const message = reason === 'INVALID_JQL' ? formatMessage((0, $9rrf5.default).invalidStateHeading) : formatMessage((0, $9rrf5.default).emptyStateHeading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a505eae840e121fb$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a505eae840e121fb$var$Illustration, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1lasE))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a505eae840e121fb$var$HeadingWrapper, null, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        appearance: "primary",
        onClick: handleOnClear
    }, formatMessage((0, $9rrf5.default).clearFiltersButton)));
};
const $a505eae840e121fb$var$wrapperStyles = (0, $1ZAYh.xcss)({
    textAlign: 'center',
    margin: 'auto',
    width: '450px',
    padding: 'space.300',
    borderRadius: 'border.radius.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $kar7l.Tokens).ELEVATION_SURFACE_CONTRAST_BOLDER
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a505eae840e121fb$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $a505eae840e121fb$var$Illustration = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1yk2 _4t3i13i4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lGiWG", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $3bf493f9be098b31$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");
const $3bf493f9be098b31$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, ...props }, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3bf493f9be098b31$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf493f9be098b31$var$CustomButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7opLA.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1qt31mi8 _1g9hu0za _1umftrgn _6l8rsb7u _9se51pfj _12ra13cp _zk5ur2ew _18vg1w6j _192e1czd _fnp71tko _1xjgkwex _1u0u1y8w _17z21063 _7n831c2q _n2ulgr9p _1cf15clp _1d7c63lg _nwukkwex _fsjdky8x _z1i3tvsq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hgbp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d2ebe01d4784a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1lasE")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $9TZf5 = parcelRequire("9TZf5");

var $gMIRj = parcelRequire("gMIRj");

var $1lasE = parcelRequire("1lasE");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $d2d2ebe01d4784a8$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1lasE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gMIRj))
});
var $d2d2ebe01d4784a8$export$2e2bcd8739ae039 = $d2d2ebe01d4784a8$var$Illustration;
// for advanced use only
const $d2d2ebe01d4784a8$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("gMIRj", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("1lasE", function(module, exports) {
module.exports = new URL("search-no-results.10b14394.svg", import.meta.url).toString();

});


parcelRegister("9rrf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8fd0b56fda09200$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d8fd0b56fda09200$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStateHeading: {
        "id": "business-filters.themed-filter-empty-state.empty-state-heading",
        "defaultMessage": "It looks like we can't find any results that match."
    },
    invalidStateHeading: {
        "id": "business-filters.themed-filter-empty-state.invalid-state-heading",
        "defaultMessage": "We can't handle the current filters, please clear to continue."
    },
    clearFiltersButton: {
        "id": "business-filters.themed-filter-empty-state.clear-filters-button",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("kny42", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e7b4247c210c8f4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $7e7b4247c210c8f4$var$Illustration = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("f3Wah")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/empty-state/illustration/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7e7b4247c210c8f4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-list-empty-state",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e7b4247c210c8f4$var$Illustration, null));

});
parcelRegister("f3Wah", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dlpQn").then(()=>parcelRequire('3Grbf'));

});


parcelRegister("j1jCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $88e2299a4687208f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $88e2299a4687208f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStateHeading: {
        "id": "business-list.list-view.empty-state.empty-state-heading",
        "defaultMessage": "View your work in a list"
    },
    emptyStateDescription: {
        "id": "business-list.list-view.empty-state.empty-state-description",
        "defaultMessage": "Manage and sort all your project\u2019s work into a single list that can be easily scanned and sorted by category."
    },
    createItemButton: {
        "id": "business-list.list-view.empty-state.create-item-button",
        "defaultMessage": "Create an item"
    },
    createIssueButton: {
        "id": "business-list.list-view.empty-state.create-issue-button",
        "defaultMessage": "Create issue"
    }
});

});


parcelRegister("aiXUL", function(module, exports) {

$parcel$export(module.exports, "GroupItem", () => $f1c34fcc4c23ae95$export$3142cb2f1b79aeb9);

var $eUqFw = parcelRequire("eUqFw");

var $aYMv7 = parcelRequire("aYMv7");

var $gZpkQ = parcelRequire("gZpkQ");

var $ef5z4 = parcelRequire("ef5z4");

var $5r9Wo = parcelRequire("5r9Wo");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $huI7r = parcelRequire("huI7r");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $2jrDX = parcelRequire("2jrDX");

var $9w3zf = parcelRequire("9w3zf");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");

var $8gkkx = parcelRequire("8gkkx");

var $l7wqg = parcelRequire("l7wqg");

var $dTdQF = parcelRequire("dTdQF");

var $kavY4 = parcelRequire("kavY4");

var $1CxqB = parcelRequire("1CxqB");

var $6dZjh = parcelRequire("6dZjh");

var $6SYWA = parcelRequire("6SYWA");

var $fOYLV = parcelRequire("fOYLV");

var $ex5gB = parcelRequire("ex5gB");

var $5m7NF = parcelRequire("5m7NF");

var $60YYZ = parcelRequire("60YYZ");
const $f1c34fcc4c23ae95$var$GroupItemRenderer = ({ field: field, data: data })=>{
    switch(field.__typename){
        case 'JiraSingleSelectUserPickerField':
            if (field.type === (0, $lO4Or.ASSIGNEE_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l7wqg.AssigneeItem), {
                data: data
            });
            return null;
        case 'GenericIssueField':
            if (field.type === (0, $lO4Or.STATUS_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ex5gB.StatusItem), {
                data: data
            });
            return null;
        case 'JiraPriorityField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dZjh.PriorityItem), {
                data: data
            });
        case 'JWMCategoryField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTdQF.CategoryItem), {
                data: data
            });
        case 'JiraNumberField':
            if (field.aliasFieldId === 'storypoints') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5m7NF.StoryPointsItem), {
                value: data.storypoints
            });
            if (field.aliasFieldId === 'storypointestimate') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5m7NF.StoryPointsItem), {
                value: data.storypointestimate
            });
            return null;
        case 'JiraSprintField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fOYLV.SprintItem), {
                data: data
            });
        default:
            return null;
    }
};
const $f1c34fcc4c23ae95$export$3142cb2f1b79aeb9 = /*#__PURE__*/ (0, $eUqFw.memo)(({ data: data, rowIndex: rowIndex, canCreateIssues: canCreateIssues })=>{
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const [, setHideDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    const issueId = (0, $6vrw7.toIssueId)(data.issueId);
    const totalGroupItems = data.childSummary?.totalCount ?? 0;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ expandedItems: expandedGroups, hierarchyData: { loading: loading } }, { setExpandedItems: setGroupExpanded }] = (0, $5r9Wo.useHierarchyStore)();
    const [{ shouldExpandAllItems: shouldExpandAllItems }, { disableExpandCollapseAllItems: disableExpandCollapseAllItems }] = (0, $aYMv7.useExpandCollapseAllItems)({
        view: 'list'
    });
    const [, { setRowCreatePosition: setRowCreatePosition }] = (0, $8gkkx.useRowCreateStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { getAvailableFields: getAvailableFields } = (0, $hHiDc.useIssueFields)();
    const availableFields = getAvailableFields();
    const categoryFieldId = availableFields.find((fieldItem)=>fieldItem.type === (0, $lO4Or.CATEGORY_TYPE))?.id;
    const field = (0, $9w3zf.useGetGroupByField)();
    const onExpand = (0, $eUqFw.useCallback)(()=>{
        const isExpanded = Boolean(expandedGroups[issueId]);
        const isStatusGroup = groupByFieldId === (0, $lO4Or.STATUS_TYPE);
        const isDoneStatus = // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'string' and 'number' have no overlap.
        data.status?.categoryId === (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE];
        // show done items when expanding the done status group
        if (isStatusGroup && isDoneStatus && !isExpanded) setHideDoneItems(false);
        if (isExpanded && shouldExpandAllItems) disableExpandCollapseAllItems();
        setGroupExpanded(issueId, !isExpanded);
    }, [
        data,
        disableExpandCollapseAllItems,
        expandedGroups,
        groupByFieldId,
        issueId,
        setGroupExpanded,
        setHideDoneItems,
        shouldExpandAllItems
    ]);
    const handleAddInlineCreateRow = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
        setRowCreatePosition({
            parentId: String(issueId)
        });
        if (setGroupExpanded) setGroupExpanded(issueId, true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'listRowCreateGroupItemIcon', {
            groupByFieldId: groupByFieldId
        });
    }, [
        setRowCreatePosition,
        issueId,
        setGroupExpanded,
        createAnalyticsEvent,
        groupByFieldId
    ]);
    const checkIfHasIssueCreation = (0, $ef5z4.useCanCreateIssueInStatus)();
    const canInlineCreate = (0, $eUqFw.useMemo)(()=>{
        if (!canCreateIssues) return false;
        if (groupByFieldId !== (0, $lO4Or.STATUS_TYPE)) return true;
        const statusId = data.status?.id && (0, $huI7r.getAriConfig)(data.status.id).resourceId;
        if (!statusId) return false;
        return checkIfHasIssueCreation(statusId);
    }, [
        canCreateIssues,
        checkIfHasIssueCreation,
        data.status,
        groupByFieldId
    ]);
    const CreateIssueComponent = (0, $eUqFw.useMemo)(()=>canInlineCreate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.CreateIssuePlusButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2jrDX.default), {
            tooltip: formatMessage((0, $1CxqB.default).createIssue),
            label: formatMessage((0, $1CxqB.default).addGroupItem),
            onClick: handleAddInlineCreateRow,
            shouldDisplayBtn: true
        })), [
        canInlineCreate,
        formatMessage,
        handleAddInlineCreateRow
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.LoadingRow), {
        key: "loading-grouping-header-row",
        "data-testid": "business-list.ui.list-view.group-item.loading-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.LoadingWrapper), {
        key: data.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.LoadingIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.LoadingField), null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6SYWA.SelectGroupCheckbox), {
        group: data,
        rowIndex: rowIndex
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.GroupContainer), null, totalGroupItems > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kavY4.ExpandIcon), {
        onClick: onExpand,
        totalGroupItems: totalGroupItems,
        rowIndex: rowIndex,
        expanded: expandedGroups[issueId] === true
    }), field ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1c34fcc4c23ae95$var$GroupItemRenderer, {
        field: field,
        data: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, groupByFieldId === (0, $lO4Or.ASSIGNEE_TYPE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l7wqg.AssigneeItem), {
        data: data
    }), groupByFieldId === (0, $lO4Or.STATUS_TYPE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ex5gB.StatusItem), {
        data: data
    }), groupByFieldId === (0, $lO4Or.PRIORITY_TYPE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dZjh.PriorityItem), {
        data: data
    }), groupByFieldId === categoryFieldId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTdQF.CategoryItem), {
        data: data
    })), CreateIssueComponent));
});

});
parcelRegister("aYMv7", function(module, exports) {

$parcel$export(module.exports, "useExpandCollapseAllItems", () => $72c1511394f3523b$export$38cfcb71ce0d3b89);

var $eUqFw = parcelRequire("eUqFw");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $72c1511394f3523b$var$actions = {
    toggleExpanding: (view)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    shouldExpandAllItems: !state[view].shouldExpandAllItems,
                    shouldCollapseAllItems: false
                }
            });
        },
    setCollapsing: (view)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    shouldExpandAllItems: false,
                    shouldCollapseAllItems: true
                }
            });
        },
    disableExpandCollapse: (view)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    shouldExpandAllItems: false,
                    shouldCollapseAllItems: false
                }
            });
        },
    setHasExpandedAllItems: (view, hasExpanded)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    hasExpandedAllItems: hasExpanded
                }
            });
        },
    setHasCollapsedAllItems: (view, hasCollapsed)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    hasCollapsedAllItems: hasCollapsed
                }
            });
        }
};
const $72c1511394f3523b$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        list: {
            shouldExpandAllItems: false,
            shouldCollapseAllItems: false,
            hasExpandedAllItems: false,
            hasCollapsedAllItems: false
        },
        timeline: {
            shouldExpandAllItems: false,
            shouldCollapseAllItems: false,
            hasExpandedAllItems: false,
            hasCollapsedAllItems: false
        }
    },
    actions: $72c1511394f3523b$var$actions,
    name: 'JWMExpandCollapseStore'
});
const $72c1511394f3523b$var$useHook = (0, $1yZQx.createHook)($72c1511394f3523b$var$Store);
const $72c1511394f3523b$export$38cfcb71ce0d3b89 = ({ view: view, onCollapse: onCollapse })=>{
    const [state, { toggleExpanding: toggleExpanding, setCollapsing: setCollapsing, disableExpandCollapse: disableExpandCollapse, setHasExpandedAllItems: setHasExpandedAllItems, setHasCollapsedAllItems: setHasCollapsedAllItems }] = $72c1511394f3523b$var$useHook();
    const { shouldExpandAllItems: shouldExpandAllItems, shouldCollapseAllItems: shouldCollapseAllItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems } = state[view];
    const toggleExpandingForView = (0, $eUqFw.useCallback)(()=>toggleExpanding(view), [
        toggleExpanding,
        view
    ]);
    const setCollapsingForView = (0, $eUqFw.useCallback)(()=>setCollapsing(view), [
        setCollapsing,
        view
    ]);
    const setHasCollapsedAllItemsForView = (0, $eUqFw.useCallback)((hasCollapsed)=>setHasCollapsedAllItems(view, hasCollapsed), [
        setHasCollapsedAllItems,
        view
    ]);
    const setHasExpandedAllItemsForView = (0, $eUqFw.useCallback)((hasExpanded)=>setHasExpandedAllItems(view, hasExpanded), [
        setHasExpandedAllItems,
        view
    ]);
    const disableExpandCollapseForView = (0, $eUqFw.useCallback)(()=>disableExpandCollapse(view), [
        disableExpandCollapse,
        view
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (onCollapse && shouldCollapseAllItems) {
            onCollapse();
            disableExpandCollapseForView();
        }
    }, [
        disableExpandCollapseForView,
        onCollapse,
        shouldCollapseAllItems
    ]);
    return [
        {
            shouldExpandAllItems: shouldExpandAllItems,
            shouldCollapseAllItems: shouldCollapseAllItems,
            hasExpandedAllItems: hasExpandedAllItems,
            hasCollapsedAllItems: hasCollapsedAllItems
        },
        {
            toggleExpandAllItems: toggleExpandingForView,
            collapseAllItems: setCollapsingForView,
            disableExpandCollapseAllItems: disableExpandCollapseForView,
            setHasExpandedAllItems: setHasExpandedAllItemsForView,
            setHasCollapsedAllItems: setHasCollapsedAllItemsForView
        }
    ];
};

});

parcelRegister("ef5z4", function(module, exports) {

$parcel$export(module.exports, "useCanCreateIssueInStatus", () => $24564dd80699b178$export$efe8838d1712139f);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $c7wtc = parcelRequire("c7wtc");
const $24564dd80699b178$export$efe8838d1712139f = ()=>{
    const workflows = (0, $c7wtc.useWorkflows)();
    const project = (0, $kQAZu.useProject)();
    return (0, $eUqFw.useCallback)((statusId, workflow = null)=>{
        if (!workflows) return false;
        const eligibleWorkflows = workflow != null ? [
            workflow
        ] : workflows.filter((w)=>w.issueTypes.some((it)=>it.hierarchyLevel >= 0));
        // we want to show the create button on the group if it can:
        // - be created from the initial transition,
        // - OR if it has a global transition leading to it
        //      AND the transition isn't conditional
        //      AND the user is allowed to transition issues
        return eligibleWorkflows.some((w)=>w.transitions.some((transition)=>transition.to.statusId === statusId && (transition.isInitial || transition.isGlobal && !transition.isConditional && project.permissions.transitionIssues)));
    }, [
        project,
        workflows
    ]);
};

});

parcelRegister("2jrDX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5945efd4865c984a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j9fWg = parcelRequire("j9fWg");

var $gLR87 = parcelRequire("gLR87");

var $gO9Xw = parcelRequire("gO9Xw");

var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");

var $8rQuz = parcelRequire("8rQuz");

var $gbsaq = parcelRequire("gbsaq");
var $5945efd4865c984a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: props.tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5945efd4865c984a$var$ChildCreateButtonWrapper, {
        id: (0, $gbsaq.CHILD_CREATE_BTN_WRAPPER),
        shouldDisplayBtn: props.shouldDisplayBtn,
        "data-testid": "business-list.common.ui.create-issue-plus-button.child-create-button-wrapper"
    }, (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        onClick: props.onClick,
        spacing: "compact",
        appearance: "subtle",
        label: props.label,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gLR87)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5945efd4865c984a$var$ChildCreateButton, {
        onClick: props.onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
        label: props.label,
        size: "small"
    })))));
const $5945efd4865c984a$var$BUTTON_SIZE = 2 * (0, $c9TLT.gridSize);
const $5945efd4865c984a$var$ICON_SIZE = 12;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5945efd4865c984a$var$ChildCreateButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb7vkz _4t3i7vkz _2rko1sit _s7n4jp4b _bfhkiw92 _syaz10s3 _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _11r712vo _e2oo1crf _1xjx1crf _z2391qo1 _19y510s3 _16uvt94y _jomr74gs _irr374gs _1di6uh8s _9h8h705v",
            __cmplp.className
        ])
    });
});
const $5945efd4865c984a$var$ChildCreateButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldDisplayBtn: shouldDisplayBtn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.shouldDisplayBtn ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gLR87", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4c99bed32bc2b2681f86174863bf9882>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c35a3f9a7f658828$var$_react = $c35a3f9a7f658828$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c35a3f9a7f658828$var$_add = $c35a3f9a7f658828$var$_interopRequireDefault((parcelRequire("cS2gQ")));

var $c35a3f9a7f658828$var$_add2 = $c35a3f9a7f658828$var$_interopRequireDefault((parcelRequire("gO9Xw")));
function $c35a3f9a7f658828$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c35a3f9a7f658828$var$AddIcon = (props)=>/*#__PURE__*/ $c35a3f9a7f658828$var$_react.default.createElement($c35a3f9a7f658828$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $c35a3f9a7f658828$var$_add2.default
    }, props));
$c35a3f9a7f658828$var$AddIcon.Name = 'AddIconMigration';
var $c35a3f9a7f658828$var$_default = module.exports.default = $c35a3f9a7f658828$var$AddIcon;

});


parcelRegister("9w3zf", function(module, exports) {

$parcel$export(module.exports, "useGetGroupByField", () => $281c588fb60f53d7$export$7a0354af7d69ba55);

var $jGcn0 = parcelRequire("jGcn0");

var $4S5hf = parcelRequire("4S5hf");

var $lO4Or = parcelRequire("lO4Or");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");
const $281c588fb60f53d7$export$1aef70471c979441 = (field)=>field.type === (0, $lO4Or.CATEGORY_TYPE);
const $281c588fb60f53d7$export$48f560f91a048a7f = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $281c588fb60f53d7$export$8b6cfed4387d2f77 = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $281c588fb60f53d7$export$ea68dd9055d500e2 = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $281c588fb60f53d7$export$7a0354af7d69ba55 = ()=>{
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const { getAvailableFields: getAvailableFields } = (0, $hHiDc.useIssueFields)();
    const availableFields = getAvailableFields();
    const { data: categoryField } = (0, $4S5hf.useFindField)($281c588fb60f53d7$export$1aef70471c979441);
    const { data: storyPointsField } = (0, $4S5hf.useFindField)($281c588fb60f53d7$export$48f560f91a048a7f);
    const { data: storyPointEstimateField } = (0, $4S5hf.useFindField)($281c588fb60f53d7$export$8b6cfed4387d2f77);
    const { data: sprintField } = (0, $4S5hf.useFindField)($281c588fb60f53d7$export$ea68dd9055d500e2);
    switch(groupByFieldId){
        case categoryField?.id:
            return categoryField;
        case storyPointsField?.id:
            return storyPointsField;
        case storyPointEstimateField?.id:
            return storyPointEstimateField;
        case sprintField?.id:
            return sprintField;
        default:
            return availableFields.find((availableField)=>availableField.type === groupByFieldId);
    }
};

});

parcelRegister("l7wqg", function(module, exports) {

$parcel$export(module.exports, "AssigneeItem", () => $c9646e4c044d1fd0$export$be57e3a2d4264803);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $gjzML = parcelRequire("gjzML");

var $8UbeN = parcelRequire("8UbeN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $b6Z7z = parcelRequire("b6Z7z");
const $c9646e4c044d1fd0$export$be57e3a2d4264803 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isUnassigned = !data.assignee;
    const unassignedDisplayName = formatMessage((0, $b6Z7z.default).unassignedDisplayName);
    const displayName = isUnassigned ? unassignedDisplayName : data.assignee?.displayName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isUnassigned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        src: "",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjzML.AvatarLite), {
        avatarUrl: data.assignee?.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UbeN.DisplayName), null, displayName));
};

});
parcelRegister("gjzML", function(module, exports) {

$parcel$export(module.exports, "AvatarLite", () => $1d0a2d9cba4728c5$export$8b9560cc4e12c651);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $1d0a2d9cba4728c5$var$AVATAR_SIZE = 24;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d0a2d9cba4728c5$var$Avatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { avatarUrl: avatarUrl, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fzlxay": (0, $9t7rW.default)(`url(${__cmplp.avatarUrl})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1itk1v7f _ouxl1ssb _12vemgnk _1lrw1dfr _bfhk18uv _2rko1ssb _vchh18uv _4t3i1tcg _1bsb1tcg _1ul91tcg _1tke1tcg _1e0c1o8l _kqswh2mm _12ji1r31 _1qu2glyw _12y3idpf _80om1kw7 _18s8v77o",
            __cmplp.isHighlighted ? "_16qs7aa6" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $1d0a2d9cba4728c5$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $1d0a2d9cba4728c5$export$8b9560cc4e12c651 = /*#__PURE__*/ (0, $eUqFw.memo)(({ avatarUrl: avatarUrl, name: name = '', highlight: highlight, testId: testId })=>{
    const isHighlighted = highlight && highlight.some($1d0a2d9cba4728c5$var$hasKeywords(name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d0a2d9cba4728c5$var$Avatar, {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        avatarUrl: avatarUrl,
        title: name,
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        isHighlighted: isHighlighted,
        "data-testid": testId
    });
});

});

parcelRegister("8UbeN", function(module, exports) {

$parcel$export(module.exports, "WrapperCommon", () => $ee6ba19431b45a72$export$2cd335d97b9054d6);
$parcel$export(module.exports, "CellWrapper", () => $ee6ba19431b45a72$export$4812fadef83edffe);
$parcel$export(module.exports, "CellContentContainer", () => $ee6ba19431b45a72$export$bd476b087602e432);
$parcel$export(module.exports, "CellContainer", () => $ee6ba19431b45a72$export$287da707e3318210);
$parcel$export(module.exports, "CellContentWrapper", () => $ee6ba19431b45a72$export$f76c50a859269a04);
$parcel$export(module.exports, "TextFieldWrapper", () => $ee6ba19431b45a72$export$e6dcd4f050b24d88);
$parcel$export(module.exports, "AvatarItem", () => $ee6ba19431b45a72$export$15f08c141eda7939);
$parcel$export(module.exports, "DisplayName", () => $ee6ba19431b45a72$export$101fbca3a406e1fd);
$parcel$export(module.exports, "EmptyCellContent", () => $ee6ba19431b45a72$export$78bba2733575aa77);
$parcel$export(module.exports, "Container", () => $ee6ba19431b45a72$export$42a852a2b6b56249);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");


var $c9TLT = parcelRequire("c9TLT");

var $79xbN = parcelRequire("79xbN");
const $ee6ba19431b45a72$export$95bfdfec8f6b837d = 2;
const $ee6ba19431b45a72$export$e643c5fb607dbcc5 = `0 0 0 ${$ee6ba19431b45a72$export$95bfdfec8f6b837d}px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$exports).B200})`} inset`;
const $ee6ba19431b45a72$export$85e848b114283663 = 160;
const $ee6ba19431b45a72$export$df441c04a8cf98f7 = 40;
const $ee6ba19431b45a72$export$2cd335d97b9054d6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uzc8vy": (0, $9t7rW.default)($ee6ba19431b45a72$export$e643c5fb607dbcc5)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.isFocused ? "_16qs179s" : "_16qsglyw",
            __cmplp.isFocused ? "_bfhkvuon" : "_bfhk18uv",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$4812fadef83edffe = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $ee6ba19431b45a72$export$2cd335d97b9054d6, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _2rko1sit _19bvu2gc",
            __cmplp.isEditable ?? true ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$bd476b087602e432 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_g3ey1q": (0, $9t7rW.default)(__cmplp.width - ((0, $c9TLT.gridSize) * 3 + $ee6ba19431b45a72$export$95bfdfec8f6b837d * 2), "px"),
            "--_1nq8131": (0, $9t7rW.default)(__cmplp.height - $ee6ba19431b45a72$export$95bfdfec8f6b837d * 2, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1e0c1txw _4cvr1h6o _1bsb6uc2 _4t3i4226",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$b9800fb826bc73d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uzc8vy": (0, $9t7rW.default)($ee6ba19431b45a72$export$e643c5fb607dbcc5)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _p7r11txw _dzc21h6o _bhl9upfu _k8em1osq _bd9w1r31 _ezapglyw _1qzf1o36 _zbayglpi",
            __cmplp.isFocused ? "_bp7o179s" : "_bp7oglyw",
            __cmplp.isFocused ? "_1gzevuon" : "_1gze18uv",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$var$focusedStyle = null;
const $ee6ba19431b45a72$var$formattedStyle = null;
const $ee6ba19431b45a72$var$cellContainerStyles = null;
const $ee6ba19431b45a72$export$287da707e3318210 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isFocused: isFocused, formatRuleBackgroundColor: formatRuleBackgroundColor, ...props }, ref)=>{
    if ((0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        ...props,
        /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _p7r11txw _dzc21h6o _bhl91osq _k8em1osq _bd9w1r31 _ezapglyw _1qzf1o36 _1gze18uv _zbayglpi",
            isFocused && "_bp7o179s _1gzevuon",
            formatRuleBackgroundColor && !isFocused && "_bfhk1olo"
        ]),
        style: {
            '--local-format-color': formatRuleBackgroundColor,
            "--_1uzc8vy": (0, $9t7rW.default)($ee6ba19431b45a72$export$e643c5fb607dbcc5)
        }
    }, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee6ba19431b45a72$export$b9800fb826bc73d, {
        ref: ref,
        isFocused: isFocused,
        ...props
    });
});
const $ee6ba19431b45a72$export$f76c50a859269a04 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { preferredWidth: preferredWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kfanob": (0, $9t7rW.default)(__cmplp.preferredWidth, "px"),
            "--_1uzc8vy": (0, $9t7rW.default)($ee6ba19431b45a72$export$e643c5fb607dbcc5)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1rw8 _1ul91178 _1p3lidpf _13ce179s",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$e6dcd4f050b24d88 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, isEditable: isEditable, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uzc8vy": (0, $9t7rW.default)($ee6ba19431b45a72$export$e643c5fb607dbcc5)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _2rkoglpi _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _cj13v77o _1v5nidpf _qbsg179s _1yds1osq _kgm11cy0 _17kn15vq _1hrp15vq _x3fa1l2s",
            __cmplp.isFocused ? "_bfhkvuon" : "_bfhk18uv",
            __cmplp.isEditable ?? true ? "_80om1kdv" : "_80om73ad",
            __cmplp.isSelected || __cmplp.isFocused ? "_16qs179s" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$15f08c141eda7939 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isUnassigned: isUnassigned, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1reo15vq _18m915vq _o5721q9c _1bsb1osq _4t3imslj _16l4kb7n",
            __cmplp.isUnassigned ? "_tzy4idpf" : "_tzy4kb7n",
            __cmplp.isUnassigned ? "_syaz1e9r" : "_syaz1kw7",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$101fbca3a406e1fd = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$78bba2733575aa77 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1e9r _lcxvglyw _12qeu2gc",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$var$containerBaseStyles = null;
const $ee6ba19431b45a72$var$containerMenuOpenStyles = null;
const $ee6ba19431b45a72$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, isMenuOpen: isMenuOpen, children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: width ? `${width}px` : '100%'
        },
        ...rest,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1osq _2rko1hkb _80omtlke _bfhk18uv _19bvu2gc _16qsglyw",
            isMenuOpen && "_bfhkvuon _19bvze3t _16qs1f5q"
        ])
    }, children));

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';


parcelRegister("b6Z7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $724195363e48e1cb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $724195363e48e1cb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassignedDisplayName: {
        "id": "business-list.list-view.group-item.assignee-item.unassigned-display-name",
        "defaultMessage": "Unassigned"
    }
});

});


parcelRegister("dTdQF", function(module, exports) {

$parcel$export(module.exports, "CategoryItem", () => $dec77a362bbe0ee4$export$41d1d7fbacf843);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $MxsGB = parcelRequire("MxsGB");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3SBWf = parcelRequire("3SBWf");
const $dec77a362bbe0ee4$export$41d1d7fbacf843 = /*#__PURE__*/ (0, $eUqFw.memo)(({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return data.category?.name != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $MxsGB.default), {
        categoryColor: data.category.color,
        categoryName: data.category.name,
        isInteractive: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dec77a362bbe0ee4$var$UncategorizedLabel, null, formatMessage((0, $3SBWf.default).noCategory));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dec77a362bbe0ee4$var$UncategorizedLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz14xw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("MxsGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $575c3f5934e57f5b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $dnJL9 = parcelRequire("dnJL9");

var $8rQuz = parcelRequire("8rQuz");

var $k7FjW = parcelRequire("k7FjW");
const $575c3f5934e57f5b$var$CategoryTag = ({ categoryName: categoryName, categoryColor: categoryColor, isInteractive: isInteractive = true })=>{
    const { textColor: textColor, backgroundColor: tagColor } = (0, $k7FjW.getColorMetadata)(categoryColor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($575c3f5934e57f5b$var$CategoryTagWrapper, {
        isInteractive: isInteractive,
        textColor: (0, $8rQuz.isVisualRefreshEnabled)() ? "var(--ds-text, #172B4D)" : textColor,
        "aria-label": categoryName,
        "data-testid": "business-categories.ui.category-form.category-tag.category-tag-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($575c3f5934e57f5b$var$StyledTag, {
        color: tagColor
    }, categoryName));
};
var $575c3f5934e57f5b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($575c3f5934e57f5b$var$CategoryTag);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $575c3f5934e57f5b$var$CategoryTagWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, isInteractive: isInteractive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $9t7rW.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1bah1e5h _4cvr1h6o _v564188d _p12f1osq _1ul9idpf _1tkeidpf _syazijt0",
            __cmplp.isInteractive ? "_d0altlke" : "_d0al73ad",
            __cmplp.className
        ])
    });
});
const $575c3f5934e57f5b$var$StyledTagOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoiti9 _bfhk1cj8 _1yt41b66 _11c81oud _vwz4dlk8 _1bto1l2s _o5721q9c _1reo15vq _18m915vq _p12f1osq",
            __cmplp.className
        ])
    });
});
const $575c3f5934e57f5b$var$StyledTagNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $9t7rW.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko5n0m _bfhk18uv _19it11we _1yt4u49m _11c81oud _vwz4dlk8 _1bto1l2s _o5721q9c _1reo15vq _18m915vq _p12f1osq",
            __cmplp.className
        ])
    });
});
const $575c3f5934e57f5b$var$StyledTag = (0, $dnJL9.componentWithFG)('visual-refresh', $575c3f5934e57f5b$var$StyledTagNew, $575c3f5934e57f5b$var$StyledTagOld);

});
parcelRegister("k7FjW", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $0ce9d8c1415fa16c$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $0ce9d8c1415fa16c$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $0ce9d8c1415fa16c$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $0ce9d8c1415fa16c$export$49fce7fdcf55f26d);

var $fwFhq = parcelRequire("fwFhq");
const $0ce9d8c1415fa16c$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $fwFhq.CATEGORY_THEMES).length);
    return (0, $fwFhq.CATEGORY_THEMES)[randomIndex].name;
};
const $0ce9d8c1415fa16c$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $fwFhq.CATEGORY_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $0ce9d8c1415fa16c$export$9eff62e8ee2aaa2c = (colorName)=>(0, $fwFhq.CATEGORY_THEMES).find((item)=>item.name === colorName)?.backgroundColor ?? '';
const $0ce9d8c1415fa16c$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $fwFhq.GREY_LIGHTEST_META;
    return (0, $fwFhq.CATEGORY_THEMES).find((item)=>item.name === colorName) ?? (0, $fwFhq.GREY_LIGHTEST_META);
};
const $0ce9d8c1415fa16c$export$4ef6b7574883e63d = ()=>(0, $fwFhq.CATEGORY_THEMES).map((item)=>item.name);

});
parcelRegister("fwFhq", function(module, exports) {

$parcel$export(module.exports, "GREY_LIGHTEST_META", () => $592872c1ad972acf$export$cb19a604bb399a88);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $592872c1ad972acf$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $592872c1ad972acf$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "CATEGORY_THEMES", () => $592872c1ad972acf$export$845e69f3af4133a6);


var $jwyl8 = parcelRequire("jwyl8");

var $kzlGv = parcelRequire("kzlGv");
const $592872c1ad972acf$export$cb19a604bb399a88 = {
    name: 'GREY_LIGHTEST',
    backgroundColor: `var(--ds-background-neutral, ${$jwyl8.N100})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N900})`,
    messageLabel: (0, $kzlGv.default).greyLightest
};
const $592872c1ad972acf$export$7c3ad8ed1eaec359 = {
    name: 'GREY_LIGHTER',
    backgroundColor: `var(--ds-background-neutral-hovered, ${$jwyl8.N200})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N900})`,
    messageLabel: (0, $kzlGv.default).greyLighter
};
const $592872c1ad972acf$export$11b75436f568ab00 = {
    name: 'GREY',
    backgroundColor: `var(--ds-background-neutral-pressed, ${$jwyl8.N300})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N900})`,
    messageLabel: (0, $kzlGv.default).grey
};
const $592872c1ad972acf$export$680a025ac49fcedd = {
    name: 'GREY_DARKER',
    backgroundColor: `var(--ds-background-neutral-bold, ${$jwyl8.N400})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).greyDarker
};
const $592872c1ad972acf$export$c63acd769779da32 = {
    name: 'GREY_DARKEST',
    backgroundColor: `var(--ds-background-neutral-bold-pressed, ${$jwyl8.N500})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).greyDarkest
};
const $592872c1ad972acf$export$d6bc0064d6a00b4b = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-purple-subtlest, ${$jwyl8.P100})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purpleLightest
};
const $592872c1ad972acf$export$7a53a04457b57cc7 = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-purple-subtler, ${$jwyl8.P200})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purpleLighter
};
const $592872c1ad972acf$export$d6f3928d12bf329c = {
    name: 'PURPLE',
    backgroundColor: `var(--ds-background-accent-purple-subtle, ${$jwyl8.P300})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purple
};
const $592872c1ad972acf$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: `var(--ds-text-accent-purple, ${$jwyl8.P400})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).purpleDarker
};
const $592872c1ad972acf$export$5e3ecd219265b1d5 = {
    name: 'PURPLE_DARKEST',
    backgroundColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).purpleDarkest
};
const $592872c1ad972acf$export$4b98b31eae42f719 = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-blue-subtlest, ${$jwyl8.B100})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blueLightest
};
const $592872c1ad972acf$export$e92a5b8219b97745 = {
    name: 'BLUE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-blue-subtler, ${$jwyl8.B200})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blueLighter
};
const $592872c1ad972acf$export$b761714c24fd7f1c = {
    name: 'BLUE',
    backgroundColor: `var(--ds-background-accent-blue-subtle, ${$jwyl8.B300})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blue
};
const $592872c1ad972acf$export$50b37b24459ab9d9 = {
    name: 'BLUE_DARKER',
    backgroundColor: `var(--ds-text-accent-blue, ${$jwyl8.B400})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).blueDarker
};
const $592872c1ad972acf$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).blueDarkest
};
const $592872c1ad972acf$export$1fe5b156c0ba3acb = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-teal-subtlest, ${$jwyl8.T100})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).tealLightest
};
const $592872c1ad972acf$export$fb40f4c2f659b9bb = {
    name: 'TEAL_LIGHTER',
    backgroundColor: `var(--ds-background-accent-teal-subtler, ${$jwyl8.T200})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).tealLighter
};
const $592872c1ad972acf$export$d177e878b5837287 = {
    name: 'TEAL',
    backgroundColor: `var(--ds-background-accent-teal-subtle, ${$jwyl8.T300})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).teal
};
const $592872c1ad972acf$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: `var(--ds-text-accent-teal, ${$jwyl8.T400})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).tealDarker
};
const $592872c1ad972acf$export$fc1c501cf599d75a = {
    name: 'TEAL_DARKEST',
    backgroundColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).tealDarkest
};
const $592872c1ad972acf$export$d977521f30fbcdeb = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-green-subtlest, ${$jwyl8.G100})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).greenLightest
};
const $592872c1ad972acf$export$911ea8fce963369 = {
    name: 'GREEN_LIGHTER',
    backgroundColor: `var(--ds-background-accent-green-subtler, ${$jwyl8.G200})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).greenLighter
};
const $592872c1ad972acf$export$814f677491d6ea0d = {
    name: 'GREEN',
    backgroundColor: `var(--ds-background-accent-green-subtle, ${$jwyl8.G300})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).green
};
const $592872c1ad972acf$export$376a849da12d546d = {
    name: 'GREEN_DARKER',
    backgroundColor: `var(--ds-background-accent-green-bolder, ${$jwyl8.G400})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).greenDarker
};
const $592872c1ad972acf$export$808ba7d394e8f2c4 = {
    name: 'GREEN_DARKEST',
    backgroundColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).greenDarkest
};
const $592872c1ad972acf$export$46ad9119b0fbf094 = {
    name: 'LIME_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-lime-subtlest, ${$jwyl8.L100})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).limeLightest
};
const $592872c1ad972acf$export$e5e5e485aa3ce630 = {
    name: 'LIME_LIGHTER',
    backgroundColor: `var(--ds-background-accent-lime-subtler, ${$jwyl8.L200})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).limeLighter
};
const $592872c1ad972acf$export$166a57cda148857c = {
    name: 'LIME',
    backgroundColor: `var(--ds-background-accent-lime-subtle, ${$jwyl8.L300})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).lime
};
const $592872c1ad972acf$export$40663533c0b649cc = {
    name: 'LIME_DARKER',
    backgroundColor: `var(--ds-text-accent-lime, ${$jwyl8.L400})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).limeDarker
};
const $592872c1ad972acf$export$78557ba4a4ffc502 = {
    name: 'LIME_DARKEST',
    backgroundColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).limeDarkest
};
const $592872c1ad972acf$export$12021cfc394e311e = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-yellow-subtlest, ${$jwyl8.Y100})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellowLightest
};
const $592872c1ad972acf$export$eab7ec7309efe3db = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: `var(--ds-background-accent-yellow-subtler, ${$jwyl8.Y200})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellowLighter
};
const $592872c1ad972acf$export$8d5b340327da7fa3 = {
    name: 'YELLOW',
    backgroundColor: `var(--ds-background-accent-yellow-subtle, ${$jwyl8.Y300})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellow
};
const $592872c1ad972acf$export$b0a7a0813708318e = {
    name: 'YELLOW_DARKER',
    backgroundColor: `var(--ds-text-accent-yellow, ${$jwyl8.Y400})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).yellowDarker
};
const $592872c1ad972acf$export$dde9759b2d3b0e02 = {
    name: 'YELLOW_DARKEST',
    backgroundColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).yellowDarkest
};
const $592872c1ad972acf$export$4718b8cf3799954b = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-orange-subtlest, ${$jwyl8.O100})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orangeLightest
};
const $592872c1ad972acf$export$8fac1fdda0aa4e41 = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-orange-subtler, ${$jwyl8.O200})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orangeLighter
};
const $592872c1ad972acf$export$2efe350451bcec02 = {
    name: 'ORANGE',
    backgroundColor: `var(--ds-background-accent-orange-subtle, ${$jwyl8.O300})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orange
};
const $592872c1ad972acf$export$5ba9bd795da8d7d5 = {
    name: 'ORANGE_DARKER',
    backgroundColor: `var(--ds-background-accent-orange-bolder, ${$jwyl8.O400})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).orangeDarker
};
const $592872c1ad972acf$export$93a7b89503a97d81 = {
    name: 'ORANGE_DARKEST',
    backgroundColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).orangeDarkest
};
const $592872c1ad972acf$export$56873b0b30501dbe = {
    name: 'RED_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-red-subtlest, ${$jwyl8.R100})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).redLightest
};
const $592872c1ad972acf$export$344aa49a80760380 = {
    name: 'RED_LIGHTER',
    backgroundColor: `var(--ds-background-accent-red-subtler, ${$jwyl8.R200})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).redLighter
};
const $592872c1ad972acf$export$c760bedaf9085f90 = {
    name: 'RED',
    backgroundColor: `var(--ds-background-accent-red-subtle, ${$jwyl8.R300})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).red
};
const $592872c1ad972acf$export$38493b731be63d77 = {
    name: 'RED_DARKER',
    backgroundColor: `var(--ds-background-accent-red-bolder, ${$jwyl8.R400})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).redDarker
};
const $592872c1ad972acf$export$dda419d8311f8d4a = {
    name: 'RED_DARKEST',
    backgroundColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).redDarkest
};
const $592872c1ad972acf$export$e0957dc0d569e65f = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-magenta-subtlest, ${$jwyl8.M100})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magentaLightest
};
const $592872c1ad972acf$export$299af16a857bf4ca = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: `var(--ds-background-accent-magenta-subtler, ${$jwyl8.M200})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magentaLighter
};
const $592872c1ad972acf$export$d7208e47aa15bafe = {
    name: 'MAGENTA',
    backgroundColor: `var(--ds-background-accent-magenta-subtle-hovered, ${$jwyl8.M300})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magenta
};
const $592872c1ad972acf$export$b3aea5a31105d4e3 = {
    name: 'MAGENTA_DARKER',
    backgroundColor: `var(--ds-text-accent-magenta, ${$jwyl8.M400})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).magentaDarker
};
const $592872c1ad972acf$export$faf43e54615bce6b = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.M500})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    messageLabel: (0, $kzlGv.default).magentaDarkest
};
const $592872c1ad972acf$export$270aee965367aeb3 = `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $592872c1ad972acf$export$941ef40ef5fdd2b1 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$exports).N500})`;
const $592872c1ad972acf$export$845e69f3af4133a6 = [
    $592872c1ad972acf$export$cb19a604bb399a88,
    $592872c1ad972acf$export$d6bc0064d6a00b4b,
    $592872c1ad972acf$export$4b98b31eae42f719,
    $592872c1ad972acf$export$1fe5b156c0ba3acb,
    $592872c1ad972acf$export$d977521f30fbcdeb,
    $592872c1ad972acf$export$46ad9119b0fbf094,
    $592872c1ad972acf$export$12021cfc394e311e,
    $592872c1ad972acf$export$4718b8cf3799954b,
    $592872c1ad972acf$export$56873b0b30501dbe,
    $592872c1ad972acf$export$e0957dc0d569e65f,
    $592872c1ad972acf$export$7c3ad8ed1eaec359,
    $592872c1ad972acf$export$7a53a04457b57cc7,
    $592872c1ad972acf$export$e92a5b8219b97745,
    $592872c1ad972acf$export$fb40f4c2f659b9bb,
    $592872c1ad972acf$export$911ea8fce963369,
    $592872c1ad972acf$export$e5e5e485aa3ce630,
    $592872c1ad972acf$export$eab7ec7309efe3db,
    $592872c1ad972acf$export$8fac1fdda0aa4e41,
    $592872c1ad972acf$export$344aa49a80760380,
    $592872c1ad972acf$export$299af16a857bf4ca,
    $592872c1ad972acf$export$11b75436f568ab00,
    $592872c1ad972acf$export$d6f3928d12bf329c,
    $592872c1ad972acf$export$b761714c24fd7f1c,
    $592872c1ad972acf$export$d177e878b5837287,
    $592872c1ad972acf$export$814f677491d6ea0d,
    $592872c1ad972acf$export$166a57cda148857c,
    $592872c1ad972acf$export$8d5b340327da7fa3,
    $592872c1ad972acf$export$2efe350451bcec02,
    $592872c1ad972acf$export$c760bedaf9085f90,
    $592872c1ad972acf$export$d7208e47aa15bafe,
    $592872c1ad972acf$export$680a025ac49fcedd,
    $592872c1ad972acf$export$7c314e2461a7241b,
    $592872c1ad972acf$export$50b37b24459ab9d9,
    $592872c1ad972acf$export$6daaa1cc3f46f41,
    $592872c1ad972acf$export$376a849da12d546d,
    $592872c1ad972acf$export$40663533c0b649cc,
    $592872c1ad972acf$export$b0a7a0813708318e,
    $592872c1ad972acf$export$5ba9bd795da8d7d5,
    $592872c1ad972acf$export$38493b731be63d77,
    $592872c1ad972acf$export$b3aea5a31105d4e3,
    $592872c1ad972acf$export$c63acd769779da32,
    $592872c1ad972acf$export$5e3ecd219265b1d5,
    $592872c1ad972acf$export$69c4eac71b813fba,
    $592872c1ad972acf$export$fc1c501cf599d75a,
    $592872c1ad972acf$export$808ba7d394e8f2c4,
    $592872c1ad972acf$export$78557ba4a4ffc502,
    $592872c1ad972acf$export$dde9759b2d3b0e02,
    $592872c1ad972acf$export$93a7b89503a97d81,
    $592872c1ad972acf$export$dda419d8311f8d4a,
    $592872c1ad972acf$export$faf43e54615bce6b
];

});
parcelRegister("jwyl8", function(module, exports) {

$parcel$export(module.exports, "N100", () => $cccad9dbca818926$export$d6447c357493214f);
$parcel$export(module.exports, "N200", () => $cccad9dbca818926$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $cccad9dbca818926$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N400", () => $cccad9dbca818926$export$eece5f492e429f08);
$parcel$export(module.exports, "N500", () => $cccad9dbca818926$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "P100", () => $cccad9dbca818926$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $cccad9dbca818926$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $cccad9dbca818926$export$b48405b95304b5a1);
$parcel$export(module.exports, "P400", () => $cccad9dbca818926$export$c71e4279dd54a18d);
$parcel$export(module.exports, "P500", () => $cccad9dbca818926$export$147899de772240ec);
$parcel$export(module.exports, "B100", () => $cccad9dbca818926$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B200", () => $cccad9dbca818926$export$215b7063051591f1);
$parcel$export(module.exports, "B300", () => $cccad9dbca818926$export$e62e8919cca44969);
$parcel$export(module.exports, "B400", () => $cccad9dbca818926$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $cccad9dbca818926$export$a6ee3d71bc067634);
$parcel$export(module.exports, "T100", () => $cccad9dbca818926$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $cccad9dbca818926$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $cccad9dbca818926$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T400", () => $cccad9dbca818926$export$7c835c78b6fcdef8);
$parcel$export(module.exports, "T500", () => $cccad9dbca818926$export$6036577f95c3877e);
$parcel$export(module.exports, "G100", () => $cccad9dbca818926$export$afbce1382ec95f73);
$parcel$export(module.exports, "G200", () => $cccad9dbca818926$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $cccad9dbca818926$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $cccad9dbca818926$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $cccad9dbca818926$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "L100", () => $cccad9dbca818926$export$fbb30b762ae4fcda);
$parcel$export(module.exports, "L200", () => $cccad9dbca818926$export$f72948ef771f6f15);
$parcel$export(module.exports, "L300", () => $cccad9dbca818926$export$59d89537e7d73aa4);
$parcel$export(module.exports, "L400", () => $cccad9dbca818926$export$4b0a7cabffffd4f5);
$parcel$export(module.exports, "L500", () => $cccad9dbca818926$export$58808b1c527bd1b0);
$parcel$export(module.exports, "Y100", () => $cccad9dbca818926$export$1cc05bbbf340e559);
$parcel$export(module.exports, "Y200", () => $cccad9dbca818926$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y300", () => $cccad9dbca818926$export$c6930421db9fa514);
$parcel$export(module.exports, "Y400", () => $cccad9dbca818926$export$59619663aa6500fb);
$parcel$export(module.exports, "Y500", () => $cccad9dbca818926$export$874739ea9e379ab6);
$parcel$export(module.exports, "O100", () => $cccad9dbca818926$export$4d0048026652f54a);
$parcel$export(module.exports, "O200", () => $cccad9dbca818926$export$51716a84e62e022c);
$parcel$export(module.exports, "O300", () => $cccad9dbca818926$export$59e5b1f9a23fd718);
$parcel$export(module.exports, "O400", () => $cccad9dbca818926$export$e30ed75d70748b1);
$parcel$export(module.exports, "O500", () => $cccad9dbca818926$export$d93a44e5c84e8256);
$parcel$export(module.exports, "R100", () => $cccad9dbca818926$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R200", () => $cccad9dbca818926$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $cccad9dbca818926$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $cccad9dbca818926$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $cccad9dbca818926$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "M100", () => $cccad9dbca818926$export$6755153cd35f90b1);
$parcel$export(module.exports, "M200", () => $cccad9dbca818926$export$a19f0c33186f7767);
$parcel$export(module.exports, "M300", () => $cccad9dbca818926$export$a46884cf0037b203);
$parcel$export(module.exports, "M400", () => $cccad9dbca818926$export$a1d4686c17e1cdef);
$parcel$export(module.exports, "M500", () => $cccad9dbca818926$export$16814b01d9742bf7);

const $cccad9dbca818926$export$d6447c357493214f = '#F0F1F4';
const $cccad9dbca818926$export$f563ee71e9ee74cd = 'rgba(9, 30, 66, 0.14)';
const $cccad9dbca818926$export$e2ef2124cf4024b1 = (0, $73a5c9d720aa66e1$exports).N60A;
const $cccad9dbca818926$export$eece5f492e429f08 = '#44546F';
const $cccad9dbca818926$export$c39c0fe0f26207ae = (0, $73a5c9d720aa66e1$exports).N800;
const $cccad9dbca818926$export$6011520a64d9a187 = '#F3F0FF';
const $cccad9dbca818926$export$a7175d4e9206bc80 = '#DFD8FD';
const $cccad9dbca818926$export$b48405b95304b5a1 = '#9F8FEF';
const $cccad9dbca818926$export$c71e4279dd54a18d = '#5E4DB2';
const $cccad9dbca818926$export$147899de772240ec = '#352C63';
const $cccad9dbca818926$export$ecfc1dff386a3e7a = '#E9F2FF';
const $cccad9dbca818926$export$215b7063051591f1 = '#CCE0FF';
const $cccad9dbca818926$export$e62e8919cca44969 = '#579DFF';
const $cccad9dbca818926$export$b3de0ae08da2ce64 = '#0055CC';
const $cccad9dbca818926$export$a6ee3d71bc067634 = '#09326C';
const $cccad9dbca818926$export$776c9c497ef08533 = '#E3FAFC';
const $cccad9dbca818926$export$69cb3ca10c1e330e = '#C1F0F5';
const $cccad9dbca818926$export$9dc1ef0f3f48059b = '#60C6D2';
const $cccad9dbca818926$export$7c835c78b6fcdef8 = '#206B74';
const $cccad9dbca818926$export$6036577f95c3877e = '#1D474C';
const $cccad9dbca818926$export$afbce1382ec95f73 = '#DFFCF0';
const $cccad9dbca818926$export$747d86715d4175de = '#BAF3DB';
const $cccad9dbca818926$export$940e1f69e873f202 = '#4BCE97';
const $cccad9dbca818926$export$a49394138f7b8e85 = '#216E4E';
const $cccad9dbca818926$export$6fa04827ac68a4fb = '#164B35';
const $cccad9dbca818926$export$fbb30b762ae4fcda = '#EEFBDA';
const $cccad9dbca818926$export$f72948ef771f6f15 = '#D3F1A7';
const $cccad9dbca818926$export$59d89537e7d73aa4 = '#94C748';
const $cccad9dbca818926$export$4b0a7cabffffd4f5 = '#4C6B1F';
const $cccad9dbca818926$export$58808b1c527bd1b0 = '#37471F';
const $cccad9dbca818926$export$1cc05bbbf340e559 = '#FFF7D6';
const $cccad9dbca818926$export$5aae31392d72caaa = (0, $73a5c9d720aa66e1$exports).Y75;
const $cccad9dbca818926$export$c6930421db9fa514 = '#E2B203';
const $cccad9dbca818926$export$59619663aa6500fb = '#7F5F01';
const $cccad9dbca818926$export$874739ea9e379ab6 = '#533F04';
const $cccad9dbca818926$export$4d0048026652f54a = '#FFF4E5';
const $cccad9dbca818926$export$51716a84e62e022c = '#FFE2BD';
const $cccad9dbca818926$export$59e5b1f9a23fd718 = '#FAA53D';
const $cccad9dbca818926$export$e30ed75d70748b1 = '#974F0C';
const $cccad9dbca818926$export$d93a44e5c84e8256 = '#5F3811';
const $cccad9dbca818926$export$be802dd0d8b57f35 = '#FFEDEB';
const $cccad9dbca818926$export$60847d42f9da92a6 = '#FFD2CC';
const $cccad9dbca818926$export$4a7404f376229999 = '#F87462';
const $cccad9dbca818926$export$2010d0fb4295b346 = '#AE2A19';
const $cccad9dbca818926$export$2837b5a1a71d5c02 = '#601E16';
const $cccad9dbca818926$export$6755153cd35f90b1 = '#FFECF8';
const $cccad9dbca818926$export$a19f0c33186f7767 = '#FDD0EC';
const $cccad9dbca818926$export$a46884cf0037b203 = '#F797D2';
const $cccad9dbca818926$export$a1d4686c17e1cdef = '#943D73';
const $cccad9dbca818926$export$16814b01d9742bf7 = '#50253F';

});

parcelRegister("kzlGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c77e6e90b19c039$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3c77e6e90b19c039$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    greyLightest: {
        "id": "business-categories.category-form.category-color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "business-categories.category-form.category-color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "business-categories.category-form.category-color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "business-categories.category-form.category-color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "business-categories.category-form.category-color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "business-categories.category-form.category-color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "business-categories.category-form.category-color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "business-categories.category-form.category-color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "business-categories.category-form.category-color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "business-categories.category-form.category-color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "business-categories.category-form.category-color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "business-categories.category-form.category-color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "business-categories.category-form.category-color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "business-categories.category-form.category-color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "business-categories.category-form.category-color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "business-categories.category-form.category-color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "business-categories.category-form.category-color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "business-categories.category-form.category-color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "business-categories.category-form.category-color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "business-categories.category-form.category-color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "business-categories.category-form.category-color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "business-categories.category-form.category-color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "business-categories.category-form.category-color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "business-categories.category-form.category-color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "business-categories.category-form.category-color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "business-categories.category-form.category-color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "business-categories.category-form.category-color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "business-categories.category-form.category-color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "business-categories.category-form.category-color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "business-categories.category-form.category-color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "business-categories.category-form.category-color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "business-categories.category-form.category-color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "business-categories.category-form.category-color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "business-categories.category-form.category-color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "business-categories.category-form.category-color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "business-categories.category-form.category-color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "business-categories.category-form.category-color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "business-categories.category-form.category-color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "business-categories.category-form.category-color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "business-categories.category-form.category-color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "business-categories.category-form.category-color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "business-categories.category-form.category-color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "business-categories.category-form.category-color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "business-categories.category-form.category-color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "business-categories.category-form.category-color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "business-categories.category-form.category-color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "business-categories.category-form.category-color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "business-categories.category-form.category-color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "business-categories.category-form.category-color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "business-categories.category-form.category-color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});




parcelRegister("3SBWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $74a53a1a378752df$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $74a53a1a378752df$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noCategory: {
        "id": "business-list.list-view.group-item.category-item.no-category",
        "defaultMessage": "Uncategorized"
    }
});

});


parcelRegister("kavY4", function(module, exports) {

$parcel$export(module.exports, "ExpandIcon", () => $a0f5f277ad8bbe17$export$fcdb0af0473ee9e4);

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");


var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $48IC4 = parcelRequire("48IC4");

var $1wnOS = parcelRequire("1wnOS");
const $a0f5f277ad8bbe17$export$fcdb0af0473ee9e4 = ({ expanded: expanded, onClick: onClick, rowIndex: rowIndex, totalGroupItems: totalGroupItems })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    const Icon = expanded ? (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))) : (0, (/*@__PURE__*/$parcel$interopDefault($dtaN9)));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onClick();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'listRowGroupExpandIcon', {
            direction: expanded ? 'collapse' : 'expand',
            totalGroupItems: totalGroupItems
        });
    }, [
        createAnalyticsEvent,
        expanded,
        onClick,
        totalGroupItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: formatMessage(expanded ? (0, $48IC4.default).collapse : (0, $48IC4.default).expand)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1wnOS.ExpandIconWrapper), {
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            label: formatMessage(expanded ? (0, $48IC4.default).collapseLabel : (0, $48IC4.default).open),
            primaryColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`
        }),
        appearance: "subtle",
        testId: `business-list.ui.list-view.group-item.expand-icon.expand-icon-wrapper-${rowIndex}`
    }));
};

});
parcelRegister("48IC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0d423199d67e0b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c0d423199d67e0b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    expand: {
        "id": "business-list.list-view.group-item.expand-icon.expand",
        "defaultMessage": "Expand"
    },
    collapse: {
        "id": "business-list.list-view.group-item.expand-icon.collapse",
        "defaultMessage": "Collapse"
    },
    collapseLabel: {
        "id": "business-list.list-view.group-item.expand-icon.collapse-label",
        "defaultMessage": "collapse"
    },
    open: {
        "id": "business-list.list-view.group-item.expand-icon.open",
        "defaultMessage": "open"
    }
});

});

parcelRegister("1wnOS", function(module, exports) {

$parcel$export(module.exports, "ExpandIconWrapper", () => $ad9c59484beb743d$export$4eeef63d68e77552);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $ad9c59484beb743d$var$CONTENT_OFFSET = "var(--ds-space-100, 8px)";
const $ad9c59484beb743d$var$WRAPPER_TRANSFORM = `translate(calc(-100% - ${$ad9c59484beb743d$var$CONTENT_OFFSET}), -50%)`;
const $ad9c59484beb743d$export$4eeef63d68e77552 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_t9ec1mu3 _14n4stnw _w1ap1tcg _btpd1tcg",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1CxqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da9484b0f88f75d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2da9484b0f88f75d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    visibleItemsCount: {
        "id": "business-list.list-view.group-item.visible-items-count",
        "defaultMessage": "{ visibleItems } of { totalGroupItems }"
    },
    addGroupItem: {
        "id": "business-list.list-view.group-item.add-group-item",
        "defaultMessage": "Add group item"
    },
    createIssue: {
        "id": "business-list.list-view.group-item.create-issue",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("6dZjh", function(module, exports) {

$parcel$export(module.exports, "PriorityItem", () => $734284504fe6d226$export$2ea27b6e6a4479a7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aCS15 = parcelRequire("aCS15");

var $eyAMn = parcelRequire("eyAMn");
const $734284504fe6d226$export$2ea27b6e6a4479a7 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const priorityName = data.priority?.name != null ? data.priority.name : formatMessage((0, $eyAMn.default).noPriority);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aCS15.default), {
        iconUrl: data.priority?.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($734284504fe6d226$var$PriorityLabel, null, priorityName));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $734284504fe6d226$var$PriorityLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aCS15", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebdc6113df78754e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $ebdc6113df78754e$var$PRIORITY_ICON_SIZE = 20;
const $ebdc6113df78754e$var$PriorityIcon = ({ iconUrl: iconUrl })=>iconUrl == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebdc6113df78754e$var$ImageIcon, {
        src: iconUrl,
        alt: ""
    });
var $ebdc6113df78754e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($ebdc6113df78754e$var$PriorityIcon);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebdc6113df78754e$var$ImageIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eyAMn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d65e095278376fc6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d65e095278376fc6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noPriority: {
        "id": "business-list.list-view.group-item.priority-item.no-priority",
        "defaultMessage": "No priority"
    }
});

});


parcelRegister("6SYWA", function(module, exports) {

$parcel$export(module.exports, "SelectGroupCheckbox", () => $f898f65ca00fefcb$export$5740ccbed0a2bd61);

var $eUqFw = parcelRequire("eUqFw");

var $hotly = parcelRequire("hotly");

var $lEcA7 = parcelRequire("lEcA7");

var $hMWPo = parcelRequire("hMWPo");

var $8COV0 = parcelRequire("8COV0");

var $5r9Wo = parcelRequire("5r9Wo");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hRFuG = parcelRequire("hRFuG");

var $4SJmy = parcelRequire("4SJmy");
const $f898f65ca00fefcb$var$getFirstParent = ({ issuesMap: issuesMap, issueId: issueId })=>{
    const parentIssueId = issuesMap.get(issueId)?.parentIssueId;
    if (parentIssueId) return $f898f65ca00fefcb$var$getFirstParent({
        issuesMap: issuesMap,
        issueId: parentIssueId
    });
    return issueId;
};
const $f898f65ca00fefcb$export$5740ccbed0a2bd61 = /*#__PURE__*/ (0, $eUqFw.memo)(({ group: group, rowIndex: rowIndex, onKeyDown: onKeyDown })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ issuesMap: issuesMap, expandedItems: expandedItems, childrenItems: childrenItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [{ areAllIssuesSelected: areAllIssuesSelected, selectedIssues: selectedIssues }, { selectIssues: selectIssues, unselectIssues: unselectIssues, selectGroup: selectGroup, unselectGroup: unselectGroup }] = (0, $hotly.useBulkSelectionStore)();
    const [isGroupSelected] = (0, $hotly.useIsGroupSelected)(group.issueId);
    const { onShiftKeyBulkSelection: onShiftKeyBulkSelection } = (0, $hMWPo.useShiftKeySelection)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { fetchingGroups: fetchingGroups, selectCollapsedGroups: selectCollapsedGroups } = (0, $lEcA7.useSelectCollapsedGroups)();
    const isLoadingGroupIssues = childrenItems[group.issueId]?.loading;
    const groupIssues = (0, $eUqFw.useMemo)(()=>!isLoadingGroupIssues ? (0, $8COV0.getAllIssueChildren)({
            issue: group,
            childrenItems: childrenItems
        }) : undefined, [
        childrenItems,
        group,
        isLoadingGroupIssues
    ]);
    const [diffGroupIssuesSelected] = (0, $hotly.useDiffIssuesSelected)(groupIssues);
    // fetchingGroups - prevent unselecting the group while fetching issues
    (0, $eUqFw.useEffect)(()=>{
        if (!areAllIssuesSelected && !fetchingGroups && !isLoadingGroupIssues && diffGroupIssuesSelected && groupIssues?.length) {
            if (diffGroupIssuesSelected.length === 0 && !isGroupSelected) // if all the issues of the group are selected we should select the group
            selectGroup(group.issueId);
            else if (diffGroupIssuesSelected.length && isGroupSelected) // if some issue is not selected we should unselect the group
            unselectGroup(group.issueId);
        }
    }, [
        areAllIssuesSelected,
        diffGroupIssuesSelected,
        fetchingGroups,
        group.issueId,
        groupIssues?.length,
        isGroupSelected,
        isLoadingGroupIssues,
        selectGroup,
        unselectGroup
    ]);
    const hasChildren = group.childSummary?.hasChildren;
    const hasFirstIssuesToFetch = (0, $eUqFw.useMemo)(()=>expandedItems[group.issueId] === undefined && hasChildren && groupIssues?.length === 0, [
        expandedItems,
        group.issueId,
        groupIssues?.length,
        hasChildren
    ]);
    const onClickCheckbox = (0, $eUqFw.useCallback)(({ isChecked: isChecked, shiftKeyPressed: shiftKeyPressed })=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectGroup', {
            isChecked: isChecked,
            rowIndex: rowIndex,
            shiftKeyPressed: shiftKeyPressed
        });
        if (isChecked) {
            // if the group is selected and we have not fetched children of the group
            // we should expand the group and fetch them
            selectCollapsedGroups([
                group
            ]);
            selectIssues({
                issues: groupIssues || [],
                selectGroup: group.issueId,
                rowIndex: rowIndex
            });
        } else {
            let issuesToUnselect = groupIssues || [];
            if (!groupIssues?.length) /* Edge case - Sorting - line 170 */ issuesToUnselect = [
                ...selectedIssues
            ].filter((issueId)=>$f898f65ca00fefcb$var$getFirstParent({
                    issuesMap: issuesMap,
                    issueId: issueId
                }) === group.issueId);
            unselectIssues({
                issues: issuesToUnselect,
                unselectGroup: group.issueId,
                rowIndex: rowIndex
            });
        }
        if (shiftKeyPressed) onShiftKeyBulkSelection({
            isChecked: isChecked,
            rowIndex: rowIndex
        });
    }, [
        createAnalyticsEvent,
        group,
        groupIssues,
        issuesMap,
        onShiftKeyBulkSelection,
        rowIndex,
        selectCollapsedGroups,
        selectIssues,
        selectedIssues,
        unselectIssues
    ]);
    //  if there is some issue of the group selected
    let hasSomeGroupIssueSelected = !!(Number(diffGroupIssuesSelected?.length) > 0 && Number(diffGroupIssuesSelected?.length) < Number(groupIssues?.length));
    // shouldBeSelected is to check the group immediately when all the issues are selected (diffGroupIssuesSelected is 0)
    //  instead of waiting for the useEffect (line 73) to update the store to calling selectGroup once all the issues are selected
    const shouldBeSelected = Number(diffGroupIssuesSelected?.length) === 0 && hasChildren && Number(groupIssues?.length) > 0 && !hasFirstIssuesToFetch;
    let isChecked = isGroupSelected || hasSomeGroupIssueSelected || !!shouldBeSelected;
    if (!isChecked && selectedIssues.size) {
        /*
                 Edge case - Sorting
                  When the sorting of the columns or the filters changes all the groups change to collapsed and all the children's data it's null.
                 If there is data selected we are not able to match it with the group data.
                 If the change it's due to a filter change we clear the selection because we don't know if it's going to match with the new group data.
                 If the change it's due to sorting we know that will still be part of that group
             */ hasSomeGroupIssueSelected = [
            ...selectedIssues
        ].some((issueId)=>$f898f65ca00fefcb$var$getFirstParent({
                issuesMap: issuesMap,
                issueId: issueId
            }) === group.issueId);
        isChecked = hasSomeGroupIssueSelected;
    }
    const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') {
            onClickCheckbox({
                isChecked: !isChecked,
                shiftKeyPressed: e.shiftKey
            });
            return;
        }
        onKeyDown?.(e);
    }, [
        isChecked,
        onClickCheckbox,
        onKeyDown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hRFuG.BulkSelectCheckbox), {
        onClick: onClickCheckbox,
        onKeyDown: handleKeyDown,
        isChecked: isChecked,
        isIndeterminate: hasSomeGroupIssueSelected,
        label: formatMessage((0, $4SJmy.default).selectGroup)
    });
});

});
parcelRegister("lEcA7", function(module, exports) {

$parcel$export(module.exports, "useSelectCollapsedGroups", () => $e928696ce77fb5c0$export$fb1b9a2145b5780d);

var $eUqFw = parcelRequire("eUqFw");

var $5r9Wo = parcelRequire("5r9Wo");

var $hotly = parcelRequire("hotly");
const $e928696ce77fb5c0$export$fb1b9a2145b5780d = ()=>{
    const [{ expandedItems: expandedItems, childrenItems: childrenItems }, { setExpandedItems: setExpandedItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [{ fetchingGroups: fetchingGroups, selectedGroups: selectedGroups }, { selectIssues: selectIssues, selectGroup: selectGroup, setFetchingGroups: setFetchingGroups }] = (0, $hotly.useBulkSelectionStore)();
    (0, $eUqFw.useEffect)(()=>{
        // if the fetch of the group issues is done and the group is selected
        // we should select the group issues
        if (fetchingGroups.length) {
            let groupFetchDone = [];
            fetchingGroups.forEach((groupId)=>{
                const group = childrenItems[groupId];
                if (group?.loading === false && selectedGroups.has(groupId)) {
                    selectIssues({
                        issues: group.data.map((i)=>String(i.issueId))
                    });
                    groupFetchDone = [
                        ...groupFetchDone,
                        groupId
                    ];
                }
            });
            if (groupFetchDone.length) setFetchingGroups(fetchingGroups.filter((g)=>!groupFetchDone.includes(g)));
        }
    }, [
        childrenItems,
        fetchingGroups,
        selectIssues,
        selectedGroups,
        setFetchingGroups
    ]);
    const selectCollapsedGroups = (0, $eUqFw.useCallback)((groups)=>{
        let groupToFetch = [];
        groups.forEach((group)=>{
            const { issueId: issueId, childSummary: childSummary } = group;
            const hasChildren = childSummary?.hasChildren;
            selectGroup(issueId);
            const hasIssuesToFetch = expandedItems[issueId] === undefined && childrenItems[issueId] === undefined && hasChildren;
            setExpandedItems(issueId, true);
            // if the group is selected and we have not fetched children of the group
            // we should expand the group and fetch them
            if (hasIssuesToFetch) groupToFetch = [
                ...groupToFetch,
                issueId
            ];
        });
        setFetchingGroups(groupToFetch);
    }, [
        childrenItems,
        expandedItems,
        selectGroup,
        setExpandedItems,
        setFetchingGroups
    ]);
    return {
        selectCollapsedGroups: selectCollapsedGroups,
        fetchingGroups: fetchingGroups.length > 0
    };
};

});

parcelRegister("hMWPo", function(module, exports) {

$parcel$export(module.exports, "useShiftKeySelection", () => $ba8313d70bc53bc1$export$e105f3cb55da1b14);

var $eUqFw = parcelRequire("eUqFw");

var $fcWBJ = parcelRequire("fcWBJ");

var $4oWxH = parcelRequire("4oWxH");

var $5r9Wo = parcelRequire("5r9Wo");

var $dSE3z = parcelRequire("dSE3z");

var $hotly = parcelRequire("hotly");

var $lEcA7 = parcelRequire("lEcA7");

var $8COV0 = parcelRequire("8COV0");
const $ba8313d70bc53bc1$export$e105f3cb55da1b14 = ()=>{
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const [{ issuesMap: issuesMap, expandedItems: expandedItems, hierarchyData: hierarchyData, childrenItems: childrenItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [{ selectedIssues: selectedIssuesStore, fetchingGroups: fetchingGroups, lastSelectedRowIndex: lastSelectedRowIndex }, { selectIssues: selectIssues, unselectIssues: unselectIssues, setLastSelectedRowIndex: setLastSelectedRowIndex }] = (0, $hotly.useBulkSelectionStore)();
    const { selectCollapsedGroups: selectCollapsedGroups } = (0, $lEcA7.useSelectCollapsedGroups)();
    /*
        If grouping, the last lastSelectedRowIndex could change  due to expanding and fetching a group
        Once we finish with the fetching of the groups we should update lastSelectedRowIndex with the new index
    */ const [lastIssueIdSelected, setLastIssueIdSelected] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        const isGrouping = groupByFieldId != null;
        if (isGrouping && !fetchingGroups.length && lastSelectedRowIndex !== undefined && lastIssueIdSelected) {
            const issues = (0, $8COV0.getFlattenIssuesList)({
                issues: hierarchyData.data,
                expandedItems: expandedItems
            });
            const newIndex = issues.findIndex((i)=>String(i.issueId) === lastIssueIdSelected);
            if (newIndex >= 0) {
                setLastSelectedRowIndex(newIndex);
                setLastIssueIdSelected(undefined);
            }
        }
    // Should only update the last selected row index once
    // the expanded items are updated and the groups are finally fetched
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expandedItems,
        fetchingGroups
    ]);
    const onShiftKeyBulkSelection = (0, $eUqFw.useCallback)(({ isChecked: isChecked, rowIndex: selectedRowIndex })=>{
        let rowIndex = selectedRowIndex;
        if (lastSelectedRowIndex !== undefined && rowIndex !== undefined) {
            const lastIssueSelected = issuesMap.get([
                ...selectedIssuesStore
            ].pop() || '');
            const parentLastIssueSelected = lastIssueSelected?.parentIssueId;
            let expandedItemsToGetFlattenList = expandedItems;
            if (parentLastIssueSelected && !(0, $4oWxH.isGroupItem)(parentLastIssueSelected) && !expandedItems[parentLastIssueSelected]) {
                /*
                    Edge case
                        If the last issue selected it's a child of a collapsed task/epic
                        We should simulate the parent as expanded because we need to select the hidden children
                        */ expandedItemsToGetFlattenList = {
                    ...expandedItemsToGetFlattenList,
                    [parentLastIssueSelected]: true
                };
                rowIndex += issuesMap.get(parentLastIssueSelected)?.children?.length || 0;
            }
            const issues = expandedItems ? (0, $8COV0.getFlattenIssuesList)({
                issues: hierarchyData.data,
                expandedItems: expandedItemsToGetFlattenList
            }) : hierarchyData.data;
            let selectedIssues = [];
            if (lastSelectedRowIndex < rowIndex) selectedIssues = issues.slice(lastSelectedRowIndex, rowIndex + 1);
            else selectedIssues = issues.slice(rowIndex, !isChecked ? lastSelectedRowIndex + 1 : lastSelectedRowIndex);
            let issueIds = [];
            const isGrouping = groupByFieldId != null;
            if (isGrouping) {
                const groups = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(selectedIssues, (issue)=>(0, $4oWxH.isGroupItem)(issue.issueId));
                // select/unselect issues that are in the middle and are not groups
                issueIds = groups.false.map((issue)=>String(issue.issueId));
                // Should select and expand the groups in the middle but not the parent of the selected issue
                const pressedIssue = issues[rowIndex];
                const groupsToSelect = groups.true?.filter((group)=>group.issueId !== pressedIssue.parentIssueId) || [];
                if (groupsToSelect.length) {
                    /*
                            if there are groups in the middle of the selection we should keep
                            the last issue selected to update the row index because could change
                            depending on the groups that are going to be expanded
                        */ setLastIssueIdSelected(pressedIssue.issueId);
                    if (isChecked) selectCollapsedGroups(groupsToSelect);
                    else groupsToSelect.forEach((group)=>{
                        const groupIssues = (0, $8COV0.getAllIssueChildren)({
                            issue: group,
                            childrenItems: childrenItems
                        });
                        unselectIssues({
                            issues: groupIssues || [],
                            unselectGroup: group.issueId,
                            rowIndex: rowIndex
                        });
                    });
                }
            } else issueIds = selectedIssues.map((issue)=>String(issue.issueId));
            if (!isChecked) unselectIssues({
                issues: issueIds
            });
            else selectIssues({
                issues: issueIds
            });
        }
    }, [
        childrenItems,
        expandedItems,
        groupByFieldId,
        hierarchyData.data,
        issuesMap,
        lastSelectedRowIndex,
        selectCollapsedGroups,
        selectIssues,
        selectedIssuesStore,
        unselectIssues
    ]);
    return {
        onShiftKeyBulkSelection: onShiftKeyBulkSelection
    };
};

});

parcelRegister("hRFuG", function(module, exports) {

$parcel$export(module.exports, "BulkSelectCheckbox", () => $b471a708ec0a3ec6$export$9d26591b0d1643b6);

var $eUqFw = parcelRequire("eUqFw");

var $dFBS3 = parcelRequire("dFBS3");

var $bT7k5 = parcelRequire("bT7k5");

var $8Wt6T = parcelRequire("8Wt6T");
var $ltfxy = parcelRequire("ltfxy");

var $lkPEe = parcelRequire("lkPEe");

var $eI5EY = parcelRequire("eI5EY");

var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gbsaq = parcelRequire("gbsaq");
const $b471a708ec0a3ec6$export$9d26591b0d1643b6 = /*#__PURE__*/ (0, $eUqFw.memo)(({ id: id, onClick: onClick, isChecked: isChecked, isIndeterminate: isIndeterminate, isSelected: isSelected, wrapperRef: wrapperRef, onKeyDown: onKeyDown, isDisabled: isDisabled, hasPulse: hasPulse, label: label, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const bulkSelectId = id ?? `${0, $gbsaq.BULK_SELECT_CHECKBOX_ID}_${(0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))()}`;
    const handleOnClick = (0, $eUqFw.useCallback)((event)=>{
        if (hasPulse) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'checkbox'
        }), 'checkbox clicked', 'bulkEditChangeboardingCheckboxPulse');
        onClick({
            isChecked: event?.currentTarget?.checked,
            shiftKeyPressed: !!event?.shiftKey
        });
    }, [
        hasPulse,
        onClick,
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isSelected && wrapperRef?.current) wrapperRef.current.focus();
    }, [
        isSelected,
        wrapperRef
    ]);
    const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
        htmlFor: bulkSelectId
    }, label)), hasPulse && (0, $eI5EY.fg)('jira_list_view_bulk_edit_changeboarding') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "bulk-select-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Wt6T.Pulse), {
        radius: 3,
        testId: "business-list.common.ui.bulk-select-checkbox.spotlight-pulse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        id: bulkSelectId,
        onClick: handleOnClick,
        isChecked: isChecked,
        isDisabled: isDisabled,
        isIndeterminate: isIndeterminate,
        testId: "business-list.common.ui.bulk-select-checkbox",
        onKeyDown: onKeyDown,
        ...wrapperRef ? {
            ref: onWrapperRef
        } : {},
        ...props
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            messageId: (0, $gbsaq.BULK_EDIT_CHANGEBOARDING_MESSAGE_ID),
            componentType: 'spotlight-pulse'
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        id: bulkSelectId,
        onClick: handleOnClick,
        isChecked: isChecked,
        isDisabled: isDisabled,
        isIndeterminate: isIndeterminate,
        testId: "business-list.common.ui.bulk-select-checkbox",
        onKeyDown: onKeyDown,
        ...wrapperRef ? {
            ref: onWrapperRef
        } : {},
        ...props
    }));
});

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");


var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});



parcelRegister("4SJmy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c146a483af553973$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c146a483af553973$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectGroup: {
        "id": "business-list.list-view.group-item.select-group-checkbox.select-group",
        "defaultMessage": "Select group"
    }
});

});


parcelRegister("fOYLV", function(module, exports) {

$parcel$export(module.exports, "SprintItem", () => $99e98ba6399b9789$export$c40eb2da058b4e36);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7qb3w = parcelRequire("7qb3w");
const $99e98ba6399b9789$export$c40eb2da058b4e36 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { sprint: sprint } = data;
    let text;
    if (!sprint) text = formatMessage((0, $7qb3w.default).backlog);
    else if (sprint.state === 'CLOSED') text = formatMessage((0, $7qb3w.default).completedSprint);
    else text = sprint.name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: text,
        testId: "business-list.ui.list-view.group-item.sprint-item.simple-tag"
    });
};

});
parcelRegister("9jNAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a667cb3800fd5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");
const $02a667cb3800fd5a$var$SimpleTagComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $02a667cb3800fd5a$var$SimpleTag = /*#__PURE__*/ (0, $eUqFw.memo)($02a667cb3800fd5a$var$SimpleTagComponent);
var $02a667cb3800fd5a$export$2e2bcd8739ae039 = $02a667cb3800fd5a$var$SimpleTag;

});
parcelRegister("d9W8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $98c5a9f7a5ded4f8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");
function $98c5a9f7a5ded4f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $jFsza.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.default})`,
    cursor: 'default'
});
const $98c5a9f7a5ded4f8$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $jFsza.cssVar).color.borderColor})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$interactiveStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.active})`
    }
});
const $98c5a9f7a5ded4f8$var$interactiveStyles = {
    name: "jcdcgl",
    styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$focusRingStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $jFsza.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $98c5a9f7a5ded4f8$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: `2px solid ${$i6wnX.focusRingColors}`,
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`
    }
});
const $98c5a9f7a5ded4f8$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $i6wnX.textColors['standardLink'] : $i6wnX.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $98c5a9f7a5ded4f8$var$baseStyles : $98c5a9f7a5ded4f8$var$baseStylesOld,
            isInteractive && ((0, $XHGTv.fg)('platform-component-visual-refresh') ? $98c5a9f7a5ded4f8$var$focusRingStyles : $98c5a9f7a5ded4f8$var$focusRingStylesOld),
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? isLink && $98c5a9f7a5ded4f8$var$interactiveStyles : undefined,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $98c5a9f7a5ded4f8$var$nonStandardLinkStyles,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && isInteractive && $98c5a9f7a5ded4f8$var$interactiveStylesOld
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.borderColor]: $i6wnX.borderColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.default]: $i6wnX.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.hover]: $i6wnX.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.active]: $i6wnX.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.default]: $i6wnX.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.focusRing]: $i6wnX.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.default]: $i6wnX.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.hover]: $i6wnX.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).borderRadius]: $i6wnX.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$98c5a9f7a5ded4f8$export$2e2bcd8739ae039 = $98c5a9f7a5ded4f8$var$BaseTag;

});
parcelRegister("jFsza", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $2e837ad2e72491cc$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $2e837ad2e72491cc$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $2e837ad2e72491cc$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $2e837ad2e72491cc$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $2e837ad2e72491cc$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $2e837ad2e72491cc$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $2e837ad2e72491cc$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $2e837ad2e72491cc$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $2e837ad2e72491cc$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $2e837ad2e72491cc$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $2e837ad2e72491cc$var$gridSizeValue = (0, $lcnyw.gridSize)();
const $2e837ad2e72491cc$var$borderRadiusValue = (0, $lcnyw.borderRadius)();
const $2e837ad2e72491cc$export$b4d89c3994664204 = 2.5 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$2e837ad2e72491cc$export$b4d89c3994664204}px`})`;
const $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca = $2e837ad2e72491cc$export$b4d89c3994664204; // button should be square
const $2e837ad2e72491cc$export$aba002ef70684916 = $2e837ad2e72491cc$export$5b2b1030a679f37; // button should be square
const $2e837ad2e72491cc$export$d5949a2c2ea9dcea = 25 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$488fda99655ff65a = `${$2e837ad2e72491cc$export$d5949a2c2ea9dcea}px`;
const $2e837ad2e72491cc$export$2e3bcb01bf928995 = $2e837ad2e72491cc$export$d5949a2c2ea9dcea - $2e837ad2e72491cc$export$b4d89c3994664204;
const $2e837ad2e72491cc$export$982d4a1a6de11130 = `${$2e837ad2e72491cc$export$2e3bcb01bf928995}px`;
const $2e837ad2e72491cc$export$35d5d1e251b985cf = `${$2e837ad2e72491cc$var$borderRadiusValue}px`;
const $2e837ad2e72491cc$export$c49771100fee18c8 = `${$2e837ad2e72491cc$export$c6f3ea2b4cffd0ca / 2}px`;
const $2e837ad2e72491cc$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $2e837ad2e72491cc$var$gridSizeValue}px`})`;
const $2e837ad2e72491cc$export$b824cac86306f7a2 = $2e837ad2e72491cc$export$5b2b1030a679f37;
const $2e837ad2e72491cc$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("i6wnX", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $fc0da2a7c84ba49c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $fc0da2a7c84ba49c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $fc0da2a7c84ba49c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $fc0da2a7c84ba49c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $fc0da2a7c84ba49c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $fc0da2a7c84ba49c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $fc0da2a7c84ba49c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $fc0da2a7c84ba49c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $fc0da2a7c84ba49c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $fc0da2a7c84ba49c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 

var $jFsza = parcelRequire("jFsza");
const $fc0da2a7c84ba49c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$73a5c9d720aa66e1$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-link, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $fc0da2a7c84ba49c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$73a5c9d720aa66e1$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$73a5c9d720aa66e1$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$9fdfb749e33cdf97})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`,
    red: `var(--ds-background-accent-red-subtle, ${$73a5c9d720aa66e1$export$be802dd0d8b57f35})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$73a5c9d720aa66e1$export$5aae31392d72caaa})`,
    green: `var(--ds-background-accent-green-subtle, ${$73a5c9d720aa66e1$export$747d86715d4175de})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$73a5c9d720aa66e1$export$69cb3ca10c1e330e})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$73a5c9d720aa66e1$export$6011520a64d9a187})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$73a5c9d720aa66e1$export$b34b069eff244586})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$73a5c9d720aa66e1$export$1cc05bbbf340e559})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$73a5c9d720aa66e1$export$afbce1382ec95f73})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$73a5c9d720aa66e1$export$776c9c497ef08533})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$73a5c9d720aa66e1$export$4b0a4417ed59760f})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`
};
const $fc0da2a7c84ba49c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$73a5c9d720aa66e1$export$b34b069eff244586})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$73a5c9d720aa66e1$export$1cc05bbbf340e559})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$73a5c9d720aa66e1$export$afbce1382ec95f73})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$73a5c9d720aa66e1$export$776c9c497ef08533})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$73a5c9d720aa66e1$export$4b0a4417ed59760f})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$73a5c9d720aa66e1$export$41060a744ab0b7ae})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$73a5c9d720aa66e1$export$69a3bf21b9686c2b})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$73a5c9d720aa66e1$export$7a8f4d33f6f9772c})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$73a5c9d720aa66e1$export$363e4475840015bb})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
};
const $fc0da2a7c84ba49c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$73a5c9d720aa66e1$export$41060a744ab0b7ae})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$73a5c9d720aa66e1$export$69a3bf21b9686c2b})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$73a5c9d720aa66e1$export$7a8f4d33f6f9772c})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$73a5c9d720aa66e1$export$363e4475840015bb})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$73a5c9d720aa66e1$export$be802dd0d8b57f35})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$73a5c9d720aa66e1$export$5aae31392d72caaa})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$73a5c9d720aa66e1$export$747d86715d4175de})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$73a5c9d720aa66e1$export$69cb3ca10c1e330e})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$73a5c9d720aa66e1$export$6011520a64d9a187})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$73a5c9d720aa66e1$export$8754fc7e6d8b3000})`
};
const $fc0da2a7c84ba49c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`;
const $fc0da2a7c84ba49c$export$7a57f79000377ca2 = {
    default: (0, $jFsza.defaultBorderRadius),
    rounded: (0, $jFsza.defaultRoundedBorderRadius)
};
const $fc0da2a7c84ba49c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`;
const $fc0da2a7c84ba49c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`;
const $fc0da2a7c84ba49c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$2837b5a1a71d5c02})`;
const $fc0da2a7c84ba49c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    red: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    green: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    redLight: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    tealLight: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    limeLight: `var(--ds-text-accent-lime, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    orangeLight: `var(--ds-text-accent-orange, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greyLight: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    magenta: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    orange: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    grey: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    magentaLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    orangeLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    greyLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};

});


parcelRegister("6aZHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eddb948b5989f5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");
function $70eddb948b5989f5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $70eddb948b5989f5$var$beforeElementStyles = {
    name: "cfjv6",
    styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $70eddb948b5989f5$var$beforeElementStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $70eddb948b5989f5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $XHGTv.fg)('platform-component-visual-refresh') ? $70eddb948b5989f5$var$beforeElementStyles : $70eddb948b5989f5$var$beforeElementStylesOld
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70eddb948b5989f5$export$2e2bcd8739ae039 = $70eddb948b5989f5$var$Before;

});

parcelRegister("gz2Bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $154b7edc63fec879$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");
function $154b7edc63fec879$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $jFsza.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $154b7edc63fec879$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$linkStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $154b7edc63fec879$var$linkStyles = {
    name: "1e5oc06",
    styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
};
const $154b7edc63fec879$var$hasAfterStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.textPaddingRight)
});
const $154b7edc63fec879$var$hasAfterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$hasBeforeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $jFsza.textMarginLeft)
});
const $154b7edc63fec879$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $byn9U.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$baseStyles : $154b7edc63fec879$var$baseStylesOld,
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$linkStyles : $154b7edc63fec879$var$linkStylesOld,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStyles : undefined,
            isRemovable && !(0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$baseStyles : $154b7edc63fec879$var$baseStylesOld,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStyles : undefined,
            isRemovable && !(0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$154b7edc63fec879$export$2e2bcd8739ae039 = $154b7edc63fec879$var$Content;

});


parcelRegister("7qb3w", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b9d061e3c74ed12$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9b9d061e3c74ed12$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    completedSprint: {
        "id": "business-list.list-view.group-item.sprint-item.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    backlog: {
        "id": "business-list.list-view.group-item.sprint-item.backlog",
        "defaultMessage": "Backlog"
    }
});

});


parcelRegister("ex5gB", function(module, exports) {

$parcel$export(module.exports, "StatusItem", () => $0ef50df9ba2f2652$export$a687524c95d42e5);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $8Qd0L = parcelRequire("8Qd0L");
const $0ef50df9ba2f2652$var$appearanceMap = {
    [(0, $8Qd0L.UNDEFINED)]: 'default',
    [(0, $8Qd0L.TODO)]: 'default',
    [(0, $8Qd0L.DONE)]: 'success',
    [(0, $8Qd0L.IN_PROGRESS)]: 'inprogress'
};
const $0ef50df9ba2f2652$export$cbc76b787f60c037 = (categoryId)=>categoryId != null ? $0ef50df9ba2f2652$var$appearanceMap[(0, $8Qd0L.statusCategoryForId)(categoryId)] : $0ef50df9ba2f2652$var$appearanceMap[0, $8Qd0L.UNDEFINED];
const $0ef50df9ba2f2652$export$a687524c95d42e5 = ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: $0ef50df9ba2f2652$export$cbc76b787f60c037(data.status?.categoryId)
    }, data.status?.name);

});

parcelRegister("5m7NF", function(module, exports) {

$parcel$export(module.exports, "StoryPointsItem", () => $6a58910c9cb7dc06$export$93b96298887b28d0);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6FafE = parcelRequire("6FafE");
const $6a58910c9cb7dc06$export$93b96298887b28d0 = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        testId: "business-list.ui.list-view.group-item.storypoints-item.storypoints",
        text: typeof value === 'number' ? formatMessage((0, $6FafE.default).storyPoints, {
            points: value
        }) : formatMessage((0, $6FafE.default).noStoryPoints)
    });
};

});
parcelRegister("6FafE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3e95fc722b69aa4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d3e95fc722b69aa4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    storyPoints: {
        "id": "business-list.list-view.group-item.storypoints-item.story-points",
        "defaultMessage": "{points, plural, one {# point} other {# points}}"
    },
    noStoryPoints: {
        "id": "business-list.list-view.group-item.storypoints-item.no-story-points",
        "defaultMessage": "No points"
    }
});

});


parcelRegister("60YYZ", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $985fcedc010f80cf$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "GroupContainer", () => $985fcedc010f80cf$export$dd05ea0be7e7193a);
$parcel$export(module.exports, "CreateIssuePlusButtonWrapper", () => $985fcedc010f80cf$export$caa7a2fe02de419c);
$parcel$export(module.exports, "LoadingIcon", () => $985fcedc010f80cf$export$b936c55164dcf1db);
$parcel$export(module.exports, "LoadingRow", () => $985fcedc010f80cf$export$d1e723d3001badba);
$parcel$export(module.exports, "LoadingField", () => $985fcedc010f80cf$export$2304bbb03949f4f1);
$parcel$export(module.exports, "LoadingWrapper", () => $985fcedc010f80cf$export$43a792a870d28db2);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");
const $985fcedc010f80cf$var$ICON_SIZE = 24;
const $985fcedc010f80cf$var$wrapperStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.250'
});
const $985fcedc010f80cf$export$e6dfd72ab29f8598 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        xcss: $985fcedc010f80cf$var$wrapperStyles
    }, children);
const $985fcedc010f80cf$var$groupContainerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.500'
});
const $985fcedc010f80cf$export$dd05ea0be7e7193a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        xcss: $985fcedc010f80cf$var$groupContainerStyles
    }, children);
const $985fcedc010f80cf$export$caa7a2fe02de419c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $985fcedc010f80cf$export$b936c55164dcf1db = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsbu2gc _4t3i1tcg _bfhk1aqf _18s81l84 _2rko1sit",
            __cmplp.className
        ])
    });
});
const $985fcedc010f80cf$export$d1e723d3001badba = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});
const $985fcedc010f80cf$export$2304bbb03949f4f1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb68cl _bfhk1aqf _18s8u2gc _2rko1l7b",
            __cmplp.className
        ])
    });
});
const $985fcedc010f80cf$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4PNxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac497dc7be8ffdce$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lkPEe = parcelRequire("lkPEe");

var $RZgA1 = parcelRequire("RZgA1");

var $kbylE = parcelRequire("kbylE");

var $aYMv7 = parcelRequire("aYMv7");

var $9TEHc = parcelRequire("9TEHc");

var $gZpkQ = parcelRequire("gZpkQ");

var $8rPxE = parcelRequire("8rPxE");

var $d9gm1 = parcelRequire("d9gm1");

var $bSsl1 = parcelRequire("bSsl1");

var $eCCst = parcelRequire("eCCst");

var $75UIt = parcelRequire("75UIt");

var $91Lr1 = parcelRequire("91Lr1");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7JTqr = parcelRequire("7JTqr");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iSNkS = parcelRequire("iSNkS");

var $3007p = parcelRequire("3007p");

var $6MsoD = parcelRequire("6MsoD");

var $8rQuz = parcelRequire("8rQuz");

var $egJIx = parcelRequire("egJIx");

var $dSE3z = parcelRequire("dSE3z");

var $aqGaJ = parcelRequire("aqGaJ");

var $3Cjpz = parcelRequire("3Cjpz");

var $eXDkt = parcelRequire("eXDkt");

var $1X186 = parcelRequire("1X186");
const $ac497dc7be8ffdce$export$223875819fd7cf93 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { inviteButtonInteraction: inviteButtonInteraction, isShareButtonEnabled: isShareButtonEnabled, isPresenceEnabled: isPresenceEnabled, hasFilterCustomFields: hasFilterCustomFields, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $egJIx.useJWMListFeatures)();
    const [hideDoneItems, setHideDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    const [{ hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems }, { toggleExpandAllItems: toggleExpandAllItems, collapseAllItems: collapseAllItems }] = (0, $aYMv7.useExpandCollapseAllItems)({
        view: 'list'
    });
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const isGrouping = groupByFieldId != null;
    const { showFlatList: showFlatList } = (0, $aqGaJ.useHierarchyConfig)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { hiddenQuickFilters: hiddenQuickFilters, allowedAliasFieldId: allowedAliasFieldId } = (0, $1X186.useFilterProps)();
    const projectType = (0, $7JTqr.getWillShowNav4)() && isSoftwareFieldsEnabled ? 'software' : 'business';
    const hasFeedbackButton = projectType === 'software';
    const shareButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eCCst.JWMShareButton), {
        shareTitle: (0, $eXDkt.default).shareTitle,
        integrationType: (0, $iSNkS.integrationTypes).LIST,
        shareContentType: "list"
    });
    const handleExpandCollapseAllItems = (0, $eUqFw.useCallback)((operation)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'expandCollapseAll', {
            operation: operation
        });
        if (operation === 'collapse') collapseAllItems();
        else if (operation === 'expand') toggleExpandAllItems();
    }, [
        collapseAllItems,
        createAnalyticsEvent,
        toggleExpandAllItems
    ]);
    const searchBarLabelId = 'header-actions-search-field-label';
    const searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), {
        id: searchBarLabelId
    }, formatMessage((0, $eXDkt.default).searchLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9gm1.SimpleSearchField), {
        placeholder: (0, $eXDkt.default).simpleSearch,
        view: "list",
        describedbyId: searchBarLabelId
    }));
    const addPeopleWithPresence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bSsl1.default), {
        view: "list",
        isPresenceEnabledInContext: isPresenceEnabled,
        isOpenNewTabOnClick: inviteButtonInteraction === 'openNewTab',
        allowCustomFields: (0, $eI5EY.fg)('jira_filter-fix_filter_by_custom_fields_and_avatar') ? hasFilterCustomFields : false,
        allowedAliasFieldId: (0, $eI5EY.fg)('jira_filter-fix_filter_by_custom_fields_and_avatar') ? allowedAliasFieldId : undefined
    });
    const shareActionButton = isShareButtonEnabled && shareButton;
    const allowedFieldTypes = (0, $eUqFw.useMemo)(()=>isSoftwareFieldsEnabled ? new Set([
            ...(0, $9TEHc.BUSINESS_FIELD_TYPES),
            ...(0, $9TEHc.SOFTWARE_FIELD_TYPES)
        ]) : undefined, [
        isSoftwareFieldsEnabled
    ]);
    const filters = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3007p.FilterDropdownListNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rPxE.Filters), {
        view: "list",
        allowedFieldTypes: allowedFieldTypes,
        allowCustomFields: hasFilterCustomFields,
        allowedAliasFieldId: allowedAliasFieldId,
        hiddenQuickFilters: hiddenQuickFilters
    }));
    const groupByDropdown = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Cjpz.default), null);
    const shouldShowFormatRules = (0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation');
    const formatRulesBtn = shouldShowFormatRules ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbylE.FormatButton), null) : null;
    const shouldShowFieldStatistics = (0, $79xbN.expValEquals)('helios_list_view_experiment', 'cohort', 'variation');
    const fieldStatistics = shouldShowFieldStatistics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $75UIt.IssueFieldStatisticsButton), null) : null;
    const moreMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6MsoD.MoreDropdownListNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91Lr1.default), {
        hideDoneItems: Boolean(hideDoneItems),
        onChangeHideDoneItems: setHideDoneItems,
        onExpandCollapseAllItems: handleExpandCollapseAllItems,
        isExpandCollapseButtonEnabled: !showFlatList || isGrouping,
        hasExpandedAllItems: hasExpandedAllItems,
        hasCollapsedAllItems: hasCollapsedAllItems,
        hasFeedbackButton: hasFeedbackButton,
        projectType: projectType
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.ActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.LeftActionsWrapper), null, searchBar, addPeopleWithPresence, (0, $8rQuz.isVisualRefreshEnabled)() && filters), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.RightActionsWrapper), null, !(0, $8rQuz.isVisualRefreshEnabled)() && !(0, $eI5EY.fg)('common_project_actions_menu') && shareActionButton, !(0, $8rQuz.isVisualRefreshEnabled)() && filters, groupByDropdown, formatRulesBtn, fieldStatistics, moreMenu));
};
var $ac497dc7be8ffdce$export$2e2bcd8739ae039 = $ac497dc7be8ffdce$export$223875819fd7cf93;

});
parcelRegister("RZgA1", function(module, exports) {

$parcel$export(module.exports, "ActionsWrapper", () => $2a4eb501d360abec$export$c8223871eecc8f3a);
$parcel$export(module.exports, "LeftActionsWrapper", () => $2a4eb501d360abec$export$42cb1c7ab389bf4d);
$parcel$export(module.exports, "RightActionsWrapper", () => $2a4eb501d360abec$export$4aa2cd250ec24dcc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hSCS8 = parcelRequire("hSCS8");
const $2a4eb501d360abec$export$c8223871eecc8f3a = ({ children: children, testId: testId })=>{
    const [{ content: content }] = (0, $hSCS8.useSidebar)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a4eb501d360abec$var$ActionsWrapperStyled, {
        sidebarOpen: !!content,
        "data-testid": testId
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a4eb501d360abec$var$CenterAlignedWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$var$ActionsWrapperStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $2a4eb501d360abec$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10qff79": (0, $9t7rW.default)(`0 ${__cmplp.sidebarOpen ? 0 : "var(--ds-space-negative-300, -24px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-negative-300, -24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke1ylp _18s8l1uc _1yt46hdp _1n261g80 _bfhk1ml8 _18k9kjed",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$export$42cb1c7ab389bf4d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $2a4eb501d360abec$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$export$4aa2cd250ec24dcc = $2a4eb501d360abec$var$CenterAlignedWrapper;

});

parcelRegister("kbylE", function(module, exports) {

$parcel$export(module.exports, "FormatButton", () => $c89034b8dad3914c$export$4ce756b69a643bb2);

var $eUqFw = parcelRequire("eUqFw");

var $7qCMS = parcelRequire("7qCMS");

var $cWU73 = parcelRequire("cWU73");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $lGiWG = parcelRequire("lGiWG");

var $l3Qg0 = parcelRequire("l3Qg0");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2KzVh = parcelRequire("2KzVh");

var $dWLk9 = parcelRequire("dWLk9");

var $8rQuz = parcelRequire("8rQuz");

var $c6yNw = parcelRequire("c6yNw");

var $6yEM4 = parcelRequire("6yEM4");

var $7fw7y = parcelRequire("7fw7y");

var $8rr0M = parcelRequire("8rr0M");

var $1OzRz = parcelRequire("1OzRz");

var $dv0yP = parcelRequire("dv0yP");

var $c5tkr = parcelRequire("c5tkr");
const $c89034b8dad3914c$var$conditionalFormattingIcon = (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7qCMS))), {
    label: "",
    color: "currentColor"
}) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cWU73))), {
    label: "",
    size: "medium"
});
const $c89034b8dad3914c$export$4ce756b69a643bb2 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectData = (0, $kQAZu.useProject)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [hydrateJql] = (0, $6yEM4.useFormatRulesSerialisedJql)();
    const formatButtonRef = (0, $eUqFw.useRef)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $1OzRz.formatRulesEntryPoint), {
        projectKey: projectData.key,
        cloudId: cloudId,
        hydrateJql: hydrateJql
    });
    const buttonTriggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    const errorFallback = (0, $eUqFw.useCallback)(({ error: error })=>// TODO: show error flag
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
            experience: (0, $c6yNw.LIST_FORMAT_RULE_EXPERIENCE),
            error: error
        }), []);
    const { onClickFormatButton: onClickFormatButton, isFormatRulesSidebarOpen: isFormatRulesSidebarOpen } = (0, $7fw7y.useFormatRulesSidebar)({
        SidebarComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "jwm.business.format.rules",
                packageName: "jiraBusinessFormatRules",
                runtimeProps: props,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv0yP.SidebarFallback), null),
                errorFallback: errorFallback
            }),
        projectId: String(projectData.id),
        formatButtonRef: formatButtonRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "format-rule-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        onClick: ()=>onClickFormatButton({
                showOnboarding: false
            }),
        iconBefore: $c89034b8dad3914c$var$conditionalFormattingIcon,
        isSelected: isFormatRulesSidebarOpen,
        appearance: (0, $8rQuz.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        ref: (0, $2KzVh.mergeRefs)(buttonTriggerRef, formatButtonRef),
        testId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.themed-button"
    }, formatMessage((0, $8rr0M.default).format))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c5tkr.Onboarding), {
        ref: (0, $2KzVh.mergeRefs)(buttonTriggerRef, formatButtonRef),
        onClickFormatButton: onClickFormatButton
    }));
};

});
parcelRegister("7qCMS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4d9e1e9576ff1294affc9854efaf91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56890c78bc8df462$var$_react = $56890c78bc8df462$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $56890c78bc8df462$var$_UNSAFE_baseNew = $56890c78bc8df462$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $56890c78bc8df462$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56890c78bc8df462$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $56890c78bc8df462$var$_react.default.createElement($56890c78bc8df462$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 3.25 1.134 8.866a1.25 1.25 0 0 0 0 1.768l4.732 4.732a1.25 1.25 0 0 0 1.768 0L13.25 9.75m-6.5-6.5 6.5 6.5m-6.5-6.5L5 1.5m8.25 8.25h-12m14 4.75a.75.75 0 0 1-1.5 0c0-.414.75-1.75.75-1.75s.75 1.336.75 1.75Z"/>`
    }, props));
$56890c78bc8df462$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $56890c78bc8df462$var$_default = module.exports.default = $56890c78bc8df462$var$PaintBucketIcon;

});

parcelRegister("cWU73", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96d66da0f0a18394$var$_react = $96d66da0f0a18394$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $96d66da0f0a18394$var$_paintBucket = $96d66da0f0a18394$var$_interopRequireDefault((parcelRequire("7qCMS")));
function $96d66da0f0a18394$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $96d66da0f0a18394$var$EditorBackgroundColorIcon = (props)=>/*#__PURE__*/ $96d66da0f0a18394$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m7.818 12.56 4.243 4.243 4.242-4.242-4.242-4.243zm-1.414 1.415a1.995 1.995 0 0 1 0-2.828l4.243-4.243a1.995 1.995 0 0 1 2.828 0l4.243 4.243c.78.78.786 2.041 0 2.828l-4.243 4.243a1.996 1.996 0 0 1-2.828 0zM6.5 13h11l-5.44 5.218zm2.732-8.925a1 1 0 0 1 1.414 0l3.536 3.536-1.414 1.414L9.232 5.49a1 1 0 0 1 0-1.415M18 16s1.5 2 1.5 3.5c0 1-1 1.5-1.5 1.5s-1.5-.4-1.5-1.5C16.5 18 18 16 18 16"/></svg>`
    }, props, {
        newIcon: $96d66da0f0a18394$var$_paintBucket.default
    }));
$96d66da0f0a18394$var$EditorBackgroundColorIcon.displayName = 'EditorBackgroundColorIcon';
var $96d66da0f0a18394$var$_default = module.exports.default = $96d66da0f0a18394$var$EditorBackgroundColorIcon;

});

parcelRegister("l3Qg0", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $c6e813dbc513f02a$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $c6e813dbc513f02a$export$5f13515bd3a35325);

var $eUqFw = parcelRequire("eUqFw");

var $a9frS = parcelRequire("a9frS");
const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions))=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $a9frS.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        eventMap,
        isActive
    ]);
};
const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("a9frS", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $592b51d0c18fde03$export$15257a36a7e3f9d6);
function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("2KzVh", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $0be6a57b715845c4$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $0be6a57b715845c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0be6a57b715845c4$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $0be6a57b715845c4$export$2e2bcd8739ae039(...refs) {
    return (0, $eUqFw.useMemo)(()=>$0be6a57b715845c4$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});

parcelRegister("c6yNw", function(module, exports) {

$parcel$export(module.exports, "MAX_RULES_FETCHED", () => $22be79928393459a$export$6e645d821ccb2e78);
$parcel$export(module.exports, "DATE_VALUES", () => $22be79928393459a$export$42247ee7424a5edb);
$parcel$export(module.exports, "DATE_PICKER_OPERATORS", () => $22be79928393459a$export$5a5ebc5948b83a8a);
$parcel$export(module.exports, "PACKAGE_NAME", () => $22be79928393459a$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $22be79928393459a$export$d57b6b390e78d90f);
$parcel$export(module.exports, "CREATE_FORMAT_RULE_EXPERIENCE", () => $22be79928393459a$export$fa13d8a70748751a);
$parcel$export(module.exports, "LIST_FORMAT_RULE_EXPERIENCE", () => $22be79928393459a$export$a81756a20f687e60);
$parcel$export(module.exports, "DELETE_FORMAT_RULE_EXPERIENCE", () => $22be79928393459a$export$aec4d62b875e16db);
$parcel$export(module.exports, "UPDATE_FORMAT_RULE_EXPERIENCE", () => $22be79928393459a$export$3f6ab32e23b3d013);
$parcel$export(module.exports, "SORT_FORMAT_RULE_EXPERIENCE", () => $22be79928393459a$export$2f9cc81b0092d33b);
$parcel$export(module.exports, "HELP_ARTICLE", () => $22be79928393459a$export$5b1d06b602bd68c5);

var $gr01C = parcelRequire("gr01C");
const $22be79928393459a$export$6e645d821ccb2e78 = 20;
const $22be79928393459a$export$42247ee7424a5edb = (0, $gr01C.DATE_VALUE_OPERATORS);
const $22be79928393459a$export$5a5ebc5948b83a8a = [
    (0, $gr01C.DATE_VALUE_OPERATORS).EXACT_DATE
];
const $22be79928393459a$export$b8b9d90f9e5bd72b = 'jiraBusinessFormatRule';
const $22be79928393459a$export$d57b6b390e78d90f = 'keystone';
const $22be79928393459a$export$fa13d8a70748751a = {
    experience: 'createFormatRule',
    packageName: $22be79928393459a$export$b8b9d90f9e5bd72b,
    teamName: $22be79928393459a$export$d57b6b390e78d90f
};
const $22be79928393459a$export$a81756a20f687e60 = {
    experience: 'listFormatRule',
    packageName: $22be79928393459a$export$b8b9d90f9e5bd72b,
    teamName: $22be79928393459a$export$d57b6b390e78d90f
};
const $22be79928393459a$export$aec4d62b875e16db = {
    experience: 'deleteFormatRule',
    packageName: $22be79928393459a$export$b8b9d90f9e5bd72b,
    teamName: $22be79928393459a$export$d57b6b390e78d90f
};
const $22be79928393459a$export$3f6ab32e23b3d013 = {
    experience: 'updateFormatRule',
    packageName: $22be79928393459a$export$b8b9d90f9e5bd72b,
    teamName: $22be79928393459a$export$d57b6b390e78d90f
};
const $22be79928393459a$export$2f9cc81b0092d33b = {
    experience: 'sortFormatRule',
    packageName: $22be79928393459a$export$b8b9d90f9e5bd72b,
    teamName: $22be79928393459a$export$d57b6b390e78d90f
};
const $22be79928393459a$export$5b1d06b602bd68c5 = {
    helpArticleId: '7afzXgtL4UauMCJZ3IxTTH',
    href: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-format-rules/'
};

});
parcelRegister("gr01C", function(module, exports) {

$parcel$export(module.exports, "DATE_VALUE_OPERATORS", () => $35295b5ec8bb573b$export$6a2fdc772d1c71fb);
const $35295b5ec8bb573b$export$6a2fdc772d1c71fb = {
    EXACT_DATE: 'EXACT_DATE',
    TODAY: 'TODAY',
    TOMORROW: 'TOMORROW',
    YESTERDAY: 'YESTERDAY',
    THIS_WEEK: 'THIS_WEEK',
    LAST_WEEK: 'LAST_WEEK',
    NEXT_WEEK: 'NEXT_WEEK',
    THIS_QUARTER: 'THIS_QUARTER',
    LAST_QUARTER: 'LAST_QUARTER',
    NEXT_QUARTER: 'NEXT_QUARTER',
    THIS_YEAR: 'THIS_YEAR',
    LAST_YEAR: 'LAST_YEAR',
    NEXT_YEAR: 'NEXT_YEAR'
};

});


parcelRegister("7fw7y", function(module, exports) {

$parcel$export(module.exports, "useFormatRulesSidebar", () => $271101c7e3b4af16$export$5bcab55a2e93dc2d);

var $eUqFw = parcelRequire("eUqFw");

var $hSCS8 = parcelRequire("hSCS8");

var $jGcn0 = parcelRequire("jGcn0");

var $4G5xU = parcelRequire("4G5xU");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $c6yNw = parcelRequire("c6yNw");
const $271101c7e3b4af16$var$FORMAT_SIDEBAR_SIDEBAR_CONTENT_KEY = 'formatRulesSidebar';
const $271101c7e3b4af16$export$5bcab55a2e93dc2d = ({ projectId: projectId, SidebarComponent: SidebarComponent, formatButtonRef: formatButtonRef })=>{
    const [, setSelectedIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isFormatRulesSidebarOpen = (0, $eUqFw.useMemo)(()=>content?.key === $271101c7e3b4af16$var$FORMAT_SIDEBAR_SIDEBAR_CONTENT_KEY, [
        content
    ]);
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $c6yNw.LIST_FORMAT_RULE_EXPERIENCE));
    const onCloseSidebar = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'formatRulesCloseButton');
        setSidebarContent(null);
        formatButtonRef?.current?.focus();
    }, [
        createAnalyticsEvent,
        formatButtonRef,
        setSidebarContent
    ]);
    const onClickFormatButton = (0, $eUqFw.useCallback)(({ showOnboarding: showOnboarding })=>{
        if (isFormatRulesSidebarOpen) onCloseSidebar();
        else {
            setSelectedIssueKey(undefined);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'formatRulesSidebarButton');
            startExperience();
            setSidebarContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SidebarComponent, {
                key: $271101c7e3b4af16$var$FORMAT_SIDEBAR_SIDEBAR_CONTENT_KEY,
                onCloseSidebar: onCloseSidebar,
                projectId: projectId,
                showOnboarding: showOnboarding
            }));
        }
    }, [
        isFormatRulesSidebarOpen,
        onCloseSidebar,
        setSelectedIssueKey,
        createAnalyticsEvent,
        startExperience,
        setSidebarContent,
        SidebarComponent,
        projectId
    ]);
    return {
        onClickFormatButton: onClickFormatButton,
        isFormatRulesSidebarOpen: isFormatRulesSidebarOpen
    };
};

});

parcelRegister("8rr0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $5198d5ba8760e53f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5198d5ba8760e53f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    format: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.format",
        "defaultMessage": "Format"
    }
});

});

parcelRegister("1OzRz", function(module, exports) {

$parcel$export(module.exports, "formatRulesEntryPoint", () => $e60822ef6dc415b4$export$a812fb5060f92ae9);

var $fZA2g = parcelRequire("fZA2g");

var $bdBW2 = parcelRequire("bdBW2");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $e60822ef6dc415b4$export$a812fb5060f92ae9 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("kC0DQ")), {
        moduleId: "b6770cbd"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, hydrateJql: hydrateJql })=>({
            queries: {
                listViewFormattingRulesQuery: {
                    parameters: (0, $bdBW2.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: 20
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'store-or-network'
                    }
                },
                listViewFormattingRulesHydrateJqlQuery: {
                    parameters: (0, $fZA2g.default),
                    variables: {
                        cloudId: cloudId,
                        jql: hydrateJql
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("fZA2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa0d8277404e78a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8a6fbcb9c17bb4a1cb0d00d86921a5a>>
 * @relayHash 2cbac86c16686b5daea6a9f231fdf6b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0d0fb7c32d0c87191a5fee40c8f0c985952a7a8a909631e11a5751171decf376
const $fa0d8277404e78a6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        }
    ], v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "list_hydrateJql_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v3 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "hydrateJqlQuery",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "fieldValueData_businessConditionalFormattingSidebar"
                                                        }
                                                    ],
                                                    "type": "JiraJqlHydratedQuery"
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jqlBuilder.hydrateJqlQuery"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "list_hydrateJql_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraJqlField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "accountId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "priorityId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlPriorityFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "sprint",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "sprintId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlSprintFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroup",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "group",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlGroupFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "projectId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlProjectFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueTypeId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0d0fb7c32d0c87191a5fee40c8f0c985952a7a8a909631e11a5751171decf376",
            "metadata": {},
            "name": "list_hydrateJql_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fa0d8277404e78a6$var$node.hash = "29ea070df4a573820b0818573b62d704";
var $fa0d8277404e78a6$export$2e2bcd8739ae039 = $fa0d8277404e78a6$var$node;

});

parcelRegister("bdBW2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d92cee3ddb7464$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f83698e03e27f727ef1e2fe7252fc51>>
 * @relayHash 0c433cda5f667bcf4a540416173db6d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a2dff011be60f61ee521340c2f88a86124a936945911e4b5bfb138137a0954e0
const $d1d92cee3ddb7464$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "list_RuleList_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraFormattingRuleConnection",
                                            "kind": "LinkedField",
                                            "name": "conditionalFormattingRules",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRuleEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRule",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "expression",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v7 /*: any*/ ,
                                                                            "type": "JiraFormattingMultipleValueOperand"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v7 /*: any*/ ,
                                                                            "type": "JiraFormattingSingleValueOperand"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v7 /*: any*/ ,
                                                                            "type": "JiraFormattingNoValueOperand"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "ruleItem_businessConditionalFormattingSidebar"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "list_RuleList_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "expression",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "alias": "multipleValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "values"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingMultipleValueOperand"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "alias": "singleValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingSingleValueOperand"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "alias": "noValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingNoValueOperand"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "formattingArea"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a2dff011be60f61ee521340c2f88a86124a936945911e4b5bfb138137a0954e0",
            "metadata": {},
            "name": "list_RuleList_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d1d92cee3ddb7464$var$node.hash = "bec8fc4cc19c330e28e463dc69485d6f";
var $d1d92cee3ddb7464$export$2e2bcd8739ae039 = $d1d92cee3ddb7464$var$node;

});

parcelRegister("kC0DQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bBkkx")
]).then(()=>parcelRequire('2LXSd'));

});


parcelRegister("dv0yP", function(module, exports) {

$parcel$export(module.exports, "ListFallback", () => $6e494721ce710c1e$export$a207fef8aae38be9);
$parcel$export(module.exports, "SidebarFallback", () => $6e494721ce710c1e$export$289c886cdbc6d1e3);

var $eUqFw = parcelRequire("eUqFw");

var $aVkzK = parcelRequire("aVkzK");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $6e494721ce710c1e$export$a207fef8aae38be9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasIcon: true,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        isShimmering: true,
        width: "120px"
    }));
const $6e494721ce710c1e$export$289c886cdbc6d1e3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6e494721ce710c1e$var$containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        isShimmering: true,
        width: "120px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        isShimmering: true,
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e494721ce710c1e$export$a207fef8aae38be9, null)));
const $6e494721ce710c1e$var$containerStyle = (0, $1ZAYh.xcss)({
    padding: 'space.250'
});

});

parcelRegister("c5tkr", function(module, exports) {

$parcel$export(module.exports, "Onboarding", () => $fed0340cc01a5c48$export$70238cd3868b67c9);
$parcel$export(module.exports, "SidebarOnboarding", () => $fed0340cc01a5c48$export$d4bff02b549bd7de);

var $eUqFw = parcelRequire("eUqFw");

var $jZ5HC = parcelRequire("jZ5HC");

var $7zpSo = parcelRequire("7zpSo");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $5ge6s = parcelRequire("5ge6s");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ap7vt = parcelRequire("ap7vt");

var $dWLk9 = parcelRequire("dWLk9");
var $3e9vj = parcelRequire("3e9vj");

var $h64Jx = parcelRequire("h64Jx");

var $jjGhq = parcelRequire("jjGhq");
const $fed0340cc01a5c48$export$53e766134521dfd3 = 'STG-EXT-1441';
const $fed0340cc01a5c48$export$5cbe8adda16e7b01 = 'jira-list-view-format-rules-onboarding';
const $fed0340cc01a5c48$var$ENV_STAGING = 'staging';
const $fed0340cc01a5c48$var$STARGATE_URL = '/gateway/api';
const $fed0340cc01a5c48$export$70238cd3868b67c9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClickFormatButton: onClickFormatButton }, ref)=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $3e9vj.useEnvironment)() === $fed0340cc01a5c48$var$ENV_STAGING ? $fed0340cc01a5c48$export$53e766134521dfd3 : $fed0340cc01a5c48$export$5cbe8adda16e7b01;
    const cloudId = (0, $dWLk9.useCloudId)();
    /**
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the FORMATTING_RULES_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $eUqFw.useMemo)(()=>new (0, $5ge6s.CoordinationClient)(cloudId, $fed0340cc01a5c48$var$STARGATE_URL), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $jZ5HC.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eUqFw.useState)(true);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (isEnrolled) stopEnrolment(false);
    }, [
        isEnrolled,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, isEnrolled && isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ap7vt.JiraSpotlight), {
        messageId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.sidebar.onboarding.jira-spotlight.format-rule-button",
        messageType: "engagement",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($h64Jx))),
        actionsBeforeElement: "1/3",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    onClickFormatButton({
                        showOnboarding: true
                    });
                },
                text: formatMessage((0, $jjGhq.default).next)
            },
            {
                appearance: 'subtle',
                onClick: ()=>setIsSpotlightActive(false),
                text: formatMessage((0, $jjGhq.default).dismiss)
            }
        ],
        dialogWidth: 320,
        heading: formatMessage((0, $jjGhq.default).onboardingHeading),
        target: "format-rule-button",
        key: "format-rule-button",
        targetRadius: 3,
        footer: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                ref: ref,
                alignItems: "center",
                justifyContent: "space-between",
                xcss: $fed0340cc01a5c48$var$footerContainerStyle
            }, children)
    }, formatMessage((0, $jjGhq.default).onboardingDescription)));
});
const $fed0340cc01a5c48$export$d4bff02b549bd7de = ({ showOnboarding: showOnboarding })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [activeSpotlight, setActiveSpotlight] = (0, $eUqFw.useState)(null);
    const next = ()=>setActiveSpotlight((activeSpotlight || 0) + 1);
    const end = ()=>setActiveSpotlight(null);
    (0, $eUqFw.useEffect)(()=>{
        if (showOnboarding) setTimeout(()=>{
            setActiveSpotlight(0);
        }, 100);
    }, [
        showOnboarding
    ]);
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ap7vt.JiraSpotlight), {
                messageId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.sidebar.onboarding.jira-spotlight.create-rule-form",
                messageType: "engagement",
                actionsBeforeElement: "2/3",
                actions: [
                    {
                        onClick: next,
                        text: 'Next'
                    },
                    {
                        appearance: 'subtle',
                        onClick: end,
                        text: formatMessage((0, $jjGhq.default).dismiss)
                    }
                ],
                dialogWidth: 280,
                target: "create-rule-form",
                key: "create-rule-form",
                targetRadius: 3
            }, formatMessage((0, $jjGhq.default).createRuleOnboarding)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ap7vt.JiraSpotlight), {
                messageId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.sidebar.onboarding.jira-spotlight.drag-rule-form",
                messageType: "engagement",
                actionsBeforeElement: "3/3",
                actions: [
                    {
                        onClick: end,
                        text: formatMessage((0, $jjGhq.default).done)
                    }
                ],
                dialogWidth: 280,
                target: "drag-rule-form",
                key: "drag-rule-form",
                targetRadius: 3
            }, formatMessage((0, $jjGhq.default).rulesOrderOnboarding))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, renderActiveSpotlight());
};
const $fed0340cc01a5c48$var$footerContainerStyle = (0, $1ZAYh.xcss)({
    paddingTop: 'space.050'
});

});
parcelRegister("jZ5HC", function(module, exports) {

$parcel$export(module.exports, "useCoordination", () => $4ed66b44f8644add$export$3c29cca421979b0e);

var $eUqFw = parcelRequire("eUqFw");
const $4ed66b44f8644add$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    };
    return [
        started,
        stop
    ];
};

});

parcelRegister("ap7vt", function(module, exports) {

$parcel$export(module.exports, "JiraSpotlight", () => $9dba2f07cab8d82f$export$e209c6be9ab8c4f4);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $jGBLd = parcelRequire("jGBLd");

var $eI5EY = parcelRequire("eI5EY");

var $i6lq0 = parcelRequire("i6lq0");
const $9dba2f07cab8d82f$export$e209c6be9ab8c4f4 = (props)=>{
    if ((0, $jGBLd.shouldBeChoreographed)(props) && (0, $eI5EY.fg)('spotlight_conversion_to_choreographer_spotlight')) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6lq0.ChoreographerSpotlight), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), rest);
};

});
parcelRegister("i6lq0", function(module, exports) {

$parcel$export(module.exports, "ChoreographerSpotlight", () => $b80fd2570c4b1abe$export$e01943d134357d00);
// eslint-disable-next-line jira/import/no-restricted-import

var $hJJD2 = parcelRequire("hJJD2");

var $kytz8 = parcelRequire("kytz8");
const $b80fd2570c4b1abe$export$e01943d134357d00 = (0, $kytz8.withChoreographedRender)((0, $hJJD2.default));

});
parcelRegister("kytz8", function(module, exports) {

$parcel$export(module.exports, "withChoreographedRender", () => $d60c6f7c92c4fa11$export$c1160fdac17030e);

var $eUqFw = parcelRequire("eUqFw");

var $6uNFR = parcelRequire("6uNFR");
function $d60c6f7c92c4fa11$export$c1160fdac17030e(Component, options) {
    function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
        const shouldRender = (0, $6uNFR.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props);
        if (options && options.toggleableProp) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const toggleableComponentProps = {
                ...props,
                [options.toggleableProp]: false
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, toggleableComponentProps);
        }
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    return ChoreographedComponent;
}

});



parcelRegister("h64Jx", function(module, exports) {
module.exports = new URL("onboarding.d274e357.svg", import.meta.url).toString();

});

parcelRegister("jjGhq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b20411f1943feeb8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b20411f1943feeb8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    onboardingHeading: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading",
        "defaultMessage": "Highlight important work with color"
    },
    onboardingDescription: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description",
        "defaultMessage": "Create a format rule to quickly view work that needs attention. Only you\u2019ll be able to view the rules you create or edit."
    },
    next: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.next",
        "defaultMessage": "Next"
    },
    createRuleOnboarding: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.create-rule-onboarding",
        "defaultMessage": "For example, you could create a rule that formats rows red when the due date is before today."
    },
    rulesOrderOnboarding: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding",
        "defaultMessage": "If you have multiple rules that apply to the same cell, the rule at the top takes precedence. Drag rules up or down to reorder them."
    },
    done: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.done",
        "defaultMessage": "Done"
    },
    dismiss: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});



parcelRegister("8rPxE", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $4a948cec7cd2ee06$export$92a576f896a9bf72);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jK1pm = parcelRequire("jK1pm");

var $jpXBE = parcelRequire("jpXBE");

var $fvzkg = parcelRequire("fvzkg");

var $jWIW7 = parcelRequire("jWIW7");

var $9GlEj = parcelRequire("9GlEj");

var $27zPy = parcelRequire("27zPy");

var $6M6Pf = parcelRequire("6M6Pf");
const $4a948cec7cd2ee06$var$hiddenQuickFiltersDefault = [
    'ACTIVE_SPRINTS'
];
const $4a948cec7cd2ee06$export$92a576f896a9bf72 = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, allowedFieldTypes: inputAllowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, hiddenQuickFilters: hiddenQuickFilters = $4a948cec7cd2ee06$var$hiddenQuickFiltersDefault, allowCustomFields: allowCustomFields, allowSavedFilters: allowSavedFilters = true, handleHasFiltersApplied: handleHasFiltersApplied, appearance: appearance })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const allowedFieldTypes = (0, $jWIW7.useAllowedFieldTypes)(inputAllowedFieldTypes);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const close = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const toggle = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'jwmFilterButton clicked');
    }, [
        createAnalyticsEvent
    ]);
    const { quickFilters: quickFilters, persistQuickFilters: setQuickFilters } = (0, $9GlEj.useQuickFilters)();
    const { filters: filters, fieldConfig: fieldConfig, customFieldsLoader: customFieldsLoader, hasFilterError: hasFilterError, setFilters: setFilters } = (0, $fvzkg.useDeserialiseJqlFiltersWithContext)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const count = Object.values(filters).flat().length + Object.values(quickFilters).filter((value)=>value).length;
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('timeline-collapse-expand-all_61d00') && handleHasFiltersApplied) handleHasFiltersApplied(count);
    }, [
        count,
        handleHasFiltersApplied
    ]);
    if ((0, $eI5EY.fg)('native_goals_integration_on_list_view')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jpXBE.useGoalsFilterAnalyticsEvent)({
        filters: filters,
        view: view
    });
    const hasFiltersApplied = count > 0 || hasFilterError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27zPy.MenuContent), {
                "data-testid": "business-filters.ui.filters.menu-content",
                count: count,
                fieldConfig: fieldConfig,
                filters: filters,
                quickFilters: quickFilters,
                setQuickFilters: setQuickFilters,
                setFilters: setFilters,
                hiddenQuickFilters: hiddenQuickFilters,
                view: view,
                allowCustomFields: allowCustomFields,
                allowSavedFilters: allowSavedFilters,
                hasFilterError: hasFilterError
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M6Pf.Trigger), {
                ...triggerProps,
                ...(0, $eI5EY.fg)('jira-calendar-business-theme') && {
                    appearance: appearance
                },
                count: count,
                hasFiltersApplied: hasFiltersApplied,
                isSelected: isOpen,
                onClick: toggle
            }),
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    }), customFieldsLoader));
});

});
parcelRegister("jpXBE", function(module, exports) {

$parcel$export(module.exports, "useGoalsFilterAnalyticsEvent", () => $bf0eb06c2610c94c$export$c9b2aef46b42c898);

var $eUqFw = parcelRequire("eUqFw");

var $hLW3I = parcelRequire("hLW3I");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $bf0eb06c2610c94c$export$c9b2aef46b42c898 = ({ filters: filters, view: view })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: filterFields } = (0, $hLW3I.useFilterFields)();
    const goalField = (0, $eUqFw.useMemo)(()=>filterFields.find((field)=>field.type === (0, $lO4Or.GOALS_CF_TYPE)), [
        filterFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (goalField && filters[goalField.id]) {
            const goalsFilter = filters[goalField.id];
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'goalsFilter applied', {
                source: view,
                goalsCount: Array.isArray(goalsFilter) ? goalsFilter.length : 0
            });
        }
    }, [
        createAnalyticsEvent,
        filters,
        goalField,
        view
    ]);
};

});
parcelRegister("hLW3I", function(module, exports) {

$parcel$export(module.exports, "useFilterFields", () => $b966faf4b3b8c8a2$export$b2d30fa5478b571a);

var $eUqFw = parcelRequire("eUqFw");

var $kMmsu = parcelRequire("kMmsu");
const $b966faf4b3b8c8a2$export$b2d30fa5478b571a = ()=>{
    const { data: fields, loading: loading } = (0, $kMmsu.useFieldsResource)();
    const data = (0, $eUqFw.useMemo)(()=>fields?.map((field)=>({
                id: field.jqlTerm,
                name: field.displayName,
                type: field.type
            })) ?? [], [
        fields
    ]);
    return {
        data: data,
        loading: loading,
        error: undefined
    };
};

});


parcelRegister("fvzkg", function(module, exports) {

$parcel$export(module.exports, "DeserialisedFiltersProvider", () => $df8b3ad8c9e75684$export$c5640c1fbeb250b6);
$parcel$export(module.exports, "useDeserialisedFilters", () => $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7);
$parcel$export(module.exports, "useDeserialiseJqlFilters", () => $df8b3ad8c9e75684$export$eaa578dc219a620a);
$parcel$export(module.exports, "useDeserialiseJqlFiltersWithContext", () => $df8b3ad8c9e75684$export$87f52da20e747485);

var $eUqFw = parcelRequire("eUqFw");

var $jhNgz = parcelRequire("jhNgz");

var $hLW3I = parcelRequire("hLW3I");

var $gZpkQ = parcelRequire("gZpkQ");

var $lEWmB = parcelRequire("lEWmB");

var $9GlEj = parcelRequire("9GlEj");

var $coMWQ = parcelRequire("coMWQ");
const $df8b3ad8c9e75684$var$DEFAULT_VALUE = {
    filters: {}
};
/* Context used by the board view until the filters get implemented in the backend */ const $df8b3ad8c9e75684$var$DeserialisedFiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($df8b3ad8c9e75684$var$DEFAULT_VALUE);
const $df8b3ad8c9e75684$export$c5640c1fbeb250b6 = ({ children: children })=>{
    const [filters, setFilters] = (0, $eUqFw.useState)({});
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(true);
    const value = (0, $eUqFw.useMemo)(()=>({
            filters: filters,
            setFilters: setFilters,
            isLoading: isLoading,
            setIsLoading: setIsLoading
        }), [
        filters,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df8b3ad8c9e75684$var$DeserialisedFiltersContext.Provider, {
        value: value
    }, children);
};
const $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7 = ()=>(0, $eUqFw.useContext)($df8b3ad8c9e75684$var$DeserialisedFiltersContext);
const $df8b3ad8c9e75684$var$EMPTY_FILTER = {};
const $df8b3ad8c9e75684$export$eaa578dc219a620a = ({ view: view, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, allowCustomFields: allowCustomFields })=>{
    const { jql: jql, setFilter: setFilter } = (0, $lEWmB.useFilters)();
    const { fieldConfig: fieldConfig, resolvers: resolvers, customFieldsLoader: customFieldsLoader, loading: isLoadingFieldConfig } = (0, $jhNgz.useFieldConfigWithCustomFields)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const [filters, setFilters] = (0, $eUqFw.useState)({});
    const [error, setError] = (0, $eUqFw.useState)(null);
    const hasFilterError = error != null;
    const [isDeserialisingFilters, setIsDeserialisingFilters] = (0, $eUqFw.useState)(false);
    const [filtersCache, setFiltersCache] = (0, $eUqFw.useState)({});
    const { data: filterFields, loading: isLoadingFilterFields } = (0, $hLW3I.useFilterFields)();
    const { quickFiltersJql: quickFiltersJql } = (0, $9GlEj.useQuickFilters)();
    (0, $eUqFw.useEffect)(()=>{
        // Skip if loading
        if (isDeserialisingFilters || isLoadingFieldConfig || isLoadingFilterFields) return;
        // Skip if no fields supported
        if (!Object.keys(fieldConfig).length) return;
        // Skip if deserialised this jql before
        if (jql != null && filters === filtersCache[jql]) return;
        // Skip if has error and jql not empty
        if (hasFilterError && jql != null) return;
        if (jql == null) {
            if (hasFilterError) setError(null);
            if (filters !== $df8b3ad8c9e75684$var$EMPTY_FILTER) setFilters($df8b3ad8c9e75684$var$EMPTY_FILTER);
            return;
        }
        if (quickFiltersJql !== null) {
            setFilters($df8b3ad8c9e75684$var$EMPTY_FILTER);
            return;
        }
        if (filtersCache[jql]) {
            setFilters(filtersCache[jql]);
            return;
        }
        setIsDeserialisingFilters(true);
        (0, $coMWQ.deserialiseJql)(jql, fieldConfig, filterFields, resolvers).then((result)=>{
            setFilters(result);
            setFiltersCache({
                ...filtersCache,
                [jql]: result
            });
        }).catch((e)=>{
            setError(e);
        }).finally(()=>{
            setIsDeserialisingFilters(false);
        });
    }, [
        hasFilterError,
        quickFiltersJql,
        error,
        filters,
        isLoadingFieldConfig,
        isLoadingFilterFields,
        fieldConfig,
        jql,
        filtersCache,
        filterFields,
        resolvers,
        isDeserialisingFilters
    ]);
    (0, $gZpkQ.useInferHideDoneItemsWithFilters)({
        filters: filters
    });
    return {
        fieldConfig: fieldConfig,
        filters: filters,
        hasFilterError: hasFilterError,
        customFieldsLoader: customFieldsLoader,
        setFilters: setFilter,
        loading: isLoadingFieldConfig || isDeserialisingFilters
    };
};
const $df8b3ad8c9e75684$export$87f52da20e747485 = (props)=>{
    const { fieldConfig: fieldConfig, filters: filters, hasFilterError: hasFilterError, customFieldsLoader: customFieldsLoader, setFilters: setFilters, loading: loading } = $df8b3ad8c9e75684$export$eaa578dc219a620a(props);
    const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7();
    (0, $eUqFw.useEffect)(()=>{
        if (setContextFilters) setContextFilters(filters);
    }, [
        filters,
        setContextFilters
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (setIsLoadingFilters) setIsLoadingFilters(loading);
    }, [
        loading,
        setIsLoadingFilters
    ]);
    return {
        fieldConfig: fieldConfig,
        filters: filters,
        hasFilterError: hasFilterError,
        customFieldsLoader: customFieldsLoader,
        setFilters: setFilters
    };
};

});
parcelRegister("jhNgz", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigWithCustomFields", () => $d017338cf4a59425$export$9f6dc7e3584916fa);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $ejYlo = parcelRequire("ejYlo");

var $bPRqC = parcelRequire("bPRqC");

var $aWjLM = parcelRequire("aWjLM");
const $d017338cf4a59425$var$emptySet = new Set();
const $d017338cf4a59425$var$CustomFieldsLoader = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, setFieldConfig: setFieldConfig })=>{
    const { fieldConfig: fieldConfig, resolvers: resolvers, loading: loading } = (0, $bPRqC.useFieldConfig)({
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId
    });
    (0, $eUqFw.useEffect)(()=>{
        setFieldConfig({
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loading
        });
    }, [
        fieldConfig,
        resolvers,
        loading,
        setFieldConfig
    ]);
    return null;
};
const $d017338cf4a59425$export$9f6dc7e3584916fa = ({ view: view, allowCustomFields: allowCustomFields, allowedAliasFieldId: allowedAliasFieldId, allowedFieldTypes: allowedFieldTypes })=>{
    const [newAllowedFieldTypes, oldAllowedFieldTypes] = (0, $eUqFw.useMemo)(()=>{
        // split allowedFieldTypes into new and old input for useFieldConfigV2 and useFieldConfigOld
        const newTypes = new Set(allowedFieldTypes);
        const oldTypes = new Set();
        (0, $9TEHc.EXTRA_CUSTOM_FIELD_TYPES).forEach((type)=>{
            if (allowedFieldTypes.has(type)) {
                newTypes.delete(type);
                oldTypes.add(type);
            }
        });
        return [
            newTypes,
            oldTypes
        ];
    }, [
        allowedFieldTypes
    ]);
    const hasCustomFields = Boolean(allowCustomFields) && oldAllowedFieldTypes.size > 0;
    const hasAliasFields = allowedAliasFieldId != null && allowedAliasFieldId.size > 0;
    const shouldLoadOldFieldConfig = hasAliasFields || hasCustomFields;
    const { fieldConfig: fieldConfigNew, resolvers: resolversNew, loading: isLoadingFieldConfigNew } = (0, $aWjLM.useFieldConfigV2)({
        view: view,
        allowedFieldTypes: newAllowedFieldTypes
    });
    const [{ fieldConfig: fieldConfigOld, loading: isLoadingFieldConfigOld, resolvers: resolversOld }, setFieldConfig] = (0, $eUqFw.useState)({
        fieldConfig: {},
        resolvers: {},
        loading: shouldLoadOldFieldConfig
    });
    const customFieldsLoader = (0, $eUqFw.useMemo)(()=>{
        if (!shouldLoadOldFieldConfig) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d017338cf4a59425$var$CustomFieldsLoader, {
            allowedFieldTypes: allowCustomFields ? oldAllowedFieldTypes : $d017338cf4a59425$var$emptySet,
            allowedAliasFieldId: allowedAliasFieldId,
            setFieldConfig: setFieldConfig
        });
    }, [
        allowCustomFields,
        allowedAliasFieldId,
        oldAllowedFieldTypes,
        shouldLoadOldFieldConfig
    ]);
    const { fetchUsers: fetchUsers } = (0, $ejYlo.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes
    });
    const fieldConfig = (0, $eUqFw.useMemo)(()=>{
        const aliasFields = {};
        const otherFields = {};
        Object.keys(fieldConfigOld).forEach((id)=>{
            if (fieldConfigOld[id].systemType === (0, $lO4Or.PEOPLE_CF_TYPE) || fieldConfigOld[id].systemType === (0, $lO4Or.USER_CF_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fieldConfigOld[id] = {
                ...fieldConfigOld[id],
                loadOptions: fetchUsers
            };
            // We want to assure that alias fields are always at the end of the filter
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (fieldConfigOld[id].aliasFieldId != null) aliasFields[id] = fieldConfigOld[id];
            else otherFields[id] = fieldConfigOld[id];
        });
        return {
            ...otherFields,
            ...fieldConfigNew,
            ...aliasFields
        };
    }, [
        fieldConfigOld,
        fieldConfigNew,
        fetchUsers
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: {
            ...resolversOld,
            ...resolversNew
        },
        customFieldsLoader: customFieldsLoader,
        loading: isLoadingFieldConfigNew || isLoadingFieldConfigOld
    };
};

});
parcelRegister("ejYlo", function(module, exports) {

$parcel$export(module.exports, "useFetchFieldValues", () => $a250a9d5a7d089ab$export$6cb851ed13e3949e);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $lO4Or = parcelRequire("lO4Or");

var $lB25E = parcelRequire("lB25E");

var $dWLk9 = parcelRequire("dWLk9");

var $kIODn = parcelRequire("kIODn");

var $4Zgod = parcelRequire("4Zgod");

var $gF4D9 = parcelRequire("gF4D9");

var $5IIOI = parcelRequire("5IIOI");


var $bRzz9 = parcelRequire("bRzz9");
const $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows of the priority filter
const $a250a9d5a7d089ab$var$MAX_INITIAL_NUMBER_OF_OPTIONS = 50; // Increased initial number of options fetched
const $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL = '(sprint in openSprints() OR sprint in futureSprints())';
// TODO: remove shouldFetchSprints and keep shouldFetchSoftwareFields after clean up  jsw_list_view_-_all_the_fields
const $a250a9d5a7d089ab$var$fetchInitialDataInternal = async (cloudId, jqlContext, jqlURLParam, allowedFieldTypes, goalsJqlTerm)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMInitialFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $8d92abf0af87bfd8$export$a48313dd44fc9855),
                variables: {
                    cloudId: cloudId,
                    first: $a250a9d5a7d089ab$var$MAX_INITIAL_NUMBER_OF_OPTIONS,
                    jql: jqlContext,
                    shouldFetchSprints: Boolean(allowedFieldTypes?.has((0, $lO4Or.SPRINT_TYPE))),
                    shouldFetchSoftwareFields: Boolean((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && allowedFieldTypes?.has((0, $lO4Or.FIX_VERSIONS_TYPE))),
                    shouldFetchParentField: Boolean((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')),
                    shouldFetchGoalsField: Boolean(allowedFieldTypes?.has((0, $lO4Or.GOALS_CF_TYPE)) && !!goalsJqlTerm && (0, $eI5EY.fg)('native_goals_integration_on_list_view')),
                    goalsJqlTerm: goalsJqlTerm && (0, $eI5EY.fg)('native_goals_integration_on_list_view') ? goalsJqlTerm : '',
                    sprintsJqlContext: allowedFieldTypes?.has((0, $lO4Or.SPRINT_TYPE)) ? `${jqlContext} AND ${$a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL}` : undefined
                }
            })
        });
        if (response.data?.jira?.jqlBuilder == null && response.data?.jwmCategoryOptions == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        const hydratedValues = jqlURLParam ? await (0, $gF4D9.hydrateFilterValues)(cloudId, jqlURLParam) : null;
        const transformedInitialData = (0, $bRzz9.transformInitialData)(response.data);
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $5IIOI.transformHydratedValues)(hydratedValues);
            return (0, $5IIOI.mergeHydratedValues)(transformedInitialData, transformedHydratedValues);
        }
        return transformedInitialData;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $bRzz9.fireFieldValuesErrorAnalytics)('initialiseFilterData', 'Failed to initialise filter data', err);
    }
    return null;
};
const $a250a9d5a7d089ab$var$memoizedFetchInitialData = (0, $5iWql.default)($a250a9d5a7d089ab$var$fetchInitialDataInternal);
const $a250a9d5a7d089ab$var$fetchTeamsServiceFnc = ()=>Promise.resolve((0, $4Zgod.EMPTY_TEAMS));
const $a250a9d5a7d089ab$export$6cb851ed13e3949e = ({ view: view, allowedFieldTypes: allowedFieldTypes, filterFields: filterFields })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const [jqlURLParam] = (0, $lB25E.useQueryParam)((0, $jGcn0.FILTER_PARAM));
    const jqlURLParamRef = (0, $eUqFw.useRef)(jqlURLParam);
    const goalsJqlTerm = (0, $bRzz9.useGoalsJqlTerm)(filterFields);
    let fetchTeamsService = $a250a9d5a7d089ab$var$fetchTeamsServiceFnc;
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) // eslint-disable-next-line react-hooks/rules-of-hooks
    fetchTeamsService = (0, $4Zgod.useFetchTeams)();
    const fetchInitialData = (0, $eUqFw.useCallback)(async ()=>{
        if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return Promise.all([
            $a250a9d5a7d089ab$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm),
            fetchTeamsService({
                first: $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS
            })
        ]).then((values)=>{
            let result = (0, $kIODn.EMPTY_TRANSFORMED_DATA);
            values.forEach((value)=>{
                result = {
                    ...result,
                    ...value
                };
            });
            return result;
        });
        return $a250a9d5a7d089ab$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm);
    }, [
        allowedFieldTypes,
        cloudId,
        fetchTeamsService,
        goalsJqlTerm,
        jqlContext
    ]);
    const fetchData = (0, $eUqFw.useCallback)(async ({ fieldName: fieldName, query: query = '', first: first = $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS, afterCursor: afterCursor, jqlContext: jqlContextProp })=>{
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $8d92abf0af87bfd8$export$f8e8a5f34f6ea725),
                variables: {
                    cloudId: cloudId,
                    first: first,
                    jqlTerm: fieldName,
                    jql: jqlContextProp ?? jqlContext,
                    searchString: query,
                    after: afterCursor
                }
            })
        });
        if (response.data?.jira?.jqlBuilder?.fieldValues == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        return response.data.jira.jqlBuilder.fieldValues;
    }, [
        cloudId,
        jqlContext
    ]);
    const fetchLabels = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'labels',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterLabels', 'Failed to search labels', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchComponents = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'component',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterComponents', 'Failed to search components', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchPriorities = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'priority',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformPriorities)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterPriorities', 'Failed to search priorities', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchUsers = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'assignee',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformUsers)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterUsers', 'Failed to search users', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchIssueTypes = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'issuetype',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            let options = (0, $kIODn.transformIssueTypes)(fieldValuesData);
            if (view === 'board') options = options.filter((option)=>option.hierarchyLevel !== -1);
            return {
                totalCount: fieldValuesData.totalCount,
                options: options
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterIssueTypes', 'Failed to search issue types', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        view
    ]);
    const fetchStatuses = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'status',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformStatuses)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterStatuses', 'Failed to search statuses', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchCategories = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first = $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS })=>{
        try {
            const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMCategoryFieldValuesSearch', {
                body: JSON.stringify({
                    query: (0, $8d92abf0af87bfd8$export$562e34ec948f373d),
                    variables: {
                        first: first,
                        jql: jqlContext,
                        searchQuery: query,
                        after: afterCursor
                    }
                })
            });
            if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            if (response.data?.jira?.jwmCategoryOptions?.edges == null) throw new Error('GraphQL response has no data');
            return {
                totalCount: response.data.jira.jwmCategoryOptions.totalCount,
                options: (0, $kIODn.transformCategories)(response.data.jira.jwmCategoryOptions)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterCategories', 'Failed to search categories', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        jqlContext
    ]);
    const fetchSprints = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'sprint',
                query: query,
                first: first,
                afterCursor: afterCursor,
                jqlContext: `${jqlContext} AND ${$a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL}`
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformSprints)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterSprints', 'Failed to search sprints', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        jqlContext
    ]);
    const fetchFixVersions = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'fixVersion',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterFixVersion', 'Failed to search fix version', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchParents = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'parent',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformParent)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterParent', 'Failed to search parents', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchGoals = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        if (!goalsJqlTerm) return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: goalsJqlTerm,
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformGoals)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterGoals', 'Failed to search goals', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        goalsJqlTerm
    ]);
    const fetchTeams = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            const fieldValuesData = await fetchTeamsService({
                query: query,
                first: first,
                after: afterCursor
            });
            return fieldValuesData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterTeams', 'Failed to search teams', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchTeamsService
    ]);
    return {
        fetchInitialData: fetchInitialData,
        fetchLabels: fetchLabels,
        fetchComponents: fetchComponents,
        fetchPriorities: fetchPriorities,
        fetchUsers: fetchUsers,
        fetchIssueTypes: fetchIssueTypes,
        fetchStatuses: fetchStatuses,
        fetchCategories: fetchCategories,
        fetchSprints: fetchSprints,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
            fetchFixVersions: fetchFixVersions,
            fetchParents: fetchParents,
            fetchTeams: fetchTeams
        } : {},
        fetchGoals: fetchGoals
    };
};

});
parcelRegister("kIODn", function(module, exports) {

$parcel$export(module.exports, "transformPriorities", () => $661a0fc6907b6ea1$export$86ca92dec35c4797);
$parcel$export(module.exports, "transformUsers", () => $661a0fc6907b6ea1$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformIssueTypes", () => $661a0fc6907b6ea1$export$4c05e2584b34e4d8);
$parcel$export(module.exports, "transformStatuses", () => $661a0fc6907b6ea1$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformCategories", () => $661a0fc6907b6ea1$export$1b389c47cf1df04e);
$parcel$export(module.exports, "transformDefaultField", () => $661a0fc6907b6ea1$export$6133e08eeff30d5f);
$parcel$export(module.exports, "transformSprints", () => $661a0fc6907b6ea1$export$6a33be7fc7f04943);
$parcel$export(module.exports, "transformGoals", () => $661a0fc6907b6ea1$export$673d4fceed3e8383);
$parcel$export(module.exports, "transformParent", () => $661a0fc6907b6ea1$export$87e9766fb5100314);
$parcel$export(module.exports, "transformTeams", () => $661a0fc6907b6ea1$export$fd398a52d6f57b46);
$parcel$export(module.exports, "EMPTY_TRANSFORMED_DATA", () => $661a0fc6907b6ea1$export$ca9df9cab9cc134f);
$parcel$export(module.exports, "transformValuesData", () => $661a0fc6907b6ea1$export$8e327b5f9ebc175d);
/* eslint-disable complexity */ 
var $lyOYo = parcelRequire("lyOYo");

var $lO4Or = parcelRequire("lO4Or");
const $661a0fc6907b6ea1$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>issueType?.avatar?.medium != null)?.avatar?.medium;
const $661a0fc6907b6ea1$var$getFirstIssueTypeId = (node)=>node.issueTypes[0]?.issueTypeId;
const $661a0fc6907b6ea1$var$getFirstIssueTypeHierarchyLevel = (node)=>node.issueTypes[0]?.hierarchy?.level;
const $661a0fc6907b6ea1$export$86ca92dec35c4797 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node.priority.iconUrl || ''
        }));
const $661a0fc6907b6ea1$export$fb8c90bfc4beaa59 = (data)=>data.edges.filter(({ node: node })=>node?.user != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node?.user?.picture || ''
        }));
const $661a0fc6907b6ea1$export$4c05e2584b34e4d8 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            id: $661a0fc6907b6ea1$var$getFirstIssueTypeId(node),
            avatar: $661a0fc6907b6ea1$var$getFirstIssueTypeAvatar(node) || '',
            square: true,
            hierarchyLevel: $661a0fc6907b6ea1$var$getFirstIssueTypeHierarchyLevel(node) || 0
        }));
const $661a0fc6907b6ea1$export$20a57a5ec025f2d = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            categoryId: node.statusCategory.statusCategoryId
        }));
const $661a0fc6907b6ea1$export$1b389c47cf1df04e = (data)=>{
    const transformedCategories = data.edges.map((edge)=>({
            cursor: edge?.cursor,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            label: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            color: edge.node.color
        }));
    // Remove any categories that have the same name across multiple projects
    return (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(transformedCategories, ({ value: value })=>value);
};
const $661a0fc6907b6ea1$export$6133e08eeff30d5f = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName
        }));
const $661a0fc6907b6ea1$export$6a33be7fc7f04943 = (data)=>data.edges.filter(({ node: node })=>node?.sprint != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.displayName,
            label: node.sprint?.name || ''
        }));
const $661a0fc6907b6ea1$export$673d4fceed3e8383 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.goal.name || '',
            status: node.goal.status || ''
        }));
const $661a0fc6907b6ea1$export$87e9766fb5100314 = (data)=>data?.edges.map(({ node: node, cursor: cursor })=>{
        let avatar = '';
        if (Number(node.issue?.fieldsByIdOrAlias.length) > 0) avatar = node.issue?.fieldsByIdOrAlias[0].issueType?.avatar?.medium || '';
        return {
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: avatar
        };
    });
const $661a0fc6907b6ea1$export$fd398a52d6f57b46 = (data)=>data?.edges.filter(({ node: node })=>node?.team != null).map(({ node: node })=>({
            cursor: data.pageInfo?.endCursor,
            value: node.team.id.replace('ari:cloud:identity::team/', ''),
            label: node.team.displayName || '',
            avatar: node.team.smallAvatarImageUrl || ''
        }));
// Type predicted
const $661a0fc6907b6ea1$var$isIssueType = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issueTypes' in node);
};
const $661a0fc6907b6ea1$var$isPriority = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'priority' in node);
};
const $661a0fc6907b6ea1$var$isStatus = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'statusCategory' in node);
};
const $661a0fc6907b6ea1$var$isSprint = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'sprint' in node);
};
const $661a0fc6907b6ea1$var$isGoal = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'goal' in node);
};
const $661a0fc6907b6ea1$var$isParent = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issue' in node);
};
// any fieldValue could be a UserFieldValues because the edges could have some node with "user" undefined
// for example : { node: { displayName: "administrators", jqlTerm: "membersOf(administrators)" }}
const $661a0fc6907b6ea1$var$isUser = (fieldValue)=>true;
const $661a0fc6907b6ea1$var$isDefaultField = (fieldValue)=>Boolean(fieldValue.edges[0]);
const $661a0fc6907b6ea1$export$ca9df9cab9cc134f = {
    labels: {
        totalCount: 0,
        options: []
    },
    components: {
        totalCount: 0,
        options: []
    },
    priority: {
        totalCount: 0,
        options: []
    },
    users: {
        totalCount: 0,
        options: []
    },
    issuetype: {
        totalCount: 0,
        options: []
    },
    status: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.CATEGORY_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.SPRINT_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.PARENT_FIELD_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.GOALS_CF_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $661a0fc6907b6ea1$export$8e327b5f9ebc175d = (data)=>{
    const transformedData = {
        ...$661a0fc6907b6ea1$export$ca9df9cab9cc134f
    };
    Object.entries(data).forEach(([key, fieldValue])=>{
        if (fieldValue && fieldValue.edges && Array.isArray(fieldValue.edges) && fieldValue.edges.length) switch(key){
            case 'issuetype':
                if ($661a0fc6907b6ea1$var$isIssueType(fieldValue)) transformedData.issuetype = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$4c05e2584b34e4d8(fieldValue)
                };
                break;
            case 'priority':
                if ($661a0fc6907b6ea1$var$isPriority(fieldValue)) transformedData.priority = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$86ca92dec35c4797(fieldValue)
                };
                break;
            case 'status':
                if ($661a0fc6907b6ea1$var$isStatus(fieldValue)) transformedData.status = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$20a57a5ec025f2d(fieldValue)
                };
                break;
            case 'component':
            case 'components':
            case 'fixVersions':
            case 'labels':
                if ($661a0fc6907b6ea1$var$isDefaultField(fieldValue)) {
                    const transformedKey = key === 'component' ? (0, $lO4Or.COMPONENTS_TYPE) : key;
                    transformedData[transformedKey] = {
                        totalCount: fieldValue.totalCount,
                        options: $661a0fc6907b6ea1$export$6133e08eeff30d5f(fieldValue)
                    };
                }
                break;
            case 'parent':
                if ($661a0fc6907b6ea1$var$isParent(fieldValue)) transformedData[key] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$87e9766fb5100314(fieldValue)
                };
                break;
            default:
                if ($661a0fc6907b6ea1$var$isSprint(fieldValue)) transformedData[0, $lO4Or.SPRINT_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$6a33be7fc7f04943(fieldValue)
                };
                else if (fieldValue.edges.some((item)=>item.node && 'user' in item.node) && $661a0fc6907b6ea1$var$isUser(fieldValue)) {
                    const usersData = $661a0fc6907b6ea1$export$fb8c90bfc4beaa59(fieldValue);
                    const userOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                        ...usersData,
                        ...transformedData.users?.options ?? []
                    ], ({ value: value })=>value);
                    transformedData.users = {
                        totalCount: userOptions.length,
                        options: userOptions
                    };
                } else if ($661a0fc6907b6ea1$var$isGoal(fieldValue)) transformedData[0, $lO4Or.GOALS_CF_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$673d4fceed3e8383(fieldValue)
                };
        }
    });
    return transformedData;
};

});

parcelRegister("4Zgod", function(module, exports) {

$parcel$export(module.exports, "EMPTY_TEAMS", () => $f012c42657d68d46$export$37430da53242c305);
$parcel$export(module.exports, "useFetchTeams", () => $f012c42657d68d46$export$da1ab223b3f1410c);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $lO4Or = parcelRequire("lO4Or");

var $jD3pk = parcelRequire("jD3pk");

var $dWLk9 = parcelRequire("dWLk9");

var $kIODn = parcelRequire("kIODn");

// use ari functions from @atlassian/ari whenever it is ready for import
const $f012c42657d68d46$var$prependOrgIdAri = (orgId)=>`ari:cloud:platform::org/${orgId}`;
const $f012c42657d68d46$export$37430da53242c305 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $f012c42657d68d46$var$MAX_NUMBER_OF_OPTIONS = 20;
const $f012c42657d68d46$export$da1ab223b3f1410c = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const fetchTeams = (0, $eUqFw.useCallback)(async ({ query: query, first: first = $f012c42657d68d46$var$MAX_NUMBER_OF_OPTIONS, after: after })=>{
        if (orgId) try {
            const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $1a073e75df73c791$export$cbe5a6af25588495),
                    variables: {
                        orgId: $f012c42657d68d46$var$prependOrgIdAri(orgId),
                        cloudId: cloudId,
                        queryString: query,
                        first: first,
                        after: after
                    }
                })
            });
            const options = (0, $kIODn.transformTeams)(response.data.team.teamSearchV2) || [];
            // Teams query doesn't return the total count
            const totalCount = options.length >= first ? first : options.length;
            return {
                [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
                    totalCount: totalCount,
                    options: options
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchTeams',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch team filter data'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return $f012c42657d68d46$export$37430da53242c305;
    }, [
        cloudId,
        orgId
    ]);
    return fetchTeams;
};

});
const $1a073e75df73c791$export$cbe5a6af25588495 = `
    query JWMTeamFilterValues($cloudId: String!, $orgId: ID!, $queryString: String, $first: Int, $after: String) {
        team @optIn(to: "Team-search-v2") {
            teamSearchV2(
                organizationId: $orgId
                siteId: $cloudId
                first: $first
                after: $after
                filter: {query: $queryString}
            ) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        team {
                            id
                            displayName
                            smallAvatarImageUrl
                        }
                    }
                }
            }
        }
    }
`;


parcelRegister("gF4D9", function(module, exports) {

$parcel$export(module.exports, "hydrateFilterValues", () => $12ce55db15189323$export$b18eef22aaa99c21);

var $5iWql = parcelRequire("5iWql");

var $6gPph = parcelRequire("6gPph");

var $dlVOn = parcelRequire("dlVOn");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

const $12ce55db15189323$export$3361e9be8093ddcc = (fields)=>{
    const hydratedValues = {};
    fields.forEach((hydratedField)=>{
        if (!hydratedField) return;
        const { field: field, values: values } = hydratedField;
        if (!field || !values) return;
        hydratedValues[field.jqlTerm] = {
            edges: values.map((item)=>(item && item.values && item.values[0]) ?? null).filter(Boolean).map((item)=>({
                    node: item
                })),
            totalCount: 0
        };
    });
    return hydratedValues;
};
const $12ce55db15189323$export$7a89edfb546e2344 = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMHydrateFilterValues', {
            body: JSON.stringify({
                query: (0, $eI5EY.fg)('native_goals_integration_on_list_view') ? (0, $a02b4224be9155fa$export$2bd792833522f1f1) : (0, $a02b4224be9155fa$export$e8b5e80812d4a604),
                variables: {
                    cloudId: cloudId,
                    jql: jqlContext
                }
            })
        });
        if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.fields == null) {
            if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.__typename === 'QueryError') throw new (0, $6gPph.QueryError)(response.data.jira.jqlBuilder.hydrateJqlQuery);
            throw new Error('Failed to fetch on hydrateFilterValuesService');
        }
        return $12ce55db15189323$export$3361e9be8093ddcc(response.data.jira.jqlBuilder.hydrateJqlQuery.fields);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'JWMHydrateFilterValues',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $12ce55db15189323$export$b18eef22aaa99c21 = (0, $5iWql.default)($12ce55db15189323$export$7a89edfb546e2344);

});
const $a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT_OLD = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $a02b4224be9155fa$export$e8b5e80812d4a604 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT_OLD}
`;
const $a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $a02b4224be9155fa$export$2bd792833522f1f1 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT}
`;


parcelRegister("5IIOI", function(module, exports) {

$parcel$export(module.exports, "transformHydratedValues", () => $3cf74c17db7589d0$export$56282b201a60959e);
$parcel$export(module.exports, "mergeHydratedValues", () => $3cf74c17db7589d0$export$8f60413c08081990);

var $lyOYo = parcelRequire("lyOYo");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $kIODn = parcelRequire("kIODn");
const $3cf74c17db7589d0$var$transformHydratedValuesOld = (data)=>{
    const transformedHydratedData = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    Object.keys(data).forEach((key)=>{
        if (data[key] && data[key].edges && Array.isArray(data[key].edges)) switch(key){
            case 'issuetype':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformIssueTypes)(data[key])
                };
                return;
            case 'priority':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformPriorities)(data[key])
                };
                return;
            case 'status':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformStatuses)(data[key])
                };
                return;
            case 'labels':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformDefaultField)(data[key])
                };
                return;
            case 'component':
                transformedHydratedData.components = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformDefaultField)(data[key])
                };
                return;
            default:
                if (data[key].edges.some((item)=>item.node && 'user' in item.node)) transformedHydratedData.users = {
                    totalCount: 0,
                    options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ...(0, $kIODn.transformUsers)(data[key]),
                        ...transformedHydratedData.users?.options ?? []
                    ], ({ value: value })=>value)
                };
                else if (data[key].edges.some((item)=>item.node && 'sprint' in item.node)) transformedHydratedData[0, $lO4Or.SPRINT_TYPE] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformSprints)(data[key])
                };
        }
    });
    return transformedHydratedData;
};
const $3cf74c17db7589d0$export$56282b201a60959e = (data)=>{
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return (0, $kIODn.transformValuesData)(data);
    return $3cf74c17db7589d0$var$transformHydratedValuesOld(data);
};
const $3cf74c17db7589d0$export$8f60413c08081990 = (initialData, hydratedValues)=>({
        labels: {
            totalCount: initialData.labels.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.labels.options,
                ...initialData.labels.options
            ], ({ value: value })=>value)
        },
        components: {
            totalCount: initialData.components.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.components.options,
                ...initialData.components.options
            ], ({ value: value })=>value)
        },
        priority: {
            totalCount: initialData.priority.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.priority.options,
                ...initialData.priority.options
            ], ({ value: value })=>value)
        },
        users: {
            totalCount: initialData.users.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.users.options,
                ...initialData.users.options
            ], ({ value: value })=>value)
        },
        issuetype: {
            totalCount: initialData.issuetype.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.issuetype.options,
                ...initialData.issuetype.options
            ], ({ value: value })=>value)
        },
        status: {
            totalCount: initialData.status.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.status.options,
                ...initialData.status.options
            ], ({ value: value })=>value)
        },
        // hydrate values endpoint doesn't support categories
        [(0, $lO4Or.CATEGORY_TYPE)]: initialData[0, $lO4Or.CATEGORY_TYPE],
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: initialData[0, $lO4Or.SPRINT_TYPE].totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.SPRINT_TYPE].options,
                ...initialData[0, $lO4Or.SPRINT_TYPE].options
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
            totalCount: initialData[0, $lO4Or.FIX_VERSIONS_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.FIX_VERSIONS_TYPE]?.options || [],
                ...initialData[0, $lO4Or.FIX_VERSIONS_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.PARENT_FIELD_TYPE)]: {
            totalCount: initialData[0, $lO4Or.PARENT_FIELD_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.PARENT_FIELD_TYPE]?.options || [],
                ...initialData[0, $lO4Or.PARENT_FIELD_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.GOALS_CF_TYPE)]: {
            totalCount: initialData[0, $lO4Or.GOALS_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.GOALS_CF_TYPE]?.options || [],
                ...initialData[0, $lO4Or.GOALS_CF_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: initialData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.options || [],
                ...initialData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.options || []
            ], ({ value: value })=>value)
        }
    });

});

const $8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT = `
fragment CategoryConnection on JiraWorkManagementCategoryOptionConnection {
    edges {
        cursor
        node {
            option {
              value
            }
            color
        }
    }
    totalCount
}
`;
const $8d92abf0af87bfd8$export$a48313dd44fc9855 = `
query JwmInitialFilterValues($cloudId: ID!, $first: Int, $jql: String!, $shouldFetchSprints: Boolean = false, $shouldFetchSoftwareFields: Boolean = false, $sprintsJqlContext: String, $goalsJqlTerm: String!, $shouldFetchGoalsField: Boolean = false, $shouldFetchParentField: Boolean = false) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            labels: fieldValues(
                first: $first
                jqlTerm: "labels"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            components: fieldValues(
                first: $first
                jqlTerm: "component"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            priority: fieldValues(
                first: $first
                jqlTerm: "priority"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            users: fieldValues(
                first: $first
                jqlTerm: "assignee"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            recentlyUsedUsers(
                first: $first
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            issuetype: fieldValues(
                first: $first
                jqlTerm: "issuetype"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                     cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            status: fieldValues(
                first: $first
                jqlTerm: "status"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            sprints: fieldValues(
                first: $first
                jqlTerm: "sprint"
                jqlContext: $sprintsJqlContext
                viewContext: JSW
            ) @include(if: $shouldFetchSprints) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            fixVersions: fieldValues(
                first: $first
                jqlTerm: "fixVersion"
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            parent: fieldValues(
                first: $first
                jqlTerm: "parent"
                jqlContext: $jql
                viewContext: JSW
            ) @include(if: $shouldFetchParentField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }

            goals: fieldValues(
                first: $first
                jqlTerm: $goalsJqlTerm
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchGoalsField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
        jwmCategoryOptions(jqlContext: $jql, first: $first) {
            ...CategoryConnection
        }
    }
}
${$8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT}
${$8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT}
`;
const $8d92abf0af87bfd8$export$f8e8a5f34f6ea725 = `
query JwmSearchFilterValues($cloudId: ID!, $first: Int, $jqlTerm: String!, $jql: String!, $searchString: String, $after: String) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            fieldValues(
                first: $first
                jqlTerm: $jqlTerm
                jqlContext: $jql
                searchString: $searchString
                after: $after
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
    }
}
${$8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT}
`;
const $8d92abf0af87bfd8$export$562e34ec948f373d = `
query JwmCategorySearchFilterValues($first: Int, $jql: String!, $searchQuery: String, $after: String) {
    jira {       
        jwmCategoryOptions(jqlContext: $jql, first: $first, searchQuery: $searchQuery, after: $after) {
            ...CategoryConnection
        }
    }
}
${$8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT}
`;

parcelRegister("bRzz9", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $26047d310e78058e$export$93219b8691fe49a0);
$parcel$export(module.exports, "fireFieldValuesErrorAnalytics", () => $26047d310e78058e$export$c3c62a63250fc6f8);
$parcel$export(module.exports, "useGoalsJqlTerm", () => $26047d310e78058e$export$674eff5ec8403101);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $kIODn = parcelRequire("kIODn");
const $26047d310e78058e$var$transformInitialCategories = (data)=>{
    if (data.jira.jwmCategoryOptions?.edges != null && Array.isArray(data.jira.jwmCategoryOptions.edges)) return {
        totalCount: data.jira.jwmCategoryOptions.totalCount,
        options: (0, $kIODn.transformCategories)(data.jira.jwmCategoryOptions)
    };
    return undefined;
};
const $26047d310e78058e$var$transformInitialDataOld = (data)=>{
    const { components: components, issuetype: issuetype, priority: priority, labels: labels, status: status, users: users, recentlyUsedUsers: recentlyUsedUsers, sprints: sprints } = data.jira.jqlBuilder;
    const transformedData = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    if (components?.edges != null && Array.isArray(components.edges)) transformedData.components = {
        totalCount: components.totalCount,
        options: (0, $kIODn.transformDefaultField)(components)
    };
    if (issuetype?.edges != null && Array.isArray(issuetype.edges)) transformedData.issuetype = {
        totalCount: issuetype.totalCount,
        options: (0, $kIODn.transformIssueTypes)(issuetype)
    };
    if (priority?.edges != null && Array.isArray(priority.edges)) transformedData.priority = {
        totalCount: priority.totalCount,
        options: (0, $kIODn.transformPriorities)(priority)
    };
    if (labels?.edges != null && Array.isArray(labels.edges)) transformedData.labels = {
        totalCount: labels.totalCount,
        options: (0, $kIODn.transformDefaultField)(labels)
    };
    if (status?.edges != null && Array.isArray(status.edges)) transformedData.status = {
        totalCount: status.totalCount,
        options: (0, $kIODn.transformStatuses)(status)
    };
    if (users?.edges != null && Array.isArray(users.edges)) {
        const usersData = (0, $kIODn.transformUsers)(users);
        const recentlyUsedUsersData = recentlyUsedUsers?.edges != null && Array.isArray(recentlyUsedUsers.edges) ? (0, $kIODn.transformUsers)(recentlyUsedUsers) : null;
        transformedData.users = {
            totalCount: users.totalCount,
            options: // combine `recentlyUsedUsers` and `users` options to improve relevancy of the users field
            recentlyUsedUsersData != null ? (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...recentlyUsedUsersData,
                ...usersData
            ], ({ value: value })=>value) : usersData
        };
    }
    const categories = $26047d310e78058e$var$transformInitialCategories(data);
    if (categories) transformedData[0, $lO4Or.CATEGORY_TYPE] = categories;
    if (sprints?.edges != null && Array.isArray(sprints.edges)) transformedData[0, $lO4Or.SPRINT_TYPE] = {
        options: (0, $kIODn.transformSprints)(sprints),
        totalCount: sprints.totalCount
    };
    return transformedData;
};
const $26047d310e78058e$export$93219b8691fe49a0 = (data)=>{
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
        const transformedData = (0, $kIODn.transformValuesData)(data.jira.jqlBuilder);
        const categories = $26047d310e78058e$var$transformInitialCategories(data);
        if (categories) transformedData[0, $lO4Or.CATEGORY_TYPE] = categories;
        return transformedData;
    }
    return $26047d310e78058e$var$transformInitialDataOld(data);
};
const $26047d310e78058e$export$c3c62a63250fc6f8 = (errorId, errorMessage, // eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>{
    (0, $guiFP.default)({
        meta: {
            id: errorId,
            packageName: 'jiraBusinessFilters',
            teamName: 'wanjel'
        },
        attributes: {
            message: errorMessage
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $26047d310e78058e$export$674eff5ec8403101 = (filterFields)=>{
    const goalsJqlTerm = (0, $eUqFw.useMemo)(()=>filterFields?.find((field)=>field?.type === (0, $lO4Or.GOALS_CF_TYPE))?.id, [
        filterFields
    ]);
    return goalsJqlTerm;
};

});


parcelRegister("bPRqC", function(module, exports) {

$parcel$export(module.exports, "useFieldConfig", () => $527c6b4310270d47$export$70da50df1be2dbe1);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $jGcn0 = parcelRequire("jGcn0");

var $35jYz = parcelRequire("35jYz");

var $gEmpR = parcelRequire("gEmpR");

var $ihkPC = parcelRequire("ihkPC");

var $fP7qq = parcelRequire("fP7qq");

var $e20I1 = parcelRequire("e20I1");

var $a75Ge = parcelRequire("a75Ge");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $lB25E = parcelRequire("lB25E");

var $dWLk9 = parcelRequire("dWLk9");

var $gF4D9 = parcelRequire("gF4D9");

var $5IIOI = parcelRequire("5IIOI");

var $7G14t = parcelRequire("7G14t");

var $ijEQD = parcelRequire("ijEQD");
const $527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS = 10;
const $527c6b4310270d47$var$useFilterMapper = true;
const $527c6b4310270d47$var$EMPTY_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_USER_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_COMPONENT_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_CATEGORY_ARRAY = [];
const $527c6b4310270d47$export$1fe8227c57fa0d68 = ()=>({
        initialUsers: {
            data: $527c6b4310270d47$var$EMPTY_USER_ARRAY,
            isLoading: false
        },
        initialLabels: {
            data: $527c6b4310270d47$var$EMPTY_ARRAY,
            isLoading: false
        },
        initialComponents: {
            data: $527c6b4310270d47$var$EMPTY_COMPONENT_ARRAY,
            isLoading: false
        },
        initialCategories: {
            data: $527c6b4310270d47$var$EMPTY_CATEGORY_ARRAY,
            isLoading: false
        },
        projectKey: null
    });
const $527c6b4310270d47$export$74cea4b24a6bc9fa = $527c6b4310270d47$export$1fe8227c57fa0d68();
const $527c6b4310270d47$var$useForceUpdate = ()=>{
    const [, setValue] = (0, $eUqFw.useState)(0);
    return (0, $eUqFw.useCallback)(()=>setValue((value)=>value + 1), []);
};
const $527c6b4310270d47$export$70da50df1be2dbe1 = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [userResolver] = (0, $eUqFw.useState)(new (0, $e20I1.UserResolver)());
    const forceUpdate = $527c6b4310270d47$var$useForceUpdate();
    // this is used to check whether the hook is still mounted by the time we call fireErrorAnalytics
    // see JET-2324
    const mounted = (0, $eUqFw.useRef)(true);
    const [priorityFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: issueTypeData, loading: loadingIssueTypesAndFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const formattedCategoryOptions = (0, $eUqFw.useMemo)(()=>{
        const categoryOptions = issueTypeData.fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE))?.fieldConfig?.selectOptions ?? [];
        return categoryOptions.map(({ value: value })=>({
                label: value,
                value: value
            }));
    }, [
        issueTypeData
    ]);
    const { statuses: statuses, loading: loadingStatuses } = (0, $a75Ge.useProjectStatuses)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $lB25E.useRouter)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [jqlURLParam] = (0, $lB25E.useQueryParam)((0, $jGcn0.FILTER_PARAM));
    const jqlURLParamRef = (0, $eUqFw.useRef)(jqlURLParam);
    const hydratedUsers = (0, $eUqFw.useRef)(null);
    const fetchInitialUsers = (0, $eUqFw.useCallback)(async ()=>{
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.isLoading = true;
        let users = [];
        const hydratedValues = jqlURLParamRef.current ? await (0, $gF4D9.hydrateFilterValues)(cloudId, jqlURLParamRef.current) : null;
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $5IIOI.transformHydratedValues)(hydratedValues);
            hydratedUsers.current = transformedHydratedValues.users.options;
        }
        const url = `/rest/api/3/user/search?maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}&query=`;
        users = await (0, $2OdyW.default)(url);
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers = {
            data: users,
            isLoading: false
        };
        forceUpdate();
        return users;
    }, [
        cloudId,
        forceUpdate
    ]);
    const fetchInitialLabels = (0, $eUqFw.useCallback)(async ()=>{
        const url = `/rest/api/3/label?maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}`;
        try {
            $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels.isLoading = true;
            const response = await (0, $2OdyW.default)(url);
            const labels = response.values;
            $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels = {
                data: labels,
                isLoading: false
            };
            forceUpdate();
            return labels;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchFilterInitialLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch initial labels',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels = {
            data: $527c6b4310270d47$var$EMPTY_ARRAY,
            isLoading: false
        };
        forceUpdate();
        return $527c6b4310270d47$var$EMPTY_ARRAY;
    }, [
        forceUpdate
    ]);
    const fetchUsers = (0, $eUqFw.useCallback)(async (query = '')=>{
        if (projectKey != null) {
            const url = `/rest/api/2/user/assignable/search?project=${projectKey}&maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}&query=${query}`;
            try {
                const response = await (0, $2OdyW.default)(url);
                return response;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'searchFilterUsers',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to search users',
                        errorType: (0, $ihkPC.getErrorType)(err),
                        online: window.navigator.onLine,
                        mounted: mounted.current
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }
        return $527c6b4310270d47$var$EMPTY_USER_ARRAY;
    }, [
        projectKey
    ]);
    const fetchProjectComponents = (0, $eUqFw.useCallback)(async (query = '')=>{
        if (projectKey != null) try {
            const response = await (0, $fP7qq.fetchComponents)({
                inputValue: query,
                autoCompleteUrl: `/rest/api/3/project/${projectKey}/component`,
                useFilterMapper: $527c6b4310270d47$var$useFilterMapper,
                mounted: mounted.current
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchFilterComponents',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch components',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return [];
    }, [
        projectKey
    ]);
    const fetchLabels = (0, $eUqFw.useCallback)((query = '')=>(0, $2OdyW.default)(`/rest/api/1.0/labels/suggest?query=${query}`).catch((err)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'searchFilterLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to search labels',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }), []);
    const fetchProjectCategories = (0, $eUqFw.useCallback)((query = '')=>{
        // TODO Replace with back end fetch API
        const filteredCategoriesQuery = formattedCategoryOptions?.filter((categoryOption)=>categoryOption.label.toLowerCase().startsWith(query.toLowerCase()));
        return Promise.resolve(filteredCategoriesQuery ?? []);
    }, [
        formattedCategoryOptions
    ]);
    const { fetch: fetchInitialStoryPointsData, data: initialStoryPoints, loading: loadingStoryPoints } = (0, $7G14t.useGroupItemValues)({
        groupFieldId: (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)
    });
    const { fetch: fetchInitialStoryPointsEstimateData, data: initialStoryPointsEstimate, loading: loadingStoryPointsEstimate } = (0, $7G14t.useGroupItemValues)({
        groupFieldId: (0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID))) fetchInitialStoryPointsData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID))) fetchInitialStoryPointsEstimateData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsEstimateData
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (projectKey != null && // Initially fetch for everything if projectKey is updated or users is empty
        ($527c6b4310270d47$export$74cea4b24a6bc9fa.projectKey !== projectKey || $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.data === $527c6b4310270d47$var$EMPTY_USER_ARRAY)) {
            if ($527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.isLoading === false) {
                $527c6b4310270d47$export$74cea4b24a6bc9fa.projectKey = projectKey;
                fetchInitialUsers();
            }
        }
    }, [
        fetchInitialUsers,
        fetchProjectComponents,
        projectKey,
        fetchInitialLabels,
        fetchProjectCategories,
        forceUpdate
    ]);
    const { data: initialUsers, isLoading: isLoadingUsers } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers;
    const { data: initialLabels, isLoading: isLoadingLabels } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels;
    const { data: initialComponents, isLoading: isLoadingComponents } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialComponents;
    const { data: initialCategories, isLoading: isLoadingCategories } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialCategories;
    const fieldOptionsData = (0, $eUqFw.useMemo)(()=>({
            priority: (0, $ijEQD.transformPriority)(priorityFieldConfig),
            issuetype: (0, $ijEQD.transformIssueType)(issueTypeData),
            status: (0, $ijEQD.transformStatuses)(statuses),
            users: (0, $ijEQD.transformUsers)(initialUsers),
            labels: (0, $ijEQD.transformLabels)(initialLabels),
            components: initialComponents,
            [(0, $lO4Or.CATEGORY_TYPE)]: initialCategories,
            [(0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)]: initialStoryPoints?.options || [],
            [(0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)]: initialStoryPointsEstimate?.options || []
        }), [
        priorityFieldConfig,
        issueTypeData,
        statuses,
        initialUsers,
        initialLabels,
        initialComponents,
        initialCategories,
        initialStoryPoints?.options,
        initialStoryPointsEstimate?.options
    ]);
    fieldOptionsData.users = (0, $eUqFw.useMemo)(()=>{
        if (hydratedUsers.current === null) return fieldOptionsData.users;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
            ...hydratedUsers.current ?? [],
            ...fieldOptionsData.users ?? []
        ], ({ value: value })=>value);
    }, [
        fieldOptionsData
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $ijEQD.getFilterFieldConfigAndResolvers)({
        formatMessage: formatMessage,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allFields: issueTypeData.fields,
        fieldOptionsData: fieldOptionsData,
        fetchUsers: (query)=>fetchUsers(query).then((users)=>(0, $ijEQD.transformUsers)(users || [])),
        fetchLabels: (query)=>fetchLabels(query).then((labels)=>labels ? (0, $ijEQD.transformLabelSuggestions)(labels) : []),
        fetchComponents: (query)=>fetchProjectComponents(query).then((components)=>components),
        fetchCategories: (query)=>fetchProjectCategories(query).then((categoriesResponse)=>categoriesResponse),
        userResolver: userResolver
    });
    const fetching = isLoadingUsers || isLoadingLabels || isLoadingComponents || isLoadingCategories || loadingStoryPoints || loadingStoryPointsEstimate;
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingIssueTypesAndFields || loadingStatuses || fetching
    };
};

});
parcelRegister("ihkPC", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $348eddd0ac284a22$export$e19f9f08a6d79fd2);

var $7byHA = parcelRequire("7byHA");
const $348eddd0ac284a22$export$7453182ebe5973d4 = 'APOLLO_NETWORK_ERROR';
const $348eddd0ac284a22$export$9705762bba4e9e25 = 'NULL_OR_UNDEFINED';
const $348eddd0ac284a22$export$d46a05f8561f868a = 'OTHER';
const $348eddd0ac284a22$export$c748438cec453c9f = {
    FAILED_TO_FETCH: 'Failed to fetch',
    NETWORK_ERROR: 'NetworkError when attempting to fetch resource.',
    NETWORK_REQUEST_FAILED: 'Network request failed',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    NETWORK_CONNECTION_ERROR: 'upstream connect error or disconnect/reset before headers. reset reason: connection',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    ABORTED: 'operation was aborted.',
    CANCELLED: 'cancelled',
    TIMEOUT: 'The request timed out.'
};
const $348eddd0ac284a22$var$isApolloClientNetworkError = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>error.networkError !== undefined && error.networkError !== null;
const $348eddd0ac284a22$export$e19f9f08a6d79fd2 = (error)=>{
    if (error == null) return $348eddd0ac284a22$export$9705762bba4e9e25;
    const message = String(error instanceof Error ? error.message : error).trim();
    if (error instanceof (0, $7byHA.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode) return `FETCH_ERROR_${statusCode}`;
    }
    if ($348eddd0ac284a22$var$isApolloClientNetworkError(error)) return $348eddd0ac284a22$export$7453182ebe5973d4;
    const entry = Object.entries($348eddd0ac284a22$export$c748438cec453c9f).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    return entry ? entry[0] : $348eddd0ac284a22$export$d46a05f8561f868a;
};

});

parcelRegister("fP7qq", function(module, exports) {

$parcel$export(module.exports, "fetchComponents", () => $9fb5f20e4a6bfa39$export$4f703ddb7c8cc5b3);

var $53ciZ = parcelRequire("53ciZ");

var $ihkPC = parcelRequire("ihkPC");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $a9hW2 = parcelRequire("a9hW2");
const $9fb5f20e4a6bfa39$export$4f703ddb7c8cc5b3 = ({ inputValue: inputValue, autoCompleteUrl: autoCompleteUrl, useFilterMapper: useFilterMapper, mounted: mounted, queryParameters: queryParameters })=>{
    const mapperFunction = useFilterMapper === true ? (0, $a9hW2.mapComponentsToFilterOptions) : (0, $a9hW2.mapComponentsToOptions);
    const query = (0, $1ybV0.ff)('jira.list.field-support-part1') ? (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: inputValue,
        ...queryParameters
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: inputValue
    });
    return (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>mapperFunction(response.values)).catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'fetchProjectComponents',
                packageName: 'jiraBusinessFetchComponents',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to fetch jwm project components',
                errorType: (0, $ihkPC.getErrorType)(error),
                online: window.navigator.onLine,
                mounted: mounted
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};

});
parcelRegister("a9hW2", function(module, exports) {

$parcel$export(module.exports, "mapComponentsToOptions", () => $c0b17925cb48a958$export$85e44418187c2c1e);
$parcel$export(module.exports, "mapComponentsToFilterOptions", () => $c0b17925cb48a958$export$b4ef58d3e943e4d5);
const $c0b17925cb48a958$export$85e44418187c2c1e = (components)=>components.map(({ id: id, componentId: componentId, name: name })=>({
            label: name,
            value: componentId !== undefined ? String(componentId) : String(id)
        }));
const $c0b17925cb48a958$export$b4ef58d3e943e4d5 = (components)=>components.map(({ name: name })=>({
            label: name,
            value: name
        }));

});


parcelRegister("e20I1", function(module, exports) {

$parcel$export(module.exports, "UserResolver", () => $2f3c56b3440530f6$export$723df28d03868f02);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
class $2f3c56b3440530f6$export$723df28d03868f02 {
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        this.getUsersFromAccountId = (accountIds)=>{
            const recoveredFromCache = [];
            const missingFromCache = [];
            accountIds.forEach((accountId)=>{
                const user = this.cache.get(accountId);
                if (user) recoveredFromCache.push(user);
                else missingFromCache.push(accountId);
            });
            if (missingFromCache.length === 0) // @ts-expect-error - User is not assignable to type 'string'
            return Promise.resolve(recoveredFromCache);
            return (0, $2OdyW.default)(`/rest/api/2/user/bulk?maxResults=10&${missingFromCache.map((accountId)=>`accountId=${accountId}`).join('&')}`).then((response)=>response && response.values.length > 0 && // @ts-expect-error - TS2339 - Property 'forEach' does not exist on type '() => IterableIterator<Readonly<Partial<Diff<ResponseSuccess, Record<any, any>>> & { accountId: string | null; displayName: string; avatarUrls: { readonly "48x48"?: string | undefined; readonly "32x32"?: string | undefined; readonly "24x24"?: string | undefined; readonly "16x16"?: string | undefined; }; }>>'. | TS7006 - Parameter 'user' implicitly has an 'any' type.
                response.values.forEach((user)=>{
                    if (user) this.cache.set(user.accountId, user);
                })).then(()=>this.getUsersFromAccountId(accountIds)).catch((err)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('jwm.services.get-users', 'Failed to fetch users', err);
            });
        };
        this.cache = new Map();
    }
}

});

parcelRegister("7G14t", function(module, exports) {

$parcel$export(module.exports, "useGroupItemValues", () => $f05aa0c8a487bc66$export$f05af123f98299b0);

var $eUqFw = parcelRequire("eUqFw");

var $NFHn0 = parcelRequire("NFHn0");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lKPnc = parcelRequire("lKPnc");

var $fOoev = parcelRequire("fOoev");
const $f05aa0c8a487bc66$var$reducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return {
                loading: true
            };
        case 'success':
            return {
                loading: false,
                data: action.payload
            };
        case 'error':
            return {
                loading: false,
                data: null
            };
        default:
            return state;
    }
};
const $f05aa0c8a487bc66$export$f05af123f98299b0 = ({ groupFieldId: groupFieldId })=>{
    const [state, dispatch] = (0, $eUqFw.useReducer)($f05aa0c8a487bc66$var$reducer, {
        loading: false
    });
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fetchDataAbortable = (0, $NFHn0.useAbortable)((0, $lKPnc.fetchGroupItemValues));
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        try {
            dispatch({
                type: 'loading'
            });
            const response = await fetchDataAbortable(groupFieldId, jqlContext);
            if (response.data?.items == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            dispatch({
                type: 'success',
                payload: (0, $fOoev.transformInitialData)({
                    data: response.data,
                    formatMessage: formatMessage
                })
            });
        } catch (error) {
            if (error === (0, $NFHn0.ABORTED)) return;
            dispatch({
                type: 'error'
            });
        }
    }, [
        fetchDataAbortable,
        formatMessage,
        groupFieldId,
        jqlContext
    ]);
    return {
        fetch: fetch,
        data: state.data,
        loading: state.loading
    };
};

});
parcelRegister("NFHn0", function(module, exports) {

$parcel$export(module.exports, "ABORTED", () => $f9f77c4f962e82bc$export$23e29024ea698a35);
$parcel$export(module.exports, "useAbortable", () => $f9f77c4f962e82bc$export$a487c7eb4387f959);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");
const $f9f77c4f962e82bc$export$23e29024ea698a35 = Symbol('ABORTED');
const $f9f77c4f962e82bc$export$a487c7eb4387f959 = (fetch)=>{
    const prevControllerRef = (0, $eUqFw.useRef)(null);
    return (0, $eUqFw.useCallback)((...args)=>{
        if (prevControllerRef.current) prevControllerRef.current.abort();
        const controller = new AbortController();
        prevControllerRef.current = controller;
        return fetch(controller.signal, ...args).catch((error)=>{
            if (controller.signal.aborted) throw $f9f77c4f962e82bc$export$23e29024ea698a35;
            else throw error;
        });
    }, [
        fetch
    ]);
};

});

parcelRegister("lKPnc", function(module, exports) {

$parcel$export(module.exports, "fetchGroupItemValues", () => $8489c6f37b087f09$export$7e6e0c3f4468ce45);

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");

var $lRmyA = parcelRequire("lRmyA");

const $8489c6f37b087f09$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows
const $8489c6f37b087f09$export$7e6e0c3f4468ce45 = async (signal, groupFieldId, jqlContext)=>{
    try {
        const variables = {
            fieldId: groupFieldId,
            first: $8489c6f37b087f09$var$MAX_NUMBER_OF_OPTIONS,
            jql: jqlContext
        };
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMFilterValuesByGroupItems', {
            body: JSON.stringify({
                query: (0, $622211c2999f2f37$export$a48313dd44fc9855),
                variables: variables
            })
        });
        return response;
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!(0, $JRB5w.isHttpClientErrorResponse)(error) && !signal.aborted) (0, $guiFP.default)({
            meta: {
                id: 'initializeFilterGroupItemsData',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to initialize filter data using the group query'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $622211c2999f2f37$export$a48313dd44fc9855 = `
query JWMFilterValuesByGroupItems($fieldId: ID!, $jql: String!, $first: Int!) {
  items: jwmItemGroups(jql: $jql, groupByFieldId: $fieldId, fieldIds: [], first: $first) {
    totalCount
    edges {
      node {
        id
        field {
          __typename
          ... on FloatCustomField {
            floatValue
          }
        }
      }
    }
  }
}
`;


parcelRegister("fOoev", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $2b76e62e743cb9ff$export$93219b8691fe49a0);

var $ivaRx = parcelRequire("ivaRx");
const $2b76e62e743cb9ff$export$93219b8691fe49a0 = ({ data: data, formatMessage: formatMessage })=>({
        totalCount: data.items.totalCount,
        options: data.items.edges.map((edge)=>{
            if (edge.node.field.floatValue == null) return {
                value: null,
                label: formatMessage((0, $ivaRx.default).noneOption)
            };
            const stringFloatValue = String(edge.node.field.floatValue);
            return {
                value: stringFloatValue,
                label: stringFloatValue
            };
        })
    });

});
parcelRegister("ivaRx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dd2394f0a911447$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4dd2394f0a911447$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noneOption: {
        "id": "business-filters.controllers.group-item-values.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("ijEQD", function(module, exports) {

$parcel$export(module.exports, "transformPriority", () => $c6e67604bea772f5$export$1b9f55a39456e911);
$parcel$export(module.exports, "transformIssueType", () => $c6e67604bea772f5$export$96520244689f81c1);
$parcel$export(module.exports, "transformStatuses", () => $c6e67604bea772f5$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformUsers", () => $c6e67604bea772f5$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformLabels", () => $c6e67604bea772f5$export$c072126708d93f04);
$parcel$export(module.exports, "transformLabelSuggestions", () => $c6e67604bea772f5$export$cdfcc40760c1a4f8);
$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $c6e67604bea772f5$export$ba4f3d2149c2bf3b);

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");

var $h1vWF = parcelRequire("h1vWF");
const $c6e67604bea772f5$export$1b9f55a39456e911 = (0, $5iWql.default)((priorityFieldConfig)=>[
        ...priorityFieldConfig?.options || []
    ].reduce((acc, next)=>{
        acc.push({
            value: next.name,
            label: next.name,
            avatar: next.iconUrl || ''
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$96520244689f81c1 = (0, $5iWql.default)((issueTypeData)=>issueTypeData.issueTypes.reduce((acc, next)=>{
        acc.push({
            value: next.id,
            label: next.name,
            id: next.id,
            avatar: next.avatarUrl,
            square: true
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$20a57a5ec025f2d = (0, $5iWql.default)((statuses)=>statuses.reduce((acc, next)=>{
        acc.push({
            value: next.untranslatedName,
            label: next.name,
            categoryId: next.statusCategory.id,
            // Board needs the status id as number for client side filtering
            id: Number(next.id)
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$fb8c90bfc4beaa59 = (0, $5iWql.default)((users)=>users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$c072126708d93f04 = (0, $5iWql.default)((labels)=>labels.reduce((acc, next)=>{
        acc.push({
            value: next || '',
            label: next
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$cdfcc40760c1a4f8 = (0, $5iWql.default)((labels)=>labels?.suggestions.reduce((acc, next)=>{
        acc.push({
            value: next.label || '',
            label: next.label
        });
        return acc;
    }, []));
const $c6e67604bea772f5$var$getType = ({ type: type })=>{
    switch(type){
        case 0, $lO4Or.PRIORITY_TYPE:
            return (0, $1run3.FieldType).PrioritySelectFilter;
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return (0, $1run3.FieldType).AvatarAsyncSelectFilter;
        case 0, $lO4Or.ISSUE_TYPE:
            return (0, $1run3.FieldType).AvatarSelectFilter;
        case 0, $lO4Or.STATUS_TYPE:
            return (0, $1run3.FieldType).LozengeSelectFilter;
        case 0, $lO4Or.LABELS_TYPE:
        case 0, $lO4Or.COMPONENTS_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            return (0, $1run3.FieldType).AsyncSelectFilter;
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
        case 0, $lO4Or.DATE_CF_TYPE:
            return (0, $1run3.FieldType).DateFilter;
        case 0, $lO4Or.CATEGORY_TYPE:
            return (0, $1run3.FieldType).CategorySelectFilter;
        case 0, $lO4Or.NUMBER_CF_TYPE:
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
        default:
            return (0, $1run3.FieldType).SelectFilter;
    }
};
const $c6e67604bea772f5$var$getSelectCustomFieldValues = (field)=>(field?.fieldConfig?.selectOptions ?? []).map(({ value: value })=>({
            label: value,
            value: value
        }));
const $c6e67604bea772f5$var$getValues = ({ type: type, fieldOptionsData: fieldOptionsData, field: field, aliasFieldId: aliasFieldId })=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return fieldOptionsData.users;
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            return $c6e67604bea772f5$var$getSelectCustomFieldValues(field);
        case 0, $lO4Or.NUMBER_CF_TYPE:
            if (aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return fieldOptionsData[0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
            return fieldOptionsData[0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID];
        default:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
    }
};
const $c6e67604bea772f5$var$isUserField = (type)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return true;
        default:
            return false;
    }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $c6e67604bea772f5$var$isCustomField = (type)=>(0, $9TEHc.EXTRA_CUSTOM_FIELD_TYPES).has(type);
const $c6e67604bea772f5$var$createUserValueGetter = (userResolver)=>(0, $5iWql.default)((accountIds)=>// @ts-expect-error - TS7006 - Parameter 'response' implicitly has an 'any' type.
        userResolver.getUsersFromAccountId(accountIds).then((response)=>$c6e67604bea772f5$export$fb8c90bfc4beaa59(response)));
const $c6e67604bea772f5$export$ba4f3d2149c2bf3b = ({ formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId = new Set(), allFields: allFields, fieldOptionsData: fieldOptionsData, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, userResolver: userResolver })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $9TEHc.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $h1vWF.default).dateRangeLabel),
        type: (0, $1run3.FieldType).DateFilter
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? '') || allowedAliasFieldId.has(field.aliasFieldId || ''));
    fields.forEach((field)=>{
        const { name: name, type: type, id: id, aliasFieldId: aliasFieldId } = field;
        // if the type is unsupported
        // or it's the start date field (which is handled separately as 'date range')
        // then skip
        if (type == null || aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID)) return;
        const selectType = $c6e67604bea772f5$var$getType({
            type: type
        });
        fieldConfig[id] = {
            systemType: type,
            label: name,
            type: selectType,
            placeholder: formatMessage((0, $h1vWF.default).filterPlaceholder),
            options: $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData,
                field: field,
                aliasFieldId: aliasFieldId
            }),
            isCustomField: $c6e67604bea772f5$var$isCustomField(type),
            fieldConfigVersion: 1
        };
        if (aliasFieldId != null && allowedAliasFieldId.has(aliasFieldId)) fieldConfig[id].aliasFieldId = aliasFieldId;
        if (type === (0, $lO4Or.ISSUE_TYPE)) fieldConfig[id].label = formatMessage((0, $h1vWF.default).typeLabel);
        if ($c6e67604bea772f5$var$isUserField(type)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
            resolvers[id] = $c6e67604bea772f5$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: 'EMPTY',
                    label: formatMessage((0, $h1vWF.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
        }
        if (type === (0, $lO4Or.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.SELECT_CF_TYPE) || type === (0, $lO4Or.MULTI_SELECT_CF_TYPE) || type === (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) fieldConfig[id].options = [
            ...fieldConfig[id].options,
            {
                value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                label: formatMessage((0, $h1vWF.default).noneOption),
                isEmptyOption: true
            }
        ];
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("1run3", function(module, exports) {

$parcel$export(module.exports, "FieldType", () => $0804b64445570a47$export$ed12481c953b8653);
$parcel$export(module.exports, "isDateField", () => $0804b64445570a47$export$7d34c8548269835d);
const $0804b64445570a47$export$ed12481c953b8653 = {
    AsyncSelectFilter: 'AsyncSelectFilter',
    AvatarSelectFilter: 'AvatarSelectFilter',
    AvatarAsyncSelectFilter: 'AvatarAsyncSelectFilter',
    PaginatedAsyncSelectFilter: 'PaginatedAsyncSelectFilter',
    LozengeAsyncSelectFilter: 'LozengeAsyncSelectFilter',
    PaginatedLozengeAsyncSelectFilter: 'PaginatedLozengeAsyncSelectFilter',
    LozengeSelectFilter: 'LozengeSelectFilter',
    PrioritySelectFilter: 'PrioritySelectFilter',
    CategorySelectFilter: 'CategorySelectFilter',
    GoalsSelectFilter: 'GoalsSelectFilter',
    PaginatedAvatarAsyncSelectFilter: 'PaginatedAvatarAsyncSelectFilter',
    NumberFilter: 'NumberFilter',
    SelectFilter: 'SelectFilter',
    SearchFilter: 'SearchFilter',
    TextFilter: 'TextFilter',
    DateFilter: 'DateFilter',
    ProjectFilter: 'ProjectFilter'
};
const $0804b64445570a47$export$7d34c8548269835d = (field)=>field.type === $0804b64445570a47$export$ed12481c953b8653.DateFilter;

});

parcelRegister("h1vWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a86e8a54f0713c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e2a86e8a54f0713c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config.date-range-label",
        "defaultMessage": "Date range"
    },
    typeLabel: {
        "id": "business-filters.controllers.field-config.type-label",
        "defaultMessage": "Type"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noneOption: {
        "id": "business-filters.controllers.field-config.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("aWjLM", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigV2", () => $f0c719cf639dcc71$export$c041141a7ef797c1);

var $eUqFw = parcelRequire("eUqFw");

var $fDLFb = parcelRequire("fDLFb");

var $e20I1 = parcelRequire("e20I1");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $ejYlo = parcelRequire("ejYlo");

var $hLW3I = parcelRequire("hLW3I");

var $jWIW7 = parcelRequire("jWIW7");

var $7goEv = parcelRequire("7goEv");
const $f0c719cf639dcc71$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $f0c719cf639dcc71$var$EMPTY_FILTER_DATA = {
    initialUsers: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialLabels: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialComponents: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialPriorities: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialIssueTypes: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialStatuses: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialCategories: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialSprints: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialFixVersions: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialParents: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialGoals: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialTeams: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA
};
const $f0c719cf639dcc71$var$initialState = {
    data: undefined,
    loadingData: true
};
const $f0c719cf639dcc71$var$reducer = (state, action)=>{
    switch(action.type){
        case 'init':
            return $f0c719cf639dcc71$var$initialState;
        case 'fetch-data-success':
            return {
                ...state,
                data: action.value,
                loadingData: false
            };
        case 'fetch-data-error':
            return {
                ...state,
                data: $f0c719cf639dcc71$var$EMPTY_FILTER_DATA,
                loadingData: false
            };
        default:
            return state;
    }
};
/**
 * useFieldConfig hook that is used to populate the field and field values for JWM Filters.
 * It can be used for JWM Overviews which includes multiple Jira Projects.
 */ const $f0c719cf639dcc71$var$emptyFieldValue = {
    totalCount: 0,
    options: []
};
const $f0c719cf639dcc71$export$c041141a7ef797c1 = ({ view: view, allowedFieldTypes: allowedFieldTypes })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectFieldData = (0, $jWIW7.useProjectFilter)();
    const { data: filterFields, loading: loadingFilterFields } = (0, $hLW3I.useFilterFields)();
    const [{ data: data, loadingData: loadingData }, dispatch] = (0, $eUqFw.useReducer)($f0c719cf639dcc71$var$reducer, $f0c719cf639dcc71$var$initialState);
    const userResolver = (0, $eUqFw.useRef)(new (0, $e20I1.UserResolver)());
    const { fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchUsers: fetchUsers, fetchCategories: fetchCategories, fetchInitialData: fetchInitialData, ...fetchOptions } = (0, $ejYlo.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        filterFields: filterFields
    });
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const businessEntityId = entity.id;
    const initialiseDefaultData = (0, $eUqFw.useCallback)(()=>{
        fetchInitialData().then((initialData)=>{
            dispatch({
                type: 'fetch-data-success',
                value: {
                    initialUsers: initialData?.users ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialLabels: initialData?.labels ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialComponents: initialData?.components ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialPriorities: initialData?.priority ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialIssueTypes: initialData?.issuetype ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialStatuses: initialData?.status ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialCategories: initialData?.[0, $lO4Or.CATEGORY_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialSprints: initialData?.[0, $lO4Or.SPRINT_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
                        initialFixVersions: initialData?.[0, $lO4Or.FIX_VERSIONS_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                        initialParents: initialData?.[0, $lO4Or.PARENT_FIELD_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                        initialTeams: initialData?.[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue
                    } : {},
                    initialGoals: initialData?.[0, $lO4Or.GOALS_CF_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue
                }
            });
        }).catch(()=>{
            dispatch({
                type: 'fetch-data-error'
            });
        });
    }, [
        fetchInitialData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!loadingFilterFields) {
            dispatch({
                type: 'init'
            });
            initialiseDefaultData();
        }
    }, [
        initialiseDefaultData,
        loadingFilterFields,
        businessEntityId
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $eUqFw.useMemo)(()=>{
        const fieldOptionsData = {
            priority: data?.initialPriorities ?? $f0c719cf639dcc71$var$emptyFieldValue,
            issuetype: data?.initialIssueTypes ?? $f0c719cf639dcc71$var$emptyFieldValue,
            status: data?.initialStatuses ?? $f0c719cf639dcc71$var$emptyFieldValue,
            users: data?.initialUsers ?? $f0c719cf639dcc71$var$emptyFieldValue,
            labels: data?.initialLabels ?? $f0c719cf639dcc71$var$emptyFieldValue,
            components: data?.initialComponents ?? $f0c719cf639dcc71$var$emptyFieldValue,
            [(0, $lO4Or.CATEGORY_TYPE)]: data?.initialCategories ?? $f0c719cf639dcc71$var$emptyFieldValue,
            [(0, $lO4Or.SPRINT_TYPE)]: data?.initialSprints ?? $f0c719cf639dcc71$var$emptyFieldValue,
            project: projectFieldData,
            ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
                [(0, $lO4Or.FIX_VERSIONS_TYPE)]: data?.initialFixVersions ?? $f0c719cf639dcc71$var$emptyFieldValue,
                [(0, $lO4Or.PARENT_FIELD_TYPE)]: data?.initialParents ?? $f0c719cf639dcc71$var$emptyFieldValue,
                [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: data?.initialTeams ?? $f0c719cf639dcc71$var$emptyFieldValue
            } : {},
            [(0, $lO4Or.GOALS_CF_TYPE)]: data?.initialGoals ?? $f0c719cf639dcc71$var$emptyFieldValue
        };
        return (0, $7goEv.getFilterFieldConfigAndResolvers)({
            view: view,
            formatMessage: formatMessage,
            allFields: filterFields,
            allowedFieldTypes: allowedFieldTypes,
            fieldOptionsData: fieldOptionsData,
            fetchUsers: fetchUsers,
            fetchLabels: fetchLabels,
            fetchComponents: fetchComponents,
            fetchCategories: fetchCategories,
            ...fetchOptions,
            userResolver: userResolver.current
        });
    }, [
        data?.initialPriorities,
        data?.initialIssueTypes,
        data?.initialStatuses,
        data?.initialUsers,
        data?.initialLabels,
        data?.initialComponents,
        data?.initialCategories,
        data?.initialSprints,
        data?.initialFixVersions,
        data?.initialParents,
        data?.initialGoals,
        data?.initialTeams,
        projectFieldData,
        view,
        formatMessage,
        filterFields,
        allowedFieldTypes,
        fetchUsers,
        fetchLabels,
        fetchComponents,
        fetchCategories,
        fetchOptions
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingData || loadingFilterFields || data == null
    };
};

});
parcelRegister("7goEv", function(module, exports) {

$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $1ffbd75d284f79d7$export$ba4f3d2149c2bf3b);

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");

var $9Jtgc = parcelRequire("9Jtgc");
const $1ffbd75d284f79d7$export$fb8c90bfc4beaa59 = (0, $5iWql.default)((users)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $1ffbd75d284f79d7$var$getType = (type)=>{
    switch(type){
        case 0, $lO4Or.CATEGORY_TYPE:
            return (0, $1run3.FieldType).CategorySelectFilter;
        case 0, $lO4Or.PRIORITY_TYPE:
            return (0, $1run3.FieldType).PrioritySelectFilter;
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return (0, $1run3.FieldType).AvatarAsyncSelectFilter;
        case 0, $lO4Or.ISSUE_TYPE:
        case 0, $lO4Or.PARENT_FIELD_TYPE:
        case 0, $lO4Or.TEAMS_PLATFORM_CF_TYPE:
            return (0, $1run3.FieldType).AvatarSelectFilter;
        case 0, $lO4Or.STATUS_TYPE:
            return (0, $1run3.FieldType).LozengeSelectFilter;
        case 0, $lO4Or.LABELS_TYPE:
        case 0, $lO4Or.COMPONENTS_TYPE:
        case 0, $lO4Or.FIX_VERSIONS_TYPE:
        case 0, $lO4Or.SPRINT_TYPE:
            return (0, $1run3.FieldType).AsyncSelectFilter;
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
            return (0, $1run3.FieldType).DateFilter;
        case 0, $lO4Or.PROJECT_TYPE:
            return (0, $1run3.FieldType).ProjectFilter;
        case 0, $lO4Or.GOALS_CF_TYPE:
            return (0, $1run3.FieldType).GoalsSelectFilter;
        default:
            return (0, $1run3.FieldType).SelectFilter;
    }
};
const $1ffbd75d284f79d7$var$getValues = (type, fieldOptionsData)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return fieldOptionsData.users;
        default:
            return fieldOptionsData[type];
    }
};
const $1ffbd75d284f79d7$var$isUserField = (type)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $1ffbd75d284f79d7$var$isCustomField = (type)=>{
    switch(type){
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $1ffbd75d284f79d7$var$createUserValueGetter = (userResolver)=>(0, $5iWql.default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((response)=>$1ffbd75d284f79d7$export$fb8c90bfc4beaa59(response)));
const $1ffbd75d284f79d7$export$ba4f3d2149c2bf3b = ({ view: view, formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allFields: allFields, fieldOptionsData: fieldOptionsData, userResolver: userResolver, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, fetchStatuses: fetchStatuses, fetchPriorities: fetchPriorities, fetchIssueTypes: fetchIssueTypes, fetchSprints: fetchSprints, fetchFixVersions: fetchFixVersions, fetchParents: fetchParents, fetchGoals: fetchGoals, fetchTeams: fetchTeams })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $9TEHc.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $9Jtgc.default).dateRangeLabel),
        type: (0, $1run3.FieldType).DateFilter,
        fromLabel: formatMessage((0, $9Jtgc.default).startDateLabel),
        toLabel: formatMessage((0, $9Jtgc.default).dueDateLabel)
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? ''));
    // eslint-disable-next-line complexity
    fields.forEach((field)=>{
        const { name: name, type: type, id: id } = field;
        const fieldType = type ?? '';
        const fieldValues = $1ffbd75d284f79d7$var$getValues(fieldType, fieldOptionsData);
        fieldConfig[id] = {
            label: name,
            type: $1ffbd75d284f79d7$var$getType(fieldType),
            placeholder: formatMessage((0, $9Jtgc.default).filterPlaceholder),
            options: fieldValues?.options || [],
            totalCount: fieldValues?.totalCount || 0,
            isCustomField: $1ffbd75d284f79d7$var$isCustomField(fieldType),
            fieldConfigVersion: 2
        };
        // issue type
        if (type === (0, $lO4Or.ISSUE_TYPE)) {
            let options = fieldValues?.options || [];
            if (view === 'board') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                options = (fieldValues?.options).filter((option)=>option.hierarchyLevel !== -1);
                fieldConfig[id].options = options;
            }
            if (fetchIssueTypes) {
                fieldConfig[id].loadOptions = fetchIssueTypes;
                fieldConfig[id].defaultOptions = options;
            }
        } else if ($1ffbd75d284f79d7$var$isUserField(fieldType)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            resolvers[id] = $1ffbd75d284f79d7$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noLabelsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noComponentsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noCategoriesLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.STATUS_TYPE) && fetchStatuses) {
            fieldConfig[id].loadOptions = fetchStatuses;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $lO4Or.PRIORITY_TYPE) && fetchPriorities) {
            fieldConfig[id].loadOptions = fetchPriorities;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $lO4Or.SPRINT_TYPE) && fetchSprints) {
            fieldConfig[id].loadOptions = fetchSprints;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noSprintLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.FIX_VERSIONS_TYPE) && fetchFixVersions && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchFixVersions;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noVersionLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.PARENT_FIELD_TYPE) && fetchParents && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchParents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noParentLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.GOALS_CF_TYPE) && fetchGoals) {
            fieldConfig[id].loadOptions = fetchGoals;
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noGoalLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fetchTeams && fieldType === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchTeams;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noTeamLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        }
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("9Jtgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $510082940a52668b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $510082940a52668b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config-v2.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config-v2.date-range-label",
        "defaultMessage": "Date range"
    },
    startDateLabel: {
        "id": "business-filters.controllers.field-config-v2.start-date-label",
        "defaultMessage": "Start date"
    },
    dueDateLabel: {
        "id": "business-filters.controllers.field-config-v2.due-date-label",
        "defaultMessage": "Due date"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config-v2.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noLabelsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-labels-label",
        "defaultMessage": "No label"
    },
    noCategoriesLabel: {
        "id": "business-filters.controllers.field-config-v2.no-categories-label",
        "defaultMessage": "No category"
    },
    noComponentsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-components-label",
        "defaultMessage": "No component"
    },
    noSprintLabel: {
        "id": "business-filters.controllers.field-config-v2.no-sprint-label",
        "defaultMessage": "Backlog"
    },
    noVersionLabel: {
        "id": "business-filters.controllers.field-config-v2.no-version-label",
        "defaultMessage": "No version"
    },
    noParentLabel: {
        "id": "business-filters.controllers.field-config-v2.no-parent-label",
        "defaultMessage": "No parent"
    },
    noGoalLabel: {
        "id": "business-filters.controllers.field-config-v2.no-goal-label",
        "defaultMessage": "No goal"
    },
    noTeamLabel: {
        "id": "business-filters.controllers.field-config-v2.no-team-label",
        "defaultMessage": "No team"
    }
});

});




parcelRegister("coMWQ", function(module, exports) {

$parcel$export(module.exports, "deserialiseJql", () => $67199c690c914c16$export$214464255b766962);

var $hir2i = parcelRequire("hir2i");

var $27QuD = parcelRequire("27QuD");

var $9FEvp = parcelRequire("9FEvp");

var $6x1NF = parcelRequire("6x1NF");

var $6RWCB = parcelRequire("6RWCB");
var $bXcc5 = parcelRequire("bXcc5");
var $k85ht = parcelRequire("k85ht");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");
const $67199c690c914c16$var$START_DATE_JQL = 'Start date[Date]';
const $67199c690c914c16$var$EMPTY = 'EMPTY';
const $67199c690c914c16$var$cleanString = (value)=>value.trim();
// some filters should display options retrieved from the URL parameters even when they are not returned amongst the useFieldConfig field values
const $67199c690c914c16$var$shouldIncludeUnknownOption = (filterField)=>{
    const allowedFieldTypes = new Set([
        (0, $lO4Or.COMPONENTS_TYPE),
        (0, $lO4Or.LABELS_TYPE),
        (0, $lO4Or.PRIORITY_TYPE),
        (0, $lO4Or.CATEGORY_TYPE)
    ]);
    return allowedFieldTypes.has(filterField?.type ?? '');
};
const $67199c690c914c16$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $67199c690c914c16$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $67199c690c914c16$var$transformIntoOptions = async (list, field, resolver, filterField)=>{
    if (resolver && typeof resolver === 'function') {
        const ids = list.map((value)=>(0, $eI5EY.fg)('wanjel-fix-filters-including-whitespace') ? value : $67199c690c914c16$var$cleanString(value));
        return resolver(ids);
    }
    const allowUnknownOption = $67199c690c914c16$var$shouldIncludeUnknownOption(filterField);
    return list.map((value)=>{
        const cleanValue = (0, $eI5EY.fg)('wanjel-fix-filters-including-whitespace') ? value : $67199c690c914c16$var$cleanString(value);
        if (field && !(0, $1run3.isDateField)(field) && Array.isArray(field.options)) {
            const optionInField = field.options.find((option)=>{
                if ((option == null || option.value == null) && !option.isEmptyOption) return null;
                if (option.isEmptyOption) return value === $67199c690c914c16$var$EMPTY;
                return option.value === cleanValue;
            });
            if (!optionInField && allowUnknownOption) return {
                value: cleanValue,
                label: cleanValue
            };
            return optionInField;
        }
        return undefined;
    }).filter((item)=>item != null && 'value' in item);
};
class $67199c690c914c16$export$5299115fe71e8b39 extends (0, $6RWCB.AbstractJastVisitor) {
    constructor(fieldConfig, filterFields, resolvers){
        super();
        this.getOption = (fieldName, items)=>$67199c690c914c16$var$transformIntoOptions(items, this.fieldConfig[fieldName], this.resolvers[fieldName], this.filterFields.find((field)=>field.id === fieldName));
        this.visitCompoundClause = (compoundClause)=>{
            const clauseMap = Promise.resolve({});
            const operator = compoundClause.operator.value;
            if (operator === (0, $e5bc650799ce4838$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), clauseMap);
            throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
        };
        this.parseDateOperand = (operator, operand)=>{
            if (operand?.operandType === (0, $807962b43ef03b56$export$38accfc5a5d1c113)) {
                let date = (0, $6x1NF.default)(new Date(operand.value), 'UTC', 'yyyy-MM-dd');
                if (operator.value === (0, $k85ht.OPERATOR_LT)) date = (0, $6x1NF.default)((0, $9FEvp.default)(new Date(operand.value), 1), 'UTC', 'yyyy-MM-dd');
                const dateType = operator.value === (0, $k85ht.OPERATOR_LT) ? 'to' : 'from';
                return {
                    value: {
                        [dateType]: date
                    }
                };
            }
            throw new Error(`JQL cannot parse date operand type: ${operand.operandType}`);
        };
        this.parseSelectOperand = async (fieldName, operand)=>{
            if (operand?.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df)) {
                const optionPromises = operand.values.flatMap((value)=>this.parseSelectOperand(fieldName, value));
                return (await Promise.all(optionPromises)).flatMap((option)=>option);
            }
            if (operand?.operandType === (0, $807962b43ef03b56$export$38accfc5a5d1c113)) return this.getOption(fieldName, [
                operand.value
            ]);
            if (operand?.operandType === (0, $807962b43ef03b56$export$f6049126fd97001f)) return [
                {
                    isEmptyOption: true,
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: ''
                }
            ];
            throw new Error(`JQL cannot parse select operand type: ${operand.operandType}`);
        };
        this.visitTerminalClause = async (terminalClause)=>{
            const { field: field, operand: operand, operator: operator } = terminalClause;
            if (!operand || !operator) return Promise.resolve({});
            const getShouldConvertCustomField = (fieldName)=>// should convert cf[] -> customfield_ if it's not a field from version 2
                !(this.fieldConfig[fieldName] && this.fieldConfig[fieldName].fieldConfigVersion === 2);
            const fieldName = $67199c690c914c16$var$getFieldIdFromJql(field.value, getShouldConvertCustomField);
            if (!Object.keys(this.fieldConfig).includes(fieldName)) throw new Error(`JQL contains unsupported fields: ${fieldName}`);
            let value = [];
            if (operator.value === (0, $k85ht.OPERATOR_GT_EQUALS) || operator.value === (0, $k85ht.OPERATOR_LT)) value = this.parseDateOperand(operator, operand);
            else if (operator.value === (0, $k85ht.OPERATOR_EQUALS) || operator.value === (0, $k85ht.OPERATOR_IN)) value = await this.parseSelectOperand(fieldName, operand);
            else throw new Error(`JQL contains unsupported operator in terminal clause: ${operator.value}`);
            return {
                [fieldName]: value
            };
        };
        this.fieldConfig = fieldConfig;
        this.filterFields = filterFields;
        this.resolvers = resolvers;
    }
    visitNotClause() {
        throw new Error('JQL contains invalid clause: NOT');
    }
    defaultResult() {
        return Promise.resolve({});
    }
    /**
	 * @param aggregate new ClauseMap to add into nextResult
	 * @param nextResult ClauseMap with previous results
	 * @returns ClauseMap with the merged results adding the aggregate at the end
	 */ async aggregateResult(aggregate, nextResult) {
        // First parameter is the object where we want to add the values and the second the new values to merge into the first object.
        return (0, (/*@__PURE__*/$parcel$interopDefault($hir2i)))(await nextResult, await aggregate, (destValue, srcValue)=>{
            if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
            return undefined;
        });
    }
}
const $67199c690c914c16$export$214464255b766962 = async (jql, fieldConfig, filterFields, resolvers)=>{
    // Create the syntax tree for the filters JQL
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query?.orderBy != null) throw new Error('JQL contains unsupported ORDER BY');
    // Parse the JQL AST into a FilterType object
    const parser = new $67199c690c914c16$export$5299115fe71e8b39(fieldConfig, filterFields, resolvers);
    const parsedJql = await jast.query?.accept(parser);
    return parsedJql ?? {};
};

});
parcelRegister("hir2i", function(module, exports) {

var $eljWd = parcelRequire("eljWd");

var $3Bqj8 = parcelRequire("3Bqj8");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $c97916e8180d3b9a$var$mergeWith = $3Bqj8(function(object, source, srcIndex, customizer) {
    $eljWd(object, source, srcIndex, customizer);
});
module.exports = $c97916e8180d3b9a$var$mergeWith;

});



parcelRegister("27zPy", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $d758afbde8c38bbf$export$479f0f2f71193efe);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $cqv89 = parcelRequire("cqv89");

var $hEiVl = parcelRequire("hEiVl");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d758afbde8c38bbf$var$LazyMenuContent = (0, $7rh0R.lazy)(()=>(parcelRequire("cXmNO")), {
    moduleId: "./src/packages/business/shared/components/filters/src/ui/filters/menu-content/main.tsx"
});
const $d758afbde8c38bbf$export$479f0f2f71193efe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hEiVl.DropdownWrapper), {
        "data-testid": "business-filters.ui.filters.menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cqv89.MenuFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d758afbde8c38bbf$var$LazyMenuContent, props)));

});
parcelRegister("cqv89", function(module, exports) {

$parcel$export(module.exports, "MenuFallback", () => $d72c10a0e4505968$export$1198e585d599d03);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $d72c10a0e4505968$export$1198e585d599d03 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d72c10a0e4505968$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium",
        testId: "business-filters.common.ui.menu-fallback.spinner"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d72c10a0e4505968$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hEiVl", function(module, exports) {

$parcel$export(module.exports, "DropdownWrapper", () => $5348b95debef5641$export$5f7211d21bfdae05);
$parcel$export(module.exports, "ScrollableContent", () => $5348b95debef5641$export$6c560fdadeb11d78);
$parcel$export(module.exports, "DropdownHeaderWrapper", () => $5348b95debef5641$export$e23294aded7a8a49);
$parcel$export(module.exports, "DropdownHeaderButtons", () => $5348b95debef5641$export$53ca7a3701b98335);
$parcel$export(module.exports, "FiltersListSeparator", () => $5348b95debef5641$export$1a67069896d998b9);
$parcel$export(module.exports, "FiltersListWrapper", () => $5348b95debef5641$export$a5a9080bd2c85987);
$parcel$export(module.exports, "Section", () => $5348b95debef5641$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "LastSection", () => $5348b95debef5641$export$1faf3c7558df435);
$parcel$export(module.exports, "SectionMessageWrapper", () => $5348b95debef5641$export$c5e20d5e200edfe2);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $9TEHc = parcelRequire("9TEHc");
const $5348b95debef5641$var$DROPDOWN_HEADER_HEIGHT = 52;
const $5348b95debef5641$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
const $5348b95debef5641$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91gwv",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$6c560fdadeb11d78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uik9ob": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(${__cmplp.offsetTop && __cmplp.offsetTop > (0, $9TEHc.POPUP_OFFSET_TOP) ? '95vh' : '85vh'} - ${// dynamically calculating offsetTop on popup mount
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (__cmplp.offsetTop ?? (0, $9TEHc.POPUP_OFFSET_TOP)) + $5348b95debef5641$var$DROPDOWN_HEADER_HEIGHT}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug _18m91wug _ln19p27b _c71l1pam",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$e23294aded7a8a49 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { stickyHeader: stickyHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bhr _2rko1sit _1pbykb7n _kqswh2mm _1yt4jd10 _1e0c1txw _1bah1yb4 _4cvr1h6o _11c8qk37",
            __cmplp.stickyHeader ? "_16qsf7oa" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$53ca7a3701b98335 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$1a67069896d998b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3do13y8 _18s81alc",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$a5a9080bd2c85987 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1gwv",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulp1f4h _n3td1f4h",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$1faf3c7558df435 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $5348b95debef5641$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdidpf _zulpidpf",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$c5e20d5e200edfe2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cXmNO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8LeNQ")
]).then(()=>parcelRequire('fTzDz'));

});


parcelRegister("6M6Pf", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $70b788e25198d514$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $4ki2H = parcelRequire("4ki2H");

var $c6CvK = parcelRequire("c6CvK");

var $lGiWG = parcelRequire("lGiWG");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $lwKJI = parcelRequire("lwKJI");
const $70b788e25198d514$var$FILTER_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ki2H))), {
    label: "",
    size: "small"
});
const $70b788e25198d514$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, withThemedButton: withThemedButton = true, isDisabled: isDisabled, appearance: appearance = 'subtle', ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filterMessageOld = (0, $eUqFw.useMemo)(()=>{
        if (count > 0) return formatMessage((0, $lwKJI.default).filtersCount, {
            filters: count
        });
        if (hasFiltersApplied) return formatMessage((0, $lwKJI.default).buttonWithFilters);
        return formatMessage((0, $lwKJI.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied
    ]);
    const filterMessage = (0, $eUqFw.useMemo)(()=>{
        if (hasFiltersApplied && count === 0) return formatMessage((0, $lwKJI.default).buttonWithFilters);
        return formatMessage((0, $lwKJI.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied
    ]);
    const TriggerButton = withThemedButton ? (0, $lGiWG.ThemedButton) : (0, $7u4fN.default);
    return (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TriggerButton, {
        ...otherProps,
        "aria-label": formatMessage((0, $lwKJI.default).filtersCount, {
            filters: count
        }),
        ref: ref,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        testId: "business-filters.ui.filters.trigger.button-wrapper",
        iconAfter: count === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6CvK))), {
            label: "",
            color: "currentColor"
        }) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70b788e25198d514$var$ButtonContents, null, filterMessage, count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70b788e25198d514$var$BadgeContents, null, count))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TriggerButton, {
        ...otherProps,
        ref: ref,
        testId: "business-filters.ui.filters.trigger.button-wrapper",
        iconBefore: $70b788e25198d514$var$FILTER_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: (0, $eI5EY.fg)('jira-calendar-business-theme') ? appearance : 'subtle',
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70b788e25198d514$var$ButtonContents, null, filterMessageOld));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70b788e25198d514$var$ButtonContents = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _zulp12x7 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $70b788e25198d514$var$BadgeContents = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _bfhk13cp _ca0qidpf _u5f36mu8 _n3tdidpf _19bv6mu8 _4t3i1j6v _1ul91j6v _2rkogqwt _11c81oud",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lwKJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $142e1a2d3eb527a7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $142e1a2d3eb527a7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filtersCount: {
        "id": "business-filters.filters.trigger.filters-count",
        "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
    },
    filterButton: {
        "id": "business-filters.filters.trigger.filter-button",
        "defaultMessage": "Filter"
    },
    buttonWithFilters: {
        "id": "business-filters.filters.trigger.button-with-filters",
        "defaultMessage": "Filters applied"
    },
    newLozenge: {
        "id": "business-filters.filters.trigger.new-lozenge",
        "defaultMessage": "New"
    },
    newLozengeTooltip: {
        "id": "business-filters.filters.trigger.new-lozenge-tooltip",
        "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
    }
});

});



parcelRegister("d9gm1", function(module, exports) {

$parcel$export(module.exports, "SimpleSearchTextField", () => $2ba7b21880f0a587$export$63f96dda4bd4f7dc);
$parcel$export(module.exports, "SimpleSearchField", () => $2ba7b21880f0a587$export$44e8ccf3428dc1d5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j9fWg = parcelRequire("j9fWg");

var $02Sz7 = parcelRequire("02Sz7");

var $9IsWp = parcelRequire("9IsWp");

var $jWuk1 = parcelRequire("jWuk1");

var $dsroq = parcelRequire("dsroq");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");


var $kar7l = parcelRequire("kar7l");

var $c1K7Q = parcelRequire("c1K7Q");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jdHI = parcelRequire("2jdHI");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8rQuz = parcelRequire("8rQuz");

var $9JEYY = parcelRequire("9JEYY");

var $96etS = parcelRequire("96etS");

var $j33Mg = parcelRequire("j33Mg");
const $2ba7b21880f0a587$var$SEARCH_FIELD_WIDTH = 184;
const $2ba7b21880f0a587$export$63f96dda4bd4f7dc = /*#__PURE__*/ (0, $eUqFw.memo)(({ inputRef: inputRef, placeholder: placeholder, value: externalValue = '', onChange: onChange, onFocus: onFocus, view: view, testId: testId, isDisabled: isDisabled, label: label, describedbyId: describedbyId, themedField: themedField = true, isFullWidth: isFullWidth = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [searchValue, setSearchValue] = (0, $eUqFw.useState)(externalValue);
    const handleSearchChange = (0, $eUqFw.useCallback)((newValue)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField updated', {
            view: view,
            ...(0, $9JEYY.getTextFieldAttributes)(newValue)
        });
        onChange(newValue);
    }, [
        createAnalyticsEvent,
        onChange,
        view
    ]);
    const [handleSearchChangeDebounced] = (0, $2jdHI.default)(handleSearchChange, 500);
    const handleChange = (0, $eUqFw.useCallback)((e)=>{
        setSearchValue(e.target.value);
        handleSearchChangeDebounced(e.target.value);
    }, [
        handleSearchChangeDebounced
    ]);
    const handleClear = (0, $eUqFw.useCallback)(()=>{
        setSearchValue('');
        handleSearchChangeDebounced('');
    }, [
        setSearchValue,
        handleSearchChangeDebounced
    ]);
    const themedIconPrimaryColor = isDisabled ? (0, $kar7l.Tokens).COLOR_TEXT_DISABLED : (0, $kar7l.Tokens).COLOR_TEXT_SUBTLEST;
    const Container = themedField ? $2ba7b21880f0a587$var$ThemedContainer : (0, $eUqFw.Fragment);
    (0, $eUqFw.useEffect)(()=>{
        setSearchValue(externalValue);
    }, [
        externalValue
    ]);
    const elemAfterSearchIcon = !(0, $8rQuz.isVisualRefreshEnabled)() ? // this will be clean up through visual-refresh cleaning
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
        label: "",
        size: "small",
        primaryColor: themedField ? themedIconPrimaryColor : undefined
    }) : null;
    let textFieldWidth;
    if ((0, $8rQuz.isVisualRefreshEnabled)()) textFieldWidth = isFullWidth ? '100%' : $2ba7b21880f0a587$var$SEARCH_FIELD_WIDTH;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ref: inputRef,
        ...(0, $c1K7Q.generateDataTestId)('searchfield'),
        "aria-describedby": describedbyId,
        testId: testId,
        value: searchValue,
        isCompact: true,
        placeholder: formatMessage(placeholder),
        "aria-label": label || formatMessage(placeholder),
        onChange: handleChange,
        onFocus: onFocus,
        isDisabled: isDisabled,
        elemAfterInput: searchValue !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingInlineEnd: (0, $8rQuz.isVisualRefreshEnabled)() ? 'space.025' : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            icon: (iconProps)=>(0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($02Sz7))), {
                    ...iconProps,
                    label: formatMessage((0, $j33Mg.default).clear),
                    spacing: "none",
                    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`
                }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
                    ...iconProps,
                    size: "small",
                    primaryColor: themedField ? themedIconPrimaryColor : undefined
                }),
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, $j33Mg.default).clear),
            testId: "business-filters.ui.simple-search-field.clear-button",
            onClick: handleClear
        })) : elemAfterSearchIcon,
        elemBeforeInput: (0, $8rQuz.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $2ba7b21880f0a587$var$iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9IsWp))), {
            color: "currentColor",
            label: "",
            spacing: "none"
        })),
        width: textFieldWidth,
        className: (0, $7JEyt.default)([
            !(0, $8rQuz.isVisualRefreshEnabled)() && "_dzcou2gc"
        ])
    }));
});
const $2ba7b21880f0a587$export$44e8ccf3428dc1d5 = /*#__PURE__*/ (0, $eUqFw.memo)(({ placeholder: placeholder, view: view, describedbyId: describedbyId, onChange: onChange })=>{
    const [simpleSearch, setSimpleSearch] = (0, $96etS.useSimpleSearch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleFocus = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField focused', {
            view: view
        });
    }, [
        createAnalyticsEvent,
        view
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('timeline-collapse-expand-all_61d00') && onChange) onChange(simpleSearch);
    }, [
        onChange,
        simpleSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ba7b21880f0a587$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ba7b21880f0a587$export$63f96dda4bd4f7dc, {
        view: view,
        onFocus: handleFocus,
        describedbyId: describedbyId,
        onChange: (text)=>{
            if ((0, $1ybV0.ff)('timeline-collapse-expand-all_61d00') && onChange) onChange(text);
            return setSimpleSearch(text);
        },
        value: simpleSearch,
        placeholder: placeholder
    }));
});
const $2ba7b21880f0a587$var$textFieldStyles = null;
const $2ba7b21880f0a587$var$iconStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    marginLeft: 'space.075'
}); /* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ba7b21880f0a587$var$ThemedContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_6l8r1oay _x2xk1oay _sg3v1oay _w15a1oay _n8yf1v8d _jeiekwex _7n831c2q _1o8hu22k _n2ulgr9p",
            __cmplp.className
        ])
    });
}); /* eslint-enable @atlaskit/design-system/no-unsafe-design-token-usage */ 
const $2ba7b21880f0a587$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("c1K7Q", function(module, exports) {

$parcel$export(module.exports, "generateDataTestId", () => $9d0a034fe3d4cf2e$export$7de5661ad251801);

var $1ybV0 = parcelRequire("1ybV0");
const $9d0a034fe3d4cf2e$var$DISABLED = 'disabled';
const $9d0a034fe3d4cf2e$var$DUPLICATED = 'duplicated';
const $9d0a034fe3d4cf2e$var$REPLACED = 'replaced';
const $9d0a034fe3d4cf2e$var$DEFAULT_FF = 'replace-data-test-id-with-data-testid-in-bento-m2';
const $9d0a034fe3d4cf2e$var$getDataTestIdFlagValue = (featureFlag = $9d0a034fe3d4cf2e$var$DEFAULT_FF)=>// eslint-disable-next-line jira/ff/static-feature-flags
    (0, $1ybV0.getMultivariateFeatureFlag)(featureFlag, $9d0a034fe3d4cf2e$var$DISABLED, [
        $9d0a034fe3d4cf2e$var$DISABLED,
        $9d0a034fe3d4cf2e$var$DUPLICATED,
        $9d0a034fe3d4cf2e$var$REPLACED
    ]);
const $9d0a034fe3d4cf2e$export$7de5661ad251801 = (testId, featureFlag = $9d0a034fe3d4cf2e$var$DEFAULT_FF)=>{
    const flagValue = $9d0a034fe3d4cf2e$var$getDataTestIdFlagValue(featureFlag);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let testIdProps = {};
    switch(flagValue){
        case 'duplicated':
            testIdProps = {
                'data-test-id': testId,
                'data-testid': testId
            };
            break;
        case 'replaced':
            testIdProps = {
                'data-testid': testId
            };
            break;
        case 'disabled':
        default:
            testIdProps = {
                'data-test-id': testId
            };
            break;
    }
    return testIdProps;
};

});

parcelRegister("2jdHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3243fa342b695d88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
function $3243fa342b695d88$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eUqFw.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eUqFw.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eUqFw.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("9JEYY", function(module, exports) {

$parcel$export(module.exports, "getTextFieldAttributes", () => $98a728a18d600acd$export$dfd7972bcd113afb);
const $98a728a18d600acd$export$dfd7972bcd113afb = (value = '')=>{
    const wordCount = value.split(/s+/).filter((word)=>word !== '').length;
    return {
        queryLength: value.length,
        wordCount: wordCount
    };
};

});

parcelRegister("j33Mg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6d42843abbf146$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7a6d42843abbf146$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "business-filters.simple-search-field.clear",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("bSsl1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf2ff9f75b0cc835$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $3f7Cz = parcelRequire("3f7Cz");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("4Htg3")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/invite-people/src/ui/add-people-with-avatars/main.tsx"
});
const $cf2ff9f75b0cc835$var$AddPeopleWithAvatar = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-business.invite-people.add-people-with-avatars",
        packageName: "jiraBusinessInvitePeople",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "invite-button-with-avatars",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$AvatarFallback, null)
    }, props?.hasInviteButton === false ? // not including the Add People provider if the invite button is not needed
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3f7Cz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars, props))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf2ff9f75b0cc835$var$AvatarFallback = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp",
            __cmplp.className
        ])
    });
});
var $cf2ff9f75b0cc835$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($cf2ff9f75b0cc835$var$AddPeopleWithAvatar);

});
parcelRegister("3f7Cz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5829e6ed86dc42e3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5GxEP = parcelRequire("5GxEP");

var $bvGWz = parcelRequire("bvGWz");

var $3MjJX = parcelRequire("3MjJX");
const $5829e6ed86dc42e3$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
    const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, $bvGWz.useAddPeople)();
    if (isModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MjJX.ProjectInvitePeopleModal), {
        onModalClose: closeAddPeopleModal,
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    });
    return null;
};
const $5829e6ed86dc42e3$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bvGWz.AddPeopleProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "jira-business.invite-people.ui.add-people",
        packageName: "jira-business.invite-people.ui.add-people",
        teamName: "jira-warepil"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$InviteWrapper, {
        "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$AddPeopleModal, {
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    }))));
var $5829e6ed86dc42e3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5829e6ed86dc42e3$var$AddPeople);
// this wrapper prevents the modal component to inherit any css logic from its parent, which could cause interferences in the consumer's UI
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5829e6ed86dc42e3$var$InviteWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bvGWz", function(module, exports) {

$parcel$export(module.exports, "AddPeopleProvider", () => $f3a4a647f29aa9d7$export$6d41c2327e862d9d);
$parcel$export(module.exports, "useAddPeople", () => $f3a4a647f29aa9d7$export$93ea361ec674cff6);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $f3a4a647f29aa9d7$var$AddPeopleContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    triggerBtnRef: {
        current: null
    },
    isModalOpen: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openAddPeopleModal: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeAddPeopleModal: ()=>{}
});
const $f3a4a647f29aa9d7$export$6d41c2327e862d9d = ({ children: children })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const triggerBtnRef = (0, $eUqFw.useRef)(null);
    const onCloseCallbackRef = (0, $eUqFw.useRef)();
    const openAddPeopleModal = (0, $eUqFw.useCallback)((onClose, source)=>{
        setIsModalOpen(true);
        const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
            source: source
        });
        if (onClose) onCloseCallbackRef.current = onClose;
    }, [
        createAnalyticsEvent,
        projectData.isSimplified
    ]);
    const closeAddPeopleModal = (0, $eUqFw.useCallback)(()=>{
        setIsModalOpen(false);
        if (typeof onCloseCallbackRef.current === 'function') {
            onCloseCallbackRef.current();
            onCloseCallbackRef.current = null;
        }
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            triggerBtnRef: triggerBtnRef,
            isModalOpen: isModalOpen,
            openAddPeopleModal: openAddPeopleModal,
            closeAddPeopleModal: closeAddPeopleModal
        }), [
        triggerBtnRef,
        isModalOpen,
        openAddPeopleModal,
        closeAddPeopleModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3a4a647f29aa9d7$var$AddPeopleContext.Provider, {
        value: context
    }, children);
};
const $f3a4a647f29aa9d7$export$93ea361ec674cff6 = ()=>(0, $eUqFw.useContext)($f3a4a647f29aa9d7$var$AddPeopleContext);

});

parcelRegister("3MjJX", function(module, exports) {

$parcel$export(module.exports, "ProjectInvitePeopleModal", () => $1368af08b2bd60b0$export$6dfea89767cb5ac1);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $hlZx3 = parcelRequire("hlZx3");

var $66rnh = parcelRequire("66rnh");

var $d1I0W = parcelRequire("d1I0W");
const $1368af08b2bd60b0$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, $hlZx3.useInviteModalHandlers)();
    if (!shouldUseInvitePeopleModal && projectData.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66rnh.AddPeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d1I0W.InvitePeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError,
        source: source
    });
};

});
parcelRegister("hlZx3", function(module, exports) {

$parcel$export(module.exports, "useInviteModalHandlers", () => $72fe370f230f9c2c$export$f696e14fc423d0b);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");


var $f90H0 = parcelRequire("f90H0");

var $bLjrh = parcelRequire("bLjrh");
const $72fe370f230f9c2c$export$f696e14fc423d0b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const projectData = (0, $kQAZu.useProject)();
    const handleAddSuccess = (0, $eUqFw.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
        const hasSentInvitation = inviteStatus === (0, $f90H0.InvitationStatusEnum).INVITED;
        const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
        showFlag(hasSuccessfullyAddedPeople ? (0, $bLjrh.createAddSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            projectKey: projectData.key
        }) : (0, $bLjrh.createInviteSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            hasSentInvitation: hasSentInvitation
        }));
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
            inviteStatus: inviteStatus
        });
    }, [
        createAnalyticsEvent,
        showFlag,
        projectData
    ]);
    const handleError = (0, $eUqFw.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$4e427f77b64bbbed)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$20ef020abfaa9ec))) {
            showFlag((0, $bLjrh.createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
            return;
        }
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$a1d765adf759361e))) showFlag((0, $bLjrh.inviteFailBadRequestFlagConfig));
        else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c7f012c6e67c4217))) showFlag((0, $bLjrh.inviteFailNetworkErrorFlagConfig));
        else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c8a538cf4ae41623)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$9bbcbc11675c1278)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$a51af3c30283d234))) showFlag((0, $bLjrh.inviteFailGenericFlagConfig));
        else showFlag((0, $bLjrh.inviteFailFlagConfig));
        const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$14fb68f74ccc8b23)) || isClientError) return;
        (0, $guiFP.default)({
            meta: {
                id: `jwm${modalType}Invite`,
                packageName: (0, $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b),
                teamName: 'jira-warepil'
            },
            attributes: {
                message: errorMessage
            },
            error: new Error(errorMessage),
            sendToPrivacyUnsafeSplunk: true
        });
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        showFlag
    ]);
    return {
        handleAddSuccess: handleAddSuccess,
        handleError: handleError
    };
};

});
const $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $aa13349e4e2d4a46$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $aa13349e4e2d4a46$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $aa13349e4e2d4a46$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $aa13349e4e2d4a46$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $aa13349e4e2d4a46$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $aa13349e4e2d4a46$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $aa13349e4e2d4a46$export$20ef020abfaa9ec = 'Licence Exceeded';
const $aa13349e4e2d4a46$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';

parcelRegister("f90H0", function(module, exports) {

$parcel$export(module.exports, "InvitationStatusEnum", () => $2279512461e31f50$export$2e0a7d2dc28c9a18);
const $2279512461e31f50$export$2e0a7d2dc28c9a18 = {
    ACCESS_REQUESTED: 'ACCESS_REQUESTED',
    INVITED: 'INVITED'
};

});

parcelRegister("bLjrh", function(module, exports) {

$parcel$export(module.exports, "inviteFailFlagConfig", () => $493a4fc4ed3495fe$export$95c6157ced8b3439);
$parcel$export(module.exports, "inviteFailGenericFlagConfig", () => $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d);
$parcel$export(module.exports, "inviteFailBadRequestFlagConfig", () => $493a4fc4ed3495fe$export$7f2d6442eed4d708);
$parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", () => $493a4fc4ed3495fe$export$c3bdacfc2255a9ed);
$parcel$export(module.exports, "createInviteSuccessFlagConfig", () => $493a4fc4ed3495fe$export$d456881895c2a0b2);
$parcel$export(module.exports, "createAddSuccessFlagConfig", () => $493a4fc4ed3495fe$export$cca35dec2a083169);
$parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", () => $493a4fc4ed3495fe$export$251dc06b3962c565);

var $jMP2a = parcelRequire("jMP2a");

var $7Ya7f = parcelRequire("7Ya7f");
const $493a4fc4ed3495fe$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
    if (totalPeopleAdded <= 0) return [
        agnosticDescription,
        {}
    ];
    return [
        specificDescription,
        {
            totalPeopleAddedMinusOne: totalPeopleAdded - 1,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }
    ];
};
const $493a4fc4ed3495fe$export$95c6157ced8b3439 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedMessageDescription,
    actions: [
        {
            content: (0, $7Ya7f.default).inviteFailedMessageCta,
            onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
        }
    ]
};
const $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedGenericMessageDescription
};
const $493a4fc4ed3495fe$export$7f2d6442eed4d708 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedBadRequestMessageDescription
};
const $493a4fc4ed3495fe$export$c3bdacfc2255a9ed = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedNetworkErrorMessageDescription
};
const $493a4fc4ed3495fe$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
    if (!hasSentInvitation) return {
        type: 'success',
        title: (0, $7Ya7f.default).requestInviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
    return {
        type: 'success',
        title: (0, $7Ya7f.default).inviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).inviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).inviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
};
const $493a4fc4ed3495fe$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
        type: 'success',
        title: (0, $7Ya7f.default).peopleAddedSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        actions: [
            {
                content: (0, $7Ya7f.default).peopleAddedManageAccess,
                onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
            }
        ]
    });
const $493a4fc4ed3495fe$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
        type: 'warning',
        title: (0, $7Ya7f.default).userLimitInviteErrorTitle,
        description: isSiteAdmin ? (0, $7Ya7f.default).userLimitInviteErrorDescriptionAdmin : (0, $7Ya7f.default).userLimitInviteErrorDescription,
        actions: isSiteAdmin ? [
            {
                content: (0, $7Ya7f.default).upgradePlan,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                    window.open('/admin/billing/applications', '_blank');
                }
            },
            {
                content: (0, $7Ya7f.default).viewUsers,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                    window.open('/admin/users', '_blank');
                }
            }
        ] : [
            {
                content: (0, $7Ya7f.default).inviteFailedMessageCta,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                    window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                }
            }
        ]
    });

});
parcelRegister("7Ya7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $97084d0fb7d00df5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $97084d0fb7d00df5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
        "defaultMessage": "Invitation sent"
    },
    inviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
        "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
    },
    inviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
        "defaultMessage": "You've successfully invited people to your business project."
    },
    inviteFailedMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
        "defaultMessage": "Something went wrong"
    },
    inviteFailedMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
    },
    inviteFailedMessageCta: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
        "defaultMessage": "Contact your admin"
    },
    inviteFailedGenericMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users, please try again."
    },
    inviteFailedBadRequestMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
    },
    inviteFailedNetworkErrorMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
    },
    requestInviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
        "defaultMessage": "Access request sent to your admin"
    },
    requestInviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
        "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
    },
    requestInviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
        "defaultMessage": "Your admin needs to approve access for people to your business project."
    },
    peopleAddedSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
        "defaultMessage": "New people added"
    },
    peopleAddedSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
        "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
        "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedManageAccess: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
        "defaultMessage": "Manage access"
    },
    userLimitInviteErrorTitle: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
        "defaultMessage": "Can't add more people"
    },
    userLimitInviteErrorDescriptionAdmin: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
        "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
    },
    userLimitInviteErrorDescription: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
        "defaultMessage": "You've reached your user limit. Contact your admin for help."
    },
    viewUsers: {
        "id": "business-invite-people.controllers.modal-handlers.view-users",
        "defaultMessage": "View users"
    },
    upgradePlan: {
        "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
        "defaultMessage": "Upgrade plan"
    }
});

});



parcelRegister("66rnh", function(module, exports) {

$parcel$export(module.exports, "AddPeopleModal", () => $0d2c4bae7dd02578$export$b28f48897cdf7241);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $kQAZu = parcelRequire("kQAZu");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $d6f6c = parcelRequire("d6f6c");

var $c7H0g = parcelRequire("c7H0g");

var $bvGWz = parcelRequire("bvGWz");


const $0d2c4bae7dd02578$export$a4917c848b5c6ce8 = (0, $7rh0R.lazy)(()=>(parcelRequire("cjlQq")), {
    ssr: false,
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $0d2c4bae7dd02578$var$userInviteErrorCodes = {
    BAD_REQUEST_ERROR_CODE: $aa13349e4e2d4a46$export$a1d765adf759361e,
    NETWORK_ERROR_CODE: $aa13349e4e2d4a46$export$c7f012c6e67c4217,
    AUTH_FAILED_ERROR_CODE: $aa13349e4e2d4a46$export$c8a538cf4ae41623,
    SERVER_ERROR_ERROR_CODE: $aa13349e4e2d4a46$export$9bbcbc11675c1278,
    USER_NOT_FOUND_ERROR_CODE: $aa13349e4e2d4a46$export$a51af3c30283d234
};
const $0d2c4bae7dd02578$export$b28f48897cdf7241 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
    const { triggerBtnRef: triggerBtnRef } = (0, $bvGWz.useAddPeople)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const handleInviteSuccess = (0, $eUqFw.useCallback)((addedParties, _role)=>{
        onInviteSuccess({
            totalPeopleAdded: addedParties.length,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            email: addedParties[0]?.email || addedParties[0]?.displayName,
            modalType: 'Project'
        });
    }, [
        onInviteSuccess
    ]);
    // From the given error message, we want to search for a known error code defined under the user invite endpoint
    // Otherwise, we return the whole message and use that as error code for mapping later on
    const extractErrorCode = (message)=>{
        // Typescript assumes Object.keys is of type string[] so need to type cast
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const errorCode of Object.keys($0d2c4bae7dd02578$var$userInviteErrorCodes)){
            const errorMessage = $0d2c4bae7dd02578$var$userInviteErrorCodes[errorCode];
            if (message.includes(errorMessage)) return errorCode;
        }
        return message; // Return original message if no error code found
    };
    const handleInviteFailure = (0, $eUqFw.useCallback)((errors)=>{
        const userInviteErrorsWithCode = {};
        errors.forEach((error)=>{
            // Group all errors by known user invite error codes
            const errorCode = extractErrorCode(error.message);
            if (errorCode) {
                if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                userInviteErrorsWithCode[errorCode].push(error);
            }
        });
        // Join messages with the same error code
        const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
            const statusCode = group[0]?.statusCode; // Assuming all errors with same error code have the same status code
            const messages = group.map((obj)=>obj.message).join('\n');
            return {
                message: messages,
                statusCode: statusCode
            };
        });
        groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
            onInviteError({
                modalType: 'Project',
                errorMessage: groupedUserInviteError.message,
                statusCode: groupedUserInviteError.statusCode
            });
        });
    }, [
        onInviteError
    ]);
    const { id: id, key: key } = projectData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-business.project-invite-people-modal.add-people",
        packageName: "jira-business.project-invite-people-modal.add-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmProjectInviteComponent viewed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "add-people-modal-lazy",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0d2c4bae7dd02578$export$a4917c848b5c6ce8, {
        isOpen: true,
        triggerBtnRef: triggerBtnRef,
        onClose: onModalClose,
        onAddSuccess: handleInviteSuccess,
        onError: handleInviteFailure,
        projectId: id,
        projectKey: key,
        projectType: "business",
        isAdmin: isAdmin,
        baseUrl: "",
        analyticsPrefix: "",
        allowFlags: false,
        onStopPerfMetric: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    })));
});

});
parcelRegister("cjlQq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("6HI0g")
]).then(()=>parcelRequire('4urEy'));

});


parcelRegister("d1I0W", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModal", () => $c68f3c6d5279f8a1$export$e3ec81c4d0451f63);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $aOw1G = parcelRequire("aOw1G");

var $kQAZu = parcelRequire("kQAZu");

var $kGQen = parcelRequire("kGQen");

var $exb0h = parcelRequire("exb0h");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $10fdS = parcelRequire("10fdS");

var $d6f6c = parcelRequire("d6f6c");

var $6Ua7e = parcelRequire("6Ua7e");

var $jD3pk = parcelRequire("jD3pk");

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");

var $dWLk9 = parcelRequire("dWLk9");

var $c7H0g = parcelRequire("c7H0g");

var $f90H0 = parcelRequire("f90H0");

const $c68f3c6d5279f8a1$export$cbfde4f653ce234 = (0, $7rh0R.lazy)(()=>(parcelRequire("5XLIV")), {
    ssr: false,
    moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
});
const $c68f3c6d5279f8a1$export$4d2a63c83bbce998 = (res)=>{
    if (res.accessRequested?.length) return (0, $f90H0.InvitationStatusEnum).ACCESS_REQUESTED;
    return (0, $f90H0.InvitationStatusEnum).INVITED;
};
const $c68f3c6d5279f8a1$var$LIST_ROUTES = [
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST)
];
const $c68f3c6d5279f8a1$var$isFailureResponse = (res)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    res.failure !== undefined;
const $c68f3c6d5279f8a1$export$e3ec81c4d0451f63 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const onInviteCompleteHandler = (0, $eUqFw.useCallback)((response)=>{
        if ($c68f3c6d5279f8a1$var$isFailureResponse(response)) {
            const { message: message, status: status } = response.failure;
            onInviteError({
                modalType: 'Instance',
                errorMessage: message,
                statusCode: status
            });
            return;
        }
        const inviteStatus = $c68f3c6d5279f8a1$export$4d2a63c83bbce998(response);
        const { invited: invited, accessRequested: accessRequested } = response;
        onInviteSuccess({
            totalPeopleAdded: invited.length || accessRequested.length,
            email: invited[0]?.email || accessRequested[0]?.email || '',
            modalType: 'Instance',
            inviteStatus: inviteStatus
        });
    }, [
        onInviteError,
        onInviteSuccess
    ]);
    const isSoftwareRoute = (0, $eUqFw.useMemo)(()=>$c68f3c6d5279f8a1$var$LIST_ROUTES.includes(route.name), [
        route
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-business.project-invite-people-modal.invite-people",
        packageName: "jira-business.project-invite-people-modal.invite-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal.invite-people",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onModalClose,
        width: "small",
        shouldScrollInViewport: true,
        testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmInstanceInviteComponent viewed"
    }), isSoftwareRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ua7e.default), {
        isOpen: true,
        cloudId: cloudId,
        projectId: projectData.id,
        jiraProjectKey: projectData.key,
        isSiteAdmin: isAdmin,
        onClose: onModalClose,
        appEdition: (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions),
        jiraProjectName: projectData.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c68f3c6d5279f8a1$export$cbfde4f653ce234, {
        onSendHandler: onModalClose,
        onInviteCompletedHandler: onInviteCompleteHandler,
        onCancelHandler: onModalClose,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        continueUrl: window.location.href,
        enableThirdParty: true,
        source: source,
        orgId: orgId
    })))));
});

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("6Ua7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $586cc92d06f8b9df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $586cc92d06f8b9df$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hAVuy")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $586cc92d06f8b9df$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($586cc92d06f8b9df$var$LazyComponent, props)));
var $586cc92d06f8b9df$export$2e2bcd8739ae039 = $586cc92d06f8b9df$export$6a02a79fa2b0ddab;

});
parcelRegister("hAVuy", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("e1vXm")
]).then(()=>parcelRequire('bagiu'));

});


parcelRegister("5XLIV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("evBHV")
]).then(()=>parcelRequire('6SUBw'));

});




parcelRegister("4Htg3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("j6IJU")
]).then(()=>parcelRequire('dNnOv'));

});


parcelRegister("eCCst", function(module, exports) {

$parcel$export(module.exports, "JWMShareButton", () => $7c9cba86062e6e6f$export$b326da26415fdf10);

var $eUqFw = parcelRequire("eUqFw");

var $dFWNP = parcelRequire("dFWNP");

var $bDUCT = parcelRequire("bDUCT");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $hfslX = parcelRequire("hfslX");

var $lxV3x = parcelRequire("lxV3x");

var $bPBzW = parcelRequire("bPBzW");

const $7c9cba86062e6e6f$var$SHARE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
    label: "",
    size: "small"
});
const $7c9cba86062e6e6f$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { shareIntegrations: shareIntegrations } = (0, $hfslX.useShareIntegrations)(shareContentType);
    const entityAri = (0, $bDUCT.useEntityAri)();
    const shareButtonRef = (0, $eUqFw.useRef)(null);
    const renderCustomTriggerButton = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'onClick' implicitly has an 'any' type. | TS7031 - Binding element 'isSelected' implicitly has an 'any' type. | TS7031 - Binding element 'ref' implicitly has an 'any' type.
    ({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
            ...triggerProps,
            ref: shareButtonRef,
            onClick: onClick,
            isSelected: isSelected,
            iconBefore: $7c9cba86062e6e6f$var$SHARE_ICON,
            appearance: "subtle"
        }, formatMessage((0, $bPBzW.default).share))), [
        formatMessage
    ]);
    const handleDialogClose = ()=>{
        onDialogClose?.();
        shareButtonRef?.current?.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxV3x.AsyncShareProjectNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        isAutoOpenDialog: isAutoOpenDialog,
        integrationType: integrationType,
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: "jira-core",
        shareLink: false ? '' : window.location.href,
        shareTitle: formatMessage(shareTitle),
        shareContentType: shareContentType,
        // @ts-expect-error - TS2322 - Type '({ onClick, isSelected }: { onClick: any; isSelected: any; }, { ref, ...triggerProps }: { [x: string]: any; ref: any; }) => Element' is not assignable to type 'RenderCustomTriggerButton'.
        renderCustomTriggerButton: renderCustomTriggerButton,
        objectAri: entityAri,
        onDialogClose: handleDialogClose,
        copyTooltipText: formatMessage((0, $bPBzW.default).shareTooltipText),
        shareIntegrations: shareIntegrations,
        integrationMode: "tabs",
        shareFormHelperMessage: formatMessage((0, $bPBzW.default).shareJwmHelperMessage)
    }));
};

});
parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9f4cb7ac67043f68$var$_share = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("ec2xp")));
function $9f4cb7ac67043f68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $9f4cb7ac67043f68$var$_share.default
    }));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = module.exports.default = $9f4cb7ac67043f68$var$ShareIcon;

});
parcelRegister("ec2xp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b1d38bd881e36a60e1d8f11863c2679>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a55427aa389adc57$var$_react = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a55427aa389adc57$var$_UNSAFE_baseNew = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a55427aa389adc57$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a55427aa389adc57$var$ShareIcon = (props)=>/*#__PURE__*/ $a55427aa389adc57$var$_react.default.createElement($a55427aa389adc57$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$a55427aa389adc57$var$ShareIcon.displayName = 'ShareIcon';
var $a55427aa389adc57$var$_default = module.exports.default = $a55427aa389adc57$var$ShareIcon;

});


parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $dFWNP = parcelRequire("dFWNP");


var $5GxEP = parcelRequire("5GxEP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");


var $8nUKh = parcelRequire("8nUKh");
const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("cD4TX")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("cD4TX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2xQrm")
]).then(()=>parcelRequire('iHQJU'));

});


parcelRegister("hfslX", function(module, exports) {

$parcel$export(module.exports, "useShareIntegrations", () => $b36423e50cabd739$export$58a9f7a7ab3466f4);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $8q0kG = parcelRequire("8q0kG");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $gWV0M = parcelRequire("gWV0M");
var $ljgr5 = parcelRequire("ljgr5");
const $b36423e50cabd739$export$58a9f7a7ab3466f4 = (shareContentType)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const ineligibilityReasons = (0, $eUqFw.useMemo)(()=>{
        const reasons = [];
        if ((0, $8q0kG.default)()) reasons.push('notDesktop');
        // All Share to Slack must be disabled in FedRAMP environment as
        // Slack Jira Integration app is not available in FedRAMP
        if ((0, $dfBCt.isFedRamp)()) reasons.push('isFedRAMP');
        return reasons;
    }, []);
    const shareIntegrations = (0, $eUqFw.useMemo)(()=>ineligibilityReasons.length === 0 ? [
            {
                type: 'Slack',
                Icon: (0, $ljgr5.default),
                Content: ({ onClose: onClose, changeTab: changeTab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWV0M.ShareToSlack), {
                        showFlag: showFlag,
                        product: "jira",
                        channel: "productAnalytics",
                        onClose: onClose,
                        cloudId: cloudId,
                        changeTab: changeTab,
                        shareContentType: shareContentType
                    })
            }
        ] : [], [
        ineligibilityReasons.length,
        showFlag,
        cloudId,
        shareContentType
    ]);
    return {
        shareIntegrations: shareIntegrations
    };
};

});
parcelRegister("gWV0M", function(module, exports) {

$parcel$export(module.exports, "ShareToSlack", () => $acb191acb45641f8$export$2cc56764fd9edb21);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $335P8 = parcelRequire("335P8");

var $ljgr5 = parcelRequire("ljgr5");
const $acb191acb45641f8$export$2cc56764fd9edb21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async-share-to-slack",
        packageName: "integrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-to-slack",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlackLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlack), props)));

});
parcelRegister("335P8", function(module, exports) {

$parcel$export(module.exports, "StyledShareToSlack", () => $7cc4332b79a68bdd$export$9aeb6210c91511b9);
$parcel$export(module.exports, "StyledShareToSlackLoader", () => $7cc4332b79a68bdd$export$d3f97cc63e3ee02);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $d3qIv = parcelRequire("d3qIv");
const $7cc4332b79a68bdd$export$9aeb6210c91511b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $d3qIv.LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8ax2b",
            __cmplp.className
        ])
    });
});
const $7cc4332b79a68bdd$export$d3f97cc63e3ee02 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $4Bees.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d3qIv", function(module, exports) {

$parcel$export(module.exports, "LazyShareToSlack", () => $3114157f9b395570$export$24281652e6b89b3b);

var $7rh0R = parcelRequire("7rh0R");

const $3114157f9b395570$export$24281652e6b89b3b = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("3jSCz")), {
    ssr: false,
    moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
});

});
parcelRegister("3jSCz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("dPtit")
]).then(()=>parcelRequire('dZKRj'));

});



parcelRegister("ljgr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f66b2d378eff6fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f66b2d378eff6fc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
        fill: "#ECB22E"
    }));

});



parcelRegister("lxV3x", function(module, exports) {

$parcel$export(module.exports, "AsyncShareProjectNudge", () => $906cb1053f659eb0$export$d95995d6ca76620b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $906cb1053f659eb0$var$LazyShareProjectNudge = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("htJn2")), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
});
const $906cb1053f659eb0$export$d95995d6ca76620b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$a1be34032ee24f78),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$a1be34032ee24f78)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-share-project-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($906cb1053f659eb0$var$LazyShareProjectNudge, null, children)));

});
const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';
const $99a775c02d636a41$export$9749a972a54ad7ba = 'boardContainerNudge';

parcelRegister("htJn2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("afZr6").then(()=>parcelRequire('16oN0'));

});


parcelRegister("bPBzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6735bf02b619f7cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6735bf02b619f7cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    share: {
        "id": "business-invite-people.jwm-share-button.share",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "business-invite-people.jwm-share-button.share-tooltip-text",
        "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
    },
    shareJwmHelperMessage: {
        "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("75UIt", function(module, exports) {

$parcel$export(module.exports, "IssueFieldStatisticsButton", () => $ff80fd94e366c01d$export$38cc32afd1948a0a);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $lebmF = parcelRequire("lebmF");

var $hSCS8 = parcelRequire("hSCS8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hA9lS = parcelRequire("hA9lS");

var $3Fyg3 = parcelRequire("3Fyg3");
const $ff80fd94e366c01d$export$38cc32afd1948a0a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { setSidebarContent: setSidebarContent, closeSidebar: closeSidebar }] = (0, $hSCS8.useSidebar)();
    const onClick = ()=>{
        setSidebarContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Fyg3.SidebarContent), {
            onClose: closeSidebar
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lebmF))),
        label: formatMessage((0, $hA9lS.default).tooltip),
        isTooltipDisabled: false,
        onClick: onClick
    });
};

});
parcelRegister("lebmF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::516f6097e54066ba4b5996a96ee1ba8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f743b887c433d3d9$var$_react = $f743b887c433d3d9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f743b887c433d3d9$var$_UNSAFE_baseNew = $f743b887c433d3d9$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $f743b887c433d3d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChartPie".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: pie charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f743b887c433d3d9$var$ChartPieIcon = (props)=>/*#__PURE__*/ $f743b887c433d3d9$var$_react.default.createElement($f743b887c433d3d9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15.25 8A7.25 7.25 0 0 0 8 .75V8z" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 8A7.25 7.25 0 1 1 8 .75M15.25 8A7.25 7.25 0 0 0 8 .75M15.25 8H8V.75"/>`
    }, props));
$f743b887c433d3d9$var$ChartPieIcon.displayName = 'ChartPieIcon';
var $f743b887c433d3d9$var$_default = module.exports.default = $f743b887c433d3d9$var$ChartPieIcon;

});

parcelRegister("hA9lS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9643fe3ab6d524dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9643fe3ab6d524dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "business-issue-field-statistics.tooltip",
        "defaultMessage": "View as chart"
    }
});

});

parcelRegister("3Fyg3", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $dfeb89f06e89387e$export$49e8f7b58a4df4ea);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $hI5oG = parcelRequire("hI5oG");

var $jWuk1 = parcelRequire("jWuk1");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5aBKV = parcelRequire("5aBKV");
const $dfeb89f06e89387e$export$49e8f7b58a4df4ea = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    /*
   * Extra div wrapper required
   * refer https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/business/shared/components/app-wrapper/src/ui/app-wrapper/sidebar-layout/styled.tsx#23
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $dfeb89f06e89387e$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium"
    }, formatMessage((0, $5aBKV.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))),
        label: formatMessage((0, $5aBKV.default).close),
        isTooltipDisabled: false,
        onClick: onClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $5aBKV.default).info))));
};
const $dfeb89f06e89387e$var$wrapperStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200',
    paddingLeft: 'space.250',
    paddingRight: 'space.250'
});

});
parcelRegister("5aBKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f88552b97cf7ec3e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f88552b97cf7ec3e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "business-issue-field-statistics.sidebar.heading",
        "defaultMessage": "View this list as a chart"
    },
    info: {
        "id": "business-issue-field-statistics.sidebar.info",
        "defaultMessage": "Select the data you'd like to see in a chart."
    },
    close: {
        "id": "business-issue-field-statistics.sidebar.close",
        "defaultMessage": "Close"
    }
});

});



parcelRegister("91Lr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $aff05ea3c914239b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $l1jnn = parcelRequire("l1jnn");

var $cRKsH = parcelRequire("cRKsH");

const $aff05ea3c914239b$export$7174b56226171cc3 = (0, $7rh0R.lazy)(()=>(parcelRequire("biWYA")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/more-menu/src/ui/more-menu/menu-content/index.tsx"
});
const $aff05ea3c914239b$var$MoreMenu = ({ hideDoneItems: hideDoneItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems, hasFeedbackButton: hasFeedbackButton, projectType: projectType, isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled, onChangeHideDoneItems: onChangeHideDoneItems, onExpandCollapseAllItems: onExpandCollapseAllItems })=>{
    const renderContent = (0, $eUqFw.useCallback)((onCloseMenu)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "menu-content",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1jnn.default), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aff05ea3c914239b$export$7174b56226171cc3, {
            hideDoneItems: hideDoneItems,
            onChangeHideDoneItems: onChangeHideDoneItems,
            onExpandCollapseAllItems: onExpandCollapseAllItems,
            isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled,
            hasExpandedAllItems: hasExpandedAllItems,
            hasCollapsedAllItems: hasCollapsedAllItems,
            hasFeedbackButton: hasFeedbackButton,
            projectType: projectType,
            onCloseMenu: onCloseMenu
        })), [
        hideDoneItems,
        onChangeHideDoneItems,
        onExpandCollapseAllItems,
        isExpandCollapseButtonEnabled,
        hasExpandedAllItems,
        hasCollapsedAllItems,
        hasFeedbackButton,
        projectType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRKsH.default), {
        renderContent: renderContent
    });
};
var $aff05ea3c914239b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($aff05ea3c914239b$var$MoreMenu);

});
parcelRegister("l1jnn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91aceacdc3d4a91$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $3Y9u8 = parcelRequire("3Y9u8");
const $a91aceacdc3d4a91$var$MenuFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y9u8.SpinnerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    }));
var $a91aceacdc3d4a91$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a91aceacdc3d4a91$var$MenuFallback);

});
parcelRegister("3Y9u8", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $4a1a450a9393c394$export$52b4dfd89a6b3a1b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4a1a450a9393c394$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cRKsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ab88bbf4e192a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $jK1pm = parcelRequire("jK1pm");


var $fG0qd = parcelRequire("fG0qd");
const $b0ab88bbf4e192a9$var$MoreMenuCore = /*#__PURE__*/ (0, $eUqFw.memo)(({ renderContent: renderContent, minWidth: minWidth = (0, $f81b038ef83e0f85$export$8c68b096b2d5e9f6), forceVisibility: forceVisibility = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(forceVisibility);
    (0, $eUqFw.useEffect)(()=>{
        setIsOpen(forceVisibility);
    }, [
        forceVisibility
    ]);
    const closeMenu = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const toggleMenu = (0, $eUqFw.useCallback)(()=>setIsOpen((oldIsOpen)=>!oldIsOpen), []);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0ab88bbf4e192a9$export$5f7211d21bfdae05, {
            width: minWidth
        }, renderContent(closeMenu)), [
        closeMenu,
        renderContent,
        minWidth
    ]);
    const trigger = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fG0qd.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: toggleMenu
        }), [
        isOpen,
        toggleMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-more-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        content: content,
        trigger: trigger,
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    }));
});
var $b0ab88bbf4e192a9$export$2e2bcd8739ae039 = $b0ab88bbf4e192a9$var$MoreMenuCore;
const $b0ab88bbf4e192a9$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq",
            __cmplp.className
        ])
    });
});

});
const $f81b038ef83e0f85$export$8c68b096b2d5e9f6 = 320;

parcelRegister("fG0qd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4453e9a08a331d11$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7JXZ0 = parcelRequire("7JXZ0");

var $jG1wZ = parcelRequire("jG1wZ");

var $lGiWG = parcelRequire("lGiWG");

var $dnJL9 = parcelRequire("dnJL9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k1mhY = parcelRequire("k1mhY");
const $4453e9a08a331d11$var$MORE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
    label: "",
    size: "small"
});
const $4453e9a08a331d11$var$TriggerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        ...otherProps,
        ref: ref,
        testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
        iconBefore: $4453e9a08a331d11$var$MORE_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle",
        "aria-label": formatMessage((0, $k1mhY.default).moreButtonLabel)
    }, formatMessage((0, $k1mhY.default).moreButton));
});
const $4453e9a08a331d11$var$Trigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        ...otherProps,
        ref: ref,
        testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7JXZ0))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        isSelected: isSelected,
        onClick: onClick,
        "aria-label": formatMessage((0, $k1mhY.default).moreButtonLabel),
        title: formatMessage((0, $k1mhY.default).moreButton)
    });
});
var $4453e9a08a331d11$export$2e2bcd8739ae039 = (0, $dnJL9.componentWithFG)('visual-refresh', $4453e9a08a331d11$var$Trigger, $4453e9a08a331d11$var$TriggerOld);

});
parcelRegister("k1mhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $255e4847f5c60031$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $255e4847f5c60031$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreButton: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button",
        "defaultMessage": "More"
    },
    moreButtonLabel: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button-label",
        "defaultMessage": "More actions on the view options"
    }
});

});



parcelRegister("biWYA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("17KHX").then(()=>parcelRequire('dBYRZ'));

});


parcelRegister("iSNkS", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $60586429dc17d610$export$a7359bcfb0ca8e98);
const $60586429dc17d610$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("3007p", function(module, exports) {

$parcel$export(module.exports, "FilterDropdownListNudgeAsync", () => $492e91749dd4ef09$export$7d038d6ad1823996);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $105cx = parcelRequire("105cx");

var $jAS31 = parcelRequire("jAS31");
const $492e91749dd4ef09$var$runtimeProps = {};
const $492e91749dd4ef09$var$entryPointParams = {};
const $492e91749dd4ef09$export$7d038d6ad1823996 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $jAS31.filterDropdownNudgeEntrypoint), $492e91749dd4ef09$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: filterDropdownNudgeRef } = (0, $105cx.useRegisterNudgeTarget)((0, $99a775c02d636a41$export$5908fa8acd2c0739), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: filterDropdownNudgeRef
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $492e91749dd4ef09$var$runtimeProps
    }));
};

});
parcelRegister("105cx", function(module, exports) {

$parcel$export(module.exports, "useRegisterNudgeTarget", () => $4897a924f3a2c5b3$export$eb8a96124d659f2d);
$parcel$export(module.exports, "PortalledNudge", () => $4897a924f3a2c5b3$export$74f8d45d75dfda4f);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $9WJJx = parcelRequire("9WJJx");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 */ class $4897a924f3a2c5b3$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $4897a924f3a2c5b3$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
/**
 * Return the singleton controller
 */ const $4897a924f3a2c5b3$var$useNudgeController = ()=>$4897a924f3a2c5b3$var$NudgeController.instance;
const $4897a924f3a2c5b3$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $4897a924f3a2c5b3$var$useHasNudgeTargetNode = (id)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const [hasRefValue, setHasRefValue] = (0, $eUqFw.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $4897a924f3a2c5b3$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $eUqFw.useState)(null);
    const frameId = (0, $eUqFw.useRef)(null);
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $4897a924f3a2c5b3$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            nudgeContainer.current = document.createElement('div');
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $4897a924f3a2c5b3$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $4897a924f3a2c5b3$var$usePortalContainer();
    const hasRefValue = $4897a924f3a2c5b3$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $4897a924f3a2c5b3$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $eUqFw.useRef)(innerRectangle);
    const spotlightRef = (0, $eUqFw.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $eUqFw.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WJJx.NudgeSpotlight), {
        ...props,
        ref: spotlightRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: innerRectangle.height,
            width: innerRectangle.width
        }
    }))), nudgeContainer.current);
};

});

parcelRegister("jAS31", function(module, exports) {

$parcel$export(module.exports, "filterDropdownNudgeEntrypoint", () => $7633c2afcd7fab51$export$5cbb00667240a7df);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $7633c2afcd7fab51$export$5cbb00667240a7df = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("dRm34")), {
        moduleId: "202abeae"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dRm34", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1ZHXu").then(()=>parcelRequire('cMrYY'));

});



parcelRegister("6MsoD", function(module, exports) {

$parcel$export(module.exports, "MoreDropdownListNudgeAsync", () => $a450ab744330ff92$export$49ce8a5fd7f1f225);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $105cx = parcelRequire("105cx");

var $hbeEy = parcelRequire("hbeEy");
const $a450ab744330ff92$var$runtimeProps = {};
const $a450ab744330ff92$var$entryPointParams = {};
const $a450ab744330ff92$export$49ce8a5fd7f1f225 = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $hbeEy.moreDropdownNudgeEntrypoint), $a450ab744330ff92$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: filterDropdownNudgeRef } = (0, $105cx.useRegisterNudgeTarget)((0, $99a775c02d636a41$export$50192b0fdc9bdacf), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: filterDropdownNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $a450ab744330ff92$var$runtimeProps
    }));
};

});
parcelRegister("hbeEy", function(module, exports) {

$parcel$export(module.exports, "moreDropdownNudgeEntrypoint", () => $6f385665b812fa99$export$32cd09a154d643d4);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $6f385665b812fa99$export$32cd09a154d643d4 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("2AeXv")), {
        moduleId: "2bbbd889"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2AeXv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("f2QdF").then(()=>parcelRequire('iBIsO'));

});



parcelRegister("3Cjpz", function(module, exports) {

$parcel$export(module.exports, "default", () => $569cf272949ec321$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $afdwN = parcelRequire("afdwN");

var $c2AuN = parcelRequire("c2AuN");
const $569cf272949ec321$var$GroupByDropdown = ()=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const close = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const toggle = (0, $eUqFw.useCallback)(()=>setIsOpen((wasOpen)=>!wasOpen), []);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($569cf272949ec321$export$5f7211d21bfdae05, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $afdwN.default), {
            popupWidth: (0, $fe06322403b52911$export$8c68b096b2d5e9f6),
            onToggle: toggle
        })), [
        toggle
    ]);
    const trigger = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2AuN.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupByDropdown');
                toggle();
            }
        }), [
        createAnalyticsEvent,
        isOpen,
        toggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        content: content,
        trigger: trigger,
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    });
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$569cf272949ec321$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($569cf272949ec321$var$GroupByDropdown);
const $569cf272949ec321$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9uuw1",
            __cmplp.className
        ])
    });
});

});
const $fe06322403b52911$export$8c68b096b2d5e9f6 = 200;

parcelRegister("afdwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc8080940516b2fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $l1jnn = parcelRequire("l1jnn");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fc8080940516b2fb$var$GroupByDropdownOptions = (0, $7rh0R.lazy)(()=>(parcelRequire("IOkKy")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/header-actions/group-by-dropdown/dropdown-options/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fc8080940516b2fb$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "group-by-dropdown-options",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1jnn.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc8080940516b2fb$var$GroupByDropdownOptions, props));

});
parcelRegister("IOkKy", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("53kwy").then(()=>parcelRequire('8FbGg'));

});


parcelRegister("c2AuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7608faa10733e46e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b8123 = parcelRequire("b8123");

var $c6CvK = parcelRequire("c6CvK");

var $c0jFd = parcelRequire("c0jFd");

var $lGiWG = parcelRequire("lGiWG");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $9w3zf = parcelRequire("9w3zf");

var $dSE3z = parcelRequire("dSE3z");

var $FRXWS = parcelRequire("FRXWS");
const $7608faa10733e46e$var$GROUP_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b8123))), {
    label: "",
    size: "small"
});
const $7608faa10733e46e$var$Trigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const groupByField = (0, $9w3zf.useGetGroupByField)();
    if ((0, $8rQuz.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        ...otherProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        "aria-label": formatMessage((0, $FRXWS.default).groupByActiveButtonAriaLabel, {
            label: groupByField?.name
        }),
        testId: "business-list.ui.list-view.header-actions.group-by-dropdown.trigger.button-wrapper",
        isSelected: isSelected,
        onClick: onClick,
        iconAfter: groupByFieldId == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6CvK))), {
            label: "",
            color: "currentColor"
        }) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        as: "span",
        columnGap: "space.075",
        alignItems: "center"
    }, groupByFieldId == null ? formatMessage((0, $FRXWS.default).groupByButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $FRXWS.default).groupByActiveButton,
        values: {
            groupByFieldId: groupByField?.name
        }
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        ...otherProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        testId: "business-list.ui.list-view.header-actions.group-by-dropdown.trigger.button-wrapper",
        iconBefore: $7608faa10733e46e$var$GROUP_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle"
    }, groupByFieldId == null ? formatMessage((0, $FRXWS.default).groupByButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $FRXWS.default).groupByActiveButtonOld,
        values: {
            groupByFieldId: groupByField?.name
        }
    })));
});
var $7608faa10733e46e$export$2e2bcd8739ae039 = $7608faa10733e46e$var$Trigger;

});
parcelRegister("b8123", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81a13e0001b9fa39$var$_react = $81a13e0001b9fa39$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $81a13e0001b9fa39$var$_menu = $81a13e0001b9fa39$var$_interopRequireDefault((parcelRequire("7FIJW")));
function $81a13e0001b9fa39$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $81a13e0001b9fa39$var$MenuExpandIcon = (props)=>/*#__PURE__*/ $81a13e0001b9fa39$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 12m0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 16m0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 8"/></svg>`
    }, props, {
        newIcon: $81a13e0001b9fa39$var$_menu.default
    }));
$81a13e0001b9fa39$var$MenuExpandIcon.displayName = 'MenuExpandIcon';
var $81a13e0001b9fa39$var$_default = module.exports.default = $81a13e0001b9fa39$var$MenuExpandIcon;

});
parcelRegister("7FIJW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ea04c75a262fc5cdf9201493991b71b1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $595f1128c598ad16$var$_react = $595f1128c598ad16$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $595f1128c598ad16$var$_UNSAFE_baseNew = $595f1128c598ad16$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $595f1128c598ad16$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $595f1128c598ad16$var$MenuIcon = (props)=>/*#__PURE__*/ $595f1128c598ad16$var$_react.default.createElement($595f1128c598ad16$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 13.25h14M1 8h14M1 2.75h14"/>`
    }, props));
$595f1128c598ad16$var$MenuIcon.displayName = 'MenuIcon';
var $595f1128c598ad16$var$_default = module.exports.default = $595f1128c598ad16$var$MenuIcon;

});


parcelRegister("FRXWS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9136e89df49d7d1e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9136e89df49d7d1e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    groupByButton: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-button",
        "defaultMessage": "Group"
    },
    groupByActiveButtonAriaLabel: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button-aria-label",
        "defaultMessage": "Group by {label}"
    },
    groupByActiveButtonOld: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button-old",
        "defaultMessage": "Group by: {groupByFieldId}"
    },
    groupByActiveButton: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button",
        "defaultMessage": "Group: {groupByFieldId}"
    },
    groupByAssignee: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-assignee",
        "defaultMessage": "Assignee"
    },
    groupByStatus: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-status",
        "defaultMessage": "Status"
    },
    groupByPriority: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-priority",
        "defaultMessage": "Priority"
    },
    groupByCategory: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-category",
        "defaultMessage": "Category"
    },
    groupByStoryPoints: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-story-points",
        "defaultMessage": "Story points"
    },
    groupByStoryPointEstimate: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-story-point-estimate",
        "defaultMessage": "Story point estimate"
    }
});

});



parcelRegister("eXDkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e912dc4da90dc873$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e912dc4da90dc873$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareTitle: {
        "id": "business-list.list-view.header-actions.share-title",
        "defaultMessage": "List"
    },
    simpleSearch: {
        "id": "business-list.list-view.header-actions.simple-search",
        "defaultMessage": "Search list"
    },
    searchLabel: {
        "id": "business-list.list-view.header-actions.search-label",
        "defaultMessage": "Typing letters in the search input applies filters"
    },
    format: {
        "id": "business-list.list-view.header-actions.conditional-formatting",
        "defaultMessage": "Format"
    }
});

});

parcelRegister("1X186", function(module, exports) {

$parcel$export(module.exports, "useFilterProps", () => $4a2983d9b3a9c1b9$export$5e00405c50f0041a);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");

var $egJIx = parcelRequire("egJIx");

var $hHiDc = parcelRequire("hHiDc");
const $4a2983d9b3a9c1b9$var$createStringSet = (0, $5iWql.default)((...args)=>new Set([
        ...args
    ]));
const $4a2983d9b3a9c1b9$export$5e00405c50f0041a = ()=>{
    const { getAvailableFields: getAvailableFields } = (0, $hHiDc.useIssueFields)();
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $egJIx.useJWMListFeatures)();
    const availableFields = (0, $eUqFw.useMemo)(()=>getAvailableFields(), [
        getAvailableFields
    ]);
    // Only hides active sprints if the field is not available or is not software or FF is off
    const hiddenQuickFilters = (0, $eUqFw.useMemo)(()=>{
        if (!isSoftwareFieldsEnabled) return [
            'ACTIVE_SPRINTS'
        ];
        const sprintField = availableFields.find((field)=>field.type === (0, $lO4Or.SPRINT_TYPE));
        if (sprintField == null) return [
            'ACTIVE_SPRINTS'
        ];
        return [];
    }, [
        availableFields,
        isSoftwareFieldsEnabled
    ]);
    const allowedAliasFieldId = (0, $eUqFw.useMemo)(()=>{
        if (!isSoftwareFieldsEnabled) return;
        const fieldsAliases = availableFields.filter((field)=>field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID) || field.aliasFieldId === (0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)).map((field)=>field.aliasFieldId);
        if (fieldsAliases.length === 0) return;
        return $4a2983d9b3a9c1b9$var$createStringSet(...fieldsAliases);
    }, [
        availableFields,
        isSoftwareFieldsEnabled
    ]);
    return {
        allowedAliasFieldId: allowedAliasFieldId,
        hiddenQuickFilters: hiddenQuickFilters
    };
};

});


parcelRegister("6lgzJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0c94c5e4d797761$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f0c94c5e4d797761$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    listHeading: {
        "id": "business-list.list-view.list-heading",
        "defaultMessage": "List"
    },
    unassignedOption: {
        "id": "business-list.list-view.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    assignToMe: {
        "id": "business-list.list-view.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    loadingMoreItems: {
        "id": "business-list.list-view.loading-more-items",
        "defaultMessage": "Loading more items..."
    }
});

});

parcelRegister("1ukK3", function(module, exports) {

$parcel$export(module.exports, "InteractionMetrics", () => $25b02abb4e2117cd$export$341b330828bd3906);

var $jwBHm = parcelRequire("jwBHm");
const $25b02abb4e2117cd$export$341b330828bd3906 = ()=>{
    const interactionMetrics = (0, $jwBHm.useInteractionMetrics)();
    if (interactionMetrics[0, $jwBHm.COLUMN_RESIZED].state === 'started') interactionMetrics[0, $jwBHm.COLUMN_RESIZED].stop({
        stopTime: Math.floor(performance.now())
    });
    if (interactionMetrics[0, $jwBHm.COLUMN_VISIBILITY_CHANGED].state === 'started') interactionMetrics[0, $jwBHm.COLUMN_VISIBILITY_CHANGED].stop({
        stopTime: Math.floor(performance.now())
    });
    if (interactionMetrics[0, $jwBHm.DND_ROW_DROPPED].state === 'started') interactionMetrics[0, $jwBHm.DND_ROW_DROPPED].stop({
        stopTime: Math.floor(performance.now())
    });
    return null;
};

});

parcelRegister("dSlaZ", function(module, exports) {

$parcel$export(module.exports, "AsyncReparentModal", () => $2451cd1567bac57e$export$2afac3ca0625436);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $85xFO = parcelRequire("85xFO");

var $abSTX = parcelRequire("abSTX");
const $2451cd1567bac57e$var$runtimeProps = {};
const $2451cd1567bac57e$var$entryPointParams = {};
const $2451cd1567bac57e$export$2afac3ca0625436 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $85xFO.reparentModalEntryPoint), $2451cd1567bac57e$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jwm.list.reparent-modal",
        packageName: (0, $abSTX.PACKAGE_NAME),
        teamName: "keystone",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $2451cd1567bac57e$var$runtimeProps,
        errorFallback: "unmount"
    });
};

});
parcelRegister("85xFO", function(module, exports) {

$parcel$export(module.exports, "reparentModalEntryPoint", () => $666b43736db1313a$export$e5e5cbbac06953a1);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $666b43736db1313a$export$e5e5cbbac06953a1 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("64oKl")), {
        moduleId: "aa8d69b8"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("64oKl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cPKRD")
]).then(()=>parcelRequire('AlhnY'));

});


parcelRegister("abSTX", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $e7c7478c8b87e1a2$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $e7c7478c8b87e1a2$export$5b388ccfa29be01);
const $e7c7478c8b87e1a2$export$b8b9d90f9e5bd72b = 'jiraBusinessList';
const $e7c7478c8b87e1a2$export$5b388ccfa29be01 = -1;

});


parcelRegister("dcGUq", function(module, exports) {

$parcel$export(module.exports, "useGetColumns", () => $8a794b760b661474$export$5cedf9467e164d21);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $lYoXb = parcelRequire("lYoXb");

var $kBh2b = parcelRequire("kBh2b");

var $6imc4 = parcelRequire("6imc4");

var $3uSNh = parcelRequire("3uSNh");

var $kLC3n = parcelRequire("kLC3n");

var $5r9Wo = parcelRequire("5r9Wo");

var $8Qd0L = parcelRequire("8Qd0L");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $gbsaq = parcelRequire("gbsaq");

var $Kei82 = parcelRequire("Kei82");

var $aXbY8 = parcelRequire("aXbY8");

var $lqO9q = parcelRequire("lqO9q");

var $b7r1l = parcelRequire("b7r1l");

var $hHiDc = parcelRequire("hHiDc");

var $1Te3F = parcelRequire("1Te3F");

var $lAcL9 = parcelRequire("lAcL9");

var $jdYVO = parcelRequire("jdYVO");

var $eMPoQ = parcelRequire("eMPoQ");

var $lhlwL = parcelRequire("lhlwL");

var $d3tIX = parcelRequire("d3tIX");

var $jxvjJ = parcelRequire("jxvjJ");

var $fG10K = parcelRequire("fG10K");

var $2Mt92 = parcelRequire("2Mt92");

var $62F3R = parcelRequire("62F3R");

var $2tEhM = parcelRequire("2tEhM");

var $atvEr = parcelRequire("atvEr");

var $dNtbZ = parcelRequire("dNtbZ");

var $5c3sP = parcelRequire("5c3sP");

var $g3fEZ = parcelRequire("g3fEZ");

var $5kwBu = parcelRequire("5kwBu");

var $6lgzJ = parcelRequire("6lgzJ");

var $IIbrH = parcelRequire("IIbrH");

var $jmKEB = parcelRequire("jmKEB");

var $cMZur = parcelRequire("cMZur");

var $fk8YW = parcelRequire("fk8YW");

var $hgKBS = parcelRequire("hgKBS");

var $iWW7F = parcelRequire("iWW7F");

var $7v11U = parcelRequire("7v11U");

var $67zRT = parcelRequire("67zRT");

var $a0Bmj = parcelRequire("a0Bmj");

var $7lf5Y = parcelRequire("7lf5Y");

var $kmNgr = parcelRequire("kmNgr");

var $9dQoH = parcelRequire("9dQoH");

var $eggEB = parcelRequire("eggEB");

var $1NqHF = parcelRequire("1NqHF");

var $261bh = parcelRequire("261bh");
const $8a794b760b661474$var$dateFieldWidth = 120;
const $8a794b760b661474$var$getAlwaysVisibleFieldsMemoized = (0, $5iWql.default)((0, $1Te3F.getAlwaysVisibleFields));
const $8a794b760b661474$export$23779177436374fa = ()=>({
        [(0, $lO4Or.ISSUE_TYPE)]: 110,
        key: 120,
        [(0, $lO4Or.SUMMARY_TYPE)]: 400,
        [(0, $lO4Or.STATUS_TYPE)]: 120,
        [(0, $lO4Or.ASSIGNEE_TYPE)]: 180,
        [(0, $lO4Or.REPORTER_TYPE)]: 180,
        [(0, $lO4Or.USER_CF_TYPE)]: 180,
        [(0, $lO4Or.DUE_DATE_TYPE)]: $8a794b760b661474$var$dateFieldWidth,
        [(0, $lO4Or.CREATED)]: $8a794b760b661474$var$dateFieldWidth,
        [(0, $lO4Or.UPDATED)]: $8a794b760b661474$var$dateFieldWidth,
        [(0, $lO4Or.PRIORITY_TYPE)]: 120,
        [(0, $lO4Or.LABELS_TYPE)]: 170,
        [(0, $lO4Or.SELECT_CF_TYPE)]: 120,
        [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: 170,
        [(0, $lO4Or.URL_CF_TYPE)]: 180,
        [(0, $lO4Or.MULTI_USER_CF_TYPE)]: 200,
        moreFields: 50,
        [(0, $lO4Or.DATETIME_CF_TYPE)]: 200,
        [(0, $lO4Or.COMPONENTS_TYPE)]: 170,
        [(0, $lO4Or.CATEGORY_TYPE)]: 170,
        [(0, $lO4Or.COMMENT_TYPE)]: 145,
        [(0, $jGcn0.COMMENT_SUMMARY_TYPE)]: 145,
        [(0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)]: 200,
        [(0, $lO4Or.SPRINT_TYPE)]: 145,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? (0, $lYoXb.getColumnWidths)() : {}
    });
const $8a794b760b661474$export$f2dfe9615519b1 = ()=>({
        [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: false,
        [(0, $lO4Or.MULTI_USER_CF_TYPE)]: false,
        [(0, $lO4Or.PEOPLE_CF_TYPE)]: false,
        [(0, $lO4Or.COMMENT_TYPE)]: false,
        [(0, $jGcn0.COMMENT_SUMMARY_TYPE)]: false,
        [(0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)]: false,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? (0, $6imc4.getSortingDisabledFields)() : {}
    });
const $8a794b760b661474$var$COMMON_COLUMN_ATTRIBUTES = {
    frozen: false,
    maxWidth: 640,
    minWidth: 120,
    resizable: true
};
const $8a794b760b661474$var$COLUMN_ATTRIBUTE_OVERRIDES = {
    [(0, $lO4Or.PRIORITY_TYPE)]: {
        minWidth: 52
    },
    [(0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)]: {
        minWidth: 200
    },
    key: {
        minWidth: 72
    }
};
const $8a794b760b661474$var$selectRowColumn = (showBulkEditOnboarding)=>({
        key: (0, $lqO9q.SELECT_ROW_COLUMN_ID),
        dataKey: (0, $lqO9q.SELECT_ROW_COLUMN_ID),
        width: (0, $gbsaq.SELECT_ROW_COLUMN_WIDTH),
        headerRenderer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7v11U.SelectAllColumnCheckbox), {
            showBulkEditOnboarding: showBulkEditOnboarding
        }),
        cellRenderer: (props)=>{
            if ((0, $aXbY8.isItemSkeleton)(props.rowData.issueId)) // experimenting with inlining CSS here to avoid styled-components runtime perf overhead
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                style: (0, $Kei82.loadingCellStyles)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxvjJ.CellNavigation), {
                columnIndex: 0,
                rowIndex: props.rowIndex || 0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7v11U.SelectRowCheckbox), props));
        }
    });
const $8a794b760b661474$var$iconSize = 'medium';
const $8a794b760b661474$var$EMPTY_ARRAY = [];
const $8a794b760b661474$var$EMPTY_PAGES_ARRAY = [];
const $8a794b760b661474$var$isTimeTrackingConfigNeeded = (field)=>field.type === (0, $lO4Or.TIME_ESTIMATE_TYPE);
const $8a794b760b661474$export$5cedf9467e164d21 = ({ columnWidths: columnWidths, rowHeight: rowHeight, openIssueModal: openIssueModal, highlightRow: highlightRow, loading: pageLoading, projectId: projectId, onIssueUpdated: onIssueUpdated, showBulkEditOnboarding: showBulkEditOnboarding = false })=>{
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache, getVisibleFields: getVisibleFields, loading: loading, isVisibleFieldsCached: isVisibleFieldsCached } = (0, $hHiDc.useIssueFields)();
    const visibleFields = getVisibleFields();
    const iconMap = (0, $kBh2b.getFieldIcons)($8a794b760b661474$var$iconSize);
    const { data: projectData, getProjectData: getProjectData, loading: projectDataLoading } = (0, $eMPoQ.useJiraSettings)();
    const [, { getParentIssueKeysByChildId: getParentIssueKeysByChildId }] = (0, $5r9Wo.useHierarchyStore)();
    const { globalSystemFields: globalSystemFields } = (0, $jdYVO.useSystemFields)();
    const { onOpenCommentsSidebar: onOpenCommentsSidebar, selectedIssueKey: selectedIssueKey } = (0, $b7r1l.useCommentsSidebar)({
        CommentsSidebar: $2tEhM.CommentsSidebar
    });
    const isIssueViewVisible = (0, $kLC3n.useIssueViewIsVisible)();
    const [{ createFields: createFields }] = (0, $lAcL9.useInlineFieldCreateControls)();
    const [hierarchyStore] = (0, $5r9Wo.useHierarchyStore)();
    const currentFirstRowKey = (0, $eUqFw.useRef)();
    const project = (0, $kQAZu.useProject)();
    const defaultColumnWidths = (0, $eUqFw.useMemo)(()=>$8a794b760b661474$export$23779177436374fa(), []);
    const sortingActions = (0, $eUqFw.useMemo)(()=>$8a794b760b661474$export$f2dfe9615519b1(), []);
    const columnFields = (0, $eUqFw.useMemo)(()=>{
        const _columnFields = [
            ...visibleFields
        ];
        if (createFields.length > 0) createFields.forEach(({ fieldId: fieldId, name: name, type: type, createIndex: createIndex })=>{
            const placeholderField = {
                id: `${(0, $lqO9q.PLACEHOLDER_COLUMN)}-${fieldId}`,
                name: name,
                type: type
            };
            if (createIndex != null) _columnFields.splice(createIndex, 0, placeholderField);
            else _columnFields.push(placeholderField);
        });
        return _columnFields;
    }, [
        visibleFields,
        createFields
    ]);
    // This function finds the first issue row from the top within the first group item
    const getFirstGroupChildRowKey = (0, $eUqFw.useCallback)(()=>{
        const groups = hierarchyStore.hierarchyData.data;
        const firstGroupChild = groups[0]?.children;
        if (!Array.isArray(groups) || !firstGroupChild) return null;
        const firstGroupRow = firstGroupChild.length > 0 && firstGroupChild[0].key.startsWith((0, $aXbY8.INLINE_CREATE_ITEM_PREFIX)) ? firstGroupChild[1] : firstGroupChild[0];
        const firstGroupChildRowKey = firstGroupRow?.key ?? null;
        return firstGroupChildRowKey;
    }, [
        hierarchyStore.hierarchyData.data
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstGroupChildRowKey = getFirstGroupChildRowKey();
        currentFirstRowKey.current = firstGroupChildRowKey;
    }, [
        getFirstGroupChildRowKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // defer loading project data until estimate column is visible
        if (!projectData && visibleFields.find((field)=>field.type === (0, $lO4Or.TIME_ESTIMATE_TYPE)) && !projectDataLoading && pageLoading === false) getProjectData();
    }, [
        projectData,
        pageLoading,
        getProjectData,
        visibleFields,
        projectDataLoading
    ]);
    const hierarchyLevelsByName = (0, $eUqFw.useMemo)(()=>Object.fromEntries(hierarchyLevelsWithCache.map((hierarchyLevel)=>[
                hierarchyLevel.name,
                hierarchyLevel.level,
                hierarchyLevel.id
            ])), [
        hierarchyLevelsWithCache
    ]);
    const cellRenderers = (0, $eUqFw.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const toReturn = {};
        columnFields// eslint-disable-next-line complexity
        .map((field)=>{
            switch(field.type){
                case 0, $lO4Or.ISSUE_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData = {}, rowData: rowData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eggEB.TypeCell), {
                                id: rowData.issueId,
                                iconUrl: cellData.iconUrl,
                                name: cellData.name,
                                avatarId: field.fieldConfig?.avatarId,
                                onChildCreateButtonClicked: rowData.onChildCreateButtonClicked,
                                hierarchyLevel: hierarchyLevelsByName[rowData.issuetype.name ?? '']
                            })
                    };
                case 'key':
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData })=>{
                            const parentIssues = getParentIssueKeysByChildId(rowData.issueId);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3fEZ.KeyCell), {
                                issueId: rowData.id,
                                issueKey: cellData,
                                parentIssues: parentIssues,
                                onOpenIssueModal: openIssueModal
                            });
                        }
                    };
                case 0, $lO4Or.SUMMARY_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData, rowIndex: rowIndex })=>{
                            const isNudgeCell = rowIndex === 0 || rowData?.key === currentFirstRowKey.current;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dQoH.TextCell), {
                                isNudgeCell: (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') ? !isIssueViewVisible && isNudgeCell : isNudgeCell,
                                issueId: rowData.issueId,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldType: (0, $lO4Or.SUMMARY_TYPE),
                                fieldValue: cellData,
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                testId: "business-list.ui.list-view.summary-cell"
                            });
                        }
                    };
                case 0, $lO4Or.URL_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const url = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'url', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1NqHF.UrlCell), {
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldType: (0, $lO4Or.URL_CF_TYPE),
                                fieldValue: url,
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.TEXT_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const wiki = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'wiki', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dQoH.TextCell), {
                                issueId: rowData.issueId,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldType: (0, $lO4Or.TEXT_CF_TYPE),
                                fieldValue: wiki,
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id,
                                testId: "business-list.ui.list-view.text-cf-cell"
                            });
                        }
                    };
                case 0, $lO4Or.TEXT_AREA_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const adf = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'adf', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kmNgr.TextAreaCell), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.TEXT_AREA_CF_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                onClick: openIssueModal(rowData),
                                fieldValue: adf
                            });
                        }
                    };
                case 0, $lO4Or.STATUS_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData, column: column })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7lf5Y.default), {
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                width: column.width,
                                height: rowHeight,
                                rowData: rowData,
                                onHighlightRow: highlightRow,
                                ...cellData
                            })
                    };
                case 0, $lO4Or.ASSIGNEE_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const userField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'userValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $261bh.default), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.ASSIGNEE_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                initialValue: userField,
                                width: column.width,
                                emptyUserNameText: (0, $6lgzJ.default).unassignedOption,
                                loggedInUserActionNameText: (0, $6lgzJ.default).assignToMe,
                                testId: "business-list.ui.list-view.assignee-cell",
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.COMMENT_TYPE:
                case 0, $jGcn0.COMMENT_SUMMARY_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const totalCount = rowData?.commentSummary?.totalCount;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $62F3R.CommentsCell), {
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                isSelected: selectedIssueKey === rowData.key,
                                onClick: onOpenCommentsSidebar,
                                totalCount: totalCount
                            });
                        }
                    };
                case 0, $lO4Or.REPORTER_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const userField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'userValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $261bh.default), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.REPORTER_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                initialValue: userField,
                                width: column.width,
                                emptyUserNameText: (0, $6lgzJ.default).unassignedOption,
                                loggedInUserActionNameText: (0, $6lgzJ.default).assignToMe,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.USER_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const userField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedUser', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $261bh.default), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.USER_CF_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                initialValue: userField,
                                width: column.width,
                                emptyUserNameText: (0, $6lgzJ.default).unassignedOption,
                                loggedInUserActionNameText: (0, $6lgzJ.default).assignToMe,
                                // @ts-expect-error - TS2339 - Property 'isEditable' does not exist on type 'never'.
                                isEditable: userField?.isEditable,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.LABELS_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const labels = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'labels', []);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kwBu.default), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.LABELS_CF_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                issueLabels: labels,
                                width: column.width,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.LABELS_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData, column: column })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kwBu.default), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.LABELS_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                issueLabels: cellData,
                                width: column.width,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            })
                    };
                case 0, $lO4Or.PRIORITY_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData, column: column })=>{
                            if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) {
                                const priorityValue = (0, $3uSNh.safeGetTransformedFieldValue)(rowData.fields, field.id, 'priority', {});
                                const { name: name, id: id } = rowData.issuetype;
                                if (typeof name !== 'string' || typeof id !== 'string') return;
                                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgKBS.default), {
                                    ...priorityValue,
                                    fieldType: (0, $lO4Or.PRIORITY_TYPE),
                                    issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                    width: column.width,
                                    height: rowHeight,
                                    fieldName: field.name,
                                    issueType: name,
                                    issueTypeId: id,
                                    testId: "business-list.ui.list-view.priority-cell",
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    selectOptions: field.fieldConfig?.options ?? []
                                });
                            }
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgKBS.default), {
                                ...cellData,
                                fieldType: (0, $lO4Or.PRIORITY_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                width: column.width,
                                height: rowHeight,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id,
                                testId: "business-list.ui.list-view.priority-cell",
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                selectOptions: field.fieldConfig?.options ?? []
                            });
                        }
                    };
                case 0, $lO4Or.DUE_DATE_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNtbZ.default), {
                                issueId: rowData.issueId,
                                fieldKey: field.id,
                                dateOnly: cellData,
                                fieldType: (0, $lO4Or.DUE_DATE_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                isDue: String(rowData.status?.categoryId) !== String((0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.DONE))),
                                testId: "business-list.ui.list-view.date-cell",
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            })
                    };
                case 0, $lO4Or.CREATED:
                case 0, $lO4Or.UPDATED:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNtbZ.default), {
                                issueId: rowData.issueId,
                                fieldKey: field.id,
                                readOnly: true,
                                dateOnly: cellData,
                                onOpenIssueModal: openIssueModal,
                                rowData: rowData,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            })
                    };
                case 0, $lO4Or.SELECT_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValue = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $67zRT.default), {
                                fieldType: (0, $lO4Or.SELECT_CF_TYPE),
                                fieldName: field.name,
                                width: column.width,
                                fieldKey: field.id,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                fieldValue: selectedValue,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValues = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedValues', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $IIbrH.default), {
                                fieldType: (0, $lO4Or.MULTI_SELECT_CF_TYPE),
                                fieldName: field.name,
                                selectOptions: field.fieldConfig?.selectOptions,
                                width: column.width,
                                fieldKey: field.id,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                fieldValue: selectedValues,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.CATEGORY_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const getFieldValue = ()=>(0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                rowData.fields, field.id, 'value', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lhlwL.default), {
                                issueId: rowData.issueId,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                width: column.width,
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.CATEGORY_TYPE),
                                issueTypeId: rowData.issuetype.id != null ? Number.parseInt(rowData.issuetype.id, 10) : -1,
                                isEditable: true,
                                fieldValue: getFieldValue(),
                                fieldName: field.name,
                                issueType: rowData.issuetype?.name
                            });
                        }
                    };
                case 0, $lO4Or.TIME_ESTIMATE_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const originalEstimate = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'originalEstimate', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fk8YW.default), {
                                config: projectData?.jiraSettings?.timeTracking ?? undefined,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldId: field.id,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                fieldValue: originalEstimate
                            });
                        }
                    };
                case 0, $lO4Or.DATE_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const stringValue = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'stringValue', null);
                            return rowData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNtbZ.default), {
                                issueId: rowData.issueId,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                readOnly: !field.fieldConfig?.isEditable,
                                fieldType: (0, $lO4Or.DATE_CF_TYPE),
                                fieldValue: stringValue,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.NUMBER_CF_TYPE:
                case 0, $lO4Or.STORY_POINTS_TYPE:
                case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const numberField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'floatValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cMZur.default), {
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldType: field.type,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'number | null'.
                                fieldValue: numberField,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.DATETIME_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const dateTimeField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'dateTimeValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5c3sP.default), {
                                height: rowHeight,
                                width: column.width,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldValue: dateTimeField,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.MULTI_USER_CF_TYPE:
                case 0, $lO4Or.PEOPLE_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const multiUserField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, field.type === (0, $lO4Or.MULTI_USER_CF_TYPE) ? 'selectedUsers' : 'users', undefined);
                            const fieldType = field.type;
                            if (fieldType == null) return null;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jmKEB.default), {
                                height: rowHeight,
                                fieldKey: field.id,
                                fieldType: fieldType,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                initialValue: multiUserField,
                                width: column.width,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.COMPONENTS_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const componentsField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'componentValues', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atvEr.default), {
                                width: column.width,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldValue: componentsField,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueId: rowData.issueId
                            });
                        }
                    };
                case 0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWW7F.default), {
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                pages: rowData.confluenceLinks?.linkedConfluencePages?.pages || $8a794b760b661474$var$EMPTY_PAGES_ARRAY,
                                pageCount: rowData.confluenceLinks?.linkedConfluencePages?.pageCount || 0
                            })
                    };
                case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValues = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedValues', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fG10K.default), {
                                width: column.width,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldName: field.name,
                                fieldValue: selectedValues,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueId: rowData.issueId,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.SPRINT_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValues = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'sprint', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a0Bmj.default), {
                                width: column.width,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldName: field.name,
                                fieldValue: selectedValues,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueId: rowData.issueId,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id,
                                issueTypeLevel: rowData.issuetype.level
                            });
                        }
                    };
                default:
                    return {
                        [field.id]: undefined
                    };
            }
        }).forEach((fieldEntry)=>fieldEntry && Object.keys(fieldEntry).forEach((fieldKey)=>{
                toReturn[fieldKey] = fieldEntry[fieldKey];
            }));
        return toReturn;
    }, [
        columnFields,
        hierarchyLevelsByName,
        getParentIssueKeysByChildId,
        openIssueModal,
        isIssueViewVisible,
        rowHeight,
        highlightRow,
        selectedIssueKey,
        onOpenCommentsSidebar,
        projectData?.jiraSettings?.timeTracking
    ]);
    const iconMapWithCategoriesEnabled = (0, $eUqFw.useCallback)((field)=>{
        if (field.type === (0, $lO4Or.ISSUE_TYPE)) return null;
        if (field.type === (0, $lO4Or.CATEGORY_TYPE)) return field.type != null && iconMap[field.type];
        // This should come after the check for category type
        // Since category has a customfield_X id which is different across projects we should not check for id
        return iconMap[field.id] ?? (field.type !== undefined && iconMap[field.type]);
    }, [
        iconMap
    ]);
    const canEditField = project.isSimplified && project.permissions?.administerProject;
    return (0, $eUqFw.useMemo)(()=>loading && !isVisibleFieldsCached ? $8a794b760b661474$var$EMPTY_ARRAY : [
            $8a794b760b661474$var$selectRowColumn(showBulkEditOnboarding),
            ...columnFields.map((field, index)=>{
                const width = columnWidths[field.id] ?? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly issuetype: 120 | 90; readonly key: 120; readonly summary: 400; readonly status: 120; readonly assignee: 180; readonly reporter: 180; readonly "com.atlassian.jira.plugin.system.customfieldtypes:userpicker": 180; ... 12 more ...; readonly "com.atlassian.jira.plugin.system.customfieldtypes:jwm-category": 170...'.
                (field.type !== undefined && defaultColumnWidths[field.type]) ?? 120;
                return {
                    key: field.id,
                    dataKey: field.id,
                    width: width,
                    /*
       * https://autodesk.github.io/react-base-table/docs/get-started
       * To avoid "unnecessary" re-renders, BaseTable ignores functions when comparing column definition by default.
       * Hence, external values not passed as inputs to the renderer function need to be specified as props here. This was causing
       * the time original estimate cell to display stale data since the config data is fetched async after initial render.
       */ timeTrackingConfig: $8a794b760b661474$var$isTimeTrackingConfigNeeded(field) ? projectData?.jiraSettings?.timeTracking : undefined,
                    headerRenderer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Mt92.ColumnHeader), {
                        icon: // TODO: JET-3805-Replace mocked data with real BE data
                        iconMapWithCategoriesEnabled(field),
                        label: field.name,
                        fieldId: field.id,
                        fieldType: field.type,
                        canSortField: field.type !== undefined && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "com.atlassian.jira.plugin.system.customfieldtypes:textarea": false; readonly "com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker": false; readonly "com.atlassian.jira.plugin.system.customfieldtypes:people": false; }'.
                        (sortingActions[field.type] ?? true) && !field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN)),
                        canHideField: !$8a794b760b661474$var$getAlwaysVisibleFieldsMemoized().includes(field.id) && !field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN)),
                        canEditField: !!(canEditField && globalSystemFields.length && !globalSystemFields.includes(field.id) && !field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN))),
                        disableDrag: (0, $lqO9q.COLUMNS_WITH_DISABLED_REORDERING).includes(field.id) || field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN)),
                        index: index
                    }),
                    cellRenderer: (0, $1ybV0.ff)('jwm.list.rendering-improvements') ? (params)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d3tIX.CellWithHorizontalVirtualization), {
                            ...params,
                            cellRenderers: cellRenderers,
                            field: field,
                            key: params.column.key,
                            onIssueUpdated: onIssueUpdated,
                            projectId: projectId,
                            width: width
                        }) : (0, $d3tIX.getCellRenderer)({
                        cellRenderers: cellRenderers,
                        field: field,
                        onIssueUpdated: onIssueUpdated,
                        projectId: projectId,
                        width: width
                    }),
                    ...$8a794b760b661474$var$COMMON_COLUMN_ATTRIBUTES,
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly priority: { readonly minWidth: 52; }; readonly key: { readonly minWidth: 72; }; readonly issuetype?: { resizable: boolean; minWidth: number; } | undefined; }'.
                    ...$8a794b760b661474$var$COLUMN_ATTRIBUTE_OVERRIDES[field.id]
                };
            })
        ], [
        loading,
        isVisibleFieldsCached,
        showBulkEditOnboarding,
        columnFields,
        columnWidths,
        defaultColumnWidths,
        projectData?.jiraSettings?.timeTracking,
        iconMapWithCategoriesEnabled,
        sortingActions,
        canEditField,
        globalSystemFields,
        cellRenderers,
        onIssueUpdated,
        projectId
    ]);
};

});
parcelRegister("lYoXb", function(module, exports) {

$parcel$export(module.exports, "getColumnWidths", () => $570957181c06a49c$export$e54c9225ca52acc);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $lLq8m = parcelRequire("lLq8m");

var $9ah4D = parcelRequire("9ah4D");

var $kYbuU = parcelRequire("kYbuU");

var $g9OCl = parcelRequire("g9OCl");

var $KBS3r = parcelRequire("KBS3r");

var $65msE = parcelRequire("65msE");

var $7GRZv = parcelRequire("7GRZv");

var $2WtZQ = parcelRequire("2WtZQ");
const $570957181c06a49c$export$e54c9225ca52acc = (0, $5iWql.default)(()=>({
        ...(0, $2WtZQ.versionColumnWidth),
        ...(0, $lLq8m.devSummaryColumnWidth),
        ...(0, $7GRZv.teamColumnWidth),
        ...(0, $9ah4D.goalsColumnWidth),
        ...(0, $1ybV0.ff)('jira.list.field-support-part1') ? {
            ...(0, $65msE.resolutionColumnWidth),
            ...(0, $kYbuU.groupColumnWidth),
            ...(0, $KBS3r.radioSelectColumnWidth),
            ...(0, $g9OCl.projectColumnWidth)
        } : {}
    }));

});
parcelRegister("lLq8m", function(module, exports) {

$parcel$export(module.exports, "devSummaryColumnWidth", () => $7249c712c321bbb3$export$358a1d02595241e8);

var $lO4Or = parcelRequire("lO4Or");
const $7249c712c321bbb3$export$358a1d02595241e8 = {
    [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: 160
};

});

parcelRegister("9ah4D", function(module, exports) {

$parcel$export(module.exports, "goalsColumnWidth", () => $83fd100814c93d61$export$775dc358f0002ea0);

var $lO4Or = parcelRequire("lO4Or");
const $83fd100814c93d61$export$775dc358f0002ea0 = {
    [(0, $lO4Or.GOALS_CF_TYPE)]: 160
};

});

parcelRegister("kYbuU", function(module, exports) {

$parcel$export(module.exports, "groupColumnWidth", () => $3914ced4b2b85479$export$67a3cc86fcd4231);

var $lO4Or = parcelRequire("lO4Or");
const $3914ced4b2b85479$export$67a3cc86fcd4231 = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: 160,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: 160
};

});

parcelRegister("g9OCl", function(module, exports) {

$parcel$export(module.exports, "projectColumnWidth", () => $daa26ed8576b2469$export$8f9363e2d2217d2a);

var $lO4Or = parcelRequire("lO4Or");
const $daa26ed8576b2469$export$8f9363e2d2217d2a = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: 160
};

});

parcelRegister("KBS3r", function(module, exports) {

$parcel$export(module.exports, "radioSelectColumnWidth", () => $9cded55b2e9d6eab$export$c34ad8e09b312cd3);

var $lO4Or = parcelRequire("lO4Or");
const $9cded55b2e9d6eab$export$c34ad8e09b312cd3 = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: 160
};

});

parcelRegister("65msE", function(module, exports) {

$parcel$export(module.exports, "resolutionColumnWidth", () => $d7c374527c66e4e2$export$a759c5e7f31f10ca);

var $lO4Or = parcelRequire("lO4Or");
const $d7c374527c66e4e2$export$a759c5e7f31f10ca = {
    [(0, $lO4Or.RESOLUTION_TYPE)]: 160
};

});

parcelRegister("7GRZv", function(module, exports) {

$parcel$export(module.exports, "teamColumnWidth", () => $530b1426493edee7$export$1f7dab61cbeaeb04);

var $lO4Or = parcelRequire("lO4Or");
const $530b1426493edee7$export$1f7dab61cbeaeb04 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: 160
};

});

parcelRegister("2WtZQ", function(module, exports) {

$parcel$export(module.exports, "versionColumnWidth", () => $614587f4ad662c09$export$99cf8efcc69bcfe1);

var $lO4Or = parcelRequire("lO4Or");
const $614587f4ad662c09$export$99cf8efcc69bcfe1 = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: 160,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: 160,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: 160,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: 160
};

});


parcelRegister("kBh2b", function(module, exports) {

$parcel$export(module.exports, "getFieldIcons", () => $e54f455c6b41e11e$export$df250ca2240f6516);

var $jqvCZ = parcelRequire("jqvCZ");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $bsrAN = parcelRequire("bsrAN");

var $6g0DE = parcelRequire("6g0DE");

var $975Me = parcelRequire("975Me");

var $4QCVn = parcelRequire("4QCVn");

var $fCSoc = parcelRequire("fCSoc");

var $7nIOX = parcelRequire("7nIOX");

var $is7XO = parcelRequire("is7XO");

var $851U9 = parcelRequire("851U9");

var $cLwpi = parcelRequire("cLwpi");

var $6wPXB = parcelRequire("6wPXB");

var $46tzp = parcelRequire("46tzp");

var $4wZzs = parcelRequire("4wZzs");
const $e54f455c6b41e11e$export$df250ca2240f6516 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((size)=>{
    const legacyFieldIcons = (0, $4wZzs.getLegacyFieldIcons)({
        size: size
    });
    return {
        ...legacyFieldIcons,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
            ...(0, $46tzp.getVersionIcons)(size),
            ...(0, $fCSoc.getParentIcon)(size),
            ...(0, $6g0DE.getDevSummaryIcons)(size),
            ...(0, $6wPXB.getTeamIcons)(size),
            ...(0, $975Me.getGoalsIcons)(size)
        } : {},
        ...(0, $1ybV0.ff)('jira.list.field-support-part1') ? {
            ...(0, $851U9.getResolutionIcons)(size),
            ...(0, $4QCVn.getGroupIcons)(size),
            ...(0, $cLwpi.getStatusCategoryIcons)(size),
            ...(0, $is7XO.getRadioSelectIcon)(size),
            ...(0, $7nIOX.getProjectIcons)(size),
            ...(0, $bsrAN.getCascadingSelectIcons)(size)
        } : {}
    };
});

});
parcelRegister("bsrAN", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectIcons", () => $4ec1409121357127$export$a1c73b689cfdba0d);

var $eUqFw = parcelRequire("eUqFw");

var $7Mesx = parcelRequire("7Mesx");

var $lO4Or = parcelRequire("lO4Or");
const $4ec1409121357127$export$a1c73b689cfdba0d = (size)=>({
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mesx))), {
            label: "",
            size: size
        })
    });

});
parcelRegister("7Mesx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a983b68a1ef33a3$var$_react = $5a983b68a1ef33a3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $5a983b68a1ef33a3$var$_listBulleted = $5a983b68a1ef33a3$var$_interopRequireDefault((parcelRequire("bH5AZ")));
function $5a983b68a1ef33a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5a983b68a1ef33a3$var$EditorBulletListIcon = (props)=>/*#__PURE__*/ $5a983b68a1ef33a3$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 8c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $5a983b68a1ef33a3$var$_listBulleted.default
    }));
$5a983b68a1ef33a3$var$EditorBulletListIcon.displayName = 'EditorBulletListIcon';
var $5a983b68a1ef33a3$var$_default = module.exports.default = $5a983b68a1ef33a3$var$EditorBulletListIcon;

});
parcelRegister("bH5AZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::38bd678c7566e24589e760902a3381f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88380d0c63fc4ead$var$_react = $88380d0c63fc4ead$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $88380d0c63fc4ead$var$_UNSAFE_baseNew = $88380d0c63fc4ead$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $88380d0c63fc4ead$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $88380d0c63fc4ead$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $88380d0c63fc4ead$var$_react.default.createElement($88380d0c63fc4ead$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$88380d0c63fc4ead$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $88380d0c63fc4ead$var$_default = module.exports.default = $88380d0c63fc4ead$var$ListBulletedIcon;

});



parcelRegister("6g0DE", function(module, exports) {

$parcel$export(module.exports, "getDevSummaryIcons", () => $c249a2a5b82bb4bc$export$af7756d867a4596f);

var $eUqFw = parcelRequire("eUqFw");

var $gojax = parcelRequire("gojax");

var $lO4Or = parcelRequire("lO4Or");
const $c249a2a5b82bb4bc$export$af7756d867a4596f = (size)=>({
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gojax))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("gojax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beedc1cceb482b08$var$_react = $beedc1cceb482b08$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $beedc1cceb482b08$var$_branch = $beedc1cceb482b08$var$_interopRequireDefault((parcelRequire("1210e")));
function $beedc1cceb482b08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $beedc1cceb482b08$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $beedc1cceb482b08$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $beedc1cceb482b08$var$_branch.default
    }));
$beedc1cceb482b08$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $beedc1cceb482b08$var$_default = module.exports.default = $beedc1cceb482b08$var$BitbucketBranchesIcon;

});
parcelRegister("1210e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d5333b3016191eb34ab8245e965a2ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c06c178a8a70140$var$_react = $0c06c178a8a70140$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0c06c178a8a70140$var$_UNSAFE_baseNew = $0c06c178a8a70140$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $0c06c178a8a70140$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c06c178a8a70140$var$BranchIcon = (props)=>/*#__PURE__*/ $0c06c178a8a70140$var$_react.default.createElement($0c06c178a8a70140$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M4.25 4.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0V9m1.5 3.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 0h3.5a2.5 2.5 0 0 0 2.5-2.5v-5.5m0 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>`
    }, props));
$0c06c178a8a70140$var$BranchIcon.displayName = 'BranchIcon';
var $0c06c178a8a70140$var$_default = module.exports.default = $0c06c178a8a70140$var$BranchIcon;

});



parcelRegister("975Me", function(module, exports) {

$parcel$export(module.exports, "getGoalsIcons", () => $860af03e515ae7da$export$191c71adb6287036);

var $eUqFw = parcelRequire("eUqFw");

var $iY7zv = parcelRequire("iY7zv");

var $lO4Or = parcelRequire("lO4Or");
const $860af03e515ae7da$export$191c71adb6287036 = ()=>({
        [(0, $lO4Or.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("4QCVn", function(module, exports) {

$parcel$export(module.exports, "getGroupIcons", () => $f5e22dbf818fedac$export$4b39ade85c5051f7);

var $eUqFw = parcelRequire("eUqFw");

var $iwsIy = parcelRequire("iwsIy");

var $lO4Or = parcelRequire("lO4Or");
const $f5e22dbf818fedac$export$4b39ade85c5051f7 = (size)=>({
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
            size: size,
            label: ""
        })
    });

});

parcelRegister("fCSoc", function(module, exports) {

$parcel$export(module.exports, "getParentIcon", () => $c4211625266bf1b6$export$744c82990563f55a);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $aa7ce = parcelRequire("aa7ce");
const $c4211625266bf1b6$export$744c82990563f55a = ()=>({
        [(0, $lO4Or.PARENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aa7ce.HierarchyIcon), null)
    });

});
parcelRegister("aa7ce", function(module, exports) {

$parcel$export(module.exports, "HierarchyIcon", () => $a7933f94a217c249$export$8c3a8f220bd0db42);

var $eUqFw = parcelRequire("eUqFw");
const $a7933f94a217c249$export$8c3a8f220bd0db42 = ({ size: size = 24 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "4.33333",
        cy: "4.66732",
        r: "1.33333",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "10.9998",
        cy: "11.3333",
        r: "1.33333",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.3335 6V8.66667C4.3335 10.1394 5.5274 11.3333 7.00016 11.3333H9.66683",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }));

});


parcelRegister("7nIOX", function(module, exports) {

$parcel$export(module.exports, "getProjectIcons", () => $288778ae0a7a6d12$export$6db5abb9a6c7aec2);

var $eUqFw = parcelRequire("eUqFw");

var $e5T2d = parcelRequire("e5T2d");

var $lO4Or = parcelRequire("lO4Or");
const $288778ae0a7a6d12$export$6db5abb9a6c7aec2 = (size)=>({
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
            size: size,
            label: ""
        })
    });

});

parcelRegister("is7XO", function(module, exports) {

$parcel$export(module.exports, "getRadioSelectIcon", () => $17a174c113288beb$export$c36fadaa74abd39e);

var $eUqFw = parcelRequire("eUqFw");

var $c6Z6Z = parcelRequire("c6Z6Z");

var $lO4Or = parcelRequire("lO4Or");
const $17a174c113288beb$export$c36fadaa74abd39e = (size)=>({
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))), {
            label: "",
            size: size
        })
    });

});
parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $02468a1d390d1515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = module.exports.default = $02468a1d390d1515$var$RadioIcon;

});


parcelRegister("851U9", function(module, exports) {

$parcel$export(module.exports, "getResolutionIcons", () => $b63068b3f418e7aa$export$e9550187a88e57a5);

var $eUqFw = parcelRequire("eUqFw");

var $k9Z3M = parcelRequire("k9Z3M");

var $lO4Or = parcelRequire("lO4Or");
const $b63068b3f418e7aa$export$e9550187a88e57a5 = (size)=>({
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.RESOLUTION_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43db9d99c93083272e0c42b874af3704>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});



parcelRegister("cLwpi", function(module, exports) {

$parcel$export(module.exports, "getStatusCategoryIcons", () => $77e71eb554926895$export$f263f5d2ca3dcccb);

var $eUqFw = parcelRequire("eUqFw");

var $gniEB = parcelRequire("gniEB");

var $lO4Or = parcelRequire("lO4Or");
const $77e71eb554926895$export$f263f5d2ca3dcccb = (size)=>({
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gniEB))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("gniEB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bebd43992fe8e822$var$_react = $bebd43992fe8e822$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $bebd43992fe8e822$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $bebd43992fe8e822$var$StatusIcon = (props)=>/*#__PURE__*/ $bebd43992fe8e822$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5m3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98zM6.02 10.423h.07l.7 2.21H5.313zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.22 1.22 0 0 0 1.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926s.55-1.922 1.437-1.922c.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965"/></svg>`
    }, props));
$bebd43992fe8e822$var$StatusIcon.displayName = 'StatusIcon';
var $bebd43992fe8e822$var$_default = module.exports.default = $bebd43992fe8e822$var$StatusIcon;

});


parcelRegister("6wPXB", function(module, exports) {

$parcel$export(module.exports, "getTeamIcons", () => $38769f2763823b24$export$b7d8ffd86073bea);

var $eUqFw = parcelRequire("eUqFw");

var $j76Bh = parcelRequire("j76Bh");

var $lO4Or = parcelRequire("lO4Or");
const $38769f2763823b24$export$b7d8ffd86073bea = (size)=>({
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j76Bh))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("j76Bh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dea3ca78c255f4b6$var$_react = $dea3ca78c255f4b6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dea3ca78c255f4b6$var$_teams = $dea3ca78c255f4b6$var$_interopRequireDefault((parcelRequire("gib2Q")));
function $dea3ca78c255f4b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $dea3ca78c255f4b6$var$TeamsIcon = (props)=>/*#__PURE__*/ $dea3ca78c255f4b6$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $dea3ca78c255f4b6$var$_teams.default
    }));
$dea3ca78c255f4b6$var$TeamsIcon.displayName = 'TeamsIcon';
var $dea3ca78c255f4b6$var$_default = module.exports.default = $dea3ca78c255f4b6$var$TeamsIcon;

});


parcelRegister("46tzp", function(module, exports) {

$parcel$export(module.exports, "getVersionIcons", () => $fc9004aee8bf2947$export$5c5f41529027464e);

var $eUqFw = parcelRequire("eUqFw");

var $14lY4 = parcelRequire("14lY4");

var $lO4Or = parcelRequire("lO4Or");
const $fc9004aee8bf2947$export$5c5f41529027464e = (size)=>({
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        })
    });

});

parcelRegister("4wZzs", function(module, exports) {

$parcel$export(module.exports, "getLegacyFieldIcons", () => $96cd876843d12f51$export$eddca397cc46c15);

var $eUqFw = parcelRequire("eUqFw");

var $kMHOY = parcelRequire("kMHOY");

var $hSJ9G = parcelRequire("hSJ9G");

var $lBXn2 = parcelRequire("lBXn2");

var $d3vNK = parcelRequire("d3vNK");

var $cjQam = parcelRequire("cjQam");

var $awjqo = parcelRequire("awjqo");

var $3fJGp = parcelRequire("3fJGp");

var $dZhDV = parcelRequire("dZhDV");

var $7XRtk = parcelRequire("7XRtk");

var $f4oGi = parcelRequire("f4oGi");

var $6nIG2 = parcelRequire("6nIG2");

var $2OpmI = parcelRequire("2OpmI");

var $dTV7w = parcelRequire("dTV7w");

var $b8123 = parcelRequire("b8123");

var $8CfG4 = parcelRequire("8CfG4");

var $4nce6 = parcelRequire("4nce6");

var $cI9iM = parcelRequire("cI9iM");

var $k6W9R = parcelRequire("k6W9R");

var $gk7tF = parcelRequire("gk7tF");

var $eyI8O = parcelRequire("eyI8O");

var $c6CvK = parcelRequire("c6CvK");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");

var $8rQuz = parcelRequire("8rQuz");
const $96cd876843d12f51$var$PriorityIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222ZM14.1219 13.5914L14.0381 13.5174L12 11.48L9.96186 13.5174C9.64143 13.8378 9.13725 13.8625 8.78855 13.5914L8.70481 13.5174C8.38438 13.197 8.35973 12.6928 8.63086 12.3441L8.70481 12.2604L11.3715 9.5937C11.6919 9.27327 12.1961 9.24861 12.5448 9.51975L12.6285 9.5937L15.2952 12.2604C15.6423 12.6075 15.6423 13.1703 15.2952 13.5174C14.9748 13.8378 14.4706 13.8625 14.1219 13.5914Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$StatusIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12ZM15.3664 11.4518L15.2952 11.3715C15.3267 11.4029 15.3553 11.4362 15.381 11.4708C15.3969 11.4923 15.4118 11.5144 15.4257 11.5372C15.4324 11.5479 15.4386 11.5588 15.4447 11.5697C15.4544 11.5873 15.4637 11.6054 15.4723 11.6239C15.4794 11.639 15.486 11.6544 15.4922 11.6699C15.4993 11.6875 15.5057 11.7051 15.5115 11.7229C15.5158 11.7361 15.5199 11.7498 15.5237 11.7636C15.5291 11.7827 15.5337 11.802 15.5377 11.8215C15.5407 11.837 15.5434 11.8525 15.5457 11.868C15.5483 11.8849 15.5504 11.9024 15.552 11.92C15.5539 11.9416 15.555 11.9626 15.5554 11.9837C15.5555 11.9886 15.5556 11.9943 15.5556 12L15.5554 12.0172C15.555 12.0382 15.5539 12.0593 15.552 12.0802L15.5556 12C15.5556 12.0439 15.5524 12.087 15.5462 12.1292C15.5436 12.1467 15.5404 12.1648 15.5366 12.1829C15.5331 12.1999 15.5293 12.2162 15.5249 12.2323C15.521 12.2463 15.5168 12.2606 15.5122 12.2748C15.5059 12.2943 15.4989 12.3135 15.4913 12.3325C15.4855 12.3467 15.4795 12.3606 15.4731 12.3744C15.4639 12.3941 15.4539 12.4138 15.4431 12.4331C15.438 12.4423 15.4326 12.4517 15.4269 12.461C15.4135 12.4829 15.3993 12.5041 15.3843 12.5246C15.3793 12.5315 15.3743 12.5382 15.3691 12.5448C15.3528 12.5655 15.3393 12.5815 15.3252 12.597L15.2952 12.6285L12.6285 15.2952C12.2814 15.6423 11.7186 15.6423 11.3715 15.2952C11.051 14.9748 11.0264 14.4706 11.2975 14.1219L11.3715 14.0381L12.52 12.8889H9.33333C8.84241 12.8889 8.44444 12.4909 8.44444 12C8.44444 11.5468 8.78355 11.1729 9.22184 11.118L9.33333 11.1111H12.5218L11.3715 9.96187C11.051 9.64144 11.0264 9.13724 11.2975 8.78853L11.3715 8.70479C11.6919 8.38436 12.1961 8.35971 12.5448 8.63085L12.6285 8.70479L15.2977 11.374C15.3221 11.3985 15.345 11.4245 15.3664 11.4518Z",
        fill: "currentColor"
    }));
// Custom icon not from Atlaskit
const $96cd876843d12f51$var$NumberGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $96cd876843d12f51$var$TypeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9299 7C10.9299 6.44772 11.3776 6 11.9299 6C12.4822 6 12.9299 6.44772 12.9299 7V10.268L15.76 8.63397C16.2383 8.35783 16.8499 8.5217 17.1261 9C17.4022 9.47829 17.2383 10.0899 16.76 10.366L13.9299 12L16.76 13.634C17.2383 13.9101 17.4022 14.5217 17.1261 15C16.8499 15.4783 16.2383 15.6422 15.76 15.366L12.9299 13.732V17C12.9299 17.5523 12.4822 18 11.9299 18C11.3776 18 10.9299 17.5523 10.9299 17V13.7321L8.09978 15.366C7.62148 15.6422 7.00989 15.4783 6.73375 15C6.45761 14.5217 6.62148 13.9101 7.09978 13.634L9.9299 12L7.09978 10.366C6.62148 10.0899 6.45761 9.47829 6.73375 9C7.00989 8.5217 7.62148 8.35783 8.09978 8.63397L10.9299 10.2679V7Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$KeyIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 6C9.44772 6 9 6.44772 9 7V9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H9V13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H9V17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17V15H13V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V15H17C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H15V11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H15V7C15 6.44772 14.5523 6 14 6C13.4477 6 13 6.44772 13 7V9H11V7C11 6.44772 10.5523 6 10 6ZM13 13V11H11V13H13Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$EpicIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5 6C17.3284 6 18 6.67157 18 7.5V16.5C18 17.3284 17.3284 18 16.5 18H7.5C6.67157 18 6 17.3284 6 16.5V7.5C6 6.67157 6.67157 6 7.5 6H16.5ZM12.375 8.25C12.2625 8.25 12.165 8.30175 12.096 8.37975L9.11175 12.1088C9.1095 12.111 9.08475 12.1425 9.08475 12.1425C9.03525 12.2092 9 12.2865 9 12.375C9 12.582 9.168 12.75 9.375 12.75C9.396 12.75 9.41325 12.7537 9.43275 12.75H11.25V15.375C11.25 15.582 11.418 15.75 11.625 15.75C11.718 15.75 11.8005 15.7125 11.8658 15.657C11.8658 15.657 11.9123 15.6068 11.9295 15.582L14.88 11.8972C14.8943 11.8837 14.9033 11.868 14.9153 11.8522L14.9355 11.8275C14.9722 11.7667 15 11.7 15 11.625C15 11.418 14.832 11.25 14.625 11.25H12.75V8.625C12.75 8.418 12.582 8.25 12.375 8.25Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$renderChevronDownIcon = ({ size: size })=>(0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $96cd876843d12f51$var$iconSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6CvK))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    })) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBXn2))), {
        size: size,
        label: ""
    });
const $96cd876843d12f51$export$eddca397cc46c15 = ({ size: size })=>({
        key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$KeyIcon, null),
        [(0, $lO4Or.ISSUE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$TypeIcon, null),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awjqo))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$StatusIcon, null),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZhDV))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2OpmI))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.CREATED)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.UPDATED)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.RESOLUTION_DATE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$PriorityIcon, null),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZhDV))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4oGi))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fJGp))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cI9iM))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awjqo))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.SELECT_CF_TYPE)]: $96cd876843d12f51$var$renderChevronDownIcon({
            size: size
        }),
        [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: $96cd876843d12f51$var$renderChevronDownIcon({
            size: size
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7XRtk))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k6W9R))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.COMPONENTS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cjQam))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.STORY_POINTS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2OpmI))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.SUBTASKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eyI8O))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b8123))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.EPIC_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$EpicIcon, null),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $jGcn0.COMMENT_SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gk7tF))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $lO4Or.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
            size: size,
            label: ""
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        [(0, $jGcn0.CARD_COVERS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dTV7w))), {
            size: size,
            label: ""
        })
    });
const $96cd876843d12f51$var$iconSpacing = (0, $1ZAYh.xcss)({
    margin: 'space.075',
    marginTop: 'space.050'
});

});
parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f21a4850a620a60b$var$_calendar = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("61UUs")));
function $f21a4850a620a60b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $f21a4850a620a60b$var$_calendar.default
    }));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = module.exports.default = $f21a4850a620a60b$var$CalendarIcon;

});
parcelRegister("61UUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20cf79a37c55dc030e28f840f88e494b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $463efb2573c58501$var$_react = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $463efb2573c58501$var$_UNSAFE_baseNew = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $463efb2573c58501$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $463efb2573c58501$var$CalendarIcon = (props)=>/*#__PURE__*/ $463efb2573c58501$var$_react.default.createElement($463efb2573c58501$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$463efb2573c58501$var$CalendarIcon.displayName = 'CalendarIcon';
var $463efb2573c58501$var$_default = module.exports.default = $463efb2573c58501$var$CalendarIcon;

});


parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d04a81b304c826a5$var$_checkboxChecked = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("ejTfu")));
function $d04a81b304c826a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d04a81b304c826a5$var$_checkboxChecked.default
    }));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = module.exports.default = $d04a81b304c826a5$var$CheckboxIcon;

});
parcelRegister("ejTfu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::028a0c4c28d56d22cc99e0300c383380>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cdb252f5736633$var$_react = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6cdb252f5736633$var$_UNSAFE_baseNew = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a6cdb252f5736633$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cdb252f5736633$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $a6cdb252f5736633$var$_react.default.createElement($a6cdb252f5736633$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$a6cdb252f5736633$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $a6cdb252f5736633$var$_default = module.exports.default = $a6cdb252f5736633$var$CheckboxCheckedIcon;

});


parcelRegister("lBXn2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbbb1b7540180857$var$_react = $fbbb1b7540180857$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fbbb1b7540180857$var$_chevronDown = $fbbb1b7540180857$var$_interopRequireDefault((parcelRequire("c6CvK")));
function $fbbb1b7540180857$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbbb1b7540180857$var$ChevronDownCircleIcon = (props)=>/*#__PURE__*/ $fbbb1b7540180857$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></g></svg>`
    }, props, {
        newIcon: $fbbb1b7540180857$var$_chevronDown.default,
        iconType: "utility"
    }));
$fbbb1b7540180857$var$ChevronDownCircleIcon.displayName = 'ChevronDownCircleIcon';
var $fbbb1b7540180857$var$_default = module.exports.default = $fbbb1b7540180857$var$ChevronDownCircleIcon;

});

parcelRegister("d3vNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98143944cdbffe97$var$_react = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $98143944cdbffe97$var$_comment = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("75UoT")));
function $98143944cdbffe97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $98143944cdbffe97$var$CommentIcon = (props)=>/*#__PURE__*/ $98143944cdbffe97$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $98143944cdbffe97$var$_comment.default
    }));
$98143944cdbffe97$var$CommentIcon.displayName = 'CommentIcon';
var $98143944cdbffe97$var$_default = module.exports.default = $98143944cdbffe97$var$CommentIcon;

});
parcelRegister("75UoT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16e54766c3ecb23743fd478f54b2afa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52a4bffd3c43d738$var$_react = $52a4bffd3c43d738$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $52a4bffd3c43d738$var$_UNSAFE_baseNew = $52a4bffd3c43d738$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $52a4bffd3c43d738$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52a4bffd3c43d738$var$CommentIcon = (props)=>/*#__PURE__*/ $52a4bffd3c43d738$var$_react.default.createElement($52a4bffd3c43d738$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
    }, props));
$52a4bffd3c43d738$var$CommentIcon.displayName = 'CommentIcon';
var $52a4bffd3c43d738$var$_default = module.exports.default = $52a4bffd3c43d738$var$CommentIcon;

});


parcelRegister("cjQam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $025082fde694ac0f$var$_react = $025082fde694ac0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $025082fde694ac0f$var$_component = $025082fde694ac0f$var$_interopRequireDefault((parcelRequire("ffCTO")));
function $025082fde694ac0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $025082fde694ac0f$var$ComponentIcon = (props)=>/*#__PURE__*/ $025082fde694ac0f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991M3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991z"/><path d="M7 8.34h2V6.67H7zM5 6.67C5 5.75 5.9 5 7 5h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.66-2 1.66H7c-1.11 0-2-.75-2-1.66zm10 1.67h2V6.67h-2zm-2-1.67c0-.92.9-1.67 2-1.67h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.67-2 1.67h-2c-1.11-.01-2-.76-2-1.67z"/></g></svg>`
    }, props, {
        newIcon: $025082fde694ac0f$var$_component.default
    }));
$025082fde694ac0f$var$ComponentIcon.displayName = 'ComponentIcon';
var $025082fde694ac0f$var$_default = module.exports.default = $025082fde694ac0f$var$ComponentIcon;

});
parcelRegister("ffCTO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebbc7ca5028230e8b11e41ffe0da7bd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1a66e480b43428b$var$_react = $b1a66e480b43428b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b1a66e480b43428b$var$_UNSAFE_baseNew = $b1a66e480b43428b$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $b1a66e480b43428b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1a66e480b43428b$var$ComponentIcon = (props)=>/*#__PURE__*/ $b1a66e480b43428b$var$_react.default.createElement($b1a66e480b43428b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 5.25H2c-.69 0-1.25.56-1.25 1.25V12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6.5c0-.69-.56-1.25-1.25-1.25h-.75m-10.5 0v-2.5h3.5v2.5m-3.5 0h3.5m0 0h3.5m0 0v-2.5h3.5v2.5m-3.5 0h3.5"/>`
    }, props));
$b1a66e480b43428b$var$ComponentIcon.displayName = 'ComponentIcon';
var $b1a66e480b43428b$var$_default = module.exports.default = $b1a66e480b43428b$var$ComponentIcon;

});


parcelRegister("awjqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a8bf5e62e78ca1b$var$_react = $7a8bf5e62e78ca1b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7a8bf5e62e78ca1b$var$_alignLeft = $7a8bf5e62e78ca1b$var$_interopRequireDefault((parcelRequire("fiu69")));
function $7a8bf5e62e78ca1b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7a8bf5e62e78ca1b$var$EditorAlignLeftIcon = (props)=>/*#__PURE__*/ $7a8bf5e62e78ca1b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 4h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m0 4h5a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7a8bf5e62e78ca1b$var$_alignLeft.default
    }));
$7a8bf5e62e78ca1b$var$EditorAlignLeftIcon.displayName = 'EditorAlignLeftIcon';
var $7a8bf5e62e78ca1b$var$_default = module.exports.default = $7a8bf5e62e78ca1b$var$EditorAlignLeftIcon;

});
parcelRegister("fiu69", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0c4e232b1cec1ca550b50a0b085edee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b22fe259af223f59$var$_react = $b22fe259af223f59$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b22fe259af223f59$var$_UNSAFE_baseNew = $b22fe259af223f59$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $b22fe259af223f59$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b22fe259af223f59$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $b22fe259af223f59$var$_react.default.createElement($b22fe259af223f59$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
    }, props));
$b22fe259af223f59$var$AlignLeftIcon.displayName = 'AlignLeftIcon';
var $b22fe259af223f59$var$_default = module.exports.default = $b22fe259af223f59$var$AlignLeftIcon;

});


parcelRegister("3fJGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25e63580bbd9aab7$var$_react = $25e63580bbd9aab7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $25e63580bbd9aab7$var$_link = $25e63580bbd9aab7$var$_interopRequireDefault((parcelRequire("h0HFa")));
function $25e63580bbd9aab7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $25e63580bbd9aab7$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $25e63580bbd9aab7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $25e63580bbd9aab7$var$_link.default
    }));
$25e63580bbd9aab7$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $25e63580bbd9aab7$var$_default = module.exports.default = $25e63580bbd9aab7$var$EditorLinkIcon;

});
parcelRegister("h0HFa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7939ee5038402c5f027adffad929d2df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6244e4cd9ddde64$var$_react = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c6244e4cd9ddde64$var$_UNSAFE_baseNew = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c6244e4cd9ddde64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6244e4cd9ddde64$var$LinkIcon = (props)=>/*#__PURE__*/ $c6244e4cd9ddde64$var$_react.default.createElement($c6244e4cd9ddde64$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$c6244e4cd9ddde64$var$LinkIcon.displayName = 'LinkIcon';
var $c6244e4cd9ddde64$var$_default = module.exports.default = $c6244e4cd9ddde64$var$LinkIcon;

});


parcelRegister("dZhDV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2eea8678fc0743c$var$_react = $a2eea8678fc0743c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2eea8678fc0743c$var$_mention = $a2eea8678fc0743c$var$_interopRequireDefault((parcelRequire("kxpIq")));
function $a2eea8678fc0743c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2eea8678fc0743c$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $a2eea8678fc0743c$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.467-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.521 7 7 7 .874 0 1.613-.09 2.258-.279a.751.751 0 0 0-.42-1.44c-.506.147-1.108.22-1.838.22-2.649 0-5.5-1.722-5.5-5.5 0-3.085 2.415-5.5 5.5-5.5 3.239 0 5.5 1.952 5.5 4.75 0 2.045-1.044 3-1.75 3-.007 0-.75-.11-.75-.75v-4a.75.75 0 1 0-1.5 0v.187c-.347-.585-1.017-.952-1.796-.952C10.103 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5"/></svg>`
    }, props, {
        newIcon: $a2eea8678fc0743c$var$_mention.default
    }));
$a2eea8678fc0743c$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $a2eea8678fc0743c$var$_default = module.exports.default = $a2eea8678fc0743c$var$EditorMentionIcon;

});
parcelRegister("kxpIq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5cad668d96b2a30ed351c60b482fb09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef3ad6446bb5dc3a$var$_react = $ef3ad6446bb5dc3a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ef3ad6446bb5dc3a$var$_UNSAFE_baseNew = $ef3ad6446bb5dc3a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $ef3ad6446bb5dc3a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef3ad6446bb5dc3a$var$MentionIcon = (props)=>/*#__PURE__*/ $ef3ad6446bb5dc3a$var$_react.default.createElement($ef3ad6446bb5dc3a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linecap="square" stroke-width="1.5" d="M11.625 14.28A7.25 7.25 0 1 1 15.25 8c0 1.381-.932 3.107-2.59 3.107-1.656 0-1.782-1.976-1.782-3.357l.005-.125m0 0c.022-1.019-.42-1.956-1.258-2.44-1.315-.759-3.11-.114-4.007 1.44s-.558 3.43.757 4.19c1.315.759 3.11.115 4.007-1.44a3.7 3.7 0 0 0 .5-1.75Z"/>`
    }, props));
$ef3ad6446bb5dc3a$var$MentionIcon.displayName = 'MentionIcon';
var $ef3ad6446bb5dc3a$var$_default = module.exports.default = $ef3ad6446bb5dc3a$var$MentionIcon;

});


parcelRegister("7XRtk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cc785836207fa6c$var$_react = $5cc785836207fa6c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $5cc785836207fa6c$var$_clock = $5cc785836207fa6c$var$_interopRequireDefault((parcelRequire("eSHsi")));
function $5cc785836207fa6c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5cc785836207fa6c$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $5cc785836207fa6c$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $5cc785836207fa6c$var$_clock.default
    }));
$5cc785836207fa6c$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $5cc785836207fa6c$var$_default = module.exports.default = $5cc785836207fa6c$var$EmojiFrequentIcon;

});

parcelRegister("f4oGi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8a5fe38412111b$var$_react = $af8a5fe38412111b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $af8a5fe38412111b$var$_textStyle = $af8a5fe38412111b$var$_interopRequireDefault((parcelRequire("9nFKt")));
function $af8a5fe38412111b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $af8a5fe38412111b$var$EmojiKeyboardIcon = (props)=>/*#__PURE__*/ $af8a5fe38412111b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m5.84 6.95-3.82 9.97a.5.5 0 0 0 .47.68H3.7a.5.5 0 0 0 .47-.33l.68-1.88a.5.5 0 0 1 .47-.33h3.8a.5.5 0 0 1 .47.33l.68 1.88a.5.5 0 0 0 .47.33h1.27a.5.5 0 0 0 .47-.68L8.69 6.95a.7.7 0 0 0-.66-.45H6.49a.7.7 0 0 0-.65.45m1.57 2.46 1.25 3.41a.2.2 0 0 1-.19.27h-2.5a.2.2 0 0 1-.19-.27l1.25-3.41a.2.2 0 0 1 .38 0m10.14 6.46c1.22 0 2.14-1.01 2.14-2.6s-.9-2.53-2.14-2.53c-1.26 0-2.18.94-2.18 2.53 0 1.58.9 2.6 2.18 2.6m2.16.6c-.37.83-1.28 1.43-2.44 1.43-2.57 0-4.27-2-4.27-4.64 0-2.55 1.66-4.57 4.2-4.57 1.56 0 2.28.83 2.5 1.33v-.34c0-.25.01-.39.21-.58q.21-.18.62-.16h.76a.58.58 0 0 1 .5.17c.21.2.19.42.19.58v6.39q0 .34.02.9 0 .29-.12.43a.63.63 0 0 1-.51.24h-.93c-.19 0-.45-.08-.53-.18s-.16-.23-.18-.53a6 6 0 0 1-.01-.36z"/></svg>`
    }, props, {
        newIcon: $af8a5fe38412111b$var$_textStyle.default
    }));
$af8a5fe38412111b$var$EmojiKeyboardIcon.displayName = 'EmojiKeyboardIcon';
var $af8a5fe38412111b$var$_default = module.exports.default = $af8a5fe38412111b$var$EmojiKeyboardIcon;

});
parcelRegister("9nFKt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03e2a0acabd5774aad5f5e2559df7d05>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d46a57315b78985$var$_react = $6d46a57315b78985$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6d46a57315b78985$var$_UNSAFE_baseNew = $6d46a57315b78985$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $6d46a57315b78985$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d46a57315b78985$var$TextStyleIcon = (props)=>/*#__PURE__*/ $6d46a57315b78985$var$_react.default.createElement($6d46a57315b78985$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 15v-.25l1.644-4.5M13.25 15v-.25l-1.644-4.5m0 0L8.5 1.75h-1l-3.106 8.5m7.212 0H4.394"/>`
    }, props));
$6d46a57315b78985$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $6d46a57315b78985$var$_default = module.exports.default = $6d46a57315b78985$var$TextStyleIcon;

});


parcelRegister("2OpmI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20c3ed57b318b9b4$var$_react = $20c3ed57b318b9b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $20c3ed57b318b9b4$var$_tag = $20c3ed57b318b9b4$var$_interopRequireDefault((parcelRequire("kBeAb")));
function $20c3ed57b318b9b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $20c3ed57b318b9b4$var$LabelIcon = (props)=>/*#__PURE__*/ $20c3ed57b318b9b4$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.433 5.428-4.207.6A2 2 0 0 0 5.53 7.727l-.6 4.207a1 1 0 0 0 .281.849l6.895 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283m-.647 5.858A1.666 1.666 0 1 1 8.43 8.929a1.666 1.666 0 0 1 2.357 2.357"/></svg>`
    }, props, {
        newIcon: $20c3ed57b318b9b4$var$_tag.default
    }));
$20c3ed57b318b9b4$var$LabelIcon.displayName = 'LabelIcon';
var $20c3ed57b318b9b4$var$_default = module.exports.default = $20c3ed57b318b9b4$var$LabelIcon;

});
parcelRegister("kBeAb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89cad69808757224d00e2fa96ed43d7e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eff293281ade4b06$var$_react = $eff293281ade4b06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $eff293281ade4b06$var$_UNSAFE_baseNew = $eff293281ade4b06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $eff293281ade4b06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eff293281ade4b06$var$TagIcon = (props)=>/*#__PURE__*/ $eff293281ade4b06$var$_react.default.createElement($eff293281ade4b06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8.768 1.75H13c.69 0 1.25.56 1.25 1.25v4.232c0 .332-.132.65-.366.884l-5.75 5.75a1.25 1.25 0 0 1-1.768 0L2.134 9.634a1.25 1.25 0 0 1 0-1.768l5.75-5.75a1.25 1.25 0 0 1 .884-.366Z"/><rect width="2" height="2" x="10" y="4" fill="currentcolor" rx="1"/>`
    }, props));
$eff293281ade4b06$var$TagIcon.displayName = 'TagIcon';
var $eff293281ade4b06$var$_default = module.exports.default = $eff293281ade4b06$var$TagIcon;

});


parcelRegister("dTV7w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1ecb853a8de6aa7$var$_react = $a1ecb853a8de6aa7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a1ecb853a8de6aa7$var$_image = $a1ecb853a8de6aa7$var$_interopRequireDefault((parcelRequire("lIfK7")));
function $a1ecb853a8de6aa7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a1ecb853a8de6aa7$var$MediaServicesScaleLargeIcon = (props)=>/*#__PURE__*/ $a1ecb853a8de6aa7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 6.007v11.986C5 18.55 5.45 19 6.007 19h11.986C18.55 19 19 18.55 19 17.993V6.007C19 5.45 18.55 5 17.993 5H6.007C5.45 5 5 5.45 5 6.007m-2 0A3.006 3.006 0 0 1 6.007 3h11.986A3.006 3.006 0 0 1 21 6.007v11.986A3.006 3.006 0 0 1 17.993 21H6.007A3.006 3.006 0 0 1 3 17.993z"/><path d="M11.005 17H16.5c.27 0 .5-.228.5-.509v-1.634a.73.73 0 0 0-.167-.44L14.5 11.85a.24.24 0 0 0-.344-.006L11 15l-.821-.821a.25.25 0 0 0-.358 0l-2.465 2.465c-.195.195-.136.356.135.356z"/><circle cx="9" cy="9" r="2"/></g></svg>`
    }, props, {
        newIcon: $a1ecb853a8de6aa7$var$_image.default
    }));
$a1ecb853a8de6aa7$var$MediaServicesScaleLargeIcon.displayName = 'MediaServicesScaleLargeIcon';
var $a1ecb853a8de6aa7$var$_default = module.exports.default = $a1ecb853a8de6aa7$var$MediaServicesScaleLargeIcon;

});
parcelRegister("lIfK7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::34cce0e65d0b47ff66878c07e93619ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fce9eb38094005c2$var$_react = $fce9eb38094005c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $fce9eb38094005c2$var$_UNSAFE_baseNew = $fce9eb38094005c2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $fce9eb38094005c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fce9eb38094005c2$var$ImageIcon = (props)=>/*#__PURE__*/ $fce9eb38094005c2$var$_react.default.createElement($fce9eb38094005c2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.75 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentcolor" fill-rule="evenodd" d="M5.75 6.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 14.25h9c.69 0 1.25-.56 1.25-1.25v-2M4 14.25H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8M4 14.25 10 7l4.25 4m-7.5-5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>`
    }, props));
$fce9eb38094005c2$var$ImageIcon.displayName = 'ImageIcon';
var $fce9eb38094005c2$var$_default = module.exports.default = $fce9eb38094005c2$var$ImageIcon;

});


parcelRegister("8CfG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $645e088e86b3f594$var$_react = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $645e088e86b3f594$var$_page = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("20Mcc")));
function $645e088e86b3f594$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $645e088e86b3f594$var$PageIcon = (props)=>/*#__PURE__*/ $645e088e86b3f594$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $645e088e86b3f594$var$_page.default
    }));
$645e088e86b3f594$var$PageIcon.displayName = 'PageIcon';
var $645e088e86b3f594$var$_default = module.exports.default = $645e088e86b3f594$var$PageIcon;

});
parcelRegister("20Mcc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cab2bd3bf7f5b1e2b2df4de8af9192f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1770f78818431634$var$_react = $1770f78818431634$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1770f78818431634$var$_UNSAFE_baseNew = $1770f78818431634$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1770f78818431634$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1770f78818431634$var$PageIcon = (props)=>/*#__PURE__*/ $1770f78818431634$var$_react.default.createElement($1770f78818431634$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$1770f78818431634$var$PageIcon.displayName = 'PageIcon';
var $1770f78818431634$var$_default = module.exports.default = $1770f78818431634$var$PageIcon;

});


parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $32f2cb577afb3a41$var$_peopleGroup = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("dd6Uq")));
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $32f2cb577afb3a41$var$_peopleGroup.default
    }));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = module.exports.default = $32f2cb577afb3a41$var$PeopleIcon;

});

parcelRegister("gk7tF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be245075b7e5aee7$var$_react = $be245075b7e5aee7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $be245075b7e5aee7$var$_sprint = $be245075b7e5aee7$var$_interopRequireDefault((parcelRequire("8TYIE")));
function $be245075b7e5aee7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $be245075b7e5aee7$var$SprintIcon = (props)=>/*#__PURE__*/ $be245075b7e5aee7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
    }, props, {
        newIcon: $be245075b7e5aee7$var$_sprint.default
    }));
$be245075b7e5aee7$var$SprintIcon.displayName = 'SprintIcon';
var $be245075b7e5aee7$var$_default = module.exports.default = $be245075b7e5aee7$var$SprintIcon;

});
parcelRegister("8TYIE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e1e458900ba648ff1441bd4c3cd4b08>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67b28f597116f9a1$var$_react = $67b28f597116f9a1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $67b28f597116f9a1$var$_UNSAFE_baseNew = $67b28f597116f9a1$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $67b28f597116f9a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67b28f597116f9a1$var$SprintIcon = (props)=>/*#__PURE__*/ $67b28f597116f9a1$var$_react.default.createElement($67b28f597116f9a1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0h7.25m-7.25 0H0m11.75-3.5 3.5 3.5-3.5 3.5"/>`
    }, props));
$67b28f597116f9a1$var$SprintIcon.displayName = 'SprintIcon';
var $67b28f597116f9a1$var$_default = module.exports.default = $67b28f597116f9a1$var$SprintIcon;

});


parcelRegister("eyI8O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9967b301fa2e1c2$var$_react = $a9967b301fa2e1c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a9967b301fa2e1c2$var$_subtasks = $a9967b301fa2e1c2$var$_interopRequireDefault((parcelRequire("cJdxC")));
function $a9967b301fa2e1c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a9967b301fa2e1c2$var$SubtaskIcon = (props)=>/*#__PURE__*/ $a9967b301fa2e1c2$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0 1 18.994 21H9.006A2.005 2.005 0 0 1 7 19h11c.555 0 1-.448 1-1zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994zM5 5v10h10V5z"/><path d="M7.707 9.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L9 10.586z"/></g></svg>`
    }, props, {
        newIcon: $a9967b301fa2e1c2$var$_subtasks.default
    }));
$a9967b301fa2e1c2$var$SubtaskIcon.displayName = 'SubtaskIcon';
var $a9967b301fa2e1c2$var$_default = module.exports.default = $a9967b301fa2e1c2$var$SubtaskIcon;

});
parcelRegister("cJdxC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::09a8c218325e783a9c5298a708af93a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9444310005a32072$var$_react = $9444310005a32072$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9444310005a32072$var$_UNSAFE_baseNew = $9444310005a32072$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9444310005a32072$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for subtasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9444310005a32072$var$SubtasksIcon = (props)=>/*#__PURE__*/ $9444310005a32072$var$_react.default.createElement($9444310005a32072$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3 8h10c.69 0 1.25.56 1.25 1.25V13c0 .69-.56 1.25-1.25 1.25H9.25C8.56 14.25 8 13.69 8 13V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v3.75C1.75 7.44 2.31 8 3 8Z"/>`
    }, props));
$9444310005a32072$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $9444310005a32072$var$_default = module.exports.default = $9444310005a32072$var$SubtasksIcon;

});




parcelRegister("kLC3n", function(module, exports) {

$parcel$export(module.exports, "useIssueViewIsVisible", () => $3fb0a1f5013f1e3d$export$433ecf2b8511729e);

var $jGcn0 = parcelRequire("jGcn0");

var $lB25E = parcelRequire("lB25E");
const $3fb0a1f5013f1e3d$export$433ecf2b8511729e = ()=>{
    const [selectedIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    return selectedIssueKey != null;
};

});

parcelRegister("Kei82", function(module, exports) {

$parcel$export(module.exports, "loadingCellStyles", () => $b5d716c64e0ac109$export$81b1b3cccf003fa1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $c9TLT = parcelRequire("c9TLT");
const $b5d716c64e0ac109$export$81b1b3cccf003fa1 = {
    backgroundColor: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N20})`,
    paddingleft: '1px',
    borderRadius: `${(0, $c9TLT.borderRadius)}px`,
    width: `calc(100% - ${(0, $c9TLT.gridSize) * 2}px)`,
    height: `calc(100% - ${(0, $c9TLT.gridSize) * 2}px)`,
    marginLeft: "var(--ds-space-100, 8px)"
};
const $b5d716c64e0ac109$export$5191481abee8295e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_9povrw": (0, $9t7rW.default)(__cmplp.width - (0, $c9TLT.gridSize) * 2, "px"),
            "--_1z066df": (0, $9t7rW.default)(__cmplp.height - (0, $c9TLT.gridSize) * 2, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1aqf _14eot94y _2rko1l7b _1bsb5cnj _4t3i5cnj _18u0u2gc",
            __cmplp.width ? "_1bsb1fse" : "_1bsb5cnj",
            __cmplp.height ? "_4t3i14kp" : "_4t3i5cnj",
            __cmplp.className
        ])
    });
});

});

parcelRegister("b7r1l", function(module, exports) {

$parcel$export(module.exports, "useCommentsSidebar", () => $14ddcd52da371266$export$aec60bac36c8115);

var $eUqFw = parcelRequire("eUqFw");

var $hSCS8 = parcelRequire("hSCS8");

var $jGcn0 = parcelRequire("jGcn0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");
const $14ddcd52da371266$export$aec60bac36c8115 = ({ CommentsSidebar: CommentsSidebar })=>{
    const [selectedIssueKey, setSelectedIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_COMMENT_PARAM));
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // set query param when comment cell is clicked
    const onOpen = (0, $eUqFw.useCallback)((issueKey)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'commentsSidebar opened');
        setSelectedIssueKey(issueKey);
    }, [
        createAnalyticsEvent,
        setSelectedIssueKey
    ]);
    // close comment sidebar on [X] button click
    const onClose = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'commentsSidebar closed');
        setSelectedIssueKey(undefined);
        setSidebarContent(null);
    }, [
        createAnalyticsEvent,
        setSelectedIssueKey,
        setSidebarContent
    ]);
    // set sidebar content after query param is set
    (0, $eUqFw.useEffect)(()=>{
        if (selectedIssueKey) {
            const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CommentsSidebar, {
                issueKey: selectedIssueKey,
                onClose: onClose
            });
            setSidebarContent(newContent);
        }
    }, [
        CommentsSidebar,
        onClose,
        selectedIssueKey,
        setSidebarContent
    ]);
    return {
        selectedIssueKey: selectedIssueKey,
        onOpenCommentsSidebar: onOpen,
        onCloseCommentsSidebar: onClose
    };
};

});

parcelRegister("jdYVO", function(module, exports) {

$parcel$export(module.exports, "useSystemFields", () => $f55deba2cfae4a59$export$91f469581f79f11f);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $gEmpR = parcelRequire("gEmpR");
const $f55deba2cfae4a59$export$91f469581f79f11f = ()=>{
    const { data: data } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const globalSystemFields = (0, $eUqFw.useMemo)(()=>{
        // if we don't have the issue types data yet, return an empty array
        if (!data || !data.fields || !data.fields.length) return [];
        const issueTypesAndFieldsData = data.fields;
        return issueTypesAndFieldsData.filter((field)=>!field.id.startsWith('customfield')).map((field)=>field.id).concat('key', (0, $jGcn0.COMMENT_SUMMARY_TYPE), (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
    }, [
        data
    ]);
    return {
        globalSystemFields: globalSystemFields
    };
};

});

parcelRegister("eMPoQ", function(module, exports) {

$parcel$export(module.exports, "useJiraSettings", () => $ff52a6775afdd596$export$5de424af876772e4);

var $iZuDo = parcelRequire("iZuDo");

var $guiFP = parcelRequire("guiFP");

var $eFSs8 = parcelRequire("eFSs8");

const $ff52a6775afdd596$export$5de424af876772e4 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [getProjectData, { data: data, loading: loading, error: error }] = (0, $iZuDo.useLazyQuery)((0, $eFSs8.JIRA_SETTINGS_QUERY), {
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'jiraSettingsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch jira settings in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    return {
        error: error,
        loading: loading,
        data: data,
        getProjectData: getProjectData
    };
};

});
parcelRegister("eFSs8", function(module, exports) {

$parcel$export(module.exports, "JIRA_SETTINGS_QUERY", () => $77c0dbbec0ed5a8d$export$652ac25405e90703);

var $9ypom = parcelRequire("9ypom");
const $77c0dbbec0ed5a8d$export$652ac25405e90703 = (0, $9ypom.default)`
  query JiraBusinessSettings {
    jiraSettings {
      timeTracking {
        isTimeTrackingEnabled
        hoursPerDay
        daysPerWeek
        defaultUnit
        format
      }
    }
  }
`;

});


parcelRegister("lhlwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6697d5f72505d3b8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6697d5f72505d3b8$var$CategoryCell = (0, $7rh0R.lazy)(()=>(parcelRequire("kSY5u")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/category-cell/main.tsx"
});
const $6697d5f72505d3b8$var$AsyncCategoryCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "category-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6697d5f72505d3b8$var$CategoryCell, props));
var $6697d5f72505d3b8$export$2e2bcd8739ae039 = $6697d5f72505d3b8$var$AsyncCategoryCell;

});
parcelRegister("kSY5u", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("aQX2q")
]).then(()=>parcelRequire('2aa7a'));

});


parcelRegister("d3tIX", function(module, exports) {

$parcel$export(module.exports, "getCellRenderer", () => $ae5e863b7902fa36$export$195172c54e8df31);
$parcel$export(module.exports, "CellWithHorizontalVirtualization", () => $ae5e863b7902fa36$export$9f868e7b7b690ae0);

var $eUqFw = parcelRequire("eUqFw");


var $8lNor = parcelRequire("8lNor");

var $lrJe0 = parcelRequire("lrJe0");

var $eI5EY = parcelRequire("eI5EY");

var $Kei82 = parcelRequire("Kei82");

var $aXbY8 = parcelRequire("aXbY8");

var $lqO9q = parcelRequire("lqO9q");

var $8safW = parcelRequire("8safW");

var $isXgL = parcelRequire("isXgL");
const $ae5e863b7902fa36$export$195172c54e8df31 = ({ cellRenderers: cellRenderers, field: field, onIssueUpdated: onIssueUpdated, projectId: projectId, width: width })=>(0, $lrJe0.isFieldCellTypes)(field.type) && (0, $lrJe0.isFieldCellSupported)(field.type) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? (params)=>{
        const { rowData: rowData, rowIndex: rowIndex, columnIndex: columnIndex } = params;
        if ((0, $aXbY8.isItemSkeleton)(rowData.issueId) || field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN))) // experimenting with inlining CSS here to avoid styled-components runtime perf overhead
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testId": "business-list.ui.list-view.loading-cell",
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            style: (0, $Kei82.loadingCellStyles)
        });
        let cellData;
        if ((0, $8lNor.isTopLevelField)(field.type)) {
            const key = (0, $8lNor.getTopLevelFieldKey)(field.type);
            if (key) cellData = rowData[key];
        } else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        cellData = rowData.fields?.find((f)=>f.fieldId === field.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $isXgL.WithCellSelection), {
            depth: rowData.depth,
            width: width,
            fieldId: field.id,
            projectId: projectId,
            issueId: rowData.issueId,
            position: rowIndex === 0 ? (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) : (0, $18eb89570dd03c8c$export$a3a66eb204e551b3),
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            field: field,
            issue: rowData
        }, ()=>// Check for type existence was already done above
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lrJe0.FieldCell), {
                fieldType: field.type ?? '',
                ...params,
                cellData: cellData,
                onIssueUpdated: onIssueUpdated,
                fieldId: field.id,
                fieldName: field.name
            }));
    } : (params)=>{
        const { rowData: rowData, rowIndex: rowIndex, columnIndex: columnIndex } = params;
        if ((0, $aXbY8.isItemSkeleton)(rowData.issueId) || field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN))) // experimenting with inlining CSS here to avoid styled-components runtime perf overhead
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testId": "business-list.ui.list-view.loading-cell",
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            style: (0, $Kei82.loadingCellStyles)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $isXgL.WithCellSelection), {
            depth: rowData.depth,
            width: width,
            fieldId: field.id,
            projectId: projectId,
            issueId: rowData.issueId,
            position: rowIndex === 0 ? (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) : (0, $18eb89570dd03c8c$export$a3a66eb204e551b3),
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            field: field,
            issue: rowData
        }, ()=>cellRenderers[field.id](params));
    };
const $ae5e863b7902fa36$export$f6f0c3fe4ec306ea = /*#__PURE__*/ (0, $eUqFw.memo)(({ cellRenderers: cellRenderers, field: field, onIssueUpdated: onIssueUpdated, projectId: projectId, width: width, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $ae5e863b7902fa36$export$195172c54e8df31({
        cellRenderers: cellRenderers,
        field: field,
        onIssueUpdated: onIssueUpdated,
        projectId: projectId,
        width: width
    })({
        ...rest,
        onIssueUpdated: onIssueUpdated
    })));
$ae5e863b7902fa36$export$f6f0c3fe4ec306ea.displayName = 'Cell';
const $ae5e863b7902fa36$export$9f868e7b7b690ae0 = (props)=>{
    const isColumnVisible = (0, $8safW.useIsColumnVisible)(props.column);
    return isColumnVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae5e863b7902fa36$export$f6f0c3fe4ec306ea, props) : null;
};

});
const $18eb89570dd03c8c$export$86bcdda8e7a22b9d = 'inner';
const $18eb89570dd03c8c$export$a3a66eb204e551b3 = 'outer';

parcelRegister("lrJe0", function(module, exports) {

$parcel$export(module.exports, "isFieldCellSupported", () => $3aa6b48d7ccfbcb2$export$33fa2ddeaefadb7f);
$parcel$export(module.exports, "isFieldCellTypes", () => $3aa6b48d7ccfbcb2$export$6a0360e2da5b783e);
$parcel$export(module.exports, "FieldCell", () => $3aa6b48d7ccfbcb2$export$8ae908fe84f8a33b);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $kzRbi = parcelRequire("kzRbi");

var $eyVJl = parcelRequire("eyVJl");

var $iwcjI = parcelRequire("iwcjI");

var $gnGlI = parcelRequire("gnGlI");

var $88U8t = parcelRequire("88U8t");

var $87lYv = parcelRequire("87lYv");

var $6l2d2 = parcelRequire("6l2d2");

var $csWQF = parcelRequire("csWQF");

var $edUxi = parcelRequire("edUxi");

var $bOyhU = parcelRequire("bOyhU");

var $cWB05 = parcelRequire("cWB05");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
const $3aa6b48d7ccfbcb2$var$createFieldCellComponents = (0, $5iWql.default)(()=>({
        ...(0, $cWB05.versionCellHandler),
        ...(0, $88U8t.parentCellHandler),
        ...(0, $eyVJl.devSummaryCellHandler),
        ...(0, $eI5EY.fg)('native_goals_integration_on_list_view') ? (0, $iwcjI.goalsCellHandler) : {},
        ...(0, $bOyhU.teamCellHandler),
        ...(0, $1ybV0.ff)('jira.list.field-support-part1') ? {
            ...(0, $csWQF.resolutionCellHandler),
            ...(0, $gnGlI.groupCellHandler),
            ...(0, $edUxi.statusCategoryCellHandler),
            ...(0, $6l2d2.radioSelectCellHandler),
            ...(0, $87lYv.projectCellHandler),
            ...(0, $kzRbi.cascadingSelectCellHandler)
        } : {}
    }));
const $3aa6b48d7ccfbcb2$export$33fa2ddeaefadb7f = (fieldType)=>{
    const Components = $3aa6b48d7ccfbcb2$var$createFieldCellComponents();
    return Components[fieldType] != null;
};
const $3aa6b48d7ccfbcb2$export$6a0360e2da5b783e = (_)=>true;
const $3aa6b48d7ccfbcb2$export$8ae908fe84f8a33b = ({ fieldType: fieldType, ...cellProps })=>{
    const Components = $3aa6b48d7ccfbcb2$var$createFieldCellComponents();
    if (!$3aa6b48d7ccfbcb2$export$6a0360e2da5b783e(fieldType)) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const Component = Components[fieldType];
    if (Component == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, cellProps);
};

});
parcelRegister("kzRbi", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectCellHandler", () => $4fb564aabcdf3c81$export$27b118c54b403d55);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $59U5n = parcelRequire("59U5n");

var $4TezD = parcelRequire("4TezD");

var $fiEoq = parcelRequire("fiEoq");

var $l4xGf = parcelRequire("l4xGf");
const $4fb564aabcdf3c81$export$4f505fdc26f544f5 = ({ rowData: issue, cellData: field, setEditMode: setEditMode, editMode: editMode, column: { width: preferredWidth }, cellRef: cellRef })=>{
    const [cascadingSelectValue, setCascadingSelectValue] = (0, $eUqFw.useState)(field?.value ?? null);
    // Update the value when it is updated in cache (e.g. via realtime)
    (0, $eUqFw.useEffect)(()=>{
        setCascadingSelectValue(field?.value ?? null);
    }, [
        field?.value
    ]);
    const isEditable = (0, $eUqFw.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [{ value: value }] = (0, $59U5n.useCascadingSelectField)({
            fieldAriId: field?.id ?? '',
            issueKey: issue.key,
            fieldKey: field?.fieldId ?? '',
            initialValue: field?.value ?? null
        });
        if (value !== cascadingSelectValue) setCascadingSelectValue(value);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable,
        testId: "business-fields.ui.cascading-select.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiEoq.CascadingSelectEdit), {
        cellRef: cellRef,
        setEditMode: setEditMode,
        fieldAriId: field?.id ?? '',
        onChange: setCascadingSelectValue,
        preferredWidth: preferredWidth,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l4xGf.CascadingSelectRead), {
            value: cascadingSelectValue
        }),
        currentValue: cascadingSelectValue,
        issueKey: issue.key,
        fieldKey: field?.fieldId || ''
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l4xGf.CascadingSelectRead), {
        value: cascadingSelectValue
    }));
};
const $4fb564aabcdf3c81$export$27b118c54b403d55 = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $4fb564aabcdf3c81$export$4f505fdc26f544f5
};

});
parcelRegister("59U5n", function(module, exports) {

$parcel$export(module.exports, "useCascadingSelectField", () => $5267396a28d8dfee$export$f7e91b2d1b79d323);

var $5I9Yw = parcelRequire("5I9Yw");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");
const $5267396a28d8dfee$export$f7e91b2d1b79d323 = ({ fieldAriId: fieldAriId, issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onFailure: onFailure })=>{
    const [editValue, setEditValue] = (0, $eUqFw.useState)(initialValue);
    const [commit] = (0, $iWLL0.useMutation)((0, $5I9Yw.default));
    const saveField = (0, $eUqFw.useCallback)((_iKey, _fKey, valuesForOperation)=>{
        if (!valuesForOperation) return Promise.resolve(undefined);
        const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = valuesForOperation;
        commit({
            variables: {
                input: {
                    id: fieldAriId,
                    operation: {
                        operation: 'SET',
                        parentOption: parentOptionValue?.id,
                        childOption: childOptionValue?.id
                    }
                }
            },
            onError: onFailure,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateCascadingSelectField: {
                        success: true,
                        errors: null
                    }
                }
            }
        });
        return Promise.resolve(undefined);
    }, [
        commit,
        fieldAriId,
        onFailure
    ]);
    const [{ value: value }, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldType: (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
        issueId: fieldAriId,
        issueKey: issueKey,
        initialValue: initialValue,
        fieldKey: fieldKey,
        saveField: saveField
    });
    return [
        {
            value: value,
            editValue: editValue,
            setEditValue: setEditValue
        },
        {
            saveValue: saveValue
        }
    ];
};

});
parcelRegister("5I9Yw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ccd7374faf6725a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5337e08f4a6e3693b40b3f92c8241db8>>
 * @relayHash bc0a11e2d247719800de1eb6e77c7c87
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12730951e32e781c2e6ae674a94e143040f31ada508e9e2b7d53cf86f2aea40f
const $1ccd7374faf6725a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraCascadingSelectFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateCascadingSelectField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelectField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelectField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "12730951e32e781c2e6ae674a94e143040f31ada508e9e2b7d53cf86f2aea40f",
            "metadata": {},
            "name": "cascadingSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$1ccd7374faf6725a$var$node.hash = "30c90a51c8447b75fc86baef709bc308";
var $1ccd7374faf6725a$export$2e2bcd8739ae039 = $1ccd7374faf6725a$var$node;

});

parcelRegister("gGiWF", function(module, exports) {

$parcel$export(module.exports, "useEditField", () => $04407df9ae6d3d74$export$343e962d356c0af1);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5oStv = parcelRequire("5oStv");

var $5oStv = parcelRequire("5oStv");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $7byHA = parcelRequire("7byHA");

var $hJ992 = parcelRequire("hJ992");

var $8wbQu = parcelRequire("8wbQu");

var $7eDnP = parcelRequire("7eDnP");

var $8p8vy = parcelRequire("8p8vy");

var $3koWU = parcelRequire("3koWU");

var $jMP2a = parcelRequire("jMP2a");

var $kmr29 = parcelRequire("kmr29");

var $fecbI = parcelRequire("fecbI");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $04407df9ae6d3d74$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $04407df9ae6d3d74$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $04407df9ae6d3d74$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $04407df9ae6d3d74$var$getFieldValue, saveField: saveField = (0, $fecbI.defaultSaveField), saveFieldById: saveFieldById = (0, $fecbI.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $fecbI.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $fecbI.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $3koWU.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const resetError = (0, $eUqFw.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $eUqFw.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: analyticsFieldTypeAlias ?? fieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $04407df9ae6d3d74$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            if ((0, $1ybV0.ff)('ui-modifications-issue-view-status-custom-field-support_hwx15')) onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            else onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent);
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $7byHA.ValidationError);
            if (!isValidationError) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            if (fieldKey === 'timetracking' && (0, $1ybV0.ff)('jiv-18751-investigate-time-tracking-update-errors_ng38s')) (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'timetracking updateFailed', {
                fieldKey: fieldKey,
                fieldType: fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $JRB5w.isClientFetchError)(ex),
                exception: ex
            });
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $JRB5w.isClientFetchError)(ex)
            });
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $eUqFw.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $eUqFw.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $04407df9ae6d3d74$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $hJ992.useIssueId)();
    const contextualIssueKey = (0, $hJ992.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $04407df9ae6d3d74$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $04407df9ae6d3d74$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const isEditFromIssueView = (0, $8wbQu.useIsEditFromIssueView);
    const onSubmitFn = (0, $eUqFw.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $eUqFw.useCallback)(// Remove optional from meta with `ui-modifications-issue-view-status-custom-field-support_hwx15` FF clean up
    async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        if ((0, $1ybV0.ff)('ui-modifications-issue-view-status-custom-field-support_hwx15')) issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, meta);
        else issueId && fieldChanged(issueId, fieldKey, fieldValue);
        if (!shouldPreventIssueViewSoftRefresh && !isEditFromIssueView(event)) try {
            const reason = (0, $7eDnP.Reason).SoftRefresh;
            (0, $1ybV0.ff)('relay-migration-issue-fields-soft-refresh-ld') ? await (0, $5oStv.default).refreshIssuePageThrowable(issueKey, reason) : await (0, $5oStv.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        shouldPreventIssueViewSoftRefresh,
        isEditFromIssueView,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $eUqFw.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $04407df9ae6d3d74$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("5oStv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdea36b35279d86d$export$2e2bcd8739ae039);

var $7eDnP = parcelRequire("7eDnP");
const $bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addEventListener = (event, callback)=>{
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeEventListener = (event, callback)=>{
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $bdea36b35279d86d$var$refreshIssuePageThrowable = (issueKey, reason = (0, $7eDnP.Reason).OnDemand)=>{
    try {
        document.dispatchEvent(new CustomEvent($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $bdea36b35279d86d$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $bdea36b35279d86d$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdea36b35279d86d$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $bdea36b35279d86d$var$addRefreshIssueListener,
    removeRefreshIssueListener: $bdea36b35279d86d$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $bdea36b35279d86d$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $bdea36b35279d86d$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $bdea36b35279d86d$var$refreshIssuePageThrowable,
    refreshIssuePage: $bdea36b35279d86d$var$refreshIssuePage
};

});
parcelRegister("7eDnP", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $501d104507444a18$export$fe867595c4640fb1);
const $501d104507444a18$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});


parcelRegister("8wbQu", function(module, exports) {

$parcel$export(module.exports, "useIsEditFromIssueView", () => $e05e50438955dd5a$export$870b996a6c1c7896);

var $hRcYT = parcelRequire("hRcYT");

var $iKlrz = parcelRequire("iKlrz");
const $e05e50438955dd5a$export$870b996a6c1c7896 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'backlogScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $iKlrz.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hRcYT.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("8p8vy", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $0829b81e40dd527a$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $0829b81e40dd527a$export$f9eb49cc2f0e28ce);

var $1ybV0 = parcelRequire("1ybV0");

var $96gVp = parcelRequire("96gVp");
var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $focHG = parcelRequire("focHG");

var $k3tie = parcelRequire("k3tie");
const $0829b81e40dd527a$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $0829b81e40dd527a$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if ((0, $1ybV0.ff)('relay-migration-issue-fields-events-transformer-ld')) {
            if (aggFieldChangeProps) value = (0, $focHG.transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
        }
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    ...(0, $1ybV0.ff)('ui-modifications-issue-view-status-custom-field-support_hwx15') ? {
                        additionalProperties: additionalProperties
                    } : {}
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if ((0, $1ybV0.ff)('relay-migration-issue-fields-events-transformer-ld')) {
            if (aggFieldChangeProps) value = (0, $focHG.transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
        }
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $0829b81e40dd527a$var$actions = {
    fieldChanged: $0829b81e40dd527a$var$fieldChanged,
    fieldChangeFailed: $0829b81e40dd527a$var$fieldChangeFailed,
    fieldChangeRequested: $0829b81e40dd527a$var$fieldChangeRequested,
    registerEventHandler: $0829b81e40dd527a$var$registerEventHandler
};
// this is a global state
const $0829b81e40dd527a$var$store = (0, $kEDjj.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $0829b81e40dd527a$var$actions
});
const $0829b81e40dd527a$export$444af741f6d8f512 = (0, $1yZQx.createHook)($0829b81e40dd527a$var$store, {
    selector: null
});
const $0829b81e40dd527a$export$f9eb49cc2f0e28ce = (0, $96gVp.createContainer)($0829b81e40dd527a$var$store);

});
parcelRegister("focHG", function(module, exports) {

$parcel$export(module.exports, "transformAggToLegacy", () => $ecb153413af3f22f$export$d951e3c38e10736d);

var $9ax61 = parcelRequire("9ax61");

var $lO4Or = parcelRequire("lO4Or");

var $9r5wz = parcelRequire("9r5wz");
const $ecb153413af3f22f$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // case MULTI_USER_PICKER_GQL_FIELD:
        case 0, $lO4Or.PEOPLE_GQL_FIELD:
            throw new Error('Requires manual implementation as the transformer package require context for this field aka all issue fields');
        // otherwise we can default to the existing package
        case 0, $lO4Or.SECURITY_GQL_FIELD:
        case 0, $lO4Or.NUMBER_GQL_FIELD:
        case 0, $lO4Or.TEXT_GQL_FIELD:
        case 0, $lO4Or.USER_PICKER_GQL_FIELD:
        case 0, $lO4Or.PRIORITY_GQL_FIELD:
        case 0, $lO4Or.URL_GQL_FIELD:
        case 0, $lO4Or.DATE_PICKER_GQL_FIELD:
        case 0, $lO4Or.PROJECT_GQL_FIELD:
        case 0, $lO4Or.DATE_TIME_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $9ax61.transformAggFieldToLegacyField)({
                [$ecb153413af3f22f$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        case 0, $lO4Or.PARENT_GQL_FIELD:
            return (0, $9r5wz.transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
        case 0, $lO4Or.SPRINT_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $9ax61.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                ...fieldValue
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $ecb153413af3f22f$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $lO4Or.TEXT_GQL_FIELD)]: 'text',
        [(0, $lO4Or.NUMBER_GQL_FIELD)]: 'number',
        [(0, $lO4Or.PRIORITY_GQL_FIELD)]: 'priority',
        [(0, $lO4Or.USER_PICKER_GQL_FIELD)]: 'user',
        [(0, $lO4Or.DATE_PICKER_GQL_FIELD)]: 'date',
        [(0, $lO4Or.PROJECT_GQL_FIELD)]: 'project',
        [(0, $lO4Or.DATE_TIME_GQL_FIELD)]: 'dateTime',
        [(0, $lO4Or.URL_GQL_FIELD)]: 'uri',
        [(0, $lO4Or.SECURITY_GQL_FIELD)]: 'securityLevel'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
};

});
parcelRegister("9ax61", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $85127a55c87acb28$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $85127a55c87acb28$export$ba106ff8c087e6b1);

var $5iWql = parcelRequire("5iWql");

var $lO4Or = parcelRequire("lO4Or");

var $kBgu2 = parcelRequire("kBgu2");

var $blEoo = parcelRequire("blEoo");

var $6Ux91 = parcelRequire("6Ux91");

var $5sNJN = parcelRequire("5sNJN");

var $2wvLE = parcelRequire("2wvLE");

var $8d1m1 = parcelRequire("8d1m1");

var $5CYGa = parcelRequire("5CYGa");

var $9wKha = parcelRequire("9wKha");

var $6PKzm = parcelRequire("6PKzm");

var $jyP56 = parcelRequire("jyP56");

var $epJqO = parcelRequire("epJqO");

var $Pxexr = parcelRequire("Pxexr");

var $beuR4 = parcelRequire("beuR4");

var $d9IUw = parcelRequire("d9IUw");

var $xnQ91 = parcelRequire("xnQ91");

var $jsTfy = parcelRequire("jsTfy");

var $55kng = parcelRequire("55kng");

var $7BRej = parcelRequire("7BRej");

var $04Gbh = parcelRequire("04Gbh");

var $3ZJZc = parcelRequire("3ZJZc");

var $bw8ws = parcelRequire("bw8ws");

var $9vCKL = parcelRequire("9vCKL");

var $i5dch = parcelRequire("i5dch");

var $iJcxE = parcelRequire("iJcxE");

var $djkJh = parcelRequire("djkJh");

var $kbDa2 = parcelRequire("kbDa2");

var $4gy8O = parcelRequire("4gy8O");

var $9w928 = parcelRequire("9w928");

var $3khS7 = parcelRequire("3khS7");

var $c52Z6 = parcelRequire("c52Z6");

var $6IjGS = parcelRequire("6IjGS");

var $eOsdu = parcelRequire("eOsdu");

var $6MxWX = parcelRequire("6MxWX");

var $9myMG = parcelRequire("9myMG");

var $gM34d = parcelRequire("gM34d");

var $16kx8 = parcelRequire("16kx8");

var $4IQ8F = parcelRequire("4IQ8F");

var $lcInz = parcelRequire("lcInz");

var $4PFnn = parcelRequire("4PFnn");

var $alpM1 = parcelRequire("alpM1");

var $l6kyU = parcelRequire("l6kyU");

var $gHd8e = parcelRequire("gHd8e");

var $dUrU1 = parcelRequire("dUrU1");

var $hQM7C = parcelRequire("hQM7C");

var $QjWSM = parcelRequire("QjWSM");

var $4CGp4 = parcelRequire("4CGp4");

var $lWE99 = parcelRequire("lWE99");

var $4eNqf = parcelRequire("4eNqf");

var $fkHM1 = parcelRequire("fkHM1");

var $fkaQR = parcelRequire("fkaQR");

var $ijtj3 = parcelRequire("ijtj3");

var $gyvos = parcelRequire("gyvos");

var $3w75b = parcelRequire("3w75b");

var $lQr58 = parcelRequire("lQr58");

var $8oO4q = parcelRequire("8oO4q");

var $5Ne6t = parcelRequire("5Ne6t");

var $2ETkN = parcelRequire("2ETkN");

var $fz8Wc = parcelRequire("fz8Wc");

var $jBiXV = parcelRequire("jBiXV");

var $1XUHd = parcelRequire("1XUHd");

var $c6LKM = parcelRequire("c6LKM");

var $8zTcQ = parcelRequire("8zTcQ");

var $5W75j = parcelRequire("5W75j");

var $7iFVU = parcelRequire("7iFVU");

var $kyZt3 = parcelRequire("kyZt3");

var $dX2ot = parcelRequire("dX2ot");

var $jhiYN = parcelRequire("jhiYN");

var $1BsAz = parcelRequire("1BsAz");
// We're memoising this just in case we FF another field
const $85127a55c87acb28$var$getTransformersNonMemoised = ()=>({
        [(0, $lO4Or.AFFECTED_SERVICES_GQL_FIELD)]: (0, $kBgu2.transformAggAffectedServicesToLegacyField),
        [(0, $lO4Or.BOOLEAN_GQL_FIELD)]: (0, $6Ux91.transformAggBooleanToLegacyField),
        [(0, $lO4Or.CASCADING_SELECT_GQL_FIELD)]: (0, $5sNJN.transformAggCascadingSelectToLegacyField),
        [(0, $lO4Or.CHECKBOX_GQL_FIELD)]: (0, $2wvLE.transformAggCheckboxToLegacyField),
        [(0, $lO4Or.CMDB_GQL_FIELD)]: (0, $8d1m1.transformAggCMDBToLegacyField),
        [(0, $lO4Or.MULTI_SELECT_GQL_FIELD)]: (0, $hQM7C.transformAggMultipleSelectToLegacyField),
        [(0, $lO4Or.COMPONENTS_GQL_FIELD)]: (0, $9wKha.transformAggComponentsToLegacyField),
        [(0, $lO4Or.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $6PKzm.transformAggConnectDateTimeToLegacyField),
        [(0, $lO4Or.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $jyP56.transformAggConnectMultipleSelectToLegacyField),
        [(0, $lO4Or.CONNECT_NUMBER_GQL_FIELD)]: (0, $epJqO.transformAggConnectNumberToLegacyField),
        [(0, $lO4Or.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $Pxexr.transformAggConnectRichTextToLegacyField),
        [(0, $lO4Or.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $beuR4.transformAggConnectSingleSelectToLegacyField),
        [(0, $lO4Or.CONNECT_TEXT_GQL_FIELD)]: (0, $d9IUw.transformAggConnectTextToLegacyField),
        [(0, $lO4Or.COLOR_GQL_FIELD)]: (0, $5CYGa.transformAggColorToLegacyField),
        [(0, $lO4Or.DATE_PICKER_GQL_FIELD)]: (0, $jsTfy.transformAggDatePickerToLegacyField),
        [(0, $lO4Or.DATE_TIME_GQL_FIELD)]: (0, $55kng.transformAggDateTimePickerToLegacyField),
        [(0, $lO4Or.EPIC_LINK_GQL_FIELD)]: (0, $7BRej.transformAggEpicLinkToLegacyField),
        [(0, $lO4Or.FLAG_GQL_FIELD)]: (0, $04Gbh.transformAggFlagToLegacyField),
        [(0, $lO4Or.FORGE_DATETIME_GQL_FIELD)]: (0, $bw8ws.transformAggForgeDateTimeToLegacyField),
        [(0, $lO4Or.FORGE_DATE_GQL_FIELD)]: (0, $3ZJZc.transformAggForgeDateToLegacyField),
        [(0, $lO4Or.FORGE_GROUP_GQL_FIELD)]: (0, $9vCKL.transformAggForgeGroupToLegacyField),
        [(0, $lO4Or.FORGE_GROUPS_GQL_FIELD)]: (0, $i5dch.transformAggForgeGroupsToLegacyField),
        [(0, $lO4Or.FORGE_NUMBER_GQL_FIELD)]: (0, $iJcxE.transformAggForgeNumberToLegacyField),
        [(0, $lO4Or.FORGE_OBJECT_GQL_FIELD)]: (0, $djkJh.transformAggForgeObjectToLegacyField),
        [(0, $lO4Or.FORGE_STRING_GQL_FIELD)]: (0, $kbDa2.transformAggForgeStringToLegacyField),
        [(0, $lO4Or.FORGE_STRINGS_GQL_FIELD)]: (0, $4gy8O.transformAggForgeStringsToLegacyField),
        [(0, $lO4Or.FORGE_USER_GQL_FIELD)]: (0, $9w928.transformAggForgeUserToLegacyField),
        [(0, $lO4Or.FORGE_USERS_GQL_FIELD)]: (0, $3khS7.transformAggForgeUsersToLegacyField),
        [(0, $lO4Or.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $6IjGS.transformAggIssueRestrictionToLegacyField),
        [(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)]: (0, $eOsdu.transformAggIssueTypeToLegacyField),
        [(0, $lO4Or.JSM_APPROVAL_GQL_FIELD)]: (0, $6MxWX.transformAggJSMApprovalsToLegacyField),
        [(0, $lO4Or.JSM_ASSETS_GQL_FIELD)]: (0, $blEoo.transformAggAssetToLegacyField),
        [(0, $lO4Or.JSM_MAJOR_INCIDENT_FIELD)]: (0, $gM34d.transformAggJSMMajorIncidentToLegacyField),
        [(0, $lO4Or.JSM_ORGANIZATION_GQL_FIELD)]: (0, $16kx8.transformAggJSMOrganizationToLegacyField),
        [(0, $lO4Or.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $9myMG.transformAggJSMEntitlementsToLegacyField),
        [(0, $lO4Or.JSM_SENTIMENT_GQL_FIELD)]: (0, $l6kyU.transformAggJSMSentimentToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $lO4Or.JSM_PEOPLE_GQL_FIELD)]: (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $4IQ8F.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $lcInz.transformAggJSMRequestLanguageToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $4PFnn.transformAggJSMRequestTypeToLegacyField),
        [(0, $lO4Or.JSM_RESPONDERS_GQL_FIELD)]: (0, $alpM1.transformAggJSMRespondersToLegacyField),
        [(0, $lO4Or.LABEL_GQL_FIELD)]: (0, $gHd8e.transformAggLabelsNodeToLegacyField),
        [(0, $lO4Or.PRIORITY_GQL_FIELD)]: (0, $fkHM1.transformAggPriorityToLegacyField),
        [(0, $lO4Or.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $dUrU1.transformAggMultiGroupPickerToLegacyField),
        [(0, $lO4Or.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.NUMBER_GQL_FIELD)]: (0, $lWE99.transformAggNumberToLegacyField),
        [(0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $4eNqf.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $lO4Or.PEOPLE_GQL_FIELD)]: (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.PROFORMA_FORMS_GQL_FIELD)]: (0, $fkaQR.transformAggProformaFormsToLegacyField),
        [(0, $lO4Or.PROJECT_GQL_FIELD)]: (0, $ijtj3.transformAggProjectToLegacyField),
        [(0, $lO4Or.MULTI_VERSION_GQL_FIELD)]: (0, $4CGp4.transformAggMultipleVersionPickerToLegacyField),
        [(0, $lO4Or.RADIO_GQL_FIELD)]: (0, $gyvos.transformAggRadioSelectToLegacyField),
        [(0, $lO4Or.RICH_TEXT_GQL_FIELD)]: (0, $lQr58.transformAggRichTextToLegacyField),
        [(0, $lO4Or.RESOLUTION_GQL_FIELD)]: (0, $3w75b.transformAggResolutionToLegacyField),
        [(0, $lO4Or.SECURITY_GQL_FIELD)]: (0, $8oO4q.transformAggSecurityLevelToLegacyField),
        [(0, $lO4Or.SPRINT_GQL_FIELD)]: (0, $c6LKM.transformAggSprintToLegacyField),
        [(0, $lO4Or.STATUS_GQL_FIELD)]: (0, $8zTcQ.transformAggStatusToLegacyField),
        [(0, $lO4Or.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $5Ne6t.transformAggSingleGroupPickerToLegacyField),
        [(0, $lO4Or.SINGLE_SELECT_GQL_FIELD)]: (0, $fz8Wc.transformAggSingleSelectToLegacyField),
        [(0, $lO4Or.TEAM_GQL_FIELD)]: (0, $5W75j.transformAggTeamToLegacyField),
        [(0, $lO4Or.TEAM_VIEW_GQL_FIELD)]: (0, $7iFVU.transformAggTeamViewToLegacyField),
        [(0, $lO4Or.TEXT_GQL_FIELD)]: (0, $2ETkN.transformAggSingleLineTextToLegacyField),
        [(0, $lO4Or.TIME_TRACKING_GQL_FIELD)]: (0, $kyZt3.transformAggTimeTrackingToLegacyField),
        [(0, $lO4Or.USER_PICKER_GQL_FIELD)]: (0, $jBiXV.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $lO4Or.URL_GQL_FIELD)]: (0, $dX2ot.transformAggUrlToLegacyField),
        [(0, $lO4Or.VERSION_GQL_FIELD)]: (0, $1XUHd.transformAggSingleVersionPickerToLegacyField),
        [(0, $lO4Or.VOTES_GQL_FIELD)]: (0, $jhiYN.transformAggVotesToLegacyField),
        [(0, $lO4Or.WATCHES_GQL_FIELD)]: (0, $1BsAz.transformAggWatchesToLegacyField),
        [(0, $lO4Or.DATA_CLASSIFICATION_FIELD)]: (0, $xnQ91.transformAggDataClassificationToLegacyField),
        [(0, $lO4Or.GOALS_GQL_FIELD)]: (0, $c52Z6.transformAggGoalsToLegacyField)
    });
const $85127a55c87acb28$var$getTransformers = (0, $5iWql.default)($85127a55c87acb28$var$getTransformersNonMemoised);
const $85127a55c87acb28$export$586ba15cbf3d3031 = (node, context)=>{
    const typename = node.__typename;
    const transformer = $85127a55c87acb28$var$getTransformers()[typename];
    return transformer ? transformer(node, context) : undefined;
};
const $85127a55c87acb28$export$ba106ff8c087e6b1 = (fields)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const transformedField = $85127a55c87acb28$export$586ba15cbf3d3031(fieldEdge.node, fields);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("kBgu2", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $347ea3dcad361eb5$export$231e0419515441d4);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $347ea3dcad361eb5$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $347ea3dcad361eb5$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $lO4Or.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedAffectedServicesConnection, $347ea3dcad361eb5$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $c7e7b1d3600a0c0f$export$a4a240cb4053b29f = 'jira-text-renderer';
const $c7e7b1d3600a0c0f$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("f4e7j", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $e263c15d21d94d7e$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $e263c15d21d94d7e$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $e263c15d21d94d7e$export$b5de5f3d2de73afc);
const $e263c15d21d94d7e$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $e263c15d21d94d7e$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $e263c15d21d94d7e$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("blEoo", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $894bbc4a3f1bdf98$export$2136dcd78a2ef18f);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $894bbc4a3f1bdf98$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $lO4Or.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("6Ux91", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $0e4e588f42a69494$export$4bd89b95f0d10de9);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $0e4e588f42a69494$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("5sNJN", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $8a9ad29dba216e4b$export$a8778af5ceb1017c);

var $1ybV0 = parcelRequire("1ybV0");


var $f4e7j = parcelRequire("f4e7j");
const $8a9ad29dba216e4b$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    const allowedValues = (0, $1ybV0.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration') ? [] : (0, $f4e7j.transformAggConnection)(node.cascadingOptions, (cascadingOption)=>{
        if (!cascadingOption.parentOptionValue) return null;
        const { parentOptionValue: parentOptionValue, childOptionValues: childOptionValues } = cascadingOption;
        const childrenObj = childOptionValues?.length ? {
            children: childOptionValues.filter(Boolean).map((option)=>({
                    id: option.optionId,
                    value: option.value ?? null,
                    ari: option.id
                }))
        } : {};
        return {
            value: parentOptionValue.value,
            id: parentOptionValue.optionId,
            ...childrenObj
        };
    });
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option-with-child',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2wvLE", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $de1faea4cf000ccb$export$baa5afdbd8fd12d3);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $de1faea4cf000ccb$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $f4e7j.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("8d1m1", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $65b0c941ec21e177$export$93506453d9bb56ae);

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $65b0c941ec21e177$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: {
            id: attribute.icon.id,
            name: attribute.icon.name,
            url16: attribute.icon.url16,
            url48: attribute.icon.url48
        }
    });
const $65b0c941ec21e177$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $f4e7j.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $f4e7j.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $65b0c941ec21e177$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $65b0c941ec21e177$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $65b0c941ec21e177$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $65b0c941ec21e177$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $65b0c941ec21e177$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $65b0c941ec21e177$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $65b0c941ec21e177$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $65b0c941ec21e177$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $65b0c941ec21e177$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $65b0c941ec21e177$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $65b0c941ec21e177$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $65b0c941ec21e177$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $65b0c941ec21e177$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $65b0c941ec21e177$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $65b0c941ec21e177$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $65b0c941ec21e177$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $65b0c941ec21e177$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        ...!(0, $1ybV0.ff)('assets-rearch-deprecate-attribute-value-id_ykukg') && {
            id: node.attributeId
        },
        workspaceId: workspaceId,
        objectAttributeValues: (0, $f4e7j.transformAggConnection)(node.objectAttributeValues, $65b0c941ec21e177$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $65b0c941ec21e177$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $65b0c941ec21e177$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
    return {
        attributes: (0, $f4e7j.transformAggConnection)(node.attributes, (nodeAttribute)=>$65b0c941ec21e177$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $65b0c941ec21e177$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $65b0c941ec21e177$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $lO4Or.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $65b0c941ec21e177$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $f4e7j.transformAggConnection)(node.selectedCmdbObjectsConnection, $65b0c941ec21e177$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("5CYGa", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $9050c04462f98fea$export$587c178f1b45e5e9);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $9050c04462f98fea$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $lO4Or.EPIC_COLOR_TYPE:
        case 0, $lO4Or.COLOR_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("9wKha", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $786c86fdf4d26692$export$97a9275777684b77);

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ...(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false) ? {
            ari: component.ari,
            metadata: component.metadata
        } : {}
    };
};
const $786c86fdf4d26692$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $lO4Or.COMPONENTS_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.components, $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent);
    const value = (0, $f4e7j.transformAggConnection)(node.selectedComponentsConnection, $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $c7e7b1d3600a0c0f$export$840ed33fa94f7693),
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $lO4Or.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("6PKzm", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $37a64e51f4c4445c$export$e6d015aa746cbdaf);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $37a64e51f4c4445c$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("jyP56", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $060cb99a84a6f8a5$export$edf5c98d20696686);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $060cb99a84a6f8a5$export$edf5c98d20696686 = (node)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (0, $f4e7j.toLegacyConnectOption));
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $f4e7j.toLegacyConnectOption));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("epJqO", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $c342681984a0fce1$export$4638a5dd3285d8f2);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c342681984a0fce1$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("Pxexr", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $6d21cc1975a64a13$export$11063e1f9210f191);

var $esUXI = parcelRequire("esUXI");

var $2qVcp = parcelRequire("2qVcp");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $6d21cc1975a64a13$var$emptyAdfObject = (0, $esUXI.getEmptyADF)();
const $6d21cc1975a64a13$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $6d21cc1975a64a13$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $2qVcp.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $6d21cc1975a64a13$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $6d21cc1975a64a13$var$emptyAdfObject
    };
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $lO4Or.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("esUXI", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $e4fec1f97a138b24$export$d109ab46c9575565);

var $3o7y4 = parcelRequire("3o7y4");
const $e4fec1f97a138b24$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("3o7y4", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $e439d27de8d77afc$export$dd1bc94b04021eeb);
const $e439d27de8d77afc$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("2qVcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fb6c9e1b8a0092$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");
const $08fb6c9e1b8a0092$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $08fb6c9e1b8a0092$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $gUUjF.default).safeErrorWithoutCustomerData($08fb6c9e1b8a0092$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $08fb6c9e1b8a0092$export$2e2bcd8739ae039 = $08fb6c9e1b8a0092$var$isFieldMissingRenderer;

});


parcelRegister("beuR4", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $b2ab3564d5e0e945$export$e44db7cf61369a28);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b2ab3564d5e0e945$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $f4e7j.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $f4e7j.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("d9IUw", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $a23506d3b78ec681$export$dd05277f5aa90657);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $a23506d3b78ec681$export$dd05277f5aa90657 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("xnQ91", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $104546bf95896cb2$export$b5edfdc89a7a2932);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $104546bf95896cb2$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        key: (0, $lO4Or.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $lO4Or.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("jsTfy", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $cbf69a6b68f1ac34$export$3d6e51d37c0454a9);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $cbf69a6b68f1ac34$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.DUE_DATE_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $lO4Or.DATE_CF_TYPE:
        case 0, $lO4Or.BASELINE_START_CF_TYPE:
        case 0, $lO4Or.BASELINE_END_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("55kng", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $d108194053a9b0cf$export$3de22f1277f0c239);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $d108194053a9b0cf$var$defaultSchema = {
    type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $d108194053a9b0cf$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $lO4Or.RESOLUTION_DATE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $lO4Or.DATETIME_CF_TYPE:
        case 0, $lO4Or.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $lO4Or.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("7BRej", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $3731013de9f5c7b2$export$1311f30c94840aa2);

var $opsFH = parcelRequire("opsFH");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $3731013de9f5c7b2$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $opsFH.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $3731013de9f5c7b2$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $lO4Or.EPIC_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $3731013de9f5c7b2$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $lO4Or.EPIC_TYPE),
            system: null
        }
    };
};

});
parcelRegister("opsFH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $e6c2c5f41d0c328b$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $e6c2c5f41d0c328b$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $e6c2c5f41d0c328b$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $e6c2c5f41d0c328b$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $e6c2c5f41d0c328b$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $e6c2c5f41d0c328b$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $e6c2c5f41d0c328b$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $e6c2c5f41d0c328b$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $e6c2c5f41d0c328b$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $e6c2c5f41d0c328b$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $e6c2c5f41d0c328b$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $e6c2c5f41d0c328b$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $e6c2c5f41d0c328b$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $e6c2c5f41d0c328b$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $e6c2c5f41d0c328b$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $e6c2c5f41d0c328b$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $e6c2c5f41d0c328b$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $e6c2c5f41d0c328b$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $e6c2c5f41d0c328b$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $e6c2c5f41d0c328b$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $e6c2c5f41d0c328b$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $e6c2c5f41d0c328b$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $e6c2c5f41d0c328b$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $e6c2c5f41d0c328b$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $e6c2c5f41d0c328b$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $e6c2c5f41d0c328b$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $e6c2c5f41d0c328b$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $e6c2c5f41d0c328b$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $e6c2c5f41d0c328b$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $e6c2c5f41d0c328b$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $e6c2c5f41d0c328b$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $e6c2c5f41d0c328b$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $e6c2c5f41d0c328b$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $e6c2c5f41d0c328b$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $e6c2c5f41d0c328b$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $e6c2c5f41d0c328b$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $e6c2c5f41d0c328b$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $e6c2c5f41d0c328b$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $e6c2c5f41d0c328b$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $e6c2c5f41d0c328b$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $e6c2c5f41d0c328b$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $e6c2c5f41d0c328b$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $e6c2c5f41d0c328b$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $e6c2c5f41d0c328b$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $e6c2c5f41d0c328b$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $e6c2c5f41d0c328b$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $e6c2c5f41d0c328b$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $e6c2c5f41d0c328b$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $e6c2c5f41d0c328b$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2 = 'PURPLE';
const $e6c2c5f41d0c328b$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $e6c2c5f41d0c328b$export$738c3b9a44c87ecc = 'BLUE';
const $e6c2c5f41d0c328b$export$1225f83626261b80 = 'DARK_BLUE';
const $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b = 'GREEN';
const $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $e6c2c5f41d0c328b$export$d0446fe88325854e = 'TEAL';
const $e6c2c5f41d0c328b$export$bb848c92687e69dc = 'DARK_TEAL';
const $e6c2c5f41d0c328b$export$aab610c505c06a8f = 'YELLOW';
const $e6c2c5f41d0c328b$export$466af87757d343a2 = 'DARK_YELLOW';
const $e6c2c5f41d0c328b$export$3de5e29ed1757f9b = 'ORANGE';
const $e6c2c5f41d0c328b$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $e6c2c5f41d0c328b$export$7d278ca694634874 = 'GREY';
const $e6c2c5f41d0c328b$export$26453300bfc61cb8 = 'DARK_GREY';
const $e6c2c5f41d0c328b$export$56d196d2844d1ca1 = [
    $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    $e6c2c5f41d0c328b$export$1225f83626261b80,
    $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    $e6c2c5f41d0c328b$export$d0446fe88325854e,
    $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    $e6c2c5f41d0c328b$export$466af87757d343a2,
    $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    $e6c2c5f41d0c328b$export$7d278ca694634874,
    $e6c2c5f41d0c328b$export$26453300bfc61cb8
];
const $e6c2c5f41d0c328b$export$792af22a0198af8d = 'purple';
const $e6c2c5f41d0c328b$export$588af712afdcb006 = 'dark_purple';
const $e6c2c5f41d0c328b$export$84c4918645391802 = 'blue';
const $e6c2c5f41d0c328b$export$b8f1f5838352a33a = 'dark_blue';
const $e6c2c5f41d0c328b$export$9384b7e350ee6542 = 'green';
const $e6c2c5f41d0c328b$export$87d3fb8d8656d38b = 'dark_green';
const $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae = 'teal';
const $e6c2c5f41d0c328b$export$a89b77a449bd223e = 'dark_teal';
const $e6c2c5f41d0c328b$export$9a33b5e3cde94885 = 'yellow';
const $e6c2c5f41d0c328b$export$33253d7862bceb8a = 'dark_yellow';
const $e6c2c5f41d0c328b$export$6609c2b23fc42f39 = 'orange';
const $e6c2c5f41d0c328b$export$cd994662b5911917 = 'dark_orange';
const $e6c2c5f41d0c328b$export$1793d43e13e078c5 = 'grey';
const $e6c2c5f41d0c328b$export$487a6e9145526564 = 'dark_grey';
const $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $e6c2c5f41d0c328b$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $e6c2c5f41d0c328b$export$94ac87c81ed074a7 = 'ghx-label-3';
const $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $e6c2c5f41d0c328b$export$610a2c132b6fcf96 = 'ghx-label-5';
const $e6c2c5f41d0c328b$export$8e4997dba71f1c40 = 'ghx-label-6';
const $e6c2c5f41d0c328b$export$18a545b4e69b27b4 = 'ghx-label-7';
const $e6c2c5f41d0c328b$export$27fff1a0d295292a = 'ghx-label-8';
const $e6c2c5f41d0c328b$export$e57aa662a56724e1 = 'ghx-label-9';
const $e6c2c5f41d0c328b$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $e6c2c5f41d0c328b$export$457ecb9560f2bf83 = 'ghx-label-11';
const $e6c2c5f41d0c328b$export$a866db37165a696c = 'ghx-label-12';
const $e6c2c5f41d0c328b$export$9b18447c1168a1b6 = 'ghx-label-13';
const $e6c2c5f41d0c328b$export$93b9ad4020e271b7 = 'ghx-label-14';
const $e6c2c5f41d0c328b$export$5cd2af17b34de3e3 = 'color_1';
const $e6c2c5f41d0c328b$export$987671fa69482a7b = 'color_2';
const $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446 = 'color_3';
const $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36 = 'color_4';
const $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256 = 'color_5';
const $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78 = 'color_6';
const $e6c2c5f41d0c328b$export$9dc62d5d151cb355 = 'color_7';
const $e6c2c5f41d0c328b$export$1ed15b30f5663f92 = 'color_8';
const $e6c2c5f41d0c328b$export$5d23a84d55ac1644 = 'color_9';
const $e6c2c5f41d0c328b$export$bf08c9a6ed42e349 = 'color_10';
const $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c = 'color_11';
const $e6c2c5f41d0c328b$export$da30755a37c3a597 = 'color_12';
const $e6c2c5f41d0c328b$export$721cf84faff6bf19 = 'color_13';
const $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd = 'color_14';
const $e6c2c5f41d0c328b$export$c537fa0d021d010b = {
    PURPLE: $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    BLUE: $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    DARK_BLUE: $e6c2c5f41d0c328b$export$1225f83626261b80,
    GREEN: $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    TEAL: $e6c2c5f41d0c328b$export$d0446fe88325854e,
    DARK_TEAL: $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    YELLOW: $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    DARK_YELLOW: $e6c2c5f41d0c328b$export$466af87757d343a2,
    ORANGE: $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    DARK_ORANGE: $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    GREY: $e6c2c5f41d0c328b$export$7d278ca694634874,
    DARK_GREY: $e6c2c5f41d0c328b$export$26453300bfc61cb8
};
const $e6c2c5f41d0c328b$export$d33d39828a18210a = {
    SERVER_PURPLE: $e6c2c5f41d0c328b$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $e6c2c5f41d0c328b$export$588af712afdcb006,
    SERVER_BLUE: $e6c2c5f41d0c328b$export$84c4918645391802,
    SERVER_DARK_BLUE: $e6c2c5f41d0c328b$export$b8f1f5838352a33a,
    SERVER_GREEN: $e6c2c5f41d0c328b$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $e6c2c5f41d0c328b$export$87d3fb8d8656d38b,
    SERVER_TEAL: $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $e6c2c5f41d0c328b$export$a89b77a449bd223e,
    SERVER_YELLOW: $e6c2c5f41d0c328b$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $e6c2c5f41d0c328b$export$33253d7862bceb8a,
    SERVER_ORANGE: $e6c2c5f41d0c328b$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $e6c2c5f41d0c328b$export$cd994662b5911917,
    SERVER_GREY: $e6c2c5f41d0c328b$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $e6c2c5f41d0c328b$export$487a6e9145526564
};
const $e6c2c5f41d0c328b$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $e6c2c5f41d0c328b$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $e6c2c5f41d0c328b$export$94ac87c81ed074a7,
    GHX_LABEL_4: $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $e6c2c5f41d0c328b$export$610a2c132b6fcf96,
    GHX_LABEL_6: $e6c2c5f41d0c328b$export$8e4997dba71f1c40,
    GHX_LABEL_7: $e6c2c5f41d0c328b$export$18a545b4e69b27b4,
    GHX_LABEL_8: $e6c2c5f41d0c328b$export$27fff1a0d295292a,
    GHX_LABEL_9: $e6c2c5f41d0c328b$export$e57aa662a56724e1,
    GHX_LABEL_10: $e6c2c5f41d0c328b$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $e6c2c5f41d0c328b$export$457ecb9560f2bf83,
    GHX_LABEL_12: $e6c2c5f41d0c328b$export$a866db37165a696c,
    GHX_LABEL_13: $e6c2c5f41d0c328b$export$9b18447c1168a1b6,
    GHX_LABEL_14: $e6c2c5f41d0c328b$export$93b9ad4020e271b7
};
const $e6c2c5f41d0c328b$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $e6c2c5f41d0c328b$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $e6c2c5f41d0c328b$export$987671fa69482a7b,
    AGILE_COLOR_3: $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $e6c2c5f41d0c328b$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $e6c2c5f41d0c328b$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $e6c2c5f41d0c328b$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $e6c2c5f41d0c328b$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $e6c2c5f41d0c328b$export$da30755a37c3a597,
    AGILE_COLOR_13: $e6c2c5f41d0c328b$export$721cf84faff6bf19,
    AGILE_COLOR_14: $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd
};

});


parcelRegister("04Gbh", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $c8b2d8c7cabddb24$export$31555b6ea19f4c2);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c8b2d8c7cabddb24$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $c8b2d8c7cabddb24$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $c8b2d8c7cabddb24$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("3ZJZc", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $c763da6a17e08623$export$30fccfce22948120);

var $2qVcp = parcelRequire("2qVcp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c763da6a17e08623$export$30fccfce22948120 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("bw8ws", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $4c0a1710d24fba77$export$61b1f0cbd04c7b9c);

var $2qVcp = parcelRequire("2qVcp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $4c0a1710d24fba77$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("9vCKL", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $c9b907ff4adf2ba8$export$60b03d63015cbb9f);

var $2qVcp = parcelRequire("2qVcp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c9b907ff4adf2ba8$export$60b03d63015cbb9f = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("i5dch", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $a11ed3e141cd8632$export$2dfa4944fba5d1f5);

var $2qVcp = parcelRequire("2qVcp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $a11ed3e141cd8632$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $f4e7j.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("iJcxE", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $0d8b7166bd07a2e4$export$5dab8986dc45db07);

var $2qVcp = parcelRequire("2qVcp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $0d8b7166bd07a2e4$export$5dab8986dc45db07 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("djkJh", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $d8b2a1a28c816219$export$fbdabdbae2a203b9);

var $2qVcp = parcelRequire("2qVcp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $d8b2a1a28c816219$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("kbDa2", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $c3ecb4f8814d5007$export$3a581fb4b3e578bd);

var $2qVcp = parcelRequire("2qVcp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c3ecb4f8814d5007$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("4gy8O", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $e5fb5863b3ffc3de$export$418a06cb5dc6aba5);

var $2qVcp = parcelRequire("2qVcp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $e5fb5863b3ffc3de$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9w928", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $bdc773687305de8f$export$bc73c7a747f907e5);

var $2qVcp = parcelRequire("2qVcp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $g5TY0 = parcelRequire("g5TY0");
const $bdc773687305de8f$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $g5TY0.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("g5TY0", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $c92150b2c9939d9c$export$d7b231260a016eaf);

const $c92150b2c9939d9c$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $0f8390fc7463ac8c$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $0f8390fc7463ac8c$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $0f8390fc7463ac8c$export$1973ca62b6c5abfe;
        default:
            return 0, $0f8390fc7463ac8c$export$d1f5101c0939e3fe;
    }
};
const $c92150b2c9939d9c$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $c92150b2c9939d9c$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $c92150b2c9939d9c$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $c92150b2c9939d9c$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $0f8390fc7463ac8c$export$981400c14dd99bc0 = 'atlassian';
const $0f8390fc7463ac8c$export$2823897fb92cd040 = 'customer';
const $0f8390fc7463ac8c$export$1973ca62b6c5abfe = 'app';
const $0f8390fc7463ac8c$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("3khS7", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $04695e9464f736dc$export$bbfea2e2f2c853b8);

var $2qVcp = parcelRequire("2qVcp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $g5TY0 = parcelRequire("g5TY0");
const $04695e9464f736dc$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $f4e7j.transformAggConnection)(node.selectedUsersConnection, (0, $g5TY0.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("c52Z6", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $967e7c1cc9b41f1e$export$158301a02ae4cbe7);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $967e7c1cc9b41f1e$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $lO4Or.GOALS_CF_TYPE)) return undefined;
    const value = node.selectedGoals ? {
        goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                id: edge?.node?.id || '',
                name: edge?.node?.name || '',
                status: edge?.node?.status || null
            })) || [],
        totalCount: node.selectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $lO4Or.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("6IjGS", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $656ee40cfd5a4289$export$62db794d5816e28e);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $ijtj3 = parcelRequire("ijtj3");
const $656ee40cfd5a4289$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $656ee40cfd5a4289$export$62db794d5816e28e = (node, context)=>{
    if (node.type !== (0, $lO4Or.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $f4e7j.transformAggConnection)(node.selectedRolesConnection, $656ee40cfd5a4289$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    const project = (0, $ijtj3.getSystemAggJiraProject)(context);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: project.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});
parcelRegister("ijtj3", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $b7b19c470c7e1e1a$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $b7b19c470c7e1e1a$export$d100105d56da4a0a);
$parcel$export(module.exports, "transformAggProjectToProjectContext", () => $b7b19c470c7e1e1a$export$275f121d4e6f5165);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $b7b19c470c7e1e1a$export$30c14b802399f417);

var $7ZZxN = parcelRequire("7ZZxN");



var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $f4e7j = parcelRequire("f4e7j");
const $b7b19c470c7e1e1a$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $5bd9e96e4d7e8aee$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $5bd9e96e4d7e8aee$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $5bd9e96e4d7e8aee$export$62113557945f790a;
    }
};
const $b7b19c470c7e1e1a$export$3dd0da95519c1a33 = (projectType)=>{
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $7ZZxN.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $b7b19c470c7e1e1a$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const projectField = fields?.find((edge)=>edge?.node?.__typename === (0, $lO4Or.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $lO4Or.PROJECT_TYPE))?.node;
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $lO4Or.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $lO4Or.PROJECT_GQL_FIELD)} with ${(0, $lO4Or.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $lO4Or.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $b7b19c470c7e1e1a$export$f7d5cb97957d02e3 = (project)=>project.projectStyle === 'TEAM_MANAGED_PROJECT';
const $b7b19c470c7e1e1a$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $6vrw7.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar.large
        }
    };
};
const $b7b19c470c7e1e1a$export$275f121d4e6f5165 = (fields)=>{
    const project = $b7b19c470c7e1e1a$export$d100105d56da4a0a(fields);
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
    const projectType = $b7b19c470c7e1e1a$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $b7b19c470c7e1e1a$var$getProjectStatus(status),
        avatarUrl: avatar.medium,
        isSimplified: $b7b19c470c7e1e1a$export$f7d5cb97957d02e3(project),
        boardId: navigationMetadata?.boardId
    };
};
const $b7b19c470c7e1e1a$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $b7b19c470c7e1e1a$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.PROJECT_TYPE),
            custom: (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $b7b19c470c7e1e1a$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($b7b19c470c7e1e1a$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $7ZZxN.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        key: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
        title: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $lO4Or.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $b7b19c470c7e1e1a$export$30c14b802399f417 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.PROJECT_PICKER_CF_TYPE:
            return $b7b19c470c7e1e1a$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $lO4Or.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $b7b19c470c7e1e1a$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $5bd9e96e4d7e8aee$export$62113557945f790a = 'PROJECT_ACTIVE';
const $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $5bd9e96e4d7e8aee$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';



parcelRegister("eOsdu", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $fddff707046980f2$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $fddff707046980f2$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $fddff707046980f2$export$de2eb3b47c7c887b);


var $edkGa = parcelRequire("edkGa");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $fddff707046980f2$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $fddff707046980f2$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $lO4Or.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $lO4Or.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $lO4Or.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $lO4Or.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)} with ${(0, $lO4Or.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $fddff707046980f2$export$2356062173546155 = (issueType)=>({
        ...$fddff707046980f2$export$d95e76b2d065f98d,
        id: issueType.issueTypeId,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: issueType.hierarchy.level,
        subtask: issueType.hierarchy.level === (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    });
const $fddff707046980f2$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $lO4Or.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $lO4Or.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $fddff707046980f2$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: (0, $lO4Or.ISSUE_TYPE),
            type: (0, $lO4Or.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("edkGa", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $b500da57c36bb99b$export$2fe6880f0073407c);

var $3l6tm = parcelRequire("3l6tm");
const $b500da57c36bb99b$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});


parcelRegister("6MxWX", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $3d843a7647f78c65$export$b14d30f2a9e4c343);

var $23qRX = parcelRequire("23qRX");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $f4e7j = parcelRequire("f4e7j");

var $g5TY0 = parcelRequire("g5TY0");
const $3d843a7647f78c65$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $lO4Or.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $6vrw7.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $lO4Or.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $23qRX.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount,
                    approvedCount: approverPrincipal.approvedCount
                },
                name: approverPrincipal.name,
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $3d843a7647f78c65$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $23qRX.APPROVER_APPROVED:
            return 0, $23qRX.APPROVER_APPROVED;
        case 0, $23qRX.APPROVER_DECLINED:
            return 0, $23qRX.APPROVER_DECLINED;
        case 0, $23qRX.APPROVER_PENDING:
        default:
            return 0, $23qRX.APPROVER_PENDING;
    }
};
const $3d843a7647f78c65$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $g5TY0.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $3d843a7647f78c65$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $3d843a7647f78c65$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $3d843a7647f78c65$var$transformDateToLegacy = (date)=>({
        epochMillis: new Date(date).valueOf()
    });
const $3d843a7647f78c65$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $3d843a7647f78c65$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $3d843a7647f78c65$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $f4e7j.transformAggConnection)(activeApproval.approverPrincipals, $3d843a7647f78c65$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $f4e7j.transformAggConnection)(activeApproval.approvers, $3d843a7647f78c65$var$transformApproverToLegacy),
        configuration: $3d843a7647f78c65$var$transformConfigurationToLegacy(configurations),
        createdDate: $3d843a7647f78c65$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $f4e7j.transformAggConnection)(activeApproval.decisions, $3d843a7647f78c65$var$transformApproverToLegacy),
        excludedApprovers: (0, $f4e7j.transformAggConnection)(activeApproval.excludedApprovers, (0, $g5TY0.transformJiraUserToLegacyServerUser)),
        status: status ? $3d843a7647f78c65$var$transformStatusToLegacy(status) : null
    };
};
const $3d843a7647f78c65$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $3d843a7647f78c65$var$getApproverDecision(finalDecision),
        createdDate: $3d843a7647f78c65$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $3d843a7647f78c65$var$transformDateToLegacy(completedDate),
        status: status ? $3d843a7647f78c65$var$transformStatusToLegacy(status) : null,
        approvers: (0, $f4e7j.transformAggConnection)(completedApproval.approvers, $3d843a7647f78c65$var$transformApproverToLegacy)
    };
};
const $3d843a7647f78c65$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $3d843a7647f78c65$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $f4e7j.transformAggConnection)(node.completedApprovalsConnection, $3d843a7647f78c65$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("23qRX", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $f236b06d6aabb595$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $f236b06d6aabb595$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $f236b06d6aabb595$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $f236b06d6aabb595$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $f236b06d6aabb595$export$2e6187b6a4348938);
const $f236b06d6aabb595$export$779c261480444a4d = (x)=>x;
const $f236b06d6aabb595$export$3b59c4db06f5829b = 'pending';
const $f236b06d6aabb595$export$e17ae8ca1010e2a4 = 'approved';
const $f236b06d6aabb595$export$b5a0d270c9cd7435 = 'declined';
const $f236b06d6aabb595$export$2e6187b6a4348938 = 'OK';
const $f236b06d6aabb595$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("9myMG", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $d0d645fec4d38846$export$850fadda8a5e6f27);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $d0d645fec4d38846$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $lO4Or.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.ENTITLEMENT_CF_TYPE),
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("gM34d", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $07db702730ef03b7$export$d4e0b2288fb31144);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $07db702730ef03b7$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("16kx8", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $cedd80ccbf21d473$export$7bd14951253a7c5f);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $cedd80ccbf21d473$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $lO4Or.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: (0, $f4e7j.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("4IQ8F", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $2d53157bbab9736d$export$c52c6988b335096);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $2d53157bbab9736d$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("lcInz", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $32361ac554652aa8$export$6a53240e225f742);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $32361ac554652aa8$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("4PFnn", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $97b247bfb6fb2bf8$export$5ffaab1383177efa);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $97b247bfb6fb2bf8$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $97b247bfb6fb2bf8$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $97b247bfb6fb2bf8$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("alpM1", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $e4d9f726b0420c01$export$5171c4d1ae5bcde5);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $e4d9f726b0420c01$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $lO4Or.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $lO4Or.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $e4d9f726b0420c01$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $lO4Or.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $f4e7j.transformAggConnection)(node.respondersConnection, $e4d9f726b0420c01$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.RESPONDERS_CF_TYPE),
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("l6kyU", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $760020295c96925b$export$702d3754a4c7d90a);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $760020295c96925b$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $lO4Or.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.SENTIMENT_CF_TYPE),
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("gHd8e", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $e9d06b1cdd22d77f$export$98e4f56e2e6c44fe);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $e9d06b1cdd22d77f$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $e9d06b1cdd22d77f$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $f4e7j.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $lO4Or.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$e9d06b1cdd22d77f$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $lO4Or.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$e9d06b1cdd22d77f$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("dUrU1", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $bf00e02f796ca76f$export$f968da580693597d);


var $f4e7j = parcelRequire("f4e7j");
const $bf00e02f796ca76f$export$f968da580693597d = (node)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("hQM7C", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $b77f8634d7271da6$export$869fb8fbcb97e0ee);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b77f8634d7271da6$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("QjWSM", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $c7caa94b89e539e2$export$cdd9991119eb040e);

var $7ZZxN = parcelRequire("7ZZxN");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $ijtj3 = parcelRequire("ijtj3");

var $g5TY0 = parcelRequire("g5TY0");
const $c7caa94b89e539e2$export$cdd9991119eb040e = (node, context)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedUsersConnection, (0, $g5TY0.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE:
            {
                const project = (0, $ijtj3.getSystemAggJiraProject)(context);
                if ((0, $ijtj3.getProjectType)(project.projectType) !== (0, $7ZZxN.SERVICE_DESK_PROJECT)) return undefined;
                // Empty array is the expected value when there are no request
                // participants.
                return {
                    ...legacyFieldValues,
                    value: value
                };
            }
        case 0, $lO4Or.PARTICIPANTS_CF_TYPE:
        case 0, $lO4Or.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $lO4Or.APPROVERS_LIST_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("4CGp4", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $3d2f68ea759270b4$export$6207ea60703068d8);

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $hd35n = parcelRequire("hd35n");
const $3d2f68ea759270b4$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $c7e7b1d3600a0c0f$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $3d2f68ea759270b4$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $lO4Or.MULTI_VERSION_CF_TYPE) && node.type !== (0, $lO4Or.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $lO4Or.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allowedValues: (0, $f4e7j.transformAggConnection)(node.multiPickerVersions, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld)),
        value: (0, $f4e7j.transformAggConnection)(node.selectedVersionsConnection, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld))
    };
    switch(node.type){
        case 0, $lO4Or.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$3d2f68ea759270b4$var$defaultSchema,
                    custom: (0, $lO4Or.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $lO4Or.AFFECTS_VERSIONS_TYPE:
        case 0, $lO4Or.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                allowedValues: legacyFieldValues.allowedValues.filter((v)=>!v.archived),
                schema: {
                    ...$3d2f68ea759270b4$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("hd35n", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersionOld", () => $41957f3e8e88f6a1$export$5427f5949bb0492d);
$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $41957f3e8e88f6a1$export$becef8d087e8b62b);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $exWH1 = parcelRequire("exWH1");
const $41957f3e8e88f6a1$export$5427f5949bb0492d = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $exWH1.VersionStatus).ARCHIVED,
        released: version.status === (0, $exWH1.VersionStatus).RELEASED
    });
const $41957f3e8e88f6a1$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $exWH1.VersionStatus).ARCHIVED,
        released: version.status === (0, $exWH1.VersionStatus).RELEASED,
        ari: version.id
    });
const $41957f3e8e88f6a1$export$5753f8f86af3608d = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration'), $41957f3e8e88f6a1$export$becef8d087e8b62b, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
$41957f3e8e88f6a1$export$5427f5949bb0492d);

});
parcelRegister("exWH1", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $4c4bb928a168d525$export$8c6e0f93bfb5c6a4);






const $4c4bb928a168d525$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("lWE99", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $1ea236981671650b$export$d754a24ed0096d2f);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $1ea236981671650b$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $lO4Or.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $lO4Or.NUMBER_CF_TYPE:
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $lO4Or.STORY_POINTS_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("4eNqf", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $50d87f174d910a4b$export$f08d02fdc74f920e);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $50d87f174d910a4b$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $lO4Or.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("fkHM1", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $ccf6d66eff5dbc1f$export$9e966ce605f800d2);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $ccf6d66eff5dbc1f$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $lO4Or.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)('priorities' in node ? node.priorities : null, $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $lO4Or.PRIORITY_TYPE),
            custom: null,
            system: (0, $lO4Or.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("fkaQR", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $b1792cecaa8dedc0$export$fdcdbf17b0d4e36f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b1792cecaa8dedc0$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $lO4Or.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $lO4Or.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $lO4Or.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("gyvos", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $f7afb2486834699b$export$f147f1eb3a15ccfc);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $f7afb2486834699b$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $lO4Or.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
            id: option.optionId,
            value: option.value ?? null,
            ari: option.id
        }));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("3w75b", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $5302369645b034cd$export$179f600c7e1d0230);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $5302369645b034cd$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $5302369645b034cd$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $lO4Or.RESOLUTION_TYPE)) return undefined;
    const value = $5302369645b034cd$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.resolutions, $5302369645b034cd$var$resolutionTransformer);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $lO4Or.RESOLUTION_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $lO4Or.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("lQr58", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $63df895e1ecc6044$export$e65ff2ce94be106e);

var $esUXI = parcelRequire("esUXI");

var $2qVcp = parcelRequire("2qVcp");


var $lO4Or = parcelRequire("lO4Or");

var $7Vbpp = parcelRequire("7Vbpp");

var $f4e7j = parcelRequire("f4e7j");
const $63df895e1ecc6044$var$emptyAdfObject = (0, $esUXI.getEmptyADF)();
const $63df895e1ecc6044$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $lO4Or.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $lO4Or.DESCRIPTION_TYPE:
        case 0, $lO4Or.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $63df895e1ecc6044$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $63df895e1ecc6044$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $2qVcp.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $lO4Or.DESCRIPTION_TYPE) && renderer === (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $63df895e1ecc6044$var$getPlainTextValue(node),
        schema: $63df895e1ecc6044$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $7Vbpp.removeCollectionFromAdf)(adfValueJson) : $63df895e1ecc6044$var$emptyAdfObject,
        value: null,
        schema: $63df895e1ecc6044$var$getSchema(node.type, renderer)
    };
};

});
parcelRegister("7Vbpp", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $e11eab7652408d68$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $e11eab7652408d68$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $e11eab7652408d68$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $e11eab7652408d68$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $e11eab7652408d68$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $e11eab7652408d68$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $e11eab7652408d68$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasMediaFileNodes", () => $e11eab7652408d68$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $e11eab7652408d68$export$80a6e90c7b29d88c);

var $6qhKX = parcelRequire("6qhKX");
var $hYZXM = parcelRequire("hYZXM");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");
const $e11eab7652408d68$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $e11eab7652408d68$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if ((0, $1ybV0.ff)('issue.details.media-inline') && adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($e11eab7652408d68$export$9e9311e676291037)
    };
    return adf;
};
const $e11eab7652408d68$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $e11eab7652408d68$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $e11eab7652408d68$export$9e9311e676291037(adf);
};
const $e11eab7652408d68$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $e11eab7652408d68$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $e11eab7652408d68$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $e11eab7652408d68$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $e11eab7652408d68$export$def86d25f0c7f0bc = (adf)=>$e11eab7652408d68$export$cf4bde415465976c(adf) ? $e11eab7652408d68$export$202742e99f678c60 : adf;
const $e11eab7652408d68$export$9a632b58fb9b287c = (doc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const mediaNodes = new Map();
        (0, $hYZXM.traverse)(doc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                mediaNodes.set(mediaNode.attrs.id, node);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                mediaNodes.set(mediaInlineNode.attrs.id, node);
            }
        });
        return mediaNodes.size > 0;
    }
    const mediaNodes = new Map();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(doc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            mediaNodes.set(node.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $e11eab7652408d68$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const currentMediaNodes = new Set();
        const newMediaNodes = new Set();
        const updatedMediaNodes = new Set();
        if (newDoc) (0, $hYZXM.traverse)(newDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                newMediaNodes.add(mediaNode.attrs.id);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                newMediaNodes.add(mediaInlineNode.attrs.id);
            }
        });
        if (currentDoc) (0, $hYZXM.traverse)(currentDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                currentMediaNodes.add(mediaNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
                }
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                currentMediaNodes.add(mediaInlineNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
                }
            }
        });
        return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
    }
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(newDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            newMediaNodes.add(node.attrs.id);
        }
    });
    if (currentDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(currentDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            currentMediaNodes.add(node.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(node.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(node.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $e11eab7652408d68$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $6qhKX.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $e11eab7652408d68$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await (parcelRequire("gAEPB"));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("87zwO"));
    const { JSONTransformer: JSONTransformer } = await (parcelRequire("hhZ0p"));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("6qhKX", function(module, exports) {

$parcel$export(module.exports, "filter", () => $d1e7bd2dc2348b7c$export$3dea766d36a8935f);

var $hYZXM = parcelRequire("hYZXM");
function $d1e7bd2dc2348b7c$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $hYZXM.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});
parcelRegister("hYZXM", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $ed8bc6cb8f4f14d7$export$df3f009e3d155b20);
function $ed8bc6cb8f4f14d7$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $ed8bc6cb8f4f14d7$export$df3f009e3d155b20(adf, visitors) {
    if (!$ed8bc6cb8f4f14d7$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $ed8bc6cb8f4f14d7$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $ed8bc6cb8f4f14d7$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $ed8bc6cb8f4f14d7$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("gAEPB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("deyW2").then(()=>parcelRequire('9wcjJ'));

});

parcelRegister("87zwO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("apXnN").then(()=>parcelRequire('fjUC0'));

});

parcelRegister("hhZ0p", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kYJkV").then(()=>parcelRequire('3M3qX'));

});



parcelRegister("8oO4q", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $28a96bf619a924f9$export$45e25e2a6750ea5a);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $28a96bf619a924f9$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $28a96bf619a924f9$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $28a96bf619a924f9$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $f4e7j.transformAggConnection)(node.securityLevels, $28a96bf619a924f9$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $lO4Or.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $lO4Or.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("5Ne6t", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $1b8c5a144aba3441$export$e6697ec5bdac9ec0);


var $f4e7j = parcelRequire("f4e7j");
const $1b8c5a144aba3441$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2ETkN", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $84dcb0c130bea779$export$31f32b3fd9e5ab6);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $84dcb0c130bea779$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $84dcb0c130bea779$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $lO4Or.EPIC_NAME_TYPE:
        case 0, $lO4Or.MESSAGE_EDIT_CF_TYPE:
        case 0, $lO4Or.MESSAGE_VIEW_CF_TYPE:
        case 0, $lO4Or.READ_ONLY_CF_TYPE:
        case 0, $lO4Or.TEXT_CF_TYPE:
        case 0, $lO4Or.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $lO4Or.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $lO4Or.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $lO4Or.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $lO4Or.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("fz8Wc", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $6eb6c9de60f230bb$export$4e113f935e09d226);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $6eb6c9de60f230bb$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $6eb6c9de60f230bb$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.EPIC_STATUS_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
            return $6eb6c9de60f230bb$var$getField(node);
        case 0, $lO4Or.CATEGORY_TYPE:
            return $6eb6c9de60f230bb$var$getField(node, (0, $lO4Or.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("jBiXV", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $13d89b5e83359a47$export$7bf73fc06c6d71be);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $g5TY0 = parcelRequire("g5TY0");
const $13d89b5e83359a47$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $g5TY0.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("1XUHd", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $c650b563dc539b29$export$d03f622577260442);

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $hd35n = parcelRequire("hd35n");
const $c650b563dc539b29$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $lO4Or.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.singlePickerVersions, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld));
    const transformVersion = (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld);
    const value = node.version ? transformVersion(node.version) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $lO4Or.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("c6LKM", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $c11b803b5a137e84$export$9b5bb05d50970021);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c11b803b5a137e84$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $c11b803b5a137e84$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($c11b803b5a137e84$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $c11b803b5a137e84$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint.name,
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $c11b803b5a137e84$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $lO4Or.SPRINT_TYPE)) return undefined;
    const sprints = (0, $f4e7j.transformAggConnection)(node.selectedSprintsConnection, $c11b803b5a137e84$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("8zTcQ", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $23ba42f503d38228$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $23ba42f503d38228$export$c80e5acb1c882c48);

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $23ba42f503d38228$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $8Qd0L.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $23ba42f503d38228$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (status == null) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $23ba42f503d38228$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $lO4Or.STATUS_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $23ba42f503d38228$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $lO4Or.STATUS_TYPE),
            custom: null,
            system: (0, $lO4Or.STATUS_TYPE)
        }
    };
};

});

parcelRegister("5W75j", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $97428b249585cac2$export$fb1b80497e96456f);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $97428b249585cac2$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $lO4Or.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("7iFVU", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $bb4542beb2315e32$export$6f6aaafb49bd4769);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $bb4542beb2315e32$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || ''
    };
};
const $bb4542beb2315e32$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $bb4542beb2315e32$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("kyZt3", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $3404d836fe97323f$export$874d9bd14269ec6f);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $3404d836fe97323f$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $3404d836fe97323f$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $lO4Or.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $3404d836fe97323f$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $3404d836fe97323f$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $3404d836fe97323f$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: (0, $lO4Or.TIME_TRACKING_TYPE),
            type: (0, $lO4Or.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("dX2ot", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $65722746bbedc61a$export$6e950e0ec9801f6c);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $65722746bbedc61a$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $lO4Or.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.URL_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("jhiYN", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $471f4de3dfdc045c$export$8966614b8594736);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $471f4de3dfdc045c$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $471f4de3dfdc045c$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $lO4Or.VOTES_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.vote ? $471f4de3dfdc045c$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.VOTES_TYPE),
            type: (0, $lO4Or.VOTES_TYPE)
        }
    };
};

});

parcelRegister("1BsAz", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $47cca6eb8a2344d9$export$6730cb17d10d6156);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $47cca6eb8a2344d9$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $47cca6eb8a2344d9$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $lO4Or.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.watch ? $47cca6eb8a2344d9$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.WATCHES_TYPE),
            type: (0, $lO4Or.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("9r5wz", function(module, exports) {

$parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", () => $8fcd0c4405f180f5$export$d8a5feb2bb0425b4);
const $8fcd0c4405f180f5$export$d8a5feb2bb0425b4 = (parentIssue)=>{
    if (!parentIssue) return null;
    return {
        id: parentIssue.issueId,
        ari: parentIssue.id,
        key: parentIssue.key,
        self: parentIssue.webUrl,
        color: parentIssue.issueColorField?.color?.colorKey,
        fields: {
            summary: parentIssue.summaryField?.text,
            issuetype: {
                name: parentIssue.issueTypeField?.issueType?.name,
                iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                // We do not have this data
                id: '',
                self: '',
                description: '',
                subtask: false,
                avatarId: 0,
                hierarchyLevel: 0
            }
        }
    };
};

});


parcelRegister("k3tie", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $8f27d9da737621d3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $8f27d9da737621d3$export$8b9b8ed7fbac313c = 'FIELD_CHANGE_REQUESTED';
const $8f27d9da737621d3$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
const $8f27d9da737621d3$export$7c15aaba9a26f469 = 'FIELD_CHANGE_FAILED';
const $8f27d9da737621d3$export$8db21fc94823e1cc = {
    [$8f27d9da737621d3$export$8b9b8ed7fbac313c]: $8f27d9da737621d3$export$8b9b8ed7fbac313c,
    [$8f27d9da737621d3$export$7c15aaba9a26f469]: $8f27d9da737621d3$export$7c15aaba9a26f469,
    [$8f27d9da737621d3$export$f567ac9d3526e5ce]: $8f27d9da737621d3$export$f567ac9d3526e5ce
};

});


parcelRegister("3koWU", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c314bd343c8e5174$export$80c2a3957bcb42ea);

var $eUqFw = parcelRequire("eUqFw");
const $c314bd343c8e5174$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});



parcelRegister("4TezD", function(module, exports) {

$parcel$export(module.exports, "WrapperCommon", () => $c5e0dade2a2fd498$export$2cd335d97b9054d6);
$parcel$export(module.exports, "CellWrapper", () => $c5e0dade2a2fd498$export$4812fadef83edffe);
$parcel$export(module.exports, "TextCellWrapper", () => $c5e0dade2a2fd498$export$aea2b0ba32a5c9ab);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $c5e0dade2a2fd498$export$2cd335d97b9054d6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c5e0dade2a2fd498$var$wrapperCommonStyles
    }, props.children);
const $c5e0dade2a2fd498$export$4812fadef83edffe = ({ isEditable: isEditable, testId: testId, children: children, hasPadding: hasPadding = true, ariaLabel: ariaLabel, onCut: onCut, onCopy: onCopy, onPaste: onPaste })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $c5e0dade2a2fd498$var$wrapperCommonStyles,
            $c5e0dade2a2fd498$var$cellWrapperStyles,
            isEditable && $c5e0dade2a2fd498$var$editableCellWrapperStyles,
            hasPadding && $c5e0dade2a2fd498$var$cellWrapperPaddingStyles
        ],
        testId: testId,
        "aria-label": ariaLabel,
        onCut: onCut,
        onCopy: onCopy,
        onPaste: onPaste
    }, children);
const $c5e0dade2a2fd498$export$aea2b0ba32a5c9ab = ({ isEditable: isEditable, testId: testId, ariaLabel: ariaLabel, children: children, onCut: onCut, onCopy: onCopy, onPaste: onPaste })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $c5e0dade2a2fd498$var$textCellWrapperStyles,
            isEditable && $c5e0dade2a2fd498$var$editableTextCellWrapperStyles
        ],
        testId: testId,
        "aria-label": ariaLabel,
        onCut: onCut,
        onCopy: onCopy,
        onPaste: onPaste
    }, children);
const $c5e0dade2a2fd498$var$wrapperCommonStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    outline: 'none'
});
const $c5e0dade2a2fd498$var$cellWrapperStyles = (0, $1ZAYh.xcss)({
    boxSizing: 'border-box',
    borderRadius: 'border.radius'
});
const $c5e0dade2a2fd498$var$cellWrapperPaddingStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.100'
});
const $c5e0dade2a2fd498$var$editableCellWrapperStyles = (0, $1ZAYh.xcss)({
    cursor: 'pointer'
});
const $c5e0dade2a2fd498$var$textCellWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    outline: 'none',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'form' does not exist in type 'SafeCSSObject'
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    form: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-ds--text-field--input]': {
            height: '100%',
            outline: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-ds--text-field--container], [data-ds--text-field--container]:focus-within': {
            outline: 'none',
            boxShadow: 'none',
            border: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    span: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
});
const $c5e0dade2a2fd498$var$editableTextCellWrapperStyles = (0, $1ZAYh.xcss)({
    cursor: 'text'
});

});

parcelRegister("fiEoq", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectEdit", () => $3c9994d572d7b4f4$export$e624ed4af58fd142);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $36Afv = parcelRequire("36Afv");
const $3c9994d572d7b4f4$export$e624ed4af58fd142 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $36Afv.CascadingSelectEditEntryPoint), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.cascadingSelect.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("36Afv", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectEditEntryPoint", () => $e47a530bad5f119e$export$93e961c95d3c1b6a);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $e47a530bad5f119e$export$93e961c95d3c1b6a = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("frypj")), {
        moduleId: "2a2020e5"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("frypj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("jvhwq")
]).then(()=>parcelRequire('hp4vO'));

});



parcelRegister("l4xGf", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectRead", () => $ccc9bc39c87cffa0$export$1e55dc71aaaa2cc4);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $yTRlI = parcelRequire("yTRlI");
const $ccc9bc39c87cffa0$export$1e55dc71aaaa2cc4 = ({ value: value })=>{
    if (value == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ccc9bc39c87cffa0$var$containerStyles
    }, (0, $yTRlI.getCascadingSelectStringValue)(value));
};
const $ccc9bc39c87cffa0$var$containerStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    display: 'block'
});

});


parcelRegister("eyVJl", function(module, exports) {

$parcel$export(module.exports, "devSummaryCellHandler", () => $f42a0eaf31349805$export$31d4252fa9154106);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $2Hkyz = parcelRequire("2Hkyz");
const $f42a0eaf31349805$export$e04e820b15fa1f63 = ({ rowData: rowData, cellData: cellData, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: false
    }, cellData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Hkyz.DevSummaryRead), {
        ...cellData,
        isHovering: false,
        issueId: rowData.issueId,
        editMode: editMode,
        setEditMode: setEditMode,
        cellRef: cellRef
    }));
const $f42a0eaf31349805$export$31d4252fa9154106 = {
    [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: $f42a0eaf31349805$export$e04e820b15fa1f63
};

});
parcelRegister("2Hkyz", function(module, exports) {

$parcel$export(module.exports, "DevSummaryRead", () => $11f65fd20dbb48e9$export$9147ca8c33d1d192);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8gviD = parcelRequire("8gviD");

var $lKCKu = parcelRequire("lKCKu");

var $2ld4O = parcelRequire("2ld4O");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $c5Qiw = parcelRequire("c5Qiw");

var $gd0Sp = parcelRequire("gd0Sp");

var $7uPRH = parcelRequire("7uPRH");

var $dpiiy = parcelRequire("dpiiy");
// Maybe we need to pass this to the cell from the list view
const $11f65fd20dbb48e9$var$popupOffset = [
    -8,
    0
];
const $11f65fd20dbb48e9$var$scopeId = 'software-list.list';
const $11f65fd20dbb48e9$export$9147ca8c33d1d192 = ({ issueId: issueId, isMerged: isMerged, isUnderReview: isUnderReview, commitCount: commitCount, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, ...props })=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const issueAri = (0, $eUqFw.useMemo)(()=>(0, $2ld4O.createIssueAri)(cloudId, issueId.toString()), [
        cloudId,
        issueId
    ]);
    const devInfoType = isMerged || isUnderReview ? (0, $8gviD.DevInfoTypes).PULLREQUEST : (0, $8gviD.DevInfoTypes).COMMIT;
    const { id: experienceId, name: experienceName } = (0, $7uPRH.experienceDetails)[devInfoType];
    const onExperienceSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: experienceName
    });
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            issueId: issueAri
        }), [
        issueAri
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $6j4bv.useEntryPoint)((0, $7uPRH.popupEntryPoints)[devInfoType], entryPointParams, (0, $7uPRH.metricsDev)[devInfoType]);
    const entryPointErrorBoundaryProps = (0, $eUqFw.useMemo)(()=>({
            ...(0, $7uPRH.packageDetails)[devInfoType],
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lKCKu.default), {
                    devInfoType: devInfoType,
                    issueAri: issueAri,
                    scopeId: $11f65fd20dbb48e9$var$scopeId
                })
        }), [
        devInfoType,
        issueAri
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            issueAri: issueAri,
            devInfoType: devInfoType,
            onReady: ()=>{
                stopMetric();
                onExperienceSuccess();
            },
            scopeId: $11f65fd20dbb48e9$var$scopeId
        }), [
        issueAri,
        devInfoType,
        stopMetric,
        onExperienceSuccess
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (editMode) entryPointActions.load();
    }, [
        editMode,
        entryPointActions
    ]);
    const handleMouseEnter = (0, $eUqFw.useCallback)(()=>{
        if (!editMode) entryPointActions.preload();
    }, [
        entryPointActions,
        editMode
    ]);
    const handleMouseLeave = (0, $eUqFw.useCallback)(()=>{
        entryPointActions.cancelPreload();
    }, [
        entryPointActions
    ]);
    const popupTrigger = (0, $eUqFw.useCallback)(({ ref: ref, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-controls': ariaControls })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            ref: ref,
            role: "button",
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            "aria-controls": ariaControls,
            xcss: $11f65fd20dbb48e9$var$triggerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpiiy.DevSummaryLozenge), {
            isMerged: isMerged,
            isUnderReview: isUnderReview,
            commitCount: commitCount,
            ...props
        })), [
        commitCount,
        isMerged,
        isUnderReview,
        props
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.code === 'Tab') return true;
        return false;
    }, []);
    const cellOverrides = (0, $eUqFw.useCallback)(()=>({
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    if (!isMerged && !isUnderReview && commitCount === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11f65fd20dbb48e9$var$Container, {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-testId": "business-fields.ui.dev-summary.cell.read.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: "bottom-start",
        autoFocus: false,
        shouldUseCaptureOnOutsideClick: true,
        testId: "business-fields.ui.dev-summary.cell.read.popup",
        trigger: popupTrigger,
        isOpen: editMode,
        offset: $11f65fd20dbb48e9$var$popupOffset,
        onClose: ()=>setEditMode(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
                analyticsSource: experienceName,
                experience: experienceName,
                experienceId: experienceId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                ...entryPointErrorBoundaryProps,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c5Qiw.DevInfoDetailsPopupSkeleton), {
                    devinfoType: devInfoType
                }),
                runtimeProps: runtimeProps
            }))
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11f65fd20dbb48e9$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $11f65fd20dbb48e9$var$triggerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    boxSizing: 'border-box',
    alignItems: 'center'
});

});
parcelRegister("8gviD", function(module, exports) {

$parcel$export(module.exports, "DevInfoTypes", () => $37282c0a5dd8d9ce$export$a100703e17b2650a);
$parcel$export(module.exports, "DevInfoTypeMap", () => $37282c0a5dd8d9ce$export$39c00ace65e13f2d);
$parcel$export(module.exports, "ButtonStatus", () => $37282c0a5dd8d9ce$export$477d4d2d93581a40);
const $37282c0a5dd8d9ce$export$a100703e17b2650a = Object.freeze({
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DECLINED: 'declined',
    MERGED: 'merged',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
});
const $37282c0a5dd8d9ce$export$39c00ace65e13f2d = {
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.BRANCH]: 'branch',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.COMMIT]: 'commit',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.PULLREQUEST]: 'pull request',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.MERGED]: 'pull request',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.DECLINED]: 'pull request',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.DEPLOYMENT]: 'deployment',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.DESIGN]: 'design'
};
const $37282c0a5dd8d9ce$export$477d4d2d93581a40 = Object.freeze({
    ACTIVE: 'active',
    HOVER: 'hover',
    DEFAULT: 'default'
});

});

parcelRegister("lKCKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b49a01e4d7de0f03$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $96IgR = parcelRequire("96IgR");


var $5JgJ2 = parcelRequire("5JgJ2");

var $e9Jo2 = parcelRequire("e9Jo2");

var $8gviD = parcelRequire("8gviD");

var $eQ4bB = parcelRequire("eQ4bB");

var $cpgno = parcelRequire("cpgno");
const $b49a01e4d7de0f03$var$ErrorFallback = ({ devInfoType: devInfoType, issueAri: issueAri, scopeId: scopeId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showDevDetailDialogForPopup: showDevDetailDialogForPopup } = (0, $eQ4bB.useShowDevDetailDialogForPopup)(scopeId);
    const handleLinkClick = ()=>{
        showDevDetailDialogForPopup(devInfoType, issueAri);
    };
    const devInfoTypeName = (0, $8gviD.DevInfoTypeMap)[devInfoType];
    const errorMessage = devInfoType === (0, $8gviD.DevInfoTypes).DESIGN ? formatMessage((0, $cpgno.default).designErrorDescription, {
        devInfoType: devInfoTypeName
    }) : formatMessage((0, $cpgno.default).errorDescription, {
        devInfoType: devInfoTypeName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupTitle), null, formatMessage((0, $cpgno.default).errorPopupTitle, {
        devInfoType: (0, $8gviD.DevInfoTypeMap)[devInfoType]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$Title, null, formatMessage((0, $cpgno.default).errorTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$Description, null, errorMessage, devInfoType !== (0, $8gviD.DevInfoTypes).DESIGN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$StyledButton, {
        appearance: "link",
        onClick: handleLinkClick
    }, formatMessage((0, $cpgno.default).developmentErrorDescriptionCta))));
};
var $b49a01e4d7de0f03$export$2e2bcd8739ae039 = $b49a01e4d7de0f03$var$ErrorFallback;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b49a01e4d7de0f03$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $b49a01e4d7de0f03$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $b49a01e4d7de0f03$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yxxidpf _12r21nn1 _if291ule _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
            __cmplp.className
        ])
    });
});
const $b49a01e4d7de0f03$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1wmz _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e9Jo2", function(module, exports) {

$parcel$export(module.exports, "PopupContainer", () => $4d67de45504f6b7f$export$cca08eed9de89ba9);
$parcel$export(module.exports, "LinkContainer", () => $4d67de45504f6b7f$export$af2ec3aa21d10ab7);
$parcel$export(module.exports, "PopupHeader", () => $4d67de45504f6b7f$export$b11ea9d6e8111404);
$parcel$export(module.exports, "StyledDate", () => $4d67de45504f6b7f$export$30301703d55848e7);
$parcel$export(module.exports, "RepositoryInfo", () => $4d67de45504f6b7f$export$fde5e3d077213a6f);
$parcel$export(module.exports, "PopupTitle", () => $4d67de45504f6b7f$export$b834616c6081368f);
$parcel$export(module.exports, "StyledLink", () => $4d67de45504f6b7f$export$9048d548939551ee);
$parcel$export(module.exports, "PopupOverflowSection", () => $4d67de45504f6b7f$export$9e3158dc6a3a0f92);
$parcel$export(module.exports, "PopupKeyline", () => $4d67de45504f6b7f$export$a0765d4427758c62);
$parcel$export(module.exports, "PopupOverflowButton", () => $4d67de45504f6b7f$export$aeb11758c9d29e5c);
$parcel$export(module.exports, "TimeDisplay", () => $4d67de45504f6b7f$export$9b3df3d60caed5f9);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $dnbhd = parcelRequire("dnbhd");
const $4d67de45504f6b7f$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi _1bsbnklw _1tkeys9h _vchhusvi",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$b11ea9d6e8111404 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$30301703d55848e7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _otyridpf _1e0c1txw _o5724jg8",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$fde5e3d077213a6f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5724jg8",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$80b51772092eddc0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _1p1dangw _otyr1b66",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$b834616c6081368f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4d67de45504f6b7f$export$80b51772092eddc0, props));
const $4d67de45504f6b7f$export$9048d548939551ee = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $dnbhd.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81doa _k48p1igg _syaz1y58 _otyru2gc",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$9e3158dc6a3a0f92 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$a0765d4427758c62 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3it94y _bfhk1wws _otyrutpp",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$aeb11758c9d29e5c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yxxidpf _12r21nn1 _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$9b3df3d60caed5f9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $lB25E = parcelRequire("lB25E");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});


parcelRegister("eQ4bB", function(module, exports) {

$parcel$export(module.exports, "useShowDevDetailDialogForPopup", () => $0f663eb0f0e5c7d1$export$cdc75a6c65207319);

var $2WYJT = parcelRequire("2WYJT");


var $huI7r = parcelRequire("huI7r");

var $8gviD = parcelRequire("8gviD");
const $0f663eb0f0e5c7d1$export$166d6c8e7de25541 = (issueAri)=>(0, $huI7r.parseAri)(issueAri)?.resourceId;
const $0f663eb0f0e5c7d1$var$devInfoTypeToPanelDataType = (devInfoType)=>{
    if (devInfoType === (0, $8gviD.DevInfoTypes).COMMIT) return 0, $14a090e212ebf7a4$export$2e42513c7764d5f3;
    if (devInfoType === (0, $8gviD.DevInfoTypes).DEPLOYMENT) return 0, $14a090e212ebf7a4$export$90cac6260ae9ced5;
    return devInfoType;
};
function $0f663eb0f0e5c7d1$export$cdc75a6c65207319(scopeId) {
    const { showDevDetailDialog: showDevDetailDialog } = (0, $2WYJT.useDevOpsDetailsDialogLoaderActions)(scopeId || 'software-board.board');
    const showDevDetailDialogForPopup = (devInfoType, issueAri)=>{
        const type = $0f663eb0f0e5c7d1$var$devInfoTypeToPanelDataType(devInfoType);
        const issueId = $0f663eb0f0e5c7d1$export$166d6c8e7de25541(issueAri);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        showDevDetailDialog(type, undefined, '', issueId);
    };
    return {
        showDevDetailDialogForPopup: showDevDetailDialogForPopup
    };
}

});
parcelRegister("2WYJT", function(module, exports) {

$parcel$export(module.exports, "loadDialogBridge", () => $87c35b59655e803f$export$7e12f7cd0f50fe5a);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderContainer", () => $87c35b59655e803f$export$5e6e4cfb89bdcb55);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderSubscriber", () => $87c35b59655e803f$export$693f51ab225dff94);
$parcel$export(module.exports, "useDevOpsDetailsDialogLoaderActions", () => $87c35b59655e803f$export$506ad06ecf691cd3);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");


var $96gVp = parcelRequire("96gVp");
var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
var $2HpOy = parcelRequire("2HpOy");
var $4s7hU = parcelRequire("4s7hU");

var $fduvM = parcelRequire("fduvM");
const $87c35b59655e803f$export$7e12f7cd0f50fe5a = async ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: (0, $fduvM.DEV_DETAILS_WRM_RESOURCE),
        wrmKeys: [
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-wrm',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources'
        ]
    });
const $87c35b59655e803f$export$e324594224ef24da = {
    resetState: (stateOverrides)=>({ setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...(0, $fduvM.INITIAL_STATE),
                ...stateOverrides
            });
        },
    updateState: (stateUpdates)=>({ getState: getState, setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...getState(),
                ...stateUpdates
            });
        },
    showDevDetailDialog: (itemType, legacyData, targetIssueKey, targetIssueId)=>({ setState: setState, getState: getState })=>{
            if (itemType === (0, $14a090e212ebf7a4$export$3f1e2b276d607490)) // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                legacyDevPanelDetailsDialogShownCounter: // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                getState().legacyDevPanelDetailsDialogShownCounter + 1,
                isDevPanelDetailsDialogShown: false,
                dataTypeSelected: itemType,
                legacyData: legacyData,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
            else // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                isDevPanelDetailsDialogShown: true,
                dataTypeSelected: itemType,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
        },
    closeDetailDialog: ()=>({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes | undefined'.
                dataTypeSelected: '',
                isDevPanelDetailsDialogShown: false,
                issueKey: undefined,
                issueId: undefined
            });
        }
};
const $87c35b59655e803f$export$390f32400eaf98c9 = (0, $kEDjj.createStore)({
    name: 'DetailsDialogLoaderRemoteState',
    initialState: (0, $fduvM.INITIAL_STATE),
    actions: $87c35b59655e803f$export$e324594224ef24da
});
const $87c35b59655e803f$export$5e6e4cfb89bdcb55 = (0, $96gVp.createContainer)($87c35b59655e803f$export$390f32400eaf98c9);
const $87c35b59655e803f$export$693f51ab225dff94 = (0, $2HpOy.createSubscriber)($87c35b59655e803f$export$390f32400eaf98c9);
const $87c35b59655e803f$export$550d4b3c29100112 = (0, $1yZQx.createHook)($87c35b59655e803f$export$390f32400eaf98c9);
function $87c35b59655e803f$export$506ad06ecf691cd3(scopeId) {
    return (0, $4s7hU.defaultRegistry).getStore($87c35b59655e803f$export$390f32400eaf98c9, scopeId)?.actions;
}

});
const $14a090e212ebf7a4$export$e18d81f044132a0e = 'branch';
const $14a090e212ebf7a4$export$74a388a09f2a004e = 'build';
const $14a090e212ebf7a4$export$2e42513c7764d5f3 = 'repository';
const $14a090e212ebf7a4$export$3f1e2b276d607490 = 'review';
const $14a090e212ebf7a4$export$90cac6260ae9ced5 = 'deployment-environment';
const $14a090e212ebf7a4$export$6f74b53d652f13f3 = 'pullrequest';
const $14a090e212ebf7a4$export$c69477f358d30f7e = 'feature-flags';
const $14a090e212ebf7a4$export$56470bdd9cd798d0 = 'remote-links';
const $14a090e212ebf7a4$export$3da53566eda5eeef = 'jira.fe.issue.dev-details.time-to.load';
const $14a090e212ebf7a4$export$b4bb784d069c9ab = 'development.details.details-header';
const $14a090e212ebf7a4$export$74189cec821240a6 = 'development.details.remote-links';

parcelRegister("fduvM", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $b00e5ffa4dd6d204$export$36d128238e6b60f5);
$parcel$export(module.exports, "DEV_DETAILS_WRM_RESOURCE", () => $b00e5ffa4dd6d204$export$43a8ab4f373ff0ee);
const $b00e5ffa4dd6d204$export$36d128238e6b60f5 = {
    issueId: '',
    issueKey: undefined,
    locale: 'en_US',
    // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes'.
    dataTypeSelected: '',
    legacyData: undefined,
    isDevPanelDetailsDialogShown: false,
    legacyDevPanelDetailsDialogShownCounter: 0
};
const $b00e5ffa4dd6d204$export$b5ed55f3ed234f95 = 'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources';
const $b00e5ffa4dd6d204$export$43a8ab4f373ff0ee = 'jira-development-status/releasereport/dev-status-dialog-bridge';
const $b00e5ffa4dd6d204$export$432f9ff6c01431e3 = 'jira-development-status/util/WRM';

});



parcelRegister("cpgno", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bd4bef6d1b1266$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $44bd4bef6d1b1266$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorPopupTitle: {
        "id": "development-board-common.error-fallback.error-popup-title",
        "defaultMessage": "{devInfoType}"
    },
    errorTitle: {
        "id": "development-board-common.error-fallback.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorDescription: {
        "id": "development-board-common.error-fallback.error-description",
        "defaultMessage": "For some reason we couldn't load this {devInfoType}."
    },
    developmentErrorDescriptionCta: {
        "id": "development-board-common.error-fallback.development-error-description-cta",
        "defaultMessage": "View all development information."
    },
    designErrorDescription: {
        "id": "development-board-common.error-fallback.design-error-description",
        "defaultMessage": "For some reason we couldn't load this design. Refresh your page to try again."
    }
});

});


parcelRegister("2ld4O", function(module, exports) {

$parcel$export(module.exports, "createIssueAri", () => $b5e04eaf4130b68e$export$6b0ec881a3540845);

var $huI7r = parcelRequire("huI7r");
const $b5e04eaf4130b68e$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    });

});

parcelRegister("c5Qiw", function(module, exports) {

$parcel$export(module.exports, "DevInfoDetailsPopupSkeleton", () => $6593062fea30be6d$export$9044eba4855892a5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $jwCRu = parcelRequire("jwCRu");

var $lRZkV = parcelRequire("lRZkV");

var $5v1Iy = parcelRequire("5v1Iy");

var $dexFQ = parcelRequire("dexFQ");

var $dmHv3 = parcelRequire("dmHv3");
// Try to keep SPA JS bundle as small as possible, skeletons should not have dependencies, so here we use hard coding instead of import gridSize
const $6593062fea30be6d$var$customCssStyles = null;
const $6593062fea30be6d$var$skeletonStyles = null;
const $6593062fea30be6d$export$ae7439e01588d047 = {
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
};
const $6593062fea30be6d$var$skeletonAsset = {
    [$6593062fea30be6d$export$ae7439e01588d047.BRANCH]: (0, (/*@__PURE__*/$parcel$interopDefault($jwCRu))),
    [$6593062fea30be6d$export$ae7439e01588d047.COMMIT]: (0, (/*@__PURE__*/$parcel$interopDefault($lRZkV))),
    [$6593062fea30be6d$export$ae7439e01588d047.PULLREQUEST]: (0, (/*@__PURE__*/$parcel$interopDefault($dmHv3))),
    [$6593062fea30be6d$export$ae7439e01588d047.DEPLOYMENT]: (0, (/*@__PURE__*/$parcel$interopDefault($5v1Iy))),
    [$6593062fea30be6d$export$ae7439e01588d047.DESIGN]: (0, (/*@__PURE__*/$parcel$interopDefault($dexFQ)))
};
const $6593062fea30be6d$export$9044eba4855892a5 = ({ devinfoType: devinfoType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.BRANCH && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.COMMIT && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.PULLREQUEST && "_1bsbnklw _1yt41lhn _vchhusvi _4t3imgvx",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.DEPLOYMENT && "_1bsbnklw _4t3i1lit",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.DESIGN && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: $6593062fea30be6d$var$skeletonAsset[devinfoType],
        className: (0, $7JEyt.default)([
            "_1wgmglyw _rcujmgjw"
        ])
    }));

});
parcelRegister("jwCRu", function(module, exports) {
module.exports = new URL("branch-details-popup.tpl.90980aef.svg", import.meta.url).toString();

});

parcelRegister("lRZkV", function(module, exports) {
module.exports = new URL("commit-details-popup.tpl.ef7b25c8.svg", import.meta.url).toString();

});

parcelRegister("5v1Iy", function(module, exports) {
module.exports = new URL("deployment-details-popup.tpl.d0e045e6.svg", import.meta.url).toString();

});

parcelRegister("dexFQ", function(module, exports) {
module.exports = new URL("design-details-popup.tpl.da785a24.svg", import.meta.url).toString();

});

parcelRegister("dmHv3", function(module, exports) {
module.exports = new URL("pr-details-popup.tpl.2fd71422.svg", import.meta.url).toString();

});


parcelRegister("7uPRH", function(module, exports) {

$parcel$export(module.exports, "metricsDev", () => $e54a6a3bc3e00198$export$9d08247a1076ddb0);
$parcel$export(module.exports, "experienceDetails", () => $e54a6a3bc3e00198$export$ba2604b0fdde2542);
$parcel$export(module.exports, "packageDetails", () => $e54a6a3bc3e00198$export$48b44d9f3c6e15de);
$parcel$export(module.exports, "popupEntryPoints", () => $e54a6a3bc3e00198$export$1452632269dce6);

var $lNfG4 = parcelRequire("lNfG4");

var $9Lh4U = parcelRequire("9Lh4U");

var $8gviD = parcelRequire("8gviD");

var $8qFOR = parcelRequire("8qFOR");
const $e54a6a3bc3e00198$var$commitDetailsPopupLoad = (0, $lNfG4.metrics).interaction({
    key: 'list.commit-details-popup-load'
});
const $e54a6a3bc3e00198$var$prDetailsPopupLoad = (0, $lNfG4.metrics).interaction({
    key: 'list.pr-details-popup-load'
});
const $e54a6a3bc3e00198$export$9d08247a1076ddb0 = {
    [(0, $8gviD.DevInfoTypes).COMMIT]: $e54a6a3bc3e00198$var$commitDetailsPopupLoad,
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: $e54a6a3bc3e00198$var$prDetailsPopupLoad
};
const $e54a6a3bc3e00198$export$ba2604b0fdde2542 = {
    [(0, $8gviD.DevInfoTypes).COMMIT]: {
        id: 'commitDetailsPopup',
        name: 'jiraSoftwareListCommitDetailsPopup'
    },
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: {
        id: 'prDetailsPopup',
        name: 'jiraSoftwareListPrDetailsPopup'
    }
};
const $e54a6a3bc3e00198$export$48b44d9f3c6e15de = {
    [(0, $8gviD.DevInfoTypes).COMMIT]: {
        id: 'renderCommitDetailsPopup',
        packageName: 'jiraDevelopmentListCommitDetailsPopup',
        teamName: 'fusion-isotopes'
    },
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: {
        id: 'renderPRDetailsPopup',
        packageName: 'jiraDevelopmentListPrDetailsPopup',
        teamName: 'fusion-isotopes'
    }
};
const $e54a6a3bc3e00198$export$1452632269dce6 = {
    [(0, $8gviD.DevInfoTypes).COMMIT]: (0, $9Lh4U.commitDetailsEntryPoint),
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: (0, $8qFOR.pullRequestDetailsEntryPoint)
};

});
parcelRegister("9Lh4U", function(module, exports) {

$parcel$export(module.exports, "commitDetailsEntryPoint", () => $3c86546e63859b12$export$543707906869c79b);

var $cRNlw = parcelRequire("cRNlw");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $3c86546e63859b12$export$543707906869c79b = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("as4bY")), {
        moduleId: "0f8578e0"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                commitDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cRNlw.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("cRNlw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eec06dfcbd43e202$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1084bead4ae00878b2af2c8348929c25>>
 * @relayHash eed264a6d119fbca146eb1de817b2b96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b
const $eec06dfcbd43e202$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b",
        "metadata": {},
        "name": "mainJiraBoardFetchCommitDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $eec06dfcbd43e202$export$2e2bcd8739ae039 = $eec06dfcbd43e202$var$node;

});

parcelRegister("as4bY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8Ydge").then(()=>parcelRequire('8jOtz'));

});


parcelRegister("8qFOR", function(module, exports) {

$parcel$export(module.exports, "pullRequestDetailsEntryPoint", () => $00e71a60969c485e$export$37ab544e7066c095);

var $jLRNB = parcelRequire("jLRNB");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $00e71a60969c485e$export$37ab544e7066c095 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("1Az09")), {
        moduleId: "1b74db53"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                pullRequestDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $jLRNB.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("jLRNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $99c2342641857612$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e18ba82933463bea77a039cb31341c83>>
 * @relayHash ec62760f3d36372780325706797b1fb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0
const $99c2342641857612$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0",
        "metadata": {},
        "name": "mainJiraBoardFetchPullRequestDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $99c2342641857612$export$2e2bcd8739ae039 = $99c2342641857612$var$node;

});

parcelRegister("1Az09", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("03Ibg")
]).then(()=>parcelRequire('8IcTB'));

});



parcelRegister("dpiiy", function(module, exports) {

$parcel$export(module.exports, "DevSummaryLozenge", () => $3de80405a7ba4d79$export$3bb699b6db60f511);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3NqHp = parcelRequire("3NqHp");

var $dEfSO = parcelRequire("dEfSO");
const $3de80405a7ba4d79$export$3bb699b6db60f511 = ({ isUnderReview: isUnderReview, isMerged: isMerged, commitCount: commitCount, pullRequestsCount: pullRequestsCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isMerged || isUnderReview) {
        const tooltipText = formatMessage((0, $dEfSO.default).pullRequest, {
            count: pullRequestsCount
        });
        const lozengeText = isMerged ? formatMessage((0, $dEfSO.default).merged) : formatMessage((0, $dEfSO.default).underReview);
        const lozengeAppearance = isMerged ? 'success' : 'default';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NqHp.TagListWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: tooltipText,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: lozengeAppearance
        }, lozengeText)));
    }
    if (commitCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3de80405a7ba4d79$var$linkStyles
    }, formatMessage((0, $dEfSO.default).commit, {
        count: commitCount
    }));
};
const $3de80405a7ba4d79$var$linkStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.blue',
    paddingLeft: 'space.075'
});

});
parcelRegister("3NqHp", function(module, exports) {

$parcel$export(module.exports, "TagListWrapper", () => $e05d2a11c57cc062$export$e4f5eab7c40840c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $4L66F = parcelRequire("4L66F");
const $e05d2a11c57cc062$export$e4f5eab7c40840c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uzc8vy": (0, $9t7rW.default)((0, $4L66F.SELECTED_CELL_BOX_SHADOW))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11vw1qnq _1e0c1txw _4cvr1h6o _1bsbupfu _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _1n261q9c _1reo15vq _18m915vq _1yt41cy0 _o5721q9c _hc7q15vq _njtz15vq _p7r1116y",
            __cmplp.isFocused ? "_16qs179s" : "_16qsglyw",
            __cmplp.isFocused ? "_bfhkvuon" : "_bfhk18uv",
            __cmplp.isEditable ?? true ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4L66F", function(module, exports) {

$parcel$export(module.exports, "SELECTED_CELL_BOX_SHADOW", () => $6eb268cb8f99047b$export$e643c5fb607dbcc5);
$parcel$export(module.exports, "DEFAULT_ROW_HEIGHT", () => $6eb268cb8f99047b$export$258441c8a79bb589);

const $6eb268cb8f99047b$export$95bfdfec8f6b837d = 2;
const $6eb268cb8f99047b$export$e643c5fb607dbcc5 = `0 0 0 ${$6eb268cb8f99047b$export$95bfdfec8f6b837d}px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$exports).B200})`} inset`;
const $6eb268cb8f99047b$export$258441c8a79bb589 = 40;
const $6eb268cb8f99047b$export$3e36baaa5cb0cfb5 = [
    0,
    -$6eb268cb8f99047b$export$258441c8a79bb589
];

});


parcelRegister("dEfSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5e9b3238b6c2d3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7c5e9b3238b6c2d3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    underReview: {
        "id": "business-fields.dev-summary.cell.read.lozenge.under-review",
        "defaultMessage": "Under review"
    },
    merged: {
        "id": "business-fields.dev-summary.cell.read.lozenge.merged",
        "defaultMessage": "Merged"
    },
    commit: {
        "id": "business-fields.dev-summary.cell.read.lozenge.commit",
        "defaultMessage": "{count, plural, one {# commit} other {# commits}}"
    },
    pullRequest: {
        "id": "business-fields.dev-summary.cell.read.lozenge.pull-request",
        "defaultMessage": "{count, plural, one {# pull request} other {# pull requests}}"
    }
});

});




parcelRegister("iwcjI", function(module, exports) {

$parcel$export(module.exports, "goalsCellHandler", () => $b0b894329932ed05$export$524e25319ef30df1);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $9JNni = parcelRequire("9JNni");

var $1ybV0 = parcelRequire("1ybV0");

var $gJNrI = parcelRequire("gJNrI");

var $lO4Or = parcelRequire("lO4Or");

var $bFzGY = parcelRequire("bFzGY");

var $4TezD = parcelRequire("4TezD");

var $b5xtc = parcelRequire("b5xtc");

var $3ylNm = parcelRequire("3ylNm");
const $b0b894329932ed05$var$defaultValue = {
    goals: [],
    totalCount: 0
};
const $b0b894329932ed05$export$aea87ff07be8100d = ({ rowData: issue, cellData: field, editMode: editMode, setEditMode: setEditMode, fieldId: fieldId, fieldName: fieldName, cellRef: cellRef })=>{
    const [goalsValue, setGoalsValue] = (0, $eUqFw.useState)(field?.value ?? $b0b894329932ed05$var$defaultValue);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isEditable = field?.isEditable ?? true;
    const isFieldAssociated = (0, $3ylNm.useIsFieldAssociatedWithIssueType)({
        fieldId: fieldId,
        issueTypeId: issue.issuetype?.id
    });
    const [{ value: value }, { saveValue: saveValue }] = (0, $gJNrI.useGoalsField)({
        issueId: issue.issueId,
        issueKey: issue.key,
        fieldKey: fieldId,
        initialValue: field?.value ?? $b0b894329932ed05$var$defaultValue
    });
    (0, $eUqFw.useEffect)(()=>{
        setGoalsValue(field?.value ?? $b0b894329932ed05$var$defaultValue);
    }, [
        field?.value
    ]);
    if ((0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view') && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(value, goalsValue)) setGoalsValue(value);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setEditMode(false);
    }, [
        setEditMode
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.code === 'Tab') return true;
        return false;
    }, []);
    const cellOverrides = (0, $eUqFw.useCallback)(()=>({
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const onGoalPicked = (0, $eUqFw.useCallback)((goal)=>{
        const newValue = {
            goals: [
                ...goalsValue.goals,
                goal
            ],
            totalCount: goalsValue.totalCount + 1
        };
        setGoalsValue(newValue);
        if ((0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view')) saveValue(newValue, null, createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        goalsValue.goals,
        goalsValue.totalCount,
        saveValue
    ]);
    const onGoalUnlinked = (0, $eUqFw.useCallback)((_, remainingGoals)=>{
        const newValue = {
            goals: remainingGoals,
            totalCount: goalsValue.totalCount > 0 ? goalsValue.totalCount - 1 : 0
        };
        setGoalsValue(newValue);
        if ((0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view')) saveValue(newValue, null, createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        goalsValue.totalCount,
        saveValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable
    }, isFieldAssociated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9JNni.default), {
        issueAri: issue.id,
        editMode: editMode,
        goals: goalsValue.goals,
        goalCount: goalsValue.totalCount,
        onClose: onClose,
        isEditable: isEditable,
        onGoalPicked: onGoalPicked,
        onGoalUnlinked: onGoalUnlinked
    }), !isFieldAssociated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5xtc.AssociateFieldPopup), {
        isOpen: editMode,
        issueType: issue.issuetype?.name,
        issueTypeId: issue.issuetype?.id,
        fieldId: fieldId,
        fieldName: fieldName,
        onClose: onClose
    }));
};
const $b0b894329932ed05$export$524e25319ef30df1 = {
    [(0, $lO4Or.GOALS_CF_TYPE)]: $b0b894329932ed05$export$aea87ff07be8100d
};

});
parcelRegister("9JNni", function(module, exports) {

$parcel$export(module.exports, "default", () => $302f90b11f728b97$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $4G5xU = parcelRequire("4G5xU");

var $l3Qg0 = parcelRequire("l3Qg0");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $k8Qyf = parcelRequire("k8Qyf");

var $bYYP0 = parcelRequire("bYYP0");

var $lO4Or = parcelRequire("lO4Or");

var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");

var $5s6G4 = parcelRequire("5s6G4");

var $gN3SH = parcelRequire("gN3SH");

var $7rATE = parcelRequire("7rATE");

var $6ixIu = parcelRequire("6ixIu");

var $igWke = parcelRequire("igWke");

var $lUluW = parcelRequire("lUluW");

var $6m7ME = parcelRequire("6m7ME");
const $302f90b11f728b97$var$POPUP_OFFSET = [
    -8,
    8
];
const $302f90b11f728b97$var$GoalsPicker = ({ issueAri: issueAri, goals: goals, goalCount: goalCount, isEditable: isEditable, editMode: editMode, onClose: onClose, onGoalPicked: onGoalPicked, onGoalUnlinked: onGoalUnlinked, shouldRenderToParent: shouldRenderToParent = false, showPlaceholder: showPlaceholder })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const pressTracing = (0, $5s6G4.default)('platform-goal-picker');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const ariaLabel = (0, $igWke.useGoalsCellAriaLabel)({
        goalCount: goalCount,
        showPlaceholder: showPlaceholder
    });
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $gN3SH.VIEW_GOAL_PICKER_EXPERIENCE));
    const { showFlag: showFlag, hasFlag: hasFlag } = (0, $k8Qyf.useFlagsService)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $lUluW.goalPickerPopoverEntryPoint), {
        cloudId: cloudId,
        issueAri: issueAri
    });
    const buttonTrigger = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (editMode) // load the entry point when the popup is opened
        entryPointActions.load();
    }, [
        editMode,
        entryPointActions
    ]);
    // Analytics
    (0, $eUqFw.useEffect)(()=>{
        if (editMode) {
            startExperience();
            pressTracing();
            // fire analytics start
            (0, $bYYP0.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $lO4Or.GOALS_CF_TYPE), {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: 'goals'
                }
            });
        }
    }, [
        editMode,
        startExperience,
        pressTracing,
        createAnalyticsEvent
    ]);
    const handleGoalPicked = (0, $eUqFw.useCallback)((goal)=>{
        // fire analytics end
        (0, $bYYP0.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $lO4Or.GOALS_CF_TYPE), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: 'goals',
                goalId: goal.id,
                action: 'goal linked',
                // it'll take some time for goalCount to get updated, so we increment it here
                numLinkedGoals: goalCount + 1
            }
        });
        onGoalPicked(goal);
    }, [
        createAnalyticsEvent,
        goalCount,
        onGoalPicked
    ]);
    const handleGoalUnlinked = (0, $eUqFw.useCallback)((goalUnlinkedId, remainingGoals)=>{
        // fire analytics end
        (0, $bYYP0.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $lO4Or.GOALS_CF_TYPE), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: 'goals',
                goalId: goalUnlinkedId,
                action: 'goal unlinked',
                numLinkedGoals: remainingGoals.length
            }
        });
        onGoalUnlinked(goalUnlinkedId, remainingGoals);
    }, [
        createAnalyticsEvent,
        onGoalUnlinked
    ]);
    const popupTrigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            role: "button",
            "aria-label": ariaLabel,
            xcss: $302f90b11f728b97$var$triggerStyles,
            ...triggerProps,
            ref: (element)=>{
                buttonTrigger(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ixIu.GoalsCellContent), {
            showPlaceholder: showPlaceholder,
            goals: goals,
            goalCount: goalCount,
            isEditable: isEditable
        })), [
        ariaLabel,
        buttonTrigger,
        goalCount,
        goals,
        isEditable,
        showPlaceholder
    ]);
    const errorFallback = (0, $eUqFw.useCallback)(({ error: error })=>{
        if (!hasFlag?.((0, $6m7ME.ERROR_FLAG_ID))) showFlag((0, $6m7ME.POPUP_ENTRYPOINT_ERROR_FLAG));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
            experience: (0, $gN3SH.VIEW_GOAL_PICKER_EXPERIENCE),
            error: error
        });
    }, [
        hasFlag,
        showFlag
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            issueAri: issueAri,
            goalCount: goalCount,
            onGoalPicked: handleGoalPicked,
            onGoalUnlinked: handleGoalUnlinked,
            onClose: onClose
        }), [
        goalCount,
        handleGoalPicked,
        handleGoalUnlinked,
        issueAri,
        onClose
    ]);
    const content = (0, $eUqFw.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm.goals.picker.edit.popup",
            packageName: "jiraBusinessGoalPicker",
            teamName: "jira-yurree",
            runtimeProps: {
                ...runtimeProps,
                onContentsResized: update
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rATE.LoadingContent), null),
            errorFallback: errorFallback
        }), [
        entryPointReferenceSubject,
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $302f90b11f728b97$var$goalPickerStyles,
        alignItems: "center",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        autoFocus: false,
        isOpen: editMode,
        content: content,
        trigger: popupTrigger,
        offset: $302f90b11f728b97$var$POPUP_OFFSET,
        placement: "bottom-start",
        shouldRenderToParent: shouldRenderToParent,
        onClose: onClose
    }));
};
var $302f90b11f728b97$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($302f90b11f728b97$var$GoalsPicker);
const $302f90b11f728b97$var$triggerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '100%',
    width: '100%',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center'
});
const $302f90b11f728b97$var$goalPickerStyles = (0, $1ZAYh.xcss)({
    minHeight: '100%',
    width: '100%'
});

});
parcelRegister("bYYP0", function(module, exports) {

$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $f85145fdcc3946b0$export$f3b2b77402b2631f);

var $hompL = parcelRequire("hompL");

var $gUUjF = parcelRequire("gUUjF");

var $jMP2a = parcelRequire("jMP2a");

var $7Ap9H = parcelRequire("7Ap9H");
/**
 * A singlenton class to provide a sessionId to track update of fields
 */ class $f85145fdcc3946b0$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
const $f85145fdcc3946b0$export$87846400a9b428fc = new $f85145fdcc3946b0$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default atrributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $f85145fdcc3946b0$var$concatAtrributes = (fieldKey, updateSessionId, attributes)=>{
    const { fieldType: fieldTypeValue } = attributes;
    const extraAttributes = $f85145fdcc3946b0$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    const fieldType = fieldTypeValue && (0, $7Ap9H.FIELD_TYPE_MAP)[fieldTypeValue] ? (0, $7Ap9H.FIELD_TYPE_MAP)[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $7Ap9H.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $f85145fdcc3946b0$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            const sessionid = $f85145fdcc3946b0$export$87846400a9b428fc.push(fieldKey);
            const attributes = $f85145fdcc3946b0$var$concatAtrributes(fieldKey, sessionid, params.attributes);
            (0, $jMP2a.fireUIAnalytics)(params.analytics, `${(0, $7Ap9H.START_ACTION_SUBJECT)} ${(0, $7Ap9H.START_ACTION)}`, (0, $7Ap9H.START_ACTION_SUBJECT_ID), attributes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', e.toString());
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            const sessionid = $f85145fdcc3946b0$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const attributes = $f85145fdcc3946b0$var$concatAtrributes(fieldKey, sessionid, params.attributes);
            if (isEndOfSession) $f85145fdcc3946b0$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
            (0, $jMP2a.fireTrackAnalytics)(params.analytics, `${(0, $7Ap9H.END_ACTION_SUBJECT)} ${(0, $7Ap9H.END_ACTION)}`, (0, $7Ap9H.END_ACTION_SUBJECT_ID), attributes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', e.toString());
        }
    },
    setAttributes (fieldKey, attributes) {
        $f85145fdcc3946b0$export$87846400a9b428fc.extraAttributes.set(fieldKey, attributes);
    },
    reset () {
        $f85145fdcc3946b0$export$87846400a9b428fc.reset();
    }
};
const $f85145fdcc3946b0$export$f3b2b77402b2631f = ()=>$f85145fdcc3946b0$var$updateAnalyticsFlowHelper;

});
parcelRegister("7Ap9H", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $f06f4a869451c640$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $f06f4a869451c640$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $f06f4a869451c640$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $f06f4a869451c640$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $f06f4a869451c640$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $f06f4a869451c640$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $f06f4a869451c640$export$e3d957ccc2d46469);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $f06f4a869451c640$export$d8ccf495ccc97a69);

var $lO4Or = parcelRequire("lO4Or");
const $f06f4a869451c640$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false
};
const $f06f4a869451c640$export$c0a4673e0c78e972 = 'clicked';
const $f06f4a869451c640$export$34a5ae354a38cc7e = 'item';
const $f06f4a869451c640$export$bc373f59492dc6e2 = 'issue';
const $f06f4a869451c640$export$b19686c1fe99f85a = 'updated';
const $f06f4a869451c640$export$4ce67e80878d47ed = 'issue';
const $f06f4a869451c640$export$e3d957ccc2d46469 = 'ended';
const $f06f4a869451c640$export$d8ccf495ccc97a69 = {
    [(0, $lO4Or.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: 'versions',
    [(0, $lO4Or.VERSION_CF_TYPE)]: 'versions',
    [(0, $lO4Or.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $lO4Or.SPRINT_TYPE)]: 'link',
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $lO4Or.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $lO4Or.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $lO4Or.USER_CF_TYPE)]: 'singleUser',
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $lO4Or.URL_CF_TYPE)]: 'url',
    [(0, $lO4Or.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: 'multiGroup'
};

});


parcelRegister("gN3SH", function(module, exports) {

$parcel$export(module.exports, "VIEW_GOAL_PICKER_EXPERIENCE", () => $a3c23dc05285d6a7$export$e665d677258d0141);
const $a3c23dc05285d6a7$export$e665d677258d0141 = {
    experience: 'viewGoalPicker',
    packageName: 'jiraBusinessGoalPicker',
    teamName: 'jira-yurree'
};

});

parcelRegister("7rATE", function(module, exports) {

$parcel$export(module.exports, "LoadingContent", () => $96937c76ff371ba7$export$4ab3512e4872e6ff);

var $eUqFw = parcelRequire("eUqFw");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $96937c76ff371ba7$export$4ab3512e4872e6ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $96937c76ff371ba7$var$loadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    }));
const $96937c76ff371ba7$var$loadingStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    width: '342px',
    padding: 'space.500'
});

});

parcelRegister("6ixIu", function(module, exports) {

$parcel$export(module.exports, "GoalsCellContent", () => $85bc4f45d09a6b3a$export$72e457a3c2c5d2a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iY7zv = parcelRequire("iY7zv");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $8TTqM = parcelRequire("8TTqM");

var $7ERlq = parcelRequire("7ERlq");

var $cxEEX = parcelRequire("cxEEX");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3LRXu = parcelRequire("3LRXu");
const $85bc4f45d09a6b3a$export$72e457a3c2c5d2a = ({ goals: goals, goalCount: goalCount, isEditable: isEditable, showPlaceholder: showPlaceholder = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (goalCount > 0 && goals !== null && goals.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85bc4f45d09a6b3a$var$Wrapper, {
        "data-testid": "business-goal-picker.ui.goals-cell-content.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $85bc4f45d09a6b3a$var$iconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8TTqM.GoalIcon), {
        size: "16",
        appearance: (0, $8TTqM.normalizeGoalAppearance)(goals[0].status || 'PENDING')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ERlq.GoalName), {
        name: goals[0].name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cxEEX.GoalsCount), {
        goalCount: goalCount
    }));
    let noGoalsContent;
    if (showPlaceholder) // if placeholder is displayed we wouldn't show 'add goal'
    noGoalsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $85bc4f45d09a6b3a$var$noGoalsStyles
    }, formatMessage((0, $3LRXu.default).noGoals));
    else if (isEditable) noGoalsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $85bc4f45d09a6b3a$var$addGoalStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }), formatMessage((0, $3LRXu.default).addGoal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85bc4f45d09a6b3a$var$Wrapper, {
        "data-testid": "business-goal-picker.ui.goals-cell-content.wrapper"
    }, noGoalsContent);
};
const $85bc4f45d09a6b3a$var$GOAL_PICKER_ADD_GOAL_DISPLAY = '--jira-goal-picker-cell-add-goal-display';
const $85bc4f45d09a6b3a$var$addGoalStyles = (0, $1ZAYh.xcss)({
    display: `var(${$85bc4f45d09a6b3a$var$GOAL_PICKER_ADD_GOAL_DISPLAY}, none)`,
    gap: 'space.100',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $85bc4f45d09a6b3a$var$noGoalsStyles = (0, $1ZAYh.xcss)({
    gap: 'space.100',
    alignItems: 'center',
    color: 'color.text.subtlest'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85bc4f45d09a6b3a$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _80omtlke _1bsb1osq _4t3i1osq _u5f3u2gc _vchhusvi _16jlkb7n _4cvr1h6o _zulpu2gc _tj4x1txw _2ooc1txw",
            __cmplp.className
        ])
    });
});
const $85bc4f45d09a6b3a$var$iconStyles = (0, $1ZAYh.xcss)({
    width: 'space.200'
});

});
parcelRegister("8TTqM", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $fdf13b72e1d50987$export$134cbcd70c6693b8);
$parcel$export(module.exports, "normalizeGoalAppearance", () => $fdf13b72e1d50987$export$f1b3ca93191ce5cc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cI2j2 = parcelRequire("cI2j2");

var $iY7zv = parcelRequire("iY7zv");

var $9Jret = parcelRequire("9Jret");

var $a34JA = parcelRequire("a34JA");
const $fdf13b72e1d50987$var$appearanceToColorMap = {
    default: 'gray',
    off_track: 'red',
    at_risk: 'yellow',
    on_track: 'green'
};
const $fdf13b72e1d50987$var$appearanceToLabelMap = {
    default: 'GenericIconLabel',
    off_track: 'townsquare.api.goal-state.off-track',
    at_risk: 'townsquare.api.goal-state.at-risk',
    on_track: 'townsquare.api.goal-state.on-track'
};
const $fdf13b72e1d50987$export$134cbcd70c6693b8 = ({ appearance: appearance, size: size, localizedLabel: localizedLabel })=>{
    const intl = (0, $5JgJ2.default)();
    const labelMessageId = localizedLabel && (0, $a34JA.isMessageId)(localizedLabel?.messageId) ? localizedLabel.messageId : $fdf13b72e1d50987$var$appearanceToLabelMap[appearance];
    return /*#__PURE__*/ $eUqFw.createElement((0, $cI2j2.default), {
        size: size,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))),
        label: intl.formatMessage((0, $a34JA.messages)[labelMessageId]),
        appearance: $fdf13b72e1d50987$var$appearanceToColorMap[appearance]
    });
};
const $fdf13b72e1d50987$export$f1b3ca93191ce5cc = (statusValue)=>{
    const appearanceLowercase = statusValue.toLocaleLowerCase();
    return (0, $9Jret.isGoalAppearance)(appearanceLowercase) ? appearanceLowercase : 'default';
};

});
parcelRegister("cI2j2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fb8d50dcfc24c9b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $1fb8d50dcfc24c9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1fb8d50dcfc24c9b$var$sizeMap = {
    '16': {
        name: "157xhr7",
        styles: "width:16px;height:16px"
    },
    '24': {
        name: "rrel8y",
        styles: "width:24px;height:24px"
    },
    '32': {
        name: "68x97p",
        styles: "width:32px;height:32px"
    },
    '40': {
        name: "1mfsro6",
        styles: "width:40px;height:40px"
    },
    '48': {
        name: "18jhpep",
        styles: "width:48px;height:48px"
    }
};
const $1fb8d50dcfc24c9b$var$appearanceMap = {
    grayBold: {
        name: "algye9",
        styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    limeBold: {
        name: "a86nvv",
        styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    greenBold: {
        name: "13e2qqr",
        styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    blueBold: {
        name: "jpsdma",
        styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    redBold: {
        name: "1bg8y7a",
        styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    purpleBold: {
        name: "19bo3lb",
        styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    magentaBold: {
        name: "1l16rgo",
        styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    tealBold: {
        name: "7kw5zl",
        styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    orangeBold: {
        name: "h77eay",
        styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    yellowBold: {
        name: "sbe4w3",
        styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    gray: {
        name: "yxgei8",
        styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
    },
    lime: {
        name: "o9c6oh",
        styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
    },
    orange: {
        name: "szqzk5",
        styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
    },
    magenta: {
        name: "o6ptuw",
        styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
    },
    green: {
        name: "157dg7e",
        styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
    },
    blue: {
        name: "x3nujl",
        styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
    },
    red: {
        name: "zqoyws",
        styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
    },
    purple: {
        name: "fitjkd",
        styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
    },
    teal: {
        name: "b3m1ww",
        styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
    },
    yellow: {
        name: "1j18jub",
        styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
    }
};
const $1fb8d50dcfc24c9b$var$shapeMap = {
    square: {
        name: "vwdoqr",
        styles: "border-radius:var(--ds-border-radius-100, 4px)"
    },
    circle: {
        name: "i2ucdk",
        styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
    }
};
const $1fb8d50dcfc24c9b$var$iconTileStyles = {
    name: "ykimcl",
    styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center"
};
function $1fb8d50dcfc24c9b$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square' } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $1fb8d50dcfc24c9b$var$iconTileStyles,
            $1fb8d50dcfc24c9b$var$appearanceMap[appearance],
            $1fb8d50dcfc24c9b$var$sizeMap[size],
            $1fb8d50dcfc24c9b$var$shapeMap[shape]
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)(ExpandedIcon, {
        color: "currentColor",
        label: label,
        spacing: "spacious",
        shouldScale: true
    }));
}

});

parcelRegister("9Jret", function(module, exports) {

$parcel$export(module.exports, "isGoalAppearance", () => $ed33bb8a36a562f3$export$86d2476abee3806b);
const $ed33bb8a36a562f3$export$d6870ac5e959c0f5 = [
    'default',
    'on_track',
    'at_risk',
    'off_track'
];
const $ed33bb8a36a562f3$export$86d2476abee3806b = (value)=>$ed33bb8a36a562f3$export$d6870ac5e959c0f5.includes(value);
const $ed33bb8a36a562f3$export$d7b4c6a971e28318 = [
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'PENDING',
    'DONE',
    'CANCELLED',
    'PAUSED',
    'ARCHIVED'
];

});

parcelRegister("a34JA", function(module, exports) {

$parcel$export(module.exports, "isMessageId", () => $b5b67297adf6aba2$export$d28699f9b486207b);
$parcel$export(module.exports, "messages", () => $b5b67297adf6aba2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b5b67297adf6aba2$var$MESSAGE_IDS = [
    'townsquare.api.goal-state.on-track',
    'townsquare.api.goal-state.off-track',
    'townsquare.api.goal-state.at-risk',
    'townsquare.api.goal-state.pending',
    'townsquare.api.goal-state.completed',
    'townsquare.api.goal-state.cancelled',
    'townsquare.api.goal-state.paused',
    'GenericIconLabel'
];
const $b5b67297adf6aba2$export$d28699f9b486207b = (value)=>$b5b67297adf6aba2$var$MESSAGE_IDS.includes(value);
const $b5b67297adf6aba2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    GenericIconLabel: {
        id: 'Goals.icon.label.generic',
        defaultMessage: 'Goal icon',
        description: 'A generic label for the goal icon, for when a label is not supplied and cannot be inferred from the appearance prop.'
    },
    'townsquare.api.goal-state.on-track': {
        id: 'Goals.icon.label.on-track',
        defaultMessage: 'On track',
        description: 'The label for the "on track" goal status'
    },
    'townsquare.api.goal-state.off-track': {
        id: 'Goals.icon.label.off-track',
        defaultMessage: 'Off track',
        description: 'The label for the "off track" goal status'
    },
    'townsquare.api.goal-state.at-risk': {
        id: 'Goals.icon.label.at-risk',
        defaultMessage: 'At risk',
        description: 'The label for the "at risk" goal status'
    },
    'townsquare.api.goal-state.pending': {
        id: 'Goals.icon.label.pending',
        defaultMessage: 'Pending',
        description: 'The label for the "pending" goal status'
    },
    'townsquare.api.goal-state.completed': {
        id: 'Goals.icon.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    'townsquare.api.goal-state.cancelled': {
        id: 'Goals.icon.label.cancelled',
        defaultMessage: 'Cancelled',
        description: 'The label for the "cancelled" goal status'
    },
    'townsquare.api.goal-state.paused': {
        id: 'Goals.icon.label.paused',
        defaultMessage: 'Paused',
        description: 'The label for the "paused" goal status'
    }
});

});


parcelRegister("7ERlq", function(module, exports) {

$parcel$export(module.exports, "GoalName", () => $1279a78781638498$export$4427fb3cde8dd0cf);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $1279a78781638498$export$4427fb3cde8dd0cf = ({ name: name })=>name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1279a78781638498$var$goalTextStyles,
        as: "span"
    }, name);
const $1279a78781638498$var$goalTextStyles = (0, $1ZAYh.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});

parcelRegister("cxEEX", function(module, exports) {

$parcel$export(module.exports, "GoalsCount", () => $901a0e7fc0437b9b$export$cb088e21a8acb84d);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $901a0e7fc0437b9b$export$cb088e21a8acb84d = ({ goalCount: goalCount })=>{
    const numberOfGoals = (0, $eUqFw.useMemo)(()=>goalCount > 1 ? `+${goalCount - 1}` : '', [
        goalCount
    ]);
    return numberOfGoals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $901a0e7fc0437b9b$var$countStyles
    }, numberOfGoals);
};
const $901a0e7fc0437b9b$var$countStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.disabled',
    fontWeight: 400,
    borderRadius: 'border.radius',
    lineHeight: 0.8632,
    padding: 'space.050',
    pointerEvents: 'none'
});

});

parcelRegister("3LRXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc93455b2bfca192$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fc93455b2bfca192$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addGoal: {
        "id": "business-goal-picker.goals-cell-content.add-goal",
        "defaultMessage": "Add goal"
    },
    noGoals: {
        "id": "business-goal-picker.goals-cell-content.no-goals",
        "defaultMessage": "None"
    },
    linkGoals: {
        "id": "business-goal-picker.goals-cell-content.link-goals",
        "defaultMessage": "Link Goals"
    }
});

});


parcelRegister("igWke", function(module, exports) {

$parcel$export(module.exports, "useGoalsCellAriaLabel", () => $a375a783a91587fb$export$65ef52b68009f944);

var $5JgJ2 = parcelRequire("5JgJ2");

var $3LRXu = parcelRequire("3LRXu");
const $a375a783a91587fb$export$65ef52b68009f944 = ({ goalCount: goalCount, showPlaceholder: showPlaceholder })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (showPlaceholder) return undefined;
    if (goalCount === 0) return formatMessage((0, $3LRXu.default).addGoal);
    return formatMessage((0, $3LRXu.default).linkGoals);
};

});

parcelRegister("lUluW", function(module, exports) {

$parcel$export(module.exports, "goalPickerPopoverEntryPoint", () => $48f2d4f515c7ffe8$export$2917eb3a6c81ef7c);

var $gkdpR = parcelRequire("gkdpR");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $48f2d4f515c7ffe8$export$2917eb3a6c81ef7c = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("enaNV")), {
        moduleId: "97c2ac23"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueAri: issueAri })=>({
            queries: {
                mainGoalsPopupContentQuery: {
                    parameters: (0, $gkdpR.default),
                    variables: {
                        cloudId: cloudId,
                        issueAri: issueAri
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("gkdpR", function(module, exports) {

$parcel$export(module.exports, "default", () => $25d0d7d36e312091$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b452e9df182e5747de78cebf3ce2959e>>
 * @relayHash 54821f2ce0db2d1ba6de7e01ec14b860
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e291987f4b2f3c06a39fa1847bccf79e6c0a181764a535dbcd391aa5e7f53c2b
const $25d0d7d36e312091$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "issueAri"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        v4 /*: any*/ 
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "kind": "InlineFragment",
        "selections": v8 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v12 = [
        "id"
    ], v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        v4 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainGoalsPopupContentQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueGoals_AtlassianGoalPicker"
                },
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TownsquareWorkspaceConnection",
                            "kind": "LinkedField",
                            "name": "allWorkspacesForOrg",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareWorkspaceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareWorkspace",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainGoalsPopupContentQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        },
                                                        {
                                                            "concreteType": "TownsquareStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareLocalizationField",
                                                                    "kind": "LinkedField",
                                                                    "name": "localizedLabel",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "messageId"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareGoal"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "args": v5 /*: any*/ ,
                            "filters": v12 /*: any*/ ,
                            "handle": "connection",
                            "key": "LinkedGoals_jiraEpicContributesToAtlasGoal",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v13 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "TownsquareGoal"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v13 /*: any*/ ,
                            "filters": v12 /*: any*/ ,
                            "handle": "connection",
                            "key": "Goals_issueGoalPicker",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        }
                    ]
                },
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TownsquareWorkspaceConnection",
                            "kind": "LinkedField",
                            "name": "allWorkspacesForOrg",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareWorkspaceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareWorkspace",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e291987f4b2f3c06a39fa1847bccf79e6c0a181764a535dbcd391aa5e7f53c2b",
            "metadata": {},
            "name": "mainGoalsPopupContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$25d0d7d36e312091$var$node.hash = "465827f41dc8a072858c56967c88337f";
var $25d0d7d36e312091$export$2e2bcd8739ae039 = $25d0d7d36e312091$var$node;

});

parcelRegister("enaNV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("60Mfg")
]).then(()=>parcelRequire('bioJd'));

});


parcelRegister("6m7ME", function(module, exports) {

$parcel$export(module.exports, "ERROR_FLAG_ID", () => $67267ee2fadbc141$export$f5e4c120ac01b615);
$parcel$export(module.exports, "POPUP_ENTRYPOINT_ERROR_FLAG", () => $67267ee2fadbc141$export$bb0d35c1fc48487f);

var $cYoou = parcelRequire("cYoou");
const $67267ee2fadbc141$export$f5e4c120ac01b615 = 'OPEN_GOAL_PICKER_ERROR_FLAG';
const $67267ee2fadbc141$export$bb0d35c1fc48487f = {
    id: $67267ee2fadbc141$export$f5e4c120ac01b615,
    type: 'error',
    title: (0, $cYoou.default).errorFlagTitle,
    description: (0, $cYoou.default).errorFlagDescription,
    isAutoDismiss: true
};

});
parcelRegister("cYoou", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ced99e7b3cd58e5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5ced99e7b3cd58e5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "business-goal-picker.error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    errorFlagDescription: {
        "id": "business-goal-picker.error-flag-description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
    }
});

});



parcelRegister("gJNrI", function(module, exports) {

$parcel$export(module.exports, "useGoalsField", () => $83d9a8d46f5a8485$export$c45dcf2640399301);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $a9yKi = parcelRequire("a9yKi");

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $dWLk9 = parcelRequire("dWLk9");

var $4Tdfn = parcelRequire("4Tdfn");
const $83d9a8d46f5a8485$export$c45dcf2640399301 = ({ fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const getDataId = (0, $eUqFw.useCallback)(// issueId can be undefined so passing this in after the saveField check to avoid TS error and ensure we actually have a valid value
    (typeName, issue)=>(0, $4Tdfn.default)({
            id: (0, $a9yKi.JiraIssuefieldvalueAri).create({
                siteId: cloudId,
                issueId: issue.toString(),
                fieldId: fieldKey
            }).toString()
        }, typeName), [
        cloudId,
        fieldKey
    ]);
    const saveField = (0, $eUqFw.useCallback)((_iKey, _fKey, valuesForOperation)=>{
        (0, $iWLL0.commitLocalUpdate)(environment, (store)=>{
            if (!issueId) return;
            const dataID = getDataId('JiraGoalsField', issueId);
            if (!dataID) return;
            const goalsField = store.get(dataID);
            if (!goalsField) return;
            const connection = (0, $cNy9K.ConnectionHandler).getConnection(goalsField, 'issue_view_goals_field_selectedGoals');
            if (connection == null) return;
            let edges = connection.getLinkedRecords('edges');
            if (!edges || edges.length === 0) {
                const newGoalDataId = getDataId('JiraGoalsField:selectedGoals(first:1):edges:0', issueId);
                if (!newGoalDataId) return;
                const newEdge = (0, $cNy9K.ConnectionHandler).createEdge(store, connection, store.create(newGoalDataId, 'JiraGoal'), 'JiraGoalEdge');
                (0, $cNy9K.ConnectionHandler).insertEdgeBefore(connection, newEdge);
                edges = connection.getLinkedRecords('edges');
            }
            if (!edges) return;
            // We should only ever have one edge
            const node = edges[0].getLinkedRecord('node');
            if (valuesForOperation.totalCount === 0) {
                const nodeId = node?.getDataID();
                const edgeId = edges[0].getDataID();
                if (!nodeId || !edgeId) return;
                // delete both the node and the edge to avoid invariant violations
                store.delete(nodeId);
                store.delete(edgeId);
                // Clear the connection to avoid invariant violations
                connection.setLinkedRecords([], 'edges');
            } else {
                node?.setValue(valuesForOperation.goals[0].id, 'id');
                node?.setValue(valuesForOperation.goals[0].name, 'name');
                node?.setValue(valuesForOperation.goals[0].status, 'status');
            }
            // We _should_ alway require the count to update
            connection?.setValue(valuesForOperation.totalCount, 'totalCount');
        });
        return Promise.resolve(undefined);
    }, [
        environment,
        getDataId,
        issueId
    ]);
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldType: (0, $lO4Or.GOALS_CF_TYPE),
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue,
        fieldKey: fieldKey,
        saveField: saveField,
        shouldPreventIssueViewSoftRefresh: true
    });
    return [
        {
            error: error,
            value: value
        },
        {
            resetError: resetError,
            saveValue: saveValue
        }
    ];
};

});
parcelRegister("a9yKi", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $c3b9111abe2b905b$export$828c4931ae562af7);

var $dq90x = parcelRequire("dq90x");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issuefieldvalue/manifest.ts
var $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $dq90x.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $dq90x.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $c3b9111abe2b905b$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("dq90x", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $969ccd5f0840c244$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $969ccd5f0840c244$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $969ccd5f0840c244$export$39e9358142fbbc64 = "jira", $969ccd5f0840c244$export$f9e57427271adc95 = "issuefieldvalue";

});



parcelRegister("b5xtc", function(module, exports) {

$parcel$export(module.exports, "AssociateFieldPopup", () => $a8b42db640d93b3a$export$bd4255b1f989bfbd);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $kQAZu = parcelRequire("kQAZu");

var $atJIB = parcelRequire("atJIB");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fM3rC = parcelRequire("fM3rC");
const $a8b42db640d93b3a$var$POPUP_OFFSET = [
    -8,
    8
];
const $a8b42db640d93b3a$export$bd4255b1f989bfbd = ({ isOpen: isOpen, issueType: issueType, issueTypeId: issueTypeId, fieldId: fieldId, fieldName: fieldName, onClose: onClose })=>{
    const project = (0, $kQAZu.useProject)();
    const { associate: associate } = (0, $atJIB.useAssociateField)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const canAssociateField = project.permissions.administerProject && project.isSimplified && issueType !== undefined && issueTypeId !== undefined;
    const popupTrigger = (0, $eUqFw.useCallback)(({ ref: ref, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-controls': ariaControls })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            ref: ref,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            "aria-controls": ariaControls,
            xcss: $a8b42db640d93b3a$var$triggerStyles,
            role: "button",
            "aria-label": formatMessage((0, $fM3rC.default).linkGoals)
        }), [
        formatMessage
    ]);
    const onAssociateField = (0, $eUqFw.useCallback)(()=>{
        associate({
            input: {
                projectId: String(project.id),
                fieldId: fieldId,
                issueTypeIds: [
                    Number(issueTypeId)
                ]
            },
            fieldName: fieldName,
            issueType: issueType,
            showSuccess: true,
            analyticsAttributes: {
                source: 'business-list.shared.fields.goals-cell'
            }
        });
        onClose();
    }, [
        associate,
        fieldId,
        fieldName,
        issueType,
        issueTypeId,
        onClose,
        project.id
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.100",
            xcss: $a8b42db640d93b3a$var$popupStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $fM3rC.default).associateGoalsFieldBody, {
            issueType: issueType,
            fieldName: fieldName,
            bold: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                    as: "strong"
                }, chunk)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, canAssociateField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onAssociateField,
            appearance: "link",
            spacing: "none"
        }, formatMessage((0, $fM3rC.default).updateFieldAssociationAction)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            href: "/secure/ContactAdministrators!default.jspa",
            target: "_blank",
            onClick: onClose,
            appearance: "link",
            spacing: "none"
        }, formatMessage((0, $fM3rC.default).contactAdmin))))), [
        canAssociateField,
        fieldName,
        formatMessage,
        issueType,
        onAssociateField,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        content: content,
        trigger: popupTrigger,
        offset: $a8b42db640d93b3a$var$POPUP_OFFSET,
        placement: "bottom-start",
        onClose: onClose
    });
};
const $a8b42db640d93b3a$var$popupStyles = (0, $1ZAYh.xcss)({
    width: '300px',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $a8b42db640d93b3a$var$triggerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '100%',
    width: '100%'
});

});
parcelRegister("atJIB", function(module, exports) {

$parcel$export(module.exports, "useAssociateField", () => $11384c76da356129$export$b4b274ed0d9c5388);

var $eUqFw = parcelRequire("eUqFw");

var $1Yimi = parcelRequire("1Yimi");

var $6F6Wi = parcelRequire("6F6Wi");

var $1TrzF = parcelRequire("1TrzF");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $132VC = parcelRequire("132VC");

var $iUDvK = parcelRequire("iUDvK");

var $7OOQG = parcelRequire("7OOQG");
const $11384c76da356129$export$c18a1e642576984f = (0, $eo17r.toFlagId)('associate-field-error-flag');
const $11384c76da356129$export$5122d1806ca6643c = (0, $eo17r.toFlagId)('associate-field-success-flag');
const $11384c76da356129$export$a2a68c9b88c306f0 = (0, $eo17r.toFlagId)('refetch-fields-error-flag');
const $11384c76da356129$export$b4b274ed0d9c5388 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { associate: associate, loading: loading, error: error } = (0, $132VC.useAssociateField)();
    const { refetchFields: refetchFields } = (0, $6F6Wi.useRefetchFields)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // the BE has a limitation where it cannot handle multiple associate calls in flight so we need a queue
    const [{ associateQueue: associateQueue }, { setAssociateQueue: setAssociateQueue, associate: associateStore, addToAssociateQueue: addToAssociateQueue }] = (0, $iUDvK.useAssociateFieldStore)();
    const associateField = (0, $eUqFw.useCallback)(({ input: input, fieldName: fieldName, issueType: issueType, showSuccess: showSuccess = false, analyticsAttributes: analyticsAttributes })=>new Promise((resolve, reject)=>{
            addToAssociateQueue({
                resolve: resolve,
                reject: reject,
                fieldProps: {
                    input: input,
                    fieldName: fieldName,
                    issueType: issueType,
                    showSuccess: showSuccess,
                    analyticsAttributes: analyticsAttributes
                }
            });
        }), [
        addToAssociateQueue
    ]);
    const associateNextInQueue = (0, $eUqFw.useCallback)(async ()=>{
        if (associateQueue.length === 0) return;
        const [{ resolve: resolve, reject: reject, fieldProps: { input: input, fieldName: fieldName, issueType: issueType, showSuccess: showSuccess, analyticsAttributes: analyticsAttributes = {} } }] = associateQueue;
        setAssociateQueue(associateQueue.splice(1)); // returns new array by keeping the first one only
        dismissFlag(`${$11384c76da356129$export$c18a1e642576984f}-${input.fieldId}`);
        dismissFlag(`${$11384c76da356129$export$a2a68c9b88c306f0}-${input.fieldId}`);
        const result = await associate({
            input: input
        });
        if (!result?.data?.jira?.jwmAssociateField?.success) {
            showFlag({
                id: `${$11384c76da356129$export$c18a1e642576984f}-${input.fieldId}`,
                type: 'error',
                title: formatMessage((0, $7OOQG.default).associateFieldErrorTitleV2, {
                    fieldName: fieldName
                }),
                description: (0, $7OOQG.default).associateFieldErrorMessageV2,
                actions: [
                    {
                        content: (0, $7OOQG.default).associateFieldTryAgainAction,
                        onClick: ()=>{
                            associateField({
                                input: input,
                                fieldName: fieldName,
                                issueType: issueType,
                                showSuccess: showSuccess,
                                analyticsAttributes: analyticsAttributes
                            });
                        }
                    }
                ]
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'associate failed', analyticsAttributes);
            reject(new Error('Associate field mutation did not succeed'));
            return;
        }
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'field associated', analyticsAttributes);
        if (showSuccess) showFlag({
            id: $11384c76da356129$export$5122d1806ca6643c,
            type: 'success',
            title: (0, $7OOQG.default).successTitle,
            description: [
                (0, $7OOQG.default).successDescription,
                {
                    fieldName: fieldName,
                    issueType: issueType,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                            as: "strong"
                        }, chunks)
                }
            ]
        });
        try {
            await refetchFields({
                shouldRetry: ([response])=>!(0, $1TrzF.isFieldInResponse)({
                        response: response,
                        fieldId: input.fieldId
                    })
            });
        } catch (e) {
            showFlag({
                id: `${$11384c76da356129$export$a2a68c9b88c306f0}-${input.fieldId}`,
                type: 'error',
                title: formatMessage((0, $7OOQG.default).refetchFieldsErrorTitle, {
                    fieldName: fieldName
                }),
                description: (0, $7OOQG.default).refetchFieldsErrorMessage
            });
            reject(e);
            return;
        }
        resolve(result);
    }, [
        associateQueue,
        setAssociateQueue,
        dismissFlag,
        associate,
        createAnalyticsEvent,
        showFlag,
        formatMessage,
        associateField,
        refetchFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (associateQueue.length > 0) associateStore(associateNextInQueue);
    }, [
        associateQueue,
        associateNextInQueue,
        associateStore
    ]);
    return {
        associate: associateField,
        loading: loading,
        error: error
    };
};

});
parcelRegister("1TrzF", function(module, exports) {

$parcel$export(module.exports, "isFieldInResponse", () => $3f712f92dfb75314$export$c323cb8dc752a295);
const $3f712f92dfb75314$export$c323cb8dc752a295 = ({ fieldId: fieldId, response: response })=>{
    const field = (response.data.jiraBusinessAvailableFields?.edges ?? []).find((issueTypeEdge)=>issueTypeEdge?.node?.fields?.edges?.find((fieldEdge)=>fieldEdge?.node?.fieldId === fieldId));
    return !!field;
};

});

parcelRegister("132VC", function(module, exports) {

$parcel$export(module.exports, "useAssociateField", () => $63e5d8bcf57ae6d0$export$b4b274ed0d9c5388);

var $iZuDo = parcelRequire("iZuDo");

var $kkYfO = parcelRequire("kkYfO");

var $4G5xU = parcelRequire("4G5xU");

var $guiFP = parcelRequire("guiFP");

var $eZo0a = parcelRequire("eZo0a");

var $fYtpD = parcelRequire("fYtpD");

var $6vFyR = parcelRequire("6vFyR");
const $63e5d8bcf57ae6d0$export$a93d8cd30a94ee3a = 'associateJwmFieldMutation';
const $63e5d8bcf57ae6d0$var$findMutationBadRequestError = (data)=>data?.jira?.jwmAssociateField?.errors?.find((e)=>e.message);
const $63e5d8bcf57ae6d0$export$b4b274ed0d9c5388 = ()=>{
    const onExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $fYtpD.ASSOCIATE_FIELD_EXPERIENCE));
    const onExperienceFail = (0, $4G5xU.useExperienceFail)((0, $fYtpD.ASSOCIATE_FIELD_EXPERIENCE));
    const onExperienceStart = (0, $4G5xU.useExperienceStart)((0, $fYtpD.ASSOCIATE_FIELD_EXPERIENCE));
    const [associateField, { loading: loading, error: error }] = (0, $iZuDo.useMutation)((0, $6vFyR.QUERY), {
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: $63e5d8bcf57ae6d0$export$a93d8cd30a94ee3a,
                    packageName: 'jiraBusinessInlineFieldConfigSidebar',
                    teamName: 'jira-warepil'
                },
                error: Array.isArray(apolloError) && apolloError.length > 0 ? apolloError[0] : apolloError,
                attributes: {
                    message: 'Failed to associate the field with issue types'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            onExperienceFail('Failed to associate the field with issue types', apolloError);
        },
        onCompleted: (apolloData)=>{
            const mutationBadRequestError = $63e5d8bcf57ae6d0$var$findMutationBadRequestError(apolloData);
            if (mutationBadRequestError) {
                const isClientError = (0, $eZo0a.isClientErrorResponse)(mutationBadRequestError.extensions?.statusCode);
                isClientError ? onExperienceSuccess() : onExperienceFail('Failed to associate the field with issue types', new (0, $kkYfO.MutationError)(mutationBadRequestError));
            } else onExperienceSuccess();
        }
    });
    const associate = ({ input: input })=>{
        onExperienceStart();
        return associateField({
            variables: {
                input: input
            }
        });
    };
    return {
        associate: associate,
        loading: loading,
        error: error
    };
};

});
parcelRegister("eZo0a", function(module, exports) {

$parcel$export(module.exports, "isClientErrorResponse", () => $172434d10a1c37f0$export$fa1f4b2a472e138c);
const $172434d10a1c37f0$export$fa1f4b2a472e138c = (statusCode)=>statusCode && statusCode >= 400 && statusCode < 500 || false;

});

parcelRegister("fYtpD", function(module, exports) {

$parcel$export(module.exports, "availableFieldTypes", () => $6d86bf388d162246$export$93dbaa9aec3844f0);
$parcel$export(module.exports, "CREATE_FIELD_EXPERIENCE", () => $6d86bf388d162246$export$9eae0a16f5941351);
$parcel$export(module.exports, "ASSOCIATE_FIELD_EXPERIENCE", () => $6d86bf388d162246$export$335bd3f229a4665a);
$parcel$export(module.exports, "DELETE_FIELD_EXPERIENCE", () => $6d86bf388d162246$export$d7cc90452cff4bb3);
$parcel$export(module.exports, "UPDATE_FIELD_EXPERIENCE", () => $6d86bf388d162246$export$64421f268399035e);
$parcel$export(module.exports, "GET_FIELDS_CONFIGURATION_EXPERIENCE", () => $6d86bf388d162246$export$88bd6cc0b5f8c349);
$parcel$export(module.exports, "GET_FIELD_DETAILS_EXPERIENCE", () => $6d86bf388d162246$export$e6582dde0a4e6af7);

var $lO4Or = parcelRequire("lO4Or");
const $6d86bf388d162246$var$defaultFieldOperations = {
    editable: true,
    canModifyRequired: true,
    canModifyOptions: true,
    canModifyDefaultValue: true,
    canModifyPropertyConfiguration: true,
    removable: true,
    categoriesWhitelist: [],
    canAssociateInSettings: true,
    deletable: true
};
const $6d86bf388d162246$var$operations = {
    ...$6d86bf388d162246$var$defaultFieldOperations,
    canModifyDefaultValue: false
};
const $6d86bf388d162246$export$93dbaa9aec3844f0 = [
    {
        key: (0, $lO4Or.TEXT_CF_TYPE),
        name: 'Short text',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.TEXT_AREA_CF_TYPE),
        name: 'Paragraph',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.DATETIME_CF_TYPE),
        name: 'Timestamp',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.SELECT_CF_TYPE),
        name: 'Dropdown',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.DATE_CF_TYPE),
        name: 'Date',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.NUMBER_CF_TYPE),
        name: 'Number',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.LABELS_CF_TYPE),
        name: 'Labels',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
        name: 'Checkbox',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.PEOPLE_CF_TYPE),
        name: 'People',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.URL_CF_TYPE),
        name: 'Url',
        operations: $6d86bf388d162246$var$operations
    }
];
const $6d86bf388d162246$export$b8b9d90f9e5bd72b = 'jiraBusinessInlineFieldConfigSidebar';
const $6d86bf388d162246$export$9eae0a16f5941351 = {
    experience: 'createField',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $6d86bf388d162246$export$335bd3f229a4665a = {
    experience: 'associateField',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $6d86bf388d162246$export$d7cc90452cff4bb3 = {
    experience: 'deleteField',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $6d86bf388d162246$export$64421f268399035e = {
    experience: 'updateField',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $6d86bf388d162246$export$88bd6cc0b5f8c349 = {
    experience: 'getFieldsConfiguration',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $6d86bf388d162246$export$e6582dde0a4e6af7 = {
    experience: 'getFieldDetails',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};

});

parcelRegister("6vFyR", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $f1a258ade8383bbf$export$2b91517d6d5b4365);

var $9ypom = parcelRequire("9ypom");
const $f1a258ade8383bbf$export$2b91517d6d5b4365 = (0, $9ypom.default)`
mutation JwmAssociateField ($input: JiraWorkManagementAssociateFieldInput!) {
  jira {
    jwmAssociateField (input: $input) {
      success
      errors {
        extensions {
          errorType
          statusCode
        }
        message
      }
      associatedIssueTypeIds
    }
  }
}
`;

});


parcelRegister("iUDvK", function(module, exports) {

$parcel$export(module.exports, "useAssociateFieldStore", () => $1ddfb19a3467aac9$export$877fa8e9cadf66c8);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $1ddfb19a3467aac9$var$actions = {
    addAssociatingField: (fieldId)=>({ setState: setState, getState: getState })=>{
            setState({
                associatingFields: [
                    ...getState().associatingFields,
                    fieldId
                ]
            });
        },
    removeAssociatingField: (fieldId)=>({ setState: setState, getState: getState })=>{
            setState({
                associatingFields: getState().associatingFields.filter((assocFieldId)=>fieldId !== assocFieldId)
            });
        },
    setAssociateQueue: (associateQueue)=>({ setState: setState })=>{
            setState({
                associateQueue: associateQueue
            });
        },
    addToAssociateQueue: (itemToAssociate)=>({ setState: setState, getState: getState })=>{
            setState({
                associateQueue: [
                    ...getState().associateQueue,
                    itemToAssociate
                ]
            });
        },
    setIsAssociating: (isAssociating)=>({ setState: setState })=>{
            setState({
                isAssociating: isAssociating
            });
        },
    associate: (associateFunction)=>async ({ setState: setState, getState: getState })=>{
            if (!getState().isAssociating) {
                setState({
                    isAssociating: true
                });
                try {
                    await associateFunction();
                } finally{
                    setState({
                        isAssociating: false
                    });
                }
            }
        }
};
const $1ddfb19a3467aac9$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        associatingFields: [],
        associateQueue: [],
        isAssociating: false
    },
    actions: $1ddfb19a3467aac9$var$actions,
    name: 'JwmFieldConfigAssociatingFields'
});
const $1ddfb19a3467aac9$export$877fa8e9cadf66c8 = (0, $1yZQx.createHook)($1ddfb19a3467aac9$var$Store);

});

parcelRegister("7OOQG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b599237b85b6d78$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9b599237b85b6d78$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    associateFieldErrorTitleV2: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-title-v-2",
        "defaultMessage": "Unable to connect {fieldName} to issue types in this project"
    },
    associateFieldErrorMessageV2: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-message-v-2",
        "defaultMessage": "Check your connection, then try again."
    },
    associateFieldTryAgainAction: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-try-again-action",
        "defaultMessage": "Try again"
    },
    refetchFieldsErrorTitle: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-title",
        "defaultMessage": "{fieldName} has been associated to issue types in the list view"
    },
    refetchFieldsErrorMessage: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-message",
        "defaultMessage": "Wait a few moments and try refreshing your page to see the change."
    },
    successTitle: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.success-title",
        "defaultMessage": "Field association updated!"
    },
    successDescription: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.success-description",
        "defaultMessage": "You can now use the <strong>{fieldName}</strong> field for your <strong>{issueType}</strong> issue type"
    }
});

});


parcelRegister("fM3rC", function(module, exports) {

$parcel$export(module.exports, "default", () => $118fa4dcea501cf8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $118fa4dcea501cf8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    associateGoalsFieldBody: {
        "id": "business-fields.goals.cell.associate-field-popup.associate-goals-field-body",
        "defaultMessage": "The <bold>{fieldName}</bold> field isn't associated with the <bold>{issueType}</bold> issue type."
    },
    contactAdmin: {
        "id": "business-fields.goals.cell.associate-field-popup.contact-admin",
        "defaultMessage": "Contact Admin"
    },
    updateFieldAssociationAction: {
        "id": "business-fields.goals.cell.associate-field-popup.update-field-association-action",
        "defaultMessage": "Update field association"
    },
    linkGoals: {
        "id": "business-fields.goals.cell.associate-field-popup.link-goals",
        "defaultMessage": "Link Goals"
    }
});

});


parcelRegister("3ylNm", function(module, exports) {

$parcel$export(module.exports, "useIsFieldAssociatedWithIssueType", () => $2931ed16cff628e3$export$cb0b144001cec81a);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");
const $2931ed16cff628e3$export$cb0b144001cec81a = ({ fieldId: fieldId, issueTypeId: issueTypeId })=>{
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const isFieldAssociated = (0, $eUqFw.useMemo)(()=>{
        if (issueTypeId === undefined) return false;
        const issueTypeFields = typesWithFields.find((type)=>type.issueType.id === issueTypeId)?.fields;
        return issueTypeFields?.some((issueTypeField)=>issueTypeField.id === fieldId) ?? false;
    }, [
        fieldId,
        issueTypeId,
        typesWithFields
    ]);
    return isFieldAssociated;
};

});


parcelRegister("gnGlI", function(module, exports) {

$parcel$export(module.exports, "groupCellHandler", () => $879c3fded9773908$export$b2844c90dc2ccc0f);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $k7Hy6 = parcelRequire("k7Hy6");

var $jhFiz = parcelRequire("jhFiz");
const $879c3fded9773908$export$2f128d21295c820 = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
    const [selectedGroups, setSelectedGroups] = (0, $eUqFw.useState)(field?.value ?? null);
    if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [{ value: fieldValue }] = (0, $gGiWF.useEditField)({
            fieldKey: field?.fieldId ?? '',
            issueKey: issue.key,
            fieldType: field?.type ?? '',
            initialValue: field?.value ?? null
        });
        if (!editMode && fieldValue !== selectedGroups) setSelectedGroups(fieldValue);
    }
    // Updated the value when a new updated is receive it
    (0, $eUqFw.useEffect)(()=>{
        setSelectedGroups(field?.value ?? null);
    }, [
        field?.value
    ]);
    const isEditable = (0, $eUqFw.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    const isMulti = (0, $eUqFw.useMemo)(()=>field?.type !== 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker', [
        field?.type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable,
        testId: "business-fields.ui.group.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k7Hy6.GroupEdit), {
        cellRef: cellRef,
        setEditMode: setEditMode,
        inputValue: inputValue,
        onInputChange: onInputChange,
        isMulti: isMulti,
        fieldName: field?.name || '',
        onChange: setSelectedGroups,
        preferredWidth: preferredWidth,
        selectedGroups: selectedGroups,
        fieldKey: field?.fieldId || '',
        issueKey: issue.key,
        fieldType: field?.type || '',
        initialValue: field?.value ?? null,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jhFiz.GroupRead), {
            isEditable: isEditable,
            selectedGroups: selectedGroups
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jhFiz.GroupRead), {
        isEditable: isEditable,
        selectedGroups: selectedGroups
    }));
};
const $879c3fded9773908$export$b2844c90dc2ccc0f = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: $879c3fded9773908$export$2f128d21295c820,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: $879c3fded9773908$export$2f128d21295c820
};

});
parcelRegister("k7Hy6", function(module, exports) {

$parcel$export(module.exports, "GroupEdit", () => $6535f341a418f83d$export$9036da6562372d3b);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $a6G0F = parcelRequire("a6G0F");
const $6535f341a418f83d$var$entryPointParams = {};
const $6535f341a418f83d$export$9036da6562372d3b = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $a6G0F.groupEditEntryPoint), $6535f341a418f83d$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.group.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("a6G0F", function(module, exports) {

$parcel$export(module.exports, "groupEditEntryPoint", () => $9c2e5bf66234ca52$export$20cce7641ad91969);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $9c2e5bf66234ca52$export$20cce7641ad91969 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("MFy40")), {
        moduleId: "fc335c35"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("MFy40", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("bq2Jx")
]).then(()=>parcelRequire('axN2v'));

});



parcelRegister("jhFiz", function(module, exports) {

$parcel$export(module.exports, "GroupRead", () => $e6b228423a375a7c$export$d8ab1fa8206677db);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");

var $4TezD = parcelRequire("4TezD");

var $3NqHp = parcelRequire("3NqHp");
const $e6b228423a375a7c$export$d8ab1fa8206677db = ({ selectedGroups: selectedGroups, isEditable: isEditable })=>{
    const group = (0, $eUqFw.useMemo)(()=>Array.isArray(selectedGroups) ? selectedGroups[0]?.name : selectedGroups?.name, [
        selectedGroups
    ]);
    const count = (0, $eUqFw.useMemo)(()=>Array.isArray(selectedGroups) ? selectedGroups.length - 1 : 0, [
        selectedGroups
    ]);
    if (group == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.WrapperCommon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NqHp.TagListWrapper), {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: group
    }), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: `+${count}`
    })));
};

});


parcelRegister("88U8t", function(module, exports) {

$parcel$export(module.exports, "parentCellHandler", () => $f2023e855c089ac9$export$342c67b3a001949f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $DX7su = parcelRequire("DX7su");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $4TezD = parcelRequire("4TezD");

var $fBoZM = parcelRequire("fBoZM");

var $kGTYI = parcelRequire("kGTYI");
const $f2023e855c089ac9$var$transformFieldToParent = (field)=>{
    if (field?.value?.summary == null || field?.value?.issueType == null || field?.value?.issueId == null || field?.value?.issueKey == null) return null;
    return {
        key: field?.value.issueKey,
        value: field?.value?.issueId,
        label: field?.value?.summary,
        fields: {
            summary: field?.value?.summary,
            issuetype: field?.value?.issueType
        },
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: field?.value?.color
    };
};
const $f2023e855c089ac9$export$d5a4cc78f8c5a2cd = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, onIssueUpdated: onIssueUpdated, cellRef: cellRef })=>{
    const [parent, setParent] = (0, $eUqFw.useState)($f2023e855c089ac9$var$transformFieldToParent(field));
    const [{ value: value }] = (0, $DX7su.useParentField)({
        issueKey: (0, $6vrw7.toIssueKey)(issue.key),
        fieldKey: field?.fieldId ?? '',
        issueId: issue.issueId
    });
    if (value && value !== parent && (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) setParent(value);
    // Updated the value when a new updated is receive it
    (0, $eUqFw.useEffect)(()=>{
        setParent($f2023e855c089ac9$var$transformFieldToParent(field));
    }, [
        field
    ]);
    const handleChange = (0, $eUqFw.useCallback)((newParent)=>{
        setParent((oldParent)=>{
            if (field != null) onIssueUpdated({
                fieldId: field.fieldId,
                fieldType: field.type,
                issueId: issue.issueId,
                newValue: newParent,
                oldValue: oldParent,
                issueKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? (0, $6vrw7.toIssueKey)(issue.key) : undefined
            });
            return newParent;
        });
        setEditMode(false);
    }, [
        field,
        issue.issueId,
        issue.key,
        onIssueUpdated,
        setEditMode
    ]);
    const handleFailure = (0, $eUqFw.useCallback)(()=>{
        setEditMode(false);
    }, [
        setEditMode
    ]);
    if (field == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: true
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fBoZM.ParentEdit), {
        parent: parent,
        cellRef: cellRef,
        fieldId: field.fieldId,
        issueKey: issue.key,
        issueId: issue.issueId,
        preferredWidth: preferredWidth,
        onChange: handleChange,
        onFailure: handleFailure,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGTYI.ParentRead), {
            parent: parent
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGTYI.ParentRead), {
        parent: parent
    }));
};
const $f2023e855c089ac9$export$342c67b3a001949f = {
    [(0, $lO4Or.PARENT_TYPE)]: $f2023e855c089ac9$export$d5a4cc78f8c5a2cd
};

});
parcelRegister("DX7su", function(module, exports) {

$parcel$export(module.exports, "useParentField", () => $7e16df0745dc2b53$export$23f8a245702eecc6);

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $7e16df0745dc2b53$export$984ebf992eeb92e6 = async (issueKey, fieldKey, newValue)=>(0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify({
            fields: {
                [fieldKey]: newValue && newValue.value ? {
                    id: newValue.value
                } : null
            }
        })
    });
const $7e16df0745dc2b53$export$aee311d2cd3543e6 = (response)=>{
    if (!response?.fields) return null;
    return response.fields.parent;
};
const $7e16df0745dc2b53$export$23f8a245702eecc6 = (props)=>{
    const { fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = null } = props;
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.custom ?? (0, $lO4Or.PARENT_TYPE);
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue, saveById: saveById }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        fieldType: fieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue,
        saveField: $7e16df0745dc2b53$export$984ebf992eeb92e6,
        mapNonOptimisticResponse: $7e16df0745dc2b53$export$aee311d2cd3543e6
    });
    const valueOption = value || null;
    return [
        {
            value: valueOption,
            fieldConfig: fieldConfig,
            error: error
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});
parcelRegister("8411R", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $7e02dfdf3441382d$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $7e02dfdf3441382d$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $7e02dfdf3441382d$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $7e02dfdf3441382d$export$28a22fd0dedf31b7);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $lRmyA = parcelRequire("lRmyA");

var $dwyR8 = parcelRequire("dwyR8");

var $kPvBW = parcelRequire("kPvBW");

var $3koWU = parcelRequire("3koWU");

var $6rkLV = parcelRequire("6rkLV");
const $7e02dfdf3441382d$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $7e02dfdf3441382d$var$fetchData = async (issueKey)=>{
    const response = await (0, $lRmyA.performPostRequest)((0, $dwyR8.getGraphQlUrl)('', (0, $kPvBW.IssueViewFetchOperations).FIELD_CONFIGURATION), {
        body: JSON.stringify({
            query: $7e02dfdf3441382d$export$9715ac6597e498fd(),
            variables: {
                issueKey: issueKey
            }
        })
    });
    if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
    (result, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [field.key]: {
                autoCompleteUrl: field.autoCompleteUrl,
                allowedValues: field.allowedValues,
                isEditable: field.editable,
                isRequired: field.required,
                schema: field.schema,
                title: field.title,
                ...field.description ? {
                    description: field.description
                } : {}
            }
        }), {});
    return null;
};
const $7e02dfdf3441382d$var$requestSet = new Set();
const $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $7e02dfdf3441382d$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $3koWU.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $6rkLV.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $eUqFw.useState)(()=>!skipRefresh && value === undefined && !$7e02dfdf3441382d$var$requestSet.has(issueKey));
    const getData = (0, $eUqFw.useCallback)(async ()=>{
        setLoading(true);
        $7e02dfdf3441382d$var$requestSet.add(issueKey);
        const result = await $7e02dfdf3441382d$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $7e02dfdf3441382d$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const shouldGetData = !skipRefresh && !$7e02dfdf3441382d$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $6rkLV.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $eUqFw.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $6rkLV.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $6rkLV.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $7e02dfdf3441382d$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $6rkLV.useFieldConfigStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("dwyR8", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $82ad8876acbb4446$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $82ad8876acbb4446$export$f2fec0cacdfabaaf);

var $k0k8C = parcelRequire("k0k8C");

var $aAj2A = parcelRequire("aAj2A");
const $82ad8876acbb4446$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $k0k8C.appendOperationQuery)(operation)}`;
const $82ad8876acbb4446$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $aAj2A.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("aAj2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f04a44c8c5fa855$export$2e2bcd8739ae039);
const $2f04a44c8c5fa855$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2f04a44c8c5fa855$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2f04a44c8c5fa855$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2f04a44c8c5fa855$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2f04a44c8c5fa855$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2f04a44c8c5fa855$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2f04a44c8c5fa855$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2f04a44c8c5fa855$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2f04a44c8c5fa855$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2f04a44c8c5fa855$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2f04a44c8c5fa855$var$getIsHybridAgilityProjectQuery()}
            ${$2f04a44c8c5fa855$var$getAgileQuery()}
        }
        ${$2f04a44c8c5fa855$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("kPvBW", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $b682c7d6e9f17978$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $b682c7d6e9f17978$export$b38f30d67f730bc4);
const $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $b682c7d6e9f17978$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $b682c7d6e9f17978$export$757f91ad408a28d4 = 'jira.user.issue.filter.hide-done-subtasks';
const $b682c7d6e9f17978$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("6rkLV", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $2581b610ec8db8fc$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $2581b610ec8db8fc$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $2581b610ec8db8fc$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $2581b610ec8db8fc$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $2581b610ec8db8fc$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $2581b610ec8db8fc$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $2581b610ec8db8fc$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $2581b610ec8db8fc$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $2581b610ec8db8fc$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $df4Sl = parcelRequire("df4Sl");

var $2vzCR = parcelRequire("2vzCR");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $2581b610ec8db8fc$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $2581b610ec8db8fc$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $2581b610ec8db8fc$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $2581b610ec8db8fc$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $2581b610ec8db8fc$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $2581b610ec8db8fc$var$actions = {
    setIssueConfig: $2581b610ec8db8fc$var$setIssueConfig,
    setIssuesConfig: $2581b610ec8db8fc$var$setIssuesConfig,
    mergeIssueConfig: $2581b610ec8db8fc$var$mergeIssueConfig,
    mergeIssuesConfig: $2581b610ec8db8fc$var$mergeIssuesConfig,
    setFieldConfigValue: $2581b610ec8db8fc$var$setFieldConfigValue
};
// this is a global state
const $2581b610ec8db8fc$var$store = (0, $kEDjj.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $2581b610ec8db8fc$var$actions
});
const $2581b610ec8db8fc$var$getIssueFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $2581b610ec8db8fc$export$52f51db4e2b3da57 = (0, $1yZQx.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$var$getFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $2581b610ec8db8fc$var$getFieldConfigWithLabel = (0, $df4Sl.createSelector)($2581b610ec8db8fc$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $2581b610ec8db8fc$var$getFieldOptionsOverrides = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $2581b610ec8db8fc$export$f9beb98c7488fd61 = (0, $1yZQx.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$314199caf05d245 = (0, $1yZQx.createHook)($2581b610ec8db8fc$var$store, {
    selector: null
});
const $2581b610ec8db8fc$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $2581b610ec8db8fc$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $2581b610ec8db8fc$var$overridesActions = {
    setFieldConfigOverridesValue: $2581b610ec8db8fc$var$setOverrides,
    resetOverridesStore: $2581b610ec8db8fc$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $2581b610ec8db8fc$var$overridesStore = (0, $kEDjj.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $2581b610ec8db8fc$var$overridesActions
});
const $2581b610ec8db8fc$export$ff357cf5a96ec0c6 = (0, $1yZQx.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$export$6e41e9c34587d557 = (0, $1yZQx.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$e704d739927bd1d6 = (0, $1yZQx.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfigWithLabel
});
const $2581b610ec8db8fc$export$d94ae842140da412 = (0, $1yZQx.createActionsHook)($2581b610ec8db8fc$var$overridesStore);
const $2581b610ec8db8fc$export$bfea9bb9bad7bc8f = (0, $1yZQx.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldOptionsOverrides
});
const $2581b610ec8db8fc$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $2581b610ec8db8fc$export$982ff1008c2e2780 = (0, $1yZQx.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIsFieldBusySelector
});

});



parcelRegister("fBoZM", function(module, exports) {

$parcel$export(module.exports, "ParentEdit", () => $76aa2c2c11e640b6$export$c7e5e7ddde2d8f0);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $lDaL7 = parcelRequire("lDaL7");
const $76aa2c2c11e640b6$var$entryPointParams = {};
const $76aa2c2c11e640b6$export$c7e5e7ddde2d8f0 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $lDaL7.parentEditEntryPoint), $76aa2c2c11e640b6$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.parent.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("lDaL7", function(module, exports) {

$parcel$export(module.exports, "parentEditEntryPoint", () => $3fd04fc0c2231ccd$export$1d2363001ed1e75d);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $3fd04fc0c2231ccd$export$1d2363001ed1e75d = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("2J1SO")), {
        moduleId: "9c7e10fe"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2J1SO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("eDTV5")
]).then(()=>parcelRequire('43A1W'));

});



parcelRegister("kGTYI", function(module, exports) {

$parcel$export(module.exports, "ParentRead", () => $219a374b3c6d1258$export$500e192e2d559470);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $e3dJ4 = parcelRequire("e3dJ4");

var $i0H65 = parcelRequire("i0H65");
const $219a374b3c6d1258$export$500e192e2d559470 = ({ parent: parent })=>{
    const { createOpenIssueModalHandler: createOpenIssueModalHandler } = (0, $e3dJ4.useIssueModalActions)();
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        if (parent == null || parent.key == null) return;
        return createOpenIssueModalHandler({
            key: parent.key
        })(e);
    }, [
        createOpenIssueModalHandler,
        parent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $219a374b3c6d1258$var$parentCellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0H65.ParentViewField), {
        value: parent,
        noValueText: "",
        isMobile: false,
        onClick: handleClick
    }));
};
const $219a374b3c6d1258$var$parentCellStyles = (0, $1ZAYh.xcss)({
    maxWidth: '100%'
});

});
parcelRegister("i0H65", function(module, exports) {

$parcel$export(module.exports, "ParentViewField", () => $ef6f97e64b612d5b$export$51036c707862fc9f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $3K8W2 = parcelRequire("3K8W2");

var $iSEc1 = parcelRequire("iSEc1");
const $ef6f97e64b612d5b$var$Summary = ({ isMobile: isMobile, onClick: onClick, label: label, lozengeTheme: lozengeTheme, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$WrapperNoClick, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: lozengeTheme
    }, label);
    if (onClick != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$ButtonText, {
        onClick: onClick,
        style: lozengeTheme
    }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$LinkText, {
        "data-testid": "issue-field-parent.ui.view-link",
        href: `/browse/${issueKey}`,
        "aria-label": formatMessage((0, $iSEc1.default).parentTitle, {
            label: label
        }),
        style: lozengeTheme
    }, label);
};
const $ef6f97e64b612d5b$var$ParentViewFieldNew = (props)=>{
    const { value: value, noValueText: noValueText, isMobile: isMobile, onClick: onClick } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (value) {
        const { key: key, fields: fields } = value;
        const label = `${key} ${fields.summary}`;
        const style = value.color ? (0, $3K8W2.getLozengeThemeByColor)(value.color) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: label,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Container, {
            "data-testid": "issue-field-parent.ui.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Icon, {
            src: fields.issuetype.iconUrl,
            alt: formatMessage((0, $iSEc1.default).icon, {
                issueType: fields?.issuetype.name || ''
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Summary, {
            isMobile: isMobile,
            label: label,
            lozengeTheme: style,
            onClick: onClick,
            issueKey: key
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$EmptyValue, {
        "data-testid": "issue-field-parent.ui.view-read-view-empty-value"
    }, noValueText);
};
const $ef6f97e64b612d5b$var$ParentViewFieldOld = (props)=>{
    const { value: value, noValueText: noValueText, isMobile: isMobile } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (value) {
        const { key: key, fields: fields } = value;
        const label = `${key} ${fields.summary}`;
        const style = value.color ? (0, $3K8W2.getLozengeThemeByColor)(value.color) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: label,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Container, {
            "data-testid": "issue-field-parent.ui.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Icon, {
            src: fields.issuetype.iconUrl,
            alt: formatMessage((0, $iSEc1.default).icon, {
                issueType: fields?.issuetype.name || ''
            })
        }), isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$WrapperNoClick // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        , {
            style: style
        }, label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$LinkText, {
            "data-testid": "issue-field-parent.ui.view-link",
            href: `/browse/${key}`,
            "aria-label": formatMessage((0, $iSEc1.default).parentTitle, {
                label: label
            }),
            style: style
        }, label)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$EmptyValue, {
        "data-testid": "issue-field-parent.ui.view-read-view-empty-value"
    }, noValueText);
};
const $ef6f97e64b612d5b$export$51036c707862fc9f = (props)=>{
    if ((0, $eI5EY.fg)('jira_-_list_-_add_onclick_handler_to_parentview')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$ParentViewFieldNew, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$ParentViewFieldOld, props);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6f97e64b612d5b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _o5721q9c _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ef6f97e64b612d5b$var$LinkText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _80omtlke _p12f1osq _2rko1sit _1yt4otz2 _11c81oud _2hwxu2gc _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ef6f97e64b612d5b$var$ButtonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _o5721q9c _80omtlke _4t3igktf _p12f1osq _2rko1sit _1yt4u49m _11c81oud _2hwxu2gc _19itglyw _11q7glyw _syaz1kw7 _12ji1r31 _1qu21kw7 _12y31o36 _vwz44jg8 _1bto1l2s _1e0c1ule _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6f97e64b612d5b$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx12x7 _p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ef6f97e64b612d5b$var$WrapperNoClick = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _1e0c1ule _4t3i7vkz _2rko1sit _1yt4u49m _11c81oud _p12f1osq _2hwxu2gc _vwz44jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6f97e64b612d5b$var$EmptyValue = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3K8W2", function(module, exports) {

$parcel$export(module.exports, "getOptionColorElem", () => $95b0c6b6b9af6b91$export$b00899e73680c477);
$parcel$export(module.exports, "mapDataToOptions", () => $95b0c6b6b9af6b91$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $95b0c6b6b9af6b91$export$fc800909123977f3);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $95b0c6b6b9af6b91$export$feb08457bf70a411);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $95b0c6b6b9af6b91$export$949dc67535a8ff2);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $1ybV0 = parcelRequire("1ybV0");

var $tgbCK = parcelRequire("tgbCK");
var $lPQPn = parcelRequire("lPQPn");
const $95b0c6b6b9af6b91$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, $tgbCK.MAP_COLORS_TO_VALUE)[color];
const $95b0c6b6b9af6b91$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95b0c6b6b9af6b91$var$ColorPatch, {
        color: color,
        "data-testid": `issue-field-parent.common.color-patch-${color}`
    });
const $95b0c6b6b9af6b91$export$99a866ffa3af7d8b = (issueParents)=>{
    const transformedResponse = (0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`,
            isDone: isDone
        })) : issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`
        }));
    return transformedResponse;
};
const $95b0c6b6b9af6b91$export$fc800909123977f3 = (option)=>({
        id: option.value
    });
const $95b0c6b6b9af6b91$export$9b822862d986dfdf = (0, $lPQPn.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $95b0c6b6b9af6b91$export$feb08457bf70a411 = (event)=>{
    if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
};
const $95b0c6b6b9af6b91$export$949dc67535a8ff2 = (color)=>$95b0c6b6b9af6b91$export$9b822862d986dfdf[color];
// We adjust the size of the color patch away from normal grid sizes because
// the issue type icon actually has a 1px border on each side, which is 2x1px on width/height
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95b0c6b6b9af6b91$var$ColorPatch = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1nzbko4": (0, $9t7rW.default)($95b0c6b6b9af6b91$export$bc913b9c9057634d(__cmplp.color))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbdlk8 _1ul9dlk8 _4t3idlk8 _2rko1y44 _bfhk1vzt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("tgbCK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3e0c3a8718e9d782$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3e0c3a8718e9d782$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3e0c3a8718e9d782$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3e0c3a8718e9d782$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3e0c3a8718e9d782$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3e0c3a8718e9d782$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3e0c3a8718e9d782$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3e0c3a8718e9d782$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3e0c3a8718e9d782$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3e0c3a8718e9d782$export$92b6aebfb522f0d9);

var $aXGkF = parcelRequire("aXGkF");


var $opsFH = parcelRequire("opsFH");
const $3e0c3a8718e9d782$export$c2357bec51c5cf5b = 'PURPLE';
const $3e0c3a8718e9d782$export$db33d74b098e3da9 = {
    [(0, $opsFH.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
    [(0, $opsFH.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
    [(0, $opsFH.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
    [(0, $opsFH.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
    [(0, $opsFH.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
    [(0, $opsFH.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
    [(0, $opsFH.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
    [(0, $opsFH.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
    [(0, $opsFH.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    [(0, $opsFH.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
    [(0, $opsFH.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
    [(0, $opsFH.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
    [(0, $opsFH.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
    [(0, $opsFH.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`
};
const $3e0c3a8718e9d782$export$fc5fe4213a5703f1 = {
    [(0, $73a5c9d720aa66e1$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
    [(0, $73a5c9d720aa66e1$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
    [(0, $73a5c9d720aa66e1$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
    [(0, $73a5c9d720aa66e1$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
    [(0, $73a5c9d720aa66e1$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
    [(0, $73a5c9d720aa66e1$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
    [(0, $73a5c9d720aa66e1$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
    [(0, $73a5c9d720aa66e1$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
    [(0, $73a5c9d720aa66e1$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    [(0, $73a5c9d720aa66e1$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
    [(0, $73a5c9d720aa66e1$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
    [(0, $73a5c9d720aa66e1$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
    [(0, $73a5c9d720aa66e1$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
    [(0, $73a5c9d720aa66e1$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`
};
const $3e0c3a8718e9d782$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$db33d74b098e3da9);
const $3e0c3a8718e9d782$export$43264b0781f10167 = {
    [(0, $opsFH.SERVER_PURPLE)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.SERVER_DARK_PURPLE)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.SERVER_BLUE)]: (0, $opsFH.BLUE),
    [(0, $opsFH.SERVER_DARK_BLUE)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.SERVER_GREEN)]: (0, $opsFH.GREEN),
    [(0, $opsFH.SERVER_DARK_GREEN)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.SERVER_TEAL)]: (0, $opsFH.TEAL),
    [(0, $opsFH.SERVER_DARK_TEAL)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.SERVER_YELLOW)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.SERVER_DARK_YELLOW)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.SERVER_ORANGE)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.SERVER_DARK_ORANGE)]: (0, $opsFH.DARK_ORANGE),
    [(0, $opsFH.SERVER_GREY)]: (0, $opsFH.GREY),
    [(0, $opsFH.SERVER_DARK_GREY)]: (0, $opsFH.DARK_GREY)
};
const $3e0c3a8718e9d782$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$43264b0781f10167);
const $3e0c3a8718e9d782$export$fb5d051fe1b2bccc = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
const $3e0c3a8718e9d782$export$994d3ffa39be04fd = {
    [(0, $opsFH.AGILE_COLOR_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.AGILE_COLOR_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.AGILE_COLOR_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.AGILE_COLOR_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.AGILE_COLOR_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.AGILE_COLOR_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.AGILE_COLOR_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.AGILE_COLOR_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.AGILE_COLOR_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.AGILE_COLOR_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.AGILE_COLOR_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.AGILE_COLOR_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.AGILE_COLOR_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.AGILE_COLOR_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$994d3ffa39be04fd);
const $3e0c3a8718e9d782$export$1fdd5a248b5f697c = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.AGILE_COLOR_1),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.AGILE_COLOR_2),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.AGILE_COLOR_3),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.AGILE_COLOR_4),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.AGILE_COLOR_5),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.AGILE_COLOR_6),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.AGILE_COLOR_7),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.AGILE_COLOR_8),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.AGILE_COLOR_9),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.AGILE_COLOR_10),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.AGILE_COLOR_11),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.AGILE_COLOR_12),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.AGILE_COLOR_13),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.AGILE_COLOR_14)
};
const $3e0c3a8718e9d782$export$82fc3b0b98905453 = {
    [(0, $opsFH.DARK_GREY)]: 'grey',
    [(0, $opsFH.DARK_YELLOW)]: 'yellow',
    [(0, $opsFH.YELLOW)]: 'yellowLight',
    [(0, $opsFH.DARK_BLUE)]: 'blue',
    [(0, $opsFH.DARK_TEAL)]: 'teal',
    [(0, $opsFH.GREEN)]: 'greenLight',
    [(0, $opsFH.PURPLE)]: 'purpleLight',
    [(0, $opsFH.DARK_PURPLE)]: 'purple',
    [(0, $opsFH.ORANGE)]: 'redLight',
    [(0, $opsFH.BLUE)]: 'blueLight',
    [(0, $opsFH.TEAL)]: 'tealLight',
    [(0, $opsFH.GREY)]: 'greyLight',
    [(0, $opsFH.DARK_GREEN)]: 'green',
    [(0, $opsFH.DARK_ORANGE)]: 'red'
};
const $3e0c3a8718e9d782$export$703aca53c431bb88 = {
    [(0, $opsFH.AGILE_COLOR_1)]: 'grey',
    [(0, $opsFH.AGILE_COLOR_2)]: 'yellow',
    [(0, $opsFH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $opsFH.AGILE_COLOR_4)]: 'blue',
    [(0, $opsFH.AGILE_COLOR_5)]: 'teal',
    [(0, $opsFH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $opsFH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $opsFH.AGILE_COLOR_8)]: 'purple',
    [(0, $opsFH.AGILE_COLOR_9)]: 'redLight',
    [(0, $opsFH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $opsFH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $opsFH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $opsFH.AGILE_COLOR_13)]: 'green',
    [(0, $opsFH.AGILE_COLOR_14)]: 'red'
};
const $3e0c3a8718e9d782$export$92b6aebfb522f0d9 = {
    [(0, $opsFH.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $73a5c9d720aa66e1$exports).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $73a5c9d720aa66e1$exports).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $73a5c9d720aa66e1$exports).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $73a5c9d720aa66e1$exports).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $73a5c9d720aa66e1$exports).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $73a5c9d720aa66e1$exports).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $73a5c9d720aa66e1$exports).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $73a5c9d720aa66e1$exports).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $73a5c9d720aa66e1$exports).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$exports).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$exports).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $73a5c9d720aa66e1$exports).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $73a5c9d720aa66e1$exports).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $73a5c9d720aa66e1$exports).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$exports).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$exports).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $73a5c9d720aa66e1$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N300})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});

parcelRegister("lPQPn", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $66f7283bb625ccc7$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $66f7283bb625ccc7$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $66f7283bb625ccc7$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $66f7283bb625ccc7$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $66f7283bb625ccc7$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $66f7283bb625ccc7$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $66f7283bb625ccc7$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $66f7283bb625ccc7$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $66f7283bb625ccc7$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $66f7283bb625ccc7$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $66f7283bb625ccc7$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $66f7283bb625ccc7$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $66f7283bb625ccc7$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $aXGkF = parcelRequire("aXGkF");

var $tgbCK = parcelRequire("tgbCK");

var $hNY9X = parcelRequire("hNY9X");

var $opsFH = parcelRequire("opsFH");
const $66f7283bb625ccc7$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $opsFH.Colors).PURPLE;
    if (color in (0, $opsFH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $opsFH.Colors).PURPLE;
};
const $66f7283bb625ccc7$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $opsFH.ServerColors).SERVER_PURPLE;
    if (color in (0, $opsFH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $opsFH.ServerColors).SERVER_PURPLE;
};
const $66f7283bb625ccc7$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $tgbCK.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $opsFH.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $66f7283bb625ccc7$export$a00423580059ae28 = (color)=>(0, $tgbCK.MAP_COLORS_TO_VALUE)[color] || (0, $tgbCK.MAP_COLORS_TO_VALUE)[0, $opsFH.PURPLE];
const $66f7283bb625ccc7$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $tgbCK.MAP_COLORS_TO_VALUE))[value] || (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$47af25386a01de1 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $66f7283bb625ccc7$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$28fb68bb1de025d5 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $66f7283bb625ccc7$var$paletteColorValues = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $66f7283bb625ccc7$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $hNY9X.default).purpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).blueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).tealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).yellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).orangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREY]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkPurpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkBlueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkTealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkYellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkOrangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREY]
        }
    ];
const $66f7283bb625ccc7$export$9b822862d986dfdf = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $66f7283bb625ccc7$export$949dc67535a8ff2 = (color = (0, $tgbCK.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $66f7283bb625ccc7$export$9b822862d986dfdf[color] ?? $66f7283bb625ccc7$export$9b822862d986dfdf[0, $tgbCK.DEFAULT_EPIC_COLOR];
const $66f7283bb625ccc7$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $opsFH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("hNY9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8f225d60e32dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7d8f225d60e32dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});



parcelRegister("iSEc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5298e5dcf31dbd81$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5298e5dcf31dbd81$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    parentTitle: {
        "id": "issue-field-parent.parent-title",
        "defaultMessage": "Click to visit {label}"
    },
    icon: {
        "id": "issue-field-parent.icon",
        "defaultMessage": "{issueType} icon"
    }
});

});




parcelRegister("87lYv", function(module, exports) {

$parcel$export(module.exports, "projectCellHandler", () => $d101ec26024855ff$export$ae050ab68eec4031);

var $eUqFw = parcelRequire("eUqFw");

var $hIoRx = parcelRequire("hIoRx");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $pzFOB = parcelRequire("pzFOB");

var $k4wfZ = parcelRequire("k4wfZ");
const $d101ec26024855ff$export$a0acc7707bde1d3 = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>{
    const [project, setProject] = (0, $eUqFw.useState)(field?.value);
    const [{ value: value }] = (0, $hIoRx.useProjectField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId || '',
        initialValue: field?.value
    });
    if (value !== project) setProject(value);
    if (field == null) return null;
    const readContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4wfZ.ProjectRead), {
        project: project
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: true,
        hasPadding: false,
        testId: "business-fields.ui.project.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $pzFOB.ProjectEdit), {
        issueKey: issue.key,
        fieldKey: field.fieldId,
        option: project,
        onChange: setProject,
        setEditMode: setEditMode,
        readContent: readContent,
        preferredWidth: preferredWidth,
        cellRef: cellRef
    }) : readContent);
};
const $d101ec26024855ff$export$ae050ab68eec4031 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $d101ec26024855ff$export$a0acc7707bde1d3
};

});
parcelRegister("hIoRx", function(module, exports) {

$parcel$export(module.exports, "useProjectField", () => $d2d345492fb3d8fc$export$85a22e7dcab3be80);

var $illlw = parcelRequire("illlw");

var $1ybV0 = parcelRequire("1ybV0");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $d2d345492fb3d8fc$export$85a22e7dcab3be80 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = null })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.PROJECT_PICKER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: (0, $1ybV0.ff)('jira.list.field-support-part1') ? initialValue : null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("pzFOB", function(module, exports) {

$parcel$export(module.exports, "ProjectEdit", () => $d9ab91d190552a91$export$847a1c7fcc9fac3d);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $eHEI8 = parcelRequire("eHEI8");
const $d9ab91d190552a91$export$847a1c7fcc9fac3d = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $eHEI8.projectEditEntryPoint), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.project.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("eHEI8", function(module, exports) {

$parcel$export(module.exports, "projectEditEntryPoint", () => $0948621a57ae1a07$export$a995c657f37f351f);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $0948621a57ae1a07$export$a995c657f37f351f = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("cUjCb")), {
        moduleId: "934d87d1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cUjCb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("1Mhz3")
]).then(()=>parcelRequire('02V79'));

});



parcelRegister("k4wfZ", function(module, exports) {

$parcel$export(module.exports, "ProjectRead", () => $397710b0ebf6b50a$export$c2b863d8638c3f33);

var $eUqFw = parcelRequire("eUqFw");

var $aA1aH = parcelRequire("aA1aH");
const $397710b0ebf6b50a$export$c2b863d8638c3f33 = ({ project: project })=>project ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aA1aH.ProjectReadView), {
        value: project
    }) : null;

});
parcelRegister("aA1aH", function(module, exports) {

$parcel$export(module.exports, "ProjectReadView", () => $26d520d2a340bb02$export$5c3359f22f4596bc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lB25E = parcelRequire("lB25E");
const $26d520d2a340bb02$export$5c3359f22f4596bc = ({ value: value, noValueText: noValueText, onClick: onClick })=>{
    const onClickLink = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        e.stopPropagation();
        onClick && onClick(e);
    }, [
        onClick
    ]);
    if (value === undefined || value === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $26d520d2a340bb02$var$emptyValueContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$EmptyValue, {
        "data-testid": "issue-field-project.ui.view-read-view-empty-value"
    }, noValueText || ''));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stopPropagation = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$ReadViewContainer, {
        "data-component-selector": "project-read-view-container"
    }, Boolean(value.avatarUrls['48x48']) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: "xsmall",
        src: value.avatarUrls['48x48'],
        borderColor: "transparent",
        testId: "issue-field-project.ui.project-avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$Label, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
        "data-testid": "issue-field-project.ui.view-label-link",
        onClick: onClickLink,
        onKeyPress: stopPropagation,
        href: `/projects/${value.key}`
    }, value.name)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26d520d2a340bb02$var$EmptyValue = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz",
            __cmplp.className
        ])
    });
});
const $26d520d2a340bb02$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _p12fuuw1 _1yt41b66",
            __cmplp.className
        ])
    });
});
const $26d520d2a340bb02$var$emptyValueContainerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.075'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26d520d2a340bb02$var$AvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $26d520d2a340bb02$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1ul9idpf _2hwxu2gc _1x211q9c _1rg815vq _1yoo15vq _1p6l1l2s _h5vp1o8l _i78x1osq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("6l2d2", function(module, exports) {

$parcel$export(module.exports, "radioSelectCellHandler", () => $d20d13aa2a67da56$export$cf09278854214c31);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $i0GKz = parcelRequire("i0GKz");

var $dLZA6 = parcelRequire("dLZA6");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4TezD = parcelRequire("4TezD");

var $dC6Z4 = parcelRequire("dC6Z4");

var $juJlc = parcelRequire("juJlc");

var $gZ9FQ = parcelRequire("gZ9FQ");
const $d20d13aa2a67da56$var$transformToOption = (option)=>{
    if (!option) return null;
    const { id: id, value: value } = option;
    return {
        value: id,
        label: value
    };
};
const $d20d13aa2a67da56$export$b6b4cb8dcfd6af64 = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleFailure = (0, $eUqFw.useCallback)((err)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'field updateFailed', 'radioSelectIssueField', {
            error: err
        });
    }, [
        createAnalyticsEvent
    ]);
    const [{ value: customFieldValue, options: radioOptions }, { saveValue: saveValue }] = (0, $i0GKz.useRadioSelectCustomField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId || '',
        initialValue: field?.value ?? null,
        onFailure: handleFailure
    });
    const option = $d20d13aa2a67da56$var$transformToOption(customFieldValue);
    const emptyOption = (0, $eUqFw.useMemo)(()=>({
            label: formatMessage((0, $juJlc.default).noValue),
            value: ''
        }), [
        formatMessage
    ]);
    /**
   * Options supplied to the RadioSelect component. An empty option may be present to allow
   * for deselection.
   */ const options = (0, $eUqFw.useMemo)(()=>{
        const result = (0, $dLZA6.mapDataToOptions)(radioOptions);
        // TODO: When we get around to supporting isRequired, we need to omit the emptyOption
        if (option) result.unshift(emptyOption);
        return result;
    }, [
        option,
        emptyOption,
        radioOptions
    ]);
    /**
   * Given the new selected option, save and move back to read only mode.
   */ const handleChange = (0, $eUqFw.useCallback)((newValue)=>{
        const newOption = newValue?.value ? newValue : null;
        const transformForSave = (0, $dLZA6.mapOptionToData)({
            value: newOption?.value ?? '',
            label: newOption?.label ?? ''
        });
        saveValue(transformForSave, null, createAnalyticsEvent({}));
        setEditMode(false);
    }, [
        saveValue,
        createAnalyticsEvent,
        setEditMode
    ]);
    const isEditable = (0, $eUqFw.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    if (field == null) return null;
    const placeholder = formatMessage((0, $juJlc.default).placeholder, {
        fieldName: field.name
    });
    const label = formatMessage((0, $juJlc.default).label, {
        fieldName: field.name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable,
        hasPadding: false,
        testId: "business-fields.ui.radio-select.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dC6Z4.RadioSelectEdit), {
        label: label,
        placeholder: placeholder,
        option: option,
        options: options,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gZ9FQ.RadioSelectRead), null, option?.label ?? ''),
        preferredWidth: preferredWidth,
        onChange: handleChange
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gZ9FQ.RadioSelectRead), null, option?.label ?? ''));
};
const $d20d13aa2a67da56$export$cf09278854214c31 = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $d20d13aa2a67da56$export$b6b4cb8dcfd6af64
};

});
parcelRegister("i0GKz", function(module, exports) {

$parcel$export(module.exports, "useRadioSelectCustomField", () => $7fd5a0cb283a0593$export$ef02e43cfb758362);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $7fd5a0cb283a0593$export$ef02e43cfb758362 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue = null, onFailure: onFailure, onSuccess: onSuccess })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'option');
    const options = fieldConfig.value?.allowedValues ?? [];
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError, saveById: saveById }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig,
            options: options
        },
        {
            saveValue: saveValue,
            resetError: resetError,
            saveById: saveById
        }
    ];
};

});

parcelRegister("dLZA6", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $3b1944adfca69728$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $3b1944adfca69728$export$fc800909123977f3);
const $3b1944adfca69728$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $3b1944adfca69728$export$fc800909123977f3 = ({ label: label, value: value })=>({
        id: value,
        value: label
    });

});

parcelRegister("dC6Z4", function(module, exports) {

$parcel$export(module.exports, "RadioSelectEdit", () => $a9d6bd5be8162ac8$export$7f25860f9e4ad119);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $4XkPy = parcelRequire("4XkPy");
const $a9d6bd5be8162ac8$var$entryPointParams = {};
const $a9d6bd5be8162ac8$export$7f25860f9e4ad119 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $4XkPy.radioSelectEntryPoint), $a9d6bd5be8162ac8$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.radio-select.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("4XkPy", function(module, exports) {

$parcel$export(module.exports, "radioSelectEntryPoint", () => $0af361e9fea841b6$export$ec67c8b087cb34f);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $0af361e9fea841b6$export$ec67c8b087cb34f = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("bLmhG")), {
        moduleId: "ff25c236"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bLmhG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("9aS9x")
]).then(()=>parcelRequire('aGFOE'));

});



parcelRegister("juJlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $746e22f582192f29$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $746e22f582192f29$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noValue: {
        "id": "business-fields.radio-select.cell.no-value",
        "defaultMessage": "None"
    },
    placeholder: {
        "id": "business-fields.radio-select.cell.placeholder",
        "defaultMessage": "Select { fieldName }"
    },
    label: {
        "id": "business-fields.radio-select.cell.label",
        "defaultMessage": "{ fieldName }"
    }
});

});

parcelRegister("gZ9FQ", function(module, exports) {

$parcel$export(module.exports, "RadioSelectRead", () => $515fc734764535af$export$51198f70a0069b1e);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4TezD = parcelRequire("4TezD");
const $515fc734764535af$export$51198f70a0069b1e = ({ children: children })=>{
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.WrapperCommon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $515fc734764535af$var$optionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $515fc734764535af$var$optionTextStyles
    }, children)));
};
const $515fc734764535af$var$optionWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    padding: 'space.075'
});
// TODO: replace with Text component from atlaskit when out of beta
const $515fc734764535af$var$optionTextStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});


parcelRegister("csWQF", function(module, exports) {

$parcel$export(module.exports, "resolutionCellHandler", () => $ab4d3fa78c9bbdbe$export$9762e1de55e8d420);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $9zfpT = parcelRequire("9zfpT");
const $ab4d3fa78c9bbdbe$export$8b67413bfec99fe = ({ cellData: field })=>{
    const [resolution, setResolution] = (0, $eUqFw.useState)(field?.value || null);
    (0, $eUqFw.useEffect)(()=>{
        setResolution(field?.value || null);
    }, [
        field?.value
    ]);
    if (field == null) return null;
    const readContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9zfpT.ResolutionRead), {
        resolution: resolution
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: false,
        hasPadding: true
    }, readContent);
};
const $ab4d3fa78c9bbdbe$export$9762e1de55e8d420 = {
    [(0, $lO4Or.RESOLUTION_TYPE)]: $ab4d3fa78c9bbdbe$export$8b67413bfec99fe
};

});
parcelRegister("9zfpT", function(module, exports) {

$parcel$export(module.exports, "ResolutionRead", () => $bc7dd289b58e6af9$export$8741d57e18b24f9f);

var $eUqFw = parcelRequire("eUqFw");

var $4cpwW = parcelRequire("4cpwW");
const $bc7dd289b58e6af9$export$8741d57e18b24f9f = ({ resolution: resolution })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cpwW.ResolutionReadView), {
        value: resolution,
        isLabelClickEnabled: true,
        hideIcon: true
    });

});
parcelRegister("4cpwW", function(module, exports) {

$parcel$export(module.exports, "ResolutionReadView", () => $2b3e9241a4bbe969$export$dfd4dfe034c38e3f);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $9nt1B = parcelRequire("9nt1B");


var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3iHmR = parcelRequire("3iHmR");
const $2b3e9241a4bbe969$export$dfd4dfe034c38e3f = ({ value: value, isLabelClickEnabled: isLabelClickEnabled, hideIcon: hideIcon = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const hasResolution = value;
    const resolutionName = value?.name || formatMessage((0, $3iHmR.default).unresolvedResolution);
    const icon = hasResolution && ((0, $1ybV0.ff)('jira.list.field-support-part1') ? !hideIcon : true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
        size: "medium",
        label: resolutionName,
        testId: "issue-field-resolution.ui.read.check-icon",
        primaryColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G400})`
    }) : null;
    const renderResolutionLabel = (labelName)=>{
        const resolutionStatusLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b3e9241a4bbe969$var$ResolutionStatusLabel, {
            "data-testid": "issue-field-resolution.ui.read.resolution-status-label",
            isDisabled: !isLabelClickEnabled,
            isDarkText: isLabelClickEnabled || !!hasResolution
        }, labelName);
        return !isLabelClickEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $3iHmR.default).readViewMessage),
            position: "top"
        }, resolutionStatusLabel) : resolutionStatusLabel;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b3e9241a4bbe969$var$Container, {
        addPadding: !isLabelClickEnabled,
        "data-testid": "issue-field-resolution.ui.read.label"
    }, icon, renderResolutionLabel(resolutionName));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b3e9241a4bbe969$var$Container = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-6kdpa7-0"
})(({ addPadding: addPadding })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        padding: addPadding ? `0 ${(0, $c9TLT.gridSize) * 2}px 0 12px` : 0,
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $c9TLT.gridSize) * 4}px`
    }));
const $2b3e9241a4bbe969$var$itemTruncateWidth = (0, $c9TLT.gridSize) * 25;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b3e9241a4bbe969$var$ResolutionStatusLabel = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-6kdpa7-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isDarkText ? `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})` : `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N90})`,
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${$2b3e9241a4bbe969$var$itemTruncateWidth}px`
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? ':hover { cursor: not-allowed; }' : '');

});
parcelRegister("9nt1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d3cc6c41555bcf7$var$_react = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6d3cc6c41555bcf7$var$_checkMark = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("j52dF")));
function $6d3cc6c41555bcf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6d3cc6c41555bcf7$var$CheckIcon = (props)=>/*#__PURE__*/ $6d3cc6c41555bcf7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $6d3cc6c41555bcf7$var$_checkMark.default
    }));
$6d3cc6c41555bcf7$var$CheckIcon.displayName = 'CheckIcon';
var $6d3cc6c41555bcf7$var$_default = module.exports.default = $6d3cc6c41555bcf7$var$CheckIcon;

});

parcelRegister("3iHmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4949ab11b370a82a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4949ab11b370a82a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    readViewMessage: {
        "id": "issue-field-resolution.read.read-view-message",
        "defaultMessage": "You cannot edit the resolution field"
    },
    unresolvedResolution: {
        "id": "issue-field-resolution.read.unresolved-resolution",
        "defaultMessage": "Unresolved"
    }
});

});




parcelRegister("edUxi", function(module, exports) {

$parcel$export(module.exports, "statusCategoryCellHandler", () => $721cfc681e9e68bc$export$1c03cc5b920eec85);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $7mdOo = parcelRequire("7mdOo");
const $721cfc681e9e68bc$export$8b895f86148e277 = ({ cellData: field })=>{
    const [statusCategory, setStatusCategory] = (0, $eUqFw.useState)(field?.value || null);
    (0, $eUqFw.useEffect)(()=>{
        setStatusCategory(field?.value || null);
    }, [
        field?.value
    ]);
    if (field == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: false
    }, statusCategory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mdOo.StatusCategoryRead), statusCategory));
};
const $721cfc681e9e68bc$export$1c03cc5b920eec85 = {
    [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: $721cfc681e9e68bc$export$8b895f86148e277
};

});
parcelRegister("7mdOo", function(module, exports) {

$parcel$export(module.exports, "StatusCategoryRead", () => $065e68873dd88149$export$3d1939a7f374f0ac);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $8Qd0L = parcelRequire("8Qd0L");
const $065e68873dd88149$var$appearanceMap = {
    [(0, $8Qd0L.UNDEFINED)]: 'default',
    [(0, $8Qd0L.TODO)]: 'default',
    [(0, $8Qd0L.DONE)]: 'success',
    [(0, $8Qd0L.IN_PROGRESS)]: 'inprogress'
};
const $065e68873dd88149$export$3d1939a7f374f0ac = ({ statusCategoryId: statusCategoryId, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "business-fields.ui.status-category.cell.read.lozenge",
        appearance: $065e68873dd88149$var$appearanceMap[(0, $8Qd0L.statusCategoryForId)(statusCategoryId)]
    }, name);

});


parcelRegister("bOyhU", function(module, exports) {

$parcel$export(module.exports, "teamCellHandler", () => $5d8668e6cb38a4b4$export$c23dfb5658df72ac);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $5JDtt = parcelRequire("5JDtt");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $4TezD = parcelRequire("4TezD");

var $29GZa = parcelRequire("29GZa");

var $jgB4A = parcelRequire("jgB4A");
const $5d8668e6cb38a4b4$export$2ea8e60ef5e5f6ad = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>{
    const [team, setTeam] = (0, $eUqFw.useState)(field?.value);
    const [{ value: value }] = (0, $5JDtt.useTeamField)({
        issueKey: (0, $6vrw7.toIssueKey)(issue.key),
        fieldKey: field?.fieldId ?? '',
        initialValue: team
    });
    if (value !== team && (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) setTeam(value);
    (0, $eUqFw.useEffect)(()=>{
        setTeam(field?.value);
    }, [
        field?.value
    ]);
    if (field == null) return null;
    const readContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jgB4A.TeamRead), {
        team: team
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: true,
        hasPadding: false,
        testId: "business-fields.ui.team.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29GZa.TeamEdit), {
        issueKey: issue.key,
        fieldKey: field.fieldId,
        team: team,
        onChange: setTeam,
        setEditMode: setEditMode,
        readContent: readContent,
        preferredWidth: preferredWidth,
        cellRef: cellRef
    }) : readContent);
};
const $5d8668e6cb38a4b4$export$c23dfb5658df72ac = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: $5d8668e6cb38a4b4$export$2ea8e60ef5e5f6ad
};

});
parcelRegister("5JDtt", function(module, exports) {

$parcel$export(module.exports, "useTeamField", () => $3373352d37138ba2$export$183b0f27978cd3a6);

var $illlw = parcelRequire("illlw");

var $eI5EY = parcelRequire("eI5EY");

var $fecbI = parcelRequire("fecbI");
var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $3373352d37138ba2$var$saveField = async (issueKey, fieldKey, newValue, baseUrl)=>{
    const newId = newValue?.id ?? null;
    return (0, $fecbI.defaultSaveField)(issueKey, fieldKey, newId, baseUrl);
};
const $3373352d37138ba2$export$183b0f27978cd3a6 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'array');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') ? initialValue || null : null,
        onSuccess: onSuccess,
        saveField: $3373352d37138ba2$var$saveField,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("29GZa", function(module, exports) {

$parcel$export(module.exports, "TeamEdit", () => $ebfbba123636b055$export$88197130b31e38af);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $3ChQh = parcelRequire("3ChQh");
const $ebfbba123636b055$export$88197130b31e38af = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $3ChQh.teamEditEntryPoint), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.team.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("3ChQh", function(module, exports) {

$parcel$export(module.exports, "teamEditEntryPoint", () => $35ae6402b069a192$export$9bcf1ad2d1e96b95);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $35ae6402b069a192$export$9bcf1ad2d1e96b95 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("25arI")), {
        moduleId: "e322dd82"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("25arI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("dybpk")
]).then(()=>parcelRequire('9HjnA'));

});



parcelRegister("jgB4A", function(module, exports) {

$parcel$export(module.exports, "TeamRead", () => $c8adc6d9ee1b8109$export$5f2e28c402b347f);

var $eUqFw = parcelRequire("eUqFw");

var $5R1rN = parcelRequire("5R1rN");
const $c8adc6d9ee1b8109$export$5f2e28c402b347f = ({ team: team })=>team ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5R1rN.TeamPickerView), {
        defaultValue: team,
        placeholder: "",
        isEditable: false
    }) : null;

});
parcelRegister("5R1rN", function(module, exports) {

$parcel$export(module.exports, "TeamPickerView", () => $02e77c5f09326d91$export$d284ae84f659e68c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $ldoFd = parcelRequire("ldoFd");

var $51sCz = parcelRequire("51sCz");

var $1Yimi = parcelRequire("1Yimi");


var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fFRi9 = parcelRequire("fFRi9");

var $iC4qb = parcelRequire("iC4qb");
const $02e77c5f09326d91$var$ErrorView = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $iC4qb.default).teamErrorViewTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Text_, {
        isDisabled: true,
        "data-testid": "issue-field-team.ui.view-error-value-text"
    }, formatMessage((0, $iC4qb.default).teamErrorViewText))));
};
const $02e77c5f09326d91$export$d284ae84f659e68c = (props)=>{
    const { defaultValue: defaultValue, isEditable: isEditable, placeholder: placeholder, noPaddingLeft: noPaddingLeft } = props;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(defaultValue)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$ReadViewContainerEmpty, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        testId: "issue-field-team.ui.view-empty-value-text",
        color: "color.text.subtlest"
    }, placeholder));
    if (defaultValue.isVisible === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$ErrorView, null);
    const team = defaultValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Wrapper, {
        isEditable: isEditable,
        noPaddingLeft: noPaddingLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fFRi9.default), {
        teamId: team.id,
        trigger: "hover-click",
        position: "left-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Text_, {
        "data-testid": "issue-field-team.ui.view-team-name"
    }, team.name))));
};
var $02e77c5f09326d91$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $02e77c5f09326d91$export$d284ae84f659e68c;
const $02e77c5f09326d91$var$ReadViewContainerEmptyControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18930yh-0"
})({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${(0, $lcnyw.fontSize)()}px`,
    maxWidth: '100%',
    padding: "var(--ds-space-075, 6px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $lcnyw.gridSize)() * 2}px`,
    alignItems: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $02e77c5f09326d91$var$ReadViewContainerEmptyExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _11c81oud _p12f1osq _1yt412x7 _1tke7vkz _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $02e77c5f09326d91$var$ReadViewContainerEmpty = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled-react-migration-issue-view_u9myz'), $02e77c5f09326d91$var$ReadViewContainerEmptyExperiment, $02e77c5f09326d91$var$ReadViewContainerEmptyControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $02e77c5f09326d91$var$TextControl = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-18930yh-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: (0, $lcnyw.gridSize)() * 2.5 / (0, $lcnyw.fontSize)(),
        textAlign: 'left',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        alignItems: 'center',
        display: 'flex',
        padding: `${"var(--ds-space-025, 2px)"} 0`
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles
const $02e77c5f09326d91$var$TextExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_bz06rf": (0, $9t7rW.default)(__cmplp.isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz48sxn _y3gn1e5h _syaz85nu _4cvr1h6o _1e0c1txw _1yt4x7n9",
            __cmplp.className
        ])
    });
});
const $02e77c5f09326d91$var$Text_ = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled-react-migration-issue-view_u9myz'), $02e77c5f09326d91$var$TextExperiment, $02e77c5f09326d91$var$TextControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $02e77c5f09326d91$var$WrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18930yh-2"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: props.isEditable ? 'pointer' : 'default',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingLeft: props.noPaddingLeft ? undefined : "var(--ds-space-075, 6px)",
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> a': {
            display: 'flex',
            alignItems: 'center'
        }
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $02e77c5f09326d91$var$WrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, noPaddingLeft: noPaddingLeft, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_167ft80": (0, $9t7rW.default)(__cmplp.isEditable ? 'pointer' : 'default'),
            "--_1qzp7z5": (0, $9t7rW.default)(__cmplp.noPaddingLeft ? undefined : "var(--ds-space-075, 6px)")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omm20a _19bv11d4 _1bsb1osq _1e0c1txw _4cvr1h6o _nbr41txw _dskl1h6o",
            __cmplp.className
        ])
    });
});
const $02e77c5f09326d91$var$Wrapper = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled-react-migration-issue-view_u9myz'), $02e77c5f09326d91$var$WrapperExperiment, $02e77c5f09326d91$var$WrapperControl);

});
parcelRegister("eWeL8", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $e0c5c7e39a960e0c$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $e0c5c7e39a960e0c$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $e0c5c7e39a960e0c$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});

parcelRegister("fFRi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d635822c142a4d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13d635822c142a4d$var$AsyncTeamProfileCardNext = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("imw7B")), {
    ssr: false,
    moduleId: "./src/packages/profilecard-next/src/ui/team-profilecard/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$13d635822c142a4d$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.profilecard-next.team-profilecard",
        packageName: "async.profilecard-next.team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-team-profilecard-next",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($13d635822c142a4d$var$AsyncTeamProfileCardNext, props)));

});
parcelRegister("imw7B", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cyrhR")
]).then(()=>parcelRequire('aBa6h'));

});


parcelRegister("iC4qb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0b2f105010cb38$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f0b2f105010cb38$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-team.error-title",
        "defaultMessage": "We couldn't set the team value"
    },
    errorMessage: {
        "id": "issue-field-team.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    teamErrorViewTooltip: {
        "id": "issue-field-team.team-error-view-tooltip",
        "defaultMessage": "This team may have been deleted, or you do not have access"
    },
    teamErrorViewText: {
        "id": "issue-field-team.team-error-view-text",
        "defaultMessage": "Not available"
    },
    placeholderTeamEditSelector: {
        "id": "issue-field-team.placeholder-team-edit-selector",
        "defaultMessage": "Choose a team"
    },
    defaultNoValueText: {
        "id": "issue-field-team.default-no-value-text",
        "defaultMessage": "None"
    },
    createTeamButtonText: {
        "id": "issue-field-team.create-team-button-text",
        "defaultMessage": "Create a team"
    },
    emptyStateDescription: {
        "id": "issue-field-team.empty-state-description",
        "defaultMessage": "Create a team to assign work across Jira and track it on your team\u2019s profile"
    },
    noOptionsMessage: {
        "id": "issue-field-team.no-options-message",
        "defaultMessage": "No options"
    }
});

});




parcelRegister("cWB05", function(module, exports) {

$parcel$export(module.exports, "versionCellHandler", () => $f3afddc8ffbc0289$export$fc6264270343b1df);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $2Lr9o = parcelRequire("2Lr9o");

var $aia5v = parcelRequire("aia5v");
const $f3afddc8ffbc0289$export$710c4688cbbfc14a = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
    const [selectedVersions, setSelectedVersions] = (0, $eUqFw.useState)(field?.value ?? null);
    if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [{ value: fieldValue }] = (0, $gGiWF.useEditField)({
            fieldKey: field?.fieldId ?? '',
            issueKey: issue.key,
            fieldType: field?.type ?? '',
            initialValue: field?.value ?? null
        });
        // Update the value when it is updated externally (e.g. when a new value is pasted)
        if (!editMode && fieldValue !== selectedVersions) setSelectedVersions(fieldValue);
    }
    // Update the value when it is updated in cache (e.g. via realtime)
    (0, $eUqFw.useEffect)(()=>{
        setSelectedVersions(field?.value ?? null);
    }, [
        field?.value
    ]);
    const isEditable = (0, $eUqFw.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    const isMulti = (0, $eUqFw.useMemo)(()=>field?.type !== 'com.atlassian.jira.plugin.system.customfieldtypes:version', [
        field?.type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable,
        testId: "business-fields.ui.version.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Lr9o.VersionEdit), {
        cellRef: cellRef,
        setEditMode: setEditMode,
        inputValue: inputValue,
        onInputChange: onInputChange,
        isMulti: isMulti,
        fieldName: field?.name || '',
        onChange: setSelectedVersions,
        preferredWidth: preferredWidth,
        selectedVersions: selectedVersions,
        fieldKey: field?.fieldId || '',
        issueKey: issue.key,
        fieldType: field?.type || '',
        initialValue: field?.value ?? null,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aia5v.VersionRead), {
            isEditable: isEditable,
            selectedVersions: selectedVersions
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aia5v.VersionRead), {
        isEditable: isEditable,
        selectedVersions: selectedVersions
    }));
};
const $f3afddc8ffbc0289$export$fc6264270343b1df = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $f3afddc8ffbc0289$export$710c4688cbbfc14a,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $f3afddc8ffbc0289$export$710c4688cbbfc14a,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $f3afddc8ffbc0289$export$710c4688cbbfc14a,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $f3afddc8ffbc0289$export$710c4688cbbfc14a
};

});
parcelRegister("2Lr9o", function(module, exports) {

$parcel$export(module.exports, "VersionEdit", () => $c59c9f8e4ef252b2$export$3c0e57d9b0204cdc);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $3aH4u = parcelRequire("3aH4u");
const $c59c9f8e4ef252b2$var$entryPointParams = {};
const $c59c9f8e4ef252b2$export$3c0e57d9b0204cdc = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $3aH4u.versionEditEntryPoint), $c59c9f8e4ef252b2$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.version.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("3aH4u", function(module, exports) {

$parcel$export(module.exports, "versionEditEntryPoint", () => $15edf8a8ef926059$export$e4a061611063756b);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $15edf8a8ef926059$export$e4a061611063756b = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("6IkAD")), {
        moduleId: "d7202e48"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6IkAD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("4HHsM")
]).then(()=>parcelRequire('aZKML'));

});



parcelRegister("aia5v", function(module, exports) {

$parcel$export(module.exports, "VersionRead", () => $cf4acba683678e4c$export$6cc418351c9e7765);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");

var $4TezD = parcelRequire("4TezD");

var $3NqHp = parcelRequire("3NqHp");
const $cf4acba683678e4c$export$6cc418351c9e7765 = ({ selectedVersions: selectedVersions, isEditable: isEditable })=>{
    const [version, count] = (0, $eUqFw.useMemo)(()=>{
        if (Array.isArray(selectedVersions)) {
            const [firstVersion, ...others] = selectedVersions ?? [];
            return [
                firstVersion?.name,
                others.length
            ];
        }
        if (selectedVersions != null) return [
            selectedVersions.name,
            0
        ];
        return [
            undefined,
            0
        ];
    }, [
        selectedVersions
    ]);
    if (version == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.WrapperCommon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NqHp.TagListWrapper), {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: version
    }), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: `+${count}`
    })));
};

});



parcelRegister("8safW", function(module, exports) {

$parcel$export(module.exports, "ColumnVisibilityProvider", () => $bfd64eb053ca9602$export$a60887dfea90a0d9);
$parcel$export(module.exports, "useColumnVisibilityUpdater", () => $bfd64eb053ca9602$export$ef90c8750ba3bb5);
$parcel$export(module.exports, "useIsColumnVisible", () => $bfd64eb053ca9602$export$3dbd1ecf42329eea);

var $eUqFw = parcelRequire("eUqFw");

var $90pMD = parcelRequire("90pMD");
const $bfd64eb053ca9602$var$VISIBILITY_OFFSET = 120;
const $bfd64eb053ca9602$var$getVisibleColumns = (scrollLeft, tableWidth, columns)=>{
    const windowLeft = scrollLeft - $bfd64eb053ca9602$var$VISIBILITY_OFFSET;
    const windowRight = scrollLeft + tableWidth + $bfd64eb053ca9602$var$VISIBILITY_OFFSET;
    const result = new Map();
    let currentOffset = 0;
    for (const column of columns){
        const columnLeft = currentOffset;
        const columnRight = columnLeft + column.width;
        const isVisible = columnRight >= windowLeft && columnLeft <= windowRight;
        result.set(column.key, isVisible);
        currentOffset = columnRight;
    }
    return result;
};
const $bfd64eb053ca9602$var$ColumnVisibilityUpdaterContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $bfd64eb053ca9602$var$ColumnVisibilityAccessorContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $bfd64eb053ca9602$export$a60887dfea90a0d9 = ({ children: children, columns: columns, width: width })=>{
    const [scrollPosition, setScrollPosition] = (0, $eUqFw.useState)({
        scrollLeft: 0
    });
    const visibleColumns = (0, $eUqFw.useMemo)(()=>$bfd64eb053ca9602$var$getVisibleColumns(scrollPosition.scrollLeft, width, columns), [
        columns,
        scrollPosition.scrollLeft,
        width
    ]);
    // Use a deeply memoized value to prevent triggering a re-render when the
    // values haven't actually changed
    const memoizedVisibileColumns = (0, $90pMD.useDeepMemo)(()=>visibleColumns, [
        visibleColumns
    ]);
    const getIsColumnVisible = (0, $eUqFw.useCallback)(({ key: key })=>// We should always have a value at this point, but we'll default to
        // true as a minor performance hit is better than missing content
        memoizedVisibileColumns.get(key) ?? true, [
        memoizedVisibileColumns
    ]);
    const columnVisibilityAccessor = (0, $eUqFw.useMemo)(()=>({
            getIsColumnVisible: getIsColumnVisible
        }), [
        getIsColumnVisible
    ]);
    const columnVisibilityUpdater = (0, $eUqFw.useMemo)(()=>({
            handleScroll: ({ scrollLeft: scrollLeft })=>setScrollPosition((prev)=>scrollLeft !== prev.scrollLeft ? {
                        scrollLeft: scrollLeft
                    } : prev)
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bfd64eb053ca9602$var$ColumnVisibilityUpdaterContext.Provider, {
        value: columnVisibilityUpdater
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bfd64eb053ca9602$var$ColumnVisibilityAccessorContext.Provider, {
        value: columnVisibilityAccessor
    }, children));
};
const $bfd64eb053ca9602$export$ef90c8750ba3bb5 = ()=>{
    const context = (0, $eUqFw.useContext)($bfd64eb053ca9602$var$ColumnVisibilityUpdaterContext);
    if (!context) throw new Error("'useColumnVisibilityUpdater' must be used inside a 'ColumnVisibilityProvider'");
    return context;
};
const $bfd64eb053ca9602$export$3dbd1ecf42329eea = (column)=>{
    const context = (0, $eUqFw.useContext)($bfd64eb053ca9602$var$ColumnVisibilityAccessorContext);
    if (!context) throw new Error("'useIsColumnVisible' must be used inside a 'ColumnVisibilityProvider'");
    return context.getIsColumnVisible(column);
};

});

parcelRegister("isXgL", function(module, exports) {

$parcel$export(module.exports, "WithCellSelection", () => $da08e5ced1cd14f6$export$3f3bc47e8aed32cb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $4TJj0 = parcelRequire("4TJj0");

var $aZGbv = parcelRequire("aZGbv");

var $i0nxo = parcelRequire("i0nxo");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $gbsaq = parcelRequire("gbsaq");

var $jxvjJ = parcelRequire("jxvjJ");

var $en1mL = parcelRequire("en1mL");
const $da08e5ced1cd14f6$export$3f3bc47e8aed32cb = /*#__PURE__*/ (0, $eUqFw.memo)(({ projectId: projectId, fieldId: fieldId, issueId: issueId, position: position, children: children, rowIndex: rowIndex, columnIndex: columnIndex, width: width, field: field, issue: issue, depth: depth = 0 })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ nodeSelection: nodeSelection }, { sendNodeSelected: sendNodeSelected, sendClearNodeSelection: sendClearNodeSelection }] = (0, $4TJj0.useCollabStore)();
    const nodeId = (0, $eUqFw.useMemo)(()=>(0, $i0nxo.getPresenceNodeId)({
            projectId: projectId,
            viewId: 'list',
            nodeId: `${fieldId}-${issueId}`
        }), [
        projectId,
        issueId,
        fieldId
    ]);
    const selections = nodeSelection[nodeId];
    const selection = selections && selections[0];
    const isIssueType = fieldId === (0, $lO4Or.ISSUE_TYPE);
    const onSendNodeSelected = (0, $eUqFw.useCallback)(()=>sendNodeSelected({
            nodeId: nodeId
        }), [
        sendNodeSelected,
        nodeId
    ]);
    const onSendClearNodeSelection = (0, $eUqFw.useCallback)(()=>sendClearNodeSelection({
            nodeId: nodeId
        }), [
        sendClearNodeSelection,
        nodeId
    ]);
    const renderedChildren = (0, $eUqFw.useMemo)(()=>children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxvjJ.CellNavigation), {
            columnIndex: columnIndex,
            rowIndex: rowIndex,
            field: field,
            issue: issue,
            fieldId: fieldId,
            onSendNodeSelected: onSendNodeSelected,
            onSendClearNodeSelection: onSendClearNodeSelection
        }, children()), [
        children,
        columnIndex,
        fieldId,
        onSendClearNodeSelection,
        onSendNodeSelected,
        rowIndex,
        field,
        issue
    ]);
    if (selection) {
        const hasMoreSelections = selections && selections.length > 1; // exclude first selection of the list
        const tooltipContent = hasMoreSelections ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, selections.map(({ user: user }, i)=>i !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                key: user.name
            }, user.name))) : null;
        const otherSelectionsContent = hasMoreSelections ? formatMessage((0, $en1mL.default).moreSelections, {
            count: selections.length - 1
        }) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da08e5ced1cd14f6$var$NodeWrapper, {
            isIssueType: isIssueType,
            width: width,
            depth: depth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZGbv.NodeSelectionWrapper), {
            color: selection.color
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: tooltipContent,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZGbv.ParticipantBadge), {
            color: selection.color,
            position: position
        }, selection.user.name, otherSelectionsContent)), renderedChildren));
    }
    return renderedChildren;
});
const $da08e5ced1cd14f6$var$nodeWrapperBaseStyles = null;
const $da08e5ced1cd14f6$var$NodeWrapper = ({ isIssueType: isIssueType, width: width, depth: depth, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...isIssueType && {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                paddingLeft: `${depth > 0 ? (0, $gbsaq.EXPAND_ICON_INDENT_WIDTH) * depth + 4 : 0}px`,
                boxSizing: 'border-box',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: `${width - (0, $gbsaq.LIST_PADDING_LEFT)}px`
            }
        },
        ...rest,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsb1kw7 _4t3i1ylp"
        ])
    }, children);

});
parcelRegister("4TJj0", function(module, exports) {

$parcel$export(module.exports, "useCollabStore", () => $8f55868fdda87f4e$export$4159ae80cfa2156);

var $lyOYo = parcelRequire("lyOYo");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $3BgyA = parcelRequire("3BgyA");

const $8f55868fdda87f4e$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            participants: state.participants.map((participant)=>{
                if (participant.clientId === user.userId) return {
                    ...participant,
                    avatar: user.avatar,
                    name: user.name,
                    email: user.email
                };
                return participant;
            })
        });
    };
const $8f55868fdda87f4e$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
        const uniqueJoined = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(joined, ({ sessionId: sessionId })=>sessionId);
        const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        const { provider: provider } = state;
        const newParticipants = [
            ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
            ...uniqueJoined
        ];
        // Collab team advised we should limit the number of max connections to control the load on collab service
        if (newParticipants.length >= (0, $daf44b44f86c0150$export$3debf01bbfa135e5) && provider) {
            // sort users by last active (last joined)
            const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
            const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
            const lastActiveUser = sortedUsers[sortedUsers.length - 1];
            // kick the last joined user out
            setState({
                ...state,
                participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
            });
            if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
            return;
        }
        setState({
            ...state,
            participants: newParticipants
        });
    };
const $8f55868fdda87f4e$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
        const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        // cleanup user selection when they leave the session
        const newSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                if (filteredSelections.length === 0) return;
                newSelection[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
            nodeSelection: newSelection
        });
    };
const $8f55868fdda87f4e$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
            ...getState(),
            provider: provider
        });
const $8f55868fdda87f4e$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                anchor: JSON.stringify({
                    nodeId: nodeId
                })
            }
        });
    };
const $8f55868fdda87f4e$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                head: JSON.stringify({
                    nodeId: nodeId,
                    dropParams: dropParams
                })
            }
        });
    };
const $8f55868fdda87f4e$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
        const { color: color } = (0, $3BgyA.getColorFromString)(sessionId);
        const newSelection = {
            nodeId: nodeId,
            user: user,
            color: color,
            sessionId: sessionId
        };
        const state = getState();
        const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
        const nodeSelection = dedupCurrentSelection ? [
            ...dedupCurrentSelection,
            newSelection
        ] : [
            newSelection
        ];
        // deduplicate selected nodes from this user, because each user can have only one selected node on the page
        // see JET-2794
        const dedupOtherSelections = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            // keep selections from all other users
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                if (filteredSelections.length === 0) return;
                dedupOtherSelections[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            nodeSelection: {
                ...dedupOtherSelections,
                [nodeId]: nodeSelection
            }
        });
    };
const $8f55868fdda87f4e$var$clearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams, userId: userId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newNodeSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
        });
        setState({
            ...state,
            nodeSelection: newNodeSelection,
            dragAnimation: dropParams && userId != null ? [
                ...state.dragAnimation,
                {
                    ...dropParams,
                    userId: userId
                }
            ] : state.dragAnimation
        });
    };
const $8f55868fdda87f4e$var$stopDragAnimation = ({ sourceNodeId: sourceNodeId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            dragAnimation: state.dragAnimation.filter((animation)=>String(animation.sourceNodeId) !== String(sourceNodeId))
        });
    };
const $8f55868fdda87f4e$var$actions = {
    setProvider: $8f55868fdda87f4e$var$setProvider,
    participantsLeft: $8f55868fdda87f4e$var$participantsLeft,
    participantsJoined: $8f55868fdda87f4e$var$participantsJoined,
    updateUserInParticipants: $8f55868fdda87f4e$var$updateUserInParticipants,
    sendNodeSelected: $8f55868fdda87f4e$var$sendNodeSelected,
    sendClearNodeSelection: $8f55868fdda87f4e$var$sendClearNodeSelection,
    setNodeSelection: $8f55868fdda87f4e$var$setNodeSelection,
    clearNodeSelection: $8f55868fdda87f4e$var$clearNodeSelection,
    stopDragAnimation: $8f55868fdda87f4e$var$stopDragAnimation
};
const $8f55868fdda87f4e$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        provider: null,
        participants: [],
        nodeSelection: {},
        dragAnimation: []
    },
    actions: $8f55868fdda87f4e$var$actions,
    name: 'JWMCollabStore'
});
const $8f55868fdda87f4e$export$4159ae80cfa2156 = (0, $1yZQx.createHook)($8f55868fdda87f4e$var$Store);

});
parcelRegister("3BgyA", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $9bfc0522bb35e6c9$export$137ec5185b12f5a2);

const $9bfc0522bb35e6c9$var$colors = [
    (0, $73a5c9d720aa66e1$exports).R300,
    (0, $73a5c9d720aa66e1$exports).R400,
    (0, $73a5c9d720aa66e1$exports).R500,
    (0, $73a5c9d720aa66e1$exports).Y300,
    (0, $73a5c9d720aa66e1$exports).Y400,
    (0, $73a5c9d720aa66e1$exports).Y500,
    (0, $73a5c9d720aa66e1$exports).G300,
    (0, $73a5c9d720aa66e1$exports).G400,
    (0, $73a5c9d720aa66e1$exports).G500,
    (0, $73a5c9d720aa66e1$exports).T300,
    (0, $73a5c9d720aa66e1$exports).T400,
    (0, $73a5c9d720aa66e1$exports).T500,
    (0, $73a5c9d720aa66e1$exports).P300,
    (0, $73a5c9d720aa66e1$exports).P400,
    (0, $73a5c9d720aa66e1$exports).P500,
    (0, $73a5c9d720aa66e1$exports).N200,
    (0, $73a5c9d720aa66e1$exports).N500,
    (0, $73a5c9d720aa66e1$exports).N800
];
const $9bfc0522bb35e6c9$export$137ec5185b12f5a2 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i += 1){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash &= hash;
    /* eslint-enable no-bitwise */ }
    const index = Math.abs(hash) % $9bfc0522bb35e6c9$var$colors.length;
    const hexColor = $9bfc0522bb35e6c9$var$colors[index];
    return {
        index: index,
        color: hexColor
    };
};

});

const $daf44b44f86c0150$export$3debf01bbfa135e5 = 80;


parcelRegister("aZGbv", function(module, exports) {

$parcel$export(module.exports, "NodeSelectionWrapper", () => $8521b6b2ec32c74c$export$f758a58bee5c7927);
$parcel$export(module.exports, "ParticipantBadge", () => $8521b6b2ec32c74c$export$91bc13dfc76fa8fa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

const $8521b6b2ec32c74c$var$BADGE_SIZE = 16;
// the badge text color will remain white regardless of the theme applied
const $8521b6b2ec32c74c$var$BADGE_TEXT_COLOR = 'white';
const $8521b6b2ec32c74c$export$f758a58bee5c7927 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_oor3vt": (0, $9t7rW.default)(`0 0 0 2px ${__cmplp.color} inset`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _16qs1zte _2rko1sit",
            __cmplp.className
        ])
    });
});
const $8521b6b2ec32c74c$export$91bc13dfc76fa8fa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _1bah1h6o _4cvr1h6o _1xi2idpf _1bsb1wug _4t3i7vkz _1pbykb7n _1yt4otz2 _11q71cj8 _vchhusvi _11c8qk37 _syazu67f",
            __cmplp.position === (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) ? "_154iidpf" : "_154id439",
            __cmplp.position === (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) ? "_2rko1pph" : "_2rko2hs0",
            __cmplp.className
        ])
    });
});

});

parcelRegister("i0nxo", function(module, exports) {

$parcel$export(module.exports, "getPresenceNodeId", () => $0ed5d5739c577dad$export$b31325f2ad6cf0b5);
const $0ed5d5739c577dad$export$b31325f2ad6cf0b5 = ({ projectId: projectId, viewId: viewId, nodeId: nodeId })=>`project:${projectId}:view/${viewId}/node/${nodeId}`;

});

parcelRegister("jxvjJ", function(module, exports) {

$parcel$export(module.exports, "CellNavigation", () => $66d68ca2d826b971$export$8511762758d83099);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $81BSq = parcelRequire("81BSq");

var $87KFZ = parcelRequire("87KFZ");

var $8UbeN = parcelRequire("8UbeN");

var $kGQen = parcelRequire("kGQen");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gbsaq = parcelRequire("gbsaq");

var $8NLkb = parcelRequire("8NLkb");

var $17QbA = parcelRequire("17QbA");

var $1eMsI = parcelRequire("1eMsI");

var $cOE3G = parcelRequire("cOE3G");
const $66d68ca2d826b971$var$isNonCharacterKey = (event)=>event.key.length > 1 || event.ctrlKey || event.metaKey;
const $66d68ca2d826b971$var$copiedFromStyles = null;
const $66d68ca2d826b971$export$8511762758d83099 = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, columnIndex: columnIndex, rowIndex: rowIndex, field: field, onSendNodeSelected: onSendNodeSelected, onSendClearNodeSelection: onSendClearNodeSelection, issue: issue, fieldId: fieldId })=>{
    const [{ isSelected: isSelected = false, isCopiedFrom: isCopiedFrom = false }, { setSelectedCell: setSelectedCell, clearSelectedCell: clearSelectedCell, clearCopiedFromCell: clearCopiedFromCell }] = (0, $8NLkb.useCellSelected)({
        column: columnIndex,
        row: rowIndex,
        issueId: issue?.issueId,
        fieldId: field?.id
    });
    const isSelectedRef = (0, $eUqFw.useRef)(isSelected);
    const prevIsSelected = (0, $hzcvF.usePreviousWithInitial)(isSelected);
    const horizontalNavigationRef = (0, $eUqFw.useRef)(false);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const cellRef = (0, $eUqFw.useRef)(null);
    const { navigate: navigate } = (0, $8NLkb.useCellActions)();
    const [{ tableRef: tableRef }] = (0, $1eMsI.useTableRefStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [editMode, setEditModeFn] = (0, $eUqFw.useState)(false);
    const [inputValue, setInputValue] = (0, $eUqFw.useState)();
    const [isHovering, setIsHovering] = (0, $eUqFw.useState)(false);
    // If double click to edit is enabled, cell is activated on first click and then go to edit mode on second.
    // Using ref instead of state to avoid a rerender as it was causing side effects inside dialogs
    const isCellActiveRef = (0, $eUqFw.useRef)(false);
    const editModeRef = (0, $eUqFw.useRef)(editMode);
    editModeRef.current = editMode;
    let formatRuleBackgroundColor = null;
    if ((0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation')) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issueFields = issue?.fields;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        formatRuleBackgroundColor = (0, $81BSq.useGetColorFormatRule)({
            formattingArea: 'CELL',
            fieldId: fieldId,
            issueId: String(issue?.issueId),
            issueFields: issueFields
        });
    }
    const isEditable = field?.fieldConfig?.isEditable ?? true;
    const isNewKeyboardNavField = field?.type && (0, $cOE3G.getNewNavSupportedFieldTypes)().has(field.type) && (0, $eI5EY.fg)('jira_list_keyboard_nav');
    const isDoubleClickToEditExperimentEnabled = (0, $79xbN.expValEquals)('list_view_1_click_to_select_2_to_edit', 'cohort', 'variation');
    const setEditMode = (0, $eUqFw.useCallback)((nextEditMode)=>{
        if (nextEditMode === editMode) return;
        if (!isNewKeyboardNavField || isEditable) setEditModeFn(nextEditMode);
    }, [
        editMode,
        isEditable,
        isNewKeyboardNavField
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // allow first render isSelected to call the fn
        if (isSelected === true && prevIsSelected === false) {
            onSendNodeSelected && onSendNodeSelected();
            horizontalNavigationRef.current = false;
        }
        if (isSelected === false && prevIsSelected === true) onSendClearNodeSelection && onSendClearNodeSelection(); // only clear if prev value is true
    }, [
        isSelected,
        onSendClearNodeSelection,
        onSendNodeSelected,
        prevIsSelected
    ]);
    (0, $eUqFw.useEffect)(()=>{
        isSelectedRef.current = isSelected;
        if (isSelected && wrapperRef.current) wrapperRef.current.focus();
    }, [
        isSelected
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (isSelectedRef.current) clearSelectedCell();
        }, [
        clearSelectedCell
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isNewKeyboardNavField) {
            if (isSelected === false && editMode) setEditMode(false);
        }
    }, [
        editMode,
        isSelected,
        isNewKeyboardNavField,
        setEditMode
    ]);
    const handleFocus = (0, $eUqFw.useCallback)(()=>{
        setSelectedCell(columnIndex, rowIndex);
    }, [
        columnIndex,
        rowIndex,
        setSelectedCell
    ]);
    const handleBlur = (0, $eUqFw.useCallback)((event)=>{
        if ((!isNewKeyboardNavField || event.relatedTarget) && !event.currentTarget?.contains(event.relatedTarget)) {
            isCellActiveRef.current = false;
            const stop = cellRef.current?.onBlur?.(event);
            if (stop) return;
            clearSelectedCell();
        }
    }, [
        clearSelectedCell,
        isNewKeyboardNavField
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)(// eslint-disable-next-line complexity
    (event)=>{
        if (isNewKeyboardNavField) {
            const stop = cellRef.current?.onKeyDown?.(event);
            if (stop) return;
        }
        const horizontalNavKeyPressed = (0, $cOE3G.VALID_HORIZONTAL_NAV_KEYS).has(event.key);
        const isTabPressed = event.key === (0, $cOE3G.KEY_TAB);
        const isValidKey = (0, $cOE3G.VALID_NAVIGATION_KEYS).has(event.key);
        if (event.shiftKey && !isTabPressed) return;
        if (!isValidKey) {
            if (isNewKeyboardNavField && !editMode && !$66d68ca2d826b971$var$isNonCharacterKey(event)) {
                setEditMode(true);
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'typeToEdit',
                    actionSubject: 'listNavigated'
                }), {
                    fieldType: field.type
                });
                setTimeout(()=>{
                    setInputValue(event.key);
                });
            }
            return;
        }
        const isScrolling = !!tableRef?.current?.table?.bodyRef?.state?.isScrolling;
        const navigationInProgress = isSelected && horizontalNavigationRef.current && horizontalNavKeyPressed;
        if (navigationInProgress || isScrolling) return;
        const fireNavigationAnalytics = ()=>{
            const EVENT_KEY = event.key === (0, $cOE3G.KEY_SPACE) ? 'Space' : event.key;
            const attributes = isNewKeyboardNavField && [
                'Enter',
                'Tab',
                'Escape',
                'Space'
            ].includes(EVENT_KEY) ? {
                isEditMode: editMode,
                fieldType: field.type
            } : {};
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: EVENT_KEY,
                actionSubject: 'listNavigated'
            }), attributes);
        };
        const handleNavigationEvent = (overrideDirection)=>{
            const direction = overrideDirection ?? (0, $cOE3G.NAV_KEYS_TO_DIRECTION)[event.key];
            if (horizontalNavKeyPressed) horizontalNavigationRef.current = true;
            navigate(direction, tableRef);
        };
        if (isNewKeyboardNavField && editMode) switch(event.key){
            case 0, $cOE3G.KEY_ENTER:
                setTimeout(()=>{
                    setEditMode(false);
                    wrapperRef?.current?.focus();
                    handleNavigationEvent((0, $gbsaq.DOWN));
                    fireNavigationAnalytics();
                }, 1);
                return;
            case 0, $cOE3G.KEY_ESCAPE:
                setTimeout(()=>{
                    setEditMode(false);
                    setInputValue(undefined);
                    wrapperRef?.current?.focus();
                });
                return;
            case 0, $cOE3G.KEY_TAB:
                setTimeout(()=>{
                    setEditMode(false);
                    wrapperRef?.current?.focus();
                    handleNavigationEvent(event.shiftKey ? (0, $gbsaq.LEFT) : (0, $gbsaq.RIGHT));
                    fireNavigationAnalytics();
                }, 1);
                return;
            case 0, $cOE3G.KEY_SPACE:
                // move selection down when pressing Space exits edit mode
                setTimeout(()=>{
                    if (!editModeRef.current) {
                        wrapperRef?.current?.focus();
                        handleNavigationEvent((0, $gbsaq.DOWN));
                        fireNavigationAnalytics();
                    }
                }, 1);
                return;
            case 0, $cOE3G.KEY_UP:
            case 0, $cOE3G.KEY_DOWN:
            case 0, $cOE3G.KEY_LEFT:
            case 0, $cOE3G.KEY_RIGHT:
                return;
            default:
        }
        const tableDataLength = tableRef?.current?.table?.props?.data?.length || 0;
        const totalColumns = tableRef?.current?.table?.props?.columns?.length || 0;
        const isFirstTableItem = columnIndex === 0 && rowIndex === 0;
        const isLastTableItem = columnIndex === totalColumns - 1 && rowIndex === tableDataLength - 1;
        const isDirectionLeft = event.key === (0, $cOE3G.KEY_LEFT) || isTabPressed && event.shiftKey;
        const isDirectionRight = event.key === (0, $cOE3G.KEY_RIGHT) || isTabPressed && !event.shiftKey;
        if (isFirstTableItem && isDirectionLeft || isLastTableItem && isDirectionRight) return;
        event.preventDefault();
        fireNavigationAnalytics();
        switch(event.key){
            case 0, $cOE3G.KEY_UP:
            case 0, $cOE3G.KEY_DOWN:
                handleNavigationEvent();
                break;
            case 0, $cOE3G.KEY_LEFT:
                if (columnIndex > 0) handleNavigationEvent();
                break;
            case 0, $cOE3G.KEY_RIGHT:
                if (columnIndex < totalColumns - 1) handleNavigationEvent();
                break;
            case 0, $cOE3G.KEY_TAB:
                handleNavigationEvent(event.shiftKey ? (0, $gbsaq.LEFT) : (0, $gbsaq.RIGHT));
                break;
            case 0, $cOE3G.KEY_ENTER:
                if (isDoubleClickToEditExperimentEnabled && !editMode) {
                    setEditMode(true);
                    break;
                }
                if (!isNewKeyboardNavField || !editMode) wrapperRef?.current?.click();
                break;
            case 0, $cOE3G.KEY_SPACE:
                if (isDoubleClickToEditExperimentEnabled && !editMode) {
                    setEditMode(true);
                    break;
                }
                if (!isNewKeyboardNavField || !editMode) wrapperRef?.current?.click();
                break;
            case 0, $cOE3G.KEY_ESCAPE:
                if (!isNewKeyboardNavField || !editMode) {
                    clearSelectedCell();
                    clearCopiedFromCell();
                    wrapperRef?.current?.blur();
                }
                break;
            default:
                break;
        }
    }, [
        isNewKeyboardNavField,
        tableRef,
        isSelected,
        editMode,
        columnIndex,
        rowIndex,
        setEditMode,
        createAnalyticsEvent,
        field?.type,
        navigate,
        isDoubleClickToEditExperimentEnabled,
        clearSelectedCell,
        clearCopiedFromCell
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if (isDoubleClickToEditExperimentEnabled) {
            if (!isSelected) wrapperRef?.current?.focus();
            if (!isCellActiveRef.current) {
                isCellActiveRef.current = true;
                return;
            }
        }
        if (isNewKeyboardNavField) {
            const stop = cellRef.current?.onClick?.(event);
            if (stop) return;
        }
        setEditMode(true);
    }, [
        isDoubleClickToEditExperimentEnabled,
        isNewKeyboardNavField,
        isSelected,
        setEditMode
    ]);
    const handleMouseEnter = (0, $eUqFw.useCallback)(()=>setIsHovering(true), [
        setIsHovering
    ]);
    const handleMouseLeave = (0, $eUqFw.useCallback)(()=>setIsHovering(false), [
        setIsHovering
    ]);
    const onInputChange = (0, $eUqFw.useCallback)((value)=>setInputValue(value), []);
    const getClone = ()=>{
        if (/*#__PURE__*/ (0, $eUqFw.isValidElement)(children)) {
            if (isNewKeyboardNavField) return /*#__PURE__*/ (0, $eUqFw.cloneElement)(children, {
                isSelected: isSelected,
                wrapperRef: wrapperRef,
                cellRef: cellRef,
                editMode: editMode,
                setEditMode: setEditMode,
                isHovering: isHovering,
                inputValue: inputValue,
                onInputChange: onInputChange
            });
            return /*#__PURE__*/ (0, $eUqFw.cloneElement)(children, {
                isSelected: isSelected,
                wrapperRef: wrapperRef,
                onFocus: handleFocus,
                onBlur: handleBlur,
                onKeyDown: handleKeyDown
            });
        }
        return children;
    };
    if (isNewKeyboardNavField) {
        const getCellContainer = (props = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UbeN.CellContainer), {
                ref: wrapperRef,
                isFocused: isSelected,
                tabIndex: 0,
                "data-testid": (0, $87KFZ.CELL_WRAPPER_TEST_ID),
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onClick: handleClick,
                formatRuleBackgroundColor: formatRuleBackgroundColor,
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: (0, $7JEyt.default)([
                    isCopiedFrom && (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') && "_kqswh2mm _cfu11ule _1cs8stnw _1kt9b3bt _1mp4mslj _kfgtmslj _14h82wlf _rfx3glpi _1rus18uv _dsq4glyw _1g0vidpf"
                ])
            }, getClone()), isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null));
        if (issue && field && (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $17QbA.ClipboardController), {
            issue: issue,
            field: field,
            fieldId: fieldId,
            isSelected: isSelected,
            isEditMode: editMode,
            onKeyDown: handleKeyDown
        }, getCellContainer());
        return getCellContainer({
            onKeyDown: handleKeyDown
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, getClone());
});

});
parcelRegister("81BSq", function(module, exports) {

$parcel$export(module.exports, "useGetColorFormatRule", () => $e7c5c882ea55dc26$export$7162d2241c1da066);

var $eUqFw = parcelRequire("eUqFw");

var $6yEM4 = parcelRequire("6yEM4");

var $784C5 = parcelRequire("784C5");
const $e7c5c882ea55dc26$export$7162d2241c1da066 = ({ formattingArea: formattingArea, fieldId: fieldId, issueId: issueId, issueFields: issueFields })=>{
    const [{ rowRules: rowRules, cellRulesByFieldId: cellRulesByFieldId, issueIdRowRuleMatched: issueIdRowRuleMatched }, { setMatchedRowRule: setMatchedRowRule }] = (0, $6yEM4.useFormatRulesStore)();
    const isCellArea = formattingArea === 'CELL';
    const formatRule = (0, $eUqFw.useMemo)(()=>{
        if (!issueFields || !issueId) return null;
        const rules = isCellArea && fieldId ? cellRulesByFieldId[fieldId] : rowRules;
        if (!rules?.length) return null;
        const rule = (0, $784C5.getColorFormatRules)({
            rules: rules,
            issueFields: issueFields
        });
        if (!rule) return null;
        if (isCellArea) {
            // If there is a row rule that is ranked before should not use the cell rule color
            const rowRule = issueIdRowRuleMatched[issueId];
            if (rowRule?.index != null && rowRule.index < rule.index) return null;
        }
        return rule;
    }, [
        cellRulesByFieldId,
        fieldId,
        isCellArea,
        issueFields,
        issueId,
        issueIdRowRuleMatched,
        rowRules
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isCellArea && formatRule && issueId) // we store the matched row rule for the issue
        setMatchedRowRule({
            rule: formatRule,
            issueId: issueId
        });
    }, [
        formatRule,
        isCellArea,
        issueId,
        setMatchedRowRule
    ]);
    return formatRule?.color || null;
};

});
parcelRegister("784C5", function(module, exports) {

$parcel$export(module.exports, "getColorFormatRules", () => $8c631176050e334a$export$251900d893745a4b);

var $jqvCZ = parcelRequire("jqvCZ");

var $9QDdk = parcelRequire("9QDdk");
const $8c631176050e334a$export$251900d893745a4b = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(({ rules: rules, issueFields: issueFields })=>{
    if (!issueFields || !rules) return null;
    const issueFieldsById = {};
    issueFields.forEach((field)=>{
        issueFieldsById[field.fieldId] = field;
    });
    for (const rule of rules){
        const { operator: operator, value: value, fieldId: fieldId } = rule;
        if (operator && fieldId) {
            const ruleField = issueFieldsById[fieldId];
            if ((0, $9QDdk.isFormatRuleEvaluationSupported)(ruleField?.type)) {
                const ruleResult = (0, $9QDdk.evaluateFormatRule)(ruleField?.type, {
                    field: ruleField,
                    operator: operator,
                    value: value
                });
                if (ruleResult) return rule;
            }
        }
    }
    return null;
}, (args)=>JSON.stringify(args));

});
parcelRegister("9QDdk", function(module, exports) {

$parcel$export(module.exports, "evaluateFormatRule", () => $7da4b58894ff5097$export$311cdf99cceaadec);
$parcel$export(module.exports, "isFormatRuleEvaluationSupported", () => $7da4b58894ff5097$export$e5e9880b1a0ddbe4);

var $5iWql = parcelRequire("5iWql");

var $54ckc = parcelRequire("54ckc");

var $QQDr5 = parcelRequire("QQDr5");

var $aiGFC = parcelRequire("aiGFC");

var $bxtFh = parcelRequire("bxtFh");

var $dyBqG = parcelRequire("dyBqG");

var $9Bmlv = parcelRequire("9Bmlv");

var $9lvK0 = parcelRequire("9lvK0");

var $d3LF1 = parcelRequire("d3LF1");

var $dDL0C = parcelRequire("dDL0C");

var $kvrlQ = parcelRequire("kvrlQ");

var $3KIMt = parcelRequire("3KIMt");

var $eW6me = parcelRequire("eW6me");

var $1WaBd = parcelRequire("1WaBd");

var $j0lze = parcelRequire("j0lze");

var $c5nZS = parcelRequire("c5nZS");
const $7da4b58894ff5097$export$1179b9c33b3930fd = (0, $5iWql.default)(()=>({
        ...(0, $eW6me.textEvaluateFormatRule),
        ...(0, $aiGFC.labelsEvaluateFormatRule),
        ...(0, $j0lze.userEvaluateFormatRule),
        ...(0, $QQDr5.dateEvaluateFormatRule),
        ...(0, $dyBqG.numberEvaluateFormatRule),
        ...(0, $9Bmlv.priorityEvaluateFormatRule),
        ...(0, $9lvK0.projectEvaluateFormatRule),
        ...(0, $kvrlQ.sprintEvaluateFormatRule),
        ...(0, $c5nZS.versionEvaluateFormatRule),
        ...(0, $1WaBd.typeEvaluateFormatRule),
        ...(0, $3KIMt.statusEvaluateFormatRule),
        ...(0, $dDL0C.singleSelectEvaluateFormatRule),
        ...(0, $bxtFh.multiSelectEvaluateFormatRule),
        ...(0, $d3LF1.radioEvaluateFormatRule),
        ...(0, $54ckc.componentsEvaluateFormatRule)
    }));
const $7da4b58894ff5097$export$311cdf99cceaadec = (fieldType, ...args)=>{
    const handlers = $7da4b58894ff5097$export$1179b9c33b3930fd();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $7da4b58894ff5097$export$e5e9880b1a0ddbe4 = (fieldType)=>{
    if (!fieldType) return false;
    const handlers = $7da4b58894ff5097$export$1179b9c33b3930fd();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType] != null;
};

});
parcelRegister("54ckc", function(module, exports) {

$parcel$export(module.exports, "componentsEvaluateFormatRule", () => $ed121f6a9ac8f278$export$e0e459c1e8cd74a0);

var $lO4Or = parcelRequire("lO4Or");
// TODO: update to use componentId once FLINGO-927 is done
const $ed121f6a9ac8f278$var$evaluateHandler = {
    CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.name)).length === value?.length),
    HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(field.value?.some((fieldValue)=>fieldValue && value?.includes(fieldValue.name))),
    DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.name)).length !== value?.length),
    IS_EMPTY: (field)=>!field.value || field.value?.length === 0,
    IS_NOT_EMPTY: (field)=>Boolean(field.value && field.value.length > 0)
};
const $ed121f6a9ac8f278$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $ed121f6a9ac8f278$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $ed121f6a9ac8f278$export$e0e459c1e8cd74a0 = {
    [(0, $lO4Or.COMPONENTS_TYPE)]: $ed121f6a9ac8f278$var$evaluateFormatRule
};

});

parcelRegister("QQDr5", function(module, exports) {

$parcel$export(module.exports, "dateEvaluateFormatRule", () => $96d1101cc64b540e$export$289deaf929c3babd);

var $eZGfb = parcelRequire("eZGfb");
var $9gp8y = parcelRequire("9gp8y");
var $kXCGy = parcelRequire("kXCGy");
var $dlGXX = parcelRequire("dlGXX");
var $58PtH = parcelRequire("58PtH");
var $dulT0 = parcelRequire("dulT0");
var $hX17M = parcelRequire("hX17M");
var $jh9tF = parcelRequire("jh9tF");
var $4BSpH = parcelRequire("4BSpH");
var $7ueqz = parcelRequire("7ueqz");
var $iHCx5 = parcelRequire("iHCx5");
var $2w5Tn = parcelRequire("2w5Tn");
var $2sFQI = parcelRequire("2sFQI");
var $62MIB = parcelRequire("62MIB");

var $lO4Or = parcelRequire("lO4Or");

var $gr01C = parcelRequire("gr01C");
const $96d1101cc64b540e$var$evaluateHandler = {
    IS: (field, value)=>{
        if (field.value && typeof value === 'string') switch(value){
            case (0, $gr01C.DATE_VALUE_OPERATORS).TODAY:
                return (0, $jh9tF.default)(new Date(field.value));
            case (0, $gr01C.DATE_VALUE_OPERATORS).TOMORROW:
                return (0, $4BSpH.default)(new Date(field.value));
            case (0, $gr01C.DATE_VALUE_OPERATORS).YESTERDAY:
                return (0, $iHCx5.default)(new Date(field.value));
            case (0, $gr01C.DATE_VALUE_OPERATORS).THIS_WEEK:
                return (0, $hX17M.default)(new Date(field.value));
            case (0, $gr01C.DATE_VALUE_OPERATORS).LAST_WEEK:
                return (0, $9gp8y.default)(new Date(field.value), new Date()) === -1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).NEXT_WEEK:
                return (0, $9gp8y.default)(new Date(field.value), new Date()) === 1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).THIS_QUARTER:
                return (0, $eZGfb.default)(new Date(field.value), new Date()) === 0;
            case (0, $gr01C.DATE_VALUE_OPERATORS).LAST_QUARTER:
                return (0, $eZGfb.default)(new Date(field.value), new Date()) === -1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).NEXT_QUARTER:
                return (0, $eZGfb.default)(new Date(field.value), new Date()) === 1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).THIS_YEAR:
                return (0, $kXCGy.default)(new Date(field.value), new Date()) === 0;
            case (0, $gr01C.DATE_VALUE_OPERATORS).LAST_YEAR:
                return (0, $kXCGy.default)(new Date(field.value), new Date()) === -1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).NEXT_YEAR:
                return (0, $kXCGy.default)(new Date(field.value), new Date()) === 1;
            default:
                {
                    const dateValue = new Date(value);
                    if ((0, $7ueqz.default)(dateValue)) return (0, $dulT0.default)(dateValue, new Date(field.value));
                    return false;
                }
        }
        return false;
    },
    IS_AFTER: (field, value)=>{
        if (field.value && typeof value === 'string') switch(value){
            case (0, $gr01C.DATE_VALUE_OPERATORS).TODAY:
                return (0, $dlGXX.default)(new Date(field.value), (0, $2w5Tn.default)());
            case (0, $gr01C.DATE_VALUE_OPERATORS).TOMORROW:
                return (0, $dlGXX.default)(new Date(field.value), (0, $2sFQI.default)());
            case (0, $gr01C.DATE_VALUE_OPERATORS).YESTERDAY:
                return (0, $dlGXX.default)(new Date(field.value), (0, $62MIB.default)());
            case (0, $gr01C.DATE_VALUE_OPERATORS).THIS_WEEK:
                return (0, $9gp8y.default)(new Date(field.value), new Date()) > 0;
            case (0, $gr01C.DATE_VALUE_OPERATORS).LAST_WEEK:
                return (0, $9gp8y.default)(new Date(field.value), new Date()) >= 0;
            case (0, $gr01C.DATE_VALUE_OPERATORS).NEXT_WEEK:
                return (0, $9gp8y.default)(new Date(field.value), new Date()) > 1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).THIS_QUARTER:
                return (0, $eZGfb.default)(new Date(field.value), new Date()) > 0;
            case (0, $gr01C.DATE_VALUE_OPERATORS).LAST_QUARTER:
                return (0, $eZGfb.default)(new Date(field.value), new Date()) >= 0;
            case (0, $gr01C.DATE_VALUE_OPERATORS).NEXT_QUARTER:
                return (0, $eZGfb.default)(new Date(field.value), new Date()) > 1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).THIS_YEAR:
                return (0, $kXCGy.default)(new Date(field.value), new Date()) > 0;
            case (0, $gr01C.DATE_VALUE_OPERATORS).LAST_YEAR:
                return (0, $kXCGy.default)(new Date(field.value), new Date()) >= 0;
            case (0, $gr01C.DATE_VALUE_OPERATORS).NEXT_YEAR:
                return (0, $kXCGy.default)(new Date(field.value), new Date()) > 1;
            default:
                {
                    const dateValue = new Date(value);
                    if ((0, $7ueqz.default)(dateValue)) return (0, $dlGXX.default)(dateValue, new Date(field.value));
                    return false;
                }
        }
        return false;
    },
    IS_BEFORE: (field, value)=>{
        if (field.value && typeof value === 'string') switch(value){
            case (0, $gr01C.DATE_VALUE_OPERATORS).TODAY:
                return (0, $58PtH.default)(new Date(field.value), (0, $2w5Tn.default)());
            case (0, $gr01C.DATE_VALUE_OPERATORS).TOMORROW:
                return (0, $58PtH.default)(new Date(field.value), (0, $2sFQI.default)());
            case (0, $gr01C.DATE_VALUE_OPERATORS).YESTERDAY:
                return (0, $58PtH.default)(new Date(field.value), (0, $62MIB.default)());
            case (0, $gr01C.DATE_VALUE_OPERATORS).THIS_WEEK:
                return (0, $9gp8y.default)(new Date(field.value), new Date()) < 0;
            case (0, $gr01C.DATE_VALUE_OPERATORS).LAST_WEEK:
                return (0, $9gp8y.default)(new Date(field.value), new Date()) < -1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).NEXT_WEEK:
                return (0, $9gp8y.default)(new Date(field.value), new Date()) < 1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).THIS_QUARTER:
                return (0, $eZGfb.default)(new Date(field.value), new Date()) < 0;
            case (0, $gr01C.DATE_VALUE_OPERATORS).LAST_QUARTER:
                return (0, $eZGfb.default)(new Date(field.value), new Date()) < -1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).NEXT_QUARTER:
                return (0, $eZGfb.default)(new Date(field.value), new Date()) < 1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).THIS_YEAR:
                return (0, $kXCGy.default)(new Date(field.value), new Date()) < 0;
            case (0, $gr01C.DATE_VALUE_OPERATORS).LAST_YEAR:
                return (0, $kXCGy.default)(new Date(field.value), new Date()) < -1;
            case (0, $gr01C.DATE_VALUE_OPERATORS).NEXT_YEAR:
                return (0, $kXCGy.default)(new Date(field.value), new Date()) < 1;
            default:
                {
                    const dateValue = new Date(value);
                    if ((0, $7ueqz.default)(dateValue)) return (0, $58PtH.default)(dateValue, new Date(field.value));
                    return false;
                }
        }
        return false;
    },
    IS_NOT: (field, value)=>!$96d1101cc64b540e$var$evaluateHandler.IS?.(field, value),
    IS_ON_OR_AFTER: (field, value)=>Boolean($96d1101cc64b540e$var$evaluateHandler.IS?.(field, value) || $96d1101cc64b540e$var$evaluateHandler.IS_AFTER?.(field, value)),
    IS_ON_OR_BEFORE: (field, value)=>Boolean($96d1101cc64b540e$var$evaluateHandler.IS?.(field, value) || $96d1101cc64b540e$var$evaluateHandler.IS_BEFORE?.(field, value)),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $96d1101cc64b540e$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $96d1101cc64b540e$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $96d1101cc64b540e$export$289deaf929c3babd = {
    [(0, $lO4Or.START_DATE_TYPE)]: $96d1101cc64b540e$var$evaluateFormatRule,
    [(0, $lO4Or.UPDATED)]: $96d1101cc64b540e$var$evaluateFormatRule,
    [(0, $lO4Or.CREATED)]: $96d1101cc64b540e$var$evaluateFormatRule,
    [(0, $lO4Or.DUE_DATE_TYPE)]: $96d1101cc64b540e$var$evaluateFormatRule,
    [(0, $lO4Or.DATE_CF_TYPE)]: $96d1101cc64b540e$var$evaluateFormatRule
};

});

parcelRegister("aiGFC", function(module, exports) {

$parcel$export(module.exports, "labelsEvaluateFormatRule", () => $b06c65df18651140$export$44959830567aabae);

var $lO4Or = parcelRequire("lO4Or");
const $b06c65df18651140$var$evaluateHandler = {
    CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue)).length === value?.length),
    HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(field.value?.some((fieldValue)=>fieldValue && value?.includes(fieldValue))),
    DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue)).length !== value?.length),
    IS_EMPTY: (field)=>field.value?.length === 0,
    IS_NOT_EMPTY: (field)=>field.value?.length > 0
};
const $b06c65df18651140$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $b06c65df18651140$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $b06c65df18651140$export$44959830567aabae = {
    [(0, $lO4Or.LABELS_TYPE)]: $b06c65df18651140$var$evaluateFormatRule,
    [(0, $lO4Or.LABELS_CF_TYPE)]: $b06c65df18651140$var$evaluateFormatRule
};

});

parcelRegister("bxtFh", function(module, exports) {

$parcel$export(module.exports, "multiSelectEvaluateFormatRule", () => $918f153f30ba1983$export$52c36143869699f1);

var $lO4Or = parcelRequire("lO4Or");
// TODO: update to compare by optionId once FLINGO-940 is done
const $918f153f30ba1983$var$evaluateHandler = {
    CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.value)).length === value?.length),
    HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(field.value?.some((fieldValue)=>fieldValue && value?.includes(fieldValue.value))),
    DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.value)).length !== value?.length),
    IS_EMPTY: (field)=>!field.value || field.value?.length === 0,
    IS_NOT_EMPTY: (field)=>Boolean(field.value && field.value.length > 0)
};
const $918f153f30ba1983$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $918f153f30ba1983$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $918f153f30ba1983$export$52c36143869699f1 = {
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: $918f153f30ba1983$var$evaluateFormatRule
};

});

parcelRegister("dyBqG", function(module, exports) {

$parcel$export(module.exports, "numberEvaluateFormatRule", () => $53c81db82a996e46$export$8b123092055dd2da);

var $lO4Or = parcelRequire("lO4Or");
const $53c81db82a996e46$var$evaluateHandler = {
    EQUALS: (field, value)=>Boolean(field.value && field.value === Number(value)),
    DOES_NOT_EQUAL: (field, value)=>Boolean(field.value && field.value !== Number(value)),
    GREATER_THAN: (field, value)=>Boolean(field.value && field.value > Number(value)),
    GREATER_THAN_OR_EQUALS: (field, value)=>Boolean(field.value && field.value >= Number(value)),
    LESS_THAN: (field, value)=>Boolean(field.value && field.value < Number(value)),
    LESS_THAN_OR_EQUALS: (field, value)=>Boolean(field.value && field.value <= Number(value)),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $53c81db82a996e46$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $53c81db82a996e46$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $53c81db82a996e46$export$8b123092055dd2da = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: $53c81db82a996e46$var$evaluateFormatRule,
    [(0, $lO4Or.STORY_POINTS_TYPE)]: $53c81db82a996e46$var$evaluateFormatRule,
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: $53c81db82a996e46$var$evaluateFormatRule
};

});

parcelRegister("9Bmlv", function(module, exports) {

$parcel$export(module.exports, "priorityEvaluateFormatRule", () => $dc3284b4c35d3e1f$export$8d97b18a0e2778ac);

var $lO4Or = parcelRequire("lO4Or");
const $dc3284b4c35d3e1f$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value?.priorityId === value),
    IS_NOT: (field, value)=>Boolean(field.value?.priorityId !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $dc3284b4c35d3e1f$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $dc3284b4c35d3e1f$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $dc3284b4c35d3e1f$export$8d97b18a0e2778ac = {
    [(0, $lO4Or.PRIORITY_TYPE)]: $dc3284b4c35d3e1f$var$evaluateFormatRule
};

});

parcelRegister("9lvK0", function(module, exports) {

$parcel$export(module.exports, "projectEvaluateFormatRule", () => $d43da91f54c3414b$export$abda41e836fbe53a);

var $lO4Or = parcelRequire("lO4Or");
const $d43da91f54c3414b$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value?.projectId === value),
    IS_NOT: (field, value)=>Boolean(field.value?.projectId !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $d43da91f54c3414b$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $d43da91f54c3414b$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $d43da91f54c3414b$export$abda41e836fbe53a = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $d43da91f54c3414b$var$evaluateFormatRule
};

});

parcelRegister("d3LF1", function(module, exports) {

$parcel$export(module.exports, "radioEvaluateFormatRule", () => $1bb3076421e7a474$export$4f805002362dd334);

var $lO4Or = parcelRequire("lO4Or");
const $1bb3076421e7a474$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value?.id === value),
    IS_NOT: (field, value)=>Boolean(field.value?.id !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $1bb3076421e7a474$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $1bb3076421e7a474$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $1bb3076421e7a474$export$4f805002362dd334 = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $1bb3076421e7a474$var$evaluateFormatRule
};

});

parcelRegister("dDL0C", function(module, exports) {

$parcel$export(module.exports, "singleSelectEvaluateFormatRule", () => $c3d249ad461fdcac$export$466ec2bab0b5512f);

var $lO4Or = parcelRequire("lO4Or");
// TODO: FLINGO:940 - use value.optionId once that ticket is done
const $c3d249ad461fdcac$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value?.value === value),
    IS_NOT: (field, value)=>Boolean(field.value?.value !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $c3d249ad461fdcac$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $c3d249ad461fdcac$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $c3d249ad461fdcac$export$466ec2bab0b5512f = {
    [(0, $lO4Or.SELECT_CF_TYPE)]: $c3d249ad461fdcac$var$evaluateFormatRule
};

});

parcelRegister("kvrlQ", function(module, exports) {

$parcel$export(module.exports, "sprintEvaluateFormatRule", () => $4e88fd3b0f07772e$export$4a797e9c240634e1);

var $lO4Or = parcelRequire("lO4Or");
const $4e88fd3b0f07772e$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value.length && field.value[0]?.sprintId === value),
    IS_NOT: (field, value)=>Boolean(field.value.length && field.value[0]?.sprintId !== value),
    IS_EMPTY: (field)=>!field.value || !field.value.length,
    IS_NOT_EMPTY: (field)=>Boolean(field.value.length)
};
const $4e88fd3b0f07772e$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $4e88fd3b0f07772e$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $4e88fd3b0f07772e$export$4a797e9c240634e1 = {
    [(0, $lO4Or.SPRINT_TYPE)]: $4e88fd3b0f07772e$var$evaluateFormatRule
};

});

parcelRegister("3KIMt", function(module, exports) {

$parcel$export(module.exports, "statusEvaluateFormatRule", () => $c19ed18da70052c2$export$e03c41425f1d323d);

var $lO4Or = parcelRequire("lO4Or");
// TODO: update to compare the status id
const $c19ed18da70052c2$var$evaluateHandler = {
    IS: (field, value)=>field.name === value,
    IS_NOT: (field, value)=>field.name !== value,
    HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(value?.includes(field.name))
};
const $c19ed18da70052c2$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $c19ed18da70052c2$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $c19ed18da70052c2$export$e03c41425f1d323d = {
    [(0, $lO4Or.STATUS_TYPE)]: $c19ed18da70052c2$var$evaluateFormatRule
};

});

parcelRegister("eW6me", function(module, exports) {

$parcel$export(module.exports, "textEvaluateFormatRule", () => $9f310bb70a5855d1$export$c4da0f7dd3518065);

var $lO4Or = parcelRequire("lO4Or");
const $9f310bb70a5855d1$var$evaluateHandler = {
    IS_EMPTY: (field)=>Boolean(!field.value),
    IS_NOT_EMPTY: (field)=>Boolean(field.value),
    CONTAINS: (field, value)=>Boolean(typeof value === 'string' && field.value?.includes(value)),
    DOES_NOT_CONTAIN: (field, value)=>Boolean(typeof value === 'string' && !field.value?.includes(value))
};
const $9f310bb70a5855d1$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $9f310bb70a5855d1$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $9f310bb70a5855d1$export$c4da0f7dd3518065 = {
    [(0, $lO4Or.SUMMARY_TYPE)]: $9f310bb70a5855d1$var$evaluateFormatRule,
    [(0, $lO4Or.TEXT_CF_TYPE)]: $9f310bb70a5855d1$var$evaluateFormatRule
};

});

parcelRegister("1WaBd", function(module, exports) {

$parcel$export(module.exports, "typeEvaluateFormatRule", () => $687f6292eff6bed1$export$8b8aad40b9f7a09b);

var $lO4Or = parcelRequire("lO4Or");
const $687f6292eff6bed1$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.issueTypeId === value),
    IS_NOT: (field, value)=>Boolean(field.issueTypeId !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $687f6292eff6bed1$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $687f6292eff6bed1$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $687f6292eff6bed1$export$8b8aad40b9f7a09b = {
    [(0, $lO4Or.ISSUE_TYPE)]: $687f6292eff6bed1$var$evaluateFormatRule
};

});

parcelRegister("j0lze", function(module, exports) {

$parcel$export(module.exports, "userEvaluateFormatRule", () => $a2cfebbb5fad5f6e$export$27e95a93355e9d3c);

var $lO4Or = parcelRequire("lO4Or");

var $VJkKV = parcelRequire("VJkKV");
const $a2cfebbb5fad5f6e$var$evaluateHandler = {
    IS: (field, value)=>{
        if (value === (0, $VJkKV.USER_EMPTY_OPERATORS).UNASSIGNED || value === (0, $VJkKV.USER_EMPTY_OPERATORS).EMPTY) return Boolean(!field.value?.accountId);
        return Boolean(field.value?.accountId === value);
    },
    IS_NOT: (field, value)=>{
        if (value === (0, $VJkKV.USER_EMPTY_OPERATORS).UNASSIGNED || value === (0, $VJkKV.USER_EMPTY_OPERATORS).EMPTY) return Boolean(field.value?.accountId);
        return Boolean(field.value?.accountId !== value);
    }
};
const $a2cfebbb5fad5f6e$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $a2cfebbb5fad5f6e$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $a2cfebbb5fad5f6e$var$evaluateMultiUserHandler = {
    CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>value?.includes(fieldValue.accountId)).length === value.length),
    HAS_ANY_OF: (field, value)=>Boolean(Array.isArray(value) && field.value?.some((fieldValue)=>value?.includes(fieldValue.accountId))),
    DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && !field.value?.some((fieldValue)=>value?.includes(fieldValue.accountId))),
    IS_EMPTY: (field)=>field.value?.length === 0,
    IS_NOT_EMPTY: (field)=>field.value?.length > 0
};
const $a2cfebbb5fad5f6e$var$evaluateFormatRulesForMultiUser = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $a2cfebbb5fad5f6e$var$evaluateMultiUserHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $a2cfebbb5fad5f6e$export$27e95a93355e9d3c = {
    [(0, $lO4Or.USER_CF_TYPE)]: $a2cfebbb5fad5f6e$var$evaluateFormatRule,
    [(0, $lO4Or.REPORTER_TYPE)]: $a2cfebbb5fad5f6e$var$evaluateFormatRule,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $a2cfebbb5fad5f6e$var$evaluateFormatRule,
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: $a2cfebbb5fad5f6e$var$evaluateFormatRulesForMultiUser,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: $a2cfebbb5fad5f6e$var$evaluateFormatRulesForMultiUser
};

});
parcelRegister("VJkKV", function(module, exports) {

$parcel$export(module.exports, "USER_EMPTY_OPERATORS", () => $eed9b83191f9d0b1$export$d6d1c00539a63d49);
const $eed9b83191f9d0b1$export$d6d1c00539a63d49 = {
    UNASSIGNED: 'UNASSIGNED',
    EMPTY: 'EMPTY'
};

});


parcelRegister("c5nZS", function(module, exports) {

$parcel$export(module.exports, "versionEvaluateFormatRule", () => $dd2a06205872ea80$export$da4c4fbd4009c683);

var $lO4Or = parcelRequire("lO4Or");
// TODO: FLINGO:925 - use value.id once that ticket is done
const $dd2a06205872ea80$var$evaluateHandler = {
    IS: (field, value)=>Boolean(field.value?.name === value),
    IS_NOT: (field, value)=>Boolean(field.value?.name !== value),
    IS_EMPTY: (field)=>!field.value,
    IS_NOT_EMPTY: (field)=>Boolean(field.value)
};
const $dd2a06205872ea80$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $dd2a06205872ea80$var$evaluateHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $dd2a06205872ea80$var$evaluateMultiVersionHandler = {
    CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>value?.includes(fieldValue.name)).length === value.length),
    HAS_ANY_OF: (field, value)=>Boolean(Array.isArray(value) && field.value?.some((fieldValue)=>value?.includes(fieldValue.name))),
    DOES_NOT_CONTAIN: (field, value)=>!(Array.isArray(value) && field.value?.filter((fieldValue)=>value?.includes(fieldValue.name)).length === value.length),
    IS_EMPTY: (field)=>field.value?.length === 0,
    IS_NOT_EMPTY: (field)=>Boolean(field.value && field.value?.length > 0)
};
const $dd2a06205872ea80$var$evaluateFormatRulesForMultiVersion = ({ field: field, operator: operator, value: value })=>{
    const evaluateHandlerFn = $dd2a06205872ea80$var$evaluateMultiVersionHandler[operator];
    if (!evaluateHandlerFn) return false;
    return evaluateHandlerFn(field, value);
};
const $dd2a06205872ea80$export$da4c4fbd4009c683 = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $dd2a06205872ea80$var$evaluateFormatRule,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $dd2a06205872ea80$var$evaluateFormatRulesForMultiVersion,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $dd2a06205872ea80$var$evaluateFormatRulesForMultiVersion,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $dd2a06205872ea80$var$evaluateFormatRulesForMultiVersion
};

});




parcelRegister("87KFZ", function(module, exports) {

$parcel$export(module.exports, "CELL_WRAPPER_TEST_ID", () => $ad717643faeaff73$export$dec9ff238ffa9d69);
$parcel$export(module.exports, "useMultiSelectKeyDown", () => $ad717643faeaff73$export$704331f55cc6e6a4);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
const $ad717643faeaff73$export$dec9ff238ffa9d69 = 'business-list.ui.list-view.cell-navigation.cell-container';
const $ad717643faeaff73$export$c4f223e53a47f1c6 = (element)=>element?.getAttribute('data-testid') === $ad717643faeaff73$export$dec9ff238ffa9d69;
const $ad717643faeaff73$export$704331f55cc6e6a4 = ({ editMode: editMode = true, wasEditMode: wasEditMode = false, menuIsOpen: menuIsOpen, setMenuIsOpen: setMenuIsOpen, saveAndClose: saveAndClose, onEscapeKeyPress: onEscapeKeyPress })=>{
    const shouldCloseWithoutSaving = (0, $eUqFw.useRef)(false);
    const saveAndCloseRef = (0, $eUqFw.useRef)(saveAndClose);
    saveAndCloseRef.current = saveAndClose;
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $eI5EY.fg)('fix-bug-labels-not-saving')) shouldCloseWithoutSaving.current = false;
    }, [
        editMode
    ]);
    const saveOnBlur = (0, $eUqFw.useCallback)(()=>{
        // save on blur when user did not press Escape
        if (wasEditMode && !editMode && (0, $eI5EY.fg)('jira_list_keyboard_nav')) {
            if (!shouldCloseWithoutSaving.current) {
                saveAndClose();
                // set close without saving to true because we already saved
                if ((0, $1ybV0.ff)('jira.list.field-support-part1')) shouldCloseWithoutSaving.current = true;
            } else shouldCloseWithoutSaving.current = false;
        }
    }, [
        editMode,
        saveAndClose,
        wasEditMode
    ]);
    const saveOnUnmount = (0, $eUqFw.useCallback)(()=>{
        // save on edit view unmount
        if (!shouldCloseWithoutSaving.current && (0, $eI5EY.fg)('jira_list_keyboard_nav')) saveAndCloseRef.current();
        else shouldCloseWithoutSaving.current = false;
    }, []);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (editMode) {
            // Close the menu on selecting an option
            if (menuIsOpen && [
                'Enter',
                'Tab',
                'Space'
            ].includes(event.code)) {
                setMenuIsOpen(false);
                return true;
            }
            // save and close when menu is closed
            if (!menuIsOpen && [
                'Enter',
                'Tab'
            ].includes(event.code)) {
                saveAndClose();
                // set close without saving to true because we already saved
                if ((0, $1ybV0.ff)('jira.list.field-support-part1')) shouldCloseWithoutSaving.current = true;
                return false;
            }
            // Reopen the menu when the user types or hits down arrow
            if (!menuIsOpen && (event.code === 'ArrowDown' || event.code.startsWith('Key') && !event.metaKey && !event.ctrlKey)) {
                setMenuIsOpen(true);
                return true;
            }
            if (event.code === 'Escape') {
                shouldCloseWithoutSaving.current = true;
                onEscapeKeyPress && onEscapeKeyPress();
            }
        }
        return false;
    }, [
        editMode,
        menuIsOpen,
        onEscapeKeyPress,
        saveAndClose,
        setMenuIsOpen
    ]);
    return {
        onKeyDown: onKeyDown,
        saveOnBlur: saveOnBlur,
        saveOnUnmount: saveOnUnmount
    };
};

});

parcelRegister("8NLkb", function(module, exports) {

$parcel$export(module.exports, "useCellSelected", () => $66741735f4c4d08e$export$82315ac370e9a611);
$parcel$export(module.exports, "useHasCellSelection", () => $66741735f4c4d08e$export$a808344e7adc2015);
$parcel$export(module.exports, "useCellActions", () => $66741735f4c4d08e$export$98b52eeb50fa4d73);

var $4oWxH = parcelRequire("4oWxH");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $gbsaq = parcelRequire("gbsaq");

var $bxcZe = parcelRequire("bxcZe");


var $l90Nb = parcelRequire("l90Nb");
const $66741735f4c4d08e$var$actions = {
    clearSelectedCell: ()=>({ setState: setState })=>{
            setState({
                selectedCell: undefined
            });
        },
    clearCopiedFromCell: ()=>({ setState: setState })=>{
            setState({
                copiedFromCell: null
            });
        },
    setSelectedCell: (columnIndex, rowIndex)=>({ setState: setState, getState: getState })=>{
            const { selectedCell: selectedCell } = getState();
            if ((0, $l90Nb.checkIsCellSelected)(selectedCell, columnIndex, rowIndex)) return;
            setState({
                selectedCell: {
                    column: columnIndex,
                    row: rowIndex
                }
            });
        },
    setCopiedFromCell: (fieldId, issueId)=>({ setState: setState, getState: getState })=>{
            if (!fieldId || !issueId) return;
            const { copiedFromCell: copiedFromCell } = getState();
            if ((0, $l90Nb.checkIsCellCopiedFrom)(copiedFromCell, fieldId, issueId)) return;
            setState({
                copiedFromCell: {
                    fieldId: fieldId,
                    issueId: issueId
                }
            });
        },
    navigate: (direction, tableRef, dragAndDropButtonRow)=>({ setState: setState, getState: getState })=>{
            const { selectedCell: selectedCell } = getState();
            const tableRefProps = tableRef?.current?.table?.props;
            const tableData = tableRefProps?.data;
            const tableWidth = tableRefProps?.width || 0;
            const scrollLeft = tableRef?.current?.table?.bodyRef?.state?.scrollLeft || 0;
            const tableColumns = tableRefProps?.columns || [];
            const { visibleColumns: visibleColumns } = (0, $bxcZe.getColumnVisibilityIndexes)(scrollLeft, tableWidth, tableColumns);
            // Handle navigation from drag and drop button to the last cell of the row above.
            if (dragAndDropButtonRow && tableData) {
                // stay on the same cell if the new row is a group item row
                if ((0, $4oWxH.isGroupItem)(tableData?.[dragAndDropButtonRow - 1]?.issueId?.toString() || null)) return;
                (0, $l90Nb.scrollCellIntoView)(tableRef, visibleColumns, direction, {
                    column: 0,
                    row: dragAndDropButtonRow
                }, {
                    column: tableColumns.length - 1,
                    row: dragAndDropButtonRow - 1
                });
                setTimeout(()=>{
                    setState({
                        selectedCell: {
                            column: tableColumns.length - 1,
                            row: dragAndDropButtonRow - 1
                        }
                    });
                }, (0, $1b5de6ccc140bcab$export$c10811fdbc59f0be));
                return;
            }
            if (!selectedCell || !tableData) return;
            const { newColumnIndex: newColumnIndex, newRowIndex: newRowIndex } = (0, $l90Nb.getUpdatedNavigationIndexes)(selectedCell, direction, tableColumns, tableData);
            // stay on the same cell if the new row is a group item row
            if (tableData && (0, $4oWxH.isGroupItem)(tableData?.[newRowIndex]?.issueId?.toString() || null)) return;
            (0, $l90Nb.scrollCellIntoView)(tableRef, visibleColumns, direction, selectedCell, {
                column: newColumnIndex,
                row: newRowIndex
            });
            const prevCellColumn = selectedCell.column;
            // Focus on the drag and drop button only if the last column was selected
            // and the next selected column and row is the first of the next row.
            const shouldFocusOnDragAndDropButton = prevCellColumn === tableColumns.length - 1 && newColumnIndex === 0 && newRowIndex < tableData.length;
            // wait for all scroll, focus and blur events to finish before setting state
            if (shouldFocusOnDragAndDropButton) {
                const { issueId: issueId } = tableData[newRowIndex];
                setTimeout(()=>{
                    document.dispatchEvent(new CustomEvent(`${(0, $gbsaq.DRAG_AND_DROP_BUTTON_FOCUS_EVENT)}`, {
                        detail: {
                            issueId: issueId
                        }
                    }));
                }, (0, $1b5de6ccc140bcab$export$c10811fdbc59f0be));
            } else setTimeout(()=>{
                setState({
                    selectedCell: {
                        column: newColumnIndex,
                        row: newRowIndex
                    }
                });
            }, (0, $1b5de6ccc140bcab$export$c10811fdbc59f0be));
        }
};
const $66741735f4c4d08e$export$390f32400eaf98c9 = (0, $kEDjj.createStore)({
    initialState: {
        selectedCell: undefined,
        copiedFromCell: null,
        prevScrolledColumnIndex: undefined
    },
    actions: $66741735f4c4d08e$var$actions,
    name: 'JwmCellNavigation'
});
const $66741735f4c4d08e$export$82315ac370e9a611 = (0, $1yZQx.createHook)($66741735f4c4d08e$export$390f32400eaf98c9, {
    // we need to use the selector to prevent unnecessary re-render in all the cells every time the focus change
    selector: (0, $l90Nb.getCellSelectedSelector)
});
const $66741735f4c4d08e$export$a808344e7adc2015 = (0, $1yZQx.createHook)($66741735f4c4d08e$export$390f32400eaf98c9, {
    selector: (0, $l90Nb.getHasSelectionSelector)
});
const $66741735f4c4d08e$export$98b52eeb50fa4d73 = (0, $1yZQx.createActionsHook)($66741735f4c4d08e$export$390f32400eaf98c9);

});
const $1b5de6ccc140bcab$export$c10811fdbc59f0be = 50;

parcelRegister("l90Nb", function(module, exports) {

$parcel$export(module.exports, "checkIsCellSelected", () => $70b68bde1795f533$export$137ef1ae0e2f1e4f);
$parcel$export(module.exports, "checkIsCellCopiedFrom", () => $70b68bde1795f533$export$10a6e994f306d4c1);
$parcel$export(module.exports, "getCellSelectedSelector", () => $70b68bde1795f533$export$8faeda346ea872cf);
$parcel$export(module.exports, "getHasSelectionSelector", () => $70b68bde1795f533$export$f296623a5c5deab7);
$parcel$export(module.exports, "getUpdatedNavigationIndexes", () => $70b68bde1795f533$export$e86d0c724f5bd464);
$parcel$export(module.exports, "scrollCellIntoView", () => $70b68bde1795f533$export$5d689075caa24122);

var $bnlpg = parcelRequire("bnlpg");

var $iTvqy = parcelRequire("iTvqy");

var $4oWxH = parcelRequire("4oWxH");

var $1jo4G = parcelRequire("1jo4G");

var $gbsaq = parcelRequire("gbsaq");
const $70b68bde1795f533$export$137ef1ae0e2f1e4f = (selectedCell, columnIndex, rowIndex)=>selectedCell ? selectedCell.column === columnIndex && selectedCell.row === rowIndex : false;
const $70b68bde1795f533$export$10a6e994f306d4c1 = (copiedCell, fieldId, issueId)=>{
    if (!copiedCell || !fieldId || !issueId) return false;
    return copiedCell.fieldId === fieldId && copiedCell.issueId === issueId;
};
const $70b68bde1795f533$export$8faeda346ea872cf = (0, $1jo4G.createSelector)((state, coordinate)=>({
        isCellSelected: $70b68bde1795f533$export$137ef1ae0e2f1e4f(state.selectedCell, coordinate.column, coordinate.row),
        isCellCopiedFrom: $70b68bde1795f533$export$10a6e994f306d4c1(state.copiedFromCell, coordinate.fieldId, coordinate.issueId)
    }), ({ isCellSelected: isCellSelected, isCellCopiedFrom: isCellCopiedFrom })=>({
        isSelected: isCellSelected,
        isCopiedFrom: isCellCopiedFrom ?? false
    }));
const $70b68bde1795f533$export$f296623a5c5deab7 = (0, $1jo4G.createSelector)((state)=>({
        hasSelection: !!state.selectedCell
    }), ({ hasSelection: hasSelection })=>({
        hasSelection: hasSelection
    }));
const $70b68bde1795f533$var$getNewColumnIndex = (initialCell, direction, totalColumns, totalRows)=>{
    const { column: initialColumnIndex, row: initialRowIndex } = initialCell;
    const lastColumnIndex = totalColumns - 1;
    const lastRowIndex = totalRows - 1;
    const isFirstTableItem = initialColumnIndex === 0 && initialRowIndex === 0;
    const isLastTableItem = initialColumnIndex === lastColumnIndex && initialRowIndex === lastRowIndex;
    if (direction === (0, $gbsaq.LEFT) && !isFirstTableItem) return (initialColumnIndex || totalColumns) - 1;
    if (direction === (0, $gbsaq.RIGHT) && !isLastTableItem) return (initialColumnIndex + 1) % totalColumns;
    return initialColumnIndex;
};
const $70b68bde1795f533$var$getNewRowIndex = (initialCell, direction, tableData)=>{
    const { row: initialRowIndex } = initialCell;
    if (direction === (0, $gbsaq.UP)) {
        let newRowIndex = initialRowIndex - 1;
        while(newRowIndex > 0 && (0, $4oWxH.isGroupItem)(tableData[newRowIndex]?.issueId?.toString() || null))newRowIndex--;
        return Math.max(0, newRowIndex);
    }
    if (direction === (0, $gbsaq.DOWN)) {
        let nextRowIndex = initialRowIndex + 1;
        while(nextRowIndex < tableData.length && (0, $4oWxH.isGroupItem)(tableData[nextRowIndex]?.issueId?.toString() || null))nextRowIndex++;
        return Math.min(tableData.length - 1, nextRowIndex);
    }
    return initialRowIndex;
};
const $70b68bde1795f533$export$e86d0c724f5bd464 = (initialCell, direction, tableColumn, tableData)=>{
    const totalColumns = tableColumn.length;
    const totalRows = tableData.length;
    const newColumnIndex = $70b68bde1795f533$var$getNewColumnIndex(initialCell, direction, totalColumns, totalRows);
    if (direction === (0, $gbsaq.UP) || direction === (0, $gbsaq.DOWN)) {
        const newRowIndex = $70b68bde1795f533$var$getNewRowIndex(initialCell, direction, tableData);
        return {
            newColumnIndex: newColumnIndex,
            newRowIndex: newRowIndex
        };
    }
    if (direction === (0, $gbsaq.RIGHT) && newColumnIndex === 0) {
        const newRowIndex = $70b68bde1795f533$var$getNewRowIndex(initialCell, (0, $gbsaq.DOWN), tableData);
        return {
            newColumnIndex: newColumnIndex,
            newRowIndex: newRowIndex
        };
    }
    if (direction === (0, $gbsaq.LEFT) && newColumnIndex === totalColumns - 1) {
        const newRowIndex = $70b68bde1795f533$var$getNewRowIndex(initialCell, (0, $gbsaq.UP), tableData);
        return {
            newColumnIndex: newColumnIndex,
            newRowIndex: newRowIndex
        };
    }
    return {
        newColumnIndex: newColumnIndex,
        newRowIndex: initialCell.row
    };
};
const $70b68bde1795f533$export$5d689075caa24122 = (tableRef, visibleColumns, direction, initialCell, newCell)=>{
    const tableWidth = tableRef.current?.table?.props?.width || 0;
    const tableColumns = tableRef.current?.table?.props?.columns || [];
    const { column: initialColumnIndex, row: initialRowIndex } = initialCell;
    const { column: newColumnIndex, row: newRowIndex } = newCell;
    if (initialRowIndex !== newRowIndex) setTimeout(()=>tableRef.current?.scrollToRow(newRowIndex, 'auto'));
    if (direction === (0, $gbsaq.LEFT)) {
        const firstVisibleColumn = (0, (/*@__PURE__*/$parcel$interopDefault($bnlpg)))(visibleColumns);
        const shouldScrollColumnIntoView = firstVisibleColumn === initialColumnIndex || firstVisibleColumn === newColumnIndex || newColumnIndex > initialColumnIndex;
        if (shouldScrollColumnIntoView) {
            const scrollAmount = tableColumns.slice(0, newColumnIndex).reduce((acc, column)=>acc + column.width, 0);
            setTimeout(()=>tableRef.current?.scrollToLeft(scrollAmount));
        }
    }
    if (direction === (0, $gbsaq.RIGHT)) {
        const lastVisibleColumn = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(visibleColumns);
        const shouldScrollColumnIntoView = lastVisibleColumn === initialColumnIndex || lastVisibleColumn === newColumnIndex || newColumnIndex < initialColumnIndex;
        if (shouldScrollColumnIntoView) {
            const totalWidthUntilNextCell = tableColumns.slice(0, newColumnIndex + 1).reduce((acc, column)=>acc + column.width, 0);
            const scrollAmount = Math.max(0, totalWidthUntilNextCell - tableWidth);
            setTimeout(()=>tableRef.current?.scrollToLeft(scrollAmount));
        }
    }
};

});
parcelRegister("bnlpg", function(module, exports) {

module.exports = (parcelRequire("jtpa0"));

});
parcelRegister("jtpa0", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $e2d43e13ed703ec3$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $e2d43e13ed703ec3$var$head;

});




parcelRegister("17QbA", function(module, exports) {

$parcel$export(module.exports, "ClipboardController", () => $55d8fb78d038efe8$export$16d13693519be2ee);

var $eUqFw = parcelRequire("eUqFw");

var $k82qK = parcelRequire("k82qK");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8NLkb = parcelRequire("8NLkb");

var $bitBE = parcelRequire("bitBE");
const $55d8fb78d038efe8$export$16d13693519be2ee = ({ children: children, issue: issue, field: field, fieldId: fieldId, isSelected: isSelected, isEditMode: isEditMode, onKeyDown: onKeyDown })=>{
    const transformedField = (0, $eUqFw.useMemo)(()=>issue.fields?.find((f)=>{
            const fieldId_ = field.id === 'key' ? 'issuekey' : field.id;
            return f.fieldId === fieldId_;
        }), [
        field.id,
        issue.fields
    ]);
    const isFieldAssociated = field.issueTypes?.includes(issue.issuetype.id ?? '');
    const transformedMissingField = isFieldAssociated ? {
        type: field.type,
        fieldId: field.id,
        value: null
    } : null;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [clipboard, setClipboard] = (0, $eUqFw.useState)(null);
    const [isCutting, setIsCutting] = (0, $eUqFw.useState)(false);
    const [contentToCopy, setContentToCopy] = (0, $eUqFw.useState)(null);
    const { setCopiedFromCell: setCopiedFromCell, clearCopiedFromCell: clearCopiedFromCell } = (0, $8NLkb.useCellActions)();
    const isEditable = field.fieldConfig?.isEditable ?? true;
    const canBeUnset = (0, $eUqFw.useMemo)(()=>(0, $bitBE.canBeReset)(field), [
        field
    ]);
    const issueForCopyAndPaste = (0, $eUqFw.useMemo)(()=>({
            key: issue.key,
            issueId: issue.issueId,
            issueType: issue.issuetype
        }), [
        issue.issueId,
        issue.issuetype,
        issue.key
    ]);
    const { renderPrepareToCopyComponent: renderPrepareToCopyComponent, renderPasteHandlerComponent: renderPasteHandlerComponent, renderCutOnlyHandlerComponent: renderCutOnlyHandlerComponent } = (0, $k82qK.useClipboard)(issueForCopyAndPaste, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    transformedField ?? transformedMissingField, fieldId);
    const { reportError: reportError, dismissFlag: dismissFlag } = (0, $bitBE.useClipboardErrorReporting)(field);
    const onPaste = (0, $eUqFw.useCallback)((success, error)=>{
        dismissFlag();
        setClipboard(null);
        if (success) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'cell pasted', {
            fieldType: field.type
        });
        else reportError({
            action: 'paste',
            error: error
        });
        if (isFieldAssociated && !transformedField) (0, $guiFP.default)({
            meta: {
                id: 'jiraClipboardController',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: `A field of type ${field.type} is missing in BE response`,
                fieldType: field.type
            },
            error: new Error('jiraClipboardControllerMissingFieldError')
        });
    }, [
        createAnalyticsEvent,
        dismissFlag,
        field.type,
        isFieldAssociated,
        reportError,
        transformedField
    ]);
    const onCut = (0, $eUqFw.useCallback)((success, error)=>{
        dismissFlag();
        setIsCutting(false);
        if (!success) reportError({
            action: 'cut',
            error: error
        });
    }, [
        dismissFlag,
        reportError
    ]);
    const paste = (0, $eUqFw.useCallback)((event)=>{
        if (isEditMode || !isEditable) return;
        const data = event.clipboardData;
        setClipboard({
            plainText: data?.getData('text/plain'),
            html: data?.getData('text/html')
        });
    }, [
        setClipboard,
        isEditMode,
        isEditable
    ]);
    const copyEventListener = (0, $eUqFw.useCallback)((e)=>{
        if (!isSelected || isEditMode) return;
        dismissFlag();
        try {
            (0, $bitBE.setDataToClipboard)(e, contentToCopy);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            reportError({
                action: 'copy',
                error: error
            });
            return;
        }
        e.preventDefault();
        setCopiedFromCell(field.id, issue?.issueId);
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'cell copied', {
            fieldType: field.type,
            hasCopied: true
        });
    }, [
        isSelected,
        isEditMode,
        contentToCopy,
        dismissFlag,
        setCopiedFromCell,
        field.id,
        field.type,
        issue?.issueId,
        createAnalyticsEvent,
        reportError
    ]);
    const cutEventListener = (0, $eUqFw.useCallback)((e)=>{
        if (!isSelected || isEditMode) return;
        try {
            (0, $bitBE.setDataToClipboard)(e, contentToCopy);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            reportError({
                action: 'cut',
                error: error
            });
            return;
        }
        e.preventDefault();
        dismissFlag();
        setCopiedFromCell(field.id, issue?.issueId);
        setIsCutting(true);
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'cell cut', {
            fieldType: field.type,
            canBeReset: canBeUnset,
            hasCopied: true
        });
    }, [
        isSelected,
        isEditMode,
        dismissFlag,
        setCopiedFromCell,
        field.id,
        field.type,
        issue?.issueId,
        createAnalyticsEvent,
        canBeUnset,
        contentToCopy,
        reportError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isSelected) {
            document.addEventListener('paste', paste, true);
            document.addEventListener('copy', copyEventListener);
            document.addEventListener('cut', cutEventListener);
        } else {
            document.removeEventListener('paste', paste, true);
            document.removeEventListener('copy', copyEventListener);
            document.removeEventListener('cut', cutEventListener);
        }
        return ()=>{
            document.removeEventListener('paste', paste, true);
            document.removeEventListener('copy', copyEventListener);
            document.removeEventListener('cut', cutEventListener);
        };
    }, [
        copyEventListener,
        cutEventListener,
        isSelected,
        paste
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, $eUqFw.cloneElement)(children, {
        onKeyDown: onKeyDown
    }), clipboard && renderPasteHandlerComponent({
        clipboard: clipboard,
        onPaste: onPaste,
        isEditable: isEditable,
        onBeforePaste: clearCopiedFromCell
    }), isCutting && renderCutOnlyHandlerComponent({
        onCut: onCut,
        isEditable: canBeUnset
    }), isSelected && renderPrepareToCopyComponent({
        onContentReady: setContentToCopy
    }));
};

});
parcelRegister("k82qK", function(module, exports) {

$parcel$export(module.exports, "useClipboard", () => $da90c978afa5b77c$export$2314ca2a3e892862);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $31jh1 = parcelRequire("31jh1");

var $caO3M = parcelRequire("caO3M");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fGxlE = parcelRequire("fGxlE");

var $a6M4d = parcelRequire("a6M4d");

var $b3neV = parcelRequire("b3neV");

var $9jnJo = parcelRequire("9jnJo");
const $da90c978afa5b77c$var$PrepareToCopyComponent = ({ issue: issue, field: field, onMissingClipboardHandler: onMissingClipboardHandler, onContentReady: onContentReady })=>{
    const Component = (0, $fGxlE.getClipboardHandlerComponent)(field?.type);
    (0, $eUqFw.useEffect)(()=>{
        if (!Component) try {
            const result = onMissingClipboardHandler();
            onContentReady(result);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onContentReady(null);
        }
    }, [
        Component,
        onContentReady,
        onMissingClipboardHandler
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        issue: issue,
        field: field,
        action: "prepare-to-copy",
        onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onContentReady: onContentReady,
        metadata: null
    });
};
const $da90c978afa5b77c$var$CutOnlyHandlerComponent = ({ issue: issue, field: field, onCut: onCut, isEditable: isEditable })=>{
    const Component = (0, $fGxlE.getClipboardHandlerComponent)(field.type);
    const checkIsEditable = (0, $eUqFw.useCallback)(()=>{
        if (!isEditable) throw new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).NON_EDITABLE);
    }, [
        isEditable
    ]);
    if (!isEditable) {
        onCut(false, new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).NON_EDITABLE));
        return null;
    }
    if (!Component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        issue: issue,
        field: field,
        action: "cut-only",
        onComplete: onCut,
        metadata: {
            fieldId: field.fieldId,
            fieldType: field.type,
            fieldValue: null
        },
        onBeforeAction: checkIsEditable
    });
};
const $da90c978afa5b77c$export$2314ca2a3e892862 = (issue, field, fieldId)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getCellValueFallback = (0, $eUqFw.useCallback)(()=>{
        if (!field) throw new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).MISSING_FIELD);
        return (0, $b3neV.getCellValue)(field, issue, formatMessage);
    }, [
        field,
        formatMessage,
        issue
    ]);
    const renderPrepareToCopyComponent = ({ onContentReady: onContentReady })=>{
        if (!field || !issue?.key || !issue?.issueId) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da90c978afa5b77c$var$PrepareToCopyComponent, {
            issue: issue,
            field: field,
            onMissingClipboardHandler: getCellValueFallback,
            onContentReady: onContentReady
        });
    };
    const renderPasteHandlerComponent = ({ clipboard: clipboard, onPaste: onPaste, isEditable: isEditable, onBeforePaste: onBeforePaste })=>{
        if (!issue?.key || !issue?.issueId) return onPaste(false, new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).MISSING_ISSUE));
        const isTopLevelField = fieldId && (0, $a6M4d.SUPPORTED_TOP_LEVEL_FIELD_TYPES).includes(fieldId);
        const fieldType = isTopLevelField ? fieldId : field?.type;
        if (!fieldType) return onPaste(false, new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).MISSING_FIELD));
        const PasteHandlerComponent = field && (0, $fGxlE.getClipboardHandlerComponent)(field?.type);
        if (!PasteHandlerComponent || !isEditable) return onPaste(false, new (0, $caO3M.UnsupportedOperationError)(`Pasting on field type ${fieldType} is not supported`));
        if (!clipboard?.plainText) return onPaste(false, new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD));
        const metadata = (0, $9jnJo.getFieldMetadataFromClipboard)(clipboard);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PasteHandlerComponent, {
            issue: issue,
            field: field,
            action: "paste",
            clipboardItem: clipboard,
            onBeforeAction: onBeforePaste,
            onComplete: onPaste,
            metadata: metadata
        });
    };
    const renderCutOnlyHandlerComponent = ({ onCut: onCut, isEditable: isEditable })=>{
        if (!field || !issue?.key || !issue?.issueId) return onCut(false, new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).MISSING_FIELD));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da90c978afa5b77c$var$CutOnlyHandlerComponent, {
            issue: issue,
            field: field,
            onCut: onCut,
            isEditable: isEditable
        });
    };
    if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) return {
        renderPasteHandlerComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        renderPrepareToCopyComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        renderCutOnlyHandlerComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    };
    return {
        renderPasteHandlerComponent: renderPasteHandlerComponent,
        renderPrepareToCopyComponent: renderPrepareToCopyComponent,
        renderCutOnlyHandlerComponent: renderCutOnlyHandlerComponent
    };
};

});
parcelRegister("31jh1", function(module, exports) {

$parcel$export(module.exports, "ClientSideValidationError", () => $e0e527e073c68fc8$export$5ba9b77898e6c81d);
$parcel$export(module.exports, "isClientSideValidationError", () => $e0e527e073c68fc8$export$ea2382f3076b0d69);
class $e0e527e073c68fc8$export$5ba9b77898e6c81d extends Error {
    constructor(message){
        super(message);
        this.name = 'ClientSideValidationError';
        this.skipSentry = true;
    }
}
const $e0e527e073c68fc8$export$ea2382f3076b0d69 = (error)=>error instanceof $e0e527e073c68fc8$export$5ba9b77898e6c81d;

});

parcelRegister("caO3M", function(module, exports) {

$parcel$export(module.exports, "UnsupportedOperationError", () => $909821f77ce9ca77$export$ab59e00737fb22e6);
$parcel$export(module.exports, "isUnsupportedOperationError", () => $909821f77ce9ca77$export$cdab81fcd467111);
class $909821f77ce9ca77$export$ab59e00737fb22e6 extends Error {
    constructor(message){
        super(message);
        this.name = 'UnsupportedOperationError';
        this.skipSentry = true;
    }
}
const $909821f77ce9ca77$export$cdab81fcd467111 = (error)=>error instanceof $909821f77ce9ca77$export$ab59e00737fb22e6;

});

parcelRegister("fGxlE", function(module, exports) {

$parcel$export(module.exports, "getClipboardHandlerComponent", () => $568e885698759d2c$export$547cefce1a43344e);

var $5iWql = parcelRequire("5iWql");

var $6Fpov = parcelRequire("6Fpov");

var $ctkxZ = parcelRequire("ctkxZ");

var $h4XEw = parcelRequire("h4XEw");

var $jNdzl = parcelRequire("jNdzl");

var $fAOKd = parcelRequire("fAOKd");

var $itK3v = parcelRequire("itK3v");

var $dL0dH = parcelRequire("dL0dH");

var $ibP9o = parcelRequire("ibP9o");

var $3wSIr = parcelRequire("3wSIr");

var $1xv3U = parcelRequire("1xv3U");

var $5MhxU = parcelRequire("5MhxU");

var $9f078 = parcelRequire("9f078");

var $bN2A6 = parcelRequire("bN2A6");

var $bOlrD = parcelRequire("bOlrD");

var $i3YJS = parcelRequire("i3YJS");

var $gRRkp = parcelRequire("gRRkp");

var $hZbCV = parcelRequire("hZbCV");

var $6hel2 = parcelRequire("6hel2");

var $hENET = parcelRequire("hENET");

var $bde5A = parcelRequire("bde5A");

var $585wU = parcelRequire("585wU");

var $iYRy3 = parcelRequire("iYRy3");

var $9HYKH = parcelRequire("9HYKH");
const $568e885698759d2c$var$createClipboardHandlers = (0, $5iWql.default)(()=>({
        ...(0, $ctkxZ.categoryClipboardHandler),
        ...(0, $h4XEw.checkboxClipboardHandler),
        ...(0, $jNdzl.componentsClipboardHandler),
        ...(0, $9HYKH.versionClipboardHandler),
        ...(0, $ibP9o.labelsClipboardHandler),
        ...(0, $1xv3U.numberClipboardHandler),
        ...(0, $iYRy3.userClipboardHandler),
        ...(0, $iYRy3.multiUserClipboardHandler),
        ...(0, $3wSIr.multiSelectClipboardHandler),
        ...(0, $fAOKd.dateClipboardHandler),
        ...(0, $itK3v.dateTimeClipboardHandler),
        ...(0, $hENET.textClipboardHandler),
        ...(0, $i3YJS.richTextClipboardHandler),
        ...(0, $9f078.priorityClipboardHandler),
        ...(0, $gRRkp.singleSelectClipboardHandler),
        ...(0, $hZbCV.sprintClipboardHandler),
        ...(0, $bde5A.timeTrackingClipboardHandler),
        ...(0, $585wU.urlClipboardHandler),
        ...(0, $6hel2.teamClipboardHandler),
        ...(0, $5MhxU.parentClipboardHandler),
        ...(0, $dL0dH.groupClipboardHandler),
        ...(0, $bN2A6.projectClipboardHandler),
        ...(0, $6Fpov.cascadingSelectClipboardHandler),
        ...(0, $bOlrD.radioSelectClipboardHandler)
    }));
const $568e885698759d2c$export$547cefce1a43344e = (fieldType)=>{
    const handlers = $568e885698759d2c$var$createClipboardHandlers();
    if (!fieldType || handlers[fieldType] == null) return;
    return handlers[fieldType];
};

});
parcelRegister("6Fpov", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectClipboardHandler", () => $1bc1b74fa1561245$export$9fd387ed8e8432cb);

var $lO4Or = parcelRequire("lO4Or");

var $59U5n = parcelRequire("59U5n");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");
const $1bc1b74fa1561245$var$isCascadingSelectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'parentOptionValue' in fieldValue;
const $1bc1b74fa1561245$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, [
        (0, $lO4Or.CASCADING_SELECT_CF_TYPE)
    ])) return null;
    if (!$1bc1b74fa1561245$var$isCascadingSelectOption(metadata.fieldValue)) return null;
    const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = metadata.fieldValue;
    return {
        parentOptionValue: parentOptionValue,
        childOptionValue: childOptionValue
    };
};
const $1bc1b74fa1561245$export$5da374e426806c6a = (fieldValue)=>{
    if (fieldValue && fieldValue.parentOptionValue) {
        if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
        return `${fieldValue.parentOptionValue.value}`;
    }
    return '';
};
function $1bc1b74fa1561245$var$assertCascadingSelectField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.CASCADING_SELECT_CF_TYPE)) throw new Error('Field type is not supported');
}
const $1bc1b74fa1561245$var$useCascadingSelectClipboardHandler = (issue, field)=>{
    $1bc1b74fa1561245$var$assertCascadingSelectField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $59U5n.useCascadingSelectField)({
        fieldAriId: field.id,
        issueKey: issue.key,
        fieldKey: field.fieldId,
        initialValue: $1bc1b74fa1561245$var$isCascadingSelectOption(field.value) ? field.value : null
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: $1bc1b74fa1561245$export$5da374e426806c6a(value),
        currentValue: value,
        getPastedValue: $1bc1b74fa1561245$var$getPastedValue,
        saveValue: saveValue
    });
};
const $1bc1b74fa1561245$var$CascadingSelectClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($1bc1b74fa1561245$var$useCascadingSelectClipboardHandler);
const $1bc1b74fa1561245$export$9fd387ed8e8432cb = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $1bc1b74fa1561245$var$CascadingSelectClipboardHelper
};

});
parcelRegister("78nSO", function(module, exports) {

$parcel$export(module.exports, "createClipboardHelperComponent", () => $493cb20d309662fa$export$6ac5565d32c446cd);

var $eUqFw = parcelRequire("eUqFw");
const $493cb20d309662fa$export$6ac5565d32c446cd = (useFieldPasteHandler)=>({ issue: issue, field: field, clipboardItem: clipboardItem, metadata: metadata, action: action, onBeforeAction: onBeforeAction, onComplete: onComplete, onContentReady: onContentReady })=>{
        const [hasBeenCalled, setHasBeenCalled] = (0, $eUqFw.useState)(false);
        const { contentToCopy: contentToCopy, copyHandler: copyHandler, pasteHandler: pasteHandler, cutHandler: cutHandler } = useFieldPasteHandler(issue, field);
        (0, $eUqFw.useEffect)(()=>{
            async function handlePrepareToCopy() {
                if (!contentToCopy || !onContentReady) return;
                try {
                    onContentReady(contentToCopy);
                    onComplete(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    onComplete(false, error);
                }
            }
            if (action === 'prepare-to-copy') handlePrepareToCopy();
        }, [
            onComplete,
            hasBeenCalled,
            action,
            copyHandler,
            contentToCopy,
            onContentReady
        ]);
        (0, $eUqFw.useEffect)(()=>{
            async function handlePaste() {
                if (!clipboardItem || hasBeenCalled) return;
                setHasBeenCalled(true);
                onBeforeAction?.();
                try {
                    await pasteHandler(clipboardItem, metadata);
                    onComplete(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    onComplete(false, error);
                }
            }
            if (action === 'paste') handlePaste();
        }, [
            clipboardItem,
            onComplete,
            pasteHandler,
            metadata,
            hasBeenCalled,
            action,
            onBeforeAction
        ]);
        (0, $eUqFw.useEffect)(()=>{
            async function handleCutOnly() {
                if (hasBeenCalled) return;
                setHasBeenCalled(true);
                try {
                    await cutHandler();
                    onComplete(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    onComplete(false, error);
                }
            }
            if (action === 'cut-only') handleCutOnly();
        }, [
            clipboardItem,
            onComplete,
            cutHandler,
            metadata,
            hasBeenCalled,
            action,
            onBeforeAction,
            copyHandler
        ]);
        return null;
    };

});

parcelRegister("kS6SG", function(module, exports) {

$parcel$export(module.exports, "useClipboardHandler", () => $7428ecb5e86e19b0$export$bc92cd7bfdca2774);

var $eUqFw = parcelRequire("eUqFw");

var $31jh1 = parcelRequire("31jh1");

var $bFzGY = parcelRequire("bFzGY");

var $a6M4d = parcelRequire("a6M4d");

var $b3neV = parcelRequire("b3neV");
function $7428ecb5e86e19b0$export$bc92cd7bfdca2774({ issue: issue, field: field, currentStringValue: currentStringValue, currentValue: currentValue, getPastedValue: getPastedValue, saveValue: saveValue, emptyValue: emptyValue }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const getContentToCopy = (0, $eUqFw.useCallback)(()=>(0, $b3neV.getFieldValueAsClipboardItem)(field, issue, currentStringValue, currentValue), [
        currentStringValue,
        currentValue,
        field,
        issue
    ]);
    const [contentToCopy, setContentToCopy] = (0, $eUqFw.useState)(getContentToCopy);
    (0, $eUqFw.useEffect)(()=>{
        if (contentToCopy?.html !== getContentToCopy()?.html) setContentToCopy(getContentToCopy());
    }, [
        getContentToCopy,
        contentToCopy
    ]);
    const copyHandler = (0, $eUqFw.useCallback)(async ()=>{
        const { html: html, plainText: plainText } = (0, $b3neV.getFieldValueAsClipboardItem)(field, issue, currentStringValue, currentValue);
        if (!plainText || !html) throw new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).NULL_GETTER);
        await (0, $b3neV.addToClipboard)(plainText, html);
    }, [
        currentStringValue,
        currentValue,
        field,
        issue
    ]);
    const pasteHandler = (0, $eUqFw.useCallback)(async (clipboardItem, metadata)=>{
        const value = getPastedValue(clipboardItem, metadata);
        if (!value || Array.isArray(value) && !value.length) throw new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD);
        await saveValue(value, null, createAnalyticsEvent({}));
    }, [
        getPastedValue,
        saveValue,
        createAnalyticsEvent
    ]);
    const cutHandler = (0, $eUqFw.useCallback)(async ()=>{
        await saveValue(emptyValue ?? null, null, createAnalyticsEvent({}));
    }, [
        saveValue,
        emptyValue,
        createAnalyticsEvent
    ]);
    return {
        contentToCopy: contentToCopy,
        copyHandler: copyHandler,
        pasteHandler: pasteHandler,
        cutHandler: cutHandler
    };
}

});
parcelRegister("a6M4d", function(module, exports) {

$parcel$export(module.exports, "VALIDATION_ERROR_CODES", () => $4e1d92f74d272718$export$6d25692f75bd9b88);
$parcel$export(module.exports, "SUPPORTED_TOP_LEVEL_FIELD_TYPES", () => $4e1d92f74d272718$export$71645e77fbde68a0);

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $4e1d92f74d272718$export$6d25692f75bd9b88 = {
    NULL_GETTER: 'NULL_GETTER',
    MISSING_FIELD: 'MISSING_FIELD',
    MISSING_ISSUE: 'MISSING_ISSUE',
    NON_COMPATIBLE_FIELD_TYPE: 'NON_COMPATIBLE_FIELD_TYPE',
    EMPTY_CLIPBOARD: 'EMPTY_CLIPBOARD',
    NON_EDITABLE: 'NON_EDITABLE'
};
const $4e1d92f74d272718$export$71645e77fbde68a0 = [
    (0, $lO4Or.COMMENT_TYPE),
    (0, $jGcn0.COMMENT_SUMMARY_TYPE),
    (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)
];

});

parcelRegister("b3neV", function(module, exports) {

$parcel$export(module.exports, "assertClipboardHasPlainTextFormat", () => $57b515a82db815e8$export$4f1e704a7a6a6107);
$parcel$export(module.exports, "assertClipboardHasRichFormat", () => $57b515a82db815e8$export$acf1aef2ce2e9ad4);
$parcel$export(module.exports, "assertClipboardDataIsCompatible", () => $57b515a82db815e8$export$4957d49d1a7a1b9e);
$parcel$export(module.exports, "getFieldValueAsClipboardItem", () => $57b515a82db815e8$export$7afe662a0eda30a6);
$parcel$export(module.exports, "addToClipboard", () => $57b515a82db815e8$export$89af511f3acca517);
$parcel$export(module.exports, "getCellValue", () => $57b515a82db815e8$export$b1f6fa0c5f374def);

var $31jh1 = parcelRequire("31jh1");

var $7BT9O = parcelRequire("7BT9O");

var $a6M4d = parcelRequire("a6M4d");
function $57b515a82db815e8$export$4f1e704a7a6a6107(clipboardItem) {
    if (!clipboardItem?.plainText) throw new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD);
    return true;
}
function $57b515a82db815e8$export$acf1aef2ce2e9ad4(clipboardItem) {
    $57b515a82db815e8$export$4f1e704a7a6a6107(clipboardItem);
    if (!clipboardItem?.html) throw new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE);
    return true;
}
function $57b515a82db815e8$export$4957d49d1a7a1b9e(metadata, compatibleTypes) {
    if (!metadata?.fieldType || !compatibleTypes.includes(metadata?.fieldType)) throw new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE);
    return true;
}
function $57b515a82db815e8$var$getStringifiedRichFieldValue(richValue) {
    if (!richValue) return null;
    if (typeof richValue === 'string') return {
        value: richValue
    };
    return richValue;
}
const $57b515a82db815e8$var$safelyAddRichValueToHtml = (html, richValue)=>{
    try {
        const DOM = new DOMParser().parseFromString(html, 'text/html');
        DOM.body?.querySelector('div')?.setAttribute('data-field-value', JSON.stringify(richValue));
        return DOM.body?.innerHTML || '';
    } catch (e) {
        return html;
    }
};
function $57b515a82db815e8$export$7afe662a0eda30a6(field, issue, textValue, value) {
    const richValue = $57b515a82db815e8$var$getStringifiedRichFieldValue(value);
    if (!textValue) return {};
    const html = `<div data-type="list-cell" data-issue-type-level="${issue?.issueType?.level}" data-field-id="${field.fieldId}" data-field-type="${field.type}">${textValue}</div>`;
    return {
        html: richValue ? $57b515a82db815e8$var$safelyAddRichValueToHtml(html, richValue) : html,
        plainText: textValue
    };
}
const $57b515a82db815e8$export$89af511f3acca517 = (plainText, html)=>{
    const blobPlain = new window.Blob([
        plainText
    ], {
        type: 'text/plain'
    });
    const blobHTML = new window.Blob([
        html
    ], {
        type: 'text/html'
    });
    const clipboardItem = new window.ClipboardItem({
        'text/html': blobHTML,
        'text/plain': blobPlain
    });
    return navigator.clipboard.write([
        clipboardItem
    ]);
};
const $57b515a82db815e8$export$b1f6fa0c5f374def = (field, issue, formatMessage)=>{
    const textValue = (0, $7BT9O.getStringValue)(field.type, field, formatMessage);
    const richValue = $57b515a82db815e8$var$getStringifiedRichFieldValue((0, $7BT9O.getRichOrStringValue)(field.type, field));
    if (!textValue) return {};
    const html = `<div data-type="list-cell" data-issue-type-level="${issue?.issueType?.level}" data-field-id="${field.fieldId}" data-field-type="${field.type}">${textValue}</div>`;
    return {
        html: richValue ? $57b515a82db815e8$var$safelyAddRichValueToHtml(html, richValue) : html,
        plainText: textValue
    };
};

});
parcelRegister("7BT9O", function(module, exports) {

$parcel$export(module.exports, "getStringValue", () => $d008083493fe3461$export$5da374e426806c6a);
$parcel$export(module.exports, "isStringValueSupported", () => $d008083493fe3461$export$c7e2e8fb7867bf39);
$parcel$export(module.exports, "getRichOrStringValue", () => $d008083493fe3461$export$efe475f7dd73bf7c);
// Used in for bulk copy

var $5iWql = parcelRequire("5iWql");

var $euJic = parcelRequire("euJic");

var $joDw1 = parcelRequire("joDw1");

var $yTRlI = parcelRequire("yTRlI");

var $fsiWG = parcelRequire("fsiWG");

var $4Ojeu = parcelRequire("4Ojeu");

var $5OQpT = parcelRequire("5OQpT");

var $cT1pT = parcelRequire("cT1pT");

var $RkH8v = parcelRequire("RkH8v");

var $9astv = parcelRequire("9astv");

var $25ch1 = parcelRequire("25ch1");

var $kmy9M = parcelRequire("kmy9M");

var $eSIrM = parcelRequire("eSIrM");

var $gos6X = parcelRequire("gos6X");

var $fvlEF = parcelRequire("fvlEF");

var $kuvVz = parcelRequire("kuvVz");

var $hYuEu = parcelRequire("hYuEu");

var $fzsEd = parcelRequire("fzsEd");

var $f9D9e = parcelRequire("f9D9e");

var $kOTJc = parcelRequire("kOTJc");

var $8B6Zu = parcelRequire("8B6Zu");

var $iZ3D5 = parcelRequire("iZ3D5");

var $lqLo4 = parcelRequire("lqLo4");

var $czRzv = parcelRequire("czRzv");

var $jG0vv = parcelRequire("jG0vv");

var $1lG3P = parcelRequire("1lG3P");

var $i2HLN = parcelRequire("i2HLN");

var $gXXVe = parcelRequire("gXXVe");

var $aPp7f = parcelRequire("aPp7f");

var $e1ahQ = parcelRequire("e1ahQ");

var $iO2v7 = parcelRequire("iO2v7");
const $d008083493fe3461$var$createStringValueHandlers = (0, $5iWql.default)(()=>({
        ...(0, $fsiWG.categoryStringValueHandler),
        ...(0, $4Ojeu.checkboxStringValueHandler),
        ...(0, $5OQpT.componentsStringValueHandler),
        ...(0, $iO2v7.versionStringValueHandler),
        ...(0, $fvlEF.parentStringValueHandler),
        ...(0, $RkH8v.devSummaryStringValueHandler),
        ...(0, $kmy9M.labelsStringValueHandler),
        ...(0, $gos6X.numberStringValueHandler),
        ...(0, $25ch1.keyStringValueHandler),
        ...(0, $gXXVe.typeStringValueHandler),
        ...(0, $e1ahQ.userStringValueHandler),
        ...(0, $jG0vv.teamStringValueHandler),
        ...(0, $9astv.groupStringValueHandler),
        ...(0, $f9D9e.resolutionStringValueHandler),
        ...(0, $euJic.dateTimeStringValueHandler),
        ...(0, $cT1pT.dateStringValueHandler),
        ...(0, $joDw1.goalStringValueHandler),
        ...(0, $1lG3P.textStringValueHandler),
        ...(0, $kuvVz.priorityStringValueHandler),
        ...(0, $fzsEd.radioSelectStringValueHandler),
        ...(0, $aPp7f.urlStringValueHandler),
        ...(0, $eSIrM.multiSelectStringValueHandler),
        ...(0, $czRzv.statusStringValueHandler),
        ...(0, $lqLo4.statusCategoryStringValueHandler),
        ...(0, $i2HLN.timeTrackingStringValueHandler),
        ...(0, $8B6Zu.singleSelectStringValueHandler),
        ...(0, $iZ3D5.sprintStringValueHandler),
        ...(0, $kOTJc.richTextStringValueHandler),
        ...(0, $hYuEu.projectStringValueHandler),
        ...(0, $yTRlI.cascadingSelectStringValueHandler)
    }));
const $d008083493fe3461$export$5da374e426806c6a = (fieldType, ...args)=>{
    const handlers = $d008083493fe3461$var$createStringValueHandlers();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $d008083493fe3461$export$c7e2e8fb7867bf39 = (fieldType)=>{
    const handlers = $d008083493fe3461$var$createStringValueHandlers();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType] != null;
};
const $d008083493fe3461$var$createRichValueHandlers = (0, $5iWql.default)(()=>({
        ...(0, $fsiWG.categoryRichValueHandler),
        ...(0, $4Ojeu.checkboxRichValueHandler),
        ...(0, $5OQpT.componentsRichValueHandler),
        ...(0, $e1ahQ.userRichValueHandler),
        ...(0, $iO2v7.versionRichValueHandler),
        ...(0, $kuvVz.priorityRichValueHandler),
        ...(0, $eSIrM.multiSelectRichValueHandler),
        ...(0, $8B6Zu.singleSelectRichValueHandler),
        ...(0, $iZ3D5.sprintRichValueHandler),
        ...(0, $fvlEF.parentRichValueHandler),
        ...(0, $jG0vv.teamRichValueHandler),
        ...(0, $hYuEu.projectRichValueHandler),
        ...(0, $9astv.groupRichValueHandler),
        ...(0, $yTRlI.cascadingSelectRichValueHandler),
        ...(0, $fzsEd.radioSelectRichValueHandler)
    }));
const $d008083493fe3461$export$3c808f0df8be4abb = (fieldType)=>{
    const handlers = $d008083493fe3461$var$createRichValueHandlers();
    if (fieldType in handlers) return true;
    return false;
};
const $d008083493fe3461$export$efe475f7dd73bf7c = (fieldType, ...args)=>{
    const handlers = $d008083493fe3461$var$createRichValueHandlers();
    if ($d008083493fe3461$export$3c808f0df8be4abb(fieldType)) return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    handlers[fieldType]?.(...args));
    return $d008083493fe3461$export$5da374e426806c6a(fieldType, ...args);
};

});
parcelRegister("euJic", function(module, exports) {

$parcel$export(module.exports, "dateTimeStringValueHandler", () => $81ef20e1a106b6db$export$3364b5b1994fef68);

var $lO4Or = parcelRequire("lO4Or");
const $81ef20e1a106b6db$var$getDateTimeValue = (field)=>field.value || '';
const $81ef20e1a106b6db$export$3364b5b1994fef68 = {
    [(0, $lO4Or.DATETIME_CF_TYPE)]: $81ef20e1a106b6db$var$getDateTimeValue
};

});

parcelRegister("joDw1", function(module, exports) {

$parcel$export(module.exports, "goalStringValueHandler", () => $398c28294d10b3eb$export$fc09a341d50e572e);

var $lO4Or = parcelRequire("lO4Or");
const $398c28294d10b3eb$export$75c4ea7a4006e4cc = (fieldValue)=>{
    // we only keep the first goal object in the store (field value)
    const goalsStringValue = fieldValue.goals.map((goal)=>goal.name).join(', ');
    const remainingCount = fieldValue.totalCount - fieldValue.goals.length;
    if (remainingCount > 0) return `${goalsStringValue} +${remainingCount}`;
    return goalsStringValue;
};
const $398c28294d10b3eb$var$getGoalsSelectValue = (field)=>$398c28294d10b3eb$export$75c4ea7a4006e4cc(field.value);
const $398c28294d10b3eb$export$fc09a341d50e572e = {
    [(0, $lO4Or.GOALS_CF_TYPE)]: $398c28294d10b3eb$var$getGoalsSelectValue
};

});

parcelRegister("fsiWG", function(module, exports) {

$parcel$export(module.exports, "categoryStringValueHandler", () => $77a85ca22e2302a9$export$648bd4153bebf5ec);
$parcel$export(module.exports, "categoryRichValueHandler", () => $77a85ca22e2302a9$export$c7c1e80cbae33846);

var $lO4Or = parcelRequire("lO4Or");
const $77a85ca22e2302a9$var$getCategoryStringValue = (field)=>String(field.value?.value ?? '');
const $77a85ca22e2302a9$export$648bd4153bebf5ec = {
    [(0, $lO4Or.CATEGORY_TYPE)]: $77a85ca22e2302a9$var$getCategoryStringValue
};
const $77a85ca22e2302a9$var$getCategoryRichValue = (field)=>field.value ?? null;
const $77a85ca22e2302a9$export$c7c1e80cbae33846 = {
    [(0, $lO4Or.CATEGORY_TYPE)]: $77a85ca22e2302a9$var$getCategoryRichValue
};

});

parcelRegister("4Ojeu", function(module, exports) {

$parcel$export(module.exports, "checkboxStringValueHandler", () => $5130df98e6a856b4$export$e8595eb8b08dfff6);
$parcel$export(module.exports, "checkboxRichValueHandler", () => $5130df98e6a856b4$export$8c6878c535c99dc0);

var $lO4Or = parcelRequire("lO4Or");
const $5130df98e6a856b4$var$getCheckboxValue = (field)=>String(field.value?.map((option)=>option?.value || '').join(', ') || '');
const $5130df98e6a856b4$export$e8595eb8b08dfff6 = {
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: $5130df98e6a856b4$var$getCheckboxValue
};
const $5130df98e6a856b4$var$getCheckboxRichValue = (field)=>field.value ?? [];
const $5130df98e6a856b4$export$8c6878c535c99dc0 = {
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: $5130df98e6a856b4$var$getCheckboxRichValue
};

});

parcelRegister("5OQpT", function(module, exports) {

$parcel$export(module.exports, "componentsStringValueHandler", () => $81e3a86a6c9a3beb$export$8c05fcecf4920250);
$parcel$export(module.exports, "componentsRichValueHandler", () => $81e3a86a6c9a3beb$export$22a98ba00b45930);

var $lO4Or = parcelRequire("lO4Or");
const $81e3a86a6c9a3beb$var$getComponentsStringValue = (field)=>String(field.value?.map((option)=>option?.name ?? '').join(', ') ?? '');
const $81e3a86a6c9a3beb$export$8c05fcecf4920250 = {
    [(0, $lO4Or.COMPONENTS_TYPE)]: $81e3a86a6c9a3beb$var$getComponentsStringValue
};
const $81e3a86a6c9a3beb$var$getComponentsRichValue = (field)=>field.value ?? [];
const $81e3a86a6c9a3beb$export$22a98ba00b45930 = {
    [(0, $lO4Or.COMPONENTS_TYPE)]: $81e3a86a6c9a3beb$var$getComponentsRichValue
};

});

parcelRegister("cT1pT", function(module, exports) {

$parcel$export(module.exports, "dateStringValueHandler", () => $ffd38bb27bd44539$export$e35cf2b38b82bde);

var $EN9B6 = parcelRequire("EN9B6");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");
const $ffd38bb27bd44539$var$getDateValue = (field)=>field.value && (0, $eI5EY.fg)('list_view_small_bulk_copy_fixes') ? (0, $EN9B6.default)(new Date(field.value), 'yyyy-MM-dd') : field.value || '';
const $ffd38bb27bd44539$export$e35cf2b38b82bde = {
    [(0, $lO4Or.START_DATE_TYPE)]: $ffd38bb27bd44539$var$getDateValue,
    [(0, $lO4Or.UPDATED)]: $ffd38bb27bd44539$var$getDateValue,
    [(0, $lO4Or.CREATED)]: $ffd38bb27bd44539$var$getDateValue,
    [(0, $lO4Or.DUE_DATE_TYPE)]: $ffd38bb27bd44539$var$getDateValue,
    [(0, $lO4Or.DATE_CF_TYPE)]: $ffd38bb27bd44539$var$getDateValue
};

});

parcelRegister("RkH8v", function(module, exports) {

$parcel$export(module.exports, "devSummaryStringValueHandler", () => $77b9f098fce15627$export$92f03a013990abef);

var $lO4Or = parcelRequire("lO4Or");

var $3ZZhY = parcelRequire("3ZZhY");
const $77b9f098fce15627$var$getDevSummaryValue = (field, formatMessage)=>{
    if (formatMessage && field) {
        if (field.isMerged) return formatMessage((0, $3ZZhY.default).merged);
        if (field.isUnderReview) return formatMessage((0, $3ZZhY.default).underReview);
        if (field.commitCount) return formatMessage((0, $3ZZhY.default).commit, {
            count: field.commitCount
        });
    }
    return '';
};
const $77b9f098fce15627$export$92f03a013990abef = {
    [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: $77b9f098fce15627$var$getDevSummaryValue
};

});
parcelRegister("3ZZhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f753c86aa311a950$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f753c86aa311a950$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    underReview: {
        "id": "business-fields.common.field-types.dev-summary.value.under-review",
        "defaultMessage": "Under review"
    },
    merged: {
        "id": "business-fields.common.field-types.dev-summary.value.merged",
        "defaultMessage": "Merged"
    },
    commit: {
        "id": "business-fields.common.field-types.dev-summary.value.commit",
        "defaultMessage": "{count, plural, one {# commit} other {# commits}}"
    }
});

});


parcelRegister("9astv", function(module, exports) {

$parcel$export(module.exports, "groupStringValueHandler", () => $f2ed5e2bfd1b136c$export$520e19bcc394328a);
$parcel$export(module.exports, "groupRichValueHandler", () => $f2ed5e2bfd1b136c$export$2df4c615ae11e379);

var $lO4Or = parcelRequire("lO4Or");
const $f2ed5e2bfd1b136c$var$getSingleGroupValue = (field)=>field.value?.name ?? '';
const $f2ed5e2bfd1b136c$var$getMultipleGroupValue = (field)=>field.value == null ? '' : field.value.map((v)=>v?.name).join(',');
const $f2ed5e2bfd1b136c$var$getSingleGroupRichValue = (field)=>field.value ?? null;
const $f2ed5e2bfd1b136c$var$getMultipleGroupRichValue = (field)=>field.value ?? [];
const $f2ed5e2bfd1b136c$export$520e19bcc394328a = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: $f2ed5e2bfd1b136c$var$getSingleGroupValue,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: $f2ed5e2bfd1b136c$var$getMultipleGroupValue
};
const $f2ed5e2bfd1b136c$export$2df4c615ae11e379 = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: $f2ed5e2bfd1b136c$var$getSingleGroupRichValue,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: $f2ed5e2bfd1b136c$var$getMultipleGroupRichValue
};

});

parcelRegister("25ch1", function(module, exports) {

$parcel$export(module.exports, "keyStringValueHandler", () => $ae96f801a75f45c9$export$6a82d6d16aaf1aae);
const $ae96f801a75f45c9$var$getKeyValue = (field)=>String(field.value || '');
const $ae96f801a75f45c9$export$6a82d6d16aaf1aae = {
    key: $ae96f801a75f45c9$var$getKeyValue
};

});

parcelRegister("kmy9M", function(module, exports) {

$parcel$export(module.exports, "labelsStringValueHandler", () => $82f58d8f913c41c1$export$614150a18e87c3e9);

var $lO4Or = parcelRequire("lO4Or");
const $82f58d8f913c41c1$var$getLabelsValue = (field)=>String(field.value.join(', ') || '');
const $82f58d8f913c41c1$export$614150a18e87c3e9 = {
    [(0, $lO4Or.LABELS_TYPE)]: $82f58d8f913c41c1$var$getLabelsValue,
    [(0, $lO4Or.LABELS_CF_TYPE)]: $82f58d8f913c41c1$var$getLabelsValue
};

});

parcelRegister("eSIrM", function(module, exports) {

$parcel$export(module.exports, "multiSelectStringValueHandler", () => $6c59fa513bc1c63d$export$a8b18450ad254ab4);
$parcel$export(module.exports, "multiSelectRichValueHandler", () => $6c59fa513bc1c63d$export$5b873e39c38cc9ad);

var $lO4Or = parcelRequire("lO4Or");
const $6c59fa513bc1c63d$var$getMultiSelectStringValue = (field)=>String(field.value?.map((option)=>option?.value ?? '').join(', ') ?? '');
const $6c59fa513bc1c63d$export$a8b18450ad254ab4 = {
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: $6c59fa513bc1c63d$var$getMultiSelectStringValue
};
const $6c59fa513bc1c63d$var$getMultiSelectRichValue = (field)=>field.value ?? [];
const $6c59fa513bc1c63d$export$5b873e39c38cc9ad = {
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: $6c59fa513bc1c63d$var$getMultiSelectRichValue
};

});

parcelRegister("gos6X", function(module, exports) {

$parcel$export(module.exports, "numberStringValueHandler", () => $7df6b6a09c279ad1$export$e0e13344aaa5277f);

var $lO4Or = parcelRequire("lO4Or");
const $7df6b6a09c279ad1$var$getNumberValue = (field)=>String(field.value || '');
const $7df6b6a09c279ad1$export$e0e13344aaa5277f = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: $7df6b6a09c279ad1$var$getNumberValue,
    [(0, $lO4Or.STORY_POINTS_TYPE)]: $7df6b6a09c279ad1$var$getNumberValue,
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: $7df6b6a09c279ad1$var$getNumberValue
};

});

parcelRegister("fvlEF", function(module, exports) {

$parcel$export(module.exports, "parentStringValueHandler", () => $b9a8c67ff7dd08e6$export$c53efd3fefacccdb);
$parcel$export(module.exports, "parentRichValueHandler", () => $b9a8c67ff7dd08e6$export$bd920f00473058fd);

var $lO4Or = parcelRequire("lO4Or");
const $b9a8c67ff7dd08e6$var$getParentValue = (field)=>field.value ? field.value.issueKey : '';
const $b9a8c67ff7dd08e6$export$c53efd3fefacccdb = {
    [(0, $lO4Or.PARENT_TYPE)]: $b9a8c67ff7dd08e6$var$getParentValue
};
const $b9a8c67ff7dd08e6$var$getParentRichValue = (field)=>field.value ?? null;
const $b9a8c67ff7dd08e6$export$bd920f00473058fd = {
    [(0, $lO4Or.PARENT_TYPE)]: $b9a8c67ff7dd08e6$var$getParentRichValue
};

});

parcelRegister("kuvVz", function(module, exports) {

$parcel$export(module.exports, "priorityStringValueHandler", () => $e8ab825cd4d4bc62$export$2fcd34cd217ed0e0);
$parcel$export(module.exports, "priorityRichValueHandler", () => $e8ab825cd4d4bc62$export$74a600c7fe980807);

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");
const $e8ab825cd4d4bc62$var$isNewTransformedPriorityField = (field)=>typeof field.value === 'object' && 'name' in (field.value || {});
const $e8ab825cd4d4bc62$var$isOldTransformedPriorityField = (field)=>typeof field.value === 'string';
const $e8ab825cd4d4bc62$var$getPriorityValueOld = (field)=>field.value?.name || '';
const $e8ab825cd4d4bc62$var$getPriorityValue = (field)=>{
    if ((0, $eI5EY.fg)('list_view_small_bulk_copy_fixes')) {
        if ($e8ab825cd4d4bc62$var$isNewTransformedPriorityField(field)) return field.value?.name || '';
        if ($e8ab825cd4d4bc62$var$isOldTransformedPriorityField(field)) return field.value;
        return '';
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $e8ab825cd4d4bc62$var$getPriorityValueOld(field);
};
const $e8ab825cd4d4bc62$export$2fcd34cd217ed0e0 = {
    [(0, $lO4Or.PRIORITY_TYPE)]: $e8ab825cd4d4bc62$var$getPriorityValue
};
const $e8ab825cd4d4bc62$var$getPriorityRichValue = (field)=>field.value || null;
const $e8ab825cd4d4bc62$export$74a600c7fe980807 = {
    [(0, $lO4Or.PRIORITY_TYPE)]: $e8ab825cd4d4bc62$var$getPriorityRichValue
};

});

parcelRegister("hYuEu", function(module, exports) {

$parcel$export(module.exports, "projectStringValueHandler", () => $01bf04ea817e8d0b$export$ac54e893c65fec32);
$parcel$export(module.exports, "projectRichValueHandler", () => $01bf04ea817e8d0b$export$24de57791a81b4b0);

var $lO4Or = parcelRequire("lO4Or");
const $01bf04ea817e8d0b$var$getProjectValue = (field)=>field.value?.name ?? '';
const $01bf04ea817e8d0b$export$ac54e893c65fec32 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $01bf04ea817e8d0b$var$getProjectValue
};
const $01bf04ea817e8d0b$var$getProjectRichValue = (field)=>field.value ?? null;
const $01bf04ea817e8d0b$export$24de57791a81b4b0 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $01bf04ea817e8d0b$var$getProjectRichValue
};

});

parcelRegister("fzsEd", function(module, exports) {

$parcel$export(module.exports, "radioSelectStringValueHandler", () => $cead45896b731956$export$5716e87f97e42f22);
$parcel$export(module.exports, "radioSelectRichValueHandler", () => $cead45896b731956$export$c28597602359ee5);

var $lO4Or = parcelRequire("lO4Or");
const $cead45896b731956$var$getRadioSelectValue = (field)=>field.value?.value ?? '';
const $cead45896b731956$export$5716e87f97e42f22 = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $cead45896b731956$var$getRadioSelectValue
};
const $cead45896b731956$var$getRadioSelectRichValue = (field)=>field.value ?? null;
const $cead45896b731956$export$c28597602359ee5 = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $cead45896b731956$var$getRadioSelectRichValue
};

});

parcelRegister("f9D9e", function(module, exports) {

$parcel$export(module.exports, "resolutionStringValueHandler", () => $bc0697fe6d604839$export$ce4b64838599caf9);

var $lO4Or = parcelRequire("lO4Or");

var $k9nJD = parcelRequire("k9nJD");
const $bc0697fe6d604839$var$getResolutionValue = (field, formatMessage)=>{
    if (field.value?.name) return field.value?.name;
    return formatMessage ? formatMessage((0, $k9nJD.default).unresolvedResolution) : '';
};
const $bc0697fe6d604839$export$ce4b64838599caf9 = {
    [(0, $lO4Or.RESOLUTION_TYPE)]: $bc0697fe6d604839$var$getResolutionValue
};

});
parcelRegister("k9nJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e07459fd45de8b2e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e07459fd45de8b2e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unresolvedResolution: {
        "id": "business-fields.common.field-types.resolution.value.unresolved-resolution",
        "defaultMessage": "Unresolved"
    }
});

});


parcelRegister("kOTJc", function(module, exports) {

$parcel$export(module.exports, "richTextStringValueHandler", () => $caf08f1fc6cf004b$export$b6df34212c07f1f3);

var $lO4Or = parcelRequire("lO4Or");
const $caf08f1fc6cf004b$var$getStringValue = (field)=>String(field.value || '');
const $caf08f1fc6cf004b$export$b6df34212c07f1f3 = {
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: $caf08f1fc6cf004b$var$getStringValue
};

});

parcelRegister("8B6Zu", function(module, exports) {

$parcel$export(module.exports, "singleSelectStringValueHandler", () => $b2e00bb5e8676378$export$6477cb7a98167465);
$parcel$export(module.exports, "singleSelectRichValueHandler", () => $b2e00bb5e8676378$export$8f1681f1304731e9);

var $lO4Or = parcelRequire("lO4Or");
const $b2e00bb5e8676378$var$getSingleSelectValue = (field)=>String(field.value?.value || '');
const $b2e00bb5e8676378$export$6477cb7a98167465 = {
    [(0, $lO4Or.SELECT_CF_TYPE)]: $b2e00bb5e8676378$var$getSingleSelectValue
};
const $b2e00bb5e8676378$var$getSingleSelectRichValue = (field)=>field.value || null;
const $b2e00bb5e8676378$export$8f1681f1304731e9 = {
    [(0, $lO4Or.SELECT_CF_TYPE)]: $b2e00bb5e8676378$var$getSingleSelectRichValue
};

});

parcelRegister("iZ3D5", function(module, exports) {

$parcel$export(module.exports, "sprintStringValueHandler", () => $e0fda199a48bfc57$export$c934a6ef333435f4);
$parcel$export(module.exports, "sprintRichValueHandler", () => $e0fda199a48bfc57$export$363144cf26cab14d);

var $lO4Or = parcelRequire("lO4Or");
const $e0fda199a48bfc57$var$getSprintStringValue = (field)=>String(field.value?.map((option)=>option?.name ?? '').join(', ') ?? '');
const $e0fda199a48bfc57$export$c934a6ef333435f4 = {
    [(0, $lO4Or.SPRINT_TYPE)]: $e0fda199a48bfc57$var$getSprintStringValue
};
const $e0fda199a48bfc57$var$getSprintRichValue = (field)=>field.value ?? [];
const $e0fda199a48bfc57$export$363144cf26cab14d = {
    [(0, $lO4Or.SPRINT_TYPE)]: $e0fda199a48bfc57$var$getSprintRichValue
};

});

parcelRegister("lqLo4", function(module, exports) {

$parcel$export(module.exports, "statusCategoryStringValueHandler", () => $162d17be218302c2$export$fbf872252a7f1d2d);

var $lO4Or = parcelRequire("lO4Or");
const $162d17be218302c2$var$getStatusCategoryValue = (field)=>field.value?.name ?? '';
const $162d17be218302c2$export$fbf872252a7f1d2d = {
    [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: $162d17be218302c2$var$getStatusCategoryValue
};

});

parcelRegister("czRzv", function(module, exports) {

$parcel$export(module.exports, "statusStringValueHandler", () => $b04116f176323565$export$237f3a01398656da);

var $lO4Or = parcelRequire("lO4Or");
const $b04116f176323565$var$getStatusValue = (field)=>String(field.name || '');
const $b04116f176323565$export$237f3a01398656da = {
    [(0, $lO4Or.STATUS_TYPE)]: $b04116f176323565$var$getStatusValue
};

});

parcelRegister("jG0vv", function(module, exports) {

$parcel$export(module.exports, "teamStringValueHandler", () => $0e2610139bb58973$export$b5a765abdc307683);
$parcel$export(module.exports, "teamRichValueHandler", () => $0e2610139bb58973$export$c73de7087af53cf7);

var $lO4Or = parcelRequire("lO4Or");
const $0e2610139bb58973$var$getTeamValue = (field)=>field.value?.name ?? '';
const $0e2610139bb58973$export$b5a765abdc307683 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: $0e2610139bb58973$var$getTeamValue
};
const $0e2610139bb58973$var$getTeamRichValue = (field)=>field.value ?? null;
const $0e2610139bb58973$export$c73de7087af53cf7 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: $0e2610139bb58973$var$getTeamRichValue
};

});

parcelRegister("1lG3P", function(module, exports) {

$parcel$export(module.exports, "textStringValueHandler", () => $71db45eb582dfce4$export$ec13eae086c24fc4);

var $lO4Or = parcelRequire("lO4Or");
const $71db45eb582dfce4$var$getTextValue = (field)=>String(field.value || '');
const $71db45eb582dfce4$export$ec13eae086c24fc4 = {
    [(0, $lO4Or.SUMMARY_TYPE)]: $71db45eb582dfce4$var$getTextValue,
    [(0, $lO4Or.TEXT_CF_TYPE)]: $71db45eb582dfce4$var$getTextValue
};

});

parcelRegister("i2HLN", function(module, exports) {

$parcel$export(module.exports, "timeTrackingStringValueHandler", () => $913f22ca26e2507b$export$d2867bf3f48fbaac);

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");
const $913f22ca26e2507b$var$getStringValue = (field)=>(0, $eI5EY.fg)('list_view_small_bulk_copy_fixes') ? field.value?.timeAsString || '' : String(field.value?.timeInSeconds || '');
const $913f22ca26e2507b$export$d2867bf3f48fbaac = {
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: $913f22ca26e2507b$var$getStringValue
};

});

parcelRegister("gXXVe", function(module, exports) {

$parcel$export(module.exports, "typeStringValueHandler", () => $f09ccae267c636b7$export$8a5121728c374439);

var $lO4Or = parcelRequire("lO4Or");
const $f09ccae267c636b7$var$getTypeValue = (field)=>String(field.value || '');
const $f09ccae267c636b7$export$8a5121728c374439 = {
    [(0, $lO4Or.ISSUE_TYPE)]: $f09ccae267c636b7$var$getTypeValue
};

});

parcelRegister("aPp7f", function(module, exports) {

$parcel$export(module.exports, "urlStringValueHandler", () => $20a1c09842740a68$export$7f5de2e826ef2c21);

var $lO4Or = parcelRequire("lO4Or");
const $20a1c09842740a68$var$getUrlValue = (field)=>String(field.value || '');
const $20a1c09842740a68$export$7f5de2e826ef2c21 = {
    [(0, $lO4Or.URL_CF_TYPE)]: $20a1c09842740a68$var$getUrlValue
};

});

parcelRegister("e1ahQ", function(module, exports) {

$parcel$export(module.exports, "userStringValueHandler", () => $5d2f7f4334a15e66$export$160c08a2783fe34b);
$parcel$export(module.exports, "userRichValueHandler", () => $5d2f7f4334a15e66$export$5fad1a6b4b204395);

var $lO4Or = parcelRequire("lO4Or");
const $5d2f7f4334a15e66$var$getUserStringValue = (field)=>String(field.value?.name || '');
const $5d2f7f4334a15e66$var$getUsersStringValue = (field)=>String(field.value.map((user)=>user?.name).join(', ') || '');
const $5d2f7f4334a15e66$export$160c08a2783fe34b = {
    [(0, $lO4Or.USER_CF_TYPE)]: $5d2f7f4334a15e66$var$getUserStringValue,
    [(0, $lO4Or.REPORTER_TYPE)]: $5d2f7f4334a15e66$var$getUserStringValue,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $5d2f7f4334a15e66$var$getUserStringValue,
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: $5d2f7f4334a15e66$var$getUsersStringValue,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: $5d2f7f4334a15e66$var$getUsersStringValue
};
const $5d2f7f4334a15e66$var$getUserRichValue = (field)=>field.value || null;
const $5d2f7f4334a15e66$var$getUserListRichValue = (field)=>field.value || [];
const $5d2f7f4334a15e66$export$5fad1a6b4b204395 = {
    [(0, $lO4Or.USER_CF_TYPE)]: $5d2f7f4334a15e66$var$getUserRichValue,
    [(0, $lO4Or.REPORTER_TYPE)]: $5d2f7f4334a15e66$var$getUserRichValue,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $5d2f7f4334a15e66$var$getUserRichValue,
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: $5d2f7f4334a15e66$var$getUserListRichValue,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: $5d2f7f4334a15e66$var$getUserListRichValue
};

});

parcelRegister("iO2v7", function(module, exports) {

$parcel$export(module.exports, "versionStringValueHandler", () => $5a4089cb83dd3276$export$608329dccbc25996);
$parcel$export(module.exports, "versionRichValueHandler", () => $5a4089cb83dd3276$export$534995286ab15bde);

var $lO4Or = parcelRequire("lO4Or");
const $5a4089cb83dd3276$var$getSingleVersionValue = (field)=>field.value?.name ?? '';
const $5a4089cb83dd3276$var$getMultipleVersionValue = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $5a4089cb83dd3276$var$getSingleVersionRichValue = (field)=>field.value ?? null;
const $5a4089cb83dd3276$var$getMultipleVersionRichValue = (field)=>field.value ?? [];
const $5a4089cb83dd3276$export$608329dccbc25996 = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $5a4089cb83dd3276$var$getSingleVersionValue,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionValue,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionValue,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionValue
};
const $5a4089cb83dd3276$export$534995286ab15bde = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $5a4089cb83dd3276$var$getSingleVersionRichValue,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionRichValue,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionRichValue,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionRichValue
};

});





parcelRegister("ctkxZ", function(module, exports) {

$parcel$export(module.exports, "categoryClipboardHandler", () => $7eb726a413de409b$export$b2a7ae1b92d8afd3);

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $69Iuh = parcelRequire("69Iuh");
const $7eb726a413de409b$var$isCategory = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'id' in fieldValue;
const $7eb726a413de409b$var$isTransformedCategory = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'optionId' in fieldValue;
const $7eb726a413de409b$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $69Iuh.categorySupportedTypes))) return null;
    if (!$7eb726a413de409b$var$isCategory(metadata.fieldValue)) return null;
    return metadata.fieldValue;
};
const $7eb726a413de409b$var$useCategoryClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: (0, $lO4Or.CATEGORY_TYPE),
        initialValue: field.value && $7eb726a413de409b$var$isTransformedCategory(field.value) ? {
            id: field.value.optionId,
            value: field.value.value,
            color: field.value?.color
        } : null
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.value || '',
        currentValue: value,
        getPastedValue: $7eb726a413de409b$var$getPastedValue,
        saveValue: saveValue
    });
};
const $7eb726a413de409b$var$CategoryClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($7eb726a413de409b$var$useCategoryClipboardHandler);
const $7eb726a413de409b$export$b2a7ae1b92d8afd3 = {
    [(0, $lO4Or.CATEGORY_TYPE)]: $7eb726a413de409b$var$CategoryClipboardHelper
};

});
parcelRegister("69Iuh", function(module, exports) {

$parcel$export(module.exports, "categorySupportedTypes", () => $d49feed23d45c461$export$7a3abb279a994c7d);

var $lO4Or = parcelRequire("lO4Or");
const $d49feed23d45c461$export$7a3abb279a994c7d = [
    (0, $lO4Or.CATEGORY_TYPE)
];

});


parcelRegister("h4XEw", function(module, exports) {

$parcel$export(module.exports, "checkboxClipboardHandler", () => $ed7eae438cfded43$export$a637ce753d346a9a);

var $3kVrU = parcelRequire("3kVrU");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $gcaYz = parcelRequire("gcaYz");
const $ed7eae438cfded43$var$isTransformedCheckboxOption = (option)=>!!option && typeof option === 'object' && 'optionId' in option && 'value' in option;
const $ed7eae438cfded43$var$isTransformedCheckbox = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($ed7eae438cfded43$var$isTransformedCheckboxOption);
const $ed7eae438cfded43$var$isCheckboxValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>!!option && typeof option === 'object' && 'id' in option && 'value' in option);
const $ed7eae438cfded43$var$emptyValue = [];
const $ed7eae438cfded43$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $gcaYz.checkboxSupportedTypes))) return [];
    if (!$ed7eae438cfded43$var$isCheckboxValue(metadata?.fieldValue)) return [];
    return metadata?.fieldValue ?? [];
};
function $ed7eae438cfded43$var$assertCheckboxField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) throw new Error('Field type is not supported');
}
const $ed7eae438cfded43$var$useCheckboxClipboardHandler = (issue, field)=>{
    $ed7eae438cfded43$var$assertCheckboxField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $3kVrU.useCheckboxSelectField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        initialValue: $ed7eae438cfded43$var$isTransformedCheckbox(field.value) ? field.value.filter(Boolean).map((option)=>({
                id: option.optionId,
                value: option.value ?? ''
            })) : undefined
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map((option)=>option?.value || '').join(', ') || '',
        currentValue: value,
        getPastedValue: $ed7eae438cfded43$var$getPastedValue,
        saveValue: saveValue,
        emptyValue: $ed7eae438cfded43$var$emptyValue
    });
};
const $ed7eae438cfded43$var$CheckboxClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($ed7eae438cfded43$var$useCheckboxClipboardHandler);
const $ed7eae438cfded43$export$a637ce753d346a9a = {
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: $ed7eae438cfded43$var$CheckboxClipboardHelper
};

});
parcelRegister("3kVrU", function(module, exports) {

$parcel$export(module.exports, "useCheckboxSelectField", () => $5ddb6026d509605f$export$64fe88e084e8ce22);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $btjMs = parcelRequire("btjMs");
const $5ddb6026d509605f$export$64fe88e084e8ce22 = ({ issueKey: issueKey, initialValue: initialValue = null, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, $btjMs.getFieldType)(fieldConfig.value) || 'array';
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});
parcelRegister("btjMs", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $2e3967e17ab00816$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $2e3967e17ab00816$export$24d1b07fa0e9f9f1);


var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");
const $2e3967e17ab00816$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $f9RL0.specialFields)();
    return [
        ...(0, $f9RL0.customFieldsToDisplay)().filter((cf)=>!(0, $f9RL0.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $lO4Or.FLAGGED_CF_TYPE)
    ];
};
const $2e3967e17ab00816$export$f521834fc2bfcd81 = (custom)=>$2e3967e17ab00816$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $2e3967e17ab00816$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $2e3967e17ab00816$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $2e3967e17ab00816$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) || $2e3967e17ab00816$export$b9089a6e41ed43aa(field) === (0, $lO4Or.DESCRIPTION_TYPE) : false;
};

});
parcelRegister("f9RL0", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $3183c1ede6a2aff4$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $3183c1ede6a2aff4$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $3183c1ede6a2aff4$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $3183c1ede6a2aff4$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $3183c1ede6a2aff4$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $3183c1ede6a2aff4$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $3183c1ede6a2aff4$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $3183c1ede6a2aff4$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $3183c1ede6a2aff4$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $3183c1ede6a2aff4$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $3183c1ede6a2aff4$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $3183c1ede6a2aff4$export$79b91d4669dcadcb);
$parcel$export(module.exports, "DEV_SUMMARY", () => $3183c1ede6a2aff4$export$950d47e775e208ee);
$parcel$export(module.exports, "EPIC", () => $3183c1ede6a2aff4$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $3183c1ede6a2aff4$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $3183c1ede6a2aff4$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $3183c1ede6a2aff4$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $3183c1ede6a2aff4$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $3183c1ede6a2aff4$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $3183c1ede6a2aff4$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $3183c1ede6a2aff4$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SLA_PANEL", () => $3183c1ede6a2aff4$export$1d0e0bb6a21b800b);
$parcel$export(module.exports, "LINKED_ALERTS", () => $3183c1ede6a2aff4$export$340fac260c3e3637);
$parcel$export(module.exports, "CHAT_CHANNEL", () => $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef);
$parcel$export(module.exports, "MSTEAMS_CHANNEL", () => $3183c1ede6a2aff4$export$8631065e0909313);
$parcel$export(module.exports, "ZOOM_MEETING", () => $3183c1ede6a2aff4$export$3c4dccba7d7e0acb);
$parcel$export(module.exports, "CONFERENCE_CALL", () => $3183c1ede6a2aff4$export$cd5e9246357daec3);
$parcel$export(module.exports, "KNOWLEDGE_BASE", () => $3183c1ede6a2aff4$export$203643a6fd9496a0);
$parcel$export(module.exports, "SENTIMENT", () => $3183c1ede6a2aff4$export$9c83bd19c3ffd90d);
$parcel$export(module.exports, "ASSET_ONBOARDING", () => $3183c1ede6a2aff4$export$c5c04443c6097d6e);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS", () => $3183c1ede6a2aff4$export$26d855f4cd7e5fe9);
$parcel$export(module.exports, "SUMMARY", () => $3183c1ede6a2aff4$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $3183c1ede6a2aff4$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $3183c1ede6a2aff4$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $3183c1ede6a2aff4$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $3183c1ede6a2aff4$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $3183c1ede6a2aff4$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $3183c1ede6a2aff4$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $3183c1ede6a2aff4$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $3183c1ede6a2aff4$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $3183c1ede6a2aff4$export$aba22e09a66f6826);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $3183c1ede6a2aff4$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $3183c1ede6a2aff4$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $3183c1ede6a2aff4$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $3183c1ede6a2aff4$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $3183c1ede6a2aff4$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $3183c1ede6a2aff4$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $3183c1ede6a2aff4$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $3183c1ede6a2aff4$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $3183c1ede6a2aff4$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $3183c1ede6a2aff4$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $3183c1ede6a2aff4$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $3183c1ede6a2aff4$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $3183c1ede6a2aff4$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $3183c1ede6a2aff4$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $3183c1ede6a2aff4$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");

var $lO4Or = parcelRequire("lO4Or");
const $3183c1ede6a2aff4$export$ebb48b08205007c5 = 'issuetype';
const $3183c1ede6a2aff4$export$a464614f8f5fe986 = 'summary';
const $3183c1ede6a2aff4$export$a311a3c9b207604e = 'parent';
const $3183c1ede6a2aff4$export$2a4f270075a033de = 'parent-issue';
const $3183c1ede6a2aff4$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $3183c1ede6a2aff4$export$289917d9a7031e1d = 'watches';
const $3183c1ede6a2aff4$export$81614f6dc3be5b00 = 'votes';
const $3183c1ede6a2aff4$export$72a5630aa398d6b4 = 'security';
const $3183c1ede6a2aff4$export$caf1ff54fbdf44bf = 'issuerestriction';
const $3183c1ede6a2aff4$export$f8f7545d2bb78afb = 'assignee';
const $3183c1ede6a2aff4$export$6d7021166edc895c = 'reporter';
const $3183c1ede6a2aff4$export$cf7e173386d30cdd = 'duedate';
const $3183c1ede6a2aff4$export$bb34f3538ba26c7e = 'priority';
const $3183c1ede6a2aff4$export$79b91d4669dcadcb = 'labels';
const $3183c1ede6a2aff4$export$cbedbfe2cd0caec7 = 'components';
const $3183c1ede6a2aff4$export$950d47e775e208ee = 'devSummary';
const $3183c1ede6a2aff4$export$f91d2bb4cc99fa5e = 'releases';
const $3183c1ede6a2aff4$export$a316570a0dbfd2b0 = 'sprint';
const $3183c1ede6a2aff4$export$405b6d72f2d243a9 = 'storyPointsField';
const $3183c1ede6a2aff4$export$3cb4a99a332e4186 = 'epic';
const $3183c1ede6a2aff4$export$d7e18f5730074533 = 'fixVersions';
const $3183c1ede6a2aff4$export$c435f0000304e508 = 'versions';
const $3183c1ede6a2aff4$export$ee99ef6ee562a446 = 'timetracking';
const $3183c1ede6a2aff4$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $3183c1ede6a2aff4$export$e50006273435e7d4 = 'status';
const $3183c1ede6a2aff4$export$f1a6ce22cbb7eb32 = 'resolution';
const $3183c1ede6a2aff4$export$ff39ebd4bb12b718 = 'created';
const $3183c1ede6a2aff4$export$cd8e68094cb5c3cb = 'updated';
const $3183c1ede6a2aff4$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $3183c1ede6a2aff4$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $3183c1ede6a2aff4$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $3183c1ede6a2aff4$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $3183c1ede6a2aff4$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $3183c1ede6a2aff4$export$203643a6fd9496a0 = 'KNOWLEDGE_BASE';
const $3183c1ede6a2aff4$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $3183c1ede6a2aff4$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $3183c1ede6a2aff4$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $3183c1ede6a2aff4$export$913055729e1380b2 = 'summary';
const $3183c1ede6a2aff4$export$d44826c816b5619b = 'description';
const $3183c1ede6a2aff4$export$a29989082612d0d9 = 'comment';
const $3183c1ede6a2aff4$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $3183c1ede6a2aff4$export$3b3d0889022c85b3 = 'children-issues';
const $3183c1ede6a2aff4$export$be46596bc6608f3b = 'environment';
const $3183c1ede6a2aff4$export$f528fadbfdb3c25e = 'subtasks';
const $3183c1ede6a2aff4$export$f10e53e8928b61bd = 'dataclassification';
const $3183c1ede6a2aff4$export$e0dfb65d1047c53c = (0, $lO4Or.PARENT_CF_TYPE);
const $3183c1ede6a2aff4$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $3183c1ede6a2aff4$export$cdbd1eb3b05729e0 = 'flagActions';
const $3183c1ede6a2aff4$export$c161a774ec2e7e56 = 'cardCoverActions';
const $3183c1ede6a2aff4$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$3183c1ede6a2aff4$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$3183c1ede6a2aff4$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$3183c1ede6a2aff4$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $lO4Or.TEAM_CF_TYPE)]: (0, $lO4Or.TEAM_CF_TYPE),
        [(0, $lO4Or.PARENT_CF_TYPE)]: (0, $lO4Or.PARENT_CF_TYPE),
        [(0, $lO4Or.BASELINE_START_CF_TYPE)]: (0, $lO4Or.BASELINE_START_CF_TYPE),
        [(0, $lO4Or.BASELINE_END_CF_TYPE)]: (0, $lO4Or.BASELINE_END_CF_TYPE),
        [(0, $lO4Or.COLOR_CF_TYPE)]: (0, $lO4Or.COLOR_CF_TYPE),
        [(0, $lO4Or.EPIC_COLOR_TYPE)]: (0, $lO4Or.EPIC_COLOR_TYPE),
        [(0, $lO4Or.EPIC_NAME_TYPE)]: (0, $lO4Or.EPIC_NAME_TYPE)
    };
    return fields;
};
const $3183c1ede6a2aff4$export$87934b3672715c91 = [
    (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $3183c1ede6a2aff4$var$serviceDeskCustomFields = [
    (0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $lO4Or.ORGANIZATIONS_CF_TYPE),
    (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE),
    (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE),
    (0, $lO4Or.APPROVALS_CF_TYPE),
    (0, $lO4Or.APPROVERS_LIST_CF_TYPE),
    (0, $lO4Or.REQUEST_TYPE_CF_TYPE),
    (0, $lO4Or.CMDB_OBJECT_CF_TYPE),
    (0, $lO4Or.RESPONDERS_CF_TYPE),
    (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE),
    (0, $lO4Or.ENTITLEMENT_CF_TYPE),
    (0, $lO4Or.SENTIMENT_CF_TYPE)
];
const $3183c1ede6a2aff4$export$efd443bccc4c01ed = ()=>[
        (0, $lO4Or.LABELS_CF_TYPE),
        (0, $lO4Or.TEXT_CF_TYPE),
        (0, $lO4Or.MULTI_USER_CF_TYPE),
        (0, $lO4Or.PARTICIPANTS_CF_TYPE),
        (0, $lO4Or.URL_CF_TYPE),
        (0, $lO4Or.NUMBER_CF_TYPE),
        (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $lO4Or.SELECT_CF_TYPE),
        (0, $lO4Or.MULTI_SELECT_CF_TYPE),
        (0, $lO4Or.VERSION_CF_TYPE),
        (0, $lO4Or.TEXT_AREA_CF_TYPE),
        (0, $lO4Or.MULTI_VERSION_CF_TYPE),
        (0, $lO4Or.DATE_CF_TYPE),
        (0, $lO4Or.GROUP_CF_TYPE),
        (0, $lO4Or.MULTI_GROUP_CF_TYPE),
        (0, $lO4Or.USER_CF_TYPE),
        (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
        (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
        (0, $lO4Or.DATETIME_CF_TYPE),
        (0, $lO4Or.ASSETS_CF_TYPE),
        (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
        (0, $lO4Or.PEOPLE_CF_TYPE),
        (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
        (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
        (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
        (0, $lO4Or.READ_ONLY_CF_TYPE),
        (0, $lO4Or.EPIC_STATUS_TYPE),
        (0, $lO4Or.MESSAGE_VIEW_CF_TYPE),
        (0, $lO4Or.MESSAGE_EDIT_CF_TYPE),
        (0, $lO4Or.CATEGORY_TYPE),
        (0, $lO4Or.GOALS_CF_TYPE),
        ...$3183c1ede6a2aff4$export$87934b3672715c91,
        ...$3183c1ede6a2aff4$var$serviceDeskCustomFields
    ];
const $3183c1ede6a2aff4$export$a18b3a656ee9c709 = {
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $7ZZxN.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $3183c1ede6a2aff4$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $3183c1ede6a2aff4$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0,
            $3183c1ede6a2aff4$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $2wUFy.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $3183c1ede6a2aff4$export$aebf676dfa727a1c();
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $3183c1ede6a2aff4$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $3183c1ede6a2aff4$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
    }
    return $3183c1ede6a2aff4$export$27e0678365e5dcff();
};

});



parcelRegister("gcaYz", function(module, exports) {

$parcel$export(module.exports, "checkboxSupportedTypes", () => $b10ae96510d2501d$export$432ca25b66c37cc2);

var $lO4Or = parcelRequire("lO4Or");
const $b10ae96510d2501d$export$432ca25b66c37cc2 = [
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)
];

});


parcelRegister("jNdzl", function(module, exports) {

$parcel$export(module.exports, "componentsClipboardHandler", () => $0d8972d026e3d3d0$export$4edb8679282799b3);

var $eUqFw = parcelRequire("eUqFw");

var $hs4xt = parcelRequire("hs4xt");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $gFwk1 = parcelRequire("gFwk1");
const $0d8972d026e3d3d0$var$isTransformedComponentsOption = (option)=>!!option && typeof option === 'object' && 'componentId' in option && 'name' in option;
const $0d8972d026e3d3d0$var$isTransformedComponents = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($0d8972d026e3d3d0$var$isTransformedComponentsOption);
const $0d8972d026e3d3d0$var$isValidComponentsValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>!!option && typeof option === 'object' && 'id' in option && 'name' in option);
const $0d8972d026e3d3d0$var$emptyValue = [];
const $0d8972d026e3d3d0$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $gFwk1.componentsSupportedTypes))) return [];
    if (!$0d8972d026e3d3d0$var$isValidComponentsValue(metadata?.fieldValue)) return [];
    return metadata?.fieldValue;
};
function $0d8972d026e3d3d0$var$assertComponentsField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.COMPONENTS_TYPE)) throw new Error('Field type is not supported');
}
const $0d8972d026e3d3d0$var$useComponentsClipboardHandler = (issue, field)=>{
    $0d8972d026e3d3d0$var$assertComponentsField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $hs4xt.useComponentsField)({
        issueKey: issue.key,
        initialValue: $0d8972d026e3d3d0$var$isTransformedComponents(field?.value) ? field.value.map((component)=>({
                id: component.componentId,
                name: component.name
            })) : $0d8972d026e3d3d0$var$emptyValue
    });
    const saveValueFn = (0, $eUqFw.useCallback)((valueToSave, meta, analyticsEvent)=>/**
			 * Wrap saveValue to make sure the saved value is never set to `null`
			 */ saveValue(valueToSave ?? [], meta, analyticsEvent), [
        saveValue
    ]);
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map(({ name: name })=>name).join(', ') || '',
        currentValue: value,
        getPastedValue: $0d8972d026e3d3d0$var$getPastedValue,
        saveValue: saveValueFn
    });
};
const $0d8972d026e3d3d0$var$ComponentsClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($0d8972d026e3d3d0$var$useComponentsClipboardHandler);
const $0d8972d026e3d3d0$export$4edb8679282799b3 = {
    [(0, $lO4Or.COMPONENTS_TYPE)]: $0d8972d026e3d3d0$var$ComponentsClipboardHelper
};

});
parcelRegister("hs4xt", function(module, exports) {

$parcel$export(module.exports, "useComponentsField", () => $4f90c282b64d4b9f$export$adf68b6acc459cc4);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

const $4f90c282b64d4b9f$export$adf68b6acc459cc4 = ({ issueKey: issueKey, initialValue: initialValue, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, (0, $ebc098a76317be78$export$98a935eb30de54ab));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'array');
    const [{ loading: loading, value: value, error: error }, { saveById: saveById, saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $ebc098a76317be78$export$98a935eb30de54ab),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});
const $ebc098a76317be78$export$e18419056f3d184a = 'assignee';
const $ebc098a76317be78$export$45cafdfd629c3ca1 = 'reporter';
const $ebc098a76317be78$export$d5bc879e3b748593 = 'description';
const $ebc098a76317be78$export$a68dbc90211df1a8 = 'fixVersions';
const $ebc098a76317be78$export$93605f2a09aa8d26 = 'labels';
const $ebc098a76317be78$export$4420b7468f889692 = 'status';
const $ebc098a76317be78$export$e7cf1830fe735d1f = 'summary';
const $ebc098a76317be78$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $ebc098a76317be78$export$a5fc282ab2bf9b89 = 'issuelinks';
const $ebc098a76317be78$export$b52547457d714bc0 = 'epic-issues';
const $ebc098a76317be78$export$3cca6e37a5823d5a = 'children-issues';
const $ebc098a76317be78$export$98a935eb30de54ab = 'components';


parcelRegister("gFwk1", function(module, exports) {

$parcel$export(module.exports, "componentsSupportedTypes", () => $3f70833a116d9732$export$99fbea5790ee13d2);

var $lO4Or = parcelRequire("lO4Or");
const $3f70833a116d9732$export$99fbea5790ee13d2 = [
    (0, $lO4Or.COMPONENTS_TYPE)
];

});


parcelRegister("fAOKd", function(module, exports) {

$parcel$export(module.exports, "dateClipboardHandler", () => $2aa73fa7c83b6a05$export$e718187ed2d7ce50);

var $6c1W0 = parcelRequire("6c1W0");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $6xy2l = parcelRequire("6xy2l");
const $2aa73fa7c83b6a05$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $6xy2l.dateSupportedTypes))) return null;
    return clipboardItem.plainText;
};
function $2aa73fa7c83b6a05$var$assertDateField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.START_DATE_TYPE) && field.type !== (0, $lO4Or.UPDATED) && field.type !== (0, $lO4Or.CREATED) && field.type !== (0, $lO4Or.DUE_DATE_TYPE) && field.type !== (0, $lO4Or.DATE_CF_TYPE)) throw new Error('Field type is not supported');
}
const $2aa73fa7c83b6a05$var$useDateClipboardHandler = (issue, field)=>{
    $2aa73fa7c83b6a05$var$assertDateField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $6c1W0.useDateField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: field?.value
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value,
        currentValue: value,
        getPastedValue: $2aa73fa7c83b6a05$var$getPastedValue,
        saveValue: saveValue
    });
};
const $2aa73fa7c83b6a05$var$DateClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($2aa73fa7c83b6a05$var$useDateClipboardHandler);
const $2aa73fa7c83b6a05$export$e718187ed2d7ce50 = {
    [(0, $lO4Or.START_DATE_TYPE)]: $2aa73fa7c83b6a05$var$DateClipboardHelper,
    [(0, $lO4Or.UPDATED)]: $2aa73fa7c83b6a05$var$DateClipboardHelper,
    [(0, $lO4Or.CREATED)]: $2aa73fa7c83b6a05$var$DateClipboardHelper,
    [(0, $lO4Or.DUE_DATE_TYPE)]: $2aa73fa7c83b6a05$var$DateClipboardHelper,
    [(0, $lO4Or.DATE_CF_TYPE)]: $2aa73fa7c83b6a05$var$DateClipboardHelper
};

});
parcelRegister("6c1W0", function(module, exports) {

$parcel$export(module.exports, "useDateField", () => $7692b2da789358d0$export$5591b0b878c1a989);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $7692b2da789358d0$export$5591b0b878c1a989 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSuccess: onSuccess })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.type ?? 'date';
    const [{ loading: loading, value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSuccess: onSuccess
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("6xy2l", function(module, exports) {

$parcel$export(module.exports, "dateSupportedTypes", () => $ba294b5cfcdf4821$export$c1d8f1bf05dab6ae);

var $lO4Or = parcelRequire("lO4Or");
const $ba294b5cfcdf4821$export$c1d8f1bf05dab6ae = [
    (0, $lO4Or.START_DATE_TYPE),
    (0, $lO4Or.UPDATED),
    (0, $lO4Or.CREATED),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.DATE_CF_TYPE)
];

});


parcelRegister("itK3v", function(module, exports) {

$parcel$export(module.exports, "dateTimeClipboardHandler", () => $4827bafd30cf6b12$export$6fbf80b68eb3090c);

var $j9Hm5 = parcelRequire("j9Hm5");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $laQ5X = parcelRequire("laQ5X");
const $4827bafd30cf6b12$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $laQ5X.dateTimeSupportedTypes))) return null;
    return clipboardItem.plainText;
};
function $4827bafd30cf6b12$var$assertDateTimeField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.DATETIME_CF_TYPE)) throw new Error('Field type is not supported');
}
const $4827bafd30cf6b12$var$useDateTimeClipboardHandler = (issue, field)=>{
    $4827bafd30cf6b12$var$assertDateTimeField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $j9Hm5.useDateTimeField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: field?.value || null
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value,
        currentValue: value,
        getPastedValue: $4827bafd30cf6b12$var$getPastedValue,
        saveValue: saveValue
    });
};
const $4827bafd30cf6b12$var$DateTimeClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($4827bafd30cf6b12$var$useDateTimeClipboardHandler);
const $4827bafd30cf6b12$export$6fbf80b68eb3090c = {
    [(0, $lO4Or.DATETIME_CF_TYPE)]: $4827bafd30cf6b12$var$DateTimeClipboardHelper
};

});
parcelRegister("j9Hm5", function(module, exports) {

$parcel$export(module.exports, "useDateTimeField", () => $8718ed734e82bf7e$export$2c2e7f1ceedfa8fa);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $8718ed734e82bf7e$export$2c2e7f1ceedfa8fa = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSuccess: onSuccess, onFailure: onFailure })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.type ?? 'datetime';
    const [{ loading: loading, value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("laQ5X", function(module, exports) {

$parcel$export(module.exports, "dateTimeSupportedTypes", () => $5882c179372923c3$export$80f63aa16e4e1227);

var $lO4Or = parcelRequire("lO4Or");
const $5882c179372923c3$export$80f63aa16e4e1227 = [
    (0, $lO4Or.DATETIME_CF_TYPE)
];

});


parcelRegister("dL0dH", function(module, exports) {

$parcel$export(module.exports, "groupClipboardHandler", () => $6aaa0f995c59fce3$export$ae43e91e8e2e40e7);

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $9wDFL = parcelRequire("9wDFL");
const $6aaa0f995c59fce3$var$isTransformedSingleGroup = (option)=>!!option && typeof option === 'object' && 'groupId' in option && 'name' in option;
const $6aaa0f995c59fce3$var$isTransformedMultipleGroups = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($6aaa0f995c59fce3$var$isTransformedSingleGroup);
const $6aaa0f995c59fce3$var$emptyValue = [];
const $6aaa0f995c59fce3$var$getPastedSingleGroupValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $9wDFL.groupSupportedTypes))) return null;
    if (!$6aaa0f995c59fce3$var$isTransformedSingleGroup(metadata.fieldValue)) return null;
    return metadata?.fieldValue;
};
const $6aaa0f995c59fce3$var$getPastedMultipleGroupsValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $9wDFL.groupSupportedTypes))) return null;
    if (!$6aaa0f995c59fce3$var$isTransformedMultipleGroups(metadata.fieldValue)) return null;
    return metadata?.fieldValue;
};
const $6aaa0f995c59fce3$var$useSingleGroupClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: field.type,
        initialValue: $6aaa0f995c59fce3$var$isTransformedSingleGroup(field.value) ? field.value : null
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.name || null,
        currentValue: value,
        getPastedValue: $6aaa0f995c59fce3$var$getPastedSingleGroupValue,
        saveValue: saveValue
    });
};
const $6aaa0f995c59fce3$var$useMultipleGroupsClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: field.type,
        initialValue: $6aaa0f995c59fce3$var$isTransformedMultipleGroups(field.value) ? field.value : $6aaa0f995c59fce3$var$emptyValue
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map((group)=>group.name).join(', ') || null,
        currentValue: value,
        getPastedValue: $6aaa0f995c59fce3$var$getPastedMultipleGroupsValue,
        saveValue: saveValue
    });
};
const $6aaa0f995c59fce3$var$SingleGroupClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($6aaa0f995c59fce3$var$useSingleGroupClipboardHandler);
const $6aaa0f995c59fce3$var$MultipleGroupsClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($6aaa0f995c59fce3$var$useMultipleGroupsClipboardHandler);
const $6aaa0f995c59fce3$export$ae43e91e8e2e40e7 = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: $6aaa0f995c59fce3$var$SingleGroupClipboardHelper,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: $6aaa0f995c59fce3$var$MultipleGroupsClipboardHelper
};

});

parcelRegister("ibP9o", function(module, exports) {

$parcel$export(module.exports, "labelsClipboardHandler", () => $3eaf5d4878c2478d$export$b0d4c8fecec395de);

var $chsVw = parcelRequire("chsVw");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");
const $3eaf5d4878c2478d$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, [
        (0, $lO4Or.LABELS_TYPE),
        (0, $lO4Or.LABELS_CF_TYPE)
    ])) return null;
    return clipboardItem.plainText.split(',').map((label)=>label.trim());
};
function $3eaf5d4878c2478d$var$assertLabelsField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.LABELS_TYPE) && field.type !== (0, $lO4Or.LABELS_CF_TYPE)) throw new Error('Field type is not supported');
}
function $3eaf5d4878c2478d$var$isNotNull(value) {
    return value !== null;
}
const $3eaf5d4878c2478d$var$useLabelsClipboardHandler = (issue, field)=>{
    $3eaf5d4878c2478d$var$assertLabelsField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $chsVw.useLabelsField)({
        issueKey: issue.key,
        issueId: issue.issueId,
        fieldKey: field?.fieldId,
        initialValue: Array.isArray(field?.value) ? field.value.filter($3eaf5d4878c2478d$var$isNotNull) : []
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.join(', ') || '',
        currentValue: value,
        getPastedValue: $3eaf5d4878c2478d$var$getPastedValue,
        saveValue: saveValue
    });
};
const $3eaf5d4878c2478d$var$LabelsClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($3eaf5d4878c2478d$var$useLabelsClipboardHandler);
const $3eaf5d4878c2478d$export$b0d4c8fecec395de = {
    [(0, $lO4Or.LABELS_TYPE)]: $3eaf5d4878c2478d$var$LabelsClipboardHelper,
    [(0, $lO4Or.LABELS_CF_TYPE)]: $3eaf5d4878c2478d$var$LabelsClipboardHelper
};

});
parcelRegister("chsVw", function(module, exports) {

$parcel$export(module.exports, "useLabelsField", () => $422b17732b7d1725$export$64894e54f74d7bc5);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");


var $3qzNZ = parcelRequire("3qzNZ");
const $422b17732b7d1725$export$64894e54f74d7bc5 = ({ fieldKey: // `fieldKey` can be `labels` or `customfield_`
fieldKey, issueId: issueId, issueKey: issueKey, fieldType: fieldType, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
    const saveLabelsFieldField = (0, $3qzNZ.useSaveLabelsField)(issueId);
    const saveField = saveLabelsFieldField;
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const labelsFieldType = fieldType || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'array');
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldType: labelsFieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue || null,
        fieldKey: fieldKey || (0, $ebc098a76317be78$export$93605f2a09aa8d26),
        saveField: saveField
    });
    return [
        {
            error: error,
            value: value,
            fieldConfig: fieldConfig
        },
        {
            resetError: resetError,
            saveValue: saveValue
        }
    ];
};

});
parcelRegister("3qzNZ", function(module, exports) {

$parcel$export(module.exports, "useSaveLabelsField", () => $8c72e74753e30ea2$export$212ad40ad2c2a1db);

var $lhgd8 = parcelRequire("lhgd8");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7byHA = parcelRequire("7byHA");

var $dWLk9 = parcelRequire("dWLk9");
/**
 * @deprecated (do not copy/use) TODO: find a way to get ari rather than building it
 * https://jplat.atlassian.net/browse/JIV-13978
 */ const $8c72e74753e30ea2$var$buildId = (cloudId, issueId, fieldKey)=>`ari:cloud:jira:${cloudId}:issuefieldvalue/${issueId}/${fieldKey}`;
const $8c72e74753e30ea2$export$212ad40ad2c2a1db = (issueId)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [commit] = (0, $iWLL0.useMutation)((0, $lhgd8.default));
    return (0, $eUqFw.useCallback)(async (_issueKey, fieldKey, value)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        id: $8c72e74753e30ea2$var$buildId(cloudId, issueId, fieldKey),
                        operations: [
                            {
                                operation: 'SET',
                                labels: value || []
                            }
                        ]
                    }
                },
                onCompleted (mutationData) {
                    if (mutationData.jira?.updateLabelsField) {
                        const { success: success, errors: responseErrors } = mutationData.jira?.updateLabelsField;
                        if (success) {
                            resolve();
                            return;
                        }
                        if (responseErrors?.length) reject(responseErrors[0].message ? new (0, $7byHA.ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating labels'));
                    } else reject(new Error('Unknown error when mutating labels'));
                },
                onError (error) {
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit,
        issueId
    ]);
};

});
parcelRegister("lhgd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $25cdafdd920c3753$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c11ab75238f9f278d90a1487bd50f054>>
 * @relayHash d660b7a8b39585d942e3868f452ae2a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d8f8d6bc107a9af3a9c530285495c2cea39cca04298631ed734969b32b449d2
const $25cdafdd920c3753$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSaveLabelsField_LabelsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSaveLabelsField_LabelsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                },
                                                {
                                                    "concreteType": "JiraLabelEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8d8f8d6bc107a9af3a9c530285495c2cea39cca04298631ed734969b32b449d2",
            "metadata": {},
            "name": "useSaveLabelsField_LabelsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$25cdafdd920c3753$var$node.hash = "8ad20115daf17ea5e9001db36624cdd7";
var $25cdafdd920c3753$export$2e2bcd8739ae039 = $25cdafdd920c3753$var$node;

});




parcelRegister("3wSIr", function(module, exports) {

$parcel$export(module.exports, "multiSelectClipboardHandler", () => $6edc28b737f52a91$export$4181cf95bcdec65a);

var $acd3W = parcelRequire("acd3W");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $bNbdC = parcelRequire("bNbdC");
const $6edc28b737f52a91$var$isTransformedMultiSelectOption = (option)=>!!option && typeof option === 'object' && 'optionId' in option && 'value' in option;
const $6edc28b737f52a91$var$isTransformedMultiSelect = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($6edc28b737f52a91$var$isTransformedMultiSelectOption);
const $6edc28b737f52a91$var$isMultiSelectValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>!!option && typeof option === 'object' && 'id' in option && 'value' in option);
const $6edc28b737f52a91$var$emptyValue = [];
function $6edc28b737f52a91$var$isNotNull(value) {
    return value !== null;
}
const $6edc28b737f52a91$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $bNbdC.multiSelectSupportedTypes))) return null;
    if (!$6edc28b737f52a91$var$isMultiSelectValue(metadata.fieldValue)) return null;
    return metadata.fieldValue?.filter($6edc28b737f52a91$var$isNotNull) ?? null;
};
function $6edc28b737f52a91$var$assertMultiSelectField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.MULTI_SELECT_CF_TYPE)) throw new Error('Field type is not supported');
}
const $6edc28b737f52a91$var$useMultiSelectClipboardHandler = (issue, field)=>{
    $6edc28b737f52a91$var$assertMultiSelectField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $acd3W.useMultiSelectField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: (0, $lO4Or.MULTI_SELECT_CF_TYPE),
        initialValue: $6edc28b737f52a91$var$isTransformedMultiSelect(field.value) ? field.value.map((option)=>({
                id: option.optionId,
                value: option.value
            })) : $6edc28b737f52a91$var$emptyValue
    });
    // ensure it is an array instead of null
    const saveFn = (valueToSave, meta, analyticsEvent)=>saveValue(valueToSave ?? $6edc28b737f52a91$var$emptyValue, meta, analyticsEvent);
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map((option)=>option.value).join(', ') || '',
        currentValue: value,
        getPastedValue: $6edc28b737f52a91$var$getPastedValue,
        saveValue: saveFn
    });
};
const $6edc28b737f52a91$var$MultiSelectClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($6edc28b737f52a91$var$useMultiSelectClipboardHandler);
const $6edc28b737f52a91$export$4181cf95bcdec65a = {
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: $6edc28b737f52a91$var$MultiSelectClipboardHelper
};

});
parcelRegister("acd3W", function(module, exports) {

$parcel$export(module.exports, "useSingleSelectField", () => $f76affc570fb2705$export$de455e978fcfd3cf);
$parcel$export(module.exports, "useMultiSelectField", () => $f76affc570fb2705$export$a996b308983609cf);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $btjMs = parcelRequire("btjMs");

var $bbmmE = parcelRequire("bbmmE");
const $f76affc570fb2705$var$useSelectField = ({ issueKey: issueKey, fieldKey: fieldKey, fieldDefaultSchemaType: fieldDefaultSchemaType, onSuccess: onSuccess, onFailure: onFailure, saveField: saveField, fieldType: fieldType, initialValue: initialValue })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const resolvedFieldType = fieldType || (0, $btjMs.getFieldType)(fieldConfig.value) || fieldDefaultSchemaType;
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: resolvedFieldType,
        initialValue: // @ts-expect-error Fix in https://jplat.jira.atlassian.cloud/browse/JIV-17559
        initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure,
        saveField: saveField
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};
const $f76affc570fb2705$export$de455e978fcfd3cf = (props)=>{
    const saveSingleSelectField = (0, $bbmmE.useSingleSelectMutation)();
    return $f76affc570fb2705$var$useSelectField({
        ...props,
        saveField: saveSingleSelectField,
        fieldDefaultSchemaType: 'option'
    });
};
const $f76affc570fb2705$export$a996b308983609cf = (props)=>$f76affc570fb2705$var$useSelectField({
        ...props,
        fieldDefaultSchemaType: 'array'
    });

});
parcelRegister("bbmmE", function(module, exports) {

$parcel$export(module.exports, "useSingleSelectMutation", () => $5f37b5f5d09f1a30$export$e568023bd1bde626);

var $fUAEy = parcelRequire("fUAEy");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7byHA = parcelRequire("7byHA");

var $hJ992 = parcelRequire("hJ992");

var $dWLk9 = parcelRequire("dWLk9");

var $cl42p = parcelRequire("cl42p");
function $5f37b5f5d09f1a30$export$e568023bd1bde626() {
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueContextIssueId = (0, $hJ992.useIssueId)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const [commit] = (0, $iWLL0.useMutation)((0, $fUAEy.default));
    return (0, $eUqFw.useCallback)(async (issueKey, fieldId, option)=>{
        const { issueId: issueId, fieldOptionAri: fieldOptionAri } = await (0, $cl42p.fetchMissingIssueAndFieldOptionData)(issueContextIssueId, option, environment, {
            cloudId: cloudId,
            issueKey: issueKey,
            fieldId: fieldId
        });
        return new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        // @todo: we shouldn't be manually constructing ARIs
                        // https://jplat.jira.atlassian.cloud/browse/JIV-16566
                        id: `ari:cloud:jira:${cloudId}:issuefieldvalue/${issueId}/${fieldId}`,
                        operation: {
                            operation: 'SET',
                            id: fieldOptionAri
                        }
                    }
                },
                onCompleted (data) {
                    if (!data.jira?.updateSingleSelectField) {
                        reject(new Error('unknown error occurred'));
                        return;
                    }
                    const { success: success, errors: errors, field: field } = data.jira.updateSingleSelectField;
                    if (!success || errors?.length) {
                        reject(errors?.[0].message ? new (0, $7byHA.ValidationError)(errors[0].message) : new Error('unknown error occurred'));
                        return;
                    }
                    resolve(field?.fieldOption ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    {
                        ari: field.fieldOption.id,
                        value: field.fieldOption.value,
                        id: field.fieldOption.optionId
                    } : null);
                },
                onError: reject
            });
        });
    }, [
        cloudId,
        commit,
        environment,
        issueContextIssueId
    ]);
}

});
parcelRegister("fUAEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e72d3b27d1cd2184$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7735160732824337ac8d363f0c91a06>>
 * @relayHash 396cef6d317a9982d56bae0401d0192f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e79778d8ae574a33e0439f2d59888b0f1b3db2a38ec6c0682cf054fcc665db61
const $e72d3b27d1cd2184$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "fieldOption",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "optionId"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSingleSelectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSingleSelectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e79778d8ae574a33e0439f2d59888b0f1b3db2a38ec6c0682cf054fcc665db61",
            "metadata": {},
            "name": "useSingleSelectMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e72d3b27d1cd2184$var$node.hash = "b8d6036932768e6445d7615f80fc6acb";
var $e72d3b27d1cd2184$export$2e2bcd8739ae039 = $e72d3b27d1cd2184$var$node;

});

parcelRegister("cl42p", function(module, exports) {

$parcel$export(module.exports, "fetchMissingIssueAndFieldOptionData", () => $ccddbc32a65dc07a$export$def6f7858b27fc01);

var $9Exgj = parcelRequire("9Exgj");

var $iWLL0 = parcelRequire("iWLL0");
async function $ccddbc32a65dc07a$export$def6f7858b27fc01(issueId, option, environment, vars) {
    const skipFieldOptionAri = option === null || Boolean(option.ari);
    // we have all the data required to make the mutation. if the field option
    // value is null that means we are unsetting so an ari is not required
    if (issueId && skipFieldOptionAri) return {
        issueId: issueId,
        fieldOptionAri: option?.ari ?? null
    };
    const result = await (0, $iWLL0.fetchQuery)(environment, (0, $9Exgj.default), {
        ...vars,
        // @todo: how do we scale when the value is empty for fields with large
        //        amount of options
        // @see https://jplat.jira.atlassian.cloud/browse/JIV-16573
        searchBy: option?.value,
        skipFieldOptionAri: skipFieldOptionAri
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const jiraIssue = result?.jira?.issueByKey;
    if (!jiraIssue?.issueId) throw new Error('failed fetch issue id');
    let ari = option != null ? option?.ari : null;
    if (!skipFieldOptionAri) ari = option ? jiraIssue?.fieldsById?.edges?.[0]?.node?.fieldOptions?.edges?.find((opt)=>opt?.node?.optionId === option.id)?.node?.id : null;
    // ari being null is still valid request as the user will be unsetting it
    // so here we check for undefined only meaning that the query above returned
    // an empty options connection, or we could not match the `optionId` from the
    // nodes in the connection.
    if (ari === undefined) throw new Error('failed to fetch field option ari');
    return {
        issueId: jiraIssue.issueId,
        fieldOptionAri: ari
    };
}

});
parcelRegister("9Exgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9668a277aa11099$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ed6f2e80602085b4937748ddaf953d>>
 * @relayHash 524d85ce5dded2d9716dceedb13042f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b143065b2371a01a056e06ca6a0f574cd106056b83483283319b3b7d3d180d58
const $c9668a277aa11099$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchBy"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipFieldOptionAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "ids.0",
                    "variableName": "fieldId"
                }
            ],
            "kind": "ListValue",
            "name": "ids"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "searchBy",
                        "variableName": "searchBy"
                    }
                ],
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v8 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectField"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "skipFieldOptionAri",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "skipFieldOptionAri",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v9 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b143065b2371a01a056e06ca6a0f574cd106056b83483283319b3b7d3d180d58",
            "metadata": {},
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c9668a277aa11099$var$node.hash = "9fecb581bfb367efbee5768f0f78cc7a";
var $c9668a277aa11099$export$2e2bcd8739ae039 = $c9668a277aa11099$var$node;

});




parcelRegister("bNbdC", function(module, exports) {

$parcel$export(module.exports, "multiSelectSupportedTypes", () => $cc3d1e0290ef44ee$export$9cb7f11173b6b689);

var $lO4Or = parcelRequire("lO4Or");
const $cc3d1e0290ef44ee$export$9cb7f11173b6b689 = [
    (0, $lO4Or.MULTI_SELECT_CF_TYPE)
];

});


parcelRegister("1xv3U", function(module, exports) {

$parcel$export(module.exports, "numberClipboardHandler", () => $302e4f33731b293a$export$801c183086232047);

var $31jh1 = parcelRequire("31jh1");

var $eY8vu = parcelRequire("eY8vu");

var $lO4Or = parcelRequire("lO4Or");

var $a6M4d = parcelRequire("a6M4d");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");
const $302e4f33731b293a$var$getPastedValue = (clipboardItem)=>{
    if (!(0, $b3neV.assertClipboardHasPlainTextFormat)(clipboardItem)) return null;
    if (Number.isNaN(Number(clipboardItem.plainText))) throw new (0, $31jh1.ClientSideValidationError)((0, $a6M4d.VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE);
    return Number(clipboardItem.plainText);
};
const $302e4f33731b293a$var$useNumberClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $eY8vu.useNumberField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: typeof field?.value === 'number' ? field?.value : undefined
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: typeof value === 'number' ? String(value) : null,
        currentValue: value,
        getPastedValue: $302e4f33731b293a$var$getPastedValue,
        saveValue: saveValue
    });
};
const $302e4f33731b293a$var$NumberClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($302e4f33731b293a$var$useNumberClipboardHandler);
const $302e4f33731b293a$export$801c183086232047 = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: $302e4f33731b293a$var$NumberClipboardHelper,
    [(0, $lO4Or.STORY_POINTS_TYPE)]: $302e4f33731b293a$var$NumberClipboardHelper,
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: $302e4f33731b293a$var$NumberClipboardHelper
};

});
parcelRegister("eY8vu", function(module, exports) {

$parcel$export(module.exports, "useNumberField", () => $847782734a282d47$export$23f548e970bdf099);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $847782734a282d47$export$23f548e970bdf099 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, saveField: saveField })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'number');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        saveField: saveField
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});


parcelRegister("5MhxU", function(module, exports) {

$parcel$export(module.exports, "parentClipboardHandler", () => $c175d49853243e9e$export$a8a030d8148a051e);

var $eUqFw = parcelRequire("eUqFw");

var $DX7su = parcelRequire("DX7su");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");
const $c175d49853243e9e$var$isTransformedParentOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'issueKey' in fieldValue && 'summary' in fieldValue && 'issueType' in fieldValue && 'issueId' in fieldValue;
const $c175d49853243e9e$var$isParentOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'label' in fieldValue && 'key' in fieldValue && 'fields' in fieldValue;
const $c175d49853243e9e$var$getPastedValue = (clipboardItem, metadata, issue)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, [
        (0, $lO4Or.PARENT_TYPE)
    ])) return null;
    // only paste when level is the same for source and destination issues
    if (String(issue?.issueType?.level) !== metadata.sourceIssueTypeLevel) return null;
    if (!$c175d49853243e9e$var$isParentOption(metadata.fieldValue)) return null;
    return metadata.fieldValue;
};
const $c175d49853243e9e$var$toParentFieldOption = (value)=>{
    const { issueKey: issueKey, issueId: issueId, summary: summary, issueType: issueType } = value;
    if (summary == null || issueType == null) return null;
    return {
        value: issueId,
        label: summary,
        key: issueKey,
        fields: {
            summary: summary,
            issuetype: issueType
        }
    };
};
const $c175d49853243e9e$var$useParentClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $DX7su.useParentField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        issueId: issue.issueId,
        initialValue: $c175d49853243e9e$var$isTransformedParentOption(field.value) ? $c175d49853243e9e$var$toParentFieldOption(field.value) : null
    });
    const createPastedValueWithIssue = (0, $eUqFw.useMemo)(()=>(clipboardItem, metadata)=>$c175d49853243e9e$var$getPastedValue(clipboardItem, metadata, issue), [
        issue
    ]);
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.key ?? '',
        currentValue: value,
        getPastedValue: createPastedValueWithIssue,
        saveValue: saveValue
    });
};
const $c175d49853243e9e$var$ParentClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($c175d49853243e9e$var$useParentClipboardHandler);
const $c175d49853243e9e$export$a8a030d8148a051e = {
    [(0, $lO4Or.PARENT_TYPE)]: $c175d49853243e9e$var$ParentClipboardHelper
};

});

parcelRegister("9f078", function(module, exports) {

$parcel$export(module.exports, "priorityClipboardHandler", () => $e76c4e2612c5e8f2$export$b89004aa95786c81);

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $fT9Dl = parcelRequire("fT9Dl");
const $e76c4e2612c5e8f2$var$isTransformedPriority = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'name' in fieldValue && 'priorityId' in fieldValue && 'iconUrl' in fieldValue;
const $e76c4e2612c5e8f2$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $fT9Dl.prioritySupportedTypes))) return null;
    if (!$e76c4e2612c5e8f2$var$isTransformedPriority(metadata.fieldValue)) return null;
    const { name: name, iconUrl: iconUrl, priorityId: priorityId } = metadata.fieldValue;
    return {
        name: name,
        iconUrl: iconUrl,
        priorityId: priorityId
    };
};
const $e76c4e2612c5e8f2$var$usePriorityClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.PRIORITY_TYPE),
        issueKey: issue.key,
        fieldType: (0, $lO4Or.PRIORITY_TYPE),
        initialValue: $e76c4e2612c5e8f2$var$isTransformedPriority(field.value) ? field.value : undefined
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.name || null,
        currentValue: value,
        getPastedValue: $e76c4e2612c5e8f2$var$getPastedValue,
        saveValue: saveValue
    });
};
const $e76c4e2612c5e8f2$var$PriorityClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($e76c4e2612c5e8f2$var$usePriorityClipboardHandler);
const $e76c4e2612c5e8f2$export$b89004aa95786c81 = {
    [(0, $lO4Or.PRIORITY_TYPE)]: $e76c4e2612c5e8f2$var$PriorityClipboardHelper
};

});
parcelRegister("fT9Dl", function(module, exports) {

$parcel$export(module.exports, "prioritySupportedTypes", () => $6f6676ccf7e9e98c$export$870d540e29b75531);

var $lO4Or = parcelRequire("lO4Or");
const $6f6676ccf7e9e98c$export$870d540e29b75531 = [
    (0, $lO4Or.PRIORITY_TYPE)
];

});


parcelRegister("bN2A6", function(module, exports) {

$parcel$export(module.exports, "projectClipboardHandler", () => $ee0fcf8e024fd6d7$export$54ffe1b6751ffaa1);

var $hIoRx = parcelRequire("hIoRx");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");
const $ee0fcf8e024fd6d7$var$isProjectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'name' in fieldValue && 'avatarUrls' in fieldValue && 'key' in fieldValue;
const $ee0fcf8e024fd6d7$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, [
        (0, $lO4Or.PROJECT_PICKER_CF_TYPE)
    ])) return null;
    if (!$ee0fcf8e024fd6d7$var$isProjectOption(metadata.fieldValue)) return null;
    const { avatarUrls: avatarUrls, key: key, name: name } = metadata.fieldValue;
    return {
        avatarUrls: avatarUrls,
        key: key,
        name: name
    };
};
function $ee0fcf8e024fd6d7$var$assertProjectField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.PROJECT_PICKER_CF_TYPE)) throw new Error('Field type is not supported');
}
const $ee0fcf8e024fd6d7$var$useProjectClipboardHandler = (issue, field)=>{
    $ee0fcf8e024fd6d7$var$assertProjectField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $hIoRx.useProjectField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: field?.value ?? null
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.name ?? '',
        currentValue: value,
        getPastedValue: $ee0fcf8e024fd6d7$var$getPastedValue,
        saveValue: saveValue
    });
};
const $ee0fcf8e024fd6d7$var$ProjectClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($ee0fcf8e024fd6d7$var$useProjectClipboardHandler);
const $ee0fcf8e024fd6d7$export$54ffe1b6751ffaa1 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $ee0fcf8e024fd6d7$var$ProjectClipboardHelper
};

});

parcelRegister("bOlrD", function(module, exports) {

$parcel$export(module.exports, "radioSelectClipboardHandler", () => $d3465a1c2b47e70d$export$29dacd6ff7afb87c);

var $i0GKz = parcelRequire("i0GKz");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $6FuLp = parcelRequire("6FuLp");
const $d3465a1c2b47e70d$var$isRadioSelectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'id' in fieldValue && 'value' in fieldValue;
const $d3465a1c2b47e70d$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $6FuLp.radioSelectSupportedTypes))) return null;
    if (!$d3465a1c2b47e70d$var$isRadioSelectOption(metadata.fieldValue)) return null;
    return {
        id: metadata.fieldValue.id,
        value: metadata.fieldValue.value
    };
};
const $d3465a1c2b47e70d$var$useRadioSelectClipboardHandler = (issue, field)=>{
    $d3465a1c2b47e70d$var$assertRadioSelectField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $i0GKz.useRadioSelectCustomField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: field?.value ? field?.value : null
    });
    const { value: valueAsString = null } = value ?? {};
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: valueAsString,
        currentValue: value,
        getPastedValue: $d3465a1c2b47e70d$var$getPastedValue,
        saveValue: saveValue
    });
};
function $d3465a1c2b47e70d$var$assertRadioSelectField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.RADIO_BUTTONS_CF_TYPE)) throw new Error('Field type is not supported');
}
const $d3465a1c2b47e70d$var$RadioSelectClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($d3465a1c2b47e70d$var$useRadioSelectClipboardHandler);
const $d3465a1c2b47e70d$export$29dacd6ff7afb87c = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $d3465a1c2b47e70d$var$RadioSelectClipboardHelper
};

});

parcelRegister("i3YJS", function(module, exports) {

$parcel$export(module.exports, "richTextClipboardHandler", () => $84065a9d3276b9f1$export$f1f0130932e64bf7);

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $45Hde = parcelRequire("45Hde");
const $84065a9d3276b9f1$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $45Hde.richTextSupportedTypes))) return null;
    return JSON.parse(clipboardItem.plainText);
};
function $84065a9d3276b9f1$var$assertRichTextField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.TEXT_AREA_CF_TYPE)) throw new Error('Field type is not supported');
}
const $84065a9d3276b9f1$var$useRichTextClipboardHandler = (issue, field)=>{
    $84065a9d3276b9f1$var$assertRichTextField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        issueKey: issue.key,
        fieldKey: field.fieldId,
        fieldType: field.type,
        initialValue: field.value ?? null
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: typeof value !== 'string' ? JSON.stringify(value) : '',
        currentValue: value,
        getPastedValue: $84065a9d3276b9f1$var$getPastedValue,
        saveValue: saveValue
    });
};
const $84065a9d3276b9f1$var$RichTextClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($84065a9d3276b9f1$var$useRichTextClipboardHandler);
const $84065a9d3276b9f1$export$f1f0130932e64bf7 = {
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: $84065a9d3276b9f1$var$RichTextClipboardHelper
};

});
parcelRegister("45Hde", function(module, exports) {

$parcel$export(module.exports, "richTextSupportedTypes", () => $9e5ea2354de6a8fd$export$8eb80ed0ab47e2a5);

var $lO4Or = parcelRequire("lO4Or");
const $9e5ea2354de6a8fd$export$8eb80ed0ab47e2a5 = [
    (0, $lO4Or.TEXT_AREA_CF_TYPE)
];

});


parcelRegister("gRRkp", function(module, exports) {

$parcel$export(module.exports, "singleSelectClipboardHandler", () => $fa2a29b32573d899$export$40b3cfc25c74248b);

var $acd3W = parcelRequire("acd3W");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $jeePg = parcelRequire("jeePg");
const $fa2a29b32573d899$var$isSingleSelectValue = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'id' in fieldValue;
const $fa2a29b32573d899$var$isTransformedSingleSelectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'optionId' in fieldValue;
const $fa2a29b32573d899$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $jeePg.singleSelectSupportedTypes))) return null;
    if (!$fa2a29b32573d899$var$isSingleSelectValue(metadata.fieldValue)) return null;
    return metadata.fieldValue;
};
const $fa2a29b32573d899$var$useSingleSelectClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $acd3W.useSingleSelectField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        initialValue: $fa2a29b32573d899$var$isTransformedSingleSelectOption(field.value) ? {
            id: field.value.optionId,
            value: field.value.value
        } : null
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.value || '',
        currentValue: value,
        getPastedValue: $fa2a29b32573d899$var$getPastedValue,
        saveValue: saveValue
    });
};
const $fa2a29b32573d899$var$SingleSelectClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($fa2a29b32573d899$var$useSingleSelectClipboardHandler);
const $fa2a29b32573d899$export$40b3cfc25c74248b = {
    [(0, $lO4Or.SELECT_CF_TYPE)]: $fa2a29b32573d899$var$SingleSelectClipboardHelper
};

});
parcelRegister("jeePg", function(module, exports) {

$parcel$export(module.exports, "singleSelectSupportedTypes", () => $db02664bdc47244b$export$2bbc728e21b0f517);

var $lO4Or = parcelRequire("lO4Or");
const $db02664bdc47244b$export$2bbc728e21b0f517 = [
    (0, $lO4Or.SELECT_CF_TYPE)
];

});


parcelRegister("hZbCV", function(module, exports) {

$parcel$export(module.exports, "sprintClipboardHandler", () => $cced96e6fbfbb176$export$43b74ee26a0ff997);

var $eUqFw = parcelRequire("eUqFw");

var $aUSBv = parcelRequire("aUSBv");

var $5EG40 = parcelRequire("5EG40");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $9sISm = parcelRequire("9sISm");
const $cced96e6fbfbb176$var$isTransformedSprintOption = (option)=>option != null && typeof option === 'object' && 'sprintId' in option && 'name' in option && 'state' in option;
const $cced96e6fbfbb176$var$isTransformedSprint = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($cced96e6fbfbb176$var$isTransformedSprintOption);
const $cced96e6fbfbb176$var$isSprintValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>option != null && typeof option === 'object' && 'id' in option && 'name' in option && 'state' in option && 'boardId' in option);
const $cced96e6fbfbb176$var$emptyValue = [];
const $cced96e6fbfbb176$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $9sISm.sprintSupportedTypes))) return [];
    if (!$cced96e6fbfbb176$var$isSprintValue(metadata?.fieldValue)) return [];
    return metadata?.fieldValue ?? [];
};
const $cced96e6fbfbb176$var$toSprintValue = (sprint)=>({
        id: Number(sprint.sprintId),
        name: String(sprint.name),
        state: String(sprint.state),
        boardId: Number((0, $aUSBv.getBoardId)(window.location.href))
    });
const $cced96e6fbfbb176$var$useSprintClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $5EG40.useSprintField)({
        issueKey: issue.key,
        fieldKey: field.fieldId,
        initialValue: $cced96e6fbfbb176$var$isTransformedSprint(field.value) ? field.value.map($cced96e6fbfbb176$var$toSprintValue) : $cced96e6fbfbb176$var$emptyValue
    });
    const saveValueFn = (0, $eUqFw.useCallback)((valueToSave, meta, analyticsEvent)=>/**
			 * Wrap saveValue to make sure the saved value is never set to `null`
			 */ saveValue(valueToSave ?? [], meta, analyticsEvent), [
        saveValue
    ]);
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map((sprint)=>sprint.name).join(', ') || '',
        currentValue: value,
        getPastedValue: $cced96e6fbfbb176$var$getPastedValue,
        saveValue: saveValueFn,
        emptyValue: $cced96e6fbfbb176$var$emptyValue
    });
};
const $cced96e6fbfbb176$var$SprintClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($cced96e6fbfbb176$var$useSprintClipboardHandler);
const $cced96e6fbfbb176$export$43b74ee26a0ff997 = {
    [(0, $lO4Or.SPRINT_TYPE)]: $cced96e6fbfbb176$var$SprintClipboardHelper
};

});
parcelRegister("5EG40", function(module, exports) {

$parcel$export(module.exports, "useSprintField", () => $1f9070b593e0eed5$export$414b643c95e23ae5);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");

var $4QywV = parcelRequire("4QywV");
const $1f9070b593e0eed5$export$218ac2eb848871c9 = async (issueKey, fieldKey, newValue)=>{
    const value = (0, $4QywV.getActiveOrFutureSprint)(newValue);
    return (0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify({
            fields: {
                // We're only saving the sprint id
                [fieldKey]: value ? value.id : null
            }
        })
    });
};
const $1f9070b593e0eed5$export$414b643c95e23ae5 = (props)=>{
    const { fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = [] } = props;
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.custom ?? (0, $lO4Or.SPRINT_TYPE);
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        fieldType: fieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue,
        saveField: $1f9070b593e0eed5$export$218ac2eb848871c9
    });
    const currentSprint = (0, $eUqFw.useMemo)(()=>(0, $4QywV.getActiveOrFutureSprint)(value), [
        value
    ]);
    const closedSprints = (0, $eUqFw.useMemo)(()=>(0, $4QywV.getClosedSprints)(value), [
        value
    ]);
    return [
        {
            currentSprint: currentSprint,
            closedSprints: closedSprints,
            error: error,
            value: value,
            fieldConfig: fieldConfig
        },
        {
            resetError: resetError,
            saveValue: saveValue
        }
    ];
};

});
parcelRegister("4QywV", function(module, exports) {

$parcel$export(module.exports, "getActiveOrFutureSprint", () => $3b23a63751969b1d$export$976090522bae1157);
$parcel$export(module.exports, "getClosedSprints", () => $3b23a63751969b1d$export$d643f70a4819e76d);

var $aJ90T = parcelRequire("aJ90T");

var $cbDYy = parcelRequire("cbDYy");
const $3b23a63751969b1d$export$976090522bae1157 = (value)=>{
    const activeSprint = (0, $cbDYy.findSprintWithState)(value, (0, $aJ90T.ACTIVE_SPRINT_STATE));
    if (activeSprint) return activeSprint;
    const futureSprint = (0, $cbDYy.findSprintWithState)(value, (0, $aJ90T.FUTURE_SPRINT_STATE));
    if (futureSprint) return futureSprint;
    return null;
};
const $3b23a63751969b1d$export$d643f70a4819e76d = (value)=>{
    if (!value) return [];
    return value.filter((0, $cbDYy.hasState)((0, $aJ90T.CLOSED_SPRINT_STATE)));
};

});
parcelRegister("aJ90T", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $d6857bb95b01f76c$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $d6857bb95b01f76c$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $d6857bb95b01f76c$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $d6857bb95b01f76c$export$73a0206a4dc59760);
const $d6857bb95b01f76c$export$3ebc9911a79d714f = 'ACTIVE';
const $d6857bb95b01f76c$export$863e42082c6bde5 = 'FUTURE';
const $d6857bb95b01f76c$export$86cdef09a89e8c4b = 'CLOSED';
const $d6857bb95b01f76c$export$73a0206a4dc59760 = {
    ACTIVE: $d6857bb95b01f76c$export$3ebc9911a79d714f,
    CLOSED: $d6857bb95b01f76c$export$86cdef09a89e8c4b,
    FUTURE: $d6857bb95b01f76c$export$863e42082c6bde5
};

});

parcelRegister("cbDYy", function(module, exports) {

$parcel$export(module.exports, "hasState", () => $8a075e979a5ccce6$export$d2fec4e2fc5f065a);
$parcel$export(module.exports, "findSprintWithState", () => $8a075e979a5ccce6$export$fb6b70a9c996212b);
$parcel$export(module.exports, "mapSprintOptionToData", () => $8a075e979a5ccce6$export$fb7a6b38a05bd2b7);
$parcel$export(module.exports, "transformSuggestions", () => $8a075e979a5ccce6$export$1d0ee4320c26fb60);

var $aJ90T = parcelRequire("aJ90T");

var $iciya = parcelRequire("iciya");
const $8a075e979a5ccce6$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $8a075e979a5ccce6$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state !== undefined && sprint.state.toLowerCase() === state.toLowerCase();
const $8a075e979a5ccce6$export$fb6b70a9c996212b = (sprints, state)=>{
    if (!sprints) return undefined;
    return sprints.find($8a075e979a5ccce6$export$d2fec4e2fc5f065a(state));
};
const $8a075e979a5ccce6$export$d63c3784bf3852ca = (state)=>{
    if (state !== undefined) {
        const stateKey = state.toUpperCase();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly ACTIVE: "ACTIVE"; readonly CLOSED: "CLOSED"; readonly FUTURE: "FUTURE"; }'.
        return (0, $aJ90T.SPRINT_STATES)[stateKey];
    }
    return undefined;
};
const $8a075e979a5ccce6$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
const $8a075e979a5ccce6$export$fbb2e1641ffac377 = (option)=>({
        id: Number(option.value),
        name: String(option.label),
        state: option.state,
        // mapSprintValueToOption ensures there will always be a boardId
        boardId: Number(option.data?.boardId) || 0
    });
const $8a075e979a5ccce6$export$b9928e57702db7d9 = (items)=>items.map($8a075e979a5ccce6$export$fbb2e1641ffac377);
const $8a075e979a5ccce6$export$cbdf60de7f2200e7 = (option)=>({
        id: Number(option.value),
        boardName: option.description,
        name: String(option.label),
        // mapSprintSuggestionToOption ensures there will always be a state
        // @ts-expect-error - TS2322 - Type 'SprintState | undefined' is not assignable to type 'SprintState'.
        stateKey: $8a075e979a5ccce6$export$d63c3784bf3852ca(option.state),
        // mapSprintSuggestionToOption ensures there will always be a date
        date: String(option.data?.date)
    });
const $8a075e979a5ccce6$export$db10bf437c75c497 = (items)=>items.map($8a075e979a5ccce6$export$cbdf60de7f2200e7);
const $8a075e979a5ccce6$export$15c97379ebef6b30 = (sprint)=>({
        id: sprint.id,
        description: sprint.boardName,
        label: sprint.name,
        state: sprint.stateKey,
        value: sprint.id,
        data: {
            date: sprint.date,
            fromCache: sprint.fromCache
        }
    });
const $8a075e979a5ccce6$export$c1cb9e6f1beaee0d = (items)=>items.map($8a075e979a5ccce6$export$15c97379ebef6b30);
const $8a075e979a5ccce6$export$ce3013ece3dbf252 = (sprint)=>({
        id: sprint.id,
        name: sprint.name,
        href: $8a075e979a5ccce6$export$e6c9132cef5ee76f(sprint.id),
        endDate: sprint.endDate || ''
    });
const $8a075e979a5ccce6$export$755a6a3c6172f7e = (sprint)=>({
        label: sprint.name,
        value: sprint.id,
        href: $8a075e979a5ccce6$export$e6c9132cef5ee76f(sprint.id),
        state: $8a075e979a5ccce6$export$d63c3784bf3852ca(sprint.state),
        data: {
            boardId: sprint.boardId,
            date: sprint.startDate
        }
    });
const $8a075e979a5ccce6$export$cbcaba92baa2e404 = (items)=>items.map($8a075e979a5ccce6$export$755a6a3c6172f7e);
const $8a075e979a5ccce6$export$1d0ee4320c26fb60 = (suggestionsFromServer, formatMessage)=>{
    const serverSuggestions = suggestionsFromServer.suggestions || [];
    const allMatches = suggestionsFromServer.allMatches || [];
    const allItems = serverSuggestions.concat(allMatches);
    const activeItems = allItems.filter((sprint)=>sprint.stateKey === (0, $aJ90T.ACTIVE_SPRINT_STATE)).map($8a075e979a5ccce6$export$15c97379ebef6b30);
    const futureItems = allItems.filter((sprint)=>sprint.stateKey === (0, $aJ90T.FUTURE_SPRINT_STATE)).map($8a075e979a5ccce6$export$15c97379ebef6b30);
    const sprints = [
        {
            label: formatMessage((0, $iciya.default).activeSprints),
            options: activeItems
        },
        {
            label: formatMessage((0, $iciya.default).futureSprints),
            options: futureItems
        }
    ];
    return sprints;
};

});
parcelRegister("iciya", function(module, exports) {

$parcel$export(module.exports, "default", () => $2522434b5de850c0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2522434b5de850c0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    activeSprints: {
        "id": "issue-field-sprint.common.active-sprints",
        "defaultMessage": "Active"
    },
    futureSprints: {
        "id": "issue-field-sprint.common.future-sprints",
        "defaultMessage": "Future"
    },
    recentSprints: {
        "id": "issue-field-sprint.common.recent-sprints",
        "defaultMessage": "Recent sprints"
    }
});

});




parcelRegister("9sISm", function(module, exports) {

$parcel$export(module.exports, "sprintSupportedTypes", () => $52fd07c03bb8a48a$export$e25836d1d6e63e05);

var $lO4Or = parcelRequire("lO4Or");
const $52fd07c03bb8a48a$export$e25836d1d6e63e05 = [
    (0, $lO4Or.SPRINT_TYPE)
];

});


parcelRegister("6hel2", function(module, exports) {

$parcel$export(module.exports, "teamClipboardHandler", () => $a73426c6bbea7e32$export$c625d5eb0e1357b2);

var $5JDtt = parcelRequire("5JDtt");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");
const $a73426c6bbea7e32$var$isTransformedTeamOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'id' in fieldValue && 'name' in fieldValue;
function $a73426c6bbea7e32$var$assertTeamField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)) throw new Error('Field type is not supported');
}
const $a73426c6bbea7e32$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, [
        (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)
    ])) return null;
    if (!$a73426c6bbea7e32$var$isTransformedTeamOption(metadata.fieldValue)) return null;
    const { id: id, name: name } = metadata.fieldValue;
    return {
        id: id,
        name: name
    };
};
const $a73426c6bbea7e32$var$useTeamClipboardHandler = (issue, field)=>{
    $a73426c6bbea7e32$var$assertTeamField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $5JDtt.useTeamField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: $a73426c6bbea7e32$var$isTransformedTeamOption(field.value) ? field.value : undefined
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: field.value?.name ?? '',
        currentValue: value,
        getPastedValue: $a73426c6bbea7e32$var$getPastedValue,
        saveValue: saveValue
    });
};
const $a73426c6bbea7e32$var$TeamClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($a73426c6bbea7e32$var$useTeamClipboardHandler);
const $a73426c6bbea7e32$export$c625d5eb0e1357b2 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: $a73426c6bbea7e32$var$TeamClipboardHelper
};

});

parcelRegister("hENET", function(module, exports) {

$parcel$export(module.exports, "textClipboardHandler", () => $6a7815dcf43e968a$export$c09434927c21c56);

var $91l9a = parcelRequire("91l9a");

var $fWeG1 = parcelRequire("fWeG1");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");
const $6a7815dcf43e968a$var$getPastedValue = (clipboardItem)=>{
    if (!(0, $b3neV.assertClipboardHasPlainTextFormat)(clipboardItem)) return null;
    return clipboardItem.plainText;
};
function $6a7815dcf43e968a$var$assertTextField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.TEXT_CF_TYPE) && field.type !== (0, $lO4Or.SUMMARY_TYPE)) throw new Error('Field type is not supported');
}
const $6a7815dcf43e968a$var$useSummaryClipboardHandler = (issue, field)=>{
    $6a7815dcf43e968a$var$assertTextField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $fWeG1.useSummaryField)({
        issueKey: issue.key,
        initialValue: field.value
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value,
        currentValue: value,
        getPastedValue: $6a7815dcf43e968a$var$getPastedValue,
        saveValue: saveValue
    });
};
const $6a7815dcf43e968a$var$useTextClipboardHandler = (issue, field)=>{
    $6a7815dcf43e968a$var$assertTextField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $91l9a.useTextCustomField)({
        issueKey: issue.key,
        fieldKey: field.fieldId,
        initialValue: field.value
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value,
        currentValue: value,
        getPastedValue: $6a7815dcf43e968a$var$getPastedValue,
        saveValue: saveValue
    });
};
const $6a7815dcf43e968a$var$SummaryClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($6a7815dcf43e968a$var$useSummaryClipboardHandler);
const $6a7815dcf43e968a$var$TextClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($6a7815dcf43e968a$var$useTextClipboardHandler);
const $6a7815dcf43e968a$export$c09434927c21c56 = {
    [(0, $lO4Or.SUMMARY_TYPE)]: $6a7815dcf43e968a$var$SummaryClipboardHelper,
    [(0, $lO4Or.TEXT_CF_TYPE)]: $6a7815dcf43e968a$var$TextClipboardHelper
};

});
parcelRegister("91l9a", function(module, exports) {

$parcel$export(module.exports, "useTextCustomField", () => $e317f21526ba3a70$export$1e71b41e5a5c15c3);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $e317f21526ba3a70$export$1e71b41e5a5c15c3 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("fWeG1", function(module, exports) {

$parcel$export(module.exports, "useSummaryField", () => $6c5f7158a1132680$export$a01f0885983ceff0);

var $illlw = parcelRequire("illlw");

var $1ybV0 = parcelRequire("1ybV0");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $6c5f7158a1132680$export$a01f0885983ceff0 = ({ issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.SUMMARY_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.SUMMARY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        // delete this condition and keep code inside when removing the isIncrementPlanningEnabled FF
        ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && onSaveField && {
            saveField: onSaveField
        }
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});


parcelRegister("bde5A", function(module, exports) {

$parcel$export(module.exports, "timeTrackingClipboardHandler", () => $c439310d2c3994e8$export$a6166b81649f40c4);

var $dKMPW = parcelRequire("dKMPW");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $3mCdi = parcelRequire("3mCdi");
const $c439310d2c3994e8$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $3mCdi.timeTrackingSupportedTypes))) return null;
    const time = Number(clipboardItem.plainText);
    if (Number.isNaN(time)) return null;
    return time;
};
function $c439310d2c3994e8$var$assertTimeTrackingField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.TIME_ESTIMATE_TYPE)) throw new Error('Field type is not supported');
}
const $c439310d2c3994e8$var$useTimeTrackingClipboardHandler = (issue, field)=>{
    $c439310d2c3994e8$var$assertTimeTrackingField(field);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fieldValue = field.value;
    const hookInitialValue = fieldValue?.timeAsString && fieldValue?.timeInSeconds && {
        originalEstimate: fieldValue.timeAsString,
        originalEstimateSeconds: fieldValue.timeInSeconds
    } || {};
    const [{ value: value }, { saveValue: saveValue }] = (0, $dKMPW.useOriginalEstimateField)({
        issueKey: issue.key,
        issueId: issue.issueId,
        fieldId: field.fieldId,
        timeTrackingValue: hookInitialValue
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: typeof value === 'number' ? String(value) : null,
        currentValue: value,
        getPastedValue: $c439310d2c3994e8$var$getPastedValue,
        saveValue: saveValue
    });
};
const $c439310d2c3994e8$var$TimeTrackingClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($c439310d2c3994e8$var$useTimeTrackingClipboardHandler);
const $c439310d2c3994e8$export$a6166b81649f40c4 = {
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: $c439310d2c3994e8$var$TimeTrackingClipboardHelper
};

});
parcelRegister("dKMPW", function(module, exports) {

$parcel$export(module.exports, "saveField", () => $899c478b0ef30ec3$export$72a8b15fb4557735);
$parcel$export(module.exports, "useOriginalEstimateField", () => $899c478b0ef30ec3$export$ce089f5e05395af0);
$parcel$export(module.exports, "useOriginalEstimateFieldWithTimeTracking", () => $899c478b0ef30ec3$export$a79ecf7a6123f80e);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $eDEru = parcelRequire("eDEru");

var $37V3y = parcelRequire("37V3y");

var $lO4Or = parcelRequire("lO4Or");

var $5zSUY = parcelRequire("5zSUY");

var $9JAdq = parcelRequire("9JAdq");
const $899c478b0ef30ec3$export$347b6dd45094a5fd = (timeTrackingValue)=>{
    const hasTimeLogged = timeTrackingValue?.timeSpentSeconds != null;
    const hasTimeRemainUpdated = timeTrackingValue?.remainingEstimateSeconds != null && timeTrackingValue?.remainingEstimateSeconds !== timeTrackingValue?.originalEstimateSeconds;
    return hasTimeLogged || hasTimeRemainUpdated;
};
const $899c478b0ef30ec3$export$72a8b15fb4557735 = async ({ issueId: issueId, newValue: newValue, timeTrackingValue: timeTrackingValue })=>{
    const hasTimeRemainingEstimate = $899c478b0ef30ec3$export$347b6dd45094a5fd(timeTrackingValue);
    // Convert the value in seconds to a time string to send to Jira.
    // 1m is always 60s, so we can do this safely.
    // we have to convert the final value to a whole number as passing decimal
    // values in minutes errors.
    const value = newValue !== null ? (0, $eDEru.secondsToWholeMinuteTimeString)(newValue) : null;
    // https://jdog.jira-dev.com/browse/BENTO-792 - The Time Estimate field is always shown,
    // because we always the return the timeoriginalestimate field from the backend. In order to
    // prevent the field from being visible but not editable when Time Tracking is missing from the
    // screen config, we use this legacy endpoint to save the field.
    return (0, $lRmyA.performPostRequest)('/secure/AjaxIssueAction.jspa?decorator=none', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $53ciZ.stringify)({
            issueId: issueId,
            timetracking_originalestimate: value,
            timetracking_targetsubfield: hasTimeRemainingEstimate ? 'timetracking_originalestimate' : undefined,
            ...(0, $9JAdq.originalEstimateBodyParams),
            singleFieldEdit: true,
            skipScreenCheck: true,
            atl_token: (0, $5zSUY.default)()
        })
    });
};
const $899c478b0ef30ec3$export$ce089f5e05395af0 = ({ issueKey: issueKey, issueId: issueId, fieldId: fieldId, timeTrackingValue: timeTrackingValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldId);
    const fieldType = fieldConfig?.schema.system || '';
    const saveClassicField = (_, __, newValue)=>$899c478b0ef30ec3$export$72a8b15fb4557735({
            issueId: issueId,
            newValue: newValue,
            timeTrackingValue: timeTrackingValue
        });
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldId,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        saveField: saveClassicField,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};
const $899c478b0ef30ec3$export$a79ecf7a6123f80e = ({ issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const timeTrack = (0, $37V3y.useTimeTrackingField)({
        fieldKey: (0, $lO4Or.TIME_TRACKING_TYPE),
        issueId: issueId,
        issueKey: issueKey
    });
    let timeTrackingValue = {};
    if (timeTrack) {
        const trackData = timeTrack[0].value;
        timeTrackingValue = {
            originalEstimateSeconds: trackData.originalEstimateSeconds,
            timeSpentSeconds: trackData.timeSpentSeconds,
            remainingEstimateSeconds: trackData.remainingEstimateSeconds
        };
    }
    const [{ value: value, error: error, fieldConfig: fieldConfig }, { saveValue: saveValue, resetError: resetError }] = $899c478b0ef30ec3$export$ce089f5e05395af0({
        fieldId: fieldKey,
        issueKey: issueKey,
        issueId: issueId,
        timeTrackingValue: timeTrackingValue,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("eDEru", function(module, exports) {

$parcel$export(module.exports, "secondsToWholeMinuteTimeString", () => $e60ef9ff18ec9e8a$export$e090c313e2cb7081);
const $e60ef9ff18ec9e8a$var$SECONDS_PER_MINUTE = 60;
const $e60ef9ff18ec9e8a$export$e090c313e2cb7081 = (seconds)=>`${Math.round(seconds / $e60ef9ff18ec9e8a$var$SECONDS_PER_MINUTE)}m`;
var $e60ef9ff18ec9e8a$export$2e2bcd8739ae039 = $e60ef9ff18ec9e8a$export$e090c313e2cb7081;

});

parcelRegister("37V3y", function(module, exports) {

$parcel$export(module.exports, "useTimeTrackingField", () => $c02e1c23ab68550b$export$eda25773281b1630);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $c02e1c23ab68550b$export$eda25773281b1630 = ({ issueKey: issueKey, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.system || '';
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: {
            originalEstimateSeconds: 0,
            timeSpentSeconds: 0,
            remainingEstimateSeconds: 0
        },
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("9JAdq", function(module, exports) {

$parcel$export(module.exports, "originalEstimateBodyParams", () => $4291bf329eb7bdb7$export$25ca12ed4532196);
$parcel$export(module.exports, "originalEstimateEditTestId", () => $4291bf329eb7bdb7$export$85273aacc194bf89);
$parcel$export(module.exports, "originalEstimateViewTestId", () => $4291bf329eb7bdb7$export$97847a81d7704a9e);
$parcel$export(module.exports, "READ_VIEW_CONTAINER_SELECTOR_NAME", () => $4291bf329eb7bdb7$export$916dec1cd99a42a1);
$parcel$export(module.exports, "READ_VIEW_CONTAINER_SELECTOR", () => $4291bf329eb7bdb7$export$5c18970ef161f5b6);
$parcel$export(module.exports, "HOVER_CONTAINER_SELECTOR_NAME", () => $4291bf329eb7bdb7$export$c43a88184f234cd2);
$parcel$export(module.exports, "HOVER_CONTAINER_SELECTOR", () => $4291bf329eb7bdb7$export$366394ad8172710b);
// used to verify mock is originalEstimate
const $4291bf329eb7bdb7$export$25ca12ed4532196 = {
    fieldsToForcePresent: 'timetracking'
};
const $4291bf329eb7bdb7$export$85273aacc194bf89 = 'issue-field-original-estimate.ui.edit';
const $4291bf329eb7bdb7$export$97847a81d7704a9e = 'issue-field-original-estimate.ui.view';
const $4291bf329eb7bdb7$export$916dec1cd99a42a1 = 'jira-issue-field-inline-edit-read-view-container';
const $4291bf329eb7bdb7$export$5c18970ef161f5b6 = `[data-component-selector="${$4291bf329eb7bdb7$export$916dec1cd99a42a1}"]`;
const $4291bf329eb7bdb7$export$c43a88184f234cd2 = 'jira-issue-field-original-estimate-hover-container';
const $4291bf329eb7bdb7$export$366394ad8172710b = `[data-component-selector="${$4291bf329eb7bdb7$export$c43a88184f234cd2}"]`;

});


parcelRegister("3mCdi", function(module, exports) {

$parcel$export(module.exports, "timeTrackingSupportedTypes", () => $11f6ca9dfa6c0ffd$export$de876e84f23a34b2);

var $lO4Or = parcelRequire("lO4Or");
const $11f6ca9dfa6c0ffd$export$de876e84f23a34b2 = [
    (0, $lO4Or.TIME_ESTIMATE_TYPE)
];

});


parcelRegister("585wU", function(module, exports) {

$parcel$export(module.exports, "urlClipboardHandler", () => $4cc7deb414a8dc9f$export$6e2f5cd13985078c);

var $3wLKg = parcelRequire("3wLKg");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");
const $4cc7deb414a8dc9f$var$getPastedValue = (clipboardItem)=>{
    if (!(0, $b3neV.assertClipboardHasPlainTextFormat)(clipboardItem)) return null;
    return clipboardItem.plainText;
};
function $4cc7deb414a8dc9f$var$assertUrlField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.URL_CF_TYPE)) throw new Error('Field type is not supported');
}
const $4cc7deb414a8dc9f$var$useUrlClipboardHandler = (issue, field)=>{
    $4cc7deb414a8dc9f$var$assertUrlField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $3wLKg.useUrlCustomField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId,
        initialValue: field.value
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value ?? '',
        currentValue: value,
        getPastedValue: $4cc7deb414a8dc9f$var$getPastedValue,
        saveValue: saveValue
    });
};
const $4cc7deb414a8dc9f$var$UrlClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($4cc7deb414a8dc9f$var$useUrlClipboardHandler);
const $4cc7deb414a8dc9f$export$6e2f5cd13985078c = {
    [(0, $lO4Or.URL_CF_TYPE)]: $4cc7deb414a8dc9f$var$UrlClipboardHelper
};

});
parcelRegister("3wLKg", function(module, exports) {

$parcel$export(module.exports, "useUrlCustomField", () => $0d8a50c570e9c30f$export$8745adc9879e9e03);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $0d8a50c570e9c30f$export$8745adc9879e9e03 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = null })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});


parcelRegister("iYRy3", function(module, exports) {

$parcel$export(module.exports, "userClipboardHandler", () => $96536ccc35d78029$export$5fdc9960135beb70);
$parcel$export(module.exports, "multiUserClipboardHandler", () => $96536ccc35d78029$export$6c011954430f0654);

var $dnK1q = parcelRequire("dnK1q");

var $gd2u3 = parcelRequire("gd2u3");

var $lu5Yp = parcelRequire("lu5Yp");

var $bBj5E = parcelRequire("bBj5E");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $0KeHR = parcelRequire("0KeHR");
const $96536ccc35d78029$var$isTransformedUser = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'accountId' in fieldValue && 'name' in fieldValue && 'picture' in fieldValue;
const $96536ccc35d78029$var$isTransformedUserList = (fieldValue)=>fieldValue != null && Array.isArray(fieldValue) && fieldValue.length > 0 && fieldValue.every($96536ccc35d78029$var$isTransformedUser);
function $96536ccc35d78029$var$isUserValue(fieldValue) {
    return fieldValue != null && typeof fieldValue === 'object' && 'accountId' in fieldValue && 'displayName' in fieldValue && 'avatarUrls' in fieldValue;
}
function $96536ccc35d78029$var$isUserValueList(fieldValue) {
    return fieldValue != null && Array.isArray(fieldValue) && fieldValue.length > 0 && fieldValue.every($96536ccc35d78029$var$isUserValue);
}
function $96536ccc35d78029$var$transformToUserValue(fieldValue) {
    const { accountId: accountId, name: name, picture: picture } = fieldValue;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        accountId: accountId,
        displayName: name,
        avatarUrl: picture,
        avatarUrls: {
            '48x48': picture
        }
    };
}
function $96536ccc35d78029$var$getPastedValue(clipboardItem, metadata) {
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $0KeHR.userSupportedTypes))) return null;
    if (!$96536ccc35d78029$var$isUserValue(metadata.fieldValue)) return null;
    return metadata.fieldValue;
}
function $96536ccc35d78029$var$getPastedValuePlural(clipboardItem, metadata) {
    if (!(0, $b3neV.assertClipboardHasRichFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $0KeHR.multiUserSupportedTypes))) return null;
    if (!$96536ccc35d78029$var$isUserValueList(metadata.fieldValue)) return null;
    return metadata.fieldValue;
}
const $96536ccc35d78029$var$useAssigneeClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $dnK1q.default)({
        issueKey: issue.key,
        initialValue: $96536ccc35d78029$var$isTransformedUser(field.value) ? $96536ccc35d78029$var$transformToUserValue(field.value) : undefined
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.displayName || null,
        currentValue: value,
        getPastedValue: $96536ccc35d78029$var$getPastedValue,
        saveValue: saveValue
    });
};
const $96536ccc35d78029$var$useReporterClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $bBj5E.useReporterField)({
        issueKey: issue.key,
        initialValue: $96536ccc35d78029$var$isTransformedUser(field.value) ? $96536ccc35d78029$var$transformToUserValue(field.value) : undefined
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.displayName || null,
        currentValue: value,
        getPastedValue: $96536ccc35d78029$var$getPastedValue,
        saveValue: saveValue
    });
};
const $96536ccc35d78029$var$useSingleUserClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $gd2u3.useUserCustomField)({
        issueKey: issue.key,
        fieldKey: field.fieldId,
        initialValue: $96536ccc35d78029$var$isTransformedUser(field.value) ? $96536ccc35d78029$var$transformToUserValue(field.value) : undefined
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.displayName || null,
        currentValue: value,
        getPastedValue: $96536ccc35d78029$var$getPastedValue,
        saveValue: saveValue
    });
};
const $96536ccc35d78029$var$useMultiUserClipboardHandler = (issue, field)=>{
    const [{ value: value }, { saveValue: saveValue }] = (0, $lu5Yp.useMultiUserCustomField)({
        issueKey: issue.key,
        fieldKey: field.fieldId,
        initialValue: $96536ccc35d78029$var$isTransformedUserList(field.value) ? field.value.map($96536ccc35d78029$var$transformToUserValue) : undefined
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: value?.map((user)=>user.displayName).join(', ') || null,
        currentValue: value,
        getPastedValue: $96536ccc35d78029$var$getPastedValuePlural,
        saveValue: saveValue
    });
};
const $96536ccc35d78029$var$UserClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($96536ccc35d78029$var$useSingleUserClipboardHandler);
const $96536ccc35d78029$var$MultiUserClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($96536ccc35d78029$var$useMultiUserClipboardHandler);
const $96536ccc35d78029$var$AssigneeClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($96536ccc35d78029$var$useAssigneeClipboardHandler);
const $96536ccc35d78029$var$ReporterClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($96536ccc35d78029$var$useReporterClipboardHandler);
const $96536ccc35d78029$export$5fdc9960135beb70 = {
    [(0, $lO4Or.USER_CF_TYPE)]: $96536ccc35d78029$var$UserClipboardHelper,
    [(0, $lO4Or.REPORTER_TYPE)]: $96536ccc35d78029$var$ReporterClipboardHelper,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $96536ccc35d78029$var$AssigneeClipboardHelper
};
const $96536ccc35d78029$export$6c011954430f0654 = {
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: $96536ccc35d78029$var$MultiUserClipboardHelper,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: $96536ccc35d78029$var$MultiUserClipboardHelper
};

});
parcelRegister("dnK1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $28b7c7940962eeef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $axhXb = parcelRequire("axhXb");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
var $kmr29 = parcelRequire("kmr29");



var $aNVyA = parcelRequire("aNVyA");
const $28b7c7940962eeef$var$getCurrentAssigneeUrl = (_baseUrl, issueKey)=>`/rest/api/3/issue/${issueKey}?fields=assignee`;
const $28b7c7940962eeef$var$getCurrentAssignee = async (baseUrl, issueKey)=>{
    const response = await (0, $lRmyA.performGetRequest)($28b7c7940962eeef$var$getCurrentAssigneeUrl(baseUrl, issueKey), {
        ...(0, $axhXb.default)
    });
    const { assignee: assignee } = response.fields;
    return assignee;
};
const $28b7c7940962eeef$export$e3a8121b536e7353 = ({ issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const fieldKey = (0, $ebc098a76317be78$export$e18419056f3d184a);
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'user');
    const [, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$e18419056f3d184a)
    });
    const baseUrl = '';
    const onSaveSuccess = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'currentAssignee' implicitly has an 'any' type.
    (currentAssignee)=>{
        if (currentAssignee && currentAssignee.accountId === (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027)) $28b7c7940962eeef$var$getCurrentAssignee(baseUrl, issueKey).then((assignee)=>{
            setFieldValue(issueKey, (0, $ebc098a76317be78$export$e18419056f3d184a), assignee);
            onSuccess?.(assignee);
        }).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'currentAssigneeFetch',
                    packageName: 'jiraIssueFieldAssignee'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            onSuccess?.(currentAssignee); // In case api fail, better to show Automatic only
        });
        else onSuccess?.(currentAssignee);
    }, [
        baseUrl,
        issueKey,
        onSuccess,
        setFieldValue
    ]);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSaveSuccess,
        onFailure: onFailure,
        saveField: (0, $aNVyA.saveAssigneeField)
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};
var $28b7c7940962eeef$export$2e2bcd8739ae039 = $28b7c7940962eeef$export$e3a8121b536e7353;

});
const $7a4a7348bcf111f0$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $7a4a7348bcf111f0$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $7a4a7348bcf111f0$export$f5d5f6bb902f1027 = '-1';

parcelRegister("aNVyA", function(module, exports) {

$parcel$export(module.exports, "saveAssigneeField", () => $c524a0889f8bfdba$export$4966afe29c596da8);

var $lRmyA = parcelRequire("lRmyA");
const $c524a0889f8bfdba$export$4966afe29c596da8 = async (issueKey, fieldKey, newValue, _baseUrl)=>{
    const userValue = newValue;
    return (0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/assignee`, {
        // the accountId field set to null will unassign the user from the issue as a fallback
        body: JSON.stringify({
            accountId: userValue?.accountId || null
        })
    });
};

});


parcelRegister("gd2u3", function(module, exports) {

$parcel$export(module.exports, "useUserCustomField", () => $294e349634183d9d$export$44f19b35a6cf5de7);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $294e349634183d9d$export$44f19b35a6cf5de7 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.USER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("lu5Yp", function(module, exports) {

$parcel$export(module.exports, "useMultiUserCustomField", () => $41a87322807108ac$export$80bbf5398d3851fe);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $41a87322807108ac$export$80bbf5398d3851fe = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.MULTI_USER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("bBj5E", function(module, exports) {

$parcel$export(module.exports, "useReporterField", () => $2e8f81ed6b967146$export$62a1425ef3dadde5);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");

const $2e8f81ed6b967146$export$62a1425ef3dadde5 = ({ issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const fieldKey = (0, $ebc098a76317be78$export$45cafdfd629c3ca1);
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.REPORTER_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("0KeHR", function(module, exports) {

$parcel$export(module.exports, "userSupportedTypes", () => $fbd64ee5f2c95200$export$ef7e74d56a5479e);
$parcel$export(module.exports, "multiUserSupportedTypes", () => $fbd64ee5f2c95200$export$60f19a2c9595ba14);

var $lO4Or = parcelRequire("lO4Or");
const $fbd64ee5f2c95200$export$ef7e74d56a5479e = [
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.ASSIGNEE_TYPE)
];
const $fbd64ee5f2c95200$export$60f19a2c9595ba14 = [
    (0, $lO4Or.MULTI_USER_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE)
];

});


parcelRegister("9HYKH", function(module, exports) {

$parcel$export(module.exports, "versionClipboardHandler", () => $023c8b311905714b$export$ac26006c0d5889ca);

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $78nSO = parcelRequire("78nSO");

var $kS6SG = parcelRequire("kS6SG");

var $b3neV = parcelRequire("b3neV");

var $iAXnP = parcelRequire("iAXnP");
const $023c8b311905714b$var$isTransformedSingleVersion = (option)=>!!option && typeof option === 'object' && 'id' in option && 'name' in option;
const $023c8b311905714b$var$isTransformedMultipleVersions = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($023c8b311905714b$var$isTransformedSingleVersion);
const $023c8b311905714b$var$emptyValue = [];
function $023c8b311905714b$var$assertVersionField(field) {
    if (!field) throw new Error('Field is required');
    if (field.type !== (0, $lO4Or.MULTI_VERSION_CF_TYPE) && field.type !== (0, $lO4Or.AFFECTS_VERSIONS_TYPE) && field.type !== (0, $lO4Or.FIX_VERSIONS_TYPE) && field.type !== (0, $lO4Or.VERSION_CF_TYPE)) throw new Error('Field type is not supported');
}
const $023c8b311905714b$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!(0, $b3neV.assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, $b3neV.assertClipboardDataIsCompatible)(metadata, (0, $iAXnP.versionSupportedTypes))) return null;
    if (!$023c8b311905714b$var$isTransformedMultipleVersions(metadata?.fieldValue) && !$023c8b311905714b$var$isTransformedSingleVersion(metadata?.fieldValue)) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $iAXnP.versionSupportedTypes).includes(metadata.fieldType)) return null;
    return metadata?.fieldValue;
};
const $023c8b311905714b$var$getInitialValue = (field)=>{
    if (field.type === (0, $lO4Or.VERSION_CF_TYPE)) return field.value ?? null;
    return $023c8b311905714b$var$isTransformedMultipleVersions(field.value) ? field.value : $023c8b311905714b$var$emptyValue;
};
const $023c8b311905714b$var$useVersionClipboardHandler = (issue, field)=>{
    $023c8b311905714b$var$assertVersionField(field);
    const [{ value: value }, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: field.type,
        initialValue: $023c8b311905714b$var$getInitialValue(field)
    });
    return (0, $kS6SG.useClipboardHandler)({
        issue: issue,
        field: field,
        currentStringValue: $023c8b311905714b$var$isTransformedSingleVersion(field.value) ? field.value?.name ?? null : field.value?.map((v)=>v.name).join(',') ?? null,
        currentValue: value,
        getPastedValue: $023c8b311905714b$var$getPastedValue,
        saveValue: saveValue
    });
};
const $023c8b311905714b$var$VersionClipboardHelper = (0, $78nSO.createClipboardHelperComponent)($023c8b311905714b$var$useVersionClipboardHandler);
const $023c8b311905714b$export$ac26006c0d5889ca = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $023c8b311905714b$var$VersionClipboardHelper,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $023c8b311905714b$var$VersionClipboardHelper,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $023c8b311905714b$var$VersionClipboardHelper,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $023c8b311905714b$var$VersionClipboardHelper
};

});


parcelRegister("9jnJo", function(module, exports) {

$parcel$export(module.exports, "getFieldMetadataFromClipboard", () => $9634c483718b7af2$export$6de7bf511f204c08);
const $9634c483718b7af2$export$6de7bf511f204c08 = (clipboard)=>{
    if (!clipboard?.html) return null;
    try {
        const clipboardDocument = new DOMParser().parseFromString(clipboard.html, 'text/html');
        const data = clipboardDocument.body?.querySelector('div')?.dataset;
        if (!data || !data.fieldType || !data.fieldId) return null;
        return {
            fieldType: data.fieldType,
            fieldId: data.fieldId,
            fieldValue: data.fieldValue ? JSON.parse(data.fieldValue) : null,
            sourceIssueTypeLevel: data.issueTypeLevel
        };
    } catch (e) {
        return null;
    }
};
const $9634c483718b7af2$export$94a5f06e658f87e2 = ()=>Promise.resolve(false);

});


parcelRegister("bitBE", function(module, exports) {

$parcel$export(module.exports, "canBeReset", () => $988cdb171b5fcb3d$export$7f0aa0ea8c7401f3);
$parcel$export(module.exports, "useClipboardErrorReporting", () => $988cdb171b5fcb3d$export$a3594035e6545378);
$parcel$export(module.exports, "setDataToClipboard", () => $988cdb171b5fcb3d$export$8b3dcc1c5e2cc52e);

var $eUqFw = parcelRequire("eUqFw");

var $31jh1 = parcelRequire("31jh1");

var $caO3M = parcelRequire("caO3M");

var $a6M4d = parcelRequire("a6M4d");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eSvUt = parcelRequire("eSvUt");
const $988cdb171b5fcb3d$var$UNSETTABLE_FIELD_TYPES = {
    issuekey: true,
    issuetype: true,
    priority: true,
    status: true,
    parent: true
};
const $988cdb171b5fcb3d$export$7f0aa0ea8c7401f3 = (field)=>{
    const isEditable = field.fieldConfig?.isEditable ?? false;
    const isRequired = field.fieldConfig?.isRequired ?? false;
    if (field.type != null && field.type in $988cdb171b5fcb3d$var$UNSETTABLE_FIELD_TYPES) return false;
    return isEditable && !isRequired;
};
const $988cdb171b5fcb3d$var$getPasteMessage = (error, wrappedFormatMessage)=>{
    if ((0, $31jh1.isClientSideValidationError)(error)) {
        if (error.message === (0, $a6M4d.VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD) return {
            title: wrappedFormatMessage((0, $eSvUt.default).emptyClipboardTitle),
            description: wrappedFormatMessage((0, $eSvUt.default).pasteEmptyClipboardError)
        };
        if (error.message === (0, $a6M4d.VALIDATION_ERROR_CODES).MISSING_FIELD) return {
            title: wrappedFormatMessage((0, $eSvUt.default).pasteErrorTitle),
            description: wrappedFormatMessage((0, $eSvUt.default).missingFieldAssociationError)
        };
        if (error.message === (0, $a6M4d.VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE) return {
            title: wrappedFormatMessage((0, $eSvUt.default).pasteErrorTitle),
            description: wrappedFormatMessage((0, $eSvUt.default).pasteUnsupportedError)
        };
    }
    if ((0, $caO3M.isUnsupportedOperationError)(error)) return {
        title: wrappedFormatMessage((0, $eSvUt.default).pasteErrorTitle),
        description: wrappedFormatMessage((0, $eSvUt.default).pasteUnsupportedError)
    };
    return {
        title: wrappedFormatMessage((0, $eSvUt.default).pasteErrorTitle),
        description: wrappedFormatMessage((0, $eSvUt.default).genericServerError)
    };
};
const $988cdb171b5fcb3d$var$getCutMessage = (error, wrappedFormatMessage)=>{
    if ((0, $31jh1.isClientSideValidationError)(error) && error.message === (0, $a6M4d.VALIDATION_ERROR_CODES).NON_EDITABLE) return {
        title: wrappedFormatMessage((0, $eSvUt.default).cutErrorTitle),
        description: wrappedFormatMessage((0, $eSvUt.default).cutNonEditableError)
    };
    return {
        title: wrappedFormatMessage((0, $eSvUt.default).cutErrorTitle),
        description: wrappedFormatMessage((0, $eSvUt.default).genericServerError)
    };
};
const $988cdb171b5fcb3d$var$getCopyMessage = (error, wrappedFormatMessage)=>({
        title: wrappedFormatMessage((0, $eSvUt.default).copyErrorTitle),
        description: wrappedFormatMessage((0, $eSvUt.default).copyValidationError)
    });
const $988cdb171b5fcb3d$var$getErrorMessage = (action, error, wrappedFormatMessage)=>{
    if (action === 'paste') return $988cdb171b5fcb3d$var$getPasteMessage(error, wrappedFormatMessage);
    if (action === 'cut') return $988cdb171b5fcb3d$var$getCutMessage(error, wrappedFormatMessage);
    if (action === 'copy') return $988cdb171b5fcb3d$var$getCopyMessage(error, wrappedFormatMessage);
};
const $988cdb171b5fcb3d$var$uniqueFlagId = (0, $eo17r.toFlagId)('LIST_COPY_PASTE_FLAG');
const $988cdb171b5fcb3d$export$a3594035e6545378 = (field)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const reportError = (0, $eUqFw.useCallback)(({ action: action, error: error })=>{
        if (!error) return;
        const ugcSafeMessage = `Failed to ${action} a field of type ${field.type}`;
        (0, $guiFP.default)({
            meta: {
                id: 'jiraClipboardController',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: ugcSafeMessage,
                fieldType: field.type,
                operation: action
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        const wrappedFormatMessage = (message)=>formatMessage(message, {
                name: field.name
            });
        const errorMessage = $988cdb171b5fcb3d$var$getErrorMessage(action, error, wrappedFormatMessage);
        if (!errorMessage) return;
        showFlag({
            id: $988cdb171b5fcb3d$var$uniqueFlagId,
            type: (0, $31jh1.isClientSideValidationError)(error) ? 'warning' : 'error',
            title: errorMessage.title,
            description: errorMessage.description
        });
    }, [
        showFlag,
        field.type,
        field.name,
        formatMessage
    ]);
    return {
        reportError: reportError,
        dismissFlag: ()=>dismissFlag($988cdb171b5fcb3d$var$uniqueFlagId)
    };
};
const $988cdb171b5fcb3d$export$8b3dcc1c5e2cc52e = (e, clipboardItem)=>{
    if (!e.clipboardData || !clipboardItem || !clipboardItem.plainText || !clipboardItem.html) throw new Error('Clipboard item is not provided');
    e.clipboardData.setData('text/plain', clipboardItem.plainText);
    e.clipboardData.setData('text/html', clipboardItem.html);
};

});
parcelRegister("eSvUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1ce62f4ffc801eb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e1ce62f4ffc801eb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pasteErrorTitle: {
        "id": "business-list.controllers.clipboard.paste-error-title",
        "defaultMessage": "Unable to paste"
    },
    cutErrorTitle: {
        "id": "business-list.controllers.clipboard.cut-error-title",
        "defaultMessage": "We couldn't cut this field"
    },
    copyErrorTitle: {
        "id": "business-list.controllers.clipboard.copy-error-title",
        "defaultMessage": "Unable to copy"
    },
    emptyClipboardTitle: {
        "id": "business-list.controllers.clipboard.empty-clipboard-title",
        "defaultMessage": "Your clipboard is empty"
    },
    genericServerError: {
        "id": "business-list.controllers.clipboard.generic-server-error",
        "defaultMessage": "Your changes couldn't be saved."
    },
    pasteUnsupportedError: {
        "id": "business-list.controllers.clipboard.paste-unsupported-error",
        "defaultMessage": "This can't be pasted on {name}."
    },
    missingFieldAssociationError: {
        "id": "business-list.controllers.clipboard.missing-field-association-error",
        "defaultMessage": "Can't paste on {name}, looks like the field is not associated to this issue type."
    },
    cutNonEditableError: {
        "id": "business-list.controllers.clipboard.cut-non-editable-error",
        "defaultMessage": "{name} is copied to your clipboard instead."
    },
    copyValidationError: {
        "id": "business-list.controllers.clipboard.copy-validation-error",
        "defaultMessage": "{name} can't be copied."
    },
    pasteEmptyClipboardError: {
        "id": "business-list.controllers.clipboard.paste-empty-clipboard-error",
        "defaultMessage": "Cut or copy your data, then try again."
    }
});

});



parcelRegister("cOE3G", function(module, exports) {

$parcel$export(module.exports, "KEY_LEFT", () => $12410568959db5bf$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $12410568959db5bf$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_UP", () => $12410568959db5bf$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $12410568959db5bf$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_SPACE", () => $12410568959db5bf$export$e51a3576c045c8d5);
$parcel$export(module.exports, "KEY_ENTER", () => $12410568959db5bf$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_ESCAPE", () => $12410568959db5bf$export$929c2026f4dd54a2);
$parcel$export(module.exports, "KEY_TAB", () => $12410568959db5bf$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "VALID_HORIZONTAL_NAV_KEYS", () => $12410568959db5bf$export$4db3e0c7105aa3de);
$parcel$export(module.exports, "VALID_NAVIGATION_KEYS", () => $12410568959db5bf$export$dbef91493a5ef2ef);
$parcel$export(module.exports, "NAV_KEYS_TO_DIRECTION", () => $12410568959db5bf$export$678e8f968de3f1e5);
$parcel$export(module.exports, "getNewNavSupportedFieldTypes", () => $12410568959db5bf$export$a421a6d0cf26d9e);

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $8lNor = parcelRequire("8lNor");

var $lO4Or = parcelRequire("lO4Or");

var $gbsaq = parcelRequire("gbsaq");
const $12410568959db5bf$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $12410568959db5bf$export$c40f9845adc73fb5 = 'ArrowRight';
const $12410568959db5bf$export$390330c10ff2b9a1 = 'ArrowUp';
const $12410568959db5bf$export$a80636c6f41931fe = 'ArrowDown';
const $12410568959db5bf$export$e51a3576c045c8d5 = ' ';
const $12410568959db5bf$export$8152f929a25a0ff4 = 'Enter';
const $12410568959db5bf$export$929c2026f4dd54a2 = 'Escape';
const $12410568959db5bf$export$10f6869ed0a7d75b = 'Tab';
const $12410568959db5bf$export$4db3e0c7105aa3de = new Set([
    $12410568959db5bf$export$fc4577f2a2af0ae3,
    $12410568959db5bf$export$c40f9845adc73fb5,
    $12410568959db5bf$export$10f6869ed0a7d75b
]);
const $12410568959db5bf$export$dbef91493a5ef2ef = new Set([
    ...$12410568959db5bf$export$4db3e0c7105aa3de,
    $12410568959db5bf$export$390330c10ff2b9a1,
    $12410568959db5bf$export$a80636c6f41931fe,
    $12410568959db5bf$export$e51a3576c045c8d5,
    $12410568959db5bf$export$8152f929a25a0ff4,
    $12410568959db5bf$export$929c2026f4dd54a2
]);
const $12410568959db5bf$export$678e8f968de3f1e5 = {
    [$12410568959db5bf$export$fc4577f2a2af0ae3]: (0, $gbsaq.LEFT),
    [$12410568959db5bf$export$c40f9845adc73fb5]: (0, $gbsaq.RIGHT),
    [$12410568959db5bf$export$390330c10ff2b9a1]: (0, $gbsaq.UP),
    [$12410568959db5bf$export$a80636c6f41931fe]: (0, $gbsaq.DOWN)
};
// todo: delete this on cleaning up jira_list_keyboard_nav
const $12410568959db5bf$var$NEW_NAV_SUPPORTED_FIELD_TYPES = new Set([
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.COMMENT_TYPE),
    (0, $jGcn0.COMMENT_SUMMARY_TYPE),
    (0, $lO4Or.CREATED),
    (0, $lO4Or.DATE_CF_TYPE),
    (0, $lO4Or.DATETIME_CF_TYPE),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $lO4Or.LABELS_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_USER_CF_TYPE),
    (0, $lO4Or.NUMBER_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.STORY_POINTS_TYPE),
    (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
    (0, $lO4Or.SPRINT_TYPE),
    (0, $lO4Or.SUMMARY_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.TEXT_AREA_CF_TYPE),
    (0, $lO4Or.TEXT_CF_TYPE),
    (0, $lO4Or.TIME_ESTIMATE_TYPE),
    (0, $lO4Or.UPDATED),
    (0, $lO4Or.URL_CF_TYPE),
    (0, $lO4Or.USER_CF_TYPE),
    'key'
]);
const $12410568959db5bf$export$a421a6d0cf26d9e = (0, $5iWql.default)(()=>new Set([
        ...$12410568959db5bf$var$NEW_NAV_SUPPORTED_FIELD_TYPES,
        ...(0, $8lNor.getSupportedFieldTypes)(true)
    ]));

});


parcelRegister("en1mL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa06c39bf74c60b7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fa06c39bf74c60b7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreSelections: {
        "id": "business-list.list-view.cell.with-cell-selection.more-selections",
        "defaultMessage": " + {count, plural, one {# other} other {# others}}"
    }
});

});



parcelRegister("fG10K", function(module, exports) {

$parcel$export(module.exports, "default", () => $647ccd5ad04117e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $647ccd5ad04117e7$var$CheckboxCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("h3ePX")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/checkbox-cell/main.tsx"
});
const $647ccd5ad04117e7$var$AsyncCheckboxCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "checkbox-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($647ccd5ad04117e7$var$CheckboxCell, props));
var $647ccd5ad04117e7$export$2e2bcd8739ae039 = $647ccd5ad04117e7$var$AsyncCheckboxCell;

});
parcelRegister("h3ePX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("yx28O")
]).then(()=>parcelRequire('3JWU6'));

});


parcelRegister("2Mt92", function(module, exports) {

$parcel$export(module.exports, "ColumnHeader", () => $d46282cefdca340c$export$5667c09b71ee0f05);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $a576Y = parcelRequire("a576Y");

var $kQAZu = parcelRequire("kQAZu");

var $hA1pi = parcelRequire("hA1pi");

var $78SWx = parcelRequire("78SWx");

var $1q8y0 = parcelRequire("1q8y0");

var $gQdUL = parcelRequire("gQdUL");

var $ggIv3 = parcelRequire("ggIv3");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hUuH5 = parcelRequire("hUuH5");


var $lAcL9 = parcelRequire("lAcL9");

var $eCeSD = parcelRequire("eCeSD");

var $cdECG = parcelRequire("cdECG");
const $d46282cefdca340c$var$BOUNDARY = 70;
const $d46282cefdca340c$var$MOUSE_MOVE_THROTTLE = 16;
const $d46282cefdca340c$export$cdd17a489f5a2a5c = 'business-list.ui.list-view.column-header.column-header-container';
const $d46282cefdca340c$var$COLUMN_HEADER_DRAG_HANDLE_TEST_ID = 'business-list.ui.list-view.column-header.column-header-container.drag-handle';
const $d46282cefdca340c$export$5667c09b71ee0f05 = ({ icon: icon, label: label, canSortField: canSortField = true, canHideField: canHideField = false, canEditField: canEditField = false, fieldId: fieldId, fieldType: fieldType = '', disableDrag: isDragDisabled, index: index })=>{
    const [isHovering, setIsHovering] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const project = (0, $kQAZu.useProject)();
    const projectId = String(project.id);
    const ref = (0, $eUqFw.useRef)(null);
    const { status: dragStatus } = (0, $1q8y0.useReorderColumns)({
        ref: ref,
        id: fieldId,
        index: index,
        isDragDisabled: isDragDisabled
    });
    const { dropTargetJSX: dropTargetJSX } = (0, $78SWx.useFullHeightColumnDropTarget)({
        id: fieldId,
        index: index
    });
    const [{ isSelected: isSelected }] = (0, $lAcL9.useInlineFieldCreateControls)();
    const { clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay, setIndex: setIndex } = (0, $hUuH5.useInlineCreateActions)();
    const { getFieldDetails: getFieldDetails, fieldDetails: fieldDetails, called: called } = (0, $hA1pi.useFieldDetails)(projectId, false);
    (0, $eUqFw.useEffect)(()=>{
        if (canEditField && isHovering && !fieldDetails && !called) getFieldDetails(fieldId);
    }, [
        called,
        canEditField,
        fieldDetails,
        fieldId,
        getFieldDetails,
        isHovering
    ]);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ updated: MessageDescriptorV2; created: MessageDescriptorV2; priority: MessageDescriptorV2; duedate: MessageDescriptorV2; ... 5 more ...; issuetype: MessageDescriptorV2; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ updated: MessageDescriptorV2; created: MessageDescriptorV2; priority: MessageDescriptorV2; duedate: MessageDescriptorV2; ... 5 more ...; issuetype: MessageDescriptorV2; }'.
    const customLabel = (0, $eCeSD.default)[fieldId] ? formatMessage((0, $eCeSD.default)[fieldId]) : label;
    const showActions = canSortField || canHideField || canEditField;
    const editActionIsVisible = canEditField && !!fieldDetails?.operations.editable;
    const columnActions = showActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdECG.ActionsWrapper), {
        "data-testid": "business-list.ui.list-view.column-header.actions-wrapper"
    }, canSortField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ggIv3.default), {
        columnName: fieldId,
        isVisible: isHovering,
        fieldType: fieldType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQdUL.default), {
        fieldId: fieldId,
        isVisible: isHovering,
        fieldType: fieldType,
        visibleActions: {
            sort: canSortField,
            hide: canHideField,
            edit: editActionIsVisible
        }
    })) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const calculateColumnIndex = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((event)=>{
        if (!event.currentTarget) return;
        const rect = event.currentTarget.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const width = rect.right - rect.left;
        if (x < width / 2 && x <= $d46282cefdca340c$var$BOUNDARY) setIndex((0, $858485d0615f86f6$export$d6f887e0c1be1b74), index - 1);
        else if (x >= width / 2 && x >= width - $d46282cefdca340c$var$BOUNDARY) setIndex((0, $858485d0615f86f6$export$d6f887e0c1be1b74), index);
        else clearIndex((0, $858485d0615f86f6$export$d6f887e0c1be1b74));
    }, $d46282cefdca340c$var$MOUSE_MOVE_THROTTLE), [
        index,
        setIndex,
        clearIndex
    ]);
    const handleMouseEnter = (0, $eUqFw.useCallback)(()=>setIsHovering(true), []);
    const handleMouseLeave = (0, $eUqFw.useCallback)(()=>{
        setIsHovering(false);
        !isSelected && clearIndexAfterDelay((0, $858485d0615f86f6$export$d6f887e0c1be1b74));
    }, [
        clearIndexAfterDelay,
        isSelected
    ]);
    const handleMouseMove = (0, $eUqFw.useCallback)((event)=>{
        event.persist(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (ref.current?.contains(event.target)) calculateColumnIndex(event);
        else clearIndex((0, $858485d0615f86f6$export$d6f887e0c1be1b74));
    }, [
        calculateColumnIndex,
        clearIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdECG.ColumnHeaderContainer), {
        "data-testid": $d46282cefdca340c$export$cdd17a489f5a2a5c,
        ref: ref,
        dragStatus: dragStatus,
        isDragDisabled: isDragDisabled,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseMove: handleMouseMove
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdECG.Title), null, isHovering && isDragDisabled !== true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d46282cefdca340c$var$ColumnDragHandle, {
        "data-testid": $d46282cefdca340c$var$COLUMN_HEADER_DRAG_HANDLE_TEST_ID
    }) : icon != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdECG.IconWrapper), null, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdECG.TextWrapper), null, customLabel)), dragStatus === 'idle' ? columnActions : null, isDragDisabled !== true ? dropTargetJSX : null);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d46282cefdca340c$var$ColumnDragHandle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1kt9mrja _is061n3s _1mp41tcg _cfu11txw _24gj1h6o _18oh15vq _eid31b66 _fntn1b66 _sxliewfl _bc1wewfl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hA1pi", function(module, exports) {

$parcel$export(module.exports, "useFieldDetails", () => $25395f6eaa1a1d99$export$ad7ee326a4c8ec42);

var $eUqFw = parcelRequire("eUqFw");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $huI7r = parcelRequire("huI7r");

var $gd0Sp = parcelRequire("gd0Sp");

var $dhsRn = parcelRequire("dhsRn");

var $3ZwQn = parcelRequire("3ZwQn");

var $dVtoT = parcelRequire("dVtoT");
const $25395f6eaa1a1d99$export$3fa4bbd5b4cf486d = (0, $eo17r.toFlagId)('field-details-error-flag');
const $25395f6eaa1a1d99$export$ad7ee326a4c8ec42 = (projectId, showErrorFlag = true)=>{
    const { getFieldDetails: getFieldDetailsService, fieldDetails: fieldDetails, loading: loading, error: error, called: called } = (0, $dhsRn.useFieldDetails)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const projectAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: projectId
        }), [
        projectId,
        cloudId
    ]);
    const cloudAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira',
            resourceType: 'site',
            resourceId: cloudId
        }), [
        cloudId
    ]);
    const getFieldDetails = (0, $eUqFw.useCallback)((fieldId)=>{
        getFieldDetailsService({
            fieldId: fieldId,
            cloudId: cloudAri,
            projectId: projectAri
        });
    }, [
        getFieldDetailsService,
        cloudAri,
        projectAri
    ]);
    const associatedFieldDetails = (0, $eUqFw.useMemo)(()=>(0, $3ZwQn.toAssociatedField)(fieldDetails), [
        fieldDetails
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!showErrorFlag) return;
        if (error) showFlag({
            id: $25395f6eaa1a1d99$export$3fa4bbd5b4cf486d,
            type: 'error',
            title: (0, $dVtoT.default).errorTitle,
            description: (0, $dVtoT.default).errorMessage
        });
        else dismissFlag($25395f6eaa1a1d99$export$3fa4bbd5b4cf486d);
    }, [
        error,
        showFlag,
        dismissFlag,
        showErrorFlag
    ]);
    return {
        getFieldDetails: getFieldDetails,
        fieldDetails: associatedFieldDetails,
        loading: loading,
        error: error,
        called: called
    };
};

});
parcelRegister("dhsRn", function(module, exports) {

$parcel$export(module.exports, "useFieldDetails", () => $b99058508c251e97$export$ad7ee326a4c8ec42);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $4G5xU = parcelRequire("4G5xU");

var $guiFP = parcelRequire("guiFP");

var $fYtpD = parcelRequire("fYtpD");

var $5w4X4 = parcelRequire("5w4X4");
const $b99058508c251e97$export$ad7ee326a4c8ec42 = ()=>{
    const onExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $fYtpD.GET_FIELD_DETAILS_EXPERIENCE));
    const onExperienceFail = (0, $4G5xU.useExperienceFail)((0, $fYtpD.GET_FIELD_DETAILS_EXPERIENCE));
    const onExperienceStart = (0, $4G5xU.useExperienceStart)((0, $fYtpD.GET_FIELD_DETAILS_EXPERIENCE));
    const [getFieldDetailsQuery, { data: data, loading: loading, error: error, called: called }] = (0, $iZuDo.useLazyQuery)((0, $5w4X4.QUERY), {
        onCompleted: ()=>{
            onExperienceSuccess();
        },
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'JwmCustomFieldDetails',
                    packageName: 'jiraBusinessInlineFieldConfigSidebar',
                    teamName: 'jira-warepil'
                },
                error: Array.isArray(apolloError) && apolloError.length > 0 ? apolloError[0] : apolloError,
                attributes: {
                    message: 'Failed to retrieve field details'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            onExperienceFail('Failed to retrieve field details', apolloError);
        },
        fetchPolicy: 'no-cache'
    });
    const getFieldDetails = (0, $eUqFw.useCallback)((variables)=>{
        onExperienceStart();
        getFieldDetailsQuery({
            variables: variables
        });
    }, [
        onExperienceStart,
        getFieldDetailsQuery
    ]);
    return {
        getFieldDetails: getFieldDetails,
        fieldDetails: data,
        error: error,
        loading: loading,
        called: called
    };
};

});
parcelRegister("5w4X4", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $4b28ee6a644779c6$export$2b91517d6d5b4365);

var $9ypom = parcelRequire("9ypom");
const $4b28ee6a644779c6$export$2b91517d6d5b4365 = (0, $9ypom.default)`
query JWMFieldDetails($cloudId: ID!, $projectId: ID!, $fieldId: String!) {
  jira {
    jwmCustomFieldDetails(cloudId: $cloudId, projectId: $projectId, fieldId: $fieldId) {
      fieldId
      name
      type
      description
      options(first: 100) {
        edges {
          node {
            optionId
            value
            isDisabled
            color {
              id
              colorKey
            }
          }
        }
      }
      configuration
      operations {
        editable
        removable
        deletable
        categoriesWhitelist
        canModifyRequired
        canModifyOptions
        canModifyDefaultValue
        canModifyPropertyConfiguration
        canAssociateInSettings
      }
    }
  }
}`;

});


parcelRegister("3ZwQn", function(module, exports) {

$parcel$export(module.exports, "toAssociatedField", () => $23b075b0e6543f14$export$b14a602973946199);
const $23b075b0e6543f14$export$b14a602973946199 = (data)=>{
    const fieldDetails = data?.jira?.jwmCustomFieldDetails;
    if (!fieldDetails) return;
    return {
        name: fieldDetails.name ?? '',
        key: fieldDetails.fieldId ?? '',
        externalUuid: fieldDetails.fieldId ?? '',
        type: fieldDetails.type ?? '',
        custom: true,
        global: false,
        description: fieldDetails.description ?? '',
        category: '',
        required: false,
        options: fieldDetails.options?.edges ? fieldDetails.options.edges.map((edge)=>({
                id: +String(edge?.node?.optionId),
                optimisticId: String(edge?.node?.optionId),
                value: String(edge?.node?.value),
                externalUuid: String(edge?.node?.optionId)
            })) : undefined,
        configuration: fieldDetails.configuration,
        operations: {
            editable: fieldDetails.operations?.editable ?? false,
            deletable: fieldDetails.operations?.deletable ?? false,
            removable: fieldDetails.operations?.removable ?? false,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            categoriesWhitelist: fieldDetails.operations?.categoriesWhitelist ?? [],
            canAssociateInSettings: fieldDetails.operations?.canAssociateInSettings ?? false,
            canModifyOptions: fieldDetails.operations?.canModifyOptions ?? false,
            canModifyDefaultValue: false,
            canModifyPropertyConfiguration: fieldDetails.operations?.canModifyPropertyConfiguration ?? false,
            canModifyRequired: fieldDetails.operations?.canModifyRequired ?? false
        },
        availability: null
    };
};

});

parcelRegister("dVtoT", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d172b07ec89405$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $72d172b07ec89405$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-inline-field-config-sidebar.controllers.field-details.error-title",
        "defaultMessage": "We couldn't load the field details"
    },
    errorMessage: {
        "id": "business-inline-field-config-sidebar.controllers.field-details.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("78SWx", function(module, exports) {

$parcel$export(module.exports, "useFullHeightColumnDropTarget", () => $02037222f73e7f06$export$2d25a320c0ca42d3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $loClp = parcelRequire("loClp");

var $4wxE1 = parcelRequire("4wxE1");
const $02037222f73e7f06$export$79660a248b11010 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1lxk _4t3iz7a8 _1e0cglyw",
            __cmplp.className
        ])
    });
});
function $02037222f73e7f06$export$2d25a320c0ca42d3({ id: id, index: index }) {
    const [closestEdge, setClosestEdge] = (0, $eUqFw.useState)(null);
    const [isDraggingAnyColumn, setIsDraggingAnyColumn] = (0, $eUqFw.useState)(false);
    const { monitorForElements: monitorForElements, dropTargetForElements: dropTargetForElements, attachClosestEdge: attachClosestEdge, extractClosestEdge: extractClosestEdge } = (0, $4wxE1.useDragAndDropAsyncModules)();
    const dropTargetRef = (0, $eUqFw.useRef)(null);
    const dropTargetJSX = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02037222f73e7f06$export$79660a248b11010, {
        ref: dropTargetRef,
        "data-testid": "business-list.controllers.drag-and-drop.use-full-height-column-drop-target.drop-target"
    }, closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $loClp.DropIndicator), {
        edge: closestEdge
    }));
    (0, $eUqFw.useEffect)(()=>monitorForElements({
            canMonitor ({ source: source }) {
                return source.data.type === 'table-header';
            },
            onGenerateDragPreview () {
                if (dropTargetRef.current) dropTargetRef.current.style.display = 'block';
            },
            onDragStart () {
                setIsDraggingAnyColumn(true);
            },
            onDrop () {
                setIsDraggingAnyColumn(false);
                if (dropTargetRef.current) dropTargetRef.current.style.display = 'none';
            }
        }), [
        monitorForElements,
        setIsDraggingAnyColumn
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const dropTarget = dropTargetRef.current;
        if (!isDraggingAnyColumn || !dropTarget) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        return dropTargetForElements({
            element: dropTarget,
            getIsSticky () {
                return true;
            },
            getData ({ input: input, element: element }) {
                const data = {
                    id: id,
                    index: index
                };
                return attachClosestEdge(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            canDrop ({ source: source }) {
                return source.data.type === 'table-header';
            },
            onDrag ({ source: source, self: self }) {
                if (source.data.id !== id) setClosestEdge(extractClosestEdge(self.data));
            },
            onDragLeave () {
                setClosestEdge(null);
            },
            onDrop () {
                setClosestEdge(null);
            }
        });
    }, [
        attachClosestEdge,
        dropTargetForElements,
        extractClosestEdge,
        id,
        index,
        isDraggingAnyColumn
    ]);
    return {
        dropTargetJSX: dropTargetJSX
    };
}

});
parcelRegister("loClp", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $fc57283f6cd57fbe$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $fc57283f6cd57fbe$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $fvYC3 = parcelRequire("fvYC3");
const $fc57283f6cd57fbe$var$lineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    position: 'absolute',
    zIndex: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $fvYC3.line).backgroundColor,
    content: '""',
    pointerEvents: 'none'
});
const $fc57283f6cd57fbe$var$edgeStyles = {
    top: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $fvYC3.line).thickness,
        top: 'var(--local-line-offset)',
        right: 0,
        left: 0
    }),
    right: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $fvYC3.line).thickness,
        top: 0,
        right: 'var(--local-line-offset)',
        bottom: 0
    }),
    bottom: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $fvYC3.line).thickness,
        right: 0,
        bottom: 'var(--local-line-offset)',
        left: 0
    }),
    left: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $fvYC3.line).thickness,
        top: 0,
        bottom: 0,
        left: 'var(--local-line-offset)'
    })
};
function $fc57283f6cd57fbe$export$62ed72bc21f6b8a6({ edge: edge, gap: gap = '0px' }) {
    /**
   * To clearly communicate the resting place of a draggable item during a drag operation,
   * the drop indicator should be positioned half way between draggable items.
   */ const lineOffset = `calc(-0.5 * (${gap} + ${(0, $fvYC3.line).thickness}px))`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fc57283f6cd57fbe$var$lineStyles,
            edge && $fc57283f6cd57fbe$var$edgeStyles[edge]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--local-line-offset': lineOffset
        }
    });
}
var // This default export is intended for usage with React.lazy
$fc57283f6cd57fbe$export$2e2bcd8739ae039 = $fc57283f6cd57fbe$export$62ed72bc21f6b8a6;

});
parcelRegister("fvYC3", function(module, exports) {

$parcel$export(module.exports, "line", () => $eb1ef4b0dfcaaeec$export$53f1d5ea8de3d7c);
/**
 * Design decisions for the drop indicator's main line
 */ const $eb1ef4b0dfcaaeec$export$53f1d5ea8de3d7c = {
    borderRadius: 0,
    thickness: 2,
    backgroundColor: "var(--ds-border-selected, #0C66E4)"
};

});


parcelRegister("4wxE1", function(module, exports) {

$parcel$export(module.exports, "useDragAndDropAsyncModules", () => $425bd90ad6f66715$export$c56d63ea801ce3a6);

var $eUqFw = parcelRequire("eUqFw");

var $fXIwx = parcelRequire("fXIwx");
var $7Ps6V = parcelRequire("7Ps6V");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

const $425bd90ad6f66715$export$d146a9e5d792fbb2 = ()=>(0, $fXIwx.importForInteraction)(()=>Promise.resolve((parcelRequire("eo9PV"))), {
        moduleId: "a81eb583"
    });

const $425bd90ad6f66715$export$7c4ce555ad7d3850 = ()=>(0, $fXIwx.importForInteraction)(()=>(parcelRequire("eCgUW")), {
        moduleId: "63a9d67a"
    });

const $425bd90ad6f66715$export$435d59857451154b = ()=>(0, $fXIwx.importForInteraction)(()=>(parcelRequire("1qVSv")), {
        moduleId: "5ef6ba42"
    });

const $425bd90ad6f66715$export$361499d975b59f21 = ()=>(0, $fXIwx.importForInteraction)(()=>(parcelRequire("gKAfL")), {
        moduleId: "fbbc3330"
    });

const $425bd90ad6f66715$export$5e8458edfac77ad = ()=>(0, $fXIwx.importForInteraction)(()=>(parcelRequire("NEB8b")), {
        moduleId: "8a3e47ea"
    });

const $425bd90ad6f66715$export$d75430c29c69863c = ()=>(0, $fXIwx.importForInteraction)(()=>(parcelRequire("5EXNi")), {
        moduleId: "b863ce2b"
    });
const $425bd90ad6f66715$export$86880b4b2e1a2384 = 'column.widths';
const $425bd90ad6f66715$var$actions = {
    loadModules: ()=>({ setState: setState })=>{
            (0, $7Ps6V.waitForAllResources)([
                $425bd90ad6f66715$export$d146a9e5d792fbb2(),
                $425bd90ad6f66715$export$7c4ce555ad7d3850(),
                $425bd90ad6f66715$export$435d59857451154b(),
                $425bd90ad6f66715$export$361499d975b59f21(),
                $425bd90ad6f66715$export$5e8458edfac77ad(),
                $425bd90ad6f66715$export$d75430c29c69863c()
            ]).onComplete(([{ draggable: draggable, monitorForElements: monitorForElements, dropTargetForElements: dropTargetForElements }, { autoScroller: autoScroller }, { attachClosestEdge: attachClosestEdge, extractClosestEdge: extractClosestEdge }, // @ts-expect-error waitForAllResources has a wrong type
            { getReorderDestinationIndex: getReorderDestinationIndex }, // @ts-expect-error same as above
            { combine: combine }, // @ts-expect-error same as above
            { attachInstruction: attachInstruction, extractInstruction: extractInstruction }])=>{
                setState({
                    draggable: draggable,
                    monitorForElements: monitorForElements,
                    dropTargetForElements: dropTargetForElements,
                    autoScroller: autoScroller,
                    attachClosestEdge: attachClosestEdge,
                    extractClosestEdge: extractClosestEdge,
                    getReorderDestinationIndex: getReorderDestinationIndex,
                    combine: combine,
                    attachInstruction: attachInstruction,
                    extractInstruction: extractInstruction
                });
            });
        }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function
const $425bd90ad6f66715$var$noop = ()=>()=>{};
const $425bd90ad6f66715$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        draggable: $425bd90ad6f66715$var$noop,
        monitorForElements: $425bd90ad6f66715$var$noop,
        dropTargetForElements: $425bd90ad6f66715$var$noop,
        autoScroller: {
            start: $425bd90ad6f66715$var$noop,
            stop: $425bd90ad6f66715$var$noop,
            updateInput: $425bd90ad6f66715$var$noop
        },
        attachClosestEdge: $425bd90ad6f66715$var$noop,
        extractClosestEdge: $425bd90ad6f66715$var$noop,
        getReorderDestinationIndex: $425bd90ad6f66715$var$noop,
        combine: $425bd90ad6f66715$var$noop,
        attachInstruction: $425bd90ad6f66715$var$noop,
        extractInstruction: $425bd90ad6f66715$var$noop
    },
    actions: $425bd90ad6f66715$var$actions,
    name: 'JWMDragAndDropAsyncModulesStore'
});
const $425bd90ad6f66715$var$useHook = (0, $1yZQx.createHook)($425bd90ad6f66715$var$Store);
const $425bd90ad6f66715$export$c56d63ea801ce3a6 = ()=>{
    const [asyncModules, { loadModules: loadModules }] = $425bd90ad6f66715$var$useHook();
    (0, $eUqFw.useEffect)(()=>{
        loadModules();
    }, [
        loadModules
    ]);
    return asyncModules;
};

});
parcelRegister("fXIwx", function(module, exports) {

$parcel$export(module.exports, "importForInteraction", () => $72cae04f88e78007$export$5b50cea0b44df65b);

var $3S0d8 = parcelRequire("3S0d8");

var $exT6p = parcelRequire("exT6p");

var $1XFiH = parcelRequire("1XFiH");
const $72cae04f88e78007$var$cache = (0, $3S0d8.createCache)(new Map());
function $72cae04f88e78007$export$5b50cea0b44df65b(loader, opts) {
    const resource = $72cae04f88e78007$var$cache.get(opts.moduleId, ()=>(0, $exT6p.JSResource)(()=>(0, $1XFiH.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
    resource.load().catch(()=>{});
    return resource;
}

});

parcelRegister("7Ps6V", function(module, exports) {

$parcel$export(module.exports, "waitForAllResources", () => $2e7f1751a6fe8b12$export$c33694368275e0ee);
function $2e7f1751a6fe8b12$export$c33694368275e0ee(resources) {
    return {
        onComplete (onLoad, onError) {
            const cleanups = [];
            const values = new Array(resources.length);
            let completed = false;
            const dispose = ()=>{
                cleanups.forEach((cleanup)=>cleanup());
                cleanups.length = 0;
            };
            const done = ()=>{
                dispose();
                completed = true;
            };
            let loadedResources = 0;
            for(let i = 0; i < resources.length && !completed; i++){
                const completable = resources[i];
                cleanups.push(completable.onComplete((value)=>{
                    values[i] = value;
                    loadedResources++;
                    if (loadedResources === resources.length) {
                        onLoad(values);
                        done();
                    }
                }, (error)=>{
                    onError?.(error);
                    done();
                }));
            }
            return dispose;
        }
    };
}

});

parcelRegister("eCgUW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hjT7J").then(()=>parcelRequire('5Pwiq'));

});

parcelRegister("1qVSv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l4v3n").then(()=>parcelRequire('fSMvP'));

});

parcelRegister("gKAfL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("Zns5L").then(()=>parcelRequire('4c90u'));

});

parcelRegister("NEB8b", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jmPXK").then(()=>parcelRequire('3f2za'));

});

parcelRegister("5EXNi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("116mw").then(()=>parcelRequire('dLGEC'));

});



parcelRegister("1q8y0", function(module, exports) {

$parcel$export(module.exports, "useReorderColumns", () => $0d4ced0bc7fb3f86$export$b250c61f32d9da58);

var $eUqFw = parcelRequire("eUqFw");

var $4wxE1 = parcelRequire("4wxE1");

var $g20qB = parcelRequire("g20qB");

var $hjMF7 = parcelRequire("hjMF7");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $0d4ced0bc7fb3f86$var$noop = ()=>{};
const $0d4ced0bc7fb3f86$export$b250c61f32d9da58 = ({ id: id, index: index, isDragDisabled: isDragDisabled, ref: ref })=>{
    const [status, setStatus] = (0, $eUqFw.useState)('idle');
    const { combine: combine, draggable: draggable } = (0, $4wxE1.useDragAndDropAsyncModules)();
    (0, $eUqFw.useEffect)(()=>{
        const el = ref.current;
        if (isDragDisabled || !el) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        let nextSiblingCleanupFn = $0d4ced0bc7fb3f86$var$noop;
        let tableBodyCleanupFn = $0d4ced0bc7fb3f86$var$noop;
        return combine(draggable({
            element: el,
            getInitialData () {
                return {
                    type: 'table-header',
                    id: id,
                    index: index
                };
            },
            onGenerateDragPreview () {
                setStatus('preview');
                // make sure the drag preview doesn't have table scroll
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const tableBody = el.closest(`.${(0, $g20qB.cl).BASE_TABLE}`)?.querySelector(`.${(0, $g20qB.cl).BASE_TABLE_BODY}`);
                if (tableBody) tableBodyCleanupFn = (0, $hjMF7.setStyle)(tableBody, {
                    overflow: 'hidden'
                });
                // hide resize handle for the drag preview
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const nextSibling = el?.nextSibling;
                if (nextSibling) nextSiblingCleanupFn = (0, $hjMF7.setStyle)(nextSibling, {
                    visibility: 'hidden'
                });
            },
            onDragStart () {
                setStatus('dragging');
                tableBodyCleanupFn();
            },
            onDrop () {
                setStatus('idle');
                nextSiblingCleanupFn();
            }
        }));
    }, [
        isDragDisabled,
        id,
        index,
        ref,
        draggable,
        combine
    ]);
    return {
        status: status
    };
};

});
parcelRegister("g20qB", function(module, exports) {

$parcel$export(module.exports, "cssVarTableHeight", () => $aeeda964183feaca$export$4c4d2d5ba926bbe5);
$parcel$export(module.exports, "cl", () => $aeeda964183feaca$export$b975d55abac2bbe3);
$parcel$export(module.exports, "INDENT_PER_LEVEL", () => $aeeda964183feaca$export$130b26c73bb9d040);
$parcel$export(module.exports, "EXPAND_DELAY_MS", () => $aeeda964183feaca$export$e5daf2bc041d74b0);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $aeeda964183feaca$export$5b388ccfa29be01);
const $aeeda964183feaca$export$4c4d2d5ba926bbe5 = '--jwm-list-height';
const $aeeda964183feaca$export$b975d55abac2bbe3 = {
    BASE_TABLE: 'BaseTable',
    BASE_TABLE_BODY: 'BaseTable__body',
    BASE_TABLE_TABLE: 'BaseTable__table',
    MULTIDRAG_COUNTER: 'jwm-multidrag-counter'
};
const $aeeda964183feaca$export$130b26c73bb9d040 = 25;
const $aeeda964183feaca$export$e5daf2bc041d74b0 = 500;
const $aeeda964183feaca$export$5b388ccfa29be01 = -1;

});

parcelRegister("hjMF7", function(module, exports) {

$parcel$export(module.exports, "setStyle", () => $848101c3f10a2435$export$37a5fde709c1db82);
/* eslint-disable no-param-reassign */ /** Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $848101c3f10a2435$export$37a5fde709c1db82(el, css) {
    const originalCss = {};
    Object.keys(css).forEach((property)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        originalCss[property] = el.style[property];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        el.style[property] = css[property];
    });
    return ()=>{
        Object.keys(originalCss).forEach((property)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            el.style[property] = originalCss[property];
        });
    };
}

});


parcelRegister("gQdUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6c7f5836ca36f72$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fuZtH = parcelRequire("fuZtH");
const $d6c7f5836ca36f72$var$ActionsDropdownMenu = ({ isVisible: isVisible, ...rest })=>{
    const [isMenuOpen, setMenuOpen] = (0, $eUqFw.useState)(false);
    // Defer loading ActionsDropdownMenu until the column is hovered
    return isMenuOpen || isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fuZtH.default), {
        ...rest,
        setMenuOpen: setMenuOpen
    }) : null;
};
var $d6c7f5836ca36f72$export$2e2bcd8739ae039 = $d6c7f5836ca36f72$var$ActionsDropdownMenu;

});
parcelRegister("fuZtH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb3560db7e29ea1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7bb3560db7e29ea1$var$ActionsDropdownMenu = (0, $7rh0R.lazy)(()=>(parcelRequire("4uGwt")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/column-header/field-actions/actions-dropdown-menu/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7bb3560db7e29ea1$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-common-actions-dropdown-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bb3560db7e29ea1$var$ActionsDropdownMenu, props));

});
parcelRegister("4uGwt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dydm5")
]).then(()=>parcelRequire('gsOav'));

});



parcelRegister("ggIv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ac91866b442541a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iaCjO = parcelRequire("iaCjO");

var $gGtKh = parcelRequire("gGtKh");

const $4ac91866b442541a$export$9951126d1499b75c = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("fLtY1")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/column-header/field-actions/sorting-indicator/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4ac91866b442541a$export$2e2bcd8739ae039 = (props)=>{
    const [sorting] = (0, $iaCjO.useSorting)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "sorting-indicator",
        fallback: null
    }, (props.columnName === sorting.sortBy || props.isVisible) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ac91866b442541a$export$9951126d1499b75c, props));
};

});
parcelRegister("fLtY1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dPTnA").then(()=>parcelRequire('6Jtmp'));

});


parcelRegister("hUuH5", function(module, exports) {

$parcel$export(module.exports, "InlineCreateContainer", () => $c546f888aa885ec7$export$c61fba5cf4e215ae);
$parcel$export(module.exports, "useInlineCreateActions", () => $c546f888aa885ec7$export$5d97dcebeb3ebb31);
$parcel$export(module.exports, "useInlineIssueCreateContext", () => $c546f888aa885ec7$export$81dc4a9ada8e5cf3);
$parcel$export(module.exports, "useInlineFieldCreateContext", () => $c546f888aa885ec7$export$3b94b6fe5fe8d50d);

var $1yZQx = parcelRequire("1yZQx");
var $96gVp = parcelRequire("96gVp");
var $kEDjj = parcelRequire("kEDjj");
const $c546f888aa885ec7$var$CLEAR_DELAY = 300;
const $c546f888aa885ec7$var$initialState = {
    issue: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    },
    field: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    }
};
const $c546f888aa885ec7$var$actions = {
    setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: index
                }
            });
            dispatch($c546f888aa885ec7$var$actions.lockIndex(key));
        },
    clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: undefined
                }
            });
            dispatch($c546f888aa885ec7$var$actions.unlockIndex(key));
        },
    clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const timeoutId = setTimeout(()=>{
                if (!getState()[key].isIndexLocked) {
                    dispatch($c546f888aa885ec7$var$actions.clearIndex(key));
                    setState({
                        [key]: {
                            ...getState()[key],
                            timeoutId: undefined
                        }
                    });
                }
            }, $c546f888aa885ec7$var$CLEAR_DELAY);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false,
                    timeoutId: timeoutId
                }
            });
        },
    lockIndex: (key)=>({ setState: setState, getState: getState })=>{
            const { timeoutId: timeoutId } = getState()[key];
            if (timeoutId) clearTimeout(timeoutId);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: true,
                    timeoutId: undefined
                }
            });
        },
    unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false
                }
            });
        }
};
const $c546f888aa885ec7$export$c61fba5cf4e215ae = (0, $96gVp.createContainer)();
const $c546f888aa885ec7$var$Store = (0, $kEDjj.createStore)({
    initialState: $c546f888aa885ec7$var$initialState,
    actions: $c546f888aa885ec7$var$actions,
    name: 'JwmListInlineCreate',
    containedBy: $c546f888aa885ec7$export$c61fba5cf4e215ae
});
const $c546f888aa885ec7$export$1baf430619906b52 = (0, $1yZQx.createHook)($c546f888aa885ec7$var$Store);
const $c546f888aa885ec7$export$5d97dcebeb3ebb31 = (0, $1yZQx.createActionsHook)($c546f888aa885ec7$var$Store);
const $c546f888aa885ec7$var$getInlineIssueCreate = (state)=>state.issue;
const $c546f888aa885ec7$var$getInlineFieldCreate = (state)=>state.field;
const $c546f888aa885ec7$export$81dc4a9ada8e5cf3 = (0, $1yZQx.createHook)($c546f888aa885ec7$var$Store, {
    selector: $c546f888aa885ec7$var$getInlineIssueCreate
});
const $c546f888aa885ec7$export$3b94b6fe5fe8d50d = (0, $1yZQx.createHook)($c546f888aa885ec7$var$Store, {
    selector: $c546f888aa885ec7$var$getInlineFieldCreate
});

});

const $858485d0615f86f6$export$76a449e52fa0e1e8 = 'issue';
const $858485d0615f86f6$export$d6f887e0c1be1b74 = 'field';

parcelRegister("eCeSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c02f2a7aea43e9c1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c02f2a7aea43e9c1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issuetype: {
        "id": "business-list.list-view.column-header.issuetype",
        "defaultMessage": "Type"
    },
    issuekey: {
        "id": "business-list.list-view.column-header.issuekey",
        "defaultMessage": "Key"
    },
    summary: {
        "id": "business-list.list-view.column-header.summary",
        "defaultMessage": "Summary"
    },
    status: {
        "id": "business-list.list-view.column-header.status",
        "defaultMessage": "Status"
    },
    assignee: {
        "id": "business-list.list-view.column-header.assignee",
        "defaultMessage": "Assignee"
    },
    labels: {
        "id": "business-list.list-view.column-header.labels",
        "defaultMessage": "Labels"
    },
    duedate: {
        "id": "business-list.list-view.column-header.duedate",
        "defaultMessage": "Due date"
    },
    priority: {
        "id": "business-list.list-view.column-header.priority",
        "defaultMessage": "Priority"
    },
    created: {
        "id": "business-list.list-view.column-header.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "business-list.list-view.column-header.updated",
        "defaultMessage": "Updated"
    }
});

});

parcelRegister("cdECG", function(module, exports) {

$parcel$export(module.exports, "ColumnHeaderContainer", () => $55907a73f66afd6c$export$8006ab862c5622cc);
$parcel$export(module.exports, "Title", () => $55907a73f66afd6c$export$f99233281efd08a0);
$parcel$export(module.exports, "TextWrapper", () => $55907a73f66afd6c$export$7c3018f441722857);
$parcel$export(module.exports, "IconWrapper", () => $55907a73f66afd6c$export$be58b4326e23250f);
$parcel$export(module.exports, "ActionsWrapper", () => $55907a73f66afd6c$export$c8223871eecc8f3a);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $55907a73f66afd6c$export$8006ab862c5622cc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragDisabled: isDragDisabled, dragStatus: dragStatus, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _kqswh2mm",
            __cmplp.isDragDisabled === false && "_80om1qgj",
            __cmplp.dragStatus === 'dragging' && "_11q71caa _syaz9jg2 _80om5szm",
            __cmplp.className
        ])
    });
});
const $55907a73f66afd6c$export$f99233281efd08a0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _16jlidpf _1reo15vq _18m915vq _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $55907a73f66afd6c$export$7c3018f441722857 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _o5721q9c _1bto1l2s _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $55907a73f66afd6c$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _4t3i1tcg _2hwx1b66 _18u01b66",
            __cmplp.className
        ])
    });
});
const $55907a73f66afd6c$export$c8223871eecc8f3a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlkb7n _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1yb4 _18s8otz2 _x7odidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("62F3R", function(module, exports) {

$parcel$export(module.exports, "CommentsCell", () => $f8a14dd987a5d2c4$export$11f3e85eadff465c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $d3vNK = parcelRequire("d3vNK");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8UbeN = parcelRequire("8UbeN");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9LxEP = parcelRequire("9LxEP");
const $f8a14dd987a5d2c4$export$11f3e85eadff465c = ({ issueKey: issueKey, isSelected: isSelected = false, onClick: onClick, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, totalCount: totalCount, cellRef: cellRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)(); /**
                  * To be deleted when jira_list_keyboard_nav is cleaned up
                  * @deprecated Now handled in CellNavigation component
                  */ 
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onClick(issueKey);
    }, [
        onClick,
        issueKey
    ]); /**
                            * To be deleted when jira_list_keyboard_nav is cleaned up
                            * @deprecated Now handled in CellNavigation component
                            */ 
    const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') {
            handleClick();
            return;
        }
        onKeyDown?.(e);
    }, [
        onKeyDown,
        handleClick
    ]);
    const handleKeyDownNew = (0, $eUqFw.useCallback)((event)=>{
        if (event.code === 'Enter') {
            onClick(issueKey);
            return true;
        }
        return false;
    }, [
        issueKey,
        onClick
    ]);
    const cellOverrides = (0, $eUqFw.useCallback)(()=>({
            onKeyDown: handleKeyDownNew,
            onClick: ()=>true
        }), [
        handleKeyDownNew
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]); /**
                                                                 * To be deleted when jira_list_keyboard_nav is cleaned up
                                                                 * @deprecated Now handled in CellNavigation component
                                                                 */ 
    const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]);
    const renderedCommentCount = (0, $eUqFw.useMemo)(()=>{
        if (totalCount == null) return null;
         // No comments, add comment
        if (totalCount === 0) return formatMessage((0, $9LxEP.default).addComment);
         // Less than 100 comments, show count
        if (totalCount < 100) return formatMessage((0, $9LxEP.default).commentsCount, {
            commentCount: totalCount
        });
         // More than 99 comments, show 99+
        return formatMessage((0, $9LxEP.default).moreComments);
    }, [
        formatMessage,
        totalCount
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8a14dd987a5d2c4$export$6ce170286acaa8d3, {
        noComments: totalCount === 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
        size: "medium",
        label: formatMessage((0, $9LxEP.default).comments)
    }), renderedCommentCount));
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f8a14dd987a5d2c4$var$wrapperStyles,
        onClick: handleClick
    }, cellContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UbeN.CellWrapper), {
        isFocused: isSelected,
        isEditable: true,
        onClick: handleClick,
        onBlur: onBlur,
        tabIndex: 0,
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        ref: onWrapperRef
    }, cellContent);
};
const $f8a14dd987a5d2c4$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { noComments: noComments, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1osq _7yhb1b66",
            __cmplp.noComments ? "_syazobra" : "_syaz1x9z",
            __cmplp.className
        ])
    });
});
const $f8a14dd987a5d2c4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    paddingLeft: 'space.100'
});

});
parcelRegister("9LxEP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cd1484fdc343cd8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1cd1484fdc343cd8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    comments: {
        "id": "business-list.list-view.comments-cell.comments",
        "defaultMessage": "Comments"
    },
    commentsCount: {
        "id": "business-list.list-view.comments-cell.comments-count",
        "defaultMessage": "{commentCount, plural, one {# comment} other {# comments}}"
    },
    moreComments: {
        "id": "business-list.list-view.comments-cell.more-comments",
        "defaultMessage": "99+ comments"
    },
    addComment: {
        "id": "business-list.list-view.comments-cell.add-comment",
        "defaultMessage": "Add comment"
    }
});

});


parcelRegister("2tEhM", function(module, exports) {

$parcel$export(module.exports, "CommentsSidebar", () => $241e55154b6735ba$export$46e144cce632afca);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");


var $gJYxu = parcelRequire("gJYxu");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");

var $c4qEZ = parcelRequire("c4qEZ");

var $fTCaK = parcelRequire("fTCaK");
const $241e55154b6735ba$var$PACKAGE_NAME = 'jwmCommentsSidebarIssueApp';

const $241e55154b6735ba$export$35dd9ab573b87c3f = (0, $7rh0R.lazy)(()=>(parcelRequire("geiGJ")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $241e55154b6735ba$export$46e144cce632afca = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, onClose: onClose })=>{
    (0, $fTCaK.useScrollToComments)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "businessCommentsSidebarInListView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: $241e55154b6735ba$var$PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($241e55154b6735ba$var$CSSAntiCorruptionLayer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($241e55154b6735ba$export$35dd9ab573b87c3f, {
        analyticsSource: (0, $0100842672acae20$export$7ca28938a07e0c33),
        issueKey: issueKey,
        onClose: onClose,
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true,
        shouldShowRootProjectsBreadcrumb: true,
        isSpaEnabled: false,
        isLoadedWithPage: false,
        viewModeOptions: {
            viewMode: 'SIDEBAR'
        }
    })))));
});
/**
 * Used to fix styles of Issue App in Sidebar broken by nested selectors affecting clipboard boundary
 * inline div on feature cleanup
 * remove div on SidebarContent improvement
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $241e55154b6735ba$var$CSSAntiCorruptionLayer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fTCaK", function(module, exports) {

$parcel$export(module.exports, "useScrollToComments", () => $a71248087d725810$export$5baf464300edba1e);

var $eUqFw = parcelRequire("eUqFw");

var $k7cZh = parcelRequire("k7cZh");

var $cSEXi = parcelRequire("cSEXi");
const $a71248087d725810$var$INTERVAL = 100;
const $a71248087d725810$var$TIMEOUT = 10000;
// account for Bento's sticky header
const $a71248087d725810$var$SCROLL_PADDING = 34;
const $a71248087d725810$export$f0c653cfd7dea798 = ()=>{
    const nodes = Array.from(document.querySelectorAll(`#${(0, $cSEXi.ELID_ISSUE_HEADER)} + div h2`));
    // take the last H2 inside Bento (comments section header)
    return nodes.length ? nodes[nodes.length - 1] : null;
};
const $a71248087d725810$export$5baf464300edba1e = ({ issueKey: issueKey })=>{
    const intervalId = (0, $eUqFw.useRef)();
    const timeoutId = (0, $eUqFw.useRef)();
    const isTimeout = (0, $eUqFw.useRef)(false);
    const waitForElement = (0, $eUqFw.useCallback)(()=>{
        if (isTimeout.current) return;
        const ref = $a71248087d725810$export$f0c653cfd7dea798();
        if (ref) // sometimes the browser can't immediately scroll,
        // so we add a small timeout here to let it render Bento first
        setTimeout(()=>{
            ref && (0, $k7cZh.default)(ref, {
                scrollMode: 'always',
                block: 'start',
                inline: 'nearest',
                behavior: (actions)=>actions.forEach(({ el: el, top: top })=>{
                        // eslint-disable-next-line no-param-reassign
                        el.scrollTop = top - $a71248087d725810$var$SCROLL_PADDING;
                    })
            });
        }, 300);
        else intervalId.current = setTimeout(waitForElement, $a71248087d725810$var$INTERVAL);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        clearTimeout(intervalId.current);
        clearTimeout(timeoutId.current);
        isTimeout.current = false;
        // clear the interval in case comments section never shows up
        timeoutId.current = setTimeout(()=>{
            isTimeout.current = true;
        }, $a71248087d725810$var$TIMEOUT);
        // kick off the interval if issueKey changes + on mount
        intervalId.current = setTimeout(waitForElement, $a71248087d725810$var$INTERVAL);
        // clear interval on unmount
        return ()=>{
            clearTimeout(intervalId.current);
            clearTimeout(timeoutId.current);
        };
    }, [
        waitForElement,
        issueKey
    ]);
};

});
parcelRegister("cSEXi", function(module, exports) {

$parcel$export(module.exports, "issueAppModalWrapperClassName", () => $071d2ef9b60c04f2$export$6bf7918be801e6c5);
$parcel$export(module.exports, "MODAL_DROPDOWN_PORTAL_CLASS_NAME", () => $071d2ef9b60c04f2$export$bab98b619b4558be);
$parcel$export(module.exports, "EDITOR_DROPDOWN_PORTAL_CLASS_NAME", () => $071d2ef9b60c04f2$export$2ec9dc4e52ec0b5d);
$parcel$export(module.exports, "EDITOR_END_CLASS_NAME", () => $071d2ef9b60c04f2$export$18cffbebfac64f6d);
$parcel$export(module.exports, "EDITOR_START_CLASS_NAME", () => $071d2ef9b60c04f2$export$ebb284f63692b8b2);
$parcel$export(module.exports, "ELID_ISSUE_HEADER", () => $071d2ef9b60c04f2$export$4ca9dd62cc85a6c6);
$parcel$export(module.exports, "ELID_ISSUE_HEADER_ACTIONS", () => $071d2ef9b60c04f2$export$23d48b936935fa57);
$parcel$export(module.exports, "AGG_ISSUE_ERROR_ANALYTICS", () => $071d2ef9b60c04f2$export$66553a9be1be2f7e);

var $0NycV = parcelRequire("0NycV");

var $4Xcha = parcelRequire("4Xcha");

var $anFLA = parcelRequire("anFLA");

var $hc60A = parcelRequire("hc60A");

var $eTy9x = parcelRequire("eTy9x");

var $fkvsU = parcelRequire("fkvsU");




var $hU5kA = parcelRequire("hU5kA");

var $cUHte = parcelRequire("cUHte");


var $cd8TS = parcelRequire("cd8TS");
const $071d2ef9b60c04f2$export$6bf7918be801e6c5 = '_issue-app-modal-dialog-wrapper';
const $071d2ef9b60c04f2$export$bab98b619b4558be = 'issue-app-modal-ak-dropdown-portal';
const $071d2ef9b60c04f2$export$2ec9dc4e52ec0b5d = 'issue-app-modal-editor-dropdown-portal';
const $071d2ef9b60c04f2$export$18cffbebfac64f6d = 'issue-editor-end';
const $071d2ef9b60c04f2$export$ebb284f63692b8b2 = 'issue-editor-start';
const $071d2ef9b60c04f2$export$3ef7e400a3598524 = 'issue.error';
const $071d2ef9b60c04f2$export$4ca9dd62cc85a6c6 = 'jira-issue-header';
const $071d2ef9b60c04f2$export$23d48b936935fa57 = 'jira-issue-header-actions';
const $071d2ef9b60c04f2$export$66553a9be1be2f7e = 'issue.error.agg';

});
parcelRegister("0NycV", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_WATCHING_ERROR", () => $033d5acebc8ea430$export$ec8031e221d27341);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_GENERIC", () => $033d5acebc8ea430$export$78f84210a13989cb);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_INVALID", () => $033d5acebc8ea430$export$10b0b01977598ffc);
$parcel$export(module.exports, "COMMENT_CONTENT_EXCEEDED_ERROR", () => $033d5acebc8ea430$export$9b38ca770beaf3d0);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS_FLAG_MESSAGE", () => $033d5acebc8ea430$export$eef81693e817e3a6);
$parcel$export(module.exports, "COMMENT_FUTURE_TIME_ERROR", () => $033d5acebc8ea430$export$a0d4d86bde270ad6);
$parcel$export(module.exports, "COMMENT_DELETE_ERROR", () => $033d5acebc8ea430$export$6b6cd1b99772a4a1);
$parcel$export(module.exports, "EDITOR_ERROR", () => $033d5acebc8ea430$export$2e48be8618f1b4f8);
$parcel$export(module.exports, "ATTACHMENT_ADD_ERROR", () => $033d5acebc8ea430$export$c060b7873ebc2eb3);
$parcel$export(module.exports, "ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR", () => $033d5acebc8ea430$export$1f8e6f6f8d64a715);
$parcel$export(module.exports, "ATTACHMENT_ADD_SUCCESS", () => $033d5acebc8ea430$export$1f92a25b34c4df93);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_ERROR", () => $033d5acebc8ea430$export$d8750340852b965e);
$parcel$export(module.exports, "REMOTE_LINK_VALIDATION_ERROR", () => $033d5acebc8ea430$export$f0962d071c2a358a);
$parcel$export(module.exports, "ATTACHMENT_DELETE_ERROR", () => $033d5acebc8ea430$export$ef7767ceecf9097c);
$parcel$export(module.exports, "WATCH_TOGGLE_UPDATE_ERROR", () => $033d5acebc8ea430$export$516af79f4e3b8794);
$parcel$export(module.exports, "FETCH_WATCHERS_ERROR", () => $033d5acebc8ea430$export$cde4105f7711a10a);
$parcel$export(module.exports, "STOP_WATCHING_SUCCESS", () => $033d5acebc8ea430$export$f674d1f44f57f99d);
$parcel$export(module.exports, "START_WATCHING_SUCCESS", () => $033d5acebc8ea430$export$bff6b5ab70bcec53);
$parcel$export(module.exports, "REMOVE_WATCHER_ERROR", () => $033d5acebc8ea430$export$37934e343a22c4e6);
$parcel$export(module.exports, "ADD_WATCHER_ERROR", () => $033d5acebc8ea430$export$6a1827094c1ef6d8);
$parcel$export(module.exports, "SUBTASKS_REORDER_ERROR_GENERIC", () => $033d5acebc8ea430$export$bb96d519395e5dcc);
$parcel$export(module.exports, "LOG_WORK_CONFIRM_ERROR", () => $033d5acebc8ea430$export$18bd55ba676f8b6d);
$parcel$export(module.exports, "ASSIGN_TO_ME_SUCCESS", () => $033d5acebc8ea430$export$1249a100986a9489);
$parcel$export(module.exports, "REMOVE_FROM_ME_SUCCESS", () => $033d5acebc8ea430$export$6b737093486e5a4e);
$parcel$export(module.exports, "CREATE_CHILD_ISSUE_ERROR", () => $033d5acebc8ea430$export$a2723f15441225d0);
$parcel$export(module.exports, "LINK_CHILD_ISSUE_ERROR", () => $033d5acebc8ea430$export$569f7258d337be55);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_SUCCESS", () => $033d5acebc8ea430$export$f92af4e9761d23b9);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_ERROR", () => $033d5acebc8ea430$export$16dc9ff6a8822a90);
$parcel$export(module.exports, "DELETE_ISSUE_ERROR", () => $033d5acebc8ea430$export$d4030883b7b7a04);
$parcel$export(module.exports, "ADD_WORKLOG_SUCCESS", () => $033d5acebc8ea430$export$2519b72aefd62ee3);
$parcel$export(module.exports, "ADD_WORKLOG_FAILURE", () => $033d5acebc8ea430$export$190e4e4a6ee2a0a2);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$f1709ebef49207cc);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_FAILURE", () => $033d5acebc8ea430$export$bde55584c7518e8d);
$parcel$export(module.exports, "EDIT_WORKLOG_SUCCESS", () => $033d5acebc8ea430$export$cf8d549e537c67d3);
$parcel$export(module.exports, "EDIT_WORKLOG_FAILURE", () => $033d5acebc8ea430$export$2d33e591258e36a8);
$parcel$export(module.exports, "DELETE_WORKLOG_SUCCESS", () => $033d5acebc8ea430$export$b595535e9bb1a2a2);
$parcel$export(module.exports, "DELETE_WORKLOG_FAILURE", () => $033d5acebc8ea430$export$c3739a68f63b7e09);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_CONFIRM_ERROR", () => $033d5acebc8ea430$export$6ba6cb22d5a3c521);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR", () => $033d5acebc8ea430$export$b1a41c9183097dc);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_REQUIRED_ERROR", () => $033d5acebc8ea430$export$67544887e2b37fbc);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_FAILED", () => $033d5acebc8ea430$export$67566c205c72838a);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_ERROR", () => $033d5acebc8ea430$export$733fe45ab8c75209);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_SUCCESS", () => $033d5acebc8ea430$export$9d1386a2d0651ca9);
$parcel$export(module.exports, "EDIT_EPIC_COLOUR_ERROR", () => $033d5acebc8ea430$export$56094d7f6af14eac);
$parcel$export(module.exports, "EDIT_ISSUE_COLOUR_ERROR", () => $033d5acebc8ea430$export$92d58445895900f9);
$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_ERROR", () => $033d5acebc8ea430$export$75d850be4d27b98e);
$parcel$export(module.exports, "CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$9030bf81702823b8);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$a2a71fb6b193e549);
$parcel$export(module.exports, "ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$8c5e4d3dfe9a1c32);
$parcel$export(module.exports, "ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$49d11338d75de478);
$parcel$export(module.exports, "ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$3573d8ff428b4c8f);
$parcel$export(module.exports, "COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST", () => $033d5acebc8ea430$export$c0657c5ed1bbfed4);
const $033d5acebc8ea430$export$ec8031e221d27341 = 'TOGGLE_WATCHING_ERROR';
const $033d5acebc8ea430$export$78f84210a13989cb = 'COMMENT_ADD_ERROR_GENERIC';
const $033d5acebc8ea430$export$10b0b01977598ffc = 'COMMENT_ADD_ERROR_INVALID';
const $033d5acebc8ea430$export$9b38ca770beaf3d0 = 'COMMENT_CONTENT_EXCEEDED_ERROR';
const $033d5acebc8ea430$export$eef81693e817e3a6 = 'SAVE_COMMENT_SUCCESS_FLAG_MESSAGE';
const $033d5acebc8ea430$export$a0d4d86bde270ad6 = 'COMMENT_FUTURE_TIME_ERROR';
const $033d5acebc8ea430$export$6b6cd1b99772a4a1 = 'COMMENT_DELETE_ERROR';
const $033d5acebc8ea430$export$2e48be8618f1b4f8 = 'EDITOR_ERROR';
const $033d5acebc8ea430$export$c060b7873ebc2eb3 = 'ATTACHMENT_ADD_ERROR';
const $033d5acebc8ea430$export$1f8e6f6f8d64a715 = 'ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR';
const $033d5acebc8ea430$export$1f92a25b34c4df93 = 'ATTACHMENT_ADD_SUCCESS';
const $033d5acebc8ea430$export$d8750340852b965e = 'DELETE_LINKED_ISSUE_ERROR';
const $033d5acebc8ea430$export$f0962d071c2a358a = 'REMOTE_LINK_VALIDATION_ERROR';
const $033d5acebc8ea430$export$ef7767ceecf9097c = 'ATTACHMENT_DELETE_ERROR';
const $033d5acebc8ea430$export$516af79f4e3b8794 = 'WATCH_TOGGLE_UPDATE_ERROR';
const $033d5acebc8ea430$export$cde4105f7711a10a = 'FETCH_WATCHERS_ERROR';
const $033d5acebc8ea430$export$f674d1f44f57f99d = 'STOP_WATCHING_SUCCESS';
const $033d5acebc8ea430$export$bff6b5ab70bcec53 = 'START_WATCHING_SUCCESS';
const $033d5acebc8ea430$export$37934e343a22c4e6 = 'REMOVE_WATCHER_ERROR';
const $033d5acebc8ea430$export$6a1827094c1ef6d8 = 'ADD_WATCHER_ERROR';
const $033d5acebc8ea430$export$bb96d519395e5dcc = 'SUBTASKS_REORDER_ERROR_GENERIC';
const $033d5acebc8ea430$export$18bd55ba676f8b6d = 'LOG_WORK_CONFIRM_ERROR';
const $033d5acebc8ea430$export$1249a100986a9489 = 'ASSIGN_TO_ME_SUCCESS';
const $033d5acebc8ea430$export$6b737093486e5a4e = 'REMOVE_FROM_ME_SUCCESS';
const $033d5acebc8ea430$export$a2723f15441225d0 = 'CREATE_CHILD_ISSUE_ERROR';
const $033d5acebc8ea430$export$569f7258d337be55 = 'LINK_CHILD_ISSUE_ERROR';
const $033d5acebc8ea430$export$f92af4e9761d23b9 = 'CHANGE_ISSUE_TYPE_SUCCESS';
const $033d5acebc8ea430$export$16dc9ff6a8822a90 = 'CHANGE_ISSUE_TYPE_ERROR';
const $033d5acebc8ea430$export$d4030883b7b7a04 = 'DELETE_ISSUE_ERROR';
const $033d5acebc8ea430$export$2519b72aefd62ee3 = 'ADD_WORKLOG_SUCCESS';
const $033d5acebc8ea430$export$190e4e4a6ee2a0a2 = 'ADD_WORKLOG_FAILURE';
const $033d5acebc8ea430$export$f1709ebef49207cc = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$2357f9add92f1c9b = 'UPDATE_TIME_REMAINING_SUCCESS';
const $033d5acebc8ea430$export$bde55584c7518e8d = 'UPDATE_TIME_REMAINING_FAILURE';
const $033d5acebc8ea430$export$cf8d549e537c67d3 = 'EDIT_WORKLOG_SUCCESS';
const $033d5acebc8ea430$export$2d33e591258e36a8 = 'EDIT_WORKLOG_FAILURE';
const $033d5acebc8ea430$export$b595535e9bb1a2a2 = 'DELETE_WORKLOG_SUCCESS';
const $033d5acebc8ea430$export$c3739a68f63b7e09 = 'DELETE_WORKLOG_FAILURE';
const $033d5acebc8ea430$export$6ba6cb22d5a3c521 = 'RICH_CONTENT_FIELD_CONFIRM_ERROR';
const $033d5acebc8ea430$export$b1a41c9183097dc = 'RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR';
const $033d5acebc8ea430$export$67544887e2b37fbc = 'RICH_CONTENT_FIELD_REQUIRED_ERROR';
const $033d5acebc8ea430$export$67566c205c72838a = 'DELETE_CONFLUENCE_PAGE_LINK_FAILED';
const $033d5acebc8ea430$export$e3245a362f751a4a = 'DELETE_WEB_LINK_FAILED';
const $033d5acebc8ea430$export$3408969e4d418350 = 'CLICKTHROUGH_BANNER_DISMISS_SUCCESS';
const $033d5acebc8ea430$export$733fe45ab8c75209 = 'SAVE_APPROVAL_ANSWER_ERROR';
const $033d5acebc8ea430$export$9d1386a2d0651ca9 = 'SAVE_APPROVAL_ANSWER_SUCCESS';
const $033d5acebc8ea430$export$56094d7f6af14eac = 'EDIT_EPIC_COLOUR_ERROR';
const $033d5acebc8ea430$export$92d58445895900f9 = 'EDIT_ISSUE_COLOUR_ERROR';
const $033d5acebc8ea430$export$75d850be4d27b98e = 'FETCH_JIRA_APP_LINKS_ERROR';
const $033d5acebc8ea430$export$9030bf81702823b8 = 'CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$a2a71fb6b193e549 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$2dd786d54c8f9397 = 'COMMENTS_INTERNAL_SERVER_ERROR';
const $033d5acebc8ea430$export$8c5e4d3dfe9a1c32 = 'ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$49d11338d75de478 = 'ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$3573d8ff428b4c8f = 'ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$c0657c5ed1bbfed4 = [
    $033d5acebc8ea430$export$a2a71fb6b193e549,
    $033d5acebc8ea430$export$3573d8ff428b4c8f
];

});

parcelRegister("4Xcha", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $c7ce8bed5d2ff289$export$89b6937a83edcaa6);
$parcel$export(module.exports, "EXCEEDED_LIMIT_INITIAL_LOAD", () => $c7ce8bed5d2ff289$export$763881dbba851043);
$parcel$export(module.exports, "EXCEEDED_LIMIT_AFTER_LOAD", () => $c7ce8bed5d2ff289$export$8a23145a6d5f95e3);
$parcel$export(module.exports, "WITHIN_LIMIT", () => $c7ce8bed5d2ff289$export$a7af19981a3e4baf);
$parcel$export(module.exports, "HREF", () => $c7ce8bed5d2ff289$export$74921a9774a80542);
$parcel$export(module.exports, "IN_PRODUCT_HELP", () => $c7ce8bed5d2ff289$export$cd480f5ec4739dab);
$parcel$export(module.exports, "WHAT_ARE_ISSUE_TYPES_URL", () => $c7ce8bed5d2ff289$export$470a531b30a8dea1);
$parcel$export(module.exports, "IN_PRODUCT_HELP_ARTICLE_IDS", () => $c7ce8bed5d2ff289$export$3691506c72823b65);
$parcel$export(module.exports, "DISMISSED", () => $c7ce8bed5d2ff289$export$6a4add537aaf5560);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE", () => $c7ce8bed5d2ff289$export$6d6e3176028f2228);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE_FE", () => $c7ce8bed5d2ff289$export$17d19a319fd47c32);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID", () => $c7ce8bed5d2ff289$export$9e448086914e060);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_AI_BREAKDOWN_CREATE_ID", () => $c7ce8bed5d2ff289$export$2dd6afd9432dbc93);

var $7ZZxN = parcelRequire("7ZZxN");
const $c7ce8bed5d2ff289$var$CHILD_ISSUES_LIMIT = 500;
const $c7ce8bed5d2ff289$export$89b6937a83edcaa6 = ()=>$c7ce8bed5d2ff289$var$CHILD_ISSUES_LIMIT;
const $c7ce8bed5d2ff289$export$763881dbba851043 = 'EXCEEDED_LIMIT_INITIAL_LOAD';
const $c7ce8bed5d2ff289$export$8a23145a6d5f95e3 = 'EXCEEDED_LIMIT_AFTER_LOAD';
const $c7ce8bed5d2ff289$export$a7af19981a3e4baf = 'WITHIN_LIMIT';
const $c7ce8bed5d2ff289$export$74921a9774a80542 = 'HREF';
const $c7ce8bed5d2ff289$export$cd480f5ec4739dab = 'IN_PRODUCT_HELP';
const $c7ce8bed5d2ff289$export$470a531b30a8dea1 = 'https://support.atlassian.com/jira-cloud-administration/docs/what-are-issue-types/';
const $c7ce8bed5d2ff289$export$3691506c72823b65 = {
    [(0, $7ZZxN.CORE_PROJECT)]: '2uhc4ieBPinkLJlWbdhXkC',
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'z6BNb3cPucF3fi5UA85Ma',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: '6feRxZzkYUHez8TwHTjSut',
    [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: null,
    [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: null
};
const $c7ce8bed5d2ff289$export$6a4add537aaf5560 = 'dismissed';
const $c7ce8bed5d2ff289$export$6d6e3176028f2228 = 'The default assignee does NOT have ASSIGNABLE permission OR Unassigned issues are turned off.';
const $c7ce8bed5d2ff289$export$17d19a319fd47c32 = "The default assignee doesn\u2019t have the Assignable User permission, or unassigned issues are turned off.";
const $c7ce8bed5d2ff289$export$9e448086914e060 = 'issue-view-child-issues-panel-inline-create';
const $c7ce8bed5d2ff289$export$2dd6afd9432dbc93 = 'issue-view-child-issues-panel-ai-breakdown-create';

});

parcelRegister("anFLA", function(module, exports) {

$parcel$export(module.exports, "EVENTS_TO_LISTEN", () => $d020b8e21ff30f0f$export$d117134317cf0005);
$parcel$export(module.exports, "REALTIME_EVENTS_ANALYTICS_SAMPLE_RATE", () => $d020b8e21ff30f0f$export$d23f2e4951d99e4e);

const $d020b8e21ff30f0f$export$d117134317cf0005 = [
    (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee),
    (0, $1d129cd1c8b202ad$export$773466d9acc404c0)
];
const $d020b8e21ff30f0f$export$d23f2e4951d99e4e = 100;

});
const $1d129cd1c8b202ad$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $1d129cd1c8b202ad$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $1d129cd1c8b202ad$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $1d129cd1c8b202ad$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $1d129cd1c8b202ad$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $1d129cd1c8b202ad$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $1d129cd1c8b202ad$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $1d129cd1c8b202ad$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';


parcelRegister("hc60A", function(module, exports) {

$parcel$export(module.exports, "ALL_ACTIVITY", () => $c4e4580e4e5263cc$export$97c6fb50aec7ca13);
$parcel$export(module.exports, "APPROVALS", () => $c4e4580e4e5263cc$export$d9f961719f63a946);
$parcel$export(module.exports, "COMMENTS", () => $c4e4580e4e5263cc$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "HISTORY", () => $c4e4580e4e5263cc$export$149eb684a26496a2);
$parcel$export(module.exports, "WORKLOG", () => $c4e4580e4e5263cc$export$df36fc05622c402);
$parcel$export(module.exports, "FORGE", () => $c4e4580e4e5263cc$export$567a44a77f893138);
$parcel$export(module.exports, "CONNECT", () => $c4e4580e4e5263cc$export$df50b52b1548c0dc);

var $fkvsU = parcelRequire("fkvsU");
const $c4e4580e4e5263cc$export$97c6fb50aec7ca13 = 'AllActivity';
const $c4e4580e4e5263cc$export$d9f961719f63a946 = 'Approvals';
const $c4e4580e4e5263cc$export$4cab9dfa8fc858f4 = 'Comments';
const $c4e4580e4e5263cc$export$149eb684a26496a2 = 'History';
const $c4e4580e4e5263cc$export$df36fc05622c402 = 'Worklog';
const $c4e4580e4e5263cc$export$567a44a77f893138 = (0, $fkvsU.FORGE_ENTITY_TYPE);
const $c4e4580e4e5263cc$export$df50b52b1548c0dc = (0, $fkvsU.CONNECT_ENTITY_TYPE);

});
parcelRegister("fkvsU", function(module, exports) {

$parcel$export(module.exports, "FORGE_ENTITY_TYPE", () => $f4e7965032899654$export$6f3804b3f188f650);
$parcel$export(module.exports, "CONNECT_ENTITY_TYPE", () => $f4e7965032899654$export$1b2059a011c9174d);
const $f4e7965032899654$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';
const $f4e7965032899654$export$1b2059a011c9174d = 'CONNECT_ENTITY_TYPE';
const $f4e7965032899654$export$38f0fc1cf1f24cba = [
    $f4e7965032899654$export$6f3804b3f188f650,
    $f4e7965032899654$export$1b2059a011c9174d
];

});


parcelRegister("eTy9x", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD", () => $0bfbe56dc89f06eb$export$724fbfb10c203824);
$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD_FOR_POST_LOAD_ACTIONS", () => $0bfbe56dc89f06eb$export$a1162d3036fadf0e);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD", () => $0bfbe56dc89f06eb$export$ed7e687bbd42b4a7);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD_OLD", () => $0bfbe56dc89f06eb$export$9b2f842ae6d3541d);
$parcel$export(module.exports, "LOAD_NEWER_BUTTON", () => $0bfbe56dc89f06eb$export$4f2e52b6b9be5088);
$parcel$export(module.exports, "LOAD_OLDER_BUTTON", () => $0bfbe56dc89f06eb$export$ed33f944ab1a1bb0);

var $c9TLT = parcelRequire("c9TLT");
const $0bfbe56dc89f06eb$export$724fbfb10c203824 = 5;
const $0bfbe56dc89f06eb$export$a1162d3036fadf0e = 100;
const $0bfbe56dc89f06eb$export$ed7e687bbd42b4a7 = 100;
const $0bfbe56dc89f06eb$export$9b2f842ae6d3541d = 10;
const $0bfbe56dc89f06eb$export$ef42ae71539e03a7 = `${3 * (0, $c9TLT.gridSize)}px`;
const $0bfbe56dc89f06eb$export$4f2e52b6b9be5088 = 'LOAD_NEWER_BUTTON';
const $0bfbe56dc89f06eb$export$ed33f944ab1a1bb0 = 'LOAD_OLDER_BUTTON';

});

const $b7817a5fa36c8dd6$export$37b67b9fa9f77199 = 'APPLINK_MISSING';
const $b7817a5fa36c8dd6$export$d1fe0e8f550fe68d = 'APPLINK_REQ_AUTH';
const $b7817a5fa36c8dd6$export$a6054426471fb4c4 = 'REMOTE_SERVER';
const $b7817a5fa36c8dd6$export$cdf8a4853fe35e61 = 'REMOTE_LINK_MISSING';

const $9e13bb906b1e3579$export$87b07f66f76af007 = 1000;
const $9e13bb906b1e3579$export$7cf28317477c9e48 = 'w';

const $b0dbf452addbddfb$export$cb17e3c17bc50301 = 'Epic';
const $b0dbf452addbddfb$export$d29cf9c8492f955d = 'Base';
const $b0dbf452addbddfb$export$7fbc739f2667a35e = 'Subtask';

parcelRegister("hU5kA", function(module, exports) {

$parcel$export(module.exports, "noPermissions", () => $da02f2b558500d9a$export$3fd167bac6ff056b);
const $da02f2b558500d9a$export$c7b3dd87fc15b364 = {
    canDeleteAllWorklogs: false,
    canDeleteOwnWorklogs: false,
    canEditAllWorklogs: false,
    canEditOwnWorklogs: false,
    canLogWork: false
};
const $da02f2b558500d9a$export$3fd167bac6ff056b = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canArchiveIssue: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canEditAllComments: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canLinkIssues: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUnarchiveIssue: false,
    canViewWatchers: false,
    canBrowseUsers: false,
    ...$da02f2b558500d9a$export$c7b3dd87fc15b364,
    canUseServiceDeskAgentFeatures: false,
    canViewDevTools: false,
    canExportIssue: false
};

});

parcelRegister("cUHte", function(module, exports) {

$parcel$export(module.exports, "fetchFieldDataPerf", () => $e54dd57964efa8b8$export$b97d963a8496fa2f);
$parcel$export(module.exports, "fetchCommentsPerf", () => $e54dd57964efa8b8$export$179836a99669cbe7);
$parcel$export(module.exports, "fetchIssueLinkPerf", () => $e54dd57964efa8b8$export$8d0984a0f9f31117);
$parcel$export(module.exports, "fetchSubtaskTypesPerf", () => $e54dd57964efa8b8$export$c1324bd586e9a53a);
$parcel$export(module.exports, "fetchUploadPerf", () => $e54dd57964efa8b8$export$72fcc6cb1cdc70e0);
$parcel$export(module.exports, "fetchUserAuthPerf", () => $e54dd57964efa8b8$export$4052b1eae3373c3b);
$parcel$export(module.exports, "fetchViewContextPerf", () => $e54dd57964efa8b8$export$b4e2588a18d8d980);
$parcel$export(module.exports, "fetchIssuePropertiesPerf", () => $e54dd57964efa8b8$export$2ee73dd298bdfe8a);
const $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $e54dd57964efa8b8$var$FETCH_FIELD_DATA_REQUEST = 'FETCH_FIELD_DATA';
const $e54dd57964efa8b8$var$FETCH_INITIAL_COMMENTS_REQUEST = 'FETCH_INITIAL_COMMENTS';
const $e54dd57964efa8b8$var$FETCH_ISSUE_LINK_TYPES_REQUEST = 'FETCH_ISSUE_LINK_TYPES';
const $e54dd57964efa8b8$var$FETCH_SUBTASK_TYPES_REQUEST = 'FETCH_SUBTASK_TYPES';
const $e54dd57964efa8b8$var$FETCH_UPLOAD_CONTEXT_REQUEST = 'FETCH_LOAD_CONTEXT';
const $e54dd57964efa8b8$var$FETCH_USER_AUTH_REQUEST = 'FETCH_USER_AUTH';
const $e54dd57964efa8b8$var$FETCH_VIEW_CONTEXT_REQUEST = 'FETCH_VIEW_CONTEXT';
const $e54dd57964efa8b8$var$FETCH_ISSUE_PROPERTIES_REQUEST = 'FETCH_ISSUE_PROPERTIES';
const $e54dd57964efa8b8$export$b97d963a8496fa2f = {
    key: $e54dd57964efa8b8$var$FETCH_FIELD_DATA_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$179836a99669cbe7 = {
    key: $e54dd57964efa8b8$var$FETCH_INITIAL_COMMENTS_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$8d0984a0f9f31117 = {
    key: $e54dd57964efa8b8$var$FETCH_ISSUE_LINK_TYPES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$c1324bd586e9a53a = {
    key: $e54dd57964efa8b8$var$FETCH_SUBTASK_TYPES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$72fcc6cb1cdc70e0 = {
    key: $e54dd57964efa8b8$var$FETCH_UPLOAD_CONTEXT_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$4052b1eae3373c3b = {
    key: $e54dd57964efa8b8$var$FETCH_USER_AUTH_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$b4e2588a18d8d980 = {
    key: $e54dd57964efa8b8$var$FETCH_VIEW_CONTEXT_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$2ee73dd298bdfe8a = {
    key: $e54dd57964efa8b8$var$FETCH_ISSUE_PROPERTIES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});

const $ab2aafcdf11a1361$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $ab2aafcdf11a1361$export$e1184c3be46bd7cb = false;
const $ab2aafcdf11a1361$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $ab2aafcdf11a1361$export$988f0f6f6457039a = 'status-and-approval-spotlight';

parcelRegister("cd8TS", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$dd2d62bc7ec6ce51);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$db1ab2b83dc17aa9);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$940ce115dba33e55);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$4ec1f3604b85d553);
$parcel$export(module.exports, "ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST", () => $626ce0fd98ef0025$export$e65b95e776ce6f27);
const $626ce0fd98ef0025$export$dd2d62bc7ec6ce51 = 'ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $626ce0fd98ef0025$export$db1ab2b83dc17aa9 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $626ce0fd98ef0025$export$940ce115dba33e55 = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $626ce0fd98ef0025$export$4ec1f3604b85d553 = 'REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $626ce0fd98ef0025$export$e65b95e776ce6f27 = [
    $626ce0fd98ef0025$export$dd2d62bc7ec6ce51,
    $626ce0fd98ef0025$export$db1ab2b83dc17aa9,
    $626ce0fd98ef0025$export$940ce115dba33e55,
    $626ce0fd98ef0025$export$4ec1f3604b85d553
];

});




parcelRegister("atvEr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cb6308118097de4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $0cb6308118097de4$var$ComponentsCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bmGRE")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/components-cell/main.tsx"
});
const $0cb6308118097de4$var$AsyncComponentsCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "components-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cb6308118097de4$var$ComponentsCell, props));
var $0cb6308118097de4$export$2e2bcd8739ae039 = $0cb6308118097de4$var$AsyncComponentsCell;

});
parcelRegister("bmGRE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("96faG").then(()=>parcelRequire('1b5M9'));

});


parcelRegister("dNtbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f848dece554a7178$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $f848dece554a7178$var$DateCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1lJYh")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/date-cell/main.tsx"
});
const $f848dece554a7178$var$AsyncDateCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "date-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f848dece554a7178$var$DateCell, props));
var $f848dece554a7178$export$2e2bcd8739ae039 = $f848dece554a7178$var$AsyncDateCell;

});
parcelRegister("1lJYh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("al3ht").then(()=>parcelRequire('5RWox'));

});


parcelRegister("5c3sP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc9ce689ed0af1ba$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $fc9ce689ed0af1ba$var$DateTimeCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4FF32")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/date-time-cell/main.tsx"
});
const $fc9ce689ed0af1ba$var$AsyncDateTimeCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "date-time-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc9ce689ed0af1ba$var$DateTimeCell, props));
var $fc9ce689ed0af1ba$export$2e2bcd8739ae039 = $fc9ce689ed0af1ba$var$AsyncDateTimeCell;

});
parcelRegister("4FF32", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dlV0Z").then(()=>parcelRequire('bZ8ql'));

});


parcelRegister("g3fEZ", function(module, exports) {

$parcel$export(module.exports, "KeyCell", () => $6556735293a55bfb$export$4d17c2f4d9bbf823);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $aWvIp = parcelRequire("aWvIp");

var $hUwRB = parcelRequire("hUwRB");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $j8Htg = parcelRequire("j8Htg");

var $jGcn0 = parcelRequire("jGcn0");

var $hYeSy = parcelRequire("hYeSy");

var $8UbeN = parcelRequire("8UbeN");

var $eP9Rz = parcelRequire("eP9Rz");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $9uU8f = parcelRequire("9uU8f");

var $8NLkb = parcelRequire("8NLkb");

var $egJIx = parcelRequire("egJIx");

var $aqGaJ = parcelRequire("aqGaJ");

var $dLenM = parcelRequire("dLenM");
const $6556735293a55bfb$export$4d17c2f4d9bbf823 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueId: issueId, issueKey: issueKey, parentIssues: parentIssues, onOpenIssueModal: onOpenIssueModal, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, isHovering: isHoveringNew = false, cellRef: cellRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isCopied, setIsCopied] = (0, $eUqFw.useState)(false);
    const [isHoveringOld, setIsHovering] = (0, $eUqFw.useState)(false);
    const isHovering = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? isHoveringNew : isHoveringOld;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { issueViewInteraction: issueViewInteraction } = (0, $egJIx.useJWMListFeatures)();
    const { showFlatList: showFlatList } = (0, $aqGaJ.useHierarchyConfig)();
    const { prefetchIssue: prefetchIssue } = (0, $hYeSy.usePrefetchIssueViewDataActions)();
    const [{ hasSelection: hasSelection }] = (0, $8NLkb.useHasCellSelection)();
    const handleIssueKeyMouseEnter = (0, $eUqFw.useCallback)(()=>{
        prefetchIssue(issueKey);
    }, [
        issueKey,
        prefetchIssue
    ]);
    const { clearSelectedCell: clearSelectedCell } = (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8NLkb.useCellActions)() : {
        clearSelectedCell: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Use handleMouseLeave in CellNavigation for generic behaviour or useImperativeHandle
   *  to provide custom override behaviour for this cell
   */ const handleMouseEnter = (0, $eUqFw.useCallback)(()=>setIsHovering(true), [
        setIsHovering
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Use handleMouseEnter in CellNavigation for generic behaviour or useImperativeHandle
   *  to provide custom override behaviour for this cell
   */ const handleMouseLeave = (0, $eUqFw.useCallback)(()=>setIsHovering(false), [
        setIsHovering
    ]);
    const handleCopyClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'keyCell copyIssueLink', {});
    }, [
        createAnalyticsEvent
    ]);
    const handleCopyReset = (0, $eUqFw.useCallback)(()=>setIsCopied(false), [
        setIsCopied
    ]);
    const handleClickChange = (0, $eUqFw.useCallback)((status)=>setIsCopied(status), []);
    const onEmbedIssueClick = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) clearSelectedCell();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'listEmbedIssue');
        (0, $j8Htg.openViewFromEmbed)({
            key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
            value: issueKey
        });
        event.preventDefault();
        event.stopPropagation();
    }, [
        clearSelectedCell,
        createAnalyticsEvent,
        issueKey
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Use handleKeyDown in CellNavigation for generic behaviour or handleKeyDownNew in this
   * cell for custom behaviour
   */ const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') return;
        onKeyDown?.(e);
    }, [
        onKeyDown
    ]);
    const onIssueKeyClick = (0, $eUqFw.useCallback)(({ id: id, key: key })=>(event)=>{
            if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) {
                event.stopPropagation();
                clearSelectedCell();
            }
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'keyCell linkClicked');
            onOpenIssueModal({
                id: id,
                key: key
            })(event);
        }, [
        clearSelectedCell,
        createAnalyticsEvent,
        onOpenIssueModal
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated wrapperRef is now managed in CellNavigation
   */ const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]);
    const handleKeyDownNew = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') issueViewInteraction === 'openNewTab' ? onEmbedIssueClick(e) : onIssueKeyClick({
            id: issueId,
            key: issueKey
        })(e);
        return false;
    }, [
        issueId,
        issueKey,
        issueViewInteraction,
        onEmbedIssueClick,
        onIssueKeyClick
    ]);
    const handleCopyIconFocus = (0, $eUqFw.useCallback)((e)=>{
        // do not allow focus to propagate or it will select the cell
        (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') && e.stopPropagation();
    }, []);
    (0, $eUqFw.useImperativeHandle)(cellRef, ()=>({
            onClick: ()=>true,
            onKeyDown: handleKeyDownNew
        }), [
        handleKeyDownNew
    ]);
    let keyContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKey, {
        href: `/browse/${issueKey}`,
        onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
            id: issueId,
            key: issueKey
        }),
        onMouseEnter: handleIssueKeyMouseEnter,
        "data-testid": "business-list.ui.list-view.key-cell.issue-key"
    }, issueKey);
    if (showFlatList && parentIssues != null) keyContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKeyContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$ParentIssueKeysWrapper, null, parentIssues.map(({ id: id, key: key }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: id
        }, index > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$ParentIssueKeysDivider, null, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKey, {
            href: `/browse/${key}`,
            onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
                id: id,
                key: key
            }),
            "data-testid": "business-list.ui.list-view.key-cell.parent-issue-key"
        }, key)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKeyHierarchyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9uU8f.default), {
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKey, {
        href: `/browse/${issueKey}`,
        onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
            id: issueId,
            key: issueKey
        }),
        "data-testid": "business-list.ui.list-view.key-cell.issue-key"
    }, issueKey)));
    /**
   * when copy and paste is enabled,
   * - show the copy icon when:
   * 		- hovering
   * 		- issue key has just been copied - so the reset logic built into the copy icon can be triggered after 3 seconds
   * - hide the copy icon when:
   * 		- there is a selection in the list, so the copy action doesn't conflict with other cell's copy action
   */ const shouldShowCopyIcon = (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') ? !hasSelection && isHovering || isCopied : isHovering;
    const keyCellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, keyContent, shouldShowCopyIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$CopyIconWrapper, {
        onFocus: handleCopyIconFocus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eP9Rz.default), {
        id: `copy-${issueKey}`,
        label: formatMessage((0, $dLenM.default).copy),
        tooltipDelay: 0,
        tooltipLabel: formatMessage((0, $dLenM.default).copy),
        tooltipLabelPosition: "top",
        shouldFitContainer: true,
        value: `${window.location.origin}/browse/${issueKey}`,
        hideFieldText: true,
        remountOnChange: true,
        onCopyClick: handleCopyClick,
        onClickChange: handleClickChange,
        onCopyReset: handleCopyReset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        iconBefore: isCopied ? // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
            label: formatMessage((0, $dLenM.default).copied),
            primaryColor: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$exports).G500})`,
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
            size: "small",
            label: formatMessage((0, $dLenM.default).copy)
        }),
        spacing: "none"
    }))));
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6556735293a55bfb$var$issueKeyCellStyles
    }, keyCellContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKeyCell, {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onBlur: onBlur,
        tabIndex: 0,
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        ref: onWrapperRef,
        isFocused: isSelected
    }, keyCellContent);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$CopyIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_tzy41r8u _t9ec12hf _u5f31b66 _4t3ipxbi _v5641hdd _kqswstnw _1xi2idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$IssueKeyCell = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8UbeN.WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvu2gc _u5f3u2gc _k48pbfng _syazagj8 _80omtlke _kqswh2mm _2rkoglpi _vchhusvi _sqoridpf _xm5vfdjv _1nw4t94y _qnlu1xty",
            __cmplp.className
        ])
    });
});
const $6556735293a55bfb$var$issueKeyCellStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    outline: 'none',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    fontWeight: 500,
    cursor: 'pointer',
    color: 'color.text',
    position: 'relative',
    '--copy-icon-opacity': 0,
    '--copy-icon-transform': `translate(${"var(--ds-space-negative-100, -8px)"}, 0)`,
    ':hover': {
        // @ts-expect-error - TS2353 - Object literal may only specify known properties, and ''--copy-icon-opacity'' does not exist in type 'SafeCSSObject'
        '--copy-icon-opacity': 1,
        '--copy-icon-transform': 'translate(0, 0)'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$IssueKey = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazagj8 _1reo15vq _18m915vq _1bto1l2s _u5f3u2gc _30l3agj8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$IssueKeyContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$IssueKeyHierarchyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$ParentIssueKeysWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _11c81vlj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$ParentIssueKeysDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41nxw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d0a128a0d80d703a$var$_link = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("h0HFa")));
function $d0a128a0d80d703a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $d0a128a0d80d703a$var$_link.default
    }));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = module.exports.default = $d0a128a0d80d703a$var$LinkIcon;

});

parcelRegister("j8Htg", function(module, exports) {

$parcel$export(module.exports, "openViewFromEmbed", () => $3314031ff4af418d$export$a29603f2eb9b6da6);
const $3314031ff4af418d$export$a29603f2eb9b6da6 = (param)=>{
    const cleanUrl = window.location.href.replace('/embed', '');
    const currentUrl = new URL(cleanUrl);
    if (param != null) currentUrl.searchParams.append(param.key, param.value);
    window.open(currentUrl.href, '_blank');
};

});

parcelRegister("eP9Rz", function(module, exports) {

$parcel$export(module.exports, "default", () => $447f96b73f1cfa1f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $SA3Qe = parcelRequire("SA3Qe");
class $447f96b73f1cfa1f$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            className: undefined,
            shouldFitContainer: false,
            hideFieldText: false,
            onCopyClick: undefined,
            onCopyReset: undefined,
            tooltipDelay: undefined,
            remountOnChange: false,
            tooltipDisabled: false
        };
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }
    render() {
        const { id: id, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, value: value, className: className, shouldFitContainer: shouldFitContainer, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled } = this.props;
        // When the input field holding the copy text is hidden, its value is not set in
        // the input field to avoid it accidentally being included in a selection when the user
        // is copying other content on the page.
        const fieldValue = hideFieldText ? '' : value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $SA3Qe.default), {
            id: id,
            label: label,
            tooltipLabel: tooltipLabel,
            tooltipLabelPosition: tooltipLabelPosition,
            tooltipDelay: tooltipDelay,
            remountOnChange: remountOnChange,
            fieldKey: value,
            value: fieldValue,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText,
            ...this.state,
            onCopyClick: this.onCopyClick,
            innerInputRef: this.onRef,
            tooltipDisabled: tooltipDisabled
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            copied: false,
            copyFailed: false
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onCopyClick = (event, analyticsEvent)=>{
            if (!this.inputTextRef || !this.inputTextRef.current) return;
            this.props.onCopyClick && this.props.onCopyClick(event, analyticsEvent);
            if (this.props.hideFieldText) // For hidden fields, update the input field ref to include the value only after the user
            // has clicked the copy button.
            this.inputTextRef.current.value = this.props.value;
            this.inputTextRef.current.select();
            let success = false;
            try {
                success = document.execCommand('copy');
                this.setState({
                    copied: true
                });
                this.props.onClickChange && this.props.onClickChange(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                success = false;
            }
            if (!success) this.setState({
                copyFailed: true
            });
            this.timeoutId = setTimeout(()=>{
                this.setState({
                    copied: false,
                    copyFailed: false
                });
                this.props.onCopyReset && this.props.onCopyReset();
            }, 3000);
            if (this.props.onCopyFinish) this.props.onCopyFinish();
        };
        this.onRef = (ref)=>{
            this.inputTextRef = ref;
        };
    }
}

});
parcelRegister("SA3Qe", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b);
$parcel$export(module.exports, "default", () => $a70a2edd0ca4f430$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $dmCPj = parcelRequire("dmCPj");

var $cf2Y4 = parcelRequire("cf2Y4");

var $8cU5f = parcelRequire("8cU5f");

var $8BJaJ = parcelRequire("8BJaJ");

var $c9TLT = parcelRequire("c9TLT");

var $dzpl6 = parcelRequire("dzpl6");

var $giAhk = parcelRequire("giAhk");


var $cJa0J = parcelRequire("cJa0J");

var $aV7qy = parcelRequire("aV7qy");
class $a70a2edd0ca4f430$export$71579edc8f362e35 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            id: (0, $df17f23b8446e341$export$4f0520e0d7c4c7b0),
            className: undefined,
            copyFailed: false,
            shouldFitContainer: false,
            hideFieldText: false,
            tooltipDelay: 100,
            remountOnChange: false
        };
    }
    constructor(props){
        super(props);
        this.textInput = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.props.innerInputRef(this.textInput);
    }
    renderDefaultButton() {
        const { tooltipLabel: tooltipLabel, onCopyClick: onCopyClick } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a70a2edd0ca4f430$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
                label: tooltipLabel
            })),
            onClick: onCopyClick
        });
    }
    render() {
        const { id: id, fieldKey: fieldKey, value: value, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, intl: intl, copied: copied, onCopyClick: onCopyClick, shouldFitContainer: shouldFitContainer, copyFailed: copyFailed, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled, ...props } = this.props;
        let actualTooltipLabel = tooltipLabel;
        if (copied) actualTooltipLabel = intl.formatMessage((0, $cJa0J.default).copied);
        else if (copyFailed) actualTooltipLabel = intl.formatMessage((0, $cJa0J.default).copyFailed);
        const copyButton = !this.props.children ? null : // @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, $eUqFw.cloneElement)((0, $eUqFw.Children).only(this.props.children), {
            onClick: onCopyClick
        });
        return(// @ts-expect-error - TS2741 - Property 'hideFieldText' is missing in type '{ children: Element[]; className: string | undefined; innerInputRef: (arg1: HTMLInputElementRef) => void; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { hideFieldText: boolean; }, any>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV7qy.Root), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV7qy.FieldContainer), {
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText
        }, label && !hideFieldText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BJaJ.FieldLabel), {
            htmlFor: (0, $df17f23b8446e341$export$4f0520e0d7c4c7b0),
            label: label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            "aria-hidden": hideFieldText ? 'true' : undefined,
            key: fieldKey,
            id: id,
            name: (0, $df17f23b8446e341$export$4f0520e0d7c4c7b0),
            label: label,
            value: value,
            isReadOnly: true,
            ref: this.textInput,
            tabIndex: hideFieldText ? -1 : undefined
        })), tooltipDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a70a2edd0ca4f430$var$FlexGrow, null, copyButton || this.renderDefaultButton()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            tag: "span",
            key: remountOnChange ? actualTooltipLabel : undefined,
            delay: tooltipDelay,
            position: tooltipLabelPosition,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                "aria-live": "assertive"
            }, actualTooltipLabel)
        }, copyButton || this.renderDefaultButton())));
    }
}
var $a70a2edd0ca4f430$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($a70a2edd0ca4f430$export$71579edc8f362e35);
const $a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ...props,
        theme: (0, $dzpl6.getTheme)({
            buttonStyles: {
                default: {
                    height: `${(0, $c9TLT.gridSize) * 5}px`,
                    width: `${(0, $c9TLT.gridSize) * 5}px`
                }
            }
        })
    });
$a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b.displayName = 'StyledButton'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a70a2edd0ca4f430$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0t94y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a70a2edd0ca4f430$var$FlexGrow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9bab72963b78cefe$var$_copy = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("dBCpP")));
function $9bab72963b78cefe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $9bab72963b78cefe$var$_copy.default
    }));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = module.exports.default = $9bab72963b78cefe$var$CopyIcon;

});
parcelRegister("dBCpP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb7c6c8cdb896d771e123a497630ca2d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e7c879c9eefdea2$var$_react = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9e7c879c9eefdea2$var$_UNSAFE_baseNew = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9e7c879c9eefdea2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e7c879c9eefdea2$var$CopyIcon = (props)=>/*#__PURE__*/ $9e7c879c9eefdea2$var$_react.default.createElement($9e7c879c9eefdea2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$9e7c879c9eefdea2$var$CopyIcon.displayName = 'CopyIcon';
var $9e7c879c9eefdea2$var$_default = module.exports.default = $9e7c879c9eefdea2$var$CopyIcon;

});


parcelRegister("8BJaJ", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $816236d547316819$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");


var $4lTFP = parcelRequire("4lTFP");

var $c9TLT = parcelRequire("c9TLT");
const $816236d547316819$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$LabelText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$RequiredIndicator, {
        role: "presentation"
    }, "*") : null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $816236d547316819$var$LabelText = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-9kgl5s-0"
})`${(0, $4lTFP.h200)()} display:block;font-family:${(0, $c9TLT.fontFamily)};margin:0;${(0, $kwce8.css)({
    padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
})}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$RequiredIndicator = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-9kgl5s-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`,
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    paddingLeft: "var(--ds-space-025, 2px)"
});
$816236d547316819$var$RequiredIndicator.displayName = 'RequiredIndicator';

});

parcelRegister("dzpl6", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $55e2e88bfdce03b8$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

const $55e2e88bfdce03b8$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $73a5c9d720aa66e1$exports).P400,
            '> span': {
                color: (0, $73a5c9d720aa66e1$exports).N0
            }
        }
    };
    return theme;
};
const $55e2e88bfdce03b8$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $55e2e88bfdce03b8$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $55e2e88bfdce03b8$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

const $df17f23b8446e341$export$4f0520e0d7c4c7b0 = 'field-copy-text';

parcelRegister("cJa0J", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4aec29dc4c903c3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a4aec29dc4c903c3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    copied: {
        "id": "common.field-copy-text.copied",
        "defaultMessage": "Copied!"
    },
    copyFailed: {
        "id": "common.field-copy-text.copy-failed",
        "defaultMessage": "Couldn't copy to clipboard"
    }
});

});

parcelRegister("aV7qy", function(module, exports) {

$parcel$export(module.exports, "Root", () => $e50c2b052b0ce017$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "FieldContainer", () => $e50c2b052b0ce017$export$b5c4b0e7cd7f148b);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $e50c2b052b0ce017$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1g0si8d-0"
})({
    display: 'flex',
    alignItems: 'flex-end'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        userSelect: 'none'
    }) : '');
const $e50c2b052b0ce017$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1g0si8d-1"
})({
    marginRight: "var(--ds-space-100, 8px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.shouldFitContainer ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        flexGrow: 1
    }) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        position: 'absolute',
        left: '-9999px',
        height: 0,
        opacity: 0,
        pointerEvents: 'none',
        userSelect: 'none'
    }) : '');

});



parcelRegister("9uU8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b6ff46bc289e851$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $7b6ff46bc289e851$var$defaultStrokeColor = "var(--ds-text-accent-blue-bolder, #42526E)";
const $7b6ff46bc289e851$var$HierarchyIconSVG = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "5.33333",
        cy: "5.33333",
        r: "1.33333",
        stroke: props.stroke || $7b6ff46bc289e851$var$defaultStrokeColor,
        strokeWidth: "1.33333",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "10.6667",
        cy: "10.6666",
        r: "1.33333",
        stroke: props.stroke || $7b6ff46bc289e851$var$defaultStrokeColor,
        strokeWidth: "1.33333",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.33337 6.66669V9.33335C5.33337 10.0697 5.93033 10.6667 6.66671 10.6667H9.33337",
        stroke: props.stroke || $7b6ff46bc289e851$var$defaultStrokeColor,
        strokeWidth: "1.33333",
        fill: "none"
    }));
const $7b6ff46bc289e851$var$HierarchyIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: (customGlyphProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b6ff46bc289e851$var$HierarchyIconSVG, {
                ...customGlyphProps,
                stroke: props.stroke
            }),
        size: props.size,
        label: props.label
    });
var $7b6ff46bc289e851$export$2e2bcd8739ae039 = $7b6ff46bc289e851$var$HierarchyIcon;

});

parcelRegister("dLenM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7801a7a01c28b853$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7801a7a01c28b853$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    copy: {
        "id": "business-list.list-view.key-cell.copy",
        "defaultMessage": "Copy link"
    },
    copied: {
        "id": "business-list.list-view.key-cell.copied",
        "defaultMessage": "Copied"
    }
});

});


parcelRegister("5kwBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c1fa5c7b9dd6cf2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $7c1fa5c7b9dd6cf2$var$LabelsCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3wYWm")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/labels-cell/main.tsx"
});
const $7c1fa5c7b9dd6cf2$var$AsyncLabelsCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "labels-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c1fa5c7b9dd6cf2$var$LabelsCell, props));
var $7c1fa5c7b9dd6cf2$export$2e2bcd8739ae039 = $7c1fa5c7b9dd6cf2$var$AsyncLabelsCell;

});
parcelRegister("3wYWm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7Zj7L").then(()=>parcelRequire('jhtFc'));

});


parcelRegister("IIbrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $96d3bc4404f11fac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $96d3bc4404f11fac$var$MultiSelectCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bbXi1")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/multi-select-cell/main.tsx"
});
const $96d3bc4404f11fac$var$AsyncMultiSelectCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "multi-select-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96d3bc4404f11fac$var$MultiSelectCell, props));
var $96d3bc4404f11fac$export$2e2bcd8739ae039 = $96d3bc4404f11fac$var$AsyncMultiSelectCell;

});
parcelRegister("bbXi1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lvnuH").then(()=>parcelRequire('5zFB7'));

});


parcelRegister("jmKEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc34430ece2ee33a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $fc34430ece2ee33a$var$MultiUserCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("h3Kuf")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/multi-user-cell/main.tsx"
});
const $fc34430ece2ee33a$var$AsyncMultiUserCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "multi-user-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc34430ece2ee33a$var$MultiUserCell, props));
var $fc34430ece2ee33a$export$2e2bcd8739ae039 = $fc34430ece2ee33a$var$AsyncMultiUserCell;

});
parcelRegister("h3Kuf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("37w72")
]).then(()=>parcelRequire('tWDSG'));

});


parcelRegister("cMZur", function(module, exports) {

$parcel$export(module.exports, "default", () => $38b684e9a0fbcdca$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $38b684e9a0fbcdca$var$NumberCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6XnjO")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/number-cell/main.tsx"
});
const $38b684e9a0fbcdca$var$AsyncNumberCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "number-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38b684e9a0fbcdca$var$NumberCell, props));
var $38b684e9a0fbcdca$export$2e2bcd8739ae039 = $38b684e9a0fbcdca$var$AsyncNumberCell;

});
parcelRegister("6XnjO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6YBeb").then(()=>parcelRequire('ezxf8'));

});


parcelRegister("fk8YW", function(module, exports) {

$parcel$export(module.exports, "default", () => $368a86d5bd919a1f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $368a86d5bd919a1f$var$OriginalEstimateCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3agd3")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/original-estimate-cell/main.tsx"
});
const $368a86d5bd919a1f$var$AsyncOriginalEstimateCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "original-estimate-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($368a86d5bd919a1f$var$OriginalEstimateCell, props));
var $368a86d5bd919a1f$export$2e2bcd8739ae039 = $368a86d5bd919a1f$var$AsyncOriginalEstimateCell;

});
parcelRegister("3agd3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lgMdq").then(()=>parcelRequire('1ZIHR'));

});


parcelRegister("hgKBS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1a0a98749a640e1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $a1a0a98749a640e1$var$PriorityCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hCDRJ")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/priority-cell/main.tsx"
});
const $a1a0a98749a640e1$var$AsyncPriorityCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "priority-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1a0a98749a640e1$var$PriorityCell, props));
var $a1a0a98749a640e1$export$2e2bcd8739ae039 = $a1a0a98749a640e1$var$AsyncPriorityCell;

});
parcelRegister("hCDRJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1vONZ").then(()=>parcelRequire('awLFp'));

});


parcelRegister("iWW7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $58db136327b66973$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $58db136327b66973$var$RemoteIssueLinksCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hybkd")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/remote-issue-links-cell/main.tsx"
});
const $58db136327b66973$var$AsyncRemoteIssueLinksCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "remote-issue-links-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($58db136327b66973$var$RemoteIssueLinksCell, props));
var $58db136327b66973$export$2e2bcd8739ae039 = $58db136327b66973$var$AsyncRemoteIssueLinksCell;

});
parcelRegister("hybkd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("5FaIp")
]).then(()=>parcelRequire('1R0FP'));

});


parcelRegister("7v11U", function(module, exports) {

$parcel$export(module.exports, "SelectRowCheckbox", () => $7005321b316efdaf$export$ee74d161095f15ae);
$parcel$export(module.exports, "SelectAllColumnCheckbox", () => $7005321b316efdaf$export$7ea5ed11456af816);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4E9Xv = parcelRequire("4E9Xv");

var $7Sz8O = parcelRequire("7Sz8O");

var $hotly = parcelRequire("hotly");

var $kh0PA = parcelRequire("kh0PA");

var $hMWPo = parcelRequire("hMWPo");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gbsaq = parcelRequire("gbsaq");

var $hRFuG = parcelRequire("hRFuG");

var $4NIME = parcelRequire("4NIME");
const $7005321b316efdaf$export$ee74d161095f15ae = /*#__PURE__*/ (0, $eUqFw.memo)(({ rowData: rowData, rowIndex: rowIndex, onKeyDown: onKeyDown, ...props })=>{
    const { issueId: rowIssueId, id: id } = rowData;
    const issueId = String(rowIssueId);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { selectIssues: selectIssues, unselectIssues: unselectIssues }] = (0, $hotly.useBulkSelectionStore)();
    const [isRowSelected] = (0, $hotly.useIsIssueSelected)({
        issueId: issueId,
        parentIssueId: rowData.parentIssueId
    });
    const { onShiftKeyBulkSelection: onShiftKeyBulkSelection } = (0, $hMWPo.useShiftKeySelection)();
    const bulkOpsFlow = (0, $4E9Xv.useBulkOpsSessionContext)();
    const onClickCheckbox = (0, $eUqFw.useCallback)(({ isChecked: isChecked, shiftKeyPressed: shiftKeyPressed })=>{
        const bulkOpsSessionID = bulkOpsFlow?.getFlowAttributes()?.bulkOpsSessionID ?? '';
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectIssue', {
            isChecked: isChecked,
            rowIndex: rowIndex,
            shiftKeyPressed: shiftKeyPressed,
            bulkOpsSessionID: bulkOpsSessionID
        });
        if (isChecked) selectIssues({
            issues: [
                issueId
            ],
            rowIndex: rowIndex
        });
        else unselectIssues({
            issues: [
                issueId
            ],
            rowIndex: rowIndex
        });
        if (shiftKeyPressed) onShiftKeyBulkSelection({
            isChecked: isChecked,
            rowIndex: rowIndex
        });
    }, [
        createAnalyticsEvent,
        issueId,
        onShiftKeyBulkSelection,
        rowIndex,
        selectIssues,
        unselectIssues,
        bulkOpsFlow
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') {
            onClickCheckbox({
                isChecked: !isRowSelected,
                shiftKeyPressed: e.shiftKey
            });
            return;
        }
        if (e.shiftKey && e.key === 'Tab' || e.key === 'ArrowLeft') {
            e.preventDefault();
            document.dispatchEvent(new CustomEvent(`${(0, $gbsaq.DRAG_AND_DROP_BUTTON_FOCUS_EVENT)}`, {
                detail: {
                    issueId: issueId
                }
            }));
            return;
        }
        onKeyDown?.(e);
    }, [
        isRowSelected,
        onClickCheckbox,
        onKeyDown,
        issueId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const focusOnCheckbox = (e)=>{
            if (String(e.detail.issueId) !== issueId) return;
            const checkbox = document.getElementById(`${(0, $gbsaq.BULK_SELECT_CHECKBOX_ID)}-${issueId}`);
            checkbox?.focus();
        };
        document.addEventListener(`${(0, $gbsaq.BULK_SELECT_CHECKBOX_ID)}-focus`, focusOnCheckbox);
        return ()=>{
            document.removeEventListener(`${(0, $gbsaq.BULK_SELECT_CHECKBOX_ID)}-focus`, focusOnCheckbox);
        };
    }, [
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7005321b316efdaf$var$SingleSelectChecboxContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hRFuG.BulkSelectCheckbox), {
        id: `${(0, $gbsaq.BULK_SELECT_CHECKBOX_ID)}-${issueId}`,
        onClick: onClickCheckbox,
        isChecked: isRowSelected,
        onKeyDown: handleKeyDown,
        isDisabled: id.startsWith((0, $7Sz8O.OPTIMISTIC_ID_PREFIX)),
        label: formatMessage((0, $4NIME.default).selectIssue, {
            issueKey: rowData.key
        }),
        ...props
    }));
});
const $7005321b316efdaf$export$7ea5ed11456af816 = /*#__PURE__*/ (0, $eUqFw.memo)(({ showBulkEditOnboarding: showBulkEditOnboarding = false })=>{
    const { isIndeterminate: isIndeterminate, onClickCheckbox: onClickCheckbox, isChecked: isChecked } = (0, $kh0PA.useSelectAllCheckbox)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isPulseActive, setIsPulseActive] = (0, $eUqFw.useState)(!isChecked);
    const onClickSelectAllCheckbox = (0, $eUqFw.useCallback)((e)=>{
        onClickCheckbox(e);
        setIsPulseActive(false);
    }, [
        onClickCheckbox
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hRFuG.BulkSelectCheckbox), {
        onClick: onClickSelectAllCheckbox,
        isChecked: isChecked || isIndeterminate,
        isIndeterminate: isIndeterminate,
        label: formatMessage((0, $4NIME.default).selectAll),
        hasPulse: showBulkEditOnboarding && isPulseActive && (0, $eI5EY.fg)('jira_list_view_bulk_edit_changeboarding')
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7005321b316efdaf$var$SingleSelectChecboxContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u08jkm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kh0PA", function(module, exports) {

$parcel$export(module.exports, "useSelectAllCheckbox", () => $2e892d45a97704be$export$1f1cc91657e74385);

var $eUqFw = parcelRequire("eUqFw");

var $5r9Wo = parcelRequire("5r9Wo");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dSE3z = parcelRequire("dSE3z");

var $hotly = parcelRequire("hotly");

var $lEcA7 = parcelRequire("lEcA7");

var $8COV0 = parcelRequire("8COV0");
const $2e892d45a97704be$export$1f1cc91657e74385 = ()=>{
    const [{ hierarchyData: { data: data, isLoadingNextPage: isLoadingNextPage }, childrenItems: childrenItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [{ areAllIssuesSelected: areAllIssuesSelected, selectedIssues: selectedIssues }, { selectAllIssues: selectAllIssues, selectAll: selectAll, clearSelection: clearSelection, unselectAll: unselectAll }] = (0, $hotly.useBulkSelectionStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { fetchingGroups: fetchingGroups, selectCollapsedGroups: selectCollapsedGroups } = (0, $lEcA7.useSelectCollapsedGroups)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const prevGroupByFieldId = (0, $hzcvF.usePreviousWithInitial)(groupByFieldId);
    const isGrouping = groupByFieldId != null;
    (0, $eUqFw.useEffect)(()=>{
        if (prevGroupByFieldId !== groupByFieldId) // if the groupByFieldId is updated, clear the selection
        clearSelection();
    }, [
        clearSelection,
        groupByFieldId,
        prevGroupByFieldId
    ]);
    /*
        UNSELECT - if is all selected and we get new data we should unselect the "select all" checkbox
        to avoid comparing all the data we can just update the select all once we:
        - fetch a new page
        - fetch any children
    */ (0, $eUqFw.useEffect)(()=>{
        if (isLoadingNextPage && areAllIssuesSelected) unselectAll();
    }, [
        areAllIssuesSelected,
        isLoadingNextPage,
        unselectAll
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (areAllIssuesSelected) {
            if (!isGrouping) unselectAll();
            else if (isGrouping && !fetchingGroups) unselectAll();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(childrenItems),
        data.length
    ]);
    /*
        SELECT ALL - if all the issues are selected we should check the 'select all checkbox'
        to avoid comparing all the data we can just check if it's all selected when an issue is selected
    */ (0, $eUqFw.useEffect)(()=>{
        if (!areAllIssuesSelected && selectedIssues.size) {
            // if is no grouping and there are more data selected we should check if all are selected.
            if (!isGrouping && selectedIssues.size >= data.length) {
                const allIssues = (0, $8COV0.getAllIssuesIds)({
                    data: data,
                    childrenItems: childrenItems
                });
                if (allIssues.length === selectedIssues.size) selectAll();
            } else if (isGrouping) {
                // if some of the groups were not fetched and have issues, then not select all
                for(let i = 0; i < data.length; i += 1){
                    const group = data[i];
                    const hasChildren = group.childSummary?.hasChildren;
                    if (hasChildren && childrenItems[group.issueId] === undefined) return;
                }
                const allIssues = (0, $8COV0.getAllIssuesIds)({
                    data: data,
                    childrenItems: childrenItems
                });
                if (allIssues.length === selectedIssues.size) selectAll();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedIssues
    ]);
    const onClickCheckbox = (0, $eUqFw.useCallback)(({ isChecked: isChecked })=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectAll', {
            isChecked: isChecked
        });
        if (isChecked) {
            const allIssues = (0, $8COV0.getAllIssuesIds)({
                data: data,
                childrenItems: childrenItems
            });
            // if it's an empty project we don't want to anything
            if (!allIssues.length && !isGrouping) return;
            selectAllIssues({
                issues: allIssues
            });
            if (isGrouping) selectCollapsedGroups(data);
        } else clearSelection();
    }, [
        childrenItems,
        clearSelection,
        createAnalyticsEvent,
        data,
        isGrouping,
        selectAllIssues,
        selectCollapsedGroups
    ]);
    return {
        isChecked: areAllIssuesSelected,
        isIndeterminate: !areAllIssuesSelected && selectedIssues.size > 0,
        onClickCheckbox: onClickCheckbox
    };
};

});

parcelRegister("4NIME", function(module, exports) {

$parcel$export(module.exports, "default", () => $1151350a786d7974$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1151350a786d7974$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectAll: {
        "id": "business-list.list-view.select-row-cell.select-all",
        "defaultMessage": "Select all issues"
    },
    selectIssue: {
        "id": "business-list.list-view.select-row-cell.select-issue",
        "defaultMessage": "Select {issueKey}"
    }
});

});


parcelRegister("67zRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20c2247af285c1e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $e20c2247af285c1e$var$SingleSelectCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("fPVev")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/single-select-cell/main.tsx"
});
const $e20c2247af285c1e$var$AsyncSingleSelectCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "single-select-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e20c2247af285c1e$var$SingleSelectCell, props));
var $e20c2247af285c1e$export$2e2bcd8739ae039 = $e20c2247af285c1e$var$AsyncSingleSelectCell;

});
parcelRegister("fPVev", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gOZCU").then(()=>parcelRequire('6bEOm'));

});


parcelRegister("a0Bmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $23762982b16d0ce0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $23762982b16d0ce0$var$SprintCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6ifua")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/sprint-cell/main.tsx"
});
const $23762982b16d0ce0$var$AsyncSprintCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "sprint-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($23762982b16d0ce0$var$SprintCell, props));
var $23762982b16d0ce0$export$2e2bcd8739ae039 = $23762982b16d0ce0$var$AsyncSprintCell;

});
parcelRegister("6ifua", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hpmEe")
]).then(()=>parcelRequire('5UIzZ'));

});


parcelRegister("7lf5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6181285132726d07$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $6181285132726d07$var$StatusCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5d11f")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/status-cell/main.tsx"
});
const $6181285132726d07$var$AsyncStatusCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "status-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6181285132726d07$var$StatusCell, props));
var $6181285132726d07$export$2e2bcd8739ae039 = $6181285132726d07$var$AsyncStatusCell;

});
parcelRegister("5d11f", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("e5Kmd").then(()=>parcelRequire('4iyZd'));

});


parcelRegister("kmNgr", function(module, exports) {

$parcel$export(module.exports, "TextAreaCell", () => $261e7f2f10d2c9ae$export$1e25c2913c11e42f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $j8Htg = parcelRequire("j8Htg");

var $jGcn0 = parcelRequire("jGcn0");

var $8UbeN = parcelRequire("8UbeN");

var $eI5EY = parcelRequire("eI5EY");

var $gGiWF = parcelRequire("gGiWF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7Vbpp = parcelRequire("7Vbpp");

var $kGYHy = parcelRequire("kGYHy");

var $egJIx = parcelRequire("egJIx");
const $261e7f2f10d2c9ae$export$1e25c2913c11e42f = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldKey: fieldKey, fieldType: fieldType, fieldValue: fieldValue, onClick: onClick, issueKey: issueKey, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, cellRef: cellRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { issueViewInteraction: issueViewInteraction } = (0, $egJIx.useJWMListFeatures)();
    const [textValue, setTextValue] = (0, $eUqFw.useState)('');
    const onEmbedClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'textAreaCell clicked', 'listEmbedIssue');
        (0, $j8Htg.openViewFromEmbed)({
            key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
            value: issueKey
        });
    }, [
        createAnalyticsEvent,
        issueKey
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated wrapperRef is now managed in CellNavigation
   */ const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]);
    const [{ value: extractedFieldValue }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: fieldValue
    });
    const cellValue = (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') ? extractedFieldValue : fieldValue;
    // keeping value up-to-date with bento value
    // text area value is type string
    (0, $eUqFw.useEffect)(()=>{
        // TODO: JEH-62
        (0, $kGYHy.getADFMarkup)((0, $7Vbpp.convertAdfStringToObject)(cellValue)).then((value)=>setTextValue(value));
    }, [
        cellValue
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        issueViewInteraction === 'openNewTab' ? onEmbedClick() : onClick(event);
    }, [
        issueViewInteraction,
        onClick,
        onEmbedClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.code === 'Enter') {
            handleClick(event);
            return true;
        }
        return false;
    }, [
        handleClick
    ]);
    const cellOverrides = (0, $eUqFw.useCallback)(()=>({
            onClick: ()=>true,
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $261e7f2f10d2c9ae$var$wrapperStyles,
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $261e7f2f10d2c9ae$var$textStyles,
        as: "span"
    }, textValue));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($261e7f2f10d2c9ae$export$e6dfd72ab29f8598, {
        isFocused: isSelected,
        onClick: handleClick,
        onBlur: onBlur,
        tabIndex: 0,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        ref: onWrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, textValue));
});
const $261e7f2f10d2c9ae$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8UbeN.WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _9n9ou2gc _17kn15vq _1hrp15vq _x3fa1l2s",
            __cmplp.className
        ])
    });
});
$261e7f2f10d2c9ae$export$e6dfd72ab29f8598.displayName = 'Wrapper';
const $261e7f2f10d2c9ae$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    cursor: 'pointer'
});
const $261e7f2f10d2c9ae$var$textStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("kGYHy", function(module, exports) {

$parcel$export(module.exports, "getADFMarkup", () => $3691a2eb87a4e6e8$export$3d7eec7fcefdad14);



const $3691a2eb87a4e6e8$export$3d7eec7fcefdad14 = async (node)=>{
    if (node === null || node === undefined || typeof node === 'string') return '';
    const schemaPromise = (parcelRequire("gAEPB"));
    const wikiPromise = (parcelRequire("87zwO"));
    const jsonPromise = (parcelRequire("hhZ0p"));
    const [{ defaultSchema: defaultSchema }, { WikiMarkupTransformer: WikiMarkupTransformer }, { JSONTransformer: JSONTransformer }] = await Promise.all([
        schemaPromise,
        wikiPromise,
        jsonPromise
    ]);
    const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
    const adfTransformer = new JSONTransformer();
    const pmNode = adfTransformer.parse(node);
    return wikiTransformer.encode(pmNode);
};

});


parcelRegister("9dQoH", function(module, exports) {

$parcel$export(module.exports, "TextCell", () => $e7c0028ace51beba$export$765aced31cc89655);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $4N6cH = parcelRequire("4N6cH");

var $bFzGY = parcelRequire("bFzGY");

var $cf2Y4 = parcelRequire("cf2Y4");

var $7eqzD = parcelRequire("7eqzD");

var $4TezD = parcelRequire("4TezD");

var $jwy0y = parcelRequire("jwy0y");

var $96etS = parcelRequire("96etS");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $gGiWF = parcelRequire("gGiWF");

var $kKLQT = parcelRequire("kKLQT");

var $e63D2 = parcelRequire("e63D2");


var $105cx = parcelRequire("105cx");

var $g43uO = parcelRequire("g43uO");

var $8UbeN = parcelRequire("8UbeN");

var $6BOi7 = parcelRequire("6BOi7");

var $kV5dc = parcelRequire("kV5dc");
const $e7c0028ace51beba$export$fc152bafe73dcaee = (props)=>{
    const { editMode: editMode, highlight: highlight, onSubmit: onSubmit, onBlur: onBlur, onChange: onChange, onKeyDown: onKeyDown, value: value, testId: testId } = props;
    if (editMode) return(// @ts-expect-error - TS2322 - Type 'FormEventHandler<HTMLInputElement> | undefined' is not assignable to type 'FormEventHandler<HTMLFormElement> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
        onSubmit: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        testId: testId ? `${testId}-field` : undefined,
        autoFocus: true,
        onBlur: onBlur,
        value: value,
        onChange: onChange,
        onKeyDown: onKeyDown
    })));
    if (value && typeof value === 'string' && (0, $4N6cH.isSafeUrl)(value) && (0, $79xbN.expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKLQT.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: value,
        fieldType: "text"
    });
    if (highlight && highlight.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e63D2.default), {
        highlight: highlight,
        text: value
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, value);
};
const $e7c0028ace51beba$export$765aced31cc89655 = ({ issueKey: issueKey, fieldKey: fieldKey, isEditable: isEditable, fieldValue: fieldValue, fieldType: fieldType, testId: testId, isNudgeCell: isNudgeCell = false, isSelected: isSelected, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, issueId: issueId, editMode: editModeNew = false, setEditMode: setEditModeNew = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), cellRef: cellRef, issueType: issueType = '', issueTypeId: issueTypeId = '', fieldName: fieldName = '', inputValue: inputValue, onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const searchHighlight = (0, $96etS.useSimpleSearchHighlight)();
    const [textValueOld, setTextValueOld] = (0, $eUqFw.useState)(fieldValue || '');
    const textValue = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? (inputValue ?? fieldValue) || '' : textValueOld;
    const setTextValue = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? onInputChange : setTextValueOld;
    const [editMode, setEditMode] = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? [
        editModeNew,
        setEditModeNew
    ] : (0, $eUqFw.useState)(false);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueId: issueId,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: fieldValue,
        onFailure: ()=>{
            setTextValue(value || '');
        }
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { ref: inlineEditNudgeRef } = (0, $105cx.useRegisterNudgeTarget)((0, $99a775c02d636a41$export$a1398a6ef9526001), isNudgeCell);
    (0, $eUqFw.useEffect)(()=>{
        if (wrapperRef?.current && (0, $eI5EY.fg)('jira_list_keyboard_nav')) inlineEditNudgeRef.current = wrapperRef.current;
    }, [
        inlineEditNudgeRef,
        wrapperRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (fieldValue) setTextValue(fieldValue);
    }, [
        fieldValue,
        setTextValue
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // when the value (from useEditField) changes, update the textValue (from the input field).
        if (value !== textValue && (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) setTextValue(value || '');
    }, // we only care about value changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setTextValue,
        value
    ]);
    /**
	 * To be deleted when jira_list_keyboard_nav is cleaned up
	 * @deprecated Use handleClick in CellNavigation for generic behaviour or useImperativeHandle in this
	 * cell for custom behaviour
	 */ const handleClick = (0, $eUqFw.useCallback)(()=>{
        if (isEditable && !editMode) {
            setEditMode(true);
            setTextValue(value || '');
        }
    }, [
        editMode,
        isEditable,
        setTextValue,
        value,
        setEditMode
    ]);
    /**
	 * To be deleted when jira_list_keyboard_nav is cleaned up
	 * @deprecated Use handleKeyDown in CellNavigation for generic behaviour or handleKeyDownNew in this
	 * cell for custom behaviour
	 */ const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        if (event.key === 'Escape') {
            setTextValue(value || '');
            wrapperRef?.current?.focus();
        }
    }, [
        setTextValue,
        value,
        wrapperRef
    ]);
    const handleKeyDownNew = (0, $eUqFw.useCallback)((event)=>{
        if (editMode && event.code === 'Escape') setTextValue(value || '');
        return false;
    }, [
        editMode,
        setTextValue,
        value
    ]);
    const saveAndClose = (0, $eUqFw.useCallback)((event)=>{
        if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) event.preventDefault();
        if (editMode) {
            setEditMode(false);
            if (textValue !== value) saveValue(textValue, null, createAnalyticsEvent({}));
        }
    }, [
        editMode,
        textValue,
        value,
        saveValue,
        createAnalyticsEvent,
        setEditMode
    ]);
    const handleBlur = (0, $eUqFw.useCallback)((event)=>{
        saveAndClose(event);
        if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) onBlur && onBlur(event);
    }, [
        onBlur,
        saveAndClose
    ]);
    const handleChange = (0, $eUqFw.useCallback)((event)=>{
        setTextValue(event.target.value);
        resetError();
    }, [
        resetError,
        setTextValue
    ]);
    const renderNudgeWrapper = (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g43uO.InlineEditListNudgeAsync), null, children);
    /**
	 * To be deleted when jira_list_keyboard_nav is cleaned up
	 * @deprecated wrapperRef is now managed in CellNavigation
	 */ const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
        inlineEditNudgeRef.current = ref;
    }, [
        inlineEditNudgeRef,
        wrapperRef
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)((e)=>{
        saveAndClose(e);
        if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) wrapperRef?.current?.focus();
    }, [
        saveAndClose,
        wrapperRef
    ]);
    const cellOverrides = (0, $eUqFw.useCallback)(()=>({
            onKeyDown: handleKeyDownNew
        }), [
        handleKeyDownNew
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const handleSpotlightClose = (0, $eUqFw.useCallback)((event)=>{
        // Need to stop the event as its auto focusing on the cell and putting it in edit mode
        event.stopPropagation();
        setEditMode(false);
        setTimeout(()=>{
            wrapperRef?.current?.focus();
        }, 0);
    }, [
        setEditMode,
        wrapperRef
    ]);
    const textCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7c0028ace51beba$export$fc152bafe73dcaee, {
        editMode: editMode,
        onBlur: handleBlur,
        onSubmit: handleSubmit,
        onKeyDown: (0, $eI5EY.fg)('jira_list_keyboard_nav') ? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) : handleKeyDown,
        onChange: handleChange,
        value: textValue,
        highlight: searchHighlight,
        testId: testId
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jwy0y.FixItErrorFlag), {
        error: error,
        title: (0, $kV5dc.default).errorTitle,
        description: (0, $kV5dc.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    const textCellWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
        condition: isNudgeCell,
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.TextCellWrapper), {
        isEditable: isEditable,
        testId: "business-list.ui.list-view.text-cell.text-cell-wrapper"
    }, textCell));
    if ((0, $79xbN.expValEquals)('list_view_1_click_to_select_2_to_edit', 'cohort', 'variation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6BOi7.ClickToSelectOnboardingTour), {
        isNudgeCell: isNudgeCell,
        wrapperRef: wrapperRef,
        onClose: handleSpotlightClose
    }, textCellWrapper);
    if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6BOi7.ClickToEditOnboardingTour), {
        isNudgeCell: isNudgeCell,
        wrapperRef: wrapperRef,
        onClose: handleSpotlightClose
    }, textCellWrapper);
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, textCellWrapper);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
        condition: isNudgeCell,
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UbeN.TextFieldWrapper), {
        onClick: handleClick,
        isEditable: isEditable,
        onFocus: onFocus,
        onBlur: onBlur,
        isSelected: isSelected,
        tabIndex: 0,
        onKeyDown: onKeyDown,
        ref: onWrapperRef
    }, textCell));
};

});
parcelRegister("4N6cH", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $37d08cfa1c7b561a$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $37d08cfa1c7b561a$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $37d08cfa1c7b561a$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $37d08cfa1c7b561a$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $37d08cfa1c7b561a$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $izjsg = parcelRequire("izjsg");
const $37d08cfa1c7b561a$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $37d08cfa1c7b561a$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $37d08cfa1c7b561a$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($izjsg)))();
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $37d08cfa1c7b561a$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('tel:', $37d08cfa1c7b561a$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('file:', $37d08cfa1c7b561a$var$urlWithoutSpacesValidator);
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $37d08cfa1c7b561a$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $37d08cfa1c7b561a$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$37d08cfa1c7b561a$var$tlds.push($37d08cfa1c7b561a$var$tlds2Char);
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.tlds($37d08cfa1c7b561a$var$tlds, false);
const $37d08cfa1c7b561a$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $37d08cfa1c7b561a$export$6f7d7761b97f967 = (text)=>{
    if (!$37d08cfa1c7b561a$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($37d08cfa1c7b561a$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($37d08cfa1c7b561a$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $37d08cfa1c7b561a$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $37d08cfa1c7b561a$export$6f7d7761b97f967(str);
    if (!match.length) match = $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $37d08cfa1c7b561a$export$6535eb414fa2c8b6(url) {
    const match = $37d08cfa1c7b561a$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $37d08cfa1c7b561a$export$23579274a7a24f7b(url) {
    return url.startsWith('/');
}

});
parcelRegister("izjsg", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d84a96391edf6631$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d84a96391edf6631$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d84a96391edf6631$var$isString(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object String]';
}
function $d84a96391edf6631$var$isObject(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object Object]';
}
function $d84a96391edf6631$var$isRegExp(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object RegExp]';
}
function $d84a96391edf6631$var$isFunction(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object Function]';
}
function $d84a96391edf6631$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d84a96391edf6631$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d84a96391edf6631$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d84a96391edf6631$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d84a96391edf6631$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d84a96391edf6631$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d84a96391edf6631$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d84a96391edf6631$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d84a96391edf6631$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d84a96391edf6631$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d84a96391edf6631$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("bUlLc"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d84a96391edf6631$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d84a96391edf6631$var$isObject(val)) {
            if ($d84a96391edf6631$var$isRegExp(val.validate)) compiled.validate = $d84a96391edf6631$var$createValidator(val.validate);
            else if ($d84a96391edf6631$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d84a96391edf6631$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d84a96391edf6631$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d84a96391edf6631$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d84a96391edf6631$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d84a96391edf6631$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d84a96391edf6631$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d84a96391edf6631$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d84a96391edf6631$var$createMatch(self, shift) {
    var match = new $d84a96391edf6631$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d84a96391edf6631$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d84a96391edf6631$var$LinkifyIt)) return new $d84a96391edf6631$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d84a96391edf6631$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d84a96391edf6631$var$assign({}, $d84a96391edf6631$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d84a96391edf6631$var$assign({}, $d84a96391edf6631$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d84a96391edf6631$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d84a96391edf6631$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d84a96391edf6631$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d84a96391edf6631$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d84a96391edf6631$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d84a96391edf6631$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d84a96391edf6631$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d84a96391edf6631$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d84a96391edf6631$var$LinkifyIt;

});
parcelRegister("bUlLc", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("4NOMA")).source;
    re.src_Cc = (parcelRequire("jvFHg")).source;
    re.src_Z = (parcelRequire("8UCq2")).source;
    re.src_P = (parcelRequire("aUAJj")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("4NOMA", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("jvFHg", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("8UCq2", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("aUAJj", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});




parcelRegister("7eqzD", function(module, exports) {

$parcel$export(module.exports, "ConditionalWrapper", () => $b3ad0a6f810bebd6$export$39aecc95f0365819);

var $eUqFw = parcelRequire("eUqFw");
const $b3ad0a6f810bebd6$export$39aecc95f0365819 = ({ condition: condition, renderWrapper: renderWrapper, children: children })=>condition ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});

parcelRegister("jwy0y", function(module, exports) {

$parcel$export(module.exports, "FixItErrorFlag", () => $7983440f5b9e4a73$export$68221e9bb70731fc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1Yimi = parcelRequire("1Yimi");

var $kQAZu = parcelRequire("kQAZu");

var $atJIB = parcelRequire("atJIB");

var $7byHA = parcelRequire("7byHA");

var $izafr = parcelRequire("izafr");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWGNJ = parcelRequire("dWGNJ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3OBna = parcelRequire("3OBna");
const $7983440f5b9e4a73$export$68221e9bb70731fc = ({ error: error, title: title, description: description, issueType: issueType, issueTypeId: issueTypeId, fieldId: fieldId, fieldName: fieldName })=>{
    const project = (0, $kQAZu.useProject)();
    if (project.isSimplified) {
        const ASSOCIATION_OR_PERMISSION_ERROR = `Field '${fieldId}' cannot be set. It is not on the appropriate screen, or unknown.`;
        const errorMessage = error instanceof (0, $7byHA.ValidationError) ? error.errors && error.errors[0] && error.errors[0].error || error.message : String(error);
        const isFixitError = errorMessage?.includes(ASSOCIATION_OR_PERMISSION_ERROR);
        const isEditPermissionError = isFixitError && !project.permissions.editIssues;
        if (isEditPermissionError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7983440f5b9e4a73$var$EditPermissionErrorFlag, null);
        if (isFixitError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7983440f5b9e4a73$var$FieldAssociationErrorFlag, {
            issueType: issueType,
            fieldName: fieldName,
            fieldId: fieldId,
            projectId: project.id,
            issueTypeId: issueTypeId,
            isAdmin: project.permissions.administerProject
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: title,
        description: description
    });
};
const $7983440f5b9e4a73$var$EditPermissionErrorFlag = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'editPermissionErrorFlag');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
        flag: {
            type: 'warning',
            title: formatMessage((0, $3OBna.default).editPermissionErrorTitle),
            actions: [
                {
                    content: formatMessage((0, $3OBna.default).editPermissionErrorAction),
                    href: '/secure/ContactAdministrators!default.jspa',
                    target: '_blank',
                    onClick: ()=>{
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'contactAdministratorFromEditPermissionFlag');
                    }
                }
            ]
        }
    });
};
const $7983440f5b9e4a73$var$FieldAssociationErrorFlag = ({ fieldId: fieldId, fieldName: fieldName, issueType: issueType, projectId: projectId, issueTypeId: issueTypeId, isAdmin: isAdmin })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { associate: associate } = (0, $atJIB.useAssociateField)();
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [shouldAssociate, setShouldAssociate] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const dismissPreviousFlags = (0, $eUqFw.useRef)(true);
    const FIXIT_ERROR_FLAG_ID = `FIXIT_ERROR_FLAG_FOR_${issueTypeId}_${fieldId}`;
    (0, $eUqFw.useEffect)(()=>{
        if (shouldAssociate) {
            setShouldAssociate(false);
            associate({
                input: {
                    projectId: String(projectId),
                    fieldId: fieldId,
                    issueTypeIds: [
                        Number(issueTypeId)
                    ]
                },
                fieldName: fieldName,
                issueType: issueType,
                showSuccess: true,
                analyticsAttributes: {
                    source: 'business-fields.common.ui.fixit-error-flag'
                }
            }) // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(()=>{});
        }
    }, [
        associate,
        fieldId,
        fieldName,
        issueType,
        issueTypeId,
        projectId,
        shouldAssociate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'fixItErrorFlag');
    }, [
        createAnalyticsEvent
    ]);
    const actions = isAdmin ? [
        {
            content: formatMessage((0, $3OBna.default).updateFieldAssociationAction),
            onClick: async ()=>{
                if (projectId) {
                    dismissFlag(FIXIT_ERROR_FLAG_ID); // When associate service is called from the flag, it triggers refetch available fields internally, but
                    // `refetch` function is `undefined`. This could be because the flag is mounted outside of the view component
                    // where the available fields service hasn't been called yet (we can only refetch a service that has been called at least once).
                    // Hence we need to make sure we call associate() inside of the cell.
                    setShouldAssociate(true);
                }
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'associateFieldFromFixItFlag');
            }
        }
    ] : [
        {
            content: formatMessage((0, $3OBna.default).editIssueTypesPermissionErrorAction),
            href: '/secure/ContactAdministrators!default.jspa',
            target: '_blank',
            onClick: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'contactAdministratorFromFixitFlag');
            }
        }
    ]; // dismiss any existing flag with the same id
    if (dismissPreviousFlags.current) {
        dismissFlag(FIXIT_ERROR_FLAG_ID);
        dismissPreviousFlags.current = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
        flag: {
            id: FIXIT_ERROR_FLAG_ID,
            type: 'warning',
            title: [
                (0, $3OBna.default).editAssociationErrorTitle,
                {
                    fieldName: fieldName,
                    issueType: issueType,
                    normal: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7983440f5b9e4a73$var$FlagMessageWrapper, null, chunks),
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                            as: "strong"
                        }, chunks)
                }
            ],
            actions: actions
        }
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7983440f5b9e4a73$var$FlagMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3OBna", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce2d4e38ff6ef256$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ce2d4e38ff6ef256$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    editAssociationErrorTitle: {
        "id": "business-fields.common.fixit-error-flag.edit-association-error-title",
        "defaultMessage": "<normal><strong>{fieldName}</strong> is not associated to the <strong>{issueType}</strong> issue type</normal>"
    },
    updateFieldAssociationAction: {
        "id": "business-fields.common.fixit-error-flag.update-field-association-action",
        "defaultMessage": "Update field association"
    },
    editPermissionErrorTitle: {
        "id": "business-fields.common.fixit-error-flag.edit-permission-error-title",
        "defaultMessage": "You do not have permission to edit in this project"
    },
    editPermissionErrorAction: {
        "id": "business-fields.common.fixit-error-flag.edit-permission-error-action",
        "defaultMessage": "Contact your project admin"
    },
    editIssueTypesPermissionErrorAction: {
        "id": "business-fields.common.fixit-error-flag.edit-issue-types-permission-error-action",
        "defaultMessage": "Contact your project admin to edit issue types"
    }
});

});


parcelRegister("kKLQT", function(module, exports) {

$parcel$export(module.exports, "LazySingleLineSmartLink", () => $3950ae5de3be63ef$export$80092fcb07ccc4b4);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $a52WR = parcelRequire("a52WR");
const $3950ae5de3be63ef$var$entryPointParams = {};
const $3950ae5de3be63ef$export$80092fcb07ccc4b4 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $a52WR.SingleLineSmartLinkEntryPoint), $3950ae5de3be63ef$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira.issue-field.single-line-smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("a52WR", function(module, exports) {

$parcel$export(module.exports, "SingleLineSmartLinkEntryPoint", () => $8e5edba9c262361a$export$e236c9b35543c8d);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $8e5edba9c262361a$export$e236c9b35543c8d = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("fXdKW")).then((module)=>module.SingleLineSmartLink), {
        moduleId: "97818dc4"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fXdKW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("eANNs")
]).then(()=>parcelRequire('5DC7O'));

});



parcelRegister("e63D2", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e295d31ad42542$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gttjd = parcelRequire("gttjd");

var $lbHMu = parcelRequire("lbHMu");
const $29e295d31ad42542$var$HighlightTextWithParser = /*#__PURE__*/ (0, $eUqFw.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $gttjd.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbHMu.default), {
        parts: parts
    });
});
var $29e295d31ad42542$export$2e2bcd8739ae039 = $29e295d31ad42542$var$HighlightTextWithParser;

});
parcelRegister("gttjd", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $38a0e824f156ae86$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $38a0e824f156ae86$export$a3aee8a24a54661f);

var $e1vfz = parcelRequire("e1vfz");

var $hTLlD = parcelRequire("hTLlD");

var $lyOYo = parcelRequire("lyOYo");

var $5iWql = parcelRequire("5iWql");
const $38a0e824f156ae86$export$f3f2882e8b11d731 = (0, $5iWql.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $38a0e824f156ae86$export$1633667427d99697 = (0, $5iWql.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $38a0e824f156ae86$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $38a0e824f156ae86$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $38a0e824f156ae86$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $38a0e824f156ae86$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $38a0e824f156ae86$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $38a0e824f156ae86$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $38a0e824f156ae86$export$f3f2882e8b11d731(text);
    const textMatches = $38a0e824f156ae86$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $38a0e824f156ae86$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(leading));
        parts.push($38a0e824f156ae86$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("lbHMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed9071505b4a281f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gda1r = parcelRequire("gda1r");
const $ed9071505b4a281f$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gda1r.Mark), {
            key: i
        }, part.content);
    }));
var $ed9071505b4a281f$export$2e2bcd8739ae039 = $ed9071505b4a281f$var$HighlightText;

});
parcelRegister("gda1r", function(module, exports) {

$parcel$export(module.exports, "Mark", () => $8f973f57522751f3$export$c9d15bcfc6d42044);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8f973f57522751f3$export$c9d15bcfc6d42044 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkwtfv _syaz1fxt",
            __cmplp.className
        ])
    });
});

});



parcelRegister("g43uO", function(module, exports) {

$parcel$export(module.exports, "InlineEditListNudgeAsync", () => $6fe8dd7cf033361b$export$ae0c23fe550deebc);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $ibSJJ = parcelRequire("ibSJJ");
const $6fe8dd7cf033361b$var$runtimeProps = {};
const $6fe8dd7cf033361b$var$entryPointParams = {};
const $6fe8dd7cf033361b$export$ae0c23fe550deebc = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $ibSJJ.inlineEditNudgeEntrypoint), $6fe8dd7cf033361b$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $6fe8dd7cf033361b$var$runtimeProps
    }));
};

});
parcelRegister("ibSJJ", function(module, exports) {

$parcel$export(module.exports, "inlineEditNudgeEntrypoint", () => $49d36488e8e47561$export$8073de424af508bc);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $49d36488e8e47561$export$8073de424af508bc = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("7HLjw")), {
        moduleId: "1e3103f7"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7HLjw", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3G9D7").then(()=>parcelRequire('5ntTS'));

});



parcelRegister("6BOi7", function(module, exports) {

$parcel$export(module.exports, "ClickToEditOnboardingTour", () => $5ab51f87cd3d57ec$export$7b4b56fb1204d901);
$parcel$export(module.exports, "ClickToSelectOnboardingTour", () => $5ab51f87cd3d57ec$export$c6deaa5246c3126);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7eqzD = parcelRequire("7eqzD");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $7istn = parcelRequire("7istn");

var $gUSXn = parcelRequire("gUSXn");
const $5ab51f87cd3d57ec$var$isMacOS = ()=>/Mac/i.test(window?.navigator?.platform);
function $5ab51f87cd3d57ec$export$7b4b56fb1204d901(props) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const steps = {
        'copy-paste': {
            heading: formatMessage((0, $gUSXn.default).clickToEditCopyPasteHeading),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                values: {
                    code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ab51f87cd3d57ec$var$Code, null, chunks)
                },
                ...$5ab51f87cd3d57ec$var$isMacOS() ? (0, $gUSXn.default).clickToEditCopyPasteBodyMac : (0, $gUSXn.default).clickToEditCopyPasteBodyWindows
            })
        },
        navigation: {
            heading: formatMessage((0, $gUSXn.default).clickToEditNavigationHeading),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                values: {
                    code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ab51f87cd3d57ec$var$Code, null, chunks)
                },
                ...$5ab51f87cd3d57ec$var$isMacOS() ? (0, $gUSXn.default).clickToEditNavigationBodyMac : (0, $gUSXn.default).clickToEditNavigationBodyWindows
            })
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ab51f87cd3d57ec$var$CopyPasteOnboardingTour, {
        ...props,
        cohort: "control",
        steps: steps
    });
}
function $5ab51f87cd3d57ec$export$c6deaa5246c3126(props) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const steps = {
        'copy-paste': {
            heading: formatMessage((0, $gUSXn.default).clickToSelectCopyPasteHeading),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                values: {
                    code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ab51f87cd3d57ec$var$Code, null, chunks)
                },
                ...$5ab51f87cd3d57ec$var$isMacOS() ? (0, $gUSXn.default).clickToSelectCopyPasteBodyMac : (0, $gUSXn.default).clickToSelectCopyPasteBodyWindows
            })
        },
        navigation: {
            heading: formatMessage((0, $gUSXn.default).clickToSelectNavigationHeading),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                values: {
                    code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ab51f87cd3d57ec$var$Code, null, chunks)
                },
                ...$5ab51f87cd3d57ec$var$isMacOS() ? (0, $gUSXn.default).clickToSelectNavigationBodyMac : (0, $gUSXn.default).clickToSelectNavigationBodyWindows
            })
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ab51f87cd3d57ec$var$CopyPasteOnboardingTour, {
        ...props,
        cohort: "variation",
        steps: steps
    });
}
function $5ab51f87cd3d57ec$var$CopyPasteOnboardingTour({ children: children, isNudgeCell: isNudgeCell, wrapperRef: wrapperRef, steps: steps, cohort: cohort, onClose: onClose }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
        condition: isNudgeCell,
        renderWrapper: (wrappedChildren)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7istn.CopyPasteTourAsync), {
                wrapperRef: wrapperRef,
                cohort: cohort,
                steps: steps,
                onClose: onClose
            }, wrappedChildren)
    }, children);
}
function $5ab51f87cd3d57ec$var$Code({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("code", {
        className: (0, $7JEyt.default)([
            "_11c81u0j _bfhkm7j4 _syaz15cr _1dqoglyw _2rkoglpi _1e0c1nu9 _1yt41d1z _16d9qvcn _1reo1wug _18m91wug _1i4q1hna _o5721jtm"
        ])
    }, children);
}
const $5ab51f87cd3d57ec$var$codeStyles = null;

});
parcelRegister("7istn", function(module, exports) {

$parcel$export(module.exports, "CopyPasteTourAsync", () => $41b7d30e4ee1adce$export$cc0fbe7c384bfe4a);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $41b7d30e4ee1adce$var$LazyCopyPasteTour = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("lfrnc")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/common/ui/lazy-copy-paste-tour/main.tsx"
});
function $41b7d30e4ee1adce$export$cc0fbe7c384bfe4a(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "copy-paste-onboarding-tour",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41b7d30e4ee1adce$var$LazyCopyPasteTour, props));
}

});
parcelRegister("lfrnc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("izy1r").then(()=>parcelRequire('048Z6'));

});


parcelRegister("gUSXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b4199fc8284d4af$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8b4199fc8284d4af$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clickToEditCopyPasteHeading: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-heading",
        "defaultMessage": "Edit issues inline, or copy and paste"
    },
    clickToEditCopyPasteBodyMac: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-body-mac",
        "defaultMessage": "Select a cell to quickly edit details. To copy and paste without editing, select <code>esc</code> then <code>command</code> + <code>C</code> / <code>V</code>."
    },
    clickToEditCopyPasteBodyWindows: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-body-windows",
        "defaultMessage": "Select a cell to quickly edit details. To copy and paste without editing, select <code>esc</code> then <code>ctrl</code> + <code>C</code> / <code>V</code>."
    },
    clickToEditNavigationHeading: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-heading",
        "defaultMessage": "Navigate with your keyboard"
    },
    clickToEditNavigationBodyMac: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-body-mac",
        "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>return</code> to edit details, and <code>esc</code> to exit edit mode."
    },
    clickToEditNavigationBodyWindows: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-body-windows",
        "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>enter</code> to edit details, and <code>esc</code> to exit edit mode."
    },
    clickToSelectCopyPasteHeading: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-heading",
        "defaultMessage": "Copy and paste details, just like a spreadsheet"
    },
    clickToSelectCopyPasteBodyMac: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-mac",
        "defaultMessage": "To copy and paste issue details, select a cell then <code>command</code> + <code>C</code> / <code>V</code>. Select the cell again to edit."
    },
    clickToSelectCopyPasteBodyWindows: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-windows",
        "defaultMessage": "To copy and paste issue details, select a cell then <code>ctrl</code> + <code>C</code> / <code>V</code>. Select the cell again to edit."
    },
    clickToSelectNavigationHeading: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-heading",
        "defaultMessage": "Navigate with your keyboard"
    },
    clickToSelectNavigationBodyMac: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-body-mac",
        "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>return</code> to edit details, and <code>esc</code> to exit edit mode."
    },
    clickToSelectNavigationBodyWindows: {
        "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-body-windows",
        "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>enter</code> to edit details, and <code>esc</code> to exit edit mode."
    }
});

});


parcelRegister("kV5dc", function(module, exports) {

$parcel$export(module.exports, "default", () => $57a40443dbebc6ac$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $57a40443dbebc6ac$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.text-cell.error-title",
        "defaultMessage": "We couldn't save the text value."
    },
    errorMessage: {
        "id": "business-list.list-view.text-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("eggEB", function(module, exports) {

$parcel$export(module.exports, "TypeCell", () => $f67cc309a1f19bcb$export$1034b01824b6a80);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

var $gEmpR = parcelRequire("gEmpR");

var $d3C6e = parcelRequire("d3C6e");

var $8UbeN = parcelRequire("8UbeN");

var $hnzPP = parcelRequire("hnzPP");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8rQuz = parcelRequire("8rQuz");

var $2jrDX = parcelRequire("2jrDX");

var $egJIx = parcelRequire("egJIx");

var $aqGaJ = parcelRequire("aqGaJ");

var $fnB7E = parcelRequire("fnB7E");
const $f67cc309a1f19bcb$var$empty = ()=>null;
const $f67cc309a1f19bcb$export$1034b01824b6a80 = /*#__PURE__*/ (0, $eUqFw.memo)(({ id: id, iconUrl: iconUrl, name: name, avatarId: avatarId = '', onChildCreateButtonClicked: onChildCreateButtonClicked, hierarchyLevel: hierarchyLevel = 0, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, cellRef: cellRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlatList: showFlatList } = (0, $aqGaJ.useHierarchyConfig)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onChildCreateButtonClicked && setTimeout(()=>{
            onChildCreateButtonClicked();
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'childCreateButton');
    }, [
        createAnalyticsEvent,
        onChildCreateButtonClicked
    ]);
    const { hasCreateSubtask: hasCreateSubtask } = (0, $egJIx.useJWMListFeatures)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const canCreateChildIssue = hierarchyLevel > 0 ? issueTypes.some((issueType)=>issueType.hierarchyLevel === hierarchyLevel - 1) : hasCreateSubtask && issueTypes.some((issueType)=>issueType.hierarchyLevel === -1);
    const canCreateChild = !(0, $d3C6e.isOptimisticIssue)(Number(id)) && !showFlatList && typeof onChildCreateButtonClicked === 'function' && canCreateChildIssue;
    const childCreateContent = canCreateChild && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2jrDX.default), {
        tooltip: formatMessage((0, $fnB7E.default).createChildItem),
        label: formatMessage((0, $fnB7E.default).createChildItem),
        onClick: handleClick,
        shouldDisplayBtn: isSelected
    });
    const iconContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        url: iconUrl,
        alt: name,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
                url: `/secure/viewavatar?size=medium&avatarId=${avatarId}&avatarType=issuetype`,
                alt: name,
                fallback: $f67cc309a1f19bcb$var$empty
            })
    }); /**
                                                                                                                                                                                                           * To be deleted when jira_list_keyboard_nav is cleaned up
                                                                                                                                                                                                           * @deprecated Now handled in CellNavigation component
                                                                                                                                                                                                           */ 
    const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]); /**
                     * To be deleted when jira_list_keyboard_nav is cleaned up
                     * @deprecated Now handled in handleKeyDownNew
                     */ 
    const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') return;
        onKeyDown?.(e);
    }, [
        onKeyDown
    ]);
    const handleKeyDownNew = (0, $eUqFw.useCallback)((event)=>{
        if (event.code === 'Enter') return true;
        return false;
    }, []); // ignore clicks to avoid entering editMode
    const handleClickNew = (0, $eUqFw.useCallback)(()=>true, []);
    const cellOverrides = (0, $eUqFw.useMemo)(()=>()=>({
                onClick: handleClickNew,
                onKeyDown: handleKeyDownNew
            }), [
        handleClickNew,
        handleKeyDownNew
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f67cc309a1f19bcb$var$TypeWrapper, {
        "data-testid": "business-list.ui.list-view.type-cell.type-wrapper",
        canCreateChild: canCreateChild,
        tabIndex: 0,
        isVisualRefresh: (0, $8rQuz.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: name
    }, iconContent), childCreateContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f67cc309a1f19bcb$var$TypeWrapperOld, {
        canCreateChild: canCreateChild,
        onBlur: onBlur,
        tabIndex: 0,
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        ref: onWrapperRef,
        isFocused: isSelected,
        "data-testid": "business-list.ui.list-view.type-cell.type-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: name
    }, iconContent), childCreateContent);
});
/**
 * To be deleted when jira_list_keyboard_nav is cleaned up
 * @deprecated Now use TypeWrapper
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f67cc309a1f19bcb$var$TypeWrapperOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8UbeN.WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoglpi _19bvldb6 _k8empxbi",
            __cmplp ? "_1hlxu2gc" : "_1hlxidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f67cc309a1f19bcb$var$TypeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _2rkoglpi _19bvldb6",
            __cmplp ? "_1hlxu2gc" : "_1hlxidpf",
            __cmplp.isVisualRefresh ? "_p7r11txw _tij01h6o" : "_k8empxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hnzPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca9fc3da0c774fa7$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/handler-naming */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");


var $c9TLT = parcelRequire("c9TLT");
const $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b = (0, $c9TLT.gridSize) * 2;
class $ca9fc3da0c774fa7$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b,
            height: $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        return url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca9fc3da0c774fa7$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            draggable: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca9fc3da0c774fa7$var$ImagePlaceholder, {
            width: width,
            height: height,
            "data-testid": "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isBroken: false
        };
        this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        };
        this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca9fc3da0c774fa7$var$ImagePlaceholder = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "owe24v-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $73a5c9d720aa66e1$exports).N30,
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    }));
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca9fc3da0c774fa7$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fnB7E", function(module, exports) {

$parcel$export(module.exports, "default", () => $f82679cf26977614$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f82679cf26977614$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addChildItem: {
        "id": "business-list.list-view.type-cell.add-child-item",
        "defaultMessage": "Add child item"
    },
    createSubtask: {
        "id": "business-list.list-view.type-cell.create-subtask",
        "defaultMessage": "Create subtask"
    },
    createTask: {
        "id": "business-list.list-view.type-cell.create-task",
        "defaultMessage": "Create"
    },
    createChildItem: {
        "id": "business-list.list-view.type-cell.create-child-item",
        "defaultMessage": "Create child issue"
    }
});

});


parcelRegister("1NqHF", function(module, exports) {

$parcel$export(module.exports, "UrlCell", () => $819bcdea9e3086de$export$110272e30ac53e5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $bFzGY = parcelRequire("bFzGY");

var $cf2Y4 = parcelRequire("cf2Y4");

var $4TezD = parcelRequire("4TezD");

var $jwy0y = parcelRequire("jwy0y");

var $8UbeN = parcelRequire("8UbeN");

var $79xbN = parcelRequire("79xbN");

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");

var $gGiWF = parcelRequire("gGiWF");

var $6Dl4d = parcelRequire("6Dl4d");

var $7Bzvw = parcelRequire("7Bzvw");
const $819bcdea9e3086de$export$110272e30ac53e5 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, fieldKey: fieldKey, isEditable: isEditable, fieldValue: fieldValue, fieldType: fieldType, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', editMode: editModeNew = false, setEditMode: setEditModeNew = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), cellRef: cellRef, inputValue: inputValue = fieldValue ?? '', onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const [textValueOld, setTextValueOld] = (0, $eUqFw.useState)(fieldValue || '');
    const [editMode, setEditMode] = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? [
        editModeNew,
        setEditModeNew
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useState)(false);
    const textValue = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? inputValue : textValueOld;
    const setTextValue = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? onInputChange : setTextValueOld;
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: fieldValue
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // reset textValue when there's an error
        if (error && value !== textValue) setTextValue(value ?? '');
    }, [
        error,
        setTextValue,
        textValue,
        value
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Now handled in useEffect above
   */ const handleClick = (0, $eUqFw.useCallback)(()=>{
        if (isEditable && !editMode) {
            setEditMode(true);
            setTextValue(value || '');
        }
    }, [
        editMode,
        isEditable,
        setEditMode,
        setTextValue,
        value
    ]);
    const saveAndClose = (0, $eUqFw.useCallback)((event)=>{
        if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) event.preventDefault();
        if (editMode) {
            setEditMode(false);
            if (textValue !== value) saveValue(textValue, null, createAnalyticsEvent({}));
        }
    }, [
        createAnalyticsEvent,
        editMode,
        saveValue,
        setEditMode,
        textValue,
        value
    ]);
    const handleChange = (0, $eUqFw.useCallback)((event)=>{
        setTextValue(event.target.value);
        resetError();
    }, [
        resetError,
        setTextValue
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Now handled in CellNavigation component
   */ const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
        !editMode && onKeyDown?.(e);
    }, [
        editMode,
        onKeyDown
    ]);
    const handleKeyDownNew = (0, $eUqFw.useCallback)((event)=>{
        if (editMode && event.code === 'Escape') setTextValue(value ?? '');
        return false;
    }, [
        editMode,
        setTextValue,
        value
    ]);
    const cellOverrides = (0, $eUqFw.useMemo)(()=>()=>({
                onKeyDown: handleKeyDownNew
            }), [
        handleKeyDownNew
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Now handled in CellNavigation component
   */ const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Now handled in handleKeyDown
   */ const handleTextFieldKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Escape') {
            e.preventDefault();
            setTextValue(value || '');
            // settimeout used here as there is a conflict with textfield autofocus
            setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
        }
    }, [
        setTextValue,
        value,
        wrapperRef
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)((event)=>{
        saveAndClose(event);
        // settimeout used here as there is a conflict with textfield autofocus
        if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) setTimeout(()=>{
            wrapperRef?.current?.focus();
        });
    }, [
        saveAndClose,
        wrapperRef
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        autoFocus: true,
        onBlur: saveAndClose,
        value: textValue,
        onChange: handleChange,
        onKeyDown: (0, $eI5EY.fg)('jira_list_keyboard_nav') ? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) : handleTextFieldKeyDown
    })) : value != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Dl4d.SmartLink), {
        value: value
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jwy0y.FixItErrorFlag), {
        error: error,
        title: (0, $7Bzvw.default).errorTitle,
        description: (0, $7Bzvw.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable,
        testId: "business-list.ui.list-view.url-cell.url-cell-wrapper",
        hasPadding: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($819bcdea9e3086de$var$Wrapper, null, cellContent));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($819bcdea9e3086de$var$WrapperOld, {
        isFocused: editMode || isSelected,
        onClick: handleClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: handleKeyDown,
        ref: onWrapperRef,
        tabIndex: 0,
        "data-testid": "business-list.ui.list-view.url-cell.url-cell-wrapper"
    }, cellContent);
});
/**
 * To be deleted when jira_list_keyboard_nav is cleaned up
 * @deprecated Now use cellWrapperStyles from @atlassian/jira-business-fields/cell-wrapper
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $819bcdea9e3086de$var$WrapperOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8UbeN.WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80om1kdv _o5721q9c _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _1yds1osq _1hw71txw _156d1y6m _6wji1h6o _bod01osq _ci54u2gc _18ywh2mm _1j631txw _1tuuidpf _1lxnidpf _2vryidpf _1umfidpf",
            __cmplp.className
        ])
    });
});
$819bcdea9e3086de$var$WrapperOld.displayName = 'Wrapper';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $819bcdea9e3086de$var$NonSmartLinkWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _80om1kdv _o5721q9c _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _1yds1osq _1hw71txw _156d1y6m _6wji1h6o _bod01osq _ci54u2gc _18ywh2mm _1j631txw _1tuuidpf _1lxnidpf _2vryidpf _1umfidpf",
            __cmplp.className
        ])
    });
});
const $819bcdea9e3086de$var$SmartLinkWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _80om1kdv _o5721q9c _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _1yds1osq _h5vp1txw _16gx1y6m _1qxz1h6o _i78x1osq _mdbou2gc _i9kvh2mm _18vc1txw _18z6idpf _svocidpf _r8aoidpf _1kmuidpf",
            __cmplp.className
        ])
    });
});
const $819bcdea9e3086de$var$Wrapper = (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true), $819bcdea9e3086de$var$SmartLinkWrapper, $819bcdea9e3086de$var$NonSmartLinkWrapper);

});
parcelRegister("6Dl4d", function(module, exports) {

$parcel$export(module.exports, "SmartLink", () => $6ff1c37b7fe05556$export$8416d4d37a0abf2d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8GAdb = parcelRequire("8GAdb");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $79xbN = parcelRequire("79xbN");

var $kKLQT = parcelRequire("kKLQT");
const $6ff1c37b7fe05556$export$8416d4d37a0abf2d = ({ value: value })=>{
    const DefaultLink = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: value,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ff1c37b7fe05556$var$LinkText, null, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ff1c37b7fe05556$var$LinkFollower, {
            "data-component-selector": "business-list.ui.list-view.url-cell.link-follower"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8GAdb))), {
            label: value
        }))), [
        value
    ]);
    if (value && (0, $79xbN.expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6ff1c37b7fe05556$var$smartLinkWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKLQT.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: value,
        fieldType: "url"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DefaultLink, null);
};
const $6ff1c37b7fe05556$var$smartLinkWrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ff1c37b7fe05556$var$LinkFollower = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ejb _11q7txrc _1e0cglyw _4cvr1h6o _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $6ff1c37b7fe05556$var$LinkText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _p12f1osq _1bto1l2s _1reo15vq _18m915vq _1o9zkb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7Bzvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c11bc7f1c1f060a6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c11bc7f1c1f060a6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.url-cell.error-title",
        "defaultMessage": "We couldn't save the text value."
    },
    errorMessage: {
        "id": "business-list.list-view.url-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("261bh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4f7c60646d0413$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $3f7Cz = parcelRequire("3f7Cz");

var $gGtKh = parcelRequire("gGtKh");

const $6a4f7c60646d0413$var$UserCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5lC9s")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/user-cell/main.tsx"
});
const $6a4f7c60646d0413$var$AsyncUserCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "user-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3f7Cz.default), {
        shouldUseInvitePeopleModal: true,
        source: "listViewAssignee"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a4f7c60646d0413$var$UserCell, props)));
var $6a4f7c60646d0413$export$2e2bcd8739ae039 = $6a4f7c60646d0413$var$AsyncUserCell;

});
parcelRegister("5lC9s", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("83ZBb").then(()=>parcelRequire('gv9fI'));

});





parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $1ybV0 = parcelRequire("1ybV0");

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if ((0, $1ybV0.ff)('polaris-detect-subproduct-for-jpd-by-project-type_8jxfy', false)) {
        if (projectType === 'product_discovery') return 'polaris';
        return (0, $dWlsy.subProductFromProjectType)(projectType);
    }
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});



// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


//# sourceMappingURL=async-business-list.35896cb6.js.map
